{
  "type": "Topology",
  "transform": {
    "scale": [
      0.002906483881124809,
      0.0016008570112434413
    ],
    "translate": [
      -180,
      -89.99892578124998
    ]
  },
  "objects": {
    "countries": {
      "type": "GeometryCollection",
      "geometries": [
        {
          "type": "Polygon",
          "arcs": [
            [
              0
            ]
          ],
          "id": 533,
          "properties": {
            "name": "Aruba"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1,
              2,
              3,
              4,
              5,
              6
            ]
          ],
          "id": 4,
          "properties": {
            "name": "Afghanistan"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                7,
                8,
                9,
                10
              ]
            ],
            [
              [
                11,
                12,
                13
              ]
            ]
          ],
          "id": 24,
          "properties": {
            "name": "Angola"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              14
            ]
          ],
          "id": 660,
          "properties": {
            "name": "Anguilla"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              15,
              16,
              17,
              18,
              19
            ]
          ],
          "id": 8,
          "properties": {
            "name": "Albania"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                20
              ]
            ],
            [
              [
                21
              ]
            ],
            [
              [
                22
              ]
            ]
          ],
          "id": 248,
          "properties": {
            "name": "Åland Islands"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              23,
              24
            ]
          ],
          "id": 20,
          "properties": {
            "name": "Andorra"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                25
              ]
            ],
            [
              [
                26
              ]
            ],
            [
              [
                27
              ]
            ],
            [
              [
                28
              ]
            ],
            [
              [
                29,
                30,
                31,
                32,
                33
              ],
              [
                34
              ]
            ]
          ],
          "id": 784,
          "properties": {
            "name": "United Arab Emirates"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                35
              ]
            ],
            [
              [
                36,
                37
              ]
            ],
            [
              [
                38
              ]
            ],
            [
              [
                39,
                40,
                41,
                42,
                43,
                44
              ]
            ]
          ],
          "id": 32,
          "properties": {
            "name": "Argentina"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                45
              ]
            ],
            [
              [
                46,
                47,
                48,
                49,
                50
              ],
              [
                51
              ]
            ]
          ],
          "id": 51,
          "properties": {
            "name": "Armenia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              52
            ]
          ],
          "id": 16,
          "properties": {
            "name": "American Samoa"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                53
              ]
            ],
            [
              [
                54
              ]
            ],
            [
              [
                55
              ]
            ],
            [
              [
                56
              ]
            ],
            [
              [
                57
              ]
            ],
            [
              [
                58
              ]
            ],
            [
              [
                59
              ]
            ],
            [
              [
                60
              ]
            ],
            [
              [
                61
              ]
            ],
            [
              [
                62
              ]
            ],
            [
              [
                63
              ]
            ],
            [
              [
                64
              ]
            ],
            [
              [
                65
              ]
            ],
            [
              [
                66
              ]
            ],
            [
              [
                67
              ]
            ],
            [
              [
                68
              ]
            ],
            [
              [
                69
              ]
            ],
            [
              [
                70
              ]
            ],
            [
              [
                71
              ]
            ],
            [
              [
                72
              ]
            ],
            [
              [
                73
              ]
            ],
            [
              [
                74
              ]
            ],
            [
              [
                75
              ]
            ],
            [
              [
                76
              ]
            ],
            [
              [
                77
              ]
            ],
            [
              [
                78
              ]
            ],
            [
              [
                79
              ]
            ],
            [
              [
                80
              ]
            ],
            [
              [
                81
              ]
            ],
            [
              [
                82
              ]
            ],
            [
              [
                83
              ]
            ],
            [
              [
                84
              ]
            ],
            [
              [
                85
              ]
            ],
            [
              [
                86
              ]
            ],
            [
              [
                87
              ]
            ],
            [
              [
                88
              ]
            ],
            [
              [
                89
              ]
            ],
            [
              [
                90
              ]
            ],
            [
              [
                91
              ]
            ],
            [
              [
                92
              ]
            ],
            [
              [
                93
              ]
            ],
            [
              [
                94
              ]
            ],
            [
              [
                95
              ]
            ],
            [
              [
                96
              ]
            ],
            [
              [
                97
              ]
            ],
            [
              [
                98
              ]
            ],
            [
              [
                99
              ]
            ],
            [
              [
                100
              ]
            ],
            [
              [
                101
              ]
            ],
            [
              [
                102
              ]
            ],
            [
              [
                103
              ]
            ],
            [
              [
                104
              ]
            ],
            [
              [
                105
              ]
            ],
            [
              [
                106
              ]
            ],
            [
              [
                107
              ]
            ],
            [
              [
                108
              ]
            ],
            [
              [
                109
              ]
            ],
            [
              [
                110
              ]
            ],
            [
              [
                111
              ]
            ],
            [
              [
                112
              ]
            ],
            [
              [
                113
              ]
            ],
            [
              [
                114
              ]
            ],
            [
              [
                115
              ]
            ],
            [
              [
                116
              ]
            ],
            [
              [
                117
              ]
            ],
            [
              [
                118
              ]
            ],
            [
              [
                119
              ]
            ],
            [
              [
                120
              ]
            ],
            [
              [
                121
              ]
            ],
            [
              [
                122
              ]
            ],
            [
              [
                123
              ]
            ],
            [
              [
                124
              ]
            ],
            [
              [
                125
              ]
            ],
            [
              [
                126
              ]
            ],
            [
              [
                127
              ]
            ],
            [
              [
                128
              ]
            ],
            [
              [
                129
              ]
            ],
            [
              [
                130
              ]
            ],
            [
              [
                131
              ]
            ],
            [
              [
                132
              ]
            ],
            [
              [
                133
              ]
            ],
            [
              [
                134
              ]
            ],
            [
              [
                135
              ]
            ],
            [
              [
                136
              ]
            ],
            [
              [
                137
              ]
            ],
            [
              [
                138
              ]
            ],
            [
              [
                139
              ]
            ],
            [
              [
                140
              ]
            ],
            [
              [
                141
              ]
            ],
            [
              [
                142
              ]
            ],
            [
              [
                143
              ]
            ],
            [
              [
                144
              ]
            ],
            [
              [
                145
              ]
            ],
            [
              [
                146
              ]
            ],
            [
              [
                147
              ]
            ],
            [
              [
                148
              ]
            ],
            [
              [
                149
              ]
            ],
            [
              [
                150
              ]
            ],
            [
              [
                151
              ]
            ],
            [
              [
                152
              ]
            ],
            [
              [
                153
              ]
            ],
            [
              [
                154
              ]
            ],
            [
              [
                155
              ]
            ],
            [
              [
                156
              ]
            ],
            [
              [
                157
              ]
            ],
            [
              [
                158
              ]
            ]
          ],
          "id": 10,
          "properties": {
            "name": "Antarctica"
          }
        },
        {
          "type": null,
          "id": 36,
          "properties": {
            "name": "Australia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                159
              ]
            ],
            [
              [
                160
              ]
            ],
            [
              [
                161
              ]
            ]
          ],
          "id": 260,
          "properties": {
            "name": "French Southern Territories"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                162
              ]
            ],
            [
              [
                163
              ]
            ]
          ],
          "id": 28,
          "properties": {
            "name": "Antigua and Barbuda"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                164
              ]
            ],
            [
              [
                165
              ]
            ],
            [
              [
                166
              ]
            ],
            [
              [
                167
              ]
            ],
            [
              [
                168
              ]
            ],
            [
              [
                169
              ]
            ],
            [
              [
                170
              ]
            ],
            [
              [
                171
              ]
            ],
            [
              [
                172
              ]
            ],
            [
              [
                173
              ]
            ],
            [
              [
                174
              ]
            ],
            [
              [
                175
              ]
            ],
            [
              [
                176
              ]
            ],
            [
              [
                177
              ]
            ],
            [
              [
                178
              ]
            ],
            [
              [
                179
              ]
            ],
            [
              [
                180
              ]
            ],
            [
              [
                181
              ]
            ],
            [
              [
                182
              ]
            ],
            [
              [
                183
              ]
            ],
            [
              [
                184
              ]
            ],
            [
              [
                185
              ]
            ],
            [
              [
                186
              ]
            ],
            [
              [
                187
              ]
            ],
            [
              [
                188
              ]
            ],
            [
              [
                189
              ]
            ],
            [
              [
                190
              ]
            ],
            [
              [
                191
              ]
            ],
            [
              [
                192
              ]
            ],
            [
              [
                193
              ]
            ],
            [
              [
                194
              ]
            ],
            [
              [
                195
              ]
            ],
            [
              [
                196
              ]
            ],
            [
              [
                197
              ]
            ],
            [
              [
                198
              ]
            ],
            [
              [
                199
              ]
            ],
            [
              [
                200
              ]
            ],
            [
              [
                201
              ]
            ],
            [
              [
                202
              ]
            ]
          ],
          "id": 36,
          "properties": {
            "name": "Australia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              203,
              204,
              205,
              206,
              207,
              208,
              209,
              210,
              211
            ]
          ],
          "id": 40,
          "properties": {
            "name": "Austria"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                212,
                213,
                -48
              ]
            ],
            [
              [
                214
              ]
            ],
            [
              [
                215,
                -51,
                216,
                217,
                218
              ],
              [
                219
              ]
            ]
          ],
          "id": 31,
          "properties": {
            "name": "Azerbaijan"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              220,
              221,
              222
            ]
          ],
          "id": 108,
          "properties": {
            "name": "Burundi"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              223,
              224,
              225,
              226,
              227,
              228,
              229
            ]
          ],
          "id": 56,
          "properties": {
            "name": "Belgium"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              230,
              231,
              232,
              233,
              234
            ]
          ],
          "id": 204,
          "properties": {
            "name": "Benin"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -232,
              235,
              236,
              237,
              238,
              239
            ]
          ],
          "id": 854,
          "properties": {
            "name": "Burkina Faso"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                240
              ]
            ],
            [
              [
                241
              ]
            ],
            [
              [
                242
              ]
            ],
            [
              [
                243
              ]
            ],
            [
              [
                244
              ]
            ],
            [
              [
                245
              ]
            ],
            [
              [
                246,
                247,
                248
              ]
            ]
          ],
          "id": 50,
          "properties": {
            "name": "Bangladesh"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              249,
              250,
              251,
              252,
              253,
              254
            ]
          ],
          "id": 100,
          "properties": {
            "name": "Bulgaria"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              255
            ]
          ],
          "id": 48,
          "properties": {
            "name": "Bahrain"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                256
              ]
            ],
            [
              [
                257
              ]
            ],
            [
              [
                258
              ]
            ],
            [
              [
                259
              ]
            ],
            [
              [
                260
              ]
            ],
            [
              [
                261
              ]
            ],
            [
              [
                262
              ]
            ],
            [
              [
                263
              ]
            ],
            [
              [
                264
              ]
            ],
            [
              [
                265
              ]
            ],
            [
              [
                266
              ]
            ],
            [
              [
                267
              ]
            ],
            [
              [
                268
              ]
            ],
            [
              [
                269
              ]
            ],
            [
              [
                270
              ]
            ]
          ],
          "id": 44,
          "properties": {
            "name": "Bahamas"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              271,
              272,
              273,
              274,
              275
            ]
          ],
          "id": 70,
          "properties": {
            "name": "Bosnia and Herzegovina"
          }
        },
        {
          "type": null,
          "id": 652,
          "properties": {
            "name": "Saint Barthélemy"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              276,
              277,
              278,
              279,
              280
            ]
          ],
          "id": 112,
          "properties": {
            "name": "Belarus"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                281
              ]
            ],
            [
              [
                282
              ]
            ],
            [
              [
                283,
                284,
                285
              ]
            ]
          ],
          "id": 84,
          "properties": {
            "name": "Belize"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              286
            ]
          ],
          "id": 60,
          "properties": {
            "name": "Bermuda"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -45,
              287,
              288,
              289,
              290
            ]
          ],
          "id": 68,
          "properties": {
            "name": "Bolivia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                291
              ]
            ],
            [
              [
                292
              ]
            ],
            [
              [
                293
              ]
            ],
            [
              [
                294
              ]
            ],
            [
              [
                295
              ]
            ],
            [
              [
                296
              ]
            ],
            [
              [
                297
              ]
            ],
            [
              [
                298
              ]
            ],
            [
              [
                299
              ]
            ],
            [
              [
                300
              ]
            ],
            [
              [
                301
              ]
            ],
            [
              [
                302
              ]
            ],
            [
              [
                303
              ]
            ],
            [
              [
                304
              ]
            ],
            [
              [
                305
              ]
            ],
            [
              [
                306
              ]
            ],
            [
              [
                307,
                308,
                309,
                310,
                -41,
                311,
                -290,
                312,
                313,
                314,
                315
              ]
            ]
          ],
          "id": 76,
          "properties": {
            "name": "Brazil"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              316
            ]
          ],
          "id": 52,
          "properties": {
            "name": "Barbados"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                317
              ]
            ],
            [
              [
                318,
                319
              ]
            ]
          ],
          "id": 96,
          "properties": {
            "name": "Brunei Darussalam"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              320,
              321
            ]
          ],
          "id": 64,
          "properties": {
            "name": "Bhutan"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              322,
              323,
              324
            ]
          ],
          "id": 72,
          "properties": {
            "name": "Botswana"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              325,
              326,
              327,
              328,
              329,
              330
            ]
          ],
          "id": 140,
          "properties": {
            "name": "Central African Republic"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                331
              ]
            ],
            [
              [
                332
              ]
            ],
            [
              [
                333
              ]
            ],
            [
              [
                334
              ]
            ],
            [
              [
                335
              ]
            ],
            [
              [
                336
              ]
            ],
            [
              [
                337
              ]
            ],
            [
              [
                338
              ]
            ],
            [
              [
                339
              ]
            ],
            [
              [
                340
              ]
            ],
            [
              [
                341
              ]
            ],
            [
              [
                342
              ]
            ],
            [
              [
                343,
                344
              ]
            ],
            [
              [
                345
              ]
            ],
            [
              [
                346
              ]
            ],
            [
              [
                347
              ]
            ],
            [
              [
                348
              ]
            ],
            [
              [
                349
              ]
            ],
            [
              [
                350
              ]
            ],
            [
              [
                351
              ]
            ],
            [
              [
                352
              ]
            ],
            [
              [
                353
              ]
            ],
            [
              [
                354
              ]
            ],
            [
              [
                355
              ]
            ],
            [
              [
                356
              ]
            ],
            [
              [
                357
              ]
            ],
            [
              [
                358
              ]
            ],
            [
              [
                359
              ]
            ],
            [
              [
                360
              ]
            ],
            [
              [
                361
              ]
            ],
            [
              [
                362
              ]
            ],
            [
              [
                363
              ]
            ],
            [
              [
                364
              ]
            ],
            [
              [
                365
              ]
            ],
            [
              [
                366
              ]
            ],
            [
              [
                367
              ]
            ],
            [
              [
                368
              ]
            ],
            [
              [
                369
              ]
            ],
            [
              [
                370
              ]
            ],
            [
              [
                371,
                372
              ]
            ],
            [
              [
                373
              ]
            ],
            [
              [
                374
              ]
            ],
            [
              [
                375
              ]
            ],
            [
              [
                376
              ]
            ],
            [
              [
                377
              ]
            ],
            [
              [
                378
              ]
            ],
            [
              [
                379
              ]
            ],
            [
              [
                380
              ]
            ],
            [
              [
                381
              ]
            ],
            [
              [
                382
              ]
            ],
            [
              [
                383
              ]
            ],
            [
              [
                384
              ]
            ],
            [
              [
                385
              ]
            ],
            [
              [
                386
              ]
            ],
            [
              [
                387
              ]
            ],
            [
              [
                388
              ]
            ],
            [
              [
                389
              ]
            ],
            [
              [
                390
              ]
            ],
            [
              [
                391
              ]
            ],
            [
              [
                392
              ]
            ],
            [
              [
                393
              ]
            ],
            [
              [
                394
              ]
            ],
            [
              [
                395
              ]
            ],
            [
              [
                396
              ]
            ],
            [
              [
                397
              ]
            ],
            [
              [
                398
              ]
            ],
            [
              [
                399
              ]
            ],
            [
              [
                400
              ]
            ],
            [
              [
                401
              ]
            ],
            [
              [
                402
              ]
            ],
            [
              [
                403
              ]
            ],
            [
              [
                404
              ]
            ],
            [
              [
                405
              ]
            ],
            [
              [
                406
              ]
            ],
            [
              [
                407
              ]
            ],
            [
              [
                408
              ]
            ],
            [
              [
                409
              ]
            ],
            [
              [
                410
              ]
            ],
            [
              [
                411
              ]
            ],
            [
              [
                412
              ]
            ],
            [
              [
                413
              ]
            ],
            [
              [
                414
              ]
            ],
            [
              [
                415
              ]
            ],
            [
              [
                416
              ]
            ],
            [
              [
                417
              ]
            ],
            [
              [
                418
              ]
            ],
            [
              [
                419
              ]
            ],
            [
              [
                420
              ]
            ],
            [
              [
                421
              ]
            ],
            [
              [
                422
              ]
            ],
            [
              [
                423
              ]
            ],
            [
              [
                424
              ]
            ],
            [
              [
                425
              ]
            ],
            [
              [
                426,
                427,
                428,
                429
              ]
            ],
            [
              [
                430
              ]
            ],
            [
              [
                431
              ]
            ],
            [
              [
                432
              ]
            ],
            [
              [
                433
              ]
            ],
            [
              [
                434
              ]
            ],
            [
              [
                435
              ]
            ],
            [
              [
                436
              ]
            ],
            [
              [
                437
              ]
            ],
            [
              [
                438
              ]
            ],
            [
              [
                439
              ]
            ],
            [
              [
                440
              ]
            ],
            [
              [
                441
              ]
            ],
            [
              [
                442
              ]
            ],
            [
              [
                443
              ]
            ],
            [
              [
                444
              ]
            ],
            [
              [
                445
              ]
            ],
            [
              [
                446
              ]
            ],
            [
              [
                447
              ]
            ],
            [
              [
                448
              ]
            ],
            [
              [
                449
              ]
            ],
            [
              [
                450
              ]
            ],
            [
              [
                451
              ]
            ],
            [
              [
                452
              ]
            ],
            [
              [
                453
              ]
            ],
            [
              [
                454
              ]
            ],
            [
              [
                455
              ]
            ],
            [
              [
                456
              ]
            ],
            [
              [
                457
              ]
            ],
            [
              [
                458
              ]
            ],
            [
              [
                459
              ]
            ],
            [
              [
                460
              ]
            ],
            [
              [
                461
              ]
            ],
            [
              [
                462
              ]
            ],
            [
              [
                463
              ]
            ],
            [
              [
                464
              ]
            ],
            [
              [
                465
              ]
            ],
            [
              [
                466
              ]
            ],
            [
              [
                467
              ]
            ],
            [
              [
                468
              ]
            ],
            [
              [
                469
              ]
            ]
          ],
          "id": 124,
          "properties": {
            "name": "Canada"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              470,
              -207,
              471,
              472,
              473,
              -209
            ]
          ],
          "id": 756,
          "properties": {
            "name": "Switzerland"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                474
              ]
            ],
            [
              [
                475
              ]
            ],
            [
              [
                476
              ]
            ],
            [
              [
                477
              ]
            ],
            [
              [
                478
              ]
            ],
            [
              [
                479
              ]
            ],
            [
              [
                480
              ]
            ],
            [
              [
                481
              ]
            ],
            [
              [
                482
              ]
            ],
            [
              [
                -37,
                483
              ]
            ],
            [
              [
                484
              ]
            ],
            [
              [
                485
              ]
            ],
            [
              [
                486
              ]
            ],
            [
              [
                487
              ]
            ],
            [
              [
                488
              ]
            ],
            [
              [
                489
              ]
            ],
            [
              [
                490
              ]
            ],
            [
              [
                491
              ]
            ],
            [
              [
                492
              ]
            ],
            [
              [
                493
              ]
            ],
            [
              [
                494
              ]
            ],
            [
              [
                495
              ]
            ],
            [
              [
                496
              ]
            ],
            [
              [
                497
              ]
            ],
            [
              [
                498
              ]
            ],
            [
              [
                499
              ]
            ],
            [
              [
                500
              ]
            ],
            [
              [
                501
              ]
            ],
            [
              [
                502
              ]
            ],
            [
              [
                503
              ]
            ],
            [
              [
                -44,
                504,
                505,
                -288
              ]
            ]
          ],
          "id": 152,
          "properties": {
            "name": "Chile"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                506
              ]
            ],
            [
              [
                507
              ]
            ],
            [
              [
                508
              ]
            ],
            [
              [
                509
              ]
            ],
            [
              [
                510
              ]
            ],
            [
              [
                511
              ]
            ],
            [
              [
                512
              ]
            ],
            [
              [
                513
              ]
            ],
            [
              [
                514
              ]
            ],
            [
              [
                515
              ]
            ],
            [
              [
                516
              ]
            ],
            [
              [
                517
              ]
            ],
            [
              [
                518,
                519,
                520,
                521,
                522,
                523,
                524,
                525,
                526,
                527,
                -321,
                528,
                529,
                530,
                531,
                532,
                533,
                534,
                -7,
                535,
                536,
                537,
                538,
                539,
                540
              ]
            ]
          ],
          "id": 156,
          "properties": {
            "name": "China (mainland)"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                541,
                542
              ]
            ],
            [
              [
                -238,
                543,
                544,
                545,
                546,
                547
              ]
            ]
          ],
          "id": 384,
          "properties": {
            "name": "Côte d'Ivoire"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              548,
              549,
              550,
              551,
              552,
              553,
              -329
            ]
          ],
          "id": 120,
          "properties": {
            "name": "Cameroon"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              554,
              555,
              -221,
              556,
              557,
              -11,
              558,
              -13,
              559,
              -327,
              560
            ]
          ],
          "id": 180,
          "properties": {
            "name": "Democratic Republic of the Congo"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -12,
              561,
              562,
              -549,
              -328,
              -560
            ]
          ],
          "id": 178,
          "properties": {
            "name": "Republic of Congo"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              563
            ]
          ],
          "id": 184,
          "properties": {
            "name": "Cook Islands"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                564
              ]
            ],
            [
              [
                565,
                -314,
                566,
                567,
                568,
                569,
                570
              ]
            ]
          ],
          "id": 170,
          "properties": {
            "name": "Colombia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                571
              ]
            ],
            [
              [
                572
              ]
            ],
            [
              [
                573
              ]
            ]
          ],
          "id": 174,
          "properties": {
            "name": "Comoros"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                574
              ]
            ],
            [
              [
                575
              ]
            ],
            [
              [
                576
              ]
            ],
            [
              [
                577
              ]
            ],
            [
              [
                578
              ]
            ],
            [
              [
                579
              ]
            ],
            [
              [
                580
              ]
            ],
            [
              [
                581
              ]
            ]
          ],
          "id": 132,
          "properties": {
            "name": "Cabo Verde"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              582,
              583,
              584,
              585
            ]
          ],
          "id": 188,
          "properties": {
            "name": "Costa Rica"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                586
              ]
            ],
            [
              [
                587
              ]
            ],
            [
              [
                588
              ]
            ],
            [
              [
                589
              ]
            ],
            [
              [
                590
              ]
            ],
            [
              [
                591
              ]
            ],
            [
              [
                592
              ]
            ]
          ],
          "id": 192,
          "properties": {
            "name": "Cuba"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              593
            ]
          ],
          "id": 531,
          "properties": {
            "name": "Curaçao"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                594
              ]
            ],
            [
              [
                595
              ]
            ]
          ],
          "id": 136,
          "properties": {
            "name": "Cayman Islands"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              596,
              597
            ]
          ],
          "id": -1,
          "properties": {
            "name": "Northern Cyprus"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -597,
              598
            ]
          ],
          "id": 196,
          "properties": {
            "name": "Cyprus"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              599,
              -211,
              600,
              601
            ]
          ],
          "id": 203,
          "properties": {
            "name": "Czech Republic"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                602,
                603
              ]
            ],
            [
              [
                604
              ]
            ],
            [
              [
                605
              ]
            ],
            [
              [
                606
              ]
            ],
            [
              [
                607,
                -601,
                -210,
                -474,
                608,
                609,
                -224,
                610,
                611,
                612,
                613
              ]
            ],
            [
              [
                614
              ]
            ]
          ],
          "id": 276,
          "properties": {
            "name": "Germany"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              615,
              616,
              617,
              618
            ]
          ],
          "id": 262,
          "properties": {
            "name": "Djibouti"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              619
            ]
          ],
          "id": 212,
          "properties": {
            "name": "Dominica"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                620
              ]
            ],
            [
              [
                621
              ]
            ],
            [
              [
                622
              ]
            ],
            [
              [
                623
              ]
            ],
            [
              [
                624
              ]
            ],
            [
              [
                625
              ]
            ],
            [
              [
                626
              ]
            ],
            [
              [
                627
              ]
            ],
            [
              [
                628
              ]
            ],
            [
              [
                629
              ]
            ],
            [
              [
                630
              ]
            ],
            [
              [
                -613,
                631
              ]
            ]
          ],
          "id": 208,
          "properties": {
            "name": "Denmark"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              632,
              633
            ]
          ],
          "id": 214,
          "properties": {
            "name": "Dominican Republic"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              634,
              635,
              636,
              637,
              638,
              639,
              640,
              641
            ]
          ],
          "id": 12,
          "properties": {
            "name": "Algeria"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                642
              ]
            ],
            [
              [
                643
              ]
            ],
            [
              [
                644
              ]
            ],
            [
              [
                645
              ]
            ],
            [
              [
                646
              ]
            ],
            [
              [
                647
              ]
            ],
            [
              [
                648
              ]
            ],
            [
              [
                649
              ]
            ],
            [
              [
                650,
                651,
                -568
              ]
            ]
          ],
          "id": 218,
          "properties": {
            "name": "Ecuador"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              652,
              653,
              654,
              655,
              656,
              657
            ]
          ],
          "id": 818,
          "properties": {
            "name": "Egypt"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                658
              ]
            ],
            [
              [
                659
              ]
            ],
            [
              [
                -617,
                660,
                661,
                662
              ]
            ]
          ],
          "id": 232,
          "properties": {
            "name": "Eritrea"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                663
              ]
            ],
            [
              [
                664
              ]
            ],
            [
              [
                665
              ]
            ],
            [
              [
                666
              ]
            ],
            [
              [
                667
              ]
            ],
            [
              [
                668
              ]
            ],
            [
              [
                669
              ]
            ],
            [
              [
                670
              ]
            ],
            [
              [
                671
              ]
            ],
            [
              [
                672
              ]
            ],
            [
              [
                673
              ]
            ],
            [
              [
                674,
                -25,
                675,
                676,
                677,
                678
              ]
            ]
          ],
          "id": 724,
          "properties": {
            "name": "Spain"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                679
              ]
            ],
            [
              [
                680
              ]
            ],
            [
              [
                681
              ]
            ],
            [
              [
                682,
                683,
                684
              ]
            ]
          ],
          "id": 233,
          "properties": {
            "name": "Estonia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -616,
              685,
              686,
              687,
              688,
              689,
              -661
            ]
          ],
          "id": 231,
          "properties": {
            "name": "Ethiopia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                690
              ]
            ],
            [
              [
                691
              ]
            ],
            [
              [
                692
              ]
            ],
            [
              [
                693
              ]
            ],
            [
              [
                694
              ]
            ],
            [
              [
                695
              ]
            ],
            [
              [
                696
              ]
            ],
            [
              [
                697,
                698,
                699,
                700
              ]
            ]
          ],
          "id": 246,
          "properties": {
            "name": "Finland"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                701
              ]
            ],
            [
              [
                702
              ]
            ],
            [
              [
                703
              ]
            ],
            [
              [
                704
              ]
            ],
            [
              [
                705
              ]
            ],
            [
              [
                706
              ]
            ],
            [
              [
                707
              ]
            ],
            [
              [
                708
              ]
            ],
            [
              [
                709
              ]
            ],
            [
              [
                710
              ]
            ],
            [
              [
                711
              ]
            ],
            [
              [
                712
              ]
            ],
            [
              [
                713
              ]
            ],
            [
              [
                714
              ]
            ],
            [
              [
                715
              ]
            ]
          ],
          "id": 242,
          "properties": {
            "name": "Fiji"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                716
              ]
            ],
            [
              [
                717
              ]
            ],
            [
              [
                718
              ]
            ],
            [
              [
                719
              ]
            ],
            [
              [
                720
              ]
            ],
            [
              [
                721
              ]
            ]
          ],
          "id": 238,
          "properties": {
            "name": "Falkland Islands"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                722
              ]
            ],
            [
              [
                723
              ]
            ],
            [
              [
                726
              ]
            ],
            [
              [
                727
              ]
            ],
            [
              [
                728
              ]
            ],
            [
              [
                729
              ]
            ],
            [
              [
                730
              ]
            ],
            [
              [
                731
              ]
            ],
            [
              [
                732,
                -609,
                -473,
                733,
                734,
                735,
                736,
                -676,
                -24,
                -675,
                737,
                -226
              ]
            ]
          ],
          "id": 250,
          "properties": {
            "name": "France"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -309,
              724,
              725
            ]
          ],
          "id": 328,
          "properties": {
            "name": "French Guiana"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                738
              ]
            ],
            [
              [
                739
              ]
            ],
            [
              [
                740
              ]
            ],
            [
              [
                741
              ]
            ],
            [
              [
                742
              ]
            ]
          ],
          "id": 234,
          "properties": {
            "name": "Faroe Islands"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                743
              ]
            ],
            [
              [
                744
              ]
            ],
            [
              [
                745
              ]
            ],
            [
              [
                746
              ]
            ],
            [
              [
                747
              ]
            ]
          ],
          "id": 583,
          "properties": {
            "name": "Micronesia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              748,
              -550,
              -563,
              749
            ]
          ],
          "id": 266,
          "properties": {
            "name": "Gabon"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                750
              ]
            ],
            [
              [
                751
              ]
            ],
            [
              [
                752,
                753
              ]
            ],
            [
              [
                754
              ]
            ],
            [
              [
                755
              ]
            ],
            [
              [
                756
              ]
            ],
            [
              [
                757
              ]
            ],
            [
              [
                758
              ]
            ],
            [
              [
                759
              ]
            ],
            [
              [
                760
              ]
            ],
            [
              [
                761
              ]
            ],
            [
              [
                762
              ]
            ],
            [
              [
                763
              ]
            ],
            [
              [
                764
              ]
            ],
            [
              [
                765
              ]
            ],
            [
              [
                766
              ]
            ],
            [
              [
                767
              ]
            ],
            [
              [
                768
              ]
            ],
            [
              [
                769
              ]
            ],
            [
              [
                770
              ]
            ],
            [
              [
                771
              ]
            ]
          ],
          "id": 826,
          "properties": {
            "name": "United Kingdom"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -50,
              772,
              773,
              774,
              -217
            ]
          ],
          "id": 268,
          "properties": {
            "name": "Georgia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              775
            ]
          ],
          "id": 831,
          "properties": {
            "name": "Guernsey"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -542,
              776,
              -544,
              -237,
              777,
              778
            ]
          ],
          "id": 288,
          "properties": {
            "name": "Ghana"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -547,
              779,
              780,
              781,
              782,
              783,
              784
            ]
          ],
          "id": 324,
          "properties": {
            "name": "Guinea"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              785,
              786
            ]
          ],
          "id": 270,
          "properties": {
            "name": "Gambia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                787
              ]
            ],
            [
              [
                788
              ]
            ],
            [
              [
                789
              ]
            ],
            [
              [
                790
              ]
            ],
            [
              [
                791
              ]
            ],
            [
              [
                792
              ]
            ],
            [
              [
                793,
                -783,
                794
              ]
            ]
          ],
          "id": 624,
          "properties": {
            "name": "Guinea-Bissau"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                -551,
                -749,
                795
              ]
            ],
            [
              [
                796
              ]
            ]
          ],
          "id": 226,
          "properties": {
            "name": "Equatorial Guinea"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                797
              ]
            ],
            [
              [
                798
              ]
            ],
            [
              [
                799
              ]
            ],
            [
              [
                800
              ]
            ],
            [
              [
                801
              ]
            ],
            [
              [
                802
              ]
            ],
            [
              [
                803
              ]
            ],
            [
              [
                804
              ]
            ],
            [
              [
                805
              ]
            ],
            [
              [
                806
              ]
            ],
            [
              [
                807
              ]
            ],
            [
              [
                808
              ]
            ],
            [
              [
                809
              ]
            ],
            [
              [
                810
              ]
            ],
            [
              [
                811
              ]
            ],
            [
              [
                812
              ]
            ],
            [
              [
                813
              ]
            ],
            [
              [
                814
              ]
            ],
            [
              [
                815
              ]
            ],
            [
              [
                816
              ]
            ],
            [
              [
                817
              ]
            ],
            [
              [
                818
              ]
            ],
            [
              [
                819
              ]
            ],
            [
              [
                820
              ]
            ],
            [
              [
                821
              ]
            ],
            [
              [
                822
              ]
            ],
            [
              [
                823
              ]
            ],
            [
              [
                824
              ]
            ],
            [
              [
                825
              ]
            ],
            [
              [
                826
              ]
            ],
            [
              [
                827
              ]
            ],
            [
              [
                828
              ]
            ],
            [
              [
                829
              ]
            ],
            [
              [
                830
              ]
            ],
            [
              [
                831
              ]
            ],
            [
              [
                832
              ]
            ],
            [
              [
                833
              ]
            ],
            [
              [
                834
              ]
            ],
            [
              [
                -17,
                835,
                -251,
                836,
                837
              ]
            ]
          ],
          "id": 300,
          "properties": {
            "name": "Greece"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              838
            ]
          ],
          "id": 308,
          "properties": {
            "name": "Grenada"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                839
              ]
            ],
            [
              [
                840
              ]
            ],
            [
              [
                841
              ]
            ],
            [
              [
                842
              ]
            ],
            [
              [
                843
              ]
            ],
            [
              [
                844
              ]
            ],
            [
              [
                845
              ]
            ],
            [
              [
                846
              ]
            ],
            [
              [
                847
              ]
            ],
            [
              [
                848
              ]
            ],
            [
              [
                849
              ]
            ],
            [
              [
                850
              ]
            ],
            [
              [
                851
              ]
            ],
            [
              [
                852
              ]
            ],
            [
              [
                853
              ]
            ],
            [
              [
                854
              ]
            ],
            [
              [
                855
              ]
            ]
          ],
          "id": 304,
          "properties": {
            "name": "Greenland"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              856,
              857,
              858,
              859,
              -284,
              860
            ]
          ],
          "id": 320,
          "properties": {
            "name": "Guatemala"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              861
            ]
          ],
          "id": 316,
          "properties": {
            "name": "Guam"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -316,
              862,
              863,
              864
            ]
          ],
          "id": 328,
          "properties": {
            "name": "Guyana"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                865
              ]
            ],
            [
              [
                866
              ]
            ],
            [
              [
                -521,
                867
              ]
            ]
          ],
          "id": 344,
          "properties": {
            "name": "Hong Kong"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              868
            ]
          ],
          "id": 334,
          "properties": {
            "name": "Heard Island and McDonald Islands"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                869,
                870,
                871,
                -857,
                872
              ]
            ],
            [
              [
                873
              ]
            ],
            [
              [
                874
              ]
            ]
          ],
          "id": 340,
          "properties": {
            "name": "Honduras"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                875
              ]
            ],
            [
              [
                -274,
                876,
                877
              ]
            ],
            [
              [
                878
              ]
            ],
            [
              [
                879
              ]
            ],
            [
              [
                880
              ]
            ],
            [
              [
                881
              ]
            ],
            [
              [
                882
              ]
            ],
            [
              [
                883
              ]
            ],
            [
              [
                884,
                -276,
                885,
                886,
                887
              ]
            ]
          ],
          "id": 191,
          "properties": {
            "name": "Croatia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                888
              ]
            ],
            [
              [
                -633,
                889
              ]
            ],
            [
              [
                890
              ]
            ]
          ],
          "id": 332,
          "properties": {
            "name": "Haiti"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              891,
              892,
              -888,
              893,
              -204,
              894,
              895
            ]
          ],
          "id": 348,
          "properties": {
            "name": "Hungary"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                896
              ]
            ],
            [
              [
                897
              ]
            ],
            [
              [
                898
              ]
            ],
            [
              [
                899
              ]
            ],
            [
              [
                900,
                901,
                902,
                903
              ]
            ],
            [
              [
                904
              ]
            ],
            [
              [
                905
              ]
            ],
            [
              [
                906
              ]
            ],
            [
              [
                907
              ]
            ],
            [
              [
                908
              ]
            ],
            [
              [
                909
              ]
            ],
            [
              [
                910
              ]
            ],
            [
              [
                911
              ]
            ],
            [
              [
                912
              ]
            ],
            [
              [
                913
              ]
            ],
            [
              [
                914
              ]
            ],
            [
              [
                915
              ]
            ],
            [
              [
                916
              ]
            ],
            [
              [
                917
              ]
            ],
            [
              [
                918
              ]
            ],
            [
              [
                919
              ]
            ],
            [
              [
                920
              ]
            ],
            [
              [
                921
              ]
            ],
            [
              [
                922
              ]
            ],
            [
              [
                923
              ]
            ],
            [
              [
                924
              ]
            ],
            [
              [
                925
              ]
            ],
            [
              [
                926
              ]
            ],
            [
              [
                927
              ]
            ],
            [
              [
                928
              ]
            ],
            [
              [
                929
              ]
            ],
            [
              [
                930
              ]
            ],
            [
              [
                931
              ]
            ],
            [
              [
                932
              ]
            ],
            [
              [
                933
              ]
            ],
            [
              [
                934
              ]
            ],
            [
              [
                935
              ]
            ],
            [
              [
                936
              ]
            ],
            [
              [
                937
              ]
            ],
            [
              [
                938
              ]
            ],
            [
              [
                939
              ]
            ],
            [
              [
                940
              ]
            ],
            [
              [
                941
              ]
            ],
            [
              [
                942
              ]
            ],
            [
              [
                943
              ]
            ],
            [
              [
                944
              ]
            ],
            [
              [
                945
              ]
            ],
            [
              [
                946
              ]
            ],
            [
              [
                947
              ]
            ],
            [
              [
                948
              ]
            ],
            [
              [
                949
              ]
            ],
            [
              [
                950
              ]
            ],
            [
              [
                951
              ]
            ],
            [
              [
                952
              ]
            ],
            [
              [
                953
              ]
            ],
            [
              [
                954
              ]
            ],
            [
              [
                955
              ]
            ],
            [
              [
                956
              ]
            ],
            [
              [
                957
              ]
            ],
            [
              [
                958
              ]
            ],
            [
              [
                959
              ]
            ],
            [
              [
                960
              ]
            ],
            [
              [
                961
              ]
            ],
            [
              [
                962
              ]
            ],
            [
              [
                963
              ]
            ],
            [
              [
                964
              ]
            ],
            [
              [
                965
              ]
            ],
            [
              [
                966
              ]
            ],
            [
              [
                967
              ]
            ],
            [
              [
                968
              ]
            ],
            [
              [
                969
              ]
            ],
            [
              [
                970
              ]
            ],
            [
              [
                971
              ]
            ],
            [
              [
                972
              ]
            ],
            [
              [
                973
              ]
            ],
            [
              [
                974
              ]
            ],
            [
              [
                975
              ]
            ],
            [
              [
                976
              ]
            ],
            [
              [
                977
              ]
            ],
            [
              [
                978
              ]
            ],
            [
              [
                979
              ]
            ],
            [
              [
                980
              ]
            ],
            [
              [
                981
              ]
            ],
            [
              [
                982
              ]
            ],
            [
              [
                983
              ]
            ],
            [
              [
                984
              ]
            ],
            [
              [
                985
              ]
            ],
            [
              [
                986,
                987
              ]
            ],
            [
              [
                988
              ]
            ],
            [
              [
                989
              ]
            ],
            [
              [
                990
              ]
            ],
            [
              [
                991
              ]
            ],
            [
              [
                992
              ]
            ],
            [
              [
                993
              ]
            ],
            [
              [
                994
              ]
            ],
            [
              [
                995
              ]
            ],
            [
              [
                996
              ]
            ],
            [
              [
                997
              ]
            ],
            [
              [
                998
              ]
            ],
            [
              [
                999
              ]
            ],
            [
              [
                1000
              ]
            ],
            [
              [
                1001
              ]
            ],
            [
              [
                1002
              ]
            ],
            [
              [
                1003
              ]
            ],
            [
              [
                1004
              ]
            ],
            [
              [
                1005
              ]
            ],
            [
              [
                1006
              ]
            ],
            [
              [
                1007
              ]
            ],
            [
              [
                1008
              ]
            ],
            [
              [
                1009
              ]
            ],
            [
              [
                1010
              ]
            ],
            [
              [
                1011
              ]
            ],
            [
              [
                1012
              ]
            ],
            [
              [
                1013
              ]
            ],
            [
              [
                1014
              ]
            ],
            [
              [
                1015
              ]
            ],
            [
              [
                1016
              ]
            ],
            [
              [
                1017
              ]
            ],
            [
              [
                1018
              ]
            ],
            [
              [
                1019
              ]
            ],
            [
              [
                1020
              ]
            ],
            [
              [
                1021
              ]
            ],
            [
              [
                1022
              ]
            ],
            [
              [
                1023
              ]
            ],
            [
              [
                1024
              ]
            ],
            [
              [
                1025
              ]
            ],
            [
              [
                1026,
                1027
              ]
            ],
            [
              [
                1028
              ]
            ],
            [
              [
                1029,
                1030
              ]
            ],
            [
              [
                1031
              ]
            ],
            [
              [
                1032
              ]
            ],
            [
              [
                1033
              ]
            ]
          ],
          "id": 360,
          "properties": {
            "name": "Indonesia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1034
            ]
          ],
          "id": 833,
          "properties": {
            "name": "Isle of Man"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1035
              ]
            ],
            [
              [
                1036
              ]
            ],
            [
              [
                1037
              ]
            ],
            [
              [
                1038
              ]
            ],
            [
              [
                1039
              ]
            ],
            [
              [
                1040
              ]
            ],
            [
              [
                1041
              ]
            ],
            [
              [
                1042
              ]
            ],
            [
              [
                1043
              ]
            ],
            [
              [
                1044
              ]
            ],
            [
              [
                1045,
                1046,
                1047,
                1048,
                -529,
                -322,
                -528,
                1049,
                -249,
                1050,
                1051,
                1052,
                1053
              ]
            ]
          ],
          "id": 356,
          "properties": {
            "name": "India"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1054
            ]
          ],
          "id": 166,
          "properties": {
            "name": "Cocos Islands"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1055
            ]
          ],
          "id": 162,
          "properties": {
            "name": "Christmas Island"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1056
            ]
          ],
          "id": 86,
          "properties": {
            "name": "British Indian Ocean Territory"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1057
              ]
            ],
            [
              [
                -753,
                1058
              ]
            ]
          ],
          "id": 372,
          "properties": {
            "name": "Ireland"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1059
              ]
            ],
            [
              [
                -47,
                -216,
                1060,
                1061,
                1062,
                1063,
                1064,
                1065,
                1066,
                1067,
                -213
              ]
            ]
          ],
          "id": 364,
          "properties": {
            "name": "Iran"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1068,
              1069,
              1070,
              1071,
              1072,
              -1067,
              1073
            ]
          ],
          "id": 368,
          "properties": {
            "name": "Iraq"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1074
            ]
          ],
          "id": 352,
          "properties": {
            "name": "Iceland"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1075,
              1076,
              1077,
              -653,
              1078,
              1079,
              1080,
              1081,
              1082
            ]
          ],
          "id": 376,
          "properties": {
            "name": "Israel"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1083
              ]
            ],
            [
              [
                1084
              ]
            ],
            [
              [
                1085
              ]
            ],
            [
              [
                1086
              ]
            ],
            [
              [
                1087
              ]
            ],
            [
              [
                1088
              ]
            ],
            [
              [
                1089
              ]
            ],
            [
              [
                1090,
                1091,
                -734,
                -472,
                -206
              ],
              [
                1092
              ]
            ]
          ],
          "id": 380,
          "properties": {
            "name": "Italy"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1093
            ]
          ],
          "id": 388,
          "properties": {
            "name": "Jamaica"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1094
            ]
          ],
          "id": 832,
          "properties": {
            "name": "Jersey"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1077,
              1095,
              -1083,
              1096,
              -1071,
              1097,
              1098
            ]
          ],
          "id": 400,
          "properties": {
            "name": "Jordan"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1099
              ]
            ],
            [
              [
                1100
              ]
            ],
            [
              [
                1101
              ]
            ],
            [
              [
                1102
              ]
            ],
            [
              [
                1103
              ]
            ],
            [
              [
                1104
              ]
            ],
            [
              [
                1105
              ]
            ],
            [
              [
                1106
              ]
            ],
            [
              [
                1107
              ]
            ],
            [
              [
                1108
              ]
            ],
            [
              [
                1109
              ]
            ],
            [
              [
                1110
              ]
            ],
            [
              [
                1111
              ]
            ],
            [
              [
                1112
              ]
            ],
            [
              [
                1113
              ]
            ],
            [
              [
                1114
              ]
            ],
            [
              [
                1115
              ]
            ],
            [
              [
                1116
              ]
            ],
            [
              [
                1117
              ]
            ],
            [
              [
                1118
              ]
            ],
            [
              [
                1119
              ]
            ],
            [
              [
                1120
              ]
            ],
            [
              [
                1121
              ]
            ],
            [
              [
                1122
              ]
            ],
            [
              [
                1123
              ]
            ],
            [
              [
                1124
              ]
            ],
            [
              [
                1125
              ]
            ],
            [
              [
                1126
              ]
            ],
            [
              [
                1127
              ]
            ],
            [
              [
                1128
              ]
            ],
            [
              [
                1129
              ]
            ],
            [
              [
                1130
              ]
            ],
            [
              [
                1131
              ]
            ]
          ],
          "id": 392,
          "properties": {
            "name": "Japan"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1132,
              -534,
              -1053
            ]
          ],
          "id": -10,
          "properties": {
            "name": "Siachen Glacier"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1133
              ]
            ],
            [
              [
                1134
              ]
            ],
            [
              [
                1135
              ]
            ],
            [
              [
                -538,
                1136,
                1137,
                1138,
                1139,
                1140
              ]
            ]
          ],
          "id": 398,
          "properties": {
            "name": "Kazakhstan"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1141
              ]
            ],
            [
              [
                1142,
                1143,
                1144,
                1145,
                1146,
                -688
              ]
            ]
          ],
          "id": 404,
          "properties": {
            "name": "Kenya"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1147,
              1148,
              -1137,
              -537
            ],
            [
              1149
            ],
            [
              1150
            ],
            [
              1151
            ]
          ],
          "id": 417,
          "properties": {
            "name": "Kyrgyzstan"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1152
              ]
            ],
            [
              [
                1153,
                1154,
                1155,
                1156
              ]
            ]
          ],
          "id": 116,
          "properties": {
            "name": "Cambodia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1157
              ]
            ],
            [
              [
                1158
              ]
            ],
            [
              [
                1159
              ]
            ],
            [
              [
                1160
              ]
            ],
            [
              [
                1161
              ]
            ],
            [
              [
                1162
              ]
            ],
            [
              [
                1163
              ]
            ]
          ],
          "id": 296,
          "properties": {
            "name": "Kiribati"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1164
              ]
            ],
            [
              [
                1165
              ]
            ]
          ],
          "id": 659,
          "properties": {
            "name": "Saint Kitts and Nevis"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1166
              ]
            ],
            [
              [
                1167
              ]
            ],
            [
              [
                1168
              ]
            ],
            [
              [
                1169
              ]
            ],
            [
              [
                1170
              ]
            ],
            [
              [
                1171
              ]
            ],
            [
              [
                1172
              ]
            ],
            [
              [
                1173
              ]
            ],
            [
              [
                1174
              ]
            ],
            [
              [
                1175
              ]
            ],
            [
              [
                1176,
                1177
              ]
            ]
          ],
          "id": 410,
          "properties": {
            "name": "South Korea"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -20,
              1178,
              1179,
              1180
            ]
          ],
          "id": -2,
          "properties": {
            "name": "Kosovo"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1181
              ]
            ],
            [
              [
                1182,
                -1069,
                1183
              ]
            ]
          ],
          "id": 414,
          "properties": {
            "name": "Kuwait"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1155,
              1184,
              1185,
              -526,
              1186
            ]
          ],
          "id": 418,
          "properties": {
            "name": "Laos"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1187,
              -1081,
              1188
            ]
          ],
          "id": 422,
          "properties": {
            "name": "Lebanon"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1189,
              -780,
              -546,
              1190
            ]
          ],
          "id": 430,
          "properties": {
            "name": "Liberia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1191,
              1192,
              1193,
              -635,
              1194,
              1195,
              -656
            ]
          ],
          "id": 434,
          "properties": {
            "name": "Libya"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1196
            ]
          ],
          "id": 662,
          "properties": {
            "name": "Saint Lucia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -208,
              -471
            ]
          ],
          "id": 438,
          "properties": {
            "name": "Liechtenstein"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1197
              ]
            ],
            [
              [
                1198
              ]
            ],
            [
              [
                1199
              ]
            ]
          ],
          "id": 144,
          "properties": {
            "name": "Sri Lanka"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1200
            ]
          ],
          "id": 426,
          "properties": {
            "name": "Lesotho"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1201,
                1202
              ]
            ],
            [
              [
                -279,
                1203,
                1204,
                1205,
                1206
              ]
            ]
          ],
          "id": 440,
          "properties": {
            "name": "Lithuania"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -733,
              -225,
              -610
            ]
          ],
          "id": 442,
          "properties": {
            "name": "Luxembourg"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -280,
              -1207,
              1207,
              -684,
              1208
            ]
          ],
          "id": 428,
          "properties": {
            "name": "Latvia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1209
            ]
          ],
          "id": 446,
          "properties": {
            "name": "Macao"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1210,
              1211
            ]
          ],
          "id": 663,
          "properties": {
            "name": "Saint Martin (French part)"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -640,
              1212,
              1213
            ]
          ],
          "id": 504,
          "properties": {
            "name": "Morocco"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1214
            ]
          ],
          "id": 492,
          "properties": {
            "name": "Monaco"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1215,
              1216
            ]
          ],
          "id": 498,
          "properties": {
            "name": "Moldova"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1217
              ]
            ],
            [
              [
                1218
              ]
            ],
            [
              [
                1219
              ]
            ]
          ],
          "id": 450,
          "properties": {
            "name": "Madagascar"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1220
              ]
            ],
            [
              [
                1221
              ]
            ]
          ],
          "id": 462,
          "properties": {
            "name": "Maldives"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1222
              ]
            ],
            [
              [
                1223
              ]
            ],
            [
              [
                1224
              ]
            ],
            [
              [
                1225
              ]
            ],
            [
              [
                1226
              ]
            ],
            [
              [
                1227
              ]
            ],
            [
              [
                1228
              ]
            ],
            [
              [
                1229
              ]
            ],
            [
              [
                1230
              ]
            ],
            [
              [
                1231
              ]
            ],
            [
              [
                1232
              ]
            ],
            [
              [
                1233
              ]
            ],
            [
              [
                1234
              ]
            ],
            [
              [
                -285,
                -860,
                1235,
                1236,
                1237
              ]
            ]
          ],
          "id": 484,
          "properties": {
            "name": "Mexico"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1238
              ]
            ],
            [
              [
                1239
              ]
            ]
          ],
          "id": 584,
          "properties": {
            "name": "Marshall Islands"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -836,
              -16,
              -1181,
              1240,
              -252
            ]
          ],
          "id": 807,
          "properties": {
            "name": "North Macedonia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -239,
              -548,
              -785,
              1241,
              1242,
              -637,
              1243
            ]
          ],
          "id": 466,
          "properties": {
            "name": "Mali"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1244
            ]
          ],
          "id": 470,
          "properties": {
            "name": "Malta"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1245
              ]
            ],
            [
              [
                1246
              ]
            ],
            [
              [
                1247
              ]
            ],
            [
              [
                1248
              ]
            ],
            [
              [
                1249
              ]
            ],
            [
              [
                1250
              ]
            ],
            [
              [
                1251
              ]
            ],
            [
              [
                1252
              ]
            ],
            [
              [
                1253
              ]
            ],
            [
              [
                1254
              ]
            ],
            [
              [
                1255
              ]
            ],
            [
              [
                1256
              ]
            ],
            [
              [
                1257
              ]
            ],
            [
              [
                1258
              ]
            ],
            [
              [
                1259
              ]
            ],
            [
              [
                1260
              ]
            ],
            [
              [
                -1186,
                1261,
                1262,
                -247,
                -1050,
                -527
              ]
            ]
          ],
          "id": 104,
          "properties": {
            "name": "Myanmar"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1179,
              -19,
              1263,
              -877,
              -273,
              1264
            ]
          ],
          "id": 499,
          "properties": {
            "name": "Montenegro"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1265,
              -540
            ]
          ],
          "id": 496,
          "properties": {
            "name": "Mongolia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1266
              ]
            ],
            [
              [
                1267
              ]
            ],
            [
              [
                1268
              ]
            ],
            [
              [
                1269
              ]
            ],
            [
              [
                1270
              ]
            ],
            [
              [
                1271
              ]
            ]
          ],
          "id": 580,
          "properties": {
            "name": "Northern Mariana Islands"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1272,
              1273,
              1274,
              1275,
              1276,
              1277,
              1278,
              1279
            ],
            [
              1280
            ],
            [
              1281
            ]
          ],
          "id": 508,
          "properties": {
            "name": "Mozambique"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1282
              ]
            ],
            [
              [
                1283,
                1284,
                1285,
                -638,
                -1243
              ]
            ]
          ],
          "id": 478,
          "properties": {
            "name": "Mauritania"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1286
            ]
          ],
          "id": 500,
          "properties": {
            "name": "Montserrat"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1287
            ]
          ],
          "id": 480,
          "properties": {
            "name": "Mauritius"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                -1282
              ]
            ],
            [
              [
                -1281
              ]
            ],
            [
              [
                -1277,
                1288,
                1289
              ]
            ]
          ],
          "id": 454,
          "properties": {
            "name": "Malawi"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1290
              ]
            ],
            [
              [
                1291
              ]
            ],
            [
              [
                -1027,
                1292
              ]
            ],
            [
              [
                1293
              ]
            ],
            [
              [
                1294
              ]
            ],
            [
              [
                1295,
                1296
              ]
            ],
            [
              [
                -1030,
                1297,
                -319,
                1298,
                1299
              ]
            ],
            [
              [
                1300
              ]
            ]
          ],
          "id": 458,
          "properties": {
            "name": "Malaysia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -324,
              1301,
              1302,
              -9,
              1303
            ]
          ],
          "id": 516,
          "properties": {
            "name": "Namibia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1304
              ]
            ],
            [
              [
                1305
              ]
            ],
            [
              [
                1306
              ]
            ],
            [
              [
                1307
              ]
            ],
            [
              [
                1308
              ]
            ]
          ],
          "id": 540,
          "properties": {
            "name": "New Caledonia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1309,
              -233,
              -240,
              -1244,
              -636,
              -1194,
              1310
            ]
          ],
          "id": 562,
          "properties": {
            "name": "Niger"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1311
            ]
          ],
          "id": 574,
          "properties": {
            "name": "Norfolk Island"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1312
              ]
            ],
            [
              [
                1313,
                -553,
                1314,
                -234,
                -1310
              ]
            ]
          ],
          "id": 566,
          "properties": {
            "name": "Nigeria"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -585,
              1315,
              -870,
              1316
            ]
          ],
          "id": 558,
          "properties": {
            "name": "Nicaragua"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1317
            ]
          ],
          "id": 570,
          "properties": {
            "name": "Niue"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1318
              ]
            ],
            [
              [
                1319
              ]
            ],
            [
              [
                1320
              ]
            ],
            [
              [
                -228,
                1321
              ]
            ],
            [
              [
                1322
              ]
            ],
            [
              [
                1323
              ]
            ],
            [
              [
                -611,
                1324,
                -229,
                1325
              ]
            ],
            [
              [
                1326
              ]
            ],
            [
              [
                1327
              ]
            ]
          ],
          "id": 528,
          "properties": {
            "name": "Netherlands"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1328
              ]
            ],
            [
              [
                1329
              ]
            ],
            [
              [
                1330
              ]
            ],
            [
              [
                1331
              ]
            ],
            [
              [
                1332
              ]
            ],
            [
              [
                1333
              ]
            ],
            [
              [
                1334
              ]
            ],
            [
              [
                1335
              ]
            ],
            [
              [
                1336
              ]
            ],
            [
              [
                1337
              ]
            ],
            [
              [
                1338
              ]
            ],
            [
              [
                1339
              ]
            ],
            [
              [
                1340
              ]
            ],
            [
              [
                1341
              ]
            ],
            [
              [
                1342
              ]
            ],
            [
              [
                1343
              ]
            ],
            [
              [
                1344
              ]
            ],
            [
              [
                1345
              ]
            ],
            [
              [
                1346
              ]
            ],
            [
              [
                1347
              ]
            ],
            [
              [
                1348,
                -701,
                1349,
                1350
              ]
            ],
            [
              [
                1351
              ]
            ],
            [
              [
                1352
              ]
            ],
            [
              [
                1353
              ]
            ],
            [
              [
                1354
              ]
            ],
            [
              [
                1355
              ]
            ],
            [
              [
                1356
              ]
            ],
            [
              [
                1357
              ]
            ],
            [
              [
                1358
              ]
            ],
            [
              [
                1359
              ]
            ],
            [
              [
                1360
              ]
            ],
            [
              [
                1361
              ]
            ]
          ],
          "id": 578,
          "properties": {
            "name": "Norway"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -530,
              -1049
            ]
          ],
          "id": 524,
          "properties": {
            "name": "Nepal"
          }
        },
        {
          "type": null,
          "id": 520,
          "properties": {
            "name": "Nauru"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1362
              ]
            ],
            [
              [
                1363
              ]
            ],
            [
              [
                1364
              ]
            ],
            [
              [
                1365
              ]
            ],
            [
              [
                1366
              ]
            ],
            [
              [
                1367
              ]
            ],
            [
              [
                1368
              ]
            ],
            [
              [
                1369
              ]
            ],
            [
              [
                1370
              ]
            ],
            [
              [
                1371
              ]
            ],
            [
              [
                1372
              ]
            ]
          ],
          "id": 554,
          "properties": {
            "name": "New Zealand"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1373
              ]
            ],
            [
              [
                1374,
                1375,
                -30,
                1376
              ]
            ],
            [
              [
                1377
              ]
            ],
            [
              [
                -33,
                1378
              ]
            ]
          ],
          "id": 512,
          "properties": {
            "name": "Oman"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1052,
              1379,
              -1065,
              -2,
              -535,
              -1133
            ]
          ],
          "id": 586,
          "properties": {
            "name": "Pakistan"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1380
              ]
            ],
            [
              [
                1381
              ]
            ],
            [
              [
                1382
              ]
            ],
            [
              [
                -570,
                1383,
                -583,
                1384
              ]
            ]
          ],
          "id": 591,
          "properties": {
            "name": "Panama"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1385
            ]
          ],
          "id": 612,
          "properties": {
            "name": "Pitcairn"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -289,
              -506,
              1386,
              -651,
              -567,
              -313
            ]
          ],
          "id": 604,
          "properties": {
            "name": "Peru"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1387
              ]
            ],
            [
              [
                1388
              ]
            ],
            [
              [
                1389
              ]
            ],
            [
              [
                1390
              ]
            ],
            [
              [
                1391
              ]
            ],
            [
              [
                1392
              ]
            ],
            [
              [
                1393
              ]
            ],
            [
              [
                1394
              ]
            ],
            [
              [
                1395
              ]
            ],
            [
              [
                1396
              ]
            ],
            [
              [
                1397
              ]
            ],
            [
              [
                1398
              ]
            ],
            [
              [
                1399
              ]
            ],
            [
              [
                1400
              ]
            ],
            [
              [
                1401
              ]
            ],
            [
              [
                1402
              ]
            ],
            [
              [
                1403
              ]
            ],
            [
              [
                1404
              ]
            ],
            [
              [
                1405
              ]
            ],
            [
              [
                1406
              ]
            ],
            [
              [
                1407
              ]
            ],
            [
              [
                1408
              ]
            ],
            [
              [
                1409
              ]
            ],
            [
              [
                1410
              ]
            ],
            [
              [
                1411
              ]
            ],
            [
              [
                1412
              ]
            ],
            [
              [
                1413
              ]
            ],
            [
              [
                1414
              ]
            ],
            [
              [
                1415
              ]
            ],
            [
              [
                1416
              ]
            ],
            [
              [
                1417
              ]
            ],
            [
              [
                1418
              ]
            ],
            [
              [
                1419
              ]
            ],
            [
              [
                1420
              ]
            ],
            [
              [
                1421
              ]
            ],
            [
              [
                1422
              ]
            ],
            [
              [
                1423
              ]
            ],
            [
              [
                1424
              ]
            ],
            [
              [
                1425
              ]
            ],
            [
              [
                1426
              ]
            ],
            [
              [
                1427
              ]
            ],
            [
              [
                1428
              ]
            ],
            [
              [
                1429
              ]
            ],
            [
              [
                1430
              ]
            ],
            [
              [
                1431
              ]
            ],
            [
              [
                1432
              ]
            ],
            [
              [
                1433
              ]
            ],
            [
              [
                1434
              ]
            ]
          ],
          "id": 608,
          "properties": {
            "name": "Philippines"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1435
            ]
          ],
          "id": 585,
          "properties": {
            "name": "Palau"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1436
              ]
            ],
            [
              [
                1437
              ]
            ],
            [
              [
                1438
              ]
            ],
            [
              [
                1439
              ]
            ],
            [
              [
                1440
              ]
            ],
            [
              [
                1441
              ]
            ],
            [
              [
                1442
              ]
            ],
            [
              [
                1443
              ]
            ],
            [
              [
                1444
              ]
            ],
            [
              [
                1445
              ]
            ],
            [
              [
                1446
              ]
            ],
            [
              [
                1447
              ]
            ],
            [
              [
                1448
              ]
            ],
            [
              [
                1449
              ]
            ],
            [
              [
                1450
              ]
            ],
            [
              [
                1451
              ]
            ],
            [
              [
                1452
              ]
            ],
            [
              [
                1453
              ]
            ],
            [
              [
                1454
              ]
            ],
            [
              [
                1455
              ]
            ],
            [
              [
                1456,
                1457,
                1458
              ]
            ],
            [
              [
                1459
              ]
            ],
            [
              [
                1460
              ]
            ],
            [
              [
                1461
              ]
            ],
            [
              [
                1462
              ]
            ],
            [
              [
                1463
              ]
            ]
          ],
          "id": 598,
          "properties": {
            "name": "Papua New Guinea"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1204,
              -278,
              1464,
              1465,
              -602,
              -608,
              1466,
              -603,
              1467,
              1468
            ]
          ],
          "id": 616,
          "properties": {
            "name": "Poland"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1469
              ]
            ],
            [
              [
                1470
              ]
            ],
            [
              [
                1471
              ]
            ]
          ],
          "id": 630,
          "properties": {
            "name": "Puerto Rico"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1472,
              1473,
              -1177,
              1474,
              -519
            ]
          ],
          "id": 408,
          "properties": {
            "name": "Korea, Democratic People's Republic"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1475
              ]
            ],
            [
              [
                1476
              ]
            ],
            [
              [
                1477
              ]
            ],
            [
              [
                1478
              ]
            ],
            [
              [
                1479
              ]
            ],
            [
              [
                1480
              ]
            ],
            [
              [
                1481
              ]
            ],
            [
              [
                -678,
                1482
              ]
            ]
          ],
          "id": 620,
          "properties": {
            "name": "Portugal"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -40,
              -291,
              -312
            ]
          ],
          "id": 600,
          "properties": {
            "name": "Paraguay"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                -658,
                1483,
                -1079
              ]
            ],
            [
              [
                -1076,
                -1096
              ]
            ]
          ],
          "id": -11,
          "properties": {
            "name": "Palestine"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1484
              ]
            ],
            [
              [
                1485
              ]
            ],
            [
              [
                1486
              ]
            ],
            [
              [
                1487
              ]
            ],
            [
              [
                1488
              ]
            ],
            [
              [
                1489
              ]
            ],
            [
              [
                1490
              ]
            ],
            [
              [
                1491
              ]
            ],
            [
              [
                1492
              ]
            ],
            [
              [
                1493
              ]
            ],
            [
              [
                1494
              ]
            ]
          ],
          "id": -12,
          "properties": {
            "name": "French Polynesia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1495,
              1496
            ]
          ],
          "id": 634,
          "properties": {
            "name": "Qatar"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -254,
              1497,
              -892,
              1498,
              -1217,
              1499,
              1500
            ]
          ],
          "id": 642,
          "properties": {
            "name": "Romania"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1501
              ]
            ],
            [
              [
                1502
              ]
            ],
            [
              [
                1503
              ]
            ],
            [
              [
                1504
              ]
            ],
            [
              [
                1505
              ]
            ],
            [
              [
                1506
              ]
            ],
            [
              [
                1507
              ]
            ],
            [
              [
                1508
              ]
            ],
            [
              [
                1509
              ]
            ],
            [
              [
                1510
              ]
            ],
            [
              [
                1511
              ]
            ],
            [
              [
                1512
              ]
            ],
            [
              [
                1513
              ]
            ],
            [
              [
                1514
              ]
            ],
            [
              [
                1515
              ]
            ],
            [
              [
                1516
              ]
            ],
            [
              [
                -1205,
                -1469,
                1517,
                -1202,
                1518
              ]
            ],
            [
              [
                1519
              ]
            ],
            [
              [
                1520
              ]
            ],
            [
              [
                1521
              ]
            ],
            [
              [
                1522
              ]
            ],
            [
              [
                1523
              ]
            ],
            [
              [
                1524
              ]
            ],
            [
              [
                1525
              ]
            ],
            [
              [
                1526
              ]
            ],
            [
              [
                1527
              ]
            ],
            [
              [
                1528
              ]
            ],
            [
              [
                1529
              ]
            ],
            [
              [
                1530
              ]
            ],
            [
              [
                1531
              ]
            ],
            [
              [
                1532
              ]
            ],
            [
              [
                1533
              ]
            ],
            [
              [
                1534
              ]
            ],
            [
              [
                1535
              ]
            ],
            [
              [
                1536
              ]
            ],
            [
              [
                1537
              ]
            ],
            [
              [
                1538
              ]
            ],
            [
              [
                1539
              ]
            ],
            [
              [
                1540
              ]
            ],
            [
              [
                1541
              ]
            ],
            [
              [
                1542
              ]
            ],
            [
              [
                1543
              ]
            ],
            [
              [
                1544
              ]
            ],
            [
              [
                1545
              ]
            ],
            [
              [
                1546
              ]
            ],
            [
              [
                1547
              ]
            ],
            [
              [
                1548
              ]
            ],
            [
              [
                1549
              ]
            ],
            [
              [
                1550
              ]
            ],
            [
              [
                1551
              ]
            ],
            [
              [
                1552
              ]
            ],
            [
              [
                1553
              ]
            ],
            [
              [
                1554
              ]
            ],
            [
              [
                1555
              ]
            ],
            [
              [
                1556
              ]
            ],
            [
              [
                1557
              ]
            ],
            [
              [
                1558
              ]
            ],
            [
              [
                1559
              ]
            ],
            [
              [
                1560
              ]
            ],
            [
              [
                1561
              ]
            ],
            [
              [
                1562
              ]
            ],
            [
              [
                1563
              ]
            ],
            [
              [
                1564
              ]
            ],
            [
              [
                1565
              ]
            ],
            [
              [
                1566
              ]
            ],
            [
              [
                -1473,
                -541,
                -1266,
                -539,
                -1141,
                1567,
                -218,
                -775,
                1568,
                1569,
                -281,
                -1209,
                -683,
                1570,
                -698,
                -1349,
                1571
              ]
            ],
            [
              [
                1572
              ]
            ],
            [
              [
                1573
              ]
            ],
            [
              [
                1574
              ]
            ],
            [
              [
                1575
              ]
            ],
            [
              [
                1576
              ]
            ],
            [
              [
                1577
              ]
            ],
            [
              [
                1578
              ]
            ],
            [
              [
                1579
              ]
            ],
            [
              [
                1580
              ]
            ],
            [
              [
                1581
              ]
            ],
            [
              [
                1582
              ]
            ],
            [
              [
                1583
              ]
            ],
            [
              [
                1584
              ]
            ],
            [
              [
                1585
              ]
            ],
            [
              [
                1586
              ]
            ],
            [
              [
                1587
              ]
            ],
            [
              [
                1588
              ]
            ],
            [
              [
                1589
              ]
            ],
            [
              [
                1590
              ]
            ],
            [
              [
                1591
              ]
            ],
            [
              [
                1592
              ]
            ],
            [
              [
                1593
              ]
            ],
            [
              [
                1594
              ]
            ],
            [
              [
                1595
              ]
            ],
            [
              [
                1596
              ]
            ],
            [
              [
                1597
              ]
            ],
            [
              [
                1598
              ]
            ],
            [
              [
                1599
              ]
            ],
            [
              [
                1600
              ]
            ],
            [
              [
                1601
              ]
            ]
          ],
          "id": 643,
          "properties": {
            "name": "Russia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -222,
              -556,
              1602,
              1603
            ]
          ],
          "id": 646,
          "properties": {
            "name": "Rwanda"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1213,
              -639,
              -1286,
              1604
            ]
          ],
          "id": 732,
          "properties": {
            "name": "Western Sahara"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1605
              ]
            ],
            [
              [
                1606
              ]
            ],
            [
              [
                -1183,
                1607,
                -1496,
                1608,
                -31,
                -1376,
                1609,
                1610,
                -1098,
                -1070
              ]
            ]
          ],
          "id": 682,
          "properties": {
            "name": "Saudi Arabia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -662,
              -690,
              1611,
              -331,
              1612,
              -1192,
              -655,
              1613
            ]
          ],
          "id": 729,
          "properties": {
            "name": "Sudan"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -689,
              -1147,
              1614,
              -561,
              -326,
              -1612
            ]
          ],
          "id": 728,
          "properties": {
            "name": "South Sudan"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -784,
              -794,
              1615,
              -786,
              1616,
              -1284,
              -1242
            ]
          ],
          "id": 686,
          "properties": {
            "name": "Senegal"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1617
            ]
          ],
          "id": 702,
          "properties": {
            "name": "Singapore"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1618
              ]
            ],
            [
              [
                1619
              ]
            ]
          ],
          "id": 239,
          "properties": {
            "name": "South Georgia and the South Sandwich Islands"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1620
              ]
            ],
            [
              [
                1621
              ]
            ]
          ],
          "id": 654,
          "properties": {
            "name": "Saint Helena, Ascension and Tristan da Cunha"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1622
              ]
            ],
            [
              [
                1623
              ]
            ],
            [
              [
                1624
              ]
            ],
            [
              [
                1625
              ]
            ],
            [
              [
                1626
              ]
            ],
            [
              [
                1627
              ]
            ],
            [
              [
                1628
              ]
            ],
            [
              [
                1629
              ]
            ],
            [
              [
                1630
              ]
            ],
            [
              [
                1631
              ]
            ],
            [
              [
                1632
              ]
            ],
            [
              [
                1633
              ]
            ],
            [
              [
                1634
              ]
            ],
            [
              [
                1635
              ]
            ],
            [
              [
                1636
              ]
            ],
            [
              [
                1637
              ]
            ],
            [
              [
                1638
              ]
            ],
            [
              [
                1639
              ]
            ],
            [
              [
                1640
              ]
            ],
            [
              [
                1641
              ]
            ],
            [
              [
                1642
              ]
            ]
          ],
          "id": 90,
          "properties": {
            "name": "Solomon Islands"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1643
              ]
            ],
            [
              [
                -1190,
                1644,
                -781
              ]
            ]
          ],
          "id": 694,
          "properties": {
            "name": "Sierra Leone"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -858,
              -872,
              1645
            ]
          ],
          "id": 222,
          "properties": {
            "name": "El Salvador"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1646
            ]
          ],
          "id": 674,
          "properties": {
            "name": "San Marino"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -686,
              -619,
              1647,
              1648
            ]
          ],
          "id": -3,
          "properties": {
            "name": "Somaliland"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -687,
              -1649,
              1649,
              -1143
            ]
          ],
          "id": 706,
          "properties": {
            "name": "Somalia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1650
            ]
          ],
          "id": 666,
          "properties": {
            "name": "Saint Pierre and Miquelon"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1498,
              -253,
              -1241,
              -1180,
              -1265,
              -272,
              -885,
              -893
            ]
          ],
          "id": 688,
          "properties": {
            "name": "Serbia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1651
              ]
            ],
            [
              [
                1652
              ]
            ]
          ],
          "id": 678,
          "properties": {
            "name": "São Tomé and Príncipe"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -308,
              -865,
              1653,
              -725
            ]
          ],
          "id": 740,
          "properties": {
            "name": "Suriname"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -895,
              -212,
              -600,
              -1466,
              1654
            ]
          ],
          "id": 703,
          "properties": {
            "name": "Slovakia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1091,
              -205,
              -894,
              -887,
              1655
            ]
          ],
          "id": 705,
          "properties": {
            "name": "Slovenia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1656
              ]
            ],
            [
              [
                1657
              ]
            ],
            [
              [
                1658
              ]
            ],
            [
              [
                1659
              ]
            ],
            [
              [
                1660
              ]
            ],
            [
              [
                -1350,
                -700,
                1661
              ]
            ]
          ],
          "id": 752,
          "properties": {
            "name": "Sweden"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1662,
              -1273
            ]
          ],
          "id": 748,
          "properties": {
            "name": "Eswatini"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1211,
              1663
            ]
          ],
          "id": 534,
          "properties": {
            "name": "Sint Maarten (Dutch part)"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1664
            ]
          ],
          "id": 690,
          "properties": {
            "name": "Seychelles"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1097,
              -1082,
              -1188,
              1665,
              1666,
              -1072
            ]
          ],
          "id": 760,
          "properties": {
            "name": "Syria"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1667
              ]
            ],
            [
              [
                1668
              ]
            ],
            [
              [
                1669
              ]
            ]
          ],
          "id": 796,
          "properties": {
            "name": "Turks and Caicos Islands"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -330,
              -554,
              -1314,
              -1311,
              -1193,
              -1613
            ]
          ],
          "id": 148,
          "properties": {
            "name": "Chad"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -778,
              -236,
              -231,
              1670
            ]
          ],
          "id": 768,
          "properties": {
            "name": "Togo"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1671
              ]
            ],
            [
              [
                1672
              ]
            ],
            [
              [
                1673
              ]
            ],
            [
              [
                1674
              ]
            ],
            [
              [
                1675
              ]
            ],
            [
              [
                1676
              ]
            ],
            [
              [
                1677
              ]
            ],
            [
              [
                1678
              ]
            ],
            [
              [
                1679
              ]
            ],
            [
              [
                -1185,
                -1154,
                1680,
                -1296,
                1681,
                -1262
              ]
            ]
          ],
          "id": 764,
          "properties": {
            "name": "Thailand"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                -1150
              ]
            ],
            [
              [
                1682
              ]
            ],
            [
              [
                -1148,
                -536,
                -6,
                1683
              ]
            ]
          ],
          "id": 762,
          "properties": {
            "name": "Tajikistan"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1684
              ]
            ],
            [
              [
                -4,
                -1062,
                1685,
                -1139,
                1686
              ]
            ]
          ],
          "id": 795,
          "properties": {
            "name": "Turkmenistan"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                -901,
                1687
              ]
            ],
            [
              [
                -903,
                1688
              ]
            ],
            [
              [
                1689
              ]
            ]
          ],
          "id": 626,
          "properties": {
            "name": "Timor-Leste"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1690
              ]
            ],
            [
              [
                1691
              ]
            ],
            [
              [
                1692
              ]
            ]
          ],
          "id": 776,
          "properties": {
            "name": "Tonga"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1693
              ]
            ],
            [
              [
                1694
              ]
            ]
          ],
          "id": 780,
          "properties": {
            "name": "Trinidad and Tobago"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1695
              ]
            ],
            [
              [
                1696
              ]
            ],
            [
              [
                -1195,
                -642,
                1697
              ]
            ]
          ],
          "id": 788,
          "properties": {
            "name": "Tunisia"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1698
              ]
            ],
            [
              [
                -773,
                -49,
                -214,
                -1068,
                -1073,
                -1667,
                1699
              ]
            ],
            [
              [
                -837,
                -250,
                1700
              ]
            ]
          ],
          "id": 792,
          "properties": {
            "name": "Turkey"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1701
              ]
            ],
            [
              [
                1702
              ]
            ]
          ],
          "id": 158,
          "properties": {
            "name": "Taiwan"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1703
              ]
            ],
            [
              [
                1704
              ]
            ],
            [
              [
                1705
              ]
            ],
            [
              [
                -1145,
                1706,
                -1278,
                -1290,
                1707,
                -557,
                -223,
                -1604,
                1708
              ]
            ]
          ],
          "id": 834,
          "properties": {
            "name": "Tanzania"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1603,
              -555,
              -1615,
              -1146,
              -1709
            ]
          ],
          "id": 800,
          "properties": {
            "name": "Uganda"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1710,
                -1500,
                -1216,
                -1499,
                -896,
                -1655,
                -1465,
                -277,
                -1570
              ]
            ]
          ],
          "id": 804,
          "properties": {
            "name": "Ukraine"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -42,
              -311,
              1711
            ]
          ],
          "id": 858,
          "properties": {
            "name": "Uruguay"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1712
              ]
            ],
            [
              [
                1713
              ]
            ],
            [
              [
                1714
              ]
            ],
            [
              [
                1715
              ]
            ],
            [
              [
                1716
              ]
            ],
            [
              [
                1717
              ]
            ],
            [
              [
                1718
              ]
            ],
            [
              [
                1719
              ]
            ],
            [
              [
                1720
              ]
            ],
            [
              [
                1721
              ]
            ],
            [
              [
                1722
              ]
            ],
            [
              [
                1723
              ]
            ],
            [
              [
                1724
              ]
            ],
            [
              [
                1725
              ]
            ],
            [
              [
                1726
              ]
            ],
            [
              [
                1727
              ]
            ],
            [
              [
                1728
              ]
            ],
            [
              [
                1729
              ]
            ],
            [
              [
                1730
              ]
            ],
            [
              [
                1731
              ]
            ],
            [
              [
                1732
              ]
            ],
            [
              [
                1733
              ]
            ],
            [
              [
                1734
              ]
            ],
            [
              [
                1735
              ]
            ],
            [
              [
                1736
              ]
            ],
            [
              [
                1737
              ]
            ],
            [
              [
                1738
              ]
            ],
            [
              [
                1739
              ]
            ],
            [
              [
                1740
              ]
            ],
            [
              [
                1741
              ]
            ],
            [
              [
                1742
              ]
            ],
            [
              [
                1743
              ]
            ],
            [
              [
                1744
              ]
            ],
            [
              [
                1745
              ]
            ],
            [
              [
                -344,
                1746,
                -1237,
                1747,
                -429
              ]
            ],
            [
              [
                1748
              ]
            ],
            [
              [
                1749
              ]
            ],
            [
              [
                1750
              ]
            ],
            [
              [
                1751
              ]
            ],
            [
              [
                1752
              ]
            ],
            [
              [
                1753
              ]
            ],
            [
              [
                1754
              ]
            ],
            [
              [
                1755
              ]
            ],
            [
              [
                1756
              ]
            ],
            [
              [
                1757
              ]
            ],
            [
              [
                1758
              ]
            ],
            [
              [
                1759
              ]
            ],
            [
              [
                1760
              ]
            ],
            [
              [
                1761
              ]
            ],
            [
              [
                1762
              ]
            ],
            [
              [
                1763
              ]
            ],
            [
              [
                1764
              ]
            ],
            [
              [
                1765
              ]
            ],
            [
              [
                1766
              ]
            ],
            [
              [
                1767
              ]
            ],
            [
              [
                1768
              ]
            ],
            [
              [
                1769
              ]
            ],
            [
              [
                1770
              ]
            ],
            [
              [
                1771
              ]
            ],
            [
              [
                1772
              ]
            ],
            [
              [
                1773
              ]
            ],
            [
              [
                1774
              ]
            ],
            [
              [
                1775
              ]
            ],
            [
              [
                1776
              ]
            ],
            [
              [
                1777
              ]
            ],
            [
              [
                1778
              ]
            ],
            [
              [
                1779
              ]
            ],
            [
              [
                1780
              ]
            ],
            [
              [
                1781
              ]
            ],
            [
              [
                1782
              ]
            ],
            [
              [
                1783
              ]
            ],
            [
              [
                1784
              ]
            ],
            [
              [
                1785
              ]
            ],
            [
              [
                1786
              ]
            ],
            [
              [
                1787
              ]
            ],
            [
              [
                1788
              ]
            ],
            [
              [
                1789
              ]
            ],
            [
              [
                1790
              ]
            ],
            [
              [
                1791
              ]
            ],
            [
              [
                1792
              ]
            ],
            [
              [
                1793
              ]
            ],
            [
              [
                1794
              ]
            ],
            [
              [
                1795
              ]
            ],
            [
              [
                1796
              ]
            ],
            [
              [
                1797
              ]
            ],
            [
              [
                1798
              ]
            ],
            [
              [
                1799
              ]
            ],
            [
              [
                1800
              ]
            ],
            [
              [
                1801
              ]
            ],
            [
              [
                1802
              ]
            ],
            [
              [
                1803
              ]
            ],
            [
              [
                1804
              ]
            ],
            [
              [
                1805
              ]
            ],
            [
              [
                1806
              ]
            ],
            [
              [
                1807
              ]
            ],
            [
              [
                1808
              ]
            ],
            [
              [
                1809
              ]
            ],
            [
              [
                1810
              ]
            ],
            [
              [
                1811
              ]
            ],
            [
              [
                1812
              ]
            ],
            [
              [
                -427,
                1813,
                -372,
                1814
              ]
            ]
          ],
          "id": 840,
          "properties": {
            "name": "United States"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                -1151
              ]
            ],
            [
              [
                -1152
              ]
            ],
            [
              [
                -1149,
                -1684,
                -5,
                -1687,
                -1138
              ]
            ]
          ],
          "id": 860,
          "properties": {
            "name": "Uzbekistan"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1815
            ]
          ],
          "id": 670,
          "properties": {
            "name": "Saint Vincent and the Grenadines"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1816
              ]
            ],
            [
              [
                1817
              ]
            ],
            [
              [
                1818
              ]
            ],
            [
              [
                1819
              ]
            ],
            [
              [
                -863,
                -315,
                -566,
                1820
              ]
            ]
          ],
          "id": 862,
          "properties": {
            "name": "Venezuela"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              1821
            ]
          ],
          "id": 92,
          "properties": {
            "name": "British Virgin Islands"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1822
              ]
            ],
            [
              [
                1823
              ]
            ],
            [
              [
                1824
              ]
            ]
          ],
          "id": 850,
          "properties": {
            "name": "U.S. Virgin Islands"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1825
              ]
            ],
            [
              [
                1826
              ]
            ],
            [
              [
                1827
              ]
            ],
            [
              [
                1828
              ]
            ],
            [
              [
                1829
              ]
            ],
            [
              [
                1830
              ]
            ],
            [
              [
                1831
              ]
            ],
            [
              [
                -1156,
                -1187,
                -525,
                1832
              ]
            ]
          ],
          "id": 704,
          "properties": {
            "name": "Vietnam"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1833
              ]
            ],
            [
              [
                1834
              ]
            ],
            [
              [
                1835
              ]
            ],
            [
              [
                1836
              ]
            ],
            [
              [
                1837
              ]
            ],
            [
              [
                1838
              ]
            ],
            [
              [
                1839
              ]
            ],
            [
              [
                1840
              ]
            ],
            [
              [
                1841
              ]
            ],
            [
              [
                1842
              ]
            ],
            [
              [
                1843
              ]
            ],
            [
              [
                1844
              ]
            ],
            [
              [
                1845
              ]
            ],
            [
              [
                1846
              ]
            ]
          ],
          "id": 548,
          "properties": {
            "name": "Vanuatu"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1847
              ]
            ],
            [
              [
                1848
              ]
            ]
          ],
          "id": 876,
          "properties": {
            "name": "Wallis and Futuna"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1849
              ]
            ],
            [
              [
                1850
              ]
            ]
          ],
          "id": 882,
          "properties": {
            "name": "Samoa"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1851
              ]
            ],
            [
              [
                1852
              ]
            ],
            [
              [
                1853
              ]
            ],
            [
              [
                -1610,
                -1375,
                1854
              ]
            ]
          ],
          "id": 887,
          "properties": {
            "name": "Yemen"
          }
        },
        {
          "type": "MultiPolygon",
          "arcs": [
            [
              [
                1855
              ]
            ],
            [
              [
                -1274,
                -1663,
                -1280,
                1856,
                -1302,
                -323,
                1857
              ],
              [
                1858
              ]
            ]
          ],
          "id": 710,
          "properties": {
            "name": "South Africa"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -1276,
              1859,
              -1304,
              -8,
              -558,
              -1708,
              -1289
            ]
          ],
          "id": 894,
          "properties": {
            "name": "Zambia"
          }
        },
        {
          "type": "Polygon",
          "arcs": [
            [
              -325,
              -1860,
              -1275,
              -1858
            ]
          ],
          "id": 716,
          "properties": {
            "name": "Zimbabwe"
          }
        }
      ],
      "bbox": [
        -180,
        -89.99892578124998,
        180,
        83.59960937500004
      ]
    }
  },
  "arcs": [
    [
      [
        37880,
        63997
      ],
      [
        0,
        -21
      ],
      [
        -24,
        11
      ],
      [
        -13,
        32
      ],
      [
        -24,
        33
      ],
      [
        0,
        32
      ],
      [
        12,
        11
      ],
      [
        37,
        -87
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        87566,
        79343
      ],
      [
        -37,
        -32
      ],
      [
        -136,
        -98
      ],
      [
        -87,
        44
      ],
      [
        -124,
        0
      ],
      [
        -99,
        -11
      ],
      [
        -124,
        -22
      ],
      [
        -49,
        0
      ],
      [
        -62,
        -43
      ],
      [
        -38,
        -11
      ],
      [
        -61,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -54
      ],
      [
        -49,
        -76
      ],
      [
        -38,
        -33
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -21
      ],
      [
        50,
        -44
      ],
      [
        25,
        -65
      ],
      [
        25,
        -141
      ],
      [
        24,
        -32
      ],
      [
        0,
        -55
      ],
      [
        13,
        -32
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -22
      ],
      [
        25,
        -54
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        -87
      ],
      [
        -62,
        -54
      ],
      [
        -25,
        -55
      ],
      [
        -37,
        -65
      ],
      [
        -12,
        -54
      ],
      [
        -37,
        -43
      ],
      [
        0,
        -22
      ],
      [
        49,
        -76
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -44
      ],
      [
        -24,
        -43
      ],
      [
        -62,
        -44
      ],
      [
        -75,
        -21
      ],
      [
        -111,
        0
      ],
      [
        -25,
        11
      ],
      [
        -87,
        54
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -65
      ],
      [
        62,
        -108
      ],
      [
        25,
        -65
      ],
      [
        25,
        -109
      ],
      [
        24,
        -54
      ],
      [
        0,
        -43
      ],
      [
        -62,
        -65
      ],
      [
        -61,
        -44
      ],
      [
        -124,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -13,
        -119
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -62,
        -163
      ],
      [
        13,
        -108
      ],
      [
        0,
        -195
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        -38,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        -37,
        10
      ],
      [
        -12,
        44
      ],
      [
        -50,
        54
      ],
      [
        -25,
        0
      ],
      [
        -24,
        -33
      ],
      [
        -38,
        11
      ],
      [
        -37,
        22
      ],
      [
        -24,
        0
      ],
      [
        -50,
        -76
      ],
      [
        -99,
        -87
      ],
      [
        -37,
        0
      ],
      [
        -13,
        -21
      ],
      [
        25,
        -65
      ],
      [
        25,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -87,
        -76
      ],
      [
        -62,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -24,
        32
      ],
      [
        -38,
        0
      ],
      [
        -37,
        -21
      ],
      [
        -37,
        -44
      ],
      [
        -37,
        -97
      ],
      [
        0,
        -11
      ],
      [
        -74,
        -65
      ],
      [
        -13,
        -76
      ],
      [
        -25,
        -119
      ],
      [
        13,
        -65
      ],
      [
        0,
        -109
      ],
      [
        -13,
        -87
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -43
      ],
      [
        25,
        -55
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        -74,
        -32
      ],
      [
        -99,
        -54
      ],
      [
        -198,
        -87
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -112,
        0
      ],
      [
        -86,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        22
      ],
      [
        -137,
        44
      ],
      [
        -384,
        -55
      ],
      [
        -37,
        11
      ],
      [
        -124,
        65
      ],
      [
        -161,
        87
      ],
      [
        -99,
        54
      ],
      [
        -136,
        65
      ]
    ],
    [
      [
        82859,
        74864
      ],
      [
        87,
        174
      ],
      [
        74,
        141
      ],
      [
        87,
        152
      ],
      [
        74,
        141
      ],
      [
        12,
        54
      ],
      [
        0,
        97
      ],
      [
        -24,
        131
      ],
      [
        -25,
        65
      ],
      [
        -112,
        21
      ],
      [
        -173,
        44
      ],
      [
        -12,
        0
      ],
      [
        -13,
        108
      ],
      [
        13,
        44
      ],
      [
        -13,
        86
      ],
      [
        0,
        76
      ],
      [
        13,
        109
      ],
      [
        12,
        54
      ],
      [
        -50,
        217
      ],
      [
        -24,
        119
      ],
      [
        -13,
        130
      ],
      [
        -12,
        33
      ],
      [
        0,
        54
      ],
      [
        49,
        119
      ],
      [
        25,
        22
      ],
      [
        25,
        54
      ],
      [
        25,
        33
      ],
      [
        0,
        21
      ],
      [
        -37,
        11
      ],
      [
        -50,
        0
      ],
      [
        -37,
        22
      ],
      [
        -25,
        76
      ],
      [
        12,
        87
      ],
      [
        -12,
        152
      ],
      [
        25,
        75
      ],
      [
        25,
        55
      ],
      [
        86,
        11
      ],
      [
        -37,
        97
      ],
      [
        -12,
        11
      ],
      [
        0,
        33
      ],
      [
        37,
        21
      ],
      [
        37,
        44
      ],
      [
        0,
        43
      ],
      [
        37,
        87
      ],
      [
        0,
        43
      ],
      [
        25,
        76
      ],
      [
        0,
        65
      ],
      [
        -12,
        33
      ],
      [
        0,
        43
      ],
      [
        37,
        22
      ],
      [
        0,
        32
      ],
      [
        12,
        44
      ],
      [
        0,
        32
      ],
      [
        13,
        22
      ],
      [
        0,
        65
      ]
    ],
    [
      [
        83008,
        78465
      ],
      [
        24,
        0
      ],
      [
        62,
        -98
      ],
      [
        62,
        -32
      ],
      [
        99,
        21
      ],
      [
        37,
        -43
      ],
      [
        50,
        -76
      ],
      [
        12,
        -43
      ],
      [
        13,
        -11
      ],
      [
        25,
        43
      ],
      [
        24,
        11
      ],
      [
        25,
        -11
      ],
      [
        50,
        11
      ],
      [
        62,
        54
      ],
      [
        62,
        65
      ],
      [
        12,
        76
      ],
      [
        12,
        44
      ],
      [
        25,
        21
      ],
      [
        -25,
        55
      ],
      [
        0,
        54
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        75,
        32
      ],
      [
        123,
        65
      ],
      [
        62,
        0
      ],
      [
        0,
        33
      ],
      [
        13,
        22
      ],
      [
        37,
        21
      ],
      [
        62,
        54
      ],
      [
        49,
        66
      ],
      [
        13,
        54
      ],
      [
        12,
        87
      ],
      [
        25,
        119
      ],
      [
        37,
        130
      ],
      [
        0,
        65
      ],
      [
        13,
        43
      ],
      [
        49,
        44
      ],
      [
        50,
        22
      ],
      [
        74,
        10
      ],
      [
        87,
        0
      ],
      [
        24,
        130
      ],
      [
        13,
        33
      ],
      [
        25,
        33
      ],
      [
        12,
        0
      ],
      [
        111,
        -98
      ],
      [
        87,
        -22
      ],
      [
        37,
        -21
      ],
      [
        25,
        10
      ]
    ],
    [
      [
        84816,
        79549
      ],
      [
        99,
        11
      ],
      [
        87,
        -21
      ],
      [
        37,
        -65
      ],
      [
        50,
        -11
      ],
      [
        62,
        32
      ],
      [
        12,
        -21
      ],
      [
        25,
        -11
      ],
      [
        25,
        11
      ],
      [
        24,
        -22
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        85237,
        79430
      ],
      [
        25,
        -65
      ],
      [
        50,
        -54
      ],
      [
        37,
        -11
      ],
      [
        49,
        43
      ],
      [
        13,
        -10
      ],
      [
        12,
        21
      ],
      [
        0,
        33
      ],
      [
        25,
        21
      ],
      [
        62,
        33
      ],
      [
        37,
        43
      ],
      [
        25,
        11
      ],
      [
        12,
        -11
      ],
      [
        25,
        11
      ],
      [
        0,
        33
      ],
      [
        25,
        11
      ],
      [
        49,
        -44
      ],
      [
        37,
        -65
      ],
      [
        38,
        -32
      ],
      [
        12,
        0
      ],
      [
        37,
        54
      ],
      [
        0,
        173
      ],
      [
        25,
        44
      ],
      [
        49,
        32
      ],
      [
        62,
        11
      ],
      [
        50,
        -11
      ],
      [
        25,
        -32
      ],
      [
        37,
        0
      ],
      [
        37,
        76
      ],
      [
        0,
        65
      ],
      [
        -12,
        65
      ],
      [
        0,
        32
      ],
      [
        37,
        33
      ],
      [
        37,
        54
      ],
      [
        37,
        76
      ],
      [
        25,
        87
      ],
      [
        49,
        54
      ],
      [
        50,
        22
      ],
      [
        50,
        -22
      ],
      [
        74,
        -65
      ],
      [
        25,
        -87
      ],
      [
        -13,
        -108
      ],
      [
        0,
        -55
      ],
      [
        13,
        -10
      ],
      [
        62,
        21
      ],
      [
        24,
        -11
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -217
      ],
      [
        0,
        -109
      ],
      [
        -12,
        -87
      ],
      [
        12,
        -75
      ],
      [
        25,
        -98
      ],
      [
        25,
        -76
      ],
      [
        37,
        -33
      ],
      [
        25,
        11
      ],
      [
        49,
        44
      ],
      [
        75,
        86
      ],
      [
        74,
        44
      ],
      [
        99,
        32
      ],
      [
        37,
        87
      ],
      [
        50,
        65
      ],
      [
        99,
        87
      ],
      [
        62,
        32
      ],
      [
        37,
        11
      ],
      [
        62,
        -32
      ],
      [
        25,
        0
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        13,
        -21
      ],
      [
        25,
        0
      ],
      [
        123,
        54
      ],
      [
        25,
        0
      ],
      [
        13,
        32
      ],
      [
        49,
        33
      ],
      [
        62,
        -33
      ],
      [
        50,
        11
      ],
      [
        24,
        -22
      ],
      [
        50,
        -75
      ]
    ],
    [
      [
        87690,
        79474
      ],
      [
        -12,
        -11
      ],
      [
        -38,
        43
      ],
      [
        -62,
        -32
      ],
      [
        -61,
        -44
      ],
      [
        0,
        -22
      ],
      [
        49,
        -65
      ]
    ],
    [
      [
        70174,
        49422
      ],
      [
        0,
        -76
      ],
      [
        13,
        -120
      ],
      [
        0,
        -76
      ],
      [
        12,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -21
      ],
      [
        0,
        -44
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -250
      ],
      [
        -12,
        -86
      ],
      [
        25,
        -141
      ],
      [
        -13,
        -44
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -130
      ],
      [
        0,
        -32
      ],
      [
        37,
        -98
      ],
      [
        0,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -24,
        -10
      ],
      [
        -174,
        0
      ],
      [
        -198,
        0
      ],
      [
        -272,
        0
      ],
      [
        0,
        -488
      ],
      [
        0,
        -402
      ],
      [
        0,
        -401
      ],
      [
        0,
        -206
      ],
      [
        0,
        -347
      ],
      [
        24,
        -185
      ],
      [
        38,
        -216
      ],
      [
        61,
        -55
      ],
      [
        50,
        -76
      ],
      [
        25,
        -65
      ],
      [
        62,
        -97
      ],
      [
        86,
        -130
      ],
      [
        75,
        -120
      ],
      [
        62,
        -108
      ]
    ],
    [
      [
        69964,
        45192
      ],
      [
        -99,
        -33
      ],
      [
        -261,
        -86
      ],
      [
        -123,
        -44
      ],
      [
        -87,
        -21
      ],
      [
        -99,
        -44
      ],
      [
        -50,
        33
      ],
      [
        -62,
        0
      ],
      [
        -62,
        -33
      ],
      [
        -62,
        -11
      ],
      [
        -74,
        44
      ],
      [
        -49,
        43
      ],
      [
        -62,
        11
      ],
      [
        -99,
        -11
      ],
      [
        -100,
        11
      ],
      [
        -86,
        32
      ],
      [
        -62,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -37,
        22
      ],
      [
        -37,
        43
      ],
      [
        -50,
        76
      ],
      [
        -37,
        87
      ],
      [
        -12,
        22
      ],
      [
        -211,
        0
      ],
      [
        -50,
        11
      ],
      [
        -260,
        0
      ],
      [
        -260,
        0
      ],
      [
        -136,
        0
      ],
      [
        -260,
        0
      ],
      [
        -211,
        0
      ],
      [
        -62,
        -11
      ],
      [
        -74,
        0
      ],
      [
        -37,
        21
      ],
      [
        -37,
        55
      ],
      [
        -38,
        32
      ],
      [
        -37,
        54
      ],
      [
        -37,
        65
      ],
      [
        -25,
        22
      ],
      [
        -74,
        22
      ],
      [
        -25,
        0
      ],
      [
        -86,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -75,
        -65
      ],
      [
        -123,
        0
      ],
      [
        -38,
        33
      ],
      [
        -24,
        -11
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        -11
      ]
    ],
    [
      [
        65963,
        45441
      ],
      [
        12,
        239
      ],
      [
        12,
        98
      ],
      [
        0,
        455
      ],
      [
        -24,
        87
      ],
      [
        62,
        76
      ],
      [
        12,
        54
      ],
      [
        25,
        76
      ],
      [
        12,
        163
      ],
      [
        74,
        379
      ],
      [
        38,
        380
      ],
      [
        37,
        173
      ],
      [
        24,
        195
      ],
      [
        112,
        261
      ],
      [
        37,
        152
      ],
      [
        62,
        86
      ],
      [
        87,
        76
      ],
      [
        62,
        152
      ],
      [
        24,
        98
      ],
      [
        38,
        195
      ],
      [
        0,
        206
      ],
      [
        24,
        271
      ],
      [
        -12,
        76
      ],
      [
        -25,
        108
      ],
      [
        -12,
        76
      ],
      [
        -25,
        76
      ],
      [
        -37,
        54
      ],
      [
        -12,
        109
      ],
      [
        -62,
        152
      ],
      [
        -13,
        108
      ],
      [
        -25,
        76
      ],
      [
        0,
        98
      ],
      [
        -24,
        97
      ],
      [
        -50,
        217
      ],
      [
        0,
        33
      ],
      [
        13,
        11
      ],
      [
        12,
        -11
      ],
      [
        99,
        195
      ],
      [
        12,
        43
      ],
      [
        -12,
        44
      ],
      [
        0,
        43
      ],
      [
        12,
        65
      ],
      [
        -99,
        369
      ],
      [
        -86,
        347
      ],
      [
        -13,
        174
      ],
      [
        -99,
        227
      ],
      [
        -49,
        141
      ],
      [
        -13,
        109
      ],
      [
        -25,
        43
      ],
      [
        38,
        22
      ],
      [
        61,
        21
      ],
      [
        75,
        22
      ],
      [
        99,
        87
      ]
    ],
    [
      [
        66421,
        52545
      ],
      [
        37,
        11
      ],
      [
        37,
        -11
      ],
      [
        25,
        11
      ],
      [
        211,
        0
      ],
      [
        49,
        -11
      ],
      [
        25,
        0
      ],
      [
        74,
        -11
      ],
      [
        87,
        0
      ],
      [
        37,
        11
      ],
      [
        223,
        0
      ],
      [
        112,
        11
      ],
      [
        111,
        -11
      ],
      [
        87,
        0
      ],
      [
        37,
        -22
      ],
      [
        37,
        -32
      ],
      [
        25,
        -44
      ],
      [
        12,
        -54
      ],
      [
        25,
        -32
      ],
      [
        0,
        -185
      ],
      [
        12,
        -97
      ],
      [
        25,
        -98
      ],
      [
        37,
        -98
      ],
      [
        13,
        -76
      ],
      [
        0,
        -65
      ],
      [
        12,
        -65
      ],
      [
        25,
        -65
      ],
      [
        25,
        -32
      ],
      [
        0,
        -22
      ],
      [
        37,
        -108
      ],
      [
        62,
        -163
      ],
      [
        37,
        -119
      ],
      [
        12,
        -11
      ],
      [
        25,
        0
      ],
      [
        99,
        21
      ],
      [
        25,
        -32
      ],
      [
        62,
        54
      ],
      [
        49,
        11
      ],
      [
        50,
        22
      ],
      [
        37,
        21
      ],
      [
        25,
        0
      ],
      [
        87,
        -32
      ],
      [
        12,
        -11
      ],
      [
        74,
        0
      ],
      [
        62,
        22
      ],
      [
        13,
        162
      ],
      [
        0,
        33
      ],
      [
        12,
        65
      ],
      [
        25,
        54
      ],
      [
        0,
        119
      ],
      [
        12,
        87
      ],
      [
        50,
        65
      ],
      [
        74,
        33
      ],
      [
        37,
        0
      ],
      [
        75,
        22
      ],
      [
        99,
        21
      ],
      [
        37,
        0
      ],
      [
        0,
        -11
      ],
      [
        -25,
        -119
      ],
      [
        0,
        -32
      ],
      [
        12,
        -44
      ],
      [
        13,
        -22
      ],
      [
        210,
        0
      ],
      [
        100,
        -10
      ],
      [
        86,
        0
      ],
      [
        25,
        -22
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -120
      ],
      [
        -12,
        -162
      ],
      [
        12,
        -152
      ],
      [
        25,
        -141
      ],
      [
        0,
        -217
      ],
      [
        -13,
        -141
      ],
      [
        -12,
        -163
      ],
      [
        0,
        -184
      ],
      [
        12,
        -76
      ],
      [
        38,
        -87
      ],
      [
        49,
        -86
      ],
      [
        37,
        -109
      ],
      [
        25,
        -141
      ],
      [
        0,
        -173
      ],
      [
        12,
        -98
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -76
      ],
      [
        0,
        -65
      ],
      [
        13,
        -33
      ],
      [
        24,
        -22
      ],
      [
        62,
        76
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        50,
        -11
      ],
      [
        111,
        0
      ],
      [
        87,
        65
      ],
      [
        50,
        0
      ],
      [
        49,
        -21
      ],
      [
        50,
        0
      ],
      [
        24,
        21
      ],
      [
        0,
        22
      ],
      [
        13,
        33
      ],
      [
        12,
        11
      ]
    ],
    [
      [
        66062,
        53087
      ],
      [
        12,
        33
      ],
      [
        37,
        76
      ],
      [
        13,
        32
      ],
      [
        37,
        11
      ],
      [
        12,
        22
      ],
      [
        13,
        43
      ],
      [
        0,
        22
      ],
      [
        86,
        54
      ],
      [
        25,
        43
      ],
      [
        25,
        22
      ],
      [
        25,
        0
      ],
      [
        12,
        -11
      ],
      [
        25,
        -65
      ],
      [
        25,
        -43
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        66421,
        53315
      ],
      [
        0,
        -11
      ],
      [
        -87,
        -54
      ],
      [
        -49,
        -98
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -44
      ],
      [
        -13,
        -21
      ],
      [
        25,
        -44
      ],
      [
        0,
        -173
      ],
      [
        -12,
        -184
      ],
      [
        -87,
        -22
      ],
      [
        -12,
        0
      ]
    ],
    [
      [
        66124,
        52621
      ],
      [
        -13,
        76
      ],
      [
        0,
        54
      ],
      [
        13,
        43
      ],
      [
        -13,
        98
      ],
      [
        -25,
        76
      ],
      [
        -24,
        97
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        40246,
        67598
      ],
      [
        -49,
        -33
      ],
      [
        0,
        22
      ],
      [
        37,
        44
      ],
      [
        25,
        -11
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        68997,
        82369
      ],
      [
        -12,
        -97
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -33
      ],
      [
        13,
        -86
      ],
      [
        0,
        -66
      ],
      [
        24,
        -97
      ],
      [
        38,
        -44
      ],
      [
        12,
        -75
      ],
      [
        12,
        -22
      ],
      [
        50,
        11
      ],
      [
        25,
        -44
      ]
    ],
    [
      [
        69134,
        81729
      ],
      [
        0,
        -43
      ],
      [
        25,
        -76
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -76
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        -98
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        -50,
        -11
      ],
      [
        -49,
        -54
      ],
      [
        0,
        -22
      ],
      [
        25,
        -65
      ],
      [
        0,
        -32
      ],
      [
        -25,
        11
      ],
      [
        -13,
        -65
      ],
      [
        -24,
        -33
      ],
      [
        -62,
        33
      ]
    ],
    [
      [
        68812,
        81014
      ],
      [
        -13,
        65
      ],
      [
        0,
        43
      ],
      [
        -49,
        108
      ],
      [
        -124,
        98
      ],
      [
        -25,
        54
      ],
      [
        -25,
        76
      ],
      [
        37,
        -22
      ],
      [
        0,
        55
      ],
      [
        -37,
        97
      ],
      [
        13,
        109
      ],
      [
        37,
        87
      ],
      [
        -13,
        108
      ],
      [
        13,
        76
      ],
      [
        -13,
        54
      ],
      [
        0,
        65
      ],
      [
        25,
        87
      ],
      [
        25,
        54
      ],
      [
        0,
        87
      ],
      [
        -37,
        43
      ],
      [
        -50,
        11
      ]
    ],
    [
      [
        68576,
        82369
      ],
      [
        0,
        33
      ],
      [
        13,
        43
      ],
      [
        0,
        43
      ],
      [
        -25,
        66
      ],
      [
        12,
        54
      ],
      [
        75,
        152
      ],
      [
        12,
        43
      ],
      [
        37,
        54
      ],
      [
        13,
        -11
      ],
      [
        0,
        -65
      ],
      [
        24,
        -32
      ],
      [
        25,
        0
      ],
      [
        62,
        43
      ]
    ],
    [
      [
        68824,
        82792
      ],
      [
        12,
        -11
      ],
      [
        38,
        -65
      ],
      [
        12,
        -54
      ],
      [
        62,
        -43
      ],
      [
        25,
        -33
      ],
      [
        12,
        -32
      ],
      [
        12,
        -98
      ],
      [
        13,
        -54
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        69010,
        93724
      ],
      [
        0,
        -22
      ],
      [
        -62,
        11
      ],
      [
        0,
        22
      ],
      [
        25,
        11
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        68688,
        93811
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        22
      ],
      [
        13,
        32
      ],
      [
        24,
        0
      ],
      [
        13,
        -32
      ]
    ],
    [
      [
        68799,
        93908
      ],
      [
        37,
        11
      ],
      [
        62,
        -65
      ],
      [
        -24,
        -43
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -75,
        -11
      ],
      [
        -24,
        11
      ],
      [
        -25,
        86
      ],
      [
        49,
        55
      ],
      [
        0,
        21
      ],
      [
        25,
        33
      ],
      [
        37,
        -44
      ]
    ],
    [
      [
        62420,
        82825
      ],
      [
        25,
        21
      ],
      [
        24,
        0
      ],
      [
        50,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        62507,
        82760
      ],
      [
        -75,
        -44
      ],
      [
        -12,
        11
      ],
      [
        0,
        33
      ],
      [
        -13,
        21
      ],
      [
        13,
        44
      ]
    ],
    [
      [
        80481,
        71318
      ],
      [
        0,
        -22
      ],
      [
        -38,
        0
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        22
      ],
      [
        13,
        33
      ],
      [
        49,
        32
      ],
      [
        38,
        -54
      ]
    ],
    [
      [
        80022,
        71383
      ],
      [
        -12,
        33
      ],
      [
        25,
        21
      ],
      [
        12,
        -21
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        80270,
        71372
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        22
      ],
      [
        50,
        33
      ],
      [
        37,
        43
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        80666,
        71481
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -12,
        21
      ],
      [
        25,
        22
      ],
      [
        24,
        -43
      ]
    ],
    [
      [
        81323,
        71817
      ],
      [
        -13,
        0
      ],
      [
        -24,
        -65
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        -38,
        -33
      ],
      [
        -24,
        76
      ],
      [
        12,
        11
      ],
      [
        -12,
        54
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -44
      ],
      [
        0,
        -173
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -97
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -65
      ],
      [
        13,
        -21
      ],
      [
        37,
        0
      ],
      [
        25,
        -76
      ],
      [
        0,
        -22
      ],
      [
        -75,
        -22
      ],
      [
        -24,
        0
      ],
      [
        -50,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        13,
        -32
      ],
      [
        0,
        -98
      ],
      [
        -13,
        -54
      ],
      [
        -49,
        -163
      ],
      [
        -25,
        -119
      ],
      [
        -25,
        -98
      ],
      [
        0,
        -206
      ]
    ],
    [
      [
        80914,
        70396
      ],
      [
        -25,
        -54
      ],
      [
        -74,
        22
      ],
      [
        -37,
        0
      ],
      [
        -50,
        10
      ],
      [
        -62,
        22
      ],
      [
        -74,
        11
      ],
      [
        -74,
        22
      ],
      [
        -75,
        10
      ],
      [
        -74,
        22
      ],
      [
        -74,
        11
      ],
      [
        -75,
        22
      ],
      [
        -62,
        11
      ],
      [
        -86,
        21
      ],
      [
        -62,
        11
      ],
      [
        -25,
        33
      ],
      [
        -12,
        43
      ],
      [
        -25,
        43
      ],
      [
        -13,
        44
      ],
      [
        -24,
        32
      ],
      [
        -13,
        44
      ],
      [
        -24,
        43
      ],
      [
        -13,
        43
      ],
      [
        -25,
        33
      ],
      [
        -12,
        43
      ],
      [
        -25,
        44
      ],
      [
        -12,
        43
      ],
      [
        -62,
        119
      ],
      [
        -12,
        44
      ],
      [
        -38,
        65
      ],
      [
        -12,
        32
      ],
      [
        0,
        98
      ]
    ],
    [
      [
        79663,
        71383
      ],
      [
        12,
        33
      ],
      [
        25,
        -55
      ],
      [
        25,
        11
      ],
      [
        12,
        -11
      ],
      [
        13,
        -108
      ],
      [
        12,
        -44
      ],
      [
        25,
        -10
      ],
      [
        74,
        -11
      ],
      [
        37,
        11
      ],
      [
        99,
        76
      ],
      [
        38,
        32
      ],
      [
        136,
        -11
      ],
      [
        99,
        -32
      ],
      [
        161,
        -11
      ],
      [
        37,
        0
      ],
      [
        87,
        65
      ],
      [
        49,
        43
      ],
      [
        38,
        22
      ],
      [
        24,
        43
      ],
      [
        25,
        109
      ],
      [
        25,
        54
      ],
      [
        12,
        65
      ],
      [
        37,
        54
      ],
      [
        112,
        152
      ],
      [
        74,
        119
      ],
      [
        13,
        44
      ],
      [
        37,
        54
      ],
      [
        25,
        65
      ],
      [
        148,
        185
      ],
      [
        25,
        75
      ],
      [
        12,
        87
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        81224,
        72489
      ],
      [
        25,
        0
      ],
      [
        0,
        -195
      ],
      [
        -13,
        -33
      ],
      [
        13,
        -32
      ],
      [
        37,
        -11
      ],
      [
        12,
        22
      ]
    ],
    [
      [
        81298,
        72240
      ],
      [
        12,
        -54
      ],
      [
        13,
        -369
      ]
    ],
    [
      [
        81261,
        71969
      ],
      [
        12,
        -11
      ],
      [
        13,
        21
      ],
      [
        0,
        44
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        39714,
        22037
      ],
      [
        37,
        -21
      ],
      [
        74,
        11
      ],
      [
        62,
        0
      ],
      [
        0,
        -11
      ],
      [
        62,
        11
      ],
      [
        13,
        -22
      ],
      [
        -50,
        -33
      ],
      [
        -12,
        11
      ],
      [
        -112,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        22
      ],
      [
        -13,
        21
      ],
      [
        25,
        33
      ],
      [
        25,
        0
      ],
      [
        25,
        43
      ]
    ],
    [
      [
        38302,
        21951
      ],
      [
        0,
        141
      ],
      [
        12,
        184
      ],
      [
        0,
        510
      ],
      [
        0,
        347
      ],
      [
        0,
        195
      ]
    ],
    [
      [
        38314,
        23328
      ],
      [
        12,
        -33
      ],
      [
        87,
        -130
      ],
      [
        25,
        -43
      ],
      [
        12,
        -65
      ],
      [
        -37,
        32
      ],
      [
        -37,
        -21
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -22
      ],
      [
        37,
        -43
      ],
      [
        87,
        -11
      ],
      [
        0,
        -11
      ],
      [
        50,
        -152
      ],
      [
        111,
        -141
      ],
      [
        62,
        -87
      ],
      [
        74,
        -75
      ],
      [
        75,
        -66
      ],
      [
        74,
        -43
      ],
      [
        62,
        -54
      ],
      [
        74,
        -76
      ],
      [
        75,
        -65
      ],
      [
        86,
        -44
      ],
      [
        87,
        -32
      ],
      [
        124,
        22
      ],
      [
        49,
        -11
      ],
      [
        25,
        -22
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        -37,
        -22
      ],
      [
        -87,
        0
      ],
      [
        -49,
        11
      ],
      [
        -112,
        -43
      ],
      [
        -37,
        0
      ],
      [
        -74,
        -33
      ],
      [
        -50,
        11
      ],
      [
        -99,
        54
      ],
      [
        -62,
        11
      ],
      [
        -235,
        22
      ],
      [
        -74,
        11
      ],
      [
        -75,
        21
      ],
      [
        -86,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -12,
        -10
      ]
    ],
    [
      [
        40630,
        31744
      ],
      [
        13,
        -44
      ],
      [
        -25,
        11
      ],
      [
        -37,
        33
      ],
      [
        -12,
        43
      ],
      [
        61,
        -21
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        40370,
        42329
      ],
      [
        13,
        -44
      ],
      [
        24,
        -32
      ],
      [
        62,
        -54
      ],
      [
        50,
        -109
      ],
      [
        50,
        -163
      ],
      [
        49,
        -119
      ],
      [
        87,
        -130
      ],
      [
        37,
        -32
      ],
      [
        25,
        -44
      ],
      [
        99,
        -108
      ],
      [
        37,
        -55
      ],
      [
        25,
        -65
      ],
      [
        62,
        -65
      ],
      [
        111,
        -65
      ],
      [
        87,
        -32
      ],
      [
        49,
        0
      ],
      [
        75,
        -44
      ],
      [
        99,
        -108
      ],
      [
        62,
        -76
      ],
      [
        25,
        -43
      ],
      [
        62,
        -65
      ],
      [
        161,
        -141
      ],
      [
        74,
        -44
      ],
      [
        62,
        -76
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        62,
        -43
      ],
      [
        49,
        -65
      ],
      [
        87,
        -163
      ],
      [
        0,
        -76
      ],
      [
        -62,
        -108
      ],
      [
        0,
        -11
      ],
      [
        -50,
        -152
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -22
      ],
      [
        -49,
        -54
      ],
      [
        -13,
        -55
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -65
      ],
      [
        12,
        -65
      ],
      [
        0,
        -33
      ],
      [
        -24,
        -22
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        -24,
        -10
      ],
      [
        -38,
        -109
      ],
      [
        -24,
        -22
      ],
      [
        -13,
        -43
      ],
      [
        13,
        -76
      ],
      [
        148,
        22
      ],
      [
        124,
        -22
      ],
      [
        149,
        -76
      ],
      [
        99,
        -21
      ],
      [
        50,
        21
      ],
      [
        24,
        0
      ],
      [
        25,
        -32
      ],
      [
        37,
        0
      ],
      [
        37,
        11
      ],
      [
        25,
        -11
      ],
      [
        25,
        -44
      ],
      [
        25,
        11
      ],
      [
        25,
        65
      ],
      [
        49,
        76
      ],
      [
        37,
        0
      ],
      [
        37,
        -11
      ],
      [
        38,
        -21
      ],
      [
        12,
        -33
      ],
      [
        37,
        0
      ],
      [
        25,
        43
      ],
      [
        12,
        44
      ],
      [
        0,
        43
      ],
      [
        13,
        33
      ],
      [
        24,
        21
      ],
      [
        25,
        76
      ],
      [
        25,
        22
      ],
      [
        50,
        0
      ],
      [
        24,
        22
      ],
      [
        0,
        32
      ],
      [
        37,
        44
      ],
      [
        38,
        86
      ],
      [
        24,
        11
      ],
      [
        25,
        76
      ],
      [
        25,
        141
      ],
      [
        25,
        185
      ],
      [
        0,
        271
      ]
    ],
    [
      [
        43133,
        40236
      ],
      [
        24,
        0
      ],
      [
        13,
        -22
      ],
      [
        25,
        -11
      ],
      [
        37,
        33
      ],
      [
        25,
        0
      ],
      [
        12,
        32
      ],
      [
        25,
        0
      ],
      [
        25,
        -32
      ],
      [
        24,
        0
      ],
      [
        13,
        -44
      ],
      [
        24,
        -11
      ],
      [
        13,
        -54
      ],
      [
        12,
        -130
      ],
      [
        50,
        -163
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -55
      ],
      [
        -12,
        -141
      ],
      [
        0,
        -43
      ],
      [
        12,
        -43
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -87
      ],
      [
        -37,
        -21
      ],
      [
        -37,
        -55
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        21
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        -54
      ],
      [
        -62,
        -44
      ],
      [
        -38,
        0
      ],
      [
        -24,
        -10
      ],
      [
        -13,
        -33
      ],
      [
        -62,
        -22
      ],
      [
        -24,
        -54
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -21
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -49,
        -54
      ],
      [
        0,
        -33
      ],
      [
        24,
        -54
      ],
      [
        -24,
        -32
      ],
      [
        -25,
        21
      ],
      [
        -37,
        -21
      ],
      [
        0,
        -55
      ],
      [
        -25,
        -10
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -54
      ],
      [
        -49,
        -163
      ],
      [
        -62,
        -87
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -54
      ],
      [
        -87,
        -185
      ],
      [
        -136,
        -162
      ],
      [
        0,
        -55
      ],
      [
        -25,
        -65
      ],
      [
        -62,
        -65
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        42105,
        37362
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -66
      ],
      [
        -12,
        -65
      ],
      [
        12,
        -76
      ],
      [
        0,
        -130
      ],
      [
        -25,
        -11
      ],
      [
        13,
        -54
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -65
      ],
      [
        -49,
        -130
      ],
      [
        0,
        -55
      ],
      [
        12,
        -21
      ],
      [
        0,
        -98
      ],
      [
        -12,
        -54
      ],
      [
        -50,
        -65
      ],
      [
        13,
        -65
      ],
      [
        0,
        -44
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -43
      ],
      [
        25,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -98
      ]
    ],
    [
      [
        41894,
        35930
      ],
      [
        0,
        -54
      ],
      [
        12,
        -250
      ],
      [
        -24,
        -75
      ],
      [
        -38,
        0
      ],
      [
        -24,
        -22
      ],
      [
        -38,
        -347
      ],
      [
        0,
        -54
      ],
      [
        25,
        -87
      ],
      [
        25,
        -109
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -43
      ],
      [
        -38,
        -22
      ],
      [
        38,
        -151
      ],
      [
        49,
        -87
      ],
      [
        186,
        -141
      ],
      [
        74,
        -76
      ],
      [
        75,
        -109
      ],
      [
        49,
        -108
      ],
      [
        0,
        -87
      ],
      [
        -62,
        -130
      ],
      [
        -12,
        -119
      ],
      [
        25,
        -76
      ],
      [
        12,
        -76
      ],
      [
        74,
        -87
      ],
      [
        50,
        -43
      ],
      [
        62,
        11
      ],
      [
        12,
        -33
      ],
      [
        13,
        -217
      ],
      [
        0,
        -65
      ],
      [
        -149,
        -379
      ],
      [
        -99,
        -185
      ],
      [
        -37,
        -97
      ],
      [
        -13,
        -109
      ],
      [
        -37,
        -54
      ],
      [
        -186,
        -174
      ],
      [
        -285,
        -141
      ],
      [
        -235,
        -76
      ],
      [
        -49,
        -32
      ],
      [
        -372,
        -87
      ],
      [
        -62,
        -11
      ],
      [
        -99,
        11
      ],
      [
        -74,
        -11
      ],
      [
        -87,
        22
      ],
      [
        -74,
        33
      ],
      [
        -38,
        65
      ],
      [
        -49,
        0
      ],
      [
        -13,
        -33
      ],
      [
        25,
        -76
      ],
      [
        -12,
        -108
      ],
      [
        12,
        -55
      ],
      [
        25,
        -10
      ],
      [
        50,
        -76
      ],
      [
        -38,
        0
      ],
      [
        13,
        -33
      ],
      [
        25,
        -22
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -162
      ],
      [
        -50,
        -44
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        -152
      ],
      [
        -12,
        -98
      ],
      [
        12,
        -65
      ],
      [
        50,
        -130
      ],
      [
        -13,
        -97
      ],
      [
        -37,
        -44
      ],
      [
        -198,
        -141
      ],
      [
        -87,
        -21
      ],
      [
        -186,
        0
      ],
      [
        -124,
        86
      ],
      [
        -86,
        54
      ],
      [
        -87,
        44
      ],
      [
        -74,
        22
      ],
      [
        12,
        43
      ],
      [
        -37,
        11
      ],
      [
        -50,
        -44
      ],
      [
        -24,
        -43
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -98
      ],
      [
        13,
        -87
      ],
      [
        37,
        -206
      ],
      [
        0,
        -108
      ],
      [
        -13,
        -141
      ],
      [
        25,
        -87
      ],
      [
        25,
        -33
      ],
      [
        74,
        -43
      ],
      [
        25,
        -22
      ],
      [
        37,
        0
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        13,
        -43
      ],
      [
        49,
        -11
      ],
      [
        112,
        22
      ],
      [
        12,
        32
      ],
      [
        0,
        54
      ],
      [
        -74,
        11
      ],
      [
        12,
        22
      ],
      [
        112,
        54
      ],
      [
        37,
        11
      ],
      [
        37,
        -54
      ],
      [
        25,
        -54
      ],
      [
        12,
        -76
      ],
      [
        0,
        -98
      ],
      [
        -12,
        -87
      ],
      [
        -25,
        -65
      ],
      [
        -124,
        -54
      ],
      [
        -25,
        22
      ],
      [
        -37,
        65
      ],
      [
        0,
        65
      ],
      [
        -37,
        43
      ],
      [
        -49,
        44
      ],
      [
        -62,
        -11
      ],
      [
        -50,
        -65
      ],
      [
        -62,
        -22
      ],
      [
        -12,
        -65
      ],
      [
        136,
        -87
      ],
      [
        62,
        -32
      ],
      [
        50,
        -11
      ],
      [
        -50,
        -54
      ],
      [
        -87,
        -44
      ],
      [
        -49,
        -32
      ],
      [
        -50,
        -65
      ],
      [
        -87,
        -174
      ],
      [
        -12,
        -43
      ],
      [
        -12,
        -98
      ],
      [
        24,
        -163
      ],
      [
        -24,
        -65
      ],
      [
        12,
        -76
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        -99,
        -108
      ],
      [
        -25,
        -87
      ],
      [
        38,
        -43
      ],
      [
        0,
        -44
      ],
      [
        -13,
        -43
      ],
      [
        -37,
        0
      ],
      [
        -149,
        22
      ],
      [
        -62,
        -44
      ],
      [
        -49,
        -43
      ],
      [
        -25,
        -44
      ],
      [
        -111,
        -32
      ],
      [
        -13,
        -11
      ],
      [
        -111,
        -206
      ],
      [
        -50,
        -119
      ],
      [
        -49,
        -130
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -76
      ],
      [
        12,
        -65
      ],
      [
        0,
        -43
      ],
      [
        25,
        -65
      ],
      [
        37,
        -65
      ],
      [
        211,
        -282
      ],
      [
        49,
        -22
      ],
      [
        223,
        -33
      ],
      [
        50,
        -43
      ],
      [
        25,
        -65
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -141
      ],
      [
        -13,
        -44
      ],
      [
        -74,
        -86
      ],
      [
        -62,
        -22
      ],
      [
        12,
        -22
      ],
      [
        25,
        0
      ],
      [
        62,
        22
      ],
      [
        25,
        -22
      ],
      [
        12,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        -149,
        -195
      ],
      [
        -74,
        -55
      ],
      [
        -62,
        -65
      ],
      [
        -87,
        -65
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        -76
      ],
      [
        -75,
        -87
      ],
      [
        -74,
        -184
      ],
      [
        0,
        -44
      ],
      [
        12,
        -21
      ],
      [
        -49,
        -315
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -44
      ],
      [
        -87,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        44
      ],
      [
        -74,
        108
      ],
      [
        -12,
        -43
      ],
      [
        -38,
        -33
      ],
      [
        62,
        -11
      ],
      [
        25,
        -21
      ],
      [
        37,
        -76
      ],
      [
        -24,
        -22
      ],
      [
        -100,
        -54
      ],
      [
        -61,
        -65
      ],
      [
        -38,
        -65
      ],
      [
        -12,
        -54
      ],
      [
        -12,
        -109
      ],
      [
        -13,
        -65
      ],
      [
        -25,
        -54
      ],
      [
        38,
        -98
      ],
      [
        24,
        -130
      ],
      [
        13,
        -87
      ],
      [
        -13,
        -65
      ],
      [
        -62,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -24,
        -32
      ],
      [
        37,
        0
      ],
      [
        49,
        -33
      ],
      [
        50,
        11
      ],
      [
        37,
        -43
      ],
      [
        74,
        -196
      ],
      [
        75,
        -108
      ],
      [
        24,
        -76
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        38376,
        23512
      ],
      [
        -12,
        33
      ],
      [
        -87,
        22
      ],
      [
        -62,
        32
      ],
      [
        -99,
        44
      ],
      [
        -99,
        0
      ],
      [
        -75,
        43
      ],
      [
        -86,
        43
      ],
      [
        -335,
        0
      ],
      [
        -173,
        11
      ],
      [
        -174,
        0
      ],
      [
        -12,
        11
      ],
      [
        0,
        54
      ],
      [
        -25,
        44
      ],
      [
        -37,
        43
      ],
      [
        -37,
        32
      ],
      [
        -50,
        98
      ],
      [
        38,
        152
      ],
      [
        0,
        43
      ],
      [
        -25,
        33
      ],
      [
        0,
        65
      ],
      [
        25,
        22
      ],
      [
        12,
        76
      ],
      [
        -25,
        140
      ],
      [
        -25,
        33
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        -32
      ],
      [
        -50,
        -33
      ],
      [
        -25,
        11
      ],
      [
        0,
        43
      ],
      [
        -25,
        33
      ],
      [
        -12,
        32
      ],
      [
        0,
        55
      ],
      [
        -12,
        76
      ],
      [
        -25,
        75
      ],
      [
        -37,
        66
      ],
      [
        -13,
        65
      ],
      [
        0,
        76
      ],
      [
        13,
        65
      ],
      [
        -13,
        65
      ],
      [
        -24,
        65
      ],
      [
        12,
        76
      ],
      [
        25,
        43
      ],
      [
        12,
        54
      ],
      [
        112,
        11
      ],
      [
        -13,
        65
      ],
      [
        25,
        54
      ],
      [
        12,
        55
      ],
      [
        25,
        21
      ],
      [
        87,
        55
      ],
      [
        25,
        32
      ],
      [
        24,
        76
      ],
      [
        0,
        33
      ],
      [
        -12,
        97
      ],
      [
        37,
        65
      ],
      [
        50,
        33
      ],
      [
        25,
        76
      ],
      [
        -13,
        76
      ],
      [
        -25,
        65
      ],
      [
        -37,
        21
      ],
      [
        0,
        65
      ],
      [
        13,
        55
      ],
      [
        49,
        130
      ],
      [
        0,
        54
      ],
      [
        13,
        22
      ],
      [
        61,
        65
      ],
      [
        25,
        65
      ],
      [
        50,
        32
      ],
      [
        0,
        33
      ],
      [
        -25,
        32
      ],
      [
        0,
        98
      ],
      [
        12,
        65
      ],
      [
        75,
        76
      ],
      [
        12,
        33
      ],
      [
        0,
        43
      ],
      [
        -12,
        98
      ],
      [
        -13,
        65
      ],
      [
        -37,
        108
      ],
      [
        13,
        33
      ],
      [
        49,
        32
      ],
      [
        13,
        54
      ],
      [
        -13,
        55
      ],
      [
        -25,
        21
      ],
      [
        0,
        163
      ],
      [
        25,
        33
      ],
      [
        62,
        10
      ],
      [
        0,
        44
      ],
      [
        50,
        65
      ],
      [
        0,
        65
      ],
      [
        -62,
        97
      ],
      [
        -25,
        66
      ],
      [
        -149,
        43
      ],
      [
        -12,
        54
      ],
      [
        0,
        33
      ],
      [
        37,
        -22
      ],
      [
        173,
        33
      ],
      [
        38,
        -22
      ],
      [
        37,
        11
      ],
      [
        12,
        86
      ],
      [
        25,
        44
      ],
      [
        0,
        43
      ],
      [
        -25,
        33
      ],
      [
        -37,
        0
      ],
      [
        -173,
        32
      ],
      [
        0,
        174
      ],
      [
        24,
        22
      ],
      [
        25,
        86
      ],
      [
        -37,
        109
      ],
      [
        25,
        65
      ],
      [
        -13,
        43
      ],
      [
        -24,
        33
      ],
      [
        -25,
        54
      ],
      [
        0,
        65
      ],
      [
        49,
        33
      ],
      [
        0,
        32
      ],
      [
        -12,
        43
      ],
      [
        -37,
        11
      ],
      [
        -75,
        55
      ],
      [
        -12,
        43
      ],
      [
        12,
        130
      ],
      [
        0,
        87
      ],
      [
        -12,
        43
      ],
      [
        12,
        33
      ],
      [
        25,
        32
      ],
      [
        -12,
        76
      ],
      [
        -13,
        33
      ],
      [
        0,
        32
      ],
      [
        25,
        65
      ],
      [
        37,
        -11
      ],
      [
        62,
        33
      ],
      [
        0,
        87
      ],
      [
        -24,
        119
      ],
      [
        -25,
        76
      ],
      [
        0,
        33
      ],
      [
        12,
        21
      ],
      [
        -12,
        109
      ],
      [
        0,
        65
      ],
      [
        12,
        184
      ],
      [
        0,
        65
      ],
      [
        -25,
        65
      ],
      [
        0,
        65
      ],
      [
        13,
        44
      ],
      [
        25,
        54
      ],
      [
        12,
        54
      ],
      [
        25,
        33
      ],
      [
        12,
        32
      ],
      [
        -37,
        54
      ],
      [
        -12,
        44
      ],
      [
        24,
        54
      ],
      [
        13,
        0
      ],
      [
        25,
        43
      ],
      [
        0,
        87
      ],
      [
        -13,
        33
      ],
      [
        0,
        76
      ],
      [
        -12,
        43
      ],
      [
        25,
        33
      ],
      [
        37,
        -11
      ],
      [
        0,
        54
      ],
      [
        12,
        11
      ],
      [
        37,
        184
      ],
      [
        -12,
        141
      ],
      [
        25,
        54
      ],
      [
        49,
        55
      ],
      [
        50,
        32
      ],
      [
        37,
        11
      ],
      [
        25,
        33
      ],
      [
        12,
        54
      ],
      [
        0,
        32
      ],
      [
        -12,
        33
      ],
      [
        -25,
        32
      ],
      [
        -25,
        152
      ],
      [
        0,
        98
      ],
      [
        -49,
        173
      ],
      [
        0,
        130
      ],
      [
        12,
        76
      ],
      [
        -25,
        87
      ],
      [
        37,
        119
      ],
      [
        0,
        33
      ],
      [
        -12,
        87
      ],
      [
        -12,
        43
      ],
      [
        12,
        54
      ],
      [
        25,
        76
      ],
      [
        0,
        76
      ],
      [
        37,
        22
      ],
      [
        25,
        43
      ],
      [
        37,
        0
      ],
      [
        12,
        11
      ],
      [
        0,
        33
      ],
      [
        37,
        86
      ],
      [
        25,
        33
      ],
      [
        37,
        11
      ],
      [
        25,
        43
      ],
      [
        0,
        54
      ],
      [
        -12,
        65
      ],
      [
        12,
        66
      ],
      [
        -12,
        97
      ],
      [
        0,
        54
      ],
      [
        -13,
        44
      ],
      [
        0,
        86
      ],
      [
        -24,
        11
      ],
      [
        -13,
        33
      ],
      [
        13,
        22
      ],
      [
        24,
        10
      ],
      [
        25,
        33
      ],
      [
        12,
        141
      ],
      [
        25,
        87
      ],
      [
        0,
        32
      ],
      [
        25,
        87
      ],
      [
        37,
        98
      ],
      [
        13,
        54
      ],
      [
        0,
        32
      ],
      [
        61,
        22
      ],
      [
        13,
        22
      ],
      [
        0,
        86
      ],
      [
        -13,
        98
      ],
      [
        0,
        206
      ],
      [
        25,
        130
      ],
      [
        0,
        65
      ],
      [
        -25,
        22
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -25,
        44
      ],
      [
        0,
        108
      ],
      [
        25,
        43
      ],
      [
        0,
        44
      ],
      [
        -25,
        54
      ],
      [
        -25,
        108
      ],
      [
        0,
        98
      ],
      [
        -24,
        22
      ],
      [
        0,
        76
      ],
      [
        -25,
        32
      ],
      [
        -13,
        54
      ],
      [
        0,
        87
      ],
      [
        25,
        0
      ],
      [
        13,
        54
      ],
      [
        -25,
        44
      ],
      [
        -25,
        0
      ],
      [
        -25,
        22
      ],
      [
        -24,
        108
      ],
      [
        -25,
        65
      ],
      [
        12,
        87
      ],
      [
        0,
        65
      ],
      [
        13,
        65
      ],
      [
        0,
        43
      ],
      [
        24,
        22
      ],
      [
        25,
        0
      ],
      [
        25,
        54
      ],
      [
        -13,
        44
      ],
      [
        0,
        32
      ],
      [
        13,
        44
      ],
      [
        12,
        97
      ],
      [
        37,
        152
      ],
      [
        0,
        54
      ],
      [
        25,
        -21
      ],
      [
        50,
        21
      ],
      [
        24,
        87
      ],
      [
        13,
        22
      ],
      [
        0,
        32
      ],
      [
        -25,
        11
      ],
      [
        -12,
        22
      ],
      [
        0,
        32
      ],
      [
        12,
        98
      ],
      [
        0,
        65
      ],
      [
        -25,
        141
      ],
      [
        -12,
        130
      ],
      [
        12,
        54
      ],
      [
        62,
        87
      ],
      [
        0,
        33
      ],
      [
        25,
        162
      ],
      [
        0,
        98
      ],
      [
        12,
        43
      ],
      [
        13,
        98
      ],
      [
        49,
        76
      ],
      [
        13,
        54
      ],
      [
        12,
        0
      ],
      [
        37,
        76
      ],
      [
        37,
        65
      ],
      [
        25,
        33
      ],
      [
        0,
        43
      ],
      [
        37,
        173
      ],
      [
        38,
        109
      ],
      [
        37,
        152
      ],
      [
        49,
        32
      ],
      [
        13,
        -21
      ],
      [
        24,
        0
      ],
      [
        13,
        32
      ],
      [
        49,
        22
      ],
      [
        25,
        21
      ],
      [
        0,
        87
      ],
      [
        -12,
        44
      ],
      [
        -37,
        86
      ],
      [
        -38,
        98
      ],
      [
        0,
        98
      ],
      [
        62,
        130
      ],
      [
        -12,
        54
      ],
      [
        -25,
        206
      ],
      [
        -12,
        54
      ],
      [
        -13,
        98
      ],
      [
        0,
        43
      ],
      [
        13,
        120
      ],
      [
        25,
        43
      ],
      [
        37,
        43
      ],
      [
        -25,
        22
      ],
      [
        0,
        33
      ],
      [
        -12,
        54
      ],
      [
        -13,
        11
      ],
      [
        -12,
        43
      ],
      [
        0,
        54
      ],
      [
        12,
        76
      ],
      [
        25,
        22
      ],
      [
        25,
        54
      ],
      [
        25,
        22
      ],
      [
        12,
        43
      ],
      [
        74,
        54
      ],
      [
        50,
        44
      ],
      [
        111,
        76
      ],
      [
        75,
        54
      ],
      [
        12,
        32
      ],
      [
        0,
        33
      ],
      [
        37,
        184
      ],
      [
        50,
        239
      ],
      [
        24,
        152
      ],
      [
        -61,
        119
      ]
    ],
    [
      [
        38810,
        41960
      ],
      [
        49,
        108
      ],
      [
        0,
        55
      ],
      [
        12,
        32
      ],
      [
        75,
        65
      ],
      [
        12,
        33
      ],
      [
        0,
        54
      ],
      [
        13,
        33
      ],
      [
        24,
        0
      ],
      [
        99,
        65
      ],
      [
        13,
        32
      ],
      [
        25,
        141
      ],
      [
        12,
        22
      ],
      [
        37,
        -22
      ],
      [
        13,
        -32
      ],
      [
        74,
        -87
      ],
      [
        25,
        -54
      ],
      [
        37,
        0
      ],
      [
        49,
        11
      ],
      [
        13,
        -11
      ],
      [
        173,
        0
      ],
      [
        50,
        -22
      ],
      [
        24,
        -22
      ],
      [
        62,
        -32
      ],
      [
        25,
        -87
      ],
      [
        25,
        -141
      ],
      [
        37,
        -152
      ],
      [
        13,
        22
      ],
      [
        12,
        119
      ],
      [
        49,
        152
      ],
      [
        50,
        184
      ],
      [
        37,
        44
      ],
      [
        50,
        -11
      ],
      [
        12,
        11
      ],
      [
        149,
        0
      ],
      [
        148,
        0
      ],
      [
        0,
        -33
      ],
      [
        25,
        -65
      ],
      [
        37,
        -43
      ]
    ],
    [
      [
        77594,
        81588
      ],
      [
        -24,
        -11
      ],
      [
        0,
        33
      ],
      [
        24,
        0
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        77916,
        80515
      ],
      [
        -62,
        10
      ],
      [
        -49,
        -32
      ],
      [
        -13,
        11
      ]
    ],
    [
      [
        77792,
        80504
      ],
      [
        -24,
        87
      ],
      [
        -37,
        97
      ],
      [
        12,
        44
      ],
      [
        -12,
        21
      ],
      [
        -62,
        54
      ],
      [
        12,
        33
      ],
      [
        0,
        76
      ],
      [
        -37,
        11
      ],
      [
        -74,
        -44
      ],
      [
        -38,
        22
      ],
      [
        -37,
        43
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        11
      ],
      [
        0,
        43
      ],
      [
        -37,
        76
      ],
      [
        -62,
        -33
      ],
      [
        -37,
        -10
      ]
    ],
    [
      [
        77322,
        81014
      ],
      [
        -13,
        32
      ],
      [
        -49,
        87
      ],
      [
        -62,
        65
      ],
      [
        -37,
        32
      ],
      [
        -99,
        -21
      ],
      [
        -75,
        32
      ],
      [
        -37,
        44
      ],
      [
        13,
        21
      ],
      [
        -38,
        120
      ],
      [
        0,
        54
      ],
      [
        -12,
        22
      ],
      [
        37,
        54
      ],
      [
        13,
        54
      ],
      [
        0,
        87
      ],
      [
        -25,
        87
      ],
      [
        -37,
        43
      ],
      [
        -25,
        43
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        76876,
        81892
      ],
      [
        62,
        11
      ],
      [
        49,
        0
      ],
      [
        50,
        22
      ],
      [
        49,
        10
      ],
      [
        25,
        22
      ],
      [
        112,
        -11
      ],
      [
        37,
        11
      ],
      [
        87,
        0
      ],
      [
        12,
        11
      ],
      [
        -12,
        22
      ],
      [
        49,
        10
      ],
      [
        12,
        11
      ]
    ],
    [
      [
        77408,
        82011
      ],
      [
        25,
        -65
      ],
      [
        25,
        -11
      ],
      [
        12,
        -32
      ],
      [
        -37,
        -11
      ],
      [
        13,
        -22
      ],
      [
        49,
        -43
      ],
      [
        37,
        0
      ],
      [
        25,
        -11
      ],
      [
        0,
        -22
      ],
      [
        50,
        -65
      ],
      [
        0,
        -21
      ],
      [
        -62,
        -65
      ],
      [
        -13,
        -44
      ],
      [
        25,
        -65
      ],
      [
        50,
        -76
      ],
      [
        49,
        -54
      ],
      [
        87,
        -54
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -87,
        0
      ],
      [
        -12,
        -22
      ],
      [
        24,
        -11
      ],
      [
        50,
        -54
      ],
      [
        25,
        -43
      ],
      [
        25,
        -22
      ],
      [
        86,
        -109
      ],
      [
        50,
        11
      ],
      [
        49,
        -32
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -33
      ],
      [
        25,
        -21
      ],
      [
        50,
        -76
      ],
      [
        -13,
        -22
      ],
      [
        -49,
        11
      ],
      [
        0,
        -33
      ],
      [
        24,
        -32
      ],
      [
        0,
        -130
      ]
    ],
    [
      [
        77396,
        81838
      ],
      [
        25,
        0
      ],
      [
        0,
        21
      ],
      [
        -25,
        11
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        3184,
        47252
      ],
      [
        -13,
        -10
      ],
      [
        -25,
        32
      ],
      [
        50,
        33
      ],
      [
        12,
        -11
      ],
      [
        -24,
        -44
      ]
    ],
    [
      [
        6194,
        4295
      ],
      [
        -112,
        -22
      ],
      [
        -260,
        33
      ],
      [
        -173,
        65
      ],
      [
        -13,
        43
      ],
      [
        -62,
        54
      ],
      [
        335,
        -21
      ],
      [
        161,
        -33
      ],
      [
        248,
        -65
      ],
      [
        -75,
        -11
      ],
      [
        -49,
        -43
      ]
    ],
    [
      [
        7569,
        4924
      ],
      [
        -273,
        141
      ],
      [
        149,
        -11
      ],
      [
        25,
        -33
      ],
      [
        148,
        -54
      ],
      [
        -49,
        -43
      ]
    ],
    [
      [
        6714,
        5249
      ],
      [
        -37,
        -11
      ],
      [
        -917,
        76
      ],
      [
        -186,
        22
      ],
      [
        -62,
        32
      ],
      [
        38,
        44
      ],
      [
        222,
        32
      ],
      [
        261,
        -21
      ],
      [
        309,
        -55
      ],
      [
        211,
        -43
      ],
      [
        111,
        -33
      ],
      [
        50,
        -43
      ]
    ],
    [
      [
        8968,
        6225
      ],
      [
        -74,
        -11
      ],
      [
        -285,
        44
      ],
      [
        -25,
        43
      ],
      [
        -247,
        43
      ],
      [
        24,
        44
      ],
      [
        174,
        -54
      ],
      [
        223,
        -55
      ],
      [
        173,
        -32
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        41374,
        6030
      ],
      [
        -13,
        -195
      ],
      [
        -24,
        -55
      ],
      [
        -100,
        -65
      ],
      [
        -161,
        -65
      ],
      [
        -495,
        33
      ],
      [
        -223,
        32
      ],
      [
        -87,
        44
      ],
      [
        -74,
        108
      ],
      [
        -198,
        -11
      ],
      [
        -137,
        -32
      ],
      [
        -49,
        -54
      ],
      [
        -322,
        86
      ],
      [
        -483,
        163
      ],
      [
        -62,
        33
      ],
      [
        74,
        43
      ],
      [
        62,
        11
      ],
      [
        62,
        -22
      ],
      [
        12,
        -65
      ],
      [
        62,
        -22
      ],
      [
        1202,
        11
      ],
      [
        99,
        0
      ],
      [
        198,
        22
      ],
      [
        112,
        22
      ],
      [
        37,
        32
      ],
      [
        -99,
        0
      ],
      [
        -75,
        76
      ],
      [
        13,
        65
      ],
      [
        124,
        22
      ],
      [
        -13,
        65
      ],
      [
        87,
        11
      ],
      [
        25,
        32
      ],
      [
        148,
        44
      ],
      [
        248,
        -22
      ],
      [
        62,
        -54
      ],
      [
        -37,
        -87
      ],
      [
        0,
        -54
      ],
      [
        99,
        -11
      ],
      [
        62,
        -54
      ],
      [
        -99,
        -33
      ],
      [
        -37,
        -54
      ]
    ],
    [
      [
        51222,
        6366
      ],
      [
        37,
        -11
      ],
      [
        49,
        55
      ],
      [
        62,
        0
      ],
      [
        273,
        -55
      ],
      [
        87,
        -54
      ],
      [
        -137,
        -22
      ],
      [
        -136,
        -43
      ],
      [
        -149,
        43
      ],
      [
        -260,
        33
      ],
      [
        -74,
        22
      ],
      [
        -62,
        76
      ],
      [
        136,
        54
      ],
      [
        174,
        -98
      ]
    ],
    [
      [
        50800,
        6442
      ],
      [
        -86,
        11
      ],
      [
        74,
        76
      ],
      [
        74,
        11
      ],
      [
        75,
        -33
      ],
      [
        -137,
        -65
      ]
    ],
    [
      [
        39156,
        6193
      ],
      [
        -49,
        0
      ],
      [
        -37,
        65
      ],
      [
        -161,
        43
      ],
      [
        -62,
        87
      ],
      [
        -223,
        87
      ],
      [
        -25,
        54
      ],
      [
        37,
        11
      ],
      [
        87,
        -22
      ],
      [
        161,
        -11
      ],
      [
        62,
        -22
      ],
      [
        173,
        0
      ],
      [
        87,
        -10
      ],
      [
        49,
        -65
      ],
      [
        112,
        -22
      ],
      [
        25,
        -119
      ],
      [
        -137,
        -55
      ],
      [
        -99,
        -21
      ]
    ],
    [
      [
        38785,
        6583
      ],
      [
        -62,
        -33
      ],
      [
        -248,
        11
      ],
      [
        -136,
        33
      ],
      [
        74,
        87
      ],
      [
        99,
        43
      ],
      [
        112,
        11
      ],
      [
        223,
        -33
      ],
      [
        -62,
        -43
      ],
      [
        0,
        -76
      ]
    ],
    [
      [
        50243,
        6670
      ],
      [
        -37,
        -33
      ],
      [
        -830,
        44
      ],
      [
        -50,
        10
      ],
      [
        13,
        44
      ],
      [
        272,
        32
      ],
      [
        87,
        44
      ],
      [
        396,
        -87
      ],
      [
        137,
        -33
      ],
      [
        12,
        -21
      ]
    ],
    [
      [
        7197,
        6366
      ],
      [
        -421,
        -32
      ],
      [
        -174,
        21
      ],
      [
        -371,
        65
      ],
      [
        -496,
        130
      ],
      [
        -223,
        76
      ],
      [
        -86,
        44
      ],
      [
        -25,
        43
      ],
      [
        25,
        119
      ],
      [
        24,
        33
      ],
      [
        112,
        43
      ],
      [
        49,
        44
      ],
      [
        112,
        54
      ],
      [
        37,
        33
      ],
      [
        124,
        0
      ],
      [
        173,
        -22
      ],
      [
        248,
        -87
      ],
      [
        310,
        -152
      ],
      [
        173,
        -87
      ],
      [
        198,
        -75
      ],
      [
        149,
        -120
      ],
      [
        37,
        -54
      ],
      [
        50,
        -32
      ],
      [
        -25,
        -44
      ]
    ],
    [
      [
        37719,
        6442
      ],
      [
        -223,
        0
      ],
      [
        -148,
        22
      ],
      [
        -87,
        43
      ],
      [
        -37,
        76
      ],
      [
        37,
        130
      ],
      [
        74,
        76
      ],
      [
        75,
        43
      ],
      [
        210,
        98
      ],
      [
        310,
        76
      ],
      [
        112,
        54
      ],
      [
        668,
        206
      ],
      [
        149,
        22
      ],
      [
        112,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -136,
        -87
      ],
      [
        -100,
        -76
      ],
      [
        -235,
        -119
      ],
      [
        -161,
        -87
      ],
      [
        -211,
        -119
      ],
      [
        -161,
        -152
      ],
      [
        25,
        -43
      ],
      [
        -37,
        -65
      ],
      [
        -211,
        -33
      ]
    ],
    [
      [
        119600,
        7396
      ],
      [
        -37,
        -43
      ],
      [
        -50,
        -22
      ],
      [
        -149,
        22
      ],
      [
        -111,
        -43
      ],
      [
        -112,
        -11
      ],
      [
        -62,
        21
      ],
      [
        -24,
        33
      ],
      [
        -13,
        76
      ],
      [
        186,
        -33
      ],
      [
        112,
        -32
      ],
      [
        86,
        43
      ],
      [
        124,
        87
      ],
      [
        37,
        -22
      ],
      [
        13,
        -76
      ]
    ],
    [
      [
        46366,
        6984
      ],
      [
        409,
        0
      ],
      [
        111,
        -11
      ],
      [
        62,
        -43
      ],
      [
        87,
        -163
      ],
      [
        24,
        -86
      ],
      [
        87,
        -109
      ],
      [
        -12,
        -206
      ],
      [
        -25,
        -54
      ],
      [
        -74,
        -54
      ],
      [
        -112,
        0
      ],
      [
        -49,
        -33
      ],
      [
        86,
        -43
      ],
      [
        -12,
        -65
      ],
      [
        -1945,
        -282
      ],
      [
        -74,
        -11
      ],
      [
        -74,
        -33
      ],
      [
        -50,
        -43
      ],
      [
        -1511,
        -54
      ],
      [
        -75,
        76
      ],
      [
        13,
        119
      ],
      [
        99,
        43
      ],
      [
        124,
        130
      ],
      [
        74,
        66
      ],
      [
        25,
        43
      ],
      [
        111,
        -43
      ],
      [
        87,
        10
      ],
      [
        124,
        65
      ],
      [
        37,
        -10
      ],
      [
        13,
        -44
      ],
      [
        210,
        98
      ],
      [
        359,
        228
      ],
      [
        124,
        119
      ],
      [
        -25,
        65
      ],
      [
        -123,
        32
      ],
      [
        74,
        109
      ],
      [
        0,
        98
      ],
      [
        49,
        10
      ],
      [
        50,
        65
      ],
      [
        -50,
        33
      ],
      [
        75,
        141
      ],
      [
        272,
        206
      ],
      [
        99,
        108
      ],
      [
        471,
        131
      ],
      [
        235,
        32
      ],
      [
        261,
        -11
      ],
      [
        99,
        -11
      ],
      [
        470,
        -130
      ],
      [
        174,
        -86
      ],
      [
        87,
        -55
      ],
      [
        24,
        -54
      ],
      [
        0,
        -54
      ],
      [
        -24,
        -65
      ],
      [
        -38,
        -44
      ],
      [
        -384,
        -32
      ],
      [
        -49,
        -22
      ],
      [
        -50,
        -65
      ],
      [
        50,
        -11
      ]
    ],
    [
      [
        10579,
        7906
      ],
      [
        -75,
        -22
      ],
      [
        -74,
        44
      ],
      [
        99,
        11
      ],
      [
        50,
        -33
      ]
    ],
    [
      [
        10182,
        7884
      ],
      [
        -334,
        44
      ],
      [
        -50,
        11
      ],
      [
        161,
        43
      ],
      [
        186,
        -76
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        119414,
        7917
      ],
      [
        124,
        -43
      ],
      [
        347,
        0
      ],
      [
        285,
        -44
      ],
      [
        24,
        -43
      ],
      [
        -86,
        -22
      ],
      [
        -124,
        -54
      ],
      [
        -75,
        -22
      ],
      [
        -74,
        0
      ],
      [
        -136,
        22
      ],
      [
        -186,
        0
      ],
      [
        -37,
        -33
      ],
      [
        -87,
        -32
      ],
      [
        -99,
        -65
      ],
      [
        -25,
        54
      ],
      [
        -148,
        141
      ],
      [
        136,
        108
      ],
      [
        0,
        22
      ],
      [
        -74,
        54
      ],
      [
        37,
        33
      ],
      [
        74,
        22
      ],
      [
        87,
        -22
      ],
      [
        37,
        -43
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        10802,
        8112
      ],
      [
        -149,
        -11
      ],
      [
        -74,
        22
      ],
      [
        -25,
        43
      ],
      [
        25,
        11
      ],
      [
        186,
        -21
      ],
      [
        86,
        -22
      ],
      [
        -49,
        -22
      ]
    ],
    [
      [
        10579,
        8036
      ],
      [
        -25,
        -11
      ],
      [
        -149,
        11
      ],
      [
        -37,
        11
      ],
      [
        -210,
        22
      ],
      [
        -112,
        54
      ],
      [
        37,
        22
      ],
      [
        75,
        11
      ],
      [
        24,
        21
      ],
      [
        211,
        11
      ],
      [
        12,
        -32
      ],
      [
        75,
        -44
      ],
      [
        37,
        -43
      ],
      [
        62,
        -33
      ]
    ],
    [
      [
        11483,
        8134
      ],
      [
        -124,
        -22
      ],
      [
        -37,
        11
      ],
      [
        12,
        33
      ],
      [
        -24,
        32
      ],
      [
        12,
        33
      ],
      [
        74,
        0
      ],
      [
        211,
        -33
      ],
      [
        25,
        -43
      ],
      [
        -149,
        -11
      ]
    ],
    [
      [
        10542,
        8286
      ],
      [
        235,
        0
      ],
      [
        99,
        -11
      ],
      [
        0,
        -33
      ],
      [
        -99,
        0
      ],
      [
        -50,
        -32
      ],
      [
        -62,
        0
      ],
      [
        -86,
        21
      ],
      [
        -75,
        33
      ],
      [
        38,
        22
      ]
    ],
    [
      [
        10232,
        8253
      ],
      [
        -136,
        -11
      ],
      [
        -87,
        33
      ],
      [
        12,
        22
      ],
      [
        236,
        10
      ],
      [
        24,
        -32
      ],
      [
        -49,
        -22
      ]
    ],
    [
      [
        11149,
        8329
      ],
      [
        -50,
        0
      ],
      [
        -99,
        54
      ],
      [
        87,
        0
      ],
      [
        62,
        -54
      ]
    ],
    [
      [
        11421,
        8340
      ],
      [
        -37,
        -43
      ],
      [
        -112,
        21
      ],
      [
        -49,
        33
      ],
      [
        25,
        43
      ],
      [
        49,
        11
      ],
      [
        75,
        -11
      ],
      [
        49,
        -54
      ]
    ],
    [
      [
        11458,
        8589
      ],
      [
        -74,
        -10
      ],
      [
        -161,
        65
      ],
      [
        -25,
        54
      ],
      [
        161,
        -22
      ],
      [
        99,
        -87
      ]
    ],
    [
      [
        117989,
        9012
      ],
      [
        -62,
        -86
      ],
      [
        -61,
        21
      ],
      [
        86,
        65
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        11954,
        8915
      ],
      [
        -273,
        65
      ],
      [
        -37,
        22
      ],
      [
        25,
        32
      ],
      [
        99,
        11
      ],
      [
        124,
        -43
      ],
      [
        62,
        -66
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        118336,
        9468
      ],
      [
        -62,
        22
      ],
      [
        -12,
        54
      ],
      [
        87,
        54
      ],
      [
        74,
        11
      ],
      [
        -37,
        -76
      ],
      [
        -50,
        -65
      ]
    ],
    [
      [
        16376,
        9717
      ],
      [
        -49,
        -43
      ],
      [
        -112,
        22
      ],
      [
        12,
        32
      ],
      [
        87,
        22
      ],
      [
        74,
        -22
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        16834,
        9620
      ],
      [
        -37,
        -11
      ],
      [
        -272,
        54
      ],
      [
        -75,
        54
      ],
      [
        75,
        55
      ],
      [
        124,
        10
      ],
      [
        12,
        -21
      ],
      [
        111,
        -33
      ],
      [
        87,
        0
      ],
      [
        13,
        -22
      ],
      [
        -38,
        -86
      ]
    ],
    [
      [
        18098,
        9598
      ],
      [
        -50,
        -11
      ],
      [
        -136,
        65
      ],
      [
        -62,
        44
      ],
      [
        -12,
        86
      ],
      [
        37,
        11
      ],
      [
        62,
        -11
      ],
      [
        124,
        -43
      ],
      [
        86,
        -11
      ],
      [
        38,
        -43
      ],
      [
        -38,
        -54
      ],
      [
        -49,
        -33
      ]
    ],
    [
      [
        21765,
        9891
      ],
      [
        -174,
        -22
      ],
      [
        -49,
        22
      ],
      [
        0,
        43
      ],
      [
        346,
        141
      ],
      [
        75,
        -32
      ],
      [
        -161,
        -98
      ],
      [
        37,
        -11
      ],
      [
        -74,
        -43
      ]
    ],
    [
      [
        20798,
        9923
      ],
      [
        -99,
        -11
      ],
      [
        -25,
        22
      ],
      [
        75,
        65
      ],
      [
        -50,
        109
      ],
      [
        50,
        0
      ],
      [
        49,
        21
      ],
      [
        112,
        0
      ],
      [
        87,
        -21
      ],
      [
        24,
        -44
      ],
      [
        -62,
        -76
      ],
      [
        -136,
        -43
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        20451,
        10140
      ],
      [
        75,
        -97
      ],
      [
        12,
        -44
      ],
      [
        -235,
        -108
      ],
      [
        -37,
        -109
      ],
      [
        -421,
        -43
      ],
      [
        -186,
        33
      ],
      [
        -37,
        32
      ],
      [
        0,
        33
      ],
      [
        61,
        10
      ],
      [
        -37,
        76
      ],
      [
        87,
        87
      ],
      [
        -124,
        76
      ],
      [
        -124,
        0
      ],
      [
        37,
        65
      ],
      [
        75,
        43
      ],
      [
        37,
        -10
      ],
      [
        161,
        0
      ],
      [
        161,
        -11
      ],
      [
        161,
        -22
      ],
      [
        334,
        -11
      ]
    ],
    [
      [
        54839,
        10064
      ],
      [
        -25,
        -141
      ],
      [
        25,
        -54
      ],
      [
        62,
        -76
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -21
      ],
      [
        -87,
        0
      ],
      [
        -37,
        32
      ],
      [
        -50,
        130
      ],
      [
        -61,
        55
      ],
      [
        -149,
        32
      ],
      [
        -149,
        -11
      ],
      [
        37,
        33
      ],
      [
        223,
        43
      ],
      [
        50,
        22
      ],
      [
        37,
        43
      ],
      [
        12,
        55
      ],
      [
        38,
        75
      ],
      [
        62,
        33
      ],
      [
        37,
        0
      ],
      [
        25,
        -54
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -55
      ]
    ],
    [
      [
        120355,
        10238
      ],
      [
        -37,
        -11
      ],
      [
        -74,
        33
      ],
      [
        -12,
        21
      ],
      [
        61,
        76
      ],
      [
        13,
        44
      ],
      [
        37,
        10
      ],
      [
        37,
        -86
      ],
      [
        25,
        -33
      ],
      [
        -50,
        -54
      ]
    ],
    [
      [
        18457,
        10433
      ],
      [
        99,
        -22
      ],
      [
        62,
        -43
      ],
      [
        87,
        -33
      ],
      [
        37,
        -75
      ],
      [
        62,
        -33
      ],
      [
        12,
        -43
      ],
      [
        -148,
        -11
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        -33
      ],
      [
        25,
        -21
      ],
      [
        87,
        -11
      ],
      [
        74,
        22
      ],
      [
        111,
        -22
      ],
      [
        137,
        54
      ],
      [
        25,
        0
      ],
      [
        136,
        -54
      ],
      [
        37,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        74,
        -22
      ],
      [
        37,
        -43
      ],
      [
        -12,
        -98
      ],
      [
        -25,
        -21
      ],
      [
        -99,
        21
      ],
      [
        -223,
        11
      ],
      [
        -74,
        22
      ],
      [
        -124,
        65
      ],
      [
        -87,
        22
      ],
      [
        -74,
        54
      ],
      [
        -112,
        32
      ],
      [
        -86,
        55
      ],
      [
        0,
        65
      ],
      [
        -75,
        32
      ],
      [
        -49,
        0
      ],
      [
        -62,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        22
      ],
      [
        0,
        76
      ],
      [
        -37,
        11
      ],
      [
        -24,
        32
      ],
      [
        12,
        87
      ],
      [
        37,
        43
      ],
      [
        50,
        11
      ],
      [
        49,
        -11
      ],
      [
        136,
        22
      ],
      [
        87,
        -11
      ]
    ],
    [
      [
        36505,
        10390
      ],
      [
        -37,
        -11
      ],
      [
        -49,
        32
      ],
      [
        25,
        65
      ],
      [
        74,
        66
      ],
      [
        62,
        10
      ],
      [
        37,
        -21
      ],
      [
        -50,
        -55
      ],
      [
        -12,
        -43
      ],
      [
        -50,
        -43
      ]
    ],
    [
      [
        25951,
        10509
      ],
      [
        -37,
        -33
      ],
      [
        -74,
        11
      ],
      [
        -62,
        44
      ],
      [
        -25,
        65
      ],
      [
        13,
        43
      ],
      [
        37,
        11
      ],
      [
        148,
        -141
      ]
    ],
    [
      [
        36344,
        10552
      ],
      [
        -49,
        -86
      ],
      [
        -62,
        -22
      ],
      [
        37,
        -33
      ],
      [
        0,
        -32
      ],
      [
        62,
        -54
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -33
      ],
      [
        -458,
        174
      ],
      [
        -37,
        32
      ],
      [
        -38,
        87
      ],
      [
        38,
        43
      ],
      [
        74,
        11
      ],
      [
        99,
        -32
      ],
      [
        25,
        43
      ],
      [
        49,
        0
      ],
      [
        13,
        22
      ],
      [
        -124,
        32
      ],
      [
        -37,
        54
      ],
      [
        111,
        33
      ],
      [
        310,
        -43
      ],
      [
        49,
        -22
      ],
      [
        38,
        -44
      ],
      [
        -38,
        -65
      ]
    ],
    [
      [
        29655,
        10661
      ],
      [
        -62,
        0
      ],
      [
        -49,
        43
      ],
      [
        37,
        22
      ],
      [
        74,
        -43
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        30560,
        10498
      ],
      [
        -124,
        -11
      ],
      [
        24,
        141
      ],
      [
        38,
        44
      ],
      [
        -75,
        97
      ],
      [
        -37,
        76
      ],
      [
        13,
        22
      ],
      [
        111,
        32
      ],
      [
        124,
        -10
      ],
      [
        49,
        -33
      ],
      [
        13,
        -76
      ],
      [
        -50,
        -54
      ],
      [
        50,
        -22
      ],
      [
        0,
        -87
      ],
      [
        -74,
        -86
      ],
      [
        -62,
        -33
      ]
    ],
    [
      [
        29234,
        10823
      ],
      [
        -74,
        0
      ],
      [
        0,
        44
      ],
      [
        161,
        43
      ],
      [
        62,
        33
      ],
      [
        25,
        -11
      ],
      [
        24,
        -76
      ],
      [
        -198,
        -33
      ]
    ],
    [
      [
        56387,
        10813
      ],
      [
        -74,
        -11
      ],
      [
        -50,
        32
      ],
      [
        -24,
        76
      ],
      [
        24,
        33
      ],
      [
        37,
        11
      ],
      [
        62,
        -87
      ],
      [
        25,
        -54
      ]
    ],
    [
      [
        85485,
        11051
      ],
      [
        -25,
        0
      ],
      [
        87,
        120
      ],
      [
        25,
        10
      ],
      [
        37,
        -43
      ],
      [
        -12,
        -43
      ],
      [
        -50,
        -33
      ],
      [
        -62,
        -11
      ]
    ],
    [
      [
        57626,
        11127
      ],
      [
        -74,
        -11
      ],
      [
        -62,
        33
      ],
      [
        -25,
        32
      ],
      [
        12,
        44
      ],
      [
        50,
        11
      ],
      [
        49,
        -44
      ],
      [
        50,
        -65
      ]
    ],
    [
      [
        85981,
        11290
      ],
      [
        -50,
        -76
      ],
      [
        -25,
        43
      ],
      [
        13,
        33
      ],
      [
        62,
        0
      ]
    ],
    [
      [
        28181,
        11290
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -65
      ],
      [
        87,
        0
      ],
      [
        37,
        130
      ],
      [
        87,
        22
      ],
      [
        37,
        -76
      ],
      [
        -37,
        -55
      ],
      [
        37,
        -65
      ],
      [
        37,
        0
      ],
      [
        74,
        98
      ],
      [
        13,
        54
      ],
      [
        74,
        65
      ],
      [
        173,
        11
      ],
      [
        87,
        -43
      ],
      [
        -62,
        -87
      ],
      [
        -136,
        -54
      ],
      [
        -99,
        -65
      ],
      [
        99,
        -22
      ],
      [
        74,
        32
      ],
      [
        198,
        55
      ],
      [
        75,
        43
      ],
      [
        25,
        -11
      ],
      [
        0,
        -65
      ],
      [
        37,
        -43
      ],
      [
        -25,
        -98
      ],
      [
        -87,
        -22
      ],
      [
        -87,
        -10
      ],
      [
        25,
        -44
      ],
      [
        -12,
        -32
      ],
      [
        -223,
        21
      ],
      [
        -112,
        -21
      ],
      [
        -74,
        32
      ],
      [
        -198,
        -21
      ],
      [
        -112,
        0
      ],
      [
        -86,
        10
      ],
      [
        -87,
        33
      ],
      [
        -74,
        11
      ],
      [
        -99,
        0
      ],
      [
        -100,
        43
      ],
      [
        -74,
        11
      ],
      [
        -124,
        43
      ],
      [
        -62,
        33
      ],
      [
        -49,
        -11
      ],
      [
        -434,
        65
      ],
      [
        -99,
        -11
      ],
      [
        -124,
        33
      ],
      [
        -25,
        43
      ],
      [
        25,
        44
      ],
      [
        37,
        10
      ],
      [
        595,
        76
      ],
      [
        62,
        22
      ],
      [
        50,
        0
      ],
      [
        86,
        -130
      ],
      [
        37,
        0
      ],
      [
        62,
        54
      ],
      [
        99,
        -11
      ],
      [
        62,
        22
      ],
      [
        38,
        54
      ],
      [
        123,
        54
      ],
      [
        75,
        -10
      ],
      [
        74,
        -22
      ],
      [
        37,
        -65
      ]
    ],
    [
      [
        60909,
        11724
      ],
      [
        -38,
        -11
      ],
      [
        -86,
        21
      ],
      [
        -37,
        55
      ],
      [
        12,
        32
      ],
      [
        37,
        11
      ],
      [
        25,
        -32
      ],
      [
        87,
        -76
      ]
    ],
    [
      [
        41089,
        11832
      ],
      [
        -37,
        -11
      ],
      [
        -87,
        33
      ],
      [
        -12,
        32
      ],
      [
        61,
        33
      ],
      [
        87,
        -33
      ],
      [
        -12,
        -54
      ]
    ],
    [
      [
        61057,
        12006
      ],
      [
        37,
        -22
      ],
      [
        50,
        11
      ],
      [
        62,
        -22
      ],
      [
        -99,
        -141
      ],
      [
        -75,
        -54
      ],
      [
        -62,
        -22
      ],
      [
        -12,
        33
      ],
      [
        0,
        86
      ],
      [
        -49,
        22
      ],
      [
        -25,
        54
      ],
      [
        -161,
        76
      ],
      [
        -13,
        33
      ],
      [
        174,
        11
      ],
      [
        99,
        -22
      ],
      [
        74,
        -43
      ]
    ],
    [
      [
        36567,
        12092
      ],
      [
        50,
        -54
      ],
      [
        -50,
        -43
      ],
      [
        -173,
        -87
      ],
      [
        -99,
        -33
      ],
      [
        -112,
        -21
      ],
      [
        -470,
        -76
      ],
      [
        -62,
        11
      ],
      [
        -25,
        21
      ],
      [
        -25,
        55
      ],
      [
        0,
        32
      ],
      [
        87,
        54
      ],
      [
        359,
        55
      ],
      [
        25,
        10
      ],
      [
        62,
        98
      ],
      [
        62,
        -22
      ],
      [
        62,
        -97
      ],
      [
        49,
        43
      ],
      [
        0,
        87
      ],
      [
        25,
        0
      ],
      [
        87,
        -43
      ],
      [
        12,
        43
      ],
      [
        25,
        22
      ],
      [
        111,
        -55
      ]
    ],
    [
      [
        41027,
        12038
      ],
      [
        -25,
        0
      ],
      [
        -62,
        76
      ],
      [
        13,
        43
      ],
      [
        24,
        11
      ],
      [
        112,
        0
      ],
      [
        37,
        -21
      ],
      [
        -12,
        -65
      ],
      [
        -87,
        -44
      ]
    ],
    [
      [
        59893,
        12147
      ],
      [
        -87,
        -44
      ],
      [
        -12,
        22
      ],
      [
        -87,
        76
      ],
      [
        74,
        11
      ],
      [
        50,
        21
      ],
      [
        49,
        -10
      ],
      [
        13,
        -76
      ]
    ],
    [
      [
        62965,
        12114
      ],
      [
        -112,
        -22
      ],
      [
        -24,
        22
      ],
      [
        -13,
        43
      ],
      [
        13,
        22
      ],
      [
        148,
        65
      ],
      [
        50,
        0
      ],
      [
        25,
        -32
      ],
      [
        -38,
        -65
      ],
      [
        -49,
        -33
      ]
    ],
    [
      [
        60797,
        12157
      ],
      [
        -62,
        0
      ],
      [
        -12,
        22
      ],
      [
        74,
        98
      ],
      [
        37,
        21
      ],
      [
        124,
        11
      ],
      [
        37,
        -21
      ],
      [
        0,
        -87
      ],
      [
        -12,
        -33
      ],
      [
        -186,
        -11
      ]
    ],
    [
      [
        37261,
        12320
      ],
      [
        13,
        -22
      ],
      [
        74,
        22
      ],
      [
        37,
        -32
      ],
      [
        -74,
        -76
      ],
      [
        -50,
        0
      ],
      [
        -37,
        76
      ],
      [
        0,
        21
      ],
      [
        37,
        11
      ]
    ],
    [
      [
        86699,
        12092
      ],
      [
        -62,
        11
      ],
      [
        -62,
        76
      ],
      [
        0,
        98
      ],
      [
        50,
        43
      ],
      [
        24,
        -87
      ],
      [
        50,
        -32
      ],
      [
        37,
        -76
      ],
      [
        -37,
        -33
      ]
    ],
    [
      [
        63485,
        12190
      ],
      [
        -62,
        -22
      ],
      [
        -62,
        33
      ],
      [
        -37,
        87
      ],
      [
        12,
        32
      ],
      [
        50,
        22
      ],
      [
        87,
        -11
      ],
      [
        37,
        -76
      ],
      [
        -25,
        -65
      ]
    ],
    [
      [
        71165,
        12244
      ],
      [
        -25,
        -21
      ],
      [
        -61,
        10
      ],
      [
        -50,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -124,
        43
      ],
      [
        -12,
        65
      ],
      [
        12,
        44
      ],
      [
        111,
        75
      ],
      [
        38,
        11
      ],
      [
        62,
        -11
      ],
      [
        49,
        -65
      ],
      [
        37,
        -97
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        62370,
        12331
      ],
      [
        -25,
        -87
      ],
      [
        -24,
        11
      ],
      [
        -13,
        43
      ],
      [
        -62,
        87
      ],
      [
        0,
        44
      ],
      [
        38,
        32
      ],
      [
        99,
        11
      ],
      [
        24,
        -11
      ],
      [
        25,
        -54
      ],
      [
        -62,
        -76
      ]
    ],
    [
      [
        40878,
        12504
      ],
      [
        -49,
        0
      ],
      [
        -37,
        22
      ],
      [
        37,
        54
      ],
      [
        62,
        -21
      ],
      [
        12,
        -44
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        36121,
        12656
      ],
      [
        62,
        -11
      ],
      [
        124,
        -108
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -10
      ],
      [
        -37,
        -87
      ],
      [
        -62,
        -33
      ],
      [
        -149,
        22
      ],
      [
        -148,
        33
      ],
      [
        -37,
        65
      ],
      [
        49,
        65
      ],
      [
        112,
        32
      ],
      [
        37,
        54
      ],
      [
        86,
        11
      ]
    ],
    [
      [
        67511,
        12483
      ],
      [
        -25,
        -44
      ],
      [
        -111,
        55
      ],
      [
        -62,
        21
      ],
      [
        -37,
        44
      ],
      [
        12,
        32
      ],
      [
        37,
        33
      ],
      [
        75,
        32
      ],
      [
        111,
        11
      ],
      [
        111,
        -11
      ],
      [
        25,
        -11
      ],
      [
        -111,
        -65
      ],
      [
        -25,
        -97
      ]
    ],
    [
      [
        37162,
        12678
      ],
      [
        -74,
        -33
      ],
      [
        -50,
        22
      ],
      [
        -149,
        44
      ],
      [
        -61,
        75
      ],
      [
        0,
        33
      ],
      [
        24,
        22
      ],
      [
        50,
        11
      ],
      [
        87,
        -22
      ],
      [
        49,
        -22
      ],
      [
        124,
        -130
      ]
    ],
    [
      [
        40593,
        12656
      ],
      [
        -24,
        0
      ],
      [
        -38,
        55
      ],
      [
        -12,
        86
      ],
      [
        -99,
        130
      ],
      [
        -25,
        76
      ],
      [
        50,
        22
      ],
      [
        111,
        -43
      ],
      [
        99,
        -109
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -55
      ],
      [
        -37,
        -10
      ],
      [
        12,
        -33
      ],
      [
        -37,
        -87
      ]
    ],
    [
      [
        37819,
        12993
      ],
      [
        0,
        -76
      ],
      [
        49,
        32
      ],
      [
        74,
        -32
      ],
      [
        124,
        -217
      ],
      [
        37,
        -152
      ],
      [
        50,
        -119
      ],
      [
        124,
        -196
      ],
      [
        99,
        -173
      ],
      [
        0,
        -87
      ],
      [
        37,
        -22
      ],
      [
        13,
        -32
      ],
      [
        12,
        -119
      ],
      [
        0,
        -131
      ],
      [
        12,
        -260
      ],
      [
        0,
        -65
      ],
      [
        -62,
        -87
      ],
      [
        -12,
        -76
      ],
      [
        -62,
        -76
      ],
      [
        -186,
        -130
      ],
      [
        -12,
        -76
      ],
      [
        -297,
        -54
      ],
      [
        -161,
        -22
      ],
      [
        -137,
        33
      ],
      [
        -74,
        -11
      ],
      [
        -446,
        -22
      ],
      [
        -12,
        33
      ],
      [
        -100,
        22
      ],
      [
        -86,
        54
      ],
      [
        -25,
        54
      ],
      [
        74,
        65
      ],
      [
        87,
        11
      ],
      [
        87,
        -11
      ],
      [
        74,
        -21
      ],
      [
        446,
        -22
      ],
      [
        149,
        32
      ],
      [
        74,
        55
      ],
      [
        -74,
        43
      ],
      [
        -37,
        0
      ],
      [
        -223,
        -65
      ],
      [
        -75,
        -11
      ],
      [
        -86,
        22
      ],
      [
        -87,
        54
      ],
      [
        0,
        22
      ],
      [
        272,
        43
      ],
      [
        75,
        43
      ],
      [
        24,
        55
      ],
      [
        -185,
        43
      ],
      [
        -75,
        -11
      ],
      [
        -86,
        11
      ],
      [
        -149,
        119
      ],
      [
        -50,
        -10
      ],
      [
        -185,
        -163
      ],
      [
        -75,
        11
      ],
      [
        -86,
        32
      ],
      [
        -75,
        11
      ],
      [
        -74,
        -22
      ],
      [
        99,
        -76
      ],
      [
        12,
        -21
      ],
      [
        -161,
        -98
      ],
      [
        -62,
        11
      ],
      [
        -49,
        54
      ],
      [
        -37,
        11
      ],
      [
        -87,
        -11
      ],
      [
        -87,
        22
      ],
      [
        -148,
        98
      ],
      [
        -13,
        32
      ],
      [
        25,
        65
      ],
      [
        -12,
        33
      ],
      [
        24,
        32
      ],
      [
        62,
        44
      ],
      [
        87,
        10
      ],
      [
        74,
        -54
      ],
      [
        87,
        -11
      ],
      [
        -12,
        109
      ],
      [
        12,
        32
      ],
      [
        62,
        22
      ],
      [
        87,
        -32
      ],
      [
        74,
        -55
      ],
      [
        87,
        -43
      ],
      [
        37,
        32
      ],
      [
        -74,
        55
      ],
      [
        -13,
        32
      ],
      [
        13,
        33
      ],
      [
        62,
        11
      ],
      [
        272,
        -44
      ],
      [
        136,
        44
      ],
      [
        -74,
        32
      ],
      [
        -161,
        33
      ],
      [
        -50,
        54
      ],
      [
        112,
        43
      ],
      [
        124,
        -11
      ],
      [
        223,
        -43
      ],
      [
        74,
        22
      ],
      [
        62,
        65
      ],
      [
        50,
        21
      ],
      [
        148,
        -10
      ],
      [
        124,
        32
      ],
      [
        25,
        0
      ],
      [
        136,
        -119
      ],
      [
        25,
        22
      ],
      [
        12,
        75
      ],
      [
        -25,
        66
      ],
      [
        -37,
        -11
      ],
      [
        -111,
        32
      ],
      [
        -124,
        11
      ],
      [
        -87,
        22
      ],
      [
        -86,
        43
      ],
      [
        0,
        33
      ],
      [
        37,
        76
      ],
      [
        173,
        86
      ],
      [
        87,
        33
      ],
      [
        111,
        0
      ],
      [
        37,
        32
      ],
      [
        -86,
        44
      ],
      [
        -62,
        43
      ],
      [
        -136,
        11
      ],
      [
        -75,
        -32
      ],
      [
        -62,
        0
      ],
      [
        -198,
        86
      ],
      [
        -62,
        54
      ],
      [
        0,
        109
      ],
      [
        37,
        98
      ],
      [
        13,
        75
      ],
      [
        -13,
        66
      ],
      [
        -24,
        32
      ],
      [
        -50,
        22
      ],
      [
        -37,
        43
      ],
      [
        -25,
        54
      ],
      [
        12,
        76
      ],
      [
        38,
        55
      ],
      [
        210,
        54
      ],
      [
        335,
        54
      ],
      [
        37,
        -22
      ],
      [
        74,
        -86
      ],
      [
        13,
        -141
      ]
    ],
    [
      [
        41052,
        13253
      ],
      [
        -13,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -49,
        32
      ],
      [
        74,
        11
      ],
      [
        37,
        -22
      ],
      [
        13,
        -32
      ]
    ],
    [
      [
        38748,
        13882
      ],
      [
        -62,
        -11
      ],
      [
        -50,
        11
      ],
      [
        0,
        54
      ],
      [
        -25,
        11
      ],
      [
        112,
        43
      ],
      [
        62,
        0
      ],
      [
        37,
        -32
      ],
      [
        -74,
        -76
      ]
    ],
    [
      [
        118634,
        14023
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        33
      ],
      [
        12,
        65
      ],
      [
        0,
        86
      ],
      [
        50,
        -43
      ],
      [
        37,
        -76
      ],
      [
        -37,
        -54
      ]
    ],
    [
      [
        38748,
        14424
      ],
      [
        -75,
        11
      ],
      [
        25,
        76
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        25,
        -54
      ],
      [
        -37,
        -33
      ]
    ],
    [
      [
        91456,
        14392
      ],
      [
        -62,
        -22
      ],
      [
        -13,
        22
      ],
      [
        -86,
        65
      ],
      [
        -13,
        76
      ],
      [
        75,
        0
      ],
      [
        86,
        -33
      ],
      [
        50,
        -76
      ],
      [
        -37,
        -32
      ]
    ],
    [
      [
        78622,
        14500
      ],
      [
        -49,
        -22
      ],
      [
        -37,
        22
      ],
      [
        25,
        43
      ],
      [
        99,
        0
      ],
      [
        49,
        -10
      ],
      [
        0,
        -33
      ],
      [
        -87,
        0
      ]
    ],
    [
      [
        118113,
        14478
      ],
      [
        -49,
        0
      ],
      [
        -25,
        65
      ],
      [
        50,
        0
      ],
      [
        24,
        -65
      ]
    ],
    [
      [
        91703,
        14511
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -37,
        44
      ],
      [
        12,
        21
      ],
      [
        38,
        11
      ],
      [
        99,
        -32
      ],
      [
        -38,
        -22
      ]
    ],
    [
      [
        38537,
        14066
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        22
      ],
      [
        -37,
        -87
      ],
      [
        -50,
        -43
      ],
      [
        -24,
        10
      ],
      [
        -25,
        -21
      ],
      [
        -62,
        0
      ],
      [
        -74,
        108
      ],
      [
        0,
        76
      ],
      [
        12,
        33
      ],
      [
        99,
        108
      ],
      [
        74,
        152
      ],
      [
        87,
        119
      ],
      [
        174,
        109
      ],
      [
        37,
        -11
      ],
      [
        12,
        -44
      ],
      [
        -87,
        -86
      ],
      [
        -12,
        -120
      ],
      [
        37,
        -11
      ],
      [
        13,
        -21
      ],
      [
        49,
        -33
      ],
      [
        -87,
        -76
      ],
      [
        -99,
        -65
      ],
      [
        75,
        -32
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        91282,
        14608
      ],
      [
        -62,
        -21
      ],
      [
        -24,
        21
      ],
      [
        12,
        55
      ],
      [
        74,
        -55
      ]
    ],
    [
      [
        95928,
        14695
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -13,
        43
      ],
      [
        50,
        11
      ],
      [
        62,
        -32
      ],
      [
        -37,
        -33
      ]
    ],
    [
      [
        117878,
        14684
      ],
      [
        -37,
        -21
      ],
      [
        -75,
        76
      ],
      [
        13,
        32
      ],
      [
        99,
        -87
      ]
    ],
    [
      [
        96423,
        14847
      ],
      [
        -50,
        0
      ],
      [
        -12,
        22
      ],
      [
        25,
        32
      ],
      [
        49,
        11
      ],
      [
        -12,
        -65
      ]
    ],
    [
      [
        39008,
        14858
      ],
      [
        -75,
        -65
      ],
      [
        -12,
        22
      ],
      [
        25,
        21
      ],
      [
        0,
        76
      ],
      [
        49,
        33
      ],
      [
        25,
        -11
      ],
      [
        -12,
        -76
      ]
    ],
    [
      [
        95160,
        14966
      ],
      [
        49,
        -21
      ],
      [
        62,
        0
      ],
      [
        25,
        -22
      ],
      [
        12,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -186,
        -11
      ],
      [
        -25,
        22
      ],
      [
        25,
        65
      ],
      [
        75,
        32
      ]
    ],
    [
      [
        93785,
        15107
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -37,
        44
      ],
      [
        24,
        21
      ],
      [
        62,
        0
      ],
      [
        50,
        -21
      ],
      [
        12,
        -22
      ],
      [
        -24,
        -22
      ]
    ],
    [
      [
        39268,
        15086
      ],
      [
        -74,
        -22
      ],
      [
        -38,
        0
      ],
      [
        13,
        65
      ],
      [
        25,
        22
      ],
      [
        0,
        43
      ],
      [
        24,
        22
      ],
      [
        13,
        43
      ],
      [
        37,
        22
      ],
      [
        74,
        -11
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        96671,
        15183
      ],
      [
        -149,
        -11
      ],
      [
        -74,
        22
      ],
      [
        -25,
        43
      ],
      [
        50,
        87
      ],
      [
        62,
        44
      ],
      [
        99,
        10
      ],
      [
        62,
        -21
      ],
      [
        49,
        -44
      ],
      [
        13,
        -54
      ],
      [
        -87,
        -76
      ]
    ],
    [
      [
        97501,
        15335
      ],
      [
        -25,
        -22
      ],
      [
        -62,
        22
      ],
      [
        -12,
        76
      ],
      [
        -25,
        22
      ],
      [
        -87,
        32
      ],
      [
        -12,
        44
      ],
      [
        12,
        21
      ],
      [
        37,
        0
      ],
      [
        87,
        -43
      ],
      [
        12,
        -22
      ],
      [
        0,
        -65
      ],
      [
        75,
        -65
      ]
    ],
    [
      [
        40135,
        15693
      ],
      [
        -74,
        -22
      ],
      [
        24,
        65
      ],
      [
        38,
        0
      ],
      [
        49,
        44
      ],
      [
        13,
        -11
      ],
      [
        -50,
        -76
      ]
    ],
    [
      [
        42228,
        15877
      ],
      [
        -61,
        22
      ],
      [
        -13,
        54
      ],
      [
        50,
        11
      ],
      [
        99,
        54
      ],
      [
        25,
        -21
      ],
      [
        -13,
        -55
      ],
      [
        -87,
        -65
      ]
    ],
    [
      [
        40185,
        15942
      ],
      [
        -38,
        -65
      ],
      [
        62,
        0
      ],
      [
        62,
        33
      ],
      [
        37,
        -33
      ],
      [
        -74,
        -21
      ],
      [
        -74,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -62,
        -65
      ],
      [
        -25,
        21
      ],
      [
        -74,
        22
      ],
      [
        -25,
        22
      ],
      [
        -62,
        21
      ],
      [
        37,
        66
      ],
      [
        99,
        54
      ],
      [
        -12,
        32
      ],
      [
        74,
        22
      ],
      [
        0,
        43
      ],
      [
        50,
        44
      ],
      [
        74,
        11
      ],
      [
        37,
        -44
      ],
      [
        -12,
        -32
      ],
      [
        25,
        -55
      ]
    ],
    [
      [
        40482,
        15975
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -43
      ],
      [
        -74,
        22
      ],
      [
        49,
        54
      ],
      [
        62,
        119
      ],
      [
        -49,
        54
      ],
      [
        12,
        33
      ],
      [
        37,
        32
      ],
      [
        75,
        -10
      ],
      [
        -13,
        -33
      ],
      [
        75,
        -33
      ],
      [
        -13,
        -65
      ],
      [
        -25,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -49,
        -32
      ]
    ],
    [
      [
        42018,
        16203
      ],
      [
        25,
        -11
      ],
      [
        62,
        65
      ],
      [
        49,
        0
      ],
      [
        -25,
        -33
      ],
      [
        99,
        -54
      ],
      [
        -12,
        -43
      ],
      [
        25,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -32
      ],
      [
        49,
        -44
      ],
      [
        -37,
        -10
      ],
      [
        -62,
        21
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        44
      ],
      [
        -37,
        0
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        0
      ],
      [
        12,
        43
      ],
      [
        -12,
        11
      ],
      [
        -87,
        -33
      ],
      [
        -25,
        33
      ],
      [
        87,
        43
      ],
      [
        -37,
        22
      ],
      [
        0,
        65
      ],
      [
        -37,
        0
      ],
      [
        -38,
        -22
      ],
      [
        -24,
        11
      ],
      [
        0,
        33
      ],
      [
        37,
        43
      ],
      [
        12,
        54
      ],
      [
        124,
        66
      ],
      [
        37,
        0
      ],
      [
        13,
        -33
      ],
      [
        -25,
        -119
      ]
    ],
    [
      [
        42179,
        16355
      ],
      [
        12,
        -11
      ],
      [
        62,
        11
      ],
      [
        25,
        -22
      ],
      [
        -37,
        -22
      ],
      [
        -136,
        11
      ],
      [
        -25,
        33
      ],
      [
        87,
        10
      ],
      [
        12,
        -10
      ]
    ],
    [
      [
        41052,
        16322
      ],
      [
        -62,
        -22
      ],
      [
        12,
        33
      ],
      [
        0,
        76
      ],
      [
        37,
        32
      ],
      [
        50,
        -11
      ],
      [
        -37,
        -43
      ],
      [
        -13,
        -32
      ],
      [
        13,
        -33
      ]
    ],
    [
      [
        42699,
        16528
      ],
      [
        -25,
        -32
      ],
      [
        -74,
        43
      ],
      [
        -25,
        32
      ],
      [
        13,
        11
      ],
      [
        124,
        22
      ],
      [
        24,
        -11
      ],
      [
        13,
        -43
      ],
      [
        -50,
        -22
      ]
    ],
    [
      [
        42303,
        16626
      ],
      [
        37,
        -87
      ],
      [
        49,
        -33
      ],
      [
        -24,
        -43
      ],
      [
        -37,
        11
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        43
      ],
      [
        12,
        22
      ],
      [
        -12,
        33
      ],
      [
        -112,
        -22
      ],
      [
        -136,
        -87
      ],
      [
        -136,
        -65
      ],
      [
        -100,
        -98
      ],
      [
        -61,
        -97
      ],
      [
        -38,
        -76
      ],
      [
        -62,
        0
      ],
      [
        -12,
        -33
      ],
      [
        37,
        -21
      ],
      [
        50,
        -11
      ],
      [
        -37,
        -54
      ],
      [
        37,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        54
      ],
      [
        -62,
        0
      ],
      [
        -87,
        65
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        12,
        -65
      ],
      [
        -25,
        -32
      ],
      [
        -24,
        21
      ],
      [
        -13,
        65
      ],
      [
        -62,
        11
      ],
      [
        -99,
        -76
      ],
      [
        -37,
        0
      ],
      [
        -12,
        -32
      ],
      [
        -99,
        -76
      ],
      [
        -87,
        -109
      ],
      [
        -50,
        -54
      ],
      [
        -86,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -62,
        22
      ],
      [
        -38,
        0
      ],
      [
        -12,
        -32
      ],
      [
        62,
        -87
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        0
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        -65
      ],
      [
        25,
        -76
      ],
      [
        99,
        -43
      ],
      [
        12,
        -22
      ],
      [
        -87,
        -22
      ],
      [
        -111,
        -151
      ],
      [
        12,
        -44
      ],
      [
        37,
        -76
      ],
      [
        62,
        -54
      ],
      [
        124,
        11
      ],
      [
        25,
        22
      ],
      [
        74,
        0
      ],
      [
        25,
        54
      ],
      [
        87,
        -11
      ],
      [
        12,
        33
      ],
      [
        25,
        10
      ],
      [
        99,
        0
      ],
      [
        25,
        -32
      ],
      [
        -62,
        -76
      ],
      [
        -37,
        22
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -33
      ],
      [
        37,
        -43
      ],
      [
        -37,
        -98
      ],
      [
        -37,
        33
      ],
      [
        0,
        54
      ],
      [
        -99,
        32
      ],
      [
        -38,
        -43
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -108
      ],
      [
        -37,
        22
      ],
      [
        -13,
        65
      ],
      [
        -74,
        54
      ],
      [
        -161,
        -11
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        37,
        -33
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -76
      ],
      [
        37,
        -43
      ],
      [
        0,
        -55
      ],
      [
        -37,
        0
      ],
      [
        -24,
        22
      ],
      [
        -100,
        141
      ],
      [
        -61,
        54
      ],
      [
        -25,
        65
      ],
      [
        -112,
        11
      ],
      [
        -62,
        -21
      ],
      [
        37,
        -66
      ],
      [
        -37,
        -21
      ],
      [
        -74,
        -109
      ],
      [
        -37,
        -43
      ],
      [
        99,
        -65
      ],
      [
        12,
        -65
      ],
      [
        -24,
        -33
      ],
      [
        -75,
        -11
      ],
      [
        -124,
        55
      ],
      [
        -49,
        0
      ],
      [
        -13,
        32
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -54
      ],
      [
        -50,
        -76
      ],
      [
        13,
        -54
      ],
      [
        24,
        -11
      ],
      [
        -86,
        -54
      ],
      [
        62,
        -22
      ],
      [
        12,
        -32
      ],
      [
        -99,
        -22
      ],
      [
        -87,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -65
      ],
      [
        38,
        -141
      ],
      [
        -62,
        -98
      ],
      [
        0,
        -32
      ],
      [
        49,
        -87
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        25,
        -11
      ],
      [
        124,
        11
      ],
      [
        87,
        43
      ],
      [
        37,
        -10
      ],
      [
        -13,
        -55
      ],
      [
        -173,
        -76
      ],
      [
        -25,
        -32
      ],
      [
        124,
        -22
      ],
      [
        37,
        -21
      ],
      [
        -25,
        -22
      ],
      [
        -62,
        -87
      ],
      [
        25,
        -22
      ],
      [
        87,
        -32
      ],
      [
        161,
        -43
      ],
      [
        124,
        -22
      ],
      [
        -25,
        54
      ],
      [
        0,
        65
      ],
      [
        74,
        54
      ],
      [
        50,
        22
      ],
      [
        198,
        22
      ],
      [
        99,
        -11
      ],
      [
        -12,
        -22
      ],
      [
        -124,
        -11
      ],
      [
        -124,
        -65
      ],
      [
        -25,
        -21
      ],
      [
        0,
        -44
      ],
      [
        112,
        -32
      ],
      [
        37,
        -33
      ],
      [
        -50,
        -87
      ],
      [
        13,
        -54
      ],
      [
        49,
        -65
      ],
      [
        75,
        -76
      ],
      [
        24,
        -43
      ],
      [
        62,
        -22
      ],
      [
        87,
        -65
      ],
      [
        37,
        -76
      ],
      [
        25,
        -152
      ],
      [
        62,
        -119
      ],
      [
        87,
        -65
      ],
      [
        12,
        -43
      ],
      [
        -25,
        -55
      ],
      [
        -74,
        33
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -54
      ],
      [
        136,
        -76
      ],
      [
        174,
        0
      ],
      [
        0,
        -43
      ],
      [
        -75,
        -76
      ],
      [
        -99,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        25,
        -54
      ],
      [
        86,
        21
      ],
      [
        137,
        -10
      ],
      [
        24,
        -76
      ],
      [
        100,
        -152
      ],
      [
        -13,
        -54
      ],
      [
        -49,
        -11
      ],
      [
        -87,
        -65
      ],
      [
        -50,
        -22
      ],
      [
        -86,
        -87
      ],
      [
        -62,
        -21
      ],
      [
        136,
        -11
      ],
      [
        124,
        65
      ],
      [
        37,
        -11
      ],
      [
        37,
        -43
      ],
      [
        13,
        -55
      ],
      [
        -25,
        -43
      ],
      [
        -211,
        -33
      ],
      [
        -99,
        -21
      ],
      [
        -111,
        -76
      ],
      [
        123,
        -33
      ],
      [
        87,
        11
      ],
      [
        112,
        -32
      ],
      [
        74,
        10
      ],
      [
        50,
        22
      ],
      [
        86,
        -11
      ],
      [
        0,
        -119
      ],
      [
        13,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -112,
        -32
      ],
      [
        -74,
        0
      ],
      [
        0,
        -76
      ],
      [
        112,
        -65
      ],
      [
        74,
        32
      ],
      [
        74,
        -21
      ],
      [
        0,
        -98
      ],
      [
        50,
        -108
      ],
      [
        37,
        0
      ],
      [
        37,
        43
      ],
      [
        50,
        0
      ],
      [
        24,
        -54
      ],
      [
        -24,
        -98
      ],
      [
        -38,
        -54
      ],
      [
        -148,
        32
      ],
      [
        -112,
        -65
      ],
      [
        -74,
        0
      ],
      [
        -111,
        87
      ],
      [
        -199,
        22
      ],
      [
        25,
        -44
      ],
      [
        50,
        -21
      ],
      [
        12,
        -76
      ],
      [
        37,
        -76
      ],
      [
        75,
        22
      ],
      [
        123,
        -44
      ],
      [
        62,
        -54
      ],
      [
        37,
        -54
      ],
      [
        -49,
        -109
      ],
      [
        -99,
        -43
      ],
      [
        -62,
        32
      ],
      [
        -50,
        0
      ],
      [
        -49,
        -21
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        186,
        0
      ],
      [
        49,
        -11
      ],
      [
        50,
        -44
      ],
      [
        -75,
        -54
      ],
      [
        -111,
        11
      ],
      [
        -50,
        -22
      ],
      [
        -49,
        -43
      ],
      [
        186,
        -22
      ],
      [
        62,
        11
      ],
      [
        123,
        44
      ],
      [
        25,
        -44
      ],
      [
        -49,
        -32
      ],
      [
        -62,
        -76
      ],
      [
        -211,
        -22
      ],
      [
        -210,
        54
      ],
      [
        12,
        -43
      ],
      [
        111,
        -130
      ],
      [
        13,
        -44
      ],
      [
        -25,
        -54
      ],
      [
        -149,
        -54
      ],
      [
        -74,
        32
      ],
      [
        -49,
        109
      ],
      [
        -62,
        22
      ],
      [
        -99,
        10
      ],
      [
        24,
        -108
      ],
      [
        -24,
        -33
      ],
      [
        -62,
        11
      ],
      [
        -62,
        -11
      ],
      [
        -137,
        -65
      ],
      [
        211,
        -21
      ],
      [
        50,
        -44
      ],
      [
        -13,
        -21
      ],
      [
        -111,
        -11
      ],
      [
        -112,
        -22
      ],
      [
        -136,
        -54
      ],
      [
        99,
        -33
      ],
      [
        99,
        11
      ],
      [
        136,
        -22
      ],
      [
        13,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        -236,
        -75
      ],
      [
        -248,
        -98
      ],
      [
        -185,
        -54
      ],
      [
        -360,
        -120
      ],
      [
        -396,
        -65
      ],
      [
        -619,
        -141
      ],
      [
        -211,
        -108
      ],
      [
        -62,
        -87
      ],
      [
        -161,
        -43
      ],
      [
        -111,
        -11
      ],
      [
        -310,
        -11
      ],
      [
        -322,
        43
      ],
      [
        -260,
        11
      ],
      [
        -137,
        -11
      ],
      [
        -483,
        65
      ],
      [
        -185,
        -10
      ],
      [
        -149,
        10
      ],
      [
        -322,
        -21
      ],
      [
        -37,
        -54
      ],
      [
        49,
        -76
      ],
      [
        112,
        -98
      ],
      [
        198,
        -184
      ],
      [
        111,
        -33
      ],
      [
        62,
        -43
      ],
      [
        124,
        -44
      ],
      [
        285,
        0
      ],
      [
        372,
        -43
      ],
      [
        223,
        -33
      ],
      [
        -13,
        -65
      ],
      [
        -136,
        -119
      ],
      [
        -74,
        -54
      ],
      [
        -198,
        -87
      ],
      [
        -261,
        -43
      ],
      [
        -198,
        21
      ],
      [
        -359,
        65
      ],
      [
        -446,
        66
      ],
      [
        -669,
        65
      ],
      [
        -322,
        54
      ],
      [
        -173,
        -54
      ],
      [
        -161,
        -11
      ],
      [
        49,
        -22
      ],
      [
        669,
        -163
      ],
      [
        557,
        -130
      ],
      [
        75,
        -32
      ],
      [
        74,
        -11
      ],
      [
        0,
        -87
      ],
      [
        -37,
        -54
      ],
      [
        -112,
        -54
      ],
      [
        -284,
        -11
      ],
      [
        -372,
        -44
      ],
      [
        -173,
        0
      ],
      [
        -186,
        44
      ],
      [
        -384,
        119
      ],
      [
        -223,
        98
      ],
      [
        -174,
        97
      ],
      [
        -111,
        87
      ],
      [
        -112,
        33
      ],
      [
        25,
        -55
      ],
      [
        62,
        -65
      ],
      [
        87,
        -65
      ],
      [
        -99,
        0
      ],
      [
        -87,
        -65
      ],
      [
        62,
        -97
      ],
      [
        111,
        -98
      ],
      [
        99,
        -22
      ],
      [
        137,
        -65
      ],
      [
        322,
        -119
      ],
      [
        148,
        -119
      ],
      [
        25,
        -65
      ],
      [
        87,
        -66
      ],
      [
        124,
        -10
      ],
      [
        25,
        54
      ],
      [
        -13,
        76
      ],
      [
        124,
        32
      ],
      [
        235,
        -32
      ],
      [
        1016,
        -11
      ],
      [
        99,
        -33
      ],
      [
        37,
        -54
      ],
      [
        25,
        -97
      ],
      [
        -99,
        -120
      ],
      [
        -74,
        -54
      ],
      [
        -236,
        -54
      ],
      [
        -161,
        -11
      ],
      [
        -346,
        11
      ],
      [
        -335,
        0
      ],
      [
        260,
        -65
      ],
      [
        260,
        -44
      ],
      [
        347,
        11
      ],
      [
        137,
        11
      ],
      [
        123,
        22
      ],
      [
        137,
        -130
      ],
      [
        99,
        -55
      ],
      [
        74,
        -141
      ],
      [
        87,
        -119
      ],
      [
        148,
        -54
      ],
      [
        100,
        32
      ],
      [
        198,
        11
      ],
      [
        198,
        -43
      ],
      [
        124,
        -11
      ],
      [
        161,
        33
      ],
      [
        124,
        54
      ],
      [
        272,
        54
      ],
      [
        124,
        43
      ],
      [
        161,
        -21
      ],
      [
        62,
        -55
      ],
      [
        50,
        -75
      ],
      [
        161,
        -66
      ],
      [
        198,
        -21
      ],
      [
        210,
        21
      ],
      [
        87,
        -21
      ],
      [
        62,
        -87
      ],
      [
        62,
        -11
      ],
      [
        830,
        -195
      ],
      [
        285,
        -33
      ],
      [
        433,
        -21
      ],
      [
        335,
        0
      ],
      [
        111,
        -54
      ],
      [
        -260,
        -33
      ],
      [
        -446,
        22
      ],
      [
        -161,
        0
      ],
      [
        -111,
        -22
      ],
      [
        -211,
        -22
      ],
      [
        50,
        -32
      ],
      [
        235,
        -11
      ],
      [
        211,
        0
      ],
      [
        24,
        -43
      ],
      [
        -198,
        -11
      ],
      [
        -421,
        -11
      ],
      [
        -74,
        -33
      ],
      [
        99,
        -21
      ],
      [
        25,
        -33
      ],
      [
        -50,
        -87
      ],
      [
        74,
        -65
      ],
      [
        100,
        0
      ],
      [
        173,
        -54
      ],
      [
        173,
        0
      ],
      [
        223,
        43
      ],
      [
        99,
        0
      ],
      [
        285,
        22
      ],
      [
        260,
        0
      ],
      [
        360,
        43
      ],
      [
        111,
        0
      ],
      [
        -99,
        -54
      ],
      [
        -446,
        -119
      ],
      [
        -210,
        -33
      ],
      [
        24,
        -65
      ],
      [
        174,
        -119
      ],
      [
        74,
        -98
      ],
      [
        74,
        -21
      ],
      [
        174,
        11
      ],
      [
        0,
        -65
      ],
      [
        -136,
        -152
      ],
      [
        62,
        -33
      ],
      [
        148,
        -22
      ],
      [
        397,
        -10
      ],
      [
        111,
        -11
      ],
      [
        669,
        358
      ],
      [
        74,
        32
      ],
      [
        446,
        163
      ],
      [
        87,
        65
      ],
      [
        173,
        0
      ],
      [
        236,
        98
      ],
      [
        223,
        75
      ],
      [
        136,
        11
      ],
      [
        87,
        22
      ],
      [
        185,
        -11
      ],
      [
        124,
        11
      ],
      [
        236,
        54
      ],
      [
        186,
        22
      ],
      [
        185,
        32
      ],
      [
        211,
        0
      ],
      [
        582,
        44
      ],
      [
        161,
        -11
      ],
      [
        186,
        -54
      ],
      [
        272,
        11
      ],
      [
        100,
        21
      ],
      [
        49,
        -54
      ],
      [
        25,
        -76
      ],
      [
        -50,
        -65
      ],
      [
        -86,
        -43
      ],
      [
        -25,
        -76
      ],
      [
        111,
        -33
      ],
      [
        397,
        44
      ],
      [
        198,
        43
      ],
      [
        62,
        33
      ],
      [
        74,
        -11
      ],
      [
        136,
        43
      ],
      [
        174,
        152
      ],
      [
        210,
        163
      ],
      [
        174,
        97
      ],
      [
        111,
        120
      ],
      [
        99,
        75
      ],
      [
        186,
        76
      ],
      [
        161,
        0
      ],
      [
        236,
        87
      ],
      [
        334,
        98
      ],
      [
        260,
        -55
      ],
      [
        285,
        -65
      ],
      [
        136,
        55
      ],
      [
        100,
        10
      ],
      [
        185,
        44
      ],
      [
        62,
        54
      ],
      [
        87,
        33
      ],
      [
        74,
        65
      ],
      [
        682,
        65
      ],
      [
        49,
        21
      ],
      [
        50,
        -10
      ],
      [
        124,
        10
      ],
      [
        148,
        33
      ],
      [
        211,
        11
      ],
      [
        111,
        -11
      ],
      [
        112,
        98
      ],
      [
        198,
        10
      ],
      [
        372,
        76
      ],
      [
        1759,
        65
      ],
      [
        74,
        33
      ],
      [
        149,
        22
      ],
      [
        62,
        76
      ],
      [
        -236,
        21
      ],
      [
        -74,
        33
      ],
      [
        -124,
        -11
      ],
      [
        -1821,
        119
      ],
      [
        -37,
        0
      ],
      [
        -50,
        65
      ],
      [
        13,
        109
      ],
      [
        -50,
        97
      ],
      [
        -111,
        22
      ],
      [
        -124,
        0
      ],
      [
        -136,
        -11
      ],
      [
        -397,
        -54
      ],
      [
        -148,
        0
      ],
      [
        -422,
        76
      ],
      [
        -272,
        76
      ],
      [
        -174,
        32
      ],
      [
        -260,
        98
      ],
      [
        0,
        98
      ],
      [
        25,
        97
      ],
      [
        235,
        260
      ],
      [
        137,
        131
      ],
      [
        99,
        10
      ],
      [
        86,
        55
      ],
      [
        100,
        130
      ],
      [
        74,
        65
      ],
      [
        161,
        65
      ],
      [
        334,
        108
      ],
      [
        186,
        -10
      ],
      [
        136,
        76
      ],
      [
        409,
        173
      ],
      [
        99,
        65
      ],
      [
        112,
        33
      ],
      [
        322,
        141
      ],
      [
        297,
        76
      ],
      [
        149,
        21
      ],
      [
        173,
        44
      ],
      [
        372,
        119
      ],
      [
        619,
        119
      ],
      [
        372,
        33
      ],
      [
        248,
        32
      ],
      [
        173,
        -21
      ],
      [
        186,
        10
      ],
      [
        223,
        55
      ],
      [
        99,
        65
      ],
      [
        347,
        -33
      ],
      [
        210,
        44
      ],
      [
        99,
        10
      ],
      [
        100,
        22
      ],
      [
        -75,
        22
      ],
      [
        -86,
        87
      ],
      [
        49,
        86
      ],
      [
        37,
        33
      ],
      [
        99,
        54
      ],
      [
        50,
        65
      ],
      [
        49,
        109
      ],
      [
        174,
        195
      ],
      [
        49,
        32
      ],
      [
        99,
        11
      ],
      [
        87,
        -11
      ],
      [
        112,
        0
      ],
      [
        260,
        -43
      ],
      [
        49,
        11
      ],
      [
        149,
        141
      ],
      [
        149,
        108
      ],
      [
        24,
        33
      ],
      [
        -12,
        54
      ],
      [
        -223,
        -33
      ],
      [
        -161,
        -32
      ],
      [
        -173,
        22
      ],
      [
        -13,
        32
      ],
      [
        37,
        22
      ],
      [
        62,
        11
      ],
      [
        13,
        32
      ],
      [
        -50,
        33
      ],
      [
        -99,
        11
      ],
      [
        -49,
        32
      ],
      [
        37,
        130
      ],
      [
        49,
        22
      ],
      [
        161,
        152
      ],
      [
        75,
        32
      ],
      [
        198,
        33
      ],
      [
        235,
        -43
      ],
      [
        62,
        10
      ],
      [
        50,
        65
      ],
      [
        -62,
        98
      ],
      [
        -37,
        33
      ],
      [
        0,
        32
      ],
      [
        123,
        -11
      ],
      [
        112,
        -21
      ],
      [
        136,
        0
      ],
      [
        161,
        97
      ],
      [
        223,
        87
      ],
      [
        112,
        32
      ],
      [
        99,
        11
      ],
      [
        49,
        87
      ],
      [
        75,
        152
      ],
      [
        62,
        87
      ],
      [
        0,
        43
      ],
      [
        -25,
        43
      ],
      [
        -112,
        -10
      ],
      [
        -124,
        32
      ],
      [
        -148,
        65
      ],
      [
        -50,
        76
      ],
      [
        -25,
        65
      ],
      [
        50,
        44
      ],
      [
        50,
        21
      ],
      [
        49,
        0
      ],
      [
        87,
        -21
      ],
      [
        111,
        -76
      ],
      [
        62,
        -22
      ],
      [
        62,
        -43
      ],
      [
        50,
        0
      ],
      [
        62,
        65
      ],
      [
        49,
        97
      ],
      [
        99,
        54
      ],
      [
        62,
        44
      ],
      [
        -25,
        43
      ],
      [
        -74,
        22
      ],
      [
        -12,
        32
      ],
      [
        37,
        33
      ],
      [
        62,
        0
      ],
      [
        62,
        -65
      ],
      [
        99,
        -43
      ],
      [
        74,
        -11
      ],
      [
        62,
        -33
      ],
      [
        87,
        -119
      ],
      [
        111,
        -195
      ],
      [
        50,
        0
      ],
      [
        99,
        21
      ],
      [
        99,
        0
      ],
      [
        74,
        55
      ],
      [
        13,
        141
      ],
      [
        25,
        65
      ],
      [
        -13,
        65
      ],
      [
        -37,
        65
      ],
      [
        -50,
        43
      ],
      [
        13,
        33
      ],
      [
        37,
        32
      ],
      [
        124,
        33
      ],
      [
        124,
        -33
      ],
      [
        161,
        11
      ],
      [
        111,
        43
      ],
      [
        99,
        22
      ],
      [
        87,
        -22
      ],
      [
        37,
        -65
      ],
      [
        -49,
        -65
      ],
      [
        -124,
        -119
      ],
      [
        -13,
        -108
      ],
      [
        62,
        -11
      ],
      [
        508,
        11
      ],
      [
        75,
        -11
      ],
      [
        86,
        0
      ],
      [
        99,
        -22
      ],
      [
        161,
        11
      ],
      [
        149,
        22
      ],
      [
        74,
        0
      ],
      [
        112,
        -22
      ],
      [
        87,
        -43
      ],
      [
        173,
        10
      ],
      [
        50,
        22
      ],
      [
        49,
        54
      ],
      [
        50,
        22
      ],
      [
        62,
        -54
      ],
      [
        24,
        -120
      ],
      [
        25,
        -54
      ],
      [
        74,
        -54
      ],
      [
        75,
        43
      ],
      [
        49,
        55
      ],
      [
        112,
        97
      ],
      [
        136,
        76
      ],
      [
        99,
        43
      ],
      [
        248,
        76
      ],
      [
        124,
        55
      ],
      [
        235,
        65
      ],
      [
        310,
        32
      ],
      [
        557,
        120
      ],
      [
        186,
        10
      ],
      [
        297,
        33
      ],
      [
        149,
        32
      ],
      [
        161,
        22
      ],
      [
        87,
        87
      ],
      [
        223,
        -65
      ],
      [
        74,
        -11
      ],
      [
        99,
        54
      ],
      [
        112,
        130
      ],
      [
        161,
        -54
      ],
      [
        99,
        -87
      ],
      [
        111,
        -65
      ],
      [
        335,
        -141
      ],
      [
        173,
        -21
      ],
      [
        50,
        21
      ],
      [
        74,
        76
      ],
      [
        87,
        109
      ],
      [
        49,
        43
      ],
      [
        161,
        98
      ],
      [
        -24,
        32
      ],
      [
        -87,
        33
      ],
      [
        12,
        32
      ],
      [
        149,
        0
      ],
      [
        74,
        -108
      ],
      [
        186,
        -65
      ],
      [
        235,
        21
      ],
      [
        186,
        0
      ],
      [
        174,
        -21
      ],
      [
        86,
        11
      ],
      [
        75,
        76
      ],
      [
        124,
        32
      ],
      [
        74,
        -32
      ],
      [
        37,
        -120
      ],
      [
        161,
        -43
      ],
      [
        322,
        -54
      ],
      [
        37,
        21
      ],
      [
        50,
        55
      ],
      [
        25,
        86
      ],
      [
        62,
        11
      ],
      [
        86,
        44
      ],
      [
        50,
        -11
      ],
      [
        62,
        -44
      ],
      [
        -25,
        -130
      ],
      [
        -37,
        -108
      ],
      [
        49,
        -98
      ],
      [
        38,
        -54
      ],
      [
        136,
        -11
      ],
      [
        161,
        11
      ],
      [
        322,
        43
      ],
      [
        37,
        98
      ],
      [
        62,
        119
      ],
      [
        124,
        152
      ],
      [
        87,
        -33
      ],
      [
        86,
        -75
      ],
      [
        50,
        -33
      ],
      [
        12,
        -54
      ],
      [
        -49,
        -54
      ],
      [
        12,
        -33
      ],
      [
        50,
        -22
      ],
      [
        185,
        -43
      ],
      [
        62,
        11
      ],
      [
        87,
        43
      ],
      [
        87,
        87
      ],
      [
        49,
        108
      ],
      [
        75,
        0
      ],
      [
        74,
        -21
      ],
      [
        50,
        -65
      ],
      [
        0,
        -98
      ],
      [
        74,
        -76
      ],
      [
        62,
        -43
      ],
      [
        148,
        -55
      ],
      [
        149,
        -10
      ],
      [
        112,
        -22
      ],
      [
        185,
        11
      ],
      [
        87,
        32
      ],
      [
        62,
        0
      ],
      [
        99,
        33
      ],
      [
        99,
        65
      ],
      [
        62,
        22
      ],
      [
        236,
        54
      ],
      [
        185,
        65
      ],
      [
        186,
        108
      ],
      [
        186,
        65
      ],
      [
        372,
        44
      ],
      [
        111,
        0
      ],
      [
        260,
        87
      ],
      [
        99,
        43
      ],
      [
        62,
        11
      ],
      [
        62,
        65
      ],
      [
        62,
        173
      ],
      [
        0,
        65
      ],
      [
        -25,
        87
      ],
      [
        -62,
        76
      ],
      [
        -49,
        119
      ],
      [
        25,
        131
      ],
      [
        37,
        43
      ],
      [
        124,
        65
      ],
      [
        124,
        11
      ],
      [
        247,
        -22
      ],
      [
        0,
        -54
      ],
      [
        -111,
        -119
      ],
      [
        -37,
        -22
      ],
      [
        12,
        -54
      ],
      [
        87,
        0
      ],
      [
        186,
        11
      ],
      [
        49,
        -55
      ],
      [
        136,
        -195
      ],
      [
        25,
        -97
      ],
      [
        50,
        -22
      ],
      [
        74,
        11
      ],
      [
        149,
        0
      ],
      [
        111,
        11
      ],
      [
        87,
        0
      ],
      [
        49,
        -11
      ],
      [
        50,
        -44
      ],
      [
        87,
        -54
      ],
      [
        86,
        43
      ],
      [
        62,
        22
      ],
      [
        87,
        -11
      ],
      [
        111,
        -54
      ],
      [
        124,
        -152
      ],
      [
        137,
        -65
      ],
      [
        12,
        44
      ],
      [
        -25,
        54
      ],
      [
        62,
        54
      ],
      [
        62,
        87
      ],
      [
        99,
        108
      ],
      [
        75,
        109
      ],
      [
        12,
        162
      ],
      [
        37,
        131
      ],
      [
        62,
        65
      ],
      [
        149,
        76
      ],
      [
        124,
        10
      ],
      [
        99,
        87
      ],
      [
        86,
        43
      ],
      [
        161,
        55
      ],
      [
        199,
        43
      ],
      [
        136,
        152
      ],
      [
        124,
        32
      ],
      [
        136,
        11
      ],
      [
        273,
        55
      ],
      [
        123,
        32
      ],
      [
        99,
        87
      ],
      [
        62,
        22
      ],
      [
        137,
        0
      ],
      [
        111,
        43
      ],
      [
        87,
        0
      ],
      [
        87,
        32
      ],
      [
        12,
        44
      ],
      [
        -37,
        43
      ],
      [
        -13,
        44
      ],
      [
        50,
        65
      ],
      [
        37,
        21
      ],
      [
        112,
        -10
      ],
      [
        99,
        -44
      ],
      [
        62,
        -11
      ],
      [
        24,
        -21
      ],
      [
        -62,
        -44
      ],
      [
        -37,
        -65
      ],
      [
        124,
        -97
      ],
      [
        75,
        10
      ],
      [
        86,
        33
      ],
      [
        87,
        -22
      ],
      [
        37,
        -54
      ],
      [
        0,
        -87
      ],
      [
        25,
        -43
      ],
      [
        62,
        43
      ],
      [
        25,
        76
      ],
      [
        -13,
        109
      ],
      [
        13,
        65
      ],
      [
        136,
        108
      ],
      [
        62,
        76
      ],
      [
        -99,
        22
      ],
      [
        -75,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -49,
        86
      ],
      [
        124,
        65
      ],
      [
        148,
        0
      ],
      [
        87,
        -65
      ],
      [
        173,
        -86
      ],
      [
        99,
        0
      ],
      [
        87,
        -11
      ],
      [
        25,
        32
      ],
      [
        -37,
        130
      ],
      [
        0,
        76
      ],
      [
        -75,
        33
      ],
      [
        -12,
        97
      ],
      [
        25,
        98
      ],
      [
        87,
        54
      ],
      [
        123,
        33
      ],
      [
        261,
        152
      ],
      [
        61,
        32
      ],
      [
        174,
        33
      ],
      [
        198,
        11
      ],
      [
        248,
        54
      ],
      [
        433,
        -33
      ],
      [
        199,
        -54
      ],
      [
        161,
        -130
      ],
      [
        123,
        -109
      ],
      [
        174,
        -32
      ],
      [
        49,
        -33
      ],
      [
        62,
        -86
      ],
      [
        -62,
        -55
      ],
      [
        -61,
        0
      ],
      [
        -100,
        33
      ],
      [
        -74,
        32
      ],
      [
        -62,
        -10
      ],
      [
        62,
        -65
      ],
      [
        50,
        -33
      ],
      [
        12,
        -54
      ],
      [
        -37,
        -65
      ],
      [
        -198,
        -141
      ],
      [
        124,
        -44
      ],
      [
        74,
        33
      ],
      [
        62,
        65
      ],
      [
        111,
        32
      ],
      [
        161,
        0
      ],
      [
        99,
        22
      ],
      [
        62,
        -11
      ],
      [
        75,
        -43
      ],
      [
        235,
        -76
      ],
      [
        186,
        -163
      ],
      [
        136,
        22
      ],
      [
        74,
        33
      ],
      [
        211,
        10
      ],
      [
        186,
        -75
      ],
      [
        99,
        -22
      ],
      [
        297,
        -22
      ],
      [
        174,
        -43
      ],
      [
        111,
        54
      ],
      [
        74,
        22
      ],
      [
        162,
        11
      ],
      [
        86,
        -11
      ],
      [
        223,
        -65
      ],
      [
        384,
        -55
      ],
      [
        273,
        -32
      ],
      [
        235,
        0
      ],
      [
        310,
        -54
      ],
      [
        86,
        -22
      ],
      [
        199,
        22
      ],
      [
        86,
        21
      ],
      [
        87,
        44
      ],
      [
        50,
        -11
      ],
      [
        37,
        -65
      ],
      [
        -25,
        -109
      ],
      [
        62,
        -141
      ],
      [
        50,
        -65
      ],
      [
        24,
        -54
      ],
      [
        -24,
        -43
      ],
      [
        -137,
        -130
      ],
      [
        13,
        -76
      ],
      [
        24,
        -44
      ],
      [
        -37,
        -54
      ],
      [
        37,
        -87
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -44
      ],
      [
        -62,
        -21
      ],
      [
        -112,
        0
      ],
      [
        -49,
        -22
      ],
      [
        -13,
        -65
      ],
      [
        25,
        -43
      ],
      [
        62,
        -22
      ],
      [
        25,
        -54
      ],
      [
        -13,
        -65
      ],
      [
        -24,
        -65
      ],
      [
        -62,
        -33
      ],
      [
        -174,
        11
      ],
      [
        -74,
        43
      ],
      [
        -62,
        -43
      ],
      [
        -149,
        -119
      ],
      [
        -111,
        -109
      ],
      [
        136,
        -32
      ],
      [
        99,
        -65
      ],
      [
        211,
        10
      ],
      [
        161,
        55
      ],
      [
        49,
        -11
      ],
      [
        25,
        -54
      ],
      [
        -12,
        -98
      ],
      [
        0,
        -76
      ],
      [
        -112,
        -206
      ],
      [
        -37,
        -33
      ],
      [
        -49,
        -65
      ],
      [
        -62,
        -43
      ],
      [
        -50,
        -22
      ],
      [
        -87,
        -65
      ],
      [
        -62,
        -119
      ],
      [
        -61,
        -98
      ],
      [
        -87,
        -162
      ],
      [
        -75,
        -282
      ],
      [
        -37,
        -120
      ],
      [
        -74,
        -184
      ],
      [
        -50,
        -33
      ],
      [
        -86,
        -86
      ],
      [
        24,
        -44
      ],
      [
        149,
        -21
      ],
      [
        112,
        -44
      ],
      [
        148,
        87
      ],
      [
        75,
        54
      ],
      [
        12,
        98
      ],
      [
        -12,
        108
      ],
      [
        49,
        65
      ],
      [
        99,
        87
      ],
      [
        310,
        65
      ],
      [
        87,
        22
      ],
      [
        74,
        76
      ],
      [
        62,
        76
      ],
      [
        111,
        43
      ],
      [
        99,
        76
      ],
      [
        13,
        54
      ],
      [
        49,
        11
      ],
      [
        112,
        54
      ],
      [
        74,
        76
      ],
      [
        25,
        65
      ],
      [
        12,
        130
      ],
      [
        25,
        98
      ],
      [
        99,
        217
      ],
      [
        50,
        65
      ],
      [
        124,
        33
      ],
      [
        49,
        32
      ],
      [
        124,
        130
      ],
      [
        -12,
        98
      ],
      [
        37,
        87
      ],
      [
        74,
        54
      ],
      [
        99,
        97
      ],
      [
        112,
        11
      ],
      [
        99,
        54
      ],
      [
        99,
        -32
      ],
      [
        111,
        -54
      ],
      [
        199,
        21
      ],
      [
        99,
        -21
      ],
      [
        74,
        21
      ],
      [
        62,
        76
      ],
      [
        25,
        98
      ],
      [
        74,
        54
      ],
      [
        87,
        0
      ],
      [
        136,
        87
      ],
      [
        149,
        87
      ],
      [
        124,
        21
      ],
      [
        86,
        65
      ],
      [
        75,
        109
      ],
      [
        74,
        87
      ],
      [
        87,
        86
      ],
      [
        24,
        141
      ],
      [
        62,
        76
      ],
      [
        100,
        65
      ],
      [
        86,
        33
      ],
      [
        372,
        108
      ],
      [
        285,
        65
      ],
      [
        285,
        87
      ],
      [
        86,
        0
      ],
      [
        112,
        54
      ],
      [
        248,
        0
      ],
      [
        62,
        109
      ],
      [
        136,
        87
      ],
      [
        99,
        32
      ],
      [
        111,
        87
      ],
      [
        87,
        0
      ],
      [
        124,
        -11
      ],
      [
        111,
        -22
      ],
      [
        100,
        0
      ],
      [
        136,
        65
      ],
      [
        210,
        11
      ],
      [
        75,
        33
      ],
      [
        49,
        32
      ],
      [
        310,
        87
      ],
      [
        111,
        -11
      ],
      [
        161,
        11
      ],
      [
        100,
        0
      ],
      [
        210,
        -22
      ],
      [
        211,
        33
      ],
      [
        86,
        33
      ],
      [
        161,
        75
      ],
      [
        186,
        22
      ],
      [
        174,
        44
      ],
      [
        186,
        -76
      ],
      [
        49,
        0
      ],
      [
        112,
        32
      ],
      [
        99,
        -11
      ],
      [
        124,
        -32
      ],
      [
        86,
        -33
      ],
      [
        37,
        0
      ],
      [
        87,
        33
      ],
      [
        87,
        54
      ],
      [
        87,
        33
      ],
      [
        148,
        -44
      ],
      [
        99,
        -43
      ],
      [
        298,
        21
      ],
      [
        235,
        66
      ],
      [
        99,
        -55
      ],
      [
        112,
        -11
      ],
      [
        185,
        87
      ],
      [
        161,
        -54
      ],
      [
        50,
        -76
      ],
      [
        173,
        11
      ],
      [
        285,
        119
      ],
      [
        137,
        22
      ],
      [
        99,
        43
      ],
      [
        148,
        163
      ],
      [
        0,
        54
      ],
      [
        50,
        44
      ],
      [
        248,
        -11
      ],
      [
        74,
        21
      ],
      [
        99,
        44
      ],
      [
        161,
        -33
      ],
      [
        173,
        -54
      ],
      [
        100,
        0
      ],
      [
        123,
        -22
      ],
      [
        124,
        -65
      ],
      [
        112,
        -21
      ],
      [
        483,
        -152
      ],
      [
        272,
        -33
      ],
      [
        137,
        -54
      ],
      [
        74,
        -65
      ],
      [
        62,
        -11
      ],
      [
        62,
        22
      ],
      [
        74,
        -76
      ],
      [
        186,
        -65
      ],
      [
        186,
        -33
      ],
      [
        124,
        54
      ],
      [
        210,
        131
      ],
      [
        75,
        65
      ],
      [
        -13,
        130
      ],
      [
        99,
        141
      ],
      [
        199,
        76
      ],
      [
        371,
        76
      ],
      [
        186,
        21
      ],
      [
        99,
        -21
      ],
      [
        50,
        -33
      ],
      [
        62,
        -22
      ],
      [
        86,
        -86
      ],
      [
        136,
        -185
      ],
      [
        100,
        -65
      ],
      [
        148,
        -21
      ],
      [
        87,
        -44
      ],
      [
        111,
        -130
      ],
      [
        -74,
        -108
      ],
      [
        -49,
        -44
      ],
      [
        -248,
        -54
      ],
      [
        -99,
        -43
      ],
      [
        -99,
        -22
      ],
      [
        -25,
        -98
      ],
      [
        37,
        -43
      ],
      [
        99,
        22
      ],
      [
        124,
        10
      ],
      [
        173,
        44
      ],
      [
        75,
        43
      ],
      [
        173,
        33
      ],
      [
        112,
        32
      ],
      [
        99,
        22
      ],
      [
        74,
        32
      ],
      [
        74,
        0
      ],
      [
        62,
        -32
      ],
      [
        62,
        0
      ],
      [
        149,
        -11
      ],
      [
        74,
        22
      ],
      [
        62,
        0
      ],
      [
        62,
        -11
      ],
      [
        74,
        -33
      ],
      [
        62,
        -10
      ],
      [
        87,
        21
      ],
      [
        285,
        98
      ],
      [
        136,
        11
      ],
      [
        62,
        -11
      ],
      [
        -136,
        -54
      ],
      [
        -235,
        -76
      ],
      [
        -124,
        -76
      ],
      [
        74,
        -33
      ],
      [
        434,
        87
      ],
      [
        198,
        54
      ],
      [
        173,
        33
      ],
      [
        50,
        21
      ],
      [
        136,
        98
      ],
      [
        62,
        22
      ],
      [
        347,
        76
      ],
      [
        161,
        43
      ],
      [
        99,
        43
      ],
      [
        87,
        0
      ],
      [
        49,
        -32
      ],
      [
        87,
        -33
      ],
      [
        74,
        11
      ],
      [
        99,
        33
      ],
      [
        99,
        130
      ],
      [
        161,
        43
      ],
      [
        75,
        -21
      ],
      [
        111,
        -44
      ],
      [
        87,
        -21
      ],
      [
        74,
        -163
      ],
      [
        174,
        -141
      ],
      [
        49,
        -44
      ],
      [
        149,
        22
      ],
      [
        161,
        -65
      ],
      [
        74,
        11
      ],
      [
        62,
        22
      ],
      [
        50,
        -11
      ],
      [
        99,
        32
      ],
      [
        173,
        358
      ],
      [
        75,
        76
      ],
      [
        49,
        33
      ],
      [
        62,
        11
      ],
      [
        99,
        43
      ],
      [
        124,
        11
      ],
      [
        99,
        -22
      ],
      [
        211,
        -11
      ],
      [
        161,
        44
      ],
      [
        198,
        0
      ],
      [
        87,
        43
      ],
      [
        99,
        11
      ],
      [
        136,
        -44
      ],
      [
        124,
        -75
      ],
      [
        37,
        -131
      ],
      [
        37,
        0
      ],
      [
        124,
        76
      ],
      [
        74,
        22
      ],
      [
        124,
        119
      ],
      [
        75,
        -32
      ],
      [
        161,
        -54
      ],
      [
        62,
        -11
      ],
      [
        123,
        -87
      ],
      [
        62,
        11
      ],
      [
        50,
        43
      ],
      [
        161,
        0
      ],
      [
        136,
        -43
      ],
      [
        62,
        -33
      ],
      [
        75,
        -54
      ],
      [
        37,
        -11
      ],
      [
        37,
        22
      ],
      [
        297,
        -22
      ],
      [
        136,
        -43
      ],
      [
        100,
        -44
      ],
      [
        346,
        -32
      ],
      [
        124,
        -44
      ],
      [
        87,
        22
      ],
      [
        149,
        -11
      ],
      [
        123,
        -86
      ],
      [
        124,
        -44
      ],
      [
        75,
        11
      ],
      [
        99,
        33
      ],
      [
        86,
        43
      ],
      [
        100,
        0
      ],
      [
        49,
        -33
      ],
      [
        12,
        -97
      ],
      [
        75,
        0
      ],
      [
        74,
        43
      ],
      [
        74,
        -11
      ],
      [
        25,
        -65
      ],
      [
        -37,
        -86
      ],
      [
        -87,
        -120
      ],
      [
        -37,
        -108
      ],
      [
        -74,
        -98
      ],
      [
        12,
        -43
      ],
      [
        75,
        -22
      ],
      [
        74,
        65
      ],
      [
        161,
        54
      ],
      [
        87,
        55
      ],
      [
        148,
        21
      ],
      [
        137,
        -21
      ],
      [
        111,
        -76
      ],
      [
        186,
        -130
      ],
      [
        25,
        -98
      ],
      [
        0,
        -43
      ],
      [
        -38,
        -55
      ],
      [
        112,
        -65
      ],
      [
        87,
        -11
      ],
      [
        74,
        11
      ],
      [
        297,
        -54
      ],
      [
        149,
        22
      ],
      [
        136,
        0
      ],
      [
        149,
        11
      ],
      [
        124,
        -11
      ],
      [
        99,
        0
      ],
      [
        111,
        11
      ],
      [
        87,
        32
      ],
      [
        50,
        -22
      ],
      [
        24,
        -227
      ],
      [
        50,
        -33
      ],
      [
        99,
        76
      ],
      [
        235,
        -22
      ],
      [
        99,
        0
      ],
      [
        87,
        -32
      ],
      [
        99,
        -54
      ],
      [
        87,
        21
      ],
      [
        50,
        44
      ],
      [
        74,
        21
      ],
      [
        25,
        55
      ],
      [
        12,
        86
      ],
      [
        -12,
        87
      ],
      [
        49,
        22
      ],
      [
        99,
        -54
      ],
      [
        124,
        -141
      ],
      [
        149,
        -131
      ],
      [
        62,
        -32
      ],
      [
        124,
        -76
      ],
      [
        161,
        -33
      ],
      [
        161,
        -75
      ],
      [
        198,
        10
      ],
      [
        149,
        -86
      ],
      [
        99,
        65
      ],
      [
        62,
        21
      ],
      [
        74,
        -21
      ],
      [
        87,
        -55
      ],
      [
        74,
        -10
      ],
      [
        260,
        -98
      ],
      [
        136,
        -33
      ],
      [
        50,
        -65
      ],
      [
        62,
        -65
      ],
      [
        0,
        -65
      ],
      [
        37,
        -87
      ],
      [
        149,
        -65
      ],
      [
        136,
        -151
      ],
      [
        136,
        -315
      ],
      [
        62,
        -54
      ],
      [
        99,
        0
      ],
      [
        99,
        -76
      ],
      [
        37,
        43
      ],
      [
        -86,
        206
      ],
      [
        -13,
        120
      ],
      [
        75,
        65
      ],
      [
        148,
        21
      ],
      [
        124,
        -119
      ],
      [
        112,
        -76
      ],
      [
        74,
        -21
      ],
      [
        149,
        10
      ],
      [
        136,
        76
      ],
      [
        111,
        -32
      ],
      [
        174,
        0
      ],
      [
        223,
        -54
      ],
      [
        86,
        10
      ],
      [
        174,
        -21
      ],
      [
        210,
        -65
      ],
      [
        112,
        -22
      ],
      [
        25,
        -33
      ],
      [
        62,
        -43
      ],
      [
        49,
        -108
      ],
      [
        75,
        -55
      ],
      [
        74,
        -11
      ],
      [
        136,
        -43
      ],
      [
        297,
        -152
      ],
      [
        112,
        -43
      ],
      [
        62,
        -33
      ],
      [
        37,
        44
      ],
      [
        0,
        76
      ],
      [
        62,
        21
      ],
      [
        111,
        -206
      ],
      [
        38,
        -76
      ],
      [
        -62,
        -65
      ],
      [
        -161,
        11
      ],
      [
        -62,
        -97
      ],
      [
        -37,
        -185
      ],
      [
        61,
        0
      ],
      [
        50,
        22
      ],
      [
        12,
        -65
      ],
      [
        -37,
        -54
      ],
      [
        -49,
        -22
      ],
      [
        -211,
        65
      ],
      [
        -124,
        11
      ],
      [
        -124,
        54
      ],
      [
        -99,
        0
      ],
      [
        137,
        -108
      ],
      [
        148,
        -44
      ],
      [
        198,
        -65
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -44
      ],
      [
        -62,
        -108
      ],
      [
        -173,
        -98
      ],
      [
        -99,
        65
      ],
      [
        -124,
        22
      ],
      [
        -62,
        -43
      ],
      [
        -124,
        11
      ],
      [
        -235,
        -22
      ],
      [
        -99,
        87
      ],
      [
        -149,
        43
      ],
      [
        12,
        -33
      ],
      [
        124,
        -141
      ],
      [
        136,
        -32
      ],
      [
        137,
        -43
      ],
      [
        25,
        -33
      ],
      [
        -62,
        -33
      ],
      [
        -75,
        0
      ],
      [
        -111,
        -65
      ],
      [
        -186,
        11
      ],
      [
        -99,
        0
      ],
      [
        -50,
        -32
      ],
      [
        -49,
        -11
      ],
      [
        37,
        -22
      ],
      [
        49,
        -65
      ],
      [
        -74,
        -54
      ],
      [
        -62,
        -22
      ],
      [
        -62,
        11
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        65
      ],
      [
        0,
        131
      ],
      [
        -49,
        119
      ],
      [
        -99,
        -11
      ],
      [
        -25,
        -108
      ],
      [
        49,
        -174
      ],
      [
        25,
        -54
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        161,
        -250
      ],
      [
        50,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        -100,
        21
      ],
      [
        -111,
        -10
      ],
      [
        -87,
        21
      ],
      [
        -86,
        11
      ],
      [
        -87,
        -32
      ],
      [
        -62,
        10
      ],
      [
        -62,
        87
      ],
      [
        -62,
        22
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        -108
      ],
      [
        -149,
        -76
      ],
      [
        -49,
        -54
      ],
      [
        -25,
        -217
      ],
      [
        -37,
        -44
      ],
      [
        -62,
        0
      ],
      [
        -50,
        -21
      ],
      [
        -136,
        32
      ],
      [
        -273,
        -76
      ],
      [
        50,
        -32
      ],
      [
        297,
        -11
      ],
      [
        99,
        -33
      ],
      [
        13,
        -97
      ],
      [
        37,
        -44
      ],
      [
        136,
        -65
      ],
      [
        25,
        -32
      ],
      [
        -50,
        -130
      ],
      [
        -74,
        -65
      ],
      [
        12,
        -33
      ],
      [
        87,
        -11
      ],
      [
        25,
        -152
      ],
      [
        -50,
        -65
      ],
      [
        37,
        -108
      ],
      [
        -99,
        -76
      ],
      [
        -12,
        -54
      ],
      [
        74,
        -33
      ],
      [
        149,
        -21
      ],
      [
        124,
        -141
      ],
      [
        49,
        -76
      ],
      [
        13,
        -120
      ],
      [
        49,
        -76
      ],
      [
        87,
        -43
      ],
      [
        0,
        -54
      ],
      [
        136,
        -22
      ],
      [
        25,
        -43
      ],
      [
        -25,
        -55
      ],
      [
        -111,
        -65
      ],
      [
        -50,
        -43
      ],
      [
        112,
        -11
      ],
      [
        124,
        -54
      ],
      [
        136,
        65
      ],
      [
        74,
        54
      ],
      [
        50,
        54
      ],
      [
        37,
        -10
      ],
      [
        49,
        -152
      ],
      [
        186,
        -87
      ],
      [
        112,
        -32
      ],
      [
        186,
        -11
      ],
      [
        24,
        -55
      ],
      [
        -24,
        -54
      ],
      [
        -186,
        0
      ],
      [
        -137,
        76
      ],
      [
        -507,
        -22
      ],
      [
        -124,
        -21
      ],
      [
        -137,
        -54
      ],
      [
        -136,
        -22
      ],
      [
        -210,
        -54
      ],
      [
        -87,
        -33
      ],
      [
        -223,
        130
      ],
      [
        -74,
        87
      ],
      [
        -38,
        11
      ],
      [
        -49,
        -22
      ],
      [
        0,
        -65
      ],
      [
        99,
        -152
      ],
      [
        50,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -75,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -124,
        22
      ],
      [
        -111,
        -44
      ],
      [
        -136,
        -97
      ],
      [
        74,
        -98
      ],
      [
        -12,
        -43
      ],
      [
        -149,
        -76
      ],
      [
        -87,
        -22
      ],
      [
        37,
        -21
      ],
      [
        87,
        -11
      ],
      [
        13,
        -33
      ],
      [
        -38,
        -21
      ],
      [
        -136,
        -33
      ],
      [
        12,
        -43
      ],
      [
        75,
        -22
      ],
      [
        99,
        0
      ],
      [
        49,
        -33
      ],
      [
        13,
        -43
      ],
      [
        -136,
        -54
      ],
      [
        -484,
        -120
      ],
      [
        -74,
        -43
      ],
      [
        0,
        -43
      ],
      [
        174,
        -11
      ],
      [
        507,
        11
      ],
      [
        38,
        -11
      ],
      [
        -50,
        -87
      ],
      [
        37,
        -32
      ],
      [
        75,
        -22
      ],
      [
        0,
        -44
      ],
      [
        -199,
        -32
      ],
      [
        13,
        -33
      ],
      [
        148,
        -43
      ],
      [
        0,
        -184
      ],
      [
        -86,
        -44
      ],
      [
        0,
        -43
      ],
      [
        148,
        -33
      ],
      [
        236,
        -130
      ],
      [
        49,
        0
      ],
      [
        236,
        -97
      ],
      [
        62,
        -44
      ],
      [
        74,
        -21
      ],
      [
        62,
        -66
      ],
      [
        210,
        -97
      ],
      [
        25,
        -44
      ],
      [
        -433,
        -75
      ],
      [
        -434,
        -55
      ],
      [
        50,
        -54
      ],
      [
        458,
        0
      ],
      [
        136,
        -32
      ],
      [
        87,
        54
      ],
      [
        508,
        65
      ],
      [
        74,
        -22
      ],
      [
        347,
        -152
      ],
      [
        161,
        -54
      ],
      [
        173,
        -32
      ],
      [
        112,
        -65
      ],
      [
        -13,
        -55
      ],
      [
        124,
        -54
      ],
      [
        174,
        43
      ],
      [
        173,
        -54
      ],
      [
        -124,
        -108
      ],
      [
        -198,
        0
      ],
      [
        62,
        -54
      ],
      [
        87,
        -22
      ],
      [
        594,
        -22
      ],
      [
        174,
        -54
      ],
      [
        161,
        32
      ],
      [
        148,
        -32
      ],
      [
        25,
        -43
      ],
      [
        211,
        -55
      ],
      [
        186,
        -21
      ],
      [
        148,
        0
      ],
      [
        174,
        -55
      ],
      [
        86,
        0
      ],
      [
        62,
        -32
      ],
      [
        409,
        -22
      ],
      [
        112,
        -65
      ],
      [
        198,
        -11
      ],
      [
        570,
        -65
      ],
      [
        631,
        -87
      ],
      [
        211,
        -86
      ],
      [
        0,
        -3525
      ],
      [
        -123861,
        0
      ],
      [
        0,
        249
      ],
      [
        0,
        185
      ],
      [
        0,
        444
      ],
      [
        0,
        434
      ],
      [
        0,
        445
      ],
      [
        0,
        445
      ],
      [
        0,
        433
      ],
      [
        0,
        445
      ],
      [
        0,
        445
      ],
      [
        545,
        11
      ],
      [
        235,
        -44
      ],
      [
        248,
        0
      ],
      [
        248,
        -11
      ],
      [
        136,
        -54
      ],
      [
        421,
        22
      ],
      [
        1016,
        -44
      ],
      [
        1041,
        -86
      ],
      [
        210,
        -33
      ],
      [
        198,
        -65
      ],
      [
        199,
        11
      ],
      [
        1189,
        -54
      ],
      [
        186,
        0
      ],
      [
        718,
        -55
      ],
      [
        1387,
        -130
      ],
      [
        112,
        11
      ],
      [
        -62,
        65
      ],
      [
        -111,
        54
      ],
      [
        -162,
        44
      ],
      [
        100,
        21
      ],
      [
        235,
        0
      ],
      [
        -50,
        33
      ],
      [
        -582,
        33
      ],
      [
        -1808,
        162
      ],
      [
        -186,
        44
      ],
      [
        -285,
        10
      ],
      [
        -62,
        33
      ],
      [
        421,
        22
      ],
      [
        50,
        21
      ],
      [
        -322,
        98
      ],
      [
        62,
        54
      ],
      [
        173,
        33
      ],
      [
        -25,
        43
      ],
      [
        -309,
        87
      ],
      [
        -199,
        32
      ],
      [
        -124,
        -21
      ],
      [
        -260,
        0
      ],
      [
        -309,
        -11
      ],
      [
        -174,
        43
      ],
      [
        -99,
        65
      ],
      [
        -285,
        120
      ],
      [
        -693,
        119
      ],
      [
        -124,
        32
      ],
      [
        -867,
        185
      ],
      [
        -50,
        76
      ],
      [
        396,
        -87
      ],
      [
        322,
        43
      ],
      [
        112,
        0
      ],
      [
        817,
        -151
      ],
      [
        285,
        -66
      ],
      [
        62,
        -21
      ],
      [
        75,
        11
      ],
      [
        681,
        10
      ],
      [
        211,
        -10
      ],
      [
        235,
        -44
      ],
      [
        99,
        -76
      ],
      [
        74,
        -32
      ],
      [
        236,
        54
      ],
      [
        223,
        33
      ],
      [
        185,
        -55
      ],
      [
        124,
        -65
      ],
      [
        545,
        11
      ],
      [
        236,
        0
      ],
      [
        161,
        -32
      ],
      [
        607,
        108
      ],
      [
        86,
        22
      ],
      [
        149,
        65
      ],
      [
        -198,
        32
      ],
      [
        -37,
        33
      ],
      [
        235,
        32
      ],
      [
        335,
        33
      ],
      [
        198,
        32
      ],
      [
        111,
        76
      ],
      [
        459,
        120
      ],
      [
        136,
        43
      ],
      [
        136,
        87
      ],
      [
        -297,
        173
      ],
      [
        -285,
        152
      ],
      [
        173,
        76
      ],
      [
        87,
        65
      ],
      [
        -186,
        87
      ],
      [
        -148,
        32
      ],
      [
        -731,
        120
      ],
      [
        74,
        65
      ],
      [
        99,
        32
      ],
      [
        211,
        22
      ],
      [
        1338,
        65
      ],
      [
        1350,
        87
      ],
      [
        37,
        32
      ],
      [
        -186,
        55
      ],
      [
        -210,
        21
      ],
      [
        -13,
        76
      ],
      [
        -322,
        54
      ],
      [
        -136,
        66
      ],
      [
        -13,
        32
      ],
      [
        50,
        87
      ],
      [
        74,
        43
      ],
      [
        124,
        22
      ],
      [
        372,
        0
      ],
      [
        148,
        22
      ],
      [
        0,
        43
      ],
      [
        -37,
        43
      ],
      [
        112,
        22
      ],
      [
        12,
        33
      ],
      [
        -37,
        43
      ],
      [
        -74,
        33
      ],
      [
        -223,
        43
      ],
      [
        -496,
        76
      ],
      [
        -297,
        87
      ],
      [
        -99,
        54
      ],
      [
        -149,
        43
      ],
      [
        13,
        33
      ],
      [
        -75,
        54
      ],
      [
        -148,
        -22
      ],
      [
        -285,
        11
      ],
      [
        -347,
        43
      ],
      [
        -236,
        55
      ],
      [
        -309,
        141
      ],
      [
        -124,
        65
      ],
      [
        87,
        43
      ],
      [
        99,
        33
      ],
      [
        421,
        76
      ],
      [
        62,
        21
      ],
      [
        87,
        65
      ],
      [
        -149,
        22
      ],
      [
        -112,
        0
      ],
      [
        -111,
        22
      ],
      [
        -421,
        0
      ],
      [
        -236,
        -11
      ],
      [
        -198,
        76
      ],
      [
        -148,
        76
      ],
      [
        -50,
        43
      ],
      [
        -25,
        65
      ],
      [
        87,
        185
      ],
      [
        12,
        206
      ],
      [
        62,
        43
      ],
      [
        62,
        11
      ],
      [
        124,
        -98
      ],
      [
        112,
        -11
      ],
      [
        173,
        22
      ],
      [
        149,
        65
      ],
      [
        99,
        11
      ],
      [
        198,
        -22
      ],
      [
        186,
        0
      ],
      [
        309,
        -65
      ],
      [
        112,
        -54
      ],
      [
        49,
        -65
      ],
      [
        124,
        -11
      ],
      [
        372,
        11
      ],
      [
        99,
        0
      ],
      [
        260,
        -98
      ],
      [
        223,
        -97
      ],
      [
        74,
        -22
      ],
      [
        137,
        -22
      ],
      [
        74,
        55
      ],
      [
        124,
        43
      ],
      [
        272,
        54
      ],
      [
        62,
        65
      ],
      [
        -136,
        54
      ],
      [
        -62,
        11
      ],
      [
        -37,
        44
      ],
      [
        0,
        54
      ],
      [
        25,
        43
      ],
      [
        62,
        11
      ],
      [
        136,
        -65
      ],
      [
        161,
        -65
      ],
      [
        50,
        -11
      ],
      [
        123,
        33
      ],
      [
        100,
        11
      ],
      [
        185,
        -131
      ],
      [
        112,
        -10
      ],
      [
        136,
        0
      ],
      [
        25,
        21
      ],
      [
        -37,
        76
      ],
      [
        -37,
        33
      ],
      [
        99,
        54
      ],
      [
        -75,
        54
      ],
      [
        -74,
        22
      ],
      [
        12,
        32
      ],
      [
        100,
        44
      ],
      [
        -13,
        97
      ],
      [
        -25,
        33
      ],
      [
        -148,
        54
      ],
      [
        -211,
        98
      ],
      [
        -186,
        43
      ],
      [
        -433,
        -43
      ],
      [
        -161,
        21
      ],
      [
        -211,
        65
      ],
      [
        136,
        33
      ],
      [
        124,
        22
      ],
      [
        99,
        65
      ],
      [
        99,
        43
      ],
      [
        162,
        -22
      ],
      [
        359,
        -119
      ],
      [
        74,
        -11
      ],
      [
        248,
        -54
      ],
      [
        148,
        11
      ],
      [
        -61,
        54
      ],
      [
        -75,
        33
      ],
      [
        -186,
        108
      ],
      [
        25,
        54
      ],
      [
        112,
        76
      ],
      [
        309,
        11
      ],
      [
        124,
        22
      ],
      [
        174,
        65
      ],
      [
        223,
        108
      ],
      [
        198,
        11
      ],
      [
        235,
        33
      ],
      [
        74,
        -22
      ],
      [
        211,
        -98
      ],
      [
        124,
        -43
      ],
      [
        87,
        0
      ],
      [
        -112,
        130
      ],
      [
        174,
        33
      ],
      [
        136,
        54
      ],
      [
        210,
        119
      ],
      [
        186,
        33
      ],
      [
        533,
        54
      ],
      [
        173,
        -43
      ],
      [
        161,
        -11
      ],
      [
        25,
        11
      ],
      [
        112,
        195
      ],
      [
        74,
        43
      ],
      [
        223,
        44
      ],
      [
        186,
        0
      ],
      [
        124,
        -55
      ],
      [
        123,
        -32
      ],
      [
        112,
        -11
      ],
      [
        111,
        0
      ],
      [
        161,
        33
      ],
      [
        223,
        10
      ],
      [
        100,
        11
      ],
      [
        123,
        -32
      ],
      [
        285,
        -11
      ],
      [
        236,
        -33
      ],
      [
        136,
        0
      ],
      [
        186,
        33
      ],
      [
        111,
        11
      ],
      [
        372,
        65
      ],
      [
        285,
        11
      ],
      [
        223,
        -33
      ],
      [
        347,
        22
      ],
      [
        359,
        -11
      ],
      [
        148,
        -33
      ],
      [
        806,
        22
      ],
      [
        644,
        54
      ],
      [
        87,
        22
      ],
      [
        136,
        65
      ],
      [
        74,
        65
      ],
      [
        161,
        22
      ],
      [
        186,
        -11
      ],
      [
        248,
        -43
      ],
      [
        223,
        10
      ],
      [
        421,
        -21
      ],
      [
        37,
        21
      ],
      [
        37,
        109
      ],
      [
        74,
        184
      ],
      [
        50,
        54
      ],
      [
        99,
        -21
      ],
      [
        285,
        -98
      ],
      [
        12,
        -43
      ],
      [
        -74,
        -44
      ],
      [
        -12,
        -86
      ],
      [
        37,
        -22
      ],
      [
        62,
        0
      ],
      [
        37,
        -33
      ],
      [
        -149,
        -108
      ],
      [
        -49,
        -11
      ],
      [
        -25,
        -130
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -54
      ],
      [
        62,
        0
      ],
      [
        62,
        22
      ],
      [
        223,
        43
      ],
      [
        309,
        33
      ],
      [
        112,
        22
      ],
      [
        62,
        0
      ],
      [
        37,
        32
      ],
      [
        -62,
        54
      ],
      [
        -12,
        55
      ],
      [
        37,
        43
      ],
      [
        -13,
        76
      ],
      [
        -24,
        65
      ],
      [
        49,
        65
      ],
      [
        62,
        -22
      ],
      [
        99,
        11
      ],
      [
        50,
        -22
      ],
      [
        173,
        -43
      ],
      [
        75,
        -43
      ],
      [
        24,
        -109
      ],
      [
        -24,
        -108
      ],
      [
        -75,
        -76
      ],
      [
        -148,
        -76
      ],
      [
        -174,
        -109
      ],
      [
        37,
        -54
      ],
      [
        87,
        11
      ],
      [
        384,
        0
      ],
      [
        248,
        11
      ],
      [
        148,
        -11
      ],
      [
        199,
        -32
      ],
      [
        161,
        -44
      ],
      [
        185,
        -11
      ],
      [
        112,
        22
      ],
      [
        111,
        -22
      ],
      [
        422,
        87
      ],
      [
        161,
        54
      ],
      [
        99,
        -32
      ],
      [
        161,
        21
      ],
      [
        86,
        -10
      ],
      [
        161,
        32
      ],
      [
        112,
        0
      ],
      [
        124,
        -11
      ],
      [
        359,
        -11
      ],
      [
        25,
        -54
      ],
      [
        111,
        -97
      ],
      [
        99,
        -33
      ],
      [
        112,
        11
      ],
      [
        87,
        32
      ],
      [
        124,
        -10
      ],
      [
        198,
        43
      ],
      [
        260,
        -11
      ],
      [
        37,
        22
      ],
      [
        37,
        54
      ],
      [
        -62,
        33
      ],
      [
        -173,
        43
      ],
      [
        -149,
        76
      ],
      [
        -62,
        22
      ],
      [
        -111,
        -11
      ],
      [
        -112,
        43
      ],
      [
        75,
        33
      ],
      [
        86,
        97
      ],
      [
        -37,
        87
      ],
      [
        -37,
        22
      ],
      [
        -99,
        0
      ],
      [
        -124,
        -33
      ],
      [
        -50,
        22
      ],
      [
        -74,
        11
      ],
      [
        -37,
        87
      ],
      [
        -87,
        151
      ],
      [
        -37,
        55
      ],
      [
        -248,
        54
      ],
      [
        -111,
        32
      ],
      [
        -37,
        55
      ],
      [
        24,
        86
      ],
      [
        137,
        22
      ],
      [
        124,
        -11
      ],
      [
        247,
        -32
      ],
      [
        62,
        -33
      ],
      [
        50,
        -11
      ],
      [
        99,
        0
      ],
      [
        322,
        22
      ],
      [
        74,
        43
      ],
      [
        223,
        22
      ],
      [
        -210,
        76
      ],
      [
        -174,
        54
      ],
      [
        -148,
        33
      ],
      [
        -261,
        21
      ],
      [
        -123,
        0
      ],
      [
        -87,
        11
      ],
      [
        -297,
        -11
      ],
      [
        -75,
        22
      ],
      [
        -62,
        65
      ],
      [
        -74,
        152
      ],
      [
        -25,
        76
      ],
      [
        87,
        65
      ],
      [
        87,
        0
      ],
      [
        124,
        -11
      ],
      [
        49,
        -22
      ],
      [
        25,
        -43
      ],
      [
        -62,
        -76
      ],
      [
        25,
        -22
      ],
      [
        124,
        0
      ],
      [
        62,
        -21
      ],
      [
        61,
        0
      ],
      [
        124,
        21
      ],
      [
        174,
        11
      ],
      [
        186,
        -43
      ],
      [
        161,
        32
      ],
      [
        545,
        -21
      ],
      [
        74,
        0
      ],
      [
        124,
        -76
      ],
      [
        62,
        11
      ],
      [
        173,
        -44
      ],
      [
        99,
        -43
      ],
      [
        99,
        -22
      ],
      [
        174,
        11
      ],
      [
        124,
        33
      ],
      [
        99,
        10
      ],
      [
        223,
        -21
      ],
      [
        111,
        -33
      ],
      [
        99,
        11
      ],
      [
        87,
        43
      ],
      [
        310,
        33
      ],
      [
        198,
        -11
      ],
      [
        372,
        -76
      ],
      [
        86,
        -11
      ],
      [
        161,
        55
      ],
      [
        62,
        76
      ],
      [
        -12,
        86
      ],
      [
        49,
        22
      ],
      [
        38,
        -11
      ],
      [
        74,
        65
      ],
      [
        173,
        -21
      ],
      [
        37,
        43
      ],
      [
        25,
        76
      ],
      [
        124,
        11
      ],
      [
        87,
        -11
      ],
      [
        111,
        -54
      ],
      [
        0,
        -44
      ],
      [
        -124,
        -162
      ],
      [
        50,
        -76
      ],
      [
        74,
        10
      ],
      [
        99,
        -10
      ],
      [
        174,
        32
      ],
      [
        136,
        -108
      ],
      [
        149,
        0
      ],
      [
        210,
        97
      ],
      [
        62,
        11
      ],
      [
        75,
        -43
      ],
      [
        111,
        -98
      ],
      [
        99,
        -54
      ],
      [
        136,
        -33
      ],
      [
        124,
        -10
      ],
      [
        223,
        -87
      ],
      [
        186,
        0
      ],
      [
        74,
        -22
      ],
      [
        211,
        -76
      ],
      [
        198,
        44
      ],
      [
        112,
        32
      ],
      [
        49,
        65
      ],
      [
        -25,
        98
      ],
      [
        -12,
        97
      ],
      [
        25,
        44
      ],
      [
        62,
        11
      ],
      [
        235,
        -109
      ],
      [
        -37,
        119
      ],
      [
        -62,
        87
      ],
      [
        12,
        65
      ],
      [
        50,
        22
      ],
      [
        99,
        -33
      ],
      [
        112,
        -21
      ],
      [
        99,
        -44
      ],
      [
        198,
        -130
      ],
      [
        62,
        -130
      ],
      [
        124,
        -22
      ],
      [
        99,
        0
      ],
      [
        235,
        44
      ],
      [
        112,
        -11
      ],
      [
        86,
        22
      ],
      [
        38,
        -65
      ],
      [
        -100,
        -98
      ],
      [
        -24,
        -54
      ],
      [
        24,
        -22
      ],
      [
        100,
        33
      ],
      [
        161,
        -11
      ],
      [
        123,
        43
      ],
      [
        112,
        22
      ],
      [
        111,
        43
      ],
      [
        149,
        -11
      ],
      [
        87,
        -43
      ],
      [
        86,
        22
      ],
      [
        124,
        -11
      ],
      [
        360,
        162
      ],
      [
        198,
        0
      ],
      [
        124,
        44
      ],
      [
        185,
        11
      ],
      [
        149,
        54
      ],
      [
        248,
        0
      ],
      [
        124,
        32
      ],
      [
        235,
        33
      ],
      [
        149,
        43
      ],
      [
        285,
        98
      ],
      [
        123,
        65
      ],
      [
        124,
        141
      ],
      [
        75,
        141
      ],
      [
        86,
        184
      ],
      [
        -49,
        120
      ],
      [
        -74,
        108
      ],
      [
        -100,
        119
      ],
      [
        -24,
        152
      ],
      [
        12,
        141
      ],
      [
        -62,
        239
      ],
      [
        -74,
        163
      ],
      [
        -174,
        249
      ],
      [
        0,
        130
      ],
      [
        -24,
        109
      ],
      [
        -50,
        75
      ],
      [
        -25,
        55
      ],
      [
        75,
        32
      ],
      [
        111,
        22
      ],
      [
        273,
        -43
      ],
      [
        24,
        65
      ],
      [
        62,
        43
      ],
      [
        50,
        54
      ],
      [
        -25,
        76
      ],
      [
        -49,
        33
      ],
      [
        -75,
        76
      ],
      [
        37,
        54
      ],
      [
        50,
        0
      ],
      [
        37,
        65
      ],
      [
        -25,
        54
      ],
      [
        25,
        87
      ],
      [
        50,
        87
      ],
      [
        37,
        43
      ],
      [
        -62,
        54
      ],
      [
        -62,
        76
      ],
      [
        12,
        65
      ],
      [
        62,
        141
      ],
      [
        50,
        65
      ],
      [
        37,
        22
      ],
      [
        -12,
        22
      ],
      [
        -75,
        21
      ],
      [
        -62,
        0
      ],
      [
        -124,
        -32
      ],
      [
        -37,
        22
      ],
      [
        0,
        43
      ],
      [
        25,
        206
      ],
      [
        74,
        22
      ],
      [
        50,
        76
      ],
      [
        37,
        0
      ],
      [
        25,
        -22
      ],
      [
        12,
        -98
      ],
      [
        13,
        -21
      ],
      [
        0,
        -55
      ],
      [
        24,
        -10
      ],
      [
        25,
        32
      ],
      [
        50,
        11
      ],
      [
        49,
        -22
      ],
      [
        -12,
        119
      ],
      [
        -12,
        44
      ],
      [
        24,
        65
      ],
      [
        -24,
        87
      ],
      [
        12,
        32
      ],
      [
        62,
        65
      ],
      [
        49,
        0
      ],
      [
        112,
        -43
      ],
      [
        49,
        54
      ],
      [
        13,
        109
      ],
      [
        -37,
        32
      ],
      [
        0,
        33
      ],
      [
        24,
        21
      ],
      [
        25,
        76
      ],
      [
        112,
        0
      ],
      [
        49,
        11
      ],
      [
        -25,
        33
      ],
      [
        -12,
        43
      ],
      [
        99,
        33
      ],
      [
        124,
        -44
      ],
      [
        37,
        33
      ],
      [
        -12,
        43
      ],
      [
        -37,
        11
      ],
      [
        0,
        76
      ],
      [
        62,
        -22
      ],
      [
        37,
        54
      ],
      [
        -25,
        33
      ],
      [
        74,
        11
      ],
      [
        37,
        43
      ],
      [
        25,
        11
      ],
      [
        62,
        -11
      ],
      [
        25,
        54
      ],
      [
        -37,
        0
      ],
      [
        -50,
        33
      ],
      [
        -12,
        87
      ],
      [
        12,
        65
      ],
      [
        50,
        54
      ],
      [
        49,
        33
      ],
      [
        99,
        -22
      ],
      [
        75,
        0
      ],
      [
        25,
        -33
      ],
      [
        49,
        -11
      ],
      [
        0,
        44
      ],
      [
        -25,
        87
      ],
      [
        112,
        65
      ],
      [
        37,
        -11
      ],
      [
        49,
        11
      ],
      [
        -12,
        43
      ],
      [
        25,
        65
      ],
      [
        37,
        11
      ],
      [
        25,
        -54
      ],
      [
        25,
        -11
      ],
      [
        37,
        11
      ],
      [
        86,
        65
      ],
      [
        87,
        11
      ],
      [
        50,
        43
      ],
      [
        12,
        43
      ],
      [
        99,
        65
      ],
      [
        99,
        131
      ],
      [
        -12,
        32
      ],
      [
        12,
        22
      ],
      [
        211,
        87
      ],
      [
        99,
        10
      ],
      [
        161,
        55
      ],
      [
        99,
        65
      ],
      [
        62,
        32
      ],
      [
        62,
        76
      ],
      [
        62,
        11
      ],
      [
        161,
        54
      ],
      [
        124,
        76
      ],
      [
        161,
        65
      ],
      [
        74,
        -11
      ],
      [
        37,
        -21
      ],
      [
        13,
        -65
      ]
    ],
    [
      [
        42823,
        16756
      ],
      [
        12,
        -22
      ],
      [
        112,
        0
      ],
      [
        25,
        -76
      ],
      [
        -25,
        -21
      ],
      [
        -149,
        10
      ],
      [
        -49,
        33
      ],
      [
        -99,
        -33
      ],
      [
        -25,
        -21
      ],
      [
        -99,
        -44
      ],
      [
        -25,
        22
      ],
      [
        -12,
        54
      ],
      [
        37,
        54
      ],
      [
        111,
        55
      ],
      [
        161,
        11
      ],
      [
        25,
        -22
      ]
    ],
    [
      [
        42637,
        16810
      ],
      [
        -74,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -74,
        43
      ],
      [
        -13,
        33
      ],
      [
        38,
        43
      ],
      [
        148,
        -22
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        41101,
        16875
      ],
      [
        -62,
        -11
      ],
      [
        -12,
        33
      ],
      [
        37,
        32
      ],
      [
        37,
        -54
      ]
    ],
    [
      [
        40383,
        16821
      ],
      [
        -13,
        22
      ],
      [
        37,
        65
      ],
      [
        75,
        32
      ],
      [
        -25,
        -65
      ],
      [
        -74,
        -54
      ]
    ],
    [
      [
        41064,
        17135
      ],
      [
        12,
        -10
      ],
      [
        161,
        21
      ],
      [
        38,
        -43
      ],
      [
        62,
        0
      ],
      [
        -137,
        -87
      ],
      [
        -37,
        43
      ],
      [
        -12,
        44
      ],
      [
        -112,
        -11
      ],
      [
        -37,
        -22
      ],
      [
        -87,
        -11
      ],
      [
        -37,
        55
      ],
      [
        62,
        0
      ],
      [
        50,
        32
      ],
      [
        12,
        44
      ],
      [
        25,
        -11
      ],
      [
        37,
        -44
      ]
    ],
    [
      [
        41485,
        17211
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        33
      ],
      [
        -13,
        33
      ],
      [
        62,
        0
      ],
      [
        25,
        -11
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        41683,
        17298
      ],
      [
        -74,
        -32
      ],
      [
        -49,
        43
      ],
      [
        49,
        22
      ],
      [
        62,
        -11
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        41981,
        17537
      ],
      [
        37,
        -11
      ],
      [
        37,
        11
      ],
      [
        25,
        -11
      ],
      [
        12,
        -54
      ],
      [
        -62,
        10
      ],
      [
        -49,
        -43
      ],
      [
        -62,
        11
      ],
      [
        -13,
        -76
      ],
      [
        -49,
        33
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        -55
      ],
      [
        -25,
        -10
      ],
      [
        -62,
        21
      ],
      [
        -62,
        33
      ],
      [
        75,
        76
      ],
      [
        12,
        21
      ],
      [
        99,
        44
      ],
      [
        50,
        -11
      ],
      [
        99,
        22
      ]
    ],
    [
      [
        43319,
        17927
      ],
      [
        -13,
        -11
      ],
      [
        -25,
        22
      ],
      [
        0,
        22
      ],
      [
        25,
        21
      ],
      [
        25,
        -32
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        42947,
        17970
      ],
      [
        -50,
        -21
      ],
      [
        -24,
        65
      ],
      [
        -25,
        32
      ],
      [
        25,
        22
      ],
      [
        247,
        -32
      ],
      [
        -24,
        -11
      ],
      [
        -112,
        -22
      ],
      [
        -37,
        -33
      ]
    ],
    [
      [
        46192,
        18404
      ],
      [
        75,
        -11
      ],
      [
        37,
        -21
      ],
      [
        12,
        -33
      ],
      [
        50,
        0
      ],
      [
        12,
        -21
      ],
      [
        0,
        -44
      ],
      [
        -74,
        54
      ],
      [
        -112,
        0
      ],
      [
        -24,
        44
      ],
      [
        -50,
        -22
      ],
      [
        0,
        54
      ],
      [
        37,
        -11
      ],
      [
        37,
        11
      ]
    ],
    [
      [
        85758,
        25573
      ],
      [
        -13,
        -11
      ],
      [
        -25,
        65
      ],
      [
        0,
        54
      ],
      [
        38,
        0
      ],
      [
        37,
        -10
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        85733,
        25540
      ],
      [
        25,
        -10
      ],
      [
        86,
        86
      ],
      [
        25,
        11
      ],
      [
        0,
        -65
      ],
      [
        12,
        -32
      ],
      [
        -62,
        0
      ],
      [
        -12,
        -33
      ],
      [
        50,
        -54
      ],
      [
        37,
        0
      ],
      [
        62,
        21
      ],
      [
        49,
        44
      ],
      [
        25,
        11
      ],
      [
        50,
        0
      ],
      [
        37,
        54
      ],
      [
        62,
        -22
      ],
      [
        24,
        -76
      ],
      [
        -24,
        -76
      ],
      [
        -37,
        -21
      ],
      [
        12,
        -33
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        44
      ],
      [
        -25,
        11
      ],
      [
        -86,
        0
      ],
      [
        0,
        -22
      ],
      [
        -38,
        -33
      ],
      [
        -24,
        -10
      ],
      [
        37,
        -55
      ],
      [
        49,
        -32
      ],
      [
        25,
        0
      ],
      [
        0,
        43
      ],
      [
        37,
        11
      ],
      [
        50,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -32
      ],
      [
        -74,
        11
      ],
      [
        -38,
        32
      ],
      [
        0,
        22
      ],
      [
        -24,
        0
      ],
      [
        -50,
        -33
      ],
      [
        -37,
        22
      ],
      [
        -50,
        43
      ],
      [
        -24,
        11
      ],
      [
        -38,
        0
      ],
      [
        -24,
        -76
      ],
      [
        -38,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -24,
        11
      ],
      [
        -13,
        21
      ],
      [
        13,
        33
      ],
      [
        0,
        32
      ],
      [
        24,
        66
      ],
      [
        0,
        32
      ],
      [
        -24,
        33
      ],
      [
        12,
        43
      ],
      [
        -12,
        54
      ],
      [
        24,
        11
      ],
      [
        -37,
        65
      ],
      [
        25,
        87
      ],
      [
        0,
        54
      ],
      [
        25,
        43
      ],
      [
        12,
        55
      ],
      [
        37,
        21
      ],
      [
        13,
        -21
      ],
      [
        -13,
        -44
      ],
      [
        25,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        12,
        -44
      ],
      [
        50,
        -11
      ]
    ],
    [
      [
        79762,
        27200
      ],
      [
        -49,
        11
      ],
      [
        -13,
        32
      ],
      [
        25,
        33
      ],
      [
        37,
        -76
      ]
    ],
    [
      [
        40692,
        66861
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        11
      ],
      [
        -13,
        32
      ],
      [
        0,
        22
      ],
      [
        25,
        43
      ],
      [
        50,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -13,
        -10
      ]
    ],
    [
      [
        40680,
        67197
      ],
      [
        0,
        -22
      ],
      [
        -37,
        33
      ],
      [
        0,
        76
      ],
      [
        37,
        -33
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        116590,
        22037
      ],
      [
        -13,
        0
      ],
      [
        13,
        131
      ],
      [
        24,
        21
      ],
      [
        0,
        -65
      ],
      [
        -24,
        -87
      ]
    ],
    [
      [
        112626,
        29108
      ],
      [
        -13,
        -65
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        44
      ],
      [
        25,
        11
      ],
      [
        12,
        21
      ],
      [
        0,
        33
      ],
      [
        37,
        22
      ],
      [
        0,
        -33
      ],
      [
        13,
        -33
      ]
    ],
    [
      [
        112650,
        29206
      ],
      [
        -24,
        0
      ],
      [
        -13,
        33
      ],
      [
        0,
        43
      ],
      [
        13,
        22
      ],
      [
        12,
        -22
      ],
      [
        12,
        -76
      ]
    ],
    [
      [
        112886,
        29531
      ],
      [
        -25,
        0
      ],
      [
        0,
        33
      ],
      [
        -12,
        11
      ],
      [
        24,
        32
      ],
      [
        25,
        -10
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -22
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        111833,
        30735
      ],
      [
        37,
        0
      ],
      [
        37,
        11
      ],
      [
        50,
        -54
      ],
      [
        37,
        0
      ],
      [
        12,
        -33
      ],
      [
        62,
        -32
      ],
      [
        25,
        -44
      ],
      [
        99,
        -54
      ],
      [
        74,
        -32
      ],
      [
        87,
        21
      ],
      [
        50,
        33
      ],
      [
        37,
        -22
      ],
      [
        12,
        33
      ],
      [
        25,
        32
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        50,
        22
      ],
      [
        24,
        0
      ],
      [
        50,
        -22
      ],
      [
        49,
        98
      ],
      [
        87,
        -22
      ],
      [
        37,
        54
      ],
      [
        25,
        0
      ],
      [
        62,
        -43
      ],
      [
        25,
        -54
      ],
      [
        0,
        -326
      ],
      [
        0,
        -358
      ],
      [
        12,
        -21
      ],
      [
        0,
        -120
      ],
      [
        -12,
        0
      ],
      [
        -13,
        33
      ],
      [
        13,
        22
      ],
      [
        -13,
        43
      ],
      [
        -24,
        22
      ],
      [
        -25,
        -22
      ],
      [
        -13,
        -43
      ],
      [
        -24,
        -55
      ],
      [
        0,
        -108
      ],
      [
        -38,
        -141
      ],
      [
        0,
        -98
      ],
      [
        25,
        -86
      ],
      [
        0,
        -120
      ],
      [
        -12,
        -21
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        65
      ],
      [
        -12,
        54
      ],
      [
        12,
        33
      ],
      [
        25,
        -22
      ],
      [
        12,
        22
      ],
      [
        0,
        32
      ],
      [
        -37,
        33
      ],
      [
        -37,
        11
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -76
      ],
      [
        -38,
        -22
      ],
      [
        -12,
        87
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -24,
        -43
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -22
      ],
      [
        -62,
        65
      ],
      [
        0,
        -43
      ],
      [
        25,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        -13,
        -76
      ],
      [
        -37,
        -76
      ],
      [
        -49,
        11
      ],
      [
        -62,
        55
      ],
      [
        -124,
        0
      ],
      [
        -50,
        -22
      ],
      [
        0,
        65
      ],
      [
        -12,
        43
      ],
      [
        37,
        11
      ],
      [
        37,
        0
      ],
      [
        0,
        22
      ],
      [
        -86,
        32
      ],
      [
        -25,
        -10
      ],
      [
        -25,
        32
      ],
      [
        -74,
        152
      ],
      [
        -37,
        43
      ],
      [
        -75,
        239
      ],
      [
        -12,
        54
      ],
      [
        -13,
        141
      ],
      [
        62,
        -65
      ],
      [
        25,
        -98
      ],
      [
        25,
        65
      ],
      [
        0,
        22
      ],
      [
        -62,
        76
      ],
      [
        -12,
        22
      ],
      [
        -25,
        0
      ],
      [
        12,
        54
      ],
      [
        -12,
        54
      ],
      [
        -62,
        120
      ],
      [
        -50,
        119
      ],
      [
        -49,
        141
      ],
      [
        0,
        43
      ],
      [
        -25,
        98
      ],
      [
        -12,
        65
      ],
      [
        0,
        65
      ],
      [
        12,
        119
      ],
      [
        12,
        76
      ],
      [
        25,
        -32
      ],
      [
        87,
        -44
      ]
    ],
    [
      [
        112923,
        30909
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        43
      ],
      [
        37,
        11
      ]
    ],
    [
      [
        111734,
        30909
      ],
      [
        -25,
        11
      ],
      [
        25,
        32
      ],
      [
        12,
        0
      ],
      [
        -12,
        -43
      ]
    ],
    [
      [
        112960,
        31039
      ],
      [
        50,
        -87
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        0
      ],
      [
        0,
        32
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -37,
        33
      ],
      [
        12,
        32
      ],
      [
        50,
        0
      ],
      [
        49,
        33
      ]
    ],
    [
      [
        112849,
        31375
      ],
      [
        62,
        -108
      ],
      [
        37,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        25,
        -32
      ],
      [
        -37,
        -55
      ],
      [
        -37,
        -21
      ],
      [
        -37,
        54
      ],
      [
        -38,
        108
      ],
      [
        -12,
        65
      ],
      [
        -25,
        0
      ],
      [
        -12,
        22
      ],
      [
        25,
        22
      ],
      [
        37,
        65
      ],
      [
        25,
        -22
      ]
    ],
    [
      [
        111449,
        31158
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        44
      ],
      [
        0,
        43
      ],
      [
        -12,
        54
      ],
      [
        12,
        44
      ],
      [
        0,
        86
      ],
      [
        25,
        22
      ],
      [
        0,
        44
      ],
      [
        25,
        10
      ],
      [
        24,
        -43
      ],
      [
        13,
        -87
      ],
      [
        0,
        -54
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -22
      ]
    ],
    [
      [
        111920,
        32167
      ],
      [
        -13,
        -11
      ],
      [
        -49,
        -11
      ],
      [
        24,
        44
      ],
      [
        38,
        -22
      ]
    ],
    [
      [
        111982,
        32254
      ],
      [
        -50,
        -44
      ],
      [
        -25,
        22
      ],
      [
        0,
        32
      ],
      [
        13,
        11
      ],
      [
        37,
        0
      ],
      [
        25,
        -21
      ]
    ],
    [
      [
        109269,
        33891
      ],
      [
        74,
        -21
      ],
      [
        37,
        32
      ],
      [
        37,
        -22
      ],
      [
        25,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -62,
        21
      ],
      [
        -50,
        -10
      ],
      [
        -24,
        -33
      ],
      [
        0,
        -54
      ],
      [
        -50,
        -33
      ],
      [
        -25,
        44
      ],
      [
        -62,
        21
      ],
      [
        -24,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -38,
        -11
      ],
      [
        -62,
        11
      ],
      [
        -74,
        87
      ],
      [
        12,
        54
      ],
      [
        25,
        32
      ],
      [
        161,
        55
      ],
      [
        75,
        43
      ],
      [
        86,
        -11
      ],
      [
        25,
        -22
      ],
      [
        -12,
        -54
      ]
    ],
    [
      [
        114756,
        39075
      ],
      [
        -37,
        -173
      ],
      [
        -12,
        0
      ],
      [
        0,
        130
      ],
      [
        12,
        65
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        114719,
        39151
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        65
      ],
      [
        0,
        109
      ],
      [
        38,
        11
      ],
      [
        -25,
        -98
      ],
      [
        12,
        -76
      ]
    ],
    [
      [
        100870,
        39943
      ],
      [
        -12,
        -33
      ],
      [
        -62,
        195
      ],
      [
        -25,
        141
      ],
      [
        25,
        22
      ],
      [
        37,
        -184
      ],
      [
        12,
        -44
      ],
      [
        0,
        -32
      ],
      [
        25,
        -65
      ]
    ],
    [
      [
        114595,
        40127
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        22
      ],
      [
        -12,
        119
      ],
      [
        25,
        120
      ],
      [
        0,
        97
      ],
      [
        49,
        76
      ],
      [
        13,
        44
      ],
      [
        0,
        54
      ],
      [
        -13,
        54
      ],
      [
        -12,
        11
      ],
      [
        12,
        32
      ],
      [
        25,
        22
      ],
      [
        13,
        -119
      ],
      [
        24,
        -33
      ],
      [
        -99,
        -444
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        113926,
        41537
      ],
      [
        38,
        -22
      ],
      [
        -13,
        -43
      ],
      [
        25,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        21
      ],
      [
        -50,
        130
      ],
      [
        13,
        44
      ],
      [
        24,
        -22
      ]
    ],
    [
      [
        113716,
        42275
      ],
      [
        -25,
        0
      ],
      [
        25,
        54
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        113505,
        42350
      ],
      [
        -12,
        -21
      ],
      [
        0,
        97
      ],
      [
        12,
        11
      ],
      [
        0,
        -87
      ]
    ],
    [
      [
        101651,
        43229
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        11
      ],
      [
        0,
        32
      ],
      [
        37,
        87
      ],
      [
        13,
        -33
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        113208,
        43543
      ],
      [
        -25,
        -10
      ],
      [
        -12,
        10
      ],
      [
        12,
        76
      ],
      [
        25,
        -76
      ]
    ],
    [
      [
        112254,
        44823
      ],
      [
        0,
        -54
      ],
      [
        25,
        -54
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        76
      ],
      [
        -25,
        44
      ],
      [
        0,
        21
      ],
      [
        25,
        0
      ],
      [
        37,
        11
      ]
    ],
    [
      [
        109900,
        45528
      ],
      [
        -12,
        11
      ],
      [
        12,
        22
      ],
      [
        13,
        43
      ],
      [
        25,
        -33
      ],
      [
        12,
        -32
      ],
      [
        -50,
        -11
      ]
    ],
    [
      [
        109925,
        45864
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -11
      ],
      [
        0,
        76
      ],
      [
        25,
        54
      ],
      [
        25,
        43
      ],
      [
        49,
        11
      ],
      [
        50,
        33
      ],
      [
        12,
        -11
      ],
      [
        25,
        -65
      ],
      [
        -49,
        -11
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        109095,
        46363
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        32
      ],
      [
        0,
        33
      ],
      [
        -12,
        0
      ],
      [
        0,
        32
      ],
      [
        12,
        11
      ],
      [
        25,
        -11
      ],
      [
        0,
        -43
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        108922,
        46450
      ],
      [
        -25,
        0
      ],
      [
        -12,
        32
      ],
      [
        12,
        22
      ],
      [
        25,
        11
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        104797,
        46591
      ],
      [
        -25,
        -11
      ],
      [
        0,
        22
      ],
      [
        -12,
        32
      ],
      [
        0,
        22
      ],
      [
        12,
        22
      ],
      [
        25,
        -55
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        104995,
        47111
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        33
      ],
      [
        12,
        65
      ],
      [
        13,
        21
      ],
      [
        12,
        -10
      ],
      [
        0,
        -66
      ]
    ],
    [
      [
        108959,
        47589
      ],
      [
        12,
        -22
      ],
      [
        25,
        0
      ],
      [
        13,
        54
      ],
      [
        12,
        0
      ],
      [
        0,
        -21
      ],
      [
        12,
        -22
      ],
      [
        -24,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        -13,
        -76
      ],
      [
        0,
        -33
      ],
      [
        13,
        -21
      ],
      [
        37,
        -22
      ],
      [
        12,
        11
      ],
      [
        13,
        -11
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        11
      ],
      [
        -50,
        0
      ],
      [
        -99,
        32
      ],
      [
        0,
        11
      ],
      [
        25,
        54
      ],
      [
        0,
        163
      ],
      [
        37,
        44
      ],
      [
        25,
        43
      ],
      [
        25,
        32
      ],
      [
        12,
        -10
      ],
      [
        0,
        -76
      ]
    ],
    [
      [
        108798,
        47578
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        11
      ],
      [
        0,
        43
      ],
      [
        12,
        11
      ],
      [
        13,
        43
      ],
      [
        24,
        -21
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        106816,
        48923
      ],
      [
        25,
        -22
      ],
      [
        12,
        -22
      ],
      [
        0,
        -21
      ],
      [
        13,
        -22
      ],
      [
        -38,
        -11
      ],
      [
        -62,
        33
      ],
      [
        -74,
        -33
      ],
      [
        -12,
        0
      ],
      [
        -13,
        22
      ],
      [
        13,
        76
      ],
      [
        25,
        -11
      ],
      [
        12,
        21
      ],
      [
        0,
        76
      ],
      [
        -12,
        33
      ],
      [
        37,
        76
      ],
      [
        24,
        11
      ],
      [
        13,
        -44
      ],
      [
        0,
        -65
      ],
      [
        25,
        -43
      ],
      [
        12,
        -54
      ]
    ],
    [
      [
        106866,
        49107
      ],
      [
        49,
        0
      ],
      [
        50,
        43
      ],
      [
        24,
        -21
      ],
      [
        13,
        0
      ],
      [
        37,
        54
      ],
      [
        37,
        11
      ],
      [
        13,
        32
      ],
      [
        12,
        -43
      ],
      [
        49,
        -33
      ],
      [
        25,
        -76
      ],
      [
        -25,
        -97
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -76
      ],
      [
        -124,
        -141
      ],
      [
        -99,
        119
      ],
      [
        -50,
        76
      ],
      [
        -37,
        109
      ],
      [
        0,
        86
      ],
      [
        -12,
        55
      ],
      [
        0,
        21
      ],
      [
        25,
        0
      ],
      [
        24,
        -54
      ],
      [
        38,
        -65
      ]
    ],
    [
      [
        108922,
        49107
      ],
      [
        -13,
        11
      ],
      [
        25,
        97
      ],
      [
        25,
        11
      ],
      [
        0,
        22
      ],
      [
        12,
        33
      ],
      [
        0,
        43
      ],
      [
        13,
        11
      ],
      [
        -13,
        -109
      ],
      [
        -49,
        -119
      ]
    ],
    [
      [
        107547,
        49150
      ],
      [
        -13,
        -10
      ],
      [
        -24,
        97
      ],
      [
        12,
        33
      ],
      [
        -12,
        54
      ],
      [
        12,
        0
      ],
      [
        12,
        43
      ],
      [
        13,
        -21
      ],
      [
        0,
        -65
      ],
      [
        12,
        -44
      ],
      [
        -12,
        -87
      ]
    ],
    [
      [
        111189,
        48749
      ],
      [
        -25,
        -141
      ],
      [
        0,
        -76
      ],
      [
        25,
        -43
      ],
      [
        25,
        -22
      ],
      [
        12,
        -65
      ],
      [
        37,
        -87
      ],
      [
        0,
        -54
      ],
      [
        25,
        -76
      ],
      [
        12,
        -152
      ],
      [
        13,
        -130
      ],
      [
        12,
        -87
      ],
      [
        -12,
        -184
      ],
      [
        12,
        -76
      ],
      [
        25,
        -65
      ],
      [
        12,
        -130
      ],
      [
        25,
        -109
      ],
      [
        25,
        -32
      ],
      [
        49,
        -43
      ],
      [
        50,
        43
      ],
      [
        25,
        65
      ],
      [
        49,
        11
      ],
      [
        50,
        32
      ],
      [
        37,
        -86
      ],
      [
        25,
        -76
      ],
      [
        86,
        -120
      ],
      [
        50,
        -76
      ],
      [
        37,
        -32
      ],
      [
        37,
        -54
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        12,
        -65
      ],
      [
        13,
        -87
      ],
      [
        -13,
        -86
      ],
      [
        25,
        -141
      ],
      [
        12,
        -109
      ],
      [
        25,
        -119
      ],
      [
        0,
        -109
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -65
      ],
      [
        25,
        -76
      ],
      [
        24,
        -54
      ],
      [
        62,
        -163
      ],
      [
        37,
        -22
      ],
      [
        25,
        0
      ],
      [
        -12,
        -97
      ],
      [
        62,
        -195
      ],
      [
        25,
        -152
      ],
      [
        -25,
        -217
      ],
      [
        -13,
        -130
      ],
      [
        0,
        -55
      ],
      [
        62,
        -151
      ],
      [
        37,
        -22
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -108
      ],
      [
        37,
        -87
      ],
      [
        37,
        -65
      ],
      [
        25,
        -33
      ],
      [
        37,
        -32
      ],
      [
        50,
        -33
      ],
      [
        62,
        -11
      ],
      [
        37,
        -43
      ],
      [
        12,
        -43
      ],
      [
        50,
        -11
      ],
      [
        12,
        11
      ],
      [
        37,
        10
      ],
      [
        25,
        -54
      ],
      [
        25,
        -97
      ],
      [
        62,
        -87
      ],
      [
        37,
        -22
      ],
      [
        12,
        -43
      ],
      [
        62,
        -22
      ],
      [
        38,
        -33
      ],
      [
        62,
        -86
      ],
      [
        49,
        -11
      ],
      [
        25,
        -22
      ],
      [
        62,
        -87
      ],
      [
        25,
        -54
      ],
      [
        12,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -65
      ],
      [
        37,
        -98
      ],
      [
        37,
        -65
      ],
      [
        50,
        -76
      ],
      [
        49,
        -97
      ],
      [
        13,
        -87
      ],
      [
        12,
        -32
      ],
      [
        25,
        -109
      ],
      [
        37,
        -65
      ],
      [
        0,
        -108
      ],
      [
        50,
        -315
      ],
      [
        37,
        -108
      ],
      [
        25,
        10
      ],
      [
        12,
        22
      ],
      [
        37,
        -76
      ],
      [
        25,
        -11
      ],
      [
        -12,
        131
      ],
      [
        12,
        86
      ],
      [
        25,
        11
      ],
      [
        25,
        -65
      ],
      [
        37,
        -65
      ],
      [
        62,
        -65
      ],
      [
        37,
        -54
      ],
      [
        12,
        0
      ],
      [
        0,
        108
      ],
      [
        25,
        11
      ],
      [
        12,
        -33
      ],
      [
        25,
        -97
      ],
      [
        12,
        -206
      ],
      [
        0,
        -174
      ],
      [
        25,
        -173
      ],
      [
        50,
        -87
      ],
      [
        49,
        -119
      ],
      [
        38,
        -22
      ],
      [
        86,
        -119
      ],
      [
        25,
        -11
      ],
      [
        37,
        0
      ],
      [
        50,
        -54
      ],
      [
        24,
        -55
      ],
      [
        50,
        -184
      ],
      [
        25,
        -54
      ],
      [
        87,
        -87
      ],
      [
        24,
        -43
      ],
      [
        37,
        -174
      ],
      [
        38,
        -76
      ],
      [
        49,
        -43
      ],
      [
        37,
        -109
      ],
      [
        0,
        -151
      ],
      [
        37,
        -120
      ],
      [
        38,
        -32
      ],
      [
        12,
        -22
      ],
      [
        -25,
        -217
      ],
      [
        25,
        -423
      ],
      [
        -12,
        -130
      ],
      [
        24,
        -130
      ],
      [
        62,
        -228
      ],
      [
        25,
        -173
      ],
      [
        50,
        -120
      ],
      [
        -13,
        -184
      ],
      [
        25,
        -87
      ],
      [
        -12,
        -119
      ],
      [
        -50,
        -119
      ],
      [
        -37,
        -152
      ],
      [
        0,
        -130
      ],
      [
        -25,
        -239
      ],
      [
        -25,
        -173
      ],
      [
        -62,
        -250
      ],
      [
        0,
        -98
      ],
      [
        13,
        -119
      ],
      [
        -13,
        -108
      ],
      [
        -12,
        -76
      ],
      [
        -12,
        -141
      ],
      [
        -50,
        -228
      ],
      [
        -87,
        -152
      ],
      [
        0,
        -130
      ],
      [
        -24,
        -119
      ],
      [
        -75,
        -109
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -43
      ],
      [
        -62,
        -44
      ],
      [
        -49,
        -54
      ],
      [
        -50,
        -119
      ],
      [
        -49,
        -130
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -76
      ],
      [
        -49,
        -43
      ],
      [
        12,
        -76
      ],
      [
        -12,
        -87
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        0
      ],
      [
        12,
        -33
      ],
      [
        -37,
        -76
      ],
      [
        -50,
        -87
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        -12,
        -152
      ],
      [
        -13,
        -86
      ],
      [
        13,
        -65
      ],
      [
        -13,
        -22
      ],
      [
        -12,
        11
      ],
      [
        -25,
        -44
      ],
      [
        13,
        -54
      ],
      [
        -50,
        -32
      ],
      [
        -62,
        -228
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -98
      ],
      [
        -24,
        -173
      ],
      [
        -13,
        -163
      ],
      [
        -12,
        -109
      ],
      [
        -25,
        -108
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -141
      ],
      [
        12,
        -119
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -55
      ],
      [
        -13,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -43
      ],
      [
        -50,
        -76
      ],
      [
        -24,
        -22
      ],
      [
        -62,
        -21
      ],
      [
        -124,
        10
      ],
      [
        -236,
        -32
      ],
      [
        -49,
        -11
      ],
      [
        -87,
        -54
      ],
      [
        -87,
        -76
      ],
      [
        -74,
        -98
      ],
      [
        -186,
        -282
      ],
      [
        -148,
        -21
      ],
      [
        -50,
        0
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -44
      ],
      [
        25,
        -32
      ],
      [
        12,
        -33
      ],
      [
        38,
        44
      ],
      [
        12,
        -11
      ],
      [
        12,
        -87
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -10
      ],
      [
        -12,
        10
      ],
      [
        -62,
        163
      ],
      [
        -37,
        22
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        141
      ],
      [
        -25,
        11
      ],
      [
        -37,
        0
      ],
      [
        -75,
        76
      ],
      [
        25,
        76
      ],
      [
        25,
        11
      ],
      [
        0,
        54
      ],
      [
        -12,
        43
      ],
      [
        -38,
        11
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        -32
      ],
      [
        -13,
        -65
      ],
      [
        -86,
        -65
      ],
      [
        -37,
        32
      ],
      [
        -38,
        65
      ],
      [
        62,
        0
      ],
      [
        38,
        55
      ],
      [
        37,
        97
      ],
      [
        -25,
        54
      ],
      [
        -25,
        33
      ],
      [
        -37,
        33
      ],
      [
        -112,
        -109
      ],
      [
        -49,
        -32
      ],
      [
        37,
        -22
      ],
      [
        25,
        0
      ],
      [
        25,
        -33
      ],
      [
        -38,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -32
      ],
      [
        -87,
        -65
      ],
      [
        -99,
        -152
      ],
      [
        -37,
        -44
      ],
      [
        -49,
        -32
      ],
      [
        -75,
        43
      ],
      [
        -37,
        11
      ],
      [
        -49,
        54
      ],
      [
        -87,
        44
      ],
      [
        -74,
        86
      ],
      [
        -50,
        33
      ],
      [
        -37,
        11
      ],
      [
        -62,
        -11
      ],
      [
        -87,
        65
      ],
      [
        -74,
        11
      ],
      [
        -37,
        -76
      ],
      [
        -62,
        22
      ],
      [
        -75,
        119
      ],
      [
        -61,
        54
      ],
      [
        -137,
        33
      ],
      [
        -86,
        86
      ],
      [
        -62,
        152
      ],
      [
        -112,
        185
      ],
      [
        -49,
        130
      ],
      [
        0,
        54
      ],
      [
        12,
        98
      ],
      [
        37,
        151
      ],
      [
        -49,
        174
      ],
      [
        -62,
        173
      ],
      [
        -25,
        55
      ],
      [
        -74,
        119
      ],
      [
        -75,
        87
      ],
      [
        -25,
        43
      ],
      [
        0,
        22
      ],
      [
        38,
        -11
      ],
      [
        12,
        32
      ],
      [
        25,
        11
      ],
      [
        12,
        -43
      ],
      [
        25,
        -11
      ],
      [
        0,
        76
      ],
      [
        12,
        43
      ],
      [
        -12,
        33
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        0
      ],
      [
        -75,
        -65
      ],
      [
        -37,
        0
      ],
      [
        -74,
        22
      ],
      [
        25,
        76
      ],
      [
        49,
        108
      ],
      [
        37,
        185
      ],
      [
        0,
        163
      ],
      [
        -24,
        65
      ],
      [
        -62,
        141
      ],
      [
        -25,
        76
      ],
      [
        -37,
        86
      ],
      [
        -25,
        -97
      ],
      [
        -25,
        -76
      ],
      [
        -25,
        -174
      ],
      [
        -62,
        -260
      ],
      [
        -37,
        0
      ],
      [
        -37,
        11
      ],
      [
        -62,
        -33
      ],
      [
        -49,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        11
      ],
      [
        50,
        195
      ],
      [
        123,
        0
      ],
      [
        25,
        98
      ],
      [
        13,
        108
      ],
      [
        -13,
        65
      ],
      [
        0,
        65
      ],
      [
        13,
        76
      ],
      [
        0,
        65
      ],
      [
        49,
        184
      ],
      [
        50,
        98
      ],
      [
        49,
        76
      ],
      [
        0,
        76
      ],
      [
        -25,
        87
      ],
      [
        0,
        76
      ],
      [
        25,
        21
      ],
      [
        25,
        44
      ],
      [
        -25,
        206
      ],
      [
        -49,
        119
      ],
      [
        0,
        -152
      ],
      [
        -38,
        -97
      ],
      [
        -49,
        -76
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -141
      ],
      [
        -37,
        -131
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        -21
      ],
      [
        -99,
        -87
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        -99,
        -249
      ],
      [
        -50,
        -76
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -21
      ],
      [
        25,
        -65
      ],
      [
        12,
        -109
      ],
      [
        0,
        -32
      ],
      [
        -24,
        21
      ],
      [
        -38,
        54
      ],
      [
        -37,
        -21
      ],
      [
        -12,
        -22
      ],
      [
        -62,
        109
      ],
      [
        -50,
        75
      ],
      [
        -37,
        44
      ],
      [
        -37,
        -11
      ],
      [
        0,
        33
      ],
      [
        37,
        32
      ],
      [
        62,
        -76
      ],
      [
        12,
        11
      ],
      [
        -49,
        249
      ],
      [
        0,
        33
      ],
      [
        -25,
        108
      ],
      [
        -12,
        33
      ],
      [
        -99,
        173
      ],
      [
        -25,
        120
      ],
      [
        -12,
        76
      ],
      [
        -25,
        43
      ],
      [
        -37,
        43
      ],
      [
        -112,
        11
      ],
      [
        -37,
        120
      ],
      [
        -25,
        141
      ],
      [
        37,
        10
      ],
      [
        13,
        44
      ],
      [
        -13,
        76
      ],
      [
        -99,
        76
      ],
      [
        -49,
        97
      ],
      [
        -38,
        33
      ],
      [
        -49,
        21
      ],
      [
        -50,
        -10
      ],
      [
        -62,
        10
      ],
      [
        -161,
        141
      ],
      [
        -37,
        0
      ],
      [
        -111,
        -43
      ],
      [
        -37,
        11
      ],
      [
        -161,
        195
      ],
      [
        -124,
        87
      ],
      [
        -37,
        22
      ],
      [
        -38,
        10
      ],
      [
        -49,
        -21
      ],
      [
        -25,
        -22
      ],
      [
        -62,
        -22
      ],
      [
        -223,
        11
      ],
      [
        -186,
        -21
      ],
      [
        -136,
        -22
      ],
      [
        -87,
        -33
      ],
      [
        -136,
        -108
      ],
      [
        -161,
        -119
      ],
      [
        -136,
        -55
      ],
      [
        -124,
        -65
      ],
      [
        -74,
        -21
      ],
      [
        -112,
        -11
      ],
      [
        -223,
        32
      ],
      [
        -74,
        -21
      ],
      [
        -112,
        -131
      ],
      [
        -37,
        -32
      ],
      [
        -74,
        -33
      ],
      [
        -174,
        -173
      ],
      [
        -74,
        -33
      ],
      [
        -62,
        -11
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        -76
      ],
      [
        -62,
        -195
      ],
      [
        -37,
        -98
      ],
      [
        -75,
        -152
      ],
      [
        -49,
        -43
      ],
      [
        -50,
        0
      ],
      [
        -49,
        -43
      ],
      [
        -50,
        54
      ],
      [
        -37,
        11
      ],
      [
        -62,
        -11
      ],
      [
        -210,
        -65
      ],
      [
        -38,
        76
      ],
      [
        -37,
        10
      ],
      [
        -74,
        0
      ],
      [
        -112,
        22
      ],
      [
        -198,
        -32
      ],
      [
        -99,
        -22
      ],
      [
        -37,
        -33
      ],
      [
        -74,
        22
      ],
      [
        -124,
        -32
      ],
      [
        -50,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -62,
        -163
      ],
      [
        -74,
        -54
      ],
      [
        -124,
        -22
      ],
      [
        -124,
        -163
      ],
      [
        -136,
        -151
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        -33
      ],
      [
        -74,
        -11
      ],
      [
        -25,
        -11
      ],
      [
        -148,
        33
      ],
      [
        -99,
        11
      ],
      [
        -124,
        22
      ],
      [
        -99,
        75
      ],
      [
        -75,
        44
      ],
      [
        -99,
        173
      ],
      [
        -49,
        55
      ],
      [
        -99,
        76
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -50,
        54
      ],
      [
        0,
        76
      ],
      [
        -12,
        54
      ],
      [
        0,
        152
      ],
      [
        12,
        184
      ],
      [
        38,
        -43
      ],
      [
        24,
        -43
      ],
      [
        62,
        10
      ],
      [
        50,
        66
      ],
      [
        37,
        97
      ],
      [
        25,
        109
      ],
      [
        0,
        119
      ],
      [
        -25,
        217
      ],
      [
        12,
        43
      ],
      [
        25,
        11
      ],
      [
        0,
        108
      ],
      [
        13,
        326
      ],
      [
        -13,
        119
      ],
      [
        -86,
        239
      ],
      [
        -62,
        217
      ],
      [
        -38,
        97
      ],
      [
        -37,
        152
      ],
      [
        -37,
        325
      ],
      [
        0,
        380
      ],
      [
        -37,
        184
      ],
      [
        -74,
        163
      ],
      [
        -13,
        65
      ],
      [
        0,
        65
      ],
      [
        -25,
        76
      ],
      [
        -62,
        163
      ],
      [
        -61,
        130
      ],
      [
        -13,
        65
      ],
      [
        -12,
        271
      ],
      [
        -25,
        119
      ],
      [
        -111,
        315
      ],
      [
        -124,
        271
      ],
      [
        -38,
        109
      ],
      [
        13,
        21
      ],
      [
        25,
        -21
      ],
      [
        0,
        97
      ],
      [
        12,
        -11
      ],
      [
        12,
        -65
      ],
      [
        50,
        -141
      ],
      [
        12,
        -76
      ],
      [
        50,
        -32
      ],
      [
        37,
        65
      ],
      [
        0,
        108
      ],
      [
        -25,
        44
      ],
      [
        -24,
        21
      ],
      [
        -38,
        76
      ],
      [
        -24,
        130
      ],
      [
        -38,
        109
      ],
      [
        0,
        43
      ],
      [
        13,
        33
      ],
      [
        37,
        -22
      ],
      [
        50,
        -130
      ],
      [
        0,
        -163
      ],
      [
        24,
        -32
      ],
      [
        13,
        21
      ],
      [
        12,
        66
      ],
      [
        12,
        -11
      ],
      [
        25,
        -141
      ],
      [
        13,
        -44
      ],
      [
        37,
        -43
      ],
      [
        25,
        32
      ],
      [
        12,
        33
      ],
      [
        0,
        98
      ],
      [
        12,
        108
      ],
      [
        -12,
        65
      ],
      [
        -74,
        195
      ],
      [
        -62,
        239
      ],
      [
        -50,
        119
      ],
      [
        -49,
        239
      ],
      [
        -38,
        97
      ],
      [
        0,
        185
      ],
      [
        25,
        162
      ],
      [
        25,
        87
      ],
      [
        74,
        195
      ],
      [
        0,
        152
      ],
      [
        13,
        98
      ],
      [
        0,
        65
      ],
      [
        -37,
        173
      ],
      [
        37,
        196
      ],
      [
        49,
        249
      ],
      [
        25,
        33
      ],
      [
        37,
        32
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -163
      ],
      [
        25,
        -86
      ],
      [
        -13,
        -109
      ],
      [
        62,
        43
      ],
      [
        25,
        44
      ],
      [
        12,
        54
      ],
      [
        62,
        195
      ],
      [
        37,
        76
      ],
      [
        50,
        54
      ],
      [
        111,
        65
      ],
      [
        100,
        87
      ],
      [
        49,
        87
      ],
      [
        62,
        76
      ],
      [
        37,
        76
      ],
      [
        37,
        54
      ],
      [
        211,
        195
      ],
      [
        37,
        44
      ],
      [
        37,
        0
      ],
      [
        62,
        -11
      ],
      [
        50,
        11
      ],
      [
        49,
        -44
      ],
      [
        37,
        0
      ],
      [
        100,
        44
      ],
      [
        49,
        43
      ],
      [
        87,
        98
      ],
      [
        37,
        32
      ],
      [
        87,
        33
      ],
      [
        99,
        32
      ],
      [
        124,
        174
      ],
      [
        86,
        -11
      ],
      [
        75,
        -22
      ],
      [
        74,
        54
      ],
      [
        136,
        33
      ],
      [
        87,
        33
      ],
      [
        149,
        119
      ],
      [
        49,
        32
      ],
      [
        62,
        76
      ],
      [
        50,
        98
      ],
      [
        49,
        141
      ],
      [
        37,
        119
      ],
      [
        13,
        54
      ],
      [
        62,
        185
      ],
      [
        12,
        32
      ],
      [
        62,
        55
      ],
      [
        87,
        141
      ],
      [
        24,
        32
      ],
      [
        13,
        43
      ],
      [
        -25,
        33
      ],
      [
        -25,
        11
      ],
      [
        -12,
        163
      ],
      [
        -12,
        97
      ],
      [
        0,
        152
      ],
      [
        37,
        108
      ],
      [
        24,
        55
      ],
      [
        38,
        54
      ],
      [
        24,
        11
      ],
      [
        25,
        54
      ],
      [
        50,
        43
      ],
      [
        37,
        152
      ],
      [
        25,
        76
      ],
      [
        24,
        0
      ],
      [
        25,
        -173
      ],
      [
        25,
        -98
      ],
      [
        50,
        -109
      ],
      [
        37,
        -162
      ],
      [
        37,
        -65
      ],
      [
        12,
        -55
      ],
      [
        13,
        44
      ],
      [
        12,
        119
      ],
      [
        0,
        141
      ],
      [
        25,
        -11
      ],
      [
        25,
        -54
      ],
      [
        24,
        -11
      ],
      [
        0,
        76
      ],
      [
        25,
        54
      ],
      [
        -12,
        33
      ],
      [
        -25,
        0
      ],
      [
        -12,
        43
      ],
      [
        -25,
        44
      ],
      [
        -25,
        32
      ],
      [
        -25,
        87
      ],
      [
        -12,
        22
      ],
      [
        12,
        21
      ],
      [
        13,
        0
      ],
      [
        24,
        33
      ],
      [
        0,
        43
      ],
      [
        -12,
        76
      ],
      [
        12,
        22
      ],
      [
        38,
        0
      ],
      [
        37,
        -119
      ],
      [
        25,
        10
      ],
      [
        12,
        44
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        12,
        -33
      ],
      [
        37,
        -43
      ],
      [
        62,
        11
      ],
      [
        25,
        -11
      ],
      [
        87,
        0
      ],
      [
        -37,
        32
      ],
      [
        -38,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -24,
        33
      ],
      [
        0,
        54
      ],
      [
        12,
        43
      ],
      [
        0,
        22
      ],
      [
        25,
        -11
      ],
      [
        24,
        0
      ],
      [
        0,
        65
      ],
      [
        25,
        87
      ],
      [
        0,
        43
      ],
      [
        -12,
        -10
      ],
      [
        -37,
        -98
      ],
      [
        -13,
        76
      ],
      [
        -24,
        65
      ],
      [
        0,
        76
      ],
      [
        12,
        87
      ],
      [
        25,
        11
      ],
      [
        24,
        -11
      ],
      [
        25,
        43
      ],
      [
        13,
        43
      ],
      [
        0,
        55
      ],
      [
        24,
        -11
      ],
      [
        75,
        -76
      ],
      [
        12,
        -43
      ],
      [
        25,
        21
      ],
      [
        0,
        87
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        0
      ],
      [
        0,
        44
      ],
      [
        -25,
        54
      ],
      [
        25,
        32
      ],
      [
        25,
        0
      ],
      [
        25,
        22
      ],
      [
        12,
        22
      ],
      [
        37,
        0
      ],
      [
        37,
        -44
      ],
      [
        25,
        -11
      ],
      [
        0,
        22
      ],
      [
        12,
        44
      ],
      [
        -49,
        54
      ],
      [
        0,
        43
      ],
      [
        -25,
        43
      ],
      [
        0,
        55
      ],
      [
        25,
        43
      ],
      [
        25,
        54
      ],
      [
        37,
        0
      ],
      [
        25,
        33
      ],
      [
        24,
        11
      ],
      [
        0,
        130
      ],
      [
        13,
        11
      ],
      [
        25,
        -22
      ],
      [
        0,
        -119
      ],
      [
        12,
        21
      ],
      [
        37,
        -10
      ],
      [
        0,
        -76
      ],
      [
        25,
        -22
      ],
      [
        12,
        65
      ],
      [
        25,
        11
      ],
      [
        0,
        87
      ],
      [
        12,
        54
      ],
      [
        0,
        32
      ],
      [
        13,
        22
      ],
      [
        12,
        43
      ],
      [
        -12,
        33
      ],
      [
        -13,
        54
      ],
      [
        25,
        11
      ],
      [
        25,
        -22
      ],
      [
        12,
        -76
      ],
      [
        13,
        -32
      ],
      [
        12,
        22
      ],
      [
        12,
        43
      ],
      [
        25,
        33
      ],
      [
        50,
        -87
      ],
      [
        49,
        43
      ],
      [
        25,
        76
      ],
      [
        0,
        109
      ],
      [
        50,
        32
      ],
      [
        37,
        -22
      ],
      [
        25,
        -54
      ],
      [
        74,
        -43
      ],
      [
        49,
        -65
      ],
      [
        25,
        -44
      ],
      [
        50,
        -54
      ],
      [
        37,
        -65
      ],
      [
        37,
        -119
      ],
      [
        99,
        -141
      ],
      [
        13,
        -22
      ],
      [
        -50,
        -217
      ],
      [
        0,
        -152
      ],
      [
        12,
        11
      ],
      [
        25,
        54
      ],
      [
        13,
        -10
      ],
      [
        12,
        21
      ],
      [
        -25,
        65
      ],
      [
        0,
        44
      ],
      [
        13,
        32
      ],
      [
        24,
        33
      ],
      [
        25,
        21
      ],
      [
        25,
        44
      ],
      [
        12,
        32
      ],
      [
        62,
        0
      ],
      [
        149,
        -65
      ],
      [
        37,
        -65
      ],
      [
        0,
        -76
      ],
      [
        12,
        -32
      ],
      [
        13,
        54
      ],
      [
        -13,
        108
      ],
      [
        13,
        22
      ],
      [
        49,
        -22
      ],
      [
        25,
        -21
      ],
      [
        37,
        -65
      ],
      [
        0,
        -44
      ],
      [
        25,
        -21
      ],
      [
        0,
        32
      ],
      [
        -12,
        54
      ],
      [
        0,
        55
      ],
      [
        12,
        43
      ],
      [
        37,
        0
      ],
      [
        0,
        32
      ],
      [
        -37,
        44
      ],
      [
        -12,
        54
      ],
      [
        25,
        43
      ],
      [
        0,
        11
      ],
      [
        -25,
        0
      ],
      [
        -50,
        44
      ],
      [
        -37,
        54
      ],
      [
        37,
        119
      ],
      [
        50,
        109
      ],
      [
        37,
        32
      ],
      [
        0,
        33
      ],
      [
        12,
        76
      ],
      [
        13,
        54
      ],
      [
        0,
        43
      ],
      [
        12,
        55
      ],
      [
        37,
        43
      ],
      [
        50,
        11
      ],
      [
        25,
        21
      ],
      [
        37,
        87
      ],
      [
        -50,
        98
      ],
      [
        13,
        54
      ],
      [
        0,
        65
      ],
      [
        61,
        43
      ],
      [
        25,
        120
      ],
      [
        13,
        21
      ],
      [
        49,
        0
      ],
      [
        13,
        11
      ],
      [
        0,
        130
      ],
      [
        12,
        22
      ],
      [
        25,
        -22
      ],
      [
        12,
        -32
      ],
      [
        37,
        -43
      ],
      [
        13,
        21
      ],
      [
        -13,
        44
      ],
      [
        0,
        54
      ],
      [
        25,
        11
      ],
      [
        25,
        0
      ],
      [
        0,
        86
      ],
      [
        12,
        11
      ],
      [
        62,
        11
      ],
      [
        25,
        54
      ],
      [
        12,
        -76
      ],
      [
        37,
        -43
      ],
      [
        100,
        0
      ],
      [
        49,
        33
      ],
      [
        25,
        -22
      ],
      [
        37,
        -11
      ],
      [
        62,
        54
      ],
      [
        50,
        -32
      ],
      [
        12,
        -33
      ],
      [
        12,
        76
      ],
      [
        13,
        22
      ],
      [
        37,
        21
      ],
      [
        37,
        -10
      ],
      [
        -25,
        54
      ],
      [
        0,
        195
      ],
      [
        13,
        43
      ],
      [
        -75,
        98
      ],
      [
        -62,
        22
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -37,
        87
      ],
      [
        -50,
        21
      ],
      [
        0,
        22
      ],
      [
        50,
        54
      ],
      [
        25,
        -11
      ],
      [
        24,
        -43
      ],
      [
        25,
        -22
      ],
      [
        13,
        0
      ],
      [
        12,
        44
      ],
      [
        12,
        21
      ],
      [
        25,
        -10
      ],
      [
        74,
        -87
      ],
      [
        38,
        -87
      ],
      [
        24,
        22
      ],
      [
        38,
        43
      ],
      [
        37,
        -11
      ],
      [
        25,
        -21
      ],
      [
        24,
        -109
      ],
      [
        25,
        -54
      ],
      [
        62,
        -11
      ],
      [
        62,
        -54
      ],
      [
        37,
        0
      ],
      [
        87,
        -11
      ],
      [
        87,
        -65
      ],
      [
        24,
        -43
      ],
      [
        50,
        -11
      ],
      [
        12,
        -22
      ],
      [
        50,
        0
      ],
      [
        62,
        43
      ],
      [
        37,
        -43
      ],
      [
        12,
        -33
      ],
      [
        50,
        -54
      ],
      [
        74,
        -21
      ],
      [
        37,
        65
      ],
      [
        75,
        43
      ],
      [
        49,
        65
      ],
      [
        50,
        33
      ],
      [
        0,
        -33
      ],
      [
        12,
        -22
      ],
      [
        -62,
        -108
      ],
      [
        0,
        -33
      ],
      [
        13,
        -21
      ],
      [
        24,
        11
      ],
      [
        13,
        32
      ],
      [
        37,
        11
      ],
      [
        25,
        -22
      ],
      [
        0,
        -86
      ],
      [
        24,
        -55
      ],
      [
        38,
        -11
      ],
      [
        24,
        0
      ],
      [
        25,
        87
      ],
      [
        -12,
        65
      ],
      [
        -25,
        11
      ],
      [
        12,
        33
      ],
      [
        62,
        108
      ],
      [
        25,
        0
      ],
      [
        25,
        -119
      ],
      [
        37,
        -54
      ],
      [
        50,
        0
      ],
      [
        12,
        -11
      ],
      [
        25,
        -65
      ],
      [
        -149,
        -271
      ],
      [
        0,
        -33
      ],
      [
        12,
        -43
      ],
      [
        13,
        -65
      ],
      [
        -50,
        -131
      ],
      [
        -12,
        -10
      ],
      [
        -12,
        32
      ],
      [
        -25,
        33
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -11
      ],
      [
        -86,
        -76
      ],
      [
        0,
        -195
      ],
      [
        24,
        -119
      ],
      [
        -37,
        -217
      ],
      [
        -25,
        -54
      ],
      [
        -24,
        -33
      ],
      [
        -62,
        -184
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        -65
      ],
      [
        12,
        -54
      ],
      [
        0,
        -43
      ],
      [
        25,
        -55
      ],
      [
        112,
        -97
      ],
      [
        49,
        -65
      ],
      [
        75,
        -87
      ],
      [
        24,
        -54
      ],
      [
        0,
        -55
      ],
      [
        112,
        -75
      ],
      [
        12,
        10
      ],
      [
        25,
        0
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -32
      ],
      [
        25,
        -33
      ],
      [
        49,
        0
      ],
      [
        25,
        11
      ],
      [
        37,
        -43
      ],
      [
        25,
        -22
      ],
      [
        37,
        -54
      ],
      [
        149,
        -109
      ],
      [
        74,
        -151
      ],
      [
        50,
        -87
      ],
      [
        62,
        -65
      ],
      [
        86,
        -44
      ],
      [
        38,
        11
      ],
      [
        74,
        -54
      ],
      [
        62,
        -22
      ],
      [
        37,
        -76
      ],
      [
        12,
        -54
      ],
      [
        0,
        -43
      ],
      [
        38,
        -98
      ],
      [
        61,
        -32
      ],
      [
        87,
        -98
      ],
      [
        75,
        -43
      ],
      [
        12,
        -33
      ],
      [
        25,
        -22
      ],
      [
        62,
        0
      ],
      [
        111,
        44
      ],
      [
        50,
        54
      ],
      [
        62,
        76
      ],
      [
        24,
        141
      ],
      [
        13,
        108
      ],
      [
        86,
        239
      ],
      [
        25,
        108
      ],
      [
        25,
        152
      ],
      [
        25,
        98
      ],
      [
        -13,
        97
      ],
      [
        25,
        185
      ],
      [
        37,
        260
      ],
      [
        25,
        87
      ],
      [
        -12,
        130
      ],
      [
        -25,
        239
      ],
      [
        12,
        75
      ],
      [
        13,
        120
      ],
      [
        -25,
        87
      ],
      [
        -12,
        54
      ],
      [
        -13,
        87
      ],
      [
        25,
        151
      ],
      [
        25,
        76
      ],
      [
        12,
        109
      ],
      [
        -12,
        195
      ],
      [
        49,
        65
      ],
      [
        13,
        33
      ],
      [
        37,
        0
      ],
      [
        12,
        -11
      ],
      [
        0,
        43
      ],
      [
        -12,
        33
      ],
      [
        0,
        43
      ],
      [
        -13,
        22
      ],
      [
        -24,
        0
      ],
      [
        -13,
        32
      ],
      [
        -25,
        22
      ],
      [
        0,
        87
      ],
      [
        50,
        173
      ],
      [
        12,
        65
      ],
      [
        38,
        -54
      ],
      [
        0,
        98
      ],
      [
        24,
        162
      ],
      [
        38,
        228
      ],
      [
        12,
        206
      ],
      [
        49,
        33
      ],
      [
        25,
        54
      ],
      [
        25,
        65
      ],
      [
        25,
        0
      ],
      [
        25,
        -33
      ],
      [
        -25,
        -75
      ],
      [
        62,
        -87
      ],
      [
        24,
        -65
      ],
      [
        0,
        -65
      ],
      [
        13,
        -55
      ],
      [
        12,
        -76
      ],
      [
        0,
        -249
      ],
      [
        25,
        -33
      ],
      [
        25,
        -21
      ],
      [
        62,
        -22
      ]
    ],
    [
      [
        110879,
        49530
      ],
      [
        -37,
        -43
      ],
      [
        -12,
        21
      ],
      [
        0,
        54
      ],
      [
        24,
        33
      ],
      [
        25,
        -65
      ]
    ],
    [
      [
        110891,
        49844
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        11
      ],
      [
        -12,
        21
      ],
      [
        12,
        33
      ],
      [
        25,
        0
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        110842,
        49866
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        33
      ],
      [
        13,
        43
      ],
      [
        12,
        -21
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        67821,
        86198
      ],
      [
        -25,
        -66
      ],
      [
        -12,
        -10
      ],
      [
        0,
        -76
      ],
      [
        12,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -38,
        -11
      ],
      [
        -49,
        44
      ],
      [
        -62,
        -55
      ],
      [
        0,
        -10
      ],
      [
        74,
        -33
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -55
      ],
      [
        -74,
        -43
      ],
      [
        12,
        -76
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -43
      ],
      [
        13,
        0
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        10
      ],
      [
        -37,
        -21
      ],
      [
        -50,
        -65
      ]
    ],
    [
      [
        67461,
        85493
      ],
      [
        -37,
        -44
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -50,
        -11
      ],
      [
        -62,
        -43
      ],
      [
        -74,
        11
      ],
      [
        -74,
        -11
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -62,
        -44
      ],
      [
        -12,
        -21
      ],
      [
        -37,
        11
      ],
      [
        -112,
        21
      ],
      [
        -62,
        33
      ],
      [
        -62,
        0
      ],
      [
        -12,
        11
      ]
    ],
    [
      [
        66644,
        85276
      ],
      [
        -74,
        21
      ],
      [
        -50,
        0
      ],
      [
        -62,
        11
      ],
      [
        -161,
        44
      ],
      [
        -37,
        0
      ],
      [
        -37,
        21
      ],
      [
        -37,
        11
      ],
      [
        -25,
        44
      ],
      [
        -13,
        43
      ],
      [
        -37,
        65
      ],
      [
        -12,
        33
      ],
      [
        25,
        43
      ],
      [
        -13,
        11
      ],
      [
        -74,
        -22
      ],
      [
        -62,
        -32
      ],
      [
        -87,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -74,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -87
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -50,
        54
      ],
      [
        -74,
        0
      ],
      [
        -12,
        11
      ]
    ],
    [
      [
        65517,
        85493
      ],
      [
        -13,
        54
      ],
      [
        -25,
        22
      ],
      [
        -49,
        -87
      ],
      [
        -25,
        0
      ],
      [
        -87,
        54
      ],
      [
        0,
        22
      ],
      [
        -37,
        43
      ],
      [
        -62,
        11
      ]
    ],
    [
      [
        65219,
        85612
      ],
      [
        13,
        11
      ],
      [
        0,
        32
      ],
      [
        -25,
        33
      ],
      [
        0,
        54
      ]
    ],
    [
      [
        65207,
        85742
      ],
      [
        25,
        76
      ],
      [
        0,
        43
      ],
      [
        -25,
        44
      ]
    ],
    [
      [
        65207,
        85905
      ],
      [
        37,
        0
      ],
      [
        25,
        11
      ],
      [
        12,
        21
      ],
      [
        25,
        -21
      ],
      [
        50,
        -22
      ],
      [
        24,
        -22
      ],
      [
        13,
        -32
      ],
      [
        0,
        -33
      ],
      [
        37,
        -11
      ],
      [
        0,
        -54
      ],
      [
        37,
        22
      ],
      [
        37,
        65
      ],
      [
        13,
        87
      ],
      [
        74,
        0
      ],
      [
        74,
        -22
      ],
      [
        37,
        -76
      ],
      [
        25,
        0
      ],
      [
        50,
        22
      ],
      [
        37,
        0
      ],
      [
        25,
        32
      ],
      [
        62,
        44
      ],
      [
        49,
        21
      ],
      [
        161,
        22
      ],
      [
        13,
        22
      ],
      [
        0,
        43
      ],
      [
        74,
        -33
      ],
      [
        37,
        -21
      ],
      [
        50,
        21
      ],
      [
        37,
        -21
      ],
      [
        0,
        -44
      ],
      [
        62,
        -54
      ],
      [
        25,
        22
      ],
      [
        0,
        43
      ],
      [
        12,
        44
      ],
      [
        -12,
        32
      ],
      [
        -38,
        0
      ],
      [
        13,
        65
      ],
      [
        0,
        54
      ],
      [
        -75,
        109
      ],
      [
        0,
        22
      ],
      [
        50,
        65
      ],
      [
        62,
        43
      ],
      [
        49,
        11
      ],
      [
        38,
        22
      ],
      [
        24,
        43
      ],
      [
        25,
        108
      ],
      [
        13,
        11
      ],
      [
        61,
        -43
      ],
      [
        38,
        43
      ],
      [
        0,
        98
      ],
      [
        12,
        11
      ]
    ],
    [
      [
        66681,
        86675
      ],
      [
        62,
        -44
      ],
      [
        12,
        -54
      ],
      [
        50,
        -22
      ],
      [
        62,
        0
      ],
      [
        25,
        33
      ],
      [
        37,
        -11
      ],
      [
        49,
        0
      ],
      [
        0,
        43
      ],
      [
        50,
        66
      ],
      [
        25,
        -11
      ],
      [
        12,
        43
      ],
      [
        12,
        109
      ],
      [
        62,
        -22
      ],
      [
        13,
        -11
      ],
      [
        25,
        11
      ],
      [
        49,
        -11
      ],
      [
        62,
        -43
      ],
      [
        37,
        -11
      ],
      [
        50,
        0
      ],
      [
        74,
        -76
      ],
      [
        112,
        0
      ],
      [
        37,
        32
      ],
      [
        37,
        -10
      ],
      [
        37,
        -33
      ],
      [
        62,
        -11
      ],
      [
        12,
        -54
      ],
      [
        13,
        -11
      ]
    ],
    [
      [
        67759,
        86577
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -76
      ],
      [
        0,
        -33
      ],
      [
        37,
        -119
      ],
      [
        37,
        -65
      ],
      [
        25,
        -54
      ]
    ],
    [
      [
        77792,
        80504
      ],
      [
        -74,
        11
      ],
      [
        -111,
        43
      ],
      [
        -37,
        22
      ],
      [
        -25,
        54
      ],
      [
        -50,
        65
      ],
      [
        -25,
        11
      ],
      [
        -12,
        22
      ],
      [
        -25,
        75
      ],
      [
        -25,
        33
      ],
      [
        -61,
        130
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        77347,
        80981
      ],
      [
        -25,
        33
      ]
    ],
    [
      [
        77421,
        81838
      ],
      [
        -25,
        0
      ],
      [
        0,
        32
      ],
      [
        25,
        -11
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        78734,
        80222
      ],
      [
        -74,
        -22
      ],
      [
        -13,
        11
      ],
      [
        -62,
        108
      ],
      [
        -37,
        11
      ],
      [
        -25,
        22
      ],
      [
        -12,
        54
      ],
      [
        -62,
        54
      ],
      [
        -12,
        44
      ],
      [
        24,
        32
      ],
      [
        62,
        22
      ],
      [
        13,
        11
      ],
      [
        0,
        65
      ],
      [
        -62,
        65
      ],
      [
        0,
        54
      ],
      [
        12,
        22
      ],
      [
        37,
        22
      ],
      [
        25,
        32
      ],
      [
        -111,
        174
      ],
      [
        -38,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        -65
      ],
      [
        -86,
        -76
      ],
      [
        -99,
        -108
      ],
      [
        -25,
        -44
      ],
      [
        -50,
        -22
      ],
      [
        -25,
        -32
      ],
      [
        -74,
        -119
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        77408,
        82011
      ],
      [
        100,
        98
      ],
      [
        49,
        -22
      ],
      [
        99,
        -54
      ],
      [
        -12,
        -33
      ],
      [
        37,
        -32
      ],
      [
        87,
        -43
      ],
      [
        37,
        21
      ],
      [
        37,
        -21
      ],
      [
        62,
        -55
      ],
      [
        25,
        11
      ],
      [
        37,
        44
      ],
      [
        12,
        54
      ],
      [
        -12,
        65
      ],
      [
        -37,
        32
      ],
      [
        -50,
        33
      ],
      [
        -25,
        32
      ],
      [
        -12,
        65
      ],
      [
        -25,
        0
      ],
      [
        0,
        76
      ],
      [
        37,
        11
      ],
      [
        50,
        87
      ]
    ],
    [
      [
        77904,
        82380
      ],
      [
        37,
        -11
      ],
      [
        0,
        -32
      ],
      [
        25,
        -11
      ],
      [
        25,
        21
      ],
      [
        49,
        -54
      ],
      [
        37,
        -54
      ],
      [
        38,
        -65
      ],
      [
        24,
        -22
      ],
      [
        25,
        -43
      ],
      [
        25,
        -87
      ],
      [
        12,
        -22
      ],
      [
        99,
        -43
      ],
      [
        62,
        -11
      ],
      [
        25,
        11
      ],
      [
        74,
        152
      ],
      [
        75,
        54
      ],
      [
        37,
        33
      ],
      [
        12,
        43
      ],
      [
        50,
        108
      ]
    ],
    [
      [
        78635,
        82347
      ],
      [
        37,
        -32
      ],
      [
        50,
        -98
      ],
      [
        74,
        -162
      ],
      [
        25,
        -44
      ],
      [
        37,
        -173
      ],
      [
        87,
        -141
      ],
      [
        24,
        -54
      ],
      [
        62,
        -66
      ],
      [
        50,
        -21
      ],
      [
        37,
        0
      ],
      [
        49,
        -22
      ],
      [
        50,
        -43
      ],
      [
        37,
        -120
      ],
      [
        -74,
        33
      ],
      [
        -87,
        -11
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -21
      ],
      [
        -50,
        -44
      ],
      [
        -24,
        -65
      ],
      [
        -13,
        -152
      ],
      [
        -37,
        -141
      ],
      [
        0,
        -65
      ],
      [
        12,
        -65
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -44
      ],
      [
        -12,
        -130
      ],
      [
        -13,
        -32
      ],
      [
        -24,
        -11
      ],
      [
        0,
        54
      ],
      [
        -38,
        22
      ],
      [
        -12,
        -33
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -249
      ]
    ],
    [
      [
        77570,
        81577
      ],
      [
        24,
        11
      ],
      [
        0,
        22
      ],
      [
        -24,
        0
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        72045,
        53434
      ],
      [
        -13,
        98
      ],
      [
        -12,
        119
      ],
      [
        -50,
        163
      ],
      [
        0,
        97
      ],
      [
        13,
        131
      ],
      [
        -13,
        75
      ],
      [
        0,
        44
      ],
      [
        13,
        97
      ],
      [
        0,
        44
      ],
      [
        -25,
        65
      ],
      [
        -37,
        65
      ],
      [
        -12,
        33
      ],
      [
        0,
        54
      ]
    ],
    [
      [
        71909,
        54519
      ],
      [
        0,
        32
      ],
      [
        12,
        33
      ],
      [
        12,
        11
      ],
      [
        37,
        -22
      ],
      [
        38,
        -33
      ],
      [
        12,
        -65
      ],
      [
        12,
        -10
      ],
      [
        112,
        0
      ],
      [
        62,
        54
      ],
      [
        0,
        32
      ],
      [
        12,
        65
      ],
      [
        0,
        141
      ],
      [
        25,
        0
      ],
      [
        37,
        -54
      ],
      [
        13,
        0
      ],
      [
        12,
        22
      ],
      [
        25,
        21
      ],
      [
        12,
        0
      ],
      [
        50,
        22
      ],
      [
        24,
        -43
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        72441,
        54714
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        -119
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -33
      ],
      [
        37,
        -32
      ],
      [
        86,
        -44
      ],
      [
        0,
        -43
      ],
      [
        13,
        -33
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -55
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -65
      ],
      [
        -37,
        -98
      ],
      [
        -12,
        -54
      ],
      [
        -62,
        -141
      ],
      [
        -62,
        -65
      ],
      [
        -25,
        -22
      ],
      [
        -99,
        0
      ]
    ],
    [
      [
        63981,
        87911
      ],
      [
        49,
        -43
      ],
      [
        37,
        -44
      ],
      [
        -24,
        -32
      ],
      [
        12,
        -33
      ],
      [
        37,
        -11
      ],
      [
        12,
        -21
      ],
      [
        0,
        -33
      ],
      [
        13,
        -54
      ],
      [
        -62,
        -43
      ],
      [
        -25,
        -76
      ]
    ],
    [
      [
        64030,
        87521
      ],
      [
        -12,
        21
      ],
      [
        -37,
        11
      ],
      [
        -38,
        -54
      ],
      [
        -24,
        -76
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -44
      ],
      [
        49,
        -97
      ],
      [
        -12,
        -54
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        63919,
        87163
      ],
      [
        -25,
        0
      ],
      [
        -74,
        -22
      ],
      [
        -50,
        65
      ],
      [
        -25,
        22
      ],
      [
        0,
        22
      ],
      [
        -25,
        0
      ],
      [
        -37,
        21
      ],
      [
        -12,
        22
      ],
      [
        -50,
        22
      ],
      [
        -24,
        0
      ],
      [
        0,
        32
      ],
      [
        -25,
        76
      ],
      [
        25,
        108
      ],
      [
        -13,
        11
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        -11
      ],
      [
        -62,
        11
      ],
      [
        -12,
        11
      ],
      [
        0,
        32
      ],
      [
        12,
        11
      ],
      [
        0,
        33
      ],
      [
        -12,
        21
      ],
      [
        12,
        66
      ],
      [
        -49,
        54
      ],
      [
        -25,
        11
      ],
      [
        -74,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        87
      ],
      [
        -49,
        21
      ],
      [
        -62,
        0
      ],
      [
        -25,
        54
      ],
      [
        0,
        44
      ],
      [
        -49,
        76
      ],
      [
        -87,
        -44
      ],
      [
        -62,
        65
      ],
      [
        -25,
        44
      ],
      [
        0,
        65
      ],
      [
        -25,
        43
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        62791,
        88128
      ],
      [
        149,
        108
      ],
      [
        136,
        76
      ]
    ],
    [
      [
        63076,
        88312
      ],
      [
        25,
        -86
      ],
      [
        50,
        21
      ],
      [
        37,
        0
      ],
      [
        49,
        -43
      ],
      [
        25,
        0
      ],
      [
        50,
        22
      ],
      [
        49,
        43
      ],
      [
        13,
        43
      ]
    ],
    [
      [
        63374,
        88312
      ],
      [
        49,
        -21
      ],
      [
        13,
        43
      ],
      [
        37,
        33
      ],
      [
        24,
        -33
      ],
      [
        25,
        0
      ],
      [
        37,
        43
      ],
      [
        25,
        -21
      ],
      [
        13,
        -33
      ],
      [
        24,
        0
      ],
      [
        38,
        44
      ],
      [
        24,
        -76
      ],
      [
        37,
        -44
      ],
      [
        38,
        -11
      ],
      [
        62,
        11
      ],
      [
        37,
        -54
      ],
      [
        49,
        -11
      ],
      [
        25,
        -32
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -98
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -33
      ],
      [
        13,
        -21
      ]
    ],
    [
      [
        63882,
        87933
      ],
      [
        49,
        21
      ],
      [
        25,
        -32
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        62482,
        60093
      ],
      [
        0,
        22
      ],
      [
        49,
        32
      ],
      [
        -12,
        76
      ],
      [
        -25,
        98
      ],
      [
        -25,
        22
      ],
      [
        0,
        43
      ],
      [
        13,
        33
      ],
      [
        -13,
        21
      ],
      [
        0,
        65
      ],
      [
        -12,
        76
      ],
      [
        25,
        0
      ],
      [
        0,
        456
      ],
      [
        0,
        347
      ],
      [
        0,
        303
      ],
      [
        -13,
        185
      ],
      [
        0,
        54
      ],
      [
        -49,
        87
      ],
      [
        -25,
        54
      ],
      [
        0,
        54
      ],
      [
        -12,
        65
      ],
      [
        0,
        271
      ],
      [
        -50,
        65
      ],
      [
        -74,
        87
      ],
      [
        -62,
        76
      ],
      [
        -13,
        22
      ],
      [
        13,
        195
      ],
      [
        12,
        33
      ],
      [
        25,
        141
      ]
    ],
    [
      [
        62234,
        63076
      ],
      [
        12,
        0
      ],
      [
        13,
        21
      ],
      [
        0,
        33
      ],
      [
        37,
        -11
      ],
      [
        0,
        65
      ],
      [
        25,
        11
      ],
      [
        0,
        43
      ],
      [
        49,
        22
      ],
      [
        13,
        11
      ],
      [
        12,
        54
      ],
      [
        12,
        11
      ],
      [
        0,
        22
      ],
      [
        13,
        10
      ],
      [
        37,
        0
      ],
      [
        12,
        -32
      ],
      [
        99,
        22
      ],
      [
        38,
        -11
      ],
      [
        86,
        130
      ],
      [
        25,
        43
      ],
      [
        25,
        87
      ],
      [
        0,
        43
      ]
    ],
    [
      [
        62742,
        63650
      ],
      [
        12,
        55
      ],
      [
        -12,
        119
      ],
      [
        0,
        22
      ],
      [
        37,
        32
      ],
      [
        62,
        22
      ],
      [
        25,
        32
      ],
      [
        25,
        22
      ],
      [
        24,
        -11
      ],
      [
        87,
        -162
      ],
      [
        50,
        -76
      ],
      [
        12,
        -44
      ],
      [
        12,
        -21
      ],
      [
        37,
        -22
      ],
      [
        25,
        -44
      ],
      [
        25,
        -54
      ]
    ],
    [
      [
        63163,
        63520
      ],
      [
        -37,
        -119
      ],
      [
        0,
        -65
      ],
      [
        49,
        -141
      ],
      [
        25,
        -33
      ],
      [
        0,
        -32
      ],
      [
        13,
        -65
      ],
      [
        0,
        -120
      ],
      [
        37,
        -108
      ],
      [
        -25,
        -108
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        -87
      ],
      [
        24,
        -65
      ],
      [
        -12,
        -98
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -141
      ],
      [
        -99,
        -32
      ],
      [
        -12,
        -163
      ],
      [
        0,
        -206
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -336
      ],
      [
        13,
        -65
      ],
      [
        0,
        -109
      ],
      [
        12,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -21
      ],
      [
        0,
        -152
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -163
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -98
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        62853,
        60191
      ],
      [
        -136,
        -22
      ],
      [
        -173,
        -43
      ],
      [
        -62,
        -33
      ]
    ],
    [
      [
        62234,
        63076
      ],
      [
        -87,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        0
      ],
      [
        0,
        22
      ],
      [
        -13,
        0
      ],
      [
        -111,
        54
      ],
      [
        -74,
        32
      ]
    ],
    [
      [
        61900,
        63162
      ],
      [
        -75,
        22
      ],
      [
        -25,
        -43
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -55
      ],
      [
        -50,
        -43
      ],
      [
        -12,
        33
      ],
      [
        -25,
        10
      ],
      [
        -49,
        -10
      ],
      [
        -25,
        10
      ],
      [
        -87,
        0
      ],
      [
        -111,
        11
      ],
      [
        -13,
        -11
      ],
      [
        -111,
        0
      ],
      [
        -112,
        -10
      ],
      [
        -173,
        0
      ],
      [
        0,
        10
      ],
      [
        -37,
        0
      ],
      [
        0,
        -10
      ],
      [
        -25,
        -163
      ],
      [
        0,
        -87
      ],
      [
        25,
        -87
      ],
      [
        24,
        -32
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -22
      ],
      [
        12,
        -32
      ],
      [
        0,
        -119
      ],
      [
        13,
        -109
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -55
      ],
      [
        25,
        -86
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        60995,
        62132
      ],
      [
        0,
        -11
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        0
      ],
      [
        -25,
        54
      ],
      [
        -12,
        11
      ],
      [
        -25,
        97
      ],
      [
        -25,
        22
      ],
      [
        -12,
        22
      ],
      [
        -25,
        65
      ],
      [
        -25,
        21
      ],
      [
        -12,
        -10
      ],
      [
        -37,
        21
      ],
      [
        -62,
        11
      ],
      [
        -74,
        0
      ],
      [
        -38,
        -22
      ],
      [
        -24,
        -21
      ],
      [
        -75,
        -44
      ],
      [
        -37,
        -32
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -49,
        43
      ],
      [
        -25,
        0
      ],
      [
        -37,
        22
      ],
      [
        -38,
        54
      ],
      [
        -24,
        22
      ],
      [
        -25,
        32
      ],
      [
        -13,
        76
      ],
      [
        -12,
        54
      ],
      [
        -25,
        65
      ],
      [
        -24,
        33
      ],
      [
        -25,
        21
      ],
      [
        -37,
        -10
      ],
      [
        -38,
        32
      ],
      [
        -12,
        44
      ]
    ],
    [
      [
        60029,
        62729
      ],
      [
        0,
        32
      ],
      [
        12,
        54
      ],
      [
        0,
        293
      ],
      [
        13,
        33
      ],
      [
        25,
        21
      ],
      [
        24,
        55
      ],
      [
        13,
        108
      ],
      [
        12,
        87
      ],
      [
        -12,
        32
      ],
      [
        0,
        33
      ],
      [
        -13,
        32
      ],
      [
        0,
        98
      ],
      [
        50,
        65
      ],
      [
        12,
        22
      ],
      [
        50,
        11
      ],
      [
        62,
        21
      ],
      [
        25,
        33
      ],
      [
        49,
        43
      ],
      [
        13,
        54
      ],
      [
        24,
        33
      ],
      [
        13,
        33
      ],
      [
        0,
        151
      ],
      [
        -13,
        33
      ],
      [
        0,
        22
      ],
      [
        87,
        75
      ],
      [
        0,
        55
      ],
      [
        -12,
        65
      ],
      [
        -25,
        43
      ],
      [
        0,
        44
      ],
      [
        25,
        43
      ],
      [
        12,
        43
      ],
      [
        25,
        33
      ],
      [
        25,
        43
      ],
      [
        37,
        11
      ],
      [
        37,
        -11
      ],
      [
        99,
        -119
      ],
      [
        37,
        0
      ],
      [
        25,
        32
      ],
      [
        25,
        22
      ],
      [
        12,
        76
      ],
      [
        0,
        109
      ],
      [
        12,
        54
      ],
      [
        13,
        11
      ],
      [
        62,
        -22
      ],
      [
        25,
        0
      ],
      [
        12,
        22
      ],
      [
        0,
        65
      ],
      [
        12,
        108
      ],
      [
        37,
        76
      ],
      [
        62,
        98
      ],
      [
        25,
        21
      ],
      [
        25,
        0
      ],
      [
        111,
        -65
      ],
      [
        25,
        22
      ],
      [
        25,
        163
      ],
      [
        74,
        21
      ],
      [
        37,
        22
      ],
      [
        62,
        65
      ],
      [
        100,
        87
      ],
      [
        61,
        43
      ],
      [
        38,
        65
      ],
      [
        49,
        65
      ],
      [
        25,
        11
      ],
      [
        49,
        11
      ],
      [
        25,
        -11
      ],
      [
        25,
        -32
      ],
      [
        50,
        32
      ],
      [
        86,
        -54
      ],
      [
        75,
        -43
      ]
    ],
    [
      [
        61999,
        65527
      ],
      [
        0,
        -76
      ],
      [
        -13,
        -87
      ],
      [
        0,
        -98
      ],
      [
        25,
        -54
      ],
      [
        50,
        -98
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -43
      ],
      [
        25,
        -65
      ],
      [
        37,
        -87
      ],
      [
        25,
        -76
      ],
      [
        49,
        -21
      ],
      [
        25,
        -33
      ],
      [
        37,
        -22
      ],
      [
        13,
        -21
      ],
      [
        12,
        -55
      ],
      [
        37,
        -32
      ],
      [
        25,
        -33
      ],
      [
        0,
        -21
      ],
      [
        -74,
        21
      ],
      [
        0,
        -206
      ],
      [
        12,
        0
      ],
      [
        25,
        -21
      ],
      [
        74,
        -98
      ],
      [
        75,
        -108
      ],
      [
        12,
        -22
      ],
      [
        37,
        -11
      ],
      [
        50,
        0
      ],
      [
        49,
        54
      ],
      [
        25,
        11
      ],
      [
        25,
        0
      ],
      [
        0,
        -11
      ],
      [
        25,
        -43
      ],
      [
        12,
        -65
      ],
      [
        12,
        -44
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        -22
      ],
      [
        13,
        -43
      ],
      [
        0,
        -22
      ],
      [
        86,
        -206
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        93562,
        69648
      ],
      [
        -25,
        0
      ],
      [
        -13,
        21
      ],
      [
        13,
        22
      ],
      [
        -13,
        87
      ],
      [
        25,
        11
      ],
      [
        13,
        -33
      ],
      [
        0,
        -108
      ]
    ],
    [
      [
        93537,
        69854
      ],
      [
        -13,
        -54
      ],
      [
        -12,
        43
      ],
      [
        12,
        43
      ],
      [
        13,
        0
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        93289,
        70071
      ],
      [
        -37,
        -44
      ],
      [
        12,
        250
      ],
      [
        25,
        -87
      ],
      [
        0,
        -119
      ]
    ],
    [
      [
        93425,
        70190
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -12,
        65
      ],
      [
        12,
        76
      ],
      [
        13,
        -11
      ],
      [
        24,
        -97
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        93153,
        70017
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        0
      ],
      [
        62,
        162
      ],
      [
        -12,
        76
      ],
      [
        0,
        65
      ],
      [
        -38,
        44
      ],
      [
        0,
        32
      ],
      [
        -12,
        55
      ],
      [
        0,
        54
      ],
      [
        25,
        11
      ],
      [
        37,
        -44
      ],
      [
        0,
        -43
      ],
      [
        12,
        -54
      ],
      [
        50,
        -98
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -141
      ],
      [
        -25,
        -43
      ]
    ],
    [
      [
        93116,
        70559
      ],
      [
        -13,
        -11
      ],
      [
        -25,
        22
      ],
      [
        13,
        32
      ],
      [
        25,
        -43
      ]
    ],
    [
      [
        93772,
        69941
      ],
      [
        13,
        -228
      ],
      [
        0,
        -87
      ],
      [
        12,
        -76
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        32
      ],
      [
        -25,
        33
      ],
      [
        -50,
        43
      ],
      [
        -12,
        -10
      ],
      [
        -37,
        -76
      ],
      [
        12,
        -55
      ],
      [
        0,
        -65
      ],
      [
        25,
        -32
      ],
      [
        0,
        -76
      ],
      [
        12,
        -43
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        93685,
        69203
      ],
      [
        -24,
        54
      ],
      [
        -13,
        65
      ],
      [
        -49,
        120
      ],
      [
        -13,
        217
      ],
      [
        0,
        97
      ],
      [
        -37,
        130
      ],
      [
        -25,
        174
      ],
      [
        -12,
        43
      ],
      [
        0,
        44
      ],
      [
        -25,
        65
      ],
      [
        -12,
        65
      ],
      [
        -62,
        119
      ],
      [
        -12,
        54
      ],
      [
        0,
        55
      ],
      [
        -25,
        -55
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -74,
        -11
      ],
      [
        -37,
        76
      ],
      [
        -62,
        195
      ],
      [
        -13,
        33
      ],
      [
        13,
        119
      ],
      [
        -13,
        108
      ],
      [
        0,
        87
      ],
      [
        -25,
        -32
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -32
      ],
      [
        -99,
        21
      ],
      [
        50,
        -54
      ],
      [
        37,
        -11
      ],
      [
        25,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -54
      ],
      [
        0,
        -43
      ],
      [
        24,
        -44
      ],
      [
        -24,
        -21
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -43
      ],
      [
        25,
        -76
      ],
      [
        -12,
        -33
      ],
      [
        24,
        -22
      ],
      [
        25,
        -119
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -87
      ],
      [
        -25,
        -87
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        43
      ],
      [
        0,
        76
      ],
      [
        25,
        76
      ],
      [
        -74,
        -65
      ],
      [
        -13,
        54
      ],
      [
        0,
        120
      ],
      [
        25,
        97
      ],
      [
        -37,
        -43
      ],
      [
        0,
        -184
      ],
      [
        -12,
        -66
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -65
      ],
      [
        -12,
        22
      ],
      [
        -12,
        86
      ],
      [
        -25,
        -108
      ],
      [
        -37,
        -65
      ],
      [
        -50,
        0
      ],
      [
        -12,
        43
      ],
      [
        -25,
        55
      ],
      [
        -12,
        86
      ],
      [
        -13,
        55
      ]
    ],
    [
      [
        92558,
        70017
      ],
      [
        13,
        54
      ],
      [
        -13,
        54
      ],
      [
        -37,
        228
      ],
      [
        0,
        32
      ],
      [
        -12,
        98
      ],
      [
        -13,
        65
      ],
      [
        0,
        54
      ],
      [
        25,
        98
      ],
      [
        -74,
        43
      ],
      [
        12,
        109
      ],
      [
        -37,
        76
      ],
      [
        -12,
        10
      ],
      [
        -13,
        65
      ],
      [
        13,
        98
      ],
      [
        37,
        108
      ],
      [
        0,
        109
      ],
      [
        12,
        32
      ],
      [
        -37,
        55
      ],
      [
        -87,
        43
      ],
      [
        -12,
        43
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        55
      ],
      [
        -13,
        54
      ],
      [
        0,
        54
      ],
      [
        38,
        119
      ],
      [
        12,
        11
      ],
      [
        37,
        -32
      ],
      [
        12,
        0
      ],
      [
        25,
        54
      ],
      [
        25,
        141
      ],
      [
        74,
        0
      ],
      [
        50,
        -11
      ],
      [
        25,
        11
      ],
      [
        24,
        43
      ],
      [
        -49,
        65
      ],
      [
        -13,
        87
      ],
      [
        -61,
        0
      ],
      [
        -38,
        22
      ],
      [
        -49,
        97
      ],
      [
        -37,
        66
      ],
      [
        -37,
        10
      ],
      [
        -13,
        22
      ],
      [
        0,
        65
      ],
      [
        13,
        44
      ],
      [
        0,
        43
      ],
      [
        37,
        54
      ],
      [
        24,
        54
      ],
      [
        25,
        33
      ],
      [
        25,
        54
      ],
      [
        -37,
        54
      ],
      [
        0,
        44
      ],
      [
        25,
        11
      ],
      [
        37,
        -33
      ],
      [
        49,
        -108
      ],
      [
        0,
        -33
      ],
      [
        50,
        -32
      ],
      [
        25,
        10
      ],
      [
        24,
        -10
      ],
      [
        0,
        54
      ],
      [
        -12,
        21
      ],
      [
        12,
        33
      ],
      [
        38,
        -22
      ],
      [
        12,
        -43
      ],
      [
        0,
        -65
      ],
      [
        25,
        -65
      ],
      [
        62,
        -65
      ],
      [
        37,
        -11
      ],
      [
        25,
        11
      ],
      [
        12,
        43
      ],
      [
        0,
        76
      ],
      [
        37,
        11
      ],
      [
        13,
        -22
      ],
      [
        37,
        -152
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -173
      ],
      [
        -13,
        -141
      ],
      [
        13,
        -33
      ],
      [
        12,
        0
      ],
      [
        87,
        -43
      ],
      [
        111,
        -44
      ],
      [
        37,
        11
      ],
      [
        62,
        -11
      ],
      [
        112,
        11
      ],
      [
        87,
        11
      ],
      [
        62,
        -33
      ],
      [
        99,
        22
      ],
      [
        99,
        0
      ],
      [
        49,
        -32
      ],
      [
        62,
        -65
      ],
      [
        37,
        -66
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -49,
        22
      ],
      [
        0,
        -76
      ],
      [
        -50,
        -239
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        22
      ],
      [
        -38,
        -11
      ],
      [
        -49,
        -65
      ],
      [
        -50,
        0
      ],
      [
        -12,
        -44
      ],
      [
        -37,
        -65
      ],
      [
        -13,
        -97
      ],
      [
        -12,
        -65
      ],
      [
        0,
        -44
      ],
      [
        37,
        -130
      ],
      [
        13,
        -173
      ],
      [
        24,
        -22
      ],
      [
        0,
        76
      ],
      [
        25,
        11
      ],
      [
        25,
        -109
      ],
      [
        12,
        -22
      ],
      [
        25,
        -10
      ],
      [
        25,
        10
      ],
      [
        25,
        66
      ],
      [
        0,
        65
      ],
      [
        -13,
        54
      ],
      [
        13,
        43
      ],
      [
        62,
        87
      ],
      [
        -13,
        65
      ],
      [
        0,
        54
      ],
      [
        50,
        -11
      ],
      [
        25,
        33
      ],
      [
        12,
        0
      ],
      [
        0,
        -33
      ],
      [
        25,
        0
      ],
      [
        12,
        -119
      ],
      [
        25,
        -97
      ],
      [
        0,
        -250
      ],
      [
        12,
        -22
      ],
      [
        25,
        -97
      ],
      [
        12,
        -33
      ],
      [
        0,
        -97
      ],
      [
        13,
        -76
      ],
      [
        12,
        -228
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        71562,
        82434
      ],
      [
        -50,
        11
      ],
      [
        -25,
        -22
      ],
      [
        -49,
        0
      ],
      [
        -37,
        -21
      ],
      [
        -25,
        11
      ],
      [
        -62,
        86
      ],
      [
        -12,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        -11
      ],
      [
        -37,
        -43
      ],
      [
        -112,
        -32
      ],
      [
        -12,
        -55
      ],
      [
        -13,
        -21
      ],
      [
        -49,
        -11
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        70979,
        82272
      ],
      [
        -37,
        21
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -22
      ],
      [
        13,
        -54
      ],
      [
        0,
        -86
      ],
      [
        -25,
        -22
      ],
      [
        -50,
        -22
      ],
      [
        -49,
        11
      ],
      [
        -50,
        -11
      ],
      [
        -87,
        -32
      ],
      [
        -49,
        -11
      ],
      [
        -37,
        43
      ],
      [
        -50,
        33
      ],
      [
        -49,
        21
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        43
      ],
      [
        -25,
        11
      ],
      [
        -13,
        22
      ],
      [
        -12,
        54
      ],
      [
        -49,
        -22
      ],
      [
        -112,
        0
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -87,
        -43
      ],
      [
        -62,
        10
      ],
      [
        -24,
        -10
      ],
      [
        -50,
        0
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        11
      ],
      [
        -49,
        0
      ]
    ],
    [
      [
        69803,
        82033
      ],
      [
        12,
        11
      ],
      [
        0,
        162
      ],
      [
        25,
        66
      ],
      [
        0,
        21
      ],
      [
        -25,
        11
      ],
      [
        -37,
        141
      ],
      [
        -13,
        22
      ],
      [
        -74,
        43
      ],
      [
        -74,
        141
      ]
    ],
    [
      [
        69617,
        82651
      ],
      [
        25,
        0
      ],
      [
        0,
        22
      ],
      [
        37,
        54
      ],
      [
        0,
        33
      ],
      [
        -25,
        32
      ],
      [
        -12,
        54
      ],
      [
        12,
        44
      ],
      [
        0,
        32
      ],
      [
        -12,
        22
      ],
      [
        12,
        33
      ],
      [
        25,
        21
      ],
      [
        62,
        0
      ],
      [
        24,
        65
      ],
      [
        25,
        22
      ],
      [
        37,
        76
      ],
      [
        0,
        32
      ],
      [
        -37,
        44
      ],
      [
        -62,
        87
      ],
      [
        -49,
        32
      ],
      [
        -25,
        98
      ],
      [
        -37,
        108
      ],
      [
        0,
        54
      ],
      [
        12,
        65
      ],
      [
        13,
        22
      ],
      [
        62,
        44
      ],
      [
        0,
        75
      ],
      [
        37,
        22
      ]
    ],
    [
      [
        69741,
        83844
      ],
      [
        111,
        -97
      ],
      [
        0,
        -22
      ],
      [
        -49,
        -33
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -55
      ],
      [
        25,
        -21
      ],
      [
        99,
        21
      ],
      [
        112,
        -10
      ],
      [
        136,
        -44
      ],
      [
        99,
        -11
      ],
      [
        74,
        22
      ],
      [
        248,
        -65
      ],
      [
        112,
        -11
      ],
      [
        61,
        22
      ],
      [
        50,
        32
      ],
      [
        37,
        65
      ],
      [
        99,
        87
      ],
      [
        99,
        44
      ],
      [
        124,
        43
      ],
      [
        75,
        11
      ],
      [
        123,
        -87
      ],
      [
        50,
        0
      ],
      [
        50,
        -33
      ],
      [
        0,
        -10
      ],
      [
        49,
        21
      ],
      [
        62,
        -108
      ],
      [
        112,
        -44
      ],
      [
        74,
        0
      ]
    ],
    [
      [
        71760,
        83540
      ],
      [
        -13,
        -151
      ],
      [
        -24,
        -76
      ],
      [
        -50,
        32
      ],
      [
        -74,
        -21
      ],
      [
        -25,
        -87
      ],
      [
        -37,
        -44
      ],
      [
        -13,
        -108
      ],
      [
        0,
        -163
      ],
      [
        -49,
        -32
      ],
      [
        -99,
        -152
      ],
      [
        62,
        -33
      ],
      [
        25,
        -32
      ],
      [
        37,
        -98
      ],
      [
        49,
        -97
      ],
      [
        13,
        -44
      ]
    ],
    [
      [
        79341,
        72381
      ],
      [
        -12,
        -44
      ],
      [
        -13,
        11
      ],
      [
        -25,
        87
      ],
      [
        0,
        54
      ],
      [
        -12,
        87
      ],
      [
        12,
        22
      ],
      [
        38,
        11
      ],
      [
        -13,
        -33
      ],
      [
        25,
        -43
      ],
      [
        0,
        -152
      ]
    ],
    [
      [
        36803,
        69453
      ],
      [
        -13,
        -44
      ],
      [
        -37,
        -87
      ],
      [
        -86,
        -21
      ],
      [
        -87,
        -11
      ],
      [
        -13,
        43
      ],
      [
        13,
        33
      ],
      [
        0,
        32
      ],
      [
        25,
        11
      ],
      [
        24,
        44
      ],
      [
        38,
        0
      ],
      [
        37,
        -22
      ],
      [
        24,
        0
      ],
      [
        38,
        32
      ],
      [
        24,
        65
      ],
      [
        13,
        -10
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        36840,
        69648
      ],
      [
        -50,
        -33
      ],
      [
        0,
        44
      ],
      [
        25,
        21
      ],
      [
        25,
        -32
      ]
    ],
    [
      [
        36790,
        70223
      ],
      [
        75,
        -22
      ],
      [
        24,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        43
      ],
      [
        -37,
        11
      ],
      [
        -62,
        0
      ],
      [
        13,
        54
      ],
      [
        24,
        -21
      ]
    ],
    [
      [
        36394,
        70092
      ],
      [
        -25,
        -21
      ],
      [
        0,
        32
      ],
      [
        50,
        54
      ],
      [
        25,
        55
      ],
      [
        24,
        21
      ],
      [
        25,
        55
      ],
      [
        0,
        21
      ],
      [
        -25,
        44
      ],
      [
        0,
        32
      ],
      [
        13,
        22
      ],
      [
        37,
        11
      ],
      [
        -13,
        -33
      ],
      [
        13,
        -97
      ],
      [
        -50,
        -109
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        -55
      ]
    ],
    [
      [
        36444,
        70407
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        33
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        33
      ],
      [
        0,
        54
      ],
      [
        49,
        -54
      ],
      [
        38,
        -22
      ]
    ],
    [
      [
        36171,
        70515
      ],
      [
        -37,
        109
      ],
      [
        -62,
        32
      ],
      [
        -25,
        33
      ],
      [
        25,
        22
      ],
      [
        0,
        32
      ],
      [
        -37,
        130
      ],
      [
        -13,
        65
      ],
      [
        -12,
        11
      ],
      [
        0,
        54
      ],
      [
        37,
        -75
      ],
      [
        13,
        -76
      ],
      [
        24,
        -65
      ],
      [
        13,
        -109
      ],
      [
        49,
        -43
      ],
      [
        25,
        -55
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        35886,
        70862
      ],
      [
        -37,
        11
      ],
      [
        -62,
        76
      ],
      [
        -25,
        11
      ],
      [
        13,
        43
      ],
      [
        24,
        -21
      ],
      [
        38,
        -65
      ],
      [
        49,
        -55
      ]
    ],
    [
      [
        36320,
        71253
      ],
      [
        -25,
        -76
      ],
      [
        -25,
        11
      ],
      [
        13,
        87
      ],
      [
        24,
        10
      ],
      [
        13,
        -32
      ]
    ],
    [
      [
        35205,
        71361
      ],
      [
        0,
        -11
      ],
      [
        -37,
        -43
      ],
      [
        24,
        -32
      ],
      [
        25,
        65
      ],
      [
        25,
        -44
      ],
      [
        12,
        -97
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -76
      ],
      [
        -62,
        0
      ],
      [
        0,
        76
      ],
      [
        -13,
        11
      ],
      [
        -12,
        97
      ],
      [
        -25,
        33
      ],
      [
        -25,
        76
      ],
      [
        13,
        21
      ],
      [
        37,
        0
      ],
      [
        49,
        22
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        36010,
        71329
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        -11
      ],
      [
        37,
        76
      ],
      [
        -37,
        44
      ],
      [
        -37,
        97
      ],
      [
        -12,
        22
      ],
      [
        0,
        43
      ],
      [
        -38,
        33
      ],
      [
        13,
        32
      ],
      [
        25,
        -11
      ],
      [
        37,
        -141
      ],
      [
        0,
        -21
      ],
      [
        74,
        -141
      ]
    ],
    [
      [
        35316,
        71839
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        11
      ],
      [
        12,
        32
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        25,
        -22
      ],
      [
        -25,
        -21
      ]
    ],
    [
      [
        35180,
        71643
      ],
      [
        0,
        -152
      ],
      [
        -37,
        -32
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -21
      ],
      [
        -24,
        -33
      ],
      [
        -13,
        54
      ],
      [
        -12,
        22
      ],
      [
        0,
        54
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        44
      ],
      [
        -25,
        54
      ],
      [
        37,
        11
      ],
      [
        13,
        -33
      ],
      [
        25,
        33
      ],
      [
        -25,
        65
      ],
      [
        37,
        97
      ],
      [
        12,
        76
      ],
      [
        -12,
        98
      ],
      [
        12,
        11
      ],
      [
        50,
        -44
      ],
      [
        12,
        -32
      ],
      [
        0,
        -43
      ],
      [
        25,
        -44
      ],
      [
        25,
        -97
      ],
      [
        37,
        -55
      ]
    ],
    [
      [
        35552,
        72131
      ],
      [
        62,
        -65
      ],
      [
        49,
        -32
      ],
      [
        50,
        -87
      ],
      [
        24,
        -33
      ],
      [
        -12,
        -151
      ],
      [
        -12,
        -87
      ],
      [
        -13,
        -44
      ],
      [
        -12,
        44
      ],
      [
        -25,
        43
      ],
      [
        37,
        0
      ],
      [
        0,
        76
      ],
      [
        25,
        54
      ],
      [
        0,
        55
      ],
      [
        -49,
        65
      ],
      [
        -25,
        54
      ],
      [
        -50,
        22
      ],
      [
        -37,
        54
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -11
      ],
      [
        25,
        76
      ],
      [
        25,
        -44
      ]
    ],
    [
      [
        34920,
        72912
      ],
      [
        37,
        -22
      ],
      [
        37,
        11
      ],
      [
        62,
        0
      ],
      [
        50,
        22
      ],
      [
        12,
        -54
      ],
      [
        -111,
        -11
      ],
      [
        -99,
        -54
      ],
      [
        -50,
        -33
      ],
      [
        -50,
        11
      ],
      [
        -62,
        108
      ],
      [
        25,
        -10
      ],
      [
        37,
        -65
      ],
      [
        38,
        10
      ],
      [
        24,
        44
      ],
      [
        0,
        43
      ],
      [
        13,
        44
      ],
      [
        37,
        -44
      ]
    ],
    [
      [
        35353,
        72392
      ],
      [
        -12,
        0
      ],
      [
        -25,
        65
      ],
      [
        -24,
        11
      ],
      [
        37,
        43
      ],
      [
        12,
        43
      ],
      [
        0,
        87
      ],
      [
        12,
        43
      ],
      [
        0,
        33
      ],
      [
        13,
        43
      ],
      [
        -13,
        44
      ],
      [
        -37,
        32
      ],
      [
        -62,
        152
      ],
      [
        -99,
        33
      ],
      [
        0,
        21
      ],
      [
        50,
        -21
      ],
      [
        37,
        0
      ],
      [
        37,
        -44
      ],
      [
        25,
        -54
      ],
      [
        37,
        -33
      ],
      [
        0,
        -32
      ],
      [
        37,
        -33
      ],
      [
        25,
        -43
      ],
      [
        12,
        -119
      ],
      [
        -37,
        -54
      ],
      [
        -12,
        -185
      ],
      [
        -13,
        -32
      ]
    ],
    [
      [
        68465,
        84245
      ],
      [
        74,
        22
      ],
      [
        50,
        -32
      ],
      [
        -25,
        -98
      ],
      [
        -62,
        -141
      ],
      [
        0,
        -87
      ],
      [
        12,
        -21
      ],
      [
        25,
        -11
      ],
      [
        37,
        -33
      ],
      [
        37,
        -43
      ],
      [
        50,
        -76
      ],
      [
        -12,
        -33
      ],
      [
        -38,
        -11
      ],
      [
        -61,
        11
      ],
      [
        0,
        -32
      ],
      [
        37,
        -54
      ],
      [
        37,
        -87
      ],
      [
        0,
        -76
      ],
      [
        -13,
        -22
      ],
      [
        -24,
        22
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        68527,
        83410
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -12,
        -21
      ],
      [
        37,
        -87
      ],
      [
        -12,
        -44
      ],
      [
        -13,
        -10
      ],
      [
        -12,
        43
      ],
      [
        -25,
        0
      ],
      [
        -62,
        -76
      ],
      [
        -24,
        -43
      ],
      [
        0,
        -76
      ],
      [
        -38,
        -11
      ],
      [
        -24,
        -33
      ],
      [
        12,
        -75
      ],
      [
        0,
        -44
      ],
      [
        25,
        -65
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -33
      ]
    ],
    [
      [
        68267,
        82803
      ],
      [
        -50,
        22
      ],
      [
        -62,
        54
      ],
      [
        -62,
        76
      ],
      [
        -62,
        65
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        68006,
        83009
      ],
      [
        -37,
        22
      ]
    ],
    [
      [
        67969,
        83031
      ],
      [
        25,
        21
      ],
      [
        0,
        44
      ],
      [
        -87,
        97
      ],
      [
        -37,
        76
      ],
      [
        0,
        87
      ],
      [
        -62,
        43
      ],
      [
        -74,
        76
      ],
      [
        -62,
        87
      ],
      [
        0,
        22
      ],
      [
        -37,
        65
      ],
      [
        -37,
        54
      ],
      [
        -37,
        33
      ],
      [
        -62,
        97
      ],
      [
        -25,
        163
      ],
      [
        -25,
        43
      ],
      [
        -62,
        87
      ],
      [
        -49,
        54
      ],
      [
        0,
        55
      ],
      [
        24,
        216
      ],
      [
        25,
        11
      ],
      [
        50,
        -21
      ],
      [
        49,
        -76
      ],
      [
        50,
        -33
      ],
      [
        25,
        33
      ],
      [
        24,
        65
      ],
      [
        25,
        32
      ],
      [
        87,
        -11
      ],
      [
        49,
        44
      ],
      [
        75,
        -65
      ],
      [
        24,
        -11
      ],
      [
        38,
        11
      ],
      [
        74,
        -33
      ],
      [
        37,
        33
      ],
      [
        62,
        -54
      ],
      [
        12,
        0
      ],
      [
        50,
        32
      ],
      [
        50,
        -11
      ],
      [
        49,
        11
      ],
      [
        74,
        -32
      ],
      [
        50,
        0
      ],
      [
        37,
        -33
      ],
      [
        12,
        -33
      ],
      [
        0,
        -43
      ],
      [
        13,
        -22
      ],
      [
        37,
        -10
      ],
      [
        25,
        10
      ]
    ],
    [
      [
        72850,
        88757
      ],
      [
        -62,
        11
      ],
      [
        -74,
        -11
      ],
      [
        -50,
        -33
      ],
      [
        -49,
        22
      ],
      [
        -38,
        -22
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        -86
      ],
      [
        -12,
        -55
      ],
      [
        25,
        -75
      ],
      [
        0,
        -44
      ],
      [
        12,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        11
      ],
      [
        -37,
        33
      ],
      [
        -13,
        43
      ],
      [
        -49,
        44
      ],
      [
        -37,
        10
      ],
      [
        -50,
        -21
      ],
      [
        -74,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -24,
        -22
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        65
      ],
      [
        -37,
        76
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -32
      ],
      [
        -49,
        -22
      ],
      [
        -38,
        -65
      ],
      [
        -24,
        11
      ],
      [
        -25,
        54
      ],
      [
        -99,
        22
      ],
      [
        -37,
        21
      ],
      [
        -38,
        -32
      ],
      [
        -24,
        0
      ],
      [
        -50,
        21
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -10
      ],
      [
        0,
        65
      ],
      [
        -87,
        21
      ],
      [
        -24,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -38,
        87
      ],
      [
        -24,
        11
      ],
      [
        -38,
        -11
      ],
      [
        -62,
        11
      ],
      [
        -111,
        32
      ],
      [
        -25,
        11
      ],
      [
        -210,
        55
      ],
      [
        -75,
        0
      ],
      [
        -99,
        10
      ],
      [
        -74,
        -10
      ],
      [
        -25,
        -11
      ],
      [
        -99,
        -11
      ],
      [
        -74,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        -65
      ],
      [
        -49,
        -65
      ],
      [
        -50,
        -44
      ],
      [
        -62,
        33
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        70050,
        88399
      ],
      [
        -24,
        54
      ],
      [
        0,
        65
      ],
      [
        24,
        55
      ],
      [
        0,
        43
      ],
      [
        13,
        65
      ],
      [
        0,
        43
      ],
      [
        -62,
        76
      ],
      [
        -50,
        22
      ],
      [
        -49,
        33
      ],
      [
        0,
        54
      ],
      [
        74,
        108
      ],
      [
        25,
        22
      ],
      [
        124,
        76
      ],
      [
        24,
        22
      ],
      [
        0,
        130
      ],
      [
        -12,
        76
      ],
      [
        0,
        43
      ],
      [
        -25,
        108
      ],
      [
        -74,
        207
      ],
      [
        -37,
        206
      ]
    ],
    [
      [
        70001,
        89907
      ],
      [
        25,
        -11
      ],
      [
        62,
        0
      ],
      [
        49,
        11
      ],
      [
        74,
        0
      ],
      [
        38,
        10
      ],
      [
        37,
        -43
      ],
      [
        111,
        54
      ],
      [
        50,
        0
      ],
      [
        12,
        22
      ],
      [
        13,
        65
      ],
      [
        12,
        22
      ],
      [
        62,
        -11
      ],
      [
        37,
        54
      ],
      [
        37,
        22
      ],
      [
        37,
        0
      ],
      [
        25,
        21
      ],
      [
        25,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        24,
        -21
      ],
      [
        37,
        0
      ],
      [
        38,
        21
      ],
      [
        -13,
        55
      ],
      [
        -62,
        32
      ],
      [
        0,
        33
      ],
      [
        37,
        97
      ],
      [
        25,
        22
      ],
      [
        -12,
        43
      ],
      [
        0,
        55
      ],
      [
        25,
        76
      ],
      [
        24,
        54
      ],
      [
        87,
        21
      ],
      [
        25,
        22
      ],
      [
        37,
        87
      ],
      [
        112,
        0
      ],
      [
        12,
        43
      ],
      [
        37,
        22
      ],
      [
        12,
        22
      ],
      [
        -37,
        21
      ],
      [
        -62,
        11
      ],
      [
        -12,
        33
      ],
      [
        25,
        43
      ],
      [
        25,
        109
      ],
      [
        0,
        32
      ]
    ],
    [
      [
        71079,
        90991
      ],
      [
        61,
        11
      ],
      [
        62,
        76
      ],
      [
        25,
        11
      ],
      [
        186,
        -22
      ],
      [
        25,
        76
      ],
      [
        86,
        98
      ],
      [
        50,
        32
      ],
      [
        37,
        11
      ]
    ],
    [
      [
        71611,
        91284
      ],
      [
        50,
        -54
      ],
      [
        37,
        21
      ],
      [
        49,
        0
      ],
      [
        50,
        -54
      ],
      [
        12,
        -32
      ],
      [
        25,
        -11
      ],
      [
        50,
        43
      ],
      [
        49,
        11
      ],
      [
        99,
        -54
      ],
      [
        13,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        50,
        -54
      ],
      [
        49,
        32
      ],
      [
        12,
        22
      ],
      [
        50,
        11
      ],
      [
        50,
        33
      ],
      [
        24,
        -11
      ],
      [
        75,
        11
      ],
      [
        74,
        -33
      ],
      [
        0,
        -22
      ],
      [
        50,
        -32
      ],
      [
        37,
        -54
      ],
      [
        62,
        -11
      ],
      [
        0,
        -130
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -32
      ],
      [
        25,
        -33
      ],
      [
        24,
        -54
      ],
      [
        0,
        -54
      ],
      [
        -49,
        -87
      ],
      [
        -13,
        -76
      ],
      [
        75,
        -54
      ],
      [
        49,
        -44
      ],
      [
        -24,
        -86
      ],
      [
        37,
        -22
      ],
      [
        25,
        -43
      ],
      [
        12,
        -66
      ],
      [
        37,
        -54
      ],
      [
        74,
        -54
      ],
      [
        62,
        -33
      ],
      [
        13,
        -21
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        25,
        -11
      ],
      [
        62,
        0
      ],
      [
        62,
        -11
      ],
      [
        86,
        -54
      ],
      [
        0,
        -76
      ],
      [
        87,
        -76
      ],
      [
        12,
        -54
      ],
      [
        -24,
        -22
      ],
      [
        -62,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        -62,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -99,
        11
      ],
      [
        -25,
        22
      ],
      [
        -12,
        32
      ],
      [
        -25,
        11
      ],
      [
        -99,
        -11
      ],
      [
        -49,
        -108
      ],
      [
        61,
        -98
      ],
      [
        38,
        -43
      ],
      [
        12,
        -33
      ],
      [
        -25,
        -21
      ],
      [
        37,
        -98
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -141
      ],
      [
        25,
        -22
      ],
      [
        37,
        -86
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        31699,
        67099
      ],
      [
        0,
        44
      ],
      [
        13,
        32
      ],
      [
        12,
        -11
      ],
      [
        -25,
        -65
      ]
    ],
    [
      [
        31662,
        67414
      ],
      [
        0,
        43
      ],
      [
        25,
        98
      ],
      [
        12,
        -11
      ],
      [
        -37,
        -130
      ]
    ],
    [
      [
        31340,
        66145
      ],
      [
        -74,
        0
      ],
      [
        -38,
        -11
      ],
      [
        -12,
        11
      ],
      [
        12,
        152
      ],
      [
        0,
        412
      ],
      [
        13,
        173
      ],
      [
        0,
        304
      ],
      [
        12,
        152
      ]
    ],
    [
      [
        31253,
        67338
      ],
      [
        0,
        97
      ],
      [
        37,
        22
      ],
      [
        38,
        -32
      ],
      [
        12,
        -22
      ],
      [
        25,
        32
      ],
      [
        25,
        65
      ],
      [
        61,
        141
      ],
      [
        13,
        98
      ],
      [
        25,
        22
      ],
      [
        24,
        0
      ],
      [
        38,
        -11
      ]
    ],
    [
      [
        31551,
        67750
      ],
      [
        -25,
        -65
      ],
      [
        25,
        -11
      ],
      [
        49,
        0
      ],
      [
        12,
        -76
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -174
      ],
      [
        0,
        -54
      ],
      [
        -24,
        -87
      ],
      [
        24,
        -65
      ],
      [
        -24,
        -76
      ],
      [
        0,
        -119
      ],
      [
        12,
        -152
      ],
      [
        -25,
        -206
      ],
      [
        -25,
        -86
      ],
      [
        -24,
        -33
      ],
      [
        -38,
        -87
      ],
      [
        -49,
        -32
      ],
      [
        -62,
        -141
      ],
      [
        -12,
        -44
      ],
      [
        12,
        -32
      ]
    ],
    [
      [
        39652,
        76383
      ],
      [
        -13,
        10
      ],
      [
        25,
        55
      ],
      [
        13,
        -11
      ],
      [
        -25,
        -54
      ]
    ],
    [
      [
        38810,
        41960
      ],
      [
        -137,
        -43
      ],
      [
        -74,
        0
      ],
      [
        -37,
        65
      ],
      [
        0,
        32
      ],
      [
        12,
        65
      ],
      [
        0,
        87
      ],
      [
        -25,
        98
      ],
      [
        0,
        76
      ],
      [
        -12,
        97
      ],
      [
        -37,
        44
      ],
      [
        -13,
        76
      ],
      [
        0,
        65
      ],
      [
        -24,
        86
      ],
      [
        0,
        196
      ],
      [
        -37,
        108
      ],
      [
        -50,
        119
      ],
      [
        -37,
        11
      ],
      [
        -13,
        44
      ],
      [
        0,
        54
      ],
      [
        38,
        76
      ],
      [
        -13,
        21
      ],
      [
        -62,
        76
      ],
      [
        -25,
        44
      ],
      [
        0,
        32
      ],
      [
        25,
        22
      ],
      [
        -12,
        65
      ],
      [
        0,
        54
      ],
      [
        -13,
        33
      ],
      [
        13,
        11
      ],
      [
        49,
        21
      ],
      [
        13,
        44
      ],
      [
        0,
        43
      ],
      [
        -13,
        33
      ],
      [
        -37,
        65
      ],
      [
        0,
        10
      ],
      [
        37,
        109
      ],
      [
        38,
        65
      ],
      [
        0,
        43
      ],
      [
        -25,
        22
      ],
      [
        -50,
        65
      ],
      [
        -25,
        54
      ],
      [
        -61,
        76
      ],
      [
        -13,
        44
      ],
      [
        0,
        97
      ],
      [
        -12,
        98
      ],
      [
        -13,
        65
      ],
      [
        0,
        76
      ],
      [
        -12,
        43
      ],
      [
        0,
        44
      ],
      [
        -12,
        54
      ],
      [
        -13,
        32
      ],
      [
        13,
        33
      ],
      [
        12,
        11
      ],
      [
        0,
        21
      ],
      [
        -74,
        66
      ],
      [
        -13,
        108
      ],
      [
        -49,
        87
      ],
      [
        -13,
        76
      ]
    ],
    [
      [
        38004,
        45279
      ],
      [
        0,
        76
      ],
      [
        -12,
        32
      ],
      [
        -25,
        22
      ],
      [
        0,
        65
      ],
      [
        62,
        65
      ],
      [
        87,
        195
      ],
      [
        25,
        44
      ],
      [
        24,
        21
      ],
      [
        13,
        22
      ],
      [
        -13,
        54
      ],
      [
        13,
        44
      ],
      [
        0,
        32
      ],
      [
        37,
        22
      ],
      [
        25,
        32
      ],
      [
        0,
        22
      ],
      [
        -25,
        32
      ],
      [
        -50,
        22
      ],
      [
        -24,
        0
      ],
      [
        -25,
        22
      ],
      [
        -13,
        22
      ],
      [
        -49,
        260
      ],
      [
        -12,
        54
      ],
      [
        0,
        33
      ],
      [
        49,
        162
      ],
      [
        37,
        65
      ],
      [
        -62,
        120
      ],
      [
        -12,
        43
      ],
      [
        0,
        54
      ],
      [
        12,
        54
      ],
      [
        25,
        33
      ],
      [
        12,
        43
      ],
      [
        0,
        55
      ],
      [
        25,
        32
      ],
      [
        13,
        44
      ],
      [
        37,
        54
      ],
      [
        0,
        76
      ],
      [
        49,
        32
      ],
      [
        0,
        65
      ],
      [
        -37,
        76
      ],
      [
        -12,
        130
      ],
      [
        -25,
        55
      ],
      [
        25,
        54
      ],
      [
        12,
        65
      ],
      [
        0,
        379
      ],
      [
        13,
        44
      ],
      [
        24,
        43
      ],
      [
        25,
        11
      ],
      [
        12,
        33
      ],
      [
        0,
        43
      ],
      [
        25,
        65
      ],
      [
        -37,
        152
      ],
      [
        -49,
        119
      ],
      [
        -38,
        119
      ],
      [
        -37,
        141
      ],
      [
        -37,
        87
      ],
      [
        -37,
        120
      ],
      [
        -25,
        97
      ],
      [
        -49,
        130
      ]
    ],
    [
      [
        37980,
        49367
      ],
      [
        49,
        11
      ],
      [
        74,
        -11
      ],
      [
        75,
        -21
      ],
      [
        62,
        -11
      ],
      [
        24,
        -22
      ],
      [
        0,
        -32
      ],
      [
        13,
        -11
      ],
      [
        37,
        0
      ],
      [
        37,
        43
      ],
      [
        75,
        43
      ],
      [
        49,
        120
      ],
      [
        25,
        54
      ],
      [
        87,
        22
      ],
      [
        12,
        -11
      ],
      [
        25,
        0
      ],
      [
        49,
        108
      ],
      [
        50,
        76
      ],
      [
        37,
        22
      ],
      [
        12,
        22
      ],
      [
        38,
        0
      ],
      [
        161,
        216
      ],
      [
        49,
        44
      ],
      [
        37,
        11
      ],
      [
        75,
        32
      ],
      [
        111,
        33
      ],
      [
        74,
        11
      ],
      [
        25,
        -33
      ],
      [
        25,
        11
      ],
      [
        25,
        43
      ],
      [
        12,
        11
      ],
      [
        25,
        0
      ],
      [
        25,
        -97
      ],
      [
        0,
        -239
      ],
      [
        -25,
        -87
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -76
      ],
      [
        13,
        -87
      ],
      [
        24,
        -108
      ],
      [
        13,
        -87
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -109
      ],
      [
        12,
        -11
      ],
      [
        13,
        -32
      ],
      [
        0,
        -54
      ],
      [
        12,
        -44
      ],
      [
        25,
        -43
      ],
      [
        12,
        -44
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -22
      ],
      [
        25,
        -11
      ],
      [
        12,
        11
      ],
      [
        25,
        -54
      ],
      [
        12,
        -54
      ],
      [
        0,
        -33
      ],
      [
        50,
        -43
      ],
      [
        24,
        -11
      ],
      [
        25,
        -54
      ],
      [
        25,
        -44
      ],
      [
        37,
        -21
      ],
      [
        13,
        -54
      ],
      [
        24,
        -66
      ],
      [
        50,
        -32
      ],
      [
        74,
        -11
      ],
      [
        37,
        -11
      ],
      [
        50,
        33
      ],
      [
        37,
        0
      ],
      [
        50,
        -44
      ],
      [
        24,
        -43
      ],
      [
        75,
        -65
      ],
      [
        25,
        32
      ],
      [
        24,
        11
      ],
      [
        13,
        -11
      ],
      [
        12,
        -54
      ],
      [
        25,
        -65
      ],
      [
        49,
        -65
      ],
      [
        25,
        -22
      ],
      [
        25,
        0
      ],
      [
        49,
        -43
      ],
      [
        62,
        -43
      ],
      [
        38,
        -11
      ],
      [
        24,
        11
      ],
      [
        25,
        -22
      ],
      [
        0,
        -43
      ],
      [
        50,
        -109
      ],
      [
        24,
        -43
      ],
      [
        38,
        -33
      ],
      [
        74,
        0
      ],
      [
        25,
        -11
      ],
      [
        25,
        11
      ],
      [
        99,
        22
      ],
      [
        24,
        0
      ],
      [
        50,
        -43
      ],
      [
        62,
        -66
      ],
      [
        49,
        -43
      ],
      [
        25,
        -32
      ],
      [
        25,
        -44
      ],
      [
        12,
        -54
      ],
      [
        0,
        -98
      ],
      [
        -24,
        -54
      ],
      [
        24,
        -87
      ],
      [
        13,
        -54
      ],
      [
        12,
        -98
      ],
      [
        13,
        -32
      ],
      [
        12,
        -293
      ],
      [
        -112,
        0
      ],
      [
        25,
        -32
      ],
      [
        50,
        -109
      ],
      [
        49,
        -97
      ],
      [
        0,
        -163
      ],
      [
        13,
        -109
      ],
      [
        0,
        -141
      ],
      [
        12,
        -86
      ],
      [
        112,
        -11
      ],
      [
        136,
        0
      ],
      [
        161,
        -11
      ],
      [
        161,
        -11
      ],
      [
        49,
        22
      ],
      [
        13,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -98
      ],
      [
        0,
        -163
      ],
      [
        13,
        -108
      ],
      [
        12,
        -87
      ],
      [
        12,
        -32
      ],
      [
        50,
        -55
      ],
      [
        74,
        -86
      ],
      [
        37,
        -22
      ],
      [
        25,
        22
      ],
      [
        13,
        -44
      ],
      [
        0,
        -65
      ],
      [
        37,
        -162
      ],
      [
        37,
        -120
      ],
      [
        0,
        -32
      ],
      [
        25,
        -22
      ],
      [
        0,
        -11
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -120
      ],
      [
        -25,
        -162
      ],
      [
        -24,
        -109
      ],
      [
        24,
        0
      ],
      [
        0,
        -87
      ],
      [
        -24,
        0
      ],
      [
        0,
        -21
      ],
      [
        -62,
        -217
      ],
      [
        -62,
        -195
      ],
      [
        99,
        -141
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        41919,
        43619
      ],
      [
        0,
        196
      ],
      [
        -13,
        21
      ],
      [
        -99,
        109
      ],
      [
        -99,
        97
      ],
      [
        -111,
        120
      ],
      [
        -161,
        0
      ],
      [
        -161,
        0
      ],
      [
        -149,
        -55
      ],
      [
        -149,
        -65
      ],
      [
        -74,
        -21
      ],
      [
        -136,
        -55
      ],
      [
        -87,
        -21
      ],
      [
        -62,
        -261
      ],
      [
        -25,
        -86
      ],
      [
        -37,
        -98
      ],
      [
        -62,
        -130
      ],
      [
        0,
        -315
      ],
      [
        -37,
        -217
      ],
      [
        -25,
        -184
      ],
      [
        -62,
        -293
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        45239,
        38869
      ],
      [
        -25,
        -32
      ],
      [
        12,
        151
      ],
      [
        13,
        55
      ],
      [
        24,
        54
      ],
      [
        13,
        -33
      ],
      [
        -13,
        -65
      ],
      [
        -24,
        -97
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        45214,
        39726
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        76
      ],
      [
        49,
        76
      ],
      [
        13,
        -33
      ],
      [
        -25,
        -108
      ]
    ],
    [
      [
        46353,
        41288
      ],
      [
        -49,
        -22
      ],
      [
        -13,
        22
      ],
      [
        50,
        108
      ],
      [
        25,
        -65
      ],
      [
        -13,
        -43
      ]
    ],
    [
      [
        46737,
        41754
      ],
      [
        0,
        -11
      ],
      [
        -62,
        -32
      ],
      [
        -12,
        32
      ],
      [
        37,
        54
      ],
      [
        13,
        0
      ],
      [
        24,
        -43
      ]
    ],
    [
      [
        48534,
        47795
      ],
      [
        0,
        -33
      ],
      [
        -25,
        0
      ],
      [
        0,
        33
      ],
      [
        -13,
        21
      ],
      [
        13,
        33
      ],
      [
        25,
        -11
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        48596,
        48033
      ],
      [
        -13,
        22
      ],
      [
        37,
        54
      ],
      [
        13,
        33
      ],
      [
        12,
        -44
      ],
      [
        -49,
        -65
      ]
    ],
    [
      [
        46614,
        54378
      ],
      [
        -38,
        -65
      ],
      [
        13,
        76
      ],
      [
        0,
        86
      ],
      [
        25,
        33
      ],
      [
        0,
        -130
      ]
    ],
    [
      [
        46477,
        55386
      ],
      [
        -24,
        -43
      ],
      [
        -13,
        11
      ],
      [
        0,
        22
      ],
      [
        13,
        43
      ],
      [
        24,
        0
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        44087,
        55321
      ],
      [
        -38,
        -11
      ],
      [
        50,
        152
      ],
      [
        49,
        76
      ],
      [
        0,
        141
      ],
      [
        38,
        130
      ],
      [
        49,
        55
      ],
      [
        50,
        10
      ],
      [
        37,
        -76
      ],
      [
        -37,
        -227
      ],
      [
        -13,
        0
      ],
      [
        -49,
        -109
      ],
      [
        -62,
        -86
      ],
      [
        -74,
        -55
      ]
    ],
    [
      [
        44855,
        56070
      ],
      [
        24,
        0
      ],
      [
        50,
        10
      ],
      [
        25,
        33
      ],
      [
        74,
        0
      ],
      [
        111,
        -33
      ],
      [
        62,
        -10
      ],
      [
        50,
        -22
      ],
      [
        25,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -120
      ],
      [
        -12,
        -76
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        11
      ],
      [
        12,
        -76
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        -130
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        -33
      ],
      [
        12,
        -32
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        11
      ],
      [
        -37,
        54
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -32
      ],
      [
        -50,
        0
      ],
      [
        -12,
        32
      ],
      [
        -37,
        22
      ],
      [
        -13,
        -76
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -21
      ],
      [
        -38,
        21
      ],
      [
        -37,
        33
      ],
      [
        -24,
        0
      ],
      [
        -13,
        -22
      ],
      [
        -74,
        -11
      ],
      [
        -37,
        -21
      ],
      [
        -25,
        0
      ],
      [
        -37,
        97
      ],
      [
        -13,
        76
      ],
      [
        -24,
        87
      ],
      [
        -13,
        87
      ],
      [
        13,
        65
      ],
      [
        24,
        0
      ],
      [
        25,
        -11
      ],
      [
        0,
        43
      ],
      [
        -37,
        0
      ],
      [
        -37,
        44
      ],
      [
        0,
        65
      ],
      [
        12,
        141
      ],
      [
        0,
        21
      ],
      [
        25,
        76
      ],
      [
        -12,
        33
      ],
      [
        24,
        130
      ],
      [
        62,
        65
      ],
      [
        75,
        33
      ],
      [
        223,
        -76
      ]
    ],
    [
      [
        44495,
        56135
      ],
      [
        -86,
        -130
      ],
      [
        -38,
        43
      ],
      [
        -12,
        22
      ],
      [
        25,
        76
      ],
      [
        49,
        32
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        44916,
        56146
      ],
      [
        -99,
        -22
      ],
      [
        -37,
        32
      ],
      [
        37,
        65
      ],
      [
        38,
        33
      ],
      [
        37,
        11
      ],
      [
        37,
        -11
      ],
      [
        12,
        -43
      ],
      [
        -25,
        -65
      ]
    ],
    [
      [
        44817,
        56384
      ],
      [
        13,
        -32
      ],
      [
        -50,
        -131
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -37,
        32
      ],
      [
        -62,
        0
      ],
      [
        -12,
        11
      ],
      [
        0,
        54
      ],
      [
        25,
        65
      ],
      [
        49,
        -10
      ],
      [
        87,
        54
      ],
      [
        49,
        -22
      ]
    ],
    [
      [
        44570,
        56297
      ],
      [
        0,
        -86
      ],
      [
        -62,
        32
      ],
      [
        0,
        98
      ],
      [
        37,
        32
      ],
      [
        25,
        44
      ],
      [
        0,
        141
      ],
      [
        12,
        21
      ],
      [
        25,
        0
      ],
      [
        0,
        -206
      ],
      [
        -37,
        -76
      ]
    ],
    [
      [
        44669,
        56460
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        22
      ],
      [
        0,
        76
      ],
      [
        13,
        43
      ],
      [
        49,
        11
      ],
      [
        25,
        22
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -76
      ]
    ],
    [
      [
        44619,
        57425
      ],
      [
        -37,
        -32
      ],
      [
        -12,
        11
      ],
      [
        -25,
        75
      ],
      [
        12,
        66
      ],
      [
        25,
        21
      ],
      [
        25,
        -11
      ],
      [
        12,
        -108
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        42489,
        57425
      ],
      [
        12,
        0
      ],
      [
        149,
        -65
      ],
      [
        24,
        11
      ],
      [
        13,
        22
      ],
      [
        0,
        97
      ],
      [
        -13,
        33
      ],
      [
        -24,
        43
      ],
      [
        -13,
        44
      ],
      [
        -25,
        10
      ],
      [
        0,
        33
      ],
      [
        38,
        54
      ],
      [
        12,
        76
      ],
      [
        37,
        -11
      ],
      [
        50,
        -54
      ],
      [
        24,
        11
      ],
      [
        100,
        11
      ],
      [
        12,
        32
      ],
      [
        12,
        0
      ],
      [
        38,
        33
      ],
      [
        37,
        0
      ],
      [
        24,
        32
      ],
      [
        13,
        0
      ],
      [
        0,
        -32
      ],
      [
        12,
        -33
      ],
      [
        25,
        -32
      ],
      [
        37,
        11
      ],
      [
        13,
        -11
      ],
      [
        12,
        -33
      ],
      [
        0,
        -21
      ],
      [
        12,
        -22
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        43133,
        57664
      ],
      [
        12,
        0
      ],
      [
        25,
        -44
      ],
      [
        25,
        -32
      ],
      [
        49,
        -33
      ],
      [
        25,
        0
      ],
      [
        37,
        -21
      ],
      [
        13,
        21
      ],
      [
        49,
        55
      ],
      [
        37,
        54
      ],
      [
        25,
        22
      ],
      [
        12,
        -33
      ],
      [
        13,
        -11
      ],
      [
        62,
        -22
      ],
      [
        62,
        55
      ],
      [
        24,
        -65
      ],
      [
        13,
        -22
      ],
      [
        12,
        11
      ],
      [
        62,
        -22
      ],
      [
        13,
        0
      ],
      [
        24,
        22
      ],
      [
        13,
        32
      ],
      [
        24,
        33
      ],
      [
        25,
        22
      ],
      [
        25,
        43
      ],
      [
        25,
        65
      ],
      [
        0,
        76
      ],
      [
        37,
        130
      ],
      [
        25,
        65
      ],
      [
        12,
        54
      ],
      [
        0,
        44
      ],
      [
        25,
        76
      ],
      [
        37,
        76
      ],
      [
        12,
        54
      ],
      [
        50,
        119
      ],
      [
        0,
        43
      ],
      [
        12,
        11
      ],
      [
        25,
        65
      ],
      [
        13,
        22
      ],
      [
        24,
        76
      ],
      [
        37,
        43
      ]
    ],
    [
      [
        44148,
        58748
      ],
      [
        38,
        109
      ],
      [
        0,
        54
      ],
      [
        37,
        0
      ],
      [
        37,
        -54
      ],
      [
        37,
        -87
      ],
      [
        50,
        -260
      ],
      [
        12,
        -250
      ],
      [
        25,
        -119
      ],
      [
        49,
        -271
      ],
      [
        13,
        -54
      ],
      [
        0,
        -55
      ],
      [
        25,
        -65
      ],
      [
        12,
        -97
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        24,
        0
      ],
      [
        13,
        -22
      ],
      [
        12,
        -65
      ],
      [
        12,
        -44
      ],
      [
        38,
        -54
      ],
      [
        49,
        -22
      ],
      [
        37,
        -10
      ],
      [
        50,
        -33
      ],
      [
        25,
        -43
      ],
      [
        37,
        -152
      ],
      [
        -13,
        -98
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -21
      ],
      [
        -37,
        -44
      ],
      [
        -87,
        -141
      ],
      [
        -12,
        -43
      ],
      [
        -50,
        -76
      ],
      [
        -37,
        -130
      ],
      [
        -62,
        -130
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        -108
      ],
      [
        -62,
        -33
      ],
      [
        -13,
        -54
      ],
      [
        -37,
        -130
      ],
      [
        -25,
        -76
      ],
      [
        -24,
        -22
      ],
      [
        -50,
        -141
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -97
      ],
      [
        -25,
        -66
      ],
      [
        -37,
        -43
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        -22
      ],
      [
        -75,
        22
      ],
      [
        -111,
        -98
      ],
      [
        87,
        -32
      ],
      [
        37,
        -44
      ],
      [
        86,
        33
      ],
      [
        112,
        119
      ],
      [
        37,
        22
      ],
      [
        74,
        86
      ],
      [
        38,
        55
      ],
      [
        61,
        65
      ],
      [
        38,
        54
      ],
      [
        24,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -24,
        -44
      ],
      [
        0,
        -32
      ],
      [
        24,
        -33
      ],
      [
        0,
        -54
      ],
      [
        13,
        -43
      ],
      [
        0,
        -76
      ],
      [
        37,
        -87
      ],
      [
        0,
        -76
      ],
      [
        25,
        -32
      ],
      [
        74,
        -130
      ],
      [
        50,
        65
      ],
      [
        24,
        10
      ],
      [
        25,
        22
      ],
      [
        37,
        22
      ],
      [
        37,
        -22
      ],
      [
        62,
        -43
      ],
      [
        50,
        43
      ],
      [
        87,
        87
      ],
      [
        -25,
        -152
      ],
      [
        -25,
        -141
      ],
      [
        -12,
        -54
      ],
      [
        -13,
        -152
      ],
      [
        -24,
        -43
      ],
      [
        12,
        -22
      ],
      [
        37,
        76
      ],
      [
        25,
        97
      ],
      [
        62,
        272
      ],
      [
        25,
        21
      ],
      [
        49,
        33
      ],
      [
        99,
        217
      ],
      [
        37,
        0
      ],
      [
        25,
        -54
      ],
      [
        25,
        -33
      ],
      [
        0,
        65
      ],
      [
        37,
        22
      ],
      [
        -37,
        32
      ],
      [
        0,
        65
      ],
      [
        12,
        55
      ],
      [
        -12,
        54
      ],
      [
        49,
        65
      ],
      [
        0,
        54
      ],
      [
        13,
        43
      ],
      [
        25,
        44
      ],
      [
        24,
        11
      ],
      [
        13,
        43
      ],
      [
        25,
        22
      ],
      [
        24,
        -44
      ],
      [
        25,
        44
      ],
      [
        25,
        21
      ],
      [
        25,
        -32
      ],
      [
        24,
        0
      ],
      [
        38,
        32
      ],
      [
        37,
        -54
      ],
      [
        12,
        22
      ],
      [
        -12,
        22
      ],
      [
        0,
        21
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        25,
        -21
      ],
      [
        24,
        -44
      ],
      [
        62,
        0
      ],
      [
        25,
        -21
      ],
      [
        25,
        0
      ],
      [
        12,
        -33
      ],
      [
        37,
        -43
      ],
      [
        13,
        -44
      ],
      [
        37,
        -11
      ],
      [
        62,
        -32
      ],
      [
        37,
        11
      ],
      [
        0,
        -44
      ],
      [
        25,
        -11
      ],
      [
        37,
        11
      ],
      [
        25,
        -54
      ],
      [
        62,
        -43
      ],
      [
        49,
        -54
      ],
      [
        37,
        10
      ],
      [
        25,
        -21
      ],
      [
        37,
        -130
      ],
      [
        13,
        -98
      ],
      [
        12,
        22
      ],
      [
        37,
        108
      ],
      [
        37,
        33
      ],
      [
        13,
        -33
      ],
      [
        37,
        -43
      ],
      [
        37,
        -55
      ],
      [
        12,
        -32
      ],
      [
        25,
        -11
      ],
      [
        0,
        -32
      ],
      [
        25,
        32
      ],
      [
        12,
        -65
      ],
      [
        25,
        -65
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        12,
        -33
      ],
      [
        25,
        -32
      ],
      [
        25,
        86
      ],
      [
        12,
        22
      ],
      [
        37,
        11
      ],
      [
        13,
        -54
      ],
      [
        0,
        -65
      ],
      [
        -50,
        -22
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -120
      ],
      [
        -25,
        -238
      ],
      [
        0,
        -33
      ],
      [
        37,
        43
      ],
      [
        62,
        120
      ],
      [
        13,
        130
      ],
      [
        24,
        119
      ],
      [
        38,
        44
      ],
      [
        37,
        -11
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -98
      ],
      [
        12,
        -43
      ],
      [
        62,
        108
      ],
      [
        25,
        33
      ],
      [
        25,
        0
      ],
      [
        37,
        43
      ],
      [
        99,
        11
      ],
      [
        12,
        54
      ],
      [
        13,
        22
      ],
      [
        49,
        0
      ],
      [
        99,
        -54
      ],
      [
        37,
        -33
      ],
      [
        62,
        -43
      ],
      [
        25,
        -44
      ],
      [
        124,
        -86
      ],
      [
        74,
        0
      ],
      [
        50,
        32
      ],
      [
        49,
        -32
      ],
      [
        25,
        -55
      ],
      [
        62,
        -21
      ],
      [
        50,
        -11
      ],
      [
        49,
        32
      ],
      [
        112,
        11
      ],
      [
        136,
        44
      ],
      [
        74,
        -11
      ],
      [
        99,
        -33
      ],
      [
        62,
        -76
      ],
      [
        62,
        -43
      ],
      [
        37,
        -44
      ],
      [
        50,
        -43
      ],
      [
        111,
        -119
      ],
      [
        50,
        -65
      ],
      [
        62,
        -98
      ],
      [
        74,
        -43
      ],
      [
        37,
        -98
      ],
      [
        38,
        -43
      ],
      [
        74,
        -174
      ],
      [
        87,
        -108
      ],
      [
        62,
        -120
      ],
      [
        111,
        -75
      ],
      [
        37,
        -131
      ],
      [
        87,
        -10
      ],
      [
        25,
        -22
      ],
      [
        37,
        -54
      ],
      [
        62,
        -22
      ],
      [
        148,
        0
      ],
      [
        62,
        22
      ],
      [
        149,
        -44
      ],
      [
        50,
        -76
      ],
      [
        49,
        -195
      ],
      [
        37,
        -228
      ],
      [
        13,
        -162
      ],
      [
        37,
        -130
      ],
      [
        25,
        -250
      ],
      [
        12,
        -76
      ],
      [
        0,
        -54
      ],
      [
        12,
        -11
      ],
      [
        13,
        -173
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -87
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -32
      ],
      [
        12,
        -76
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -195
      ],
      [
        -74,
        -326
      ],
      [
        -62,
        -184
      ],
      [
        -87,
        -195
      ],
      [
        -49,
        -109
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        22
      ],
      [
        13,
        -54
      ],
      [
        -13,
        -44
      ],
      [
        -49,
        -141
      ],
      [
        -62,
        -97
      ],
      [
        -62,
        -163
      ],
      [
        -87,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -62,
        -98
      ],
      [
        -50,
        -141
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        11
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -119
      ],
      [
        -25,
        -22
      ],
      [
        0,
        44
      ],
      [
        13,
        21
      ],
      [
        -13,
        33
      ],
      [
        -25,
        -87
      ],
      [
        13,
        -65
      ],
      [
        -25,
        -98
      ],
      [
        -74,
        -282
      ],
      [
        -87,
        -227
      ],
      [
        -25,
        -76
      ],
      [
        -74,
        -163
      ],
      [
        -62,
        -76
      ],
      [
        -25,
        11
      ],
      [
        -12,
        119
      ],
      [
        -50,
        76
      ],
      [
        -12,
        11
      ],
      [
        -12,
        -76
      ],
      [
        -13,
        -21
      ],
      [
        -25,
        0
      ],
      [
        25,
        -44
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        -65
      ],
      [
        -24,
        -130
      ],
      [
        24,
        11
      ],
      [
        13,
        -11
      ],
      [
        0,
        -55
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -152
      ],
      [
        -12,
        -32
      ],
      [
        25,
        -33
      ],
      [
        -25,
        -347
      ],
      [
        12,
        -173
      ],
      [
        25,
        -391
      ],
      [
        25,
        -173
      ],
      [
        0,
        -11
      ],
      [
        -25,
        -206
      ],
      [
        -37,
        -195
      ],
      [
        -25,
        -163
      ],
      [
        -12,
        -174
      ],
      [
        -13,
        -86
      ],
      [
        0,
        -87
      ],
      [
        13,
        -206
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -97
      ],
      [
        -50,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        -49,
        -163
      ],
      [
        -37,
        -238
      ],
      [
        0,
        -130
      ],
      [
        12,
        -272
      ],
      [
        -12,
        -108
      ],
      [
        -13,
        -76
      ],
      [
        -24,
        -43
      ],
      [
        -50,
        -65
      ],
      [
        -50,
        -141
      ],
      [
        -24,
        -152
      ],
      [
        -25,
        -54
      ],
      [
        -13,
        -76
      ],
      [
        -24,
        -87
      ],
      [
        -75,
        -141
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -76
      ],
      [
        -49,
        -130
      ],
      [
        -25,
        -163
      ],
      [
        12,
        -65
      ],
      [
        13,
        -195
      ],
      [
        -13,
        -54
      ],
      [
        -37,
        -54
      ],
      [
        -161,
        -98
      ],
      [
        -37,
        -43
      ],
      [
        -99,
        -163
      ],
      [
        0,
        -98
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -54
      ],
      [
        -186,
        0
      ],
      [
        -87,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -49,
        44
      ],
      [
        0,
        32
      ],
      [
        12,
        55
      ],
      [
        -12,
        21
      ],
      [
        -50,
        -11
      ],
      [
        0,
        -54
      ],
      [
        12,
        -22
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -32
      ],
      [
        -49,
        0
      ],
      [
        -50,
        -33
      ],
      [
        -74,
        -11
      ],
      [
        -50,
        -22
      ],
      [
        -25,
        22
      ],
      [
        25,
        22
      ],
      [
        37,
        -11
      ],
      [
        37,
        22
      ],
      [
        -12,
        21
      ],
      [
        -49,
        44
      ],
      [
        -62,
        -22
      ],
      [
        -38,
        -43
      ],
      [
        -74,
        0
      ],
      [
        -99,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -55
      ],
      [
        37,
        -43
      ],
      [
        -13,
        -32
      ],
      [
        -24,
        -11
      ],
      [
        -99,
        -22
      ],
      [
        -87,
        -130
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        -54
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -37,
        22
      ],
      [
        -62,
        10
      ],
      [
        -49,
        -21
      ],
      [
        -223,
        -196
      ],
      [
        -87,
        -86
      ],
      [
        -87,
        -152
      ],
      [
        -161,
        -184
      ],
      [
        -86,
        -109
      ],
      [
        -13,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        25,
        -22
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -43
      ],
      [
        -62,
        -120
      ],
      [
        -13,
        11
      ],
      [
        25,
        54
      ],
      [
        -37,
        11
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -33
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -12,
        -32
      ],
      [
        86,
        -33
      ],
      [
        13,
        -32
      ],
      [
        -50,
        -141
      ],
      [
        -49,
        -11
      ],
      [
        0,
        -22
      ],
      [
        24,
        0
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -152
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        12,
        -44
      ],
      [
        25,
        -43
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -65
      ],
      [
        0,
        -54
      ],
      [
        24,
        -109
      ],
      [
        0,
        -108
      ],
      [
        13,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -43
      ],
      [
        13,
        -65
      ],
      [
        -25,
        -120
      ],
      [
        12,
        -162
      ],
      [
        0,
        -163
      ],
      [
        -24,
        -141
      ],
      [
        -38,
        -87
      ],
      [
        0,
        -87
      ],
      [
        -86,
        -75
      ],
      [
        -87,
        -109
      ],
      [
        -74,
        -119
      ],
      [
        -87,
        -185
      ],
      [
        -99,
        -271
      ],
      [
        -87,
        -390
      ],
      [
        -111,
        -293
      ],
      [
        -50,
        -108
      ],
      [
        -49,
        -120
      ],
      [
        -87,
        -141
      ],
      [
        -99,
        -141
      ],
      [
        -124,
        -119
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -76
      ],
      [
        -13,
        32
      ],
      [
        13,
        44
      ],
      [
        -13,
        43
      ],
      [
        0,
        54
      ],
      [
        25,
        11
      ],
      [
        37,
        -32
      ],
      [
        25,
        43
      ],
      [
        49,
        11
      ],
      [
        75,
        141
      ],
      [
        62,
        43
      ],
      [
        37,
        87
      ],
      [
        0,
        141
      ],
      [
        25,
        22
      ],
      [
        37,
        -11
      ],
      [
        12,
        32
      ],
      [
        -12,
        22
      ],
      [
        12,
        65
      ],
      [
        62,
        54
      ],
      [
        25,
        76
      ],
      [
        -12,
        174
      ],
      [
        12,
        11
      ],
      [
        25,
        -33
      ],
      [
        12,
        11
      ],
      [
        12,
        76
      ],
      [
        0,
        43
      ],
      [
        -37,
        11
      ],
      [
        -99,
        -87
      ],
      [
        -25,
        0
      ],
      [
        -12,
        65
      ],
      [
        -49,
        33
      ],
      [
        -13,
        54
      ],
      [
        0,
        44
      ],
      [
        -25,
        10
      ],
      [
        0,
        -65
      ],
      [
        13,
        -65
      ],
      [
        37,
        -76
      ],
      [
        -12,
        -21
      ],
      [
        -38,
        -120
      ],
      [
        0,
        -65
      ],
      [
        -12,
        11
      ],
      [
        -12,
        -97
      ],
      [
        -25,
        -44
      ],
      [
        -13,
        -43
      ],
      [
        13,
        -44
      ],
      [
        -87,
        -119
      ],
      [
        -99,
        -87
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -76
      ],
      [
        -38,
        -54
      ],
      [
        -24,
        -119
      ],
      [
        0,
        -54
      ],
      [
        24,
        -131
      ],
      [
        -24,
        -32
      ],
      [
        -50,
        -130
      ],
      [
        -49,
        -271
      ],
      [
        -50,
        -163
      ],
      [
        -37,
        -87
      ],
      [
        -211,
        -293
      ]
    ],
    [
      [
        43566,
        35138
      ],
      [
        -12,
        0
      ],
      [
        -50,
        55
      ],
      [
        0,
        303
      ],
      [
        25,
        65
      ],
      [
        25,
        33
      ],
      [
        25,
        54
      ],
      [
        37,
        65
      ],
      [
        25,
        54
      ],
      [
        0,
        33
      ],
      [
        -25,
        32
      ],
      [
        -50,
        33
      ],
      [
        -49,
        43
      ],
      [
        -37,
        65
      ],
      [
        -13,
        66
      ],
      [
        -25,
        65
      ],
      [
        -12,
        86
      ],
      [
        -37,
        33
      ],
      [
        -37,
        43
      ],
      [
        -87,
        44
      ],
      [
        -50,
        76
      ],
      [
        -62,
        130
      ],
      [
        -12,
        32
      ],
      [
        -111,
        54
      ],
      [
        -50,
        76
      ],
      [
        -12,
        -21
      ],
      [
        -62,
        54
      ],
      [
        -13,
        54
      ],
      [
        -49,
        109
      ],
      [
        -37,
        54
      ],
      [
        -25,
        11
      ],
      [
        -13,
        -44
      ],
      [
        -49,
        -65
      ],
      [
        -50,
        -32
      ],
      [
        -24,
        0
      ],
      [
        0,
        54
      ],
      [
        12,
        98
      ],
      [
        -25,
        43
      ],
      [
        -37,
        87
      ],
      [
        -87,
        119
      ],
      [
        -99,
        163
      ],
      [
        -49,
        43
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        -76
      ],
      [
        -12,
        -10
      ],
      [
        -62,
        0
      ],
      [
        -62,
        10
      ],
      [
        -12,
        55
      ]
    ],
    [
      [
        43133,
        40236
      ],
      [
        0,
        86
      ],
      [
        49,
        141
      ],
      [
        13,
        55
      ],
      [
        0,
        43
      ],
      [
        12,
        119
      ],
      [
        25,
        217
      ],
      [
        12,
        130
      ],
      [
        -12,
        65
      ],
      [
        0,
        55
      ],
      [
        25,
        43
      ],
      [
        -62,
        98
      ],
      [
        -38,
        21
      ],
      [
        -24,
        33
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        -22
      ],
      [
        -38,
        -21
      ],
      [
        -37,
        -33
      ],
      [
        -12,
        -22
      ],
      [
        -74,
        -21
      ],
      [
        -62,
        11
      ],
      [
        -25,
        86
      ],
      [
        0,
        109
      ],
      [
        -25,
        32
      ],
      [
        -12,
        33
      ],
      [
        0,
        32
      ],
      [
        12,
        44
      ],
      [
        0,
        65
      ],
      [
        -12,
        22
      ],
      [
        0,
        108
      ],
      [
        -25,
        76
      ],
      [
        0,
        43
      ],
      [
        -13,
        44
      ],
      [
        0,
        43
      ],
      [
        13,
        43
      ],
      [
        0,
        44
      ],
      [
        -25,
        54
      ],
      [
        -25,
        119
      ],
      [
        -24,
        55
      ],
      [
        -25,
        0
      ],
      [
        -25,
        21
      ],
      [
        -74,
        0
      ],
      [
        -50,
        65
      ],
      [
        -12,
        55
      ],
      [
        -25,
        10
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -49,
        0
      ],
      [
        -37,
        11
      ],
      [
        -37,
        22
      ],
      [
        -38,
        10
      ],
      [
        -24,
        -10
      ],
      [
        -25,
        10
      ],
      [
        -62,
        11
      ],
      [
        -25,
        33
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -24,
        22
      ],
      [
        -13,
        32
      ],
      [
        25,
        87
      ],
      [
        -12,
        43
      ],
      [
        12,
        33
      ],
      [
        0,
        184
      ],
      [
        25,
        87
      ],
      [
        -13,
        54
      ],
      [
        25,
        87
      ],
      [
        0,
        87
      ],
      [
        -25,
        65
      ],
      [
        0,
        87
      ],
      [
        -12,
        43
      ],
      [
        -12,
        11
      ],
      [
        -13,
        43
      ],
      [
        0,
        87
      ],
      [
        -24,
        43
      ],
      [
        0,
        33
      ],
      [
        -25,
        65
      ],
      [
        0,
        43
      ]
    ],
    [
      [
        37980,
        49367
      ],
      [
        -25,
        0
      ],
      [
        -62,
        22
      ],
      [
        -37,
        0
      ],
      [
        -87,
        -76
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -25,
        22
      ],
      [
        -24,
        54
      ],
      [
        -25,
        -22
      ],
      [
        -13,
        -21
      ],
      [
        0,
        271
      ],
      [
        0,
        466
      ],
      [
        25,
        76
      ],
      [
        -12,
        54
      ],
      [
        0,
        55
      ],
      [
        -13,
        32
      ],
      [
        -12,
        -22
      ],
      [
        -74,
        -97
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -49,
        -76
      ],
      [
        -25,
        -10
      ],
      [
        -99,
        -11
      ],
      [
        -198,
        0
      ],
      [
        0,
        97
      ],
      [
        -25,
        44
      ],
      [
        0,
        54
      ],
      [
        -25,
        87
      ],
      [
        -12,
        32
      ],
      [
        -37,
        11
      ],
      [
        -50,
        22
      ],
      [
        -62,
        22
      ],
      [
        -136,
        0
      ],
      [
        37,
        97
      ],
      [
        37,
        87
      ],
      [
        0,
        76
      ],
      [
        -37,
        76
      ],
      [
        -12,
        43
      ],
      [
        -25,
        54
      ],
      [
        -37,
        44
      ],
      [
        -13,
        54
      ],
      [
        0,
        32
      ],
      [
        -24,
        33
      ],
      [
        -25,
        43
      ],
      [
        -25,
        33
      ],
      [
        0,
        54
      ],
      [
        -25,
        33
      ],
      [
        0,
        76
      ],
      [
        -37,
        54
      ],
      [
        -12,
        32
      ],
      [
        0,
        33
      ],
      [
        24,
        32
      ],
      [
        -12,
        33
      ],
      [
        -25,
        32
      ],
      [
        -25,
        44
      ],
      [
        -37,
        43
      ],
      [
        0,
        33
      ],
      [
        13,
        21
      ],
      [
        0,
        76
      ],
      [
        37,
        22
      ],
      [
        37,
        11
      ],
      [
        0,
        43
      ],
      [
        -12,
        55
      ],
      [
        -13,
        21
      ],
      [
        0,
        44
      ],
      [
        13,
        65
      ],
      [
        0,
        43
      ],
      [
        24,
        43
      ],
      [
        124,
        163
      ],
      [
        37,
        0
      ],
      [
        38,
        65
      ],
      [
        0,
        76
      ],
      [
        -25,
        119
      ],
      [
        -13,
        33
      ],
      [
        13,
        43
      ],
      [
        12,
        65
      ],
      [
        37,
        87
      ],
      [
        25,
        98
      ],
      [
        0,
        21
      ],
      [
        13,
        66
      ],
      [
        12,
        119
      ],
      [
        0,
        87
      ],
      [
        25,
        43
      ],
      [
        49,
        11
      ],
      [
        25,
        43
      ],
      [
        50,
        65
      ],
      [
        37,
        76
      ],
      [
        37,
        22
      ],
      [
        62,
        65
      ],
      [
        37,
        43
      ],
      [
        50,
        44
      ],
      [
        99,
        21
      ],
      [
        37,
        22
      ],
      [
        37,
        0
      ],
      [
        25,
        33
      ],
      [
        37,
        0
      ],
      [
        62,
        21
      ],
      [
        12,
        33
      ],
      [
        25,
        43
      ],
      [
        25,
        33
      ],
      [
        25,
        11
      ],
      [
        24,
        -11
      ],
      [
        38,
        0
      ],
      [
        49,
        11
      ],
      [
        25,
        -55
      ],
      [
        25,
        -32
      ],
      [
        37,
        0
      ],
      [
        25,
        -22
      ],
      [
        24,
        0
      ],
      [
        13,
        22
      ],
      [
        0,
        32
      ]
    ],
    [
      [
        37856,
        53564
      ],
      [
        0,
        22
      ],
      [
        12,
        130
      ],
      [
        25,
        206
      ],
      [
        12,
        195
      ],
      [
        25,
        217
      ],
      [
        50,
        434
      ],
      [
        12,
        185
      ],
      [
        12,
        151
      ],
      [
        13,
        98
      ],
      [
        25,
        239
      ],
      [
        0,
        54
      ],
      [
        -13,
        32
      ],
      [
        0,
        65
      ],
      [
        -12,
        22
      ],
      [
        -25,
        22
      ],
      [
        0,
        54
      ],
      [
        -12,
        22
      ],
      [
        0,
        21
      ],
      [
        -13,
        33
      ],
      [
        13,
        22
      ],
      [
        0,
        76
      ],
      [
        -25,
        54
      ],
      [
        -25,
        11
      ],
      [
        -25,
        43
      ],
      [
        -37,
        43
      ],
      [
        -37,
        76
      ],
      [
        -12,
        33
      ],
      [
        0,
        455
      ],
      [
        49,
        0
      ],
      [
        62,
        22
      ],
      [
        25,
        33
      ],
      [
        12,
        -11
      ],
      [
        37,
        43
      ],
      [
        38,
        -11
      ],
      [
        12,
        -21
      ],
      [
        25,
        -11
      ],
      [
        12,
        -22
      ],
      [
        37,
        11
      ],
      [
        0,
        141
      ],
      [
        -12,
        22
      ],
      [
        -25,
        75
      ],
      [
        -12,
        22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -22
      ],
      [
        -38,
        11
      ],
      [
        -12,
        11
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        11
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -11
      ],
      [
        0,
        412
      ],
      [
        37,
        11
      ],
      [
        25,
        0
      ],
      [
        25,
        22
      ],
      [
        37,
        0
      ],
      [
        62,
        -33
      ],
      [
        136,
        0
      ],
      [
        248,
        0
      ],
      [
        -25,
        87
      ],
      [
        12,
        33
      ],
      [
        0,
        32
      ],
      [
        13,
        22
      ],
      [
        24,
        -22
      ],
      [
        13,
        -65
      ],
      [
        12,
        -43
      ],
      [
        25,
        -22
      ],
      [
        37,
        11
      ],
      [
        13,
        11
      ],
      [
        37,
        86
      ],
      [
        37,
        76
      ],
      [
        25,
        22
      ],
      [
        12,
        22
      ],
      [
        37,
        0
      ],
      [
        13,
        -22
      ],
      [
        49,
        -141
      ],
      [
        37,
        -98
      ],
      [
        13,
        -54
      ],
      [
        0,
        -130
      ],
      [
        -13,
        -119
      ],
      [
        13,
        -22
      ],
      [
        74,
        33
      ]
    ],
    [
      [
        38921,
        56981
      ],
      [
        87,
        -152
      ],
      [
        62,
        -98
      ],
      [
        24,
        -43
      ],
      [
        62,
        0
      ],
      [
        62,
        32
      ],
      [
        62,
        76
      ],
      [
        37,
        33
      ],
      [
        13,
        0
      ],
      [
        37,
        -33
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -65
      ],
      [
        0,
        -33
      ],
      [
        25,
        0
      ],
      [
        25,
        65
      ],
      [
        49,
        87
      ],
      [
        37,
        54
      ],
      [
        25,
        55
      ],
      [
        62,
        76
      ],
      [
        37,
        21
      ],
      [
        25,
        -11
      ],
      [
        25,
        33
      ],
      [
        49,
        87
      ],
      [
        13,
        11
      ],
      [
        62,
        0
      ],
      [
        37,
        43
      ],
      [
        24,
        65
      ],
      [
        25,
        87
      ],
      [
        0,
        87
      ],
      [
        13,
        21
      ],
      [
        24,
        22
      ],
      [
        38,
        0
      ],
      [
        49,
        43
      ],
      [
        37,
        44
      ],
      [
        37,
        11
      ],
      [
        13,
        10
      ],
      [
        12,
        44
      ],
      [
        13,
        76
      ],
      [
        -13,
        43
      ],
      [
        -62,
        11
      ],
      [
        -49,
        0
      ],
      [
        -99,
        32
      ],
      [
        -13,
        11
      ],
      [
        0,
        22
      ],
      [
        13,
        33
      ],
      [
        0,
        54
      ],
      [
        -13,
        87
      ],
      [
        -37,
        119
      ],
      [
        -25,
        130
      ],
      [
        0,
        239
      ],
      [
        -12,
        43
      ],
      [
        -99,
        152
      ],
      [
        -37,
        65
      ],
      [
        -13,
        54
      ],
      [
        -37,
        87
      ],
      [
        0,
        32
      ],
      [
        25,
        -10
      ],
      [
        25,
        -22
      ],
      [
        12,
        -44
      ],
      [
        12,
        -10
      ],
      [
        112,
        0
      ],
      [
        25,
        -11
      ],
      [
        24,
        -33
      ],
      [
        13,
        -65
      ],
      [
        25,
        -22
      ],
      [
        123,
        0
      ],
      [
        50,
        -21
      ],
      [
        50,
        21
      ],
      [
        24,
        -10
      ],
      [
        50,
        -98
      ],
      [
        37,
        -43
      ],
      [
        25,
        -65
      ],
      [
        37,
        0
      ],
      [
        37,
        54
      ],
      [
        0,
        162
      ],
      [
        13,
        55
      ],
      [
        12,
        11
      ],
      [
        25,
        0
      ],
      [
        49,
        65
      ],
      [
        25,
        10
      ],
      [
        87,
        -43
      ],
      [
        25,
        22
      ],
      [
        86,
        43
      ],
      [
        87,
        54
      ],
      [
        25,
        76
      ],
      [
        49,
        22
      ],
      [
        25,
        43
      ],
      [
        62,
        0
      ],
      [
        25,
        11
      ],
      [
        25,
        33
      ],
      [
        12,
        65
      ],
      [
        25,
        32
      ],
      [
        37,
        22
      ],
      [
        25,
        33
      ],
      [
        24,
        75
      ],
      [
        0,
        33
      ],
      [
        -24,
        108
      ],
      [
        -25,
        22
      ]
    ],
    [
      [
        41027,
        59464
      ],
      [
        25,
        11
      ],
      [
        24,
        -22
      ],
      [
        50,
        0
      ],
      [
        12,
        11
      ],
      [
        25,
        0
      ],
      [
        37,
        33
      ],
      [
        13,
        -11
      ],
      [
        24,
        0
      ],
      [
        13,
        -33
      ],
      [
        0,
        -21
      ],
      [
        37,
        -44
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -109
      ],
      [
        -13,
        -43
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -11
      ],
      [
        62,
        0
      ],
      [
        13,
        -21
      ],
      [
        25,
        0
      ],
      [
        37,
        -33
      ],
      [
        12,
        -22
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -54
      ],
      [
        12,
        -22
      ],
      [
        25,
        -86
      ],
      [
        25,
        -55
      ],
      [
        -13,
        -32
      ],
      [
        -25,
        -87
      ],
      [
        -24,
        -54
      ],
      [
        -37,
        -43
      ],
      [
        0,
        -152
      ],
      [
        -13,
        -44
      ],
      [
        -37,
        -173
      ],
      [
        0,
        -195
      ],
      [
        37,
        -206
      ],
      [
        37,
        -55
      ],
      [
        13,
        -97
      ],
      [
        -13,
        -98
      ],
      [
        0,
        -32
      ],
      [
        13,
        -22
      ],
      [
        12,
        0
      ],
      [
        12,
        -22
      ],
      [
        0,
        -54
      ],
      [
        38,
        -33
      ],
      [
        62,
        -108
      ],
      [
        12,
        -11
      ],
      [
        0,
        -22
      ],
      [
        37,
        -54
      ],
      [
        87,
        -54
      ],
      [
        37,
        -54
      ],
      [
        12,
        -11
      ],
      [
        38,
        32
      ],
      [
        12,
        22
      ],
      [
        62,
        0
      ],
      [
        0,
        22
      ],
      [
        12,
        22
      ],
      [
        -12,
        54
      ],
      [
        12,
        21
      ],
      [
        25,
        11
      ],
      [
        0,
        22
      ],
      [
        25,
        43
      ],
      [
        37,
        -21
      ],
      [
        25,
        -22
      ],
      [
        37,
        0
      ],
      [
        12,
        11
      ],
      [
        0,
        22
      ],
      [
        13,
        43
      ],
      [
        37,
        11
      ],
      [
        25,
        21
      ],
      [
        62,
        0
      ],
      [
        24,
        22
      ],
      [
        13,
        22
      ],
      [
        25,
        87
      ],
      [
        37,
        32
      ],
      [
        49,
        11
      ],
      [
        25,
        22
      ],
      [
        25,
        -44
      ],
      [
        62,
        -32
      ],
      [
        24,
        0
      ],
      [
        25,
        21
      ],
      [
        25,
        0
      ],
      [
        25,
        -10
      ],
      [
        25,
        21
      ]
    ],
    [
      [
        41460,
        64388
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -13,
        32
      ],
      [
        0,
        98
      ],
      [
        25,
        0
      ],
      [
        50,
        -98
      ],
      [
        -13,
        -43
      ]
    ],
    [
      [
        101502,
        59280
      ],
      [
        37,
        0
      ],
      [
        12,
        -22
      ],
      [
        13,
        -76
      ],
      [
        25,
        -76
      ],
      [
        0,
        -108
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        21
      ],
      [
        -13,
        120
      ],
      [
        -12,
        76
      ],
      [
        0,
        130
      ]
    ],
    [
      [
        101502,
        59280
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        -55
      ],
      [
        0,
        -32
      ],
      [
        12,
        -65
      ],
      [
        0,
        -65
      ],
      [
        25,
        -44
      ],
      [
        -12,
        -21
      ],
      [
        -13,
        -44
      ],
      [
        13,
        -10
      ],
      [
        -13,
        -66
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        21
      ],
      [
        -50,
        120
      ],
      [
        -37,
        11
      ],
      [
        -12,
        21
      ],
      [
        0,
        76
      ],
      [
        -13,
        33
      ],
      [
        -24,
        32
      ],
      [
        -25,
        22
      ],
      [
        -13,
        22
      ]
    ],
    [
      [
        101167,
        59085
      ],
      [
        38,
        0
      ],
      [
        49,
        10
      ],
      [
        74,
        65
      ],
      [
        38,
        55
      ],
      [
        74,
        86
      ],
      [
        49,
        55
      ],
      [
        13,
        -11
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        92509,
        73281
      ],
      [
        24,
        87
      ],
      [
        25,
        32
      ],
      [
        25,
        54
      ],
      [
        12,
        66
      ],
      [
        50,
        75
      ],
      [
        62,
        152
      ],
      [
        62,
        54
      ],
      [
        37,
        22
      ],
      [
        25,
        44
      ],
      [
        49,
        32
      ],
      [
        87,
        -22
      ],
      [
        50,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -54
      ],
      [
        50,
        -11
      ],
      [
        49,
        11
      ],
      [
        99,
        -32
      ],
      [
        37,
        -44
      ],
      [
        25,
        11
      ],
      [
        25,
        33
      ],
      [
        37,
        32
      ],
      [
        37,
        -43
      ],
      [
        87,
        -55
      ],
      [
        0,
        -108
      ]
    ],
    [
      [
        93450,
        73552
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -65
      ],
      [
        49,
        -76
      ],
      [
        37,
        0
      ],
      [
        38,
        11
      ],
      [
        12,
        -11
      ],
      [
        25,
        -54
      ],
      [
        12,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -43
      ],
      [
        25,
        -65
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -21
      ],
      [
        -49,
        0
      ],
      [
        -25,
        43
      ],
      [
        -12,
        0
      ],
      [
        -50,
        -54
      ],
      [
        -49,
        11
      ],
      [
        -87,
        -11
      ],
      [
        -50,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -37,
        32
      ],
      [
        -37,
        22
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -65
      ],
      [
        -62,
        -11
      ],
      [
        -62,
        -22
      ],
      [
        -12,
        11
      ],
      [
        -38,
        0
      ],
      [
        0,
        33
      ],
      [
        -24,
        22
      ],
      [
        -50,
        10
      ],
      [
        -25,
        22
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        33
      ],
      [
        -37,
        43
      ],
      [
        -25,
        11
      ],
      [
        -12,
        87
      ],
      [
        -25,
        22
      ],
      [
        0,
        54
      ],
      [
        50,
        54
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        72032,
        42350
      ],
      [
        -86,
        -10
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        -76
      ],
      [
        -37,
        -54
      ],
      [
        -50,
        -32
      ],
      [
        -50,
        -22
      ],
      [
        -61,
        -11
      ],
      [
        -50,
        -65
      ],
      [
        -74,
        -109
      ],
      [
        -25,
        -75
      ],
      [
        -13,
        -55
      ],
      [
        -37,
        -21
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -10
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        -43
      ],
      [
        -38,
        -22
      ],
      [
        -24,
        -32
      ],
      [
        -38,
        -109
      ],
      [
        -49,
        -303
      ],
      [
        -74,
        -98
      ],
      [
        -38,
        -76
      ],
      [
        -12,
        -43
      ],
      [
        -111,
        -54
      ],
      [
        -75,
        -44
      ],
      [
        -12,
        -21
      ],
      [
        -13,
        -98
      ],
      [
        -24,
        -130
      ],
      [
        -25,
        -98
      ],
      [
        -13,
        -87
      ],
      [
        -24,
        -108
      ],
      [
        -50,
        -65
      ],
      [
        -87,
        -22
      ],
      [
        -74,
        0
      ],
      [
        -37,
        -43
      ],
      [
        -50,
        0
      ],
      [
        -62,
        21
      ],
      [
        -74,
        33
      ],
      [
        -49,
        65
      ],
      [
        -75,
        0
      ],
      [
        -161,
        174
      ],
      [
        -37,
        43
      ],
      [
        -49,
        11
      ],
      [
        -87,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        -87
      ],
      [
        -37,
        -163
      ],
      [
        -25,
        -130
      ],
      [
        -12,
        -43
      ],
      [
        -50,
        -55
      ],
      [
        -87,
        -108
      ],
      [
        -37,
        -119
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        -22
      ],
      [
        -12,
        -21
      ],
      [
        -13,
        -65
      ],
      [
        -12,
        -22
      ],
      [
        -74,
        0
      ],
      [
        -13,
        11
      ],
      [
        -136,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -50,
        -22
      ],
      [
        -12,
        11
      ],
      [
        -25,
        54
      ],
      [
        0,
        184
      ],
      [
        50,
        120
      ],
      [
        12,
        54
      ],
      [
        0,
        163
      ],
      [
        -37,
        108
      ],
      [
        -37,
        152
      ],
      [
        -37,
        173
      ],
      [
        -25,
        44
      ],
      [
        -25,
        76
      ],
      [
        -111,
        130
      ],
      [
        -13,
        22
      ]
    ],
    [
      [
        68799,
        40735
      ],
      [
        0,
        336
      ],
      [
        0,
        358
      ],
      [
        0,
        357
      ],
      [
        0,
        358
      ],
      [
        0,
        326
      ],
      [
        174,
        0
      ],
      [
        161,
        0
      ],
      [
        12,
        21
      ],
      [
        0,
        369
      ],
      [
        0,
        260
      ],
      [
        0,
        250
      ],
      [
        0,
        260
      ],
      [
        0,
        250
      ],
      [
        0,
        260
      ],
      [
        0,
        249
      ],
      [
        0,
        380
      ],
      [
        87,
        11
      ],
      [
        99,
        21
      ],
      [
        161,
        44
      ],
      [
        161,
        54
      ],
      [
        99,
        33
      ],
      [
        161,
        43
      ],
      [
        25,
        -22
      ],
      [
        62,
        -130
      ],
      [
        37,
        -141
      ],
      [
        37,
        22
      ],
      [
        74,
        119
      ],
      [
        38,
        54
      ],
      [
        37,
        44
      ],
      [
        37,
        32
      ],
      [
        50,
        33
      ],
      [
        37,
        -33
      ],
      [
        12,
        -21
      ],
      [
        99,
        119
      ],
      [
        37,
        32
      ],
      [
        99,
        22
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        70620,
        45094
      ],
      [
        -12,
        -21
      ],
      [
        0,
        -87
      ],
      [
        12,
        -44
      ],
      [
        25,
        -32
      ],
      [
        37,
        -87
      ],
      [
        13,
        -76
      ],
      [
        24,
        -54
      ],
      [
        75,
        -130
      ],
      [
        0,
        -44
      ],
      [
        12,
        -43
      ],
      [
        37,
        -98
      ],
      [
        13,
        -21
      ],
      [
        0,
        -65
      ],
      [
        37,
        -174
      ],
      [
        37,
        -108
      ],
      [
        25,
        -22
      ],
      [
        74,
        -108
      ],
      [
        74,
        -87
      ],
      [
        87,
        -65
      ],
      [
        50,
        -44
      ],
      [
        37,
        -21
      ],
      [
        12,
        -33
      ],
      [
        13,
        -54
      ],
      [
        12,
        -98
      ],
      [
        0,
        -54
      ],
      [
        62,
        0
      ],
      [
        49,
        -11
      ],
      [
        25,
        -11
      ],
      [
        0,
        -379
      ],
      [
        50,
        -87
      ],
      [
        24,
        -65
      ],
      [
        38,
        -119
      ],
      [
        12,
        -11
      ],
      [
        50,
        -11
      ],
      [
        111,
        -43
      ],
      [
        74,
        -33
      ],
      [
        87,
        -43
      ],
      [
        25,
        -22
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -32
      ],
      [
        24,
        -55
      ],
      [
        50,
        0
      ],
      [
        25,
        -54
      ],
      [
        24,
        -22
      ]
    ],
    [
      [
        70236,
        61622
      ],
      [
        13,
        0
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -87
      ],
      [
        0,
        -65
      ],
      [
        37,
        -43
      ],
      [
        25,
        -22
      ],
      [
        24,
        -11
      ],
      [
        99,
        -32
      ],
      [
        38,
        -33
      ],
      [
        62,
        -108
      ],
      [
        61,
        -98
      ],
      [
        13,
        -54
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -54
      ],
      [
        37,
        -87
      ],
      [
        37,
        -54
      ],
      [
        62,
        -65
      ],
      [
        112,
        -108
      ],
      [
        49,
        -65
      ],
      [
        50,
        -109
      ],
      [
        37,
        -54
      ],
      [
        25,
        -44
      ],
      [
        -13,
        -108
      ],
      [
        0,
        -33
      ],
      [
        13,
        -32
      ],
      [
        25,
        -43
      ],
      [
        24,
        -131
      ],
      [
        38,
        -32
      ],
      [
        37,
        -11
      ],
      [
        24,
        -33
      ],
      [
        100,
        -108
      ],
      [
        24,
        -32
      ],
      [
        25,
        -66
      ],
      [
        0,
        -108
      ],
      [
        13,
        -98
      ],
      [
        24,
        -65
      ],
      [
        25,
        -43
      ]
    ],
    [
      [
        71351,
        59410
      ],
      [
        -99,
        54
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -37,
        11
      ],
      [
        -161,
        54
      ],
      [
        -124,
        55
      ],
      [
        -37,
        21
      ],
      [
        -62,
        11
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        -120
      ],
      [
        -12,
        -21
      ],
      [
        -62,
        -44
      ],
      [
        -25,
        11
      ],
      [
        -74,
        -32
      ],
      [
        -112,
        54
      ],
      [
        -49,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -87,
        -54
      ],
      [
        -99,
        -65
      ],
      [
        -62,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -74,
        43
      ],
      [
        -37,
        11
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        -43
      ],
      [
        -49,
        -130
      ],
      [
        -38,
        -141
      ],
      [
        -24,
        -54
      ],
      [
        -174,
        76
      ],
      [
        -87,
        21
      ],
      [
        -49,
        -21
      ],
      [
        -62,
        43
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -62,
        43
      ],
      [
        -50,
        22
      ],
      [
        -62,
        0
      ],
      [
        -25,
        11
      ],
      [
        -61,
        141
      ],
      [
        -50,
        87
      ],
      [
        -74,
        75
      ],
      [
        -50,
        55
      ],
      [
        -25,
        32
      ],
      [
        -37,
        22
      ],
      [
        -62,
        11
      ],
      [
        -62,
        -44
      ],
      [
        -86,
        -108
      ],
      [
        -87,
        -228
      ],
      [
        -50,
        -87
      ],
      [
        -37,
        -21
      ],
      [
        0,
        -54
      ],
      [
        25,
        -196
      ],
      [
        -12,
        -173
      ],
      [
        0,
        -120
      ]
    ],
    [
      [
        68329,
        58390
      ],
      [
        -25,
        11
      ],
      [
        -13,
        65
      ],
      [
        -12,
        11
      ],
      [
        -50,
        -21
      ],
      [
        -24,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        0
      ],
      [
        -13,
        33
      ],
      [
        -74,
        0
      ],
      [
        -25,
        22
      ],
      [
        -99,
        43
      ],
      [
        -12,
        22
      ],
      [
        -25,
        0
      ],
      [
        -50,
        -44
      ],
      [
        -99,
        -43
      ],
      [
        -74,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        -65
      ],
      [
        -12,
        -98
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -109
      ],
      [
        -12,
        -76
      ],
      [
        -37,
        -97
      ],
      [
        -50,
        -174
      ]
    ],
    [
      [
        67486,
        57631
      ],
      [
        -12,
        55
      ],
      [
        -13,
        75
      ],
      [
        0,
        131
      ],
      [
        -12,
        54
      ],
      [
        12,
        43
      ],
      [
        -24,
        87
      ],
      [
        -37,
        54
      ],
      [
        0,
        22
      ],
      [
        -25,
        0
      ],
      [
        -25,
        11
      ],
      [
        -37,
        65
      ],
      [
        -25,
        65
      ],
      [
        -50,
        76
      ],
      [
        -24,
        76
      ],
      [
        -50,
        86
      ],
      [
        -37,
        76
      ],
      [
        -25,
        76
      ],
      [
        0,
        44
      ],
      [
        25,
        0
      ],
      [
        0,
        32
      ],
      [
        -12,
        54
      ],
      [
        -13,
        76
      ],
      [
        -12,
        44
      ],
      [
        -37,
        76
      ],
      [
        -50,
        54
      ],
      [
        -12,
        22
      ],
      [
        0,
        43
      ],
      [
        -25,
        249
      ],
      [
        0,
        76
      ],
      [
        -25,
        44
      ],
      [
        -12,
        11
      ],
      [
        12,
        54
      ],
      [
        0,
        54
      ],
      [
        13,
        33
      ],
      [
        0,
        227
      ],
      [
        -13,
        11
      ],
      [
        0,
        22
      ],
      [
        -25,
        0
      ],
      [
        -24,
        76
      ],
      [
        0,
        32
      ],
      [
        37,
        65
      ],
      [
        49,
        33
      ],
      [
        25,
        43
      ],
      [
        13,
        33
      ],
      [
        24,
        119
      ],
      [
        37,
        119
      ],
      [
        25,
        22
      ],
      [
        13,
        76
      ],
      [
        37,
        141
      ],
      [
        0,
        43
      ],
      [
        12,
        44
      ],
      [
        50,
        54
      ],
      [
        37,
        108
      ]
    ],
    [
      [
        67251,
        60917
      ],
      [
        74,
        -21
      ],
      [
        50,
        -11
      ],
      [
        37,
        22
      ],
      [
        25,
        32
      ],
      [
        62,
        33
      ],
      [
        62,
        43
      ],
      [
        12,
        54
      ],
      [
        12,
        33
      ],
      [
        25,
        21
      ],
      [
        12,
        -10
      ],
      [
        13,
        -65
      ],
      [
        25,
        -55
      ],
      [
        37,
        -65
      ],
      [
        12,
        11
      ],
      [
        25,
        43
      ],
      [
        62,
        33
      ],
      [
        12,
        11
      ],
      [
        50,
        65
      ],
      [
        62,
        54
      ],
      [
        25,
        11
      ],
      [
        49,
        43
      ],
      [
        99,
        0
      ],
      [
        112,
        22
      ],
      [
        74,
        11
      ],
      [
        37,
        11
      ],
      [
        0,
        11
      ],
      [
        25,
        65
      ],
      [
        0,
        11
      ],
      [
        37,
        32
      ],
      [
        50,
        98
      ],
      [
        37,
        86
      ],
      [
        12,
        44
      ],
      [
        25,
        32
      ],
      [
        -12,
        33
      ],
      [
        -62,
        76
      ],
      [
        0,
        32
      ],
      [
        49,
        65
      ],
      [
        37,
        22
      ],
      [
        87,
        -11
      ],
      [
        87,
        11
      ],
      [
        99,
        33
      ],
      [
        49,
        32
      ],
      [
        87,
        0
      ],
      [
        74,
        98
      ],
      [
        38,
        21
      ],
      [
        0,
        22
      ],
      [
        37,
        33
      ],
      [
        37,
        76
      ],
      [
        37,
        65
      ],
      [
        13,
        54
      ],
      [
        86,
        163
      ],
      [
        25,
        0
      ],
      [
        12,
        10
      ],
      [
        38,
        109
      ],
      [
        12,
        22
      ],
      [
        37,
        21
      ],
      [
        25,
        76
      ],
      [
        0,
        130
      ],
      [
        25,
        44
      ],
      [
        62,
        65
      ],
      [
        24,
        54
      ],
      [
        38,
        0
      ],
      [
        37,
        43
      ],
      [
        37,
        33
      ],
      [
        49,
        32
      ],
      [
        38,
        -10
      ],
      [
        37,
        -22
      ],
      [
        37,
        -11
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        69790,
        63032
      ],
      [
        25,
        -76
      ],
      [
        112,
        -206
      ],
      [
        12,
        -43
      ],
      [
        62,
        -141
      ],
      [
        62,
        -217
      ],
      [
        0,
        -130
      ],
      [
        -13,
        -174
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        -98
      ],
      [
        0,
        -76
      ],
      [
        25,
        -32
      ],
      [
        0,
        -76
      ],
      [
        12,
        -33
      ],
      [
        37,
        -21
      ],
      [
        74,
        -11
      ],
      [
        50,
        -11
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        41349,
        83660
      ],
      [
        -37,
        -22
      ],
      [
        -50,
        0
      ],
      [
        -25,
        33
      ],
      [
        62,
        -11
      ],
      [
        25,
        11
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        38958,
        84126
      ],
      [
        -49,
        -32
      ],
      [
        12,
        86
      ],
      [
        25,
        22
      ],
      [
        12,
        -11
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        40953,
        84625
      ],
      [
        -25,
        11
      ],
      [
        -25,
        32
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        -12,
        -54
      ]
    ],
    [
      [
        36567,
        84690
      ],
      [
        -49,
        -11
      ],
      [
        37,
        65
      ],
      [
        62,
        11
      ],
      [
        -50,
        -65
      ]
    ],
    [
      [
        36617,
        84614
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -62,
        -11
      ],
      [
        37,
        44
      ],
      [
        49,
        32
      ],
      [
        62,
        87
      ],
      [
        13,
        0
      ],
      [
        -25,
        -98
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        37484,
        85493
      ],
      [
        -25,
        0
      ],
      [
        0,
        21
      ],
      [
        75,
        55
      ],
      [
        -13,
        -44
      ],
      [
        -37,
        -32
      ]
    ],
    [
      [
        40903,
        84918
      ],
      [
        12,
        -11
      ],
      [
        38,
        32
      ],
      [
        24,
        0
      ],
      [
        0,
        -21
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        25,
        -10
      ],
      [
        0,
        -22
      ],
      [
        -38,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        12,
        -22
      ],
      [
        50,
        22
      ],
      [
        37,
        0
      ],
      [
        37,
        21
      ],
      [
        75,
        109
      ],
      [
        -75,
        -11
      ],
      [
        -12,
        11
      ],
      [
        62,
        65
      ],
      [
        -13,
        43
      ],
      [
        25,
        54
      ],
      [
        75,
        66
      ],
      [
        24,
        -33
      ],
      [
        0,
        -43
      ],
      [
        50,
        10
      ],
      [
        49,
        -10
      ],
      [
        38,
        -33
      ],
      [
        -13,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        38,
        -32
      ],
      [
        0,
        -22
      ],
      [
        -62,
        -33
      ],
      [
        -38,
        -43
      ],
      [
        -24,
        -43
      ],
      [
        -62,
        -55
      ],
      [
        -99,
        -43
      ],
      [
        -38,
        0
      ],
      [
        -37,
        11
      ],
      [
        -37,
        0
      ],
      [
        -99,
        -22
      ],
      [
        -62,
        87
      ],
      [
        -12,
        141
      ],
      [
        0,
        76
      ],
      [
        25,
        76
      ],
      [
        61,
        76
      ],
      [
        87,
        217
      ],
      [
        25,
        54
      ],
      [
        12,
        43
      ],
      [
        87,
        109
      ],
      [
        50,
        21
      ],
      [
        24,
        0
      ],
      [
        0,
        -54
      ],
      [
        25,
        -97
      ],
      [
        -12,
        -98
      ],
      [
        -37,
        -119
      ],
      [
        -13,
        -76
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -33
      ],
      [
        -74,
        -75
      ],
      [
        -37,
        -11
      ],
      [
        -87,
        -76
      ]
    ],
    [
      [
        39974,
        85243
      ],
      [
        25,
        0
      ],
      [
        12,
        54
      ],
      [
        50,
        -10
      ],
      [
        24,
        -22
      ],
      [
        38,
        0
      ],
      [
        24,
        -33
      ],
      [
        62,
        -21
      ],
      [
        50,
        0
      ],
      [
        99,
        21
      ],
      [
        173,
        22
      ],
      [
        38,
        -11
      ],
      [
        12,
        -32
      ],
      [
        -99,
        -87
      ],
      [
        -75,
        -44
      ],
      [
        0,
        -141
      ],
      [
        -86,
        -10
      ],
      [
        -25,
        21
      ],
      [
        -12,
        44
      ],
      [
        0,
        32
      ],
      [
        -25,
        44
      ],
      [
        -50,
        32
      ],
      [
        -24,
        -11
      ],
      [
        12,
        -21
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -124,
        43
      ],
      [
        -24,
        33
      ],
      [
        -25,
        54
      ],
      [
        12,
        22
      ],
      [
        -86,
        0
      ],
      [
        -38,
        11
      ],
      [
        0,
        108
      ],
      [
        -37,
        22
      ],
      [
        -49,
        11
      ],
      [
        -13,
        32
      ],
      [
        50,
        87
      ],
      [
        12,
        43
      ],
      [
        25,
        33
      ],
      [
        62,
        65
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -44
      ],
      [
        -37,
        -86
      ],
      [
        62,
        -76
      ],
      [
        12,
        -22
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        40618,
        85753
      ],
      [
        50,
        -22
      ],
      [
        -13,
        -22
      ],
      [
        -49,
        0
      ],
      [
        -13,
        11
      ],
      [
        25,
        120
      ],
      [
        37,
        21
      ],
      [
        62,
        87
      ],
      [
        62,
        33
      ],
      [
        25,
        -11
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -55
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        43269,
        85850
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        21
      ],
      [
        25,
        33
      ],
      [
        24,
        65
      ],
      [
        13,
        -22
      ],
      [
        -25,
        -76
      ]
    ],
    [
      [
        39726,
        86122
      ],
      [
        0,
        -44
      ],
      [
        -49,
        -43
      ],
      [
        -13,
        11
      ],
      [
        13,
        21
      ],
      [
        0,
        44
      ],
      [
        49,
        11
      ]
    ],
    [
      [
        19461,
        86664
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        11
      ],
      [
        -12,
        108
      ],
      [
        37,
        -32
      ],
      [
        -12,
        -11
      ],
      [
        25,
        -33
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        38834,
        84430
      ],
      [
        -49,
        11
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        11
      ],
      [
        -38,
        65
      ],
      [
        13,
        43
      ],
      [
        -25,
        87
      ],
      [
        37,
        54
      ],
      [
        -25,
        33
      ],
      [
        -37,
        0
      ],
      [
        -25,
        11
      ],
      [
        -24,
        32
      ],
      [
        -25,
        11
      ],
      [
        0,
        54
      ],
      [
        12,
        11
      ],
      [
        -12,
        33
      ],
      [
        12,
        43
      ],
      [
        -12,
        11
      ],
      [
        0,
        238
      ],
      [
        0,
        467
      ],
      [
        -50,
        54
      ],
      [
        -49,
        65
      ],
      [
        -50,
        43
      ],
      [
        -24,
        11
      ],
      [
        -62,
        -43
      ],
      [
        -62,
        -22
      ],
      [
        -62,
        -32
      ],
      [
        -62,
        21
      ],
      [
        -13,
        22
      ],
      [
        0,
        98
      ],
      [
        -62,
        21
      ],
      [
        -24,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        -76
      ],
      [
        -75,
        -151
      ],
      [
        -62,
        -98
      ],
      [
        -37,
        -76
      ],
      [
        -24,
        -174
      ],
      [
        -38,
        -54
      ],
      [
        -24,
        -65
      ],
      [
        -25,
        -119
      ],
      [
        0,
        -44
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -21
      ],
      [
        -24,
        -44
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -22
      ],
      [
        -49,
        -43
      ],
      [
        -37,
        -55
      ],
      [
        0,
        -32
      ],
      [
        12,
        -44
      ],
      [
        -37,
        -10
      ],
      [
        -25,
        -33
      ],
      [
        12,
        -32
      ],
      [
        -24,
        -33
      ],
      [
        -38,
        54
      ],
      [
        -49,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -37,
        22
      ],
      [
        -37,
        -55
      ],
      [
        -25,
        -119
      ],
      [
        -149,
        0
      ],
      [
        -285,
        0
      ],
      [
        -284,
        0
      ],
      [
        -149,
        -11
      ],
      [
        -235,
        0
      ]
    ],
    [
      [
        36221,
        84321
      ],
      [
        49,
        33
      ],
      [
        99,
        87
      ],
      [
        75,
        32
      ],
      [
        99,
        98
      ],
      [
        74,
        21
      ],
      [
        12,
        22
      ],
      [
        13,
        76
      ],
      [
        37,
        108
      ],
      [
        37,
        66
      ],
      [
        37,
        86
      ],
      [
        62,
        65
      ],
      [
        87,
        44
      ],
      [
        74,
        108
      ],
      [
        50,
        33
      ],
      [
        49,
        21
      ],
      [
        13,
        44
      ],
      [
        24,
        32
      ],
      [
        75,
        44
      ],
      [
        74,
        11
      ],
      [
        87,
        43
      ],
      [
        62,
        22
      ],
      [
        37,
        43
      ],
      [
        49,
        22
      ],
      [
        162,
        108
      ],
      [
        49,
        54
      ],
      [
        62,
        109
      ],
      [
        50,
        54
      ],
      [
        12,
        65
      ],
      [
        74,
        87
      ],
      [
        75,
        130
      ],
      [
        37,
        87
      ],
      [
        62,
        54
      ],
      [
        111,
        141
      ],
      [
        62,
        54
      ],
      [
        25,
        11
      ],
      [
        62,
        44
      ],
      [
        37,
        54
      ],
      [
        74,
        54
      ],
      [
        112,
        65
      ],
      [
        111,
        76
      ],
      [
        161,
        76
      ],
      [
        174,
        97
      ],
      [
        148,
        55
      ],
      [
        99,
        11
      ],
      [
        124,
        21
      ],
      [
        50,
        0
      ],
      [
        186,
        -43
      ],
      [
        99,
        -54
      ],
      [
        99,
        -120
      ],
      [
        25,
        -76
      ],
      [
        -62,
        22
      ],
      [
        -13,
        -22
      ],
      [
        62,
        -65
      ],
      [
        -12,
        -86
      ],
      [
        -25,
        -87
      ],
      [
        -99,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -76
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -32
      ],
      [
        -87,
        -55
      ],
      [
        -74,
        11
      ],
      [
        -87,
        44
      ],
      [
        -62,
        54
      ],
      [
        -49,
        -54
      ],
      [
        -62,
        10
      ],
      [
        -25,
        -10
      ],
      [
        -50,
        10
      ],
      [
        13,
        -32
      ],
      [
        24,
        0
      ],
      [
        50,
        -54
      ],
      [
        124,
        -44
      ],
      [
        37,
        -32
      ],
      [
        25,
        -98
      ],
      [
        25,
        -22
      ],
      [
        37,
        11
      ],
      [
        49,
        55
      ],
      [
        37,
        21
      ],
      [
        87,
        22
      ],
      [
        -25,
        -33
      ],
      [
        62,
        0
      ],
      [
        62,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        -24,
        -65
      ],
      [
        -25,
        -119
      ],
      [
        -62,
        -87
      ],
      [
        -74,
        -86
      ],
      [
        12,
        -22
      ],
      [
        25,
        -11
      ],
      [
        49,
        33
      ],
      [
        75,
        -22
      ],
      [
        -25,
        -109
      ],
      [
        37,
        -119
      ],
      [
        25,
        -22
      ],
      [
        12,
        -97
      ],
      [
        25,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        37,
        -21
      ],
      [
        0,
        -44
      ],
      [
        124,
        -11
      ],
      [
        12,
        -21
      ],
      [
        87,
        -22
      ],
      [
        25,
        -33
      ],
      [
        -75,
        -54
      ],
      [
        62,
        -43
      ],
      [
        62,
        -54
      ],
      [
        62,
        10
      ],
      [
        50,
        -43
      ],
      [
        24,
        -33
      ],
      [
        62,
        11
      ],
      [
        75,
        0
      ],
      [
        62,
        -21
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -22
      ],
      [
        62,
        0
      ],
      [
        37,
        -21
      ],
      [
        13,
        32
      ],
      [
        74,
        33
      ],
      [
        87,
        87
      ],
      [
        12,
        -11
      ],
      [
        0,
        -33
      ],
      [
        12,
        -54
      ],
      [
        38,
        -33
      ],
      [
        37,
        -10
      ],
      [
        62,
        32
      ],
      [
        25,
        -22
      ],
      [
        49,
        -108
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        124,
        -11
      ],
      [
        25,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -161,
        -98
      ],
      [
        -74,
        -32
      ],
      [
        -87,
        -65
      ],
      [
        -87,
        -33
      ],
      [
        -99,
        -43
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -50,
        -44
      ],
      [
        -62,
        -10
      ],
      [
        -24,
        10
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        11
      ],
      [
        -49,
        32
      ],
      [
        0,
        33
      ],
      [
        -37,
        32
      ],
      [
        -13,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        54
      ],
      [
        -49,
        -22
      ],
      [
        -13,
        -65
      ],
      [
        13,
        -11
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        11
      ],
      [
        -37,
        -76
      ],
      [
        -38,
        -22
      ],
      [
        -37,
        -76
      ],
      [
        -49,
        -54
      ],
      [
        -13,
        -44
      ],
      [
        -74,
        -86
      ],
      [
        -50,
        0
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -76
      ],
      [
        -12,
        11
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        22
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -50,
        152
      ],
      [
        -37,
        11
      ],
      [
        -12,
        -44
      ],
      [
        -37,
        44
      ],
      [
        -13,
        163
      ],
      [
        -12,
        43
      ],
      [
        37,
        141
      ],
      [
        87,
        119
      ],
      [
        -37,
        11
      ],
      [
        -62,
        -87
      ],
      [
        0,
        22
      ],
      [
        37,
        54
      ],
      [
        37,
        33
      ],
      [
        50,
        21
      ],
      [
        37,
        0
      ],
      [
        49,
        55
      ],
      [
        -62,
        0
      ],
      [
        273,
        238
      ],
      [
        62,
        44
      ],
      [
        99,
        43
      ],
      [
        12,
        33
      ],
      [
        25,
        0
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -32
      ],
      [
        12,
        -33
      ],
      [
        37,
        -11
      ],
      [
        50,
        65
      ],
      [
        111,
        55
      ],
      [
        99,
        10
      ],
      [
        38,
        22
      ],
      [
        -87,
        22
      ],
      [
        -99,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -87,
        -11
      ],
      [
        -87,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        11
      ],
      [
        -25,
        22
      ],
      [
        25,
        65
      ],
      [
        99,
        87
      ],
      [
        49,
        86
      ],
      [
        25,
        11
      ],
      [
        13,
        33
      ],
      [
        -38,
        0
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        33
      ],
      [
        -37,
        32
      ],
      [
        12,
        -65
      ],
      [
        -62,
        -108
      ],
      [
        -49,
        -11
      ],
      [
        -50,
        -44
      ],
      [
        -173,
        -130
      ],
      [
        -112,
        -76
      ],
      [
        -24,
        0
      ],
      [
        -50,
        22
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        -21
      ],
      [
        -62,
        -55
      ],
      [
        -25,
        22
      ],
      [
        -74,
        -32
      ],
      [
        -50,
        -11
      ],
      [
        -25,
        54
      ],
      [
        -49,
        0
      ],
      [
        -13,
        11
      ]
    ],
    [
      [
        18544,
        87043
      ],
      [
        12,
        -54
      ],
      [
        -49,
        11
      ],
      [
        -13,
        11
      ],
      [
        13,
        43
      ],
      [
        37,
        -11
      ]
    ],
    [
      [
        43157,
        87195
      ],
      [
        -86,
        -65
      ],
      [
        -13,
        11
      ],
      [
        -12,
        54
      ],
      [
        25,
        0
      ],
      [
        25,
        -21
      ],
      [
        37,
        32
      ],
      [
        24,
        -11
      ]
    ],
    [
      [
        43319,
        87282
      ],
      [
        37,
        -43
      ],
      [
        -87,
        -44
      ],
      [
        -25,
        0
      ],
      [
        0,
        76
      ],
      [
        37,
        -21
      ],
      [
        13,
        43
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        19213,
        87152
      ],
      [
        0,
        -11
      ],
      [
        -75,
        43
      ],
      [
        -37,
        33
      ],
      [
        -12,
        33
      ],
      [
        -50,
        32
      ],
      [
        13,
        22
      ],
      [
        25,
        0
      ],
      [
        37,
        -22
      ],
      [
        37,
        -43
      ],
      [
        62,
        -87
      ]
    ],
    [
      [
        18358,
        87206
      ],
      [
        -25,
        -11
      ],
      [
        -86,
        76
      ],
      [
        12,
        33
      ],
      [
        0,
        43
      ],
      [
        25,
        22
      ],
      [
        37,
        -22
      ],
      [
        12,
        -22
      ],
      [
        25,
        -75
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        40655,
        86881
      ],
      [
        -136,
        -11
      ],
      [
        -112,
        43
      ],
      [
        -86,
        11
      ],
      [
        -87,
        44
      ],
      [
        -186,
        108
      ],
      [
        -12,
        33
      ],
      [
        -50,
        86
      ],
      [
        -37,
        44
      ],
      [
        -198,
        97
      ],
      [
        -12,
        44
      ],
      [
        37,
        21
      ],
      [
        49,
        11
      ],
      [
        37,
        0
      ],
      [
        124,
        -43
      ],
      [
        161,
        -33
      ],
      [
        75,
        -32
      ],
      [
        148,
        -87
      ],
      [
        174,
        -141
      ],
      [
        37,
        -11
      ],
      [
        74,
        -65
      ],
      [
        37,
        -87
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        18928,
        87466
      ],
      [
        -13,
        -10
      ],
      [
        -12,
        75
      ],
      [
        12,
        22
      ],
      [
        25,
        0
      ],
      [
        13,
        -65
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        18854,
        87510
      ],
      [
        -25,
        21
      ],
      [
        -37,
        109
      ],
      [
        24,
        65
      ],
      [
        38,
        -11
      ],
      [
        37,
        -76
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -76
      ]
    ],
    [
      [
        18160,
        87846
      ],
      [
        173,
        -76
      ],
      [
        174,
        -43
      ],
      [
        124,
        -44
      ],
      [
        74,
        -11
      ],
      [
        49,
        -32
      ],
      [
        50,
        -130
      ],
      [
        37,
        -54
      ],
      [
        50,
        -109
      ],
      [
        49,
        -65
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -22
      ],
      [
        37,
        -76
      ],
      [
        62,
        -65
      ],
      [
        161,
        -76
      ],
      [
        62,
        -43
      ],
      [
        62,
        -98
      ],
      [
        25,
        -76
      ],
      [
        37,
        -87
      ],
      [
        50,
        -141
      ],
      [
        12,
        11
      ],
      [
        0,
        54
      ],
      [
        25,
        -11
      ],
      [
        37,
        -140
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -55
      ],
      [
        -24,
        -10
      ],
      [
        -112,
        32
      ],
      [
        -161,
        87
      ],
      [
        -99,
        43
      ],
      [
        -112,
        76
      ],
      [
        -37,
        33
      ],
      [
        -12,
        32
      ],
      [
        74,
        87
      ],
      [
        25,
        43
      ],
      [
        25,
        76
      ],
      [
        -13,
        0
      ],
      [
        -24,
        -76
      ],
      [
        -13,
        -10
      ],
      [
        -86,
        -11
      ],
      [
        -62,
        11
      ],
      [
        -38,
        -44
      ],
      [
        -24,
        11
      ],
      [
        -38,
        43
      ],
      [
        -61,
        44
      ],
      [
        49,
        32
      ],
      [
        12,
        33
      ],
      [
        -24,
        0
      ],
      [
        -37,
        54
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        22
      ],
      [
        12,
        54
      ],
      [
        -37,
        0
      ],
      [
        -12,
        33
      ],
      [
        -50,
        11
      ],
      [
        -12,
        -33
      ],
      [
        -12,
        0
      ],
      [
        -50,
        44
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        11
      ],
      [
        0,
        108
      ],
      [
        37,
        11
      ],
      [
        37,
        33
      ],
      [
        -74,
        43
      ],
      [
        -62,
        108
      ],
      [
        -62,
        22
      ],
      [
        -25,
        -43
      ],
      [
        -49,
        0
      ],
      [
        -25,
        43
      ],
      [
        0,
        33
      ],
      [
        12,
        32
      ],
      [
        -12,
        44
      ],
      [
        -25,
        10
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        76
      ],
      [
        -74,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -38,
        21
      ],
      [
        25,
        33
      ],
      [
        -12,
        65
      ],
      [
        -37,
        11
      ],
      [
        12,
        76
      ],
      [
        25,
        11
      ],
      [
        74,
        10
      ],
      [
        25,
        -10
      ],
      [
        12,
        43
      ],
      [
        25,
        32
      ],
      [
        -25,
        11
      ],
      [
        -74,
        0
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -74,
        0
      ],
      [
        -25,
        11
      ],
      [
        -50,
        54
      ],
      [
        -25,
        55
      ],
      [
        0,
        32
      ],
      [
        13,
        33
      ],
      [
        25,
        21
      ],
      [
        49,
        22
      ],
      [
        62,
        0
      ],
      [
        74,
        -33
      ],
      [
        174,
        -108
      ]
    ],
    [
      [
        42848,
        88410
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -44
      ],
      [
        -37,
        -10
      ],
      [
        -75,
        0
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        -44
      ],
      [
        25,
        -43
      ],
      [
        50,
        11
      ],
      [
        24,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -119
      ],
      [
        -25,
        -44
      ],
      [
        -49,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -86,
        -152
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -87
      ],
      [
        -62,
        -87
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -87
      ],
      [
        -37,
        -54
      ],
      [
        12,
        -44
      ],
      [
        0,
        -65
      ],
      [
        25,
        22
      ],
      [
        49,
        87
      ],
      [
        38,
        54
      ],
      [
        24,
        11
      ],
      [
        62,
        119
      ],
      [
        25,
        11
      ],
      [
        12,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        87,
        44
      ],
      [
        12,
        0
      ],
      [
        37,
        -33
      ],
      [
        37,
        0
      ],
      [
        50,
        22
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -49,
        -44
      ],
      [
        -112,
        -76
      ],
      [
        0,
        -21
      ],
      [
        50,
        11
      ],
      [
        12,
        -11
      ],
      [
        0,
        -55
      ],
      [
        -62,
        -75
      ],
      [
        87,
        32
      ],
      [
        49,
        -43
      ],
      [
        62,
        11
      ],
      [
        38,
        21
      ],
      [
        12,
        -32
      ],
      [
        0,
        -44
      ],
      [
        25,
        22
      ],
      [
        0,
        76
      ],
      [
        25,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -87
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -54
      ],
      [
        37,
        43
      ],
      [
        -12,
        22
      ],
      [
        25,
        43
      ],
      [
        49,
        33
      ],
      [
        25,
        -22
      ],
      [
        49,
        54
      ],
      [
        38,
        22
      ],
      [
        49,
        65
      ],
      [
        37,
        22
      ],
      [
        0,
        -119
      ],
      [
        13,
        0
      ],
      [
        24,
        54
      ],
      [
        38,
        0
      ],
      [
        99,
        11
      ],
      [
        37,
        -11
      ],
      [
        37,
        -22
      ],
      [
        50,
        -43
      ],
      [
        12,
        -33
      ],
      [
        0,
        -76
      ],
      [
        -87,
        -97
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -55
      ],
      [
        12,
        -21
      ],
      [
        -24,
        -11
      ],
      [
        0,
        -22
      ],
      [
        24,
        -22
      ],
      [
        38,
        11
      ],
      [
        24,
        -21
      ],
      [
        -24,
        -55
      ],
      [
        0,
        -32
      ],
      [
        -38,
        -22
      ],
      [
        -74,
        -54
      ],
      [
        0,
        -11
      ],
      [
        87,
        44
      ],
      [
        25,
        0
      ],
      [
        12,
        32
      ],
      [
        37,
        0
      ],
      [
        37,
        -11
      ],
      [
        62,
        54
      ],
      [
        25,
        -10
      ],
      [
        25,
        10
      ],
      [
        49,
        55
      ],
      [
        13,
        0
      ],
      [
        0,
        -87
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -43
      ],
      [
        -24,
        -11
      ],
      [
        24,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        -11
      ],
      [
        25,
        -22
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        -62,
        -76
      ],
      [
        12,
        -43
      ],
      [
        25,
        -43
      ],
      [
        50,
        10
      ],
      [
        37,
        44
      ],
      [
        74,
        163
      ],
      [
        74,
        43
      ],
      [
        50,
        43
      ],
      [
        25,
        -11
      ],
      [
        -37,
        -54
      ],
      [
        -50,
        -141
      ],
      [
        -25,
        -97
      ],
      [
        0,
        -87
      ],
      [
        25,
        -33
      ],
      [
        50,
        55
      ],
      [
        24,
        43
      ],
      [
        37,
        98
      ],
      [
        25,
        -22
      ],
      [
        0,
        -33
      ],
      [
        25,
        -86
      ],
      [
        -12,
        -76
      ],
      [
        -87,
        -206
      ],
      [
        12,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -98
      ],
      [
        -25,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        43
      ],
      [
        -37,
        0
      ],
      [
        -50,
        -54
      ],
      [
        -12,
        0
      ],
      [
        -12,
        32
      ],
      [
        0,
        130
      ],
      [
        12,
        44
      ],
      [
        -12,
        32
      ],
      [
        12,
        55
      ],
      [
        -12,
        32
      ],
      [
        -62,
        -87
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -65
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -13,
        54
      ],
      [
        38,
        98
      ],
      [
        37,
        119
      ],
      [
        37,
        76
      ],
      [
        0,
        43
      ],
      [
        -13,
        33
      ],
      [
        -12,
        87
      ],
      [
        -37,
        97
      ],
      [
        -50,
        33
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -62,
        -141
      ],
      [
        -25,
        -87
      ],
      [
        -25,
        11
      ],
      [
        -12,
        21
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -74,
        -141
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        -50,
        -87
      ],
      [
        -37,
        0
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -11
      ],
      [
        -111,
        -21
      ],
      [
        -38,
        32
      ],
      [
        0,
        33
      ],
      [
        38,
        65
      ],
      [
        74,
        21
      ],
      [
        49,
        33
      ],
      [
        38,
        54
      ],
      [
        62,
        119
      ],
      [
        74,
        44
      ],
      [
        37,
        32
      ],
      [
        25,
        44
      ],
      [
        0,
        21
      ],
      [
        -50,
        -32
      ],
      [
        -49,
        22
      ],
      [
        -99,
        0
      ],
      [
        -25,
        -109
      ],
      [
        -50,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -37,
        22
      ],
      [
        -74,
        -22
      ],
      [
        0,
        22
      ],
      [
        74,
        43
      ],
      [
        13,
        119
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -21
      ],
      [
        -38,
        21
      ],
      [
        -12,
        -10
      ],
      [
        -25,
        -66
      ],
      [
        -74,
        -32
      ],
      [
        -87,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -235,
        44
      ],
      [
        -74,
        -11
      ],
      [
        -75,
        22
      ],
      [
        -12,
        10
      ],
      [
        -136,
        0
      ],
      [
        0,
        44
      ],
      [
        -62,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -174,
        -33
      ],
      [
        -37,
        22
      ],
      [
        -37,
        87
      ],
      [
        -12,
        97
      ],
      [
        37,
        66
      ],
      [
        99,
        97
      ],
      [
        87,
        109
      ],
      [
        37,
        54
      ],
      [
        37,
        11
      ],
      [
        62,
        54
      ],
      [
        -62,
        0
      ],
      [
        -37,
        11
      ],
      [
        -37,
        0
      ],
      [
        -75,
        -11
      ],
      [
        -74,
        0
      ],
      [
        0,
        22
      ],
      [
        37,
        43
      ],
      [
        50,
        43
      ],
      [
        0,
        -32
      ],
      [
        24,
        -22
      ],
      [
        38,
        -11
      ],
      [
        12,
        22
      ],
      [
        12,
        76
      ],
      [
        37,
        97
      ],
      [
        13,
        66
      ],
      [
        49,
        54
      ],
      [
        13,
        -11
      ],
      [
        49,
        -11
      ],
      [
        25,
        11
      ],
      [
        37,
        87
      ],
      [
        -37,
        11
      ],
      [
        -37,
        43
      ],
      [
        0,
        54
      ],
      [
        12,
        33
      ],
      [
        25,
        32
      ],
      [
        37,
        33
      ],
      [
        50,
        -44
      ],
      [
        25,
        22
      ],
      [
        -38,
        54
      ],
      [
        -12,
        65
      ],
      [
        74,
        206
      ],
      [
        38,
        109
      ],
      [
        49,
        163
      ],
      [
        37,
        75
      ],
      [
        62,
        22
      ],
      [
        -37,
        22
      ],
      [
        0,
        43
      ],
      [
        50,
        44
      ],
      [
        49,
        86
      ],
      [
        -12,
        44
      ],
      [
        74,
        76
      ],
      [
        25,
        97
      ],
      [
        37,
        54
      ],
      [
        149,
        76
      ],
      [
        62,
        55
      ],
      [
        37,
        -11
      ],
      [
        12,
        -33
      ],
      [
        62,
        -21
      ],
      [
        12,
        21
      ],
      [
        -12,
        33
      ],
      [
        12,
        11
      ],
      [
        62,
        10
      ],
      [
        13,
        -32
      ]
    ],
    [
      [
        17912,
        88367
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        32
      ],
      [
        -12,
        98
      ],
      [
        37,
        32
      ],
      [
        37,
        -65
      ],
      [
        0,
        -86
      ]
    ],
    [
      [
        42873,
        88627
      ],
      [
        -13,
        32
      ],
      [
        50,
        33
      ],
      [
        -13,
        -43
      ],
      [
        -24,
        -22
      ]
    ],
    [
      [
        34610,
        88670
      ],
      [
        -12,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -12,
        22
      ],
      [
        99,
        54
      ],
      [
        24,
        -11
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        16847,
        88670
      ],
      [
        -25,
        11
      ],
      [
        -12,
        76
      ],
      [
        12,
        33
      ],
      [
        25,
        -33
      ],
      [
        0,
        -87
      ]
    ],
    [
      [
        17763,
        88952
      ],
      [
        -37,
        -11
      ],
      [
        13,
        33
      ],
      [
        0,
        163
      ],
      [
        24,
        43
      ],
      [
        38,
        11
      ],
      [
        -13,
        -152
      ],
      [
        -25,
        -87
      ]
    ],
    [
      [
        17565,
        89017
      ],
      [
        -12,
        -32
      ],
      [
        -50,
        65
      ],
      [
        -49,
        97
      ],
      [
        0,
        55
      ],
      [
        25,
        -11
      ],
      [
        61,
        -76
      ],
      [
        25,
        -43
      ],
      [
        0,
        -55
      ]
    ],
    [
      [
        17429,
        89321
      ],
      [
        -25,
        11
      ],
      [
        -37,
        65
      ],
      [
        0,
        43
      ],
      [
        25,
        -11
      ],
      [
        37,
        -108
      ]
    ],
    [
      [
        34152,
        89158
      ],
      [
        -99,
        11
      ],
      [
        -124,
        54
      ],
      [
        -161,
        76
      ],
      [
        -62,
        33
      ],
      [
        -12,
        21
      ],
      [
        49,
        76
      ],
      [
        25,
        11
      ],
      [
        173,
        22
      ],
      [
        62,
        -11
      ],
      [
        137,
        -173
      ],
      [
        12,
        -66
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        16599,
        89440
      ],
      [
        25,
        -54
      ],
      [
        12,
        -54
      ],
      [
        0,
        -54
      ],
      [
        -62,
        -33
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -22
      ],
      [
        62,
        -33
      ],
      [
        25,
        -43
      ],
      [
        50,
        -11
      ],
      [
        49,
        -21
      ],
      [
        -49,
        -76
      ],
      [
        62,
        -98
      ],
      [
        12,
        -11
      ],
      [
        37,
        11
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        25,
        -22
      ],
      [
        50,
        0
      ],
      [
        0,
        -43
      ],
      [
        -38,
        -43
      ],
      [
        -61,
        54
      ],
      [
        -38,
        54
      ],
      [
        -12,
        43
      ],
      [
        -87,
        98
      ],
      [
        -99,
        130
      ],
      [
        -25,
        22
      ],
      [
        -37,
        76
      ],
      [
        13,
        21
      ],
      [
        37,
        11
      ],
      [
        0,
        22
      ],
      [
        -112,
        43
      ],
      [
        -24,
        44
      ],
      [
        61,
        0
      ],
      [
        112,
        21
      ],
      [
        12,
        22
      ],
      [
        50,
        11
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        17689,
        89288
      ],
      [
        25,
        -206
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -98
      ],
      [
        -25,
        44
      ],
      [
        0,
        249
      ],
      [
        -12,
        0
      ],
      [
        -13,
        -43
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        54
      ],
      [
        -25,
        87
      ],
      [
        -24,
        43
      ],
      [
        0,
        33
      ],
      [
        37,
        76
      ],
      [
        0,
        65
      ],
      [
        12,
        21
      ],
      [
        25,
        0
      ],
      [
        74,
        -65
      ],
      [
        37,
        -43
      ],
      [
        25,
        -98
      ]
    ],
    [
      [
        17479,
        89397
      ],
      [
        -38,
        -11
      ],
      [
        -12,
        22
      ],
      [
        0,
        43
      ],
      [
        25,
        43
      ],
      [
        25,
        11
      ],
      [
        0,
        -108
      ]
    ],
    [
      [
        34424,
        89516
      ],
      [
        0,
        -22
      ],
      [
        -24,
        0
      ],
      [
        -25,
        33
      ],
      [
        12,
        22
      ],
      [
        37,
        -33
      ]
    ],
    [
      [
        17243,
        89429
      ],
      [
        -25,
        0
      ],
      [
        -74,
        109
      ],
      [
        -49,
        32
      ],
      [
        -38,
        55
      ],
      [
        -37,
        32
      ],
      [
        25,
        54
      ],
      [
        12,
        0
      ],
      [
        75,
        -43
      ],
      [
        86,
        -76
      ],
      [
        62,
        -119
      ],
      [
        -37,
        -44
      ]
    ],
    [
      [
        17119,
        89917
      ],
      [
        -37,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        11
      ],
      [
        -38,
        44
      ],
      [
        -24,
        -11
      ],
      [
        12,
        -33
      ],
      [
        -25,
        0
      ],
      [
        0,
        54
      ],
      [
        13,
        22
      ],
      [
        74,
        65
      ],
      [
        50,
        -32
      ],
      [
        24,
        -55
      ]
    ],
    [
      [
        16277,
        90026
      ],
      [
        37,
        -33
      ],
      [
        74,
        22
      ],
      [
        50,
        -54
      ],
      [
        12,
        -44
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -21
      ],
      [
        -124,
        -76
      ],
      [
        0,
        -22
      ],
      [
        136,
        11
      ],
      [
        0,
        76
      ],
      [
        25,
        43
      ],
      [
        -12,
        109
      ],
      [
        62,
        0
      ],
      [
        49,
        21
      ],
      [
        37,
        44
      ],
      [
        13,
        0
      ],
      [
        -13,
        -98
      ],
      [
        -62,
        -173
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -130
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        -112,
        -44
      ],
      [
        -61,
        0
      ],
      [
        -50,
        44
      ],
      [
        -25,
        32
      ],
      [
        13,
        33
      ],
      [
        62,
        0
      ],
      [
        24,
        -22
      ],
      [
        13,
        11
      ],
      [
        -87,
        65
      ],
      [
        -62,
        32
      ],
      [
        -25,
        76
      ],
      [
        -49,
        98
      ],
      [
        -13,
        87
      ],
      [
        0,
        54
      ],
      [
        13,
        87
      ],
      [
        12,
        11
      ],
      [
        124,
        -22
      ]
    ],
    [
      [
        16872,
        90243
      ],
      [
        0,
        43
      ],
      [
        12,
        54
      ],
      [
        49,
        -10
      ],
      [
        -12,
        -44
      ],
      [
        -49,
        -43
      ]
    ],
    [
      [
        16995,
        90427
      ],
      [
        100,
        109
      ],
      [
        24,
        54
      ]
    ],
    [
      [
        17119,
        90590
      ],
      [
        13,
        -54
      ],
      [
        -50,
        -76
      ],
      [
        -74,
        -44
      ],
      [
        -13,
        11
      ]
    ],
    [
      [
        40940,
        91219
      ],
      [
        0,
        -11
      ],
      [
        -74,
        22
      ],
      [
        12,
        43
      ],
      [
        25,
        11
      ],
      [
        50,
        -33
      ],
      [
        -13,
        -32
      ]
    ],
    [
      [
        34808,
        91284
      ],
      [
        -37,
        -11
      ],
      [
        0,
        22
      ],
      [
        25,
        43
      ],
      [
        12,
        44
      ],
      [
        0,
        54
      ],
      [
        25,
        32
      ],
      [
        25,
        0
      ],
      [
        0,
        -108
      ],
      [
        -12,
        -33
      ],
      [
        -38,
        -43
      ]
    ],
    [
      [
        34412,
        91327
      ],
      [
        -37,
        0
      ],
      [
        0,
        44
      ],
      [
        74,
        54
      ],
      [
        37,
        0
      ],
      [
        25,
        22
      ],
      [
        13,
        -11
      ],
      [
        -13,
        -33
      ],
      [
        -99,
        -76
      ]
    ],
    [
      [
        34771,
        91360
      ],
      [
        -62,
        -119
      ],
      [
        -24,
        -120
      ],
      [
        -25,
        0
      ],
      [
        -13,
        22
      ],
      [
        50,
        141
      ],
      [
        -12,
        43
      ],
      [
        -87,
        -173
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        11
      ],
      [
        37,
        130
      ],
      [
        -25,
        22
      ],
      [
        -74,
        -119
      ],
      [
        -37,
        -44
      ],
      [
        -37,
        22
      ],
      [
        0,
        22
      ],
      [
        136,
        195
      ],
      [
        25,
        54
      ],
      [
        24,
        -11
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        13,
        -10
      ],
      [
        24,
        21
      ],
      [
        25,
        44
      ],
      [
        25,
        108
      ],
      [
        12,
        87
      ],
      [
        25,
        -33
      ],
      [
        25,
        -10
      ],
      [
        12,
        -33
      ],
      [
        50,
        -33
      ],
      [
        0,
        -43
      ],
      [
        12,
        -11
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        34449,
        91674
      ],
      [
        -25,
        11
      ],
      [
        13,
        54
      ],
      [
        25,
        -32
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        40680,
        92162
      ],
      [
        25,
        -10
      ],
      [
        12,
        -76
      ],
      [
        -49,
        10
      ],
      [
        -62,
        44
      ],
      [
        12,
        32
      ],
      [
        25,
        22
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        34499,
        92141
      ],
      [
        -37,
        0
      ],
      [
        12,
        54
      ],
      [
        25,
        0
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        38128,
        93095
      ],
      [
        -25,
        -43
      ],
      [
        -24,
        0
      ],
      [
        0,
        65
      ],
      [
        -13,
        32
      ],
      [
        50,
        11
      ],
      [
        12,
        -65
      ]
    ],
    [
      [
        34375,
        93551
      ],
      [
        -37,
        0
      ],
      [
        49,
        65
      ],
      [
        50,
        -11
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -21
      ]
    ],
    [
      [
        39763,
        93919
      ],
      [
        -12,
        -43
      ],
      [
        -99,
        54
      ],
      [
        -37,
        44
      ],
      [
        0,
        32
      ],
      [
        62,
        11
      ],
      [
        62,
        -54
      ],
      [
        24,
        -44
      ]
    ],
    [
      [
        38450,
        93843
      ],
      [
        -49,
        11
      ],
      [
        12,
        65
      ],
      [
        37,
        55
      ],
      [
        25,
        75
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        50,
        -54
      ],
      [
        0,
        -54
      ],
      [
        -62,
        -54
      ],
      [
        -75,
        -44
      ]
    ],
    [
      [
        34908,
        94147
      ],
      [
        -50,
        -11
      ],
      [
        25,
        44
      ],
      [
        62,
        21
      ],
      [
        62,
        0
      ],
      [
        -13,
        -21
      ],
      [
        -86,
        -33
      ]
    ],
    [
      [
        39615,
        94548
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        33
      ],
      [
        -149,
        98
      ],
      [
        -12,
        54
      ],
      [
        24,
        11
      ],
      [
        75,
        11
      ],
      [
        62,
        0
      ],
      [
        49,
        -11
      ],
      [
        50,
        -44
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -49,
        -65
      ]
    ],
    [
      [
        29915,
        94841
      ],
      [
        -49,
        33
      ],
      [
        -13,
        21
      ],
      [
        50,
        11
      ],
      [
        25,
        -32
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        39553,
        94863
      ],
      [
        25,
        0
      ],
      [
        0,
        -22
      ],
      [
        37,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -87,
        43
      ],
      [
        -25,
        44
      ],
      [
        0,
        22
      ],
      [
        25,
        21
      ],
      [
        37,
        -11
      ],
      [
        13,
        -32
      ]
    ],
    [
      [
        34561,
        95199
      ],
      [
        24,
        -11
      ],
      [
        38,
        -65
      ],
      [
        24,
        -22
      ],
      [
        -12,
        -141
      ],
      [
        -25,
        -32
      ],
      [
        -74,
        -163
      ],
      [
        -37,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -100,
        98
      ],
      [
        -37,
        22
      ],
      [
        -24,
        43
      ],
      [
        0,
        130
      ],
      [
        12,
        54
      ],
      [
        74,
        120
      ],
      [
        62,
        43
      ],
      [
        50,
        -11
      ],
      [
        62,
        11
      ]
    ],
    [
      [
        39627,
        95297
      ],
      [
        99,
        -11
      ],
      [
        37,
        -44
      ],
      [
        -24,
        -43
      ],
      [
        -62,
        -22
      ],
      [
        -87,
        33
      ],
      [
        -12,
        22
      ],
      [
        37,
        21
      ],
      [
        12,
        44
      ]
    ],
    [
      [
        36468,
        95329
      ],
      [
        -86,
        0
      ],
      [
        -137,
        54
      ],
      [
        25,
        22
      ],
      [
        62,
        -32
      ],
      [
        99,
        0
      ],
      [
        25,
        -11
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        37719,
        95286
      ],
      [
        -61,
        0
      ],
      [
        -50,
        11
      ],
      [
        -37,
        21
      ],
      [
        -25,
        33
      ],
      [
        0,
        32
      ],
      [
        -50,
        55
      ],
      [
        -49,
        10
      ],
      [
        -25,
        44
      ],
      [
        136,
        -22
      ],
      [
        124,
        -65
      ],
      [
        62,
        -76
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        33706,
        95535
      ],
      [
        25,
        -11
      ],
      [
        -13,
        -97
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        -43
      ],
      [
        -149,
        -152
      ],
      [
        -161,
        -130
      ],
      [
        -37,
        0
      ],
      [
        -37,
        22
      ],
      [
        -50,
        0
      ],
      [
        -111,
        -44
      ],
      [
        -13,
        87
      ],
      [
        -62,
        76
      ],
      [
        0,
        22
      ],
      [
        62,
        65
      ],
      [
        124,
        217
      ],
      [
        37,
        0
      ],
      [
        62,
        -22
      ],
      [
        50,
        0
      ],
      [
        87,
        43
      ],
      [
        86,
        -11
      ],
      [
        75,
        33
      ],
      [
        37,
        0
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        35130,
        95861
      ],
      [
        25,
        -22
      ],
      [
        37,
        0
      ],
      [
        62,
        -109
      ],
      [
        0,
        -21
      ],
      [
        -49,
        -44
      ],
      [
        -50,
        -21
      ],
      [
        -74,
        11
      ],
      [
        -87,
        65
      ],
      [
        -86,
        108
      ],
      [
        0,
        22
      ],
      [
        99,
        21
      ],
      [
        99,
        0
      ],
      [
        24,
        -10
      ]
    ],
    [
      [
        35539,
        95817
      ],
      [
        -37,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -149,
        120
      ],
      [
        87,
        54
      ],
      [
        124,
        -65
      ],
      [
        37,
        -44
      ],
      [
        -13,
        -65
      ]
    ],
    [
      [
        35205,
        96186
      ],
      [
        -25,
        -33
      ],
      [
        -62,
        11
      ],
      [
        -12,
        33
      ],
      [
        86,
        21
      ],
      [
        13,
        -32
      ]
    ],
    [
      [
        32703,
        96978
      ],
      [
        37,
        0
      ],
      [
        12,
        32
      ],
      [
        62,
        87
      ],
      [
        37,
        11
      ],
      [
        87,
        -65
      ],
      [
        25,
        -33
      ],
      [
        12,
        -43
      ],
      [
        87,
        -33
      ],
      [
        136,
        -32
      ],
      [
        99,
        -109
      ],
      [
        74,
        -32
      ],
      [
        137,
        -98
      ],
      [
        111,
        -22
      ],
      [
        75,
        -43
      ],
      [
        86,
        -141
      ],
      [
        50,
        -163
      ],
      [
        -25,
        -32
      ],
      [
        -62,
        -54
      ],
      [
        62,
        0
      ],
      [
        136,
        32
      ],
      [
        112,
        -32
      ],
      [
        25,
        43
      ],
      [
        37,
        0
      ],
      [
        49,
        -43
      ],
      [
        37,
        -55
      ],
      [
        0,
        -21
      ],
      [
        112,
        -65
      ],
      [
        -12,
        -22
      ],
      [
        -149,
        -108
      ],
      [
        -74,
        -66
      ],
      [
        -38,
        -10
      ],
      [
        -49,
        10
      ],
      [
        -62,
        33
      ],
      [
        -273,
        98
      ],
      [
        -74,
        10
      ],
      [
        -12,
        11
      ],
      [
        -25,
        120
      ],
      [
        -25,
        21
      ],
      [
        -161,
        44
      ],
      [
        0,
        65
      ],
      [
        -12,
        21
      ],
      [
        -87,
        -10
      ],
      [
        -99,
        -55
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -87
      ],
      [
        -25,
        -33
      ],
      [
        -136,
        -130
      ],
      [
        -62,
        -10
      ],
      [
        -62,
        -131
      ],
      [
        -99,
        -86
      ],
      [
        -62,
        -33
      ],
      [
        -87,
        -32
      ],
      [
        -61,
        -11
      ],
      [
        -38,
        11
      ],
      [
        -24,
        86
      ],
      [
        -50,
        239
      ],
      [
        -25,
        32
      ],
      [
        -173,
        -32
      ],
      [
        -99,
        0
      ],
      [
        -87,
        -54
      ],
      [
        -74,
        0
      ],
      [
        -37,
        11
      ],
      [
        -13,
        54
      ],
      [
        87,
        141
      ],
      [
        223,
        119
      ],
      [
        12,
        22
      ],
      [
        0,
        65
      ],
      [
        -25,
        87
      ],
      [
        -12,
        86
      ],
      [
        12,
        98
      ],
      [
        38,
        141
      ],
      [
        12,
        76
      ],
      [
        25,
        249
      ],
      [
        12,
        76
      ],
      [
        37,
        109
      ],
      [
        62,
        76
      ],
      [
        37,
        32
      ],
      [
        50,
        22
      ],
      [
        37,
        -44
      ],
      [
        62,
        -32
      ],
      [
        50,
        -65
      ],
      [
        0,
        -65
      ],
      [
        -50,
        -44
      ],
      [
        74,
        -54
      ],
      [
        38,
        -108
      ]
    ],
    [
      [
        32789,
        97173
      ],
      [
        -37,
        0
      ],
      [
        -25,
        54
      ],
      [
        -86,
        65
      ],
      [
        -13,
        33
      ],
      [
        -12,
        86
      ],
      [
        12,
        44
      ],
      [
        75,
        -11
      ],
      [
        86,
        -130
      ],
      [
        25,
        -87
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        33124,
        97314
      ],
      [
        37,
        -22
      ],
      [
        111,
        -22
      ],
      [
        13,
        -21
      ],
      [
        -50,
        -44
      ],
      [
        -74,
        44
      ],
      [
        -12,
        -22
      ],
      [
        -62,
        11
      ],
      [
        37,
        54
      ],
      [
        -37,
        22
      ],
      [
        -62,
        -33
      ],
      [
        -38,
        22
      ],
      [
        -12,
        87
      ],
      [
        -25,
        32
      ],
      [
        -49,
        22
      ],
      [
        -37,
        43
      ],
      [
        24,
        33
      ],
      [
        99,
        -33
      ],
      [
        112,
        -65
      ],
      [
        25,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -21
      ],
      [
        25,
        -22
      ]
    ],
    [
      [
        33322,
        97618
      ],
      [
        74,
        -11
      ],
      [
        -49,
        -44
      ],
      [
        -25,
        55
      ]
    ],
    [
      [
        24738,
        98073
      ],
      [
        37,
        -11
      ],
      [
        62,
        0
      ],
      [
        -13,
        -43
      ],
      [
        -37,
        -44
      ],
      [
        -37,
        55
      ],
      [
        -12,
        43
      ]
    ],
    [
      [
        40358,
        98106
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        22
      ],
      [
        87,
        75
      ],
      [
        74,
        0
      ],
      [
        -99,
        -75
      ]
    ],
    [
      [
        24799,
        98322
      ],
      [
        -12,
        -54
      ],
      [
        -74,
        65
      ],
      [
        0,
        65
      ],
      [
        12,
        65
      ],
      [
        25,
        22
      ],
      [
        25,
        -32
      ],
      [
        0,
        -65
      ],
      [
        24,
        -33
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        24366,
        98680
      ],
      [
        62,
        0
      ],
      [
        37,
        -54
      ],
      [
        -12,
        -11
      ],
      [
        -87,
        44
      ],
      [
        0,
        21
      ]
    ],
    [
      [
        36592,
        98561
      ],
      [
        -161,
        -11
      ],
      [
        -99,
        11
      ],
      [
        -62,
        22
      ],
      [
        -62,
        97
      ],
      [
        13,
        55
      ],
      [
        111,
        10
      ],
      [
        173,
        -43
      ],
      [
        100,
        0
      ],
      [
        37,
        -11
      ],
      [
        25,
        -76
      ],
      [
        0,
        -54
      ],
      [
        -75,
        0
      ]
    ],
    [
      [
        32133,
        98529
      ],
      [
        -99,
        43
      ],
      [
        -13,
        32
      ],
      [
        25,
        98
      ],
      [
        -37,
        33
      ],
      [
        0,
        32
      ],
      [
        37,
        65
      ],
      [
        50,
        54
      ],
      [
        49,
        -10
      ],
      [
        50,
        -66
      ],
      [
        -13,
        -32
      ],
      [
        25,
        -98
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -76
      ],
      [
        -49,
        -43
      ]
    ],
    [
      [
        35886,
        98897
      ],
      [
        186,
        -65
      ],
      [
        25,
        -32
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -44
      ],
      [
        12,
        -141
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -65
      ],
      [
        -62,
        -86
      ],
      [
        -161,
        -65
      ],
      [
        -87,
        -22
      ],
      [
        -99,
        0
      ],
      [
        -124,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -49,
        22
      ],
      [
        -25,
        32
      ],
      [
        -50,
        120
      ],
      [
        -24,
        108
      ],
      [
        24,
        98
      ],
      [
        38,
        65
      ],
      [
        62,
        86
      ],
      [
        86,
        109
      ],
      [
        112,
        32
      ],
      [
        99,
        0
      ],
      [
        37,
        11
      ],
      [
        99,
        0
      ]
    ],
    [
      [
        34746,
        98810
      ],
      [
        -24,
        -10
      ],
      [
        -37,
        43
      ],
      [
        12,
        54
      ],
      [
        62,
        11
      ],
      [
        49,
        -54
      ],
      [
        -62,
        -44
      ]
    ],
    [
      [
        25951,
        98941
      ],
      [
        -49,
        10
      ],
      [
        -87,
        44
      ],
      [
        -37,
        32
      ],
      [
        25,
        22
      ],
      [
        99,
        0
      ],
      [
        37,
        -11
      ],
      [
        37,
        -32
      ],
      [
        13,
        -44
      ],
      [
        -38,
        -21
      ]
    ],
    [
      [
        36159,
        98908
      ],
      [
        -25,
        0
      ],
      [
        -37,
        33
      ],
      [
        -87,
        43
      ],
      [
        -25,
        33
      ],
      [
        0,
        43
      ],
      [
        37,
        65
      ],
      [
        75,
        -11
      ],
      [
        24,
        -22
      ],
      [
        62,
        -97
      ],
      [
        0,
        -54
      ],
      [
        -24,
        -33
      ]
    ],
    [
      [
        26881,
        99060
      ],
      [
        -162,
        54
      ],
      [
        13,
        22
      ],
      [
        49,
        22
      ],
      [
        50,
        54
      ],
      [
        87,
        -33
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        -37,
        -43
      ]
    ],
    [
      [
        27438,
        99190
      ],
      [
        -50,
        -43
      ],
      [
        -86,
        32
      ],
      [
        12,
        141
      ],
      [
        25,
        22
      ],
      [
        37,
        -11
      ],
      [
        37,
        -43
      ],
      [
        50,
        -33
      ],
      [
        -25,
        -65
      ]
    ],
    [
      [
        27525,
        99320
      ],
      [
        -13,
        -32
      ],
      [
        -62,
        21
      ],
      [
        -12,
        55
      ],
      [
        25,
        32
      ],
      [
        49,
        -22
      ],
      [
        13,
        -54
      ]
    ],
    [
      [
        30795,
        99450
      ],
      [
        -37,
        0
      ],
      [
        -37,
        44
      ],
      [
        -25,
        0
      ],
      [
        0,
        32
      ],
      [
        62,
        22
      ],
      [
        37,
        -76
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        34672,
        99223
      ],
      [
        -49,
        0
      ],
      [
        -13,
        54
      ],
      [
        50,
        65
      ],
      [
        37,
        32
      ],
      [
        87,
        22
      ],
      [
        24,
        65
      ],
      [
        50,
        22
      ],
      [
        0,
        54
      ],
      [
        74,
        22
      ],
      [
        37,
        0
      ],
      [
        38,
        -54
      ],
      [
        -13,
        -22
      ],
      [
        -62,
        -44
      ],
      [
        -49,
        -75
      ],
      [
        -87,
        -98
      ],
      [
        -124,
        -43
      ]
    ],
    [
      [
        30894,
        99580
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        54
      ],
      [
        0,
        22
      ],
      [
        37,
        32
      ],
      [
        62,
        0
      ]
    ],
    [
      [
        35428,
        99407
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        11
      ],
      [
        -37,
        32
      ],
      [
        -12,
        44
      ],
      [
        12,
        97
      ],
      [
        75,
        11
      ],
      [
        37,
        -21
      ],
      [
        87,
        0
      ],
      [
        24,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -62,
        -54
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        -22
      ]
    ],
    [
      [
        27116,
        99559
      ],
      [
        -37,
        0
      ],
      [
        0,
        32
      ],
      [
        24,
        22
      ],
      [
        -37,
        22
      ],
      [
        0,
        43
      ],
      [
        75,
        -22
      ],
      [
        37,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -43
      ]
    ],
    [
      [
        29061,
        99678
      ],
      [
        49,
        -43
      ],
      [
        -25,
        -87
      ],
      [
        -49,
        -22
      ],
      [
        -50,
        11
      ],
      [
        25,
        33
      ],
      [
        -12,
        86
      ],
      [
        -37,
        11
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        22
      ],
      [
        0,
        76
      ],
      [
        12,
        32
      ],
      [
        50,
        44
      ],
      [
        37,
        0
      ],
      [
        62,
        -33
      ]
    ],
    [
      [
        14084,
        99678
      ],
      [
        -24,
        -22
      ],
      [
        -62,
        33
      ],
      [
        49,
        32
      ],
      [
        25,
        0
      ],
      [
        74,
        -32
      ],
      [
        -62,
        -11
      ]
    ],
    [
      [
        38562,
        99656
      ],
      [
        -13,
        -10
      ],
      [
        -86,
        32
      ],
      [
        -13,
        22
      ],
      [
        87,
        43
      ],
      [
        25,
        0
      ],
      [
        49,
        -32
      ],
      [
        -49,
        -55
      ]
    ],
    [
      [
        35081,
        99765
      ],
      [
        12,
        -54
      ],
      [
        -111,
        -55
      ],
      [
        -87,
        -32
      ],
      [
        -74,
        22
      ],
      [
        62,
        65
      ],
      [
        99,
        21
      ],
      [
        37,
        44
      ],
      [
        62,
        -11
      ]
    ],
    [
      [
        34598,
        99808
      ],
      [
        25,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        -62,
        -32
      ],
      [
        -111,
        -11
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -62,
        11
      ],
      [
        -37,
        43
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        43
      ],
      [
        -124,
        22
      ],
      [
        0,
        22
      ],
      [
        50,
        22
      ],
      [
        62,
        -11
      ],
      [
        12,
        43
      ],
      [
        50,
        -11
      ],
      [
        24,
        11
      ],
      [
        87,
        -43
      ],
      [
        124,
        43
      ],
      [
        62,
        -11
      ]
    ],
    [
      [
        28404,
        99721
      ],
      [
        25,
        -10
      ],
      [
        25,
        32
      ],
      [
        62,
        -43
      ],
      [
        37,
        -44
      ],
      [
        99,
        -43
      ],
      [
        136,
        -87
      ],
      [
        87,
        -130
      ],
      [
        37,
        -65
      ],
      [
        37,
        -43
      ],
      [
        87,
        -76
      ],
      [
        49,
        32
      ],
      [
        50,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -62,
        -32
      ],
      [
        -49,
        0
      ],
      [
        -62,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -11
      ],
      [
        -86,
        -65
      ],
      [
        -50,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -136,
        43
      ],
      [
        -87,
        -10
      ],
      [
        -74,
        10
      ],
      [
        -149,
        87
      ],
      [
        -136,
        54
      ],
      [
        -13,
        55
      ],
      [
        -74,
        -33
      ],
      [
        -49,
        0
      ],
      [
        -50,
        22
      ],
      [
        -12,
        54
      ],
      [
        -37,
        11
      ],
      [
        -38,
        -22
      ],
      [
        0,
        -22
      ],
      [
        -86,
        0
      ],
      [
        -38,
        33
      ],
      [
        -37,
        76
      ],
      [
        37,
        54
      ],
      [
        186,
        22
      ],
      [
        62,
        32
      ],
      [
        75,
        55
      ],
      [
        24,
        32
      ],
      [
        -37,
        43
      ],
      [
        0,
        98
      ],
      [
        50,
        -11
      ],
      [
        62,
        -54
      ],
      [
        24,
        22
      ],
      [
        -49,
        76
      ],
      [
        0,
        32
      ],
      [
        25,
        65
      ],
      [
        49,
        33
      ],
      [
        99,
        11
      ],
      [
        37,
        -11
      ],
      [
        100,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        32021,
        100014
      ],
      [
        37,
        -11
      ],
      [
        38,
        11
      ],
      [
        49,
        -21
      ],
      [
        0,
        -55
      ],
      [
        -99,
        -10
      ],
      [
        -50,
        21
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -37,
        54
      ],
      [
        74,
        33
      ],
      [
        62,
        -22
      ]
    ],
    [
      [
        27413,
        100253
      ],
      [
        -74,
        11
      ],
      [
        -37,
        21
      ],
      [
        -13,
        33
      ],
      [
        13,
        43
      ],
      [
        37,
        0
      ],
      [
        87,
        -54
      ],
      [
        -13,
        -54
      ]
    ],
    [
      [
        17194,
        91121
      ],
      [
        0,
        87
      ],
      [
        -25,
        54
      ],
      [
        -50,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -24,
        65
      ],
      [
        -62,
        22
      ],
      [
        -25,
        43
      ],
      [
        -74,
        33
      ],
      [
        -50,
        11
      ],
      [
        -37,
        32
      ],
      [
        -99,
        65
      ],
      [
        -25,
        22
      ],
      [
        -87,
        0
      ],
      [
        -25,
        97
      ],
      [
        0,
        22
      ],
      [
        -24,
        22
      ],
      [
        -50,
        22
      ],
      [
        25,
        108
      ],
      [
        -112,
        33
      ],
      [
        38,
        75
      ],
      [
        -75,
        131
      ],
      [
        -37,
        54
      ],
      [
        -87,
        173
      ],
      [
        -62,
        109
      ],
      [
        -37,
        76
      ],
      [
        -62,
        97
      ],
      [
        -49,
        65
      ],
      [
        12,
        55
      ],
      [
        -99,
        108
      ],
      [
        -49,
        76
      ],
      [
        -137,
        87
      ],
      [
        -62,
        97
      ],
      [
        -12,
        55
      ],
      [
        -62,
        43
      ],
      [
        -62,
        54
      ],
      [
        -49,
        22
      ],
      [
        -50,
        98
      ],
      [
        12,
        32
      ],
      [
        0,
        54
      ],
      [
        -74,
        76
      ],
      [
        -74,
        54
      ],
      [
        -211,
        -97
      ],
      [
        -74,
        -22
      ],
      [
        25,
        -43
      ],
      [
        -13,
        -33
      ],
      [
        -62,
        -11
      ],
      [
        0,
        -108
      ],
      [
        -37,
        -87
      ],
      [
        -87,
        0
      ],
      [
        -161,
        -97
      ],
      [
        -49,
        -55
      ],
      [
        -37,
        11
      ],
      [
        12,
        44
      ],
      [
        -12,
        75
      ],
      [
        -25,
        76
      ],
      [
        -87,
        87
      ],
      [
        -49,
        44
      ],
      [
        -62,
        65
      ],
      [
        -161,
        141
      ],
      [
        -25,
        86
      ],
      [
        -112,
        55
      ],
      [
        -49,
        54
      ],
      [
        12,
        54
      ],
      [
        25,
        65
      ],
      [
        0,
        43
      ],
      [
        -50,
        0
      ],
      [
        -86,
        -10
      ],
      [
        -75,
        0
      ],
      [
        -99,
        -87
      ],
      [
        -161,
        65
      ],
      [
        -24,
        -43
      ],
      [
        -162,
        43
      ],
      [
        0,
        369
      ],
      [
        0,
        368
      ],
      [
        0,
        185
      ],
      [
        0,
        358
      ],
      [
        0,
        368
      ],
      [
        0,
        369
      ],
      [
        0,
        358
      ],
      [
        0,
        184
      ],
      [
        0,
        369
      ],
      [
        0,
        184
      ],
      [
        0,
        358
      ],
      [
        0,
        185
      ],
      [
        0,
        368
      ],
      [
        0,
        358
      ],
      [
        0,
        369
      ],
      [
        0,
        369
      ],
      [
        0,
        358
      ],
      [
        0,
        368
      ]
    ],
    [
      [
        13415,
        99721
      ],
      [
        199,
        -32
      ],
      [
        148,
        11
      ],
      [
        273,
        -65
      ],
      [
        173,
        -120
      ],
      [
        137,
        -65
      ],
      [
        49,
        -43
      ],
      [
        310,
        -108
      ],
      [
        62,
        -11
      ],
      [
        124,
        -44
      ],
      [
        74,
        11
      ],
      [
        124,
        -11
      ],
      [
        86,
        -32
      ],
      [
        174,
        -87
      ],
      [
        49,
        0
      ],
      [
        -61,
        87
      ],
      [
        -75,
        32
      ],
      [
        -87,
        22
      ],
      [
        -24,
        33
      ],
      [
        24,
        21
      ],
      [
        75,
        11
      ],
      [
        -87,
        54
      ],
      [
        74,
        130
      ],
      [
        25,
        -21
      ],
      [
        37,
        32
      ],
      [
        75,
        -21
      ],
      [
        24,
        75
      ],
      [
        25,
        33
      ],
      [
        99,
        11
      ],
      [
        137,
        -11
      ],
      [
        -13,
        65
      ],
      [
        37,
        65
      ],
      [
        50,
        -11
      ],
      [
        37,
        -54
      ],
      [
        87,
        -32
      ],
      [
        -13,
        -66
      ],
      [
        -24,
        -21
      ],
      [
        -62,
        -87
      ],
      [
        86,
        33
      ],
      [
        87,
        43
      ],
      [
        74,
        22
      ],
      [
        62,
        0
      ],
      [
        75,
        43
      ],
      [
        49,
        98
      ],
      [
        25,
        10
      ],
      [
        136,
        0
      ],
      [
        13,
        11
      ],
      [
        -50,
        22
      ],
      [
        25,
        22
      ],
      [
        49,
        11
      ],
      [
        38,
        -33
      ],
      [
        24,
        0
      ],
      [
        87,
        33
      ],
      [
        112,
        75
      ],
      [
        99,
        33
      ],
      [
        24,
        -22
      ],
      [
        38,
        11
      ],
      [
        74,
        87
      ],
      [
        87,
        54
      ],
      [
        86,
        0
      ],
      [
        75,
        -32
      ],
      [
        49,
        10
      ],
      [
        37,
        -10
      ],
      [
        75,
        65
      ],
      [
        37,
        -11
      ],
      [
        25,
        -65
      ],
      [
        -38,
        -44
      ],
      [
        -272,
        -130
      ],
      [
        -87,
        -65
      ],
      [
        -86,
        -32
      ],
      [
        -310,
        -55
      ],
      [
        -37,
        -10
      ],
      [
        -62,
        -76
      ],
      [
        -62,
        -65
      ],
      [
        -62,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -50,
        -44
      ],
      [
        -49,
        -65
      ],
      [
        -149,
        -130
      ],
      [
        25,
        -21
      ],
      [
        211,
        -22
      ],
      [
        49,
        22
      ],
      [
        13,
        21
      ],
      [
        -62,
        11
      ],
      [
        -25,
        65
      ],
      [
        25,
        44
      ],
      [
        62,
        43
      ],
      [
        61,
        11
      ],
      [
        75,
        43
      ],
      [
        74,
        33
      ],
      [
        50,
        54
      ],
      [
        -13,
        22
      ],
      [
        62,
        32
      ],
      [
        99,
        -11
      ],
      [
        13,
        -21
      ],
      [
        49,
        32
      ],
      [
        37,
        0
      ],
      [
        25,
        -65
      ],
      [
        37,
        -22
      ],
      [
        75,
        98
      ],
      [
        99,
        108
      ],
      [
        86,
        44
      ],
      [
        186,
        65
      ],
      [
        161,
        32
      ],
      [
        37,
        33
      ],
      [
        25,
        -33
      ],
      [
        -74,
        -21
      ],
      [
        0,
        -54
      ],
      [
        37,
        -33
      ],
      [
        112,
        65
      ],
      [
        123,
        109
      ],
      [
        25,
        75
      ],
      [
        62,
        33
      ],
      [
        112,
        43
      ],
      [
        37,
        22
      ],
      [
        -124,
        33
      ],
      [
        12,
        32
      ],
      [
        -62,
        33
      ],
      [
        0,
        43
      ],
      [
        50,
        54
      ],
      [
        62,
        -11
      ],
      [
        37,
        -21
      ],
      [
        124,
        -98
      ],
      [
        87,
        -76
      ],
      [
        74,
        -108
      ],
      [
        74,
        -185
      ],
      [
        149,
        -141
      ],
      [
        74,
        -54
      ],
      [
        112,
        -54
      ],
      [
        111,
        -11
      ],
      [
        75,
        43
      ],
      [
        0,
        33
      ],
      [
        -25,
        54
      ],
      [
        -37,
        44
      ],
      [
        49,
        65
      ],
      [
        13,
        54
      ],
      [
        37,
        0
      ],
      [
        111,
        108
      ],
      [
        -74,
        11
      ],
      [
        0,
        22
      ],
      [
        74,
        22
      ],
      [
        13,
        21
      ],
      [
        49,
        22
      ],
      [
        50,
        -22
      ],
      [
        -13,
        -130
      ],
      [
        37,
        -108
      ],
      [
        75,
        -33
      ],
      [
        0,
        -22
      ],
      [
        -112,
        -119
      ],
      [
        13,
        -54
      ],
      [
        111,
        -11
      ],
      [
        25,
        11
      ],
      [
        149,
        0
      ],
      [
        49,
        32
      ],
      [
        37,
        44
      ],
      [
        50,
        32
      ],
      [
        25,
        55
      ],
      [
        24,
        97
      ],
      [
        38,
        22
      ],
      [
        61,
        -11
      ],
      [
        25,
        11
      ],
      [
        112,
        -11
      ],
      [
        111,
        11
      ],
      [
        112,
        -11
      ],
      [
        260,
        -87
      ],
      [
        235,
        -152
      ],
      [
        149,
        -54
      ],
      [
        334,
        -54
      ],
      [
        50,
        -11
      ],
      [
        87,
        -54
      ],
      [
        136,
        -65
      ],
      [
        272,
        -65
      ],
      [
        62,
        -22
      ],
      [
        37,
        11
      ],
      [
        161,
        -22
      ],
      [
        38,
        0
      ],
      [
        124,
        -32
      ],
      [
        -62,
        87
      ],
      [
        111,
        -11
      ],
      [
        12,
        21
      ],
      [
        87,
        -10
      ],
      [
        74,
        -22
      ],
      [
        62,
        -33
      ],
      [
        87,
        -21
      ],
      [
        124,
        -65
      ],
      [
        74,
        -55
      ],
      [
        75,
        -65
      ],
      [
        49,
        -87
      ],
      [
        37,
        -10
      ],
      [
        -49,
        -87
      ],
      [
        -62,
        -11
      ],
      [
        -174,
        22
      ],
      [
        -24,
        -55
      ],
      [
        -99,
        -32
      ],
      [
        -13,
        -76
      ],
      [
        -87,
        -54
      ],
      [
        0,
        -22
      ],
      [
        50,
        -11
      ],
      [
        50,
        -32
      ],
      [
        99,
        -11
      ],
      [
        198,
        -43
      ],
      [
        37,
        0
      ],
      [
        99,
        -22
      ],
      [
        223,
        0
      ],
      [
        50,
        -11
      ],
      [
        223,
        0
      ],
      [
        37,
        22
      ],
      [
        74,
        11
      ],
      [
        186,
        10
      ],
      [
        136,
        44
      ],
      [
        13,
        -22
      ],
      [
        49,
        0
      ],
      [
        62,
        22
      ],
      [
        149,
        76
      ],
      [
        62,
        0
      ],
      [
        37,
        32
      ],
      [
        25,
        -11
      ],
      [
        37,
        -65
      ],
      [
        49,
        -32
      ],
      [
        25,
        -44
      ],
      [
        25,
        -10
      ],
      [
        136,
        -11
      ],
      [
        50,
        -11
      ],
      [
        37,
        -44
      ],
      [
        0,
        -65
      ],
      [
        49,
        -65
      ],
      [
        13,
        11
      ],
      [
        25,
        87
      ],
      [
        37,
        11
      ],
      [
        49,
        -76
      ],
      [
        174,
        -141
      ],
      [
        24,
        -54
      ],
      [
        -24,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        -50,
        -11
      ],
      [
        -74,
        11
      ],
      [
        74,
        -76
      ],
      [
        37,
        -55
      ],
      [
        124,
        -108
      ],
      [
        12,
        -33
      ],
      [
        50,
        -10
      ],
      [
        -50,
        75
      ],
      [
        0,
        55
      ],
      [
        -12,
        86
      ],
      [
        50,
        33
      ],
      [
        37,
        -43
      ],
      [
        37,
        0
      ],
      [
        87,
        -33
      ],
      [
        -75,
        109
      ],
      [
        25,
        21
      ],
      [
        -99,
        109
      ],
      [
        -25,
        76
      ],
      [
        0,
        76
      ],
      [
        -74,
        75
      ],
      [
        -37,
        66
      ],
      [
        0,
        54
      ],
      [
        74,
        54
      ],
      [
        12,
        32
      ],
      [
        -12,
        44
      ],
      [
        111,
        11
      ],
      [
        112,
        32
      ],
      [
        99,
        11
      ],
      [
        37,
        54
      ],
      [
        99,
        0
      ],
      [
        0,
        55
      ],
      [
        50,
        54
      ],
      [
        87,
        11
      ],
      [
        62,
        43
      ],
      [
        37,
        76
      ],
      [
        -62,
        32
      ],
      [
        -37,
        -10
      ],
      [
        -149,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        -111,
        11
      ],
      [
        -74,
        -44
      ],
      [
        -50,
        -10
      ],
      [
        -74,
        21
      ],
      [
        -37,
        0
      ],
      [
        -50,
        -32
      ],
      [
        25,
        -44
      ],
      [
        -13,
        -21
      ],
      [
        -99,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -49,
        -11
      ],
      [
        -38,
        11
      ],
      [
        -123,
        76
      ],
      [
        24,
        54
      ],
      [
        124,
        141
      ],
      [
        186,
        21
      ],
      [
        111,
        33
      ],
      [
        211,
        76
      ],
      [
        37,
        0
      ],
      [
        136,
        54
      ],
      [
        50,
        11
      ],
      [
        124,
        -33
      ],
      [
        49,
        -21
      ],
      [
        50,
        -76
      ],
      [
        50,
        -185
      ],
      [
        99,
        -75
      ],
      [
        49,
        10
      ],
      [
        13,
        -43
      ],
      [
        49,
        0
      ],
      [
        50,
        -22
      ],
      [
        0,
        -54
      ],
      [
        99,
        -54
      ],
      [
        148,
        0
      ],
      [
        87,
        22
      ],
      [
        62,
        32
      ],
      [
        161,
        -108
      ],
      [
        62,
        -55
      ],
      [
        50,
        -32
      ],
      [
        123,
        -43
      ],
      [
        87,
        10
      ],
      [
        62,
        -10
      ],
      [
        112,
        -33
      ],
      [
        161,
        43
      ],
      [
        24,
        0
      ],
      [
        100,
        33
      ],
      [
        37,
        0
      ],
      [
        62,
        22
      ],
      [
        86,
        0
      ],
      [
        248,
        -33
      ],
      [
        62,
        -32
      ],
      [
        50,
        -11
      ],
      [
        74,
        0
      ],
      [
        49,
        11
      ],
      [
        38,
        21
      ],
      [
        99,
        22
      ],
      [
        -25,
        32
      ],
      [
        -50,
        33
      ],
      [
        -37,
        54
      ],
      [
        13,
        44
      ],
      [
        49,
        -11
      ],
      [
        50,
        -44
      ],
      [
        111,
        -130
      ],
      [
        50,
        -43
      ],
      [
        111,
        -44
      ],
      [
        50,
        -10
      ],
      [
        111,
        65
      ],
      [
        0,
        43
      ],
      [
        -25,
        43
      ],
      [
        -49,
        22
      ],
      [
        -62,
        43
      ],
      [
        -74,
        11
      ],
      [
        -124,
        -54
      ],
      [
        -112,
        109
      ],
      [
        13,
        32
      ],
      [
        -13,
        54
      ],
      [
        -24,
        11
      ],
      [
        -50,
        65
      ],
      [
        0,
        22
      ],
      [
        62,
        11
      ],
      [
        87,
        -44
      ],
      [
        49,
        22
      ],
      [
        99,
        22
      ],
      [
        -37,
        43
      ],
      [
        -12,
        44
      ],
      [
        37,
        10
      ],
      [
        99,
        -43
      ],
      [
        12,
        22
      ],
      [
        50,
        -11
      ],
      [
        74,
        -65
      ],
      [
        50,
        -76
      ],
      [
        124,
        -11
      ],
      [
        74,
        33
      ],
      [
        -111,
        -141
      ],
      [
        12,
        -22
      ],
      [
        74,
        32
      ],
      [
        13,
        44
      ],
      [
        136,
        54
      ],
      [
        25,
        0
      ],
      [
        -62,
        -260
      ],
      [
        -13,
        -65
      ],
      [
        -62,
        -109
      ],
      [
        0,
        -21
      ],
      [
        62,
        -66
      ],
      [
        13,
        -75
      ],
      [
        49,
        -11
      ],
      [
        99,
        32
      ],
      [
        13,
        -11
      ],
      [
        -25,
        -65
      ],
      [
        74,
        11
      ],
      [
        50,
        -43
      ],
      [
        0,
        -87
      ],
      [
        -37,
        -22
      ],
      [
        -87,
        -11
      ],
      [
        -62,
        33
      ],
      [
        -87,
        -11
      ],
      [
        -49,
        44
      ],
      [
        -25,
        -22
      ],
      [
        211,
        -206
      ],
      [
        0,
        -54
      ],
      [
        12,
        0
      ],
      [
        12,
        54
      ],
      [
        -12,
        21
      ],
      [
        -87,
        87
      ],
      [
        -12,
        33
      ],
      [
        25,
        21
      ],
      [
        124,
        -21
      ],
      [
        49,
        0
      ],
      [
        50,
        32
      ],
      [
        0,
        109
      ],
      [
        24,
        76
      ],
      [
        -37,
        152
      ],
      [
        -25,
        65
      ],
      [
        -61,
        54
      ],
      [
        -13,
        22
      ],
      [
        87,
        195
      ],
      [
        62,
        0
      ],
      [
        37,
        21
      ],
      [
        87,
        -32
      ],
      [
        37,
        22
      ],
      [
        99,
        75
      ],
      [
        74,
        66
      ],
      [
        50,
        65
      ],
      [
        62,
        43
      ],
      [
        161,
        76
      ],
      [
        0,
        22
      ],
      [
        -62,
        0
      ],
      [
        -13,
        32
      ],
      [
        13,
        98
      ],
      [
        -37,
        87
      ],
      [
        -50,
        10
      ],
      [
        -12,
        -65
      ],
      [
        -50,
        -65
      ],
      [
        -136,
        -21
      ],
      [
        -50,
        32
      ],
      [
        25,
        65
      ],
      [
        25,
        33
      ],
      [
        87,
        54
      ],
      [
        49,
        54
      ],
      [
        -62,
        11
      ],
      [
        -12,
        65
      ],
      [
        12,
        43
      ],
      [
        223,
        55
      ],
      [
        -74,
        -98
      ],
      [
        25,
        -11
      ],
      [
        111,
        87
      ],
      [
        -37,
        11
      ],
      [
        0,
        54
      ],
      [
        -37,
        22
      ],
      [
        -50,
        -11
      ],
      [
        -74,
        -33
      ],
      [
        -50,
        0
      ],
      [
        -62,
        22
      ],
      [
        -99,
        108
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -43
      ],
      [
        -161,
        54
      ],
      [
        -99,
        55
      ],
      [
        -161,
        43
      ],
      [
        -37,
        65
      ],
      [
        -112,
        119
      ],
      [
        -25,
        55
      ],
      [
        0,
        75
      ],
      [
        75,
        87
      ],
      [
        12,
        33
      ],
      [
        62,
        32
      ],
      [
        50,
        11
      ],
      [
        24,
        65
      ],
      [
        -99,
        -32
      ],
      [
        -49,
        21
      ],
      [
        -75,
        87
      ],
      [
        0,
        43
      ],
      [
        38,
        120
      ],
      [
        -25,
        32
      ],
      [
        37,
        33
      ],
      [
        -12,
        43
      ],
      [
        12,
        22
      ],
      [
        124,
        87
      ],
      [
        111,
        -55
      ],
      [
        62,
        0
      ],
      [
        50,
        98
      ],
      [
        -13,
        11
      ],
      [
        -111,
        0
      ],
      [
        -37,
        43
      ],
      [
        87,
        65
      ],
      [
        37,
        65
      ],
      [
        111,
        76
      ],
      [
        198,
        55
      ],
      [
        50,
        -44
      ],
      [
        0,
        -43
      ],
      [
        62,
        -54
      ],
      [
        37,
        -11
      ],
      [
        37,
        11
      ],
      [
        87,
        0
      ],
      [
        25,
        -11
      ],
      [
        -13,
        -44
      ],
      [
        13,
        -21
      ],
      [
        124,
        -76
      ],
      [
        123,
        -120
      ],
      [
        25,
        -43
      ],
      [
        25,
        -87
      ],
      [
        0,
        -130
      ],
      [
        -37,
        -43
      ],
      [
        74,
        -33
      ],
      [
        74,
        -65
      ],
      [
        75,
        -32
      ],
      [
        49,
        -87
      ],
      [
        62,
        -87
      ],
      [
        -12,
        -32
      ],
      [
        49,
        -11
      ],
      [
        38,
        32
      ],
      [
        37,
        -32
      ],
      [
        49,
        -87
      ],
      [
        -148,
        -11
      ],
      [
        -50,
        22
      ],
      [
        -49,
        43
      ],
      [
        -87,
        -87
      ],
      [
        25,
        -10
      ],
      [
        111,
        0
      ],
      [
        50,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -74,
        -55
      ],
      [
        -211,
        -141
      ],
      [
        25,
        -11
      ],
      [
        111,
        22
      ],
      [
        87,
        -22
      ],
      [
        12,
        -32
      ],
      [
        99,
        -43
      ],
      [
        62,
        10
      ],
      [
        124,
        65
      ],
      [
        62,
        0
      ],
      [
        13,
        -21
      ],
      [
        -50,
        -22
      ],
      [
        0,
        -22
      ],
      [
        124,
        -21
      ],
      [
        136,
        0
      ],
      [
        50,
        -33
      ],
      [
        -75,
        -11
      ],
      [
        -49,
        -32
      ],
      [
        -25,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -111,
        11
      ],
      [
        173,
        -109
      ],
      [
        50,
        -97
      ],
      [
        37,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        13,
        -130
      ],
      [
        -25,
        -87
      ],
      [
        86,
        -87
      ],
      [
        25,
        -43
      ],
      [
        25,
        11
      ],
      [
        62,
        76
      ],
      [
        50,
        76
      ],
      [
        -13,
        65
      ],
      [
        37,
        65
      ],
      [
        25,
        130
      ],
      [
        62,
        87
      ],
      [
        62,
        97
      ],
      [
        62,
        22
      ],
      [
        37,
        0
      ],
      [
        87,
        -87
      ],
      [
        62,
        -43
      ],
      [
        148,
        -87
      ],
      [
        62,
        -65
      ],
      [
        25,
        -65
      ],
      [
        12,
        -87
      ],
      [
        38,
        -76
      ],
      [
        0,
        -97
      ],
      [
        -25,
        -33
      ],
      [
        -75,
        0
      ],
      [
        -49,
        65
      ],
      [
        -37,
        -32
      ],
      [
        12,
        -76
      ],
      [
        0,
        -141
      ],
      [
        37,
        -120
      ],
      [
        75,
        -86
      ],
      [
        173,
        -163
      ],
      [
        0,
        -22
      ],
      [
        37,
        -87
      ],
      [
        25,
        -10
      ],
      [
        173,
        151
      ],
      [
        25,
        0
      ],
      [
        62,
        44
      ],
      [
        13,
        108
      ],
      [
        49,
        109
      ],
      [
        149,
        152
      ],
      [
        74,
        238
      ],
      [
        -12,
        76
      ],
      [
        24,
        65
      ],
      [
        50,
        33
      ],
      [
        12,
        32
      ],
      [
        75,
        -21
      ],
      [
        148,
        21
      ],
      [
        0,
        11
      ],
      [
        -86,
        33
      ],
      [
        37,
        65
      ],
      [
        25,
        0
      ],
      [
        24,
        76
      ],
      [
        -86,
        54
      ],
      [
        -50,
        0
      ],
      [
        -49,
        43
      ],
      [
        -13,
        54
      ],
      [
        13,
        55
      ],
      [
        -13,
        54
      ],
      [
        13,
        32
      ],
      [
        -38,
        65
      ],
      [
        25,
        66
      ],
      [
        -25,
        54
      ],
      [
        38,
        11
      ],
      [
        74,
        -33
      ],
      [
        62,
        0
      ],
      [
        124,
        33
      ],
      [
        136,
        -11
      ],
      [
        111,
        -54
      ],
      [
        87,
        -33
      ],
      [
        235,
        -11
      ],
      [
        87,
        11
      ],
      [
        124,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -43
      ],
      [
        -99,
        -22
      ],
      [
        49,
        -22
      ],
      [
        112,
        -32
      ],
      [
        37,
        -65
      ],
      [
        -12,
        -33
      ],
      [
        99,
        11
      ],
      [
        74,
        -11
      ],
      [
        112,
        -33
      ],
      [
        24,
        -54
      ],
      [
        -210,
        -141
      ],
      [
        86,
        0
      ],
      [
        112,
        -21
      ],
      [
        37,
        -44
      ],
      [
        -12,
        -76
      ],
      [
        -75,
        -65
      ],
      [
        -111,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -74,
        33
      ],
      [
        -99,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -22
      ],
      [
        62,
        -76
      ],
      [
        -25,
        -11
      ],
      [
        25,
        -21
      ],
      [
        50,
        -87
      ],
      [
        74,
        22
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -44
      ],
      [
        37,
        -76
      ],
      [
        99,
        -86
      ],
      [
        100,
        -76
      ],
      [
        49,
        -87
      ],
      [
        -12,
        -65
      ],
      [
        -62,
        -184
      ],
      [
        -50,
        -33
      ],
      [
        -87,
        -11
      ],
      [
        -49,
        -43
      ],
      [
        -37,
        -65
      ],
      [
        -50,
        -55
      ],
      [
        -37,
        -10
      ],
      [
        -87,
        -76
      ],
      [
        -111,
        -22
      ],
      [
        -124,
        -108
      ],
      [
        -37,
        -11
      ],
      [
        -62,
        11
      ],
      [
        -12,
        65
      ],
      [
        -38,
        32
      ],
      [
        -86,
        119
      ],
      [
        -75,
        0
      ],
      [
        -49,
        55
      ],
      [
        25,
        11
      ],
      [
        -87,
        75
      ],
      [
        -50,
        33
      ],
      [
        -62,
        11
      ],
      [
        -62,
        -44
      ],
      [
        -24,
        -43
      ],
      [
        37,
        -11
      ],
      [
        49,
        44
      ],
      [
        38,
        0
      ],
      [
        148,
        -141
      ],
      [
        37,
        -22
      ],
      [
        37,
        -98
      ],
      [
        50,
        -65
      ],
      [
        62,
        -108
      ],
      [
        -25,
        -22
      ],
      [
        -49,
        11
      ],
      [
        -99,
        43
      ],
      [
        -38,
        -21
      ],
      [
        -24,
        -55
      ],
      [
        -149,
        55
      ],
      [
        -74,
        43
      ],
      [
        -62,
        65
      ],
      [
        -50,
        65
      ],
      [
        -62,
        22
      ],
      [
        -62,
        -33
      ],
      [
        -309,
        0
      ],
      [
        -13,
        -11
      ],
      [
        13,
        -86
      ],
      [
        37,
        -33
      ],
      [
        161,
        -54
      ],
      [
        37,
        -22
      ],
      [
        12,
        -43
      ],
      [
        -24,
        -65
      ],
      [
        -310,
        -304
      ],
      [
        -87,
        -97
      ],
      [
        -87,
        -22
      ],
      [
        -173,
        0
      ],
      [
        -62,
        32
      ],
      [
        -87,
        76
      ],
      [
        -62,
        44
      ],
      [
        -37,
        11
      ],
      [
        -24,
        43
      ],
      [
        -112,
        43
      ],
      [
        -173,
        109
      ],
      [
        -62,
        11
      ],
      [
        -62,
        0
      ],
      [
        25,
        -44
      ],
      [
        -87,
        11
      ],
      [
        -75,
        33
      ],
      [
        -61,
        -11
      ],
      [
        -174,
        32
      ],
      [
        -99,
        0
      ],
      [
        -37,
        -11
      ],
      [
        111,
        -43
      ],
      [
        38,
        22
      ],
      [
        136,
        -22
      ],
      [
        148,
        -43
      ],
      [
        38,
        0
      ],
      [
        86,
        -44
      ],
      [
        62,
        -54
      ],
      [
        124,
        -130
      ],
      [
        99,
        -65
      ],
      [
        260,
        -44
      ],
      [
        99,
        0
      ],
      [
        186,
        -10
      ],
      [
        124,
        -33
      ],
      [
        12,
        -65
      ],
      [
        -74,
        -108
      ],
      [
        -25,
        -65
      ],
      [
        -210,
        -261
      ],
      [
        -37,
        -97
      ],
      [
        -38,
        -44
      ],
      [
        -99,
        -54
      ],
      [
        -86,
        -54
      ],
      [
        -62,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -37,
        21
      ],
      [
        -25,
        -43
      ],
      [
        -86,
        43
      ],
      [
        -38,
        -21
      ],
      [
        -37,
        11
      ],
      [
        -49,
        43
      ],
      [
        -25,
        54
      ],
      [
        -87,
        -32
      ],
      [
        50,
        -33
      ],
      [
        25,
        -76
      ],
      [
        -25,
        -11
      ],
      [
        -75,
        33
      ],
      [
        38,
        -65
      ],
      [
        12,
        -54
      ],
      [
        -50,
        -65
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -74,
        22
      ],
      [
        -37,
        -43
      ],
      [
        -38,
        -11
      ],
      [
        -111,
        32
      ],
      [
        -136,
        65
      ],
      [
        -149,
        22
      ],
      [
        12,
        32
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -21
      ],
      [
        -86,
        0
      ],
      [
        -211,
        97
      ],
      [
        -161,
        55
      ],
      [
        -62,
        10
      ],
      [
        -25,
        -65
      ],
      [
        38,
        -43
      ],
      [
        49,
        -22
      ],
      [
        62,
        11
      ],
      [
        -49,
        33
      ],
      [
        0,
        32
      ],
      [
        74,
        -32
      ],
      [
        223,
        -87
      ],
      [
        124,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        -86,
        -54
      ],
      [
        0,
        -11
      ],
      [
        62,
        0
      ],
      [
        111,
        76
      ],
      [
        37,
        11
      ],
      [
        50,
        -22
      ],
      [
        74,
        -65
      ],
      [
        50,
        -33
      ],
      [
        86,
        -21
      ],
      [
        124,
        -76
      ],
      [
        13,
        -174
      ],
      [
        -25,
        -65
      ],
      [
        -87,
        -11
      ],
      [
        -111,
        -76
      ],
      [
        -38,
        -11
      ],
      [
        -148,
        11
      ],
      [
        -75,
        22
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        0
      ],
      [
        -13,
        -32
      ],
      [
        25,
        -44
      ],
      [
        62,
        -21
      ],
      [
        62,
        -11
      ],
      [
        0,
        -44
      ],
      [
        -50,
        -21
      ],
      [
        -37,
        21
      ],
      [
        -62,
        -21
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        -54
      ],
      [
        -62,
        -55
      ],
      [
        87,
        -108
      ],
      [
        -37,
        0
      ],
      [
        -75,
        65
      ],
      [
        -99,
        43
      ],
      [
        -12,
        -11
      ],
      [
        87,
        -65
      ],
      [
        12,
        -21
      ],
      [
        -62,
        -44
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        0
      ],
      [
        25,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -74,
        11
      ],
      [
        12,
        -43
      ],
      [
        74,
        -54
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -99,
        -54
      ],
      [
        -62,
        -76
      ],
      [
        -12,
        -32
      ],
      [
        12,
        -55
      ],
      [
        -12,
        -21
      ],
      [
        -50,
        0
      ],
      [
        13,
        -65
      ],
      [
        -38,
        -120
      ],
      [
        -49,
        -97
      ],
      [
        -50,
        -87
      ],
      [
        -24,
        -76
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -22
      ],
      [
        37,
        -32
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -130
      ],
      [
        -25,
        -87
      ],
      [
        13,
        -304
      ],
      [
        -13,
        -130
      ],
      [
        -12,
        -76
      ],
      [
        -12,
        -32
      ],
      [
        37,
        -44
      ],
      [
        0,
        -32
      ],
      [
        25,
        -65
      ],
      [
        37,
        0
      ],
      [
        62,
        -76
      ],
      [
        37,
        -22
      ],
      [
        -13,
        -228
      ],
      [
        25,
        22
      ],
      [
        13,
        152
      ],
      [
        37,
        65
      ],
      [
        25,
        22
      ],
      [
        86,
        10
      ],
      [
        99,
        -21
      ],
      [
        50,
        0
      ],
      [
        25,
        11
      ],
      [
        37,
        -22
      ],
      [
        12,
        -22
      ],
      [
        0,
        -76
      ],
      [
        13,
        -54
      ],
      [
        62,
        -163
      ],
      [
        74,
        -282
      ],
      [
        74,
        -195
      ],
      [
        25,
        -87
      ],
      [
        -62,
        -173
      ],
      [
        -25,
        -33
      ],
      [
        13,
        -21
      ],
      [
        62,
        54
      ],
      [
        49,
        0
      ],
      [
        25,
        -22
      ],
      [
        74,
        33
      ],
      [
        310,
        108
      ],
      [
        74,
        11
      ],
      [
        112,
        -22
      ],
      [
        86,
        -43
      ],
      [
        87,
        -65
      ],
      [
        99,
        -44
      ],
      [
        161,
        -32
      ],
      [
        37,
        -22
      ],
      [
        87,
        -21
      ],
      [
        50,
        -22
      ],
      [
        124,
        -130
      ],
      [
        62,
        -44
      ],
      [
        74,
        -43
      ],
      [
        62,
        -87
      ],
      [
        111,
        -173
      ],
      [
        25,
        -22
      ],
      [
        74,
        -33
      ],
      [
        124,
        -32
      ],
      [
        186,
        -87
      ],
      [
        186,
        -76
      ],
      [
        49,
        -32
      ],
      [
        50,
        -44
      ],
      [
        50,
        -65
      ],
      [
        61,
        -54
      ],
      [
        0,
        -76
      ],
      [
        50,
        44
      ],
      [
        50,
        0
      ],
      [
        74,
        -22
      ],
      [
        74,
        0
      ],
      [
        99,
        22
      ],
      [
        62,
        0
      ],
      [
        37,
        10
      ],
      [
        87,
        -32
      ],
      [
        37,
        0
      ],
      [
        124,
        -22
      ],
      [
        74,
        11
      ],
      [
        38,
        -54
      ],
      [
        62,
        11
      ],
      [
        37,
        -11
      ],
      [
        74,
        -54
      ],
      [
        25,
        -44
      ],
      [
        25,
        -87
      ],
      [
        0,
        -32
      ],
      [
        -50,
        -206
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -65
      ],
      [
        12,
        -44
      ],
      [
        50,
        -86
      ],
      [
        37,
        -141
      ],
      [
        -13,
        -44
      ],
      [
        -12,
        -86
      ],
      [
        0,
        -55
      ],
      [
        12,
        -97
      ],
      [
        0,
        -65
      ],
      [
        -24,
        -33
      ],
      [
        -25,
        -87
      ],
      [
        12,
        -65
      ],
      [
        87,
        -97
      ],
      [
        49,
        -98
      ],
      [
        50,
        -54
      ],
      [
        50,
        -87
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -55
      ],
      [
        0,
        -32
      ],
      [
        37,
        0
      ],
      [
        50,
        -54
      ],
      [
        37,
        -33
      ],
      [
        62,
        -33
      ],
      [
        49,
        -43
      ],
      [
        112,
        -141
      ],
      [
        24,
        -54
      ],
      [
        25,
        -87
      ],
      [
        25,
        -54
      ],
      [
        0,
        -33
      ],
      [
        -87,
        -76
      ],
      [
        -62,
        -86
      ],
      [
        25,
        0
      ],
      [
        112,
        119
      ],
      [
        37,
        11
      ],
      [
        86,
        -33
      ],
      [
        100,
        -65
      ],
      [
        24,
        11
      ],
      [
        13,
        33
      ],
      [
        25,
        108
      ],
      [
        37,
        43
      ],
      [
        12,
        55
      ],
      [
        50,
        32
      ],
      [
        24,
        0
      ],
      [
        0,
        -43
      ],
      [
        50,
        -22
      ],
      [
        37,
        -32
      ],
      [
        12,
        -55
      ],
      [
        25,
        -76
      ],
      [
        13,
        0
      ],
      [
        12,
        76
      ],
      [
        37,
        65
      ],
      [
        0,
        22
      ],
      [
        -87,
        130
      ],
      [
        0,
        22
      ],
      [
        38,
        43
      ],
      [
        0,
        44
      ],
      [
        62,
        76
      ],
      [
        37,
        65
      ],
      [
        37,
        76
      ],
      [
        -12,
        21
      ],
      [
        0,
        65
      ],
      [
        -13,
        65
      ],
      [
        -62,
        87
      ],
      [
        -12,
        76
      ],
      [
        25,
        65
      ],
      [
        -50,
        76
      ],
      [
        -37,
        141
      ],
      [
        -13,
        130
      ],
      [
        -12,
        87
      ],
      [
        -25,
        65
      ],
      [
        0,
        33
      ],
      [
        25,
        65
      ],
      [
        25,
        11
      ],
      [
        -25,
        32
      ],
      [
        -12,
        43
      ],
      [
        24,
        33
      ],
      [
        -61,
        65
      ],
      [
        12,
        33
      ],
      [
        -50,
        32
      ],
      [
        -49,
        76
      ],
      [
        -62,
        163
      ],
      [
        -25,
        32
      ],
      [
        0,
        33
      ],
      [
        260,
        108
      ],
      [
        25,
        22
      ],
      [
        186,
        98
      ],
      [
        62,
        54
      ],
      [
        86,
        54
      ],
      [
        248,
        260
      ],
      [
        25,
        65
      ],
      [
        112,
        152
      ],
      [
        37,
        65
      ],
      [
        37,
        152
      ],
      [
        0,
        98
      ],
      [
        12,
        130
      ],
      [
        0,
        108
      ],
      [
        -25,
        185
      ],
      [
        -24,
        119
      ],
      [
        -50,
        141
      ],
      [
        0,
        32
      ],
      [
        -124,
        228
      ],
      [
        -111,
        109
      ],
      [
        -25,
        32
      ],
      [
        -161,
        98
      ],
      [
        -112,
        108
      ],
      [
        -61,
        44
      ],
      [
        12,
        76
      ],
      [
        0,
        43
      ],
      [
        25,
        43
      ],
      [
        62,
        87
      ],
      [
        37,
        65
      ],
      [
        49,
        65
      ],
      [
        50,
        33
      ],
      [
        25,
        43
      ],
      [
        0,
        22
      ],
      [
        -38,
        43
      ],
      [
        50,
        54
      ],
      [
        0,
        76
      ],
      [
        50,
        0
      ],
      [
        62,
        -76
      ],
      [
        24,
        11
      ],
      [
        -24,
        22
      ],
      [
        -25,
        43
      ],
      [
        0,
        22
      ],
      [
        49,
        43
      ],
      [
        -12,
        87
      ],
      [
        25,
        54
      ],
      [
        0,
        22
      ],
      [
        -87,
        11
      ],
      [
        -12,
        22
      ],
      [
        49,
        21
      ],
      [
        0,
        11
      ],
      [
        -74,
        130
      ],
      [
        -13,
        44
      ],
      [
        62,
        65
      ],
      [
        0,
        21
      ],
      [
        -74,
        0
      ],
      [
        -25,
        44
      ],
      [
        25,
        32
      ],
      [
        25,
        65
      ],
      [
        -75,
        -10
      ],
      [
        -37,
        21
      ],
      [
        -62,
        0
      ],
      [
        0,
        22
      ],
      [
        112,
        152
      ],
      [
        37,
        76
      ],
      [
        0,
        141
      ],
      [
        74,
        76
      ],
      [
        -62,
        43
      ],
      [
        -86,
        87
      ],
      [
        -50,
        97
      ],
      [
        -12,
        120
      ],
      [
        -13,
        54
      ],
      [
        13,
        54
      ],
      [
        25,
        43
      ],
      [
        49,
        44
      ],
      [
        112,
        65
      ],
      [
        74,
        22
      ],
      [
        62,
        -11
      ],
      [
        111,
        -11
      ],
      [
        87,
        -43
      ],
      [
        273,
        -87
      ],
      [
        49,
        -44
      ],
      [
        -49,
        -32
      ],
      [
        12,
        -11
      ],
      [
        99,
        65
      ],
      [
        50,
        11
      ],
      [
        148,
        -43
      ],
      [
        99,
        -76
      ],
      [
        13,
        11
      ],
      [
        -37,
        32
      ],
      [
        24,
        22
      ],
      [
        149,
        65
      ],
      [
        50,
        32
      ],
      [
        123,
        65
      ],
      [
        100,
        -65
      ],
      [
        123,
        -108
      ],
      [
        62,
        -43
      ],
      [
        62,
        0
      ],
      [
        25,
        -66
      ],
      [
        -12,
        -43
      ],
      [
        -38,
        -76
      ],
      [
        13,
        0
      ],
      [
        74,
        54
      ],
      [
        99,
        -54
      ],
      [
        50,
        -65
      ],
      [
        25,
        -76
      ],
      [
        24,
        44
      ],
      [
        25,
        0
      ],
      [
        75,
        -44
      ],
      [
        12,
        -22
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        -54
      ],
      [
        25,
        -11
      ],
      [
        50,
        0
      ],
      [
        -38,
        -54
      ],
      [
        75,
        -76
      ],
      [
        62,
        -44
      ],
      [
        62,
        0
      ],
      [
        49,
        -11
      ],
      [
        112,
        -43
      ],
      [
        62,
        -11
      ],
      [
        86,
        22
      ],
      [
        37,
        -22
      ],
      [
        13,
        -32
      ],
      [
        0,
        -44
      ],
      [
        12,
        -21
      ],
      [
        62,
        -11
      ],
      [
        74,
        32
      ],
      [
        13,
        22
      ],
      [
        0,
        43
      ],
      [
        12,
        22
      ],
      [
        50,
        -11
      ],
      [
        0,
        -21
      ],
      [
        25,
        -55
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -55
      ],
      [
        -37,
        -76
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -21
      ],
      [
        12,
        -33
      ],
      [
        0,
        -43
      ],
      [
        37,
        -65
      ],
      [
        0,
        -66
      ],
      [
        -12,
        -21
      ],
      [
        -50,
        -33
      ],
      [
        -49,
        -11
      ],
      [
        -186,
        0
      ],
      [
        -50,
        11
      ],
      [
        13,
        -32
      ],
      [
        99,
        0
      ],
      [
        173,
        -22
      ],
      [
        50,
        -43
      ],
      [
        25,
        -98
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -65
      ],
      [
        13,
        -33
      ],
      [
        87,
        0
      ],
      [
        24,
        -32
      ],
      [
        -37,
        -65
      ],
      [
        13,
        -65
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        -12,
        11
      ],
      [
        -25,
        65
      ],
      [
        -50,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        -22
      ],
      [
        0,
        -10
      ],
      [
        50,
        -11
      ],
      [
        49,
        -33
      ],
      [
        38,
        0
      ],
      [
        37,
        22
      ],
      [
        99,
        76
      ],
      [
        74,
        32
      ],
      [
        75,
        -11
      ],
      [
        86,
        11
      ],
      [
        50,
        -21
      ],
      [
        62,
        -76
      ],
      [
        12,
        -98
      ],
      [
        37,
        -43
      ],
      [
        0,
        -76
      ],
      [
        -24,
        -109
      ],
      [
        -62,
        -97
      ],
      [
        0,
        -33
      ],
      [
        49,
        44
      ],
      [
        50,
        195
      ],
      [
        24,
        43
      ],
      [
        38,
        11
      ],
      [
        12,
        -11
      ],
      [
        25,
        -87
      ],
      [
        25,
        -10
      ],
      [
        24,
        54
      ],
      [
        13,
        -11
      ],
      [
        12,
        -87
      ],
      [
        37,
        -22
      ],
      [
        62,
        55
      ],
      [
        87,
        43
      ],
      [
        49,
        43
      ],
      [
        38,
        22
      ],
      [
        62,
        11
      ],
      [
        37,
        43
      ],
      [
        12,
        55
      ],
      [
        74,
        97
      ],
      [
        25,
        0
      ],
      [
        37,
        -43
      ],
      [
        50,
        -76
      ],
      [
        0,
        -109
      ],
      [
        12,
        0
      ],
      [
        25,
        66
      ],
      [
        0,
        43
      ],
      [
        -49,
        108
      ],
      [
        12,
        22
      ],
      [
        62,
        22
      ],
      [
        -25,
        32
      ],
      [
        25,
        44
      ],
      [
        49,
        0
      ],
      [
        0,
        32
      ],
      [
        62,
        -11
      ],
      [
        0,
        22
      ],
      [
        50,
        0
      ],
      [
        0,
        11
      ],
      [
        -74,
        32
      ],
      [
        -25,
        22
      ],
      [
        -13,
        54
      ],
      [
        38,
        -10
      ],
      [
        12,
        21
      ],
      [
        0,
        44
      ],
      [
        12,
        21
      ],
      [
        38,
        -11
      ],
      [
        -25,
        66
      ],
      [
        0,
        21
      ],
      [
        49,
        0
      ],
      [
        25,
        -11
      ],
      [
        74,
        -54
      ],
      [
        13,
        11
      ],
      [
        -50,
        43
      ],
      [
        -62,
        33
      ],
      [
        -24,
        22
      ],
      [
        -25,
        43
      ],
      [
        0,
        43
      ],
      [
        25,
        65
      ],
      [
        49,
        22
      ],
      [
        74,
        -43
      ],
      [
        13,
        11
      ],
      [
        -50,
        32
      ],
      [
        0,
        54
      ],
      [
        87,
        217
      ],
      [
        37,
        44
      ],
      [
        37,
        10
      ],
      [
        75,
        -43
      ],
      [
        24,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        49,
        11
      ],
      [
        50,
        0
      ],
      [
        25,
        -54
      ],
      [
        12,
        -120
      ],
      [
        37,
        22
      ],
      [
        25,
        -43
      ],
      [
        12,
        -65
      ],
      [
        38,
        -44
      ],
      [
        24,
        -43
      ],
      [
        -24,
        -43
      ],
      [
        -50,
        -22
      ],
      [
        12,
        -22
      ],
      [
        50,
        -11
      ],
      [
        12,
        -21
      ],
      [
        75,
        10
      ],
      [
        49,
        -86
      ],
      [
        -37,
        -55
      ],
      [
        -87,
        -32
      ],
      [
        -74,
        0
      ],
      [
        12,
        -22
      ],
      [
        50,
        0
      ],
      [
        74,
        11
      ],
      [
        62,
        22
      ],
      [
        50,
        0
      ],
      [
        -13,
        -44
      ],
      [
        25,
        -65
      ],
      [
        -25,
        -21
      ],
      [
        38,
        -11
      ],
      [
        49,
        21
      ],
      [
        62,
        -130
      ],
      [
        -87,
        -86
      ],
      [
        -37,
        -11
      ],
      [
        0,
        -33
      ],
      [
        25,
        0
      ],
      [
        25,
        -32
      ],
      [
        86,
        43
      ],
      [
        75,
        11
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -97
      ],
      [
        -50,
        -66
      ],
      [
        -86,
        -54
      ],
      [
        -62,
        -65
      ],
      [
        12,
        -11
      ],
      [
        87,
        55
      ],
      [
        49,
        21
      ],
      [
        87,
        22
      ],
      [
        25,
        0
      ],
      [
        62,
        -119
      ],
      [
        37,
        -11
      ],
      [
        37,
        11
      ],
      [
        50,
        -33
      ],
      [
        24,
        -32
      ],
      [
        -37,
        -55
      ],
      [
        25,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        -75,
        -54
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        0
      ],
      [
        0,
        -22
      ],
      [
        74,
        11
      ],
      [
        87,
        -22
      ],
      [
        25,
        -32
      ],
      [
        -37,
        -87
      ],
      [
        62,
        -32
      ],
      [
        24,
        10
      ],
      [
        25,
        -10
      ],
      [
        99,
        -109
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -109
      ],
      [
        -50,
        -11
      ],
      [
        -185,
        22
      ],
      [
        -100,
        43
      ],
      [
        -12,
        -21
      ],
      [
        99,
        -44
      ],
      [
        37,
        -43
      ],
      [
        62,
        -11
      ],
      [
        25,
        -43
      ],
      [
        -50,
        0
      ],
      [
        -37,
        -33
      ],
      [
        25,
        -22
      ],
      [
        136,
        -21
      ],
      [
        38,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -75,
        -32
      ],
      [
        0,
        -33
      ],
      [
        50,
        -11
      ],
      [
        50,
        11
      ],
      [
        24,
        -11
      ],
      [
        13,
        -97
      ],
      [
        -50,
        -22
      ],
      [
        37,
        -33
      ],
      [
        62,
        -10
      ],
      [
        25,
        -55
      ],
      [
        37,
        0
      ],
      [
        50,
        55
      ],
      [
        37,
        -11
      ],
      [
        0,
        -33
      ],
      [
        49,
        -43
      ],
      [
        38,
        0
      ],
      [
        49,
        -22
      ],
      [
        -25,
        -76
      ],
      [
        38,
        -65
      ],
      [
        37,
        -43
      ],
      [
        -62,
        -76
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -22
      ],
      [
        37,
        -11
      ],
      [
        50,
        33
      ],
      [
        86,
        11
      ],
      [
        25,
        22
      ],
      [
        37,
        10
      ],
      [
        25,
        -21
      ],
      [
        0,
        -44
      ],
      [
        25,
        -21
      ],
      [
        37,
        21
      ],
      [
        25,
        -21
      ],
      [
        -13,
        -22
      ],
      [
        13,
        -54
      ],
      [
        62,
        97
      ],
      [
        62,
        -11
      ],
      [
        24,
        -21
      ],
      [
        25,
        -65
      ],
      [
        13,
        -65
      ],
      [
        37,
        -65
      ],
      [
        136,
        -44
      ],
      [
        62,
        22
      ],
      [
        12,
        32
      ],
      [
        75,
        11
      ],
      [
        12,
        -65
      ],
      [
        74,
        -65
      ],
      [
        75,
        -22
      ],
      [
        37,
        -21
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -32
      ],
      [
        -62,
        0
      ],
      [
        -86,
        -22
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -22
      ],
      [
        -74,
        -32
      ],
      [
        -38,
        -76
      ],
      [
        -37,
        -43
      ],
      [
        -99,
        0
      ],
      [
        -25,
        -44
      ],
      [
        -61,
        -21
      ],
      [
        -112,
        -65
      ],
      [
        -50,
        0
      ],
      [
        -37,
        10
      ],
      [
        -86,
        -54
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        11
      ],
      [
        -37,
        32
      ],
      [
        0,
        -32
      ],
      [
        74,
        -44
      ],
      [
        25,
        -32
      ],
      [
        -74,
        -55
      ],
      [
        0,
        -21
      ],
      [
        24,
        -11
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -21
      ],
      [
        62,
        32
      ],
      [
        62,
        54
      ],
      [
        50,
        65
      ],
      [
        74,
        22
      ],
      [
        99,
        65
      ],
      [
        74,
        65
      ],
      [
        75,
        76
      ],
      [
        86,
        65
      ],
      [
        112,
        54
      ],
      [
        87,
        22
      ],
      [
        49,
        0
      ],
      [
        0,
        11
      ],
      [
        -49,
        11
      ],
      [
        -87,
        -11
      ],
      [
        -13,
        33
      ],
      [
        13,
        21
      ],
      [
        49,
        22
      ],
      [
        199,
        -22
      ],
      [
        62,
        -21
      ],
      [
        74,
        -152
      ],
      [
        25,
        -44
      ],
      [
        0,
        -32
      ],
      [
        -38,
        -54
      ],
      [
        -86,
        -55
      ],
      [
        25,
        -21
      ],
      [
        37,
        -76
      ],
      [
        37,
        32
      ],
      [
        62,
        98
      ],
      [
        62,
        43
      ],
      [
        49,
        11
      ],
      [
        87,
        0
      ],
      [
        0,
        -32
      ],
      [
        37,
        -55
      ],
      [
        87,
        -21
      ],
      [
        49,
        -76
      ],
      [
        13,
        -44
      ],
      [
        25,
        -32
      ],
      [
        -13,
        -22
      ],
      [
        25,
        -43
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -87
      ],
      [
        13,
        -109
      ],
      [
        -13,
        -54
      ],
      [
        25,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        -161,
        -32
      ],
      [
        24,
        -22
      ],
      [
        62,
        0
      ],
      [
        75,
        -11
      ],
      [
        37,
        -21
      ],
      [
        12,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -86,
        21
      ],
      [
        0,
        -10
      ],
      [
        86,
        -55
      ],
      [
        37,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        -111,
        -130
      ],
      [
        -87,
        -76
      ],
      [
        -99,
        -76
      ],
      [
        -149,
        -141
      ],
      [
        -37,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -62,
        0
      ],
      [
        -136,
        -44
      ],
      [
        -62,
        -54
      ],
      [
        -74,
        -11
      ],
      [
        -87,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -136,
        -184
      ],
      [
        -37,
        -65
      ],
      [
        -74,
        -65
      ],
      [
        -87,
        -109
      ],
      [
        -62,
        -54
      ],
      [
        -25,
        -65
      ],
      [
        -74,
        -33
      ],
      [
        -124,
        -10
      ],
      [
        -50,
        -11
      ],
      [
        -74,
        21
      ],
      [
        -49,
        -32
      ],
      [
        -75,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -149,
        -65
      ],
      [
        -37,
        65
      ],
      [
        -37,
        22
      ],
      [
        -87,
        0
      ],
      [
        -62,
        21
      ],
      [
        -123,
        22
      ],
      [
        -38,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -74,
        0
      ],
      [
        -25,
        -32
      ],
      [
        -124,
        10
      ],
      [
        -49,
        33
      ],
      [
        -99,
        0
      ],
      [
        -50,
        -22
      ],
      [
        -124,
        22
      ],
      [
        -124,
        -22
      ],
      [
        -99,
        11
      ],
      [
        -37,
        22
      ],
      [
        -173,
        -44
      ],
      [
        -62,
        22
      ],
      [
        -62,
        -54
      ],
      [
        -37,
        11
      ],
      [
        -38,
        -11
      ],
      [
        -24,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -50,
        -54
      ],
      [
        -62,
        -43
      ],
      [
        -99,
        -250
      ],
      [
        -12,
        -86
      ],
      [
        -37,
        -66
      ],
      [
        -62,
        -10
      ],
      [
        -174,
        -55
      ],
      [
        -86,
        -32
      ],
      [
        24,
        -33
      ],
      [
        -24,
        -21
      ],
      [
        -87,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        -99,
        -65
      ],
      [
        -100,
        -163
      ],
      [
        -49,
        -119
      ],
      [
        -62,
        -87
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -25,
        11
      ],
      [
        -50,
        43
      ],
      [
        -37,
        0
      ],
      [
        -99,
        54
      ],
      [
        -186,
        33
      ],
      [
        25,
        -33
      ],
      [
        62,
        -11
      ],
      [
        62,
        0
      ],
      [
        124,
        -65
      ],
      [
        62,
        -21
      ],
      [
        62,
        -65
      ],
      [
        -25,
        -98
      ],
      [
        -25,
        -76
      ],
      [
        -25,
        -54
      ],
      [
        -111,
        -152
      ],
      [
        -50,
        -43
      ],
      [
        -86,
        -185
      ],
      [
        -87,
        -76
      ],
      [
        -50,
        -54
      ],
      [
        -49,
        -76
      ],
      [
        -124,
        -65
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -111,
        -76
      ],
      [
        -25,
        -43
      ],
      [
        -149,
        -130
      ],
      [
        -49,
        -11
      ],
      [
        -50,
        -33
      ],
      [
        -12,
        -54
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        -109
      ],
      [
        -74,
        -97
      ],
      [
        -75,
        -22
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -43
      ],
      [
        12,
        -44
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -87,
        -76
      ],
      [
        -123,
        -130
      ]
    ],
    [
      [
        36221,
        84321
      ],
      [
        -50,
        0
      ],
      [
        -50,
        -11
      ],
      [
        -61,
        -54
      ],
      [
        -75,
        -76
      ],
      [
        -136,
        -173
      ],
      [
        -25,
        -44
      ],
      [
        -49,
        -32
      ],
      [
        -50,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -74,
        -97
      ],
      [
        -75,
        -174
      ],
      [
        -49,
        -97
      ],
      [
        -149,
        0
      ],
      [
        -211,
        0
      ],
      [
        -284,
        0
      ],
      [
        -50,
        -22
      ],
      [
        -50,
        -44
      ],
      [
        -61,
        -32
      ],
      [
        37,
        -119
      ],
      [
        0,
        -120
      ],
      [
        12,
        -11
      ],
      [
        0,
        -43
      ],
      [
        25,
        -22
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -149,
        -98
      ],
      [
        -99,
        -76
      ],
      [
        -173,
        -97
      ],
      [
        -149,
        -44
      ],
      [
        -124,
        -32
      ],
      [
        -74,
        -33
      ],
      [
        -173,
        -130
      ],
      [
        -149,
        -130
      ],
      [
        -87,
        -65
      ],
      [
        -86,
        0
      ],
      [
        -62,
        43
      ],
      [
        -50,
        54
      ],
      [
        -37,
        87
      ],
      [
        0,
        109
      ],
      [
        12,
        65
      ],
      [
        13,
        32
      ],
      [
        62,
        55
      ],
      [
        111,
        141
      ],
      [
        25,
        75
      ],
      [
        25,
        174
      ],
      [
        0,
        32
      ],
      [
        37,
        120
      ],
      [
        37,
        130
      ],
      [
        25,
        65
      ],
      [
        -25,
        152
      ],
      [
        -25,
        238
      ],
      [
        -25,
        120
      ],
      [
        -49,
        434
      ],
      [
        -25,
        162
      ],
      [
        -210,
        185
      ],
      [
        -149,
        108
      ],
      [
        49,
        119
      ],
      [
        -12,
        11
      ],
      [
        -37,
        65
      ],
      [
        -25,
        0
      ],
      [
        -87,
        -32
      ],
      [
        -37,
        43
      ],
      [
        -25,
        54
      ],
      [
        0,
        87
      ],
      [
        -12,
        43
      ],
      [
        0,
        66
      ],
      [
        -87,
        -11
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        0
      ],
      [
        -37,
        55
      ],
      [
        -37,
        65
      ],
      [
        -25,
        162
      ],
      [
        -74,
        44
      ],
      [
        -62,
        54
      ],
      [
        -74,
        43
      ],
      [
        -124,
        109
      ],
      [
        -74,
        43
      ],
      [
        -62,
        54
      ],
      [
        -149,
        109
      ],
      [
        -87,
        65
      ],
      [
        -99,
        65
      ],
      [
        -186,
        141
      ],
      [
        -62,
        43
      ],
      [
        -24,
        11
      ],
      [
        -62,
        44
      ],
      [
        -75,
        43
      ],
      [
        -74,
        -22
      ],
      [
        -161,
        -108
      ],
      [
        -74,
        -44
      ],
      [
        -87,
        -10
      ],
      [
        -87,
        10
      ],
      [
        -37,
        -10
      ],
      [
        -37,
        10
      ],
      [
        -25,
        65
      ],
      [
        -87,
        -10
      ],
      [
        -99,
        10
      ],
      [
        -37,
        -10
      ],
      [
        -25,
        21
      ],
      [
        -12,
        44
      ],
      [
        -74,
        -11
      ],
      [
        -62,
        -54
      ],
      [
        -50,
        -33
      ],
      [
        -49,
        0
      ],
      [
        -50,
        33
      ],
      [
        -62,
        54
      ],
      [
        -49,
        65
      ],
      [
        -62,
        32
      ],
      [
        -50,
        -10
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -25,
        98
      ],
      [
        -25,
        21
      ],
      [
        -99,
        65
      ],
      [
        -74,
        33
      ],
      [
        -111,
        0
      ],
      [
        -25,
        -43
      ],
      [
        -87,
        -22
      ],
      [
        -49,
        54
      ],
      [
        -62,
        33
      ],
      [
        -199,
        54
      ],
      [
        -24,
        22
      ],
      [
        -38,
        141
      ],
      [
        -12,
        65
      ],
      [
        -12,
        97
      ],
      [
        0,
        33
      ],
      [
        -25,
        21
      ],
      [
        -74,
        11
      ],
      [
        0,
        -238
      ],
      [
        -236,
        0
      ],
      [
        -285,
        0
      ],
      [
        -297,
        0
      ],
      [
        -297,
        0
      ],
      [
        -285,
        0
      ],
      [
        -149,
        0
      ],
      [
        -297,
        0
      ],
      [
        -285,
        0
      ],
      [
        -149,
        0
      ],
      [
        -297,
        0
      ],
      [
        -297,
        0
      ],
      [
        -285,
        0
      ],
      [
        -297,
        0
      ],
      [
        -298,
        0
      ],
      [
        -285,
        0
      ],
      [
        -148,
        0
      ],
      [
        -298,
        0
      ],
      [
        -148,
        0
      ],
      [
        -285,
        0
      ],
      [
        -297,
        0
      ],
      [
        -149,
        0
      ],
      [
        -297,
        0
      ],
      [
        -285,
        0
      ],
      [
        -298,
        0
      ],
      [
        -297,
        0
      ],
      [
        -149,
        0
      ],
      [
        -285,
        0
      ],
      [
        -148,
        0
      ],
      [
        -297,
        0
      ],
      [
        -298,
        0
      ],
      [
        -285,
        0
      ],
      [
        -297,
        0
      ],
      [
        -297,
        0
      ],
      [
        -285,
        0
      ],
      [
        -149,
        0
      ],
      [
        -297,
        0
      ],
      [
        -174,
        0
      ]
    ],
    [
      [
        19683,
        86816
      ],
      [
        -49,
        54
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        -32
      ],
      [
        -12,
        0
      ],
      [
        -12,
        43
      ],
      [
        24,
        33
      ],
      [
        -49,
        21
      ],
      [
        0,
        44
      ],
      [
        -13,
        32
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        13,
        22
      ],
      [
        -50,
        21
      ],
      [
        -37,
        -10
      ],
      [
        0,
        32
      ],
      [
        12,
        33
      ],
      [
        0,
        97
      ],
      [
        -37,
        -32
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -32
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -13,
        0
      ],
      [
        -111,
        43
      ],
      [
        -37,
        33
      ],
      [
        -25,
        43
      ],
      [
        -12,
        44
      ],
      [
        24,
        43
      ],
      [
        25,
        -11
      ],
      [
        37,
        -87
      ],
      [
        75,
        44
      ],
      [
        0,
        22
      ],
      [
        -38,
        -22
      ],
      [
        -37,
        22
      ],
      [
        -25,
        32
      ],
      [
        0,
        174
      ],
      [
        -24,
        -11
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -11
      ],
      [
        -49,
        0
      ],
      [
        -25,
        21
      ],
      [
        -99,
        131
      ],
      [
        0,
        32
      ],
      [
        -50,
        119
      ],
      [
        -12,
        65
      ],
      [
        -25,
        0
      ],
      [
        0,
        33
      ],
      [
        37,
        76
      ],
      [
        25,
        65
      ],
      [
        0,
        141
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -86
      ],
      [
        -12,
        -55
      ],
      [
        -37,
        -43
      ],
      [
        -50,
        -22
      ],
      [
        -99,
        11
      ],
      [
        -62,
        -21
      ],
      [
        -49,
        32
      ],
      [
        -50,
        -22
      ],
      [
        -149,
        33
      ],
      [
        -12,
        11
      ],
      [
        12,
        32
      ],
      [
        62,
        11
      ],
      [
        112,
        44
      ],
      [
        -25,
        10
      ],
      [
        -136,
        -21
      ],
      [
        -50,
        0
      ],
      [
        0,
        32
      ],
      [
        37,
        54
      ],
      [
        0,
        22
      ],
      [
        -37,
        11
      ],
      [
        13,
        65
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -32
      ],
      [
        -111,
        -11
      ],
      [
        -38,
        -22
      ],
      [
        -74,
        33
      ],
      [
        -62,
        43
      ],
      [
        -87,
        108
      ],
      [
        0,
        120
      ],
      [
        100,
        162
      ],
      [
        24,
        22
      ],
      [
        124,
        11
      ],
      [
        -12,
        32
      ],
      [
        -112,
        0
      ],
      [
        -37,
        -21
      ],
      [
        -62,
        -130
      ],
      [
        -37,
        21
      ],
      [
        0,
        22
      ],
      [
        -25,
        43
      ],
      [
        -25,
        98
      ],
      [
        50,
        141
      ],
      [
        -37,
        0
      ],
      [
        0,
        54
      ],
      [
        12,
        65
      ],
      [
        124,
        109
      ],
      [
        74,
        21
      ],
      [
        25,
        -43
      ],
      [
        50,
        -22
      ],
      [
        25,
        -21
      ],
      [
        12,
        -44
      ],
      [
        62,
        -76
      ],
      [
        12,
        0
      ],
      [
        -74,
        98
      ],
      [
        -12,
        54
      ],
      [
        -75,
        54
      ],
      [
        -12,
        44
      ],
      [
        0,
        43
      ],
      [
        74,
        76
      ],
      [
        13,
        43
      ],
      [
        0,
        44
      ],
      [
        -25,
        32
      ],
      [
        0,
        -97
      ],
      [
        -25,
        -33
      ],
      [
        -149,
        -173
      ],
      [
        -62,
        -22
      ],
      [
        -49,
        -43
      ],
      [
        -13,
        -65
      ],
      [
        -37,
        -120
      ],
      [
        -37,
        -108
      ],
      [
        -37,
        130
      ],
      [
        -50,
        108
      ],
      [
        112,
        98
      ],
      [
        -12,
        87
      ],
      [
        -75,
        -65
      ],
      [
        0,
        43
      ],
      [
        50,
        239
      ],
      [
        25,
        65
      ],
      [
        -13,
        0
      ],
      [
        -87,
        -55
      ],
      [
        -37,
        33
      ],
      [
        -24,
        163
      ],
      [
        -38,
        65
      ],
      [
        -74,
        54
      ],
      [
        -74,
        22
      ],
      [
        -25,
        43
      ],
      [
        -12,
        65
      ],
      [
        24,
        65
      ],
      [
        25,
        33
      ],
      [
        62,
        11
      ],
      [
        -12,
        -98
      ],
      [
        24,
        0
      ],
      [
        100,
        -87
      ],
      [
        24,
        0
      ],
      [
        37,
        22
      ],
      [
        25,
        0
      ],
      [
        50,
        -22
      ],
      [
        12,
        22
      ],
      [
        -37,
        22
      ],
      [
        -50,
        0
      ],
      [
        -49,
        -11
      ],
      [
        -37,
        21
      ],
      [
        -25,
        33
      ],
      [
        -37,
        98
      ],
      [
        25,
        65
      ],
      [
        49,
        21
      ],
      [
        -25,
        44
      ],
      [
        -24,
        0
      ],
      [
        -75,
        -65
      ],
      [
        -49,
        -22
      ],
      [
        -50,
        -87
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -44
      ],
      [
        -75,
        -43
      ],
      [
        -37,
        -65
      ],
      [
        -37,
        54
      ],
      [
        -49,
        54
      ],
      [
        -25,
        87
      ],
      [
        -62,
        11
      ],
      [
        -62,
        54
      ],
      [
        -25,
        43
      ],
      [
        37,
        87
      ],
      [
        50,
        65
      ],
      [
        0,
        87
      ],
      [
        12,
        11
      ],
      [
        87,
        22
      ],
      [
        62,
        43
      ],
      [
        -99,
        0
      ],
      [
        -62,
        -33
      ],
      [
        -74,
        55
      ],
      [
        -38,
        54
      ],
      [
        -12,
        43
      ],
      [
        12,
        33
      ],
      [
        0,
        43
      ],
      [
        38,
        98
      ],
      [
        24,
        21
      ],
      [
        37,
        98
      ],
      [
        62,
        119
      ],
      [
        13,
        55
      ],
      [
        86,
        162
      ],
      [
        -12,
        0
      ],
      [
        -37,
        76
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -130
      ],
      [
        -13,
        -43
      ],
      [
        -37,
        -87
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        21
      ],
      [
        37,
        163
      ],
      [
        -25,
        65
      ],
      [
        -12,
        65
      ],
      [
        0,
        119
      ],
      [
        25,
        76
      ]
    ],
    [
      [
        28627,
        101771
      ],
      [
        -62,
        0
      ],
      [
        -49,
        44
      ],
      [
        0,
        65
      ],
      [
        24,
        32
      ],
      [
        62,
        22
      ],
      [
        38,
        -43
      ],
      [
        37,
        -11
      ],
      [
        12,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -22
      ]
    ],
    [
      [
        22520,
        101565
      ],
      [
        62,
        -11
      ],
      [
        136,
        44
      ],
      [
        87,
        11
      ],
      [
        37,
        -11
      ],
      [
        37,
        21
      ],
      [
        0,
        87
      ],
      [
        62,
        76
      ],
      [
        75,
        33
      ],
      [
        111,
        -11
      ],
      [
        112,
        -33
      ],
      [
        136,
        -21
      ],
      [
        198,
        -87
      ],
      [
        62,
        -33
      ],
      [
        12,
        -21
      ],
      [
        -37,
        -66
      ],
      [
        -86,
        -86
      ],
      [
        -75,
        -22
      ],
      [
        -25,
        -22
      ],
      [
        75,
        -32
      ],
      [
        49,
        32
      ],
      [
        75,
        65
      ],
      [
        12,
        -54
      ],
      [
        50,
        -11
      ],
      [
        62,
        44
      ],
      [
        61,
        65
      ],
      [
        100,
        43
      ],
      [
        24,
        22
      ],
      [
        75,
        11
      ],
      [
        0,
        65
      ],
      [
        -25,
        21
      ],
      [
        -99,
        44
      ],
      [
        -37,
        54
      ],
      [
        0,
        33
      ],
      [
        198,
        0
      ],
      [
        37,
        -11
      ],
      [
        136,
        -65
      ],
      [
        37,
        -44
      ],
      [
        124,
        -54
      ],
      [
        50,
        -32
      ],
      [
        0,
        -44
      ],
      [
        62,
        -22
      ],
      [
        37,
        -43
      ],
      [
        49,
        -108
      ],
      [
        25,
        -120
      ],
      [
        75,
        -141
      ],
      [
        12,
        -97
      ],
      [
        25,
        -33
      ],
      [
        49,
        -11
      ],
      [
        25,
        -21
      ],
      [
        50,
        -11
      ],
      [
        37,
        54
      ],
      [
        124,
        76
      ],
      [
        -25,
        22
      ],
      [
        37,
        11
      ],
      [
        -87,
        86
      ],
      [
        -49,
        76
      ],
      [
        -37,
        98
      ],
      [
        -13,
        87
      ],
      [
        -37,
        43
      ],
      [
        0,
        43
      ],
      [
        -25,
        44
      ],
      [
        -74,
        282
      ],
      [
        0,
        32
      ],
      [
        37,
        33
      ],
      [
        62,
        0
      ],
      [
        -49,
        43
      ],
      [
        12,
        43
      ],
      [
        111,
        -10
      ],
      [
        75,
        -22
      ],
      [
        136,
        -65
      ],
      [
        50,
        54
      ],
      [
        49,
        -11
      ],
      [
        112,
        -43
      ],
      [
        148,
        -76
      ],
      [
        87,
        -33
      ],
      [
        62,
        -54
      ],
      [
        74,
        -87
      ],
      [
        0,
        -54
      ],
      [
        37,
        -43
      ],
      [
        0,
        -44
      ],
      [
        25,
        -97
      ],
      [
        124,
        -271
      ],
      [
        37,
        -65
      ],
      [
        87,
        -109
      ],
      [
        49,
        -76
      ],
      [
        13,
        -119
      ],
      [
        -37,
        -54
      ],
      [
        -38,
        -109
      ],
      [
        13,
        -43
      ],
      [
        124,
        -76
      ],
      [
        74,
        -108
      ],
      [
        25,
        -22
      ],
      [
        99,
        -54
      ],
      [
        136,
        -55
      ],
      [
        37,
        -32
      ],
      [
        25,
        11
      ],
      [
        -25,
        65
      ],
      [
        13,
        21
      ],
      [
        99,
        -86
      ],
      [
        136,
        -65
      ],
      [
        149,
        -87
      ],
      [
        62,
        11
      ],
      [
        37,
        -22
      ],
      [
        25,
        -76
      ],
      [
        148,
        11
      ],
      [
        37,
        -22
      ],
      [
        38,
        -152
      ],
      [
        0,
        -97
      ],
      [
        -38,
        -33
      ],
      [
        -111,
        22
      ],
      [
        -37,
        87
      ],
      [
        -13,
        0
      ],
      [
        -49,
        -87
      ],
      [
        -37,
        0
      ],
      [
        -124,
        76
      ],
      [
        -50,
        11
      ],
      [
        -99,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        25,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        -111,
        11
      ],
      [
        -149,
        76
      ],
      [
        -37,
        -22
      ],
      [
        124,
        -108
      ],
      [
        25,
        0
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -87
      ],
      [
        12,
        -11
      ],
      [
        62,
        76
      ],
      [
        161,
        87
      ],
      [
        99,
        11
      ],
      [
        62,
        -44
      ],
      [
        -37,
        -43
      ],
      [
        0,
        -43
      ],
      [
        25,
        -33
      ],
      [
        62,
        -11
      ],
      [
        12,
        -54
      ],
      [
        -24,
        -65
      ],
      [
        -223,
        -87
      ],
      [
        -87,
        -11
      ],
      [
        -50,
        -32
      ],
      [
        -86,
        11
      ],
      [
        -112,
        -11
      ],
      [
        -198,
        32
      ],
      [
        -99,
        33
      ],
      [
        -37,
        0
      ],
      [
        -38,
        -33
      ],
      [
        -185,
        33
      ],
      [
        -25,
        22
      ],
      [
        49,
        76
      ],
      [
        -86,
        10
      ],
      [
        -87,
        22
      ],
      [
        -161,
        11
      ],
      [
        -50,
        11
      ],
      [
        -74,
        43
      ],
      [
        0,
        98
      ],
      [
        -62,
        32
      ],
      [
        -37,
        0
      ],
      [
        -74,
        -54
      ],
      [
        -62,
        -108
      ],
      [
        -112,
        -98
      ],
      [
        -25,
        -11
      ],
      [
        -148,
        -32
      ],
      [
        -174,
        -11
      ],
      [
        -62,
        -22
      ],
      [
        -136,
        -87
      ],
      [
        -186,
        -54
      ],
      [
        -161,
        -32
      ],
      [
        -173,
        -11
      ],
      [
        -136,
        -22
      ],
      [
        -99,
        11
      ],
      [
        -62,
        -33
      ],
      [
        -335,
        -10
      ],
      [
        -198,
        -33
      ],
      [
        -87,
        11
      ],
      [
        -74,
        65
      ],
      [
        -99,
        152
      ],
      [
        12,
        119
      ],
      [
        -25,
        98
      ],
      [
        -12,
        10
      ],
      [
        -124,
        33
      ],
      [
        -86,
        11
      ],
      [
        -298,
        0
      ],
      [
        -148,
        11
      ],
      [
        -87,
        11
      ],
      [
        -87,
        21
      ],
      [
        -136,
        54
      ],
      [
        -74,
        98
      ],
      [
        -137,
        141
      ],
      [
        -24,
        119
      ],
      [
        0,
        33
      ],
      [
        24,
        32
      ],
      [
        198,
        44
      ],
      [
        347,
        54
      ],
      [
        322,
        33
      ],
      [
        149,
        0
      ],
      [
        87,
        -22
      ],
      [
        86,
        0
      ],
      [
        162,
        -11
      ],
      [
        185,
        -22
      ],
      [
        50,
        0
      ],
      [
        111,
        33
      ],
      [
        137,
        0
      ],
      [
        49,
        22
      ],
      [
        -25,
        21
      ],
      [
        -136,
        65
      ],
      [
        -359,
        109
      ],
      [
        -87,
        21
      ],
      [
        -124,
        22
      ],
      [
        -198,
        -11
      ],
      [
        -87,
        -21
      ],
      [
        -86,
        -11
      ],
      [
        -161,
        -11
      ],
      [
        -260,
        -11
      ],
      [
        -50,
        22
      ],
      [
        -260,
        -11
      ],
      [
        -211,
        11
      ],
      [
        -235,
        162
      ],
      [
        -37,
        55
      ],
      [
        37,
        43
      ],
      [
        111,
        65
      ],
      [
        223,
        44
      ],
      [
        298,
        75
      ],
      [
        185,
        33
      ],
      [
        -49,
        22
      ],
      [
        0,
        21
      ],
      [
        99,
        22
      ],
      [
        136,
        -11
      ],
      [
        0,
        22
      ],
      [
        -74,
        22
      ],
      [
        -421,
        -65
      ],
      [
        -186,
        0
      ],
      [
        -136,
        -33
      ],
      [
        -75,
        0
      ],
      [
        -86,
        33
      ],
      [
        -13,
        21
      ],
      [
        25,
        33
      ],
      [
        99,
        21
      ],
      [
        50,
        66
      ],
      [
        -223,
        -11
      ],
      [
        -75,
        0
      ],
      [
        -99,
        21
      ],
      [
        -37,
        55
      ],
      [
        0,
        86
      ],
      [
        13,
        55
      ],
      [
        123,
        108
      ],
      [
        75,
        22
      ],
      [
        62,
        54
      ],
      [
        -99,
        87
      ],
      [
        37,
        65
      ],
      [
        86,
        65
      ],
      [
        298,
        173
      ],
      [
        99,
        33
      ],
      [
        136,
        54
      ],
      [
        359,
        98
      ],
      [
        310,
        97
      ],
      [
        112,
        -21
      ],
      [
        49,
        -33
      ],
      [
        37,
        -130
      ],
      [
        0,
        -98
      ],
      [
        -12,
        -32
      ],
      [
        -62,
        -76
      ],
      [
        -87,
        -87
      ]
    ],
    [
      [
        25704,
        101760
      ],
      [
        -50,
        11
      ],
      [
        -49,
        33
      ],
      [
        -174,
        130
      ],
      [
        -12,
        43
      ],
      [
        -149,
        98
      ],
      [
        -136,
        43
      ],
      [
        -12,
        11
      ],
      [
        99,
        109
      ],
      [
        24,
        10
      ],
      [
        372,
        44
      ],
      [
        136,
        -11
      ],
      [
        99,
        -65
      ],
      [
        38,
        0
      ],
      [
        61,
        -65
      ],
      [
        -12,
        -120
      ],
      [
        -74,
        -108
      ],
      [
        -62,
        -54
      ],
      [
        0,
        -33
      ],
      [
        -99,
        -76
      ]
    ],
    [
      [
        34561,
        102227
      ],
      [
        62,
        -11
      ],
      [
        371,
        11
      ],
      [
        75,
        -11
      ],
      [
        235,
        -65
      ],
      [
        62,
        -22
      ],
      [
        62,
        -98
      ],
      [
        87,
        -21
      ],
      [
        37,
        -33
      ],
      [
        24,
        -65
      ],
      [
        100,
        -43
      ],
      [
        12,
        -76
      ],
      [
        62,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -75,
        -11
      ],
      [
        -210,
        11
      ],
      [
        -285,
        33
      ],
      [
        -248,
        -22
      ],
      [
        -198,
        -54
      ],
      [
        -124,
        -11
      ],
      [
        -149,
        65
      ],
      [
        -62,
        130
      ],
      [
        -24,
        98
      ],
      [
        -149,
        32
      ],
      [
        -62,
        33
      ],
      [
        -12,
        32
      ],
      [
        12,
        65
      ],
      [
        -25,
        65
      ],
      [
        0,
        87
      ],
      [
        38,
        22
      ],
      [
        123,
        0
      ],
      [
        99,
        -33
      ],
      [
        199,
        -32
      ]
    ],
    [
      [
        32133,
        100567
      ],
      [
        12,
        -10
      ],
      [
        149,
        43
      ],
      [
        161,
        65
      ],
      [
        186,
        0
      ],
      [
        37,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        74,
        -44
      ],
      [
        25,
        55
      ],
      [
        25,
        162
      ],
      [
        25,
        98
      ],
      [
        0,
        54
      ],
      [
        -62,
        44
      ],
      [
        -75,
        -11
      ],
      [
        -74,
        21
      ],
      [
        -49,
        33
      ],
      [
        -62,
        87
      ],
      [
        -112,
        76
      ],
      [
        13,
        21
      ],
      [
        111,
        44
      ],
      [
        50,
        76
      ],
      [
        24,
        10
      ],
      [
        112,
        -10
      ],
      [
        136,
        -55
      ],
      [
        -12,
        33
      ],
      [
        -50,
        43
      ],
      [
        -12,
        44
      ],
      [
        74,
        32
      ],
      [
        -124,
        22
      ],
      [
        -62,
        -22
      ],
      [
        -86,
        44
      ],
      [
        -87,
        119
      ],
      [
        0,
        87
      ],
      [
        25,
        54
      ],
      [
        37,
        43
      ],
      [
        74,
        11
      ],
      [
        347,
        -98
      ],
      [
        -12,
        33
      ],
      [
        -273,
        98
      ],
      [
        -111,
        32
      ],
      [
        -25,
        33
      ],
      [
        161,
        141
      ],
      [
        136,
        32
      ],
      [
        62,
        44
      ],
      [
        111,
        0
      ],
      [
        112,
        -22
      ],
      [
        -50,
        54
      ],
      [
        62,
        43
      ],
      [
        112,
        33
      ],
      [
        260,
        65
      ],
      [
        248,
        0
      ],
      [
        111,
        -22
      ],
      [
        75,
        -32
      ],
      [
        61,
        -98
      ],
      [
        25,
        -108
      ],
      [
        50,
        -44
      ],
      [
        111,
        -43
      ],
      [
        37,
        -65
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -44
      ],
      [
        50,
        -76
      ],
      [
        50,
        -21
      ],
      [
        0,
        -22
      ],
      [
        -50,
        -43
      ],
      [
        -198,
        -152
      ],
      [
        87,
        21
      ],
      [
        49,
        -21
      ],
      [
        -74,
        -109
      ],
      [
        -37,
        -43
      ],
      [
        86,
        -54
      ],
      [
        -86,
        -11
      ],
      [
        0,
        -109
      ],
      [
        49,
        11
      ],
      [
        25,
        44
      ],
      [
        111,
        97
      ],
      [
        99,
        44
      ],
      [
        62,
        -33
      ],
      [
        13,
        11
      ],
      [
        -75,
        76
      ],
      [
        13,
        43
      ],
      [
        49,
        33
      ],
      [
        50,
        11
      ],
      [
        50,
        -66
      ],
      [
        74,
        0
      ],
      [
        37,
        33
      ],
      [
        111,
        -76
      ],
      [
        -12,
        -108
      ],
      [
        12,
        -33
      ],
      [
        75,
        -76
      ],
      [
        49,
        11
      ],
      [
        -49,
        54
      ],
      [
        -25,
        44
      ],
      [
        12,
        108
      ],
      [
        38,
        54
      ],
      [
        99,
        -54
      ],
      [
        99,
        11
      ],
      [
        136,
        -65
      ],
      [
        74,
        0
      ],
      [
        -12,
        22
      ],
      [
        -50,
        10
      ],
      [
        -198,
        76
      ],
      [
        -62,
        44
      ],
      [
        -12,
        54
      ],
      [
        49,
        54
      ],
      [
        124,
        54
      ],
      [
        149,
        33
      ],
      [
        99,
        0
      ],
      [
        124,
        -11
      ],
      [
        74,
        -22
      ],
      [
        174,
        -76
      ],
      [
        124,
        11
      ],
      [
        185,
        -65
      ],
      [
        62,
        -65
      ],
      [
        25,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        -112,
        -109
      ],
      [
        -49,
        -22
      ],
      [
        -37,
        -43
      ],
      [
        12,
        -11
      ],
      [
        161,
        87
      ],
      [
        87,
        22
      ],
      [
        62,
        0
      ],
      [
        148,
        -33
      ],
      [
        25,
        -43
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -198,
        -65
      ],
      [
        -112,
        -11
      ],
      [
        87,
        -32
      ],
      [
        87,
        10
      ],
      [
        0,
        -21
      ],
      [
        -38,
        -44
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -65
      ],
      [
        -62,
        -109
      ],
      [
        12,
        -10
      ],
      [
        87,
        75
      ],
      [
        13,
        87
      ],
      [
        37,
        65
      ],
      [
        62,
        65
      ],
      [
        99,
        0
      ],
      [
        49,
        44
      ],
      [
        62,
        11
      ],
      [
        37,
        -33
      ],
      [
        -62,
        -76
      ],
      [
        -111,
        -119
      ],
      [
        50,
        11
      ],
      [
        24,
        32
      ],
      [
        99,
        76
      ],
      [
        25,
        -43
      ],
      [
        50,
        -33
      ],
      [
        25,
        -65
      ],
      [
        49,
        -32
      ],
      [
        25,
        21
      ],
      [
        -37,
        87
      ],
      [
        37,
        43
      ],
      [
        99,
        76
      ],
      [
        111,
        -43
      ],
      [
        161,
        -11
      ],
      [
        162,
        -43
      ],
      [
        136,
        -98
      ],
      [
        25,
        -54
      ],
      [
        -75,
        -87
      ],
      [
        -62,
        -32
      ],
      [
        -99,
        10
      ],
      [
        -49,
        -21
      ],
      [
        -99,
        -87
      ],
      [
        -112,
        -65
      ],
      [
        112,
        0
      ],
      [
        99,
        119
      ],
      [
        86,
        11
      ],
      [
        137,
        -43
      ],
      [
        62,
        11
      ],
      [
        49,
        43
      ],
      [
        87,
        32
      ],
      [
        37,
        -32
      ],
      [
        12,
        -33
      ],
      [
        0,
        -86
      ],
      [
        -37,
        -44
      ],
      [
        -148,
        -108
      ],
      [
        -75,
        -11
      ],
      [
        -62,
        -22
      ],
      [
        -49,
        -54
      ],
      [
        -62,
        -32
      ],
      [
        49,
        -22
      ],
      [
        25,
        11
      ],
      [
        37,
        54
      ],
      [
        37,
        32
      ],
      [
        38,
        0
      ],
      [
        24,
        -32
      ],
      [
        112,
        54
      ],
      [
        37,
        33
      ],
      [
        99,
        65
      ],
      [
        74,
        32
      ],
      [
        137,
        33
      ],
      [
        49,
        -11
      ],
      [
        37,
        -33
      ],
      [
        112,
        11
      ],
      [
        74,
        -21
      ],
      [
        37,
        -22
      ],
      [
        199,
        -76
      ],
      [
        24,
        -22
      ],
      [
        13,
        -54
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -99,
        -65
      ],
      [
        -211,
        -33
      ],
      [
        -87,
        -43
      ],
      [
        -123,
        -76
      ],
      [
        49,
        -22
      ],
      [
        37,
        11
      ],
      [
        62,
        54
      ],
      [
        136,
        33
      ],
      [
        161,
        11
      ],
      [
        13,
        -33
      ],
      [
        -99,
        -108
      ],
      [
        37,
        -22
      ],
      [
        87,
        11
      ],
      [
        24,
        43
      ],
      [
        38,
        22
      ],
      [
        62,
        11
      ],
      [
        24,
        32
      ],
      [
        -37,
        11
      ],
      [
        13,
        43
      ],
      [
        61,
        55
      ],
      [
        87,
        -22
      ],
      [
        50,
        -33
      ],
      [
        124,
        -119
      ],
      [
        62,
        -108
      ],
      [
        0,
        -65
      ],
      [
        -50,
        -22
      ],
      [
        -161,
        32
      ],
      [
        -74,
        0
      ],
      [
        -62,
        -21
      ],
      [
        -62,
        -55
      ],
      [
        -99,
        0
      ],
      [
        -62,
        -10
      ],
      [
        -99,
        -33
      ],
      [
        -38,
        -22
      ],
      [
        0,
        -21
      ],
      [
        50,
        0
      ],
      [
        99,
        32
      ],
      [
        99,
        11
      ],
      [
        161,
        -65
      ],
      [
        50,
        -11
      ],
      [
        25,
        11
      ],
      [
        161,
        0
      ],
      [
        111,
        -33
      ],
      [
        87,
        -54
      ],
      [
        37,
        -32
      ],
      [
        0,
        -55
      ],
      [
        -37,
        -32
      ],
      [
        -149,
        11
      ],
      [
        -37,
        11
      ],
      [
        -50,
        -11
      ],
      [
        -99,
        21
      ],
      [
        -62,
        33
      ],
      [
        -86,
        -33
      ],
      [
        -75,
        22
      ],
      [
        -74,
        -22
      ],
      [
        -149,
        -65
      ],
      [
        25,
        -10
      ],
      [
        198,
        54
      ],
      [
        38,
        0
      ],
      [
        185,
        -76
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -98
      ],
      [
        -161,
        44
      ],
      [
        -74,
        0
      ],
      [
        -62,
        -22
      ],
      [
        -174,
        32
      ],
      [
        -24,
        -10
      ],
      [
        148,
        -55
      ],
      [
        186,
        -21
      ],
      [
        62,
        -33
      ],
      [
        0,
        -43
      ],
      [
        74,
        -54
      ],
      [
        99,
        21
      ],
      [
        62,
        -32
      ],
      [
        87,
        -22
      ],
      [
        124,
        0
      ],
      [
        50,
        -11
      ],
      [
        -13,
        -22
      ],
      [
        -87,
        -21
      ],
      [
        -12,
        -33
      ],
      [
        74,
        -76
      ],
      [
        0,
        -21
      ],
      [
        -37,
        -65
      ],
      [
        75,
        32
      ],
      [
        37,
        -11
      ],
      [
        -13,
        65
      ],
      [
        38,
        22
      ],
      [
        111,
        22
      ],
      [
        -25,
        -98
      ],
      [
        0,
        -54
      ],
      [
        -49,
        -87
      ],
      [
        -37,
        -32
      ],
      [
        49,
        -11
      ],
      [
        62,
        86
      ],
      [
        74,
        66
      ],
      [
        13,
        0
      ],
      [
        0,
        -66
      ],
      [
        37,
        -21
      ],
      [
        49,
        32
      ],
      [
        50,
        0
      ],
      [
        50,
        -65
      ],
      [
        37,
        44
      ],
      [
        111,
        54
      ],
      [
        25,
        0
      ],
      [
        25,
        -33
      ],
      [
        -62,
        -54
      ],
      [
        -13,
        -43
      ],
      [
        13,
        -22
      ],
      [
        62,
        0
      ],
      [
        74,
        33
      ],
      [
        37,
        -22
      ],
      [
        37,
        -43
      ],
      [
        87,
        -76
      ],
      [
        50,
        21
      ],
      [
        62,
        -54
      ],
      [
        -87,
        -43
      ],
      [
        25,
        -98
      ],
      [
        -99,
        11
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -32
      ],
      [
        62,
        0
      ],
      [
        49,
        11
      ],
      [
        75,
        0
      ],
      [
        0,
        32
      ],
      [
        49,
        11
      ],
      [
        37,
        22
      ],
      [
        87,
        -22
      ],
      [
        99,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -50,
        -109
      ],
      [
        -136,
        -108
      ],
      [
        25,
        0
      ],
      [
        161,
        65
      ],
      [
        111,
        11
      ],
      [
        38,
        10
      ],
      [
        37,
        -21
      ],
      [
        74,
        -11
      ],
      [
        99,
        87
      ],
      [
        50,
        -22
      ],
      [
        49,
        -54
      ],
      [
        99,
        -87
      ],
      [
        62,
        -65
      ],
      [
        13,
        -43
      ],
      [
        -50,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -62,
        54
      ],
      [
        -62,
        22
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -33
      ],
      [
        161,
        -76
      ],
      [
        25,
        -54
      ],
      [
        0,
        -32
      ],
      [
        -99,
        -33
      ],
      [
        -99,
        11
      ],
      [
        -75,
        43
      ],
      [
        -49,
        11
      ],
      [
        -13,
        -11
      ],
      [
        50,
        -54
      ],
      [
        -50,
        -54
      ],
      [
        174,
        -98
      ],
      [
        12,
        -21
      ],
      [
        -49,
        -22
      ],
      [
        -161,
        11
      ],
      [
        74,
        -76
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -55
      ],
      [
        -13,
        -54
      ],
      [
        -62,
        0
      ],
      [
        -49,
        -11
      ],
      [
        -74,
        22
      ],
      [
        -75,
        65
      ],
      [
        -12,
        -32
      ],
      [
        -75,
        -22
      ],
      [
        0,
        -11
      ],
      [
        112,
        -22
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -195
      ],
      [
        -13,
        -65
      ],
      [
        -25,
        -65
      ],
      [
        -49,
        -54
      ],
      [
        -74,
        97
      ],
      [
        -75,
        22
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        65
      ],
      [
        13,
        98
      ],
      [
        -13,
        22
      ],
      [
        -49,
        -65
      ],
      [
        -25,
        -87
      ],
      [
        -37,
        32
      ],
      [
        -112,
        131
      ],
      [
        -37,
        54
      ],
      [
        -74,
        152
      ],
      [
        -37,
        32
      ],
      [
        12,
        44
      ],
      [
        62,
        65
      ],
      [
        62,
        32
      ],
      [
        62,
        22
      ],
      [
        24,
        32
      ],
      [
        38,
        76
      ],
      [
        74,
        76
      ],
      [
        -25,
        11
      ],
      [
        -87,
        -65
      ],
      [
        -74,
        -98
      ],
      [
        -111,
        -43
      ],
      [
        -75,
        -11
      ],
      [
        -99,
        11
      ],
      [
        -25,
        11
      ],
      [
        13,
        43
      ],
      [
        -25,
        22
      ],
      [
        -49,
        0
      ],
      [
        -50,
        54
      ],
      [
        -74,
        22
      ],
      [
        -99,
        130
      ],
      [
        -25,
        65
      ],
      [
        -75,
        43
      ],
      [
        13,
        -54
      ],
      [
        -74,
        -11
      ],
      [
        -38,
        33
      ],
      [
        -12,
        -33
      ],
      [
        50,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -50,
        -11
      ],
      [
        -74,
        65
      ],
      [
        -112,
        55
      ],
      [
        25,
        -76
      ],
      [
        37,
        -65
      ],
      [
        174,
        -141
      ],
      [
        -25,
        -55
      ],
      [
        -50,
        -21
      ],
      [
        -49,
        0
      ],
      [
        -99,
        32
      ],
      [
        -50,
        33
      ],
      [
        -62,
        65
      ],
      [
        -99,
        76
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -33
      ],
      [
        38,
        -11
      ],
      [
        86,
        -65
      ],
      [
        13,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -32
      ],
      [
        49,
        -65
      ],
      [
        87,
        -33
      ],
      [
        -25,
        -98
      ],
      [
        -12,
        -21
      ],
      [
        25,
        -11
      ],
      [
        86,
        43
      ],
      [
        25,
        0
      ],
      [
        62,
        -32
      ],
      [
        37,
        -65
      ],
      [
        62,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        -62,
        -32
      ],
      [
        50,
        -33
      ],
      [
        61,
        -87
      ],
      [
        0,
        -43
      ],
      [
        62,
        -22
      ],
      [
        13,
        -32
      ],
      [
        37,
        -22
      ],
      [
        50,
        0
      ],
      [
        111,
        -76
      ],
      [
        0,
        -21
      ],
      [
        -37,
        -33
      ],
      [
        37,
        -33
      ],
      [
        25,
        11
      ],
      [
        12,
        33
      ],
      [
        62,
        65
      ],
      [
        50,
        -22
      ],
      [
        86,
        -97
      ],
      [
        38,
        10
      ],
      [
        49,
        -54
      ],
      [
        -25,
        -32
      ],
      [
        -62,
        -33
      ],
      [
        0,
        -11
      ],
      [
        124,
        0
      ],
      [
        25,
        -11
      ],
      [
        12,
        -32
      ],
      [
        -49,
        -87
      ],
      [
        -50,
        11
      ],
      [
        -86,
        0
      ],
      [
        86,
        -54
      ],
      [
        62,
        -87
      ],
      [
        0,
        -43
      ],
      [
        50,
        -11
      ],
      [
        37,
        11
      ],
      [
        87,
        0
      ],
      [
        -13,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        12,
        -11
      ],
      [
        50,
        11
      ],
      [
        12,
        -11
      ],
      [
        62,
        -120
      ],
      [
        -49,
        -21
      ],
      [
        0,
        -65
      ],
      [
        25,
        -65
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -66
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        10
      ],
      [
        -62,
        185
      ],
      [
        -37,
        54
      ],
      [
        -49,
        33
      ],
      [
        37,
        -163
      ],
      [
        0,
        -87
      ],
      [
        -13,
        -32
      ],
      [
        62,
        -76
      ],
      [
        50,
        -109
      ],
      [
        25,
        -11
      ],
      [
        -25,
        -32
      ],
      [
        -50,
        0
      ],
      [
        -86,
        43
      ],
      [
        -13,
        -11
      ],
      [
        37,
        -141
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        22
      ],
      [
        -74,
        87
      ],
      [
        -124,
        86
      ],
      [
        -37,
        -10
      ],
      [
        -25,
        32
      ],
      [
        -99,
        87
      ],
      [
        0,
        -65
      ],
      [
        -74,
        21
      ],
      [
        -62,
        120
      ],
      [
        -13,
        -87
      ],
      [
        -24,
        -11
      ],
      [
        -38,
        87
      ],
      [
        -37,
        11
      ],
      [
        -25,
        54
      ],
      [
        -61,
        0
      ],
      [
        -112,
        108
      ],
      [
        -74,
        98
      ],
      [
        -37,
        0
      ],
      [
        37,
        -141
      ],
      [
        -13,
        0
      ],
      [
        -161,
        141
      ],
      [
        -86,
        54
      ],
      [
        -50,
        11
      ],
      [
        -87,
        0
      ],
      [
        -12,
        -32
      ],
      [
        37,
        -65
      ],
      [
        50,
        -44
      ],
      [
        99,
        -108
      ],
      [
        74,
        -109
      ],
      [
        173,
        -65
      ],
      [
        -24,
        -32
      ],
      [
        124,
        -65
      ],
      [
        136,
        -131
      ],
      [
        12,
        -21
      ],
      [
        75,
        -22
      ],
      [
        24,
        -22
      ],
      [
        62,
        -86
      ],
      [
        62,
        -98
      ],
      [
        87,
        -43
      ],
      [
        12,
        -44
      ],
      [
        -49,
        -43
      ],
      [
        25,
        -76
      ],
      [
        0,
        -43
      ],
      [
        -62,
        -22
      ],
      [
        -62,
        11
      ],
      [
        -124,
        76
      ],
      [
        -136,
        43
      ],
      [
        -50,
        11
      ],
      [
        -37,
        32
      ],
      [
        -384,
        65
      ],
      [
        -62,
        44
      ],
      [
        -124,
        54
      ],
      [
        -99,
        98
      ],
      [
        -74,
        130
      ],
      [
        -75,
        11
      ],
      [
        -86,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -112,
        65
      ],
      [
        -87,
        33
      ],
      [
        -62,
        43
      ],
      [
        -37,
        11
      ],
      [
        37,
        76
      ],
      [
        -86,
        -55
      ],
      [
        -87,
        55
      ],
      [
        -124,
        141
      ],
      [
        -49,
        43
      ],
      [
        12,
        11
      ],
      [
        99,
        0
      ],
      [
        25,
        11
      ],
      [
        74,
        65
      ],
      [
        -49,
        22
      ],
      [
        -25,
        43
      ],
      [
        -37,
        32
      ],
      [
        -37,
        11
      ],
      [
        -137,
        -11
      ],
      [
        -24,
        33
      ],
      [
        37,
        65
      ],
      [
        -13,
        11
      ],
      [
        -74,
        -44
      ],
      [
        -25,
        0
      ],
      [
        -62,
        131
      ],
      [
        -12,
        0
      ],
      [
        -62,
        54
      ],
      [
        -87,
        108
      ],
      [
        -74,
        55
      ],
      [
        -25,
        32
      ],
      [
        62,
        87
      ],
      [
        -124,
        22
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        11
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        108
      ],
      [
        -25,
        11
      ],
      [
        -74,
        0
      ],
      [
        -37,
        22
      ],
      [
        -38,
        98
      ],
      [
        -24,
        0
      ],
      [
        -75,
        -33
      ],
      [
        37,
        -33
      ],
      [
        62,
        -97
      ],
      [
        -24,
        -44
      ],
      [
        -62,
        -21
      ],
      [
        -62,
        0
      ],
      [
        -87,
        21
      ],
      [
        -62,
        33
      ],
      [
        -74,
        -11
      ],
      [
        -13,
        -87
      ],
      [
        -99,
        0
      ],
      [
        -124,
        -54
      ],
      [
        -49,
        0
      ],
      [
        -62,
        -32
      ],
      [
        -50,
        -11
      ],
      [
        -99,
        32
      ],
      [
        -86,
        11
      ],
      [
        -75,
        44
      ],
      [
        -49,
        -11
      ],
      [
        -99,
        86
      ],
      [
        -50,
        109
      ],
      [
        0,
        54
      ],
      [
        25,
        33
      ],
      [
        12,
        86
      ],
      [
        13,
        22
      ],
      [
        61,
        54
      ],
      [
        149,
        55
      ],
      [
        25,
        32
      ],
      [
        -25,
        76
      ],
      [
        0,
        33
      ],
      [
        37,
        43
      ],
      [
        25,
        11
      ],
      [
        99,
        -33
      ],
      [
        62,
        0
      ],
      [
        248,
        -76
      ],
      [
        87,
        -43
      ],
      [
        62,
        -54
      ],
      [
        49,
        -76
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -43
      ],
      [
        37,
        -22
      ],
      [
        13,
        11
      ],
      [
        0,
        54
      ],
      [
        25,
        11
      ],
      [
        -13,
        65
      ],
      [
        -37,
        44
      ],
      [
        -99,
        76
      ],
      [
        25,
        32
      ],
      [
        136,
        -22
      ],
      [
        50,
        11
      ],
      [
        61,
        55
      ],
      [
        50,
        10
      ],
      [
        62,
        -21
      ],
      [
        37,
        0
      ],
      [
        62,
        21
      ],
      [
        50,
        55
      ],
      [
        86,
        21
      ],
      [
        37,
        0
      ],
      [
        75,
        -21
      ],
      [
        37,
        0
      ],
      [
        0,
        32
      ],
      [
        -25,
        76
      ],
      [
        -37,
        65
      ],
      [
        -99,
        76
      ],
      [
        -124,
        130
      ],
      [
        -12,
        33
      ],
      [
        12,
        43
      ],
      [
        149,
        87
      ],
      [
        124,
        97
      ],
      [
        111,
        109
      ],
      [
        87,
        32
      ],
      [
        12,
        66
      ],
      [
        62,
        119
      ],
      [
        112,
        43
      ],
      [
        37,
        22
      ],
      [
        49,
        76
      ],
      [
        0,
        22
      ],
      [
        -49,
        32
      ],
      [
        -75,
        195
      ],
      [
        -49,
        98
      ],
      [
        -62,
        87
      ],
      [
        -50,
        97
      ],
      [
        -99,
        98
      ],
      [
        13,
        65
      ],
      [
        -99,
        -43
      ],
      [
        -75,
        43
      ],
      [
        -25,
        65
      ],
      [
        38,
        65
      ],
      [
        0,
        33
      ],
      [
        -25,
        43
      ],
      [
        -74,
        11
      ],
      [
        -25,
        -11
      ],
      [
        62,
        -76
      ],
      [
        -13,
        -11
      ],
      [
        -99,
        -11
      ],
      [
        -49,
        22
      ],
      [
        -99,
        119
      ],
      [
        12,
        22
      ],
      [
        -87,
        11
      ],
      [
        62,
        43
      ],
      [
        0,
        22
      ],
      [
        -62,
        11
      ],
      [
        0,
        32
      ],
      [
        75,
        33
      ],
      [
        -50,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -50,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        33
      ],
      [
        -62,
        0
      ],
      [
        -25,
        -44
      ],
      [
        -87,
        -32
      ],
      [
        -124,
        -65
      ],
      [
        -62,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -12,
        22
      ],
      [
        12,
        54
      ],
      [
        0,
        98
      ],
      [
        25,
        32
      ],
      [
        50,
        22
      ],
      [
        99,
        -22
      ],
      [
        37,
        0
      ],
      [
        74,
        54
      ],
      [
        38,
        65
      ],
      [
        -50,
        65
      ],
      [
        -87,
        44
      ],
      [
        -124,
        32
      ],
      [
        -37,
        44
      ],
      [
        0,
        54
      ],
      [
        99,
        32
      ],
      [
        0,
        11
      ],
      [
        -99,
        11
      ],
      [
        -86,
        -65
      ],
      [
        -50,
        22
      ],
      [
        -37,
        0
      ],
      [
        -37,
        32
      ],
      [
        37,
        11
      ],
      [
        49,
        44
      ],
      [
        -49,
        54
      ],
      [
        -75,
        11
      ],
      [
        -123,
        -11
      ],
      [
        -25,
        76
      ],
      [
        0,
        54
      ],
      [
        -37,
        119
      ],
      [
        -174,
        -11
      ],
      [
        -124,
        87
      ],
      [
        -49,
        54
      ],
      [
        -25,
        11
      ],
      [
        -50,
        76
      ],
      [
        -24,
        11
      ],
      [
        -99,
        -76
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -11
      ],
      [
        111,
        -33
      ],
      [
        62,
        -54
      ],
      [
        25,
        -87
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -43
      ],
      [
        -75,
        -33
      ],
      [
        -74,
        -22
      ],
      [
        -99,
        0
      ],
      [
        -198,
        65
      ],
      [
        -25,
        0
      ],
      [
        -149,
        33
      ],
      [
        -49,
        0
      ],
      [
        -99,
        22
      ],
      [
        -149,
        21
      ],
      [
        -37,
        -11
      ],
      [
        49,
        -32
      ],
      [
        62,
        -11
      ],
      [
        50,
        -32
      ],
      [
        87,
        -76
      ],
      [
        37,
        -55
      ],
      [
        -37,
        -21
      ],
      [
        -211,
        130
      ],
      [
        -198,
        -65
      ],
      [
        -124,
        11
      ],
      [
        -223,
        97
      ],
      [
        -136,
        -32
      ],
      [
        -112,
        0
      ],
      [
        -235,
        21
      ],
      [
        -74,
        22
      ],
      [
        -50,
        33
      ],
      [
        -50,
        0
      ],
      [
        -136,
        21
      ],
      [
        -124,
        -54
      ],
      [
        -136,
        43
      ],
      [
        -62,
        44
      ],
      [
        -49,
        108
      ],
      [
        12,
        44
      ],
      [
        -112,
        -11
      ],
      [
        -111,
        11
      ],
      [
        -12,
        -22
      ],
      [
        37,
        -33
      ],
      [
        -62,
        -10
      ],
      [
        -136,
        10
      ],
      [
        -75,
        -54
      ],
      [
        -186,
        130
      ],
      [
        -99,
        11
      ],
      [
        -62,
        33
      ],
      [
        -124,
        152
      ],
      [
        -49,
        151
      ],
      [
        0,
        44
      ],
      [
        111,
        -22
      ],
      [
        174,
        0
      ],
      [
        74,
        -32
      ],
      [
        99,
        -22
      ],
      [
        174,
        0
      ],
      [
        124,
        22
      ],
      [
        12,
        10
      ],
      [
        -87,
        33
      ],
      [
        -173,
        98
      ],
      [
        -62,
        10
      ],
      [
        -186,
        11
      ],
      [
        -161,
        22
      ],
      [
        -124,
        43
      ],
      [
        -124,
        65
      ],
      [
        -37,
        87
      ],
      [
        -12,
        98
      ],
      [
        -25,
        119
      ],
      [
        25,
        65
      ],
      [
        99,
        65
      ],
      [
        -62,
        33
      ],
      [
        -12,
        32
      ],
      [
        0,
        98
      ],
      [
        12,
        32
      ],
      [
        173,
        239
      ],
      [
        0,
        65
      ],
      [
        37,
        98
      ],
      [
        87,
        97
      ],
      [
        75,
        33
      ],
      [
        12,
        54
      ],
      [
        272,
        174
      ],
      [
        149,
        54
      ],
      [
        248,
        43
      ],
      [
        124,
        11
      ],
      [
        161,
        0
      ],
      [
        285,
        -22
      ],
      [
        49,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -87,
        -54
      ],
      [
        -161,
        -87
      ],
      [
        -111,
        -97
      ],
      [
        -161,
        -217
      ],
      [
        -50,
        -54
      ],
      [
        -12,
        -98
      ],
      [
        25,
        -43
      ],
      [
        74,
        -76
      ],
      [
        12,
        -44
      ],
      [
        0,
        -217
      ],
      [
        38,
        -130
      ],
      [
        62,
        -86
      ],
      [
        173,
        -131
      ],
      [
        161,
        -97
      ],
      [
        12,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -86,
        -44
      ],
      [
        -124,
        -21
      ],
      [
        -62,
        -22
      ],
      [
        -87,
        -43
      ],
      [
        -99,
        -33
      ],
      [
        -37,
        -22
      ]
    ],
    [
      [
        27512,
        102400
      ],
      [
        298,
        -130
      ],
      [
        223,
        43
      ],
      [
        123,
        11
      ],
      [
        112,
        44
      ],
      [
        87,
        0
      ],
      [
        123,
        -22
      ],
      [
        75,
        -87
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        -186,
        -65
      ],
      [
        25,
        -22
      ],
      [
        74,
        11
      ],
      [
        37,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        -75,
        -22
      ],
      [
        -99,
        -43
      ],
      [
        -223,
        -163
      ],
      [
        0,
        -43
      ],
      [
        25,
        -11
      ],
      [
        62,
        44
      ],
      [
        87,
        21
      ],
      [
        99,
        0
      ],
      [
        62,
        -21
      ],
      [
        62,
        -55
      ],
      [
        -37,
        -32
      ],
      [
        49,
        -11
      ],
      [
        62,
        -54
      ],
      [
        -37,
        -76
      ],
      [
        37,
        0
      ],
      [
        62,
        32
      ],
      [
        124,
        11
      ],
      [
        25,
        -97
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        -21
      ],
      [
        74,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -62,
        -76
      ],
      [
        50,
        -43
      ],
      [
        12,
        -87
      ],
      [
        -149,
        -43
      ],
      [
        -62,
        -55
      ],
      [
        -86,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -211,
        22
      ],
      [
        -37,
        32
      ],
      [
        -13,
        54
      ],
      [
        -49,
        -21
      ],
      [
        12,
        -33
      ],
      [
        75,
        -98
      ],
      [
        12,
        -75
      ],
      [
        -74,
        -55
      ],
      [
        -87,
        -32
      ],
      [
        -50,
        11
      ],
      [
        -61,
        32
      ],
      [
        -87,
        11
      ],
      [
        -62,
        108
      ],
      [
        -62,
        55
      ],
      [
        -50,
        65
      ],
      [
        -136,
        97
      ],
      [
        -74,
        65
      ],
      [
        -87,
        87
      ],
      [
        -74,
        33
      ],
      [
        -62,
        0
      ],
      [
        -75,
        76
      ],
      [
        -99,
        -33
      ],
      [
        -99,
        43
      ],
      [
        -12,
        44
      ],
      [
        -37,
        11
      ],
      [
        -13,
        32
      ],
      [
        -148,
        76
      ],
      [
        -112,
        98
      ],
      [
        25,
        97
      ],
      [
        37,
        44
      ],
      [
        74,
        54
      ],
      [
        100,
        0
      ],
      [
        74,
        -33
      ],
      [
        25,
        -43
      ],
      [
        49,
        -22
      ],
      [
        62,
        -54
      ],
      [
        25,
        -54
      ],
      [
        87,
        -22
      ],
      [
        74,
        11
      ],
      [
        136,
        33
      ],
      [
        37,
        130
      ],
      [
        50,
        -54
      ],
      [
        37,
        10
      ],
      [
        13,
        33
      ],
      [
        -62,
        98
      ],
      [
        -62,
        0
      ],
      [
        -38,
        21
      ],
      [
        38,
        65
      ],
      [
        74,
        0
      ],
      [
        62,
        -32
      ],
      [
        12,
        21
      ],
      [
        -86,
        65
      ],
      [
        -38,
        11
      ],
      [
        -37,
        -32
      ],
      [
        -86,
        -22
      ],
      [
        -50,
        0
      ],
      [
        -198,
        98
      ],
      [
        -25,
        43
      ],
      [
        74,
        43
      ],
      [
        112,
        22
      ],
      [
        49,
        -22
      ],
      [
        62,
        -54
      ],
      [
        50,
        11
      ],
      [
        -25,
        43
      ],
      [
        -62,
        22
      ],
      [
        -62,
        54
      ],
      [
        -12,
        44
      ],
      [
        25,
        21
      ],
      [
        148,
        33
      ],
      [
        99,
        -33
      ],
      [
        75,
        0
      ],
      [
        24,
        33
      ],
      [
        -86,
        0
      ],
      [
        -25,
        22
      ],
      [
        74,
        32
      ]
    ],
    [
      [
        28119,
        102357
      ],
      [
        -148,
        -11
      ],
      [
        -50,
        -22
      ],
      [
        -49,
        0
      ],
      [
        -112,
        33
      ],
      [
        -37,
        22
      ],
      [
        111,
        32
      ],
      [
        87,
        43
      ],
      [
        87,
        11
      ],
      [
        173,
        44
      ],
      [
        124,
        0
      ],
      [
        25,
        -22
      ],
      [
        -37,
        -43
      ],
      [
        -137,
        -76
      ],
      [
        -37,
        -11
      ]
    ],
    [
      [
        29866,
        102541
      ],
      [
        136,
        -32
      ],
      [
        99,
        -33
      ],
      [
        62,
        -43
      ],
      [
        37,
        -11
      ],
      [
        199,
        32
      ],
      [
        185,
        -10
      ],
      [
        161,
        -33
      ],
      [
        87,
        -54
      ],
      [
        0,
        -33
      ],
      [
        -62,
        -76
      ],
      [
        -74,
        -76
      ],
      [
        -74,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -62,
        -76
      ],
      [
        -112,
        -33
      ],
      [
        50,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        -111,
        -141
      ],
      [
        -50,
        -43
      ],
      [
        -111,
        -76
      ],
      [
        -50,
        0
      ],
      [
        -334,
        54
      ],
      [
        -74,
        -11
      ],
      [
        -223,
        -21
      ],
      [
        161,
        -54
      ],
      [
        74,
        -87
      ],
      [
        0,
        -65
      ],
      [
        -111,
        -109
      ],
      [
        -62,
        -141
      ],
      [
        -38,
        -21
      ],
      [
        -123,
        32
      ],
      [
        -174,
        -22
      ],
      [
        -62,
        11
      ],
      [
        13,
        98
      ],
      [
        -13,
        97
      ],
      [
        -25,
        98
      ],
      [
        -99,
        174
      ],
      [
        -24,
        108
      ],
      [
        12,
        109
      ],
      [
        0,
        130
      ],
      [
        -25,
        141
      ],
      [
        0,
        76
      ],
      [
        37,
        32
      ],
      [
        62,
        11
      ],
      [
        124,
        -43
      ],
      [
        37,
        21
      ],
      [
        -49,
        54
      ],
      [
        -37,
        66
      ],
      [
        0,
        32
      ],
      [
        37,
        43
      ],
      [
        111,
        44
      ],
      [
        87,
        11
      ],
      [
        186,
        11
      ],
      [
        49,
        -11
      ],
      [
        137,
        43
      ],
      [
        74,
        -11
      ]
    ],
    [
      [
        20724,
        102509
      ],
      [
        99,
        54
      ],
      [
        87,
        0
      ],
      [
        25,
        -22
      ],
      [
        37,
        -76
      ],
      [
        99,
        98
      ],
      [
        62,
        32
      ],
      [
        198,
        11
      ],
      [
        161,
        -21
      ],
      [
        112,
        -44
      ],
      [
        161,
        -87
      ],
      [
        260,
        -173
      ],
      [
        161,
        -76
      ],
      [
        37,
        -54
      ],
      [
        -25,
        -65
      ],
      [
        -186,
        -65
      ],
      [
        -161,
        -44
      ],
      [
        -198,
        -97
      ],
      [
        -149,
        -44
      ],
      [
        -173,
        -86
      ],
      [
        -334,
        -131
      ],
      [
        -62,
        -54
      ],
      [
        -124,
        -184
      ],
      [
        -99,
        -44
      ],
      [
        -99,
        0
      ],
      [
        -38,
        -10
      ],
      [
        0,
        -55
      ],
      [
        -49,
        -97
      ],
      [
        -37,
        -217
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        -32
      ],
      [
        -112,
        -43
      ],
      [
        -186,
        -33
      ],
      [
        -49,
        43
      ],
      [
        -50,
        -10
      ],
      [
        -136,
        -109
      ],
      [
        -136,
        -43
      ],
      [
        -99,
        -65
      ],
      [
        -87,
        0
      ],
      [
        -99,
        76
      ],
      [
        -99,
        173
      ],
      [
        -99,
        98
      ],
      [
        -13,
        21
      ],
      [
        -260,
        98
      ],
      [
        -186,
        87
      ],
      [
        -185,
        -11
      ],
      [
        24,
        65
      ],
      [
        0,
        43
      ],
      [
        50,
        33
      ],
      [
        -13,
        32
      ],
      [
        50,
        44
      ],
      [
        37,
        76
      ],
      [
        37,
        11
      ],
      [
        38,
        43
      ],
      [
        74,
        54
      ],
      [
        -25,
        33
      ],
      [
        12,
        97
      ],
      [
        25,
        33
      ],
      [
        124,
        43
      ],
      [
        0,
        44
      ],
      [
        -62,
        10
      ],
      [
        -25,
        22
      ],
      [
        13,
        44
      ],
      [
        49,
        54
      ],
      [
        75,
        130
      ],
      [
        111,
        65
      ],
      [
        25,
        76
      ],
      [
        87,
        76
      ],
      [
        -38,
        43
      ],
      [
        -74,
        11
      ],
      [
        -49,
        65
      ],
      [
        -112,
        184
      ],
      [
        -49,
        44
      ],
      [
        12,
        22
      ],
      [
        421,
        54
      ],
      [
        285,
        11
      ],
      [
        297,
        54
      ],
      [
        87,
        0
      ],
      [
        136,
        -33
      ],
      [
        87,
        -43
      ],
      [
        111,
        -43
      ],
      [
        211,
        -66
      ],
      [
        124,
        -10
      ],
      [
        -62,
        -76
      ]
    ],
    [
      [
        28429,
        102769
      ],
      [
        -99,
        -43
      ],
      [
        -37,
        32
      ],
      [
        111,
        76
      ],
      [
        50,
        -32
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        29135,
        102758
      ],
      [
        -12,
        -11
      ],
      [
        -149,
        33
      ],
      [
        -25,
        22
      ],
      [
        62,
        32
      ],
      [
        50,
        0
      ],
      [
        86,
        -54
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        26100,
        103083
      ],
      [
        -62,
        0
      ],
      [
        -111,
        22
      ],
      [
        -75,
        33
      ],
      [
        -12,
        21
      ],
      [
        62,
        109
      ],
      [
        74,
        54
      ],
      [
        137,
        11
      ],
      [
        86,
        -33
      ],
      [
        25,
        -76
      ],
      [
        37,
        -32
      ],
      [
        0,
        -43
      ],
      [
        -49,
        -33
      ],
      [
        -112,
        -33
      ]
    ],
    [
      [
        29742,
        103083
      ],
      [
        25,
        -54
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -108
      ],
      [
        -12,
        -11
      ],
      [
        -335,
        -22
      ],
      [
        -87,
        22
      ],
      [
        -173,
        76
      ],
      [
        -50,
        10
      ],
      [
        -148,
        11
      ],
      [
        -75,
        65
      ],
      [
        -61,
        0
      ],
      [
        -38,
        44
      ],
      [
        -74,
        0
      ],
      [
        0,
        43
      ],
      [
        74,
        87
      ],
      [
        75,
        22
      ],
      [
        12,
        76
      ],
      [
        62,
        54
      ],
      [
        99,
        54
      ],
      [
        211,
        54
      ],
      [
        136,
        0
      ],
      [
        136,
        -43
      ],
      [
        124,
        -76
      ],
      [
        74,
        -98
      ],
      [
        38,
        -32
      ],
      [
        24,
        -54
      ],
      [
        -12,
        -66
      ]
    ],
    [
      [
        28862,
        103387
      ],
      [
        -24,
        -22
      ],
      [
        -99,
        11
      ],
      [
        -87,
        -76
      ],
      [
        -74,
        0
      ],
      [
        -38,
        55
      ],
      [
        13,
        32
      ],
      [
        198,
        54
      ],
      [
        12,
        33
      ],
      [
        87,
        -22
      ],
      [
        62,
        -43
      ],
      [
        -50,
        -22
      ]
    ],
    [
      [
        20266,
        103528
      ],
      [
        -50,
        0
      ],
      [
        0,
        22
      ],
      [
        74,
        54
      ],
      [
        25,
        -32
      ],
      [
        -49,
        -44
      ]
    ],
    [
      [
        29408,
        103528
      ],
      [
        -38,
        0
      ],
      [
        -62,
        33
      ],
      [
        -37,
        76
      ],
      [
        124,
        54
      ],
      [
        25,
        -22
      ],
      [
        62,
        -108
      ],
      [
        -13,
        -22
      ],
      [
        -61,
        -11
      ]
    ],
    [
      [
        21207,
        103431
      ],
      [
        -99,
        -44
      ],
      [
        -62,
        0
      ],
      [
        -99,
        33
      ],
      [
        -74,
        11
      ],
      [
        -25,
        21
      ],
      [
        49,
        44
      ],
      [
        211,
        130
      ],
      [
        173,
        54
      ],
      [
        124,
        76
      ],
      [
        87,
        0
      ],
      [
        -37,
        -87
      ],
      [
        -87,
        -97
      ],
      [
        -124,
        -131
      ],
      [
        -37,
        -10
      ]
    ],
    [
      [
        34722,
        103647
      ],
      [
        0,
        -43
      ],
      [
        -99,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -62,
        33
      ],
      [
        49,
        43
      ],
      [
        198,
        120
      ],
      [
        50,
        -22
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        26757,
        103702
      ],
      [
        62,
        -55
      ],
      [
        -100,
        -21
      ],
      [
        -86,
        -76
      ],
      [
        -124,
        -11
      ],
      [
        -136,
        0
      ],
      [
        24,
        43
      ],
      [
        75,
        55
      ],
      [
        -50,
        21
      ],
      [
        -198,
        -32
      ],
      [
        -74,
        21
      ],
      [
        62,
        65
      ],
      [
        -149,
        0
      ],
      [
        -62,
        44
      ],
      [
        25,
        43
      ],
      [
        111,
        33
      ],
      [
        149,
        21
      ],
      [
        161,
        33
      ],
      [
        186,
        -22
      ],
      [
        25,
        -119
      ],
      [
        24,
        0
      ],
      [
        75,
        -43
      ]
    ],
    [
      [
        26137,
        104049
      ],
      [
        99,
        11
      ],
      [
        50,
        -33
      ],
      [
        186,
        -54
      ],
      [
        -50,
        -54
      ],
      [
        -99,
        -22
      ],
      [
        -310,
        0
      ],
      [
        -74,
        130
      ],
      [
        0,
        43
      ],
      [
        136,
        33
      ],
      [
        87,
        -11
      ],
      [
        -25,
        -43
      ]
    ],
    [
      [
        28305,
        103984
      ],
      [
        12,
        -33
      ],
      [
        -24,
        -32
      ],
      [
        12,
        -44
      ],
      [
        50,
        -43
      ],
      [
        12,
        -76
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -76
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -32
      ],
      [
        -74,
        -22
      ],
      [
        13,
        -11
      ],
      [
        148,
        -32
      ],
      [
        13,
        -11
      ],
      [
        -25,
        -130
      ],
      [
        -62,
        21
      ],
      [
        -87,
        -54
      ],
      [
        13,
        -98
      ],
      [
        49,
        -43
      ],
      [
        12,
        -32
      ],
      [
        -111,
        -11
      ],
      [
        12,
        -33
      ],
      [
        -49,
        -22
      ],
      [
        -161,
        -10
      ],
      [
        -198,
        0
      ],
      [
        -87,
        21
      ],
      [
        -74,
        -43
      ],
      [
        -211,
        22
      ],
      [
        -25,
        10
      ],
      [
        -62,
        98
      ],
      [
        13,
        22
      ],
      [
        99,
        11
      ],
      [
        -75,
        32
      ],
      [
        -123,
        33
      ],
      [
        12,
        43
      ],
      [
        149,
        33
      ],
      [
        99,
        65
      ],
      [
        74,
        21
      ],
      [
        0,
        22
      ],
      [
        186,
        22
      ],
      [
        12,
        11
      ],
      [
        -248,
        -11
      ],
      [
        -346,
        -33
      ],
      [
        -100,
        -21
      ],
      [
        -86,
        10
      ],
      [
        -372,
        -54
      ],
      [
        -62,
        11
      ],
      [
        -25,
        43
      ],
      [
        25,
        22
      ],
      [
        112,
        43
      ],
      [
        49,
        44
      ],
      [
        -12,
        22
      ],
      [
        49,
        43
      ],
      [
        75,
        0
      ],
      [
        111,
        -33
      ],
      [
        62,
        -32
      ],
      [
        62,
        0
      ],
      [
        -62,
        43
      ],
      [
        -25,
        44
      ],
      [
        25,
        43
      ],
      [
        -99,
        11
      ],
      [
        -37,
        21
      ],
      [
        -12,
        44
      ],
      [
        111,
        65
      ],
      [
        -12,
        11
      ],
      [
        -124,
        0
      ],
      [
        -75,
        32
      ],
      [
        13,
        33
      ],
      [
        111,
        76
      ],
      [
        124,
        -22
      ],
      [
        99,
        -43
      ],
      [
        13,
        -55
      ],
      [
        297,
        -162
      ],
      [
        50,
        -33
      ],
      [
        74,
        -21
      ],
      [
        62,
        21
      ],
      [
        -99,
        44
      ],
      [
        -50,
        65
      ],
      [
        37,
        11
      ],
      [
        75,
        -11
      ],
      [
        0,
        21
      ],
      [
        -62,
        22
      ],
      [
        -75,
        0
      ],
      [
        -74,
        33
      ],
      [
        149,
        43
      ],
      [
        -62,
        22
      ],
      [
        -174,
        32
      ],
      [
        -74,
        33
      ],
      [
        12,
        43
      ],
      [
        161,
        54
      ],
      [
        112,
        11
      ],
      [
        136,
        0
      ],
      [
        174,
        -108
      ],
      [
        86,
        11
      ],
      [
        -37,
        86
      ],
      [
        99,
        55
      ],
      [
        62,
        -22
      ],
      [
        99,
        -54
      ],
      [
        99,
        -33
      ],
      [
        50,
        0
      ],
      [
        37,
        -32
      ]
    ],
    [
      [
        27091,
        104049
      ],
      [
        -87,
        0
      ],
      [
        -37,
        21
      ],
      [
        149,
        33
      ],
      [
        99,
        54
      ],
      [
        149,
        0
      ],
      [
        62,
        -11
      ],
      [
        -161,
        -54
      ],
      [
        -174,
        -43
      ]
    ],
    [
      [
        24663,
        103723
      ],
      [
        99,
        11
      ],
      [
        75,
        -22
      ],
      [
        24,
        -54
      ],
      [
        -86,
        -65
      ],
      [
        24,
        -32
      ],
      [
        75,
        54
      ],
      [
        49,
        11
      ],
      [
        112,
        0
      ],
      [
        62,
        -33
      ],
      [
        25,
        -43
      ],
      [
        99,
        22
      ],
      [
        -50,
        32
      ],
      [
        -12,
        54
      ],
      [
        111,
        65
      ],
      [
        50,
        0
      ],
      [
        161,
        -32
      ],
      [
        111,
        -44
      ],
      [
        37,
        -119
      ],
      [
        -12,
        -65
      ],
      [
        -50,
        -87
      ],
      [
        -61,
        -195
      ],
      [
        -87,
        -65
      ],
      [
        -161,
        -43
      ],
      [
        -161,
        -55
      ],
      [
        -149,
        11
      ],
      [
        -124,
        33
      ],
      [
        -136,
        -33
      ],
      [
        -87,
        0
      ],
      [
        -99,
        33
      ],
      [
        37,
        21
      ],
      [
        -62,
        22
      ],
      [
        -223,
        -119
      ],
      [
        -235,
        -22
      ],
      [
        -124,
        -32
      ],
      [
        -74,
        -65
      ],
      [
        -62,
        -33
      ],
      [
        -124,
        -32
      ],
      [
        -149,
        -55
      ],
      [
        -272,
        -43
      ],
      [
        -174,
        -11
      ],
      [
        -173,
        11
      ],
      [
        -260,
        108
      ],
      [
        -37,
        44
      ],
      [
        25,
        32
      ],
      [
        61,
        33
      ],
      [
        273,
        65
      ],
      [
        173,
        65
      ],
      [
        62,
        11
      ],
      [
        161,
        11
      ],
      [
        75,
        -11
      ],
      [
        99,
        11
      ],
      [
        62,
        21
      ],
      [
        148,
        87
      ],
      [
        13,
        22
      ],
      [
        -50,
        21
      ],
      [
        -99,
        -43
      ],
      [
        -111,
        -11
      ],
      [
        -75,
        -21
      ],
      [
        -86,
        0
      ],
      [
        -75,
        43
      ],
      [
        -62,
        0
      ],
      [
        -49,
        -43
      ],
      [
        -50,
        -22
      ],
      [
        -136,
        0
      ],
      [
        -124,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -25,
        76
      ],
      [
        37,
        76
      ],
      [
        87,
        43
      ],
      [
        -25,
        11
      ],
      [
        -99,
        -22
      ],
      [
        -62,
        11
      ],
      [
        -37,
        -97
      ],
      [
        -124,
        21
      ],
      [
        62,
        -65
      ],
      [
        -37,
        -54
      ],
      [
        -136,
        -54
      ],
      [
        -75,
        -11
      ],
      [
        -74,
        76
      ],
      [
        -50,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        -76
      ],
      [
        -148,
        54
      ],
      [
        -112,
        76
      ],
      [
        -186,
        -11
      ],
      [
        -173,
        33
      ],
      [
        -25,
        43
      ],
      [
        25,
        55
      ],
      [
        62,
        54
      ],
      [
        149,
        21
      ],
      [
        235,
        0
      ],
      [
        50,
        11
      ],
      [
        260,
        76
      ],
      [
        74,
        44
      ],
      [
        -12,
        10
      ],
      [
        -310,
        -65
      ],
      [
        -136,
        -10
      ],
      [
        -199,
        10
      ],
      [
        -49,
        11
      ],
      [
        37,
        65
      ],
      [
        87,
        33
      ],
      [
        136,
        22
      ],
      [
        198,
        21
      ],
      [
        124,
        0
      ],
      [
        -49,
        33
      ],
      [
        -285,
        -11
      ],
      [
        -75,
        32
      ],
      [
        37,
        55
      ],
      [
        -24,
        32
      ],
      [
        49,
        44
      ],
      [
        87,
        32
      ],
      [
        161,
        -11
      ],
      [
        285,
        -11
      ],
      [
        -37,
        33
      ],
      [
        -223,
        22
      ],
      [
        -50,
        10
      ],
      [
        13,
        66
      ],
      [
        74,
        43
      ],
      [
        272,
        43
      ],
      [
        87,
        0
      ],
      [
        112,
        -32
      ],
      [
        24,
        -22
      ],
      [
        25,
        -76
      ],
      [
        50,
        -43
      ],
      [
        37,
        -11
      ],
      [
        223,
        32
      ],
      [
        161,
        -43
      ],
      [
        124,
        -76
      ],
      [
        161,
        -87
      ],
      [
        -74,
        -54
      ],
      [
        12,
        -11
      ],
      [
        173,
        0
      ],
      [
        87,
        -141
      ],
      [
        87,
        -32
      ],
      [
        198,
        0
      ],
      [
        471,
        -33
      ],
      [
        49,
        22
      ],
      [
        13,
        33
      ],
      [
        -13,
        65
      ],
      [
        -297,
        108
      ],
      [
        -25,
        43
      ],
      [
        149,
        55
      ],
      [
        12,
        54
      ],
      [
        -99,
        65
      ],
      [
        -74,
        11
      ],
      [
        -99,
        32
      ],
      [
        -37,
        55
      ],
      [
        12,
        32
      ],
      [
        149,
        65
      ],
      [
        111,
        109
      ],
      [
        62,
        43
      ],
      [
        87,
        33
      ],
      [
        86,
        0
      ],
      [
        99,
        -44
      ],
      [
        13,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        37,
        -119
      ],
      [
        111,
        -65
      ],
      [
        25,
        -65
      ],
      [
        -99,
        -87
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        31055,
        104005
      ],
      [
        -111,
        -11
      ],
      [
        -87,
        55
      ],
      [
        -87,
        97
      ],
      [
        13,
        33
      ],
      [
        123,
        32
      ],
      [
        75,
        0
      ],
      [
        62,
        -32
      ],
      [
        24,
        -44
      ],
      [
        -37,
        -32
      ],
      [
        -12,
        -43
      ],
      [
        37,
        -55
      ]
    ],
    [
      [
        22855,
        104157
      ],
      [
        -50,
        -22
      ],
      [
        -359,
        22
      ],
      [
        -37,
        33
      ],
      [
        74,
        32
      ],
      [
        74,
        11
      ],
      [
        186,
        11
      ],
      [
        99,
        -22
      ],
      [
        37,
        -43
      ],
      [
        -24,
        -22
      ]
    ],
    [
      [
        29482,
        104255
      ],
      [
        124,
        11
      ],
      [
        111,
        -33
      ],
      [
        136,
        -65
      ],
      [
        13,
        -54
      ],
      [
        -50,
        -65
      ],
      [
        -62,
        -55
      ],
      [
        25,
        -10
      ],
      [
        149,
        97
      ],
      [
        99,
        -11
      ],
      [
        136,
        0
      ],
      [
        186,
        44
      ],
      [
        161,
        0
      ],
      [
        62,
        -11
      ],
      [
        136,
        -54
      ],
      [
        62,
        -44
      ],
      [
        -25,
        -21
      ],
      [
        -272,
        21
      ],
      [
        25,
        -43
      ],
      [
        173,
        0
      ],
      [
        533,
        -87
      ],
      [
        24,
        -22
      ],
      [
        -61,
        -43
      ],
      [
        -310,
        -22
      ],
      [
        -186,
        11
      ],
      [
        -149,
        33
      ],
      [
        -49,
        -11
      ],
      [
        49,
        -33
      ],
      [
        87,
        -10
      ],
      [
        74,
        -22
      ],
      [
        25,
        -22
      ],
      [
        161,
        -11
      ],
      [
        75,
        -54
      ],
      [
        49,
        0
      ],
      [
        74,
        -76
      ],
      [
        62,
        11
      ],
      [
        99,
        -65
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        -99,
        -43
      ],
      [
        124,
        0
      ],
      [
        124,
        -76
      ],
      [
        37,
        32
      ],
      [
        -13,
        76
      ],
      [
        50,
        22
      ],
      [
        49,
        -11
      ],
      [
        124,
        -76
      ],
      [
        161,
        33
      ],
      [
        38,
        -11
      ],
      [
        37,
        -44
      ],
      [
        49,
        66
      ],
      [
        37,
        21
      ],
      [
        161,
        -87
      ],
      [
        87,
        -10
      ],
      [
        37,
        -22
      ],
      [
        174,
        -22
      ],
      [
        12,
        33
      ],
      [
        -62,
        32
      ],
      [
        37,
        22
      ],
      [
        137,
        33
      ],
      [
        74,
        -11
      ],
      [
        124,
        43
      ],
      [
        136,
        11
      ],
      [
        235,
        98
      ],
      [
        62,
        0
      ],
      [
        174,
        -44
      ],
      [
        309,
        54
      ],
      [
        62,
        0
      ],
      [
        174,
        -21
      ],
      [
        173,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        62,
        -22
      ],
      [
        161,
        0
      ],
      [
        136,
        -32
      ],
      [
        12,
        -33
      ],
      [
        -61,
        -33
      ],
      [
        61,
        -10
      ],
      [
        124,
        0
      ],
      [
        62,
        -55
      ],
      [
        25,
        -76
      ],
      [
        -161,
        -86
      ],
      [
        -149,
        -55
      ],
      [
        87,
        -32
      ],
      [
        161,
        22
      ],
      [
        50,
        -11
      ],
      [
        49,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -149,
        -22
      ],
      [
        -99,
        33
      ],
      [
        -37,
        -11
      ],
      [
        50,
        -33
      ],
      [
        -25,
        -151
      ],
      [
        -335,
        -11
      ],
      [
        -198,
        -55
      ],
      [
        -86,
        0
      ],
      [
        -124,
        33
      ],
      [
        -112,
        0
      ],
      [
        -87,
        33
      ],
      [
        -49,
        75
      ],
      [
        12,
        76
      ],
      [
        -37,
        0
      ],
      [
        -74,
        44
      ],
      [
        -25,
        -33
      ],
      [
        50,
        -22
      ],
      [
        -13,
        -86
      ],
      [
        -49,
        -54
      ],
      [
        -112,
        -11
      ],
      [
        -136,
        -33
      ],
      [
        -149,
        11
      ],
      [
        -86,
        22
      ],
      [
        -100,
        -33
      ],
      [
        -74,
        54
      ],
      [
        -37,
        -43
      ],
      [
        -87,
        -22
      ],
      [
        -49,
        0
      ],
      [
        -62,
        33
      ],
      [
        -75,
        -22
      ],
      [
        -111,
        33
      ],
      [
        0,
        -44
      ],
      [
        -112,
        -11
      ],
      [
        -136,
        22
      ],
      [
        -74,
        -22
      ],
      [
        -136,
        11
      ],
      [
        -149,
        0
      ],
      [
        -50,
        33
      ],
      [
        75,
        152
      ],
      [
        -50,
        21
      ],
      [
        -62,
        -11
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -12,
        44
      ],
      [
        -62,
        -33
      ],
      [
        -38,
        0
      ],
      [
        13,
        -65
      ],
      [
        -87,
        -43
      ],
      [
        -136,
        -11
      ],
      [
        -186,
        43
      ],
      [
        -62,
        0
      ],
      [
        -87,
        54
      ],
      [
        -111,
        22
      ],
      [
        0,
        -54
      ],
      [
        -74,
        11
      ],
      [
        -75,
        -11
      ],
      [
        -37,
        32
      ],
      [
        -74,
        22
      ],
      [
        -75,
        130
      ],
      [
        -24,
        76
      ],
      [
        37,
        33
      ],
      [
        -50,
        43
      ],
      [
        -49,
        22
      ],
      [
        -25,
        43
      ],
      [
        0,
        76
      ],
      [
        111,
        119
      ],
      [
        13,
        33
      ],
      [
        -37,
        119
      ],
      [
        -186,
        163
      ],
      [
        -136,
        152
      ],
      [
        -25,
        11
      ],
      [
        -136,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -74,
        -11
      ],
      [
        -298,
        22
      ],
      [
        -99,
        -22
      ],
      [
        -87,
        0
      ],
      [
        -62,
        66
      ],
      [
        -173,
        43
      ],
      [
        -37,
        32
      ],
      [
        62,
        44
      ],
      [
        -260,
        87
      ],
      [
        -87,
        21
      ],
      [
        0,
        44
      ],
      [
        74,
        -22
      ],
      [
        75,
        0
      ],
      [
        12,
        22
      ],
      [
        -87,
        32
      ],
      [
        -49,
        33
      ],
      [
        25,
        43
      ],
      [
        309,
        54
      ],
      [
        75,
        0
      ],
      [
        346,
        -65
      ],
      [
        112,
        -32
      ]
    ],
    [
      [
        22173,
        104537
      ],
      [
        13,
        -44
      ],
      [
        -248,
        -65
      ],
      [
        -37,
        -32
      ],
      [
        12,
        -22
      ],
      [
        149,
        -76
      ],
      [
        -13,
        -43
      ],
      [
        -99,
        11
      ],
      [
        -12,
        -33
      ],
      [
        99,
        -87
      ],
      [
        -12,
        -32
      ],
      [
        -87,
        -44
      ],
      [
        -87,
        -21
      ],
      [
        -186,
        -33
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -54
      ],
      [
        -74,
        -33
      ],
      [
        -50,
        0
      ],
      [
        -86,
        33
      ],
      [
        -87,
        54
      ],
      [
        -12,
        54
      ],
      [
        37,
        98
      ],
      [
        49,
        87
      ],
      [
        -37,
        11
      ],
      [
        -111,
        -22
      ],
      [
        -62,
        -43
      ],
      [
        -25,
        -98
      ],
      [
        -99,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        62,
        -22
      ],
      [
        0,
        -54
      ],
      [
        -74,
        -44
      ],
      [
        -37,
        -65
      ],
      [
        -75,
        -21
      ],
      [
        -99,
        97
      ],
      [
        -62,
        0
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -21
      ],
      [
        74,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -24,
        0
      ],
      [
        -50,
        -43
      ],
      [
        -62,
        -33
      ],
      [
        -149,
        -22
      ],
      [
        -37,
        22
      ],
      [
        -12,
        54
      ],
      [
        -50,
        54
      ],
      [
        -37,
        76
      ],
      [
        -49,
        0
      ],
      [
        -38,
        -86
      ],
      [
        -111,
        -33
      ],
      [
        -124,
        33
      ],
      [
        -74,
        10
      ],
      [
        -50,
        -10
      ],
      [
        -86,
        -44
      ],
      [
        -75,
        0
      ],
      [
        -37,
        33
      ],
      [
        25,
        43
      ],
      [
        -13,
        54
      ],
      [
        -111,
        -10
      ],
      [
        136,
        130
      ],
      [
        50,
        32
      ],
      [
        260,
        22
      ],
      [
        25,
        11
      ],
      [
        148,
        130
      ],
      [
        37,
        22
      ],
      [
        186,
        54
      ],
      [
        37,
        65
      ],
      [
        50,
        22
      ],
      [
        136,
        97
      ],
      [
        248,
        141
      ],
      [
        99,
        22
      ],
      [
        273,
        22
      ],
      [
        260,
        -44
      ],
      [
        37,
        33
      ],
      [
        124,
        -11
      ],
      [
        37,
        22
      ],
      [
        -124,
        32
      ],
      [
        0,
        22
      ],
      [
        74,
        43
      ],
      [
        161,
        11
      ],
      [
        285,
        -119
      ]
    ],
    [
      [
        31018,
        104483
      ],
      [
        -87,
        -44
      ],
      [
        -309,
        76
      ],
      [
        -62,
        43
      ],
      [
        -13,
        98
      ],
      [
        25,
        43
      ],
      [
        99,
        22
      ],
      [
        149,
        -11
      ],
      [
        74,
        -21
      ],
      [
        124,
        -66
      ],
      [
        37,
        -32
      ],
      [
        12,
        -65
      ],
      [
        -49,
        -43
      ]
    ],
    [
      [
        25951,
        104407
      ],
      [
        -49,
        -11
      ],
      [
        -173,
        32
      ],
      [
        -62,
        44
      ],
      [
        -112,
        130
      ],
      [
        -12,
        43
      ],
      [
        -112,
        119
      ],
      [
        75,
        22
      ],
      [
        86,
        -11
      ],
      [
        50,
        -21
      ],
      [
        136,
        -98
      ],
      [
        37,
        -87
      ],
      [
        62,
        0
      ],
      [
        74,
        -43
      ],
      [
        38,
        -54
      ],
      [
        -13,
        -55
      ],
      [
        -25,
        -10
      ]
    ],
    [
      [
        29073,
        104808
      ],
      [
        87,
        -22
      ],
      [
        87,
        11
      ],
      [
        334,
        -11
      ],
      [
        149,
        11
      ],
      [
        99,
        -22
      ],
      [
        49,
        -54
      ],
      [
        -62,
        -11
      ],
      [
        -74,
        -108
      ],
      [
        -99,
        -11
      ],
      [
        -198,
        22
      ],
      [
        -545,
        0
      ],
      [
        -99,
        76
      ],
      [
        24,
        65
      ],
      [
        25,
        10
      ],
      [
        223,
        44
      ]
    ],
    [
      [
        26930,
        104743
      ],
      [
        -124,
        0
      ],
      [
        -111,
        21
      ],
      [
        -25,
        33
      ],
      [
        0,
        65
      ],
      [
        74,
        11
      ],
      [
        211,
        0
      ],
      [
        111,
        -22
      ],
      [
        112,
        -76
      ],
      [
        -211,
        -11
      ],
      [
        -37,
        -21
      ]
    ],
    [
      [
        22756,
        104786
      ],
      [
        -87,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -112,
        33
      ],
      [
        -136,
        87
      ],
      [
        -12,
        32
      ],
      [
        235,
        65
      ],
      [
        25,
        -43
      ],
      [
        37,
        0
      ],
      [
        87,
        -54
      ],
      [
        62,
        -11
      ],
      [
        37,
        -54
      ],
      [
        -74,
        -33
      ]
    ],
    [
      [
        23920,
        105003
      ],
      [
        272,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -148,
        -43
      ],
      [
        -186,
        -22
      ],
      [
        -37,
        -21
      ],
      [
        49,
        -33
      ],
      [
        149,
        11
      ],
      [
        49,
        -22
      ],
      [
        13,
        -87
      ],
      [
        -37,
        -54
      ],
      [
        -161,
        -54
      ],
      [
        -75,
        -11
      ],
      [
        -111,
        0
      ],
      [
        -248,
        -54
      ],
      [
        -149,
        11
      ],
      [
        -99,
        54
      ],
      [
        -99,
        22
      ],
      [
        -74,
        32
      ],
      [
        -12,
        44
      ],
      [
        24,
        10
      ],
      [
        -49,
        98
      ],
      [
        0,
        54
      ],
      [
        25,
        33
      ],
      [
        61,
        0
      ],
      [
        75,
        21
      ],
      [
        173,
        33
      ],
      [
        372,
        54
      ],
      [
        111,
        0
      ],
      [
        149,
        11
      ]
    ],
    [
      [
        26484,
        105025
      ],
      [
        -87,
        0
      ],
      [
        0,
        32
      ],
      [
        50,
        33
      ],
      [
        74,
        22
      ],
      [
        37,
        -33
      ],
      [
        -74,
        -54
      ]
    ],
    [
      [
        24143,
        105339
      ],
      [
        62,
        -32
      ],
      [
        49,
        0
      ],
      [
        50,
        -87
      ],
      [
        -12,
        -76
      ],
      [
        -112,
        -22
      ],
      [
        -111,
        22
      ],
      [
        -87,
        -22
      ],
      [
        -161,
        11
      ],
      [
        -161,
        44
      ],
      [
        -25,
        -33
      ],
      [
        -74,
        -32
      ],
      [
        -87,
        0
      ],
      [
        -124,
        54
      ],
      [
        -149,
        -11
      ],
      [
        -210,
        -43
      ],
      [
        -50,
        32
      ],
      [
        50,
        43
      ],
      [
        99,
        44
      ],
      [
        223,
        54
      ],
      [
        173,
        11
      ],
      [
        75,
        22
      ],
      [
        148,
        65
      ],
      [
        161,
        32
      ],
      [
        62,
        0
      ],
      [
        211,
        -76
      ]
    ],
    [
      [
        28825,
        105274
      ],
      [
        75,
        -21
      ],
      [
        148,
        10
      ],
      [
        186,
        -54
      ],
      [
        50,
        -54
      ],
      [
        -137,
        -54
      ],
      [
        -24,
        -22
      ],
      [
        124,
        -54
      ],
      [
        12,
        -44
      ],
      [
        -87,
        -65
      ],
      [
        -87,
        0
      ],
      [
        -198,
        -54
      ],
      [
        -161,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -136,
        -21
      ],
      [
        -25,
        32
      ],
      [
        12,
        33
      ],
      [
        -136,
        43
      ],
      [
        -74,
        65
      ],
      [
        148,
        11
      ],
      [
        87,
        22
      ],
      [
        -124,
        43
      ],
      [
        -173,
        11
      ],
      [
        -74,
        65
      ],
      [
        -13,
        33
      ],
      [
        -87,
        54
      ],
      [
        0,
        32
      ],
      [
        87,
        22
      ],
      [
        -74,
        87
      ],
      [
        -13,
        54
      ],
      [
        38,
        11
      ],
      [
        210,
        0
      ],
      [
        149,
        -22
      ],
      [
        87,
        -32
      ],
      [
        111,
        -11
      ],
      [
        112,
        -65
      ],
      [
        24,
        -33
      ]
    ],
    [
      [
        26335,
        105762
      ],
      [
        87,
        -11
      ],
      [
        99,
        -43
      ],
      [
        87,
        -87
      ],
      [
        -25,
        -76
      ],
      [
        37,
        -43
      ],
      [
        38,
        0
      ],
      [
        37,
        65
      ],
      [
        173,
        54
      ],
      [
        62,
        -11
      ],
      [
        136,
        -54
      ],
      [
        62,
        -11
      ],
      [
        37,
        -32
      ],
      [
        -37,
        -76
      ],
      [
        75,
        -11
      ],
      [
        161,
        22
      ],
      [
        148,
        -54
      ],
      [
        149,
        -109
      ],
      [
        -87,
        -76
      ],
      [
        25,
        -22
      ],
      [
        0,
        -65
      ],
      [
        74,
        -10
      ],
      [
        149,
        -98
      ],
      [
        37,
        -76
      ],
      [
        -37,
        -76
      ],
      [
        -74,
        -22
      ],
      [
        -112,
        -10
      ],
      [
        -99,
        -22
      ],
      [
        -111,
        22
      ],
      [
        -112,
        43
      ],
      [
        -62,
        54
      ],
      [
        -12,
        65
      ],
      [
        -50,
        22
      ],
      [
        -37,
        43
      ],
      [
        -87,
        0
      ],
      [
        -173,
        44
      ],
      [
        -161,
        11
      ],
      [
        -112,
        -22
      ],
      [
        -62,
        54
      ],
      [
        25,
        22
      ],
      [
        -334,
        -33
      ],
      [
        -87,
        -32
      ],
      [
        -136,
        0
      ],
      [
        -149,
        54
      ],
      [
        -74,
        76
      ],
      [
        25,
        54
      ],
      [
        62,
        11
      ],
      [
        173,
        -22
      ],
      [
        161,
        -11
      ],
      [
        62,
        11
      ],
      [
        37,
        33
      ],
      [
        -37,
        21
      ],
      [
        -149,
        11
      ],
      [
        161,
        33
      ],
      [
        62,
        22
      ],
      [
        -49,
        21
      ],
      [
        -174,
        0
      ],
      [
        -62,
        11
      ],
      [
        13,
        22
      ],
      [
        99,
        54
      ],
      [
        -87,
        54
      ],
      [
        -99,
        -22
      ],
      [
        -136,
        -97
      ],
      [
        -62,
        22
      ],
      [
        87,
        97
      ],
      [
        0,
        22
      ],
      [
        -62,
        22
      ],
      [
        -137,
        -22
      ],
      [
        -74,
        0
      ],
      [
        -12,
        22
      ],
      [
        12,
        119
      ],
      [
        50,
        43
      ],
      [
        185,
        -11
      ],
      [
        298,
        33
      ],
      [
        99,
        0
      ],
      [
        86,
        -22
      ]
    ],
    [
      [
        27933,
        106174
      ],
      [
        13,
        -76
      ],
      [
        -25,
        -75
      ],
      [
        -37,
        -11
      ],
      [
        -99,
        21
      ],
      [
        -37,
        55
      ],
      [
        -62,
        32
      ],
      [
        -161,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -13,
        76
      ],
      [
        25,
        43
      ],
      [
        87,
        22
      ],
      [
        123,
        -11
      ],
      [
        149,
        0
      ],
      [
        37,
        -22
      ],
      [
        37,
        -65
      ]
    ],
    [
      [
        30312,
        106890
      ],
      [
        210,
        -173
      ],
      [
        223,
        -120
      ],
      [
        -12,
        -43
      ],
      [
        149,
        -22
      ],
      [
        124,
        -32
      ],
      [
        61,
        21
      ],
      [
        124,
        0
      ],
      [
        62,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        25,
        -32
      ],
      [
        -25,
        -43
      ],
      [
        62,
        -55
      ],
      [
        174,
        -43
      ],
      [
        74,
        0
      ],
      [
        25,
        22
      ],
      [
        -124,
        54
      ],
      [
        -25,
        54
      ],
      [
        87,
        54
      ],
      [
        99,
        0
      ],
      [
        161,
        -32
      ],
      [
        13,
        -120
      ],
      [
        -87,
        -32
      ],
      [
        12,
        -33
      ],
      [
        223,
        -21
      ],
      [
        74,
        -98
      ],
      [
        -49,
        -141
      ],
      [
        -62,
        -54
      ],
      [
        25,
        -11
      ],
      [
        124,
        22
      ],
      [
        74,
        32
      ],
      [
        149,
        -21
      ],
      [
        99,
        -76
      ],
      [
        62,
        65
      ],
      [
        37,
        11
      ],
      [
        49,
        -55
      ],
      [
        112,
        -86
      ],
      [
        49,
        -65
      ],
      [
        -49,
        -33
      ],
      [
        -434,
        -119
      ],
      [
        -99,
        -44
      ],
      [
        -62,
        11
      ],
      [
        -37,
        -54
      ],
      [
        -161,
        -119
      ],
      [
        -49,
        -22
      ],
      [
        -100,
        43
      ],
      [
        -12,
        109
      ],
      [
        50,
        76
      ],
      [
        -25,
        0
      ],
      [
        -99,
        -65
      ],
      [
        0,
        -152
      ],
      [
        -25,
        -22
      ],
      [
        74,
        -22
      ],
      [
        25,
        -43
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -149,
        87
      ],
      [
        -61,
        -11
      ],
      [
        49,
        -120
      ],
      [
        -62,
        -130
      ],
      [
        -111,
        11
      ],
      [
        -186,
        141
      ],
      [
        -124,
        109
      ],
      [
        -25,
        -33
      ],
      [
        198,
        -217
      ],
      [
        -24,
        -22
      ],
      [
        -137,
        55
      ],
      [
        -12,
        21
      ],
      [
        -99,
        22
      ],
      [
        -124,
        -11
      ],
      [
        99,
        -54
      ],
      [
        0,
        -43
      ],
      [
        -186,
        0
      ],
      [
        -173,
        21
      ],
      [
        -161,
        33
      ],
      [
        -161,
        43
      ],
      [
        -112,
        44
      ],
      [
        -62,
        43
      ],
      [
        50,
        22
      ],
      [
        136,
        21
      ],
      [
        149,
        11
      ],
      [
        -13,
        11
      ],
      [
        -272,
        33
      ],
      [
        -186,
        0
      ],
      [
        -49,
        21
      ],
      [
        -87,
        65
      ],
      [
        25,
        22
      ],
      [
        123,
        -11
      ],
      [
        -37,
        33
      ],
      [
        -198,
        32
      ],
      [
        -74,
        33
      ],
      [
        -25,
        32
      ],
      [
        87,
        44
      ],
      [
        223,
        65
      ],
      [
        210,
        21
      ],
      [
        50,
        66
      ],
      [
        409,
        43
      ],
      [
        12,
        11
      ],
      [
        -322,
        0
      ],
      [
        -136,
        54
      ],
      [
        -137,
        -22
      ],
      [
        -173,
        -43
      ],
      [
        -136,
        -43
      ],
      [
        -62,
        21
      ],
      [
        62,
        44
      ],
      [
        -124,
        10
      ],
      [
        -186,
        -43
      ],
      [
        -87,
        -32
      ],
      [
        -74,
        43
      ],
      [
        -124,
        22
      ],
      [
        -25,
        21
      ],
      [
        25,
        65
      ],
      [
        124,
        22
      ],
      [
        273,
        65
      ],
      [
        37,
        44
      ],
      [
        -310,
        -55
      ],
      [
        -186,
        11
      ],
      [
        -210,
        109
      ],
      [
        -50,
        43
      ],
      [
        -12,
        76
      ],
      [
        -50,
        65
      ],
      [
        347,
        -43
      ],
      [
        124,
        -11
      ],
      [
        272,
        0
      ],
      [
        13,
        54
      ],
      [
        99,
        32
      ],
      [
        -99,
        11
      ],
      [
        -211,
        -43
      ],
      [
        -74,
        0
      ],
      [
        -87,
        54
      ],
      [
        -124,
        0
      ],
      [
        -124,
        44
      ],
      [
        13,
        32
      ],
      [
        74,
        22
      ],
      [
        198,
        -11
      ],
      [
        -210,
        119
      ],
      [
        12,
        87
      ],
      [
        74,
        22
      ],
      [
        75,
        0
      ],
      [
        62,
        -22
      ],
      [
        99,
        0
      ],
      [
        74,
        -33
      ],
      [
        37,
        -43
      ],
      [
        149,
        -11
      ],
      [
        186,
        0
      ],
      [
        -37,
        22
      ],
      [
        -186,
        32
      ],
      [
        -75,
        66
      ],
      [
        -136,
        43
      ],
      [
        -111,
        11
      ],
      [
        0,
        21
      ],
      [
        86,
        87
      ],
      [
        100,
        33
      ],
      [
        161,
        -11
      ],
      [
        99,
        11
      ],
      [
        136,
        32
      ],
      [
        161,
        -11
      ],
      [
        37,
        44
      ],
      [
        -49,
        32
      ],
      [
        -174,
        0
      ],
      [
        -111,
        33
      ],
      [
        0,
        43
      ],
      [
        49,
        11
      ],
      [
        161,
        0
      ],
      [
        99,
        11
      ],
      [
        99,
        -11
      ],
      [
        285,
        -65
      ],
      [
        112,
        -76
      ]
    ],
    [
      [
        38017,
        108072
      ],
      [
        371,
        -11
      ],
      [
        161,
        -32
      ],
      [
        459,
        0
      ],
      [
        62,
        -22
      ],
      [
        -137,
        -65
      ],
      [
        -532,
        -87
      ],
      [
        223,
        -10
      ],
      [
        111,
        10
      ],
      [
        136,
        33
      ],
      [
        137,
        11
      ],
      [
        297,
        65
      ],
      [
        124,
        -22
      ],
      [
        87,
        54
      ],
      [
        123,
        -10
      ],
      [
        87,
        -66
      ],
      [
        136,
        33
      ],
      [
        161,
        -11
      ],
      [
        62,
        -22
      ],
      [
        -62,
        -43
      ],
      [
        199,
        -87
      ],
      [
        -62,
        -76
      ],
      [
        272,
        44
      ],
      [
        260,
        -11
      ],
      [
        112,
        -33
      ],
      [
        62,
        -65
      ],
      [
        -25,
        -43
      ],
      [
        -111,
        -54
      ],
      [
        -124,
        -44
      ],
      [
        -75,
        -43
      ],
      [
        -111,
        -22
      ],
      [
        -372,
        -108
      ],
      [
        -347,
        -65
      ],
      [
        -223,
        11
      ],
      [
        -86,
        -55
      ],
      [
        -174,
        -21
      ],
      [
        -223,
        -11
      ],
      [
        -74,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -607,
        -119
      ],
      [
        50,
        -33
      ],
      [
        966,
        152
      ],
      [
        173,
        11
      ],
      [
        161,
        -11
      ],
      [
        -24,
        -33
      ],
      [
        -223,
        -97
      ],
      [
        -285,
        -87
      ],
      [
        -136,
        -65
      ],
      [
        -360,
        -109
      ],
      [
        -297,
        -119
      ],
      [
        -111,
        -54
      ],
      [
        -211,
        -130
      ],
      [
        -62,
        -11
      ],
      [
        -136,
        22
      ],
      [
        -50,
        -98
      ],
      [
        -285,
        -33
      ],
      [
        -185,
        -32
      ],
      [
        -100,
        0
      ],
      [
        -49,
        -22
      ],
      [
        161,
        -21
      ],
      [
        248,
        32
      ],
      [
        111,
        -11
      ],
      [
        -62,
        -65
      ],
      [
        -186,
        -54
      ],
      [
        62,
        -43
      ],
      [
        -99,
        -55
      ],
      [
        -285,
        -43
      ],
      [
        -74,
        11
      ],
      [
        -347,
        76
      ],
      [
        -124,
        11
      ],
      [
        -111,
        21
      ],
      [
        -87,
        0
      ],
      [
        -99,
        -21
      ],
      [
        211,
        -44
      ],
      [
        148,
        0
      ],
      [
        75,
        -21
      ],
      [
        61,
        -55
      ],
      [
        0,
        -65
      ],
      [
        -86,
        -32
      ],
      [
        -186,
        0
      ],
      [
        -62,
        -22
      ],
      [
        -211,
        0
      ],
      [
        -235,
        -33
      ],
      [
        -99,
        11
      ],
      [
        -99,
        33
      ],
      [
        -99,
        11
      ],
      [
        -112,
        -11
      ],
      [
        137,
        -44
      ],
      [
        61,
        -54
      ],
      [
        62,
        0
      ],
      [
        112,
        -54
      ],
      [
        87,
        0
      ],
      [
        86,
        -22
      ],
      [
        124,
        22
      ],
      [
        87,
        0
      ],
      [
        -12,
        -108
      ],
      [
        -38,
        -11
      ],
      [
        -210,
        0
      ],
      [
        -87,
        11
      ],
      [
        -49,
        21
      ],
      [
        -87,
        11
      ],
      [
        -87,
        -11
      ],
      [
        -74,
        11
      ],
      [
        -359,
        -32
      ],
      [
        -199,
        10
      ],
      [
        -210,
        0
      ],
      [
        198,
        -76
      ],
      [
        49,
        -10
      ],
      [
        360,
        54
      ],
      [
        111,
        0
      ],
      [
        149,
        -22
      ],
      [
        99,
        -65
      ],
      [
        136,
        0
      ],
      [
        99,
        -22
      ],
      [
        236,
        -75
      ],
      [
        -50,
        -66
      ],
      [
        -111,
        -54
      ],
      [
        -174,
        -11
      ],
      [
        -334,
        0
      ],
      [
        297,
        -76
      ],
      [
        112,
        -43
      ],
      [
        -124,
        -65
      ],
      [
        -112,
        -130
      ],
      [
        -74,
        -22
      ],
      [
        -99,
        0
      ],
      [
        -124,
        -32
      ],
      [
        -248,
        10
      ],
      [
        -198,
        0
      ],
      [
        -25,
        -65
      ],
      [
        13,
        -141
      ],
      [
        -13,
        -65
      ],
      [
        -62,
        -65
      ],
      [
        -148,
        -43
      ],
      [
        -149,
        -11
      ],
      [
        -260,
        -11
      ],
      [
        -136,
        0
      ],
      [
        -199,
        33
      ],
      [
        -223,
        97
      ],
      [
        -49,
        -11
      ],
      [
        49,
        -43
      ],
      [
        87,
        -43
      ],
      [
        -87,
        -33
      ],
      [
        -185,
        -11
      ],
      [
        99,
        -54
      ],
      [
        223,
        44
      ],
      [
        111,
        -11
      ],
      [
        174,
        -65
      ],
      [
        123,
        32
      ],
      [
        149,
        0
      ],
      [
        50,
        -32
      ],
      [
        24,
        -44
      ],
      [
        -12,
        -65
      ],
      [
        111,
        -54
      ],
      [
        75,
        0
      ],
      [
        136,
        54
      ],
      [
        37,
        0
      ],
      [
        99,
        -76
      ],
      [
        0,
        -65
      ],
      [
        -49,
        -65
      ],
      [
        -50,
        -43
      ],
      [
        -223,
        -76
      ],
      [
        -124,
        -65
      ],
      [
        -235,
        -65
      ],
      [
        -74,
        0
      ],
      [
        -174,
        -44
      ],
      [
        -99,
        0
      ],
      [
        0,
        54
      ],
      [
        50,
        66
      ],
      [
        -50,
        65
      ],
      [
        -74,
        21
      ],
      [
        -186,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -62,
        65
      ],
      [
        -74,
        11
      ],
      [
        -38,
        -11
      ],
      [
        50,
        -76
      ],
      [
        -12,
        -21
      ],
      [
        -397,
        -22
      ],
      [
        -173,
        11
      ],
      [
        -37,
        21
      ],
      [
        -99,
        -86
      ],
      [
        -298,
        -33
      ],
      [
        -186,
        33
      ],
      [
        -148,
        54
      ],
      [
        -62,
        32
      ],
      [
        -37,
        55
      ],
      [
        -50,
        -33
      ],
      [
        -49,
        -97
      ],
      [
        -100,
        32
      ],
      [
        -123,
        22
      ],
      [
        -50,
        -44
      ],
      [
        -211,
        22
      ],
      [
        -99,
        -11
      ],
      [
        -148,
        33
      ],
      [
        -186,
        11
      ],
      [
        -74,
        10
      ],
      [
        24,
        207
      ],
      [
        248,
        108
      ],
      [
        74,
        54
      ],
      [
        149,
        33
      ],
      [
        273,
        0
      ],
      [
        99,
        21
      ],
      [
        74,
        0
      ],
      [
        -111,
        109
      ],
      [
        -87,
        0
      ],
      [
        -62,
        32
      ],
      [
        -62,
        65
      ],
      [
        -112,
        141
      ],
      [
        25,
        44
      ],
      [
        186,
        54
      ],
      [
        161,
        11
      ],
      [
        223,
        -54
      ],
      [
        74,
        -44
      ],
      [
        149,
        -141
      ],
      [
        50,
        -32
      ],
      [
        210,
        -54
      ],
      [
        75,
        -11
      ],
      [
        272,
        21
      ],
      [
        87,
        11
      ],
      [
        74,
        65
      ],
      [
        87,
        44
      ],
      [
        186,
        162
      ],
      [
        24,
        55
      ],
      [
        -24,
        21
      ],
      [
        -248,
        -217
      ],
      [
        -124,
        -54
      ],
      [
        -136,
        -11
      ],
      [
        -112,
        33
      ],
      [
        -124,
        -44
      ],
      [
        -74,
        11
      ],
      [
        -74,
        33
      ],
      [
        0,
        119
      ],
      [
        -87,
        109
      ],
      [
        322,
        162
      ],
      [
        74,
        11
      ],
      [
        -49,
        22
      ],
      [
        -124,
        0
      ],
      [
        -50,
        43
      ],
      [
        -74,
        -76
      ],
      [
        -111,
        -54
      ],
      [
        -223,
        -11
      ],
      [
        62,
        65
      ],
      [
        -13,
        55
      ],
      [
        -124,
        -55
      ],
      [
        -161,
        -43
      ],
      [
        -148,
        11
      ],
      [
        -75,
        21
      ],
      [
        25,
        66
      ],
      [
        0,
        86
      ],
      [
        186,
        152
      ],
      [
        49,
        76
      ],
      [
        384,
        43
      ],
      [
        236,
        44
      ],
      [
        74,
        -22
      ],
      [
        297,
        -32
      ],
      [
        223,
        -44
      ],
      [
        99,
        54
      ],
      [
        186,
        -10
      ],
      [
        99,
        21
      ],
      [
        137,
        54
      ],
      [
        -38,
        11
      ],
      [
        -123,
        -32
      ],
      [
        -137,
        -11
      ],
      [
        -148,
        22
      ],
      [
        -248,
        0
      ],
      [
        -124,
        10
      ],
      [
        -99,
        22
      ],
      [
        -50,
        54
      ],
      [
        112,
        33
      ],
      [
        149,
        -43
      ],
      [
        86,
        0
      ],
      [
        -223,
        108
      ],
      [
        -210,
        163
      ],
      [
        -87,
        76
      ],
      [
        -62,
        32
      ],
      [
        -272,
        33
      ],
      [
        -38,
        11
      ],
      [
        -86,
        65
      ],
      [
        -25,
        108
      ],
      [
        -50,
        65
      ],
      [
        50,
        87
      ],
      [
        62,
        43
      ],
      [
        396,
        -32
      ],
      [
        161,
        0
      ],
      [
        211,
        -11
      ],
      [
        124,
        -22
      ],
      [
        124,
        -43
      ],
      [
        123,
        -65
      ],
      [
        112,
        -33
      ],
      [
        99,
        -54
      ],
      [
        173,
        -119
      ],
      [
        137,
        -44
      ],
      [
        148,
        -21
      ],
      [
        199,
        -11
      ],
      [
        123,
        43
      ],
      [
        -61,
        11
      ],
      [
        -149,
        -11
      ],
      [
        -99,
        11
      ],
      [
        -124,
        65
      ],
      [
        -174,
        109
      ],
      [
        -161,
        65
      ],
      [
        -210,
        130
      ],
      [
        -13,
        32
      ],
      [
        162,
        33
      ],
      [
        532,
        43
      ],
      [
        322,
        54
      ],
      [
        137,
        65
      ],
      [
        433,
        87
      ],
      [
        520,
        54
      ],
      [
        -86,
        22
      ],
      [
        -310,
        0
      ],
      [
        -186,
        11
      ],
      [
        -49,
        22
      ],
      [
        24,
        54
      ],
      [
        124,
        76
      ],
      [
        248,
        97
      ],
      [
        -149,
        11
      ],
      [
        -124,
        -43
      ],
      [
        -136,
        -76
      ],
      [
        -161,
        -11
      ],
      [
        -37,
        -22
      ],
      [
        -99,
        -130
      ],
      [
        -186,
        -76
      ],
      [
        -396,
        -86
      ],
      [
        -87,
        0
      ],
      [
        -285,
        -44
      ],
      [
        -173,
        11
      ],
      [
        37,
        33
      ],
      [
        148,
        65
      ],
      [
        38,
        32
      ],
      [
        -397,
        -43
      ],
      [
        -86,
        -22
      ],
      [
        -149,
        -76
      ],
      [
        -50,
        -11
      ],
      [
        -371,
        -10
      ],
      [
        -149,
        43
      ],
      [
        -186,
        -11
      ],
      [
        -124,
        33
      ],
      [
        124,
        108
      ],
      [
        347,
        119
      ],
      [
        198,
        33
      ],
      [
        459,
        43
      ],
      [
        24,
        22
      ],
      [
        -867,
        -65
      ],
      [
        -148,
        -54
      ],
      [
        -298,
        -141
      ],
      [
        -86,
        -33
      ],
      [
        -124,
        -11
      ],
      [
        -99,
        11
      ],
      [
        -223,
        65
      ],
      [
        -149,
        33
      ],
      [
        -62,
        54
      ],
      [
        25,
        11
      ],
      [
        260,
        43
      ],
      [
        359,
        -11
      ],
      [
        161,
        11
      ],
      [
        149,
        22
      ],
      [
        235,
        54
      ],
      [
        248,
        76
      ],
      [
        50,
        22
      ],
      [
        -100,
        11
      ],
      [
        -222,
        -33
      ],
      [
        -261,
        -76
      ],
      [
        -223,
        -32
      ],
      [
        -557,
        -11
      ],
      [
        -173,
        -22
      ],
      [
        -75,
        11
      ],
      [
        -124,
        54
      ],
      [
        13,
        33
      ],
      [
        124,
        32
      ],
      [
        111,
        11
      ],
      [
        -136,
        33
      ],
      [
        -13,
        21
      ],
      [
        273,
        87
      ],
      [
        99,
        22
      ],
      [
        161,
        11
      ],
      [
        174,
        -11
      ],
      [
        12,
        11
      ],
      [
        -174,
        21
      ],
      [
        -297,
        -11
      ],
      [
        -458,
        -86
      ],
      [
        -112,
        21
      ],
      [
        25,
        22
      ],
      [
        248,
        87
      ],
      [
        0,
        11
      ],
      [
        -174,
        0
      ],
      [
        -99,
        21
      ],
      [
        -161,
        -43
      ],
      [
        -111,
        -11
      ],
      [
        -99,
        33
      ],
      [
        12,
        32
      ],
      [
        149,
        65
      ],
      [
        260,
        54
      ],
      [
        111,
        11
      ],
      [
        174,
        0
      ],
      [
        173,
        44
      ],
      [
        198,
        65
      ],
      [
        174,
        21
      ],
      [
        149,
        -10
      ],
      [
        210,
        -76
      ],
      [
        62,
        43
      ],
      [
        74,
        11
      ],
      [
        161,
        -11
      ],
      [
        174,
        -43
      ],
      [
        210,
        11
      ],
      [
        -49,
        32
      ],
      [
        -483,
        98
      ],
      [
        -13,
        21
      ],
      [
        285,
        44
      ],
      [
        174,
        76
      ],
      [
        186,
        21
      ],
      [
        136,
        -43
      ],
      [
        186,
        -11
      ],
      [
        74,
        -22
      ],
      [
        149,
        -86
      ],
      [
        136,
        -55
      ],
      [
        37,
        33
      ],
      [
        -25,
        33
      ],
      [
        75,
        32
      ],
      [
        322,
        -87
      ],
      [
        495,
        -86
      ],
      [
        0,
        32
      ],
      [
        -458,
        98
      ],
      [
        -174,
        54
      ],
      [
        -161,
        76
      ],
      [
        0,
        22
      ],
      [
        149,
        43
      ],
      [
        111,
        11
      ],
      [
        -148,
        54
      ],
      [
        0,
        22
      ],
      [
        111,
        11
      ],
      [
        322,
        -55
      ],
      [
        25,
        11
      ],
      [
        -136,
        98
      ],
      [
        62,
        21
      ],
      [
        124,
        0
      ],
      [
        198,
        -43
      ],
      [
        359,
        -22
      ],
      [
        87,
        11
      ],
      [
        -359,
        76
      ],
      [
        -112,
        65
      ],
      [
        87,
        11
      ],
      [
        248,
        0
      ],
      [
        223,
        -22
      ],
      [
        185,
        11
      ],
      [
        124,
        -11
      ],
      [
        136,
        -32
      ],
      [
        273,
        -109
      ],
      [
        99,
        -76
      ],
      [
        50,
        -10
      ],
      [
        148,
        43
      ],
      [
        -285,
        130
      ],
      [
        -173,
        65
      ],
      [
        -74,
        54
      ],
      [
        470,
        33
      ],
      [
        459,
        -22
      ],
      [
        124,
        -43
      ],
      [
        123,
        -65
      ],
      [
        149,
        -44
      ],
      [
        173,
        -10
      ],
      [
        -235,
        86
      ],
      [
        37,
        65
      ],
      [
        186,
        55
      ],
      [
        285,
        10
      ],
      [
        186,
        -54
      ],
      [
        198,
        54
      ],
      [
        310,
        11
      ],
      [
        161,
        -65
      ]
    ],
    [
      [
        65207,
        85742
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -43
      ],
      [
        13,
        -22
      ],
      [
        24,
        0
      ]
    ],
    [
      [
        65517,
        85493
      ],
      [
        -13,
        -87
      ],
      [
        0,
        -44
      ],
      [
        13,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        10
      ],
      [
        -25,
        44
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -55
      ],
      [
        25,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -37,
        76
      ],
      [
        -49,
        -11
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -25,
        32
      ],
      [
        -12,
        54
      ],
      [
        0,
        33
      ],
      [
        -50,
        0
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -119
      ],
      [
        -13,
        -44
      ],
      [
        -49,
        -65
      ],
      [
        -25,
        -54
      ],
      [
        13,
        -54
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        22
      ],
      [
        0,
        32
      ],
      [
        -37,
        54
      ],
      [
        12,
        44
      ],
      [
        -62,
        21
      ],
      [
        -74,
        109
      ],
      [
        12,
        76
      ],
      [
        -12,
        32
      ],
      [
        -50,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        -50,
        -43
      ],
      [
        13,
        -65
      ],
      [
        -50,
        -87
      ],
      [
        -74,
        -65
      ],
      [
        -87,
        43
      ],
      [
        -62,
        -43
      ],
      [
        -74,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        22
      ]
    ],
    [
      [
        64340,
        84907
      ],
      [
        0,
        11
      ],
      [
        -37,
        65
      ],
      [
        -25,
        22
      ],
      [
        -25,
        43
      ],
      [
        13,
        76
      ],
      [
        -13,
        22
      ],
      [
        0,
        65
      ],
      [
        -62,
        10
      ],
      [
        -49,
        0
      ],
      [
        -75,
        -65
      ],
      [
        13,
        -54
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        11
      ],
      [
        0,
        32
      ],
      [
        24,
        22
      ],
      [
        25,
        54
      ],
      [
        0,
        33
      ],
      [
        -25,
        22
      ],
      [
        13,
        21
      ],
      [
        25,
        98
      ],
      [
        49,
        43
      ],
      [
        37,
        44
      ],
      [
        13,
        54
      ],
      [
        0,
        65
      ],
      [
        74,
        54
      ],
      [
        50,
        87
      ],
      [
        61,
        87
      ],
      [
        0,
        32
      ],
      [
        -24,
        0
      ],
      [
        0,
        22
      ],
      [
        24,
        43
      ],
      [
        25,
        22
      ],
      [
        25,
        0
      ],
      [
        25,
        -43
      ],
      [
        49,
        0
      ],
      [
        25,
        21
      ],
      [
        25,
        55
      ],
      [
        49,
        32
      ]
    ],
    [
      [
        64550,
        85948
      ],
      [
        25,
        -22
      ],
      [
        75,
        0
      ],
      [
        99,
        22
      ],
      [
        37,
        0
      ],
      [
        37,
        -11
      ],
      [
        12,
        22
      ],
      [
        37,
        0
      ],
      [
        0,
        22
      ],
      [
        -37,
        0
      ],
      [
        -24,
        21
      ],
      [
        12,
        33
      ],
      [
        25,
        22
      ],
      [
        37,
        0
      ],
      [
        37,
        -44
      ],
      [
        37,
        0
      ],
      [
        25,
        -32
      ],
      [
        99,
        10
      ],
      [
        124,
        -86
      ]
    ],
    [
      [
        38673,
        21300
      ],
      [
        -86,
        22
      ],
      [
        0,
        21
      ],
      [
        99,
        0
      ],
      [
        12,
        -11
      ],
      [
        -25,
        -32
      ]
    ],
    [
      [
        38772,
        21376
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -62,
        32
      ],
      [
        50,
        33
      ],
      [
        25,
        32
      ],
      [
        12,
        -54
      ],
      [
        25,
        -32
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        39057,
        21712
      ],
      [
        -24,
        -22
      ],
      [
        -38,
        11
      ],
      [
        0,
        22
      ],
      [
        38,
        32
      ],
      [
        37,
        -21
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        38847,
        21766
      ],
      [
        -13,
        -32
      ],
      [
        -49,
        -54
      ],
      [
        -50,
        10
      ],
      [
        -12,
        44
      ],
      [
        -37,
        11
      ],
      [
        -50,
        -44
      ],
      [
        -25,
        -11
      ],
      [
        -111,
        33
      ],
      [
        -37,
        87
      ],
      [
        -37,
        54
      ],
      [
        61,
        32
      ],
      [
        87,
        0
      ],
      [
        149,
        -21
      ],
      [
        62,
        0
      ],
      [
        49,
        -54
      ],
      [
        13,
        -55
      ]
    ],
    [
      [
        37942,
        21907
      ],
      [
        273,
        -65
      ],
      [
        87,
        44
      ],
      [
        74,
        0
      ],
      [
        12,
        -55
      ],
      [
        -62,
        -54
      ],
      [
        0,
        -32
      ],
      [
        75,
        -11
      ],
      [
        25,
        -33
      ],
      [
        -13,
        -54
      ],
      [
        87,
        -87
      ],
      [
        12,
        -21
      ],
      [
        0,
        -87
      ],
      [
        -37,
        11
      ],
      [
        -25,
        21
      ],
      [
        -37,
        55
      ],
      [
        -49,
        10
      ],
      [
        -38,
        22
      ],
      [
        -74,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        65
      ],
      [
        24,
        54
      ],
      [
        -12,
        22
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        44
      ],
      [
        -49,
        10
      ],
      [
        -13,
        -65
      ],
      [
        13,
        -65
      ],
      [
        49,
        -65
      ],
      [
        -25,
        0
      ],
      [
        -61,
        22
      ],
      [
        -38,
        43
      ],
      [
        -49,
        44
      ],
      [
        0,
        54
      ],
      [
        -50,
        -11
      ],
      [
        -25,
        33
      ],
      [
        -37,
        21
      ],
      [
        25,
        55
      ],
      [
        12,
        108
      ],
      [
        62,
        -22
      ]
    ],
    [
      [
        37496,
        21940
      ],
      [
        13,
        -44
      ],
      [
        49,
        -21
      ],
      [
        137,
        43
      ],
      [
        49,
        -97
      ],
      [
        -37,
        -66
      ],
      [
        -25,
        -10
      ],
      [
        -24,
        10
      ],
      [
        0,
        22
      ],
      [
        -25,
        33
      ],
      [
        -50,
        -22
      ],
      [
        -25,
        22
      ],
      [
        -49,
        21
      ],
      [
        0,
        22
      ],
      [
        -87,
        76
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -33
      ],
      [
        -12,
        33
      ],
      [
        12,
        32
      ],
      [
        136,
        -21
      ]
    ],
    [
      [
        37360,
        22460
      ],
      [
        75,
        -54
      ],
      [
        49,
        11
      ],
      [
        12,
        -87
      ],
      [
        -49,
        -87
      ],
      [
        -112,
        98
      ],
      [
        -37,
        -11
      ],
      [
        -62,
        11
      ],
      [
        -24,
        -32
      ],
      [
        -38,
        -11
      ],
      [
        -12,
        54
      ],
      [
        -37,
        54
      ],
      [
        -50,
        44
      ],
      [
        25,
        75
      ],
      [
        50,
        33
      ],
      [
        99,
        -33
      ],
      [
        62,
        -10
      ],
      [
        49,
        -55
      ]
    ],
    [
      [
        36840,
        22807
      ],
      [
        0,
        -54
      ],
      [
        74,
        0
      ],
      [
        75,
        -11
      ],
      [
        37,
        -65
      ],
      [
        25,
        -21
      ],
      [
        24,
        -55
      ],
      [
        -24,
        -32
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -62,
        -54
      ],
      [
        -124,
        -33
      ],
      [
        -12,
        33
      ],
      [
        24,
        21
      ],
      [
        25,
        55
      ],
      [
        12,
        54
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -11
      ],
      [
        -62,
        44
      ],
      [
        0,
        141
      ],
      [
        -62,
        -11
      ],
      [
        -37,
        54
      ],
      [
        -13,
        54
      ],
      [
        -74,
        11
      ],
      [
        49,
        76
      ],
      [
        87,
        11
      ],
      [
        25,
        -44
      ],
      [
        99,
        -21
      ],
      [
        -12,
        54
      ],
      [
        24,
        22
      ],
      [
        50,
        -55
      ]
    ],
    [
      [
        36332,
        23154
      ],
      [
        112,
        -21
      ],
      [
        61,
        -33
      ],
      [
        38,
        -32
      ],
      [
        37,
        0
      ],
      [
        37,
        -44
      ],
      [
        37,
        -11
      ],
      [
        50,
        -65
      ],
      [
        49,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -61,
        22
      ],
      [
        -62,
        11
      ],
      [
        0,
        32
      ],
      [
        -75,
        87
      ],
      [
        -62,
        22
      ],
      [
        -49,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -49,
        54
      ],
      [
        -50,
        43
      ],
      [
        -49,
        98
      ],
      [
        12,
        22
      ],
      [
        37,
        -22
      ],
      [
        25,
        -43
      ],
      [
        25,
        -11
      ],
      [
        12,
        -44
      ]
    ],
    [
      [
        38302,
        21951
      ],
      [
        -50,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -87,
        -11
      ],
      [
        -136,
        33
      ],
      [
        -37,
        21
      ],
      [
        -50,
        65
      ],
      [
        -12,
        -21
      ],
      [
        -87,
        -44
      ],
      [
        -37,
        0
      ],
      [
        -37,
        22
      ],
      [
        -13,
        22
      ],
      [
        -74,
        -44
      ],
      [
        -87,
        44
      ],
      [
        -62,
        21
      ],
      [
        -99,
        11
      ],
      [
        -74,
        44
      ],
      [
        -136,
        0
      ],
      [
        -25,
        10
      ],
      [
        -13,
        55
      ],
      [
        50,
        54
      ],
      [
        74,
        -43
      ],
      [
        25,
        32
      ],
      [
        50,
        33
      ],
      [
        74,
        -33
      ],
      [
        25,
        0
      ],
      [
        37,
        22
      ],
      [
        25,
        54
      ],
      [
        62,
        -11
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -44
      ],
      [
        49,
        -10
      ],
      [
        50,
        0
      ],
      [
        37,
        -11
      ],
      [
        0,
        21
      ],
      [
        -50,
        65
      ],
      [
        -24,
        55
      ],
      [
        -75,
        32
      ],
      [
        -37,
        87
      ],
      [
        0,
        141
      ],
      [
        74,
        33
      ],
      [
        -24,
        65
      ],
      [
        37,
        43
      ],
      [
        25,
        11
      ],
      [
        24,
        -163
      ],
      [
        25,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        0
      ],
      [
        38,
        -87
      ],
      [
        49,
        -21
      ],
      [
        50,
        -65
      ],
      [
        0,
        -44
      ],
      [
        24,
        -22
      ],
      [
        62,
        0
      ],
      [
        37,
        11
      ],
      [
        25,
        33
      ],
      [
        25,
        0
      ],
      [
        37,
        -33
      ],
      [
        75,
        -21
      ],
      [
        37,
        -87
      ],
      [
        12,
        -11
      ],
      [
        50,
        65
      ],
      [
        24,
        11
      ],
      [
        0,
        22
      ],
      [
        -49,
        32
      ],
      [
        -273,
        152
      ],
      [
        -37,
        54
      ],
      [
        -12,
        76
      ],
      [
        0,
        87
      ],
      [
        12,
        22
      ],
      [
        50,
        32
      ],
      [
        86,
        44
      ],
      [
        124,
        75
      ],
      [
        0,
        44
      ],
      [
        -12,
        21
      ],
      [
        -50,
        22
      ],
      [
        -74,
        0
      ],
      [
        -50,
        -11
      ],
      [
        -74,
        -43
      ],
      [
        -74,
        32
      ],
      [
        -37,
        44
      ],
      [
        -13,
        65
      ],
      [
        0,
        76
      ],
      [
        50,
        54
      ],
      [
        25,
        -11
      ],
      [
        24,
        22
      ],
      [
        13,
        32
      ],
      [
        -62,
        66
      ],
      [
        -25,
        43
      ],
      [
        12,
        11
      ],
      [
        50,
        0
      ],
      [
        74,
        -54
      ],
      [
        25,
        0
      ],
      [
        50,
        54
      ],
      [
        74,
        119
      ],
      [
        25,
        33
      ],
      [
        25,
        0
      ],
      [
        86,
        -109
      ],
      [
        25,
        -11
      ],
      [
        99,
        65
      ],
      [
        12,
        0
      ],
      [
        50,
        -43
      ]
    ],
    [
      [
        36419,
        23773
      ],
      [
        -75,
        21
      ],
      [
        -24,
        33
      ],
      [
        0,
        32
      ],
      [
        -25,
        44
      ],
      [
        49,
        -11
      ],
      [
        25,
        -43
      ],
      [
        50,
        -33
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        36183,
        23957
      ],
      [
        13,
        -119
      ],
      [
        49,
        -22
      ],
      [
        38,
        -76
      ],
      [
        -50,
        -108
      ],
      [
        -12,
        -76
      ],
      [
        -50,
        11
      ],
      [
        -25,
        65
      ],
      [
        -37,
        76
      ],
      [
        -25,
        151
      ],
      [
        37,
        44
      ],
      [
        25,
        -11
      ],
      [
        0,
        54
      ],
      [
        37,
        11
      ]
    ],
    [
      [
        36270,
        24185
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        22
      ],
      [
        -12,
        -33
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -49,
        -109
      ],
      [
        -38,
        -32
      ],
      [
        0,
        43
      ],
      [
        25,
        109
      ],
      [
        25,
        65
      ],
      [
        37,
        -33
      ],
      [
        50,
        33
      ],
      [
        49,
        43
      ],
      [
        50,
        0
      ],
      [
        12,
        -43
      ]
    ],
    [
      [
        36010,
        24553
      ],
      [
        0,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -13,
        76
      ],
      [
        13,
        33
      ],
      [
        0,
        76
      ],
      [
        37,
        -11
      ],
      [
        62,
        0
      ],
      [
        12,
        -11
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        -55
      ]
    ],
    [
      [
        36097,
        24792
      ],
      [
        -62,
        -43
      ],
      [
        -25,
        21
      ],
      [
        -50,
        0
      ],
      [
        25,
        109
      ],
      [
        13,
        32
      ],
      [
        12,
        65
      ],
      [
        37,
        -21
      ],
      [
        74,
        -33
      ],
      [
        38,
        -11
      ],
      [
        12,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -43
      ]
    ],
    [
      [
        36084,
        25703
      ],
      [
        0,
        -43
      ],
      [
        -49,
        -98
      ],
      [
        -87,
        -98
      ],
      [
        -25,
        0
      ],
      [
        -24,
        22
      ],
      [
        49,
        65
      ],
      [
        0,
        44
      ],
      [
        -12,
        21
      ],
      [
        -37,
        22
      ],
      [
        12,
        43
      ],
      [
        25,
        22
      ],
      [
        86,
        22
      ],
      [
        13,
        21
      ],
      [
        49,
        0
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        36295,
        25508
      ],
      [
        12,
        -87
      ],
      [
        -12,
        -87
      ],
      [
        -12,
        -141
      ],
      [
        24,
        -10
      ],
      [
        0,
        -66
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        -49,
        -21
      ],
      [
        -25,
        10
      ],
      [
        -13,
        44
      ],
      [
        0,
        76
      ],
      [
        -24,
        54
      ],
      [
        0,
        22
      ],
      [
        24,
        54
      ],
      [
        0,
        54
      ],
      [
        -49,
        -11
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -109
      ],
      [
        -12,
        -54
      ],
      [
        -12,
        -11
      ],
      [
        -75,
        0
      ],
      [
        -62,
        54
      ],
      [
        -24,
        -21
      ],
      [
        -13,
        65
      ],
      [
        13,
        43
      ],
      [
        74,
        0
      ],
      [
        0,
        87
      ],
      [
        -37,
        43
      ],
      [
        -13,
        33
      ],
      [
        13,
        21
      ],
      [
        49,
        44
      ],
      [
        25,
        -22
      ],
      [
        37,
        11
      ],
      [
        0,
        54
      ],
      [
        -37,
        22
      ],
      [
        13,
        43
      ],
      [
        49,
        44
      ],
      [
        25,
        32
      ],
      [
        0,
        44
      ],
      [
        -13,
        43
      ],
      [
        38,
        54
      ],
      [
        49,
        22
      ],
      [
        37,
        -33
      ],
      [
        25,
        0
      ],
      [
        13,
        -32
      ],
      [
        12,
        -217
      ]
    ],
    [
      [
        35948,
        25757
      ],
      [
        -37,
        0
      ],
      [
        -12,
        109
      ],
      [
        49,
        217
      ],
      [
        -25,
        97
      ],
      [
        62,
        33
      ],
      [
        37,
        -119
      ],
      [
        50,
        -131
      ],
      [
        -12,
        -119
      ],
      [
        -13,
        -32
      ],
      [
        -74,
        -33
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        36270,
        25855
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -75,
        -22
      ],
      [
        -25,
        65
      ],
      [
        -24,
        87
      ],
      [
        0,
        22
      ],
      [
        -25,
        43
      ],
      [
        -37,
        141
      ],
      [
        12,
        54
      ],
      [
        87,
        33
      ],
      [
        25,
        54
      ],
      [
        24,
        -11
      ],
      [
        -12,
        -108
      ],
      [
        12,
        -33
      ],
      [
        38,
        -43
      ],
      [
        0,
        -33
      ],
      [
        12,
        -65
      ],
      [
        25,
        -21
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -22
      ],
      [
        25,
        -108
      ]
    ],
    [
      [
        36084,
        26332
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        54
      ],
      [
        12,
        22
      ],
      [
        37,
        22
      ],
      [
        37,
        0
      ],
      [
        25,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -49,
        -32
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        36357,
        27677
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        21
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        44
      ],
      [
        49,
        87
      ],
      [
        25,
        65
      ],
      [
        0,
        86
      ],
      [
        25,
        55
      ],
      [
        37,
        10
      ],
      [
        12,
        -65
      ],
      [
        -12,
        -108
      ],
      [
        25,
        -76
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        36109,
        28176
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        22
      ],
      [
        0,
        32
      ],
      [
        25,
        11
      ],
      [
        12,
        -11
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        36592,
        28219
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        22
      ],
      [
        0,
        33
      ],
      [
        -25,
        43
      ],
      [
        0,
        43
      ],
      [
        25,
        44
      ],
      [
        37,
        -44
      ],
      [
        0,
        -130
      ]
    ],
    [
      [
        36815,
        28241
      ],
      [
        -87,
        -54
      ],
      [
        -37,
        21
      ],
      [
        -24,
        33
      ],
      [
        0,
        32
      ],
      [
        -13,
        55
      ],
      [
        13,
        32
      ],
      [
        37,
        33
      ],
      [
        12,
        32
      ],
      [
        0,
        87
      ],
      [
        25,
        11
      ],
      [
        62,
        -33
      ],
      [
        62,
        -43
      ],
      [
        24,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -24,
        -54
      ],
      [
        -50,
        -87
      ]
    ],
    [
      [
        36555,
        28479
      ],
      [
        -12,
        -21
      ],
      [
        -38,
        -11
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -54
      ],
      [
        25,
        -43
      ],
      [
        25,
        -109
      ],
      [
        12,
        -86
      ],
      [
        25,
        -87
      ],
      [
        0,
        -98
      ],
      [
        -37,
        -11
      ],
      [
        0,
        -32
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        22
      ],
      [
        0,
        76
      ],
      [
        -37,
        32
      ],
      [
        -25,
        54
      ],
      [
        -25,
        98
      ],
      [
        -24,
        22
      ],
      [
        -25,
        76
      ],
      [
        -50,
        65
      ],
      [
        50,
        32
      ],
      [
        0,
        76
      ],
      [
        62,
        43
      ],
      [
        37,
        -21
      ],
      [
        25,
        11
      ],
      [
        12,
        21
      ],
      [
        0,
        120
      ],
      [
        37,
        32
      ],
      [
        25,
        0
      ],
      [
        12,
        -32
      ],
      [
        25,
        -33
      ],
      [
        37,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -44
      ]
    ],
    [
      [
        36530,
        28837
      ],
      [
        0,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -12,
        -33
      ],
      [
        -62,
        22
      ],
      [
        0,
        43
      ],
      [
        99,
        22
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        36233,
        28978
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        33
      ],
      [
        37,
        22
      ],
      [
        25,
        -44
      ]
    ],
    [
      [
        36543,
        29141
      ],
      [
        -25,
        -22
      ],
      [
        -50,
        11
      ],
      [
        -49,
        0
      ],
      [
        -37,
        22
      ],
      [
        -38,
        32
      ],
      [
        -12,
        22
      ],
      [
        0,
        33
      ],
      [
        37,
        65
      ],
      [
        25,
        130
      ],
      [
        12,
        173
      ],
      [
        -12,
        65
      ],
      [
        0,
        33
      ],
      [
        12,
        32
      ],
      [
        0,
        109
      ],
      [
        38,
        65
      ],
      [
        0,
        65
      ],
      [
        12,
        65
      ],
      [
        0,
        33
      ],
      [
        -12,
        11
      ],
      [
        12,
        21
      ],
      [
        99,
        -54
      ],
      [
        74,
        -11
      ],
      [
        0,
        -54
      ],
      [
        25,
        -109
      ],
      [
        13,
        -21
      ],
      [
        -13,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -44
      ],
      [
        13,
        -54
      ],
      [
        -50,
        -21
      ],
      [
        -49,
        -55
      ],
      [
        0,
        -21
      ],
      [
        74,
        -87
      ],
      [
        12,
        -54
      ],
      [
        25,
        -55
      ],
      [
        -37,
        -86
      ],
      [
        -62,
        -55
      ],
      [
        0,
        -75
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        34808,
        35193
      ],
      [
        -62,
        -11
      ],
      [
        13,
        32
      ],
      [
        25,
        22
      ],
      [
        37,
        -22
      ],
      [
        -13,
        -21
      ]
    ],
    [
      [
        24329,
        39260
      ],
      [
        -62,
        -22
      ],
      [
        25,
        65
      ],
      [
        49,
        -22
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        38376,
        23512
      ],
      [
        -198,
        55
      ],
      [
        -37,
        32
      ],
      [
        -38,
        0
      ],
      [
        -74,
        -32
      ],
      [
        -37,
        -98
      ],
      [
        -25,
        -33
      ],
      [
        -49,
        -21
      ],
      [
        -50,
        0
      ],
      [
        -161,
        -98
      ],
      [
        -62,
        -11
      ],
      [
        -74,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        12,
        -43
      ],
      [
        -49,
        -163
      ],
      [
        -13,
        -98
      ],
      [
        0,
        -43
      ],
      [
        13,
        -76
      ],
      [
        -13,
        -130
      ],
      [
        -24,
        -32
      ],
      [
        -75,
        -33
      ],
      [
        -49,
        22
      ],
      [
        -87,
        21
      ],
      [
        -62,
        55
      ],
      [
        -87,
        32
      ],
      [
        -24,
        22
      ],
      [
        -62,
        97
      ],
      [
        -13,
        76
      ],
      [
        38,
        65
      ],
      [
        74,
        0
      ],
      [
        49,
        11
      ],
      [
        25,
        -32
      ],
      [
        13,
        -65
      ],
      [
        -25,
        -65
      ],
      [
        37,
        10
      ],
      [
        12,
        152
      ],
      [
        124,
        76
      ],
      [
        75,
        119
      ],
      [
        12,
        44
      ],
      [
        -25,
        22
      ],
      [
        -62,
        32
      ],
      [
        -173,
        -152
      ],
      [
        -75,
        -32
      ],
      [
        -61,
        -44
      ],
      [
        -62,
        -76
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -55
      ],
      [
        0,
        -54
      ],
      [
        -62,
        22
      ],
      [
        -99,
        87
      ],
      [
        -13,
        32
      ],
      [
        13,
        33
      ],
      [
        37,
        43
      ],
      [
        0,
        109
      ],
      [
        25,
        76
      ],
      [
        49,
        43
      ],
      [
        25,
        -11
      ],
      [
        0,
        -32
      ],
      [
        62,
        0
      ],
      [
        111,
        108
      ],
      [
        50,
        0
      ],
      [
        62,
        -22
      ],
      [
        74,
        11
      ],
      [
        25,
        33
      ],
      [
        -49,
        32
      ],
      [
        -62,
        11
      ],
      [
        -137,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -54
      ],
      [
        -25,
        43
      ],
      [
        -49,
        22
      ],
      [
        -38,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -43
      ],
      [
        -49,
        -44
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -87
      ],
      [
        -37,
        -32
      ],
      [
        -75,
        11
      ],
      [
        -37,
        65
      ],
      [
        -62,
        76
      ],
      [
        136,
        76
      ],
      [
        25,
        76
      ],
      [
        25,
        32
      ],
      [
        -12,
        33
      ],
      [
        -25,
        0
      ],
      [
        0,
        -44
      ],
      [
        -13,
        -43
      ],
      [
        -49,
        22
      ],
      [
        -74,
        -55
      ],
      [
        -38,
        11
      ],
      [
        -74,
        -11
      ],
      [
        -37,
        22
      ],
      [
        0,
        43
      ],
      [
        12,
        44
      ],
      [
        -12,
        65
      ],
      [
        -25,
        22
      ],
      [
        -25,
        -11
      ],
      [
        0,
        43
      ],
      [
        -24,
        76
      ],
      [
        -25,
        43
      ],
      [
        12,
        11
      ],
      [
        50,
        -32
      ],
      [
        37,
        0
      ],
      [
        62,
        -44
      ],
      [
        49,
        22
      ],
      [
        0,
        76
      ],
      [
        13,
        0
      ],
      [
        49,
        -54
      ],
      [
        25,
        11
      ],
      [
        62,
        -11
      ],
      [
        50,
        21
      ],
      [
        62,
        44
      ],
      [
        49,
        65
      ],
      [
        37,
        -22
      ],
      [
        13,
        -76
      ],
      [
        24,
        -21
      ],
      [
        0,
        -66
      ],
      [
        -49,
        -65
      ],
      [
        12,
        -21
      ],
      [
        25,
        11
      ],
      [
        37,
        65
      ],
      [
        0,
        54
      ],
      [
        -37,
        87
      ],
      [
        0,
        54
      ],
      [
        37,
        32
      ],
      [
        13,
        87
      ],
      [
        -100,
        119
      ],
      [
        -123,
        76
      ],
      [
        0,
        -32
      ],
      [
        111,
        -76
      ],
      [
        50,
        -44
      ],
      [
        24,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -123,
        -43
      ],
      [
        -149,
        -130
      ],
      [
        -50,
        22
      ],
      [
        -24,
        43
      ],
      [
        -25,
        65
      ],
      [
        -25,
        43
      ],
      [
        -37,
        0
      ],
      [
        -13,
        22
      ],
      [
        -37,
        -11
      ],
      [
        -74,
        65
      ],
      [
        50,
        55
      ],
      [
        49,
        -22
      ],
      [
        12,
        184
      ],
      [
        -24,
        33
      ],
      [
        -62,
        54
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -86,
        33
      ],
      [
        -37,
        32
      ],
      [
        -38,
        11
      ],
      [
        -86,
        173
      ],
      [
        -13,
        65
      ],
      [
        87,
        0
      ],
      [
        62,
        11
      ],
      [
        12,
        33
      ],
      [
        -24,
        54
      ],
      [
        -25,
        33
      ],
      [
        49,
        76
      ],
      [
        87,
        -87
      ],
      [
        12,
        -44
      ],
      [
        50,
        -130
      ],
      [
        12,
        -21
      ],
      [
        112,
        -87
      ],
      [
        12,
        0
      ],
      [
        0,
        65
      ],
      [
        25,
        87
      ],
      [
        37,
        43
      ],
      [
        -37,
        54
      ],
      [
        -50,
        -152
      ],
      [
        -37,
        -21
      ],
      [
        -62,
        119
      ],
      [
        -12,
        11
      ],
      [
        0,
        76
      ],
      [
        62,
        11
      ],
      [
        -99,
        43
      ],
      [
        -37,
        33
      ],
      [
        -37,
        54
      ],
      [
        -38,
        43
      ],
      [
        75,
        87
      ],
      [
        24,
        54
      ],
      [
        112,
        -32
      ],
      [
        25,
        21
      ],
      [
        -25,
        33
      ],
      [
        -12,
        -11
      ],
      [
        -38,
        33
      ],
      [
        -49,
        75
      ],
      [
        0,
        33
      ],
      [
        12,
        76
      ],
      [
        13,
        22
      ],
      [
        49,
        10
      ],
      [
        50,
        -21
      ],
      [
        24,
        -22
      ],
      [
        13,
        11
      ],
      [
        -13,
        54
      ],
      [
        -37,
        22
      ],
      [
        -37,
        32
      ],
      [
        0,
        44
      ],
      [
        25,
        76
      ],
      [
        -12,
        32
      ],
      [
        -25,
        -32
      ],
      [
        -13,
        -44
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        22
      ],
      [
        -25,
        43
      ],
      [
        12,
        33
      ],
      [
        -12,
        184
      ],
      [
        0,
        163
      ],
      [
        12,
        119
      ],
      [
        38,
        54
      ],
      [
        24,
        11
      ],
      [
        38,
        0
      ],
      [
        12,
        11
      ],
      [
        -50,
        32
      ],
      [
        -62,
        -43
      ],
      [
        -49,
        22
      ],
      [
        0,
        65
      ],
      [
        -25,
        54
      ],
      [
        -12,
        65
      ],
      [
        0,
        109
      ],
      [
        74,
        -11
      ],
      [
        50,
        -22
      ],
      [
        136,
        0
      ],
      [
        111,
        -98
      ],
      [
        50,
        11
      ],
      [
        0,
        22
      ],
      [
        -37,
        22
      ],
      [
        -25,
        54
      ],
      [
        -25,
        22
      ],
      [
        0,
        65
      ],
      [
        -25,
        141
      ],
      [
        -12,
        0
      ],
      [
        -37,
        -131
      ],
      [
        -37,
        -32
      ],
      [
        -50,
        -22
      ],
      [
        -49,
        -11
      ],
      [
        -38,
        22
      ],
      [
        -12,
        33
      ],
      [
        0,
        32
      ],
      [
        -12,
        22
      ],
      [
        -50,
        21
      ],
      [
        -37,
        44
      ],
      [
        25,
        54
      ],
      [
        25,
        22
      ],
      [
        24,
        0
      ],
      [
        50,
        -54
      ],
      [
        25,
        -11
      ],
      [
        37,
        54
      ],
      [
        -25,
        11
      ],
      [
        -99,
        87
      ],
      [
        25,
        65
      ],
      [
        74,
        76
      ],
      [
        12,
        21
      ],
      [
        -12,
        54
      ],
      [
        12,
        76
      ],
      [
        -12,
        55
      ],
      [
        -37,
        54
      ],
      [
        -50,
        22
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -44
      ],
      [
        -12,
        -10
      ],
      [
        -74,
        10
      ],
      [
        -38,
        44
      ],
      [
        -62,
        32
      ],
      [
        -24,
        76
      ],
      [
        24,
        65
      ],
      [
        -12,
        0
      ],
      [
        -37,
        -54
      ],
      [
        -62,
        -32
      ],
      [
        -50,
        0
      ],
      [
        -37,
        -44
      ],
      [
        37,
        -11
      ],
      [
        25,
        -76
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -49,
        43
      ],
      [
        -25,
        55
      ],
      [
        0,
        43
      ],
      [
        25,
        65
      ],
      [
        74,
        76
      ],
      [
        12,
        33
      ],
      [
        50,
        32
      ],
      [
        62,
        87
      ],
      [
        49,
        54
      ],
      [
        -25,
        33
      ],
      [
        -24,
        65
      ],
      [
        0,
        76
      ],
      [
        99,
        32
      ],
      [
        49,
        -11
      ],
      [
        62,
        0
      ],
      [
        25,
        22
      ],
      [
        25,
        0
      ],
      [
        49,
        22
      ],
      [
        25,
        32
      ],
      [
        0,
        76
      ],
      [
        -12,
        65
      ],
      [
        37,
        44
      ],
      [
        37,
        10
      ],
      [
        37,
        -21
      ],
      [
        -25,
        -76
      ],
      [
        -24,
        -174
      ],
      [
        -13,
        -32
      ],
      [
        -24,
        -33
      ],
      [
        12,
        -65
      ],
      [
        -25,
        -54
      ],
      [
        -87,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        62,
        0
      ],
      [
        37,
        11
      ],
      [
        50,
        43
      ],
      [
        12,
        65
      ],
      [
        12,
        130
      ],
      [
        50,
        22
      ],
      [
        12,
        -33
      ],
      [
        0,
        -130
      ],
      [
        -37,
        -195
      ],
      [
        -49,
        -76
      ],
      [
        0,
        -43
      ],
      [
        37,
        0
      ],
      [
        49,
        97
      ],
      [
        13,
        76
      ],
      [
        0,
        87
      ],
      [
        12,
        109
      ],
      [
        13,
        54
      ],
      [
        0,
        76
      ],
      [
        -62,
        43
      ],
      [
        0,
        43
      ],
      [
        12,
        98
      ],
      [
        62,
        0
      ],
      [
        62,
        54
      ],
      [
        37,
        22
      ],
      [
        25,
        0
      ],
      [
        74,
        -65
      ],
      [
        13,
        22
      ],
      [
        -13,
        21
      ],
      [
        -87,
        87
      ],
      [
        -74,
        11
      ],
      [
        25,
        163
      ],
      [
        99,
        32
      ],
      [
        124,
        119
      ],
      [
        25,
        185
      ],
      [
        -62,
        21
      ],
      [
        -62,
        66
      ],
      [
        -87,
        75
      ],
      [
        12,
        66
      ],
      [
        0,
        108
      ],
      [
        62,
        22
      ],
      [
        25,
        141
      ],
      [
        -37,
        108
      ],
      [
        0,
        87
      ],
      [
        50,
        65
      ],
      [
        24,
        108
      ],
      [
        37,
        0
      ],
      [
        0,
        87
      ],
      [
        -24,
        65
      ],
      [
        0,
        87
      ],
      [
        24,
        98
      ],
      [
        38,
        -11
      ],
      [
        12,
        11
      ],
      [
        -37,
        65
      ],
      [
        -25,
        65
      ],
      [
        12,
        21
      ],
      [
        50,
        44
      ],
      [
        25,
        -44
      ],
      [
        37,
        -108
      ],
      [
        12,
        32
      ],
      [
        -24,
        109
      ],
      [
        -13,
        141
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -37,
        54
      ],
      [
        12,
        44
      ],
      [
        50,
        65
      ],
      [
        62,
        11
      ],
      [
        37,
        43
      ],
      [
        12,
        98
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        -76
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        22
      ],
      [
        -50,
        65
      ],
      [
        -25,
        22
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -50,
        -119
      ],
      [
        -25,
        -22
      ],
      [
        -99,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -37,
        22
      ],
      [
        0,
        32
      ],
      [
        12,
        33
      ],
      [
        25,
        32
      ],
      [
        -25,
        11
      ],
      [
        -37,
        33
      ],
      [
        -12,
        43
      ],
      [
        -37,
        206
      ],
      [
        -13,
        87
      ],
      [
        25,
        65
      ],
      [
        50,
        249
      ],
      [
        12,
        131
      ],
      [
        25,
        119
      ],
      [
        0,
        65
      ],
      [
        62,
        76
      ],
      [
        25,
        43
      ],
      [
        49,
        228
      ],
      [
        12,
        119
      ],
      [
        -86,
        380
      ],
      [
        -13,
        65
      ],
      [
        0,
        87
      ],
      [
        13,
        152
      ],
      [
        12,
        54
      ],
      [
        -25,
        87
      ],
      [
        -49,
        130
      ],
      [
        0,
        65
      ],
      [
        25,
        76
      ],
      [
        -25,
        86
      ],
      [
        25,
        87
      ],
      [
        74,
        -21
      ],
      [
        37,
        10
      ],
      [
        37,
        98
      ],
      [
        0,
        108
      ],
      [
        13,
        55
      ],
      [
        0,
        65
      ],
      [
        37,
        32
      ],
      [
        12,
        65
      ],
      [
        37,
        87
      ],
      [
        37,
        260
      ],
      [
        25,
        65
      ],
      [
        37,
        76
      ],
      [
        -12,
        109
      ],
      [
        25,
        43
      ],
      [
        37,
        109
      ],
      [
        12,
        65
      ],
      [
        62,
        86
      ],
      [
        13,
        109
      ],
      [
        49,
        184
      ],
      [
        0,
        130
      ],
      [
        13,
        76
      ],
      [
        0,
        76
      ],
      [
        24,
        98
      ],
      [
        38,
        119
      ],
      [
        62,
        109
      ],
      [
        0,
        86
      ],
      [
        -13,
        55
      ],
      [
        0,
        86
      ],
      [
        -25,
        120
      ],
      [
        62,
        76
      ],
      [
        37,
        195
      ],
      [
        0,
        76
      ],
      [
        13,
        97
      ],
      [
        -25,
        109
      ],
      [
        -12,
        249
      ],
      [
        -13,
        195
      ],
      [
        -24,
        206
      ],
      [
        0,
        120
      ],
      [
        -25,
        141
      ],
      [
        0,
        76
      ],
      [
        12,
        184
      ],
      [
        99,
        119
      ],
      [
        13,
        130
      ],
      [
        12,
        185
      ],
      [
        0,
        119
      ],
      [
        -12,
        65
      ],
      [
        -50,
        98
      ],
      [
        0,
        206
      ],
      [
        37,
        54
      ],
      [
        25,
        65
      ],
      [
        50,
        185
      ],
      [
        12,
        195
      ],
      [
        25,
        152
      ],
      [
        12,
        54
      ],
      [
        25,
        76
      ],
      [
        12,
        11
      ],
      [
        0,
        173
      ],
      [
        37,
        228
      ],
      [
        0,
        65
      ],
      [
        38,
        152
      ],
      [
        12,
        108
      ],
      [
        12,
        65
      ],
      [
        -12,
        65
      ],
      [
        12,
        141
      ],
      [
        -24,
        87
      ],
      [
        0,
        43
      ],
      [
        24,
        152
      ],
      [
        25,
        33
      ],
      [
        25,
        76
      ],
      [
        12,
        76
      ],
      [
        0,
        43
      ],
      [
        -37,
        250
      ],
      [
        0,
        86
      ],
      [
        13,
        195
      ],
      [
        12,
        120
      ],
      [
        -12,
        108
      ],
      [
        12,
        54
      ],
      [
        0,
        66
      ],
      [
        25,
        75
      ],
      [
        12,
        55
      ],
      [
        -37,
        54
      ],
      [
        -37,
        65
      ],
      [
        0,
        76
      ],
      [
        12,
        54
      ],
      [
        0,
        65
      ],
      [
        37,
        22
      ],
      [
        25,
        32
      ],
      [
        25,
        76
      ],
      [
        25,
        185
      ],
      [
        0,
        227
      ],
      [
        24,
        141
      ],
      [
        0,
        66
      ],
      [
        13,
        140
      ],
      [
        25,
        174
      ],
      [
        -13,
        65
      ],
      [
        -37,
        336
      ],
      [
        0,
        120
      ],
      [
        25,
        184
      ],
      [
        0,
        271
      ],
      [
        -25,
        119
      ],
      [
        0,
        76
      ],
      [
        -25,
        141
      ],
      [
        -25,
        271
      ],
      [
        0,
        272
      ],
      [
        -24,
        32
      ]
    ],
    [
      [
        37695,
        44758
      ],
      [
        49,
        11
      ],
      [
        37,
        0
      ],
      [
        38,
        22
      ],
      [
        49,
        54
      ],
      [
        25,
        65
      ],
      [
        12,
        65
      ],
      [
        0,
        54
      ],
      [
        -12,
        76
      ],
      [
        0,
        54
      ],
      [
        12,
        22
      ],
      [
        50,
        11
      ],
      [
        49,
        87
      ]
    ],
    [
      [
        100077,
        68704
      ],
      [
        25,
        -65
      ],
      [
        12,
        -76
      ],
      [
        0,
        -76
      ],
      [
        -24,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -62,
        -173
      ],
      [
        -13,
        -44
      ],
      [
        -12,
        -21
      ],
      [
        0,
        -55
      ],
      [
        -13,
        -76
      ],
      [
        -12,
        -97
      ],
      [
        -12,
        -44
      ],
      [
        -38,
        -43
      ],
      [
        -24,
        0
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        -54
      ],
      [
        -38,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -49,
        -11
      ],
      [
        -37,
        -86
      ],
      [
        -38,
        -22
      ],
      [
        -24,
        0
      ],
      [
        -38,
        33
      ],
      [
        -74,
        32
      ],
      [
        -62,
        22
      ],
      [
        -37,
        32
      ],
      [
        -74,
        76
      ],
      [
        -13,
        130
      ],
      [
        -12,
        76
      ],
      [
        0,
        22
      ],
      [
        12,
        228
      ],
      [
        0,
        21
      ],
      [
        50,
        76
      ],
      [
        37,
        33
      ],
      [
        50,
        87
      ],
      [
        37,
        32
      ],
      [
        24,
        54
      ],
      [
        -24,
        11
      ],
      [
        24,
        44
      ],
      [
        13,
        32
      ],
      [
        12,
        11
      ],
      [
        37,
        -11
      ],
      [
        38,
        11
      ],
      [
        24,
        43
      ],
      [
        112,
        -10
      ],
      [
        62,
        21
      ],
      [
        25,
        33
      ],
      [
        61,
        -11
      ],
      [
        13,
        22
      ],
      [
        74,
        -55
      ],
      [
        0,
        76
      ],
      [
        25,
        22
      ],
      [
        25,
        -43
      ],
      [
        25,
        -33
      ],
      [
        24,
        -11
      ]
    ],
    [
      [
        99904,
        69387
      ],
      [
        12,
        -21
      ],
      [
        37,
        21
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        21
      ],
      [
        -49,
        0
      ],
      [
        12,
        44
      ],
      [
        25,
        10
      ]
    ],
    [
      [
        100684,
        69735
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        11
      ],
      [
        12,
        32
      ],
      [
        37,
        22
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        100734,
        69713
      ],
      [
        -13,
        -22
      ],
      [
        -12,
        22
      ],
      [
        0,
        54
      ],
      [
        25,
        43
      ],
      [
        0,
        -97
      ]
    ],
    [
      [
        100994,
        70461
      ],
      [
        -37,
        11
      ],
      [
        -13,
        22
      ],
      [
        13,
        32
      ],
      [
        25,
        -32
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        102592,
        71513
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        0
      ],
      [
        0,
        65
      ],
      [
        25,
        -11
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        103149,
        72120
      ],
      [
        -24,
        -32
      ],
      [
        -13,
        11
      ],
      [
        0,
        130
      ],
      [
        25,
        11
      ],
      [
        0,
        -22
      ],
      [
        25,
        -22
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        103645,
        73758
      ],
      [
        -50,
        -11
      ],
      [
        0,
        44
      ],
      [
        25,
        43
      ],
      [
        25,
        -43
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        103955,
        74756
      ],
      [
        -38,
        32
      ],
      [
        0,
        22
      ],
      [
        25,
        11
      ],
      [
        13,
        -65
      ]
    ],
    [
      [
        104041,
        74886
      ],
      [
        -12,
        -22
      ],
      [
        -13,
        65
      ],
      [
        25,
        -10
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        104004,
        74929
      ],
      [
        -12,
        -10
      ],
      [
        -37,
        32
      ],
      [
        -50,
        11
      ],
      [
        -12,
        32
      ],
      [
        0,
        44
      ],
      [
        49,
        0
      ],
      [
        74,
        -65
      ],
      [
        -12,
        -44
      ]
    ],
    [
      [
        103855,
        75884
      ],
      [
        -37,
        -11
      ],
      [
        -86,
        54
      ],
      [
        -62,
        54
      ],
      [
        -38,
        76
      ],
      [
        0,
        22
      ],
      [
        38,
        0
      ],
      [
        49,
        -33
      ],
      [
        0,
        -32
      ],
      [
        25,
        -11
      ],
      [
        12,
        -22
      ],
      [
        75,
        -54
      ],
      [
        24,
        -43
      ]
    ],
    [
      [
        106828,
        82781
      ],
      [
        0,
        22
      ],
      [
        -24,
        11
      ],
      [
        -50,
        65
      ],
      [
        -12,
        32
      ],
      [
        0,
        87
      ],
      [
        -37,
        22
      ],
      [
        -25,
        43
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -76
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -76
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -13,
        -32
      ],
      [
        -37,
        10
      ],
      [
        -12,
        22
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -54
      ],
      [
        -13,
        -54
      ],
      [
        -24,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        -65
      ],
      [
        -62,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -74,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -99,
        -22
      ],
      [
        0,
        -54
      ],
      [
        24,
        -44
      ],
      [
        25,
        -86
      ],
      [
        25,
        -22
      ],
      [
        12,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -24,
        -76
      ],
      [
        -25,
        -32
      ],
      [
        -13,
        0
      ],
      [
        -24,
        43
      ],
      [
        -37,
        0
      ],
      [
        -75,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -13,
        22
      ],
      [
        -37,
        0
      ],
      [
        -49,
        21
      ],
      [
        -38,
        0
      ],
      [
        -12,
        22
      ],
      [
        0,
        32
      ],
      [
        -25,
        44
      ],
      [
        -12,
        43
      ],
      [
        -37,
        22
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -50,
        -44
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -120
      ],
      [
        -12,
        -32
      ],
      [
        -12,
        0
      ],
      [
        -62,
        -130
      ],
      [
        -62,
        -76
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -43
      ],
      [
        -38,
        0
      ],
      [
        -24,
        -22
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        -54
      ],
      [
        -24,
        -11
      ],
      [
        -87,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -62,
        -87
      ],
      [
        -87,
        -87
      ],
      [
        -24,
        -54
      ],
      [
        -13,
        -65
      ]
    ],
    [
      [
        104710,
        81198
      ],
      [
        -25,
        -43
      ],
      [
        -62,
        -55
      ],
      [
        -123,
        -11
      ],
      [
        -38,
        33
      ],
      [
        -24,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -24,
        -22
      ],
      [
        -13,
        -32
      ],
      [
        -74,
        -11
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -174,
        -141
      ],
      [
        -37,
        -65
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        -32
      ],
      [
        -49,
        -33
      ],
      [
        -13,
        -32
      ],
      [
        -61,
        11
      ],
      [
        -25,
        -33
      ],
      [
        12,
        -54
      ],
      [
        -49,
        -22
      ],
      [
        -62,
        -11
      ],
      [
        -62,
        -54
      ],
      [
        -13,
        54
      ],
      [
        0,
        65
      ],
      [
        25,
        22
      ],
      [
        25,
        0
      ],
      [
        149,
        98
      ],
      [
        -25,
        65
      ],
      [
        12,
        32
      ],
      [
        37,
        55
      ],
      [
        13,
        32
      ],
      [
        -99,
        -22
      ],
      [
        -50,
        0
      ],
      [
        -37,
        11
      ],
      [
        12,
        44
      ],
      [
        0,
        43
      ],
      [
        -12,
        11
      ],
      [
        74,
        65
      ],
      [
        13,
        22
      ],
      [
        -13,
        43
      ],
      [
        13,
        54
      ],
      [
        99,
        65
      ],
      [
        24,
        65
      ],
      [
        38,
        55
      ],
      [
        74,
        141
      ],
      [
        0,
        21
      ],
      [
        25,
        65
      ],
      [
        0,
        22
      ],
      [
        -50,
        98
      ],
      [
        -87,
        97
      ],
      [
        -12,
        76
      ],
      [
        -12,
        0
      ],
      [
        -13,
        -54
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        0
      ],
      [
        -12,
        22
      ],
      [
        -124,
        11
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -99,
        -217
      ],
      [
        -37,
        -22
      ],
      [
        -173,
        -130
      ],
      [
        -87,
        -54
      ],
      [
        -74,
        -98
      ],
      [
        -50,
        -119
      ],
      [
        -12,
        -98
      ],
      [
        -75,
        -141
      ],
      [
        -24,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -50,
        -43
      ],
      [
        -62,
        -33
      ],
      [
        -49,
        87
      ],
      [
        -38,
        22
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        -43
      ],
      [
        -49,
        -174
      ],
      [
        -25,
        -97
      ],
      [
        0,
        -44
      ],
      [
        37,
        -130
      ],
      [
        37,
        -65
      ],
      [
        87,
        -76
      ],
      [
        186,
        -54
      ],
      [
        37,
        11
      ],
      [
        50,
        0
      ],
      [
        49,
        -55
      ],
      [
        25,
        -76
      ],
      [
        0,
        -86
      ],
      [
        25,
        -44
      ],
      [
        -38,
        -43
      ],
      [
        -12,
        -87
      ],
      [
        0,
        -97
      ],
      [
        12,
        -44
      ],
      [
        38,
        -43
      ],
      [
        62,
        -44
      ],
      [
        61,
        0
      ],
      [
        100,
        11
      ],
      [
        49,
        65
      ],
      [
        0,
        65
      ],
      [
        87,
        87
      ],
      [
        62,
        76
      ],
      [
        -25,
        43
      ],
      [
        37,
        11
      ],
      [
        136,
        76
      ],
      [
        100,
        -65
      ],
      [
        61,
        -76
      ],
      [
        62,
        -11
      ],
      [
        38,
        -43
      ],
      [
        49,
        -33
      ],
      [
        50,
        0
      ],
      [
        62,
        -10
      ],
      [
        24,
        54
      ],
      [
        25,
        0
      ],
      [
        13,
        -44
      ],
      [
        61,
        -32
      ],
      [
        50,
        0
      ],
      [
        37,
        11
      ],
      [
        25,
        -11
      ],
      [
        -37,
        -54
      ],
      [
        12,
        -87
      ],
      [
        -49,
        -76
      ],
      [
        24,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -24,
        -11
      ],
      [
        -38,
        -54
      ],
      [
        -24,
        0
      ],
      [
        -37,
        76
      ],
      [
        -38,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -186,
        -141
      ],
      [
        -86,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -11
      ],
      [
        37,
        -43
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        21
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -98
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        -10
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        33
      ],
      [
        12,
        54
      ],
      [
        -12,
        21
      ],
      [
        -50,
        -21
      ],
      [
        -25,
        -44
      ],
      [
        25,
        -65
      ],
      [
        37,
        -21
      ],
      [
        -24,
        -33
      ],
      [
        -50,
        -43
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        -38,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -120
      ],
      [
        -49,
        -65
      ],
      [
        -13,
        -97
      ],
      [
        13,
        -65
      ],
      [
        49,
        0
      ],
      [
        25,
        -22
      ],
      [
        50,
        -87
      ],
      [
        74,
        -54
      ],
      [
        62,
        -33
      ],
      [
        87,
        -75
      ],
      [
        37,
        -98
      ],
      [
        37,
        -184
      ],
      [
        25,
        -98
      ],
      [
        0,
        -43
      ],
      [
        37,
        -98
      ],
      [
        37,
        -152
      ],
      [
        50,
        -141
      ],
      [
        12,
        -108
      ],
      [
        -12,
        -55
      ],
      [
        0,
        -54
      ],
      [
        37,
        -65
      ],
      [
        111,
        -65
      ],
      [
        37,
        -54
      ],
      [
        0,
        -109
      ],
      [
        25,
        -54
      ],
      [
        75,
        -43
      ],
      [
        24,
        -33
      ],
      [
        25,
        -54
      ],
      [
        12,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -37,
        0
      ],
      [
        -24,
        11
      ],
      [
        -112,
        87
      ],
      [
        -37,
        10
      ],
      [
        -37,
        -21
      ],
      [
        -62,
        21
      ],
      [
        -62,
        98
      ],
      [
        -50,
        32
      ],
      [
        -49,
        22
      ],
      [
        -112,
        -97
      ],
      [
        -25,
        10
      ],
      [
        -24,
        -21
      ],
      [
        49,
        -22
      ],
      [
        62,
        33
      ],
      [
        50,
        43
      ],
      [
        74,
        -22
      ],
      [
        25,
        -108
      ],
      [
        49,
        -44
      ],
      [
        38,
        -21
      ],
      [
        49,
        -54
      ],
      [
        62,
        -87
      ],
      [
        99,
        -109
      ],
      [
        50,
        -97
      ],
      [
        24,
        -152
      ],
      [
        -37,
        -33
      ],
      [
        -86,
        -11
      ],
      [
        -38,
        -32
      ],
      [
        -37,
        -54
      ],
      [
        -99,
        -98
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -74,
        22
      ],
      [
        -62,
        0
      ],
      [
        -62,
        -66
      ],
      [
        0,
        -21
      ],
      [
        37,
        -11
      ],
      [
        50,
        43
      ],
      [
        49,
        -108
      ],
      [
        87,
        22
      ],
      [
        87,
        86
      ],
      [
        37,
        0
      ],
      [
        25,
        -11
      ],
      [
        37,
        -43
      ],
      [
        87,
        -152
      ],
      [
        86,
        -54
      ],
      [
        50,
        -11
      ],
      [
        -62,
        -54
      ],
      [
        -74,
        -130
      ],
      [
        -38,
        -22
      ],
      [
        38,
        -22
      ],
      [
        49,
        55
      ],
      [
        12,
        21
      ],
      [
        25,
        -11
      ],
      [
        13,
        -75
      ],
      [
        -25,
        -228
      ],
      [
        -25,
        0
      ],
      [
        -12,
        65
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        25,
        -11
      ],
      [
        49,
        -65
      ],
      [
        13,
        -33
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -54
      ],
      [
        -13,
        -22
      ],
      [
        -24,
        -10
      ],
      [
        -13,
        -44
      ],
      [
        25,
        -76
      ],
      [
        12,
        -97
      ],
      [
        13,
        -44
      ],
      [
        -37,
        22
      ],
      [
        -50,
        -65
      ],
      [
        -37,
        0
      ],
      [
        -13,
        76
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        -22
      ],
      [
        -49,
        -162
      ],
      [
        -25,
        -22
      ],
      [
        -50,
        11
      ],
      [
        0,
        -22
      ],
      [
        25,
        -33
      ],
      [
        0,
        -21
      ],
      [
        -49,
        -98
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -24,
        -32
      ],
      [
        12,
        -65
      ],
      [
        0,
        -44
      ],
      [
        -50,
        -97
      ],
      [
        -24,
        -66
      ],
      [
        -38,
        -32
      ],
      [
        -49,
        -130
      ],
      [
        -25,
        -130
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        11
      ],
      [
        0,
        44
      ],
      [
        -25,
        32
      ],
      [
        0,
        76
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -11
      ],
      [
        12,
        -32
      ],
      [
        0,
        -33
      ],
      [
        25,
        -11
      ],
      [
        25,
        -43
      ],
      [
        12,
        -54
      ],
      [
        25,
        -55
      ],
      [
        0,
        -21
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -65
      ],
      [
        -38,
        -44
      ],
      [
        -49,
        0
      ],
      [
        -25,
        33
      ],
      [
        -37,
        11
      ],
      [
        50,
        -98
      ],
      [
        12,
        -11
      ],
      [
        37,
        0
      ],
      [
        25,
        33
      ],
      [
        37,
        0
      ],
      [
        12,
        -55
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -152
      ],
      [
        25,
        -97
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        33
      ],
      [
        -25,
        32
      ],
      [
        -25,
        -10
      ],
      [
        -24,
        10
      ],
      [
        -38,
        -10
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -33
      ],
      [
        25,
        -32
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -21
      ],
      [
        -74,
        11
      ],
      [
        -37,
        -55
      ],
      [
        12,
        -75
      ],
      [
        -12,
        -55
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        -32
      ],
      [
        -24,
        -11
      ],
      [
        0,
        -22
      ],
      [
        24,
        -10
      ],
      [
        -12,
        -109
      ],
      [
        -37,
        -22
      ],
      [
        -50,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        33
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -55
      ],
      [
        -62,
        0
      ],
      [
        12,
        -54
      ],
      [
        50,
        0
      ],
      [
        12,
        -32
      ],
      [
        0,
        -55
      ],
      [
        -49,
        -86
      ],
      [
        -25,
        -66
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        -65
      ],
      [
        -13,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -22
      ],
      [
        -37,
        -87
      ],
      [
        -12,
        33
      ],
      [
        0,
        43
      ],
      [
        -13,
        0
      ],
      [
        -25,
        -43
      ],
      [
        -49,
        -44
      ],
      [
        -12,
        33
      ],
      [
        -50,
        11
      ],
      [
        -12,
        -120
      ],
      [
        -62,
        -75
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -33
      ],
      [
        -24,
        0
      ],
      [
        -13,
        -32
      ],
      [
        -12,
        -109
      ],
      [
        -13,
        -32
      ],
      [
        -49,
        0
      ],
      [
        -25,
        22
      ],
      [
        -12,
        -44
      ],
      [
        -50,
        -21
      ],
      [
        -74,
        -44
      ],
      [
        -37,
        11
      ],
      [
        -38,
        22
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        0
      ],
      [
        -37,
        32
      ],
      [
        -25,
        33
      ],
      [
        -37,
        -33
      ],
      [
        -38,
        -43
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        11
      ],
      [
        -13,
        65
      ],
      [
        -24,
        11
      ],
      [
        -38,
        -87
      ],
      [
        13,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -25,
        32
      ],
      [
        -25,
        11
      ],
      [
        -24,
        -33
      ]
    ],
    [
      [
        101242,
        70298
      ],
      [
        -25,
        11
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        101155,
        70277
      ],
      [
        -37,
        11
      ],
      [
        -25,
        43
      ],
      [
        -25,
        87
      ],
      [
        -37,
        43
      ],
      [
        -12,
        33
      ],
      [
        -13,
        65
      ],
      [
        0,
        65
      ],
      [
        13,
        32
      ],
      [
        -37,
        -10
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -32
      ],
      [
        37,
        -44
      ],
      [
        0,
        -43
      ],
      [
        37,
        -76
      ],
      [
        0,
        -119
      ],
      [
        12,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -55
      ]
    ],
    [
      [
        100994,
        70092
      ],
      [
        -12,
        22
      ],
      [
        -13,
        -32
      ]
    ],
    [
      [
        100969,
        70082
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        76
      ],
      [
        -25,
        -55
      ],
      [
        -12,
        -108
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        33
      ],
      [
        -25,
        -22
      ],
      [
        -49,
        -76
      ],
      [
        -25,
        22
      ],
      [
        -25,
        43
      ],
      [
        0,
        44
      ],
      [
        -25,
        11
      ],
      [
        0,
        -33
      ],
      [
        13,
        -76
      ],
      [
        -13,
        -22
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        10
      ],
      [
        -25,
        22
      ],
      [
        -61,
        33
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -74,
        -11
      ],
      [
        -25,
        -32
      ],
      [
        -74,
        0
      ],
      [
        -38,
        11
      ],
      [
        0,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        -37,
        -11
      ],
      [
        -49,
        -65
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        11
      ],
      [
        -13,
        65
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -43
      ],
      [
        -62,
        -87
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -54
      ],
      [
        61,
        -11
      ],
      [
        13,
        -55
      ],
      [
        -25,
        -21
      ],
      [
        0,
        -33
      ],
      [
        62,
        -97
      ],
      [
        12,
        -33
      ],
      [
        -24,
        -65
      ],
      [
        -38,
        -43
      ],
      [
        -74,
        -22
      ],
      [
        -62,
        22
      ],
      [
        -25,
        43
      ],
      [
        13,
        22
      ],
      [
        25,
        0
      ],
      [
        -13,
        54
      ],
      [
        -37,
        22
      ],
      [
        -25,
        65
      ],
      [
        13,
        54
      ],
      [
        -25,
        87
      ],
      [
        -25,
        21
      ],
      [
        13,
        109
      ],
      [
        -13,
        43
      ],
      [
        37,
        65
      ],
      [
        0,
        65
      ],
      [
        50,
        33
      ],
      [
        0,
        65
      ],
      [
        -25,
        0
      ],
      [
        -25,
        43
      ],
      [
        -24,
        -21
      ],
      [
        -38,
        97
      ],
      [
        -24,
        11
      ],
      [
        12,
        -98
      ],
      [
        -37,
        -43
      ],
      [
        -99,
        -32
      ],
      [
        -25,
        10
      ],
      [
        0,
        33
      ],
      [
        12,
        32
      ],
      [
        -12,
        33
      ],
      [
        -25,
        22
      ],
      [
        -87,
        0
      ],
      [
        -12,
        11
      ],
      [
        -49,
        108
      ],
      [
        12,
        33
      ],
      [
        -12,
        21
      ],
      [
        -38,
        0
      ],
      [
        0,
        -108
      ],
      [
        13,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        54
      ],
      [
        -25,
        -87
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        -11
      ]
    ],
    [
      [
        99074,
        69648
      ],
      [
        -62,
        87
      ],
      [
        -12,
        10
      ],
      [
        -38,
        -32
      ],
      [
        -61,
        -11
      ],
      [
        -13,
        33
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        65
      ],
      [
        -25,
        0
      ],
      [
        -37,
        54
      ],
      [
        -25,
        22
      ],
      [
        0,
        32
      ],
      [
        -49,
        44
      ],
      [
        -50,
        21
      ],
      [
        -12,
        -10
      ],
      [
        -12,
        32
      ],
      [
        0,
        163
      ],
      [
        -25,
        32
      ],
      [
        -13,
        33
      ],
      [
        0,
        65
      ],
      [
        13,
        43
      ],
      [
        25,
        11
      ],
      [
        24,
        33
      ],
      [
        25,
        86
      ],
      [
        -87,
        87
      ],
      [
        -61,
        -32
      ],
      [
        -38,
        11
      ],
      [
        -24,
        43
      ],
      [
        -38,
        22
      ],
      [
        -24,
        0
      ],
      [
        -13,
        -33
      ],
      [
        -37,
        0
      ],
      [
        -25,
        22
      ],
      [
        -24,
        43
      ],
      [
        -50,
        22
      ],
      [
        -37,
        108
      ],
      [
        -62,
        65
      ],
      [
        -25,
        -43
      ],
      [
        -74,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        -55
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        -65
      ],
      [
        -25,
        0
      ],
      [
        -24,
        43
      ],
      [
        0,
        22
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -109
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -10
      ],
      [
        -87,
        151
      ],
      [
        -12,
        11
      ],
      [
        -37,
        -108
      ],
      [
        -12,
        -11
      ],
      [
        -38,
        98
      ],
      [
        -24,
        0
      ],
      [
        -50,
        -98
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        55
      ],
      [
        -12,
        32
      ],
      [
        -38,
        44
      ],
      [
        -37,
        32
      ],
      [
        -49,
        33
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -98
      ],
      [
        -13,
        -54
      ],
      [
        -37,
        -54
      ]
    ],
    [
      [
        97067,
        70190
      ],
      [
        -37,
        43
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        65
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -87
      ],
      [
        -24,
        -65
      ],
      [
        12,
        -32
      ],
      [
        0,
        -65
      ],
      [
        12,
        -44
      ],
      [
        38,
        -65
      ],
      [
        12,
        -43
      ],
      [
        0,
        -174
      ],
      [
        -12,
        -86
      ],
      [
        0,
        -55
      ],
      [
        37,
        -54
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        11
      ],
      [
        -37,
        32
      ],
      [
        -25,
        0
      ],
      [
        -62,
        -32
      ],
      [
        -12,
        11
      ],
      [
        -13,
        54
      ],
      [
        0,
        65
      ],
      [
        -12,
        11
      ],
      [
        12,
        76
      ],
      [
        -25,
        32
      ]
    ],
    [
      [
        96720,
        69691
      ],
      [
        0,
        109
      ],
      [
        -24,
        0
      ],
      [
        -75,
        -55
      ],
      [
        -62,
        -97
      ],
      [
        -49,
        -33
      ],
      [
        -25,
        22
      ],
      [
        -37,
        11
      ],
      [
        -50,
        -22
      ],
      [
        -25,
        22
      ],
      [
        -12,
        32
      ],
      [
        0,
        65
      ],
      [
        -37,
        22
      ],
      [
        -25,
        76
      ],
      [
        13,
        54
      ],
      [
        0,
        54
      ],
      [
        -13,
        22
      ],
      [
        -111,
        44
      ],
      [
        -62,
        10
      ],
      [
        -37,
        -10
      ],
      [
        -38,
        21
      ],
      [
        0,
        98
      ],
      [
        13,
        54
      ],
      [
        37,
        76
      ],
      [
        0,
        119
      ],
      [
        12,
        87
      ],
      [
        50,
        87
      ],
      [
        -12,
        54
      ],
      [
        -50,
        33
      ],
      [
        -37,
        0
      ],
      [
        -62,
        21
      ],
      [
        -62,
        33
      ],
      [
        12,
        76
      ],
      [
        -12,
        43
      ],
      [
        0,
        33
      ],
      [
        -25,
        54
      ],
      [
        13,
        65
      ],
      [
        -13,
        76
      ],
      [
        -25,
        21
      ],
      [
        -12,
        44
      ],
      [
        0,
        76
      ],
      [
        50,
        76
      ],
      [
        0,
        21
      ],
      [
        -87,
        -32
      ],
      [
        0,
        11
      ],
      [
        -74,
        21
      ],
      [
        -50,
        -10
      ],
      [
        -74,
        -33
      ],
      [
        -62,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        21
      ],
      [
        0,
        44
      ],
      [
        37,
        86
      ],
      [
        13,
        65
      ],
      [
        -13,
        55
      ],
      [
        0,
        43
      ],
      [
        -37,
        33
      ],
      [
        -12,
        32
      ],
      [
        0,
        87
      ],
      [
        12,
        87
      ],
      [
        50,
        43
      ],
      [
        12,
        22
      ],
      [
        -12,
        65
      ],
      [
        0,
        32
      ],
      [
        12,
        76
      ],
      [
        25,
        65
      ],
      [
        37,
        -11
      ],
      [
        49,
        66
      ],
      [
        13,
        43
      ],
      [
        12,
        98
      ],
      [
        13,
        10
      ],
      [
        37,
        -10
      ],
      [
        12,
        10
      ],
      [
        25,
        55
      ],
      [
        25,
        76
      ],
      [
        24,
        21
      ],
      [
        25,
        0
      ],
      [
        13,
        22
      ],
      [
        0,
        32
      ],
      [
        -25,
        55
      ],
      [
        0,
        65
      ],
      [
        25,
        21
      ],
      [
        12,
        33
      ],
      [
        0,
        65
      ],
      [
        12,
        87
      ],
      [
        0,
        379
      ],
      [
        -12,
        87
      ],
      [
        0,
        152
      ],
      [
        -12,
        87
      ],
      [
        -13,
        21
      ],
      [
        -37,
        33
      ],
      [
        -37,
        -11
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        11
      ],
      [
        0,
        32
      ],
      [
        -13,
        44
      ],
      [
        -49,
        238
      ],
      [
        0,
        55
      ],
      [
        -62,
        108
      ],
      [
        -13,
        33
      ],
      [
        -37,
        0
      ],
      [
        -24,
        32
      ],
      [
        -25,
        54
      ],
      [
        -13,
        11
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        -13,
        -54
      ],
      [
        -37,
        -76
      ]
    ],
    [
      [
        95407,
        73845
      ],
      [
        -62,
        76
      ],
      [
        -24,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -75,
        11
      ],
      [
        -37,
        54
      ],
      [
        -24,
        11
      ],
      [
        -62,
        -44
      ],
      [
        -13,
        -21
      ],
      [
        -25,
        10
      ],
      [
        -12,
        33
      ],
      [
        25,
        43
      ],
      [
        -13,
        11
      ],
      [
        25,
        54
      ],
      [
        75,
        98
      ],
      [
        -50,
        163
      ],
      [
        0,
        21
      ],
      [
        -37,
        -21
      ],
      [
        -62,
        -76
      ],
      [
        -12,
        11
      ],
      [
        0,
        97
      ],
      [
        12,
        22
      ],
      [
        37,
        33
      ],
      [
        25,
        32
      ],
      [
        0,
        33
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        11
      ],
      [
        -24,
        75
      ],
      [
        -13,
        22
      ],
      [
        -25,
        11
      ],
      [
        -111,
        -76
      ],
      [
        -62,
        -65
      ],
      [
        0,
        -43
      ],
      [
        -12,
        0
      ],
      [
        -25,
        -55
      ],
      [
        -25,
        -10
      ],
      [
        -25,
        10
      ],
      [
        -37,
        33
      ],
      [
        -136,
        43
      ],
      [
        -25,
        76
      ],
      [
        -25,
        11
      ],
      [
        -49,
        -65
      ],
      [
        -62,
        -43
      ],
      [
        -37,
        -55
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        0,
        -32
      ],
      [
        -38,
        -65
      ],
      [
        -74,
        -65
      ],
      [
        -111,
        -22
      ],
      [
        -37,
        -22
      ],
      [
        -38,
        -86
      ],
      [
        -12,
        -55
      ],
      [
        -25,
        -43
      ],
      [
        -49,
        -65
      ],
      [
        -62,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        12,
        -22
      ],
      [
        0,
        -65
      ],
      [
        -49,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -12,
        11
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        -11
      ],
      [
        -74,
        22
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        92509,
        73281
      ],
      [
        -25,
        22
      ],
      [
        -25,
        43
      ],
      [
        0,
        65
      ],
      [
        25,
        152
      ],
      [
        12,
        54
      ],
      [
        -12,
        33
      ],
      [
        0,
        54
      ],
      [
        -74,
        54
      ],
      [
        -13,
        0
      ],
      [
        -25,
        -32
      ],
      [
        -74,
        -44
      ],
      [
        -49,
        -11
      ],
      [
        -13,
        -11
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        92236,
        73628
      ],
      [
        -62,
        11
      ],
      [
        -87,
        -44
      ],
      [
        -12,
        -10
      ],
      [
        -25,
        10
      ],
      [
        -99,
        0
      ],
      [
        -49,
        11
      ],
      [
        -37,
        54
      ],
      [
        -62,
        44
      ],
      [
        -38,
        11
      ],
      [
        0,
        32
      ],
      [
        -12,
        22
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        -76
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        55
      ],
      [
        -37,
        65
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -10
      ],
      [
        -25,
        43
      ],
      [
        -24,
        98
      ],
      [
        -25,
        54
      ],
      [
        -25,
        32
      ],
      [
        -99,
        0
      ],
      [
        -99,
        22
      ],
      [
        -12,
        33
      ],
      [
        24,
        141
      ],
      [
        -24,
        10
      ],
      [
        -75,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -24,
        22
      ],
      [
        -25,
        43
      ],
      [
        -62,
        54
      ],
      [
        -12,
        33
      ],
      [
        -38,
        43
      ],
      [
        -37,
        33
      ],
      [
        -24,
        152
      ],
      [
        -13,
        32
      ],
      [
        -62,
        43
      ],
      [
        -49,
        -32
      ],
      [
        -38,
        -33
      ],
      [
        -24,
        0
      ],
      [
        -50,
        76
      ],
      [
        -37,
        87
      ],
      [
        -37,
        76
      ],
      [
        -25,
        32
      ],
      [
        -49,
        0
      ],
      [
        -62,
        44
      ],
      [
        -124,
        163
      ],
      [
        -87,
        75
      ],
      [
        -37,
        55
      ],
      [
        -25,
        108
      ],
      [
        -136,
        44
      ],
      [
        -87,
        -33
      ],
      [
        -49,
        -152
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        43
      ],
      [
        -12,
        44
      ]
    ],
    [
      [
        89796,
        75060
      ],
      [
        -13,
        43
      ],
      [
        -37,
        32
      ],
      [
        -62,
        76
      ],
      [
        -148,
        98
      ],
      [
        -25,
        0
      ],
      [
        12,
        76
      ],
      [
        -24,
        65
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        65
      ],
      [
        0,
        11
      ],
      [
        -49,
        43
      ],
      [
        -38,
        0
      ],
      [
        -37,
        -10
      ],
      [
        -24,
        21
      ],
      [
        -50,
        76
      ],
      [
        -37,
        87
      ],
      [
        -50,
        98
      ],
      [
        -24,
        10
      ],
      [
        -13,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -38,
        0
      ],
      [
        13,
        87
      ],
      [
        -13,
        22
      ],
      [
        0,
        54
      ],
      [
        25,
        33
      ],
      [
        -25,
        32
      ],
      [
        -12,
        44
      ],
      [
        0,
        97
      ],
      [
        12,
        65
      ],
      [
        -24,
        22
      ],
      [
        -62,
        119
      ],
      [
        -13,
        54
      ],
      [
        0,
        55
      ],
      [
        -24,
        76
      ],
      [
        12,
        32
      ],
      [
        37,
        0
      ],
      [
        62,
        22
      ],
      [
        12,
        -22
      ],
      [
        0,
        -43
      ],
      [
        62,
        -87
      ],
      [
        25,
        0
      ],
      [
        25,
        22
      ],
      [
        25,
        54
      ],
      [
        24,
        11
      ]
    ],
    [
      [
        89176,
        76513
      ],
      [
        0,
        43
      ]
    ],
    [
      [
        89176,
        76556
      ],
      [
        13,
        87
      ],
      [
        0,
        32
      ],
      [
        -13,
        33
      ],
      [
        0,
        87
      ],
      [
        -37,
        43
      ],
      [
        13,
        54
      ],
      [
        0,
        44
      ],
      [
        -37,
        76
      ],
      [
        -62,
        86
      ],
      [
        -13,
        44
      ],
      [
        -12,
        97
      ],
      [
        0,
        141
      ],
      [
        -13,
        76
      ],
      [
        0,
        55
      ],
      [
        62,
        65
      ],
      [
        25,
        43
      ],
      [
        -25,
        54
      ],
      [
        -24,
        22
      ],
      [
        -25,
        43
      ],
      [
        -37,
        33
      ],
      [
        -50,
        32
      ],
      [
        -62,
        33
      ],
      [
        -25,
        22
      ],
      [
        -12,
        75
      ],
      [
        -50,
        228
      ],
      [
        -24,
        76
      ],
      [
        0,
        33
      ],
      [
        12,
        108
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -13,
        22
      ]
    ],
    [
      [
        88693,
        78389
      ],
      [
        -74,
        -22
      ],
      [
        -50,
        11
      ],
      [
        -49,
        22
      ],
      [
        -74,
        22
      ],
      [
        -112,
        65
      ]
    ],
    [
      [
        88334,
        78487
      ],
      [
        -49,
        43
      ],
      [
        -13,
        33
      ],
      [
        -12,
        65
      ],
      [
        -13,
        0
      ],
      [
        -37,
        -33
      ],
      [
        -49,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -13,
        76
      ],
      [
        -12,
        22
      ],
      [
        -50,
        21
      ],
      [
        -12,
        44
      ],
      [
        25,
        54
      ],
      [
        0,
        173
      ],
      [
        -25,
        87
      ],
      [
        -25,
        33
      ],
      [
        -12,
        32
      ],
      [
        -38,
        33
      ],
      [
        -37,
        11
      ],
      [
        -49,
        -22
      ],
      [
        -13,
        98
      ],
      [
        -12,
        10
      ],
      [
        -99,
        55
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        33
      ],
      [
        -62,
        21
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        87690,
        79474
      ],
      [
        37,
        32
      ],
      [
        25,
        33
      ],
      [
        12,
        32
      ],
      [
        0,
        33
      ],
      [
        -37,
        54
      ],
      [
        -37,
        43
      ],
      [
        12,
        54
      ],
      [
        0,
        76
      ],
      [
        -12,
        11
      ],
      [
        0,
        65
      ],
      [
        -12,
        65
      ],
      [
        -25,
        44
      ],
      [
        0,
        108
      ],
      [
        25,
        76
      ],
      [
        -13,
        44
      ],
      [
        -99,
        86
      ],
      [
        -87,
        33
      ],
      [
        -49,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        -50,
        11
      ],
      [
        -25,
        32
      ],
      [
        -12,
        55
      ],
      [
        -25,
        75
      ],
      [
        0,
        44
      ],
      [
        13,
        21
      ],
      [
        24,
        11
      ],
      [
        0,
        44
      ],
      [
        -24,
        21
      ],
      [
        -13,
        44
      ],
      [
        -37,
        76
      ],
      [
        12,
        43
      ],
      [
        0,
        87
      ]
    ],
    [
      [
        87256,
        80851
      ],
      [
        62,
        32
      ],
      [
        25,
        22
      ],
      [
        13,
        33
      ],
      [
        -13,
        86
      ],
      [
        -12,
        33
      ],
      [
        0,
        32
      ],
      [
        37,
        98
      ],
      [
        12,
        43
      ],
      [
        37,
        22
      ],
      [
        50,
        11
      ],
      [
        62,
        22
      ],
      [
        62,
        86
      ],
      [
        25,
        22
      ],
      [
        49,
        11
      ],
      [
        13,
        11
      ],
      [
        -13,
        54
      ],
      [
        13,
        43
      ],
      [
        49,
        -32
      ],
      [
        37,
        0
      ],
      [
        50,
        22
      ],
      [
        99,
        86
      ],
      [
        12,
        -11
      ],
      [
        13,
        -54
      ],
      [
        12,
        -119
      ],
      [
        12,
        -11
      ],
      [
        62,
        0
      ],
      [
        50,
        43
      ],
      [
        25,
        11
      ],
      [
        25,
        -11
      ],
      [
        37,
        33
      ],
      [
        24,
        -43
      ],
      [
        50,
        54
      ],
      [
        12,
        43
      ],
      [
        25,
        44
      ],
      [
        25,
        97
      ],
      [
        0,
        22
      ],
      [
        25,
        22
      ],
      [
        37,
        108
      ],
      [
        49,
        33
      ],
      [
        75,
        -22
      ],
      [
        37,
        11
      ],
      [
        99,
        -22
      ],
      [
        50,
        22
      ],
      [
        24,
        21
      ],
      [
        50,
        0
      ],
      [
        62,
        11
      ],
      [
        74,
        130
      ],
      [
        0,
        33
      ],
      [
        37,
        54
      ],
      [
        37,
        22
      ],
      [
        62,
        65
      ],
      [
        137,
        98
      ],
      [
        49,
        43
      ],
      [
        25,
        0
      ],
      [
        50,
        22
      ],
      [
        99,
        54
      ],
      [
        24,
        54
      ],
      [
        13,
        11
      ],
      [
        111,
        11
      ],
      [
        13,
        11
      ],
      [
        -13,
        54
      ],
      [
        0,
        32
      ]
    ],
    [
      [
        89523,
        82564
      ],
      [
        13,
        55
      ],
      [
        -37,
        217
      ],
      [
        37,
        108
      ],
      [
        62,
        43
      ],
      [
        37,
        11
      ],
      [
        0,
        22
      ],
      [
        -25,
        11
      ],
      [
        -37,
        43
      ],
      [
        12,
        33
      ],
      [
        75,
        43
      ],
      [
        49,
        -11
      ],
      [
        12,
        33
      ],
      [
        -24,
        76
      ],
      [
        -25,
        43
      ],
      [
        25,
        54
      ],
      [
        -25,
        87
      ],
      [
        -25,
        65
      ],
      [
        -25,
        130
      ],
      [
        -24,
        44
      ],
      [
        -25,
        86
      ],
      [
        0,
        141
      ],
      [
        -13,
        76
      ],
      [
        25,
        120
      ],
      [
        0,
        32
      ],
      [
        25,
        0
      ],
      [
        0,
        43
      ],
      [
        -37,
        11
      ],
      [
        -37,
        22
      ],
      [
        -87,
        0
      ],
      [
        -25,
        11
      ],
      [
        -25,
        43
      ],
      [
        38,
        33
      ],
      [
        37,
        43
      ],
      [
        49,
        11
      ],
      [
        149,
        65
      ],
      [
        74,
        0
      ],
      [
        62,
        22
      ],
      [
        99,
        43
      ],
      [
        124,
        65
      ],
      [
        25,
        -21
      ],
      [
        12,
        -55
      ],
      [
        50,
        -43
      ],
      [
        12,
        11
      ],
      [
        50,
        11
      ],
      [
        49,
        21
      ],
      [
        25,
        -11
      ],
      [
        50,
        -54
      ],
      [
        24,
        22
      ],
      [
        25,
        87
      ],
      [
        0,
        86
      ],
      [
        -12,
        11
      ],
      [
        -50,
        11
      ],
      [
        -37,
        33
      ],
      [
        -12,
        32
      ],
      [
        12,
        65
      ],
      [
        62,
        206
      ],
      [
        12,
        98
      ],
      [
        50,
        141
      ],
      [
        37,
        152
      ],
      [
        62,
        206
      ],
      [
        0,
        43
      ],
      [
        13,
        98
      ],
      [
        24,
        11
      ],
      [
        37,
        -11
      ],
      [
        87,
        -44
      ],
      [
        62,
        -43
      ],
      [
        62,
        -32
      ],
      [
        74,
        -11
      ],
      [
        62,
        11
      ],
      [
        50,
        0
      ],
      [
        62,
        -11
      ],
      [
        49,
        0
      ],
      [
        37,
        -87
      ],
      [
        25,
        0
      ],
      [
        87,
        76
      ],
      [
        37,
        54
      ],
      [
        50,
        0
      ],
      [
        37,
        11
      ],
      [
        25,
        22
      ],
      [
        12,
        54
      ],
      [
        25,
        43
      ],
      [
        0,
        87
      ],
      [
        -25,
        65
      ],
      [
        0,
        43
      ],
      [
        -25,
        217
      ],
      [
        13,
        87
      ],
      [
        24,
        98
      ],
      [
        25,
        65
      ],
      [
        25,
        43
      ],
      [
        25,
        22
      ],
      [
        74,
        0
      ],
      [
        74,
        22
      ],
      [
        38,
        21
      ],
      [
        61,
        22
      ],
      [
        38,
        76
      ],
      [
        24,
        32
      ],
      [
        13,
        109
      ],
      [
        -13,
        43
      ],
      [
        13,
        44
      ],
      [
        37,
        54
      ],
      [
        62,
        11
      ],
      [
        62,
        0
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        91964,
        86881
      ],
      [
        37,
        -11
      ],
      [
        49,
        32
      ],
      [
        87,
        22
      ]
    ],
    [
      [
        92137,
        86924
      ],
      [
        0,
        -54
      ],
      [
        25,
        -43
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -21
      ],
      [
        37,
        -55
      ],
      [
        38,
        -21
      ],
      [
        37,
        -33
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -43
      ],
      [
        12,
        -32
      ],
      [
        111,
        -55
      ],
      [
        38,
        -43
      ],
      [
        37,
        -11
      ],
      [
        12,
        -43
      ],
      [
        0,
        -54
      ],
      [
        87,
        -76
      ],
      [
        37,
        -11
      ],
      [
        37,
        -54
      ],
      [
        50,
        -11
      ],
      [
        49,
        21
      ],
      [
        50,
        11
      ],
      [
        37,
        -21
      ],
      [
        37,
        -76
      ],
      [
        37,
        -33
      ],
      [
        37,
        11
      ],
      [
        25,
        22
      ],
      [
        25,
        0
      ],
      [
        0,
        -22
      ],
      [
        25,
        -65
      ],
      [
        74,
        -54
      ],
      [
        0,
        -33
      ],
      [
        13,
        -32
      ],
      [
        24,
        -33
      ],
      [
        13,
        -54
      ],
      [
        0,
        -54
      ],
      [
        24,
        -66
      ],
      [
        62,
        -130
      ],
      [
        50,
        -32
      ],
      [
        37,
        -130
      ],
      [
        0,
        -55
      ],
      [
        12,
        -43
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -87
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -33
      ],
      [
        37,
        -141
      ],
      [
        -24,
        -33
      ],
      [
        -50,
        -86
      ],
      [
        -37,
        -76
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -54
      ],
      [
        37,
        -65
      ],
      [
        0,
        -22
      ],
      [
        37,
        -109
      ],
      [
        12,
        -10
      ],
      [
        13,
        21
      ],
      [
        37,
        0
      ],
      [
        87,
        -65
      ],
      [
        49,
        0
      ],
      [
        50,
        -21
      ],
      [
        49,
        -11
      ],
      [
        99,
        0
      ],
      [
        50,
        -22
      ],
      [
        87,
        -11
      ],
      [
        49,
        0
      ],
      [
        74,
        11
      ],
      [
        174,
        -33
      ],
      [
        74,
        -21
      ],
      [
        50,
        -22
      ],
      [
        37,
        -43
      ],
      [
        37,
        -76
      ],
      [
        37,
        -22
      ],
      [
        75,
        -22
      ],
      [
        62,
        -76
      ],
      [
        49,
        -32
      ],
      [
        74,
        -76
      ],
      [
        50,
        -32
      ],
      [
        62,
        -22
      ],
      [
        99,
        11
      ],
      [
        12,
        -11
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -97
      ],
      [
        12,
        -22
      ],
      [
        38,
        -11
      ],
      [
        37,
        -86
      ],
      [
        37,
        -120
      ],
      [
        49,
        -173
      ],
      [
        0,
        -65
      ],
      [
        25,
        -44
      ],
      [
        62,
        -65
      ],
      [
        25,
        -54
      ],
      [
        49,
        -54
      ],
      [
        13,
        -54
      ],
      [
        0,
        -66
      ],
      [
        12,
        -10
      ],
      [
        161,
        21
      ],
      [
        124,
        22
      ],
      [
        174,
        -33
      ],
      [
        185,
        -32
      ],
      [
        161,
        -33
      ],
      [
        261,
        -43
      ],
      [
        99,
        43
      ],
      [
        74,
        22
      ],
      [
        37,
        0
      ],
      [
        235,
        -54
      ],
      [
        112,
        -22
      ],
      [
        74,
        -11
      ],
      [
        87,
        0
      ],
      [
        37,
        -21
      ],
      [
        99,
        -174
      ],
      [
        62,
        -32
      ],
      [
        149,
        -44
      ],
      [
        74,
        -32
      ],
      [
        99,
        -22
      ],
      [
        62,
        -43
      ],
      [
        62,
        -55
      ],
      [
        99,
        -65
      ],
      [
        198,
        65
      ],
      [
        62,
        11
      ],
      [
        0,
        -130
      ],
      [
        124,
        -11
      ],
      [
        50,
        -32
      ],
      [
        25,
        10
      ],
      [
        49,
        76
      ],
      [
        37,
        22
      ],
      [
        75,
        54
      ],
      [
        111,
        87
      ],
      [
        235,
        141
      ],
      [
        50,
        33
      ],
      [
        74,
        21
      ],
      [
        62,
        11
      ],
      [
        75,
        22
      ],
      [
        161,
        32
      ],
      [
        99,
        11
      ],
      [
        37,
        11
      ],
      [
        62,
        0
      ],
      [
        124,
        -22
      ],
      [
        148,
        22
      ],
      [
        75,
        0
      ],
      [
        37,
        11
      ],
      [
        136,
        87
      ],
      [
        74,
        32
      ],
      [
        112,
        76
      ],
      [
        25,
        44
      ],
      [
        62,
        86
      ],
      [
        24,
        54
      ],
      [
        50,
        76
      ],
      [
        49,
        98
      ],
      [
        62,
        33
      ],
      [
        100,
        43
      ],
      [
        61,
        54
      ],
      [
        38,
        65
      ],
      [
        37,
        11
      ],
      [
        25,
        22
      ],
      [
        0,
        65
      ],
      [
        -38,
        76
      ],
      [
        -49,
        65
      ],
      [
        -62,
        97
      ],
      [
        0,
        44
      ],
      [
        -25,
        32
      ],
      [
        -12,
        33
      ],
      [
        0,
        32
      ],
      [
        37,
        55
      ],
      [
        0,
        32
      ],
      [
        12,
        65
      ],
      [
        25,
        98
      ],
      [
        50,
        87
      ],
      [
        49,
        65
      ],
      [
        50,
        11
      ],
      [
        24,
        -11
      ],
      [
        100,
        0
      ],
      [
        37,
        -33
      ],
      [
        25,
        -65
      ],
      [
        37,
        -11
      ],
      [
        124,
        -54
      ],
      [
        49,
        -11
      ],
      [
        37,
        0
      ],
      [
        99,
        -22
      ],
      [
        25,
        11
      ],
      [
        25,
        33
      ],
      [
        62,
        54
      ],
      [
        62,
        43
      ],
      [
        25,
        44
      ],
      [
        86,
        97
      ],
      [
        25,
        44
      ],
      [
        0,
        22
      ],
      [
        25,
        54
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        62,
        -22
      ],
      [
        173,
        22
      ],
      [
        37,
        21
      ],
      [
        50,
        11
      ],
      [
        87,
        98
      ],
      [
        37,
        32
      ],
      [
        24,
        11
      ],
      [
        50,
        65
      ],
      [
        -12,
        33
      ],
      [
        12,
        76
      ],
      [
        62,
        119
      ],
      [
        25,
        32
      ],
      [
        25,
        55
      ],
      [
        37,
        11
      ],
      [
        37,
        43
      ],
      [
        124,
        -22
      ],
      [
        37,
        0
      ],
      [
        37,
        22
      ],
      [
        0,
        32
      ],
      [
        12,
        66
      ],
      [
        13,
        32
      ],
      [
        37,
        0
      ],
      [
        37,
        -43
      ],
      [
        50,
        11
      ],
      [
        37,
        43
      ],
      [
        49,
        32
      ],
      [
        87,
        33
      ],
      [
        37,
        -11
      ],
      [
        112,
        0
      ],
      [
        12,
        33
      ],
      [
        25,
        11
      ],
      [
        111,
        -76
      ],
      [
        50,
        -22
      ],
      [
        49,
        11
      ],
      [
        50,
        -11
      ],
      [
        37,
        0
      ],
      [
        50,
        43
      ],
      [
        12,
        33
      ],
      [
        0,
        76
      ],
      [
        -49,
        108
      ],
      [
        0,
        44
      ],
      [
        -13,
        32
      ],
      [
        -62,
        65
      ],
      [
        -49,
        76
      ],
      [
        -25,
        22
      ],
      [
        -12,
        43
      ],
      [
        -38,
        33
      ],
      [
        -24,
        54
      ],
      [
        0,
        22
      ],
      [
        -25,
        21
      ],
      [
        -87,
        44
      ],
      [
        -74,
        119
      ],
      [
        -25,
        22
      ],
      [
        -87,
        11
      ],
      [
        -24,
        21
      ],
      [
        -62,
        -21
      ],
      [
        -50,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        -44
      ],
      [
        -37,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        0
      ],
      [
        -74,
        87
      ],
      [
        -62,
        33
      ],
      [
        -50,
        11
      ],
      [
        -86,
        -22
      ],
      [
        -50,
        0
      ],
      [
        -12,
        11
      ],
      [
        -37,
        0
      ],
      [
        -50,
        -44
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        33
      ],
      [
        -37,
        32
      ],
      [
        -37,
        55
      ],
      [
        -12,
        43
      ],
      [
        -13,
        119
      ],
      [
        37,
        33
      ],
      [
        50,
        32
      ],
      [
        0,
        131
      ],
      [
        12,
        75
      ],
      [
        50,
        76
      ],
      [
        25,
        55
      ],
      [
        0,
        32
      ],
      [
        24,
        65
      ],
      [
        13,
        65
      ],
      [
        37,
        76
      ],
      [
        50,
        152
      ],
      [
        62,
        174
      ],
      [
        37,
        86
      ]
    ],
    [
      [
        102072,
        87336
      ],
      [
        74,
        -54
      ],
      [
        111,
        -65
      ],
      [
        87,
        -11
      ],
      [
        75,
        -54
      ],
      [
        61,
        -11
      ],
      [
        112,
        119
      ],
      [
        87,
        87
      ],
      [
        99,
        76
      ],
      [
        86,
        11
      ],
      [
        50,
        22
      ],
      [
        37,
        32
      ],
      [
        25,
        54
      ],
      [
        12,
        76
      ],
      [
        -12,
        54
      ],
      [
        -37,
        11
      ],
      [
        -13,
        22
      ],
      [
        25,
        43
      ],
      [
        13,
        55
      ],
      [
        24,
        43
      ],
      [
        37,
        43
      ],
      [
        13,
        44
      ],
      [
        0,
        54
      ],
      [
        25,
        54
      ],
      [
        62,
        98
      ],
      [
        0,
        43
      ],
      [
        74,
        152
      ],
      [
        37,
        108
      ],
      [
        62,
        76
      ],
      [
        87,
        87
      ],
      [
        62,
        76
      ],
      [
        24,
        76
      ],
      [
        0,
        65
      ],
      [
        -37,
        65
      ],
      [
        0,
        54
      ],
      [
        13,
        65
      ],
      [
        -13,
        44
      ],
      [
        -49,
        32
      ],
      [
        -50,
        11
      ],
      [
        -62,
        -21
      ],
      [
        -37,
        21
      ],
      [
        -12,
        54
      ],
      [
        24,
        44
      ],
      [
        38,
        32
      ],
      [
        74,
        76
      ],
      [
        99,
        130
      ],
      [
        87,
        65
      ],
      [
        148,
        22
      ],
      [
        112,
        44
      ],
      [
        124,
        43
      ],
      [
        86,
        22
      ],
      [
        62,
        -22
      ],
      [
        75,
        11
      ],
      [
        148,
        43
      ],
      [
        50,
        11
      ],
      [
        87,
        -22
      ],
      [
        12,
        11
      ],
      [
        50,
        -22
      ],
      [
        86,
        -65
      ],
      [
        50,
        -21
      ],
      [
        49,
        -11
      ],
      [
        25,
        -44
      ],
      [
        37,
        -32
      ],
      [
        62,
        -11
      ],
      [
        87,
        -54
      ],
      [
        0,
        32
      ],
      [
        62,
        22
      ],
      [
        49,
        -22
      ],
      [
        75,
        -54
      ],
      [
        74,
        -32
      ],
      [
        13,
        -22
      ],
      [
        0,
        -43
      ],
      [
        12,
        -22
      ],
      [
        49,
        -11
      ],
      [
        25,
        -43
      ],
      [
        37,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        12,
        -32
      ],
      [
        38,
        -11
      ],
      [
        12,
        -43
      ],
      [
        49,
        -76
      ],
      [
        0,
        -33
      ],
      [
        25,
        -54
      ],
      [
        37,
        -184
      ],
      [
        50,
        -87
      ],
      [
        12,
        -54
      ],
      [
        0,
        -87
      ],
      [
        38,
        -33
      ],
      [
        12,
        -54
      ],
      [
        0,
        -98
      ],
      [
        25,
        -54
      ],
      [
        0,
        -43
      ],
      [
        37,
        -76
      ],
      [
        62,
        -98
      ],
      [
        37,
        -76
      ],
      [
        12,
        -54
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -32
      ],
      [
        12,
        -11
      ],
      [
        0,
        -54
      ],
      [
        13,
        -33
      ],
      [
        74,
        -54
      ],
      [
        -37,
        -141
      ],
      [
        0,
        -65
      ],
      [
        25,
        -44
      ],
      [
        49,
        -54
      ],
      [
        0,
        -32
      ],
      [
        37,
        -33
      ],
      [
        62,
        -32
      ],
      [
        87,
        0
      ],
      [
        99,
        21
      ],
      [
        62,
        0
      ],
      [
        25,
        -11
      ],
      [
        0,
        -54
      ],
      [
        12,
        -21
      ],
      [
        75,
        -22
      ],
      [
        24,
        -44
      ],
      [
        25,
        22
      ],
      [
        50,
        -22
      ],
      [
        24,
        22
      ],
      [
        38,
        0
      ],
      [
        24,
        -65
      ],
      [
        38,
        0
      ],
      [
        37,
        -54
      ],
      [
        86,
        -141
      ],
      [
        50,
        -54
      ],
      [
        62,
        -11
      ],
      [
        62,
        0
      ],
      [
        25,
        -54
      ],
      [
        -25,
        -66
      ],
      [
        0,
        -43
      ],
      [
        37,
        -76
      ],
      [
        25,
        -32
      ],
      [
        25,
        -55
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -87
      ],
      [
        0,
        -65
      ],
      [
        37,
        -54
      ],
      [
        25,
        -54
      ],
      [
        12,
        -54
      ],
      [
        0,
        -33
      ],
      [
        25,
        -11
      ],
      [
        99,
        22
      ],
      [
        49,
        0
      ],
      [
        38,
        -22
      ],
      [
        74,
        0
      ],
      [
        124,
        22
      ],
      [
        124,
        0
      ],
      [
        24,
        33
      ],
      [
        25,
        75
      ],
      [
        25,
        33
      ],
      [
        25,
        0
      ],
      [
        37,
        22
      ],
      [
        50,
        54
      ],
      [
        37,
        22
      ],
      [
        111,
        0
      ],
      [
        37,
        21
      ],
      [
        37,
        44
      ],
      [
        50,
        43
      ],
      [
        161,
        65
      ],
      [
        12,
        -11
      ],
      [
        87,
        -21
      ],
      [
        37,
        -76
      ],
      [
        -12,
        -55
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -21
      ],
      [
        37,
        -109
      ],
      [
        25,
        -54
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -54
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -50,
        -54
      ],
      [
        -24,
        -65
      ],
      [
        12,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -163
      ],
      [
        -12,
        -65
      ],
      [
        -38,
        -65
      ],
      [
        13,
        -44
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -10
      ],
      [
        0,
        -44
      ],
      [
        -37,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -44
      ],
      [
        -24,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        -109
      ],
      [
        0,
        -119
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -24,
        22
      ],
      [
        -50,
        11
      ],
      [
        -12,
        10
      ],
      [
        -112,
        33
      ],
      [
        -62,
        32
      ],
      [
        -62,
        22
      ],
      [
        -49,
        54
      ],
      [
        -37,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -75
      ],
      [
        -50,
        -66
      ],
      [
        -61,
        -21
      ],
      [
        -13,
        -11
      ],
      [
        -74,
        -22
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -33
      ],
      [
        25,
        -97
      ],
      [
        12,
        -76
      ],
      [
        50,
        -249
      ],
      [
        -25,
        -44
      ],
      [
        -13,
        -184
      ],
      [
        13,
        -33
      ],
      [
        0,
        -108
      ],
      [
        25,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -76
      ],
      [
        -13,
        -76
      ],
      [
        -24,
        -65
      ],
      [
        0,
        -44
      ],
      [
        -13,
        -43
      ],
      [
        -37,
        -32
      ],
      [
        -49,
        10
      ],
      [
        -75,
        -32
      ],
      [
        -49,
        -33
      ],
      [
        -13,
        -32
      ],
      [
        37,
        -22
      ],
      [
        25,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        60859,
        59421
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        60859,
        59388
      ],
      [
        -50,
        22
      ],
      [
        13,
        22
      ],
      [
        37,
        -11
      ]
    ],
    [
      [
        60995,
        62132
      ],
      [
        0,
        -108
      ],
      [
        13,
        -11
      ],
      [
        -13,
        -44
      ],
      [
        -12,
        -65
      ],
      [
        0,
        -43
      ],
      [
        12,
        -11
      ],
      [
        13,
        -43
      ],
      [
        12,
        -76
      ],
      [
        12,
        -33
      ],
      [
        25,
        -358
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -22
      ],
      [
        12,
        -22
      ],
      [
        -24,
        -43
      ],
      [
        -50,
        -76
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -54
      ],
      [
        -24,
        -141
      ],
      [
        -13,
        -119
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -21
      ],
      [
        0,
        -33
      ],
      [
        -50,
        -108
      ],
      [
        -25,
        -87
      ],
      [
        0,
        -228
      ],
      [
        50,
        -217
      ],
      [
        25,
        -184
      ],
      [
        12,
        -54
      ],
      [
        0,
        -22
      ],
      [
        13,
        -22
      ],
      [
        49,
        -11
      ],
      [
        12,
        -119
      ],
      [
        0,
        -108
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -21
      ],
      [
        -25,
        0
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        11
      ]
    ],
    [
      [
        60884,
        59421
      ],
      [
        -50,
        43
      ],
      [
        0,
        87
      ],
      [
        -12,
        11
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        -109
      ],
      [
        -13,
        -21
      ],
      [
        -186,
        54
      ],
      [
        -37,
        43
      ],
      [
        -37,
        11
      ],
      [
        -87,
        0
      ],
      [
        -61,
        -21
      ],
      [
        -25,
        -22
      ],
      [
        186,
        11
      ],
      [
        12,
        -11
      ],
      [
        -211,
        -44
      ],
      [
        -86,
        -21
      ],
      [
        -25,
        11
      ],
      [
        -25,
        32
      ],
      [
        -87,
        0
      ],
      [
        13,
        -32
      ],
      [
        49,
        10
      ],
      [
        13,
        -21
      ],
      [
        -174,
        -33
      ],
      [
        -111,
        -43
      ],
      [
        -50,
        -33
      ],
      [
        -173,
        -119
      ],
      [
        -99,
        -65
      ],
      [
        -25,
        -22
      ],
      [
        -50,
        -54
      ],
      [
        -62,
        -33
      ],
      [
        -61,
        -75
      ],
      [
        -50,
        -11
      ]
    ],
    [
      [
        59323,
        58933
      ],
      [
        0,
        141
      ],
      [
        -12,
        152
      ],
      [
        0,
        54
      ],
      [
        12,
        65
      ],
      [
        0,
        43
      ],
      [
        25,
        33
      ],
      [
        0,
        65
      ],
      [
        25,
        54
      ],
      [
        0,
        206
      ],
      [
        -13,
        119
      ],
      [
        -25,
        0
      ],
      [
        -37,
        44
      ],
      [
        -37,
        0
      ],
      [
        -25,
        32
      ],
      [
        0,
        44
      ],
      [
        -12,
        21
      ],
      [
        0,
        55
      ],
      [
        -13,
        43
      ],
      [
        -37,
        33
      ],
      [
        -24,
        10
      ],
      [
        -25,
        -10
      ],
      [
        -50,
        21
      ],
      [
        -25,
        22
      ],
      [
        -12,
        43
      ],
      [
        -25,
        33
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        22
      ],
      [
        0,
        11
      ],
      [
        74,
        119
      ],
      [
        25,
        65
      ],
      [
        0,
        108
      ],
      [
        12,
        65
      ],
      [
        -49,
        206
      ],
      [
        0,
        66
      ],
      [
        -25,
        32
      ]
    ],
    [
      [
        59001,
        60939
      ],
      [
        25,
        22
      ],
      [
        24,
        0
      ],
      [
        38,
        -22
      ],
      [
        12,
        11
      ],
      [
        37,
        108
      ],
      [
        0,
        44
      ],
      [
        -12,
        21
      ],
      [
        25,
        76
      ],
      [
        24,
        65
      ],
      [
        -24,
        55
      ],
      [
        -13,
        0
      ],
      [
        -37,
        32
      ],
      [
        -12,
        22
      ],
      [
        0,
        119
      ],
      [
        12,
        22
      ],
      [
        50,
        11
      ],
      [
        61,
        -22
      ],
      [
        25,
        0
      ],
      [
        25,
        -54
      ],
      [
        12,
        0
      ],
      [
        13,
        22
      ],
      [
        -13,
        86
      ],
      [
        0,
        54
      ],
      [
        -24,
        55
      ],
      [
        -62,
        32
      ],
      [
        0,
        65
      ],
      [
        12,
        65
      ],
      [
        12,
        22
      ],
      [
        38,
        33
      ],
      [
        -25,
        43
      ],
      [
        -25,
        33
      ],
      [
        12,
        65
      ],
      [
        0,
        76
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -25,
        11
      ],
      [
        -12,
        43
      ],
      [
        0,
        239
      ],
      [
        -13,
        65
      ],
      [
        13,
        32
      ],
      [
        25,
        22
      ],
      [
        24,
        65
      ]
    ],
    [
      [
        59174,
        62566
      ],
      [
        37,
        11
      ],
      [
        25,
        32
      ],
      [
        25,
        65
      ],
      [
        25,
        55
      ],
      [
        49,
        0
      ],
      [
        13,
        10
      ],
      [
        12,
        -43
      ],
      [
        13,
        -22
      ],
      [
        12,
        0
      ],
      [
        0,
        -54
      ],
      [
        74,
        -22
      ],
      [
        25,
        -10
      ],
      [
        12,
        -33
      ],
      [
        25,
        0
      ],
      [
        13,
        33
      ],
      [
        -13,
        32
      ],
      [
        0,
        33
      ],
      [
        13,
        21
      ],
      [
        37,
        11
      ],
      [
        24,
        0
      ],
      [
        25,
        -11
      ],
      [
        13,
        33
      ],
      [
        -13,
        76
      ],
      [
        0,
        43
      ],
      [
        13,
        44
      ],
      [
        37,
        -44
      ],
      [
        49,
        -22
      ],
      [
        -12,
        66
      ],
      [
        25,
        21
      ],
      [
        37,
        22
      ],
      [
        12,
        -76
      ],
      [
        0,
        -76
      ],
      [
        13,
        -65
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -43
      ],
      [
        37,
        -32
      ],
      [
        25,
        0
      ],
      [
        25,
        21
      ],
      [
        25,
        44
      ],
      [
        0,
        32
      ],
      [
        25,
        22
      ],
      [
        49,
        22
      ],
      [
        50,
        10
      ],
      [
        12,
        -10
      ]
    ],
    [
      [
        67486,
        57631
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        -55
      ],
      [
        25,
        -141
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        54
      ],
      [
        -37,
        32
      ],
      [
        -49,
        65
      ],
      [
        -50,
        22
      ],
      [
        -62,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        22
      ],
      [
        -38,
        43
      ],
      [
        -24,
        -21
      ],
      [
        -62,
        0
      ],
      [
        0,
        32
      ],
      [
        -13,
        11
      ],
      [
        -37,
        0
      ],
      [
        -12,
        22
      ],
      [
        -25,
        11
      ],
      [
        -25,
        43
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        11
      ],
      [
        -173,
        0
      ],
      [
        -174,
        0
      ]
    ],
    [
      [
        66495,
        57566
      ],
      [
        0,
        33
      ],
      [
        -25,
        21
      ],
      [
        -185,
        0
      ],
      [
        -50,
        22
      ],
      [
        -62,
        11
      ],
      [
        -62,
        -11
      ],
      [
        -74,
        0
      ],
      [
        -136,
        11
      ],
      [
        -75,
        0
      ],
      [
        0,
        -87
      ]
    ],
    [
      [
        65826,
        57566
      ],
      [
        -185,
        0
      ],
      [
        -174,
        0
      ],
      [
        -111,
        0
      ],
      [
        -50,
        44
      ],
      [
        0,
        43
      ],
      [
        -12,
        0
      ]
    ],
    [
      [
        65294,
        57653
      ],
      [
        12,
        152
      ],
      [
        12,
        119
      ],
      [
        25,
        217
      ],
      [
        -12,
        98
      ],
      [
        -13,
        43
      ],
      [
        -61,
        141
      ],
      [
        24,
        54
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        55
      ],
      [
        -25,
        65
      ],
      [
        12,
        11
      ],
      [
        13,
        32
      ],
      [
        49,
        -11
      ],
      [
        -37,
        76
      ],
      [
        0,
        22
      ],
      [
        -12,
        11
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        -44
      ],
      [
        -12,
        -10
      ],
      [
        -25,
        0
      ],
      [
        -12,
        10
      ],
      [
        -25,
        44
      ],
      [
        -50,
        22
      ],
      [
        -37,
        32
      ],
      [
        -12,
        87
      ],
      [
        -13,
        32
      ],
      [
        0,
        44
      ],
      [
        -12,
        54
      ],
      [
        12,
        76
      ],
      [
        -12,
        11
      ],
      [
        -50,
        0
      ],
      [
        -12,
        43
      ],
      [
        -12,
        11
      ],
      [
        0,
        -76
      ],
      [
        -13,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        33
      ],
      [
        0,
        21
      ],
      [
        12,
        87
      ]
    ],
    [
      [
        64872,
        59182
      ],
      [
        0,
        54
      ],
      [
        25,
        55
      ],
      [
        25,
        76
      ],
      [
        25,
        97
      ],
      [
        25,
        163
      ],
      [
        12,
        108
      ],
      [
        12,
        87
      ],
      [
        25,
        87
      ],
      [
        25,
        54
      ],
      [
        62,
        119
      ],
      [
        37,
        76
      ],
      [
        74,
        98
      ],
      [
        25,
        43
      ],
      [
        25,
        65
      ],
      [
        25,
        76
      ],
      [
        24,
        22
      ],
      [
        100,
        119
      ],
      [
        0,
        -21
      ],
      [
        12,
        -44
      ],
      [
        37,
        -11
      ],
      [
        37,
        0
      ],
      [
        25,
        11
      ],
      [
        12,
        22
      ],
      [
        13,
        76
      ],
      [
        25,
        11
      ],
      [
        37,
        -44
      ],
      [
        74,
        -130
      ],
      [
        25,
        -32
      ],
      [
        0,
        -22
      ],
      [
        25,
        -119
      ],
      [
        0,
        -33
      ],
      [
        24,
        -11
      ],
      [
        62,
        33
      ],
      [
        50,
        65
      ],
      [
        12,
        43
      ],
      [
        13,
        22
      ],
      [
        0,
        97
      ],
      [
        74,
        131
      ],
      [
        25,
        32
      ],
      [
        0,
        11
      ],
      [
        -25,
        87
      ],
      [
        25,
        86
      ],
      [
        62,
        109
      ],
      [
        0,
        87
      ],
      [
        49,
        141
      ],
      [
        25,
        173
      ],
      [
        0,
        33
      ],
      [
        25,
        87
      ],
      [
        37,
        108
      ],
      [
        49,
        22
      ],
      [
        62,
        76
      ],
      [
        25,
        86
      ],
      [
        0,
        87
      ],
      [
        13,
        98
      ],
      [
        24,
        152
      ],
      [
        38,
        43
      ],
      [
        61,
        43
      ],
      [
        0,
        55
      ],
      [
        13,
        108
      ],
      [
        0,
        87
      ],
      [
        12,
        43
      ],
      [
        50,
        87
      ],
      [
        12,
        130
      ],
      [
        25,
        141
      ],
      [
        62,
        174
      ],
      [
        62,
        162
      ],
      [
        25,
        44
      ],
      [
        24,
        21
      ],
      [
        38,
        0
      ],
      [
        12,
        11
      ],
      [
        74,
        87
      ],
      [
        37,
        32
      ],
      [
        25,
        55
      ],
      [
        0,
        32
      ],
      [
        -12,
        87
      ],
      [
        12,
        65
      ],
      [
        13,
        98
      ],
      [
        0,
        97
      ],
      [
        -13,
        44
      ],
      [
        -25,
        54
      ],
      [
        -37,
        22
      ],
      [
        -49,
        10
      ],
      [
        -25,
        22
      ],
      [
        0,
        87
      ],
      [
        -12,
        54
      ],
      [
        -25,
        293
      ]
    ],
    [
      [
        66768,
        64388
      ],
      [
        62,
        0
      ],
      [
        74,
        -44
      ],
      [
        12,
        -21
      ],
      [
        13,
        -98
      ],
      [
        25,
        -54
      ],
      [
        49,
        -54
      ],
      [
        25,
        -98
      ],
      [
        12,
        -141
      ],
      [
        25,
        -87
      ],
      [
        12,
        -10
      ],
      [
        25,
        -131
      ],
      [
        13,
        -32
      ],
      [
        0,
        -130
      ],
      [
        12,
        -65
      ],
      [
        -25,
        -109
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -97
      ],
      [
        25,
        -163
      ],
      [
        12,
        -119
      ],
      [
        25,
        -109
      ],
      [
        25,
        -76
      ],
      [
        49,
        -87
      ],
      [
        37,
        -86
      ],
      [
        50,
        -44
      ],
      [
        -37,
        -32
      ],
      [
        -75,
        0
      ],
      [
        -49,
        11
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -11
      ],
      [
        -87,
        -11
      ],
      [
        -161,
        22
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -44
      ],
      [
        -62,
        -130
      ],
      [
        12,
        -65
      ],
      [
        25,
        -43
      ],
      [
        74,
        -152
      ],
      [
        12,
        -54
      ],
      [
        75,
        -109
      ],
      [
        74,
        -119
      ],
      [
        37,
        -22
      ],
      [
        37,
        -54
      ],
      [
        50,
        -98
      ],
      [
        50,
        -141
      ],
      [
        24,
        -152
      ],
      [
        37,
        -141
      ],
      [
        13,
        -32
      ],
      [
        25,
        -11
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -87
      ]
    ],
    [
      [
        72540,
        58390
      ],
      [
        13,
        -10
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -87
      ],
      [
        -13,
        -65
      ],
      [
        -12,
        -87
      ],
      [
        37,
        -65
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -97
      ],
      [
        -12,
        -98
      ],
      [
        -12,
        -43
      ],
      [
        37,
        -33
      ],
      [
        49,
        0
      ],
      [
        38,
        -76
      ],
      [
        24,
        0
      ],
      [
        13,
        -11
      ],
      [
        0,
        -21
      ],
      [
        25,
        -22
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -112,
        -227
      ],
      [
        -149,
        -272
      ],
      [
        -62,
        -32
      ],
      [
        -24,
        -54
      ],
      [
        -25,
        -87
      ],
      [
        -37,
        -65
      ],
      [
        -50,
        -44
      ],
      [
        0,
        -184
      ],
      [
        -49,
        -206
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -98
      ],
      [
        -13,
        -32
      ],
      [
        -12,
        -207
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -97
      ],
      [
        0,
        -120
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -87
      ],
      [
        13,
        -151
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        72094,
        55343
      ],
      [
        -37,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -50,
        -130
      ],
      [
        -24,
        -54
      ],
      [
        0,
        -109
      ],
      [
        12,
        -87
      ],
      [
        -12,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        -62,
        -86
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -98
      ],
      [
        12,
        -43
      ],
      [
        0,
        -33
      ],
      [
        38,
        -21
      ]
    ],
    [
      [
        72045,
        53434
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -206
      ],
      [
        -12,
        -44
      ],
      [
        37,
        -173
      ],
      [
        25,
        -87
      ],
      [
        0,
        -54
      ],
      [
        24,
        -54
      ],
      [
        13,
        -98
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -119
      ],
      [
        0,
        -44
      ],
      [
        12,
        -86
      ],
      [
        0,
        -87
      ],
      [
        25,
        -54
      ],
      [
        37,
        -141
      ],
      [
        37,
        -44
      ],
      [
        50,
        -76
      ],
      [
        74,
        -97
      ],
      [
        12,
        -44
      ],
      [
        62,
        -184
      ],
      [
        13,
        -76
      ],
      [
        24,
        -108
      ],
      [
        25,
        -98
      ],
      [
        25,
        -119
      ],
      [
        25,
        -87
      ],
      [
        12,
        -54
      ]
    ],
    [
      [
        72503,
        51092
      ],
      [
        -62,
        -11
      ],
      [
        -87,
        -22
      ],
      [
        -86,
        -32
      ],
      [
        -99,
        -22
      ],
      [
        -99,
        -33
      ],
      [
        -100,
        -21
      ],
      [
        -74,
        -22
      ],
      [
        -25,
        -11
      ],
      [
        13,
        -65
      ],
      [
        -13,
        -76
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -76
      ],
      [
        -99,
        -130
      ],
      [
        0,
        -33
      ],
      [
        49,
        -141
      ],
      [
        25,
        -206
      ],
      [
        0,
        -358
      ],
      [
        13,
        -86
      ],
      [
        -13,
        -76
      ],
      [
        -25,
        -87
      ],
      [
        -12,
        -76
      ],
      [
        -12,
        -119
      ],
      [
        -37,
        -228
      ],
      [
        0,
        -54
      ],
      [
        12,
        -33
      ],
      [
        25,
        -119
      ],
      [
        37,
        -65
      ],
      [
        62,
        -87
      ],
      [
        74,
        -130
      ],
      [
        25,
        -54
      ],
      [
        49,
        -11
      ],
      [
        50,
        -22
      ],
      [
        25,
        -22
      ],
      [
        25,
        11
      ],
      [
        0,
        98
      ],
      [
        24,
        32
      ],
      [
        50,
        11
      ],
      [
        12,
        22
      ],
      [
        25,
        0
      ],
      [
        0,
        -423
      ],
      [
        0,
        -347
      ],
      [
        -12,
        -33
      ],
      [
        -13,
        -10
      ],
      [
        -37,
        54
      ],
      [
        0,
        43
      ],
      [
        -12,
        33
      ],
      [
        -37,
        -11
      ],
      [
        -75,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        0
      ],
      [
        -37,
        11
      ],
      [
        -25,
        43
      ],
      [
        -25,
        119
      ],
      [
        -50,
        120
      ],
      [
        -24,
        43
      ],
      [
        -38,
        11
      ],
      [
        -12,
        54
      ],
      [
        -12,
        76
      ],
      [
        -25,
        65
      ],
      [
        -12,
        22
      ],
      [
        -50,
        32
      ],
      [
        -50,
        44
      ],
      [
        -74,
        54
      ],
      [
        -37,
        0
      ],
      [
        -37,
        11
      ],
      [
        -25,
        22
      ],
      [
        -12,
        21
      ],
      [
        -25,
        76
      ],
      [
        -13,
        76
      ],
      [
        -61,
        109
      ],
      [
        -25,
        108
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -98
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -33
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -62,
        11
      ],
      [
        -25,
        11
      ],
      [
        -87,
        22
      ],
      [
        -25,
        0
      ],
      [
        -37,
        21
      ],
      [
        -25,
        22
      ],
      [
        -74,
        54
      ],
      [
        -37,
        -11
      ],
      [
        -62,
        87
      ],
      [
        -12,
        44
      ],
      [
        -13,
        86
      ],
      [
        0,
        55
      ],
      [
        13,
        54
      ],
      [
        -13,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        -11
      ],
      [
        -62,
        -33
      ],
      [
        -74,
        -32
      ],
      [
        -50,
        -54
      ],
      [
        -12,
        0
      ],
      [
        -37,
        21
      ],
      [
        -13,
        22
      ],
      [
        25,
        76
      ],
      [
        -12,
        76
      ],
      [
        -25,
        43
      ],
      [
        -37,
        22
      ],
      [
        -25,
        0
      ],
      [
        0,
        43
      ],
      [
        -13,
        44
      ],
      [
        -37,
        11
      ]
    ],
    [
      [
        66421,
        52545
      ],
      [
        -25,
        22
      ],
      [
        -49,
        -11
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        -54
      ],
      [
        -50,
        -33
      ],
      [
        -37,
        11
      ],
      [
        -37,
        65
      ],
      [
        -37,
        87
      ]
    ],
    [
      [
        66421,
        53315
      ],
      [
        12,
        22
      ],
      [
        13,
        0
      ],
      [
        24,
        -65
      ],
      [
        62,
        -76
      ],
      [
        13,
        0
      ],
      [
        12,
        21
      ],
      [
        25,
        22
      ],
      [
        37,
        22
      ],
      [
        12,
        21
      ],
      [
        13,
        44
      ],
      [
        0,
        108
      ],
      [
        25,
        11
      ],
      [
        37,
        -32
      ],
      [
        12,
        0
      ],
      [
        37,
        43
      ],
      [
        38,
        11
      ],
      [
        74,
        65
      ],
      [
        25,
        -76
      ],
      [
        0,
        -22
      ],
      [
        -13,
        -32
      ],
      [
        -12,
        -55
      ],
      [
        12,
        -54
      ],
      [
        0,
        -97
      ],
      [
        25,
        -22
      ],
      [
        25,
        11
      ],
      [
        25,
        -22
      ],
      [
        37,
        0
      ],
      [
        62,
        109
      ],
      [
        74,
        151
      ],
      [
        50,
        98
      ],
      [
        49,
        43
      ],
      [
        25,
        44
      ],
      [
        12,
        54
      ],
      [
        25,
        33
      ],
      [
        62,
        32
      ],
      [
        37,
        33
      ],
      [
        37,
        97
      ],
      [
        50,
        195
      ],
      [
        25,
        163
      ],
      [
        0,
        456
      ],
      [
        0,
        184
      ],
      [
        74,
        130
      ],
      [
        37,
        76
      ],
      [
        37,
        87
      ],
      [
        50,
        206
      ],
      [
        37,
        97
      ],
      [
        25,
        55
      ],
      [
        49,
        43
      ],
      [
        62,
        43
      ],
      [
        87,
        141
      ],
      [
        74,
        141
      ],
      [
        -12,
        163
      ],
      [
        25,
        141
      ],
      [
        37,
        184
      ],
      [
        12,
        185
      ],
      [
        -12,
        206
      ],
      [
        0,
        163
      ],
      [
        37,
        184
      ],
      [
        25,
        76
      ],
      [
        0,
        293
      ],
      [
        49,
        249
      ],
      [
        37,
        152
      ],
      [
        62,
        173
      ],
      [
        13,
        98
      ],
      [
        25,
        141
      ],
      [
        0,
        108
      ]
    ],
    [
      [
        71351,
        59410
      ],
      [
        12,
        -43
      ],
      [
        25,
        -55
      ],
      [
        50,
        -76
      ],
      [
        25,
        -32
      ],
      [
        12,
        -54
      ],
      [
        25,
        -65
      ],
      [
        49,
        -44
      ],
      [
        13,
        -32
      ],
      [
        62,
        -76
      ],
      [
        24,
        0
      ],
      [
        38,
        -22
      ],
      [
        24,
        0
      ],
      [
        62,
        87
      ],
      [
        37,
        32
      ],
      [
        75,
        -11
      ],
      [
        74,
        -65
      ],
      [
        25,
        0
      ],
      [
        49,
        65
      ],
      [
        38,
        76
      ],
      [
        24,
        11
      ],
      [
        37,
        -32
      ],
      [
        38,
        -65
      ],
      [
        37,
        -87
      ],
      [
        12,
        -43
      ],
      [
        37,
        -55
      ],
      [
        62,
        -119
      ],
      [
        75,
        -65
      ],
      [
        24,
        -33
      ],
      [
        25,
        -65
      ],
      [
        0,
        -43
      ],
      [
        13,
        -22
      ],
      [
        12,
        11
      ],
      [
        25,
        0
      ],
      [
        12,
        -11
      ],
      [
        37,
        -87
      ]
    ],
    [
      [
        66062,
        53087
      ],
      [
        -13,
        11
      ],
      [
        -37,
        76
      ],
      [
        -25,
        65
      ],
      [
        0,
        33
      ],
      [
        -12,
        21
      ],
      [
        0,
        65
      ],
      [
        -37,
        87
      ],
      [
        -99,
        141
      ],
      [
        0,
        43
      ],
      [
        -87,
        141
      ]
    ],
    [
      [
        65752,
        53770
      ],
      [
        37,
        141
      ],
      [
        25,
        33
      ],
      [
        74,
        76
      ],
      [
        0,
        -11
      ],
      [
        62,
        -98
      ],
      [
        13,
        -10
      ],
      [
        12,
        10
      ],
      [
        25,
        -10
      ],
      [
        12,
        21
      ],
      [
        0,
        22
      ],
      [
        -12,
        32
      ],
      [
        0,
        33
      ],
      [
        12,
        33
      ],
      [
        0,
        32
      ],
      [
        13,
        43
      ],
      [
        0,
        22
      ],
      [
        -13,
        22
      ],
      [
        -37,
        32
      ],
      [
        -25,
        33
      ],
      [
        0,
        76
      ],
      [
        25,
        32
      ],
      [
        0,
        11
      ],
      [
        -25,
        33
      ],
      [
        -25,
        54
      ],
      [
        -37,
        11
      ],
      [
        25,
        97
      ],
      [
        0,
        206
      ],
      [
        25,
        -10
      ],
      [
        25,
        -22
      ],
      [
        49,
        32
      ],
      [
        25,
        0
      ],
      [
        12,
        -21
      ],
      [
        25,
        -22
      ],
      [
        136,
        54
      ],
      [
        0,
        55
      ],
      [
        13,
        43
      ],
      [
        0,
        43
      ],
      [
        -25,
        76
      ],
      [
        0,
        33
      ],
      [
        12,
        21
      ],
      [
        50,
        44
      ],
      [
        12,
        0
      ],
      [
        25,
        -22
      ],
      [
        25,
        -43
      ],
      [
        25,
        -87
      ],
      [
        24,
        -65
      ],
      [
        25,
        -87
      ],
      [
        50,
        -32
      ],
      [
        74,
        -22
      ],
      [
        37,
        0
      ],
      [
        87,
        130
      ],
      [
        0,
        33
      ],
      [
        25,
        -11
      ],
      [
        12,
        -76
      ],
      [
        25,
        -54
      ],
      [
        -13,
        -44
      ],
      [
        13,
        -21
      ],
      [
        37,
        -11
      ],
      [
        25,
        11
      ],
      [
        12,
        32
      ],
      [
        25,
        43
      ],
      [
        0,
        33
      ],
      [
        -12,
        22
      ],
      [
        0,
        32
      ],
      [
        12,
        22
      ],
      [
        25,
        65
      ],
      [
        0,
        43
      ],
      [
        12,
        33
      ],
      [
        37,
        32
      ],
      [
        13,
        120
      ],
      [
        -13,
        32
      ],
      [
        0,
        44
      ],
      [
        13,
        32
      ],
      [
        12,
        76
      ],
      [
        -12,
        109
      ],
      [
        0,
        86
      ],
      [
        -13,
        76
      ],
      [
        25,
        228
      ],
      [
        0,
        22
      ],
      [
        -12,
        32
      ],
      [
        -25,
        33
      ],
      [
        -50,
        32
      ],
      [
        -24,
        33
      ],
      [
        -13,
        43
      ],
      [
        -12,
        22
      ],
      [
        -62,
        11
      ],
      [
        -13,
        32
      ],
      [
        0,
        65
      ],
      [
        13,
        109
      ],
      [
        0,
        130
      ],
      [
        12,
        43
      ],
      [
        37,
        44
      ],
      [
        13,
        65
      ],
      [
        49,
        11
      ],
      [
        25,
        21
      ],
      [
        12,
        22
      ],
      [
        0,
        33
      ],
      [
        38,
        86
      ],
      [
        0,
        55
      ],
      [
        -13,
        65
      ],
      [
        -37,
        76
      ],
      [
        -12,
        119
      ],
      [
        -25,
        32
      ],
      [
        -37,
        22
      ],
      [
        -75,
        11
      ],
      [
        -49,
        -22
      ],
      [
        -62,
        -43
      ],
      [
        -87,
        -44
      ],
      [
        -25,
        0
      ],
      [
        -12,
        22
      ],
      [
        12,
        11
      ],
      [
        13,
        43
      ],
      [
        -25,
        109
      ],
      [
        0,
        152
      ],
      [
        12,
        86
      ],
      [
        25,
        109
      ],
      [
        0,
        43
      ]
    ],
    [
      [
        6962,
        42936
      ],
      [
        -37,
        22
      ],
      [
        12,
        21
      ],
      [
        25,
        -10
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        35044,
        57805
      ],
      [
        -25,
        11
      ],
      [
        0,
        32
      ],
      [
        12,
        22
      ],
      [
        13,
        -11
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        37385,
        63629
      ],
      [
        -25,
        -33
      ],
      [
        -49,
        -32
      ],
      [
        -62,
        -22
      ],
      [
        -87,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        -87,
        -260
      ],
      [
        -62,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -98
      ],
      [
        -12,
        -65
      ],
      [
        -50,
        -141
      ],
      [
        -24,
        -184
      ],
      [
        -13,
        -109
      ],
      [
        -12,
        -152
      ],
      [
        -13,
        -76
      ],
      [
        -24,
        -65
      ],
      [
        -38,
        -76
      ],
      [
        -24,
        -76
      ],
      [
        -13,
        -54
      ],
      [
        -12,
        -21
      ],
      [
        12,
        -22
      ],
      [
        50,
        22
      ],
      [
        49,
        43
      ],
      [
        13,
        -11
      ],
      [
        25,
        -76
      ],
      [
        37,
        0
      ],
      [
        12,
        -11
      ],
      [
        25,
        -162
      ],
      [
        25,
        -141
      ],
      [
        86,
        -152
      ],
      [
        0,
        -54
      ],
      [
        13,
        -87
      ],
      [
        0,
        -44
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        -54
      ],
      [
        -12,
        -98
      ],
      [
        0,
        -174
      ],
      [
        24,
        -76
      ],
      [
        62,
        -21
      ],
      [
        25,
        -76
      ],
      [
        25,
        -98
      ],
      [
        25,
        -43
      ],
      [
        37,
        -22
      ],
      [
        25,
        11
      ],
      [
        74,
        11
      ],
      [
        49,
        0
      ],
      [
        87,
        -22
      ],
      [
        74,
        0
      ],
      [
        62,
        54
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        38,
        -21
      ],
      [
        49,
        -44
      ],
      [
        37,
        -21
      ],
      [
        50,
        11
      ],
      [
        12,
        -11
      ],
      [
        62,
        -152
      ],
      [
        62,
        -130
      ],
      [
        99,
        -217
      ],
      [
        13,
        -11
      ],
      [
        37,
        11
      ],
      [
        12,
        -22
      ],
      [
        25,
        11
      ],
      [
        37,
        43
      ],
      [
        50,
        0
      ],
      [
        74,
        -21
      ],
      [
        87,
        0
      ],
      [
        111,
        21
      ],
      [
        74,
        33
      ],
      [
        25,
        32
      ],
      [
        50,
        -10
      ],
      [
        49,
        -22
      ],
      [
        37,
        -44
      ],
      [
        0,
        -32
      ],
      [
        13,
        -65
      ],
      [
        -13,
        -54
      ],
      [
        -37,
        -65
      ],
      [
        -12,
        -76
      ],
      [
        -13,
        -98
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -12,
        -65
      ],
      [
        12,
        -87
      ],
      [
        -12,
        -130
      ],
      [
        -13,
        -163
      ],
      [
        0,
        -98
      ],
      [
        25,
        -76
      ],
      [
        0,
        -119
      ],
      [
        25,
        -65
      ],
      [
        37,
        -206
      ],
      [
        25,
        -22
      ],
      [
        12,
        -21
      ],
      [
        62,
        -174
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        -87
      ],
      [
        -124,
        -206
      ],
      [
        0,
        -43
      ],
      [
        37,
        21
      ],
      [
        37,
        -10
      ],
      [
        25,
        -22
      ],
      [
        0,
        -54
      ],
      [
        37,
        -22
      ],
      [
        50,
        -109
      ],
      [
        37,
        -54
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -44
      ],
      [
        13,
        -76
      ],
      [
        24,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        25,
        -33
      ],
      [
        24,
        -162
      ],
      [
        13,
        -55
      ],
      [
        0,
        -21
      ],
      [
        25,
        -120
      ],
      [
        0,
        -43
      ],
      [
        12,
        -43
      ]
    ],
    [
      [
        37856,
        53564
      ],
      [
        -25,
        55
      ],
      [
        -25,
        43
      ],
      [
        -25,
        22
      ],
      [
        -12,
        32
      ],
      [
        -12,
        76
      ],
      [
        -25,
        22
      ],
      [
        -13,
        21
      ],
      [
        -49,
        -43
      ],
      [
        -74,
        54
      ],
      [
        -13,
        0
      ],
      [
        37,
        120
      ],
      [
        75,
        195
      ],
      [
        49,
        119
      ],
      [
        50,
        141
      ],
      [
        25,
        76
      ],
      [
        0,
        33
      ],
      [
        -13,
        21
      ],
      [
        -25,
        11
      ],
      [
        -24,
        22
      ],
      [
        -13,
        32
      ],
      [
        -49,
        44
      ],
      [
        -37,
        21
      ],
      [
        -13,
        22
      ],
      [
        -25,
        11
      ],
      [
        -24,
        32
      ],
      [
        -75,
        87
      ],
      [
        -12,
        0
      ],
      [
        -50,
        -21
      ],
      [
        -24,
        -44
      ],
      [
        -38,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -12,
        22
      ],
      [
        -25,
        11
      ],
      [
        -25,
        32
      ],
      [
        -37,
        33
      ],
      [
        -37,
        11
      ],
      [
        -62,
        -109
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        0
      ],
      [
        -38,
        -22
      ],
      [
        -37,
        22
      ],
      [
        -37,
        32
      ],
      [
        -12,
        -10
      ],
      [
        -50,
        -22
      ],
      [
        -49,
        0
      ],
      [
        -13,
        43
      ],
      [
        -62,
        33
      ],
      [
        0,
        76
      ],
      [
        13,
        43
      ],
      [
        -13,
        54
      ],
      [
        -12,
        76
      ],
      [
        0,
        33
      ],
      [
        -25,
        32
      ],
      [
        -25,
        0
      ],
      [
        -37,
        22
      ],
      [
        -25,
        65
      ],
      [
        13,
        65
      ],
      [
        -13,
        54
      ],
      [
        -24,
        33
      ],
      [
        -25,
        87
      ],
      [
        -25,
        21
      ],
      [
        -25,
        0
      ],
      [
        -25,
        11
      ],
      [
        -12,
        44
      ],
      [
        -25,
        21
      ],
      [
        -24,
        44
      ],
      [
        -62,
        32
      ],
      [
        -13,
        33
      ],
      [
        -25,
        43
      ],
      [
        13,
        33
      ],
      [
        -13,
        21
      ],
      [
        -12,
        44
      ],
      [
        -12,
        76
      ],
      [
        -13,
        32
      ],
      [
        -24,
        33
      ],
      [
        -25,
        65
      ],
      [
        -37,
        22
      ],
      [
        -13,
        21
      ],
      [
        -25,
        65
      ],
      [
        -49,
        0
      ],
      [
        -13,
        22
      ],
      [
        -49,
        65
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -43
      ]
    ],
    [
      [
        36022,
        56146
      ],
      [
        -62,
        43
      ],
      [
        -49,
        65
      ],
      [
        -62,
        11
      ],
      [
        -37,
        43
      ],
      [
        -25,
        65
      ],
      [
        -37,
        54
      ],
      [
        -62,
        66
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -25,
        22
      ],
      [
        -24,
        -22
      ],
      [
        -50,
        22
      ],
      [
        -37,
        11
      ],
      [
        -37,
        43
      ],
      [
        -13,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -37,
        22
      ],
      [
        0,
        22
      ],
      [
        -25,
        130
      ],
      [
        -62,
        54
      ],
      [
        0,
        33
      ],
      [
        -13,
        43
      ],
      [
        -49,
        -11
      ],
      [
        -62,
        44
      ],
      [
        -50,
        43
      ],
      [
        -49,
        54
      ],
      [
        -74,
        87
      ],
      [
        -25,
        32
      ],
      [
        -25,
        22
      ],
      [
        -25,
        54
      ],
      [
        -25,
        44
      ],
      [
        -12,
        11
      ]
    ],
    [
      [
        34796,
        57122
      ],
      [
        -12,
        43
      ],
      [
        -50,
        65
      ],
      [
        25,
        76
      ],
      [
        62,
        65
      ],
      [
        74,
        -54
      ],
      [
        0,
        97
      ],
      [
        -25,
        87
      ],
      [
        0,
        152
      ],
      [
        13,
        33
      ],
      [
        25,
        43
      ],
      [
        24,
        32
      ],
      [
        37,
        -10
      ],
      [
        13,
        32
      ],
      [
        62,
        -11
      ],
      [
        25,
        11
      ],
      [
        24,
        33
      ],
      [
        25,
        86
      ],
      [
        12,
        11
      ],
      [
        25,
        0
      ],
      [
        13,
        44
      ],
      [
        37,
        54
      ],
      [
        0,
        22
      ],
      [
        -13,
        75
      ],
      [
        50,
        22
      ],
      [
        25,
        109
      ],
      [
        25,
        65
      ],
      [
        12,
        0
      ],
      [
        12,
        76
      ],
      [
        37,
        76
      ],
      [
        50,
        206
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -12,
        22
      ],
      [
        0,
        97
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        65
      ],
      [
        0,
        44
      ],
      [
        13,
        43
      ],
      [
        0,
        33
      ],
      [
        -38,
        -22
      ],
      [
        0,
        22
      ],
      [
        25,
        32
      ],
      [
        13,
        33
      ],
      [
        24,
        32
      ],
      [
        0,
        44
      ],
      [
        13,
        76
      ],
      [
        0,
        119
      ],
      [
        -13,
        32
      ],
      [
        -12,
        152
      ],
      [
        0,
        152
      ],
      [
        -12,
        54
      ],
      [
        -50,
        76
      ],
      [
        74,
        87
      ],
      [
        25,
        65
      ],
      [
        -25,
        141
      ],
      [
        -49,
        108
      ],
      [
        0,
        66
      ],
      [
        25,
        0
      ],
      [
        12,
        141
      ],
      [
        0,
        43
      ],
      [
        -25,
        76
      ],
      [
        -25,
        0
      ],
      [
        -24,
        87
      ],
      [
        -25,
        21
      ],
      [
        -13,
        55
      ],
      [
        -37,
        108
      ],
      [
        -37,
        65
      ]
    ],
    [
      [
        35118,
        60733
      ],
      [
        25,
        130
      ],
      [
        25,
        22
      ],
      [
        12,
        32
      ],
      [
        -12,
        87
      ],
      [
        0,
        22
      ],
      [
        24,
        -11
      ],
      [
        25,
        -76
      ],
      [
        13,
        -11
      ],
      [
        12,
        11
      ],
      [
        74,
        87
      ],
      [
        -12,
        32
      ],
      [
        25,
        98
      ],
      [
        24,
        11
      ],
      [
        13,
        22
      ],
      [
        -13,
        43
      ],
      [
        -49,
        195
      ],
      [
        -12,
        54
      ],
      [
        -25,
        44
      ],
      [
        25,
        86
      ],
      [
        12,
        11
      ]
    ],
    [
      [
        35304,
        61622
      ],
      [
        12,
        -11
      ],
      [
        25,
        -86
      ],
      [
        50,
        -65
      ],
      [
        49,
        -87
      ],
      [
        13,
        -65
      ],
      [
        24,
        -44
      ],
      [
        0,
        -10
      ],
      [
        -24,
        -55
      ],
      [
        24,
        -43
      ],
      [
        25,
        11
      ],
      [
        13,
        43
      ],
      [
        0,
        195
      ],
      [
        -25,
        98
      ],
      [
        -25,
        65
      ],
      [
        0,
        33
      ],
      [
        37,
        10
      ],
      [
        37,
        33
      ],
      [
        137,
        184
      ],
      [
        49,
        174
      ],
      [
        37,
        65
      ],
      [
        50,
        43
      ],
      [
        49,
        -10
      ],
      [
        38,
        21
      ],
      [
        12,
        54
      ],
      [
        -12,
        76
      ],
      [
        -13,
        44
      ],
      [
        13,
        65
      ],
      [
        12,
        97
      ],
      [
        0,
        87
      ],
      [
        25,
        44
      ],
      [
        -13,
        21
      ],
      [
        -24,
        -43
      ],
      [
        -13,
        22
      ],
      [
        37,
        75
      ],
      [
        25,
        131
      ],
      [
        12,
        43
      ],
      [
        62,
        76
      ],
      [
        13,
        32
      ],
      [
        37,
        55
      ],
      [
        74,
        119
      ],
      [
        25,
        33
      ],
      [
        136,
        -76
      ],
      [
        37,
        10
      ],
      [
        0,
        -21
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        24,
        -44
      ],
      [
        25,
        -21
      ],
      [
        12,
        32
      ],
      [
        13,
        87
      ],
      [
        37,
        98
      ],
      [
        0,
        97
      ],
      [
        25,
        33
      ],
      [
        25,
        10
      ],
      [
        49,
        -10
      ],
      [
        37,
        -22
      ],
      [
        50,
        0
      ],
      [
        124,
        11
      ],
      [
        198,
        260
      ],
      [
        99,
        54
      ],
      [
        62,
        55
      ],
      [
        37,
        108
      ],
      [
        0,
        76
      ],
      [
        37,
        32
      ],
      [
        25,
        0
      ],
      [
        12,
        22
      ],
      [
        0,
        22
      ],
      [
        75,
        76
      ],
      [
        74,
        0
      ],
      [
        87,
        -54
      ],
      [
        37,
        -109
      ],
      [
        0,
        -76
      ],
      [
        -50,
        -76
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        76987,
        48521
      ],
      [
        -37,
        -21
      ],
      [
        -12,
        43
      ],
      [
        0,
        22
      ],
      [
        25,
        -11
      ],
      [
        24,
        -33
      ]
    ],
    [
      [
        77223,
        48662
      ],
      [
        24,
        -86
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -12,
        11
      ],
      [
        -25,
        54
      ],
      [
        -62,
        43
      ],
      [
        25,
        11
      ],
      [
        12,
        -11
      ],
      [
        25,
        11
      ],
      [
        0,
        22
      ],
      [
        12,
        21
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        76876,
        48782
      ],
      [
        0,
        -11
      ],
      [
        -50,
        43
      ],
      [
        -24,
        54
      ],
      [
        0,
        206
      ],
      [
        12,
        22
      ],
      [
        25,
        11
      ],
      [
        12,
        -22
      ],
      [
        0,
        -130
      ],
      [
        25,
        -87
      ],
      [
        12,
        -65
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        53563,
        65494
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -24,
        54
      ],
      [
        12,
        33
      ],
      [
        37,
        33
      ],
      [
        12,
        -11
      ],
      [
        13,
        -55
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        53947,
        65668
      ],
      [
        -13,
        0
      ],
      [
        -12,
        32
      ],
      [
        0,
        44
      ],
      [
        12,
        43
      ],
      [
        25,
        0
      ],
      [
        13,
        -33
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -21
      ]
    ],
    [
      [
        53860,
        65592
      ],
      [
        -25,
        -65
      ],
      [
        -49,
        10
      ],
      [
        -50,
        98
      ],
      [
        0,
        54
      ],
      [
        13,
        44
      ],
      [
        0,
        54
      ],
      [
        24,
        0
      ],
      [
        0,
        -33
      ],
      [
        50,
        -86
      ],
      [
        37,
        -76
      ]
    ],
    [
      [
        54034,
        66362
      ],
      [
        37,
        -22
      ],
      [
        25,
        11
      ],
      [
        24,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -25,
        33
      ],
      [
        25,
        65
      ],
      [
        -12,
        65
      ]
    ],
    [
      [
        53637,
        66600
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -11
      ],
      [
        -49,
        22
      ],
      [
        -13,
        -11
      ],
      [
        -25,
        -54
      ],
      [
        -24,
        75
      ],
      [
        0,
        33
      ],
      [
        12,
        11
      ],
      [
        37,
        -22
      ],
      [
        62,
        -11
      ]
    ],
    [
      [
        54046,
        66622
      ],
      [
        -12,
        -33
      ],
      [
        -13,
        44
      ],
      [
        -12,
        76
      ],
      [
        25,
        21
      ],
      [
        12,
        0
      ],
      [
        0,
        -108
      ]
    ],
    [
      [
        53365,
        66720
      ],
      [
        -50,
        -11
      ],
      [
        -25,
        21
      ],
      [
        13,
        22
      ],
      [
        37,
        33
      ],
      [
        25,
        -44
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        53266,
        66795
      ],
      [
        -38,
        -10
      ],
      [
        -12,
        10
      ],
      [
        0,
        44
      ],
      [
        -12,
        32
      ],
      [
        0,
        22
      ],
      [
        74,
        65
      ],
      [
        37,
        -11
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -32
      ],
      [
        -49,
        -66
      ]
    ],
    [
      [
        33520,
        62197
      ],
      [
        0,
        -11
      ],
      [
        -25,
        -21
      ],
      [
        0,
        -11
      ],
      [
        -37,
        21
      ],
      [
        -25,
        33
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -249
      ],
      [
        25,
        0
      ],
      [
        37,
        -44
      ],
      [
        12,
        -21
      ],
      [
        0,
        -33
      ],
      [
        -49,
        -65
      ],
      [
        -13,
        -32
      ],
      [
        25,
        -66
      ],
      [
        0,
        -119
      ],
      [
        -62,
        -65
      ],
      [
        0,
        -22
      ],
      [
        25,
        -32
      ],
      [
        25,
        -76
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        33409,
        61254
      ],
      [
        -25,
        76
      ],
      [
        -25,
        65
      ],
      [
        -37,
        32
      ],
      [
        0,
        98
      ],
      [
        -12,
        54
      ],
      [
        -38,
        43
      ],
      [
        -37,
        33
      ],
      [
        -25,
        0
      ],
      [
        13,
        -54
      ],
      [
        49,
        -98
      ],
      [
        0,
        -43
      ],
      [
        -37,
        11
      ],
      [
        -49,
        21
      ],
      [
        -25,
        22
      ],
      [
        -50,
        76
      ],
      [
        38,
        76
      ],
      [
        12,
        43
      ],
      [
        0,
        98
      ],
      [
        -12,
        54
      ],
      [
        -87,
        152
      ],
      [
        -75,
        65
      ],
      [
        -37,
        43
      ],
      [
        -99,
        44
      ],
      [
        -25,
        21
      ],
      [
        -37,
        87
      ],
      [
        13,
        54
      ],
      [
        -25,
        65
      ],
      [
        -112,
        141
      ],
      [
        -49,
        55
      ],
      [
        -25,
        32
      ],
      [
        12,
        -98
      ],
      [
        25,
        -54
      ],
      [
        87,
        -76
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -11
      ],
      [
        -75,
        141
      ],
      [
        -99,
        65
      ],
      [
        -25,
        33
      ],
      [
        -37,
        108
      ],
      [
        -12,
        98
      ],
      [
        0,
        65
      ],
      [
        49,
        108
      ],
      [
        13,
        44
      ],
      [
        -13,
        21
      ],
      [
        13,
        44
      ],
      [
        -25,
        32
      ],
      [
        -37,
        33
      ],
      [
        -25,
        32
      ],
      [
        0,
        11
      ],
      [
        50,
        44
      ],
      [
        0,
        43
      ]
    ],
    [
      [
        32418,
        63119
      ],
      [
        24,
        22
      ],
      [
        13,
        43
      ],
      [
        12,
        22
      ],
      [
        13,
        0
      ],
      [
        12,
        -22
      ],
      [
        62,
        -32
      ],
      [
        62,
        -44
      ],
      [
        99,
        -54
      ],
      [
        37,
        32
      ],
      [
        25,
        33
      ],
      [
        25,
        0
      ],
      [
        49,
        -43
      ],
      [
        37,
        -11
      ],
      [
        13,
        11
      ],
      [
        37,
        -55
      ],
      [
        12,
        -32
      ],
      [
        0,
        -33
      ],
      [
        13,
        -11
      ],
      [
        24,
        0
      ],
      [
        62,
        -21
      ],
      [
        38,
        0
      ],
      [
        37,
        32
      ],
      [
        12,
        22
      ],
      [
        13,
        54
      ]
    ],
    [
      [
        33149,
        63032
      ],
      [
        12,
        -21
      ],
      [
        0,
        -44
      ],
      [
        12,
        -43
      ],
      [
        37,
        -174
      ],
      [
        38,
        -97
      ],
      [
        74,
        -163
      ],
      [
        37,
        -33
      ],
      [
        50,
        -141
      ],
      [
        24,
        -21
      ],
      [
        13,
        -44
      ],
      [
        62,
        -32
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        33520,
        69691
      ],
      [
        -99,
        -87
      ],
      [
        -37,
        0
      ],
      [
        -37,
        22
      ],
      [
        -25,
        33
      ],
      [
        -12,
        43
      ],
      [
        49,
        -22
      ],
      [
        12,
        22
      ],
      [
        -37,
        119
      ],
      [
        37,
        98
      ],
      [
        100,
        -33
      ],
      [
        49,
        -162
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        35205,
        69930
      ],
      [
        -13,
        -22
      ],
      [
        -49,
        43
      ],
      [
        -25,
        33
      ],
      [
        0,
        33
      ],
      [
        99,
        -22
      ],
      [
        -12,
        -65
      ]
    ],
    [
      [
        35130,
        70038
      ],
      [
        -49,
        22
      ],
      [
        -12,
        22
      ],
      [
        24,
        21
      ],
      [
        37,
        -11
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -11
      ]
    ],
    [
      [
        35081,
        70136
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        22
      ],
      [
        -25,
        10
      ],
      [
        -24,
        33
      ],
      [
        -13,
        33
      ],
      [
        25,
        10
      ],
      [
        37,
        -32
      ],
      [
        13,
        -54
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        34870,
        70298
      ],
      [
        50,
        -10
      ],
      [
        12,
        10
      ],
      [
        37,
        -10
      ],
      [
        25,
        -44
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        11
      ],
      [
        -50,
        0
      ],
      [
        -49,
        44
      ],
      [
        24,
        10
      ]
    ],
    [
      [
        34623,
        70374
      ],
      [
        0,
        -21
      ],
      [
        -62,
        43
      ],
      [
        -25,
        54
      ],
      [
        12,
        11
      ],
      [
        75,
        -87
      ]
    ],
    [
      [
        33768,
        70678
      ],
      [
        87,
        -22
      ],
      [
        74,
        11
      ],
      [
        37,
        11
      ],
      [
        0,
        -22
      ],
      [
        25,
        -43
      ],
      [
        62,
        22
      ],
      [
        124,
        11
      ],
      [
        37,
        -55
      ],
      [
        62,
        -43
      ],
      [
        37,
        -11
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        37,
        -43
      ],
      [
        50,
        10
      ],
      [
        -13,
        -43
      ],
      [
        62,
        -54
      ],
      [
        50,
        -98
      ],
      [
        24,
        -43
      ],
      [
        62,
        -65
      ],
      [
        38,
        -11
      ],
      [
        111,
        0
      ],
      [
        50,
        -22
      ],
      [
        0,
        11
      ],
      [
        198,
        -163
      ],
      [
        49,
        -86
      ],
      [
        37,
        -44
      ],
      [
        112,
        -87
      ],
      [
        25,
        11
      ],
      [
        -37,
        55
      ],
      [
        0,
        10
      ],
      [
        37,
        -10
      ],
      [
        62,
        -98
      ],
      [
        49,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        -62,
        11
      ],
      [
        37,
        -44
      ],
      [
        0,
        -32
      ],
      [
        25,
        -11
      ],
      [
        12,
        43
      ],
      [
        25,
        33
      ],
      [
        50,
        -87
      ],
      [
        37,
        -32
      ],
      [
        -13,
        -44
      ],
      [
        50,
        22
      ],
      [
        25,
        -54
      ],
      [
        62,
        0
      ],
      [
        74,
        -33
      ],
      [
        62,
        -54
      ],
      [
        62,
        -22
      ],
      [
        62,
        0
      ],
      [
        25,
        -32
      ],
      [
        12,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        25,
        -32
      ],
      [
        -50,
        -22
      ],
      [
        0,
        -43
      ],
      [
        13,
        -22
      ],
      [
        25,
        22
      ],
      [
        37,
        -11
      ],
      [
        62,
        -11
      ],
      [
        49,
        0
      ],
      [
        87,
        -22
      ],
      [
        25,
        -11
      ],
      [
        74,
        -86
      ],
      [
        50,
        -87
      ],
      [
        49,
        -33
      ],
      [
        50,
        0
      ],
      [
        24,
        -21
      ],
      [
        13,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        -24,
        -55
      ],
      [
        -62,
        0
      ],
      [
        -75,
        -10
      ],
      [
        -111,
        -65
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -11
      ],
      [
        -24,
        33
      ],
      [
        -13,
        -22
      ],
      [
        -25,
        -22
      ],
      [
        -86,
        0
      ],
      [
        -75,
        44
      ],
      [
        -136,
        21
      ],
      [
        -37,
        0
      ],
      [
        -87,
        -21
      ],
      [
        -99,
        -11
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -22
      ],
      [
        -75,
        0
      ],
      [
        -86,
        -22
      ],
      [
        -87,
        0
      ],
      [
        62,
        141
      ],
      [
        111,
        141
      ],
      [
        25,
        22
      ],
      [
        25,
        65
      ],
      [
        -37,
        76
      ],
      [
        -13,
        44
      ],
      [
        -37,
        21
      ],
      [
        -49,
        11
      ],
      [
        -37,
        0
      ],
      [
        -87,
        11
      ],
      [
        -50,
        0
      ],
      [
        -49,
        32
      ],
      [
        -62,
        109
      ],
      [
        -37,
        22
      ],
      [
        -25,
        54
      ],
      [
        -12,
        152
      ],
      [
        -13,
        76
      ],
      [
        -25,
        65
      ],
      [
        -62,
        65
      ],
      [
        -123,
        -44
      ],
      [
        -38,
        0
      ],
      [
        -24,
        22
      ],
      [
        -199,
        98
      ],
      [
        -74,
        54
      ],
      [
        -62,
        65
      ],
      [
        -25,
        54
      ],
      [
        -24,
        33
      ],
      [
        -13,
        -11
      ],
      [
        -161,
        0
      ],
      [
        -37,
        22
      ],
      [
        -37,
        65
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        -32
      ],
      [
        -25,
        54
      ],
      [
        -124,
        11
      ],
      [
        -62,
        54
      ],
      [
        -37,
        65
      ],
      [
        37,
        22
      ],
      [
        75,
        21
      ],
      [
        24,
        44
      ],
      [
        0,
        43
      ],
      [
        -12,
        22
      ],
      [
        -62,
        32
      ],
      [
        -285,
        0
      ],
      [
        -37,
        -54
      ],
      [
        -62,
        -54
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        -62,
        -87
      ],
      [
        -37,
        -21
      ],
      [
        -37,
        11
      ],
      [
        -12,
        -11
      ],
      [
        -87,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -76
      ],
      [
        -13,
        -22
      ],
      [
        -74,
        -22
      ],
      [
        -74,
        -76
      ],
      [
        -13,
        0
      ],
      [
        0,
        87
      ],
      [
        -25,
        11
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        -54
      ],
      [
        -37,
        11
      ],
      [
        12,
        21
      ],
      [
        124,
        98
      ],
      [
        25,
        -11
      ],
      [
        25,
        11
      ],
      [
        12,
        22
      ],
      [
        -25,
        108
      ],
      [
        13,
        76
      ],
      [
        25,
        65
      ],
      [
        86,
        119
      ],
      [
        273,
        185
      ],
      [
        25,
        11
      ],
      [
        173,
        43
      ],
      [
        25,
        11
      ],
      [
        86,
        54
      ],
      [
        87,
        22
      ],
      [
        87,
        -22
      ]
    ],
    [
      [
        38264,
        63748
      ],
      [
        -12,
        -11
      ],
      [
        -62,
        65
      ],
      [
        -62,
        98
      ],
      [
        0,
        43
      ],
      [
        13,
        0
      ],
      [
        12,
        -21
      ],
      [
        25,
        -66
      ],
      [
        62,
        -43
      ],
      [
        24,
        -65
      ]
    ],
    [
      [
        33929,
        68303
      ],
      [
        25,
        -11
      ],
      [
        0,
        22
      ],
      [
        62,
        -11
      ],
      [
        0,
        -33
      ],
      [
        -38,
        0
      ],
      [
        -24,
        -21
      ],
      [
        -37,
        11
      ],
      [
        12,
        43
      ]
    ],
    [
      [
        34412,
        68520
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -22
      ],
      [
        0,
        22
      ],
      [
        13,
        11
      ],
      [
        37,
        0
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        73618,
        78118
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -33
      ],
      [
        -50,
        -22
      ],
      [
        -12,
        11
      ],
      [
        -37,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -13,
        11
      ],
      [
        0,
        55
      ],
      [
        -25,
        43
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -13,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -62,
        -43
      ],
      [
        -12,
        0
      ],
      [
        -50,
        43
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        73184,
        78183
      ],
      [
        13,
        -11
      ],
      [
        37,
        22
      ],
      [
        25,
        54
      ],
      [
        0,
        76
      ],
      [
        62,
        -22
      ],
      [
        62,
        -11
      ],
      [
        49,
        0
      ],
      [
        50,
        11
      ],
      [
        161,
        76
      ],
      [
        49,
        44
      ],
      [
        75,
        43
      ],
      [
        12,
        -22
      ],
      [
        -173,
        -184
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -44
      ],
      [
        25,
        -43
      ]
    ],
    [
      [
        73618,
        78118
      ],
      [
        25,
        -44
      ],
      [
        -87,
        -21
      ],
      [
        -37,
        11
      ],
      [
        -62,
        -109
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        -87,
        -22
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -24,
        11
      ],
      [
        -25,
        54
      ],
      [
        -62,
        -10
      ],
      [
        -62,
        32
      ],
      [
        -37,
        43
      ],
      [
        -25,
        120
      ],
      [
        -12,
        76
      ],
      [
        37,
        -22
      ],
      [
        25,
        22
      ],
      [
        24,
        43
      ],
      [
        38,
        22
      ],
      [
        24,
        -11
      ]
    ],
    [
      [
        68403,
        87141
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        0
      ],
      [
        -75,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        -74,
        -55
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        -50,
        -32
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        -11
      ],
      [
        -75,
        11
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -109
      ]
    ],
    [
      [
        66681,
        86675
      ],
      [
        -50,
        76
      ],
      [
        -49,
        43
      ],
      [
        -37,
        0
      ],
      [
        -13,
        33
      ],
      [
        -37,
        54
      ],
      [
        -25,
        11
      ],
      [
        -24,
        32
      ],
      [
        -37,
        65
      ],
      [
        -38,
        44
      ],
      [
        -37,
        0
      ],
      [
        -49,
        43
      ],
      [
        -38,
        108
      ],
      [
        -24,
        33
      ],
      [
        -25,
        54
      ],
      [
        -12,
        11
      ],
      [
        49,
        87
      ],
      [
        -25,
        54
      ],
      [
        -62,
        54
      ],
      [
        -24,
        33
      ],
      [
        -38,
        108
      ],
      [
        13,
        22
      ],
      [
        37,
        -43
      ],
      [
        12,
        -33
      ],
      [
        13,
        11
      ],
      [
        12,
        43
      ],
      [
        37,
        44
      ],
      [
        37,
        32
      ],
      [
        25,
        0
      ],
      [
        50,
        22
      ],
      [
        62,
        -11
      ],
      [
        25,
        43
      ],
      [
        49,
        22
      ],
      [
        25,
        33
      ],
      [
        37,
        21
      ],
      [
        37,
        11
      ],
      [
        37,
        54
      ],
      [
        50,
        0
      ],
      [
        136,
        76
      ],
      [
        25,
        22
      ],
      [
        62,
        22
      ],
      [
        0,
        11
      ],
      [
        -37,
        32
      ],
      [
        12,
        43
      ],
      [
        74,
        -21
      ],
      [
        25,
        -54
      ],
      [
        13,
        0
      ],
      [
        0,
        -44
      ],
      [
        49,
        -22
      ],
      [
        13,
        33
      ]
    ],
    [
      [
        67016,
        87987
      ],
      [
        37,
        0
      ],
      [
        24,
        11
      ],
      [
        0,
        87
      ],
      [
        100,
        -44
      ],
      [
        0,
        -43
      ],
      [
        24,
        -44
      ],
      [
        50,
        -10
      ],
      [
        62,
        -33
      ],
      [
        25,
        0
      ],
      [
        49,
        -43
      ],
      [
        25,
        0
      ],
      [
        25,
        -44
      ],
      [
        12,
        11
      ],
      [
        74,
        22
      ],
      [
        50,
        -44
      ],
      [
        -12,
        -43
      ],
      [
        -38,
        -22
      ],
      [
        -24,
        -32
      ],
      [
        24,
        -33
      ],
      [
        75,
        -76
      ],
      [
        37,
        -86
      ],
      [
        25,
        -11
      ],
      [
        24,
        11
      ],
      [
        13,
        21
      ],
      [
        37,
        33
      ],
      [
        37,
        22
      ],
      [
        -25,
        65
      ],
      [
        -12,
        54
      ],
      [
        87,
        -33
      ],
      [
        99,
        -76
      ],
      [
        49,
        0
      ],
      [
        50,
        33
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        -22
      ],
      [
        74,
        -108
      ],
      [
        50,
        11
      ],
      [
        24,
        21
      ],
      [
        62,
        -43
      ],
      [
        25,
        -33
      ],
      [
        25,
        11
      ],
      [
        49,
        -11
      ],
      [
        25,
        -21
      ],
      [
        0,
        -76
      ],
      [
        74,
        -87
      ],
      [
        13,
        -65
      ]
    ],
    [
      [
        66817,
        89917
      ],
      [
        -12,
        -21
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        66817,
        89863
      ],
      [
        -62,
        0
      ],
      [
        -37,
        11
      ],
      [
        -12,
        33
      ],
      [
        12,
        32
      ],
      [
        -37,
        43
      ],
      [
        0,
        44
      ],
      [
        74,
        -54
      ],
      [
        62,
        -55
      ]
    ],
    [
      [
        65802,
        90210
      ],
      [
        -50,
        0
      ],
      [
        -25,
        22
      ],
      [
        13,
        43
      ],
      [
        49,
        -21
      ],
      [
        13,
        -44
      ]
    ],
    [
      [
        66644,
        90189
      ],
      [
        0,
        -66
      ],
      [
        -37,
        33
      ],
      [
        -50,
        0
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -62,
        43
      ],
      [
        -12,
        44
      ],
      [
        12,
        97
      ],
      [
        25,
        22
      ],
      [
        0,
        32
      ],
      [
        25,
        44
      ],
      [
        37,
        0
      ],
      [
        25,
        -54
      ],
      [
        49,
        -22
      ],
      [
        12,
        -33
      ],
      [
        -37,
        -43
      ],
      [
        13,
        -22
      ],
      [
        37,
        -21
      ]
    ],
    [
      [
        64885,
        90395
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -24,
        22
      ],
      [
        24,
        21
      ],
      [
        37,
        0
      ],
      [
        13,
        -21
      ]
    ],
    [
      [
        66830,
        89776
      ],
      [
        12,
        -65
      ],
      [
        0,
        -43
      ],
      [
        37,
        -174
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        50,
        -65
      ],
      [
        86,
        -76
      ],
      [
        38,
        -76
      ],
      [
        -25,
        -108
      ],
      [
        25,
        -55
      ],
      [
        24,
        -10
      ],
      [
        0,
        -87
      ],
      [
        25,
        -22
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -32
      ],
      [
        -24,
        -44
      ],
      [
        0,
        -43
      ],
      [
        37,
        -65
      ],
      [
        0,
        -87
      ],
      [
        62,
        -32
      ],
      [
        37,
        -141
      ],
      [
        -13,
        -98
      ],
      [
        -61,
        -141
      ]
    ],
    [
      [
        64550,
        85948
      ],
      [
        -24,
        0
      ],
      [
        -13,
        43
      ],
      [
        0,
        66
      ],
      [
        25,
        86
      ],
      [
        0,
        98
      ],
      [
        12,
        54
      ],
      [
        50,
        163
      ],
      [
        12,
        87
      ],
      [
        13,
        54
      ],
      [
        99,
        141
      ],
      [
        0,
        65
      ],
      [
        -112,
        43
      ],
      [
        -74,
        11
      ],
      [
        -50,
        54
      ],
      [
        -86,
        -21
      ],
      [
        -25,
        10
      ],
      [
        -37,
        0
      ],
      [
        -13,
        33
      ],
      [
        -37,
        22
      ],
      [
        -37,
        -44
      ],
      [
        -12,
        11
      ],
      [
        -37,
        76
      ],
      [
        -38,
        65
      ],
      [
        -24,
        33
      ],
      [
        -38,
        11
      ]
    ],
    [
      [
        64104,
        87109
      ],
      [
        0,
        32
      ],
      [
        13,
        54
      ],
      [
        25,
        55
      ],
      [
        12,
        10
      ],
      [
        0,
        65
      ],
      [
        -50,
        22
      ],
      [
        -49,
        43
      ],
      [
        -25,
        44
      ],
      [
        0,
        87
      ]
    ],
    [
      [
        63981,
        87911
      ],
      [
        24,
        98
      ],
      [
        -12,
        32
      ],
      [
        -50,
        33
      ],
      [
        0,
        21
      ],
      [
        25,
        0
      ],
      [
        62,
        66
      ],
      [
        -12,
        21
      ],
      [
        0,
        33
      ],
      [
        37,
        108
      ],
      [
        0,
        54
      ],
      [
        -37,
        65
      ],
      [
        -13,
        44
      ],
      [
        -37,
        65
      ],
      [
        0,
        22
      ],
      [
        75,
        54
      ],
      [
        74,
        -33
      ],
      [
        49,
        11
      ],
      [
        75,
        33
      ],
      [
        25,
        43
      ],
      [
        -38,
        54
      ],
      [
        99,
        87
      ],
      [
        13,
        43
      ],
      [
        0,
        66
      ],
      [
        -13,
        43
      ],
      [
        -49,
        0
      ],
      [
        -37,
        11
      ],
      [
        -13,
        21
      ],
      [
        0,
        66
      ],
      [
        13,
        21
      ],
      [
        99,
        0
      ],
      [
        0,
        11
      ],
      [
        49,
        195
      ],
      [
        13,
        22
      ],
      [
        0,
        173
      ]
    ],
    [
      [
        64402,
        89494
      ],
      [
        -13,
        33
      ],
      [
        -37,
        33
      ],
      [
        0,
        65
      ],
      [
        13,
        43
      ],
      [
        37,
        65
      ],
      [
        25,
        11
      ],
      [
        123,
        11
      ],
      [
        124,
        0
      ],
      [
        62,
        -98
      ],
      [
        -25,
        -43
      ],
      [
        38,
        -22
      ],
      [
        24,
        43
      ],
      [
        13,
        66
      ],
      [
        49,
        -33
      ],
      [
        25,
        0
      ],
      [
        -12,
        76
      ],
      [
        12,
        65
      ],
      [
        25,
        54
      ],
      [
        99,
        -21
      ],
      [
        111,
        10
      ],
      [
        38,
        -21
      ],
      [
        86,
        -130
      ],
      [
        25,
        0
      ],
      [
        -111,
        151
      ],
      [
        -38,
        22
      ],
      [
        -86,
        22
      ],
      [
        -25,
        54
      ],
      [
        0,
        163
      ],
      [
        -37,
        32
      ],
      [
        -50,
        -11
      ],
      [
        0,
        65
      ],
      [
        62,
        11
      ],
      [
        50,
        33
      ],
      [
        0,
        43
      ],
      [
        -25,
        33
      ],
      [
        -74,
        119
      ],
      [
        0,
        76
      ]
    ],
    [
      [
        64910,
        90514
      ],
      [
        62,
        0
      ],
      [
        12,
        -11
      ],
      [
        99,
        -32
      ],
      [
        25,
        -22
      ],
      [
        25,
        0
      ],
      [
        99,
        32
      ],
      [
        49,
        -21
      ]
    ],
    [
      [
        65281,
        90460
      ],
      [
        0,
        -11
      ],
      [
        50,
        -11
      ],
      [
        37,
        -76
      ],
      [
        12,
        -54
      ],
      [
        -62,
        -65
      ],
      [
        100,
        11
      ],
      [
        0,
        -22
      ],
      [
        24,
        -33
      ],
      [
        50,
        22
      ],
      [
        124,
        -76
      ],
      [
        74,
        33
      ],
      [
        25,
        0
      ],
      [
        12,
        -55
      ],
      [
        -12,
        -65
      ],
      [
        -74,
        -65
      ],
      [
        12,
        -43
      ],
      [
        25,
        -11
      ],
      [
        62,
        11
      ],
      [
        111,
        -43
      ],
      [
        12,
        21
      ],
      [
        87,
        87
      ],
      [
        37,
        22
      ],
      [
        99,
        11
      ],
      [
        25,
        43
      ],
      [
        50,
        32
      ],
      [
        25,
        44
      ],
      [
        61,
        76
      ],
      [
        162,
        -44
      ],
      [
        37,
        -76
      ],
      [
        111,
        -86
      ],
      [
        87,
        0
      ],
      [
        37,
        -76
      ],
      [
        12,
        -109
      ],
      [
        25,
        -32
      ],
      [
        37,
        -22
      ],
      [
        75,
        -22
      ]
    ],
    [
      [
        64786,
        90438
      ],
      [
        -13,
        76
      ],
      [
        38,
        -11
      ],
      [
        86,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -87,
        -10
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        76690,
        63086
      ],
      [
        -50,
        0
      ],
      [
        -12,
        22
      ],
      [
        -25,
        22
      ],
      [
        -37,
        11
      ],
      [
        -87,
        -55
      ],
      [
        -86,
        -21
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -25,
        22
      ],
      [
        -12,
        130
      ],
      [
        0,
        249
      ],
      [
        12,
        54
      ],
      [
        0,
        33
      ],
      [
        50,
        76
      ],
      [
        12,
        32
      ],
      [
        62,
        141
      ],
      [
        37,
        120
      ],
      [
        37,
        86
      ]
    ],
    [
      [
        76504,
        63997
      ],
      [
        25,
        44
      ],
      [
        12,
        -11
      ],
      [
        62,
        -87
      ],
      [
        13,
        0
      ],
      [
        24,
        33
      ],
      [
        13,
        87
      ],
      [
        25,
        32
      ],
      [
        37,
        33
      ],
      [
        49,
        21
      ]
    ],
    [
      [
        76764,
        64149
      ],
      [
        0,
        -21
      ],
      [
        62,
        -131
      ],
      [
        37,
        -173
      ],
      [
        -24,
        -98
      ],
      [
        -25,
        -32
      ],
      [
        -74,
        -87
      ],
      [
        -87,
        -65
      ],
      [
        -62,
        -109
      ],
      [
        -37,
        11
      ],
      [
        12,
        -43
      ],
      [
        13,
        -11
      ],
      [
        24,
        11
      ],
      [
        37,
        32
      ],
      [
        50,
        22
      ],
      [
        50,
        0
      ],
      [
        37,
        -22
      ],
      [
        25,
        -32
      ]
    ],
    [
      [
        76802,
        63401
      ],
      [
        -25,
        -87
      ],
      [
        -37,
        -108
      ],
      [
        -50,
        -120
      ]
    ],
    [
      [
        40841,
        65744
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        108
      ],
      [
        -25,
        87
      ],
      [
        12,
        43
      ],
      [
        0,
        22
      ],
      [
        50,
        -32
      ],
      [
        12,
        -33
      ],
      [
        12,
        -98
      ],
      [
        -12,
        -75
      ]
    ],
    [
      [
        65839,
        90503
      ],
      [
        49,
        -43
      ],
      [
        50,
        11
      ],
      [
        37,
        -44
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -50,
        -22
      ],
      [
        -136,
        87
      ],
      [
        0,
        109
      ],
      [
        75,
        0
      ],
      [
        37,
        -33
      ]
    ],
    [
      [
        65529,
        90471
      ],
      [
        -50,
        10
      ],
      [
        0,
        33
      ],
      [
        62,
        -33
      ],
      [
        -12,
        -10
      ]
    ],
    [
      [
        66247,
        90546
      ],
      [
        -24,
        -10
      ],
      [
        -50,
        10
      ],
      [
        -62,
        -43
      ],
      [
        -12,
        43
      ],
      [
        37,
        33
      ],
      [
        12,
        33
      ],
      [
        87,
        -44
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        65380,
        90503
      ],
      [
        -24,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -13,
        98
      ],
      [
        25,
        0
      ],
      [
        62,
        -55
      ],
      [
        12,
        -54
      ]
    ],
    [
      [
        65616,
        90416
      ],
      [
        -13,
        0
      ],
      [
        -24,
        44
      ],
      [
        0,
        21
      ],
      [
        37,
        65
      ],
      [
        49,
        55
      ],
      [
        13,
        65
      ],
      [
        12,
        0
      ],
      [
        -12,
        -54
      ],
      [
        -62,
        -196
      ]
    ],
    [
      [
        67115,
        90579
      ],
      [
        -13,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -62,
        43
      ],
      [
        13,
        87
      ],
      [
        12,
        33
      ],
      [
        124,
        -87
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -43
      ]
    ],
    [
      [
        65591,
        90948
      ],
      [
        25,
        -98
      ],
      [
        37,
        -76
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -87
      ],
      [
        -62,
        -54
      ],
      [
        -62,
        0
      ],
      [
        -62,
        21
      ],
      [
        -99,
        55
      ],
      [
        -38,
        119
      ],
      [
        0,
        97
      ],
      [
        50,
        11
      ],
      [
        99,
        44
      ],
      [
        25,
        0
      ],
      [
        25,
        -33
      ],
      [
        24,
        0
      ],
      [
        38,
        44
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        66285,
        90948
      ],
      [
        -38,
        -33
      ],
      [
        -12,
        44
      ],
      [
        25,
        32
      ],
      [
        25,
        -43
      ]
    ],
    [
      [
        65579,
        91056
      ],
      [
        -38,
        0
      ],
      [
        0,
        44
      ],
      [
        13,
        32
      ],
      [
        -13,
        33
      ],
      [
        13,
        21
      ],
      [
        37,
        -65
      ],
      [
        -12,
        -65
      ]
    ],
    [
      [
        66247,
        91056
      ],
      [
        0,
        -54
      ],
      [
        -24,
        -33
      ],
      [
        -62,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        24,
        -33
      ],
      [
        38,
        -21
      ],
      [
        12,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        -75,
        -33
      ],
      [
        -12,
        -75
      ],
      [
        0,
        -152
      ],
      [
        -74,
        -33
      ],
      [
        -37,
        87
      ],
      [
        0,
        43
      ],
      [
        -13,
        33
      ],
      [
        0,
        43
      ],
      [
        -12,
        54
      ],
      [
        -87,
        22
      ],
      [
        -49,
        -11
      ],
      [
        -38,
        76
      ],
      [
        13,
        87
      ],
      [
        -25,
        43
      ],
      [
        0,
        44
      ],
      [
        -37,
        21
      ],
      [
        -13,
        55
      ],
      [
        25,
        10
      ],
      [
        62,
        -10
      ],
      [
        25,
        21
      ],
      [
        49,
        76
      ],
      [
        13,
        44
      ],
      [
        49,
        0
      ],
      [
        25,
        -22
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -65
      ],
      [
        37,
        -22
      ],
      [
        13,
        54
      ],
      [
        25,
        33
      ],
      [
        0,
        65
      ],
      [
        -13,
        21
      ],
      [
        50,
        55
      ],
      [
        62,
        43
      ],
      [
        37,
        0
      ],
      [
        74,
        -22
      ],
      [
        25,
        -32
      ],
      [
        -25,
        -54
      ],
      [
        12,
        -109
      ]
    ],
    [
      [
        65727,
        91978
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        22
      ],
      [
        25,
        22
      ],
      [
        74,
        10
      ],
      [
        -37,
        -43
      ]
    ],
    [
      [
        64910,
        90514
      ],
      [
        0,
        43
      ],
      [
        -38,
        98
      ],
      [
        38,
        11
      ],
      [
        -13,
        108
      ],
      [
        -12,
        54
      ],
      [
        -161,
        120
      ],
      [
        12,
        184
      ],
      [
        13,
        54
      ],
      [
        -25,
        98
      ],
      [
        0,
        108
      ],
      [
        12,
        185
      ],
      [
        37,
        0
      ],
      [
        62,
        -33
      ],
      [
        37,
        0
      ],
      [
        13,
        -32
      ],
      [
        25,
        -11
      ],
      [
        24,
        87
      ],
      [
        50,
        65
      ],
      [
        62,
        43
      ],
      [
        25,
        -33
      ],
      [
        24,
        33
      ],
      [
        13,
        130
      ],
      [
        -50,
        22
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -76
      ],
      [
        -37,
        -97
      ],
      [
        -62,
        -11
      ],
      [
        -50,
        -33
      ],
      [
        -62,
        54
      ],
      [
        0,
        66
      ],
      [
        50,
        86
      ],
      [
        62,
        76
      ],
      [
        74,
        0
      ],
      [
        50,
        22
      ],
      [
        111,
        0
      ],
      [
        50,
        11
      ],
      [
        37,
        43
      ],
      [
        99,
        152
      ],
      [
        50,
        65
      ],
      [
        99,
        22
      ],
      [
        74,
        21
      ],
      [
        -12,
        -54
      ],
      [
        37,
        -76
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -87
      ],
      [
        -24,
        -43
      ],
      [
        -50,
        -109
      ],
      [
        0,
        -227
      ],
      [
        25,
        -44
      ],
      [
        37,
        -21
      ],
      [
        124,
        0
      ],
      [
        25,
        -55
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -32
      ],
      [
        -86,
        -66
      ],
      [
        -25,
        0
      ],
      [
        -37,
        55
      ],
      [
        -38,
        -44
      ],
      [
        -37,
        -130
      ],
      [
        -12,
        -87
      ],
      [
        -62,
        11
      ],
      [
        -37,
        -21
      ],
      [
        25,
        -22
      ],
      [
        12,
        -44
      ],
      [
        -74,
        -54
      ],
      [
        -13,
        -32
      ],
      [
        -62,
        -65
      ],
      [
        38,
        -141
      ],
      [
        -13,
        -44
      ],
      [
        -49,
        -54
      ],
      [
        -13,
        -54
      ],
      [
        37,
        11
      ],
      [
        25,
        -11
      ],
      [
        25,
        -44
      ],
      [
        12,
        -86
      ]
    ],
    [
      [
        37236,
        67479
      ],
      [
        0,
        195
      ],
      [
        -37,
        43
      ],
      [
        -25,
        65
      ],
      [
        -24,
        55
      ],
      [
        49,
        0
      ],
      [
        37,
        76
      ],
      [
        13,
        43
      ],
      [
        0,
        32
      ],
      [
        -25,
        44
      ],
      [
        0,
        43
      ],
      [
        12,
        33
      ],
      [
        38,
        54
      ],
      [
        0,
        43
      ],
      [
        -38,
        55
      ],
      [
        0,
        21
      ],
      [
        13,
        65
      ],
      [
        0,
        44
      ],
      [
        -13,
        119
      ],
      [
        -12,
        22
      ]
    ],
    [
      [
        37224,
        68531
      ],
      [
        25,
        11
      ],
      [
        0,
        32
      ],
      [
        12,
        43
      ],
      [
        37,
        22
      ],
      [
        50,
        0
      ],
      [
        49,
        -32
      ],
      [
        13,
        10
      ],
      [
        99,
        33
      ],
      [
        49,
        -11
      ],
      [
        13,
        -22
      ],
      [
        49,
        -54
      ],
      [
        75,
        0
      ],
      [
        37,
        -54
      ],
      [
        37,
        -33
      ],
      [
        25,
        0
      ],
      [
        37,
        22
      ],
      [
        25,
        0
      ],
      [
        24,
        -43
      ],
      [
        0,
        -76
      ],
      [
        25,
        -65
      ],
      [
        25,
        -44
      ],
      [
        136,
        22
      ],
      [
        37,
        -43
      ],
      [
        -24,
        -44
      ],
      [
        -99,
        11
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -33
      ],
      [
        37,
        0
      ],
      [
        50,
        -11
      ],
      [
        74,
        -43
      ],
      [
        87,
        -22
      ],
      [
        74,
        -54
      ],
      [
        87,
        -119
      ],
      [
        25,
        -22
      ],
      [
        12,
        -43
      ],
      [
        -37,
        -120
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -54
      ],
      [
        -13,
        -11
      ],
      [
        -25,
        33
      ],
      [
        -12,
        54
      ],
      [
        -49,
        43
      ],
      [
        -38,
        -11
      ],
      [
        -74,
        22
      ],
      [
        -49,
        -11
      ],
      [
        -38,
        0
      ],
      [
        -86,
        22
      ],
      [
        -38,
        -22
      ],
      [
        -49,
        -21
      ],
      [
        -37,
        -65
      ],
      [
        -13,
        -11
      ],
      [
        -111,
        -22
      ],
      [
        -25,
        22
      ],
      [
        -25,
        43
      ],
      [
        -37,
        11
      ],
      [
        -62,
        -33
      ],
      [
        -37,
        -10
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -76
      ],
      [
        -62,
        -174
      ],
      [
        -37,
        -97
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        55
      ],
      [
        -25,
        21
      ],
      [
        -24,
        11
      ],
      [
        0,
        76
      ],
      [
        -25,
        65
      ],
      [
        -13,
        22
      ]
    ],
    [
      [
        65195,
        75092
      ],
      [
        -62,
        -65
      ],
      [
        24,
        -76
      ],
      [
        87,
        -228
      ],
      [
        13,
        -43
      ],
      [
        24,
        -119
      ],
      [
        13,
        -120
      ],
      [
        12,
        -43
      ],
      [
        0,
        -347
      ],
      [
        12,
        -315
      ],
      [
        13,
        -162
      ],
      [
        -25,
        -152
      ],
      [
        -25,
        -130
      ],
      [
        0,
        -76
      ],
      [
        13,
        -109
      ],
      [
        12,
        -76
      ],
      [
        25,
        -43
      ],
      [
        0,
        -141
      ],
      [
        -13,
        -43
      ],
      [
        -61,
        -76
      ],
      [
        -62,
        -65
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -109
      ],
      [
        49,
        -108
      ],
      [
        75,
        -174
      ],
      [
        74,
        -184
      ],
      [
        0,
        -44
      ],
      [
        12,
        -130
      ],
      [
        25,
        -162
      ],
      [
        37,
        -66
      ],
      [
        13,
        -54
      ],
      [
        24,
        -43
      ],
      [
        38,
        -33
      ],
      [
        86,
        44
      ],
      [
        149,
        -65
      ],
      [
        136,
        -76
      ],
      [
        0,
        -22
      ],
      [
        37,
        -87
      ],
      [
        87,
        -282
      ],
      [
        25,
        -108
      ]
    ],
    [
      [
        66037,
        70906
      ],
      [
        -174,
        -195
      ],
      [
        -173,
        -185
      ],
      [
        -186,
        -195
      ],
      [
        -173,
        -184
      ],
      [
        -186,
        -196
      ],
      [
        -173,
        -195
      ],
      [
        -174,
        -184
      ],
      [
        -186,
        -195
      ],
      [
        -111,
        -120
      ],
      [
        -74,
        -119
      ],
      [
        -100,
        -141
      ],
      [
        -86,
        -130
      ],
      [
        -161,
        -260
      ],
      [
        -50,
        -65
      ],
      [
        -99,
        -163
      ],
      [
        -25,
        -22
      ],
      [
        -136,
        -54
      ],
      [
        -124,
        -43
      ],
      [
        -111,
        -33
      ],
      [
        -87,
        -32
      ],
      [
        -74,
        -22
      ]
    ],
    [
      [
        63374,
        68173
      ],
      [
        -99,
        -44
      ],
      [
        -87,
        -21
      ],
      [
        -75,
        -33
      ],
      [
        -49,
        0
      ],
      [
        -25,
        11
      ],
      [
        -49,
        87
      ],
      [
        12,
        43
      ],
      [
        25,
        65
      ],
      [
        0,
        22
      ],
      [
        12,
        11
      ],
      [
        0,
        65
      ],
      [
        -12,
        54
      ],
      [
        0,
        141
      ],
      [
        -25,
        43
      ],
      [
        -50,
        33
      ],
      [
        -37,
        33
      ],
      [
        -74,
        21
      ],
      [
        -62,
        22
      ],
      [
        -25,
        22
      ],
      [
        -49,
        86
      ],
      [
        -13,
        33
      ],
      [
        -99,
        11
      ],
      [
        -37,
        11
      ],
      [
        -25,
        21
      ],
      [
        -24,
        33
      ],
      [
        -25,
        87
      ],
      [
        0,
        21
      ],
      [
        -112,
        98
      ],
      [
        -49,
        65
      ],
      [
        0,
        54
      ],
      [
        12,
        54
      ],
      [
        -12,
        44
      ],
      [
        0,
        32
      ],
      [
        -50,
        55
      ],
      [
        -111,
        141
      ],
      [
        -112,
        130
      ],
      [
        -124,
        130
      ],
      [
        -111,
        141
      ],
      [
        -223,
        260
      ],
      [
        -112,
        141
      ],
      [
        -223,
        260
      ],
      [
        -111,
        141
      ],
      [
        -223,
        261
      ],
      [
        -112,
        141
      ],
      [
        -123,
        130
      ],
      [
        -112,
        130
      ],
      [
        -198,
        249
      ],
      [
        -112,
        120
      ]
    ],
    [
      [
        60264,
        71828
      ],
      [
        -74,
        86
      ],
      [
        -87,
        87
      ],
      [
        -74,
        98
      ],
      [
        -62,
        54
      ],
      [
        -62,
        65
      ],
      [
        -62,
        76
      ],
      [
        -62,
        65
      ],
      [
        -74,
        65
      ],
      [
        -62,
        76
      ],
      [
        -62,
        65
      ],
      [
        -62,
        76
      ],
      [
        -62,
        65
      ],
      [
        -74,
        65
      ],
      [
        -62,
        76
      ],
      [
        -124,
        130
      ],
      [
        -136,
        141
      ],
      [
        -62,
        76
      ],
      [
        -62,
        65
      ]
    ],
    [
      [
        58939,
        73259
      ],
      [
        0,
        228
      ]
    ],
    [
      [
        58939,
        73487
      ],
      [
        0,
        293
      ],
      [
        0,
        369
      ],
      [
        37,
        32
      ],
      [
        62,
        76
      ],
      [
        12,
        33
      ],
      [
        25,
        32
      ],
      [
        99,
        87
      ],
      [
        13,
        32
      ],
      [
        111,
        120
      ],
      [
        50,
        10
      ],
      [
        25,
        22
      ],
      [
        61,
        98
      ],
      [
        50,
        32
      ],
      [
        161,
        -43
      ],
      [
        25,
        22
      ],
      [
        12,
        43
      ],
      [
        0,
        87
      ],
      [
        13,
        11
      ],
      [
        37,
        -11
      ],
      [
        49,
        0
      ],
      [
        25,
        11
      ],
      [
        136,
        32
      ],
      [
        112,
        54
      ],
      [
        49,
        65
      ],
      [
        38,
        66
      ],
      [
        37,
        97
      ],
      [
        37,
        87
      ],
      [
        62,
        54
      ],
      [
        87,
        43
      ],
      [
        74,
        55
      ],
      [
        62,
        65
      ],
      [
        49,
        65
      ],
      [
        99,
        22
      ],
      [
        25,
        32
      ],
      [
        0,
        43
      ],
      [
        -12,
        22
      ],
      [
        -37,
        33
      ],
      [
        -13,
        0
      ],
      [
        0,
        97
      ],
      [
        13,
        33
      ],
      [
        0,
        43
      ],
      [
        -25,
        44
      ],
      [
        0,
        76
      ],
      [
        25,
        43
      ],
      [
        62,
        -11
      ],
      [
        49,
        11
      ],
      [
        149,
        87
      ],
      [
        12,
        21
      ],
      [
        25,
        109
      ],
      [
        12,
        21
      ],
      [
        124,
        33
      ],
      [
        99,
        -11
      ],
      [
        50,
        0
      ],
      [
        99,
        -11
      ],
      [
        186,
        0
      ],
      [
        12,
        11
      ],
      [
        0,
        33
      ],
      [
        -12,
        65
      ],
      [
        12,
        43
      ],
      [
        50,
        76
      ],
      [
        -13,
        54
      ],
      [
        -62,
        76
      ],
      [
        -24,
        22
      ],
      [
        -50,
        108
      ],
      [
        -12,
        120
      ],
      [
        -50,
        152
      ],
      [
        25,
        162
      ],
      [
        -37,
        130
      ],
      [
        0,
        44
      ],
      [
        12,
        86
      ],
      [
        0,
        120
      ],
      [
        -37,
        119
      ],
      [
        25,
        76
      ],
      [
        -37,
        76
      ],
      [
        12,
        87
      ],
      [
        -37,
        54
      ],
      [
        -99,
        119
      ],
      [
        -13,
        44
      ]
    ],
    [
      [
        61156,
        78140
      ],
      [
        75,
        -11
      ],
      [
        37,
        11
      ],
      [
        86,
        54
      ],
      [
        62,
        76
      ],
      [
        50,
        32
      ],
      [
        50,
        87
      ],
      [
        37,
        54
      ],
      [
        62,
        54
      ],
      [
        161,
        120
      ],
      [
        24,
        0
      ],
      [
        62,
        -33
      ],
      [
        50,
        11
      ],
      [
        25,
        43
      ],
      [
        37,
        98
      ],
      [
        124,
        130
      ],
      [
        99,
        54
      ],
      [
        62,
        55
      ],
      [
        99,
        54
      ],
      [
        248,
        32
      ],
      [
        123,
        22
      ],
      [
        87,
        -11
      ],
      [
        87,
        87
      ],
      [
        49,
        33
      ],
      [
        186,
        10
      ],
      [
        87,
        55
      ],
      [
        334,
        0
      ],
      [
        38,
        -11
      ],
      [
        49,
        -44
      ],
      [
        62,
        -76
      ],
      [
        37,
        -21
      ],
      [
        50,
        21
      ],
      [
        99,
        76
      ],
      [
        111,
        44
      ],
      [
        75,
        43
      ],
      [
        24,
        65
      ],
      [
        50,
        22
      ],
      [
        37,
        -43
      ],
      [
        112,
        -55
      ],
      [
        74,
        11
      ],
      [
        37,
        22
      ],
      [
        -12,
        76
      ],
      [
        74,
        -22
      ],
      [
        62,
        -43
      ],
      [
        62,
        -65
      ],
      [
        50,
        -22
      ],
      [
        74,
        32
      ],
      [
        148,
        22
      ]
    ],
    [
      [
        64872,
        79289
      ],
      [
        13,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -50,
        -43
      ],
      [
        -37,
        -87
      ],
      [
        -37,
        -54
      ],
      [
        -12,
        -33
      ],
      [
        37,
        -22
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -195
      ],
      [
        -12,
        -119
      ],
      [
        0,
        -44
      ],
      [
        25,
        -86
      ],
      [
        0,
        -163
      ],
      [
        25,
        -119
      ],
      [
        -25,
        -76
      ],
      [
        -13,
        -65
      ],
      [
        -12,
        -98
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -55
      ],
      [
        -62,
        -54
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -98
      ],
      [
        -62,
        -76
      ],
      [
        -13,
        -32
      ],
      [
        -12,
        -65
      ],
      [
        0,
        -87
      ],
      [
        12,
        -76
      ],
      [
        37,
        -98
      ],
      [
        38,
        -173
      ],
      [
        12,
        -33
      ],
      [
        99,
        -86
      ],
      [
        50,
        -98
      ],
      [
        37,
        -141
      ],
      [
        0,
        -98
      ],
      [
        74,
        -76
      ],
      [
        50,
        -76
      ],
      [
        62,
        -54
      ],
      [
        62,
        -65
      ],
      [
        0,
        -22
      ],
      [
        24,
        -140
      ],
      [
        13,
        -141
      ],
      [
        24,
        -163
      ],
      [
        25,
        -152
      ],
      [
        37,
        -282
      ],
      [
        25,
        -130
      ],
      [
        13,
        -152
      ]
    ],
    [
      [
        34350,
        54356
      ],
      [
        0,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -12,
        11
      ],
      [
        0,
        22
      ],
      [
        12,
        87
      ],
      [
        12,
        43
      ],
      [
        25,
        33
      ],
      [
        25,
        21
      ],
      [
        25,
        -11
      ],
      [
        37,
        -32
      ],
      [
        -37,
        -54
      ],
      [
        -38,
        -22
      ],
      [
        -12,
        -76
      ]
    ],
    [
      [
        30807,
        55376
      ],
      [
        -12,
        0
      ],
      [
        -12,
        21
      ],
      [
        12,
        54
      ],
      [
        25,
        -21
      ],
      [
        12,
        -22
      ],
      [
        -25,
        -32
      ]
    ],
    [
      [
        31154,
        55647
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        43
      ],
      [
        25,
        44
      ],
      [
        25,
        22
      ],
      [
        12,
        43
      ],
      [
        37,
        22
      ],
      [
        25,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -54
      ]
    ],
    [
      [
        30844,
        55733
      ],
      [
        -24,
        0
      ],
      [
        -50,
        55
      ],
      [
        0,
        65
      ],
      [
        25,
        32
      ],
      [
        74,
        22
      ],
      [
        25,
        -33
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        30473,
        55929
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        21
      ],
      [
        -25,
        76
      ],
      [
        13,
        22
      ],
      [
        61,
        22
      ],
      [
        13,
        -44
      ],
      [
        0,
        -86
      ]
    ],
    [
      [
        30758,
        56005
      ],
      [
        -13,
        -22
      ],
      [
        -62,
        22
      ],
      [
        -24,
        43
      ],
      [
        12,
        43
      ],
      [
        25,
        22
      ],
      [
        37,
        -22
      ],
      [
        37,
        -54
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        30522,
        56232
      ],
      [
        25,
        -43
      ],
      [
        13,
        -119
      ],
      [
        62,
        -120
      ],
      [
        12,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        12,
        -11
      ],
      [
        25,
        -44
      ],
      [
        24,
        -54
      ],
      [
        -37,
        -119
      ],
      [
        -74,
        -43
      ],
      [
        -87,
        0
      ],
      [
        -12,
        10
      ],
      [
        -25,
        44
      ],
      [
        0,
        43
      ],
      [
        12,
        33
      ],
      [
        38,
        65
      ],
      [
        62,
        43
      ],
      [
        12,
        44
      ],
      [
        -25,
        43
      ],
      [
        -12,
        76
      ],
      [
        -50,
        54
      ],
      [
        -12,
        163
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        22
      ],
      [
        37,
        65
      ],
      [
        37,
        21
      ],
      [
        25,
        -21
      ],
      [
        12,
        -44
      ]
    ],
    [
      [
        34771,
        56991
      ],
      [
        -12,
        0
      ],
      [
        -13,
        33
      ],
      [
        38,
        43
      ],
      [
        -13,
        -76
      ]
    ],
    [
      [
        36022,
        56146
      ],
      [
        -24,
        -22
      ],
      [
        -38,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -24,
        0
      ],
      [
        0,
        -22
      ],
      [
        24,
        -22
      ],
      [
        25,
        -32
      ],
      [
        25,
        -98
      ],
      [
        37,
        -65
      ],
      [
        25,
        -32
      ],
      [
        0,
        -22
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -32
      ],
      [
        13,
        -163
      ],
      [
        -37,
        0
      ],
      [
        -13,
        11
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        -65
      ],
      [
        -12,
        -163
      ],
      [
        -25,
        -130
      ],
      [
        -24,
        -43
      ],
      [
        -38,
        -76
      ],
      [
        -49,
        -109
      ],
      [
        -62,
        -151
      ],
      [
        -62,
        -65
      ],
      [
        -37,
        -55
      ],
      [
        -50,
        -65
      ],
      [
        -62,
        -76
      ],
      [
        -62,
        -54
      ],
      [
        -99,
        -54
      ],
      [
        -74,
        -54
      ],
      [
        -50,
        -22
      ],
      [
        -49,
        -33
      ],
      [
        -75,
        -43
      ],
      [
        -24,
        -43
      ],
      [
        -37,
        -98
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -32
      ],
      [
        12,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -21
      ],
      [
        0,
        32
      ],
      [
        -13,
        33
      ],
      [
        -25,
        0
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -108
      ],
      [
        0,
        -109
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -109
      ],
      [
        0,
        -119
      ],
      [
        -25,
        -44
      ],
      [
        -62,
        -75
      ],
      [
        0,
        -98
      ],
      [
        -25,
        0
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -38,
        0
      ],
      [
        -12,
        11
      ],
      [
        -25,
        65
      ],
      [
        -25,
        43
      ],
      [
        -12,
        54
      ],
      [
        -12,
        87
      ],
      [
        -37,
        54
      ],
      [
        -50,
        -21
      ],
      [
        -62,
        54
      ],
      [
        -37,
        43
      ],
      [
        -25,
        22
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        -65
      ],
      [
        -38,
        -33
      ],
      [
        -12,
        0
      ],
      [
        -25,
        44
      ],
      [
        25,
        43
      ],
      [
        25,
        76
      ],
      [
        -37,
        0
      ],
      [
        -13,
        22
      ],
      [
        0,
        97
      ],
      [
        25,
        22
      ],
      [
        25,
        -11
      ],
      [
        25,
        0
      ],
      [
        12,
        33
      ],
      [
        25,
        21
      ],
      [
        0,
        22
      ],
      [
        -13,
        54
      ],
      [
        0,
        109
      ],
      [
        -12,
        21
      ],
      [
        0,
        55
      ],
      [
        -12,
        21
      ],
      [
        0,
        33
      ],
      [
        -13,
        11
      ]
    ],
    [
      [
        34288,
        54096
      ],
      [
        62,
        43
      ],
      [
        12,
        33
      ],
      [
        25,
        21
      ],
      [
        25,
        44
      ],
      [
        12,
        43
      ],
      [
        38,
        195
      ],
      [
        37,
        131
      ],
      [
        -13,
        54
      ],
      [
        -24,
        86
      ],
      [
        -13,
        109
      ],
      [
        13,
        43
      ],
      [
        -13,
        22
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -174
      ],
      [
        -13,
        -76
      ],
      [
        -24,
        -21
      ],
      [
        -13,
        10
      ],
      [
        13,
        130
      ],
      [
        -13,
        -21
      ],
      [
        -37,
        -87
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        -62,
        54
      ],
      [
        -75,
        141
      ],
      [
        -49,
        32
      ],
      [
        -37,
        55
      ],
      [
        0,
        21
      ],
      [
        -13,
        22
      ],
      [
        37,
        33
      ],
      [
        38,
        43
      ],
      [
        0,
        152
      ],
      [
        -25,
        119
      ],
      [
        12,
        163
      ],
      [
        -12,
        54
      ],
      [
        -25,
        130
      ],
      [
        25,
        65
      ],
      [
        74,
        54
      ],
      [
        25,
        22
      ],
      [
        12,
        109
      ],
      [
        13,
        65
      ],
      [
        24,
        0
      ],
      [
        -24,
        86
      ],
      [
        0,
        44
      ],
      [
        49,
        130
      ],
      [
        25,
        33
      ],
      [
        37,
        65
      ],
      [
        37,
        97
      ],
      [
        0,
        163
      ],
      [
        -12,
        108
      ],
      [
        0,
        120
      ],
      [
        12,
        32
      ],
      [
        50,
        22
      ],
      [
        37,
        32
      ],
      [
        12,
        44
      ],
      [
        50,
        -11
      ],
      [
        49,
        54
      ],
      [
        75,
        33
      ],
      [
        124,
        65
      ],
      [
        24,
        54
      ],
      [
        -12,
        98
      ]
    ],
    [
      [
        73705,
        75710
      ],
      [
        24,
        -130
      ],
      [
        25,
        -108
      ],
      [
        37,
        -141
      ],
      [
        13,
        -65
      ],
      [
        0,
        -33
      ],
      [
        49,
        -163
      ],
      [
        25,
        -130
      ],
      [
        12,
        -108
      ],
      [
        38,
        -152
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        73928,
        74626
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -108
      ],
      [
        -49,
        -315
      ],
      [
        -50,
        -249
      ],
      [
        -12,
        -163
      ],
      [
        -13,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        -37,
        -87
      ],
      [
        -49,
        43
      ],
      [
        -99,
        141
      ],
      [
        -62,
        131
      ],
      [
        -62,
        86
      ],
      [
        -62,
        109
      ],
      [
        -13,
        76
      ],
      [
        0,
        54
      ],
      [
        -37,
        184
      ],
      [
        -74,
        130
      ],
      [
        -50,
        152
      ],
      [
        -24,
        174
      ],
      [
        -25,
        108
      ],
      [
        -37,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -76
      ],
      [
        12,
        -65
      ],
      [
        49,
        -87
      ],
      [
        38,
        -130
      ],
      [
        -13,
        -119
      ],
      [
        13,
        -43
      ],
      [
        49,
        -87
      ],
      [
        25,
        -98
      ],
      [
        49,
        -108
      ],
      [
        62,
        -152
      ],
      [
        62,
        -98
      ],
      [
        38,
        -43
      ],
      [
        24,
        -54
      ],
      [
        0,
        -185
      ],
      [
        37,
        -108
      ],
      [
        13,
        -54
      ],
      [
        37,
        -44
      ],
      [
        12,
        -54
      ],
      [
        13,
        -87
      ],
      [
        25,
        -249
      ],
      [
        37,
        -54
      ],
      [
        86,
        -336
      ],
      [
        87,
        -207
      ],
      [
        37,
        -151
      ],
      [
        62,
        -196
      ],
      [
        124,
        -412
      ],
      [
        62,
        -130
      ],
      [
        25,
        -65
      ],
      [
        49,
        -65
      ],
      [
        62,
        -76
      ],
      [
        -49,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -44
      ],
      [
        13,
        -206
      ],
      [
        12,
        -108
      ],
      [
        50,
        -206
      ],
      [
        24,
        -65
      ],
      [
        25,
        -33
      ],
      [
        12,
        -32
      ],
      [
        112,
        -65
      ],
      [
        62,
        -152
      ],
      [
        149,
        -184
      ],
      [
        12,
        -66
      ]
    ],
    [
      [
        74609,
        69951
      ],
      [
        -112,
        0
      ],
      [
        -223,
        0
      ],
      [
        -222,
        0
      ],
      [
        -236,
        0
      ],
      [
        -223,
        0
      ],
      [
        -223,
        0
      ],
      [
        -223,
        0
      ],
      [
        -235,
        0
      ],
      [
        -174,
        0
      ],
      [
        25,
        98
      ],
      [
        -12,
        22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        -109
      ],
      [
        -13,
        -11
      ],
      [
        -173,
        0
      ],
      [
        -137,
        0
      ],
      [
        -260,
        0
      ],
      [
        -260,
        0
      ],
      [
        -260,
        0
      ],
      [
        -272,
        0
      ],
      [
        -261,
        0
      ],
      [
        -260,
        0
      ],
      [
        -260,
        0
      ]
    ],
    [
      [
        70521,
        69951
      ],
      [
        0,
        282
      ],
      [
        0,
        282
      ],
      [
        0,
        282
      ],
      [
        0,
        282
      ],
      [
        0,
        282
      ],
      [
        0,
        271
      ],
      [
        0,
        423
      ],
      [
        0,
        282
      ],
      [
        0,
        282
      ],
      [
        0,
        423
      ],
      [
        0,
        282
      ],
      [
        0,
        412
      ],
      [
        0,
        423
      ],
      [
        0,
        315
      ],
      [
        -25,
        87
      ],
      [
        -12,
        119
      ],
      [
        -25,
        152
      ],
      [
        0,
        54
      ],
      [
        -37,
        152
      ],
      [
        0,
        43
      ],
      [
        62,
        163
      ],
      [
        12,
        54
      ],
      [
        25,
        141
      ],
      [
        -25,
        98
      ],
      [
        -24,
        162
      ],
      [
        0,
        87
      ],
      [
        24,
        54
      ],
      [
        38,
        55
      ],
      [
        24,
        76
      ],
      [
        25,
        21
      ]
    ],
    [
      [
        70583,
        75992
      ],
      [
        25,
        -76
      ],
      [
        49,
        -21
      ],
      [
        174,
        76
      ],
      [
        198,
        -76
      ],
      [
        99,
        -22
      ],
      [
        174,
        -54
      ],
      [
        99,
        -109
      ],
      [
        24,
        -11
      ],
      [
        75,
        0
      ],
      [
        49,
        -65
      ],
      [
        186,
        -21
      ],
      [
        99,
        -65
      ],
      [
        87,
        -76
      ],
      [
        37,
        0
      ],
      [
        37,
        21
      ],
      [
        112,
        98
      ],
      [
        111,
        130
      ],
      [
        50,
        22
      ],
      [
        49,
        0
      ],
      [
        37,
        54
      ],
      [
        25,
        65
      ],
      [
        62,
        11
      ],
      [
        124,
        54
      ],
      [
        -12,
        -22
      ],
      [
        -112,
        -65
      ],
      [
        50,
        -10
      ],
      [
        99,
        43
      ],
      [
        12,
        22
      ],
      [
        0,
        54
      ],
      [
        13,
        11
      ],
      [
        37,
        -11
      ],
      [
        124,
        -87
      ],
      [
        24,
        0
      ],
      [
        99,
        54
      ],
      [
        25,
        -21
      ],
      [
        62,
        -109
      ],
      [
        -25,
        11
      ],
      [
        -62,
        87
      ],
      [
        -12,
        -44
      ],
      [
        -37,
        -76
      ],
      [
        49,
        -32
      ],
      [
        38,
        -11
      ],
      [
        24,
        -43
      ],
      [
        13,
        -44
      ],
      [
        37,
        22
      ],
      [
        25,
        43
      ],
      [
        -25,
        65
      ],
      [
        37,
        -21
      ],
      [
        74,
        -98
      ],
      [
        25,
        -22
      ],
      [
        25,
        0
      ],
      [
        62,
        33
      ],
      [
        12,
        -11
      ],
      [
        75,
        44
      ],
      [
        24,
        -55
      ],
      [
        62,
        22
      ],
      [
        99,
        0
      ],
      [
        87,
        33
      ],
      [
        99,
        86
      ]
    ],
    [
      [
        73692,
        75775
      ],
      [
        13,
        -65
      ]
    ],
    [
      [
        75736,
        66015
      ],
      [
        13,
        -33
      ],
      [
        24,
        22
      ],
      [
        0,
        21
      ],
      [
        50,
        -43
      ],
      [
        0,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -37,
        10
      ],
      [
        -25,
        -10
      ],
      [
        -50,
        21
      ],
      [
        0,
        44
      ],
      [
        25,
        -22
      ],
      [
        12,
        11
      ],
      [
        -24,
        43
      ],
      [
        -25,
        0
      ],
      [
        0,
        33
      ],
      [
        25,
        21
      ],
      [
        -13,
        33
      ],
      [
        25,
        0
      ],
      [
        25,
        -22
      ],
      [
        12,
        -32
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        75711,
        66264
      ],
      [
        13,
        -65
      ],
      [
        -37,
        22
      ],
      [
        12,
        43
      ],
      [
        12,
        0
      ]
    ],
    [
      [
        76504,
        63997
      ],
      [
        -49,
        131
      ],
      [
        -38,
        65
      ],
      [
        -24,
        32
      ],
      [
        -37,
        33
      ],
      [
        -25,
        97
      ],
      [
        -37,
        98
      ],
      [
        -50,
        76
      ],
      [
        -87,
        119
      ],
      [
        -86,
        141
      ],
      [
        -62,
        163
      ],
      [
        -37,
        76
      ],
      [
        -25,
        21
      ],
      [
        -75,
        55
      ],
      [
        -61,
        65
      ],
      [
        -50,
        65
      ],
      [
        -25,
        11
      ],
      [
        -25,
        0
      ],
      [
        -62,
        -11
      ],
      [
        -49,
        32
      ],
      [
        -50,
        11
      ],
      [
        -24,
        22
      ],
      [
        -25,
        -22
      ],
      [
        -62,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -12,
        44
      ],
      [
        -37,
        54
      ],
      [
        -13,
        0
      ],
      [
        -12,
        -32
      ],
      [
        -62,
        -66
      ],
      [
        -112,
        -32
      ],
      [
        -24,
        0
      ],
      [
        -13,
        32
      ],
      [
        -49,
        109
      ],
      [
        -25,
        22
      ],
      [
        -37,
        10
      ],
      [
        -37,
        66
      ],
      [
        -25,
        32
      ],
      [
        -62,
        -249
      ],
      [
        -13,
        -87
      ],
      [
        -24,
        -109
      ],
      [
        -25,
        11
      ],
      [
        -87,
        185
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        -76
      ],
      [
        -13,
        -11
      ],
      [
        -74,
        33
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        -22
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        74485,
        65114
      ],
      [
        0,
        185
      ],
      [
        -25,
        249
      ],
      [
        0,
        120
      ],
      [
        25,
        76
      ],
      [
        25,
        65
      ],
      [
        37,
        227
      ],
      [
        12,
        44
      ],
      [
        25,
        130
      ],
      [
        13,
        32
      ],
      [
        24,
        152
      ],
      [
        0,
        206
      ],
      [
        25,
        109
      ],
      [
        0,
        43
      ],
      [
        12,
        98
      ],
      [
        0,
        21
      ],
      [
        50,
        -10
      ],
      [
        37,
        10
      ],
      [
        50,
        0
      ],
      [
        12,
        33
      ],
      [
        25,
        108
      ],
      [
        12,
        22
      ],
      [
        37,
        33
      ],
      [
        38,
        54
      ],
      [
        37,
        11
      ],
      [
        25,
        21
      ],
      [
        24,
        11
      ],
      [
        25,
        0
      ],
      [
        25,
        11
      ],
      [
        0,
        11
      ],
      [
        25,
        0
      ],
      [
        0,
        11
      ],
      [
        24,
        32
      ],
      [
        25,
        55
      ],
      [
        0,
        32
      ],
      [
        13,
        33
      ],
      [
        37,
        76
      ],
      [
        25,
        32
      ]
    ],
    [
      [
        75204,
        67457
      ],
      [
        111,
        -358
      ],
      [
        74,
        -434
      ],
      [
        25,
        -336
      ],
      [
        37,
        -173
      ],
      [
        37,
        -76
      ],
      [
        25,
        -163
      ],
      [
        25,
        -11
      ],
      [
        25,
        -43
      ],
      [
        25,
        -141
      ],
      [
        24,
        -65
      ],
      [
        13,
        54
      ],
      [
        0,
        22
      ],
      [
        -13,
        54
      ],
      [
        13,
        54
      ],
      [
        12,
        33
      ],
      [
        62,
        -76
      ],
      [
        12,
        -76
      ],
      [
        0,
        -44
      ],
      [
        50,
        -86
      ],
      [
        25,
        -22
      ],
      [
        49,
        -11
      ],
      [
        75,
        -43
      ],
      [
        49,
        -98
      ],
      [
        136,
        -76
      ],
      [
        100,
        -228
      ],
      [
        61,
        -162
      ],
      [
        199,
        -250
      ],
      [
        37,
        -119
      ],
      [
        25,
        -119
      ],
      [
        37,
        11
      ],
      [
        74,
        -131
      ],
      [
        25,
        -97
      ],
      [
        49,
        -33
      ],
      [
        13,
        55
      ],
      [
        37,
        -44
      ],
      [
        12,
        -76
      ]
    ],
    [
      [
        55768,
        73585
      ],
      [
        -37,
        -98
      ],
      [
        -50,
        43
      ],
      [
        0,
        22
      ],
      [
        37,
        11
      ],
      [
        37,
        43
      ],
      [
        13,
        -21
      ]
    ],
    [
      [
        56623,
        73801
      ],
      [
        0,
        -54
      ],
      [
        12,
        -43
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -44
      ],
      [
        -37,
        11
      ],
      [
        -50,
        87
      ],
      [
        0,
        65
      ],
      [
        25,
        43
      ],
      [
        12,
        54
      ],
      [
        87,
        -10
      ],
      [
        13,
        10
      ]
    ],
    [
      [
        56016,
        73715
      ],
      [
        -38,
        11
      ],
      [
        -12,
        54
      ],
      [
        25,
        54
      ],
      [
        12,
        0
      ],
      [
        25,
        -33
      ],
      [
        12,
        -43
      ],
      [
        -24,
        -43
      ]
    ],
    [
      [
        56300,
        73942
      ],
      [
        -24,
        -141
      ],
      [
        -37,
        -75
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        97
      ],
      [
        -25,
        87
      ],
      [
        -25,
        33
      ],
      [
        25,
        21
      ],
      [
        37,
        -10
      ],
      [
        62,
        21
      ],
      [
        87,
        98
      ],
      [
        62,
        11
      ],
      [
        0,
        -33
      ],
      [
        -75,
        -87
      ]
    ],
    [
      [
        57044,
        73812
      ],
      [
        -50,
        -76
      ],
      [
        -49,
        22
      ],
      [
        86,
        76
      ],
      [
        25,
        119
      ],
      [
        50,
        196
      ],
      [
        12,
        21
      ],
      [
        37,
        0
      ],
      [
        13,
        -32
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -109
      ],
      [
        -25,
        -97
      ],
      [
        -86,
        -55
      ]
    ],
    [
      [
        55793,
        74008
      ],
      [
        -13,
        0
      ],
      [
        -12,
        54
      ],
      [
        -37,
        119
      ],
      [
        24,
        54
      ],
      [
        50,
        0
      ],
      [
        25,
        -76
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -76
      ],
      [
        -24,
        -54
      ]
    ],
    [
      [
        57205,
        74279
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        11
      ],
      [
        13,
        87
      ],
      [
        12,
        32
      ],
      [
        50,
        44
      ],
      [
        37,
        11
      ],
      [
        12,
        43
      ],
      [
        12,
        11
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -87
      ],
      [
        -24,
        -33
      ],
      [
        -62,
        -21
      ]
    ],
    [
      [
        62469,
        80374
      ],
      [
        -62,
        0
      ],
      [
        0,
        43
      ],
      [
        13,
        11
      ],
      [
        49,
        -54
      ]
    ],
    [
      [
        62420,
        80525
      ],
      [
        -13,
        -43
      ],
      [
        -62,
        33
      ],
      [
        13,
        43
      ],
      [
        12,
        11
      ],
      [
        13,
        54
      ],
      [
        74,
        33
      ],
      [
        25,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        63002,
        81068
      ],
      [
        37,
        -22
      ],
      [
        37,
        22
      ],
      [
        37,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        -49,
        -97
      ],
      [
        -13,
        -55
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        43
      ],
      [
        -50,
        22
      ],
      [
        -12,
        65
      ],
      [
        -13,
        22
      ],
      [
        -24,
        11
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -32
      ],
      [
        -12,
        32
      ],
      [
        -25,
        33
      ],
      [
        0,
        21
      ],
      [
        136,
        152
      ],
      [
        50,
        33
      ],
      [
        86,
        43
      ],
      [
        13,
        -11
      ],
      [
        -13,
        -32
      ],
      [
        13,
        -33
      ],
      [
        -25,
        -43
      ]
    ],
    [
      [
        63398,
        81100
      ],
      [
        0,
        -11
      ],
      [
        -111,
        76
      ],
      [
        -37,
        11
      ],
      [
        0,
        65
      ],
      [
        74,
        11
      ],
      [
        50,
        -32
      ],
      [
        37,
        -76
      ],
      [
        -13,
        -44
      ]
    ],
    [
      [
        61305,
        83324
      ],
      [
        0,
        -22
      ],
      [
        25,
        -33
      ],
      [
        37,
        -21
      ],
      [
        25,
        0
      ],
      [
        49,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -32
      ],
      [
        38,
        -11
      ],
      [
        0,
        21
      ],
      [
        24,
        22
      ],
      [
        0,
        -32
      ],
      [
        124,
        -65
      ],
      [
        62,
        0
      ],
      [
        0,
        -22
      ],
      [
        62,
        -76
      ],
      [
        12,
        11
      ],
      [
        25,
        -11
      ],
      [
        62,
        22
      ],
      [
        50,
        -44
      ],
      [
        37,
        -43
      ],
      [
        87,
        22
      ],
      [
        12,
        -22
      ],
      [
        37,
        11
      ],
      [
        50,
        -11
      ],
      [
        49,
        0
      ],
      [
        0,
        76
      ],
      [
        13,
        22
      ],
      [
        24,
        0
      ],
      [
        124,
        -66
      ],
      [
        62,
        -21
      ],
      [
        50,
        -65
      ]
    ],
    [
      [
        62507,
        82760
      ],
      [
        61,
        -22
      ],
      [
        25,
        -22
      ],
      [
        13,
        -43
      ],
      [
        12,
        0
      ],
      [
        62,
        43
      ],
      [
        62,
        -21
      ],
      [
        62,
        -33
      ],
      [
        37,
        0
      ],
      [
        0,
        33
      ],
      [
        50,
        21
      ],
      [
        24,
        22
      ],
      [
        25,
        0
      ],
      [
        87,
        -22
      ]
    ],
    [
      [
        63027,
        82716
      ],
      [
        37,
        -87
      ],
      [
        -50,
        -21
      ],
      [
        0,
        -76
      ],
      [
        25,
        -11
      ],
      [
        0,
        -108
      ],
      [
        -37,
        -55
      ],
      [
        -50,
        -54
      ],
      [
        -235,
        -184
      ],
      [
        -49,
        -98
      ],
      [
        -25,
        -22
      ],
      [
        -174,
        -54
      ],
      [
        -185,
        -87
      ],
      [
        -75,
        -97
      ],
      [
        -37,
        -44
      ],
      [
        25,
        -10
      ],
      [
        37,
        -55
      ],
      [
        -12,
        -21
      ],
      [
        -50,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -87,
        -184
      ],
      [
        -74,
        -141
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -87
      ],
      [
        -87,
        -217
      ],
      [
        0,
        -65
      ],
      [
        37,
        -228
      ],
      [
        25,
        -54
      ],
      [
        37,
        -54
      ],
      [
        62,
        -33
      ],
      [
        25,
        -43
      ],
      [
        -25,
        -43
      ],
      [
        -62,
        -66
      ],
      [
        -124,
        -97
      ],
      [
        -37,
        -76
      ],
      [
        -13,
        -65
      ],
      [
        -37,
        -33
      ],
      [
        -12,
        -97
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -44
      ],
      [
        38,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        -62,
        -21
      ],
      [
        -136,
        0
      ],
      [
        -112,
        -109
      ],
      [
        -49,
        -97
      ],
      [
        -50,
        -185
      ],
      [
        -62,
        -97
      ],
      [
        -24,
        -22
      ],
      [
        -37,
        43
      ],
      [
        -50,
        11
      ],
      [
        -50,
        -22
      ],
      [
        -24,
        -32
      ],
      [
        -38,
        -22
      ],
      [
        -49,
        22
      ],
      [
        -74,
        11
      ],
      [
        -50,
        -11
      ],
      [
        -49,
        -22
      ],
      [
        -50,
        11
      ],
      [
        -87,
        11
      ],
      [
        -186,
        -22
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        -62,
        -76
      ],
      [
        -87,
        0
      ],
      [
        -86,
        -54
      ],
      [
        -50,
        -120
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        11
      ],
      [
        -13,
        -54
      ],
      [
        -49,
        -33
      ],
      [
        -62,
        44
      ],
      [
        -62,
        54
      ],
      [
        -25,
        11
      ],
      [
        -62,
        141
      ],
      [
        -12,
        65
      ],
      [
        0,
        43
      ],
      [
        -37,
        33
      ],
      [
        -13,
        54
      ],
      [
        25,
        76
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        76
      ],
      [
        -137,
        152
      ],
      [
        -12,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -86,
        -11
      ]
    ],
    [
      [
        59373,
        79441
      ],
      [
        -13,
        152
      ],
      [
        -12,
        65
      ],
      [
        0,
        32
      ],
      [
        12,
        87
      ],
      [
        25,
        44
      ],
      [
        25,
        75
      ],
      [
        37,
        55
      ],
      [
        62,
        32
      ],
      [
        25,
        87
      ],
      [
        -50,
        -11
      ],
      [
        -87,
        174
      ],
      [
        0,
        32
      ],
      [
        25,
        87
      ],
      [
        0,
        43
      ],
      [
        12,
        33
      ],
      [
        38,
        43
      ],
      [
        24,
        44
      ],
      [
        25,
        97
      ],
      [
        -25,
        33
      ],
      [
        -37,
        11
      ],
      [
        -49,
        130
      ],
      [
        -13,
        87
      ],
      [
        -37,
        43
      ],
      [
        -25,
        65
      ],
      [
        25,
        22
      ],
      [
        112,
        0
      ],
      [
        37,
        21
      ],
      [
        37,
        141
      ],
      [
        0,
        76
      ],
      [
        -37,
        44
      ],
      [
        0,
        43
      ],
      [
        49,
        65
      ],
      [
        25,
        22
      ],
      [
        -12,
        43
      ],
      [
        0,
        130
      ],
      [
        12,
        22
      ],
      [
        -12,
        76
      ],
      [
        0,
        65
      ],
      [
        -25,
        76
      ],
      [
        0,
        22
      ],
      [
        49,
        43
      ],
      [
        25,
        65
      ],
      [
        50,
        54
      ],
      [
        49,
        44
      ],
      [
        62,
        97
      ],
      [
        0,
        44
      ],
      [
        -24,
        32
      ],
      [
        -62,
        11
      ],
      [
        -25,
        11
      ],
      [
        0,
        119
      ],
      [
        -25,
        44
      ],
      [
        -74,
        10
      ],
      [
        -13,
        -10
      ],
      [
        -74,
        10
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -74,
        -33
      ],
      [
        -38,
        0
      ],
      [
        -62,
        33
      ],
      [
        -62,
        -11
      ],
      [
        -12,
        11
      ],
      [
        -62,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -12,
        65
      ],
      [
        25,
        54
      ],
      [
        -25,
        76
      ],
      [
        -37,
        -11
      ],
      [
        -99,
        -43
      ],
      [
        -62,
        -65
      ]
    ],
    [
      [
        58902,
        82413
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        11
      ],
      [
        0,
        97
      ],
      [
        37,
        76
      ],
      [
        37,
        33
      ],
      [
        -12,
        10
      ],
      [
        -38,
        0
      ],
      [
        0,
        33
      ],
      [
        38,
        43
      ],
      [
        -25,
        11
      ],
      [
        -13,
        33
      ],
      [
        0,
        54
      ],
      [
        13,
        22
      ],
      [
        -13,
        21
      ],
      [
        -62,
        -32
      ],
      [
        -12,
        11
      ],
      [
        0,
        43
      ],
      [
        37,
        65
      ],
      [
        0,
        11
      ],
      [
        -37,
        11
      ],
      [
        -37,
        32
      ],
      [
        -37,
        76
      ],
      [
        0,
        33
      ],
      [
        25,
        87
      ],
      [
        111,
        97
      ],
      [
        62,
        -11
      ],
      [
        50,
        11
      ],
      [
        37,
        33
      ],
      [
        62,
        32
      ],
      [
        0,
        44
      ],
      [
        -13,
        21
      ],
      [
        13,
        22
      ],
      [
        86,
        76
      ],
      [
        50,
        11
      ],
      [
        49,
        32
      ],
      [
        38,
        -21
      ],
      [
        37,
        10
      ],
      [
        74,
        -97
      ],
      [
        74,
        -22
      ],
      [
        50,
        22
      ],
      [
        99,
        0
      ],
      [
        50,
        -11
      ],
      [
        86,
        22
      ],
      [
        50,
        -11
      ],
      [
        87,
        32
      ],
      [
        61,
        -32
      ],
      [
        112,
        -22
      ],
      [
        74,
        -32
      ],
      [
        199,
        -55
      ],
      [
        74,
        0
      ],
      [
        99,
        33
      ],
      [
        49,
        22
      ],
      [
        38,
        -11
      ],
      [
        62,
        21
      ],
      [
        24,
        -10
      ],
      [
        38,
        -33
      ],
      [
        123,
        -54
      ],
      [
        38,
        43
      ],
      [
        24,
        11
      ],
      [
        99,
        -22
      ],
      [
        87,
        -54
      ],
      [
        50,
        0
      ],
      [
        74,
        11
      ],
      [
        50,
        33
      ],
      [
        12,
        0
      ]
    ],
    [
      [
        69704,
        92835
      ],
      [
        24,
        -22
      ],
      [
        50,
        22
      ],
      [
        49,
        -11
      ],
      [
        112,
        -76
      ],
      [
        12,
        -22
      ],
      [
        -74,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -24,
        -32
      ],
      [
        -50,
        -33
      ],
      [
        -12,
        -22
      ],
      [
        -75,
        11
      ],
      [
        -49,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        -49,
        -119
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -12,
        22
      ],
      [
        74,
        119
      ],
      [
        -25,
        11
      ],
      [
        -74,
        54
      ],
      [
        -13,
        22
      ],
      [
        25,
        11
      ],
      [
        25,
        43
      ],
      [
        -50,
        76
      ],
      [
        25,
        11
      ],
      [
        50,
        -22
      ],
      [
        37,
        22
      ],
      [
        25,
        -11
      ],
      [
        24,
        43
      ],
      [
        75,
        33
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        69951,
        92791
      ],
      [
        -24,
        -10
      ],
      [
        -62,
        43
      ],
      [
        24,
        43
      ],
      [
        62,
        -21
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -11
      ]
    ],
    [
      [
        69815,
        92965
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        22
      ],
      [
        -37,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        11
      ],
      [
        0,
        22
      ],
      [
        -25,
        76
      ],
      [
        -25,
        21
      ],
      [
        -49,
        0
      ],
      [
        -37,
        22
      ],
      [
        136,
        22
      ],
      [
        37,
        65
      ],
      [
        25,
        11
      ],
      [
        25,
        -11
      ],
      [
        0,
        -44
      ],
      [
        62,
        -10
      ],
      [
        24,
        -44
      ],
      [
        13,
        -54
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        71562,
        93366
      ],
      [
        24,
        -11
      ],
      [
        25,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        -21
      ],
      [
        -38,
        -11
      ],
      [
        -12,
        -54
      ],
      [
        -37,
        -87
      ],
      [
        -50,
        -76
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -32
      ],
      [
        38,
        -185
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -65
      ],
      [
        37,
        -87
      ],
      [
        37,
        -130
      ],
      [
        37,
        -43
      ],
      [
        -86,
        -44
      ],
      [
        -13,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        71339,
        92152
      ],
      [
        -62,
        0
      ],
      [
        -75,
        43
      ],
      [
        -49,
        -11
      ],
      [
        -99,
        -32
      ],
      [
        -87,
        43
      ],
      [
        -25,
        43
      ],
      [
        -62,
        76
      ],
      [
        -12,
        33
      ],
      [
        -74,
        11
      ],
      [
        -25,
        32
      ],
      [
        -50,
        22
      ],
      [
        -74,
        54
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -33
      ],
      [
        -50,
        44
      ],
      [
        -62,
        -44
      ],
      [
        -49,
        -10
      ],
      [
        -112,
        -44
      ],
      [
        -24,
        -32
      ],
      [
        -13,
        10
      ]
    ],
    [
      [
        70298,
        92368
      ],
      [
        0,
        22
      ],
      [
        37,
        119
      ],
      [
        13,
        98
      ],
      [
        24,
        33
      ],
      [
        -12,
        21
      ],
      [
        -62,
        22
      ],
      [
        -12,
        -33
      ],
      [
        -62,
        -43
      ],
      [
        -37,
        33
      ],
      [
        -87,
        32
      ],
      [
        -25,
        43
      ],
      [
        0,
        44
      ],
      [
        -49,
        43
      ],
      [
        -13,
        54
      ],
      [
        13,
        33
      ],
      [
        37,
        22
      ],
      [
        12,
        21
      ],
      [
        -62,
        0
      ],
      [
        0,
        22
      ],
      [
        -25,
        65
      ],
      [
        25,
        54
      ],
      [
        -12,
        11
      ],
      [
        12,
        54
      ],
      [
        0,
        55
      ],
      [
        50,
        32
      ],
      [
        49,
        11
      ],
      [
        99,
        11
      ],
      [
        -12,
        54
      ],
      [
        37,
        0
      ],
      [
        75,
        65
      ],
      [
        74,
        -11
      ],
      [
        99,
        44
      ],
      [
        198,
        0
      ],
      [
        25,
        21
      ],
      [
        -12,
        22
      ],
      [
        12,
        22
      ],
      [
        87,
        0
      ],
      [
        235,
        -44
      ],
      [
        62,
        0
      ],
      [
        74,
        -54
      ],
      [
        37,
        -11
      ],
      [
        124,
        0
      ],
      [
        198,
        -32
      ],
      [
        38,
        43
      ]
    ],
    [
      [
        76690,
        63086
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        -50,
        -141
      ],
      [
        0,
        -33
      ],
      [
        25,
        -43
      ],
      [
        25,
        -152
      ],
      [
        12,
        -32
      ],
      [
        25,
        -44
      ],
      [
        37,
        -76
      ],
      [
        13,
        -54
      ],
      [
        37,
        -32
      ],
      [
        12,
        -66
      ],
      [
        37,
        -97
      ],
      [
        25,
        -87
      ],
      [
        62,
        -87
      ],
      [
        25,
        0
      ],
      [
        62,
        -119
      ],
      [
        62,
        -87
      ],
      [
        12,
        -11
      ],
      [
        99,
        -54
      ],
      [
        112,
        -76
      ],
      [
        86,
        -54
      ],
      [
        223,
        -130
      ],
      [
        260,
        -152
      ],
      [
        211,
        -130
      ],
      [
        25,
        -22
      ],
      [
        223,
        0
      ],
      [
        124,
        0
      ]
    ],
    [
      [
        78437,
        61210
      ],
      [
        -87,
        -152
      ],
      [
        -99,
        -162
      ],
      [
        -99,
        -185
      ],
      [
        -62,
        -108
      ],
      [
        -112,
        -184
      ],
      [
        -86,
        -141
      ],
      [
        -87,
        -174
      ],
      [
        -74,
        -141
      ],
      [
        -112,
        -206
      ],
      [
        -62,
        -130
      ],
      [
        -99,
        -217
      ],
      [
        -74,
        -130
      ],
      [
        -99,
        0
      ],
      [
        -99,
        11
      ],
      [
        -124,
        10
      ],
      [
        -38,
        -10
      ],
      [
        -123,
        -55
      ],
      [
        -137,
        -119
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -76
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -161,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -75,
        -32
      ],
      [
        -37,
        -76
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        76331,
        58694
      ],
      [
        -136,
        0
      ],
      [
        -38,
        -11
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -25,
        22
      ],
      [
        -25,
        11
      ],
      [
        -74,
        130
      ],
      [
        -37,
        44
      ],
      [
        -75,
        -55
      ],
      [
        -74,
        -65
      ],
      [
        -111,
        -76
      ],
      [
        -50,
        -65
      ],
      [
        -25,
        -54
      ],
      [
        -49,
        -119
      ],
      [
        -37,
        -65
      ],
      [
        -13,
        -11
      ],
      [
        -99,
        21
      ],
      [
        -25,
        11
      ],
      [
        -62,
        11
      ],
      [
        -74,
        22
      ],
      [
        -49,
        32
      ],
      [
        -50,
        0
      ],
      [
        -74,
        11
      ],
      [
        -50,
        11
      ],
      [
        -49,
        65
      ],
      [
        -124,
        152
      ],
      [
        -75,
        76
      ],
      [
        -74,
        87
      ],
      [
        -87,
        97
      ],
      [
        -24,
        11
      ],
      [
        -100,
        11
      ],
      [
        -99,
        0
      ],
      [
        -62,
        11
      ],
      [
        -37,
        32
      ],
      [
        -12,
        65
      ],
      [
        -25,
        55
      ],
      [
        -37,
        65
      ],
      [
        0,
        86
      ],
      [
        12,
        98
      ],
      [
        0,
        109
      ],
      [
        -12,
        43
      ],
      [
        -99,
        43
      ],
      [
        -13,
        0
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        32
      ],
      [
        0,
        33
      ],
      [
        12,
        22
      ]
    ],
    [
      [
        74064,
        59649
      ],
      [
        -12,
        10
      ],
      [
        -25,
        44
      ],
      [
        -37,
        54
      ],
      [
        -25,
        119
      ],
      [
        -13,
        109
      ],
      [
        -24,
        76
      ],
      [
        -13,
        86
      ],
      [
        -49,
        228
      ],
      [
        -25,
        33
      ],
      [
        -25,
        43
      ],
      [
        -25,
        76
      ],
      [
        -74,
        65
      ],
      [
        -74,
        130
      ],
      [
        -13,
        54
      ],
      [
        0,
        44
      ],
      [
        -12,
        43
      ],
      [
        -25,
        44
      ],
      [
        -87,
        97
      ],
      [
        -49,
        22
      ],
      [
        -50,
        11
      ],
      [
        -49,
        21
      ],
      [
        -50,
        44
      ],
      [
        -25,
        32
      ],
      [
        0,
        44
      ],
      [
        13,
        54
      ],
      [
        37,
        141
      ],
      [
        25,
        87
      ],
      [
        12,
        21
      ],
      [
        50,
        11
      ],
      [
        49,
        0
      ],
      [
        25,
        -11
      ],
      [
        50,
        0
      ],
      [
        62,
        11
      ],
      [
        24,
        22
      ],
      [
        25,
        65
      ],
      [
        0,
        390
      ],
      [
        -12,
        131
      ],
      [
        12,
        21
      ]
    ],
    [
      [
        73655,
        62121
      ],
      [
        0,
        33
      ],
      [
        13,
        141
      ],
      [
        12,
        76
      ],
      [
        0,
        43
      ],
      [
        49,
        163
      ],
      [
        0,
        43
      ],
      [
        -12,
        174
      ],
      [
        25,
        76
      ],
      [
        25,
        86
      ],
      [
        24,
        33
      ],
      [
        25,
        22
      ],
      [
        74,
        -87
      ],
      [
        38,
        43
      ],
      [
        12,
        33
      ],
      [
        0,
        65
      ],
      [
        12,
        119
      ],
      [
        0,
        76
      ],
      [
        13,
        87
      ],
      [
        25,
        130
      ],
      [
        0,
        76
      ],
      [
        12,
        43
      ],
      [
        50,
        87
      ],
      [
        37,
        119
      ],
      [
        37,
        98
      ],
      [
        49,
        141
      ],
      [
        38,
        87
      ],
      [
        37,
        10
      ],
      [
        62,
        11
      ],
      [
        37,
        11
      ],
      [
        0,
        22
      ],
      [
        12,
        32
      ],
      [
        0,
        174
      ],
      [
        25,
        119
      ],
      [
        12,
        76
      ],
      [
        13,
        43
      ],
      [
        25,
        33
      ],
      [
        12,
        65
      ],
      [
        12,
        141
      ],
      [
        0,
        87
      ],
      [
        25,
        162
      ]
    ],
    [
      [
        69369,
        93757
      ],
      [
        -37,
        0
      ],
      [
        -12,
        32
      ],
      [
        49,
        11
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        69431,
        93778
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        43
      ],
      [
        25,
        22
      ],
      [
        24,
        0
      ],
      [
        -12,
        -44
      ]
    ],
    [
      [
        69555,
        93930
      ],
      [
        37,
        -22
      ],
      [
        25,
        11
      ],
      [
        25,
        -32
      ],
      [
        -38,
        -22
      ],
      [
        13,
        -65
      ],
      [
        -37,
        0
      ],
      [
        -25,
        43
      ],
      [
        -37,
        33
      ],
      [
        37,
        54
      ]
    ],
    [
      [
        69493,
        93908
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        32
      ],
      [
        12,
        22
      ],
      [
        50,
        -44
      ]
    ],
    [
      [
        69307,
        94028
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        0
      ],
      [
        -25,
        22
      ],
      [
        -13,
        54
      ],
      [
        25,
        22
      ],
      [
        13,
        -22
      ],
      [
        49,
        -43
      ]
    ],
    [
      [
        69220,
        95720
      ],
      [
        25,
        -11
      ],
      [
        25,
        21
      ],
      [
        25,
        -10
      ],
      [
        -37,
        -55
      ],
      [
        -62,
        22
      ],
      [
        -13,
        54
      ],
      [
        50,
        0
      ],
      [
        -13,
        -21
      ]
    ],
    [
      [
        70472,
        96815
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        11
      ],
      [
        0,
        43
      ],
      [
        62,
        22
      ],
      [
        37,
        -32
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        71896,
        99331
      ],
      [
        -149,
        -65
      ],
      [
        -49,
        -11
      ],
      [
        12,
        -22
      ],
      [
        87,
        0
      ],
      [
        25,
        -21
      ],
      [
        0,
        -44
      ],
      [
        -99,
        -141
      ],
      [
        0,
        -32
      ],
      [
        24,
        -87
      ],
      [
        50,
        -98
      ],
      [
        223,
        -75
      ],
      [
        62,
        -87
      ],
      [
        99,
        -109
      ],
      [
        62,
        -43
      ],
      [
        -12,
        -87
      ],
      [
        -137,
        -141
      ],
      [
        -111,
        -141
      ],
      [
        -50,
        -76
      ],
      [
        -12,
        -54
      ],
      [
        87,
        -119
      ],
      [
        49,
        -109
      ],
      [
        37,
        -54
      ],
      [
        13,
        -54
      ],
      [
        37,
        -76
      ],
      [
        37,
        -33
      ],
      [
        37,
        -54
      ],
      [
        0,
        -43
      ],
      [
        62,
        -152
      ],
      [
        0,
        -65
      ],
      [
        -124,
        -22
      ],
      [
        -12,
        -11
      ],
      [
        37,
        -32
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -76
      ],
      [
        62,
        -11
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -54
      ],
      [
        12,
        -54
      ],
      [
        50,
        -65
      ],
      [
        99,
        -22
      ],
      [
        25,
        -76
      ],
      [
        -50,
        -54
      ],
      [
        12,
        -76
      ],
      [
        25,
        -43
      ],
      [
        99,
        -55
      ],
      [
        50,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -76
      ],
      [
        -75,
        -97
      ],
      [
        -74,
        -33
      ],
      [
        0,
        -11
      ],
      [
        149,
        -141
      ],
      [
        74,
        -54
      ],
      [
        186,
        -130
      ],
      [
        49,
        -87
      ],
      [
        62,
        -76
      ],
      [
        13,
        -43
      ],
      [
        -38,
        -65
      ],
      [
        -12,
        -54
      ],
      [
        -37,
        -76
      ],
      [
        -37,
        -55
      ],
      [
        -87,
        -97
      ],
      [
        -124,
        -119
      ],
      [
        -25,
        -44
      ],
      [
        -62,
        -65
      ],
      [
        -99,
        -130
      ],
      [
        -37,
        -22
      ],
      [
        -74,
        -108
      ],
      [
        -74,
        -65
      ],
      [
        -87,
        -98
      ],
      [
        -87,
        -65
      ],
      [
        -87,
        -76
      ],
      [
        -24,
        -32
      ],
      [
        -38,
        -22
      ],
      [
        -49,
        -44
      ],
      [
        -87,
        -97
      ],
      [
        -124,
        -130
      ]
    ],
    [
      [
        71487,
        94028
      ],
      [
        -37,
        -22
      ],
      [
        -74,
        -22
      ],
      [
        -87,
        55
      ],
      [
        -49,
        -22
      ],
      [
        -38,
        -33
      ],
      [
        -86,
        -10
      ],
      [
        -62,
        -22
      ],
      [
        0,
        87
      ],
      [
        25,
        32
      ],
      [
        -13,
        11
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -55
      ],
      [
        -25,
        -21
      ],
      [
        -62,
        -11
      ],
      [
        -62,
        43
      ],
      [
        -24,
        0
      ],
      [
        24,
        -65
      ],
      [
        0,
        -22
      ],
      [
        -24,
        0
      ],
      [
        -75,
        -43
      ],
      [
        -25,
        33
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        0
      ],
      [
        -37,
        -43
      ],
      [
        -74,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -87,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        22
      ],
      [
        -111,
        -22
      ],
      [
        -99,
        -32
      ],
      [
        -50,
        0
      ],
      [
        -37,
        11
      ],
      [
        -50,
        -33
      ],
      [
        -49,
        -54
      ],
      [
        -75,
        -11
      ],
      [
        13,
        33
      ],
      [
        37,
        21
      ],
      [
        25,
        44
      ],
      [
        -13,
        43
      ],
      [
        -24,
        0
      ],
      [
        -62,
        98
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -11
      ],
      [
        -74,
        0
      ],
      [
        -12,
        22
      ],
      [
        12,
        87
      ],
      [
        37,
        0
      ],
      [
        0,
        32
      ],
      [
        -25,
        0
      ],
      [
        25,
        65
      ],
      [
        -12,
        11
      ],
      [
        -99,
        11
      ],
      [
        -112,
        65
      ],
      [
        -25,
        0
      ],
      [
        -12,
        54
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -62,
        43
      ],
      [
        0,
        54
      ],
      [
        -13,
        44
      ],
      [
        0,
        54
      ],
      [
        -12,
        76
      ],
      [
        12,
        54
      ],
      [
        38,
        76
      ],
      [
        12,
        65
      ],
      [
        0,
        76
      ],
      [
        -12,
        54
      ],
      [
        24,
        0
      ],
      [
        -24,
        44
      ],
      [
        37,
        10
      ],
      [
        -50,
        152
      ],
      [
        -25,
        55
      ],
      [
        -49,
        54
      ],
      [
        25,
        76
      ],
      [
        12,
        65
      ],
      [
        -12,
        76
      ],
      [
        -50,
        43
      ],
      [
        -25,
        130
      ],
      [
        13,
        76
      ],
      [
        111,
        130
      ],
      [
        0,
        54
      ],
      [
        62,
        0
      ],
      [
        -25,
        55
      ],
      [
        -12,
        54
      ],
      [
        99,
        22
      ],
      [
        25,
        -22
      ],
      [
        74,
        22
      ],
      [
        74,
        43
      ],
      [
        -24,
        76
      ],
      [
        49,
        32
      ],
      [
        50,
        55
      ],
      [
        0,
        43
      ],
      [
        74,
        22
      ],
      [
        87,
        86
      ],
      [
        87,
        55
      ],
      [
        86,
        86
      ],
      [
        25,
        0
      ],
      [
        25,
        55
      ],
      [
        74,
        76
      ],
      [
        25,
        10
      ],
      [
        25,
        76
      ],
      [
        86,
        76
      ],
      [
        62,
        109
      ],
      [
        25,
        32
      ],
      [
        12,
        44
      ],
      [
        38,
        0
      ],
      [
        24,
        32
      ],
      [
        75,
        22
      ],
      [
        111,
        -22
      ],
      [
        -12,
        54
      ],
      [
        49,
        44
      ],
      [
        -12,
        54
      ],
      [
        -37,
        22
      ],
      [
        25,
        65
      ],
      [
        0,
        76
      ],
      [
        12,
        76
      ],
      [
        -37,
        43
      ],
      [
        -136,
        65
      ],
      [
        -62,
        11
      ],
      [
        -25,
        54
      ],
      [
        12,
        44
      ],
      [
        -12,
        21
      ],
      [
        -62,
        -54
      ],
      [
        -87,
        22
      ]
    ],
    [
      [
        70236,
        97325
      ],
      [
        -37,
        108
      ],
      [
        -50,
        98
      ],
      [
        -49,
        32
      ],
      [
        -25,
        33
      ],
      [
        0,
        141
      ],
      [
        62,
        65
      ],
      [
        12,
        87
      ],
      [
        25,
        76
      ],
      [
        -37,
        65
      ],
      [
        -62,
        76
      ],
      [
        -25,
        75
      ],
      [
        13,
        55
      ],
      [
        37,
        21
      ],
      [
        -12,
        76
      ],
      [
        -25,
        11
      ],
      [
        -62,
        0
      ],
      [
        -13,
        11
      ],
      [
        38,
        76
      ],
      [
        -25,
        130
      ],
      [
        12,
        54
      ],
      [
        50,
        44
      ],
      [
        -62,
        43
      ],
      [
        -50,
        65
      ],
      [
        -49,
        11
      ],
      [
        -25,
        76
      ],
      [
        -50,
        32
      ],
      [
        -62,
        55
      ],
      [
        -272,
        76
      ],
      [
        -99,
        54
      ],
      [
        -87,
        54
      ],
      [
        -12,
        22
      ],
      [
        -62,
        32
      ],
      [
        -25,
        33
      ],
      [
        -87,
        43
      ],
      [
        -12,
        44
      ],
      [
        -87,
        43
      ]
    ],
    [
      [
        69022,
        99342
      ],
      [
        13,
        22
      ],
      [
        74,
        0
      ],
      [
        62,
        -22
      ],
      [
        25,
        22
      ],
      [
        -25,
        65
      ],
      [
        25,
        43
      ],
      [
        111,
        22
      ],
      [
        62,
        -11
      ],
      [
        62,
        -76
      ],
      [
        198,
        -228
      ],
      [
        0,
        -43
      ],
      [
        37,
        0
      ],
      [
        199,
        -22
      ],
      [
        24,
        -22
      ],
      [
        62,
        0
      ],
      [
        124,
        44
      ],
      [
        62,
        54
      ],
      [
        50,
        0
      ],
      [
        111,
        -54
      ],
      [
        124,
        -33
      ],
      [
        37,
        -32
      ],
      [
        50,
        -11
      ],
      [
        49,
        32
      ],
      [
        25,
        76
      ],
      [
        62,
        65
      ],
      [
        74,
        11
      ],
      [
        62,
        65
      ],
      [
        13,
        55
      ],
      [
        -13,
        97
      ],
      [
        37,
        87
      ],
      [
        50,
        173
      ],
      [
        111,
        87
      ],
      [
        87,
        87
      ],
      [
        124,
        0
      ],
      [
        62,
        -11
      ],
      [
        87,
        33
      ],
      [
        74,
        54
      ],
      [
        111,
        11
      ],
      [
        50,
        -54
      ],
      [
        74,
        -66
      ],
      [
        50,
        -32
      ],
      [
        248,
        -98
      ],
      [
        74,
        -119
      ],
      [
        -37,
        -54
      ],
      [
        -74,
        -65
      ],
      [
        -62,
        -65
      ],
      [
        12,
        -76
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        123341,
        44357
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        33
      ],
      [
        -24,
        -43
      ],
      [
        -13,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -12,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        22
      ],
      [
        25,
        33
      ],
      [
        24,
        0
      ],
      [
        38,
        65
      ],
      [
        24,
        0
      ],
      [
        13,
        21
      ],
      [
        37,
        -11
      ],
      [
        25,
        -21
      ]
    ],
    [
      [
        62,
        44378
      ],
      [
        -12,
        -10
      ],
      [
        0,
        -22
      ],
      [
        -13,
        0
      ],
      [
        0,
        32
      ],
      [
        13,
        11
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        123626,
        44910
      ],
      [
        -25,
        43
      ],
      [
        0,
        33
      ],
      [
        12,
        22
      ],
      [
        25,
        -76
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        347,
        44986
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        33
      ],
      [
        12,
        10
      ],
      [
        25,
        -32
      ]
    ],
    [
      [
        595,
        44997
      ],
      [
        -13,
        0
      ],
      [
        -25,
        21
      ],
      [
        13,
        33
      ],
      [
        25,
        -33
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        123452,
        45138
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        43
      ],
      [
        13,
        33
      ],
      [
        12,
        0
      ],
      [
        13,
        -33
      ],
      [
        -13,
        -32
      ]
    ],
    [
      [
        123266,
        45365
      ],
      [
        0,
        -32
      ],
      [
        13,
        -11
      ],
      [
        25,
        -54
      ],
      [
        62,
        -76
      ],
      [
        0,
        -65
      ],
      [
        12,
        -54
      ],
      [
        0,
        -65
      ],
      [
        12,
        -87
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        0
      ],
      [
        0,
        -11
      ],
      [
        -49,
        0
      ],
      [
        -62,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -25,
        22
      ],
      [
        -50,
        22
      ],
      [
        -62,
        21
      ],
      [
        -49,
        44
      ],
      [
        -25,
        65
      ],
      [
        0,
        32
      ],
      [
        13,
        33
      ],
      [
        24,
        32
      ],
      [
        0,
        22
      ],
      [
        25,
        22
      ],
      [
        -12,
        43
      ],
      [
        0,
        33
      ],
      [
        74,
        108
      ],
      [
        74,
        44
      ],
      [
        38,
        -11
      ],
      [
        61,
        43
      ],
      [
        25,
        11
      ],
      [
        25,
        -11
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        123650,
        45365
      ],
      [
        -12,
        65
      ],
      [
        25,
        -10
      ],
      [
        0,
        -22
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        347,
        45420
      ],
      [
        0,
        43
      ],
      [
        -13,
        22
      ],
      [
        0,
        21
      ],
      [
        25,
        -21
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        122907,
        45506
      ],
      [
        -25,
        -10
      ],
      [
        13,
        43
      ],
      [
        12,
        22
      ],
      [
        13,
        0
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        123861,
        45615
      ],
      [
        -37,
        -22
      ],
      [
        0,
        22
      ],
      [
        12,
        54
      ],
      [
        25,
        54
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -65
      ]
    ],
    [
      [
        0,
        45637
      ],
      [
        0,
        -22
      ],
      [
        0,
        32
      ],
      [
        0,
        33
      ],
      [
        0,
        22
      ],
      [
        0,
        21
      ],
      [
        25,
        55
      ],
      [
        12,
        10
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -54
      ],
      [
        -37,
        -54
      ]
    ],
    [
      [
        12,
        45908
      ],
      [
        -12,
        -22
      ],
      [
        0,
        33
      ],
      [
        25,
        32
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -11
      ]
    ],
    [
      [
        123849,
        46114
      ],
      [
        -50,
        -87
      ],
      [
        -25,
        -87
      ],
      [
        -49,
        -54
      ],
      [
        -25,
        -65
      ],
      [
        12,
        -65
      ],
      [
        38,
        65
      ],
      [
        49,
        65
      ],
      [
        12,
        11
      ],
      [
        13,
        -22
      ],
      [
        0,
        -22
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -43
      ],
      [
        -62,
        0
      ],
      [
        -50,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -24,
        22
      ],
      [
        0,
        33
      ],
      [
        -13,
        11
      ],
      [
        -37,
        0
      ],
      [
        -49,
        -66
      ],
      [
        -13,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -24,
        11
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        43
      ],
      [
        0,
        44
      ],
      [
        -12,
        32
      ],
      [
        -37,
        0
      ],
      [
        0,
        44
      ],
      [
        25,
        32
      ],
      [
        0,
        33
      ],
      [
        37,
        -33
      ],
      [
        24,
        22
      ],
      [
        13,
        0
      ],
      [
        25,
        65
      ],
      [
        74,
        65
      ],
      [
        49,
        11
      ],
      [
        50,
        22
      ],
      [
        37,
        54
      ],
      [
        50,
        43
      ],
      [
        37,
        11
      ],
      [
        37,
        -11
      ],
      [
        62,
        44
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        122870,
        48402
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        22
      ],
      [
        12,
        11
      ],
      [
        25,
        -11
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        41386,
        23588
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        22
      ],
      [
        0,
        44
      ],
      [
        37,
        -22
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        41820,
        23729
      ],
      [
        0,
        -65
      ],
      [
        -25,
        22
      ],
      [
        -13,
        32
      ],
      [
        38,
        11
      ]
    ],
    [
      [
        40928,
        23870
      ],
      [
        49,
        -11
      ],
      [
        -24,
        -97
      ],
      [
        -25,
        0
      ],
      [
        -37,
        65
      ],
      [
        37,
        43
      ]
    ],
    [
      [
        41188,
        24065
      ],
      [
        49,
        -10
      ],
      [
        38,
        43
      ],
      [
        62,
        11
      ],
      [
        12,
        -33
      ],
      [
        37,
        0
      ],
      [
        112,
        55
      ],
      [
        37,
        -44
      ],
      [
        -13,
        -32
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -55
      ],
      [
        -49,
        -86
      ],
      [
        -62,
        -98
      ],
      [
        -25,
        -11
      ],
      [
        -87,
        0
      ],
      [
        -37,
        -97
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -86,
        87
      ],
      [
        61,
        65
      ],
      [
        62,
        0
      ],
      [
        50,
        43
      ],
      [
        37,
        22
      ],
      [
        13,
        32
      ],
      [
        24,
        11
      ],
      [
        -12,
        44
      ],
      [
        -74,
        -33
      ],
      [
        -38,
        33
      ],
      [
        112,
        32
      ],
      [
        12,
        11
      ],
      [
        -24,
        33
      ],
      [
        -38,
        21
      ],
      [
        -37,
        44
      ],
      [
        0,
        76
      ],
      [
        87,
        -66
      ]
    ],
    [
      [
        41237,
        24109
      ],
      [
        -37,
        0
      ],
      [
        -12,
        22
      ],
      [
        0,
        54
      ],
      [
        37,
        0
      ],
      [
        37,
        -22
      ],
      [
        -25,
        -54
      ]
    ],
    [
      [
        41671,
        24185
      ],
      [
        62,
        -33
      ],
      [
        62,
        11
      ],
      [
        25,
        -11
      ],
      [
        24,
        -32
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        -11
      ],
      [
        12,
        -54
      ],
      [
        75,
        -33
      ],
      [
        -13,
        65
      ],
      [
        13,
        33
      ],
      [
        99,
        22
      ],
      [
        12,
        -11
      ],
      [
        37,
        -76
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -32
      ],
      [
        37,
        -11
      ],
      [
        25,
        -22
      ],
      [
        -13,
        -43
      ],
      [
        -111,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -124,
        -43
      ],
      [
        12,
        -44
      ],
      [
        0,
        -65
      ],
      [
        -161,
        65
      ],
      [
        -24,
        -11
      ],
      [
        37,
        -97
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        -76
      ],
      [
        -49,
        54
      ],
      [
        -38,
        55
      ],
      [
        0,
        43
      ],
      [
        38,
        65
      ],
      [
        -13,
        22
      ],
      [
        99,
        97
      ],
      [
        38,
        44
      ],
      [
        49,
        10
      ],
      [
        -12,
        22
      ],
      [
        0,
        98
      ],
      [
        62,
        87
      ],
      [
        0,
        54
      ],
      [
        12,
        0
      ]
    ],
    [
      [
        81125,
        42882
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -62,
        54
      ],
      [
        -25,
        33
      ],
      [
        -25,
        97
      ],
      [
        25,
        98
      ],
      [
        50,
        22
      ],
      [
        49,
        0
      ],
      [
        25,
        -22
      ],
      [
        25,
        -76
      ],
      [
        37,
        -65
      ],
      [
        -12,
        -87
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        77470,
        48109
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        22
      ],
      [
        0,
        109
      ],
      [
        -12,
        54
      ],
      [
        12,
        32
      ],
      [
        25,
        -43
      ],
      [
        25,
        -22
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        43133,
        57664
      ],
      [
        0,
        11
      ],
      [
        24,
        0
      ],
      [
        25,
        43
      ],
      [
        25,
        33
      ],
      [
        50,
        162
      ],
      [
        24,
        65
      ],
      [
        0,
        217
      ],
      [
        38,
        109
      ],
      [
        24,
        65
      ],
      [
        0,
        108
      ],
      [
        -12,
        0
      ],
      [
        -12,
        54
      ],
      [
        -13,
        33
      ],
      [
        -49,
        87
      ],
      [
        -38,
        97
      ],
      [
        13,
        55
      ],
      [
        -25,
        32
      ],
      [
        0,
        87
      ],
      [
        -12,
        54
      ],
      [
        0,
        174
      ],
      [
        -13,
        32
      ],
      [
        0,
        98
      ],
      [
        13,
        32
      ],
      [
        0,
        33
      ],
      [
        37,
        108
      ],
      [
        25,
        65
      ],
      [
        37,
        44
      ]
    ],
    [
      [
        43294,
        59562
      ],
      [
        25,
        32
      ],
      [
        24,
        163
      ],
      [
        25,
        65
      ],
      [
        25,
        0
      ],
      [
        136,
        -130
      ],
      [
        62,
        -11
      ],
      [
        136,
        -76
      ],
      [
        37,
        -97
      ],
      [
        112,
        -152
      ],
      [
        62,
        -55
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -65
      ],
      [
        37,
        54
      ],
      [
        49,
        -87
      ],
      [
        37,
        -130
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -11
      ],
      [
        13,
        22
      ],
      [
        0,
        54
      ],
      [
        12,
        65
      ],
      [
        13,
        0
      ],
      [
        24,
        -32
      ],
      [
        25,
        -185
      ],
      [
        12,
        -32
      ],
      [
        0,
        -109
      ]
    ],
    [
      [
        41002,
        65266
      ],
      [
        -12,
        -32
      ],
      [
        -13,
        21
      ],
      [
        -62,
        0
      ],
      [
        -12,
        33
      ],
      [
        25,
        43
      ],
      [
        -25,
        11
      ],
      [
        -12,
        22
      ],
      [
        -25,
        98
      ],
      [
        0,
        32
      ],
      [
        25,
        11
      ],
      [
        37,
        -33
      ],
      [
        25,
        -43
      ],
      [
        12,
        0
      ],
      [
        0,
        -43
      ],
      [
        12,
        -22
      ],
      [
        0,
        -22
      ],
      [
        25,
        -76
      ]
    ],
    [
      [
        40853,
        66145
      ],
      [
        -12,
        -11
      ],
      [
        -12,
        11
      ],
      [
        0,
        32
      ],
      [
        12,
        33
      ],
      [
        12,
        0
      ],
      [
        13,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -11
      ]
    ],
    [
      [
        40730,
        66210
      ],
      [
        -25,
        -22
      ],
      [
        -13,
        0
      ],
      [
        -12,
        54
      ],
      [
        -12,
        152
      ],
      [
        0,
        22
      ],
      [
        12,
        11
      ],
      [
        37,
        -11
      ],
      [
        25,
        -43
      ],
      [
        0,
        -131
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        40829,
        66351
      ],
      [
        -75,
        0
      ],
      [
        0,
        43
      ],
      [
        13,
        44
      ],
      [
        -13,
        43
      ],
      [
        25,
        43
      ],
      [
        13,
        -21
      ],
      [
        24,
        -65
      ],
      [
        62,
        -65
      ],
      [
        -49,
        -22
      ]
    ],
    [
      [
        65182,
        82955
      ],
      [
        0,
        -119
      ],
      [
        25,
        -44
      ],
      [
        0,
        -260
      ],
      [
        -50,
        -130
      ],
      [
        0,
        -120
      ],
      [
        -24,
        -65
      ],
      [
        -25,
        -108
      ],
      [
        -25,
        -43
      ],
      [
        -99,
        86
      ],
      [
        -25,
        44
      ],
      [
        0,
        21
      ],
      [
        25,
        22
      ],
      [
        0,
        22
      ],
      [
        -62,
        43
      ],
      [
        12,
        65
      ],
      [
        0,
        33
      ],
      [
        -49,
        0
      ],
      [
        0,
        21
      ],
      [
        37,
        55
      ],
      [
        0,
        32
      ],
      [
        -25,
        11
      ],
      [
        -25,
        65
      ],
      [
        38,
        43
      ],
      [
        -13,
        33
      ],
      [
        -25,
        11
      ],
      [
        25,
        43
      ],
      [
        25,
        76
      ],
      [
        37,
        33
      ],
      [
        62,
        32
      ],
      [
        50,
        54
      ],
      [
        49,
        -32
      ],
      [
        13,
        22
      ],
      [
        0,
        141
      ],
      [
        12,
        43
      ],
      [
        25,
        0
      ],
      [
        12,
        -22
      ],
      [
        0,
        -108
      ]
    ],
    [
      [
        61516,
        84885
      ],
      [
        -13,
        -54
      ],
      [
        -49,
        98
      ],
      [
        24,
        21
      ],
      [
        38,
        -65
      ]
    ],
    [
      [
        63919,
        87163
      ],
      [
        12,
        -22
      ],
      [
        25,
        -11
      ],
      [
        37,
        -32
      ],
      [
        25,
        11
      ],
      [
        12,
        21
      ],
      [
        37,
        0
      ],
      [
        37,
        -21
      ]
    ],
    [
      [
        64340,
        84907
      ],
      [
        -25,
        -43
      ],
      [
        -49,
        -33
      ],
      [
        0,
        -65
      ],
      [
        24,
        -22
      ],
      [
        50,
        -108
      ],
      [
        49,
        -65
      ],
      [
        -12,
        -33
      ],
      [
        -12,
        -65
      ],
      [
        -38,
        -11
      ],
      [
        -49,
        -54
      ],
      [
        -50,
        11
      ],
      [
        -24,
        -22
      ],
      [
        0,
        -32
      ],
      [
        24,
        -22
      ],
      [
        13,
        -33
      ],
      [
        0,
        -32
      ],
      [
        25,
        -33
      ],
      [
        49,
        -10
      ],
      [
        12,
        -22
      ],
      [
        13,
        -87
      ],
      [
        -25,
        0
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -76
      ],
      [
        12,
        -33
      ],
      [
        0,
        -43
      ],
      [
        13,
        -33
      ],
      [
        24,
        -32
      ],
      [
        62,
        -55
      ],
      [
        75,
        -43
      ],
      [
        86,
        22
      ],
      [
        13,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -50,
        -76
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        64501,
        83551
      ],
      [
        -13,
        -11
      ]
    ],
    [
      [
        64488,
        83540
      ],
      [
        -24,
        11
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        64464,
        83530
      ],
      [
        -75,
        -44
      ],
      [
        -99,
        -141
      ],
      [
        -49,
        -32
      ],
      [
        -25,
        -76
      ],
      [
        -37,
        -44
      ],
      [
        -87,
        -32
      ],
      [
        -62,
        -44
      ],
      [
        -37,
        22
      ],
      [
        -74,
        0
      ],
      [
        -37,
        44
      ],
      [
        -100,
        32
      ],
      [
        -24,
        76
      ],
      [
        -75,
        0
      ],
      [
        -12,
        11
      ],
      [
        0,
        54
      ],
      [
        -62,
        -11
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -86,
        43
      ],
      [
        -62,
        22
      ],
      [
        -50,
        65
      ],
      [
        -49,
        -22
      ],
      [
        -50,
        -54
      ],
      [
        -173,
        -174
      ],
      [
        -38,
        -65
      ],
      [
        -37,
        -108
      ],
      [
        0,
        -43
      ],
      [
        13,
        -163
      ],
      [
        37,
        -76
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        61305,
        83324
      ],
      [
        62,
        21
      ],
      [
        49,
        76
      ],
      [
        50,
        293
      ],
      [
        25,
        336
      ],
      [
        25,
        65
      ],
      [
        37,
        11
      ],
      [
        -25,
        54
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        25,
        315
      ],
      [
        12,
        108
      ],
      [
        25,
        120
      ],
      [
        49,
        -44
      ],
      [
        62,
        -97
      ],
      [
        25,
        -131
      ],
      [
        12,
        -10
      ],
      [
        -24,
        184
      ],
      [
        -50,
        98
      ],
      [
        -111,
        108
      ],
      [
        -13,
        43
      ],
      [
        62,
        -21
      ],
      [
        -12,
        43
      ],
      [
        -13,
        76
      ],
      [
        -12,
        173
      ],
      [
        12,
        22
      ],
      [
        -12,
        44
      ],
      [
        -87,
        21
      ],
      [
        -136,
        98
      ],
      [
        -37,
        108
      ],
      [
        -50,
        76
      ],
      [
        -12,
        44
      ],
      [
        0,
        32
      ],
      [
        25,
        76
      ],
      [
        -25,
        43
      ],
      [
        -25,
        11
      ],
      [
        -12,
        22
      ],
      [
        24,
        65
      ],
      [
        38,
        0
      ],
      [
        12,
        22
      ],
      [
        -124,
        -22
      ],
      [
        -62,
        22
      ],
      [
        0,
        43
      ],
      [
        37,
        65
      ],
      [
        -49,
        33
      ],
      [
        -37,
        0
      ],
      [
        -38,
        -11
      ],
      [
        -12,
        11
      ],
      [
        25,
        43
      ],
      [
        -13,
        11
      ],
      [
        -61,
        -11
      ],
      [
        -38,
        11
      ],
      [
        -37,
        43
      ],
      [
        -37,
        0
      ],
      [
        -12,
        22
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        33
      ],
      [
        -137,
        54
      ],
      [
        -61,
        0
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -25,
        33
      ],
      [
        -12,
        54
      ],
      [
        -87,
        43
      ],
      [
        12,
        33
      ],
      [
        87,
        21
      ],
      [
        25,
        33
      ],
      [
        -37,
        33
      ],
      [
        -37,
        10
      ],
      [
        -13,
        33
      ],
      [
        62,
        0
      ],
      [
        50,
        11
      ],
      [
        -13,
        21
      ],
      [
        -25,
        11
      ],
      [
        -123,
        0
      ],
      [
        -13,
        33
      ],
      [
        13,
        76
      ],
      [
        62,
        54
      ],
      [
        161,
        54
      ],
      [
        74,
        -11
      ],
      [
        49,
        11
      ],
      [
        62,
        33
      ],
      [
        25,
        32
      ],
      [
        74,
        11
      ],
      [
        87,
        -22
      ],
      [
        62,
        -119
      ],
      [
        37,
        -43
      ],
      [
        87,
        65
      ],
      [
        124,
        0
      ],
      [
        25,
        -33
      ],
      [
        12,
        33
      ],
      [
        25,
        32
      ],
      [
        25,
        -11
      ],
      [
        0,
        -32
      ],
      [
        136,
        11
      ],
      [
        -37,
        97
      ],
      [
        -13,
        250
      ],
      [
        -37,
        76
      ],
      [
        -62,
        173
      ],
      [
        0,
        55
      ],
      [
        62,
        0
      ],
      [
        37,
        -11
      ],
      [
        75,
        21
      ],
      [
        37,
        -10
      ],
      [
        0,
        -55
      ],
      [
        12,
        -65
      ],
      [
        25,
        -65
      ],
      [
        62,
        0
      ],
      [
        74,
        -22
      ],
      [
        87,
        0
      ],
      [
        111,
        -32
      ],
      [
        62,
        22
      ],
      [
        50,
        43
      ],
      [
        99,
        22
      ],
      [
        0,
        21
      ],
      [
        -50,
        -10
      ],
      [
        -49,
        32
      ],
      [
        -13,
        33
      ],
      [
        13,
        21
      ],
      [
        12,
        65
      ],
      [
        149,
        98
      ],
      [
        111,
        32
      ],
      [
        112,
        55
      ],
      [
        49,
        54
      ],
      [
        50,
        98
      ],
      [
        12,
        10
      ],
      [
        -12,
        22
      ],
      [
        12,
        282
      ],
      [
        25,
        87
      ],
      [
        87,
        65
      ],
      [
        186,
        54
      ],
      [
        24,
        11
      ]
    ],
    [
      [
        59620,
        94592
      ],
      [
        -25,
        11
      ],
      [
        -37,
        54
      ],
      [
        -12,
        43
      ],
      [
        49,
        -22
      ],
      [
        25,
        -54
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        59645,
        94819
      ],
      [
        -12,
        -21
      ],
      [
        -75,
        54
      ],
      [
        0,
        33
      ],
      [
        75,
        -33
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        59447,
        95026
      ],
      [
        49,
        -33
      ],
      [
        -24,
        -22
      ],
      [
        -50,
        0
      ],
      [
        -37,
        22
      ],
      [
        -12,
        33
      ],
      [
        61,
        10
      ],
      [
        13,
        -10
      ]
    ],
    [
      [
        59645,
        95091
      ],
      [
        -12,
        -87
      ],
      [
        -62,
        22
      ],
      [
        49,
        -109
      ],
      [
        -37,
        11
      ],
      [
        -74,
        76
      ],
      [
        -50,
        119
      ],
      [
        75,
        22
      ],
      [
        49,
        -33
      ],
      [
        62,
        -21
      ]
    ],
    [
      [
        59719,
        95101
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        11
      ],
      [
        25,
        54
      ],
      [
        24,
        -22
      ]
    ],
    [
      [
        118002,
        59540
      ],
      [
        0,
        -32
      ],
      [
        -25,
        21
      ],
      [
        12,
        22
      ],
      [
        13,
        -11
      ]
    ],
    [
      [
        116391,
        60473
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        54
      ],
      [
        -13,
        11
      ],
      [
        0,
        22
      ],
      [
        25,
        21
      ],
      [
        37,
        -10
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        114100,
        60798
      ],
      [
        -13,
        11
      ],
      [
        0,
        22
      ],
      [
        13,
        0
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        114186,
        60852
      ],
      [
        -12,
        0
      ],
      [
        0,
        22
      ],
      [
        12,
        0
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        109455,
        62154
      ],
      [
        0,
        43
      ],
      [
        12,
        11
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -21
      ],
      [
        -12,
        0
      ]
    ],
    [
      [
        65219,
        56861
      ],
      [
        25,
        11
      ],
      [
        25,
        22
      ],
      [
        12,
        -11
      ],
      [
        13,
        -43
      ],
      [
        37,
        -22
      ],
      [
        12,
        0
      ],
      [
        13,
        22
      ],
      [
        123,
        0
      ],
      [
        186,
        0
      ],
      [
        161,
        0
      ],
      [
        0,
        466
      ],
      [
        0,
        260
      ]
    ],
    [
      [
        65752,
        53770
      ],
      [
        -37,
        55
      ],
      [
        -25,
        97
      ],
      [
        -99,
        174
      ],
      [
        -25,
        65
      ],
      [
        -87,
        173
      ],
      [
        -111,
        163
      ],
      [
        -87,
        141
      ],
      [
        0,
        33
      ],
      [
        87,
        -76
      ],
      [
        12,
        21
      ],
      [
        -24,
        44
      ],
      [
        -38,
        32
      ],
      [
        -37,
        11
      ],
      [
        -24,
        0
      ],
      [
        -25,
        33
      ],
      [
        -13,
        43
      ],
      [
        0,
        43
      ],
      [
        -12,
        44
      ],
      [
        -50,
        87
      ],
      [
        -24,
        75
      ],
      [
        49,
        -43
      ],
      [
        13,
        22
      ],
      [
        -13,
        21
      ],
      [
        -49,
        44
      ],
      [
        -25,
        0
      ],
      [
        0,
        65
      ],
      [
        -37,
        119
      ],
      [
        -37,
        98
      ],
      [
        0,
        43
      ],
      [
        99,
        -206
      ],
      [
        24,
        0
      ],
      [
        50,
        22
      ],
      [
        -12,
        32
      ],
      [
        -25,
        22
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        0
      ],
      [
        -13,
        11
      ],
      [
        0,
        22
      ],
      [
        25,
        97
      ],
      [
        -12,
        0
      ],
      [
        -25,
        -32
      ],
      [
        -13,
        0
      ],
      [
        -49,
        54
      ],
      [
        -50,
        141
      ],
      [
        -12,
        22
      ],
      [
        0,
        54
      ],
      [
        -12,
        22
      ],
      [
        -50,
        195
      ],
      [
        12,
        -11
      ],
      [
        25,
        -65
      ],
      [
        37,
        22
      ],
      [
        25,
        32
      ],
      [
        25,
        0
      ],
      [
        25,
        33
      ],
      [
        49,
        141
      ],
      [
        13,
        184
      ],
      [
        0,
        109
      ],
      [
        -13,
        108
      ],
      [
        25,
        11
      ],
      [
        12,
        -44
      ],
      [
        0,
        -21
      ],
      [
        25,
        -33
      ],
      [
        37,
        0
      ],
      [
        75,
        -65
      ],
      [
        12,
        54
      ],
      [
        62,
        44
      ],
      [
        -25,
        11
      ],
      [
        -49,
        -22
      ],
      [
        -87,
        65
      ],
      [
        -25,
        43
      ],
      [
        -25,
        76
      ],
      [
        -24,
        44
      ],
      [
        0,
        32
      ],
      [
        62,
        44
      ],
      [
        12,
        -11
      ],
      [
        0,
        -33
      ],
      [
        25,
        -22
      ],
      [
        0,
        131
      ],
      [
        -13,
        130
      ],
      [
        0,
        32
      ]
    ],
    [
      [
        61553,
        87879
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -33
      ],
      [
        -38,
        -11
      ],
      [
        -74,
        55
      ],
      [
        0,
        21
      ],
      [
        50,
        11
      ],
      [
        24,
        33
      ],
      [
        50,
        -22
      ],
      [
        25,
        -32
      ]
    ],
    [
      [
        60475,
        89527
      ],
      [
        50,
        -43
      ],
      [
        -50,
        -22
      ],
      [
        -50,
        -54
      ],
      [
        -37,
        21
      ],
      [
        -24,
        55
      ],
      [
        -13,
        76
      ],
      [
        37,
        21
      ],
      [
        50,
        0
      ],
      [
        37,
        -54
      ]
    ],
    [
      [
        59781,
        90004
      ],
      [
        -24,
        0
      ],
      [
        -38,
        -22
      ],
      [
        -86,
        0
      ],
      [
        0,
        76
      ],
      [
        -50,
        22
      ],
      [
        -25,
        54
      ],
      [
        0,
        22
      ],
      [
        -49,
        43
      ],
      [
        -13,
        0
      ],
      [
        -49,
        -65
      ],
      [
        12,
        -43
      ],
      [
        -49,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        32
      ],
      [
        -62,
        22
      ],
      [
        -13,
        43
      ],
      [
        -74,
        76
      ],
      [
        -12,
        44
      ],
      [
        124,
        65
      ],
      [
        12,
        22
      ],
      [
        -62,
        43
      ],
      [
        12,
        22
      ],
      [
        50,
        0
      ],
      [
        50,
        21
      ],
      [
        37,
        44
      ],
      [
        12,
        32
      ],
      [
        13,
        76
      ],
      [
        12,
        22
      ],
      [
        62,
        43
      ]
    ],
    [
      [
        59447,
        90633
      ],
      [
        12,
        -32
      ],
      [
        25,
        0
      ],
      [
        25,
        21
      ],
      [
        25,
        65
      ],
      [
        86,
        0
      ],
      [
        75,
        33
      ],
      [
        123,
        -11
      ],
      [
        25,
        -43
      ],
      [
        25,
        -76
      ],
      [
        37,
        -76
      ],
      [
        50,
        -54
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -54
      ],
      [
        74,
        0
      ],
      [
        37,
        -65
      ],
      [
        0,
        -76
      ],
      [
        -49,
        65
      ],
      [
        -25,
        0
      ],
      [
        12,
        -43
      ],
      [
        0,
        -54
      ],
      [
        38,
        -11
      ],
      [
        -25,
        -65
      ],
      [
        -74,
        -22
      ],
      [
        -13,
        -43
      ],
      [
        -25,
        -44
      ],
      [
        -24,
        -22
      ],
      [
        -38,
        0
      ],
      [
        -37,
        22
      ]
    ],
    [
      [
        60165,
        90850
      ],
      [
        -37,
        0
      ],
      [
        -37,
        22
      ],
      [
        -25,
        87
      ],
      [
        25,
        54
      ],
      [
        25,
        11
      ],
      [
        37,
        -33
      ],
      [
        12,
        -65
      ],
      [
        0,
        -76
      ]
    ],
    [
      [
        59818,
        91154
      ],
      [
        25,
        -152
      ],
      [
        -12,
        -22
      ],
      [
        -62,
        -32
      ],
      [
        0,
        43
      ],
      [
        -25,
        65
      ],
      [
        -49,
        -54
      ],
      [
        0,
        76
      ],
      [
        49,
        43
      ],
      [
        13,
        -11
      ],
      [
        61,
        44
      ]
    ],
    [
      [
        59868,
        91078
      ],
      [
        -25,
        0
      ],
      [
        -12,
        54
      ],
      [
        37,
        54
      ],
      [
        12,
        33
      ],
      [
        62,
        54
      ],
      [
        13,
        0
      ],
      [
        -25,
        -76
      ],
      [
        -62,
        -119
      ]
    ],
    [
      [
        59942,
        91414
      ],
      [
        -148,
        -43
      ],
      [
        -37,
        11
      ],
      [
        0,
        21
      ],
      [
        37,
        11
      ],
      [
        12,
        87
      ],
      [
        -62,
        54
      ],
      [
        13,
        22
      ],
      [
        37,
        21
      ],
      [
        24,
        0
      ],
      [
        38,
        -21
      ],
      [
        24,
        -44
      ],
      [
        38,
        -10
      ],
      [
        24,
        -22
      ],
      [
        0,
        -87
      ]
    ],
    [
      [
        59373,
        91794
      ],
      [
        -38,
        0
      ],
      [
        0,
        32
      ],
      [
        38,
        -11
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        59769,
        91794
      ],
      [
        -25,
        0
      ],
      [
        -37,
        32
      ],
      [
        37,
        22
      ],
      [
        25,
        -11
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        59434,
        91891
      ],
      [
        -37,
        0
      ],
      [
        -24,
        44
      ],
      [
        0,
        119
      ],
      [
        37,
        11
      ],
      [
        12,
        -11
      ],
      [
        12,
        -163
      ]
    ],
    [
      [
        59806,
        92130
      ],
      [
        0,
        -87
      ],
      [
        25,
        -43
      ],
      [
        74,
        -11
      ],
      [
        62,
        0
      ],
      [
        12,
        -33
      ],
      [
        -49,
        -43
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        97
      ],
      [
        -37,
        -10
      ],
      [
        -62,
        10
      ],
      [
        -37,
        76
      ],
      [
        -74,
        22
      ],
      [
        -38,
        65
      ],
      [
        25,
        22
      ],
      [
        37,
        0
      ],
      [
        -12,
        43
      ],
      [
        87,
        22
      ],
      [
        0,
        43
      ],
      [
        25,
        0
      ],
      [
        49,
        -54
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        59447,
        92249
      ],
      [
        37,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -49,
        0
      ],
      [
        -75,
        43
      ],
      [
        25,
        32
      ],
      [
        50,
        11
      ],
      [
        12,
        -11
      ],
      [
        25,
        22
      ]
    ],
    [
      [
        59794,
        92672
      ],
      [
        -50,
        -108
      ],
      [
        -12,
        0
      ],
      [
        -25,
        -65
      ],
      [
        12,
        -44
      ],
      [
        -99,
        -65
      ],
      [
        -37,
        -54
      ],
      [
        -12,
        0
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -25,
        32
      ],
      [
        50,
        33
      ],
      [
        0,
        21
      ],
      [
        24,
        22
      ],
      [
        -62,
        43
      ],
      [
        13,
        44
      ],
      [
        -25,
        11
      ],
      [
        0,
        54
      ],
      [
        25,
        32
      ],
      [
        25,
        0
      ],
      [
        24,
        -21
      ],
      [
        50,
        0
      ],
      [
        -25,
        54
      ],
      [
        25,
        32
      ],
      [
        62,
        33
      ],
      [
        87,
        65
      ],
      [
        24,
        11
      ],
      [
        13,
        -44
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        60859,
        92770
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -55
      ],
      [
        -74,
        -54
      ],
      [
        -124,
        -119
      ],
      [
        -75,
        -54
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -43
      ],
      [
        62,
        -11
      ],
      [
        -74,
        -98
      ],
      [
        -25,
        -54
      ],
      [
        49,
        0
      ],
      [
        50,
        11
      ],
      [
        74,
        43
      ],
      [
        75,
        22
      ],
      [
        37,
        0
      ],
      [
        74,
        -22
      ],
      [
        50,
        11
      ],
      [
        247,
        0
      ],
      [
        50,
        11
      ],
      [
        49,
        -22
      ],
      [
        25,
        -32
      ],
      [
        37,
        -87
      ],
      [
        -62,
        -76
      ],
      [
        -37,
        -98
      ],
      [
        0,
        -32
      ],
      [
        -74,
        -174
      ],
      [
        -50,
        -86
      ],
      [
        -24,
        -65
      ],
      [
        -62,
        -76
      ],
      [
        -137,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        74,
        11
      ],
      [
        75,
        -55
      ],
      [
        0,
        -43
      ],
      [
        -38,
        -33
      ],
      [
        -74,
        0
      ],
      [
        -62,
        -75
      ],
      [
        -62,
        -33
      ],
      [
        99,
        -43
      ],
      [
        13,
        0
      ],
      [
        62,
        43
      ],
      [
        86,
        0
      ],
      [
        149,
        -76
      ],
      [
        50,
        -54
      ],
      [
        62,
        -87
      ],
      [
        61,
        -65
      ],
      [
        50,
        -195
      ],
      [
        25,
        -141
      ],
      [
        49,
        -163
      ],
      [
        50,
        -76
      ],
      [
        136,
        -65
      ],
      [
        25,
        -22
      ],
      [
        111,
        -141
      ],
      [
        100,
        -108
      ],
      [
        -50,
        -54
      ],
      [
        12,
        -54
      ],
      [
        62,
        -120
      ],
      [
        13,
        -65
      ],
      [
        -37,
        0
      ],
      [
        -38,
        22
      ],
      [
        -24,
        32
      ],
      [
        -75,
        -10
      ],
      [
        0,
        -11
      ],
      [
        62,
        0
      ],
      [
        149,
        -141
      ],
      [
        49,
        -87
      ],
      [
        25,
        -108
      ],
      [
        -25,
        -44
      ],
      [
        -86,
        -108
      ],
      [
        86,
        -65
      ],
      [
        38,
        10
      ],
      [
        37,
        66
      ],
      [
        25,
        21
      ],
      [
        49,
        11
      ],
      [
        74,
        -22
      ],
      [
        38,
        11
      ],
      [
        74,
        -21
      ],
      [
        37,
        -22
      ],
      [
        99,
        -87
      ],
      [
        25,
        -54
      ],
      [
        0,
        -54
      ],
      [
        12,
        -76
      ],
      [
        -24,
        -54
      ],
      [
        -25,
        -131
      ],
      [
        -25,
        -54
      ],
      [
        -74,
        -76
      ],
      [
        -38,
        11
      ],
      [
        13,
        -76
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -75,
        -44
      ],
      [
        50,
        -21
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -74,
        -11
      ],
      [
        24,
        -76
      ],
      [
        13,
        -11
      ],
      [
        74,
        -11
      ],
      [
        173,
        0
      ],
      [
        0,
        -119
      ],
      [
        -12,
        -11
      ],
      [
        -111,
        -65
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -75,
        0
      ],
      [
        -24,
        -32
      ],
      [
        -87,
        -44
      ],
      [
        -74,
        -32
      ],
      [
        -149,
        32
      ],
      [
        -87,
        0
      ],
      [
        -111,
        -32
      ],
      [
        -75,
        32
      ],
      [
        -37,
        22
      ],
      [
        -62,
        11
      ],
      [
        -12,
        -33
      ],
      [
        -62,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -62,
        -22
      ],
      [
        -49,
        11
      ],
      [
        0,
        -32
      ],
      [
        24,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -99,
        22
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -37,
        33
      ],
      [
        -38,
        21
      ],
      [
        -49,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -148,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -13,
        -76
      ],
      [
        -49,
        -119
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        43
      ],
      [
        -74,
        33
      ],
      [
        -25,
        32
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -10
      ],
      [
        -112,
        -55
      ],
      [
        -74,
        -76
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -10
      ],
      [
        -37,
        43
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -13,
        22
      ],
      [
        0,
        32
      ],
      [
        25,
        44
      ],
      [
        87,
        22
      ],
      [
        62,
        86
      ],
      [
        37,
        44
      ],
      [
        12,
        32
      ],
      [
        38,
        22
      ],
      [
        12,
        32
      ],
      [
        99,
        120
      ],
      [
        0,
        32
      ],
      [
        13,
        44
      ],
      [
        0,
        54
      ],
      [
        86,
        22
      ],
      [
        37,
        108
      ],
      [
        112,
        22
      ],
      [
        87,
        0
      ],
      [
        74,
        -22
      ],
      [
        49,
        0
      ],
      [
        38,
        11
      ],
      [
        37,
        22
      ],
      [
        74,
        141
      ],
      [
        25,
        65
      ],
      [
        -87,
        -22
      ],
      [
        -99,
        -87
      ],
      [
        0,
        -11
      ],
      [
        -99,
        22
      ],
      [
        -112,
        108
      ],
      [
        -74,
        -21
      ],
      [
        -49,
        11
      ],
      [
        49,
        54
      ],
      [
        -62,
        11
      ],
      [
        -37,
        32
      ],
      [
        -49,
        11
      ],
      [
        -62,
        -43
      ],
      [
        -62,
        -33
      ],
      [
        -75,
        44
      ],
      [
        -24,
        21
      ],
      [
        0,
        76
      ],
      [
        -25,
        22
      ],
      [
        25,
        43
      ],
      [
        99,
        54
      ],
      [
        173,
        98
      ],
      [
        62,
        43
      ],
      [
        25,
        33
      ],
      [
        25,
        98
      ],
      [
        24,
        43
      ],
      [
        -24,
        33
      ],
      [
        12,
        65
      ],
      [
        -25,
        75
      ],
      [
        0,
        55
      ],
      [
        -87,
        -11
      ],
      [
        -74,
        -54
      ],
      [
        -37,
        0
      ],
      [
        12,
        54
      ],
      [
        38,
        43
      ],
      [
        49,
        33
      ],
      [
        37,
        76
      ],
      [
        62,
        54
      ],
      [
        99,
        43
      ],
      [
        13,
        11
      ],
      [
        49,
        -11
      ],
      [
        75,
        33
      ],
      [
        37,
        0
      ],
      [
        74,
        -54
      ],
      [
        -25,
        86
      ],
      [
        37,
        22
      ],
      [
        0,
        98
      ],
      [
        50,
        86
      ],
      [
        -25,
        11
      ],
      [
        -25,
        65
      ],
      [
        13,
        33
      ],
      [
        37,
        32
      ],
      [
        25,
        109
      ],
      [
        -13,
        32
      ],
      [
        -99,
        -32
      ],
      [
        -86,
        108
      ],
      [
        -50,
        109
      ],
      [
        -12,
        54
      ],
      [
        49,
        130
      ],
      [
        62,
        87
      ],
      [
        -49,
        32
      ],
      [
        -50,
        -10
      ],
      [
        -50,
        -44
      ],
      [
        -24,
        0
      ],
      [
        -38,
        -43
      ],
      [
        -86,
        -22
      ],
      [
        -25,
        44
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -22
      ],
      [
        -112,
        55
      ],
      [
        -24,
        -44
      ],
      [
        0,
        -54
      ],
      [
        -50,
        43
      ],
      [
        -49,
        98
      ],
      [
        0,
        43
      ],
      [
        24,
        22
      ],
      [
        25,
        -11
      ],
      [
        25,
        98
      ],
      [
        62,
        130
      ],
      [
        25,
        32
      ],
      [
        12,
        55
      ],
      [
        -12,
        65
      ],
      [
        -62,
        54
      ],
      [
        0,
        54
      ],
      [
        24,
        98
      ],
      [
        50,
        21
      ],
      [
        -62,
        55
      ],
      [
        -25,
        -22
      ],
      [
        -49,
        -22
      ],
      [
        -13,
        -21
      ],
      [
        -49,
        -11
      ],
      [
        0,
        43
      ],
      [
        25,
        76
      ],
      [
        -38,
        -22
      ],
      [
        -37,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        12,
        -10
      ],
      [
        13,
        -76
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        -238
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        0
      ],
      [
        -13,
        22
      ],
      [
        0,
        54
      ],
      [
        25,
        109
      ],
      [
        25,
        65
      ],
      [
        37,
        43
      ],
      [
        -37,
        0
      ],
      [
        0,
        163
      ],
      [
        25,
        54
      ],
      [
        0,
        65
      ],
      [
        24,
        65
      ],
      [
        25,
        98
      ],
      [
        25,
        32
      ],
      [
        0,
        33
      ],
      [
        50,
        86
      ],
      [
        -13,
        0
      ],
      [
        -149,
        -140
      ],
      [
        -74,
        21
      ],
      [
        -25,
        33
      ],
      [
        -12,
        54
      ],
      [
        -50,
        11
      ],
      [
        25,
        32
      ],
      [
        62,
        11
      ],
      [
        50,
        44
      ],
      [
        -50,
        32
      ],
      [
        50,
        33
      ],
      [
        49,
        86
      ],
      [
        13,
        87
      ],
      [
        -38,
        65
      ],
      [
        -49,
        22
      ],
      [
        -12,
        43
      ],
      [
        49,
        55
      ],
      [
        -25,
        86
      ],
      [
        50,
        130
      ],
      [
        87,
        0
      ],
      [
        24,
        22
      ],
      [
        38,
        0
      ],
      [
        -75,
        87
      ],
      [
        13,
        54
      ],
      [
        0,
        43
      ],
      [
        12,
        22
      ],
      [
        87,
        0
      ],
      [
        24,
        11
      ],
      [
        -24,
        54
      ],
      [
        0,
        109
      ],
      [
        24,
        32
      ],
      [
        25,
        11
      ],
      [
        62,
        -22
      ],
      [
        13,
        -32
      ],
      [
        74,
        43
      ],
      [
        25,
        -32
      ],
      [
        86,
        21
      ],
      [
        112,
        11
      ],
      [
        62,
        22
      ],
      [
        136,
        22
      ],
      [
        74,
        0
      ],
      [
        -12,
        -76
      ]
    ],
    [
      [
        60834,
        92943
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        33
      ],
      [
        0,
        43
      ],
      [
        37,
        0
      ],
      [
        37,
        -65
      ]
    ],
    [
      [
        60871,
        93084
      ],
      [
        0,
        -11
      ],
      [
        87,
        -10
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        0
      ],
      [
        -37,
        33
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        11
      ],
      [
        0,
        43
      ],
      [
        -37,
        -21
      ],
      [
        0,
        54
      ],
      [
        13,
        43
      ],
      [
        24,
        11
      ],
      [
        62,
        -32
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        61045,
        93214
      ],
      [
        -37,
        0
      ],
      [
        24,
        33
      ],
      [
        62,
        11
      ],
      [
        0,
        -22
      ],
      [
        -49,
        -22
      ]
    ],
    [
      [
        60983,
        93182
      ],
      [
        -37,
        0
      ],
      [
        0,
        43
      ],
      [
        -62,
        22
      ],
      [
        -13,
        22
      ],
      [
        25,
        21
      ],
      [
        50,
        -43
      ],
      [
        12,
        -33
      ],
      [
        25,
        0
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        61478,
        94028
      ],
      [
        0,
        -44
      ],
      [
        25,
        11
      ],
      [
        25,
        -43
      ],
      [
        25,
        -22
      ],
      [
        -13,
        -108
      ],
      [
        -12,
        -55
      ],
      [
        -12,
        0
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -21
      ],
      [
        -13,
        -55
      ],
      [
        -24,
        11
      ],
      [
        37,
        130
      ],
      [
        -25,
        44
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        43
      ],
      [
        -37,
        -10
      ],
      [
        -13,
        32
      ],
      [
        50,
        11
      ],
      [
        50,
        22
      ],
      [
        -25,
        86
      ],
      [
        -50,
        22
      ],
      [
        62,
        65
      ],
      [
        37,
        0
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        61565,
        94017
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        65
      ],
      [
        25,
        76
      ],
      [
        24,
        -11
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -87
      ]
    ],
    [
      [
        61652,
        94201
      ],
      [
        -13,
        -76
      ],
      [
        -37,
        0
      ],
      [
        0,
        65
      ],
      [
        50,
        11
      ]
    ],
    [
      [
        76876,
        81892
      ],
      [
        -13,
        43
      ],
      [
        -24,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -25,
        44
      ],
      [
        13,
        10
      ],
      [
        -37,
        44
      ],
      [
        -50,
        76
      ],
      [
        -37,
        11
      ],
      [
        -13,
        43
      ],
      [
        -24,
        22
      ],
      [
        -50,
        -22
      ],
      [
        -12,
        -54
      ],
      [
        -13,
        -22
      ],
      [
        -99,
        33
      ],
      [
        -99,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -24,
        0
      ],
      [
        -25,
        22
      ],
      [
        -37,
        11
      ],
      [
        -25,
        21
      ]
    ],
    [
      [
        76207,
        82152
      ],
      [
        62,
        109
      ],
      [
        25,
        76
      ],
      [
        0,
        97
      ],
      [
        -38,
        109
      ],
      [
        -24,
        152
      ],
      [
        -37,
        162
      ],
      [
        -25,
        54
      ],
      [
        -99,
        55
      ],
      [
        -25,
        65
      ],
      [
        -74,
        86
      ],
      [
        -124,
        44
      ],
      [
        -99,
        108
      ],
      [
        -75,
        65
      ]
    ],
    [
      [
        75674,
        83334
      ],
      [
        25,
        44
      ],
      [
        12,
        43
      ],
      [
        25,
        11
      ],
      [
        124,
        -33
      ],
      [
        50,
        11
      ],
      [
        49,
        -32
      ],
      [
        50,
        -44
      ],
      [
        49,
        -21
      ],
      [
        99,
        -33
      ],
      [
        75,
        -65
      ],
      [
        161,
        -22
      ],
      [
        74,
        22
      ],
      [
        50,
        0
      ],
      [
        49,
        -43
      ],
      [
        37,
        0
      ],
      [
        37,
        11
      ],
      [
        38,
        -22
      ],
      [
        37,
        -33
      ],
      [
        0,
        -21
      ],
      [
        37,
        -44
      ],
      [
        87,
        -54
      ],
      [
        74,
        -32
      ],
      [
        87,
        -76
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -32
      ],
      [
        25,
        -22
      ],
      [
        49,
        0
      ],
      [
        13,
        22
      ],
      [
        37,
        11
      ],
      [
        37,
        21
      ],
      [
        37,
        33
      ],
      [
        62,
        32
      ],
      [
        50,
        -11
      ],
      [
        49,
        -75
      ],
      [
        25,
        75
      ],
      [
        124,
        -54
      ],
      [
        37,
        -76
      ],
      [
        87,
        0
      ],
      [
        49,
        -32
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -76
      ],
      [
        12,
        -22
      ],
      [
        87,
        -76
      ],
      [
        13,
        -32
      ],
      [
        74,
        -22
      ],
      [
        25,
        0
      ],
      [
        12,
        -22
      ],
      [
        62,
        -43
      ]
    ],
    [
      [
        61057,
        87130
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        22
      ],
      [
        25,
        32
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        60859,
        59421
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        61900,
        63162
      ],
      [
        24,
        -43
      ],
      [
        0,
        -98
      ],
      [
        -24,
        -65
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -22
      ],
      [
        0,
        -21
      ],
      [
        37,
        -44
      ],
      [
        12,
        -32
      ],
      [
        25,
        -44
      ],
      [
        62,
        -86
      ],
      [
        25,
        -11
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -249
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -87
      ],
      [
        -25,
        0
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -22
      ],
      [
        24,
        -11
      ],
      [
        25,
        33
      ],
      [
        13,
        0
      ],
      [
        49,
        -54
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -87
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -86
      ],
      [
        13,
        -44
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -33
      ],
      [
        13,
        -21
      ],
      [
        24,
        -98
      ],
      [
        50,
        -54
      ],
      [
        25,
        -76
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -260
      ],
      [
        -37,
        -109
      ],
      [
        0,
        -65
      ],
      [
        12,
        -32
      ],
      [
        13,
        0
      ],
      [
        24,
        -22
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -87
      ],
      [
        -12,
        -54
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -108
      ],
      [
        25,
        -33
      ],
      [
        25,
        -97
      ],
      [
        12,
        -11
      ],
      [
        0,
        -76
      ],
      [
        62,
        -76
      ],
      [
        25,
        -11
      ],
      [
        25,
        -65
      ],
      [
        12,
        -22
      ],
      [
        37,
        -21
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        62333,
        60017
      ],
      [
        -25,
        -21
      ],
      [
        -24,
        -33
      ],
      [
        -13,
        -65
      ],
      [
        -25,
        -54
      ],
      [
        -62,
        -33
      ],
      [
        -173,
        0
      ],
      [
        -136,
        -119
      ],
      [
        -75,
        -43
      ],
      [
        -37,
        -66
      ],
      [
        -74,
        -43
      ],
      [
        -37,
        -65
      ],
      [
        -99,
        -22
      ],
      [
        -199,
        -130
      ],
      [
        -37,
        -65
      ],
      [
        -86,
        -65
      ],
      [
        -25,
        0
      ],
      [
        -62,
        65
      ],
      [
        -50,
        33
      ],
      [
        -111,
        54
      ],
      [
        -74,
        22
      ],
      [
        -50,
        21
      ]
    ],
    [
      [
        59001,
        60939
      ],
      [
        -25,
        33
      ],
      [
        0,
        32
      ],
      [
        -12,
        11
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        -87
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        0
      ],
      [
        0,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -24,
        44
      ],
      [
        -25,
        54
      ],
      [
        -37,
        21
      ],
      [
        -13,
        -10
      ],
      [
        -25,
        10
      ],
      [
        0,
        22
      ],
      [
        25,
        44
      ],
      [
        0,
        32
      ],
      [
        13,
        43
      ],
      [
        0,
        44
      ],
      [
        -25,
        97
      ],
      [
        0,
        66
      ],
      [
        -13,
        32
      ],
      [
        0,
        87
      ],
      [
        -12,
        11
      ],
      [
        0,
        108
      ],
      [
        -12,
        22
      ],
      [
        -25,
        11
      ],
      [
        -13,
        21
      ],
      [
        0,
        22
      ],
      [
        -12,
        11
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        43
      ],
      [
        -12,
        -10
      ],
      [
        -99,
        -55
      ],
      [
        0,
        44
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        0
      ]
    ],
    [
      [
        58382,
        61514
      ],
      [
        -25,
        11
      ],
      [
        -13,
        -11
      ],
      [
        -37,
        -76
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -25,
        33
      ],
      [
        0,
        22
      ],
      [
        25,
        86
      ],
      [
        37,
        76
      ],
      [
        0,
        22
      ],
      [
        -12,
        43
      ],
      [
        -25,
        65
      ],
      [
        0,
        120
      ],
      [
        -37,
        11
      ],
      [
        -13,
        32
      ],
      [
        25,
        87
      ],
      [
        0,
        32
      ],
      [
        -25,
        44
      ],
      [
        -37,
        76
      ],
      [
        -24,
        97
      ],
      [
        -38,
        76
      ],
      [
        -24,
        33
      ],
      [
        -25,
        54
      ],
      [
        0,
        33
      ],
      [
        -25,
        10
      ],
      [
        -223,
        0
      ],
      [
        0,
        -43
      ],
      [
        -74,
        -32
      ],
      [
        -50,
        32
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        -98
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -21
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -119
      ],
      [
        -25,
        -43
      ],
      [
        -49,
        -22
      ],
      [
        -13,
        -76
      ],
      [
        -24,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        22
      ],
      [
        -13,
        -11
      ]
    ],
    [
      [
        57353,
        61872
      ],
      [
        0,
        97
      ],
      [
        -37,
        65
      ],
      [
        0,
        22
      ],
      [
        -12,
        44
      ],
      [
        -50,
        75
      ],
      [
        -37,
        0
      ],
      [
        13,
        55
      ],
      [
        0,
        86
      ],
      [
        -25,
        55
      ],
      [
        12,
        43
      ],
      [
        -12,
        0
      ],
      [
        -13,
        -32
      ],
      [
        -24,
        10
      ],
      [
        -50,
        44
      ],
      [
        -25,
        97
      ],
      [
        0,
        11
      ],
      [
        -49,
        0
      ],
      [
        -87,
        76
      ],
      [
        -62,
        184
      ],
      [
        0,
        44
      ],
      [
        12,
        87
      ],
      [
        -37,
        -44
      ],
      [
        0,
        33
      ],
      [
        -25,
        76
      ],
      [
        0,
        43
      ],
      [
        -24,
        22
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        -87
      ],
      [
        -25,
        11
      ],
      [
        0,
        65
      ]
    ],
    [
      [
        56746,
        63043
      ],
      [
        38,
        87
      ],
      [
        61,
        206
      ],
      [
        13,
        54
      ],
      [
        12,
        11
      ],
      [
        25,
        0
      ],
      [
        62,
        32
      ],
      [
        37,
        44
      ],
      [
        25,
        22
      ],
      [
        49,
        -11
      ],
      [
        50,
        11
      ],
      [
        87,
        43
      ],
      [
        0,
        141
      ],
      [
        -13,
        32
      ],
      [
        -37,
        55
      ],
      [
        -25,
        54
      ],
      [
        0,
        22
      ],
      [
        25,
        32
      ],
      [
        37,
        0
      ],
      [
        13,
        11
      ],
      [
        12,
        65
      ],
      [
        0,
        54
      ],
      [
        -12,
        76
      ],
      [
        0,
        44
      ]
    ],
    [
      [
        57205,
        64128
      ],
      [
        111,
        0
      ],
      [
        13,
        -11
      ],
      [
        49,
        -11
      ],
      [
        50,
        0
      ],
      [
        0,
        -87
      ],
      [
        24,
        0
      ],
      [
        25,
        22
      ],
      [
        99,
        -87
      ],
      [
        38,
        -11
      ],
      [
        24,
        0
      ],
      [
        25,
        -21
      ],
      [
        37,
        -11
      ],
      [
        37,
        32
      ],
      [
        99,
        22
      ],
      [
        25,
        -11
      ],
      [
        87,
        22
      ],
      [
        37,
        0
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        58010,
        63965
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -54
      ],
      [
        25,
        -43
      ],
      [
        37,
        -55
      ],
      [
        37,
        11
      ],
      [
        62,
        109
      ],
      [
        25,
        0
      ],
      [
        24,
        -33
      ],
      [
        25,
        -76
      ],
      [
        25,
        -65
      ],
      [
        12,
        -11
      ],
      [
        25,
        22
      ],
      [
        50,
        119
      ],
      [
        37,
        33
      ],
      [
        12,
        0
      ],
      [
        25,
        22
      ],
      [
        37,
        -22
      ],
      [
        50,
        -43
      ],
      [
        62,
        -44
      ],
      [
        24,
        -11
      ],
      [
        13,
        11
      ],
      [
        24,
        65
      ],
      [
        62,
        54
      ],
      [
        38,
        11
      ],
      [
        12,
        22
      ],
      [
        0,
        54
      ],
      [
        -25,
        44
      ],
      [
        0,
        10
      ],
      [
        37,
        22
      ],
      [
        62,
        -32
      ],
      [
        25,
        -22
      ],
      [
        12,
        -43
      ],
      [
        25,
        -141
      ],
      [
        37,
        -120
      ],
      [
        0,
        -152
      ],
      [
        13,
        -21
      ],
      [
        12,
        0
      ],
      [
        13,
        -22
      ],
      [
        12,
        -54
      ],
      [
        74,
        -65
      ],
      [
        25,
        -33
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -21
      ],
      [
        -37,
        -44
      ],
      [
        -50,
        -119
      ],
      [
        0,
        -22
      ],
      [
        25,
        -10
      ],
      [
        49,
        43
      ],
      [
        25,
        -11
      ],
      [
        25,
        -54
      ],
      [
        0,
        -206
      ],
      [
        12,
        -87
      ],
      [
        13,
        -22
      ],
      [
        86,
        -76
      ],
      [
        0,
        -32
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -43
      ]
    ],
    [
      [
        56226,
        64702
      ],
      [
        198,
        0
      ],
      [
        161,
        0
      ],
      [
        38,
        87
      ],
      [
        49,
        44
      ],
      [
        50,
        10
      ],
      [
        62,
        -21
      ],
      [
        61,
        -65
      ],
      [
        62,
        -33
      ],
      [
        25,
        -43
      ],
      [
        37,
        -33
      ],
      [
        25,
        -11
      ],
      [
        13,
        11
      ],
      [
        37,
        11
      ],
      [
        12,
        11
      ],
      [
        62,
        0
      ],
      [
        37,
        -33
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -54
      ],
      [
        -49,
        -22
      ],
      [
        -87,
        -33
      ],
      [
        -62,
        22
      ],
      [
        -87,
        44
      ],
      [
        -37,
        43
      ],
      [
        -25,
        11
      ],
      [
        -24,
        21
      ],
      [
        -25,
        33
      ],
      [
        -50,
        22
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -24,
        -22
      ],
      [
        -124,
        -22
      ],
      [
        -50,
        -21
      ],
      [
        -12,
        -109
      ],
      [
        -273,
        0
      ],
      [
        -24,
        -21
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        56152,
        64377
      ],
      [
        0,
        54
      ],
      [
        -13,
        120
      ],
      [
        25,
        54
      ],
      [
        25,
        21
      ],
      [
        25,
        -21
      ],
      [
        0,
        -44
      ],
      [
        12,
        -32
      ],
      [
        50,
        -22
      ],
      [
        49,
        11
      ],
      [
        25,
        -11
      ],
      [
        0,
        33
      ],
      [
        12,
        32
      ],
      [
        62,
        22
      ],
      [
        62,
        11
      ],
      [
        62,
        21
      ],
      [
        50,
        -10
      ],
      [
        12,
        21
      ],
      [
        -37,
        11
      ],
      [
        -99,
        -22
      ],
      [
        -99,
        -10
      ],
      [
        -75,
        -65
      ],
      [
        -37,
        0
      ],
      [
        -24,
        65
      ],
      [
        -13,
        86
      ]
    ],
    [
      [
        56449,
        63141
      ],
      [
        0,
        -22
      ],
      [
        -12,
        0
      ],
      [
        0,
        87
      ],
      [
        12,
        -22
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        56375,
        63119
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        44
      ],
      [
        24,
        10
      ],
      [
        25,
        44
      ],
      [
        13,
        0
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        56511,
        63217
      ],
      [
        0,
        -22
      ],
      [
        -12,
        0
      ],
      [
        0,
        54
      ],
      [
        12,
        22
      ],
      [
        25,
        0
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -32
      ]
    ],
    [
      [
        56449,
        63379
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        21
      ],
      [
        0,
        33
      ],
      [
        25,
        43
      ],
      [
        12,
        0
      ],
      [
        0,
        -76
      ]
    ],
    [
      [
        56573,
        63423
      ],
      [
        0,
        -22
      ],
      [
        -25,
        22
      ],
      [
        25,
        43
      ],
      [
        25,
        11
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -21
      ]
    ],
    [
      [
        56424,
        63640
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -12,
        54
      ],
      [
        37,
        22
      ],
      [
        12,
        0
      ]
    ],
    [
      [
        56177,
        63932
      ],
      [
        62,
        0
      ],
      [
        61,
        22
      ],
      [
        38,
        33
      ],
      [
        37,
        10
      ],
      [
        99,
        -10
      ],
      [
        87,
        32
      ],
      [
        74,
        54
      ],
      [
        62,
        65
      ],
      [
        161,
        0
      ],
      [
        124,
        -10
      ],
      [
        223,
        0
      ]
    ],
    [
      [
        56746,
        63043
      ],
      [
        -12,
        54
      ],
      [
        12,
        76
      ],
      [
        -12,
        0
      ],
      [
        -37,
        -65
      ],
      [
        -13,
        0
      ],
      [
        0,
        76
      ],
      [
        -24,
        0
      ],
      [
        -37,
        33
      ],
      [
        0,
        75
      ],
      [
        24,
        33
      ],
      [
        0,
        11
      ],
      [
        -24,
        0
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        22
      ],
      [
        12,
        54
      ],
      [
        62,
        43
      ],
      [
        37,
        0
      ],
      [
        25,
        11
      ],
      [
        -12,
        44
      ],
      [
        -38,
        10
      ],
      [
        -24,
        -10
      ],
      [
        -37,
        -33
      ],
      [
        -38,
        76
      ],
      [
        0,
        32
      ],
      [
        13,
        33
      ],
      [
        25,
        22
      ],
      [
        74,
        0
      ],
      [
        37,
        32
      ],
      [
        0,
        33
      ],
      [
        -12,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -87,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        -65
      ],
      [
        -50,
        -32
      ],
      [
        -49,
        10
      ],
      [
        12,
        87
      ],
      [
        -12,
        22
      ],
      [
        -62,
        -22
      ],
      [
        -50,
        33
      ],
      [
        -25,
        43
      ],
      [
        13,
        65
      ],
      [
        25,
        33
      ],
      [
        0,
        21
      ],
      [
        -25,
        0
      ],
      [
        -50,
        -21
      ],
      [
        -86,
        97
      ]
    ],
    [
      [
        65219,
        56861
      ],
      [
        13,
        11
      ],
      [
        -37,
        44
      ],
      [
        -25,
        0
      ],
      [
        -13,
        10
      ],
      [
        13,
        98
      ],
      [
        25,
        87
      ],
      [
        24,
        65
      ],
      [
        25,
        11
      ],
      [
        0,
        32
      ],
      [
        25,
        109
      ],
      [
        25,
        86
      ],
      [
        0,
        239
      ]
    ],
    [
      [
        64934,
        58564
      ],
      [
        50,
        0
      ],
      [
        25,
        -33
      ],
      [
        -13,
        -54
      ],
      [
        -49,
        -141
      ],
      [
        -25,
        -108
      ],
      [
        -25,
        0
      ],
      [
        -62,
        21
      ],
      [
        0,
        22
      ],
      [
        -12,
        22
      ],
      [
        12,
        54
      ],
      [
        0,
        22
      ],
      [
        37,
        21
      ],
      [
        25,
        120
      ],
      [
        13,
        32
      ],
      [
        24,
        22
      ]
    ],
    [
      [
        70125,
        78411
      ],
      [
        74,
        0
      ],
      [
        12,
        32
      ],
      [
        25,
        11
      ],
      [
        13,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -22
      ],
      [
        49,
        -11
      ],
      [
        0,
        -54
      ],
      [
        13,
        -11
      ],
      [
        49,
        0
      ],
      [
        62,
        33
      ],
      [
        37,
        11
      ],
      [
        87,
        -11
      ],
      [
        37,
        -44
      ],
      [
        75,
        0
      ],
      [
        62,
        -21
      ],
      [
        24,
        11
      ],
      [
        62,
        10
      ],
      [
        0,
        -130
      ],
      [
        13,
        -11
      ],
      [
        24,
        11
      ],
      [
        13,
        33
      ],
      [
        49,
        21
      ],
      [
        50,
        0
      ],
      [
        37,
        55
      ],
      [
        0,
        -98
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -50,
        0
      ],
      [
        -74,
        11
      ],
      [
        -74,
        -11
      ],
      [
        -137,
        -32
      ],
      [
        -136,
        -22
      ],
      [
        -25,
        11
      ],
      [
        0,
        76
      ],
      [
        -49,
        32
      ],
      [
        -50,
        22
      ],
      [
        -198,
        54
      ],
      [
        -74,
        0
      ],
      [
        -25,
        11
      ],
      [
        -12,
        22
      ],
      [
        0,
        76
      ],
      [
        12,
        76
      ],
      [
        37,
        -11
      ],
      [
        13,
        22
      ],
      [
        0,
        65
      ],
      [
        12,
        -11
      ],
      [
        12,
        -54
      ],
      [
        13,
        -11
      ]
    ],
    [
      [
        71277,
        78367
      ],
      [
        -13,
        -32
      ],
      [
        -12,
        32
      ],
      [
        0,
        33
      ],
      [
        -12,
        54
      ],
      [
        24,
        76
      ],
      [
        0,
        43
      ],
      [
        25,
        11
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -54
      ],
      [
        25,
        -43
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        69852,
        78823
      ],
      [
        0,
        -33
      ],
      [
        -37,
        22
      ],
      [
        -12,
        32
      ],
      [
        0,
        55
      ],
      [
        12,
        32
      ],
      [
        25,
        -21
      ],
      [
        37,
        -55
      ],
      [
        -25,
        -32
      ]
    ],
    [
      [
        71500,
        78660
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        22
      ],
      [
        12,
        76
      ],
      [
        -12,
        65
      ],
      [
        61,
        108
      ],
      [
        112,
        55
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -97
      ],
      [
        -25,
        -55
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -11
      ],
      [
        -49,
        -76
      ]
    ],
    [
      [
        70695,
        78942
      ],
      [
        -25,
        -32
      ],
      [
        -13,
        21
      ],
      [
        25,
        44
      ],
      [
        13,
        -33
      ]
    ],
    [
      [
        71029,
        79072
      ],
      [
        -50,
        -54
      ],
      [
        -12,
        22
      ],
      [
        0,
        32
      ],
      [
        25,
        -11
      ],
      [
        25,
        33
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        71512,
        79051
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        43
      ],
      [
        25,
        22
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        70360,
        79181
      ],
      [
        12,
        -44
      ],
      [
        -12,
        -11
      ],
      [
        -62,
        -10
      ],
      [
        0,
        32
      ],
      [
        13,
        22
      ],
      [
        12,
        -22
      ],
      [
        12,
        22
      ],
      [
        25,
        11
      ]
    ],
    [
      [
        70657,
        79126
      ],
      [
        -12,
        -10
      ],
      [
        -25,
        32
      ],
      [
        0,
        33
      ],
      [
        13,
        11
      ],
      [
        37,
        -44
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        71202,
        79159
      ],
      [
        0,
        22
      ],
      [
        38,
        43
      ],
      [
        49,
        43
      ],
      [
        50,
        -21
      ],
      [
        -75,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        70434,
        79278
      ],
      [
        -24,
        22
      ],
      [
        12,
        43
      ],
      [
        25,
        -43
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        71215,
        79300
      ],
      [
        -25,
        -11
      ],
      [
        0,
        54
      ],
      [
        12,
        11
      ],
      [
        25,
        -43
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        70620,
        79365
      ],
      [
        -25,
        -43
      ],
      [
        -24,
        0
      ],
      [
        -13,
        21
      ],
      [
        13,
        55
      ],
      [
        37,
        21
      ],
      [
        12,
        -11
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        70719,
        79311
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        44
      ],
      [
        -12,
        43
      ],
      [
        62,
        87
      ],
      [
        25,
        -33
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -43
      ]
    ],
    [
      [
        70360,
        79408
      ],
      [
        -12,
        -10
      ],
      [
        -25,
        10
      ],
      [
        25,
        55
      ],
      [
        12,
        -11
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        70335,
        79539
      ],
      [
        -24,
        -11
      ],
      [
        12,
        43
      ],
      [
        -12,
        22
      ],
      [
        24,
        11
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -43
      ]
    ],
    [
      [
        70509,
        79636
      ],
      [
        0,
        -65
      ],
      [
        -25,
        11
      ],
      [
        12,
        65
      ],
      [
        13,
        -11
      ]
    ],
    [
      [
        70670,
        79593
      ],
      [
        -37,
        -11
      ],
      [
        0,
        54
      ],
      [
        12,
        11
      ],
      [
        37,
        -22
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        70880,
        79658
      ],
      [
        -12,
        22
      ],
      [
        37,
        43
      ],
      [
        37,
        0
      ],
      [
        0,
        -43
      ],
      [
        -62,
        -22
      ]
    ],
    [
      [
        70608,
        79701
      ],
      [
        -13,
        -43
      ],
      [
        -74,
        87
      ],
      [
        13,
        10
      ],
      [
        24,
        -21
      ],
      [
        50,
        -11
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        70298,
        79690
      ],
      [
        -12,
        -32
      ],
      [
        -13,
        43
      ],
      [
        13,
        44
      ],
      [
        25,
        10
      ],
      [
        12,
        -21
      ],
      [
        -25,
        -44
      ]
    ],
    [
      [
        71153,
        79831
      ],
      [
        37,
        -21
      ],
      [
        37,
        0
      ],
      [
        0,
        -44
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -24,
        32
      ],
      [
        -37,
        0
      ],
      [
        -13,
        11
      ],
      [
        25,
        33
      ],
      [
        37,
        21
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        69109,
        79831
      ],
      [
        12,
        -43
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        43
      ],
      [
        -25,
        54
      ],
      [
        0,
        22
      ],
      [
        25,
        43
      ],
      [
        25,
        -43
      ],
      [
        25,
        -11
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        70521,
        79799
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        55
      ],
      [
        -25,
        32
      ],
      [
        -12,
        33
      ],
      [
        -25,
        11
      ],
      [
        0,
        43
      ],
      [
        37,
        11
      ],
      [
        13,
        -44
      ],
      [
        37,
        0
      ],
      [
        0,
        -32
      ],
      [
        12,
        -65
      ]
    ],
    [
      [
        70026,
        79907
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        21
      ],
      [
        25,
        33
      ],
      [
        25,
        -11
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        69022,
        80189
      ],
      [
        0,
        -76
      ],
      [
        25,
        -10
      ],
      [
        25,
        -66
      ],
      [
        0,
        -43
      ],
      [
        -62,
        33
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        32
      ],
      [
        0,
        44
      ],
      [
        -13,
        11
      ],
      [
        -37,
        -44
      ],
      [
        0,
        33
      ],
      [
        37,
        86
      ],
      [
        13,
        -32
      ],
      [
        12,
        11
      ],
      [
        12,
        43
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        69072,
        80157
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        65
      ],
      [
        0,
        43
      ],
      [
        25,
        -21
      ],
      [
        0,
        -33
      ],
      [
        25,
        -43
      ]
    ],
    [
      [
        70905,
        80092
      ],
      [
        -37,
        -44
      ],
      [
        -37,
        55
      ],
      [
        0,
        21
      ],
      [
        25,
        11
      ],
      [
        12,
        33
      ],
      [
        -12,
        43
      ],
      [
        -38,
        54
      ],
      [
        0,
        44
      ],
      [
        50,
        21
      ],
      [
        37,
        -43
      ],
      [
        25,
        0
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -109
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        69047,
        80330
      ],
      [
        -37,
        0
      ],
      [
        -13,
        33
      ],
      [
        13,
        65
      ],
      [
        12,
        32
      ],
      [
        25,
        22
      ],
      [
        0,
        -152
      ]
    ],
    [
      [
        70410,
        80460
      ],
      [
        -38,
        -21
      ],
      [
        0,
        32
      ],
      [
        -37,
        33
      ],
      [
        13,
        43
      ],
      [
        24,
        -11
      ],
      [
        38,
        -76
      ]
    ],
    [
      [
        69976,
        80547
      ],
      [
        37,
        -87
      ],
      [
        37,
        -32
      ],
      [
        25,
        0
      ],
      [
        62,
        -43
      ],
      [
        74,
        -11
      ],
      [
        38,
        -87
      ],
      [
        0,
        -43
      ],
      [
        24,
        -152
      ],
      [
        38,
        -44
      ],
      [
        24,
        -11
      ],
      [
        37,
        11
      ],
      [
        13,
        -21
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        33
      ],
      [
        -12,
        0
      ],
      [
        -25,
        32
      ],
      [
        -37,
        33
      ],
      [
        0,
        54
      ],
      [
        -38,
        65
      ],
      [
        -12,
        11
      ],
      [
        0,
        32
      ],
      [
        -62,
        11
      ],
      [
        -37,
        0
      ],
      [
        -37,
        33
      ],
      [
        -13,
        65
      ],
      [
        -37,
        32
      ],
      [
        -12,
        33
      ],
      [
        -74,
        87
      ],
      [
        -38,
        32
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        22
      ],
      [
        99,
        87
      ],
      [
        62,
        21
      ],
      [
        25,
        -54
      ]
    ],
    [
      [
        70100,
        80645
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -25,
        76
      ],
      [
        62,
        -65
      ]
    ],
    [
      [
        70137,
        80677
      ],
      [
        0,
        44
      ],
      [
        37,
        21
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        71017,
        80786
      ],
      [
        -13,
        -44
      ],
      [
        50,
        -54
      ],
      [
        25,
        -87
      ],
      [
        -25,
        -32
      ],
      [
        -50,
        -11
      ],
      [
        -74,
        33
      ],
      [
        -25,
        32
      ],
      [
        50,
        54
      ],
      [
        -25,
        22
      ],
      [
        -37,
        -65
      ],
      [
        -75,
        54
      ],
      [
        25,
        65
      ],
      [
        37,
        0
      ],
      [
        50,
        33
      ],
      [
        0,
        21
      ],
      [
        62,
        11
      ],
      [
        25,
        -32
      ]
    ],
    [
      [
        68836,
        80851
      ],
      [
        0,
        -44
      ],
      [
        -37,
        22
      ],
      [
        -37,
        33
      ],
      [
        -25,
        76
      ],
      [
        -49,
        86
      ],
      [
        0,
        33
      ],
      [
        12,
        22
      ],
      [
        50,
        10
      ],
      [
        37,
        -43
      ],
      [
        -37,
        -54
      ],
      [
        25,
        -33
      ],
      [
        0,
        -65
      ],
      [
        37,
        -43
      ],
      [
        24,
        0
      ]
    ],
    [
      [
        70682,
        81187
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -54
      ],
      [
        -74,
        10
      ],
      [
        -25,
        22
      ],
      [
        0,
        87
      ],
      [
        62,
        11
      ],
      [
        12,
        -33
      ],
      [
        25,
        11
      ],
      [
        12,
        22
      ],
      [
        25,
        11
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        70756,
        81469
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        55
      ],
      [
        37,
        21
      ],
      [
        25,
        -11
      ],
      [
        12,
        -43
      ]
    ],
    [
      [
        70447,
        81588
      ],
      [
        -37,
        -21
      ],
      [
        -50,
        32
      ],
      [
        0,
        33
      ],
      [
        25,
        54
      ],
      [
        12,
        11
      ],
      [
        37,
        0
      ],
      [
        13,
        -44
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        69134,
        81729
      ],
      [
        49,
        11
      ],
      [
        75,
        0
      ],
      [
        24,
        22
      ],
      [
        25,
        0
      ],
      [
        37,
        -22
      ],
      [
        75,
        54
      ],
      [
        49,
        98
      ],
      [
        112,
        33
      ],
      [
        49,
        -22
      ],
      [
        37,
        0
      ],
      [
        38,
        11
      ],
      [
        37,
        21
      ],
      [
        12,
        87
      ],
      [
        12,
        11
      ],
      [
        38,
        0
      ]
    ],
    [
      [
        70979,
        82272
      ],
      [
        38,
        -11
      ],
      [
        24,
        -44
      ],
      [
        25,
        -21
      ],
      [
        25,
        -120
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -75,
        -65
      ],
      [
        0,
        -109
      ],
      [
        13,
        -43
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        70880,
        81653
      ],
      [
        -12,
        33
      ],
      [
        -50,
        43
      ],
      [
        -123,
        22
      ],
      [
        -62,
        43
      ],
      [
        -25,
        -10
      ],
      [
        -50,
        43
      ],
      [
        -99,
        -87
      ],
      [
        -49,
        0
      ],
      [
        -38,
        44
      ],
      [
        -24,
        10
      ],
      [
        -37,
        -21
      ],
      [
        -50,
        -76
      ],
      [
        -50,
        -44
      ],
      [
        -49,
        11
      ],
      [
        -62,
        0
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -33
      ],
      [
        37,
        -43
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -44
      ],
      [
        50,
        0
      ],
      [
        74,
        -54
      ],
      [
        25,
        -54
      ],
      [
        12,
        -54
      ],
      [
        -62,
        75
      ],
      [
        -87,
        55
      ],
      [
        -24,
        0
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -22
      ],
      [
        61,
        -86
      ],
      [
        25,
        -22
      ],
      [
        13,
        -54
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        44
      ],
      [
        -62,
        119
      ],
      [
        -75,
        22
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -65
      ],
      [
        13,
        -33
      ],
      [
        74,
        -65
      ],
      [
        -25,
        -21
      ],
      [
        -74,
        43
      ],
      [
        -25,
        54
      ],
      [
        -12,
        87
      ],
      [
        -62,
        54
      ],
      [
        -74,
        54
      ],
      [
        -13,
        55
      ],
      [
        25,
        65
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -55
      ],
      [
        -13,
        -97
      ],
      [
        0,
        -54
      ],
      [
        87,
        -141
      ],
      [
        49,
        -152
      ],
      [
        50,
        -44
      ],
      [
        37,
        -86
      ],
      [
        25,
        -44
      ],
      [
        12,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        22
      ],
      [
        25,
        54
      ],
      [
        -13,
        22
      ],
      [
        -49,
        54
      ],
      [
        -62,
        -44
      ],
      [
        37,
        -97
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        0
      ],
      [
        0,
        -33
      ],
      [
        37,
        -32
      ],
      [
        75,
        -33
      ],
      [
        49,
        -43
      ],
      [
        38,
        -11
      ],
      [
        37,
        -87
      ],
      [
        74,
        -22
      ],
      [
        37,
        -86
      ],
      [
        50,
        -11
      ],
      [
        49,
        -33
      ],
      [
        13,
        -32
      ],
      [
        0,
        -55
      ],
      [
        12,
        -119
      ],
      [
        0,
        -152
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        65
      ],
      [
        -49,
        65
      ],
      [
        -50,
        87
      ],
      [
        -25,
        10
      ],
      [
        -37,
        -21
      ],
      [
        -74,
        -22
      ],
      [
        -50,
        -43
      ],
      [
        37,
        -65
      ],
      [
        0,
        -44
      ],
      [
        13,
        -65
      ],
      [
        74,
        -22
      ],
      [
        0,
        -21
      ],
      [
        25,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -112,
        -65
      ],
      [
        -12,
        10
      ],
      [
        0,
        55
      ],
      [
        -87,
        54
      ],
      [
        -25,
        32
      ],
      [
        -24,
        -21
      ],
      [
        12,
        -98
      ],
      [
        37,
        -65
      ],
      [
        50,
        -173
      ],
      [
        25,
        -98
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -76
      ],
      [
        25,
        -65
      ],
      [
        -12,
        -33
      ],
      [
        -38,
        22
      ],
      [
        -49,
        97
      ],
      [
        -13,
        66
      ],
      [
        -24,
        10
      ],
      [
        -37,
        -10
      ],
      [
        -38,
        -131
      ],
      [
        0,
        -76
      ],
      [
        -49,
        33
      ],
      [
        12,
        87
      ],
      [
        -62,
        152
      ],
      [
        -12,
        10
      ],
      [
        -37,
        76
      ],
      [
        -37,
        -21
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -55
      ],
      [
        -12,
        -43
      ],
      [
        -50,
        87
      ],
      [
        -62,
        130
      ],
      [
        0,
        76
      ],
      [
        50,
        65
      ],
      [
        -13,
        54
      ],
      [
        -37,
        98
      ],
      [
        -49,
        54
      ],
      [
        -37,
        22
      ],
      [
        -13,
        65
      ],
      [
        -49,
        54
      ],
      [
        0,
        32
      ],
      [
        62,
        76
      ],
      [
        24,
        98
      ],
      [
        25,
        11
      ],
      [
        37,
        -22
      ],
      [
        37,
        0
      ],
      [
        25,
        65
      ],
      [
        25,
        33
      ],
      [
        50,
        0
      ],
      [
        99,
        -87
      ],
      [
        99,
        -43
      ],
      [
        62,
        -44
      ],
      [
        24,
        -43
      ],
      [
        50,
        -11
      ],
      [
        -12,
        54
      ],
      [
        24,
        11
      ],
      [
        50,
        0
      ],
      [
        25,
        43
      ],
      [
        -13,
        22
      ],
      [
        -37,
        22
      ],
      [
        -37,
        0
      ],
      [
        -37,
        22
      ],
      [
        -25,
        32
      ],
      [
        -62,
        33
      ],
      [
        -49,
        54
      ],
      [
        -13,
        -33
      ],
      [
        -62,
        -21
      ],
      [
        -86,
        43
      ],
      [
        -50,
        -33
      ],
      [
        -87,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -37,
        87
      ],
      [
        -12,
        10
      ],
      [
        0,
        -65
      ],
      [
        -50,
        -21
      ],
      [
        -25,
        21
      ],
      [
        -12,
        76
      ],
      [
        -25,
        98
      ],
      [
        -37,
        76
      ],
      [
        -37,
        21
      ],
      [
        0,
        65
      ],
      [
        37,
        11
      ],
      [
        62,
        -32
      ],
      [
        37,
        21
      ],
      [
        -12,
        33
      ],
      [
        0,
        33
      ],
      [
        -37,
        0
      ],
      [
        -38,
        10
      ],
      [
        -49,
        -21
      ],
      [
        -25,
        21
      ],
      [
        0,
        22
      ],
      [
        -50,
        43
      ],
      [
        -24,
        66
      ],
      [
        -62,
        43
      ],
      [
        -37,
        141
      ],
      [
        -38,
        65
      ],
      [
        -24,
        33
      ]
    ],
    [
      [
        40692,
        63715
      ],
      [
        -12,
        22
      ],
      [
        0,
        44
      ],
      [
        25,
        75
      ],
      [
        25,
        -10
      ],
      [
        -13,
        -98
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        46007,
        94180
      ],
      [
        -38,
        -76
      ],
      [
        -37,
        21
      ],
      [
        -25,
        33
      ],
      [
        -37,
        11
      ],
      [
        -49,
        0
      ],
      [
        0,
        11
      ],
      [
        136,
        86
      ],
      [
        74,
        22
      ],
      [
        -24,
        -65
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        49178,
        97151
      ],
      [
        -50,
        0
      ],
      [
        -12,
        44
      ],
      [
        0,
        54
      ],
      [
        62,
        21
      ],
      [
        37,
        -43
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        44371,
        99656
      ],
      [
        -49,
        -21
      ],
      [
        -25,
        21
      ],
      [
        -37,
        120
      ],
      [
        12,
        43
      ],
      [
        -12,
        33
      ],
      [
        87,
        43
      ],
      [
        49,
        -11
      ],
      [
        87,
        -43
      ],
      [
        0,
        -11
      ],
      [
        -74,
        -43
      ],
      [
        -25,
        -55
      ],
      [
        -13,
        -76
      ]
    ],
    [
      [
        43777,
        99906
      ],
      [
        124,
        -54
      ],
      [
        111,
        -33
      ],
      [
        25,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        37,
        -32
      ],
      [
        0,
        -22
      ],
      [
        -62,
        -65
      ],
      [
        -236,
        -76
      ],
      [
        -272,
        -76
      ],
      [
        -74,
        11
      ],
      [
        -87,
        43
      ],
      [
        -50,
        44
      ],
      [
        50,
        21
      ],
      [
        136,
        11
      ],
      [
        -62,
        54
      ],
      [
        -37,
        -10
      ],
      [
        -74,
        21
      ],
      [
        -124,
        11
      ],
      [
        -74,
        22
      ],
      [
        -50,
        32
      ],
      [
        -12,
        33
      ],
      [
        24,
        119
      ],
      [
        13,
        22
      ],
      [
        49,
        11
      ],
      [
        99,
        -22
      ],
      [
        13,
        11
      ],
      [
        -112,
        43
      ],
      [
        -37,
        22
      ],
      [
        -25,
        54
      ],
      [
        13,
        54
      ],
      [
        37,
        22
      ],
      [
        111,
        33
      ],
      [
        124,
        -11
      ],
      [
        223,
        -44
      ],
      [
        87,
        -54
      ],
      [
        124,
        -119
      ]
    ],
    [
      [
        44148,
        100470
      ],
      [
        -161,
        11
      ],
      [
        13,
        65
      ],
      [
        49,
        0
      ],
      [
        112,
        -44
      ],
      [
        -13,
        -32
      ]
    ],
    [
      [
        53179,
        100513
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        38,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        -136,
        -32
      ],
      [
        -87,
        -54
      ],
      [
        -50,
        -44
      ],
      [
        -24,
        0
      ],
      [
        -25,
        44
      ],
      [
        -87,
        21
      ],
      [
        -173,
        -10
      ],
      [
        -199,
        -33
      ],
      [
        -74,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -12,
        33
      ],
      [
        37,
        65
      ],
      [
        49,
        11
      ],
      [
        25,
        43
      ],
      [
        -12,
        54
      ],
      [
        12,
        65
      ],
      [
        37,
        11
      ],
      [
        124,
        -32
      ],
      [
        99,
        0
      ],
      [
        124,
        10
      ],
      [
        87,
        22
      ],
      [
        186,
        76
      ],
      [
        24,
        0
      ],
      [
        50,
        -43
      ],
      [
        62,
        -33
      ]
    ],
    [
      [
        43504,
        100589
      ],
      [
        -37,
        0
      ],
      [
        -87,
        33
      ],
      [
        -24,
        21
      ],
      [
        37,
        55
      ],
      [
        49,
        43
      ],
      [
        50,
        11
      ],
      [
        49,
        -76
      ],
      [
        0,
        -44
      ],
      [
        -37,
        -43
      ]
    ],
    [
      [
        42996,
        101684
      ],
      [
        -173,
        -141
      ],
      [
        -87,
        33
      ],
      [
        -37,
        33
      ],
      [
        -62,
        -11
      ],
      [
        -49,
        43
      ],
      [
        74,
        33
      ],
      [
        111,
        10
      ],
      [
        50,
        -10
      ],
      [
        99,
        32
      ],
      [
        62,
        0
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        55731,
        103322
      ],
      [
        37,
        -130
      ],
      [
        49,
        -43
      ],
      [
        87,
        10
      ],
      [
        37,
        -76
      ],
      [
        -62,
        -21
      ],
      [
        -272,
        11
      ],
      [
        -112,
        -11
      ],
      [
        -74,
        43
      ],
      [
        12,
        76
      ],
      [
        0,
        87
      ],
      [
        75,
        43
      ],
      [
        74,
        -43
      ],
      [
        149,
        54
      ]
    ],
    [
      [
        55532,
        103712
      ],
      [
        -37,
        -10
      ],
      [
        -136,
        260
      ],
      [
        12,
        163
      ],
      [
        62,
        0
      ],
      [
        50,
        -33
      ],
      [
        25,
        -152
      ],
      [
        24,
        -228
      ]
    ],
    [
      [
        37261,
        104515
      ],
      [
        -111,
        0
      ],
      [
        -124,
        22
      ],
      [
        -50,
        21
      ],
      [
        25,
        33
      ],
      [
        161,
        11
      ],
      [
        186,
        -44
      ],
      [
        -13,
        -21
      ],
      [
        -74,
        -22
      ]
    ],
    [
      [
        55743,
        104710
      ],
      [
        -62,
        0
      ],
      [
        -12,
        54
      ],
      [
        99,
        87
      ],
      [
        74,
        0
      ],
      [
        13,
        -54
      ],
      [
        -25,
        -43
      ],
      [
        -87,
        -44
      ]
    ],
    [
      [
        55384,
        104916
      ],
      [
        -75,
        55
      ],
      [
        -24,
        86
      ],
      [
        0,
        98
      ],
      [
        62,
        43
      ],
      [
        62,
        0
      ],
      [
        0,
        -130
      ],
      [
        24,
        -54
      ],
      [
        -49,
        -98
      ]
    ],
    [
      [
        55867,
        106077
      ],
      [
        -149,
        -65
      ],
      [
        -210,
        0
      ],
      [
        -137,
        32
      ],
      [
        -37,
        54
      ],
      [
        50,
        55
      ],
      [
        161,
        43
      ],
      [
        198,
        22
      ],
      [
        173,
        -11
      ],
      [
        25,
        -54
      ],
      [
        -74,
        -76
      ]
    ],
    [
      [
        55508,
        107346
      ],
      [
        -37,
        -22
      ],
      [
        -100,
        0
      ],
      [
        -185,
        108
      ],
      [
        -13,
        55
      ],
      [
        112,
        21
      ],
      [
        74,
        -43
      ],
      [
        149,
        -119
      ]
    ],
    [
      [
        46490,
        107487
      ],
      [
        -75,
        -11
      ],
      [
        -148,
        65
      ],
      [
        -223,
        65
      ],
      [
        -211,
        43
      ],
      [
        -186,
        120
      ],
      [
        13,
        76
      ],
      [
        297,
        21
      ],
      [
        347,
        -65
      ],
      [
        161,
        -65
      ],
      [
        62,
        -54
      ],
      [
        -37,
        -195
      ]
    ],
    [
      [
        51618,
        108408
      ],
      [
        334,
        -32
      ],
      [
        174,
        -43
      ],
      [
        272,
        -11
      ],
      [
        223,
        -22
      ],
      [
        372,
        -54
      ],
      [
        62,
        -22
      ],
      [
        -136,
        -22
      ],
      [
        -483,
        -21
      ],
      [
        -868,
        -22
      ],
      [
        -495,
        -43
      ],
      [
        -161,
        0
      ],
      [
        -12,
        -65
      ],
      [
        185,
        0
      ],
      [
        384,
        65
      ],
      [
        149,
        10
      ],
      [
        273,
        0
      ],
      [
        346,
        -21
      ],
      [
        397,
        0
      ],
      [
        297,
        21
      ],
      [
        347,
        33
      ],
      [
        99,
        -87
      ],
      [
        124,
        -86
      ],
      [
        111,
        10
      ],
      [
        161,
        -43
      ],
      [
        100,
        0
      ],
      [
        297,
        -22
      ],
      [
        297,
        -65
      ],
      [
        50,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -136,
        -54
      ],
      [
        -161,
        -43
      ],
      [
        -223,
        -44
      ],
      [
        -260,
        -21
      ],
      [
        -1970,
        -76
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        -43
      ],
      [
        25,
        -65
      ],
      [
        86,
        -11
      ],
      [
        223,
        32
      ],
      [
        372,
        33
      ],
      [
        272,
        0
      ],
      [
        645,
        -33
      ],
      [
        198,
        -65
      ],
      [
        99,
        -119
      ],
      [
        223,
        22
      ],
      [
        49,
        21
      ],
      [
        75,
        76
      ],
      [
        37,
        65
      ],
      [
        87,
        22
      ],
      [
        470,
        33
      ],
      [
        75,
        -11
      ],
      [
        74,
        -76
      ],
      [
        0,
        -152
      ],
      [
        -37,
        -65
      ],
      [
        -87,
        -98
      ],
      [
        -74,
        -54
      ],
      [
        -248,
        -130
      ],
      [
        -223,
        -130
      ],
      [
        -37,
        -54
      ],
      [
        74,
        -11
      ],
      [
        50,
        54
      ],
      [
        247,
        65
      ],
      [
        223,
        98
      ],
      [
        112,
        32
      ],
      [
        136,
        54
      ],
      [
        248,
        152
      ],
      [
        136,
        54
      ],
      [
        136,
        0
      ],
      [
        25,
        -86
      ],
      [
        359,
        -22
      ],
      [
        50,
        -22
      ],
      [
        173,
        -21
      ],
      [
        87,
        21
      ],
      [
        322,
        196
      ],
      [
        248,
        54
      ],
      [
        111,
        -11
      ],
      [
        335,
        0
      ],
      [
        186,
        -22
      ],
      [
        260,
        -43
      ],
      [
        186,
        -22
      ],
      [
        198,
        -65
      ],
      [
        149,
        -65
      ],
      [
        -38,
        -32
      ],
      [
        -247,
        -66
      ],
      [
        -75,
        -54
      ],
      [
        -235,
        -87
      ],
      [
        -112,
        -32
      ],
      [
        -247,
        -11
      ],
      [
        -99,
        -32
      ],
      [
        62,
        -33
      ],
      [
        12,
        -54
      ],
      [
        -87,
        -44
      ],
      [
        -235,
        -21
      ],
      [
        -124,
        -44
      ],
      [
        -149,
        -11
      ],
      [
        -111,
        11
      ],
      [
        -161,
        -54
      ],
      [
        124,
        -54
      ],
      [
        161,
        -33
      ],
      [
        0,
        -21
      ],
      [
        -75,
        -44
      ],
      [
        -111,
        -43
      ],
      [
        -174,
        -44
      ],
      [
        -123,
        11
      ],
      [
        -124,
        -21
      ],
      [
        -124,
        0
      ],
      [
        -211,
        21
      ],
      [
        -173,
        33
      ],
      [
        -87,
        0
      ],
      [
        -149,
        -65
      ],
      [
        -99,
        -87
      ],
      [
        -12,
        -98
      ],
      [
        74,
        -65
      ],
      [
        199,
        0
      ],
      [
        37,
        -43
      ],
      [
        -50,
        -174
      ],
      [
        13,
        -32
      ],
      [
        86,
        -22
      ],
      [
        62,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -223,
        -54
      ],
      [
        -50,
        -98
      ],
      [
        -61,
        -43
      ],
      [
        -112,
        0
      ],
      [
        -87,
        -22
      ],
      [
        -173,
        -87
      ],
      [
        62,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -87,
        -108
      ],
      [
        -25,
        -55
      ],
      [
        -37,
        -141
      ],
      [
        -49,
        -43
      ],
      [
        -75,
        -130
      ],
      [
        0,
        -54
      ],
      [
        62,
        -33
      ],
      [
        62,
        33
      ],
      [
        87,
        86
      ],
      [
        99,
        44
      ],
      [
        99,
        -11
      ],
      [
        285,
        -76
      ],
      [
        87,
        -33
      ],
      [
        62,
        -65
      ],
      [
        0,
        -21
      ],
      [
        -75,
        -11
      ],
      [
        -148,
        65
      ],
      [
        -75,
        11
      ],
      [
        -173,
        -44
      ],
      [
        74,
        -108
      ],
      [
        75,
        -43
      ],
      [
        148,
        -22
      ],
      [
        174,
        -76
      ],
      [
        62,
        11
      ],
      [
        74,
        32
      ],
      [
        111,
        0
      ],
      [
        87,
        -43
      ],
      [
        13,
        -130
      ],
      [
        -13,
        -54
      ],
      [
        -62,
        -87
      ],
      [
        -86,
        -11
      ],
      [
        -75,
        33
      ],
      [
        -186,
        21
      ],
      [
        -185,
        44
      ],
      [
        -149,
        0
      ],
      [
        -161,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -223,
        -97
      ],
      [
        -50,
        11
      ],
      [
        -148,
        65
      ],
      [
        -124,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        112,
        -54
      ],
      [
        136,
        -11
      ],
      [
        49,
        -109
      ],
      [
        87,
        -87
      ],
      [
        112,
        0
      ],
      [
        99,
        22
      ],
      [
        148,
        -43
      ],
      [
        124,
        -11
      ],
      [
        74,
        -54
      ],
      [
        -24,
        -76
      ],
      [
        49,
        -65
      ],
      [
        87,
        -65
      ],
      [
        25,
        -65
      ],
      [
        0,
        -55
      ],
      [
        25,
        -65
      ],
      [
        12,
        -130
      ],
      [
        -50,
        -65
      ],
      [
        -99,
        -22
      ],
      [
        -74,
        65
      ],
      [
        -62,
        33
      ],
      [
        -99,
        0
      ],
      [
        -149,
        -98
      ],
      [
        -111,
        -10
      ],
      [
        -62,
        -44
      ],
      [
        -74,
        -22
      ],
      [
        -75,
        0
      ],
      [
        -12,
        -21
      ],
      [
        62,
        -22
      ],
      [
        86,
        22
      ],
      [
        137,
        54
      ],
      [
        49,
        -22
      ],
      [
        50,
        -97
      ],
      [
        -37,
        -98
      ],
      [
        -50,
        -54
      ],
      [
        62,
        -11
      ],
      [
        87,
        65
      ],
      [
        62,
        152
      ],
      [
        74,
        22
      ],
      [
        74,
        -22
      ],
      [
        62,
        -76
      ],
      [
        87,
        -141
      ],
      [
        87,
        -54
      ],
      [
        24,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -65
      ],
      [
        -124,
        -33
      ],
      [
        -136,
        22
      ],
      [
        -75,
        0
      ],
      [
        13,
        -54
      ],
      [
        -149,
        -43
      ],
      [
        -161,
        -11
      ],
      [
        -149,
        32
      ],
      [
        -136,
        54
      ],
      [
        50,
        66
      ],
      [
        24,
        75
      ],
      [
        -62,
        55
      ],
      [
        -24,
        0
      ],
      [
        24,
        -76
      ],
      [
        -12,
        -33
      ],
      [
        -124,
        -54
      ],
      [
        50,
        -65
      ],
      [
        -50,
        -65
      ],
      [
        13,
        -44
      ],
      [
        99,
        -32
      ],
      [
        235,
        -11
      ],
      [
        99,
        -11
      ],
      [
        223,
        -54
      ],
      [
        12,
        -22
      ],
      [
        -37,
        -97
      ],
      [
        -24,
        -109
      ],
      [
        -38,
        -11
      ],
      [
        -235,
        -10
      ],
      [
        -74,
        -11
      ],
      [
        -124,
        -44
      ],
      [
        -99,
        -54
      ],
      [
        -62,
        -11
      ],
      [
        -211,
        54
      ],
      [
        -87,
        33
      ],
      [
        -185,
        87
      ],
      [
        -137,
        141
      ],
      [
        -99,
        -87
      ],
      [
        -74,
        -11
      ],
      [
        -87,
        33
      ],
      [
        0,
        -55
      ],
      [
        50,
        -21
      ],
      [
        -13,
        -22
      ],
      [
        -74,
        -11
      ],
      [
        -99,
        -32
      ],
      [
        -149,
        -98
      ],
      [
        -148,
        -11
      ],
      [
        -75,
        33
      ],
      [
        -123,
        21
      ],
      [
        -174,
        55
      ],
      [
        25,
        -33
      ],
      [
        198,
        -65
      ],
      [
        25,
        -22
      ],
      [
        -62,
        -43
      ],
      [
        -186,
        0
      ],
      [
        -111,
        -22
      ],
      [
        12,
        -21
      ],
      [
        62,
        -22
      ],
      [
        62,
        43
      ],
      [
        149,
        -10
      ],
      [
        111,
        32
      ],
      [
        136,
        11
      ],
      [
        223,
        54
      ],
      [
        37,
        54
      ],
      [
        75,
        22
      ],
      [
        161,
        11
      ],
      [
        161,
        0
      ],
      [
        74,
        -11
      ],
      [
        62,
        -54
      ],
      [
        99,
        -33
      ],
      [
        62,
        -43
      ],
      [
        87,
        -11
      ],
      [
        49,
        -54
      ],
      [
        137,
        -65
      ],
      [
        99,
        -11
      ],
      [
        49,
        -33
      ],
      [
        0,
        -119
      ],
      [
        13,
        -54
      ],
      [
        -25,
        -152
      ],
      [
        -74,
        -33
      ],
      [
        12,
        -75
      ],
      [
        -12,
        -66
      ],
      [
        -75,
        22
      ],
      [
        -74,
        44
      ],
      [
        -174,
        65
      ],
      [
        -161,
        43
      ],
      [
        -136,
        65
      ],
      [
        -99,
        119
      ],
      [
        -62,
        141
      ],
      [
        -25,
        76
      ],
      [
        -62,
        11
      ],
      [
        -123,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        -211,
        -54
      ],
      [
        -74,
        -33
      ],
      [
        -50,
        0
      ],
      [
        -148,
        -43
      ],
      [
        62,
        -32
      ],
      [
        86,
        10
      ],
      [
        37,
        22
      ],
      [
        149,
        43
      ],
      [
        112,
        11
      ],
      [
        123,
        55
      ],
      [
        62,
        0
      ],
      [
        13,
        -22
      ],
      [
        37,
        -174
      ],
      [
        -12,
        -43
      ],
      [
        -149,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        25,
        -33
      ],
      [
        99,
        33
      ],
      [
        62,
        33
      ],
      [
        37,
        -11
      ],
      [
        50,
        -55
      ],
      [
        210,
        -86
      ],
      [
        75,
        -44
      ],
      [
        99,
        -32
      ],
      [
        111,
        -54
      ],
      [
        161,
        -55
      ],
      [
        50,
        -86
      ],
      [
        37,
        -11
      ],
      [
        99,
        0
      ],
      [
        -12,
        -44
      ],
      [
        -112,
        -76
      ],
      [
        -62,
        -32
      ],
      [
        13,
        -76
      ],
      [
        37,
        -11
      ],
      [
        37,
        54
      ],
      [
        25,
        0
      ],
      [
        74,
        33
      ],
      [
        74,
        -22
      ],
      [
        25,
        -162
      ],
      [
        0,
        -217
      ],
      [
        13,
        -33
      ],
      [
        37,
        -184
      ],
      [
        -37,
        -33
      ],
      [
        -100,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -112,
        0
      ],
      [
        0,
        87
      ],
      [
        -12,
        32
      ],
      [
        0,
        131
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -141
      ],
      [
        -25,
        -43
      ],
      [
        -86,
        10
      ],
      [
        -137,
        0
      ],
      [
        -161,
        65
      ],
      [
        -62,
        65
      ],
      [
        -86,
        163
      ],
      [
        -13,
        76
      ],
      [
        -37,
        65
      ],
      [
        -62,
        54
      ],
      [
        -161,
        65
      ],
      [
        -149,
        87
      ],
      [
        -148,
        65
      ],
      [
        -112,
        11
      ],
      [
        -161,
        -11
      ],
      [
        -111,
        33
      ],
      [
        -50,
        -22
      ],
      [
        13,
        -43
      ],
      [
        223,
        -22
      ],
      [
        136,
        0
      ],
      [
        74,
        -11
      ],
      [
        37,
        -21
      ],
      [
        25,
        -109
      ],
      [
        -25,
        -54
      ],
      [
        -99,
        -54
      ],
      [
        -186,
        -76
      ],
      [
        -49,
        -11
      ],
      [
        -211,
        0
      ],
      [
        -198,
        32
      ],
      [
        -136,
        0
      ],
      [
        -37,
        -10
      ],
      [
        37,
        -22
      ],
      [
        111,
        -33
      ],
      [
        -12,
        -86
      ],
      [
        -50,
        -66
      ],
      [
        -86,
        -54
      ],
      [
        -211,
        -65
      ],
      [
        25,
        -11
      ],
      [
        136,
        22
      ],
      [
        186,
        -54
      ],
      [
        149,
        11
      ],
      [
        285,
        43
      ],
      [
        49,
        -11
      ],
      [
        37,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -173,
        -54
      ],
      [
        -50,
        -11
      ],
      [
        -123,
        -87
      ],
      [
        -13,
        -54
      ],
      [
        75,
        -22
      ],
      [
        37,
        22
      ],
      [
        86,
        109
      ],
      [
        100,
        21
      ],
      [
        111,
        -11
      ],
      [
        99,
        11
      ],
      [
        211,
        76
      ],
      [
        272,
        -43
      ],
      [
        236,
        -65
      ],
      [
        136,
        -33
      ],
      [
        161,
        -11
      ],
      [
        310,
        0
      ],
      [
        24,
        -11
      ],
      [
        -24,
        -43
      ],
      [
        -50,
        -32
      ],
      [
        -62,
        -11
      ],
      [
        -149,
        -44
      ],
      [
        -12,
        -11
      ],
      [
        25,
        -43
      ],
      [
        -75,
        -11
      ],
      [
        -111,
        -32
      ],
      [
        -111,
        0
      ],
      [
        37,
        -33
      ],
      [
        12,
        -65
      ],
      [
        -74,
        -11
      ],
      [
        -99,
        22
      ],
      [
        -25,
        -11
      ],
      [
        25,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -198,
        -97
      ],
      [
        -112,
        -11
      ],
      [
        37,
        -44
      ],
      [
        0,
        -21
      ],
      [
        -62,
        -44
      ],
      [
        -111,
        -43
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -44
      ],
      [
        -87,
        -43
      ],
      [
        -62,
        -22
      ],
      [
        -74,
        -54
      ],
      [
        -161,
        -22
      ],
      [
        -87,
        -32
      ],
      [
        -62,
        -11
      ],
      [
        -210,
        -65
      ],
      [
        -87,
        0
      ],
      [
        -87,
        -22
      ],
      [
        -161,
        -54
      ],
      [
        -87,
        -22
      ],
      [
        -49,
        -21
      ],
      [
        -62,
        0
      ],
      [
        -161,
        10
      ],
      [
        -62,
        -21
      ],
      [
        -50,
        -55
      ],
      [
        -37,
        0
      ],
      [
        -136,
        33
      ],
      [
        37,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -87,
        -32
      ],
      [
        -111,
        10
      ],
      [
        -87,
        22
      ],
      [
        -111,
        65
      ],
      [
        -137,
        98
      ],
      [
        -62,
        32
      ],
      [
        0,
        -32
      ],
      [
        50,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -62,
        -33
      ],
      [
        74,
        -86
      ],
      [
        0,
        -55
      ],
      [
        -74,
        -65
      ],
      [
        -25,
        0
      ],
      [
        -161,
        -108
      ],
      [
        -49,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -74,
        -130
      ],
      [
        -62,
        -43
      ],
      [
        12,
        -33
      ],
      [
        -37,
        -97
      ],
      [
        -99,
        -141
      ],
      [
        -75,
        -131
      ],
      [
        -61,
        -65
      ],
      [
        -50,
        0
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        -76
      ],
      [
        -24,
        -22
      ],
      [
        -186,
        -119
      ],
      [
        -87,
        11
      ],
      [
        -87,
        54
      ],
      [
        -24,
        -22
      ],
      [
        37,
        -108
      ],
      [
        -62,
        -54
      ],
      [
        -74,
        -44
      ],
      [
        -112,
        -97
      ],
      [
        -12,
        75
      ],
      [
        -37,
        11
      ],
      [
        -50,
        -108
      ],
      [
        -99,
        -11
      ],
      [
        -37,
        54
      ],
      [
        -62,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -87
      ],
      [
        -37,
        -22
      ],
      [
        -50,
        11
      ],
      [
        -37,
        -32
      ],
      [
        -62,
        32
      ],
      [
        -12,
        44
      ],
      [
        49,
        65
      ],
      [
        13,
        32
      ],
      [
        -13,
        33
      ],
      [
        13,
        43
      ],
      [
        111,
        130
      ],
      [
        74,
        65
      ],
      [
        -12,
        11
      ],
      [
        -173,
        44
      ],
      [
        -87,
        10
      ],
      [
        -37,
        -10
      ],
      [
        62,
        -44
      ],
      [
        74,
        -32
      ],
      [
        -74,
        -76
      ],
      [
        -25,
        -109
      ],
      [
        -25,
        -43
      ],
      [
        -99,
        54
      ],
      [
        -12,
        -43
      ],
      [
        86,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -148,
        -55
      ],
      [
        -161,
        -10
      ],
      [
        -298,
        -33
      ],
      [
        -74,
        0
      ],
      [
        0,
        -22
      ],
      [
        211,
        -108
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -21
      ],
      [
        -62,
        -76
      ],
      [
        -112,
        -55
      ],
      [
        -148,
        33
      ],
      [
        -62,
        -11
      ],
      [
        -75,
        11
      ],
      [
        0,
        -43
      ],
      [
        38,
        -98
      ],
      [
        49,
        0
      ],
      [
        62,
        22
      ],
      [
        50,
        -54
      ],
      [
        24,
        -98
      ],
      [
        50,
        -43
      ],
      [
        37,
        -76
      ],
      [
        -99,
        -87
      ],
      [
        -74,
        0
      ],
      [
        0,
        -44
      ],
      [
        -38,
        -32
      ],
      [
        -61,
        11
      ],
      [
        -75,
        32
      ],
      [
        -136,
        11
      ],
      [
        136,
        -76
      ],
      [
        50,
        -32
      ],
      [
        74,
        21
      ],
      [
        74,
        -21
      ],
      [
        -12,
        -130
      ],
      [
        25,
        -98
      ],
      [
        12,
        -22
      ],
      [
        -74,
        -65
      ],
      [
        -13,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        11
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        12,
        -44
      ],
      [
        -50,
        -86
      ],
      [
        -49,
        -44
      ],
      [
        -149,
        0
      ],
      [
        -86,
        76
      ],
      [
        -25,
        -22
      ],
      [
        74,
        -65
      ],
      [
        112,
        -54
      ],
      [
        -13,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        -98
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -32
      ],
      [
        -124,
        21
      ],
      [
        -111,
        -11
      ],
      [
        -38,
        11
      ],
      [
        0,
        -32
      ],
      [
        124,
        -44
      ],
      [
        112,
        -21
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        12,
        -44
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -87
      ],
      [
        25,
        -54
      ],
      [
        25,
        -32
      ],
      [
        12,
        -98
      ],
      [
        -37,
        -54
      ],
      [
        -99,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        87,
        -21
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        -109
      ],
      [
        -49,
        -195
      ],
      [
        -25,
        -184
      ],
      [
        -124,
        -152
      ],
      [
        -50,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -87,
        32
      ],
      [
        -62,
        11
      ],
      [
        -49,
        0
      ],
      [
        37,
        -43
      ],
      [
        49,
        -11
      ],
      [
        50,
        -22
      ],
      [
        74,
        -10
      ],
      [
        37,
        -33
      ],
      [
        13,
        -43
      ],
      [
        0,
        -44
      ],
      [
        12,
        -119
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        -44
      ],
      [
        -99,
        11
      ],
      [
        -49,
        -22
      ],
      [
        24,
        -32
      ],
      [
        -86,
        -22
      ],
      [
        -62,
        11
      ],
      [
        12,
        54
      ],
      [
        -74,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -25,
        76
      ],
      [
        99,
        141
      ],
      [
        -12,
        22
      ],
      [
        -50,
        -43
      ],
      [
        -62,
        -109
      ],
      [
        -25,
        -11
      ],
      [
        -74,
        22
      ],
      [
        -186,
        98
      ],
      [
        0,
        108
      ],
      [
        62,
        0
      ],
      [
        75,
        54
      ],
      [
        -38,
        22
      ],
      [
        -74,
        -32
      ],
      [
        -50,
        10
      ],
      [
        -49,
        33
      ],
      [
        -124,
        43
      ],
      [
        -37,
        22
      ],
      [
        -37,
        98
      ],
      [
        49,
        119
      ],
      [
        50,
        76
      ],
      [
        12,
        54
      ],
      [
        -12,
        22
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -76
      ],
      [
        -99,
        -44
      ],
      [
        -99,
        -32
      ],
      [
        -74,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -87,
        0
      ],
      [
        -37,
        -21
      ],
      [
        -49,
        10
      ],
      [
        -25,
        33
      ],
      [
        -50,
        0
      ],
      [
        -74,
        -11
      ],
      [
        25,
        -65
      ],
      [
        -99,
        0
      ],
      [
        -25,
        11
      ],
      [
        -50,
        43
      ],
      [
        13,
        22
      ],
      [
        148,
        98
      ],
      [
        -24,
        10
      ],
      [
        -100,
        -10
      ],
      [
        -24,
        10
      ],
      [
        -62,
        -10
      ],
      [
        0,
        86
      ],
      [
        -13,
        33
      ],
      [
        -24,
        22
      ],
      [
        -149,
        32
      ],
      [
        -25,
        87
      ],
      [
        -12,
        65
      ],
      [
        -62,
        11
      ],
      [
        -25,
        32
      ],
      [
        25,
        22
      ],
      [
        12,
        33
      ],
      [
        -49,
        43
      ],
      [
        12,
        11
      ],
      [
        -37,
        76
      ],
      [
        25,
        32
      ],
      [
        86,
        44
      ],
      [
        13,
        21
      ],
      [
        74,
        22
      ],
      [
        -62,
        22
      ],
      [
        -74,
        -11
      ],
      [
        -50,
        -54
      ],
      [
        -86,
        -11
      ],
      [
        -13,
        11
      ],
      [
        -12,
        86
      ],
      [
        49,
        55
      ],
      [
        -86,
        32
      ],
      [
        -99,
        43
      ],
      [
        -87,
        76
      ],
      [
        25,
        65
      ],
      [
        0,
        66
      ],
      [
        -13,
        21
      ],
      [
        75,
        109
      ],
      [
        0,
        54
      ],
      [
        -87,
        -98
      ],
      [
        -25,
        11
      ],
      [
        -37,
        65
      ],
      [
        -99,
        87
      ],
      [
        -25,
        54
      ],
      [
        -50,
        54
      ],
      [
        -61,
        109
      ],
      [
        -100,
        130
      ],
      [
        -12,
        76
      ],
      [
        25,
        87
      ],
      [
        -37,
        65
      ],
      [
        99,
        32
      ],
      [
        235,
        65
      ],
      [
        87,
        0
      ],
      [
        -50,
        33
      ],
      [
        13,
        32
      ],
      [
        -13,
        22
      ],
      [
        -86,
        -54
      ],
      [
        -285,
        -76
      ],
      [
        -50,
        65
      ],
      [
        62,
        76
      ],
      [
        37,
        87
      ],
      [
        62,
        65
      ],
      [
        37,
        11
      ],
      [
        99,
        -11
      ],
      [
        -12,
        32
      ],
      [
        12,
        22
      ],
      [
        50,
        22
      ],
      [
        74,
        11
      ],
      [
        37,
        -11
      ],
      [
        38,
        -44
      ],
      [
        37,
        -76
      ],
      [
        49,
        -32
      ],
      [
        0,
        43
      ],
      [
        -24,
        44
      ],
      [
        -13,
        76
      ],
      [
        -62,
        43
      ],
      [
        -74,
        0
      ],
      [
        -50,
        54
      ],
      [
        -12,
        44
      ],
      [
        -37,
        75
      ],
      [
        -37,
        98
      ],
      [
        -13,
        0
      ],
      [
        13,
        -65
      ],
      [
        24,
        -43
      ],
      [
        38,
        -141
      ],
      [
        -13,
        -33
      ],
      [
        -74,
        -54
      ],
      [
        -87,
        -22
      ],
      [
        25,
        44
      ],
      [
        12,
        54
      ],
      [
        -49,
        -22
      ],
      [
        -37,
        -32
      ],
      [
        -13,
        -55
      ],
      [
        -87,
        -151
      ],
      [
        -61,
        -87
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -37,
        108
      ],
      [
        0,
        163
      ],
      [
        -50,
        238
      ],
      [
        0,
        55
      ],
      [
        -74,
        32
      ],
      [
        -25,
        76
      ],
      [
        25,
        22
      ],
      [
        99,
        54
      ],
      [
        74,
        54
      ],
      [
        75,
        87
      ],
      [
        37,
        22
      ],
      [
        124,
        21
      ],
      [
        62,
        0
      ],
      [
        0,
        22
      ],
      [
        -99,
        0
      ],
      [
        -124,
        -33
      ],
      [
        -99,
        -97
      ],
      [
        -112,
        -65
      ],
      [
        -74,
        0
      ],
      [
        -62,
        76
      ],
      [
        -87,
        -11
      ],
      [
        -74,
        11
      ],
      [
        -13,
        119
      ],
      [
        50,
        119
      ],
      [
        -62,
        11
      ],
      [
        -37,
        44
      ],
      [
        124,
        75
      ],
      [
        186,
        120
      ],
      [
        148,
        86
      ],
      [
        62,
        76
      ],
      [
        74,
        33
      ],
      [
        137,
        98
      ],
      [
        -50,
        10
      ],
      [
        -433,
        -314
      ],
      [
        -50,
        -33
      ],
      [
        -74,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -100,
        -10
      ],
      [
        -37,
        -11
      ],
      [
        -24,
        11
      ],
      [
        -13,
        76
      ],
      [
        13,
        43
      ],
      [
        -13,
        43
      ],
      [
        25,
        54
      ],
      [
        37,
        44
      ],
      [
        12,
        43
      ],
      [
        112,
        65
      ],
      [
        25,
        44
      ],
      [
        148,
        21
      ],
      [
        62,
        0
      ],
      [
        13,
        22
      ],
      [
        -62,
        11
      ],
      [
        -112,
        0
      ],
      [
        -111,
        11
      ],
      [
        -75,
        0
      ],
      [
        -49,
        11
      ],
      [
        -37,
        32
      ],
      [
        -75,
        87
      ],
      [
        38,
        119
      ],
      [
        0,
        54
      ],
      [
        123,
        76
      ],
      [
        75,
        33
      ],
      [
        87,
        65
      ],
      [
        99,
        43
      ],
      [
        99,
        0
      ],
      [
        161,
        -54
      ],
      [
        86,
        -11
      ],
      [
        75,
        11
      ],
      [
        87,
        -22
      ],
      [
        173,
        -75
      ],
      [
        25,
        10
      ],
      [
        -13,
        22
      ],
      [
        -173,
        76
      ],
      [
        0,
        33
      ],
      [
        49,
        0
      ],
      [
        50,
        32
      ],
      [
        -37,
        11
      ],
      [
        -112,
        -11
      ],
      [
        -37,
        -22
      ],
      [
        -124,
        -10
      ],
      [
        -111,
        21
      ],
      [
        -87,
        44
      ],
      [
        -62,
        -22
      ],
      [
        -161,
        -33
      ],
      [
        -149,
        -119
      ],
      [
        -61,
        -22
      ],
      [
        -38,
        11
      ],
      [
        38,
        109
      ],
      [
        12,
        76
      ],
      [
        74,
        75
      ],
      [
        75,
        152
      ],
      [
        37,
        11
      ],
      [
        210,
        -54
      ],
      [
        124,
        -43
      ],
      [
        99,
        -11
      ],
      [
        62,
        0
      ],
      [
        50,
        43
      ],
      [
        25,
        65
      ],
      [
        62,
        65
      ],
      [
        0,
        54
      ],
      [
        -87,
        -10
      ],
      [
        -62,
        -76
      ],
      [
        -62,
        -22
      ],
      [
        -136,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -112,
        22
      ],
      [
        -25,
        32
      ],
      [
        -136,
        -10
      ],
      [
        -74,
        0
      ],
      [
        62,
        75
      ],
      [
        62,
        120
      ],
      [
        49,
        32
      ],
      [
        99,
        33
      ],
      [
        100,
        -11
      ],
      [
        185,
        -87
      ],
      [
        50,
        -11
      ],
      [
        173,
        33
      ],
      [
        62,
        54
      ],
      [
        50,
        76
      ],
      [
        -75,
        -22
      ],
      [
        -74,
        -10
      ],
      [
        25,
        119
      ],
      [
        12,
        97
      ],
      [
        13,
        22
      ],
      [
        99,
        -11
      ],
      [
        136,
        11
      ],
      [
        37,
        33
      ],
      [
        -62,
        10
      ],
      [
        -25,
        33
      ],
      [
        -99,
        -33
      ],
      [
        -86,
        11
      ],
      [
        62,
        120
      ],
      [
        37,
        119
      ],
      [
        0,
        43
      ],
      [
        25,
        33
      ],
      [
        136,
        43
      ],
      [
        0,
        22
      ],
      [
        -62,
        65
      ],
      [
        12,
        22
      ],
      [
        50,
        21
      ],
      [
        0,
        22
      ],
      [
        -37,
        0
      ],
      [
        -124,
        -22
      ],
      [
        -99,
        33
      ],
      [
        -37,
        0
      ],
      [
        -100,
        -43
      ],
      [
        -37,
        10
      ],
      [
        -223,
        44
      ],
      [
        -37,
        11
      ],
      [
        -74,
        54
      ],
      [
        -161,
        87
      ],
      [
        -112,
        32
      ],
      [
        -223,
        33
      ],
      [
        -49,
        32
      ],
      [
        -124,
        119
      ],
      [
        -13,
        22
      ],
      [
        75,
        65
      ],
      [
        62,
        11
      ],
      [
        99,
        0
      ],
      [
        124,
        -32
      ],
      [
        136,
        0
      ],
      [
        161,
        -22
      ],
      [
        74,
        -22
      ],
      [
        223,
        -119
      ],
      [
        87,
        -43
      ],
      [
        37,
        0
      ],
      [
        161,
        -44
      ],
      [
        87,
        22
      ],
      [
        -12,
        22
      ],
      [
        -75,
        10
      ],
      [
        -124,
        87
      ],
      [
        -12,
        65
      ],
      [
        25,
        44
      ],
      [
        0,
        54
      ],
      [
        -50,
        32
      ],
      [
        -111,
        55
      ],
      [
        24,
        21
      ],
      [
        50,
        0
      ],
      [
        87,
        -32
      ],
      [
        49,
        0
      ],
      [
        37,
        21
      ],
      [
        -49,
        22
      ],
      [
        -74,
        54
      ],
      [
        -236,
        0
      ],
      [
        -62,
        11
      ],
      [
        -62,
        33
      ],
      [
        -124,
        -11
      ],
      [
        -74,
        0
      ],
      [
        -37,
        87
      ],
      [
        0,
        21
      ],
      [
        37,
        11
      ],
      [
        37,
        54
      ],
      [
        50,
        33
      ],
      [
        272,
        54
      ],
      [
        13,
        44
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -161,
        32
      ],
      [
        -87,
        -54
      ],
      [
        -87,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -50,
        21
      ],
      [
        -12,
        44
      ],
      [
        50,
        21
      ],
      [
        62,
        55
      ],
      [
        0,
        21
      ],
      [
        -62,
        -11
      ],
      [
        -13,
        22
      ],
      [
        0,
        76
      ],
      [
        -74,
        98
      ],
      [
        -50,
        -11
      ],
      [
        75,
        -65
      ],
      [
        12,
        -76
      ],
      [
        -87,
        -65
      ],
      [
        -24,
        -44
      ],
      [
        -38,
        -21
      ],
      [
        -37,
        11
      ],
      [
        37,
        -87
      ],
      [
        -24,
        -44
      ],
      [
        -124,
        -43
      ],
      [
        -174,
        -11
      ],
      [
        -74,
        22
      ],
      [
        -99,
        11
      ],
      [
        -87,
        86
      ],
      [
        -25,
        44
      ],
      [
        0,
        43
      ],
      [
        38,
        44
      ],
      [
        37,
        119
      ],
      [
        49,
        97
      ],
      [
        149,
        131
      ],
      [
        12,
        32
      ],
      [
        -24,
        11
      ],
      [
        -149,
        -119
      ],
      [
        -87,
        -11
      ],
      [
        -25,
        22
      ],
      [
        25,
        65
      ],
      [
        75,
        -11
      ],
      [
        24,
        32
      ],
      [
        -49,
        44
      ],
      [
        -50,
        11
      ],
      [
        50,
        32
      ],
      [
        111,
        0
      ],
      [
        112,
        87
      ],
      [
        25,
        43
      ],
      [
        -13,
        54
      ],
      [
        13,
        55
      ],
      [
        -50,
        54
      ],
      [
        -74,
        32
      ],
      [
        -37,
        -54
      ],
      [
        -38,
        0
      ],
      [
        -124,
        44
      ],
      [
        -12,
        65
      ],
      [
        87,
        32
      ],
      [
        49,
        65
      ],
      [
        -12,
        87
      ],
      [
        -37,
        43
      ],
      [
        -99,
        -54
      ],
      [
        -13,
        54
      ],
      [
        -111,
        55
      ],
      [
        0,
        43
      ],
      [
        25,
        33
      ],
      [
        12,
        54
      ],
      [
        50,
        0
      ],
      [
        -25,
        87
      ],
      [
        -37,
        32
      ],
      [
        -75,
        109
      ],
      [
        -49,
        32
      ],
      [
        -37,
        0
      ],
      [
        -236,
        -43
      ],
      [
        -25,
        11
      ],
      [
        112,
        43
      ],
      [
        74,
        11
      ],
      [
        25,
        43
      ],
      [
        -25,
        87
      ],
      [
        13,
        22
      ],
      [
        111,
        21
      ],
      [
        37,
        22
      ],
      [
        -99,
        54
      ],
      [
        -99,
        33
      ],
      [
        -87,
        108
      ],
      [
        -99,
        65
      ],
      [
        -161,
        54
      ],
      [
        -49,
        44
      ],
      [
        -50,
        65
      ],
      [
        -49,
        43
      ],
      [
        -112,
        44
      ],
      [
        -12,
        21
      ],
      [
        111,
        55
      ],
      [
        13,
        21
      ],
      [
        -87,
        120
      ],
      [
        -124,
        21
      ],
      [
        -74,
        22
      ],
      [
        -124,
        65
      ],
      [
        -99,
        22
      ],
      [
        -149,
        54
      ],
      [
        -248,
        65
      ],
      [
        -111,
        43
      ],
      [
        -149,
        11
      ],
      [
        -161,
        44
      ],
      [
        -136,
        10
      ],
      [
        -87,
        -10
      ],
      [
        -87,
        43
      ],
      [
        -99,
        22
      ],
      [
        -49,
        -11
      ],
      [
        -136,
        -76
      ],
      [
        -38,
        0
      ],
      [
        -123,
        65
      ],
      [
        -137,
        -65
      ],
      [
        -74,
        -22
      ],
      [
        -186,
        -32
      ],
      [
        -37,
        11
      ],
      [
        -112,
        65
      ],
      [
        -24,
        0
      ],
      [
        -137,
        -55
      ],
      [
        -74,
        -10
      ],
      [
        -99,
        43
      ],
      [
        -74,
        -11
      ],
      [
        74,
        -87
      ],
      [
        62,
        -54
      ],
      [
        -50,
        0
      ],
      [
        -458,
        65
      ],
      [
        -62,
        11
      ],
      [
        -260,
        119
      ],
      [
        -99,
        33
      ],
      [
        -37,
        43
      ],
      [
        25,
        22
      ],
      [
        185,
        76
      ],
      [
        75,
        22
      ],
      [
        136,
        10
      ],
      [
        49,
        22
      ],
      [
        -37,
        22
      ],
      [
        -186,
        -11
      ],
      [
        -161,
        11
      ],
      [
        -148,
        32
      ],
      [
        -75,
        55
      ],
      [
        0,
        32
      ],
      [
        -111,
        -11
      ],
      [
        -87,
        -32
      ],
      [
        -99,
        21
      ],
      [
        -12,
        55
      ],
      [
        -124,
        65
      ],
      [
        0,
        32
      ],
      [
        62,
        44
      ],
      [
        124,
        32
      ],
      [
        322,
        22
      ],
      [
        235,
        -22
      ],
      [
        87,
        65
      ],
      [
        49,
        22
      ],
      [
        161,
        22
      ],
      [
        236,
        10
      ],
      [
        248,
        -32
      ],
      [
        111,
        -33
      ],
      [
        -25,
        65
      ],
      [
        50,
        44
      ],
      [
        0,
        65
      ],
      [
        -124,
        76
      ],
      [
        -50,
        0
      ],
      [
        -111,
        -33
      ],
      [
        -124,
        -54
      ],
      [
        -161,
        -22
      ],
      [
        -111,
        22
      ],
      [
        -87,
        33
      ],
      [
        -62,
        -11
      ],
      [
        -37,
        -33
      ],
      [
        -124,
        -43
      ],
      [
        -50,
        0
      ],
      [
        -223,
        54
      ],
      [
        -49,
        22
      ],
      [
        0,
        32
      ],
      [
        -62,
        33
      ],
      [
        -87,
        21
      ],
      [
        161,
        66
      ],
      [
        0,
        10
      ],
      [
        -111,
        0
      ],
      [
        -62,
        -32
      ],
      [
        -137,
        0
      ],
      [
        -136,
        22
      ],
      [
        -37,
        32
      ],
      [
        -198,
        33
      ],
      [
        -248,
        141
      ],
      [
        -12,
        21
      ],
      [
        86,
        55
      ],
      [
        -49,
        54
      ],
      [
        12,
        21
      ],
      [
        99,
        66
      ],
      [
        137,
        32
      ],
      [
        173,
        54
      ],
      [
        211,
        0
      ],
      [
        161,
        55
      ],
      [
        148,
        32
      ],
      [
        347,
        43
      ],
      [
        25,
        22
      ],
      [
        -37,
        33
      ],
      [
        223,
        65
      ],
      [
        173,
        11
      ],
      [
        174,
        43
      ],
      [
        272,
        11
      ],
      [
        112,
        -22
      ],
      [
        99,
        11
      ],
      [
        136,
        87
      ],
      [
        99,
        108
      ],
      [
        99,
        185
      ],
      [
        62,
        162
      ],
      [
        62,
        33
      ],
      [
        149,
        32
      ],
      [
        -50,
        22
      ],
      [
        -74,
        0
      ],
      [
        -149,
        -33
      ],
      [
        -136,
        0
      ],
      [
        -62,
        -21
      ],
      [
        -149,
        -11
      ],
      [
        -161,
        32
      ],
      [
        -173,
        0
      ],
      [
        -87,
        87
      ],
      [
        74,
        119
      ],
      [
        137,
        76
      ],
      [
        223,
        76
      ],
      [
        111,
        22
      ],
      [
        198,
        87
      ],
      [
        124,
        87
      ],
      [
        62,
        21
      ],
      [
        211,
        33
      ],
      [
        161,
        -22
      ],
      [
        74,
        43
      ],
      [
        0,
        33
      ],
      [
        74,
        43
      ],
      [
        112,
        0
      ],
      [
        223,
        -21
      ],
      [
        136,
        -44
      ],
      [
        75,
        11
      ],
      [
        86,
        98
      ],
      [
        25,
        76
      ],
      [
        -37,
        217
      ],
      [
        124,
        65
      ],
      [
        136,
        43
      ],
      [
        186,
        11
      ],
      [
        210,
        -33
      ],
      [
        298,
        -119
      ],
      [
        124,
        -43
      ],
      [
        198,
        -55
      ],
      [
        223,
        -97
      ],
      [
        62,
        0
      ],
      [
        -62,
        43
      ],
      [
        -347,
        130
      ],
      [
        -124,
        55
      ],
      [
        -211,
        108
      ],
      [
        -148,
        33
      ],
      [
        0,
        21
      ],
      [
        186,
        54
      ],
      [
        346,
        44
      ],
      [
        384,
        32
      ],
      [
        137,
        0
      ],
      [
        223,
        22
      ],
      [
        24,
        22
      ],
      [
        261,
        43
      ],
      [
        61,
        0
      ],
      [
        199,
        -54
      ],
      [
        99,
        -65
      ],
      [
        37,
        -65
      ],
      [
        -12,
        -206
      ],
      [
        61,
        -33
      ],
      [
        137,
        119
      ],
      [
        37,
        109
      ],
      [
        -62,
        43
      ],
      [
        0,
        87
      ],
      [
        25,
        43
      ],
      [
        86,
        0
      ],
      [
        360,
        -151
      ],
      [
        136,
        -33
      ],
      [
        149,
        -87
      ],
      [
        185,
        11
      ],
      [
        248,
        -11
      ],
      [
        37,
        22
      ],
      [
        -49,
        33
      ],
      [
        -248,
        86
      ],
      [
        -111,
        76
      ],
      [
        -75,
        87
      ],
      [
        -12,
        54
      ],
      [
        49,
        11
      ],
      [
        273,
        0
      ],
      [
        409,
        -43
      ],
      [
        520,
        -152
      ],
      [
        248,
        -44
      ],
      [
        458,
        -162
      ],
      [
        136,
        -33
      ],
      [
        62,
        0
      ],
      [
        62,
        44
      ],
      [
        -37,
        108
      ],
      [
        37,
        141
      ],
      [
        74,
        33
      ],
      [
        25,
        43
      ],
      [
        -25,
        65
      ],
      [
        -86,
        43
      ],
      [
        -335,
        109
      ],
      [
        62,
        32
      ],
      [
        99,
        11
      ],
      [
        830,
        -32
      ],
      [
        149,
        -11
      ],
      [
        87,
        -22
      ],
      [
        210,
        11
      ],
      [
        -25,
        43
      ],
      [
        -966,
        55
      ],
      [
        -272,
        11
      ],
      [
        -87,
        -11
      ],
      [
        -285,
        0
      ],
      [
        -124,
        54
      ],
      [
        112,
        76
      ],
      [
        260,
        -33
      ],
      [
        260,
        65
      ],
      [
        149,
        11
      ],
      [
        346,
        76
      ],
      [
        149,
        0
      ],
      [
        248,
        -32
      ],
      [
        74,
        -44
      ],
      [
        186,
        -22
      ],
      [
        211,
        109
      ],
      [
        111,
        32
      ],
      [
        161,
        -21
      ],
      [
        198,
        -54
      ],
      [
        137,
        -22
      ],
      [
        223,
        -109
      ],
      [
        86,
        33
      ],
      [
        13,
        87
      ],
      [
        -223,
        54
      ],
      [
        -37,
        54
      ],
      [
        74,
        33
      ],
      [
        111,
        -11
      ],
      [
        161,
        65
      ],
      [
        211,
        -22
      ],
      [
        111,
        0
      ],
      [
        62,
        44
      ],
      [
        496,
        0
      ],
      [
        173,
        21
      ],
      [
        186,
        -32
      ],
      [
        99,
        0
      ],
      [
        298,
        54
      ],
      [
        780,
        -11
      ],
      [
        260,
        -22
      ]
    ],
    [
      [
        31563,
        66036
      ],
      [
        -37,
        -65
      ],
      [
        -62,
        -87
      ],
      [
        -50,
        -75
      ],
      [
        -99,
        -131
      ],
      [
        0,
        -10
      ],
      [
        -74,
        -55
      ],
      [
        -13,
        -86
      ],
      [
        0,
        -22
      ],
      [
        13,
        -54
      ],
      [
        12,
        -76
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        -13,
        -43
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        31179,
        65223
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        -22
      ],
      [
        0,
        -21
      ],
      [
        12,
        -44
      ],
      [
        0,
        -22
      ],
      [
        -50,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        -32
      ],
      [
        -62,
        -109
      ],
      [
        0,
        -32
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        30931,
        64789
      ],
      [
        -136,
        109
      ],
      [
        -50,
        21
      ],
      [
        -185,
        -11
      ],
      [
        -75,
        44
      ],
      [
        -86,
        76
      ],
      [
        -62,
        76
      ],
      [
        -149,
        195
      ]
    ],
    [
      [
        30188,
        65299
      ],
      [
        25,
        54
      ],
      [
        0,
        206
      ],
      [
        24,
        44
      ],
      [
        13,
        32
      ],
      [
        -50,
        98
      ],
      [
        0,
        21
      ],
      [
        13,
        33
      ],
      [
        24,
        108
      ],
      [
        50,
        130
      ],
      [
        50,
        141
      ],
      [
        24,
        87
      ],
      [
        261,
        0
      ],
      [
        185,
        0
      ],
      [
        -12,
        54
      ],
      [
        25,
        120
      ],
      [
        0,
        21
      ],
      [
        -25,
        33
      ],
      [
        -37,
        22
      ],
      [
        -13,
        21
      ],
      [
        0,
        33
      ],
      [
        -24,
        98
      ],
      [
        -38,
        43
      ],
      [
        -61,
        54
      ],
      [
        -50,
        65
      ],
      [
        -62,
        141
      ],
      [
        -37,
        33
      ],
      [
        149,
        0
      ],
      [
        0,
        347
      ],
      [
        272,
        0
      ],
      [
        161,
        0
      ],
      [
        198,
        0
      ]
    ],
    [
      [
        31340,
        66145
      ],
      [
        12,
        -22
      ],
      [
        25,
        0
      ],
      [
        25,
        -32
      ],
      [
        37,
        -33
      ],
      [
        25,
        54
      ],
      [
        -25,
        54
      ],
      [
        0,
        11
      ],
      [
        124,
        -141
      ]
    ],
    [
      [
        111721,
        64496
      ],
      [
        -12,
        0
      ],
      [
        -12,
        22
      ],
      [
        0,
        87
      ],
      [
        49,
        54
      ],
      [
        13,
        65
      ],
      [
        24,
        -11
      ],
      [
        13,
        -21
      ],
      [
        -62,
        -98
      ],
      [
        -13,
        -98
      ]
    ],
    [
      [
        41027,
        59464
      ],
      [
        -74,
        141
      ],
      [
        -149,
        304
      ],
      [
        0,
        11
      ],
      [
        25,
        76
      ],
      [
        24,
        43
      ],
      [
        38,
        54
      ],
      [
        -13,
        109
      ],
      [
        13,
        43
      ],
      [
        -13,
        33
      ],
      [
        -12,
        54
      ],
      [
        25,
        65
      ],
      [
        12,
        11
      ],
      [
        50,
        11
      ],
      [
        24,
        32
      ],
      [
        25,
        0
      ],
      [
        37,
        -11
      ],
      [
        37,
        54
      ],
      [
        75,
        55
      ],
      [
        25,
        97
      ],
      [
        -25,
        44
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -12,
        43
      ],
      [
        0,
        22
      ],
      [
        12,
        43
      ],
      [
        -12,
        22
      ],
      [
        -25,
        87
      ],
      [
        0,
        21
      ],
      [
        13,
        44
      ],
      [
        24,
        32
      ],
      [
        13,
        76
      ],
      [
        12,
        22
      ],
      [
        50,
        11
      ],
      [
        74,
        108
      ],
      [
        50,
        33
      ],
      [
        12,
        65
      ],
      [
        0,
        22
      ],
      [
        50,
        32
      ],
      [
        0,
        43
      ],
      [
        -62,
        152
      ]
    ],
    [
      [
        41275,
        61557
      ],
      [
        12,
        -11
      ],
      [
        50,
        -97
      ],
      [
        24,
        -22
      ],
      [
        13,
        0
      ],
      [
        0,
        22
      ],
      [
        24,
        -11
      ],
      [
        62,
        -65
      ],
      [
        100,
        -119
      ],
      [
        136,
        -206
      ],
      [
        37,
        -87
      ],
      [
        25,
        -33
      ],
      [
        37,
        -97
      ],
      [
        12,
        -44
      ],
      [
        0,
        -173
      ],
      [
        -37,
        -130
      ],
      [
        -12,
        -87
      ],
      [
        12,
        -44
      ],
      [
        25,
        66
      ],
      [
        37,
        75
      ],
      [
        37,
        22
      ],
      [
        37,
        -32
      ],
      [
        38,
        -11
      ],
      [
        37,
        -22
      ],
      [
        62,
        -119
      ],
      [
        62,
        -87
      ],
      [
        24,
        -76
      ],
      [
        62,
        -32
      ],
      [
        50,
        -66
      ],
      [
        12,
        -54
      ],
      [
        0,
        -130
      ],
      [
        -12,
        -206
      ]
    ],
    [
      [
        42241,
        59681
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -54
      ],
      [
        25,
        -11
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -54
      ],
      [
        -87,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        0
      ],
      [
        -25,
        -65
      ],
      [
        12,
        -22
      ],
      [
        13,
        -44
      ],
      [
        0,
        -86
      ],
      [
        -25,
        -76
      ],
      [
        -25,
        -141
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -108
      ],
      [
        49,
        -98
      ],
      [
        13,
        -43
      ],
      [
        12,
        -65
      ],
      [
        37,
        -54
      ],
      [
        25,
        -44
      ],
      [
        0,
        -76
      ],
      [
        13,
        -21
      ],
      [
        37,
        -11
      ],
      [
        25,
        11
      ],
      [
        0,
        10
      ],
      [
        37,
        0
      ],
      [
        12,
        -21
      ],
      [
        0,
        -109
      ],
      [
        12,
        -21
      ],
      [
        0,
        -33
      ],
      [
        13,
        -54
      ],
      [
        0,
        -87
      ],
      [
        25,
        -54
      ],
      [
        12,
        -11
      ],
      [
        12,
        -54
      ],
      [
        13,
        -33
      ],
      [
        12,
        -65
      ],
      [
        13,
        -32
      ],
      [
        24,
        -87
      ],
      [
        25,
        -54
      ],
      [
        12,
        -76
      ],
      [
        25,
        -44
      ],
      [
        25,
        -21
      ],
      [
        25,
        0
      ],
      [
        25,
        -44
      ]
    ],
    [
      [
        101229,
        70092
      ],
      [
        -12,
        -10
      ],
      [
        -25,
        43
      ],
      [
        25,
        22
      ],
      [
        12,
        -22
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        101143,
        70092
      ],
      [
        -50,
        0
      ],
      [
        12,
        44
      ],
      [
        38,
        -11
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        101242,
        70298
      ],
      [
        0,
        -54
      ],
      [
        24,
        -43
      ],
      [
        -24,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -50,
        43
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        44
      ],
      [
        50,
        32
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        87281,
        23024
      ],
      [
        -37,
        -32
      ],
      [
        -50,
        0
      ],
      [
        -37,
        97
      ],
      [
        -24,
        33
      ],
      [
        12,
        11
      ],
      [
        25,
        -22
      ],
      [
        74,
        -22
      ],
      [
        74,
        -65
      ],
      [
        -37,
        0
      ]
    ],
    [
      [
        33310,
        65581
      ],
      [
        -87,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -65
      ],
      [
        -13,
        11
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -13,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -12,
        -43
      ],
      [
        -38,
        10
      ],
      [
        -24,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -25,
        32
      ],
      [
        -25,
        44
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -21
      ],
      [
        -12,
        0
      ],
      [
        -13,
        -33
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -76
      ],
      [
        -37,
        -54
      ],
      [
        -38,
        -22
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        76
      ],
      [
        -24,
        54
      ],
      [
        -38,
        -43
      ],
      [
        -62,
        -141
      ],
      [
        -99,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -65
      ],
      [
        12,
        -141
      ],
      [
        13,
        -65
      ],
      [
        -13,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -37,
        -32
      ],
      [
        -99,
        -11
      ]
    ],
    [
      [
        31873,
        64323
      ],
      [
        0,
        65
      ],
      [
        -25,
        22
      ],
      [
        -25,
        97
      ],
      [
        0,
        44
      ],
      [
        -37,
        21
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        22
      ]
    ],
    [
      [
        31712,
        64583
      ],
      [
        24,
        33
      ],
      [
        0,
        32
      ],
      [
        -12,
        11
      ],
      [
        0,
        43
      ],
      [
        12,
        44
      ],
      [
        13,
        97
      ],
      [
        -13,
        22
      ],
      [
        -24,
        22
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        11
      ],
      [
        -12,
        32
      ],
      [
        -25,
        22
      ],
      [
        -49,
        -33
      ],
      [
        -62,
        -54
      ],
      [
        -13,
        0
      ],
      [
        0,
        76
      ],
      [
        -25,
        22
      ],
      [
        -37,
        11
      ],
      [
        -24,
        32
      ],
      [
        -38,
        33
      ],
      [
        0,
        21
      ],
      [
        -49,
        54
      ],
      [
        -13,
        33
      ],
      [
        -24,
        43
      ],
      [
        -25,
        -10
      ],
      [
        -62,
        43
      ]
    ],
    [
      [
        31563,
        66036
      ],
      [
        37,
        -11
      ],
      [
        25,
        33
      ],
      [
        25,
        22
      ],
      [
        24,
        43
      ],
      [
        13,
        11
      ],
      [
        62,
        22
      ],
      [
        25,
        0
      ],
      [
        24,
        -55
      ],
      [
        25,
        -21
      ],
      [
        37,
        21
      ],
      [
        37,
        0
      ],
      [
        124,
        -43
      ],
      [
        50,
        22
      ],
      [
        99,
        0
      ],
      [
        37,
        -11
      ],
      [
        62,
        65
      ],
      [
        37,
        11
      ],
      [
        50,
        32
      ],
      [
        0,
        33
      ],
      [
        49,
        0
      ],
      [
        112,
        -65
      ],
      [
        111,
        11
      ],
      [
        37,
        32
      ],
      [
        25,
        11
      ],
      [
        112,
        -65
      ],
      [
        24,
        -54
      ],
      [
        25,
        0
      ],
      [
        25,
        11
      ],
      [
        0,
        10
      ],
      [
        -25,
        11
      ],
      [
        -12,
        22
      ],
      [
        99,
        -33
      ],
      [
        161,
        -249
      ],
      [
        0,
        -11
      ],
      [
        -62,
        65
      ],
      [
        -37,
        0
      ],
      [
        -13,
        -11
      ],
      [
        0,
        -65
      ],
      [
        25,
        0
      ],
      [
        13,
        11
      ],
      [
        24,
        -11
      ],
      [
        62,
        -108
      ],
      [
        13,
        0
      ],
      [
        12,
        22
      ],
      [
        25,
        10
      ],
      [
        25,
        -32
      ],
      [
        49,
        11
      ],
      [
        37,
        -98
      ],
      [
        38,
        -54
      ]
    ],
    [
      [
        32195,
        66448
      ],
      [
        -62,
        -54
      ],
      [
        12,
        44
      ],
      [
        37,
        32
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        32381,
        66492
      ],
      [
        -25,
        -33
      ],
      [
        -13,
        22
      ],
      [
        13,
        33
      ],
      [
        37,
        10
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        67647,
        83074
      ],
      [
        75,
        -22
      ],
      [
        37,
        11
      ],
      [
        49,
        -11
      ],
      [
        0,
        -32
      ],
      [
        -37,
        11
      ],
      [
        -49,
        -22
      ],
      [
        -38,
        11
      ],
      [
        -37,
        54
      ]
    ],
    [
      [
        68267,
        82803
      ],
      [
        0,
        -22
      ],
      [
        24,
        -65
      ]
    ],
    [
      [
        68291,
        82716
      ],
      [
        -123,
        130
      ],
      [
        -112,
        98
      ],
      [
        -87,
        33
      ],
      [
        -111,
        75
      ],
      [
        -13,
        44
      ],
      [
        174,
        -119
      ],
      [
        -13,
        32
      ]
    ],
    [
      [
        67845,
        83150
      ],
      [
        -185,
        0
      ],
      [
        -38,
        11
      ],
      [
        -61,
        43
      ],
      [
        49,
        11
      ],
      [
        50,
        -11
      ],
      [
        12,
        -21
      ],
      [
        173,
        -33
      ]
    ],
    [
      [
        67697,
        83248
      ],
      [
        -50,
        -11
      ],
      [
        -74,
        32
      ],
      [
        12,
        44
      ],
      [
        50,
        0
      ],
      [
        87,
        -22
      ],
      [
        12,
        -33
      ],
      [
        -37,
        -10
      ]
    ],
    [
      [
        67152,
        83909
      ],
      [
        -13,
        -21
      ],
      [
        -24,
        32
      ],
      [
        -25,
        54
      ],
      [
        -37,
        33
      ],
      [
        -13,
        32
      ],
      [
        0,
        44
      ],
      [
        13,
        0
      ],
      [
        111,
        -163
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        67028,
        84169
      ],
      [
        -50,
        11
      ],
      [
        -12,
        22
      ],
      [
        12,
        22
      ],
      [
        25,
        -11
      ],
      [
        25,
        -44
      ]
    ],
    [
      [
        66904,
        84115
      ],
      [
        -12,
        0
      ],
      [
        -38,
        141
      ],
      [
        -12,
        33
      ],
      [
        12,
        21
      ],
      [
        -12,
        109
      ],
      [
        25,
        11
      ],
      [
        0,
        -54
      ],
      [
        12,
        -33
      ],
      [
        25,
        -33
      ],
      [
        -12,
        -65
      ],
      [
        12,
        -97
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        67016,
        84310
      ],
      [
        -38,
        -10
      ],
      [
        -24,
        21
      ],
      [
        0,
        22
      ],
      [
        -38,
        0
      ],
      [
        -24,
        33
      ],
      [
        49,
        86
      ],
      [
        37,
        -86
      ],
      [
        13,
        -11
      ],
      [
        25,
        -55
      ]
    ],
    [
      [
        68428,
        84907
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        25,
        -44
      ],
      [
        12,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        12,
        -33
      ],
      [
        50,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -43
      ],
      [
        25,
        -33
      ],
      [
        62,
        -43
      ],
      [
        24,
        0
      ],
      [
        25,
        -44
      ],
      [
        0,
        -21
      ],
      [
        -74,
        0
      ],
      [
        -50,
        -22
      ],
      [
        25,
        -98
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        67969,
        83031
      ],
      [
        -12,
        21
      ],
      [
        -74,
        98
      ],
      [
        -62,
        54
      ],
      [
        -87,
        120
      ],
      [
        -99,
        43
      ],
      [
        -74,
        43
      ],
      [
        -38,
        0
      ],
      [
        -49,
        -21
      ],
      [
        -50,
        10
      ],
      [
        -12,
        33
      ],
      [
        0,
        54
      ],
      [
        -50,
        44
      ],
      [
        -49,
        54
      ],
      [
        -62,
        54
      ],
      [
        -124,
        217
      ],
      [
        62,
        22
      ],
      [
        25,
        0
      ],
      [
        0,
        32
      ],
      [
        -37,
        33
      ],
      [
        -100,
        130
      ],
      [
        -24,
        65
      ],
      [
        -13,
        76
      ],
      [
        13,
        97
      ],
      [
        -13,
        66
      ],
      [
        -86,
        86
      ],
      [
        -25,
        44
      ],
      [
        -50,
        32
      ],
      [
        -25,
        0
      ],
      [
        -24,
        -43
      ],
      [
        -13,
        -76
      ],
      [
        -49,
        -98
      ],
      [
        -13,
        -43
      ],
      [
        -24,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        11
      ],
      [
        -37,
        97
      ],
      [
        -37,
        65
      ],
      [
        -12,
        44
      ],
      [
        0,
        43
      ],
      [
        -37,
        152
      ],
      [
        24,
        22
      ]
    ],
    [
      [
        66594,
        84647
      ],
      [
        13,
        -22
      ],
      [
        86,
        -33
      ],
      [
        25,
        11
      ],
      [
        25,
        44
      ],
      [
        25,
        -22
      ],
      [
        99,
        0
      ],
      [
        25,
        11
      ],
      [
        24,
        65
      ],
      [
        25,
        32
      ],
      [
        25,
        -54
      ],
      [
        25,
        -32
      ],
      [
        37,
        -33
      ],
      [
        37,
        22
      ],
      [
        62,
        -33
      ],
      [
        37,
        0
      ],
      [
        37,
        11
      ],
      [
        -12,
        44
      ],
      [
        0,
        54
      ],
      [
        12,
        21
      ],
      [
        -24,
        44
      ],
      [
        61,
        43
      ],
      [
        62,
        22
      ],
      [
        13,
        22
      ],
      [
        0,
        119
      ],
      [
        -25,
        32
      ],
      [
        12,
        55
      ],
      [
        50,
        21
      ],
      [
        25,
        22
      ],
      [
        49,
        22
      ],
      [
        37,
        54
      ],
      [
        50,
        -11
      ],
      [
        0,
        76
      ],
      [
        25,
        33
      ],
      [
        74,
        -22
      ]
    ],
    [
      [
        67610,
        85265
      ],
      [
        74,
        -54
      ],
      [
        50,
        -55
      ],
      [
        25,
        -54
      ],
      [
        25,
        -32
      ],
      [
        37,
        -33
      ],
      [
        37,
        -43
      ],
      [
        49,
        -76
      ],
      [
        75,
        -22
      ],
      [
        12,
        -32
      ],
      [
        62,
        -44
      ],
      [
        50,
        -11
      ],
      [
        99,
        -11
      ],
      [
        62,
        0
      ],
      [
        49,
        33
      ],
      [
        25,
        54
      ],
      [
        25,
        0
      ],
      [
        62,
        22
      ]
    ],
    [
      [
        36877,
        67945
      ],
      [
        -12,
        -43
      ],
      [
        -87,
        54
      ],
      [
        -62,
        65
      ],
      [
        0,
        33
      ],
      [
        37,
        10
      ],
      [
        37,
        -21
      ],
      [
        50,
        -44
      ],
      [
        37,
        -54
      ]
    ],
    [
      [
        37236,
        67479
      ],
      [
        -37,
        54
      ],
      [
        -25,
        43
      ],
      [
        -37,
        22
      ],
      [
        -161,
        0
      ],
      [
        -37,
        -33
      ],
      [
        -50,
        -10
      ],
      [
        -37,
        0
      ],
      [
        -99,
        32
      ],
      [
        -37,
        22
      ],
      [
        -37,
        11
      ],
      [
        -87,
        -22
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -43
      ],
      [
        -13,
        -11
      ],
      [
        -37,
        65
      ],
      [
        -74,
        87
      ],
      [
        -74,
        43
      ],
      [
        -25,
        65
      ],
      [
        37,
        108
      ],
      [
        37,
        22
      ],
      [
        62,
        -11
      ],
      [
        74,
        -43
      ],
      [
        62,
        0
      ],
      [
        38,
        -33
      ],
      [
        235,
        -43
      ],
      [
        37,
        -11
      ],
      [
        37,
        22
      ],
      [
        25,
        54
      ],
      [
        74,
        0
      ],
      [
        13,
        11
      ],
      [
        12,
        32
      ],
      [
        0,
        33
      ],
      [
        -49,
        43
      ],
      [
        -62,
        98
      ],
      [
        -50,
        108
      ],
      [
        25,
        33
      ],
      [
        -13,
        76
      ],
      [
        25,
        119
      ],
      [
        -124,
        109
      ],
      [
        -86,
        10
      ],
      [
        -37,
        22
      ],
      [
        -13,
        33
      ],
      [
        13,
        54
      ],
      [
        61,
        54
      ],
      [
        38,
        11
      ],
      [
        86,
        11
      ],
      [
        87,
        -11
      ],
      [
        62,
        -54
      ],
      [
        74,
        -44
      ],
      [
        137,
        -32
      ],
      [
        12,
        11
      ]
    ],
    [
      [
        36927,
        68726
      ],
      [
        12,
        -11
      ],
      [
        -12,
        -22
      ],
      [
        -62,
        33
      ],
      [
        -25,
        0
      ],
      [
        -12,
        22
      ],
      [
        49,
        21
      ],
      [
        50,
        -43
      ]
    ],
    [
      [
        69790,
        86165
      ],
      [
        0,
        -11
      ],
      [
        -62,
        -87
      ],
      [
        -37,
        -21
      ],
      [
        -25,
        11
      ],
      [
        -74,
        -33
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        -87
      ],
      [
        -37,
        -32
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        -21
      ],
      [
        -24,
        -109
      ],
      [
        -50,
        -76
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -54
      ],
      [
        -37,
        -55
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        -22
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        -65
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        -32
      ],
      [
        -24,
        -33
      ],
      [
        -50,
        11
      ],
      [
        -87,
        -22
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        68886,
        85015
      ],
      [
        -25,
        22
      ],
      [
        -74,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -75,
        22
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -65
      ],
      [
        -62,
        -44
      ],
      [
        -49,
        11
      ],
      [
        -50,
        -43
      ],
      [
        -12,
        0
      ]
    ],
    [
      [
        67610,
        85265
      ],
      [
        -12,
        11
      ],
      [
        -37,
        76
      ],
      [
        0,
        32
      ],
      [
        -13,
        11
      ],
      [
        -12,
        43
      ],
      [
        0,
        33
      ],
      [
        -13,
        11
      ],
      [
        -62,
        11
      ]
    ],
    [
      [
        67821,
        86198
      ],
      [
        12,
        10
      ],
      [
        37,
        -10
      ],
      [
        75,
        -66
      ],
      [
        49,
        -54
      ],
      [
        37,
        -21
      ],
      [
        75,
        0
      ],
      [
        62,
        -11
      ],
      [
        198,
        21
      ],
      [
        24,
        44
      ],
      [
        -12,
        21
      ],
      [
        0,
        33
      ],
      [
        12,
        33
      ],
      [
        38,
        32
      ],
      [
        124,
        11
      ],
      [
        74,
        22
      ],
      [
        25,
        65
      ],
      [
        24,
        11
      ],
      [
        25,
        -11
      ],
      [
        37,
        -33
      ],
      [
        50,
        -11
      ],
      [
        62,
        55
      ],
      [
        74,
        43
      ],
      [
        50,
        130
      ],
      [
        0,
        11
      ],
      [
        49,
        22
      ],
      [
        87,
        -11
      ],
      [
        62,
        -22
      ],
      [
        49,
        0
      ],
      [
        62,
        33
      ],
      [
        25,
        0
      ],
      [
        13,
        -22
      ],
      [
        24,
        -11
      ],
      [
        25,
        -65
      ],
      [
        25,
        -33
      ],
      [
        25,
        -10
      ],
      [
        111,
        43
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        69543,
        86447
      ],
      [
        24,
        11
      ],
      [
        25,
        -33
      ],
      [
        0,
        -21
      ],
      [
        25,
        -44
      ],
      [
        49,
        -32
      ],
      [
        25,
        -44
      ],
      [
        37,
        -21
      ],
      [
        37,
        0
      ],
      [
        25,
        -44
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        104227,
        49400
      ],
      [
        -37,
        0
      ],
      [
        -12,
        11
      ],
      [
        0,
        54
      ],
      [
        12,
        22
      ],
      [
        74,
        43
      ],
      [
        25,
        32
      ],
      [
        50,
        76
      ],
      [
        37,
        33
      ],
      [
        0,
        -54
      ],
      [
        12,
        -55
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        -65
      ],
      [
        -75,
        -43
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        103855,
        49595
      ],
      [
        -49,
        11
      ],
      [
        -12,
        11
      ],
      [
        37,
        32
      ],
      [
        24,
        44
      ],
      [
        50,
        0
      ],
      [
        -12,
        -55
      ],
      [
        -38,
        -43
      ]
    ],
    [
      [
        104388,
        49779
      ],
      [
        -37,
        -21
      ],
      [
        0,
        43
      ],
      [
        25,
        54
      ],
      [
        24,
        22
      ],
      [
        13,
        -33
      ],
      [
        -25,
        -21
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        103211,
        50354
      ],
      [
        25,
        -21
      ],
      [
        50,
        -55
      ],
      [
        12,
        -21
      ],
      [
        0,
        -44
      ],
      [
        12,
        -21
      ],
      [
        25,
        -11
      ],
      [
        25,
        11
      ],
      [
        25,
        -22
      ],
      [
        12,
        -33
      ],
      [
        37,
        -54
      ],
      [
        13,
        -54
      ],
      [
        37,
        -33
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        -65
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        0
      ],
      [
        -50,
        -44
      ],
      [
        -12,
        22
      ],
      [
        -50,
        11
      ],
      [
        -37,
        32
      ],
      [
        -37,
        44
      ],
      [
        -13,
        54
      ],
      [
        -24,
        43
      ],
      [
        -38,
        33
      ],
      [
        -74,
        87
      ],
      [
        -50,
        11
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -86,
        43
      ],
      [
        -25,
        22
      ],
      [
        -13,
        32
      ],
      [
        0,
        33
      ],
      [
        -12,
        32
      ],
      [
        25,
        55
      ],
      [
        49,
        32
      ],
      [
        38,
        11
      ],
      [
        49,
        0
      ],
      [
        62,
        11
      ],
      [
        62,
        -22
      ],
      [
        25,
        11
      ],
      [
        25,
        43
      ],
      [
        24,
        -54
      ]
    ],
    [
      [
        104599,
        50376
      ],
      [
        24,
        -43
      ],
      [
        62,
        -11
      ],
      [
        13,
        11
      ],
      [
        37,
        65
      ],
      [
        0,
        75
      ]
    ],
    [
      [
        104735,
        50473
      ],
      [
        49,
        22
      ],
      [
        25,
        22
      ],
      [
        25,
        32
      ],
      [
        74,
        76
      ]
    ],
    [
      [
        104908,
        50625
      ],
      [
        0,
        -65
      ],
      [
        13,
        -11
      ],
      [
        49,
        44
      ],
      [
        13,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -44
      ],
      [
        -49,
        0
      ],
      [
        0,
        -65
      ],
      [
        25,
        -54
      ],
      [
        12,
        -87
      ]
    ],
    [
      [
        104958,
        50267
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        -54
      ],
      [
        -50,
        -65
      ],
      [
        -37,
        -98
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -87,
        -22
      ],
      [
        -74,
        -76
      ],
      [
        -37,
        -21
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        22
      ],
      [
        -12,
        32
      ],
      [
        0,
        33
      ],
      [
        37,
        86
      ],
      [
        -37,
        33
      ],
      [
        0,
        32
      ],
      [
        25,
        163
      ],
      [
        12,
        54
      ],
      [
        87,
        152
      ],
      [
        25,
        22
      ]
    ],
    [
      [
        101700,
        50734
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        43
      ],
      [
        -12,
        11
      ],
      [
        24,
        33
      ],
      [
        13,
        0
      ],
      [
        12,
        -33
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        104239,
        50875
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        11
      ],
      [
        13,
        33
      ],
      [
        0,
        21
      ],
      [
        37,
        33
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -32
      ]
    ],
    [
      [
        103025,
        50755
      ],
      [
        -12,
        -10
      ],
      [
        -12,
        10
      ],
      [
        0,
        98
      ],
      [
        12,
        22
      ],
      [
        0,
        54
      ],
      [
        37,
        -11
      ],
      [
        13,
        -22
      ],
      [
        0,
        -21
      ],
      [
        -38,
        -76
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        104351,
        50994
      ],
      [
        0,
        -22
      ],
      [
        -99,
        0
      ],
      [
        0,
        33
      ],
      [
        25,
        43
      ],
      [
        37,
        22
      ],
      [
        49,
        -22
      ],
      [
        -12,
        -54
      ]
    ],
    [
      [
        102059,
        50831
      ],
      [
        -49,
        -130
      ],
      [
        25,
        -43
      ],
      [
        -75,
        -22
      ],
      [
        -111,
        33
      ],
      [
        -62,
        32
      ],
      [
        0,
        54
      ],
      [
        62,
        -21
      ],
      [
        12,
        21
      ],
      [
        0,
        185
      ],
      [
        50,
        97
      ],
      [
        24,
        33
      ],
      [
        38,
        22
      ],
      [
        86,
        -55
      ],
      [
        25,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -141
      ]
    ],
    [
      [
        104685,
        51016
      ],
      [
        -24,
        -44
      ],
      [
        -13,
        -65
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        65
      ],
      [
        -37,
        0
      ],
      [
        12,
        54
      ],
      [
        12,
        22
      ],
      [
        25,
        0
      ],
      [
        12,
        -22
      ],
      [
        50,
        98
      ],
      [
        25,
        -22
      ],
      [
        -13,
        -54
      ]
    ],
    [
      [
        104562,
        51048
      ],
      [
        -50,
        -21
      ],
      [
        -25,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        22
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        33
      ],
      [
        -25,
        0
      ],
      [
        25,
        54
      ],
      [
        49,
        54
      ],
      [
        -24,
        43
      ],
      [
        24,
        11
      ],
      [
        25,
        0
      ],
      [
        25,
        -11
      ],
      [
        62,
        66
      ],
      [
        37,
        -33
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        109715,
        50972
      ],
      [
        -25,
        -10
      ],
      [
        -87,
        21
      ],
      [
        0,
        44
      ],
      [
        37,
        65
      ],
      [
        25,
        21
      ],
      [
        12,
        0
      ],
      [
        38,
        -108
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        102369,
        50983
      ],
      [
        -25,
        11
      ],
      [
        13,
        33
      ],
      [
        -13,
        43
      ],
      [
        0,
        33
      ],
      [
        25,
        21
      ],
      [
        37,
        0
      ],
      [
        0,
        -21
      ],
      [
        -37,
        -120
      ]
    ],
    [
      [
        102889,
        51070
      ],
      [
        -12,
        0
      ],
      [
        0,
        43
      ],
      [
        25,
        11
      ],
      [
        12,
        -32
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        104784,
        51124
      ],
      [
        13,
        -32
      ],
      [
        25,
        21
      ],
      [
        86,
        0
      ],
      [
        62,
        -21
      ],
      [
        13,
        -76
      ],
      [
        -13,
        -22
      ],
      [
        -235,
        -54
      ],
      [
        -25,
        32
      ],
      [
        25,
        55
      ],
      [
        -12,
        32
      ],
      [
        12,
        44
      ],
      [
        25,
        32
      ],
      [
        24,
        -11
      ]
    ],
    [
      [
        105899,
        51157
      ],
      [
        62,
        -33
      ],
      [
        37,
        11
      ],
      [
        13,
        -22
      ],
      [
        -37,
        -54
      ],
      [
        -75,
        44
      ],
      [
        -12,
        43
      ],
      [
        12,
        11
      ]
    ],
    [
      [
        104165,
        50831
      ],
      [
        -49,
        -21
      ],
      [
        -50,
        -44
      ],
      [
        -25,
        -11
      ],
      [
        -111,
        0
      ],
      [
        -87,
        -75
      ],
      [
        -62,
        -22
      ],
      [
        -25,
        43
      ],
      [
        -24,
        11
      ],
      [
        -38,
        0
      ],
      [
        -24,
        -65
      ],
      [
        -50,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -62,
        54
      ],
      [
        -87,
        22
      ],
      [
        -74,
        -11
      ],
      [
        -75,
        33
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -32
      ],
      [
        0,
        32
      ],
      [
        -25,
        65
      ],
      [
        0,
        87
      ],
      [
        13,
        22
      ],
      [
        0,
        32
      ],
      [
        12,
        33
      ],
      [
        25,
        -11
      ],
      [
        49,
        43
      ],
      [
        38,
        54
      ],
      [
        49,
        22
      ],
      [
        25,
        0
      ],
      [
        12,
        -11
      ],
      [
        50,
        22
      ],
      [
        49,
        -54
      ],
      [
        50,
        0
      ],
      [
        74,
        -65
      ],
      [
        50,
        -33
      ],
      [
        37,
        -43
      ],
      [
        25,
        -22
      ],
      [
        37,
        0
      ],
      [
        25,
        33
      ],
      [
        25,
        10
      ],
      [
        24,
        0
      ],
      [
        37,
        11
      ],
      [
        38,
        22
      ],
      [
        24,
        -22
      ],
      [
        75,
        -76
      ],
      [
        24,
        -10
      ],
      [
        38,
        21
      ],
      [
        12,
        22
      ],
      [
        0,
        32
      ],
      [
        25,
        55
      ],
      [
        62,
        43
      ],
      [
        37,
        33
      ],
      [
        25,
        54
      ],
      [
        -50,
        22
      ],
      [
        25,
        54
      ],
      [
        25,
        -11
      ],
      [
        24,
        -22
      ],
      [
        0,
        -108
      ],
      [
        -24,
        -33
      ],
      [
        0,
        -21
      ],
      [
        -37,
        -44
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        106952,
        51016
      ],
      [
        -12,
        32
      ],
      [
        62,
        109
      ],
      [
        25,
        -22
      ],
      [
        24,
        0
      ],
      [
        -37,
        -54
      ],
      [
        -49,
        -22
      ],
      [
        -13,
        -43
      ]
    ],
    [
      [
        102604,
        51016
      ],
      [
        25,
        -22
      ],
      [
        12,
        0
      ],
      [
        25,
        43
      ],
      [
        25,
        11
      ],
      [
        25,
        0
      ],
      [
        37,
        -32
      ],
      [
        12,
        -44
      ],
      [
        13,
        33
      ],
      [
        37,
        32
      ],
      [
        25,
        -10
      ],
      [
        24,
        -22
      ],
      [
        13,
        -76
      ],
      [
        0,
        -65
      ],
      [
        37,
        -65
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        -10
      ],
      [
        -24,
        32
      ],
      [
        -62,
        -22
      ],
      [
        0,
        -21
      ],
      [
        37,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        22
      ],
      [
        -25,
        0
      ],
      [
        -62,
        -32
      ],
      [
        -25,
        0
      ],
      [
        0,
        97
      ],
      [
        -12,
        22
      ],
      [
        -62,
        -109
      ],
      [
        -25,
        -10
      ],
      [
        -25,
        10
      ],
      [
        -62,
        -54
      ],
      [
        -24,
        11
      ],
      [
        -25,
        0
      ],
      [
        -74,
        -65
      ],
      [
        -50,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -24,
        -22
      ],
      [
        -37,
        -21
      ],
      [
        -25,
        21
      ],
      [
        -37,
        11
      ],
      [
        -38,
        54
      ],
      [
        0,
        44
      ],
      [
        13,
        54
      ],
      [
        0,
        130
      ],
      [
        12,
        44
      ],
      [
        25,
        10
      ],
      [
        50,
        44
      ],
      [
        37,
        43
      ],
      [
        24,
        0
      ],
      [
        50,
        -32
      ],
      [
        25,
        -11
      ],
      [
        37,
        11
      ],
      [
        25,
        -22
      ],
      [
        12,
        -43
      ],
      [
        0,
        -22
      ],
      [
        13,
        -11
      ],
      [
        37,
        -76
      ],
      [
        24,
        0
      ],
      [
        38,
        -11
      ],
      [
        37,
        44
      ],
      [
        37,
        0
      ],
      [
        12,
        32
      ],
      [
        -24,
        44
      ],
      [
        -38,
        43
      ],
      [
        -24,
        0
      ],
      [
        -62,
        76
      ],
      [
        -13,
        32
      ],
      [
        -12,
        55
      ],
      [
        12,
        32
      ],
      [
        37,
        33
      ],
      [
        13,
        0
      ],
      [
        74,
        -22
      ],
      [
        13,
        -11
      ],
      [
        12,
        -76
      ],
      [
        12,
        -32
      ]
    ],
    [
      [
        101651,
        51124
      ],
      [
        24,
        -32
      ],
      [
        50,
        -98
      ],
      [
        12,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        -44
      ],
      [
        -87,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -12,
        11
      ],
      [
        12,
        33
      ],
      [
        0,
        43
      ],
      [
        -25,
        87
      ],
      [
        -74,
        87
      ],
      [
        -37,
        21
      ],
      [
        -50,
        11
      ],
      [
        -37,
        65
      ],
      [
        0,
        33
      ],
      [
        -12,
        32
      ],
      [
        12,
        33
      ],
      [
        50,
        -11
      ],
      [
        62,
        -32
      ],
      [
        61,
        0
      ],
      [
        50,
        75
      ],
      [
        12,
        0
      ],
      [
        100,
        -54
      ]
    ],
    [
      [
        106593,
        51243
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -50,
        76
      ],
      [
        13,
        54
      ],
      [
        0,
        22
      ],
      [
        74,
        -11
      ],
      [
        0,
        -87
      ]
    ],
    [
      [
        105553,
        51428
      ],
      [
        0,
        -44
      ],
      [
        -38,
        -10
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -55
      ],
      [
        -62,
        22
      ],
      [
        -49,
        11
      ],
      [
        -13,
        11
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -49,
        -54
      ],
      [
        0,
        65
      ],
      [
        12,
        43
      ],
      [
        50,
        98
      ],
      [
        37,
        -22
      ],
      [
        49,
        -11
      ],
      [
        50,
        22
      ],
      [
        37,
        43
      ],
      [
        50,
        22
      ],
      [
        37,
        -54
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        105763,
        51450
      ],
      [
        -25,
        -11
      ],
      [
        13,
        43
      ],
      [
        0,
        43
      ],
      [
        37,
        -10
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -32
      ]
    ],
    [
      [
        109591,
        51048
      ],
      [
        -87,
        -86
      ],
      [
        -111,
        21
      ],
      [
        -38,
        0
      ],
      [
        -62,
        -21
      ],
      [
        -12,
        10
      ],
      [
        12,
        76
      ],
      [
        50,
        206
      ],
      [
        62,
        185
      ],
      [
        25,
        43
      ],
      [
        37,
        54
      ],
      [
        37,
        33
      ],
      [
        87,
        32
      ],
      [
        74,
        0
      ],
      [
        50,
        -76
      ],
      [
        24,
        -54
      ],
      [
        0,
        -65
      ],
      [
        -24,
        -119
      ],
      [
        -38,
        -109
      ],
      [
        -61,
        -86
      ],
      [
        -25,
        -44
      ]
    ],
    [
      [
        107113,
        51222
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -25,
        0
      ],
      [
        0,
        43
      ],
      [
        -12,
        33
      ],
      [
        12,
        54
      ],
      [
        0,
        65
      ],
      [
        25,
        0
      ],
      [
        0,
        43
      ],
      [
        25,
        87
      ],
      [
        24,
        33
      ],
      [
        25,
        54
      ],
      [
        12,
        11
      ],
      [
        13,
        43
      ],
      [
        12,
        11
      ],
      [
        0,
        43
      ],
      [
        37,
        33
      ],
      [
        25,
        -22
      ],
      [
        13,
        -32
      ],
      [
        -38,
        -44
      ],
      [
        25,
        -108
      ],
      [
        -25,
        -119
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -54
      ],
      [
        -13,
        -44
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        107336,
        51710
      ],
      [
        -12,
        -22
      ],
      [
        -12,
        11
      ],
      [
        -13,
        33
      ],
      [
        -25,
        10
      ],
      [
        38,
        33
      ],
      [
        24,
        -65
      ]
    ],
    [
      [
        101291,
        51753
      ],
      [
        -12,
        -21
      ],
      [
        -13,
        10
      ],
      [
        -12,
        44
      ],
      [
        12,
        11
      ],
      [
        13,
        -11
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        106197,
        51732
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        32
      ],
      [
        12,
        44
      ],
      [
        25,
        11
      ],
      [
        13,
        -22
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        103484,
        51764
      ],
      [
        -50,
        0
      ],
      [
        0,
        65
      ],
      [
        50,
        -32
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        101093,
        51775
      ],
      [
        0,
        -11
      ],
      [
        -62,
        11
      ],
      [
        -37,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -111,
        0
      ],
      [
        -13,
        -11
      ],
      [
        -124,
        54
      ],
      [
        -12,
        44
      ],
      [
        12,
        43
      ],
      [
        38,
        65
      ],
      [
        62,
        11
      ],
      [
        322,
        0
      ],
      [
        24,
        -54
      ],
      [
        13,
        -11
      ],
      [
        -75,
        -44
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        101626,
        51862
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        22
      ],
      [
        0,
        32
      ],
      [
        12,
        22
      ],
      [
        37,
        11
      ],
      [
        25,
        0
      ],
      [
        37,
        -33
      ],
      [
        0,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        108265,
        52003
      ],
      [
        -12,
        -11
      ],
      [
        -12,
        11
      ],
      [
        0,
        21
      ],
      [
        24,
        55
      ],
      [
        13,
        0
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -43
      ]
    ],
    [
      [
        98132,
        52068
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        11
      ],
      [
        0,
        11
      ],
      [
        25,
        43
      ],
      [
        25,
        22
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -43
      ]
    ],
    [
      [
        108278,
        52122
      ],
      [
        -25,
        0
      ],
      [
        -12,
        43
      ],
      [
        24,
        11
      ],
      [
        13,
        -22
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        108216,
        52187
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -44
      ],
      [
        -37,
        -54
      ],
      [
        -12,
        -87
      ],
      [
        -13,
        -21
      ],
      [
        -49,
        -44
      ],
      [
        -37,
        54
      ],
      [
        -13,
        33
      ],
      [
        25,
        195
      ],
      [
        0,
        174
      ],
      [
        25,
        11
      ],
      [
        12,
        -33
      ],
      [
        62,
        -108
      ],
      [
        50,
        -33
      ]
    ],
    [
      [
        98863,
        52458
      ],
      [
        38,
        -65
      ],
      [
        37,
        -43
      ],
      [
        24,
        -22
      ],
      [
        38,
        0
      ],
      [
        37,
        -11
      ],
      [
        49,
        -22
      ],
      [
        62,
        -10
      ],
      [
        25,
        10
      ],
      [
        25,
        -10
      ],
      [
        25,
        -55
      ],
      [
        37,
        -54
      ],
      [
        12,
        -32
      ],
      [
        13,
        -130
      ],
      [
        37,
        -44
      ],
      [
        24,
        -11
      ],
      [
        87,
        0
      ],
      [
        99,
        -32
      ],
      [
        37,
        0
      ],
      [
        25,
        32
      ],
      [
        37,
        -21
      ],
      [
        75,
        -33
      ],
      [
        37,
        -11
      ],
      [
        49,
        11
      ],
      [
        50,
        0
      ],
      [
        12,
        -11
      ],
      [
        50,
        -21
      ],
      [
        12,
        0
      ],
      [
        37,
        32
      ],
      [
        13,
        54
      ],
      [
        25,
        76
      ],
      [
        12,
        76
      ],
      [
        12,
        33
      ],
      [
        25,
        43
      ],
      [
        13,
        11
      ],
      [
        49,
        0
      ],
      [
        12,
        -22
      ],
      [
        50,
        -130
      ],
      [
        12,
        -11
      ],
      [
        62,
        -11
      ],
      [
        38,
        33
      ],
      [
        24,
        0
      ],
      [
        37,
        -33
      ],
      [
        13,
        -21
      ],
      [
        25,
        -22
      ],
      [
        86,
        -22
      ],
      [
        25,
        -54
      ],
      [
        124,
        0
      ],
      [
        37,
        -22
      ],
      [
        25,
        -151
      ],
      [
        12,
        -33
      ],
      [
        37,
        -22
      ],
      [
        13,
        -21
      ],
      [
        0,
        -163
      ],
      [
        74,
        -65
      ],
      [
        74,
        -33
      ],
      [
        87,
        -11
      ],
      [
        136,
        33
      ],
      [
        50,
        33
      ],
      [
        12,
        0
      ],
      [
        112,
        -87
      ],
      [
        12,
        -22
      ],
      [
        13,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -163
      ],
      [
        0,
        -86
      ],
      [
        25,
        -98
      ],
      [
        49,
        -76
      ],
      [
        0,
        -54
      ],
      [
        -49,
        21
      ],
      [
        -25,
        22
      ],
      [
        -13,
        33
      ],
      [
        -24,
        21
      ],
      [
        -37,
        -10
      ],
      [
        -75,
        43
      ],
      [
        -86,
        54
      ],
      [
        -149,
        119
      ],
      [
        -50,
        0
      ],
      [
        -74,
        -43
      ],
      [
        -74,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -75,
        32
      ],
      [
        -87,
        22
      ],
      [
        -210,
        11
      ],
      [
        -62,
        21
      ],
      [
        -173,
        44
      ],
      [
        -75,
        32
      ],
      [
        -198,
        163
      ],
      [
        -62,
        32
      ],
      [
        -198,
        87
      ],
      [
        -99,
        0
      ],
      [
        -50,
        22
      ],
      [
        -37,
        0
      ],
      [
        -49,
        -33
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        0
      ],
      [
        -149,
        43
      ],
      [
        -37,
        22
      ],
      [
        -37,
        33
      ],
      [
        -25,
        43
      ],
      [
        -25,
        22
      ],
      [
        -86,
        43
      ],
      [
        -223,
        33
      ],
      [
        -38,
        11
      ],
      [
        -24,
        21
      ],
      [
        -13,
        33
      ],
      [
        0,
        43
      ],
      [
        25,
        87
      ],
      [
        12,
        32
      ],
      [
        -111,
        76
      ],
      [
        -87,
        44
      ],
      [
        -37,
        11
      ],
      [
        -37,
        0
      ],
      [
        -50,
        -11
      ],
      [
        -62,
        21
      ],
      [
        -24,
        0
      ],
      [
        -13,
        -10
      ],
      [
        -25,
        10
      ],
      [
        0,
        33
      ],
      [
        13,
        33
      ],
      [
        25,
        32
      ],
      [
        12,
        0
      ],
      [
        0,
        -54
      ],
      [
        25,
        -22
      ],
      [
        12,
        11
      ],
      [
        37,
        65
      ],
      [
        0,
        33
      ],
      [
        25,
        97
      ],
      [
        13,
        -22
      ],
      [
        24,
        22
      ],
      [
        25,
        217
      ],
      [
        25,
        65
      ],
      [
        37,
        44
      ],
      [
        12,
        21
      ],
      [
        38,
        -32
      ],
      [
        62,
        -11
      ],
      [
        37,
        -22
      ],
      [
        74,
        -22
      ],
      [
        50,
        -32
      ],
      [
        24,
        0
      ],
      [
        13,
        11
      ],
      [
        24,
        43
      ],
      [
        13,
        65
      ],
      [
        37,
        -32
      ],
      [
        62,
        -11
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        104611,
        52480
      ],
      [
        -12,
        -33
      ],
      [
        -13,
        44
      ],
      [
        -12,
        11
      ],
      [
        0,
        43
      ],
      [
        25,
        -22
      ],
      [
        12,
        -43
      ]
    ],
    [
      [
        103397,
        52285
      ],
      [
        -12,
        -109
      ],
      [
        -13,
        33
      ],
      [
        0,
        97
      ],
      [
        -12,
        44
      ],
      [
        12,
        54
      ],
      [
        -12,
        141
      ],
      [
        12,
        65
      ],
      [
        25,
        -87
      ],
      [
        0,
        -238
      ]
    ],
    [
      [
        100709,
        52588
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        0
      ],
      [
        -12,
        21
      ],
      [
        24,
        44
      ],
      [
        25,
        -11
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        107621,
        52556
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        21
      ],
      [
        -12,
        0
      ],
      [
        0,
        109
      ],
      [
        -13,
        76
      ],
      [
        25,
        0
      ],
      [
        0,
        -22
      ],
      [
        12,
        -11
      ],
      [
        25,
        -76
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        108290,
        52653
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -44
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -32
      ],
      [
        12,
        -66
      ],
      [
        0,
        -97
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -11
      ],
      [
        -74,
        11
      ],
      [
        -62,
        109
      ],
      [
        -25,
        54
      ],
      [
        -12,
        11
      ],
      [
        0,
        32
      ],
      [
        49,
        0
      ],
      [
        0,
        22
      ],
      [
        12,
        87
      ],
      [
        -37,
        54
      ],
      [
        0,
        32
      ],
      [
        13,
        11
      ],
      [
        24,
        -21
      ],
      [
        50,
        97
      ],
      [
        0,
        22
      ],
      [
        12,
        54
      ],
      [
        25,
        11
      ],
      [
        13,
        -11
      ],
      [
        12,
        -32
      ],
      [
        0,
        -55
      ],
      [
        12,
        -11
      ],
      [
        25,
        -65
      ]
    ],
    [
      [
        107658,
        52523
      ],
      [
        0,
        141
      ],
      [
        25,
        44
      ],
      [
        37,
        184
      ],
      [
        13,
        0
      ],
      [
        12,
        -22
      ],
      [
        -25,
        -141
      ],
      [
        -49,
        -97
      ],
      [
        -13,
        -109
      ]
    ],
    [
      [
        97142,
        52794
      ],
      [
        -25,
        -10
      ],
      [
        -62,
        108
      ],
      [
        12,
        22
      ],
      [
        25,
        0
      ],
      [
        50,
        -55
      ],
      [
        12,
        -21
      ],
      [
        -12,
        -44
      ]
    ],
    [
      [
        104462,
        52925
      ],
      [
        0,
        -66
      ],
      [
        -12,
        0
      ],
      [
        -25,
        44
      ],
      [
        0,
        22
      ],
      [
        13,
        10
      ],
      [
        24,
        -10
      ]
    ],
    [
      [
        103917,
        52816
      ],
      [
        -24,
        -11
      ],
      [
        -38,
        65
      ],
      [
        -24,
        65
      ],
      [
        24,
        55
      ],
      [
        0,
        43
      ],
      [
        13,
        11
      ],
      [
        25,
        0
      ],
      [
        12,
        -44
      ],
      [
        12,
        -10
      ],
      [
        0,
        -174
      ]
    ],
    [
      [
        104116,
        52925
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -37,
        32
      ],
      [
        0,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -12,
        43
      ],
      [
        24,
        108
      ],
      [
        25,
        44
      ],
      [
        -12,
        43
      ],
      [
        -13,
        98
      ],
      [
        13,
        54
      ],
      [
        49,
        33
      ],
      [
        62,
        54
      ],
      [
        13,
        -33
      ],
      [
        12,
        -162
      ],
      [
        -49,
        -131
      ],
      [
        0,
        -75
      ]
    ],
    [
      [
        104301,
        53369
      ],
      [
        13,
        -130
      ],
      [
        -25,
        11
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -55
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -130
      ],
      [
        25,
        11
      ],
      [
        25,
        -44
      ],
      [
        25,
        -21
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        22
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        22
      ],
      [
        -13,
        -22
      ],
      [
        -24,
        0
      ],
      [
        -13,
        76
      ],
      [
        0,
        33
      ],
      [
        13,
        43
      ],
      [
        0,
        22
      ],
      [
        12,
        32
      ],
      [
        25,
        44
      ],
      [
        12,
        32
      ],
      [
        0,
        22
      ],
      [
        13,
        76
      ],
      [
        0,
        76
      ],
      [
        12,
        65
      ],
      [
        0,
        130
      ],
      [
        37,
        108
      ],
      [
        37,
        44
      ],
      [
        0,
        -33
      ],
      [
        37,
        -76
      ]
    ],
    [
      [
        107881,
        53564
      ],
      [
        -24,
        -10
      ],
      [
        -62,
        54
      ],
      [
        0,
        43
      ],
      [
        49,
        -65
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        104326,
        53640
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        11
      ],
      [
        -25,
        44
      ],
      [
        0,
        54
      ],
      [
        -12,
        22
      ],
      [
        25,
        32
      ],
      [
        62,
        -11
      ],
      [
        12,
        -21
      ],
      [
        0,
        -55
      ]
    ],
    [
      [
        106159,
        53976
      ],
      [
        -61,
        -32
      ],
      [
        12,
        54
      ],
      [
        12,
        22
      ],
      [
        25,
        -22
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        106060,
        53922
      ],
      [
        -24,
        -43
      ],
      [
        -13,
        22
      ],
      [
        -25,
        10
      ],
      [
        -37,
        -54
      ],
      [
        -24,
        22
      ],
      [
        0,
        32
      ],
      [
        37,
        55
      ],
      [
        37,
        10
      ],
      [
        49,
        44
      ],
      [
        13,
        0
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        106209,
        53998
      ],
      [
        0,
        -32
      ],
      [
        -37,
        10
      ],
      [
        -13,
        44
      ],
      [
        13,
        11
      ],
      [
        25,
        -11
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        101985,
        54052
      ],
      [
        -12,
        -108
      ],
      [
        -25,
        54
      ],
      [
        25,
        76
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        105825,
        54139
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        33
      ],
      [
        25,
        22
      ],
      [
        12,
        -44
      ]
    ],
    [
      [
        101935,
        53792
      ],
      [
        -74,
        -108
      ],
      [
        0,
        141
      ],
      [
        -25,
        76
      ],
      [
        13,
        54
      ],
      [
        12,
        97
      ],
      [
        12,
        76
      ],
      [
        50,
        55
      ],
      [
        0,
        -87
      ],
      [
        12,
        -33
      ],
      [
        0,
        -173
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        105577,
        54280
      ],
      [
        50,
        -43
      ],
      [
        25,
        -65
      ],
      [
        24,
        -44
      ],
      [
        25,
        -32
      ],
      [
        0,
        -152
      ],
      [
        -49,
        -22
      ],
      [
        -50,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        0
      ],
      [
        -38,
        -21
      ],
      [
        -49,
        32
      ],
      [
        -50,
        44
      ],
      [
        -74,
        75
      ],
      [
        -12,
        33
      ],
      [
        -38,
        65
      ],
      [
        0,
        43
      ],
      [
        -12,
        120
      ],
      [
        25,
        32
      ],
      [
        49,
        -21
      ],
      [
        25,
        32
      ],
      [
        87,
        22
      ],
      [
        87,
        0
      ],
      [
        24,
        -22
      ]
    ],
    [
      [
        105961,
        54378
      ],
      [
        -24,
        -54
      ],
      [
        -25,
        10
      ],
      [
        25,
        33
      ],
      [
        24,
        11
      ]
    ],
    [
      [
        98702,
        54334
      ],
      [
        -12,
        -10
      ],
      [
        -25,
        21
      ],
      [
        -12,
        33
      ],
      [
        12,
        21
      ],
      [
        37,
        -21
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        98901,
        54399
      ],
      [
        -13,
        -10
      ],
      [
        -12,
        10
      ],
      [
        0,
        22
      ],
      [
        12,
        22
      ],
      [
        25,
        -11
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        106568,
        54421
      ],
      [
        75,
        -65
      ],
      [
        49,
        -11
      ],
      [
        62,
        11
      ],
      [
        25,
        -11
      ],
      [
        74,
        -87
      ],
      [
        13,
        -65
      ],
      [
        12,
        -43
      ],
      [
        0,
        -54
      ],
      [
        37,
        -22
      ],
      [
        25,
        -65
      ],
      [
        12,
        -22
      ],
      [
        -24,
        -184
      ],
      [
        -75,
        65
      ],
      [
        -74,
        76
      ],
      [
        -37,
        32
      ],
      [
        -87,
        66
      ],
      [
        -25,
        54
      ],
      [
        -37,
        43
      ],
      [
        -111,
        0
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -22
      ],
      [
        -49,
        33
      ],
      [
        -38,
        11
      ],
      [
        -37,
        21
      ],
      [
        -49,
        22
      ],
      [
        0,
        54
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -21
      ],
      [
        -50,
        -98
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -12,
        22
      ],
      [
        -50,
        108
      ],
      [
        -12,
        22
      ],
      [
        -25,
        22
      ],
      [
        -37,
        -11
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -43
      ],
      [
        -13,
        11
      ],
      [
        13,
        65
      ],
      [
        0,
        32
      ],
      [
        -13,
        33
      ],
      [
        0,
        43
      ],
      [
        74,
        174
      ],
      [
        38,
        43
      ],
      [
        123,
        22
      ],
      [
        75,
        -11
      ],
      [
        37,
        0
      ],
      [
        37,
        11
      ],
      [
        25,
        0
      ],
      [
        0,
        -33
      ],
      [
        12,
        -32
      ],
      [
        25,
        0
      ],
      [
        37,
        32
      ],
      [
        25,
        44
      ],
      [
        25,
        21
      ],
      [
        37,
        0
      ],
      [
        25,
        -10
      ],
      [
        49,
        -44
      ]
    ],
    [
      [
        96473,
        54226
      ],
      [
        12,
        -87
      ],
      [
        -37,
        54
      ],
      [
        0,
        76
      ],
      [
        -25,
        33
      ],
      [
        -25,
        43
      ],
      [
        -12,
        109
      ],
      [
        12,
        21
      ],
      [
        13,
        0
      ],
      [
        86,
        -162
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        99148,
        54345
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        -55
      ],
      [
        -25,
        11
      ],
      [
        0,
        33
      ],
      [
        -37,
        54
      ],
      [
        -13,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -62,
        -22
      ],
      [
        0,
        43
      ],
      [
        -24,
        44
      ],
      [
        0,
        87
      ],
      [
        12,
        32
      ],
      [
        0,
        44
      ],
      [
        12,
        43
      ],
      [
        0,
        98
      ],
      [
        62,
        32
      ],
      [
        13,
        -22
      ],
      [
        74,
        -21
      ],
      [
        50,
        -65
      ],
      [
        24,
        -87
      ],
      [
        -37,
        -98
      ]
    ],
    [
      [
        96398,
        54497
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        0
      ],
      [
        -12,
        32
      ],
      [
        0,
        152
      ],
      [
        12,
        11
      ],
      [
        62,
        -109
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        108154,
        54887
      ],
      [
        -13,
        22
      ],
      [
        13,
        33
      ],
      [
        12,
        0
      ],
      [
        -12,
        -55
      ]
    ],
    [
      [
        96274,
        54746
      ],
      [
        0,
        -10
      ],
      [
        -49,
        54
      ],
      [
        -25,
        11
      ],
      [
        -25,
        65
      ],
      [
        0,
        65
      ],
      [
        13,
        22
      ],
      [
        12,
        0
      ],
      [
        25,
        -33
      ],
      [
        12,
        -65
      ],
      [
        25,
        -65
      ],
      [
        12,
        -44
      ]
    ],
    [
      [
        105292,
        54681
      ],
      [
        -24,
        22
      ],
      [
        -13,
        98
      ],
      [
        -12,
        21
      ],
      [
        -13,
        98
      ],
      [
        0,
        22
      ],
      [
        25,
        43
      ],
      [
        13,
        -11
      ],
      [
        0,
        -119
      ],
      [
        24,
        -119
      ],
      [
        0,
        -55
      ]
    ],
    [
      [
        104537,
        54996
      ],
      [
        0,
        -33
      ],
      [
        -13,
        0
      ],
      [
        -12,
        55
      ],
      [
        25,
        -22
      ]
    ],
    [
      [
        105280,
        55094
      ],
      [
        111,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        -124,
        -32
      ],
      [
        -37,
        10
      ],
      [
        -124,
        -21
      ],
      [
        -12,
        0
      ],
      [
        0,
        32
      ],
      [
        -13,
        22
      ],
      [
        13,
        22
      ],
      [
        25,
        11
      ],
      [
        74,
        -11
      ],
      [
        99,
        11
      ]
    ],
    [
      [
        104301,
        55083
      ],
      [
        -24,
        -55
      ],
      [
        -13,
        22
      ],
      [
        13,
        44
      ],
      [
        12,
        10
      ],
      [
        12,
        -21
      ]
    ],
    [
      [
        106779,
        55159
      ],
      [
        0,
        -33
      ],
      [
        25,
        -43
      ],
      [
        -13,
        -55
      ],
      [
        -12,
        0
      ],
      [
        12,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        22
      ],
      [
        -62,
        32
      ],
      [
        -50,
        54
      ],
      [
        -12,
        22
      ],
      [
        99,
        65
      ],
      [
        37,
        22
      ],
      [
        25,
        0
      ],
      [
        49,
        22
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        104921,
        55148
      ],
      [
        37,
        -22
      ],
      [
        12,
        0
      ],
      [
        0,
        22
      ],
      [
        13,
        11
      ],
      [
        12,
        -11
      ],
      [
        0,
        -44
      ],
      [
        25,
        0
      ],
      [
        25,
        -21
      ],
      [
        0,
        -44
      ],
      [
        -62,
        -11
      ],
      [
        -50,
        -32
      ],
      [
        -62,
        32
      ],
      [
        -62,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -37,
        87
      ],
      [
        25,
        109
      ],
      [
        12,
        21
      ],
      [
        25,
        11
      ],
      [
        62,
        0
      ],
      [
        99,
        -43
      ]
    ],
    [
      [
        108538,
        55224
      ],
      [
        136,
        -33
      ],
      [
        37,
        0
      ],
      [
        75,
        -11
      ],
      [
        62,
        -43
      ],
      [
        111,
        -11
      ],
      [
        37,
        -11
      ],
      [
        25,
        -21
      ],
      [
        -62,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -62,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        22
      ],
      [
        -50,
        22
      ],
      [
        -62,
        43
      ],
      [
        -136,
        54
      ],
      [
        0,
        55
      ]
    ],
    [
      [
        99408,
        55202
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        55
      ],
      [
        25,
        21
      ],
      [
        24,
        -21
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        98405,
        55169
      ],
      [
        12,
        -43
      ],
      [
        25,
        -32
      ],
      [
        13,
        -44
      ],
      [
        12,
        -206
      ],
      [
        50,
        -173
      ],
      [
        161,
        -65
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -120
      ],
      [
        0,
        -32
      ],
      [
        25,
        -87
      ],
      [
        -25,
        0
      ],
      [
        -25,
        11
      ],
      [
        -24,
        43
      ],
      [
        -25,
        11
      ],
      [
        -50,
        54
      ],
      [
        -37,
        22
      ],
      [
        -49,
        22
      ],
      [
        -25,
        43
      ],
      [
        0,
        184
      ],
      [
        -25,
        22
      ],
      [
        -12,
        65
      ],
      [
        -13,
        87
      ],
      [
        -24,
        22
      ],
      [
        -38,
        21
      ],
      [
        -12,
        22
      ],
      [
        -74,
        -33
      ],
      [
        -38,
        33
      ],
      [
        -37,
        22
      ],
      [
        0,
        43
      ],
      [
        25,
        33
      ],
      [
        37,
        32
      ],
      [
        25,
        33
      ],
      [
        0,
        32
      ],
      [
        -12,
        33
      ],
      [
        24,
        65
      ],
      [
        13,
        22
      ],
      [
        49,
        21
      ],
      [
        25,
        -87
      ],
      [
        13,
        -32
      ],
      [
        12,
        43
      ],
      [
        -12,
        76
      ],
      [
        37,
        22
      ],
      [
        37,
        0
      ],
      [
        25,
        -22
      ],
      [
        12,
        -32
      ],
      [
        0,
        -55
      ]
    ],
    [
      [
        104450,
        55148
      ],
      [
        -25,
        0
      ],
      [
        -12,
        11
      ],
      [
        0,
        97
      ],
      [
        12,
        22
      ],
      [
        13,
        -11
      ],
      [
        0,
        -43
      ],
      [
        12,
        -22
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        106011,
        55180
      ],
      [
        -13,
        -32
      ],
      [
        -61,
        11
      ],
      [
        -62,
        0
      ],
      [
        -62,
        -22
      ],
      [
        -38,
        22
      ],
      [
        -24,
        32
      ],
      [
        0,
        33
      ],
      [
        24,
        86
      ],
      [
        50,
        55
      ],
      [
        12,
        21
      ],
      [
        38,
        -21
      ],
      [
        62,
        -55
      ],
      [
        37,
        -54
      ],
      [
        37,
        -43
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        104314,
        55484
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        12,
        -65
      ],
      [
        37,
        87
      ],
      [
        25,
        11
      ],
      [
        25,
        -11
      ],
      [
        25,
        -54
      ],
      [
        -13,
        -66
      ],
      [
        -25,
        -32
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        43
      ],
      [
        -12,
        11
      ],
      [
        -13,
        -97
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        22
      ],
      [
        0,
        21
      ],
      [
        12,
        33
      ],
      [
        0,
        119
      ],
      [
        -24,
        -21
      ],
      [
        -38,
        -109
      ],
      [
        -37,
        -43
      ],
      [
        -12,
        21
      ],
      [
        -12,
        76
      ],
      [
        12,
        87
      ],
      [
        25,
        65
      ],
      [
        24,
        0
      ],
      [
        62,
        22
      ],
      [
        13,
        -11
      ]
    ],
    [
      [
        99669,
        55473
      ],
      [
        -62,
        -65
      ],
      [
        -25,
        11
      ],
      [
        -13,
        22
      ],
      [
        13,
        119
      ],
      [
        12,
        43
      ],
      [
        50,
        0
      ],
      [
        25,
        -21
      ],
      [
        24,
        -55
      ],
      [
        -24,
        -54
      ]
    ],
    [
      [
        108364,
        55516
      ],
      [
        -24,
        -10
      ],
      [
        -13,
        10
      ],
      [
        -24,
        55
      ],
      [
        12,
        32
      ],
      [
        25,
        22
      ],
      [
        12,
        -22
      ],
      [
        0,
        -32
      ],
      [
        25,
        0
      ],
      [
        -13,
        -55
      ]
    ],
    [
      [
        96039,
        55104
      ],
      [
        -25,
        0
      ],
      [
        -74,
        65
      ],
      [
        -12,
        44
      ],
      [
        0,
        43
      ],
      [
        -75,
        174
      ],
      [
        0,
        32
      ],
      [
        25,
        141
      ],
      [
        62,
        44
      ],
      [
        25,
        -33
      ],
      [
        0,
        -65
      ],
      [
        49,
        -108
      ],
      [
        13,
        -65
      ],
      [
        0,
        -22
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        37,
        -75
      ],
      [
        12,
        -33
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -22
      ]
    ],
    [
      [
        107002,
        55397
      ],
      [
        -13,
        -21
      ],
      [
        -49,
        10
      ],
      [
        -25,
        44
      ],
      [
        -12,
        54
      ],
      [
        0,
        43
      ],
      [
        -25,
        76
      ],
      [
        0,
        11
      ],
      [
        87,
        43
      ],
      [
        37,
        -21
      ],
      [
        25,
        -22
      ],
      [
        -13,
        -141
      ],
      [
        -12,
        -76
      ]
    ],
    [
      [
        106965,
        55733
      ],
      [
        -25,
        -54
      ],
      [
        -149,
        -43
      ],
      [
        13,
        21
      ],
      [
        0,
        22
      ],
      [
        12,
        11
      ],
      [
        50,
        22
      ],
      [
        37,
        -11
      ],
      [
        25,
        0
      ],
      [
        0,
        32
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        108501,
        55809
      ],
      [
        74,
        -21
      ],
      [
        25,
        0
      ],
      [
        25,
        -33
      ],
      [
        37,
        11
      ],
      [
        12,
        -11
      ],
      [
        62,
        -87
      ],
      [
        37,
        -65
      ],
      [
        37,
        -54
      ],
      [
        38,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -37,
        33
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        43
      ],
      [
        0,
        55
      ],
      [
        -37,
        130
      ],
      [
        -25,
        -44
      ],
      [
        -50,
        66
      ],
      [
        -12,
        0
      ],
      [
        -37,
        54
      ],
      [
        0,
        32
      ]
    ],
    [
      [
        105726,
        55723
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        21
      ],
      [
        -13,
        0
      ],
      [
        13,
        98
      ],
      [
        25,
        -11
      ],
      [
        12,
        -76
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        106866,
        55885
      ],
      [
        -13,
        0
      ],
      [
        -37,
        22
      ],
      [
        12,
        22
      ],
      [
        25,
        21
      ],
      [
        25,
        -11
      ],
      [
        12,
        -21
      ],
      [
        -24,
        -33
      ]
    ],
    [
      [
        103855,
        55961
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        -12,
        11
      ],
      [
        -37,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -13,
        0
      ],
      [
        0,
        33
      ],
      [
        37,
        43
      ],
      [
        13,
        -11
      ],
      [
        24,
        11
      ]
    ],
    [
      [
        110433,
        54584
      ],
      [
        0,
        -499
      ],
      [
        0,
        -260
      ],
      [
        0,
        -250
      ],
      [
        0,
        -260
      ],
      [
        0,
        -250
      ],
      [
        0,
        -379
      ],
      [
        0,
        -434
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -108
      ],
      [
        -12,
        -76
      ],
      [
        24,
        -65
      ],
      [
        25,
        -33
      ],
      [
        0,
        -488
      ],
      [
        0,
        -260
      ],
      [
        0,
        -250
      ],
      [
        0,
        -390
      ]
    ],
    [
      [
        110433,
        50517
      ],
      [
        -25,
        22
      ],
      [
        -49,
        65
      ],
      [
        -37,
        86
      ],
      [
        -25,
        76
      ],
      [
        -37,
        65
      ],
      [
        -137,
        196
      ],
      [
        -49,
        130
      ],
      [
        -99,
        -22
      ],
      [
        -50,
        -22
      ],
      [
        -49,
        -10
      ],
      [
        -37,
        43
      ],
      [
        0,
        87
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -44
      ],
      [
        -50,
        -76
      ],
      [
        -25,
        44
      ],
      [
        0,
        32
      ],
      [
        13,
        33
      ],
      [
        0,
        32
      ],
      [
        12,
        87
      ],
      [
        25,
        43
      ],
      [
        12,
        87
      ],
      [
        13,
        33
      ],
      [
        0,
        32
      ],
      [
        -13,
        44
      ],
      [
        -25,
        10
      ],
      [
        -12,
        22
      ],
      [
        -12,
        65
      ],
      [
        -13,
        22
      ],
      [
        -25,
        22
      ],
      [
        -12,
        32
      ],
      [
        12,
        22
      ],
      [
        25,
        11
      ],
      [
        -12,
        32
      ],
      [
        -37,
        44
      ],
      [
        -37,
        86
      ],
      [
        0,
        11
      ],
      [
        24,
        22
      ],
      [
        62,
        11
      ],
      [
        -49,
        87
      ],
      [
        -13,
        65
      ],
      [
        -12,
        32
      ],
      [
        -50,
        76
      ],
      [
        -24,
        65
      ],
      [
        -25,
        141
      ],
      [
        -25,
        109
      ],
      [
        25,
        65
      ],
      [
        -25,
        0
      ],
      [
        -37,
        21
      ],
      [
        25,
        55
      ],
      [
        0,
        21
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        0
      ],
      [
        0,
        162
      ],
      [
        -25,
        22
      ],
      [
        -25,
        32
      ],
      [
        -25,
        11
      ],
      [
        -24,
        22
      ],
      [
        -13,
        43
      ],
      [
        -148,
        141
      ],
      [
        -13,
        44
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        22
      ],
      [
        -13,
        21
      ],
      [
        -24,
        -10
      ],
      [
        -25,
        21
      ],
      [
        -37,
        0
      ],
      [
        -75,
        54
      ],
      [
        -86,
        76
      ],
      [
        -62,
        22
      ],
      [
        -38,
        43
      ],
      [
        -37,
        33
      ],
      [
        -86,
        33
      ],
      [
        -100,
        21
      ],
      [
        -86,
        0
      ],
      [
        -149,
        163
      ],
      [
        -25,
        65
      ],
      [
        0,
        87
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -50,
        43
      ],
      [
        -49,
        -21
      ],
      [
        -25,
        32
      ],
      [
        0,
        44
      ],
      [
        -12,
        21
      ],
      [
        -38,
        -21
      ],
      [
        -24,
        0
      ],
      [
        -25,
        65
      ],
      [
        -25,
        43
      ],
      [
        -37,
        43
      ],
      [
        -13,
        66
      ],
      [
        0,
        141
      ],
      [
        38,
        65
      ],
      [
        12,
        54
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -87
      ],
      [
        0,
        -109
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        0
      ],
      [
        12,
        -65
      ],
      [
        -12,
        -65
      ],
      [
        -38,
        -109
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        -108
      ],
      [
        -62,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        33
      ],
      [
        -24,
        21
      ],
      [
        0,
        44
      ],
      [
        -25,
        76
      ],
      [
        -13,
        76
      ],
      [
        38,
        97
      ],
      [
        -13,
        87
      ],
      [
        -25,
        76
      ],
      [
        -62,
        97
      ],
      [
        -74,
        98
      ],
      [
        -37,
        22
      ],
      [
        -62,
        11
      ],
      [
        -25,
        43
      ],
      [
        -12,
        43
      ],
      [
        37,
        11
      ],
      [
        62,
        54
      ],
      [
        25,
        0
      ],
      [
        86,
        -32
      ],
      [
        25,
        -22
      ],
      [
        25,
        -11
      ],
      [
        62,
        76
      ],
      [
        50,
        109
      ],
      [
        24,
        21
      ],
      [
        25,
        11
      ],
      [
        25,
        -11
      ],
      [
        62,
        -43
      ],
      [
        37,
        -11
      ],
      [
        25,
        0
      ],
      [
        12,
        -32
      ],
      [
        25,
        -22
      ],
      [
        0,
        54
      ],
      [
        12,
        54
      ],
      [
        25,
        22
      ],
      [
        12,
        0
      ],
      [
        13,
        22
      ],
      [
        0,
        54
      ],
      [
        -37,
        0
      ],
      [
        24,
        43
      ],
      [
        25,
        55
      ],
      [
        0,
        21
      ],
      [
        -74,
        -54
      ],
      [
        -74,
        -22
      ],
      [
        -50,
        11
      ],
      [
        -50,
        0
      ],
      [
        -86,
        -43
      ],
      [
        -37,
        11
      ],
      [
        -75,
        11
      ],
      [
        -49,
        21
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -37,
        43
      ],
      [
        -38,
        87
      ],
      [
        -24,
        32
      ],
      [
        -13,
        33
      ],
      [
        -12,
        141
      ],
      [
        -12,
        87
      ],
      [
        -62,
        21
      ],
      [
        -149,
        87
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -10
      ],
      [
        -50,
        21
      ],
      [
        13,
        33
      ],
      [
        12,
        54
      ],
      [
        13,
        22
      ],
      [
        24,
        21
      ],
      [
        13,
        33
      ],
      [
        25,
        98
      ],
      [
        0,
        97
      ],
      [
        61,
        44
      ],
      [
        124,
        54
      ],
      [
        25,
        21
      ],
      [
        25,
        55
      ],
      [
        37,
        21
      ],
      [
        25,
        55
      ],
      [
        87,
        65
      ],
      [
        86,
        0
      ],
      [
        75,
        -44
      ],
      [
        74,
        -54
      ],
      [
        136,
        -141
      ],
      [
        136,
        0
      ],
      [
        62,
        -22
      ],
      [
        25,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -65
      ],
      [
        12,
        -65
      ],
      [
        50,
        -130
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -76
      ],
      [
        0,
        -33
      ],
      [
        -24,
        -54
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -76
      ],
      [
        13,
        -76
      ],
      [
        0,
        -141
      ],
      [
        12,
        -76
      ],
      [
        62,
        -195
      ],
      [
        37,
        -130
      ],
      [
        0,
        163
      ],
      [
        12,
        21
      ],
      [
        25,
        22
      ],
      [
        25,
        -54
      ],
      [
        0,
        -76
      ],
      [
        12,
        -141
      ],
      [
        25,
        0
      ],
      [
        25,
        21
      ],
      [
        12,
        -43
      ],
      [
        0,
        -152
      ],
      [
        13,
        -21
      ],
      [
        62,
        -66
      ],
      [
        62,
        -10
      ],
      [
        37,
        0
      ],
      [
        37,
        21
      ],
      [
        25,
        44
      ],
      [
        24,
        54
      ],
      [
        75,
        119
      ],
      [
        25,
        54
      ],
      [
        24,
        87
      ],
      [
        13,
        22
      ],
      [
        74,
        98
      ],
      [
        12,
        32
      ],
      [
        25,
        119
      ],
      [
        13,
        33
      ],
      [
        74,
        32
      ],
      [
        87,
        22
      ],
      [
        74,
        54
      ],
      [
        37,
        55
      ],
      [
        0,
        32
      ],
      [
        -12,
        54
      ],
      [
        0,
        22
      ],
      [
        12,
        22
      ],
      [
        149,
        152
      ],
      [
        74,
        54
      ],
      [
        25,
        0
      ],
      [
        74,
        -87
      ],
      [
        186,
        -108
      ],
      [
        25,
        -33
      ],
      [
        24,
        -43
      ],
      [
        38,
        -33
      ],
      [
        49,
        -11
      ],
      [
        37,
        -32
      ],
      [
        38,
        -44
      ],
      [
        74,
        -65
      ],
      [
        111,
        -87
      ],
      [
        124,
        0
      ],
      [
        25,
        -43
      ],
      [
        25,
        0
      ],
      [
        111,
        -22
      ],
      [
        37,
        -32
      ],
      [
        0,
        -65
      ],
      [
        87,
        0
      ]
    ],
    [
      [
        97872,
        56005
      ],
      [
        25,
        -66
      ],
      [
        13,
        -21
      ],
      [
        -25,
        -76
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        22
      ],
      [
        -13,
        -55
      ],
      [
        -12,
        76
      ],
      [
        -25,
        55
      ],
      [
        12,
        43
      ],
      [
        25,
        -11
      ],
      [
        37,
        44
      ]
    ],
    [
      [
        105813,
        56015
      ],
      [
        37,
        -97
      ],
      [
        -25,
        -87
      ],
      [
        25,
        -43
      ],
      [
        49,
        -11
      ],
      [
        13,
        -11
      ],
      [
        0,
        -22
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        33
      ],
      [
        -13,
        43
      ],
      [
        -49,
        -21
      ],
      [
        -13,
        0
      ],
      [
        0,
        97
      ],
      [
        -24,
        33
      ],
      [
        -25,
        54
      ],
      [
        0,
        33
      ],
      [
        12,
        43
      ],
      [
        -12,
        33
      ],
      [
        25,
        0
      ],
      [
        24,
        -44
      ],
      [
        13,
        44
      ],
      [
        12,
        21
      ],
      [
        13,
        -11
      ]
    ],
    [
      [
        105701,
        55907
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -12,
        65
      ],
      [
        12,
        87
      ],
      [
        25,
        22
      ],
      [
        25,
        -22
      ],
      [
        -13,
        -22
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -65
      ]
    ],
    [
      [
        97612,
        55994
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        22
      ],
      [
        0,
        32
      ],
      [
        24,
        44
      ],
      [
        25,
        0
      ],
      [
        37,
        -33
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -21
      ]
    ],
    [
      [
        106928,
        56211
      ],
      [
        61,
        -22
      ],
      [
        13,
        0
      ],
      [
        87,
        -65
      ],
      [
        12,
        -33
      ],
      [
        0,
        -32
      ],
      [
        12,
        -22
      ],
      [
        -24,
        -54
      ],
      [
        -13,
        0
      ],
      [
        -49,
        22
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -12,
        43
      ],
      [
        -37,
        22
      ],
      [
        -38,
        97
      ],
      [
        -24,
        -11
      ],
      [
        0,
        -32
      ],
      [
        24,
        -22
      ],
      [
        25,
        -65
      ],
      [
        25,
        -11
      ],
      [
        25,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -50,
        -11
      ],
      [
        -25,
        33
      ],
      [
        0,
        54
      ],
      [
        -24,
        -21
      ],
      [
        -13,
        -22
      ],
      [
        -12,
        0
      ],
      [
        -13,
        65
      ],
      [
        -62,
        0
      ],
      [
        -37,
        32
      ],
      [
        25,
        33
      ],
      [
        0,
        33
      ],
      [
        25,
        21
      ],
      [
        25,
        -11
      ],
      [
        24,
        22
      ],
      [
        13,
        -11
      ],
      [
        12,
        22
      ],
      [
        50,
        11
      ],
      [
        25,
        11
      ]
    ],
    [
      [
        95804,
        55885
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        32
      ],
      [
        0,
        33
      ],
      [
        37,
        152
      ],
      [
        -37,
        141
      ],
      [
        13,
        10
      ],
      [
        12,
        -21
      ],
      [
        25,
        -87
      ],
      [
        24,
        -65
      ],
      [
        -24,
        -163
      ]
    ],
    [
      [
        97971,
        56102
      ],
      [
        13,
        -11
      ],
      [
        12,
        33
      ],
      [
        37,
        -65
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        -74,
        65
      ],
      [
        -50,
        -21
      ],
      [
        -37,
        32
      ],
      [
        37,
        130
      ],
      [
        25,
        -21
      ],
      [
        12,
        -33
      ],
      [
        37,
        -65
      ]
    ],
    [
      [
        106494,
        56102
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        44
      ],
      [
        -37,
        32
      ],
      [
        -12,
        76
      ],
      [
        74,
        -119
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        105775,
        56211
      ],
      [
        -24,
        10
      ],
      [
        12,
        66
      ],
      [
        12,
        -33
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        97947,
        56254
      ],
      [
        -13,
        0
      ],
      [
        -24,
        22
      ],
      [
        -38,
        86
      ],
      [
        25,
        -10
      ],
      [
        50,
        -98
      ]
    ],
    [
      [
        97464,
        56558
      ],
      [
        -38,
        -11
      ],
      [
        -12,
        11
      ],
      [
        0,
        54
      ],
      [
        12,
        43
      ],
      [
        13,
        0
      ],
      [
        25,
        -54
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        105763,
        56612
      ],
      [
        -12,
        0
      ],
      [
        0,
        65
      ],
      [
        24,
        0
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        105751,
        56709
      ],
      [
        -13,
        -21
      ],
      [
        -24,
        32
      ],
      [
        12,
        22
      ],
      [
        12,
        0
      ],
      [
        13,
        -33
      ]
    ],
    [
      [
        97513,
        56634
      ],
      [
        -37,
        65
      ],
      [
        12,
        43
      ],
      [
        13,
        11
      ],
      [
        12,
        -22
      ],
      [
        25,
        -65
      ],
      [
        -25,
        -32
      ]
    ],
    [
      [
        97649,
        56709
      ],
      [
        -37,
        22
      ],
      [
        0,
        33
      ],
      [
        13,
        11
      ],
      [
        24,
        -66
      ]
    ],
    [
      [
        97786,
        56731
      ],
      [
        -13,
        -11
      ],
      [
        -37,
        55
      ],
      [
        12,
        21
      ],
      [
        13,
        -21
      ],
      [
        25,
        -11
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        97377,
        56677
      ],
      [
        -13,
        -22
      ],
      [
        -12,
        22
      ],
      [
        -62,
        22
      ],
      [
        -25,
        0
      ],
      [
        -62,
        32
      ],
      [
        -24,
        44
      ],
      [
        0,
        32
      ],
      [
        12,
        22
      ],
      [
        0,
        65
      ],
      [
        12,
        22
      ],
      [
        38,
        -44
      ],
      [
        24,
        -43
      ],
      [
        25,
        -11
      ],
      [
        74,
        -65
      ],
      [
        13,
        -76
      ]
    ],
    [
      [
        97513,
        56872
      ],
      [
        0,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -12,
        43
      ],
      [
        12,
        33
      ],
      [
        13,
        -33
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        97414,
        56753
      ],
      [
        0,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -37,
        65
      ],
      [
        -25,
        33
      ],
      [
        -37,
        21
      ],
      [
        -25,
        0
      ],
      [
        0,
        76
      ],
      [
        25,
        0
      ],
      [
        74,
        -54
      ],
      [
        25,
        -33
      ],
      [
        25,
        -97
      ]
    ],
    [
      [
        97711,
        56948
      ],
      [
        25,
        -22
      ],
      [
        12,
        11
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -65
      ],
      [
        -25,
        21
      ],
      [
        -12,
        22
      ],
      [
        0,
        54
      ],
      [
        24,
        0
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        97910,
        56970
      ],
      [
        0,
        -44
      ],
      [
        24,
        -21
      ],
      [
        0,
        -87
      ],
      [
        -24,
        -65
      ],
      [
        0,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -13,
        22
      ],
      [
        0,
        32
      ],
      [
        -12,
        11
      ],
      [
        0,
        65
      ],
      [
        -50,
        -22
      ],
      [
        -12,
        0
      ],
      [
        -12,
        33
      ],
      [
        12,
        22
      ],
      [
        50,
        54
      ],
      [
        24,
        -11
      ],
      [
        38,
        22
      ]
    ],
    [
      [
        97166,
        56829
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -25,
        86
      ],
      [
        0,
        76
      ],
      [
        -12,
        55
      ],
      [
        12,
        32
      ],
      [
        13,
        0
      ],
      [
        25,
        -32
      ],
      [
        24,
        -55
      ],
      [
        0,
        -21
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        95469,
        57132
      ],
      [
        75,
        -184
      ],
      [
        24,
        -22
      ],
      [
        37,
        -76
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -163
      ],
      [
        -24,
        -33
      ],
      [
        -50,
        22
      ],
      [
        0,
        22
      ],
      [
        -25,
        119
      ],
      [
        -49,
        76
      ],
      [
        -25,
        0
      ],
      [
        -12,
        65
      ],
      [
        -25,
        87
      ],
      [
        -74,
        141
      ],
      [
        62,
        0
      ],
      [
        37,
        65
      ],
      [
        0,
        11
      ],
      [
        49,
        -44
      ]
    ],
    [
      [
        97191,
        57122
      ],
      [
        0,
        -76
      ],
      [
        -25,
        21
      ],
      [
        -24,
        33
      ],
      [
        -25,
        22
      ],
      [
        -37,
        10
      ],
      [
        -38,
        22
      ],
      [
        -12,
        33
      ],
      [
        0,
        43
      ],
      [
        149,
        -76
      ],
      [
        12,
        -32
      ]
    ],
    [
      [
        104896,
        56840
      ],
      [
        -74,
        -109
      ],
      [
        -13,
        -54
      ],
      [
        -25,
        -54
      ],
      [
        -24,
        -65
      ],
      [
        -25,
        -55
      ],
      [
        -50,
        -43
      ],
      [
        -24,
        -11
      ],
      [
        -38,
        0
      ],
      [
        -123,
        -43
      ],
      [
        -38,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -86,
        11
      ],
      [
        -38,
        54
      ],
      [
        -24,
        43
      ],
      [
        -38,
        11
      ],
      [
        -24,
        -11
      ],
      [
        -223,
        0
      ],
      [
        -75,
        -11
      ],
      [
        -74,
        -21
      ],
      [
        -37,
        11
      ],
      [
        -37,
        21
      ],
      [
        -37,
        11
      ],
      [
        -25,
        0
      ],
      [
        -149,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -74,
        43
      ],
      [
        -37,
        11
      ],
      [
        -38,
        -11
      ],
      [
        -37,
        -43
      ],
      [
        -62,
        -109
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -76
      ],
      [
        -12,
        -87
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -65
      ],
      [
        25,
        -162
      ],
      [
        12,
        -55
      ],
      [
        50,
        -141
      ],
      [
        0,
        -11
      ],
      [
        62,
        -43
      ],
      [
        25,
        -54
      ],
      [
        37,
        -130
      ],
      [
        25,
        -76
      ],
      [
        37,
        11
      ],
      [
        37,
        -11
      ],
      [
        50,
        -22
      ],
      [
        37,
        44
      ],
      [
        24,
        75
      ],
      [
        13,
        65
      ],
      [
        62,
        109
      ],
      [
        25,
        54
      ],
      [
        24,
        22
      ],
      [
        38,
        -44
      ],
      [
        12,
        -21
      ],
      [
        37,
        -11
      ],
      [
        50,
        11
      ],
      [
        37,
        32
      ],
      [
        25,
        55
      ],
      [
        37,
        21
      ],
      [
        86,
        0
      ],
      [
        50,
        -11
      ],
      [
        74,
        11
      ],
      [
        0,
        22
      ],
      [
        -12,
        32
      ],
      [
        62,
        44
      ],
      [
        49,
        11
      ],
      [
        38,
        -11
      ],
      [
        37,
        -33
      ],
      [
        12,
        -32
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -109
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        21
      ],
      [
        -25,
        55
      ],
      [
        -37,
        21
      ],
      [
        -74,
        -32
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        -130
      ],
      [
        -50,
        -108
      ],
      [
        -62,
        -98
      ],
      [
        -24,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -100,
        -54
      ],
      [
        -37,
        -44
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -24,
        11
      ],
      [
        -38,
        33
      ],
      [
        -24,
        -76
      ],
      [
        24,
        -11
      ],
      [
        38,
        -43
      ],
      [
        24,
        -76
      ],
      [
        50,
        -33
      ],
      [
        37,
        -76
      ],
      [
        50,
        -130
      ],
      [
        12,
        -76
      ],
      [
        25,
        -54
      ],
      [
        74,
        -98
      ],
      [
        0,
        -86
      ],
      [
        37,
        -98
      ],
      [
        -37,
        -43
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -87
      ],
      [
        0,
        -54
      ],
      [
        12,
        -33
      ],
      [
        50,
        -43
      ],
      [
        24,
        -76
      ],
      [
        25,
        -11
      ],
      [
        0,
        -65
      ],
      [
        25,
        -22
      ],
      [
        12,
        -43
      ],
      [
        13,
        -11
      ],
      [
        25,
        33
      ],
      [
        24,
        -33
      ],
      [
        0,
        -43
      ],
      [
        13,
        -33
      ],
      [
        -13,
        -76
      ],
      [
        0,
        -32
      ],
      [
        -24,
        0
      ],
      [
        -25,
        32
      ],
      [
        -13,
        -21
      ],
      [
        13,
        -22
      ],
      [
        -87,
        0
      ],
      [
        -99,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -33
      ],
      [
        13,
        -76
      ],
      [
        -13,
        -21
      ],
      [
        -49,
        -11
      ],
      [
        -50,
        21
      ],
      [
        -62,
        33
      ],
      [
        -24,
        54
      ],
      [
        -13,
        54
      ],
      [
        25,
        196
      ],
      [
        0,
        21
      ],
      [
        25,
        55
      ],
      [
        0,
        43
      ],
      [
        -25,
        43
      ],
      [
        -50,
        22
      ],
      [
        -37,
        43
      ],
      [
        -136,
        217
      ],
      [
        0,
        98
      ],
      [
        50,
        130
      ],
      [
        0,
        22
      ],
      [
        12,
        97
      ],
      [
        0,
        76
      ],
      [
        -12,
        87
      ],
      [
        -13,
        43
      ],
      [
        -49,
        22
      ],
      [
        -38,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -111,
        -130
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -65
      ],
      [
        12,
        -54
      ],
      [
        25,
        -65
      ],
      [
        13,
        -66
      ],
      [
        12,
        -216
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -65
      ],
      [
        -13,
        -141
      ],
      [
        13,
        -206
      ],
      [
        12,
        -130
      ],
      [
        -12,
        -65
      ],
      [
        -38,
        -228
      ],
      [
        0,
        -33
      ],
      [
        38,
        -151
      ],
      [
        12,
        -65
      ],
      [
        0,
        -66
      ],
      [
        -37,
        33
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        55
      ],
      [
        -38,
        54
      ],
      [
        -24,
        65
      ],
      [
        -13,
        65
      ],
      [
        25,
        152
      ],
      [
        37,
        119
      ],
      [
        0,
        163
      ],
      [
        25,
        65
      ],
      [
        0,
        65
      ],
      [
        12,
        239
      ],
      [
        -12,
        21
      ],
      [
        -37,
        141
      ],
      [
        0,
        141
      ],
      [
        -25,
        44
      ],
      [
        -25,
        10
      ],
      [
        -37,
        -10
      ],
      [
        -87,
        -33
      ],
      [
        -24,
        33
      ],
      [
        -25,
        119
      ],
      [
        -12,
        76
      ],
      [
        0,
        76
      ],
      [
        12,
        76
      ],
      [
        -25,
        97
      ],
      [
        0,
        33
      ],
      [
        25,
        43
      ],
      [
        25,
        11
      ],
      [
        12,
        22
      ],
      [
        50,
        65
      ],
      [
        12,
        65
      ],
      [
        0,
        76
      ],
      [
        12,
        76
      ],
      [
        50,
        130
      ],
      [
        12,
        65
      ],
      [
        -12,
        108
      ],
      [
        0,
        152
      ],
      [
        12,
        109
      ],
      [
        50,
        206
      ],
      [
        49,
        108
      ],
      [
        25,
        33
      ],
      [
        50,
        -109
      ],
      [
        0,
        54
      ],
      [
        -13,
        55
      ],
      [
        -37,
        368
      ],
      [
        13,
        22
      ],
      [
        12,
        0
      ],
      [
        25,
        22
      ],
      [
        0,
        43
      ],
      [
        -13,
        87
      ],
      [
        0,
        32
      ],
      [
        38,
        131
      ],
      [
        24,
        43
      ],
      [
        13,
        32
      ],
      [
        12,
        76
      ],
      [
        50,
        109
      ],
      [
        12,
        65
      ],
      [
        25,
        11
      ],
      [
        12,
        -65
      ],
      [
        50,
        -44
      ],
      [
        37,
        33
      ],
      [
        0,
        22
      ],
      [
        12,
        32
      ],
      [
        25,
        22
      ],
      [
        12,
        32
      ],
      [
        13,
        65
      ],
      [
        37,
        98
      ],
      [
        37,
        22
      ],
      [
        25,
        0
      ],
      [
        49,
        -44
      ],
      [
        25,
        -11
      ],
      [
        25,
        11
      ],
      [
        25,
        -32
      ],
      [
        25,
        -65
      ],
      [
        12,
        -22
      ],
      [
        111,
        11
      ],
      [
        87,
        -33
      ],
      [
        112,
        -11
      ],
      [
        37,
        -21
      ],
      [
        37,
        -33
      ],
      [
        37,
        -43
      ],
      [
        37,
        -11
      ],
      [
        25,
        43
      ],
      [
        37,
        22
      ],
      [
        75,
        -11
      ],
      [
        198,
        -54
      ],
      [
        25,
        0
      ],
      [
        123,
        108
      ],
      [
        50,
        109
      ],
      [
        37,
        22
      ],
      [
        25,
        97
      ],
      [
        12,
        22
      ],
      [
        37,
        11
      ],
      [
        13,
        21
      ],
      [
        49,
        131
      ],
      [
        25,
        10
      ],
      [
        37,
        -10
      ],
      [
        13,
        -22
      ],
      [
        24,
        -87
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -43
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        -130
      ],
      [
        -50,
        -108
      ]
    ],
    [
      [
        96919,
        57512
      ],
      [
        12,
        -54
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        -12,
        -65
      ],
      [
        -38,
        -44
      ],
      [
        -37,
        11
      ],
      [
        -12,
        22
      ],
      [
        -25,
        87
      ],
      [
        12,
        75
      ],
      [
        13,
        22
      ],
      [
        25,
        0
      ],
      [
        37,
        44
      ],
      [
        25,
        -33
      ]
    ],
    [
      [
        105875,
        56742
      ],
      [
        24,
        -11
      ],
      [
        25,
        0
      ],
      [
        13,
        33
      ],
      [
        0,
        32
      ],
      [
        12,
        65
      ],
      [
        37,
        55
      ],
      [
        12,
        0
      ],
      [
        25,
        21
      ],
      [
        -12,
        54
      ],
      [
        25,
        98
      ],
      [
        74,
        76
      ],
      [
        37,
        22
      ],
      [
        50,
        11
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -33
      ],
      [
        12,
        -65
      ],
      [
        0,
        -162
      ],
      [
        -12,
        -22
      ],
      [
        -137,
        -119
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -43
      ],
      [
        50,
        -65
      ],
      [
        74,
        -54
      ],
      [
        12,
        -22
      ],
      [
        13,
        -43
      ],
      [
        0,
        -55
      ],
      [
        24,
        -21
      ],
      [
        25,
        -11
      ],
      [
        25,
        -54
      ],
      [
        -124,
        75
      ],
      [
        -25,
        33
      ],
      [
        -49,
        0
      ],
      [
        -37,
        11
      ],
      [
        -38,
        32
      ],
      [
        -37,
        0
      ],
      [
        -24,
        -10
      ],
      [
        -13,
        -44
      ],
      [
        0,
        -54
      ],
      [
        13,
        -54
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -65
      ],
      [
        37,
        -184
      ],
      [
        37,
        -152
      ],
      [
        50,
        -152
      ],
      [
        25,
        -54
      ],
      [
        -13,
        -33
      ],
      [
        -12,
        55
      ],
      [
        -74,
        54
      ],
      [
        0,
        21
      ],
      [
        -50,
        152
      ],
      [
        -49,
        76
      ],
      [
        -13,
        33
      ],
      [
        -12,
        54
      ],
      [
        12,
        54
      ],
      [
        -12,
        65
      ],
      [
        0,
        76
      ],
      [
        12,
        87
      ],
      [
        -25,
        54
      ],
      [
        -24,
        65
      ],
      [
        -13,
        76
      ],
      [
        0,
        54
      ],
      [
        25,
        65
      ],
      [
        0,
        33
      ],
      [
        -25,
        54
      ],
      [
        -37,
        130
      ],
      [
        0,
        65
      ],
      [
        37,
        141
      ],
      [
        0,
        66
      ],
      [
        13,
        32
      ],
      [
        0,
        43
      ],
      [
        24,
        87
      ],
      [
        38,
        87
      ],
      [
        49,
        98
      ],
      [
        25,
        32
      ],
      [
        25,
        11
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -109
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -44
      ],
      [
        25,
        -32
      ],
      [
        25,
        -55
      ],
      [
        0,
        -227
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -87
      ],
      [
        -74,
        -87
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -33
      ],
      [
        13,
        -32
      ],
      [
        25,
        -22
      ]
    ],
    [
      [
        95407,
        57512
      ],
      [
        -37,
        54
      ],
      [
        -37,
        33
      ],
      [
        25,
        11
      ],
      [
        37,
        -22
      ],
      [
        12,
        -33
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        106122,
        57490
      ],
      [
        -62,
        -11
      ],
      [
        -12,
        33
      ],
      [
        -12,
        141
      ],
      [
        37,
        108
      ],
      [
        49,
        55
      ],
      [
        37,
        21
      ],
      [
        13,
        0
      ],
      [
        25,
        -76
      ],
      [
        -13,
        -162
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        105069,
        57870
      ],
      [
        -12,
        65
      ],
      [
        12,
        33
      ],
      [
        13,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        95110,
        57686
      ],
      [
        -37,
        10
      ],
      [
        -112,
        141
      ],
      [
        -24,
        0
      ],
      [
        -25,
        22
      ],
      [
        -25,
        11
      ],
      [
        -25,
        76
      ],
      [
        0,
        32
      ],
      [
        25,
        55
      ],
      [
        37,
        -11
      ],
      [
        25,
        -76
      ],
      [
        50,
        -33
      ],
      [
        12,
        -32
      ],
      [
        87,
        -98
      ],
      [
        12,
        -32
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        99384,
        58033
      ],
      [
        -13,
        -33
      ],
      [
        -12,
        22
      ],
      [
        25,
        11
      ]
    ],
    [
      [
        98306,
        58000
      ],
      [
        -12,
        0
      ],
      [
        0,
        130
      ],
      [
        12,
        -32
      ],
      [
        25,
        -22
      ],
      [
        12,
        0
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        98492,
        58184
      ],
      [
        0,
        -43
      ],
      [
        -25,
        22
      ],
      [
        0,
        65
      ],
      [
        25,
        0
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        102406,
        58260
      ],
      [
        0,
        -21
      ],
      [
        -37,
        54
      ],
      [
        0,
        65
      ],
      [
        25,
        0
      ],
      [
        25,
        -11
      ],
      [
        -13,
        -87
      ]
    ],
    [
      [
        105156,
        58358
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        44
      ],
      [
        0,
        76
      ],
      [
        -13,
        32
      ],
      [
        0,
        54
      ],
      [
        25,
        -32
      ],
      [
        12,
        -65
      ],
      [
        25,
        -55
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        105565,
        58564
      ],
      [
        -25,
        33
      ],
      [
        0,
        21
      ],
      [
        13,
        11
      ],
      [
        12,
        -32
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        105528,
        58629
      ],
      [
        -25,
        43
      ],
      [
        -12,
        66
      ],
      [
        24,
        -22
      ],
      [
        13,
        -54
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        102406,
        58813
      ],
      [
        25,
        0
      ],
      [
        49,
        11
      ]
    ],
    [
      [
        102480,
        58824
      ],
      [
        13,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -62,
        -32
      ],
      [
        -37,
        76
      ],
      [
        12,
        21
      ]
    ],
    [
      [
        99185,
        58521
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        32
      ],
      [
        50,
        44
      ],
      [
        0,
        22
      ],
      [
        -50,
        21
      ],
      [
        -12,
        22
      ],
      [
        -13,
        65
      ],
      [
        0,
        33
      ],
      [
        62,
        97
      ],
      [
        25,
        11
      ],
      [
        0,
        -43
      ],
      [
        50,
        -98
      ],
      [
        0,
        -98
      ],
      [
        -38,
        -86
      ]
    ],
    [
      [
        99644,
        57479
      ],
      [
        -37,
        -75
      ],
      [
        12,
        -33
      ],
      [
        0,
        -33
      ],
      [
        25,
        -10
      ],
      [
        12,
        -109
      ],
      [
        50,
        -108
      ],
      [
        24,
        -22
      ],
      [
        25,
        -43
      ],
      [
        25,
        -65
      ],
      [
        25,
        -22
      ],
      [
        74,
        -119
      ],
      [
        25,
        -44
      ],
      [
        37,
        -43
      ],
      [
        37,
        11
      ],
      [
        112,
        86
      ],
      [
        24,
        0
      ],
      [
        38,
        22
      ],
      [
        62,
        -11
      ],
      [
        62,
        -21
      ],
      [
        24,
        0
      ],
      [
        25,
        10
      ],
      [
        25,
        0
      ],
      [
        25,
        -10
      ],
      [
        62,
        65
      ],
      [
        49,
        21
      ],
      [
        37,
        185
      ],
      [
        25,
        32
      ],
      [
        25,
        22
      ],
      [
        49,
        22
      ],
      [
        161,
        11
      ],
      [
        25,
        -55
      ],
      [
        -12,
        -21
      ],
      [
        25,
        -11
      ],
      [
        24,
        -22
      ],
      [
        87,
        -43
      ],
      [
        25,
        -22
      ],
      [
        25,
        11
      ],
      [
        37,
        -54
      ],
      [
        25,
        21
      ],
      [
        24,
        33
      ],
      [
        25,
        43
      ],
      [
        25,
        33
      ],
      [
        25,
        11
      ],
      [
        49,
        0
      ],
      [
        50,
        10
      ],
      [
        37,
        22
      ],
      [
        49,
        -32
      ],
      [
        13,
        10
      ],
      [
        0,
        33
      ],
      [
        25,
        54
      ],
      [
        12,
        44
      ],
      [
        0,
        86
      ],
      [
        12,
        22
      ],
      [
        38,
        22
      ],
      [
        0,
        86
      ],
      [
        -13,
        11
      ],
      [
        -12,
        76
      ],
      [
        12,
        33
      ],
      [
        0,
        21
      ],
      [
        25,
        11
      ],
      [
        37,
        55
      ],
      [
        50,
        54
      ],
      [
        24,
        54
      ],
      [
        0,
        22
      ],
      [
        -12,
        32
      ],
      [
        -25,
        11
      ],
      [
        0,
        54
      ],
      [
        13,
        22
      ],
      [
        0,
        87
      ],
      [
        24,
        54
      ],
      [
        25,
        32
      ],
      [
        25,
        -21
      ],
      [
        50,
        21
      ],
      [
        12,
        55
      ],
      [
        0,
        141
      ],
      [
        12,
        11
      ],
      [
        13,
        54
      ],
      [
        0,
        32
      ],
      [
        -13,
        87
      ],
      [
        13,
        54
      ],
      [
        0,
        130
      ],
      [
        12,
        22
      ],
      [
        25,
        141
      ],
      [
        37,
        33
      ],
      [
        12,
        54
      ],
      [
        25,
        11
      ],
      [
        37,
        -44
      ],
      [
        50,
        44
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        25,
        -33
      ],
      [
        37,
        44
      ],
      [
        25,
        -22
      ],
      [
        24,
        0
      ],
      [
        13,
        11
      ],
      [
        49,
        -11
      ],
      [
        87,
        0
      ],
      [
        62,
        -22
      ],
      [
        62,
        -65
      ],
      [
        49,
        -11
      ]
    ],
    [
      [
        102381,
        58824
      ],
      [
        -37,
        -32
      ],
      [
        0,
        -33
      ],
      [
        25,
        -54
      ],
      [
        0,
        -33
      ],
      [
        62,
        -86
      ],
      [
        0,
        -22
      ],
      [
        12,
        -22
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        0
      ],
      [
        -25,
        22
      ],
      [
        -12,
        32
      ],
      [
        -13,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        11
      ],
      [
        -49,
        0
      ],
      [
        -13,
        -22
      ],
      [
        13,
        -10
      ],
      [
        62,
        -98
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -33
      ],
      [
        24,
        -11
      ],
      [
        38,
        -43
      ],
      [
        12,
        0
      ],
      [
        25,
        -22
      ],
      [
        0,
        -76
      ],
      [
        25,
        -32
      ],
      [
        -25,
        -44
      ],
      [
        37,
        -32
      ],
      [
        25,
        -11
      ],
      [
        0,
        -54
      ],
      [
        24,
        -76
      ],
      [
        50,
        -109
      ],
      [
        12,
        -32
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -22
      ],
      [
        24,
        -32
      ],
      [
        13,
        -65
      ],
      [
        62,
        -109
      ],
      [
        136,
        -173
      ],
      [
        50,
        -65
      ],
      [
        74,
        -141
      ],
      [
        37,
        -33
      ],
      [
        12,
        -32
      ],
      [
        -37,
        -65
      ],
      [
        -49,
        -22
      ],
      [
        -75,
        -22
      ],
      [
        -74,
        22
      ],
      [
        -37,
        22
      ],
      [
        -37,
        32
      ],
      [
        -25,
        65
      ],
      [
        -37,
        44
      ],
      [
        25,
        -87
      ],
      [
        -25,
        -87
      ],
      [
        -50,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        -62,
        -239
      ],
      [
        -12,
        -65
      ],
      [
        -13,
        -271
      ],
      [
        0,
        -76
      ],
      [
        25,
        -151
      ],
      [
        0,
        -76
      ],
      [
        12,
        -33
      ],
      [
        -24,
        -43
      ],
      [
        -50,
        -44
      ],
      [
        -50,
        -32
      ],
      [
        -24,
        -54
      ],
      [
        -25,
        -66
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -12,
        22
      ],
      [
        -13,
        -11
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -54
      ],
      [
        -49,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -32
      ],
      [
        25,
        10
      ],
      [
        25,
        -10
      ],
      [
        0,
        -163
      ],
      [
        -37,
        -54
      ],
      [
        37,
        -33
      ],
      [
        37,
        -11
      ],
      [
        13,
        -54
      ],
      [
        -13,
        -76
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -10
      ],
      [
        0,
        -163
      ],
      [
        -25,
        -76
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        22
      ],
      [
        -12,
        -33
      ],
      [
        12,
        -21
      ],
      [
        25,
        -66
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        -76
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -43
      ],
      [
        -248,
        -196
      ],
      [
        -186,
        -162
      ],
      [
        -24,
        11
      ],
      [
        0,
        21
      ],
      [
        -13,
        261
      ],
      [
        -25,
        130
      ],
      [
        0,
        76
      ],
      [
        -24,
        -65
      ],
      [
        -25,
        0
      ],
      [
        -25,
        43
      ],
      [
        0,
        22
      ],
      [
        -12,
        43
      ],
      [
        -13,
        -33
      ],
      [
        -24,
        0
      ],
      [
        -25,
        44
      ],
      [
        -50,
        -65
      ],
      [
        -49,
        -44
      ],
      [
        -37,
        0
      ],
      [
        -25,
        22
      ],
      [
        0,
        141
      ],
      [
        -37,
        11
      ],
      [
        -38,
        -33
      ],
      [
        -12,
        11
      ],
      [
        -12,
        -21
      ],
      [
        -99,
        195
      ],
      [
        -25,
        -152
      ],
      [
        -75,
        -87
      ],
      [
        -61,
        -54
      ],
      [
        -50,
        22
      ],
      [
        -50,
        32
      ],
      [
        -62,
        -32
      ],
      [
        -49,
        -98
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        11
      ],
      [
        0,
        325
      ],
      [
        -24,
        44
      ],
      [
        -25,
        32
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -50,
        22
      ],
      [
        -37,
        -11
      ],
      [
        -74,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -12,
        32
      ],
      [
        0,
        33
      ],
      [
        -38,
        -54
      ],
      [
        -12,
        10
      ],
      [
        -37,
        76
      ],
      [
        -62,
        -32
      ],
      [
        -13,
        0
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        11
      ],
      [
        0,
        33
      ],
      [
        -37,
        433
      ],
      [
        -12,
        141
      ],
      [
        -13,
        33
      ],
      [
        -37,
        54
      ],
      [
        0,
        76
      ],
      [
        25,
        65
      ],
      [
        0,
        152
      ],
      [
        -12,
        76
      ],
      [
        -13,
        54
      ],
      [
        -25,
        54
      ],
      [
        -37,
        55
      ],
      [
        -37,
        43
      ],
      [
        -74,
        43
      ],
      [
        -37,
        0
      ],
      [
        -25,
        22
      ],
      [
        0,
        65
      ],
      [
        12,
        33
      ],
      [
        25,
        10
      ],
      [
        0,
        22
      ],
      [
        -37,
        33
      ],
      [
        -37,
        54
      ],
      [
        -13,
        32
      ],
      [
        0,
        109
      ],
      [
        13,
        54
      ],
      [
        0,
        22
      ],
      [
        12,
        87
      ],
      [
        25,
        21
      ],
      [
        -13,
        33
      ],
      [
        -24,
        22
      ],
      [
        0,
        32
      ],
      [
        -25,
        54
      ],
      [
        -50,
        65
      ],
      [
        -12,
        109
      ],
      [
        0,
        238
      ],
      [
        12,
        141
      ],
      [
        25,
        44
      ],
      [
        25,
        11
      ],
      [
        0,
        21
      ],
      [
        -25,
        -11
      ],
      [
        13,
        120
      ],
      [
        37,
        108
      ],
      [
        37,
        65
      ],
      [
        12,
        65
      ],
      [
        25,
        65
      ],
      [
        87,
        65
      ]
    ],
    [
      [
        105553,
        58738
      ],
      [
        -13,
        -22
      ],
      [
        -25,
        11
      ],
      [
        0,
        32
      ],
      [
        25,
        54
      ],
      [
        13,
        66
      ],
      [
        -13,
        10
      ],
      [
        -12,
        44
      ],
      [
        0,
        43
      ],
      [
        12,
        76
      ],
      [
        13,
        0
      ],
      [
        24,
        -43
      ],
      [
        0,
        -65
      ],
      [
        13,
        -55
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -86
      ]
    ],
    [
      [
        95122,
        59475
      ],
      [
        38,
        0
      ],
      [
        86,
        33
      ],
      [
        37,
        0
      ],
      [
        50,
        -22
      ],
      [
        25,
        -22
      ],
      [
        99,
        22
      ],
      [
        25,
        -22
      ],
      [
        62,
        -97
      ],
      [
        61,
        -109
      ],
      [
        25,
        -65
      ],
      [
        13,
        -65
      ],
      [
        86,
        -152
      ],
      [
        13,
        -65
      ],
      [
        -13,
        -76
      ],
      [
        13,
        -65
      ],
      [
        86,
        -54
      ],
      [
        38,
        -44
      ],
      [
        24,
        -65
      ],
      [
        25,
        -43
      ],
      [
        25,
        -33
      ],
      [
        99,
        -75
      ],
      [
        124,
        -174
      ],
      [
        74,
        -76
      ],
      [
        87,
        -184
      ],
      [
        12,
        -65
      ],
      [
        37,
        -87
      ],
      [
        62,
        -119
      ],
      [
        13,
        -33
      ],
      [
        25,
        -43
      ],
      [
        12,
        -55
      ],
      [
        25,
        -43
      ],
      [
        25,
        -32
      ],
      [
        37,
        -11
      ],
      [
        37,
        -76
      ],
      [
        25,
        -22
      ],
      [
        0,
        54
      ],
      [
        -25,
        65
      ],
      [
        0,
        33
      ],
      [
        25,
        54
      ],
      [
        12,
        0
      ],
      [
        50,
        -22
      ],
      [
        62,
        -97
      ],
      [
        24,
        -54
      ],
      [
        13,
        -76
      ],
      [
        24,
        -76
      ],
      [
        25,
        -44
      ],
      [
        62,
        -21
      ],
      [
        37,
        -22
      ],
      [
        87,
        -119
      ],
      [
        25,
        -44
      ],
      [
        12,
        -65
      ],
      [
        25,
        -76
      ],
      [
        0,
        -76
      ],
      [
        87,
        -151
      ],
      [
        37,
        -22
      ],
      [
        99,
        -11
      ],
      [
        62,
        -87
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -54
      ],
      [
        -74,
        -76
      ],
      [
        0,
        -33
      ],
      [
        37,
        22
      ],
      [
        37,
        33
      ],
      [
        38,
        43
      ],
      [
        74,
        76
      ],
      [
        50,
        -22
      ],
      [
        37,
        -54
      ],
      [
        37,
        -65
      ],
      [
        12,
        -76
      ],
      [
        25,
        -76
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        -50,
        -76
      ],
      [
        -12,
        -32
      ],
      [
        12,
        -11
      ],
      [
        -12,
        -65
      ],
      [
        37,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -32
      ],
      [
        50,
        -141
      ],
      [
        49,
        -55
      ],
      [
        75,
        -54
      ],
      [
        37,
        -32
      ],
      [
        49,
        -11
      ],
      [
        62,
        0
      ],
      [
        0,
        -22
      ],
      [
        13,
        -108
      ],
      [
        12,
        -65
      ],
      [
        12,
        -152
      ],
      [
        13,
        -65
      ],
      [
        0,
        -76
      ],
      [
        12,
        -54
      ],
      [
        37,
        -44
      ],
      [
        50,
        -32
      ],
      [
        12,
        -33
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -65
      ],
      [
        12,
        -32
      ],
      [
        25,
        11
      ],
      [
        62,
        119
      ],
      [
        37,
        21
      ],
      [
        87,
        0
      ],
      [
        37,
        -21
      ],
      [
        74,
        -65
      ],
      [
        99,
        -250
      ],
      [
        62,
        -173
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        -50,
        -87
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -108
      ],
      [
        0,
        -76
      ],
      [
        25,
        -54
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -152
      ],
      [
        -12,
        -21
      ],
      [
        24,
        -250
      ],
      [
        0,
        -282
      ],
      [
        -24,
        -423
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -66
      ],
      [
        -25,
        0
      ],
      [
        -37,
        33
      ],
      [
        0,
        33
      ],
      [
        -12,
        32
      ],
      [
        -62,
        76
      ],
      [
        -13,
        -22
      ],
      [
        -62,
        -86
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -37,
        32
      ],
      [
        -99,
        98
      ],
      [
        0,
        -76
      ],
      [
        12,
        -109
      ],
      [
        13,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        65
      ],
      [
        -37,
        76
      ],
      [
        -74,
        130
      ],
      [
        -37,
        55
      ],
      [
        -75,
        195
      ],
      [
        -24,
        21
      ],
      [
        -124,
        141
      ],
      [
        -62,
        87
      ],
      [
        -25,
        54
      ],
      [
        -74,
        76
      ],
      [
        -137,
        196
      ],
      [
        -61,
        119
      ],
      [
        -62,
        184
      ],
      [
        -13,
        44
      ],
      [
        -111,
        141
      ],
      [
        -62,
        76
      ],
      [
        -25,
        54
      ],
      [
        -50,
        162
      ],
      [
        -24,
        66
      ],
      [
        -13,
        43
      ],
      [
        -37,
        43
      ],
      [
        -25,
        44
      ],
      [
        -62,
        151
      ],
      [
        -24,
        66
      ],
      [
        -13,
        65
      ],
      [
        0,
        130
      ],
      [
        -124,
        390
      ],
      [
        -37,
        130
      ],
      [
        -25,
        174
      ],
      [
        0,
        11
      ],
      [
        -74,
        152
      ],
      [
        -25,
        54
      ],
      [
        -24,
        43
      ],
      [
        -25,
        54
      ],
      [
        -50,
        174
      ],
      [
        -25,
        54
      ],
      [
        -24,
        33
      ],
      [
        -87,
        65
      ],
      [
        -37,
        43
      ],
      [
        -25,
        54
      ],
      [
        -37,
        206
      ],
      [
        -37,
        217
      ],
      [
        -50,
        282
      ],
      [
        -37,
        130
      ],
      [
        -37,
        109
      ],
      [
        0,
        22
      ],
      [
        -174,
        184
      ],
      [
        -49,
        43
      ],
      [
        -50,
        11
      ],
      [
        -24,
        44
      ],
      [
        -13,
        86
      ],
      [
        -12,
        109
      ],
      [
        -13,
        76
      ],
      [
        0,
        32
      ],
      [
        -74,
        87
      ],
      [
        -49,
        130
      ],
      [
        -25,
        54
      ],
      [
        -75,
        185
      ],
      [
        -24,
        54
      ],
      [
        -25,
        32
      ],
      [
        -99,
        33
      ],
      [
        -25,
        33
      ],
      [
        -74,
        162
      ],
      [
        -87,
        120
      ],
      [
        -136,
        249
      ],
      [
        -37,
        65
      ],
      [
        -13,
        65
      ],
      [
        -25,
        65
      ],
      [
        -62,
        195
      ],
      [
        13,
        33
      ],
      [
        0,
        141
      ],
      [
        62,
        43
      ],
      [
        111,
        -32
      ],
      [
        37,
        -44
      ],
      [
        62,
        -97
      ],
      [
        38,
        -44
      ],
      [
        37,
        -10
      ],
      [
        86,
        -33
      ]
    ],
    [
      [
        94738,
        59844
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        65
      ],
      [
        49,
        -11
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        60401,
        90058
      ],
      [
        -62,
        -76
      ],
      [
        -50,
        33
      ],
      [
        13,
        76
      ],
      [
        37,
        22
      ],
      [
        37,
        65
      ],
      [
        25,
        21
      ],
      [
        12,
        -10
      ],
      [
        25,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        94230,
        60484
      ],
      [
        -24,
        -55
      ],
      [
        -37,
        163
      ],
      [
        -25,
        0
      ],
      [
        0,
        76
      ],
      [
        12,
        32
      ],
      [
        50,
        33
      ],
      [
        12,
        -22
      ],
      [
        25,
        -141
      ],
      [
        -13,
        -86
      ]
    ],
    [
      [
        94169,
        60809
      ],
      [
        -25,
        -54
      ],
      [
        -13,
        32
      ],
      [
        0,
        22
      ],
      [
        25,
        32
      ],
      [
        13,
        -32
      ]
    ],
    [
      [
        94069,
        61134
      ],
      [
        -24,
        0
      ],
      [
        0,
        22
      ],
      [
        -13,
        33
      ],
      [
        0,
        21
      ],
      [
        25,
        11
      ],
      [
        25,
        -76
      ],
      [
        -13,
        -11
      ]
    ],
    [
      [
        94107,
        61243
      ],
      [
        -13,
        -22
      ],
      [
        -12,
        0
      ],
      [
        0,
        98
      ],
      [
        12,
        32
      ],
      [
        13,
        -11
      ],
      [
        -13,
        -32
      ],
      [
        13,
        -65
      ]
    ],
    [
      [
        93970,
        61362
      ],
      [
        -12,
        -11
      ],
      [
        -12,
        33
      ],
      [
        0,
        32
      ],
      [
        12,
        11
      ],
      [
        12,
        -65
      ]
    ],
    [
      [
        93846,
        61926
      ],
      [
        -12,
        -11
      ],
      [
        -12,
        22
      ],
      [
        0,
        22
      ],
      [
        24,
        32
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        93747,
        62804
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        21
      ],
      [
        0,
        66
      ],
      [
        -12,
        65
      ],
      [
        49,
        86
      ],
      [
        25,
        -65
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -98
      ]
    ],
    [
      [
        93933,
        63737
      ],
      [
        13,
        -87
      ],
      [
        -25,
        33
      ],
      [
        -13,
        32
      ],
      [
        25,
        22
      ]
    ],
    [
      [
        93822,
        64247
      ],
      [
        -13,
        54
      ],
      [
        13,
        11
      ],
      [
        12,
        -11
      ],
      [
        -12,
        -54
      ]
    ],
    [
      [
        93822,
        63423
      ],
      [
        -13,
        0
      ],
      [
        -37,
        108
      ],
      [
        0,
        76
      ],
      [
        -12,
        22
      ],
      [
        37,
        86
      ],
      [
        0,
        66
      ],
      [
        12,
        54
      ],
      [
        13,
        11
      ],
      [
        24,
        0
      ],
      [
        0,
        54
      ],
      [
        -24,
        32
      ],
      [
        0,
        120
      ],
      [
        12,
        43
      ],
      [
        0,
        130
      ],
      [
        25,
        33
      ],
      [
        0,
        97
      ],
      [
        12,
        120
      ],
      [
        0,
        86
      ],
      [
        25,
        76
      ],
      [
        37,
        33
      ],
      [
        13,
        0
      ],
      [
        0,
        -87
      ],
      [
        -13,
        -43
      ],
      [
        13,
        -44
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -87
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        -54
      ],
      [
        -12,
        -22
      ],
      [
        24,
        -65
      ],
      [
        13,
        -195
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        -10
      ],
      [
        13,
        -131
      ],
      [
        -38,
        -97
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -21
      ],
      [
        12,
        -33
      ],
      [
        0,
        -184
      ],
      [
        -24,
        -65
      ]
    ],
    [
      [
        89003,
        76133
      ],
      [
        0,
        -97
      ],
      [
        12,
        -44
      ],
      [
        25,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -54
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -87
      ],
      [
        38,
        0
      ],
      [
        12,
        22
      ],
      [
        37,
        0
      ],
      [
        13,
        54
      ],
      [
        24,
        -10
      ],
      [
        50,
        -98
      ],
      [
        37,
        -87
      ]
    ],
    [
      [
        89226,
        75645
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        89226,
        75623
      ],
      [
        12,
        0
      ],
      [
        38,
        -54
      ],
      [
        24,
        -21
      ],
      [
        37,
        10
      ],
      [
        38,
        0
      ],
      [
        49,
        -43
      ],
      [
        0,
        -11
      ],
      [
        50,
        -65
      ],
      [
        25,
        11
      ],
      [
        24,
        -65
      ],
      [
        -12,
        -76
      ],
      [
        25,
        0
      ],
      [
        148,
        -98
      ],
      [
        62,
        -76
      ],
      [
        37,
        -32
      ],
      [
        13,
        -43
      ]
    ],
    [
      [
        89796,
        75060
      ],
      [
        -13,
        10
      ],
      [
        -24,
        -10
      ],
      [
        -75,
        -109
      ],
      [
        -24,
        -22
      ],
      [
        -75,
        -141
      ],
      [
        -49,
        -195
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -76
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        -87
      ],
      [
        -13,
        -76
      ],
      [
        62,
        -87
      ],
      [
        37,
        -43
      ],
      [
        38,
        -33
      ],
      [
        12,
        0
      ],
      [
        12,
        33
      ],
      [
        25,
        -11
      ],
      [
        37,
        -32
      ],
      [
        13,
        -22
      ],
      [
        99,
        -87
      ],
      [
        74,
        -76
      ],
      [
        0,
        -32
      ],
      [
        25,
        -44
      ],
      [
        111,
        -119
      ],
      [
        50,
        -43
      ],
      [
        25,
        -33
      ],
      [
        49,
        33
      ],
      [
        50,
        -33
      ],
      [
        111,
        -119
      ],
      [
        62,
        11
      ],
      [
        13,
        -11
      ],
      [
        24,
        -98
      ],
      [
        62,
        -32
      ],
      [
        50,
        -11
      ],
      [
        49,
        -22
      ],
      [
        25,
        -22
      ],
      [
        37,
        22
      ],
      [
        0,
        22
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        62,
        -44
      ],
      [
        25,
        -11
      ],
      [
        25,
        44
      ],
      [
        49,
        11
      ],
      [
        25,
        21
      ],
      [
        37,
        -43
      ],
      [
        87,
        -43
      ],
      [
        50,
        -33
      ],
      [
        12,
        -32
      ],
      [
        0,
        -98
      ],
      [
        12,
        -33
      ],
      [
        87,
        -76
      ],
      [
        25,
        -32
      ],
      [
        49,
        -11
      ],
      [
        13,
        -54
      ],
      [
        37,
        -11
      ],
      [
        99,
        54
      ],
      [
        25,
        0
      ],
      [
        25,
        -76
      ],
      [
        0,
        -43
      ],
      [
        49,
        -33
      ],
      [
        50,
        33
      ],
      [
        37,
        -22
      ],
      [
        87,
        -21
      ],
      [
        61,
        -55
      ],
      [
        50,
        -32
      ],
      [
        25,
        0
      ],
      [
        87,
        76
      ],
      [
        24,
        -76
      ],
      [
        62,
        -44
      ],
      [
        50,
        33
      ],
      [
        37,
        -11
      ],
      [
        37,
        0
      ],
      [
        37,
        22
      ],
      [
        37,
        0
      ],
      [
        50,
        -33
      ],
      [
        25,
        33
      ],
      [
        12,
        97
      ],
      [
        25,
        87
      ],
      [
        0,
        44
      ],
      [
        -25,
        75
      ],
      [
        -37,
        98
      ],
      [
        0,
        33
      ],
      [
        12,
        173
      ],
      [
        13,
        98
      ],
      [
        12,
        43
      ],
      [
        13,
        76
      ],
      [
        0,
        54
      ],
      [
        -13,
        22
      ]
    ],
    [
      [
        95407,
        73845
      ],
      [
        0,
        -87
      ],
      [
        13,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        -38,
        -32
      ],
      [
        -24,
        -33
      ],
      [
        0,
        -130
      ],
      [
        74,
        -174
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        54
      ],
      [
        -25,
        76
      ],
      [
        -25,
        22
      ],
      [
        -25,
        0
      ],
      [
        -136,
        -44
      ],
      [
        -25,
        0
      ],
      [
        -49,
        -32
      ],
      [
        -50,
        -109
      ],
      [
        -62,
        -54
      ],
      [
        -86,
        -130
      ],
      [
        -100,
        -65
      ],
      [
        -24,
        -33
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -75
      ],
      [
        12,
        -98
      ],
      [
        13,
        -65
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        -86
      ],
      [
        -37,
        -109
      ],
      [
        -25,
        -54
      ],
      [
        -49,
        -33
      ],
      [
        -13,
        -32
      ],
      [
        -25,
        -109
      ],
      [
        13,
        -32
      ],
      [
        37,
        -33
      ],
      [
        12,
        -54
      ],
      [
        -24,
        -76
      ],
      [
        -50,
        -184
      ],
      [
        -49,
        -98
      ],
      [
        -25,
        -97
      ],
      [
        -25,
        -130
      ],
      [
        -12,
        -87
      ],
      [
        -25,
        -54
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        21
      ],
      [
        -50,
        22
      ],
      [
        -62,
        43
      ],
      [
        -62,
        -21
      ],
      [
        -49,
        65
      ],
      [
        -13,
        -33
      ],
      [
        13,
        -152
      ],
      [
        24,
        -65
      ],
      [
        -12,
        -97
      ],
      [
        0,
        -109
      ],
      [
        -12,
        -130
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -13,
        -22
      ],
      [
        13,
        -54
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -54
      ],
      [
        0,
        -55
      ],
      [
        25,
        -119
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        10
      ],
      [
        -38,
        -130
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -25,
        55
      ],
      [
        -24,
        21
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -21
      ]
    ],
    [
      [
        92558,
        70017
      ],
      [
        0,
        -98
      ],
      [
        -25,
        0
      ],
      [
        25,
        -65
      ],
      [
        0,
        -109
      ],
      [
        -49,
        -10
      ],
      [
        -13,
        65
      ],
      [
        -12,
        -55
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        43
      ],
      [
        0,
        44
      ],
      [
        25,
        173
      ],
      [
        -25,
        33
      ],
      [
        -12,
        32
      ],
      [
        -25,
        -173
      ],
      [
        13,
        -76
      ],
      [
        -13,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -62,
        97
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        0
      ],
      [
        -25,
        43
      ],
      [
        49,
        271
      ],
      [
        -37,
        54
      ],
      [
        -37,
        33
      ],
      [
        -12,
        -11
      ],
      [
        12,
        -22
      ],
      [
        37,
        -21
      ],
      [
        25,
        -44
      ],
      [
        -37,
        -65
      ],
      [
        -37,
        -119
      ],
      [
        -50,
        -54
      ],
      [
        -50,
        -44
      ],
      [
        -161,
        -76
      ],
      [
        -37,
        -21
      ],
      [
        -49,
        -87
      ],
      [
        -25,
        -87
      ],
      [
        -12,
        -76
      ],
      [
        24,
        -86
      ],
      [
        13,
        -141
      ],
      [
        12,
        -22
      ],
      [
        -49,
        -109
      ],
      [
        -25,
        -75
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -33
      ],
      [
        -74,
        -86
      ],
      [
        -25,
        -55
      ],
      [
        -24,
        -43
      ],
      [
        -25,
        22
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -223,
        -119
      ],
      [
        -25,
        0
      ],
      [
        0,
        22
      ],
      [
        13,
        10
      ],
      [
        0,
        76
      ],
      [
        -25,
        11
      ],
      [
        -74,
        -87
      ],
      [
        -38,
        -86
      ],
      [
        25,
        -11
      ],
      [
        50,
        54
      ],
      [
        24,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -74,
        -75
      ],
      [
        -149,
        -239
      ],
      [
        -12,
        -43
      ],
      [
        -49,
        -109
      ],
      [
        -50,
        -119
      ],
      [
        -99,
        -185
      ],
      [
        -25,
        -65
      ],
      [
        -161,
        -141
      ],
      [
        -25,
        -43
      ],
      [
        -62,
        -130
      ],
      [
        -62,
        -109
      ],
      [
        -74,
        -97
      ],
      [
        -136,
        -119
      ],
      [
        -74,
        -109
      ],
      [
        -25,
        -76
      ],
      [
        -13,
        -22
      ],
      [
        13,
        -43
      ],
      [
        25,
        -54
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        -49,
        -43
      ],
      [
        -124,
        -98
      ],
      [
        -12,
        0
      ],
      [
        -112,
        22
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -185
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        -24,
        0
      ],
      [
        -13,
        11
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        65
      ],
      [
        -49,
        22
      ],
      [
        -87,
        -65
      ],
      [
        -37,
        -55
      ],
      [
        -62,
        -238
      ],
      [
        -25,
        -152
      ],
      [
        25,
        -173
      ],
      [
        25,
        -141
      ],
      [
        0,
        -141
      ],
      [
        -25,
        -87
      ],
      [
        13,
        -98
      ],
      [
        37,
        -173
      ],
      [
        0,
        -55
      ],
      [
        24,
        -130
      ],
      [
        -24,
        22
      ],
      [
        -13,
        54
      ],
      [
        -24,
        65
      ],
      [
        -25,
        -65
      ],
      [
        12,
        -43
      ],
      [
        62,
        -65
      ],
      [
        25,
        -44
      ],
      [
        -50,
        -423
      ],
      [
        -24,
        -141
      ],
      [
        -38,
        -97
      ],
      [
        -24,
        -44
      ],
      [
        -38,
        -151
      ],
      [
        -24,
        -185
      ],
      [
        -13,
        -76
      ],
      [
        13,
        -76
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -22
      ],
      [
        24,
        -86
      ],
      [
        0,
        -261
      ],
      [
        0,
        -282
      ],
      [
        -37,
        -10
      ],
      [
        -49,
        0
      ],
      [
        -25,
        10
      ],
      [
        -50,
        -10
      ],
      [
        -24,
        -33
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -87
      ],
      [
        -87,
        -217
      ],
      [
        -25,
        -141
      ],
      [
        13,
        -43
      ],
      [
        25,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        -198,
        -98
      ],
      [
        -50,
        -76
      ],
      [
        -24,
        -65
      ],
      [
        -25,
        -141
      ],
      [
        0,
        -86
      ],
      [
        -25,
        -87
      ],
      [
        -99,
        -119
      ],
      [
        -62,
        -33
      ],
      [
        -25,
        -33
      ],
      [
        -74,
        33
      ],
      [
        -74,
        108
      ],
      [
        -38,
        66
      ],
      [
        -123,
        271
      ],
      [
        -25,
        32
      ],
      [
        -25,
        119
      ],
      [
        0,
        44
      ],
      [
        -25,
        43
      ],
      [
        -25,
        141
      ],
      [
        -24,
        293
      ],
      [
        12,
        -11
      ],
      [
        12,
        -54
      ],
      [
        13,
        -76
      ],
      [
        0,
        -98
      ],
      [
        25,
        -10
      ],
      [
        12,
        10
      ],
      [
        -37,
        239
      ],
      [
        -37,
        54
      ],
      [
        -13,
        11
      ],
      [
        -12,
        33
      ],
      [
        0,
        76
      ],
      [
        -25,
        75
      ],
      [
        0,
        44
      ],
      [
        -62,
        238
      ],
      [
        -25,
        174
      ],
      [
        -49,
        195
      ],
      [
        -25,
        65
      ],
      [
        -37,
        141
      ],
      [
        -37,
        76
      ],
      [
        -37,
        87
      ],
      [
        -38,
        65
      ],
      [
        -86,
        315
      ],
      [
        -37,
        173
      ],
      [
        -13,
        87
      ],
      [
        -12,
        65
      ],
      [
        -37,
        260
      ],
      [
        0,
        109
      ],
      [
        -25,
        108
      ],
      [
        -37,
        119
      ],
      [
        -13,
        76
      ],
      [
        0,
        33
      ],
      [
        -24,
        119
      ],
      [
        0,
        54
      ],
      [
        -13,
        55
      ],
      [
        -25,
        43
      ],
      [
        -12,
        43
      ],
      [
        -50,
        120
      ],
      [
        -24,
        21
      ],
      [
        -25,
        87
      ],
      [
        -25,
        141
      ],
      [
        -25,
        54
      ],
      [
        38,
        0
      ],
      [
        -50,
        109
      ],
      [
        25,
        54
      ],
      [
        -37,
        0
      ],
      [
        -25,
        32
      ],
      [
        -25,
        98
      ],
      [
        -37,
        119
      ],
      [
        -50,
        250
      ],
      [
        -37,
        466
      ],
      [
        -25,
        206
      ],
      [
        0,
        54
      ],
      [
        -62,
        304
      ],
      [
        0,
        98
      ],
      [
        -12,
        65
      ],
      [
        -12,
        130
      ],
      [
        -13,
        43
      ],
      [
        0,
        22
      ],
      [
        13,
        65
      ],
      [
        24,
        87
      ],
      [
        13,
        65
      ],
      [
        -13,
        76
      ],
      [
        -24,
        -76
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        65
      ],
      [
        0,
        185
      ],
      [
        -13,
        22
      ],
      [
        0,
        32
      ],
      [
        13,
        43
      ],
      [
        -25,
        33
      ],
      [
        -13,
        108
      ],
      [
        0,
        33
      ],
      [
        -12,
        22
      ],
      [
        12,
        151
      ],
      [
        62,
        304
      ],
      [
        13,
        65
      ],
      [
        -25,
        174
      ],
      [
        0,
        86
      ],
      [
        -50,
        55
      ],
      [
        -24,
        119
      ],
      [
        37,
        65
      ],
      [
        -37,
        -11
      ],
      [
        62,
        109
      ],
      [
        12,
        32
      ],
      [
        -99,
        11
      ],
      [
        12,
        109
      ],
      [
        13,
        54
      ],
      [
        -38,
        11
      ],
      [
        13,
        119
      ],
      [
        25,
        22
      ],
      [
        24,
        0
      ],
      [
        38,
        21
      ],
      [
        -38,
        22
      ],
      [
        -37,
        0
      ],
      [
        -49,
        -11
      ],
      [
        -38,
        11
      ],
      [
        -24,
        -11
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -44
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        50,
        -33
      ],
      [
        25,
        -65
      ],
      [
        0,
        -86
      ],
      [
        -62,
        -185
      ],
      [
        -25,
        -43
      ],
      [
        -149,
        -119
      ],
      [
        -62,
        -65
      ],
      [
        -123,
        -76
      ],
      [
        -50,
        -22
      ],
      [
        -62,
        22
      ],
      [
        -74,
        65
      ],
      [
        -124,
        151
      ],
      [
        -37,
        55
      ],
      [
        -99,
        206
      ],
      [
        -62,
        108
      ],
      [
        -124,
        195
      ],
      [
        -62,
        131
      ],
      [
        -13,
        54
      ],
      [
        0,
        65
      ],
      [
        25,
        32
      ],
      [
        25,
        -21
      ],
      [
        37,
        -65
      ],
      [
        13,
        -11
      ],
      [
        99,
        76
      ],
      [
        37,
        0
      ],
      [
        25,
        32
      ],
      [
        24,
        -11
      ],
      [
        62,
        65
      ],
      [
        37,
        0
      ],
      [
        25,
        11
      ],
      [
        50,
        152
      ],
      [
        37,
        98
      ],
      [
        37,
        21
      ],
      [
        -12,
        22
      ],
      [
        0,
        33
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -49,
        11
      ],
      [
        -124,
        -65
      ],
      [
        -37,
        -55
      ],
      [
        -25,
        -10
      ],
      [
        -149,
        54
      ],
      [
        -148,
        130
      ],
      [
        -62,
        87
      ],
      [
        -38,
        108
      ],
      [
        -37,
        130
      ],
      [
        13,
        33
      ],
      [
        62,
        76
      ],
      [
        12,
        43
      ],
      [
        -74,
        -65
      ],
      [
        -38,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -24,
        163
      ]
    ],
    [
      [
        85374,
        71112
      ],
      [
        49,
        54
      ],
      [
        62,
        22
      ],
      [
        87,
        0
      ],
      [
        0,
        195
      ],
      [
        25,
        11
      ],
      [
        12,
        -22
      ],
      [
        25,
        22
      ],
      [
        24,
        -22
      ],
      [
        25,
        11
      ],
      [
        25,
        -11
      ],
      [
        37,
        0
      ],
      [
        74,
        11
      ],
      [
        38,
        -11
      ],
      [
        49,
        -54
      ],
      [
        37,
        -11
      ],
      [
        75,
        22
      ],
      [
        24,
        54
      ],
      [
        62,
        43
      ],
      [
        75,
        33
      ],
      [
        12,
        11
      ],
      [
        12,
        -22
      ],
      [
        0,
        -65
      ],
      [
        50,
        -33
      ],
      [
        37,
        22
      ],
      [
        37,
        65
      ],
      [
        25,
        -11
      ],
      [
        13,
        33
      ],
      [
        -25,
        54
      ],
      [
        0,
        76
      ],
      [
        25,
        43
      ],
      [
        0,
        44
      ],
      [
        -25,
        87
      ],
      [
        -25,
        108
      ],
      [
        -37,
        87
      ],
      [
        -50,
        141
      ],
      [
        13,
        119
      ],
      [
        -13,
        33
      ],
      [
        -25,
        21
      ],
      [
        -24,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -13,
        11
      ],
      [
        -62,
        130
      ],
      [
        -12,
        44
      ],
      [
        0,
        54
      ],
      [
        25,
        87
      ],
      [
        0,
        87
      ],
      [
        12,
        75
      ],
      [
        -37,
        66
      ],
      [
        -49,
        10
      ],
      [
        -62,
        22
      ],
      [
        -50,
        43
      ],
      [
        -37,
        44
      ],
      [
        0,
        119
      ],
      [
        12,
        109
      ],
      [
        13,
        32
      ],
      [
        37,
        54
      ],
      [
        25,
        22
      ],
      [
        111,
        239
      ],
      [
        25,
        97
      ],
      [
        62,
        87
      ],
      [
        25,
        22
      ],
      [
        37,
        0
      ],
      [
        49,
        -55
      ],
      [
        0,
        -54
      ],
      [
        13,
        -43
      ],
      [
        37,
        -43
      ],
      [
        37,
        10
      ],
      [
        136,
        87
      ],
      [
        87,
        11
      ],
      [
        62,
        22
      ],
      [
        49,
        32
      ],
      [
        25,
        130
      ],
      [
        87,
        152
      ],
      [
        12,
        98
      ],
      [
        37,
        108
      ],
      [
        100,
        98
      ],
      [
        99,
        76
      ],
      [
        12,
        43
      ],
      [
        62,
        174
      ],
      [
        50,
        151
      ],
      [
        12,
        98
      ],
      [
        25,
        98
      ],
      [
        37,
        32
      ],
      [
        62,
        33
      ],
      [
        49,
        43
      ],
      [
        50,
        76
      ],
      [
        -12,
        33
      ],
      [
        -13,
        76
      ],
      [
        50,
        75
      ],
      [
        62,
        163
      ],
      [
        49,
        76
      ],
      [
        13,
        0
      ],
      [
        49,
        43
      ],
      [
        37,
        44
      ],
      [
        -12,
        43
      ],
      [
        -25,
        11
      ],
      [
        0,
        87
      ],
      [
        25,
        130
      ],
      [
        0,
        32
      ],
      [
        -25,
        120
      ],
      [
        0,
        32
      ],
      [
        37,
        76
      ],
      [
        149,
        130
      ],
      [
        25,
        0
      ],
      [
        37,
        33
      ],
      [
        25,
        43
      ],
      [
        0,
        65
      ],
      [
        -25,
        33
      ],
      [
        -87,
        54
      ],
      [
        -74,
        0
      ],
      [
        -37,
        22
      ],
      [
        -13,
        65
      ],
      [
        13,
        97
      ],
      [
        -62,
        11
      ],
      [
        -50,
        0
      ],
      [
        -12,
        22
      ],
      [
        12,
        33
      ],
      [
        -12,
        43
      ],
      [
        0,
        43
      ],
      [
        -13,
        0
      ],
      [
        -49,
        44
      ],
      [
        -50,
        76
      ],
      [
        0,
        32
      ],
      [
        25,
        33
      ],
      [
        25,
        54
      ],
      [
        0,
        43
      ],
      [
        12,
        33
      ],
      [
        -37,
        54
      ],
      [
        -25,
        22
      ],
      [
        0,
        97
      ],
      [
        75,
        65
      ],
      [
        12,
        44
      ],
      [
        -12,
        32
      ],
      [
        -38,
        0
      ],
      [
        -49,
        11
      ],
      [
        -12,
        11
      ],
      [
        0,
        43
      ],
      [
        24,
        55
      ],
      [
        0,
        21
      ],
      [
        -24,
        33
      ],
      [
        -38,
        22
      ],
      [
        0,
        65
      ],
      [
        50,
        141
      ],
      [
        124,
        75
      ],
      [
        223,
        -75
      ],
      [
        74,
        -11
      ],
      [
        25,
        -22
      ],
      [
        124,
        -54
      ],
      [
        37,
        0
      ],
      [
        49,
        32
      ],
      [
        25,
        33
      ],
      [
        37,
        32
      ],
      [
        50,
        0
      ],
      [
        99,
        55
      ],
      [
        37,
        -11
      ],
      [
        37,
        32
      ],
      [
        25,
        33
      ],
      [
        0,
        22
      ],
      [
        87,
        75
      ],
      [
        12,
        44
      ],
      [
        0,
        32
      ]
    ],
    [
      [
        88433,
        78150
      ],
      [
        87,
        76
      ],
      [
        37,
        44
      ],
      [
        62,
        43
      ],
      [
        37,
        43
      ],
      [
        37,
        33
      ]
    ],
    [
      [
        88693,
        78389
      ],
      [
        13,
        -22
      ],
      [
        25,
        -11
      ],
      [
        49,
        22
      ],
      [
        -12,
        -108
      ],
      [
        0,
        -33
      ],
      [
        24,
        -76
      ],
      [
        50,
        -228
      ],
      [
        12,
        -75
      ],
      [
        25,
        -22
      ],
      [
        62,
        -33
      ],
      [
        50,
        -32
      ],
      [
        37,
        -33
      ],
      [
        25,
        -43
      ],
      [
        24,
        -22
      ],
      [
        25,
        -54
      ],
      [
        -25,
        -43
      ],
      [
        -62,
        -65
      ],
      [
        0,
        -55
      ],
      [
        13,
        -76
      ],
      [
        0,
        -141
      ],
      [
        12,
        -97
      ],
      [
        13,
        -44
      ],
      [
        62,
        -86
      ],
      [
        37,
        -76
      ],
      [
        0,
        -44
      ],
      [
        -13,
        -54
      ],
      [
        37,
        -43
      ],
      [
        0,
        -87
      ],
      [
        13,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -87
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -62,
        87
      ],
      [
        0,
        43
      ],
      [
        -12,
        22
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -12,
        -32
      ],
      [
        24,
        -76
      ],
      [
        0,
        -55
      ],
      [
        13,
        -54
      ],
      [
        62,
        -119
      ],
      [
        24,
        -22
      ],
      [
        -12,
        -65
      ]
    ],
    [
      [
        95246,
        48608
      ],
      [
        -12,
        11
      ],
      [
        0,
        22
      ],
      [
        12,
        0
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        98306,
        49660
      ],
      [
        -12,
        -43
      ],
      [
        -38,
        32
      ],
      [
        0,
        33
      ],
      [
        25,
        0
      ],
      [
        13,
        21
      ],
      [
        12,
        -43
      ]
    ],
    [
      [
        86860,
        51601
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        65
      ],
      [
        25,
        32
      ],
      [
        12,
        -10
      ],
      [
        -12,
        -55
      ]
    ],
    [
      [
        58505,
        89896
      ],
      [
        -24,
        0
      ],
      [
        -13,
        21
      ],
      [
        -74,
        11
      ],
      [
        25,
        33
      ],
      [
        12,
        -11
      ],
      [
        50,
        0
      ],
      [
        24,
        -54
      ]
    ],
    [
      [
        59781,
        90004
      ],
      [
        25,
        -43
      ],
      [
        -62,
        -22
      ],
      [
        0,
        -65
      ],
      [
        25,
        -32
      ],
      [
        25,
        -120
      ],
      [
        24,
        -87
      ],
      [
        -12,
        -21
      ],
      [
        12,
        -44
      ],
      [
        -12,
        -21
      ],
      [
        12,
        -44
      ],
      [
        25,
        -130
      ],
      [
        13,
        -97
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        -119
      ],
      [
        -13,
        -76
      ],
      [
        -37,
        -87
      ],
      [
        -49,
        -43
      ],
      [
        49,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        22
      ],
      [
        -25,
        0
      ],
      [
        -49,
        -33
      ],
      [
        -12,
        55
      ],
      [
        -25,
        -55
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        11
      ],
      [
        -112,
        -33
      ],
      [
        -24,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        -75,
        -22
      ],
      [
        -24,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -50,
        44
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -11
      ],
      [
        -49,
        -43
      ],
      [
        -50,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -161,
        -54
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -49,
        0
      ],
      [
        -62,
        -32
      ],
      [
        -37,
        10
      ],
      [
        37,
        76
      ],
      [
        62,
        33
      ],
      [
        -13,
        22
      ],
      [
        -111,
        -33
      ],
      [
        -75,
        -33
      ],
      [
        13,
        44
      ],
      [
        111,
        97
      ],
      [
        -111,
        -32
      ],
      [
        -50,
        11
      ],
      [
        0,
        21
      ],
      [
        -37,
        -10
      ],
      [
        -12,
        43
      ],
      [
        74,
        98
      ],
      [
        74,
        32
      ],
      [
        13,
        22
      ],
      [
        -25,
        11
      ],
      [
        -149,
        0
      ],
      [
        13,
        43
      ],
      [
        49,
        43
      ],
      [
        37,
        11
      ],
      [
        62,
        -32
      ],
      [
        62,
        11
      ],
      [
        -24,
        21
      ],
      [
        -25,
        76
      ],
      [
        49,
        33
      ],
      [
        37,
        54
      ],
      [
        25,
        11
      ],
      [
        87,
        11
      ],
      [
        87,
        21
      ],
      [
        99,
        44
      ],
      [
        -50,
        11
      ],
      [
        -25,
        32
      ],
      [
        -37,
        -54
      ],
      [
        -24,
        -22
      ],
      [
        -75,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        -21
      ],
      [
        0,
        43
      ],
      [
        87,
        76
      ],
      [
        37,
        76
      ],
      [
        -25,
        32
      ],
      [
        62,
        98
      ],
      [
        50,
        11
      ],
      [
        25,
        22
      ],
      [
        24,
        0
      ],
      [
        25,
        32
      ],
      [
        -37,
        22
      ],
      [
        -161,
        0
      ],
      [
        -25,
        21
      ],
      [
        -12,
        33
      ],
      [
        -74,
        -11
      ],
      [
        -13,
        22
      ],
      [
        25,
        32
      ],
      [
        -74,
        0
      ],
      [
        -25,
        11
      ],
      [
        12,
        44
      ],
      [
        -25,
        10
      ],
      [
        0,
        33
      ],
      [
        38,
        0
      ],
      [
        49,
        22
      ],
      [
        -12,
        43
      ],
      [
        0,
        43
      ],
      [
        49,
        33
      ],
      [
        62,
        11
      ],
      [
        0,
        54
      ],
      [
        -62,
        0
      ],
      [
        -49,
        -11
      ],
      [
        0,
        44
      ],
      [
        12,
        43
      ],
      [
        0,
        54
      ],
      [
        -25,
        -11
      ],
      [
        0,
        44
      ],
      [
        -12,
        21
      ],
      [
        -37,
        -10
      ],
      [
        0,
        32
      ],
      [
        25,
        43
      ],
      [
        62,
        -10
      ],
      [
        37,
        21
      ],
      [
        136,
        0
      ],
      [
        62,
        -54
      ],
      [
        37,
        43
      ],
      [
        99,
        -10
      ],
      [
        50,
        -22
      ],
      [
        25,
        11
      ],
      [
        -38,
        65
      ],
      [
        25,
        32
      ],
      [
        112,
        65
      ],
      [
        12,
        44
      ],
      [
        25,
        43
      ],
      [
        -112,
        -21
      ],
      [
        -99,
        43
      ],
      [
        13,
        32
      ],
      [
        62,
        33
      ],
      [
        49,
        65
      ],
      [
        -12,
        43
      ],
      [
        12,
        33
      ],
      [
        25,
        22
      ],
      [
        12,
        65
      ],
      [
        50,
        0
      ],
      [
        49,
        21
      ],
      [
        62,
        11
      ],
      [
        13,
        33
      ],
      [
        37,
        0
      ],
      [
        37,
        -54
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        13,
        -33
      ],
      [
        37,
        33
      ],
      [
        0,
        65
      ],
      [
        -13,
        54
      ],
      [
        25,
        22
      ],
      [
        50,
        11
      ],
      [
        -25,
        43
      ],
      [
        49,
        0
      ],
      [
        25,
        -33
      ],
      [
        75,
        -43
      ],
      [
        -38,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        81261,
        73031
      ],
      [
        -37,
        -75
      ],
      [
        -50,
        -66
      ],
      [
        -37,
        22
      ],
      [
        -62,
        -32
      ],
      [
        -37,
        -44
      ],
      [
        -50,
        -21
      ],
      [
        -37,
        10
      ],
      [
        13,
        33
      ],
      [
        62,
        43
      ],
      [
        86,
        65
      ],
      [
        -12,
        65
      ],
      [
        12,
        11
      ],
      [
        50,
        -21
      ],
      [
        49,
        43
      ],
      [
        50,
        22
      ],
      [
        25,
        -33
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        78734,
        80222
      ],
      [
        12,
        -185
      ],
      [
        37,
        -227
      ],
      [
        25,
        -65
      ],
      [
        37,
        -44
      ],
      [
        62,
        -54
      ],
      [
        38,
        -11
      ],
      [
        86,
        -11
      ],
      [
        87,
        -21
      ],
      [
        49,
        -22
      ],
      [
        38,
        -43
      ],
      [
        37,
        -120
      ],
      [
        74,
        -86
      ],
      [
        136,
        -120
      ],
      [
        62,
        -43
      ],
      [
        223,
        -87
      ],
      [
        149,
        11
      ],
      [
        396,
        152
      ],
      [
        137,
        32
      ],
      [
        24,
        -21
      ],
      [
        -49,
        -22
      ],
      [
        25,
        -22
      ],
      [
        74,
        0
      ],
      [
        25,
        54
      ],
      [
        -13,
        33
      ],
      [
        -12,
        141
      ],
      [
        -25,
        98
      ]
    ],
    [
      [
        80468,
        79539
      ],
      [
        99,
        0
      ],
      [
        37,
        10
      ],
      [
        100,
        55
      ],
      [
        24,
        0
      ],
      [
        13,
        21
      ],
      [
        24,
        11
      ],
      [
        25,
        141
      ],
      [
        87,
        109
      ],
      [
        49,
        54
      ],
      [
        50,
        43
      ],
      [
        74,
        33
      ],
      [
        87,
        -11
      ],
      [
        112,
        0
      ],
      [
        24,
        -11
      ],
      [
        25,
        11
      ],
      [
        0,
        65
      ],
      [
        50,
        33
      ],
      [
        37,
        0
      ],
      [
        37,
        10
      ],
      [
        87,
        -32
      ],
      [
        99,
        0
      ],
      [
        37,
        -44
      ],
      [
        0,
        -32
      ],
      [
        12,
        -33
      ],
      [
        0,
        -43
      ],
      [
        62,
        -22
      ],
      [
        62,
        -11
      ],
      [
        62,
        -32
      ],
      [
        25,
        -22
      ],
      [
        49,
        -21
      ],
      [
        50,
        -76
      ],
      [
        62,
        -22
      ],
      [
        37,
        32
      ],
      [
        50,
        -21
      ],
      [
        49,
        21
      ],
      [
        37,
        -21
      ],
      [
        99,
        -87
      ],
      [
        13,
        11
      ],
      [
        25,
        -33
      ],
      [
        12,
        -86
      ],
      [
        25,
        -55
      ],
      [
        37,
        -43
      ],
      [
        136,
        -87
      ],
      [
        37,
        -54
      ],
      [
        38,
        -76
      ],
      [
        49,
        -119
      ],
      [
        285,
        0
      ],
      [
        12,
        -44
      ],
      [
        0,
        -173
      ],
      [
        13,
        -65
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -54
      ],
      [
        13,
        -11
      ],
      [
        12,
        -54
      ],
      [
        0,
        -130
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        83008,
        78465
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -43
      ],
      [
        12,
        -33
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -87
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        0,
        -33
      ],
      [
        12,
        -11
      ],
      [
        37,
        -97
      ],
      [
        -86,
        -11
      ],
      [
        -25,
        -55
      ],
      [
        -25,
        -75
      ],
      [
        12,
        -152
      ],
      [
        -12,
        -87
      ],
      [
        25,
        -76
      ],
      [
        37,
        -22
      ],
      [
        50,
        0
      ],
      [
        37,
        -11
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        -49,
        -119
      ],
      [
        0,
        -54
      ],
      [
        12,
        -33
      ],
      [
        13,
        -130
      ],
      [
        24,
        -119
      ],
      [
        50,
        -217
      ],
      [
        -12,
        -54
      ],
      [
        -13,
        -109
      ],
      [
        0,
        -76
      ],
      [
        13,
        -86
      ],
      [
        -13,
        -44
      ],
      [
        13,
        -108
      ],
      [
        12,
        0
      ],
      [
        173,
        -44
      ],
      [
        112,
        -21
      ],
      [
        25,
        -65
      ],
      [
        24,
        -131
      ],
      [
        0,
        -97
      ],
      [
        -12,
        -54
      ],
      [
        -74,
        -141
      ],
      [
        -87,
        -152
      ],
      [
        -74,
        -141
      ]
    ],
    [
      [
        82946,
        75038
      ],
      [
        -87,
        -174
      ]
    ],
    [
      [
        82859,
        74864
      ],
      [
        62,
        -119
      ],
      [
        49,
        -76
      ],
      [
        62,
        -130
      ],
      [
        0,
        -43
      ],
      [
        75,
        -250
      ],
      [
        62,
        -119
      ],
      [
        49,
        -76
      ],
      [
        50,
        -43
      ],
      [
        37,
        0
      ],
      [
        74,
        -44
      ],
      [
        75,
        -108
      ],
      [
        61,
        11
      ],
      [
        0,
        -163
      ],
      [
        13,
        -119
      ],
      [
        12,
        -196
      ],
      [
        -25,
        -86
      ],
      [
        0,
        -65
      ],
      [
        50,
        -22
      ],
      [
        99,
        22
      ],
      [
        25,
        -33
      ],
      [
        12,
        -43
      ],
      [
        -25,
        -87
      ],
      [
        13,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -119
      ],
      [
        -25,
        -11
      ],
      [
        -112,
        11
      ],
      [
        -37,
        -33
      ],
      [
        -74,
        -21
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -43
      ],
      [
        -37,
        10
      ],
      [
        -13,
        -32
      ],
      [
        -86,
        -43
      ],
      [
        -13,
        -55
      ],
      [
        -24,
        -206
      ],
      [
        -25,
        -32
      ],
      [
        0,
        -55
      ],
      [
        -13,
        -65
      ],
      [
        -12,
        -184
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        83119,
        71958
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -62,
        21
      ],
      [
        -49,
        33
      ],
      [
        -149,
        65
      ],
      [
        -12,
        22
      ],
      [
        -13,
        54
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -76
      ],
      [
        -136,
        43
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -62,
        0
      ],
      [
        -62,
        54
      ],
      [
        -75,
        -32
      ],
      [
        -61,
        -11
      ],
      [
        -87,
        87
      ],
      [
        -87,
        21
      ],
      [
        -111,
        0
      ],
      [
        -62,
        33
      ],
      [
        -37,
        32
      ],
      [
        -50,
        -21
      ],
      [
        -12,
        43
      ],
      [
        -149,
        44
      ],
      [
        -25,
        75
      ],
      [
        -12,
        76
      ],
      [
        0,
        76
      ],
      [
        -37,
        130
      ],
      [
        -13,
        196
      ],
      [
        -25,
        141
      ],
      [
        -24,
        54
      ],
      [
        -37,
        65
      ],
      [
        -25,
        22
      ],
      [
        -137,
        43
      ],
      [
        -74,
        -33
      ],
      [
        -62,
        -65
      ],
      [
        -99,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        -65
      ],
      [
        -38,
        -43
      ],
      [
        -37,
        11
      ],
      [
        -49,
        -33
      ],
      [
        -87,
        -108
      ],
      [
        -50,
        -33
      ],
      [
        -37,
        0
      ],
      [
        -49,
        54
      ],
      [
        -87,
        65
      ],
      [
        -62,
        22
      ],
      [
        -87,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -74,
        76
      ],
      [
        -12,
        54
      ],
      [
        -38,
        44
      ],
      [
        -124,
        86
      ],
      [
        -99,
        109
      ],
      [
        -24,
        43
      ],
      [
        -13,
        65
      ],
      [
        -37,
        76
      ],
      [
        -99,
        65
      ],
      [
        -62,
        65
      ],
      [
        -62,
        11
      ],
      [
        -62,
        0
      ],
      [
        -25,
        11
      ],
      [
        -24,
        33
      ],
      [
        -87,
        141
      ],
      [
        0,
        54
      ],
      [
        -50,
        130
      ],
      [
        -12,
        54
      ],
      [
        -12,
        130
      ],
      [
        -13,
        33
      ],
      [
        -49,
        54
      ],
      [
        -13,
        33
      ],
      [
        13,
        54
      ],
      [
        0,
        32
      ],
      [
        -25,
        33
      ],
      [
        -37,
        22
      ],
      [
        -13,
        43
      ],
      [
        0,
        130
      ],
      [
        -37,
        76
      ],
      [
        -62,
        87
      ],
      [
        -49,
        119
      ],
      [
        -25,
        33
      ],
      [
        -25,
        173
      ],
      [
        -37,
        0
      ],
      [
        -149,
        -108
      ],
      [
        -37,
        65
      ],
      [
        -136,
        108
      ],
      [
        -13,
        44
      ],
      [
        38,
        21
      ],
      [
        24,
        -21
      ],
      [
        25,
        21
      ],
      [
        -12,
        33
      ],
      [
        -25,
        32
      ],
      [
        -50,
        -10
      ],
      [
        13,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -13,
        -44
      ],
      [
        0,
        -54
      ],
      [
        13,
        -76
      ],
      [
        -37,
        -54
      ],
      [
        -50,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        78622,
        74929
      ],
      [
        -37,
        44
      ],
      [
        -12,
        54
      ],
      [
        0,
        76
      ],
      [
        -37,
        43
      ],
      [
        -25,
        11
      ],
      [
        -25,
        54
      ],
      [
        -25,
        33
      ],
      [
        -12,
        0
      ],
      [
        0,
        228
      ],
      [
        -12,
        97
      ],
      [
        -50,
        11
      ],
      [
        -62,
        0
      ],
      [
        0,
        250
      ],
      [
        50,
        249
      ],
      [
        -37,
        87
      ],
      [
        -38,
        97
      ],
      [
        -24,
        33
      ],
      [
        -38,
        119
      ],
      [
        -12,
        54
      ],
      [
        -12,
        22
      ],
      [
        -25,
        11
      ],
      [
        -50,
        -11
      ],
      [
        -111,
        141
      ],
      [
        -87,
        87
      ],
      [
        -62,
        65
      ],
      [
        -25,
        11
      ],
      [
        -62,
        11
      ],
      [
        -12,
        10
      ],
      [
        0,
        66
      ],
      [
        25,
        54
      ],
      [
        0,
        32
      ],
      [
        -62,
        152
      ],
      [
        -37,
        11
      ],
      [
        12,
        32
      ],
      [
        0,
        33
      ],
      [
        -12,
        22
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        54
      ],
      [
        -74,
        141
      ],
      [
        -25,
        22
      ],
      [
        12,
        54
      ],
      [
        37,
        65
      ],
      [
        0,
        87
      ],
      [
        -37,
        87
      ],
      [
        25,
        65
      ],
      [
        0,
        32
      ],
      [
        49,
        0
      ],
      [
        0,
        109
      ],
      [
        13,
        32
      ],
      [
        74,
        141
      ],
      [
        50,
        33
      ],
      [
        24,
        32
      ],
      [
        13,
        44
      ],
      [
        -13,
        21
      ],
      [
        0,
        55
      ],
      [
        -37,
        65
      ],
      [
        -12,
        54
      ],
      [
        25,
        97
      ],
      [
        49,
        22
      ],
      [
        25,
        22
      ],
      [
        0,
        22
      ],
      [
        -37,
        32
      ],
      [
        -149,
        0
      ],
      [
        -25,
        65
      ],
      [
        -37,
        33
      ],
      [
        -49,
        11
      ],
      [
        -13,
        32
      ],
      [
        -37,
        184
      ],
      [
        -12,
        33
      ],
      [
        -37,
        0
      ],
      [
        -25,
        43
      ],
      [
        0,
        120
      ],
      [
        -50,
        86
      ],
      [
        -49,
        217
      ]
    ],
    [
      [
        77322,
        79419
      ],
      [
        0,
        44
      ],
      [
        12,
        43
      ],
      [
        -25,
        43
      ],
      [
        -49,
        55
      ],
      [
        0,
        97
      ],
      [
        -13,
        22
      ],
      [
        13,
        65
      ],
      [
        -62,
        54
      ],
      [
        -25,
        33
      ],
      [
        -37,
        0
      ],
      [
        0,
        54
      ],
      [
        25,
        43
      ],
      [
        25,
        65
      ],
      [
        0,
        44
      ],
      [
        12,
        32
      ],
      [
        25,
        33
      ],
      [
        -13,
        32
      ],
      [
        -49,
        11
      ],
      [
        0,
        163
      ],
      [
        -13,
        33
      ],
      [
        13,
        86
      ],
      [
        -37,
        65
      ],
      [
        -13,
        33
      ],
      [
        13,
        22
      ],
      [
        0,
        75
      ],
      [
        -38,
        44
      ],
      [
        0,
        65
      ],
      [
        -12,
        43
      ],
      [
        37,
        11
      ],
      [
        62,
        -11
      ],
      [
        25,
        22
      ],
      [
        25,
        152
      ],
      [
        12,
        43
      ],
      [
        25,
        22
      ],
      [
        49,
        -54
      ],
      [
        38,
        -22
      ]
    ],
    [
      [
        78437,
        74940
      ],
      [
        -87,
        65
      ],
      [
        -25,
        11
      ],
      [
        -49,
        0
      ],
      [
        -62,
        -11
      ],
      [
        -38,
        -21
      ],
      [
        -49,
        -65
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -98
      ],
      [
        -25,
        -76
      ],
      [
        -74,
        -173
      ],
      [
        -62,
        -109
      ]
    ],
    [
      [
        77929,
        74387
      ],
      [
        -50,
        -22
      ],
      [
        -297,
        44
      ],
      [
        -161,
        22
      ],
      [
        -124,
        21
      ],
      [
        -111,
        152
      ],
      [
        -87,
        108
      ],
      [
        -112,
        152
      ],
      [
        -111,
        141
      ],
      [
        -124,
        152
      ],
      [
        -87,
        109
      ],
      [
        -99,
        141
      ],
      [
        -87,
        119
      ],
      [
        -74,
        97
      ],
      [
        -99,
        98
      ],
      [
        -273,
        239
      ],
      [
        -74,
        76
      ],
      [
        -148,
        130
      ],
      [
        -223,
        65
      ],
      [
        -124,
        32
      ],
      [
        -75,
        22
      ]
    ],
    [
      [
        75389,
        76285
      ],
      [
        50,
        65
      ],
      [
        -12,
        76
      ],
      [
        -38,
        -11
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        109
      ],
      [
        25,
        11
      ],
      [
        -25,
        130
      ],
      [
        -50,
        282
      ],
      [
        -25,
        130
      ]
    ],
    [
      [
        75265,
        77055
      ],
      [
        100,
        98
      ],
      [
        173,
        151
      ],
      [
        99,
        98
      ],
      [
        198,
        174
      ],
      [
        87,
        86
      ],
      [
        87,
        33
      ],
      [
        12,
        22
      ],
      [
        50,
        119
      ],
      [
        24,
        97
      ],
      [
        0,
        163
      ],
      [
        13,
        163
      ],
      [
        25,
        163
      ],
      [
        24,
        54
      ],
      [
        0,
        108
      ],
      [
        -24,
        76
      ],
      [
        -13,
        87
      ],
      [
        0,
        130
      ],
      [
        13,
        65
      ],
      [
        37,
        76
      ],
      [
        136,
        54
      ],
      [
        62,
        98
      ],
      [
        37,
        43
      ],
      [
        99,
        174
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        76504,
        79398
      ],
      [
        25,
        10
      ],
      [
        62,
        76
      ],
      [
        37,
        65
      ],
      [
        12,
        11
      ],
      [
        62,
        -32
      ],
      [
        50,
        32
      ],
      [
        25,
        -21
      ],
      [
        49,
        -11
      ],
      [
        87,
        -54
      ],
      [
        37,
        0
      ],
      [
        62,
        -11
      ],
      [
        50,
        54
      ],
      [
        37,
        0
      ],
      [
        12,
        -11
      ],
      [
        25,
        -54
      ],
      [
        0,
        -119
      ],
      [
        25,
        -22
      ],
      [
        37,
        54
      ],
      [
        37,
        33
      ],
      [
        37,
        43
      ],
      [
        50,
        -22
      ]
    ],
    [
      [
        78622,
        74929
      ],
      [
        -24,
        -10
      ],
      [
        -37,
        10
      ],
      [
        -75,
        55
      ],
      [
        -25,
        0
      ],
      [
        -24,
        -22
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        56573,
        97585
      ],
      [
        37,
        0
      ],
      [
        99,
        33
      ],
      [
        62,
        54
      ],
      [
        37,
        11
      ],
      [
        62,
        -11
      ],
      [
        -74,
        -54
      ],
      [
        -37,
        -66
      ],
      [
        -37,
        -43
      ],
      [
        37,
        -32
      ],
      [
        37,
        -11
      ],
      [
        62,
        11
      ],
      [
        25,
        -66
      ],
      [
        -62,
        -119
      ],
      [
        136,
        22
      ],
      [
        25,
        -11
      ],
      [
        0,
        -43
      ],
      [
        25,
        -55
      ],
      [
        49,
        11
      ],
      [
        74,
        -11
      ],
      [
        38,
        -21
      ],
      [
        12,
        -33
      ],
      [
        37,
        11
      ],
      [
        25,
        -43
      ],
      [
        -25,
        -55
      ],
      [
        -37,
        -21
      ],
      [
        25,
        -44
      ],
      [
        25,
        0
      ],
      [
        0,
        -32
      ],
      [
        -38,
        -33
      ],
      [
        62,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -24,
        -32
      ],
      [
        -75,
        -11
      ],
      [
        13,
        -54
      ],
      [
        -13,
        -33
      ],
      [
        -62,
        -76
      ],
      [
        -86,
        -11
      ],
      [
        -62,
        -54
      ],
      [
        24,
        -32
      ],
      [
        -49,
        -87
      ],
      [
        -161,
        -87
      ],
      [
        -87,
        0
      ],
      [
        -74,
        -32
      ],
      [
        -124,
        -44
      ],
      [
        -136,
        -87
      ],
      [
        -75,
        -75
      ],
      [
        -99,
        -44
      ],
      [
        -124,
        -22
      ],
      [
        -185,
        -43
      ],
      [
        -62,
        -22
      ],
      [
        0,
        -21
      ],
      [
        -38,
        -22
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        -22
      ],
      [
        -62,
        11
      ],
      [
        12,
        -32
      ],
      [
        -148,
        -44
      ],
      [
        -211,
        22
      ],
      [
        -74,
        32
      ],
      [
        -99,
        33
      ],
      [
        -62,
        11
      ],
      [
        -87,
        0
      ],
      [
        -74,
        54
      ],
      [
        -25,
        33
      ],
      [
        0,
        32
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        44
      ],
      [
        -49,
        0
      ],
      [
        -50,
        21
      ],
      [
        -74,
        65
      ],
      [
        -75,
        -54
      ],
      [
        -309,
        0
      ],
      [
        -99,
        -11
      ],
      [
        -13,
        22
      ],
      [
        -24,
        98
      ],
      [
        12,
        32
      ],
      [
        25,
        0
      ],
      [
        24,
        -43
      ],
      [
        25,
        -11
      ],
      [
        112,
        32
      ],
      [
        62,
        33
      ],
      [
        62,
        65
      ],
      [
        12,
        54
      ],
      [
        37,
        44
      ],
      [
        25,
        11
      ],
      [
        -12,
        21
      ],
      [
        -112,
        -54
      ],
      [
        -25,
        0
      ],
      [
        25,
        43
      ],
      [
        -12,
        11
      ],
      [
        12,
        65
      ],
      [
        87,
        55
      ],
      [
        37,
        10
      ],
      [
        -25,
        22
      ],
      [
        -87,
        -54
      ],
      [
        -62,
        -22
      ],
      [
        -61,
        33
      ],
      [
        -13,
        43
      ],
      [
        25,
        43
      ],
      [
        -74,
        44
      ],
      [
        -87,
        0
      ],
      [
        -211,
        22
      ],
      [
        -49,
        -11
      ],
      [
        -75,
        -33
      ],
      [
        -49,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -25,
        76
      ],
      [
        50,
        22
      ],
      [
        61,
        -11
      ],
      [
        75,
        21
      ],
      [
        37,
        0
      ],
      [
        49,
        33
      ],
      [
        38,
        -22
      ],
      [
        99,
        33
      ],
      [
        12,
        21
      ],
      [
        37,
        -10
      ],
      [
        62,
        0
      ],
      [
        62,
        10
      ],
      [
        149,
        0
      ],
      [
        25,
        22
      ],
      [
        24,
        54
      ],
      [
        -12,
        11
      ],
      [
        -87,
        -43
      ],
      [
        -124,
        22
      ],
      [
        -37,
        32
      ],
      [
        62,
        54
      ],
      [
        62,
        33
      ],
      [
        87,
        32
      ],
      [
        12,
        33
      ],
      [
        -49,
        32
      ],
      [
        -112,
        -10
      ],
      [
        -25,
        32
      ],
      [
        -86,
        22
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -74,
        -33
      ],
      [
        -174,
        -43
      ],
      [
        -99,
        -33
      ],
      [
        -37,
        22
      ],
      [
        -74,
        22
      ],
      [
        -75,
        10
      ],
      [
        -12,
        11
      ],
      [
        49,
        55
      ],
      [
        25,
        10
      ],
      [
        99,
        -43
      ],
      [
        -12,
        87
      ],
      [
        -37,
        43
      ],
      [
        12,
        11
      ],
      [
        62,
        -11
      ],
      [
        99,
        -54
      ],
      [
        50,
        11
      ],
      [
        49,
        43
      ],
      [
        -86,
        0
      ],
      [
        -38,
        11
      ],
      [
        -49,
        43
      ],
      [
        37,
        22
      ],
      [
        74,
        0
      ],
      [
        -86,
        76
      ],
      [
        12,
        43
      ],
      [
        87,
        -32
      ],
      [
        0,
        22
      ],
      [
        -37,
        21
      ],
      [
        12,
        33
      ],
      [
        62,
        21
      ],
      [
        99,
        -54
      ],
      [
        25,
        -32
      ],
      [
        0,
        -33
      ],
      [
        62,
        0
      ],
      [
        37,
        33
      ],
      [
        37,
        -22
      ],
      [
        25,
        -65
      ],
      [
        37,
        11
      ],
      [
        0,
        97
      ],
      [
        -149,
        65
      ],
      [
        -24,
        33
      ],
      [
        99,
        43
      ],
      [
        -13,
        22
      ],
      [
        -49,
        -11
      ],
      [
        -99,
        11
      ],
      [
        12,
        33
      ],
      [
        50,
        32
      ],
      [
        173,
        0
      ],
      [
        87,
        -87
      ],
      [
        74,
        -21
      ],
      [
        0,
        -11
      ],
      [
        112,
        -98
      ],
      [
        86,
        -54
      ],
      [
        -49,
        -22
      ],
      [
        49,
        -21
      ],
      [
        25,
        -33
      ],
      [
        -25,
        -87
      ],
      [
        -25,
        -32
      ],
      [
        0,
        -33
      ],
      [
        38,
        -43
      ],
      [
        -25,
        -65
      ],
      [
        37,
        0
      ],
      [
        25,
        -33
      ],
      [
        25,
        -65
      ],
      [
        24,
        -11
      ],
      [
        13,
        87
      ],
      [
        24,
        11
      ],
      [
        13,
        76
      ],
      [
        49,
        43
      ],
      [
        50,
        11
      ],
      [
        37,
        -43
      ],
      [
        37,
        -11
      ],
      [
        37,
        97
      ],
      [
        0,
        66
      ],
      [
        -12,
        75
      ],
      [
        25,
        87
      ],
      [
        37,
        11
      ],
      [
        62,
        -32
      ],
      [
        49,
        -76
      ],
      [
        75,
        -87
      ],
      [
        62,
        -22
      ],
      [
        12,
        22
      ],
      [
        0,
        152
      ],
      [
        25,
        21
      ],
      [
        62,
        11
      ],
      [
        62,
        44
      ],
      [
        74,
        10
      ],
      [
        74,
        -65
      ],
      [
        38,
        -65
      ],
      [
        62,
        -54
      ],
      [
        37,
        -76
      ],
      [
        24,
        -11
      ],
      [
        0,
        55
      ],
      [
        -12,
        43
      ],
      [
        -62,
        119
      ],
      [
        13,
        44
      ],
      [
        136,
        -11
      ],
      [
        111,
        -109
      ],
      [
        50,
        33
      ],
      [
        111,
        119
      ],
      [
        62,
        -43
      ],
      [
        62,
        -11
      ],
      [
        37,
        32
      ],
      [
        50,
        11
      ],
      [
        25,
        55
      ],
      [
        -37,
        108
      ],
      [
        12,
        22
      ],
      [
        87,
        21
      ],
      [
        74,
        0
      ],
      [
        62,
        -54
      ],
      [
        49,
        -54
      ],
      [
        0,
        -43
      ],
      [
        50,
        -33
      ]
    ],
    [
      [
        74151,
        76448
      ],
      [
        -50,
        32
      ],
      [
        0,
        33
      ],
      [
        -74,
        21
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -76
      ],
      [
        0,
        -55
      ],
      [
        13,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -13,
        -32
      ],
      [
        38,
        11
      ],
      [
        49,
        -33
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -44
      ],
      [
        -12,
        -108
      ],
      [
        12,
        -11
      ],
      [
        62,
        11
      ],
      [
        62,
        32
      ],
      [
        37,
        44
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        74126,
        75873
      ],
      [
        -25,
        -152
      ],
      [
        12,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -87
      ],
      [
        -37,
        -119
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -98
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -173
      ],
      [
        -24,
        -98
      ],
      [
        0,
        -54
      ],
      [
        -38,
        -206
      ]
    ],
    [
      [
        73952,
        74680
      ],
      [
        -24,
        -54
      ]
    ],
    [
      [
        73705,
        75710
      ],
      [
        37,
        54
      ],
      [
        0,
        44
      ],
      [
        62,
        97
      ],
      [
        -13,
        44
      ]
    ],
    [
      [
        73791,
        75949
      ],
      [
        62,
        184
      ],
      [
        50,
        195
      ],
      [
        37,
        261
      ],
      [
        25,
        130
      ],
      [
        25,
        87
      ],
      [
        12,
        76
      ]
    ],
    [
      [
        74002,
        76882
      ],
      [
        74,
        0
      ],
      [
        37,
        -11
      ],
      [
        25,
        32
      ],
      [
        13,
        76
      ],
      [
        12,
        22
      ],
      [
        12,
        -22
      ],
      [
        13,
        22
      ],
      [
        37,
        32
      ],
      [
        25,
        55
      ],
      [
        12,
        10
      ]
    ],
    [
      [
        74262,
        77098
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -32
      ],
      [
        24,
        -54
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -33
      ],
      [
        12,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        74237,
        76665
      ],
      [
        -62,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        -12,
        -141
      ]
    ],
    [
      [
        66074,
        79170
      ],
      [
        -25,
        0
      ],
      [
        -12,
        22
      ],
      [
        0,
        32
      ],
      [
        25,
        -11
      ],
      [
        12,
        -43
      ]
    ],
    [
      [
        67288,
        80092
      ],
      [
        -25,
        -76
      ],
      [
        -99,
        -195
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -120
      ],
      [
        12,
        -75
      ],
      [
        37,
        -55
      ],
      [
        -25,
        -32
      ],
      [
        25,
        -44
      ],
      [
        25,
        -21
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -98
      ],
      [
        -37,
        11
      ],
      [
        -37,
        22
      ],
      [
        -50,
        -11
      ],
      [
        -87,
        54
      ],
      [
        -49,
        109
      ],
      [
        -37,
        43
      ],
      [
        -37,
        33
      ],
      [
        -38,
        11
      ],
      [
        -49,
        -11
      ],
      [
        -37,
        21
      ],
      [
        -75,
        76
      ],
      [
        -111,
        98
      ],
      [
        -25,
        43
      ],
      [
        -49,
        22
      ],
      [
        -38,
        33
      ],
      [
        -24,
        10
      ],
      [
        -50,
        -10
      ],
      [
        -62,
        65
      ],
      [
        -37,
        97
      ],
      [
        49,
        141
      ],
      [
        13,
        22
      ],
      [
        25,
        11
      ],
      [
        24,
        54
      ],
      [
        50,
        -98
      ],
      [
        25,
        0
      ],
      [
        25,
        33
      ],
      [
        12,
        32
      ],
      [
        37,
        33
      ],
      [
        37,
        0
      ],
      [
        25,
        -11
      ],
      [
        25,
        -43
      ],
      [
        25,
        0
      ],
      [
        74,
        -76
      ],
      [
        25,
        0
      ],
      [
        86,
        32
      ],
      [
        87,
        -10
      ],
      [
        74,
        21
      ],
      [
        50,
        22
      ],
      [
        25,
        43
      ],
      [
        25,
        11
      ],
      [
        61,
        0
      ],
      [
        50,
        -11
      ],
      [
        25,
        11
      ],
      [
        25,
        33
      ],
      [
        24,
        0
      ],
      [
        50,
        43
      ],
      [
        25,
        0
      ],
      [
        24,
        -22
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        64848,
        80623
      ],
      [
        -25,
        -65
      ],
      [
        -25,
        43
      ],
      [
        0,
        44
      ],
      [
        50,
        -22
      ]
    ],
    [
      [
        66718,
        81643
      ],
      [
        -25,
        0
      ],
      [
        0,
        32
      ],
      [
        38,
        -11
      ],
      [
        -13,
        -21
      ]
    ],
    [
      [
        64773,
        81849
      ],
      [
        -12,
        -33
      ],
      [
        -12,
        33
      ],
      [
        37,
        54
      ],
      [
        12,
        -11
      ],
      [
        -25,
        -43
      ]
    ],
    [
      [
        65244,
        81751
      ],
      [
        13,
        -43
      ],
      [
        37,
        -163
      ],
      [
        0,
        -65
      ],
      [
        -50,
        -109
      ],
      [
        0,
        -75
      ],
      [
        25,
        -87
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -358
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -55
      ],
      [
        -37,
        -11
      ],
      [
        -74,
        44
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -12,
        -120
      ],
      [
        -50,
        -76
      ],
      [
        -37,
        -10
      ],
      [
        -50,
        10
      ],
      [
        -25,
        66
      ],
      [
        -49,
        108
      ],
      [
        0,
        54
      ],
      [
        -12,
        120
      ],
      [
        24,
        54
      ],
      [
        13,
        97
      ],
      [
        12,
        11
      ],
      [
        0,
        65
      ],
      [
        -12,
        33
      ],
      [
        -25,
        11
      ],
      [
        -12,
        43
      ],
      [
        24,
        65
      ],
      [
        0,
        130
      ],
      [
        -24,
        98
      ],
      [
        -13,
        32
      ],
      [
        -25,
        33
      ],
      [
        -12,
        32
      ],
      [
        -25,
        33
      ],
      [
        0,
        76
      ],
      [
        13,
        54
      ],
      [
        0,
        33
      ],
      [
        49,
        -44
      ],
      [
        37,
        -11
      ],
      [
        37,
        11
      ],
      [
        50,
        33
      ],
      [
        37,
        32
      ],
      [
        62,
        98
      ],
      [
        62,
        43
      ],
      [
        0,
        44
      ],
      [
        12,
        11
      ],
      [
        25,
        -44
      ],
      [
        25,
        0
      ],
      [
        37,
        -32
      ],
      [
        25,
        -55
      ],
      [
        25,
        -21
      ],
      [
        -25,
        -54
      ],
      [
        37,
        -33
      ]
    ],
    [
      [
        65504,
        82987
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -11
      ],
      [
        0,
        -32
      ],
      [
        -25,
        21
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        0
      ],
      [
        0,
        44
      ],
      [
        50,
        0
      ],
      [
        37,
        11
      ],
      [
        12,
        21
      ]
    ],
    [
      [
        66644,
        85276
      ],
      [
        -13,
        -44
      ],
      [
        -12,
        0
      ],
      [
        -62,
        -54
      ],
      [
        -25,
        -32
      ],
      [
        0,
        -55
      ],
      [
        25,
        0
      ],
      [
        25,
        -21
      ],
      [
        37,
        -11
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        -55
      ],
      [
        13,
        -21
      ],
      [
        37,
        10
      ],
      [
        -13,
        -108
      ],
      [
        37,
        -11
      ],
      [
        50,
        -76
      ],
      [
        12,
        -54
      ],
      [
        -49,
        0
      ]
    ],
    [
      [
        66644,
        84690
      ],
      [
        25,
        22
      ],
      [
        -50,
        97
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -43
      ],
      [
        -87,
        43
      ],
      [
        -24,
        -21
      ],
      [
        -13,
        -33
      ],
      [
        -24,
        -32
      ],
      [
        -50,
        -22
      ],
      [
        -136,
        -87
      ],
      [
        -25,
        0
      ],
      [
        -25,
        22
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -76
      ],
      [
        12,
        -22
      ],
      [
        38,
        -97
      ],
      [
        49,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        -24,
        -22
      ],
      [
        -38,
        22
      ],
      [
        -12,
        -76
      ],
      [
        25,
        -185
      ],
      [
        25,
        -119
      ],
      [
        37,
        -65
      ],
      [
        62,
        -87
      ],
      [
        74,
        -43
      ],
      [
        136,
        -141
      ],
      [
        99,
        -76
      ],
      [
        37,
        -119
      ],
      [
        38,
        -130
      ],
      [
        74,
        -304
      ],
      [
        62,
        -109
      ],
      [
        124,
        -173
      ],
      [
        111,
        -119
      ],
      [
        99,
        -65
      ],
      [
        87,
        -22
      ],
      [
        186,
        22
      ],
      [
        37,
        -11
      ],
      [
        37,
        -22
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        -43
      ],
      [
        -37,
        -44
      ],
      [
        0,
        -76
      ],
      [
        37,
        -43
      ],
      [
        185,
        -130
      ],
      [
        186,
        -109
      ],
      [
        62,
        -54
      ],
      [
        62,
        -76
      ],
      [
        174,
        -119
      ],
      [
        24,
        -54
      ],
      [
        99,
        -120
      ],
      [
        50,
        -97
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -76
      ],
      [
        -13,
        -43
      ],
      [
        -25,
        -55
      ],
      [
        -37,
        22
      ],
      [
        -49,
        54
      ],
      [
        -75,
        206
      ],
      [
        -136,
        22
      ],
      [
        -74,
        54
      ],
      [
        0,
        22
      ],
      [
        -25,
        43
      ],
      [
        -49,
        11
      ],
      [
        -38,
        -32
      ],
      [
        -86,
        -206
      ],
      [
        -50,
        -174
      ],
      [
        0,
        -65
      ],
      [
        25,
        -76
      ],
      [
        74,
        -32
      ],
      [
        62,
        -65
      ],
      [
        37,
        -55
      ],
      [
        13,
        -162
      ],
      [
        12,
        -76
      ],
      [
        -25,
        -55
      ],
      [
        -49,
        11
      ],
      [
        -75,
        -32
      ],
      [
        -37,
        -54
      ],
      [
        -25,
        -55
      ],
      [
        0,
        -184
      ],
      [
        -99,
        -108
      ],
      [
        -49,
        -98
      ],
      [
        -25,
        -87
      ],
      [
        -111,
        0
      ],
      [
        -25,
        54
      ],
      [
        -13,
        87
      ],
      [
        25,
        54
      ],
      [
        37,
        22
      ],
      [
        38,
        119
      ],
      [
        -13,
        76
      ],
      [
        13,
        44
      ],
      [
        24,
        21
      ],
      [
        75,
        33
      ],
      [
        0,
        108
      ],
      [
        -38,
        55
      ],
      [
        -12,
        75
      ],
      [
        -12,
        131
      ],
      [
        -62,
        173
      ],
      [
        -25,
        152
      ],
      [
        -25,
        76
      ],
      [
        -37,
        32
      ],
      [
        -74,
        0
      ],
      [
        -25,
        11
      ],
      [
        -124,
        109
      ],
      [
        0,
        43
      ],
      [
        12,
        43
      ],
      [
        -24,
        109
      ],
      [
        -25,
        54
      ],
      [
        -25,
        22
      ],
      [
        -74,
        -33
      ],
      [
        -25,
        11
      ],
      [
        -50,
        -22
      ],
      [
        50,
        76
      ],
      [
        -12,
        22
      ],
      [
        -50,
        33
      ],
      [
        -62,
        10
      ],
      [
        -12,
        -21
      ],
      [
        -13,
        11
      ],
      [
        0,
        32
      ],
      [
        -62,
        163
      ],
      [
        -62,
        76
      ],
      [
        -49,
        -11
      ],
      [
        -62,
        32
      ],
      [
        -62,
        0
      ],
      [
        -25,
        -21
      ],
      [
        -24,
        11
      ],
      [
        0,
        21
      ],
      [
        -62,
        65
      ],
      [
        -75,
        44
      ],
      [
        -148,
        217
      ],
      [
        -50,
        76
      ],
      [
        -87,
        86
      ],
      [
        -62,
        130
      ],
      [
        -49,
        44
      ],
      [
        -62,
        43
      ],
      [
        -37,
        -21
      ],
      [
        -37,
        10
      ],
      [
        12,
        22
      ],
      [
        25,
        11
      ],
      [
        -13,
        43
      ],
      [
        -74,
        130
      ],
      [
        -49,
        44
      ],
      [
        -50,
        97
      ],
      [
        -25,
        -10
      ],
      [
        -25,
        10
      ],
      [
        0,
        65
      ],
      [
        13,
        44
      ],
      [
        -37,
        141
      ],
      [
        -38,
        97
      ],
      [
        -24,
        207
      ],
      [
        -25,
        65
      ],
      [
        -50,
        43
      ],
      [
        -111,
        43
      ],
      [
        -149,
        141
      ],
      [
        -37,
        0
      ],
      [
        -87,
        55
      ],
      [
        -62,
        10
      ],
      [
        -62,
        -43
      ],
      [
        -99,
        -141
      ],
      [
        -74,
        -130
      ],
      [
        -25,
        -22
      ],
      [
        -86,
        -54
      ],
      [
        -87,
        -22
      ]
    ],
    [
      [
        66186,
        83660
      ],
      [
        12,
        -22
      ],
      [
        25,
        0
      ],
      [
        12,
        33
      ],
      [
        -25,
        21
      ],
      [
        -24,
        -32
      ]
    ],
    [
      [
        35341,
        67739
      ],
      [
        37,
        -22
      ],
      [
        50,
        -11
      ],
      [
        37,
        0
      ],
      [
        37,
        -54
      ],
      [
        37,
        -32
      ],
      [
        112,
        -65
      ],
      [
        49,
        -120
      ],
      [
        0,
        -32
      ],
      [
        -24,
        -22
      ],
      [
        -38,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -37,
        22
      ],
      [
        -12,
        22
      ],
      [
        -37,
        11
      ],
      [
        -13,
        21
      ],
      [
        -25,
        0
      ],
      [
        -24,
        -87
      ],
      [
        -38,
        11
      ],
      [
        -12,
        22
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -75
      ],
      [
        -25,
        32
      ],
      [
        -37,
        33
      ],
      [
        -37,
        21
      ],
      [
        -62,
        0
      ],
      [
        -37,
        11
      ],
      [
        -25,
        65
      ],
      [
        -13,
        22
      ],
      [
        -24,
        22
      ],
      [
        -37,
        75
      ],
      [
        0,
        11
      ],
      [
        -87,
        22
      ],
      [
        -13,
        43
      ],
      [
        0,
        33
      ],
      [
        38,
        54
      ],
      [
        12,
        11
      ],
      [
        37,
        0
      ],
      [
        37,
        11
      ],
      [
        37,
        32
      ],
      [
        149,
        -32
      ],
      [
        25,
        0
      ],
      [
        37,
        -11
      ]
    ],
    [
      [
        61231,
        86968
      ],
      [
        0,
        -33
      ],
      [
        -75,
        0
      ],
      [
        0,
        54
      ],
      [
        75,
        -21
      ]
    ],
    [
      [
        74126,
        75873
      ],
      [
        0,
        54
      ],
      [
        12,
        76
      ],
      [
        25,
        54
      ],
      [
        -12,
        141
      ],
      [
        0,
        65
      ],
      [
        12,
        87
      ],
      [
        -12,
        98
      ]
    ],
    [
      [
        74237,
        76665
      ],
      [
        37,
        -11
      ],
      [
        25,
        -33
      ],
      [
        37,
        -87
      ],
      [
        50,
        -21
      ],
      [
        25,
        -22
      ],
      [
        25,
        -43
      ],
      [
        37,
        -22
      ],
      [
        124,
        -22
      ],
      [
        161,
        163
      ],
      [
        99,
        98
      ],
      [
        62,
        54
      ],
      [
        99,
        108
      ],
      [
        74,
        65
      ],
      [
        87,
        87
      ],
      [
        86,
        76
      ]
    ],
    [
      [
        75389,
        76285
      ],
      [
        -49,
        -76
      ],
      [
        -75,
        -43
      ],
      [
        -136,
        -54
      ],
      [
        -87,
        -44
      ],
      [
        -222,
        -97
      ],
      [
        -174,
        -87
      ],
      [
        124,
        -217
      ],
      [
        111,
        -195
      ],
      [
        50,
        -98
      ],
      [
        62,
        -108
      ],
      [
        -112,
        -98
      ],
      [
        -12,
        -22
      ],
      [
        -49,
        -195
      ],
      [
        -100,
        -32
      ],
      [
        -86,
        -33
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -74,
        -216
      ],
      [
        -62,
        -87
      ],
      [
        -75,
        -98
      ],
      [
        -24,
        0
      ],
      [
        -137,
        33
      ],
      [
        -86,
        32
      ],
      [
        -62,
        11
      ],
      [
        -75,
        22
      ]
    ],
    [
      [
        73952,
        74550
      ],
      [
        13,
        87
      ],
      [
        -13,
        43
      ]
    ],
    [
      [
        104549,
        71383
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        11
      ],
      [
        0,
        22
      ],
      [
        25,
        21
      ],
      [
        12,
        44
      ],
      [
        50,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        104685,
        71524
      ],
      [
        -12,
        -98
      ],
      [
        -25,
        -10
      ],
      [
        -12,
        10
      ],
      [
        -25,
        55
      ],
      [
        12,
        21
      ],
      [
        38,
        -11
      ],
      [
        24,
        76
      ],
      [
        13,
        -10
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        105082,
        71665
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        11
      ],
      [
        12,
        87
      ],
      [
        13,
        -11
      ],
      [
        0,
        -33
      ],
      [
        37,
        -43
      ]
    ],
    [
      [
        110842,
        72836
      ],
      [
        -25,
        65
      ],
      [
        25,
        0
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        106048,
        72858
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -33
      ],
      [
        13,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -32
      ],
      [
        12,
        -33
      ],
      [
        -24,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -13,
        43
      ],
      [
        13,
        22
      ],
      [
        25,
        76
      ],
      [
        0,
        76
      ],
      [
        24,
        21
      ],
      [
        50,
        76
      ],
      [
        -25,
        22
      ],
      [
        0,
        33
      ],
      [
        13,
        10
      ],
      [
        24,
        -10
      ],
      [
        13,
        -22
      ],
      [
        24,
        11
      ],
      [
        38,
        87
      ],
      [
        12,
        54
      ],
      [
        25,
        -44
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -43
      ]
    ],
    [
      [
        106308,
        73530
      ],
      [
        -12,
        -10
      ],
      [
        -25,
        10
      ],
      [
        0,
        109
      ],
      [
        25,
        11
      ],
      [
        12,
        -65
      ],
      [
        0,
        -55
      ]
    ],
    [
      [
        106420,
        73769
      ],
      [
        0,
        -11
      ],
      [
        -38,
        11
      ],
      [
        -12,
        54
      ],
      [
        25,
        -11
      ],
      [
        25,
        -43
      ]
    ],
    [
      [
        106469,
        73834
      ],
      [
        -37,
        -54
      ],
      [
        -25,
        54
      ],
      [
        -37,
        22
      ],
      [
        25,
        21
      ],
      [
        0,
        22
      ],
      [
        25,
        33
      ],
      [
        62,
        21
      ],
      [
        24,
        22
      ],
      [
        38,
        54
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        -76
      ],
      [
        -25,
        -21
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        106866,
        75114
      ],
      [
        -38,
        -11
      ],
      [
        -24,
        11
      ],
      [
        -13,
        87
      ],
      [
        37,
        43
      ],
      [
        50,
        -43
      ],
      [
        -12,
        -87
      ]
    ],
    [
      [
        106977,
        75201
      ],
      [
        -25,
        -11
      ],
      [
        0,
        43
      ],
      [
        25,
        76
      ],
      [
        0,
        65
      ],
      [
        25,
        76
      ],
      [
        25,
        0
      ],
      [
        -13,
        -98
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -86
      ]
    ],
    [
      [
        106779,
        76469
      ],
      [
        -37,
        0
      ],
      [
        -13,
        22
      ],
      [
        50,
        43
      ],
      [
        37,
        -10
      ],
      [
        -37,
        -55
      ]
    ],
    [
      [
        106680,
        76350
      ],
      [
        -25,
        -22
      ],
      [
        0,
        76
      ],
      [
        -12,
        11
      ],
      [
        12,
        76
      ],
      [
        0,
        33
      ],
      [
        50,
        21
      ],
      [
        12,
        -32
      ],
      [
        0,
        -98
      ],
      [
        -37,
        -65
      ]
    ],
    [
      [
        106197,
        76697
      ],
      [
        12,
        -22
      ],
      [
        37,
        11
      ],
      [
        25,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -10
      ],
      [
        -13,
        -33
      ],
      [
        -24,
        11
      ],
      [
        -13,
        22
      ],
      [
        13,
        97
      ]
    ],
    [
      [
        110037,
        76860
      ],
      [
        -25,
        22
      ],
      [
        0,
        21
      ],
      [
        37,
        -21
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        106333,
        76730
      ],
      [
        -12,
        -11
      ],
      [
        0,
        54
      ],
      [
        -13,
        22
      ],
      [
        13,
        11
      ],
      [
        24,
        65
      ],
      [
        13,
        -44
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        -54
      ]
    ],
    [
      [
        106482,
        76968
      ],
      [
        -25,
        -32
      ],
      [
        0,
        54
      ],
      [
        12,
        43
      ],
      [
        13,
        -32
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        106581,
        77294
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        22
      ],
      [
        0,
        54
      ],
      [
        12,
        11
      ],
      [
        25,
        -11
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        107051,
        77207
      ],
      [
        50,
        -22
      ],
      [
        25,
        0
      ],
      [
        37,
        33
      ],
      [
        37,
        21
      ],
      [
        37,
        -32
      ],
      [
        13,
        -33
      ],
      [
        -38,
        -97
      ],
      [
        -37,
        -76
      ],
      [
        62,
        -11
      ],
      [
        62,
        0
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -44
      ],
      [
        37,
        -43
      ],
      [
        -12,
        -44
      ],
      [
        37,
        -43
      ],
      [
        -13,
        -43
      ],
      [
        -86,
        -152
      ],
      [
        -50,
        -174
      ],
      [
        -25,
        -130
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -76
      ],
      [
        13,
        -65
      ],
      [
        -13,
        -76
      ],
      [
        -37,
        -162
      ],
      [
        -37,
        0
      ],
      [
        -37,
        21
      ],
      [
        -25,
        0
      ],
      [
        0,
        -32
      ],
      [
        13,
        -76
      ],
      [
        -62,
        -98
      ],
      [
        -75,
        -54
      ],
      [
        0,
        43
      ],
      [
        25,
        44
      ],
      [
        13,
        65
      ],
      [
        -13,
        76
      ],
      [
        -25,
        86
      ],
      [
        0,
        33
      ],
      [
        25,
        11
      ],
      [
        13,
        22
      ],
      [
        0,
        32
      ],
      [
        -13,
        22
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -98
      ],
      [
        -13,
        -65
      ],
      [
        13,
        -32
      ],
      [
        0,
        -33
      ],
      [
        37,
        -54
      ],
      [
        -25,
        -54
      ],
      [
        -136,
        75
      ],
      [
        -12,
        66
      ],
      [
        49,
        32
      ],
      [
        12,
        87
      ],
      [
        -24,
        65
      ],
      [
        -25,
        43
      ],
      [
        12,
        55
      ],
      [
        -12,
        65
      ],
      [
        0,
        86
      ],
      [
        49,
        33
      ],
      [
        50,
        97
      ],
      [
        25,
        98
      ],
      [
        37,
        98
      ],
      [
        -50,
        21
      ],
      [
        25,
        55
      ],
      [
        -12,
        54
      ],
      [
        -37,
        76
      ],
      [
        -25,
        87
      ],
      [
        -25,
        43
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -44
      ],
      [
        25,
        -54
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -54
      ],
      [
        49,
        11
      ],
      [
        13,
        -33
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        22
      ],
      [
        -12,
        32
      ],
      [
        -38,
        11
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -33
      ],
      [
        25,
        98
      ],
      [
        -12,
        32
      ],
      [
        -37,
        65
      ],
      [
        0,
        33
      ],
      [
        -13,
        43
      ],
      [
        13,
        33
      ],
      [
        37,
        -44
      ],
      [
        12,
        -54
      ],
      [
        25,
        -21
      ],
      [
        37,
        -11
      ],
      [
        -25,
        86
      ],
      [
        -124,
        163
      ],
      [
        13,
        65
      ],
      [
        25,
        11
      ],
      [
        49,
        -22
      ],
      [
        12,
        33
      ],
      [
        -12,
        32
      ],
      [
        37,
        33
      ],
      [
        62,
        32
      ],
      [
        13,
        44
      ],
      [
        37,
        -11
      ],
      [
        37,
        33
      ],
      [
        25,
        54
      ],
      [
        0,
        32
      ],
      [
        12,
        33
      ],
      [
        62,
        54
      ],
      [
        62,
        0
      ],
      [
        37,
        -32
      ],
      [
        25,
        -55
      ],
      [
        12,
        -65
      ],
      [
        37,
        -43
      ]
    ],
    [
      [
        107435,
        77413
      ],
      [
        13,
        -22
      ],
      [
        37,
        11
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -21
      ],
      [
        -49,
        11
      ],
      [
        0,
        54
      ],
      [
        24,
        -11
      ]
    ],
    [
      [
        107534,
        77521
      ],
      [
        0,
        -21
      ],
      [
        -37,
        11
      ],
      [
        25,
        43
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        106407,
        77532
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        43
      ],
      [
        12,
        109
      ],
      [
        38,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -65
      ]
    ],
    [
      [
        108154,
        77608
      ],
      [
        49,
        -22
      ],
      [
        50,
        11
      ],
      [
        -12,
        -119
      ],
      [
        24,
        -76
      ],
      [
        0,
        -43
      ],
      [
        13,
        -22
      ],
      [
        -62,
        -54
      ],
      [
        -62,
        -76
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -174
      ],
      [
        -25,
        33
      ],
      [
        -49,
        97
      ],
      [
        -38,
        22
      ],
      [
        -62,
        22
      ],
      [
        -136,
        -98
      ],
      [
        -12,
        -76
      ],
      [
        -50,
        -130
      ],
      [
        -24,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -86
      ],
      [
        -37,
        -55
      ],
      [
        -50,
        11
      ],
      [
        -25,
        -11
      ],
      [
        25,
        87
      ],
      [
        -37,
        11
      ],
      [
        -37,
        0
      ],
      [
        0,
        54
      ],
      [
        -25,
        33
      ],
      [
        25,
        43
      ],
      [
        0,
        54
      ],
      [
        12,
        55
      ],
      [
        -37,
        21
      ],
      [
        0,
        65
      ],
      [
        -50,
        -10
      ],
      [
        -62,
        -44
      ],
      [
        0,
        33
      ],
      [
        62,
        43
      ],
      [
        25,
        33
      ],
      [
        99,
        108
      ],
      [
        25,
        65
      ],
      [
        0,
        33
      ],
      [
        25,
        86
      ],
      [
        25,
        22
      ],
      [
        24,
        44
      ],
      [
        25,
        0
      ],
      [
        13,
        -66
      ],
      [
        37,
        -43
      ],
      [
        49,
        33
      ],
      [
        62,
        0
      ],
      [
        37,
        32
      ],
      [
        25,
        65
      ],
      [
        0,
        65
      ],
      [
        25,
        0
      ],
      [
        37,
        44
      ],
      [
        37,
        32
      ],
      [
        50,
        0
      ],
      [
        49,
        -21
      ],
      [
        50,
        -44
      ]
    ],
    [
      [
        108154,
        77749
      ],
      [
        -13,
        0
      ],
      [
        -24,
        -32
      ],
      [
        -25,
        43
      ],
      [
        0,
        22
      ],
      [
        62,
        0
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        108352,
        77630
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        10
      ],
      [
        -25,
        55
      ],
      [
        37,
        43
      ],
      [
        25,
        65
      ],
      [
        25,
        33
      ],
      [
        37,
        11
      ],
      [
        -37,
        -87
      ],
      [
        12,
        -76
      ]
    ],
    [
      [
        106444,
        77673
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        43
      ],
      [
        25,
        98
      ],
      [
        0,
        54
      ],
      [
        49,
        43
      ],
      [
        0,
        -86
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        109900,
        77901
      ],
      [
        -12,
        -22
      ],
      [
        -12,
        22
      ],
      [
        0,
        32
      ],
      [
        24,
        0
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        107807,
        78834
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        11
      ],
      [
        -25,
        32
      ],
      [
        12,
        44
      ],
      [
        25,
        22
      ],
      [
        37,
        -55
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        109529,
        79842
      ],
      [
        -25,
        22
      ],
      [
        12,
        87
      ],
      [
        -24,
        0
      ],
      [
        0,
        54
      ],
      [
        12,
        43
      ],
      [
        62,
        87
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -86
      ],
      [
        0,
        -33
      ],
      [
        37,
        0
      ],
      [
        -25,
        -98
      ],
      [
        -49,
        -54
      ]
    ],
    [
      [
        110520,
        82055
      ],
      [
        12,
        -11
      ],
      [
        62,
        32
      ],
      [
        -25,
        -195
      ],
      [
        13,
        -152
      ],
      [
        0,
        -76
      ],
      [
        12,
        -76
      ],
      [
        25,
        -43
      ],
      [
        37,
        -32
      ],
      [
        50,
        -120
      ],
      [
        37,
        -141
      ],
      [
        25,
        -141
      ],
      [
        12,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -33
      ],
      [
        -25,
        -249
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -44
      ],
      [
        -50,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -141
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        0
      ],
      [
        -62,
        -43
      ],
      [
        -37,
        -98
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -65
      ],
      [
        25,
        -152
      ],
      [
        13,
        -152
      ],
      [
        -13,
        -216
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        -13,
        -76
      ],
      [
        -37,
        -141
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -98
      ],
      [
        25,
        -108
      ],
      [
        50,
        -130
      ],
      [
        12,
        -43
      ],
      [
        25,
        -33
      ],
      [
        -87,
        -43
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        -76
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -76
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        -44
      ],
      [
        -37,
        -54
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        11
      ],
      [
        -13,
        33
      ],
      [
        13,
        32
      ],
      [
        0,
        174
      ],
      [
        25,
        32
      ],
      [
        12,
        55
      ],
      [
        49,
        65
      ],
      [
        0,
        32
      ],
      [
        -12,
        33
      ],
      [
        -25,
        21
      ],
      [
        -49,
        -10
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        0,
        -54
      ],
      [
        25,
        -66
      ],
      [
        -38,
        -54
      ],
      [
        -24,
        65
      ],
      [
        -25,
        33
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -119
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        54
      ],
      [
        12,
        109
      ],
      [
        0,
        65
      ],
      [
        38,
        32
      ],
      [
        -25,
        44
      ],
      [
        -37,
        10
      ],
      [
        -50,
        -21
      ],
      [
        -25,
        -65
      ],
      [
        -86,
        -152
      ],
      [
        -25,
        -87
      ],
      [
        -74,
        33
      ],
      [
        -75,
        0
      ],
      [
        -74,
        10
      ],
      [
        -74,
        -21
      ],
      [
        -87,
        -33
      ],
      [
        0,
        22
      ],
      [
        74,
        54
      ],
      [
        0,
        43
      ],
      [
        -62,
        -10
      ],
      [
        -24,
        10
      ],
      [
        -25,
        44
      ],
      [
        -13,
        -11
      ],
      [
        13,
        -65
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        22
      ],
      [
        0,
        43
      ],
      [
        -12,
        65
      ],
      [
        0,
        44
      ],
      [
        12,
        32
      ],
      [
        -12,
        22
      ],
      [
        -38,
        -22
      ],
      [
        -62,
        -152
      ],
      [
        -12,
        -65
      ],
      [
        37,
        -54
      ],
      [
        87,
        -98
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -43
      ],
      [
        -100,
        -44
      ],
      [
        -74,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -74,
        -196
      ],
      [
        -49,
        -141
      ],
      [
        -75,
        -43
      ],
      [
        -87,
        43
      ],
      [
        -37,
        109
      ],
      [
        -62,
        108
      ],
      [
        -12,
        65
      ],
      [
        0,
        109
      ],
      [
        -12,
        65
      ],
      [
        12,
        22
      ],
      [
        50,
        43
      ],
      [
        37,
        65
      ],
      [
        12,
        33
      ],
      [
        0,
        43
      ],
      [
        -25,
        22
      ],
      [
        -49,
        0
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        21
      ],
      [
        -49,
        55
      ],
      [
        -25,
        10
      ],
      [
        -50,
        0
      ],
      [
        -37,
        -10
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -99,
        -119
      ],
      [
        -38,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -74,
        -43
      ],
      [
        -12,
        10
      ],
      [
        -99,
        -86
      ],
      [
        -37,
        21
      ],
      [
        -87,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -50,
        22
      ],
      [
        -37,
        43
      ],
      [
        -37,
        -21
      ],
      [
        -25,
        -55
      ],
      [
        -12,
        -130
      ],
      [
        -25,
        -119
      ],
      [
        -136,
        141
      ],
      [
        -87,
        -22
      ],
      [
        -87,
        -43
      ],
      [
        -25,
        11
      ],
      [
        -24,
        32
      ],
      [
        -38,
        -11
      ],
      [
        -24,
        -21
      ],
      [
        -13,
        184
      ],
      [
        25,
        54
      ],
      [
        25,
        22
      ],
      [
        37,
        11
      ],
      [
        50,
        -11
      ],
      [
        24,
        11
      ],
      [
        37,
        43
      ],
      [
        50,
        87
      ],
      [
        50,
        32
      ],
      [
        37,
        33
      ],
      [
        74,
        108
      ],
      [
        74,
        87
      ],
      [
        112,
        174
      ],
      [
        49,
        86
      ],
      [
        62,
        44
      ],
      [
        75,
        22
      ],
      [
        37,
        0
      ],
      [
        49,
        -55
      ],
      [
        38,
        22
      ],
      [
        37,
        11
      ],
      [
        49,
        -11
      ],
      [
        75,
        0
      ],
      [
        86,
        22
      ],
      [
        37,
        32
      ],
      [
        50,
        22
      ],
      [
        136,
        22
      ],
      [
        99,
        54
      ],
      [
        38,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -44
      ],
      [
        13,
        -21
      ],
      [
        24,
        -11
      ],
      [
        87,
        -11
      ],
      [
        37,
        -11
      ],
      [
        75,
        65
      ],
      [
        61,
        98
      ],
      [
        -24,
        76
      ],
      [
        0,
        65
      ],
      [
        12,
        86
      ],
      [
        37,
        65
      ],
      [
        37,
        33
      ],
      [
        25,
        54
      ],
      [
        74,
        130
      ],
      [
        50,
        109
      ],
      [
        12,
        130
      ],
      [
        -12,
        152
      ],
      [
        50,
        108
      ],
      [
        161,
        98
      ],
      [
        12,
        -54
      ],
      [
        -74,
        -98
      ],
      [
        -37,
        -43
      ],
      [
        -38,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        37,
        -55
      ],
      [
        13,
        -43
      ],
      [
        0,
        -76
      ],
      [
        37,
        -43
      ],
      [
        37,
        -11
      ],
      [
        37,
        11
      ],
      [
        50,
        97
      ],
      [
        0,
        22
      ],
      [
        148,
        65
      ],
      [
        62,
        54
      ],
      [
        37,
        11
      ],
      [
        37,
        33
      ],
      [
        112,
        162
      ],
      [
        25,
        55
      ],
      [
        12,
        65
      ],
      [
        25,
        65
      ],
      [
        25,
        43
      ],
      [
        124,
        109
      ],
      [
        49,
        75
      ],
      [
        25,
        163
      ],
      [
        12,
        65
      ],
      [
        50,
        120
      ],
      [
        37,
        54
      ],
      [
        50,
        282
      ],
      [
        49,
        108
      ],
      [
        0,
        217
      ],
      [
        -37,
        87
      ],
      [
        -50,
        -11
      ],
      [
        -24,
        33
      ],
      [
        12,
        21
      ],
      [
        25,
        0
      ],
      [
        25,
        33
      ],
      [
        24,
        76
      ],
      [
        13,
        76
      ],
      [
        0,
        32
      ],
      [
        -13,
        65
      ],
      [
        -24,
        76
      ],
      [
        0,
        43
      ],
      [
        37,
        76
      ],
      [
        49,
        22
      ],
      [
        37,
        33
      ],
      [
        0,
        21
      ],
      [
        25,
        65
      ],
      [
        0,
        33
      ],
      [
        -12,
        98
      ],
      [
        25,
        43
      ],
      [
        24,
        -11
      ],
      [
        37,
        0
      ],
      [
        25,
        -11
      ],
      [
        13,
        -184
      ],
      [
        24,
        -44
      ],
      [
        25,
        0
      ],
      [
        25,
        66
      ],
      [
        12,
        0
      ],
      [
        75,
        -33
      ],
      [
        37,
        65
      ],
      [
        12,
        76
      ],
      [
        -12,
        65
      ],
      [
        -13,
        22
      ],
      [
        -49,
        -33
      ],
      [
        -87,
        -32
      ],
      [
        0,
        65
      ],
      [
        13,
        108
      ],
      [
        12,
        33
      ],
      [
        25,
        21
      ],
      [
        37,
        -21
      ],
      [
        62,
        -65
      ]
    ],
    [
      [
        109913,
        82499
      ],
      [
        -13,
        0
      ],
      [
        -12,
        55
      ],
      [
        25,
        43
      ],
      [
        25,
        0
      ],
      [
        -13,
        -87
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        110532,
        84397
      ],
      [
        -49,
        22
      ],
      [
        0,
        32
      ],
      [
        37,
        22
      ],
      [
        25,
        -32
      ],
      [
        -13,
        -44
      ]
    ],
    [
      [
        110458,
        84527
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        119
      ],
      [
        37,
        -11
      ],
      [
        0,
        -76
      ]
    ],
    [
      [
        111412,
        83768
      ],
      [
        62,
        0
      ],
      [
        24,
        -11
      ],
      [
        137,
        -86
      ],
      [
        74,
        -22
      ],
      [
        37,
        11
      ],
      [
        99,
        141
      ],
      [
        87,
        108
      ],
      [
        12,
        -32
      ],
      [
        -49,
        -130
      ],
      [
        -37,
        -131
      ],
      [
        -13,
        -65
      ],
      [
        13,
        -65
      ],
      [
        49,
        -119
      ],
      [
        25,
        -109
      ],
      [
        50,
        -10
      ],
      [
        37,
        32
      ],
      [
        24,
        33
      ],
      [
        25,
        11
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        -65
      ],
      [
        -12,
        -10
      ],
      [
        -50,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -74,
        -65
      ],
      [
        -38,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -62,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -74,
        21
      ],
      [
        -37,
        0
      ],
      [
        -75,
        -65
      ],
      [
        -74,
        -76
      ],
      [
        -62,
        -97
      ],
      [
        -50,
        -109
      ],
      [
        -24,
        -65
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -87
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        22
      ],
      [
        -74,
        54
      ],
      [
        -137,
        87
      ],
      [
        -148,
        141
      ],
      [
        -75,
        65
      ],
      [
        -148,
        -22
      ],
      [
        -149,
        -130
      ],
      [
        -12,
        11
      ],
      [
        -87,
        119
      ],
      [
        -25,
        11
      ],
      [
        -49,
        0
      ],
      [
        -37,
        -54
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -22
      ],
      [
        37,
        -87
      ],
      [
        37,
        -43
      ],
      [
        25,
        -11
      ],
      [
        37,
        11
      ],
      [
        12,
        -11
      ],
      [
        62,
        -87
      ],
      [
        62,
        -76
      ],
      [
        13,
        -32
      ],
      [
        -50,
        -44
      ],
      [
        -62,
        22
      ],
      [
        -49,
        33
      ],
      [
        -62,
        -87
      ],
      [
        -37,
        -98
      ],
      [
        -38,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -37,
        87
      ],
      [
        13,
        76
      ],
      [
        24,
        65
      ],
      [
        13,
        65
      ],
      [
        -25,
        97
      ],
      [
        -49,
        76
      ],
      [
        -25,
        55
      ],
      [
        0,
        108
      ],
      [
        12,
        87
      ],
      [
        0,
        43
      ],
      [
        50,
        22
      ],
      [
        74,
        65
      ],
      [
        37,
        43
      ],
      [
        37,
        55
      ],
      [
        13,
        65
      ],
      [
        -37,
        119
      ],
      [
        0,
        32
      ],
      [
        37,
        33
      ],
      [
        37,
        -22
      ],
      [
        62,
        -65
      ],
      [
        62,
        0
      ],
      [
        62,
        -21
      ],
      [
        62,
        21
      ],
      [
        24,
        44
      ],
      [
        13,
        65
      ],
      [
        -13,
        86
      ],
      [
        0,
        76
      ],
      [
        25,
        65
      ],
      [
        50,
        109
      ],
      [
        12,
        65
      ],
      [
        12,
        152
      ],
      [
        25,
        130
      ],
      [
        13,
        152
      ],
      [
        -25,
        141
      ],
      [
        -50,
        130
      ],
      [
        25,
        119
      ],
      [
        0,
        22
      ],
      [
        50,
        22
      ],
      [
        49,
        65
      ],
      [
        25,
        -22
      ],
      [
        12,
        -33
      ],
      [
        50,
        -65
      ],
      [
        87,
        -130
      ],
      [
        99,
        -184
      ],
      [
        62,
        -98
      ],
      [
        62,
        -87
      ],
      [
        74,
        -86
      ],
      [
        124,
        -109
      ],
      [
        37,
        -54
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        88433,
        78150
      ],
      [
        -12,
        55
      ],
      [
        -13,
        21
      ],
      [
        -12,
        65
      ],
      [
        -25,
        55
      ],
      [
        -37,
        141
      ]
    ],
    [
      [
        79192,
        84235
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -25,
        76
      ],
      [
        13,
        0
      ],
      [
        12,
        -44
      ],
      [
        37,
        -10
      ]
    ],
    [
      [
        79229,
        84310
      ],
      [
        -12,
        33
      ],
      [
        12,
        33
      ],
      [
        13,
        0
      ],
      [
        0,
        -55
      ],
      [
        -13,
        -11
      ]
    ],
    [
      [
        80047,
        84582
      ],
      [
        -25,
        10
      ],
      [
        -12,
        33
      ],
      [
        12,
        33
      ],
      [
        25,
        -11
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        89523,
        82564
      ],
      [
        -49,
        76
      ],
      [
        -50,
        65
      ],
      [
        -37,
        22
      ],
      [
        -74,
        11
      ],
      [
        -37,
        0
      ],
      [
        -25,
        11
      ],
      [
        -75,
        119
      ],
      [
        -12,
        54
      ],
      [
        -12,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        11
      ],
      [
        -87,
        33
      ],
      [
        -37,
        21
      ],
      [
        -49,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -99,
        0
      ],
      [
        -75,
        22
      ],
      [
        -99,
        0
      ],
      [
        -25,
        11
      ],
      [
        -74,
        0
      ],
      [
        -87,
        43
      ],
      [
        -12,
        -11
      ],
      [
        -149,
        -32
      ],
      [
        -99,
        11
      ],
      [
        -148,
        0
      ],
      [
        -38,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -99,
        22
      ],
      [
        -111,
        43
      ],
      [
        -75,
        43
      ],
      [
        -62,
        44
      ],
      [
        -99,
        76
      ],
      [
        -49,
        43
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -25,
        -32
      ],
      [
        -87,
        -54
      ],
      [
        -24,
        -33
      ],
      [
        -50,
        -249
      ],
      [
        25,
        -120
      ],
      [
        -62,
        33
      ],
      [
        -37,
        43
      ],
      [
        -112,
        22
      ],
      [
        -37,
        43
      ],
      [
        -74,
        22
      ],
      [
        -99,
        54
      ],
      [
        -37,
        0
      ],
      [
        -112,
        44
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        0
      ],
      [
        -25,
        11
      ],
      [
        -62,
        -33
      ],
      [
        -50,
        -97
      ],
      [
        -24,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        -37,
        -76
      ],
      [
        0,
        -33
      ],
      [
        25,
        -21
      ]
    ],
    [
      [
        86340,
        82608
      ],
      [
        -37,
        -33
      ],
      [
        -38,
        0
      ],
      [
        -24,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -10
      ],
      [
        -12,
        21
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -54
      ],
      [
        -50,
        -76
      ],
      [
        -49,
        -44
      ],
      [
        -62,
        -32
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -33
      ],
      [
        -50,
        -54
      ],
      [
        -12,
        -32
      ],
      [
        -50,
        -22
      ],
      [
        -62,
        -54
      ],
      [
        0,
        -65
      ],
      [
        -74,
        -87
      ],
      [
        -62,
        -98
      ],
      [
        -37,
        -87
      ],
      [
        0,
        -43
      ],
      [
        12,
        -32
      ],
      [
        0,
        -55
      ],
      [
        -37,
        -11
      ],
      [
        -62,
        33
      ],
      [
        -49,
        43
      ],
      [
        -38,
        55
      ],
      [
        0,
        32
      ],
      [
        13,
        65
      ],
      [
        12,
        33
      ],
      [
        -25,
        21
      ],
      [
        -24,
        44
      ],
      [
        -13,
        43
      ],
      [
        -49,
        -21
      ],
      [
        -25,
        21
      ],
      [
        -62,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -50,
        -10
      ],
      [
        -61,
        0
      ],
      [
        -75,
        -11
      ],
      [
        -37,
        21
      ],
      [
        -25,
        109
      ],
      [
        -49,
        336
      ],
      [
        0,
        65
      ],
      [
        -99,
        0
      ],
      [
        -75,
        11
      ],
      [
        0,
        54
      ],
      [
        13,
        65
      ],
      [
        0,
        76
      ],
      [
        12,
        98
      ],
      [
        0,
        184
      ],
      [
        12,
        65
      ],
      [
        0,
        65
      ],
      [
        -74,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        54
      ],
      [
        -87,
        217
      ],
      [
        -74,
        65
      ],
      [
        -38,
        44
      ],
      [
        -24,
        54
      ],
      [
        -38,
        43
      ],
      [
        -24,
        44
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        -22
      ],
      [
        -37,
        -32
      ],
      [
        -49,
        -33
      ],
      [
        -50,
        0
      ],
      [
        -37,
        11
      ],
      [
        -62,
        0
      ],
      [
        -111,
        22
      ],
      [
        -87,
        0
      ],
      [
        -75,
        11
      ],
      [
        -123,
        -22
      ],
      [
        -75,
        -22
      ],
      [
        -62,
        -11
      ],
      [
        -74,
        -21
      ],
      [
        -87,
        -11
      ],
      [
        -99,
        141
      ],
      [
        -25,
        54
      ],
      [
        -86,
        119
      ],
      [
        -75,
        109
      ],
      [
        -24,
        54
      ],
      [
        -13,
        65
      ],
      [
        -62,
        65
      ],
      [
        -49,
        43
      ],
      [
        -50,
        33
      ],
      [
        -49,
        43
      ],
      [
        -38,
        44
      ],
      [
        -99,
        87
      ],
      [
        -49,
        32
      ],
      [
        -99,
        87
      ],
      [
        -37,
        43
      ],
      [
        -50,
        44
      ],
      [
        -50,
        32
      ],
      [
        -185,
        163
      ],
      [
        -50,
        32
      ],
      [
        -87,
        -21
      ],
      [
        -62,
        -22
      ],
      [
        -148,
        -65
      ],
      [
        -75,
        -22
      ],
      [
        -173,
        -76
      ],
      [
        -62,
        -21
      ],
      [
        -62,
        -33
      ],
      [
        -173,
        -65
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -293
      ],
      [
        0,
        -281
      ],
      [
        0,
        -282
      ],
      [
        0,
        -293
      ],
      [
        0,
        -282
      ],
      [
        0,
        -293
      ],
      [
        0,
        -282
      ],
      [
        0,
        -293
      ]
    ],
    [
      [
        81187,
        82022
      ],
      [
        -50,
        0
      ],
      [
        -99,
        -32
      ],
      [
        -37,
        21
      ],
      [
        -25,
        33
      ],
      [
        -12,
        32
      ],
      [
        -25,
        33
      ],
      [
        -37,
        65
      ],
      [
        -75,
        152
      ],
      [
        0,
        43
      ],
      [
        -24,
        54
      ],
      [
        -62,
        76
      ],
      [
        -161,
        141
      ],
      [
        -38,
        22
      ],
      [
        -37,
        0
      ],
      [
        -24,
        -11
      ],
      [
        -87,
        -11
      ],
      [
        -62,
        -32
      ],
      [
        -87,
        -33
      ],
      [
        -87,
        -43
      ],
      [
        -49,
        -44
      ],
      [
        -50,
        -75
      ],
      [
        -74,
        -98
      ]
    ],
    [
      [
        79985,
        82315
      ],
      [
        -12,
        65
      ],
      [
        0,
        130
      ],
      [
        24,
        87
      ],
      [
        25,
        119
      ],
      [
        13,
        76
      ],
      [
        -13,
        130
      ],
      [
        -12,
        33
      ],
      [
        -25,
        11
      ],
      [
        -62,
        -11
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        43
      ],
      [
        -38,
        11
      ],
      [
        -37,
        -21
      ],
      [
        -25,
        21
      ],
      [
        -24,
        44
      ],
      [
        -37,
        97
      ],
      [
        -25,
        33
      ],
      [
        -37,
        11
      ],
      [
        -75,
        0
      ],
      [
        0,
        195
      ],
      [
        -25,
        54
      ],
      [
        -37,
        43
      ],
      [
        -24,
        65
      ],
      [
        -38,
        131
      ],
      [
        -37,
        151
      ],
      [
        -49,
        44
      ],
      [
        -124,
        32
      ],
      [
        -25,
        22
      ],
      [
        0,
        108
      ],
      [
        12,
        33
      ],
      [
        38,
        33
      ],
      [
        161,
        0
      ],
      [
        62,
        -66
      ],
      [
        37,
        -10
      ],
      [
        74,
        21
      ],
      [
        62,
        -11
      ],
      [
        -25,
        33
      ],
      [
        -62,
        22
      ],
      [
        -25,
        54
      ],
      [
        -61,
        65
      ],
      [
        -13,
        33
      ],
      [
        0,
        43
      ],
      [
        13,
        32
      ],
      [
        37,
        44
      ],
      [
        24,
        43
      ],
      [
        38,
        98
      ],
      [
        24,
        54
      ],
      [
        50,
        -11
      ],
      [
        62,
        33
      ],
      [
        111,
        0
      ],
      [
        124,
        11
      ],
      [
        124,
        -44
      ],
      [
        99,
        -21
      ],
      [
        50,
        10
      ],
      [
        -50,
        55
      ],
      [
        -74,
        54
      ],
      [
        -25,
        43
      ],
      [
        37,
        130
      ],
      [
        50,
        120
      ],
      [
        37,
        141
      ],
      [
        -12,
        141
      ],
      [
        -13,
        32
      ],
      [
        0,
        44
      ],
      [
        37,
        75
      ],
      [
        -12,
        55
      ],
      [
        -25,
        65
      ],
      [
        -49,
        65
      ],
      [
        -87,
        0
      ],
      [
        -62,
        22
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -44
      ],
      [
        -49,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -25,
        43
      ],
      [
        -25,
        -11
      ],
      [
        -74,
        33
      ],
      [
        -37,
        54
      ],
      [
        -112,
        44
      ],
      [
        -49,
        10
      ],
      [
        -87,
        -43
      ],
      [
        -111,
        -98
      ],
      [
        -25,
        -10
      ],
      [
        -13,
        10
      ],
      [
        -24,
        -10
      ],
      [
        -137,
        -152
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        -11
      ],
      [
        -38,
        0
      ],
      [
        -24,
        -21
      ],
      [
        -50,
        0
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -76
      ],
      [
        -24,
        21
      ],
      [
        -25,
        -32
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        78858,
        85156
      ],
      [
        -149,
        109
      ],
      [
        -62,
        32
      ],
      [
        -37,
        55
      ],
      [
        0,
        32
      ],
      [
        37,
        44
      ],
      [
        25,
        -22
      ],
      [
        74,
        -22
      ],
      [
        25,
        22
      ],
      [
        0,
        22
      ],
      [
        -87,
        206
      ],
      [
        -49,
        141
      ],
      [
        -50,
        86
      ],
      [
        -49,
        76
      ],
      [
        -37,
        76
      ],
      [
        -25,
        22
      ],
      [
        -174,
        32
      ],
      [
        -37,
        11
      ],
      [
        -62,
        -43
      ],
      [
        -37,
        32
      ],
      [
        -25,
        55
      ],
      [
        -12,
        43
      ],
      [
        12,
        43
      ],
      [
        0,
        65
      ],
      [
        -37,
        98
      ],
      [
        -62,
        33
      ],
      [
        -62,
        54
      ],
      [
        -12,
        97
      ],
      [
        25,
        141
      ],
      [
        49,
        109
      ],
      [
        62,
        76
      ],
      [
        0,
        65
      ],
      [
        -25,
        32
      ],
      [
        -37,
        33
      ],
      [
        -12,
        43
      ],
      [
        12,
        87
      ],
      [
        13,
        119
      ],
      [
        37,
        98
      ],
      [
        49,
        54
      ],
      [
        37,
        33
      ],
      [
        25,
        43
      ],
      [
        0,
        130
      ],
      [
        37,
        54
      ],
      [
        25,
        22
      ],
      [
        37,
        11
      ],
      [
        38,
        -22
      ],
      [
        49,
        -65
      ],
      [
        74,
        -108
      ],
      [
        50,
        -109
      ],
      [
        74,
        -65
      ],
      [
        62,
        33
      ],
      [
        75,
        54
      ],
      [
        12,
        33
      ],
      [
        -12,
        54
      ],
      [
        -25,
        76
      ],
      [
        -13,
        86
      ],
      [
        -12,
        120
      ],
      [
        -12,
        43
      ],
      [
        62,
        -11
      ],
      [
        37,
        22
      ],
      [
        49,
        54
      ],
      [
        87,
        76
      ],
      [
        25,
        54
      ],
      [
        12,
        55
      ],
      [
        25,
        43
      ],
      [
        111,
        22
      ],
      [
        38,
        43
      ],
      [
        111,
        54
      ],
      [
        37,
        54
      ],
      [
        50,
        87
      ],
      [
        49,
        54
      ],
      [
        37,
        55
      ],
      [
        13,
        32
      ],
      [
        124,
        -54
      ],
      [
        37,
        -33
      ],
      [
        12,
        -65
      ],
      [
        37,
        -10
      ],
      [
        62,
        10
      ],
      [
        62,
        44
      ],
      [
        75,
        76
      ],
      [
        74,
        21
      ],
      [
        37,
        -21
      ],
      [
        37,
        -55
      ],
      [
        25,
        -54
      ],
      [
        50,
        -21
      ],
      [
        62,
        10
      ],
      [
        24,
        -10
      ],
      [
        50,
        0
      ],
      [
        99,
        10
      ],
      [
        74,
        -54
      ],
      [
        50,
        -97
      ],
      [
        99,
        -55
      ],
      [
        62,
        -76
      ],
      [
        49,
        -75
      ],
      [
        50,
        -87
      ],
      [
        0,
        -65
      ],
      [
        25,
        -87
      ],
      [
        12,
        0
      ],
      [
        37,
        32
      ],
      [
        0,
        120
      ],
      [
        -12,
        65
      ],
      [
        -25,
        43
      ],
      [
        13,
        22
      ],
      [
        49,
        11
      ],
      [
        99,
        -87
      ],
      [
        62,
        -76
      ],
      [
        124,
        -87
      ],
      [
        50,
        -11
      ],
      [
        37,
        11
      ],
      [
        86,
        65
      ],
      [
        25,
        87
      ],
      [
        124,
        109
      ],
      [
        50,
        -22
      ],
      [
        49,
        32
      ],
      [
        25,
        0
      ],
      [
        62,
        22
      ],
      [
        49,
        -22
      ],
      [
        87,
        -97
      ],
      [
        50,
        11
      ],
      [
        49,
        54
      ],
      [
        13,
        43
      ],
      [
        24,
        22
      ],
      [
        75,
        -11
      ],
      [
        49,
        0
      ],
      [
        0,
        11
      ],
      [
        62,
        -22
      ],
      [
        62,
        -54
      ],
      [
        37,
        -65
      ],
      [
        62,
        -76
      ],
      [
        13,
        -32
      ],
      [
        37,
        -11
      ],
      [
        37,
        0
      ],
      [
        25,
        -11
      ],
      [
        99,
        -22
      ],
      [
        25,
        -22
      ],
      [
        0,
        -54
      ],
      [
        86,
        33
      ],
      [
        13,
        21
      ],
      [
        49,
        131
      ],
      [
        25,
        32
      ],
      [
        37,
        -11
      ],
      [
        62,
        -76
      ],
      [
        37,
        -21
      ],
      [
        37,
        0
      ],
      [
        38,
        -11
      ],
      [
        111,
        22
      ],
      [
        99,
        54
      ],
      [
        50,
        54
      ],
      [
        24,
        76
      ],
      [
        25,
        98
      ],
      [
        25,
        54
      ],
      [
        -12,
        65
      ],
      [
        -50,
        54
      ],
      [
        -136,
        43
      ],
      [
        -13,
        33
      ],
      [
        -185,
        65
      ],
      [
        -25,
        76
      ],
      [
        -37,
        43
      ],
      [
        -75,
        33
      ],
      [
        -12,
        32
      ],
      [
        12,
        22
      ],
      [
        62,
        33
      ],
      [
        62,
        65
      ],
      [
        25,
        11
      ],
      [
        62,
        0
      ],
      [
        99,
        86
      ],
      [
        12,
        65
      ],
      [
        -61,
        109
      ],
      [
        -13,
        65
      ],
      [
        37,
        97
      ],
      [
        25,
        22
      ],
      [
        12,
        44
      ],
      [
        25,
        21
      ],
      [
        112,
        22
      ],
      [
        173,
        -33
      ],
      [
        50,
        11
      ],
      [
        12,
        54
      ],
      [
        -25,
        33
      ],
      [
        -74,
        43
      ],
      [
        -37,
        33
      ],
      [
        -87,
        11
      ],
      [
        -74,
        32
      ],
      [
        -13,
        22
      ],
      [
        0,
        43
      ],
      [
        25,
        33
      ],
      [
        25,
        11
      ],
      [
        25,
        -11
      ],
      [
        49,
        32
      ],
      [
        0,
        33
      ],
      [
        -37,
        22
      ],
      [
        -62,
        -22
      ],
      [
        -87,
        43
      ],
      [
        0,
        22
      ],
      [
        38,
        54
      ],
      [
        0,
        87
      ],
      [
        12,
        54
      ],
      [
        37,
        33
      ],
      [
        37,
        11
      ],
      [
        87,
        -33
      ],
      [
        112,
        -22
      ],
      [
        24,
        0
      ],
      [
        13,
        33
      ],
      [
        161,
        0
      ],
      [
        49,
        43
      ],
      [
        149,
        22
      ],
      [
        12,
        22
      ],
      [
        62,
        11
      ],
      [
        99,
        32
      ],
      [
        38,
        22
      ],
      [
        49,
        -11
      ],
      [
        62,
        22
      ],
      [
        12,
        21
      ],
      [
        50,
        33
      ],
      [
        87,
        22
      ],
      [
        24,
        -22
      ],
      [
        50,
        0
      ],
      [
        87,
        22
      ],
      [
        62,
        -33
      ],
      [
        24,
        22
      ],
      [
        25,
        86
      ],
      [
        50,
        33
      ],
      [
        37,
        43
      ],
      [
        74,
        -10
      ],
      [
        75,
        54
      ],
      [
        12,
        -22
      ],
      [
        87,
        0
      ],
      [
        123,
        33
      ],
      [
        62,
        10
      ],
      [
        124,
        33
      ],
      [
        50,
        22
      ],
      [
        74,
        21
      ],
      [
        75,
        11
      ],
      [
        49,
        44
      ],
      [
        37,
        10
      ],
      [
        50,
        0
      ],
      [
        49,
        22
      ],
      [
        0,
        76
      ],
      [
        -12,
        22
      ],
      [
        37,
        21
      ],
      [
        50,
        0
      ],
      [
        24,
        11
      ],
      [
        112,
        98
      ],
      [
        49,
        22
      ],
      [
        174,
        -22
      ],
      [
        87,
        -33
      ],
      [
        49,
        -43
      ],
      [
        74,
        -43
      ],
      [
        25,
        0
      ],
      [
        75,
        21
      ],
      [
        12,
        33
      ],
      [
        111,
        32
      ],
      [
        13,
        -32
      ],
      [
        49,
        -76
      ],
      [
        25,
        -119
      ],
      [
        50,
        -141
      ],
      [
        12,
        -76
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -108
      ],
      [
        -37,
        -65
      ],
      [
        24,
        -33
      ],
      [
        75,
        -32
      ],
      [
        123,
        10
      ],
      [
        75,
        22
      ],
      [
        37,
        -11
      ],
      [
        25,
        22
      ],
      [
        12,
        43
      ],
      [
        25,
        11
      ],
      [
        25,
        -32
      ],
      [
        24,
        -55
      ],
      [
        25,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        25,
        -75
      ],
      [
        49,
        32
      ],
      [
        0,
        43
      ],
      [
        -12,
        22
      ],
      [
        12,
        22
      ],
      [
        50,
        0
      ],
      [
        62,
        -11
      ],
      [
        74,
        -76
      ],
      [
        37,
        -22
      ],
      [
        50,
        0
      ],
      [
        86,
        65
      ],
      [
        25,
        -10
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        -44
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -76
      ],
      [
        25,
        -55
      ],
      [
        0,
        -32
      ],
      [
        37,
        11
      ],
      [
        49,
        65
      ],
      [
        75,
        32
      ],
      [
        74,
        -10
      ],
      [
        50,
        -22
      ],
      [
        49,
        -54
      ],
      [
        25,
        10
      ],
      [
        0,
        66
      ],
      [
        12,
        21
      ],
      [
        137,
        120
      ],
      [
        49,
        -11
      ],
      [
        74,
        43
      ],
      [
        62,
        54
      ],
      [
        0,
        65
      ],
      [
        13,
        11
      ],
      [
        86,
        11
      ],
      [
        75,
        33
      ],
      [
        124,
        97
      ],
      [
        86,
        11
      ],
      [
        87,
        65
      ],
      [
        25,
        0
      ],
      [
        -13,
        -76
      ],
      [
        -49,
        -108
      ],
      [
        -74,
        0
      ],
      [
        12,
        -76
      ],
      [
        37,
        -54
      ],
      [
        186,
        -163
      ],
      [
        124,
        -109
      ],
      [
        136,
        -141
      ],
      [
        50,
        -119
      ],
      [
        62,
        -97
      ],
      [
        99,
        -185
      ],
      [
        74,
        -173
      ],
      [
        99,
        -196
      ],
      [
        50,
        -108
      ],
      [
        111,
        -239
      ],
      [
        37,
        -65
      ],
      [
        50,
        -141
      ],
      [
        49,
        -130
      ],
      [
        50,
        -108
      ],
      [
        25,
        -11
      ],
      [
        0,
        54
      ],
      [
        25,
        11
      ],
      [
        24,
        33
      ],
      [
        50,
        0
      ],
      [
        25,
        21
      ],
      [
        12,
        33
      ],
      [
        -12,
        54
      ],
      [
        0,
        54
      ],
      [
        62,
        33
      ],
      [
        12,
        32
      ],
      [
        25,
        11
      ],
      [
        49,
        -11
      ],
      [
        25,
        -21
      ],
      [
        12,
        -33
      ],
      [
        50,
        0
      ],
      [
        12,
        -32
      ],
      [
        -24,
        -76
      ],
      [
        0,
        -33
      ],
      [
        12,
        -11
      ],
      [
        74,
        11
      ],
      [
        25,
        -11
      ],
      [
        12,
        -54
      ],
      [
        0,
        -54
      ],
      [
        13,
        -22
      ],
      [
        49,
        0
      ],
      [
        50,
        11
      ],
      [
        62,
        0
      ],
      [
        49,
        -33
      ],
      [
        87,
        22
      ],
      [
        50,
        -11
      ],
      [
        49,
        33
      ],
      [
        50,
        76
      ],
      [
        87,
        0
      ],
      [
        24,
        43
      ],
      [
        62,
        22
      ],
      [
        25,
        0
      ],
      [
        124,
        -76
      ],
      [
        49,
        -44
      ],
      [
        38,
        -21
      ],
      [
        12,
        -65
      ],
      [
        37,
        -44
      ],
      [
        25,
        -54
      ],
      [
        12,
        -54
      ],
      [
        13,
        -87
      ],
      [
        24,
        -32
      ],
      [
        25,
        0
      ],
      [
        75,
        -22
      ],
      [
        74,
        -76
      ],
      [
        37,
        0
      ],
      [
        25,
        -11
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -44
      ],
      [
        13,
        -32
      ],
      [
        49,
        -87
      ],
      [
        25,
        -54
      ],
      [
        0,
        -33
      ],
      [
        25,
        -11
      ],
      [
        25,
        22
      ],
      [
        49,
        -22
      ],
      [
        124,
        -21
      ],
      [
        25,
        -11
      ],
      [
        12,
        -33
      ],
      [
        13,
        11
      ],
      [
        62,
        -11
      ],
      [
        12,
        33
      ],
      [
        62,
        54
      ],
      [
        74,
        87
      ],
      [
        37,
        -11
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        0,
        -32
      ],
      [
        25,
        0
      ],
      [
        37,
        -44
      ],
      [
        50,
        -108
      ],
      [
        37,
        -44
      ],
      [
        62,
        -21
      ],
      [
        25,
        -44
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        76033,
        54866
      ],
      [
        -12,
        -11
      ],
      [
        0,
        43
      ],
      [
        37,
        44
      ],
      [
        25,
        -22
      ],
      [
        0,
        -11
      ],
      [
        -50,
        -43
      ]
    ],
    [
      [
        76331,
        58694
      ],
      [
        -37,
        -108
      ],
      [
        -50,
        -130
      ],
      [
        -99,
        -239
      ],
      [
        -62,
        -130
      ],
      [
        -62,
        -98
      ],
      [
        0,
        -390
      ],
      [
        0,
        -521
      ],
      [
        0,
        -531
      ],
      [
        0,
        -521
      ],
      [
        0,
        -358
      ],
      [
        99,
        -217
      ],
      [
        62,
        -141
      ],
      [
        37,
        -108
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        76219,
        55159
      ],
      [
        -49,
        -109
      ],
      [
        -50,
        -54
      ],
      [
        -49,
        -22
      ],
      [
        -38,
        22
      ],
      [
        -12,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        -13,
        11
      ],
      [
        0,
        -65
      ],
      [
        13,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        -24,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -62,
        -87
      ],
      [
        -87,
        -11
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -130
      ],
      [
        -13,
        -87
      ],
      [
        -12,
        -54
      ],
      [
        -37,
        -66
      ],
      [
        -25,
        -54
      ],
      [
        -13,
        -54
      ],
      [
        -12,
        -33
      ],
      [
        -12,
        -130
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -21
      ],
      [
        -50,
        -206
      ],
      [
        -37,
        -87
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -55
      ]
    ],
    [
      [
        75414,
        53282
      ],
      [
        0,
        11
      ],
      [
        -37,
        33
      ],
      [
        -50,
        65
      ],
      [
        -49,
        76
      ],
      [
        -50,
        65
      ],
      [
        -62,
        65
      ],
      [
        -49,
        76
      ],
      [
        -50,
        65
      ],
      [
        -49,
        76
      ],
      [
        -62,
        65
      ],
      [
        -37,
        65
      ],
      [
        -13,
        43
      ],
      [
        -25,
        33
      ],
      [
        -12,
        0
      ],
      [
        0,
        65
      ],
      [
        25,
        65
      ],
      [
        0,
        33
      ],
      [
        -13,
        43
      ],
      [
        0,
        87
      ],
      [
        -37,
        32
      ],
      [
        -148,
        152
      ],
      [
        -149,
        152
      ],
      [
        -74,
        65
      ],
      [
        -149,
        152
      ],
      [
        -149,
        152
      ],
      [
        -62,
        76
      ],
      [
        -74,
        75
      ],
      [
        -74,
        66
      ],
      [
        -149,
        151
      ],
      [
        -148,
        152
      ],
      [
        -25,
        22
      ],
      [
        -25,
        32
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        73593,
        55592
      ],
      [
        0,
        369
      ],
      [
        0,
        239
      ],
      [
        13,
        119
      ],
      [
        24,
        76
      ],
      [
        25,
        54
      ],
      [
        0,
        76
      ],
      [
        25,
        65
      ],
      [
        37,
        54
      ],
      [
        0,
        22
      ],
      [
        50,
        87
      ],
      [
        24,
        108
      ],
      [
        13,
        44
      ],
      [
        37,
        54
      ],
      [
        37,
        11
      ],
      [
        25,
        21
      ],
      [
        0,
        22
      ],
      [
        -13,
        65
      ],
      [
        13,
        22
      ],
      [
        25,
        87
      ],
      [
        24,
        54
      ],
      [
        0,
        43
      ],
      [
        13,
        33
      ],
      [
        0,
        65
      ],
      [
        -37,
        347
      ],
      [
        12,
        32
      ],
      [
        -25,
        66
      ],
      [
        -12,
        21
      ],
      [
        -25,
        130
      ],
      [
        -12,
        11
      ],
      [
        -37,
        54
      ],
      [
        -25,
        120
      ],
      [
        -25,
        32
      ],
      [
        -12,
        120
      ],
      [
        -13,
        32
      ],
      [
        25,
        119
      ],
      [
        0,
        33
      ],
      [
        -25,
        22
      ],
      [
        -37,
        21
      ],
      [
        -37,
        55
      ],
      [
        0,
        21
      ],
      [
        -12,
        22
      ],
      [
        -50,
        206
      ]
    ],
    [
      [
        73618,
        58846
      ],
      [
        62,
        130
      ],
      [
        74,
        119
      ],
      [
        87,
        163
      ],
      [
        87,
        152
      ],
      [
        62,
        119
      ],
      [
        74,
        120
      ]
    ],
    [
      [
        87256,
        80851
      ],
      [
        -12,
        11
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -10
      ],
      [
        -87,
        0
      ],
      [
        -74,
        21
      ],
      [
        -99,
        -32
      ],
      [
        -37,
        -76
      ],
      [
        -13,
        0
      ],
      [
        -49,
        65
      ],
      [
        -25,
        22
      ],
      [
        -74,
        -44
      ],
      [
        -25,
        11
      ],
      [
        0,
        76
      ],
      [
        -13,
        11
      ],
      [
        -49,
        11
      ],
      [
        -12,
        11
      ],
      [
        0,
        65
      ],
      [
        -38,
        10
      ],
      [
        -37,
        -43
      ],
      [
        -62,
        -11
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        -54
      ],
      [
        -74,
        -11
      ],
      [
        -37,
        55
      ],
      [
        -25,
        54
      ],
      [
        -13,
        11
      ],
      [
        -61,
        0
      ],
      [
        -50,
        -22
      ],
      [
        -12,
        22
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        -11
      ],
      [
        -124,
        22
      ],
      [
        -50,
        -33
      ],
      [
        -49,
        0
      ],
      [
        -12,
        87
      ],
      [
        -13,
        54
      ],
      [
        0,
        43
      ],
      [
        25,
        87
      ],
      [
        25,
        -11
      ],
      [
        12,
        -21
      ],
      [
        25,
        11
      ],
      [
        0,
        43
      ],
      [
        -13,
        11
      ],
      [
        25,
        54
      ],
      [
        87,
        33
      ],
      [
        62,
        32
      ],
      [
        149,
        -87
      ],
      [
        24,
        -11
      ],
      [
        25,
        -65
      ],
      [
        37,
        33
      ],
      [
        0,
        54
      ],
      [
        37,
        33
      ],
      [
        75,
        32
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        86340,
        81350
      ],
      [
        12,
        11
      ],
      [
        99,
        21
      ],
      [
        62,
        -32
      ],
      [
        13,
        -22
      ],
      [
        49,
        11
      ],
      [
        12,
        -43
      ],
      [
        62,
        54
      ],
      [
        38,
        11
      ],
      [
        12,
        54
      ],
      [
        37,
        54
      ],
      [
        37,
        11
      ],
      [
        50,
        -33
      ],
      [
        12,
        22
      ],
      [
        -12,
        54
      ],
      [
        0,
        33
      ],
      [
        12,
        11
      ],
      [
        62,
        -44
      ],
      [
        37,
        22
      ],
      [
        25,
        32
      ],
      [
        0,
        33
      ],
      [
        124,
        87
      ],
      [
        0,
        21
      ],
      [
        -50,
        22
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        11
      ],
      [
        -62,
        0
      ],
      [
        -12,
        11
      ],
      [
        -38,
        65
      ],
      [
        -49,
        33
      ],
      [
        -62,
        -11
      ],
      [
        0,
        65
      ],
      [
        -25,
        43
      ],
      [
        -25,
        -21
      ],
      [
        -24,
        21
      ],
      [
        -38,
        0
      ],
      [
        0,
        76
      ],
      [
        -24,
        65
      ],
      [
        -38,
        22
      ],
      [
        0,
        54
      ],
      [
        -24,
        -22
      ],
      [
        0,
        -86
      ],
      [
        -13,
        -22
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -13,
        -141
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -24,
        21
      ],
      [
        -25,
        0
      ],
      [
        -62,
        44
      ],
      [
        -13,
        86
      ],
      [
        -24,
        33
      ],
      [
        -75,
        -22
      ],
      [
        -12,
        22
      ],
      [
        -74,
        32
      ],
      [
        -13,
        44
      ],
      [
        99,
        97
      ],
      [
        37,
        65
      ],
      [
        50,
        44
      ],
      [
        37,
        11
      ],
      [
        13,
        65
      ],
      [
        62,
        32
      ],
      [
        61,
        55
      ],
      [
        0,
        21
      ],
      [
        -24,
        33
      ],
      [
        -37,
        21
      ],
      [
        -25,
        -21
      ]
    ],
    [
      [
        86253,
        81089
      ],
      [
        -12,
        22
      ],
      [
        -62,
        11
      ],
      [
        24,
        -54
      ],
      [
        50,
        21
      ]
    ],
    [
      [
        86625,
        81165
      ],
      [
        0,
        33
      ],
      [
        -38,
        -22
      ],
      [
        13,
        -32
      ],
      [
        25,
        21
      ]
    ],
    [
      [
        86426,
        81133
      ],
      [
        -12,
        54
      ],
      [
        12,
        43
      ],
      [
        -49,
        22
      ],
      [
        -12,
        44
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -65
      ],
      [
        25,
        -22
      ],
      [
        -13,
        -65
      ],
      [
        74,
        0
      ]
    ],
    [
      [
        97377,
        63260
      ],
      [
        -13,
        0
      ],
      [
        0,
        65
      ],
      [
        13,
        0
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        97340,
        63531
      ],
      [
        0,
        11
      ],
      [
        -62,
        228
      ],
      [
        -13,
        97
      ],
      [
        13,
        87
      ],
      [
        0,
        22
      ],
      [
        -13,
        43
      ],
      [
        -24,
        44
      ],
      [
        -50,
        65
      ],
      [
        0,
        97
      ],
      [
        -12,
        119
      ],
      [
        -13,
        44
      ],
      [
        -24,
        65
      ],
      [
        -13,
        65
      ],
      [
        0,
        163
      ],
      [
        74,
        21
      ],
      [
        13,
        22
      ],
      [
        -13,
        22
      ],
      [
        25,
        32
      ],
      [
        37,
        87
      ],
      [
        38,
        76
      ],
      [
        24,
        108
      ],
      [
        50,
        65
      ],
      [
        49,
        55
      ],
      [
        87,
        21
      ],
      [
        37,
        33
      ],
      [
        25,
        0
      ],
      [
        37,
        -33
      ],
      [
        62,
        0
      ],
      [
        25,
        -10
      ],
      [
        25,
        10
      ],
      [
        62,
        11
      ],
      [
        62,
        -11
      ],
      [
        62,
        11
      ],
      [
        61,
        22
      ],
      [
        38,
        -11
      ],
      [
        37,
        -22
      ],
      [
        0,
        -76
      ],
      [
        25,
        -10
      ],
      [
        24,
        32
      ],
      [
        13,
        44
      ]
    ],
    [
      [
        98108,
        65180
      ],
      [
        12,
        -22
      ],
      [
        0,
        -33
      ],
      [
        12,
        -43
      ],
      [
        38,
        -54
      ],
      [
        12,
        0
      ],
      [
        50,
        32
      ],
      [
        74,
        -43
      ],
      [
        25,
        -76
      ],
      [
        24,
        -33
      ],
      [
        62,
        0
      ],
      [
        25,
        87
      ],
      [
        -12,
        44
      ],
      [
        -37,
        86
      ],
      [
        0,
        55
      ],
      [
        62,
        10
      ],
      [
        12,
        65
      ],
      [
        25,
        0
      ],
      [
        25,
        -10
      ],
      [
        37,
        32
      ],
      [
        12,
        44
      ],
      [
        37,
        -66
      ],
      [
        25,
        -21
      ],
      [
        25,
        -33
      ],
      [
        12,
        -32
      ],
      [
        13,
        -11
      ],
      [
        37,
        11
      ],
      [
        37,
        54
      ],
      [
        25,
        0
      ],
      [
        37,
        43
      ],
      [
        12,
        55
      ],
      [
        13,
        10
      ],
      [
        24,
        -21
      ],
      [
        13,
        0
      ],
      [
        25,
        65
      ],
      [
        12,
        21
      ]
    ],
    [
      [
        98913,
        65396
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -65
      ],
      [
        -50,
        -109
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -108
      ],
      [
        0,
        -33
      ],
      [
        25,
        -54
      ],
      [
        25,
        -109
      ],
      [
        24,
        -97
      ],
      [
        13,
        -87
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -130
      ],
      [
        -24,
        -120
      ],
      [
        0,
        -65
      ],
      [
        12,
        -54
      ],
      [
        12,
        -87
      ],
      [
        0,
        -173
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        44
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -65
      ],
      [
        -62,
        -22
      ],
      [
        -13,
        -43
      ],
      [
        -24,
        0
      ],
      [
        -50,
        -11
      ],
      [
        -25,
        0
      ],
      [
        0,
        -163
      ],
      [
        -24,
        -11
      ],
      [
        -38,
        22
      ],
      [
        -49,
        22
      ],
      [
        -37,
        11
      ],
      [
        -13,
        -55
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -206
      ],
      [
        12,
        -33
      ],
      [
        75,
        -108
      ],
      [
        25,
        -22
      ],
      [
        -13,
        -76
      ],
      [
        13,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -62,
        55
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        43
      ],
      [
        -37,
        43
      ],
      [
        -50,
        -21
      ],
      [
        -62,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -49,
        32
      ],
      [
        -37,
        11
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -44
      ],
      [
        13,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        -43
      ],
      [
        -87,
        0
      ],
      [
        -25,
        -54
      ],
      [
        -24,
        -11
      ]
    ],
    [
      [
        97848,
        62718
      ],
      [
        -50,
        76
      ],
      [
        -111,
        32
      ],
      [
        -13,
        33
      ],
      [
        -12,
        11
      ],
      [
        -13,
        -44
      ],
      [
        -62,
        -43
      ],
      [
        -24,
        21
      ],
      [
        -13,
        33
      ],
      [
        0,
        43
      ],
      [
        13,
        33
      ],
      [
        37,
        22
      ],
      [
        12,
        86
      ],
      [
        -25,
        98
      ],
      [
        -37,
        54
      ],
      [
        -24,
        -32
      ],
      [
        -25,
        -65
      ],
      [
        -13,
        -44
      ],
      [
        -74,
        0
      ],
      [
        -25,
        185
      ],
      [
        13,
        97
      ],
      [
        0,
        54
      ],
      [
        -38,
        87
      ],
      [
        0,
        76
      ],
      [
        -24,
        33
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        9699,
        49064
      ],
      [
        -12,
        10
      ],
      [
        0,
        22
      ],
      [
        12,
        0
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        8300,
        52697
      ],
      [
        -25,
        0
      ],
      [
        0,
        11
      ],
      [
        25,
        0
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        121966,
        55712
      ],
      [
        -13,
        21
      ],
      [
        -12,
        76
      ],
      [
        12,
        0
      ],
      [
        13,
        -54
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        121458,
        56850
      ],
      [
        12,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        11
      ],
      [
        25,
        43
      ],
      [
        12,
        33
      ],
      [
        -12,
        32
      ]
    ],
    [
      [
        121458,
        57057
      ],
      [
        0,
        10
      ],
      [
        49,
        11
      ],
      [
        0,
        -21
      ],
      [
        -49,
        0
      ]
    ],
    [
      [
        7792,
        57371
      ],
      [
        49,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        33
      ],
      [
        -62,
        76
      ],
      [
        25,
        10
      ],
      [
        0,
        -21
      ],
      [
        24,
        -22
      ],
      [
        13,
        43
      ],
      [
        25,
        33
      ],
      [
        0,
        -76
      ]
    ],
    [
      [
        7098,
        58662
      ],
      [
        37,
        -55
      ],
      [
        -12,
        -21
      ],
      [
        -13,
        0
      ],
      [
        0,
        43
      ],
      [
        -24,
        11
      ],
      [
        12,
        22
      ]
    ],
    [
      [
        40407,
        66904
      ],
      [
        -12,
        -11
      ],
      [
        -12,
        22
      ],
      [
        0,
        43
      ],
      [
        12,
        0
      ],
      [
        12,
        -22
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        40370,
        66980
      ],
      [
        -24,
        32
      ],
      [
        -25,
        11
      ],
      [
        -13,
        22
      ],
      [
        0,
        32
      ],
      [
        13,
        11
      ],
      [
        25,
        -32
      ],
      [
        12,
        -44
      ],
      [
        12,
        -10
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        105391,
        76968
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        11
      ],
      [
        -24,
        55
      ],
      [
        12,
        32
      ],
      [
        49,
        65
      ],
      [
        124,
        54
      ],
      [
        25,
        0
      ],
      [
        50,
        -21
      ],
      [
        12,
        -44
      ],
      [
        -25,
        -65
      ],
      [
        -99,
        -65
      ],
      [
        -87,
        -11
      ]
    ],
    [
      [
        105540,
        77662
      ],
      [
        0,
        -21
      ],
      [
        -25,
        0
      ],
      [
        -12,
        32
      ],
      [
        12,
        22
      ],
      [
        25,
        -33
      ]
    ],
    [
      [
        105354,
        77684
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        22
      ],
      [
        0,
        32
      ],
      [
        50,
        76
      ],
      [
        24,
        -10
      ],
      [
        13,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        -37,
        -33
      ]
    ],
    [
      [
        105899,
        77836
      ],
      [
        -12,
        -22
      ],
      [
        -12,
        33
      ],
      [
        12,
        32
      ],
      [
        12,
        -43
      ]
    ],
    [
      [
        105330,
        77912
      ],
      [
        -13,
        -11
      ],
      [
        -25,
        76
      ],
      [
        -12,
        22
      ],
      [
        25,
        21
      ],
      [
        25,
        -54
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        105986,
        77955
      ],
      [
        0,
        -65
      ],
      [
        -25,
        0
      ],
      [
        -12,
        43
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        43
      ],
      [
        0,
        44
      ],
      [
        25,
        32
      ],
      [
        12,
        -22
      ],
      [
        25,
        -10
      ],
      [
        12,
        -44
      ]
    ],
    [
      [
        106221,
        77955
      ],
      [
        -37,
        -43
      ],
      [
        -49,
        76
      ],
      [
        62,
        97
      ],
      [
        12,
        0
      ],
      [
        12,
        -130
      ]
    ],
    [
      [
        105416,
        79007
      ],
      [
        0,
        -43
      ],
      [
        -25,
        32
      ],
      [
        -12,
        87
      ],
      [
        25,
        -22
      ],
      [
        12,
        -54
      ]
    ],
    [
      [
        106965,
        79625
      ],
      [
        -13,
        -21
      ],
      [
        -24,
        21
      ],
      [
        0,
        22
      ],
      [
        37,
        22
      ],
      [
        12,
        -11
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        105453,
        79788
      ],
      [
        0,
        -87
      ],
      [
        -37,
        11
      ],
      [
        -12,
        98
      ],
      [
        12,
        32
      ],
      [
        25,
        -21
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        105491,
        79810
      ],
      [
        12,
        21
      ],
      [
        0,
        65
      ],
      [
        37,
        44
      ],
      [
        37,
        76
      ],
      [
        50,
        87
      ],
      [
        49,
        43
      ],
      [
        211,
        0
      ],
      [
        50,
        -11
      ],
      [
        61,
        22
      ],
      [
        25,
        21
      ],
      [
        37,
        98
      ],
      [
        25,
        54
      ],
      [
        13,
        11
      ]
    ],
    [
      [
        106098,
        80341
      ],
      [
        74,
        -282
      ],
      [
        87,
        -173
      ],
      [
        62,
        -141
      ],
      [
        99,
        -250
      ],
      [
        37,
        -130
      ],
      [
        0,
        -87
      ],
      [
        12,
        -108
      ],
      [
        -12,
        -65
      ],
      [
        0,
        -163
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -163
      ],
      [
        25,
        -32
      ],
      [
        13,
        21
      ],
      [
        24,
        11
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -163
      ],
      [
        -12,
        -119
      ],
      [
        -37,
        -108
      ],
      [
        -38,
        -87
      ],
      [
        -49,
        -44
      ],
      [
        -37,
        -10
      ],
      [
        -62,
        0
      ],
      [
        -50,
        10
      ],
      [
        -49,
        -10
      ],
      [
        -25,
        -55
      ],
      [
        12,
        -54
      ],
      [
        0,
        -32
      ],
      [
        -24,
        0
      ],
      [
        -38,
        21
      ],
      [
        -49,
        0
      ],
      [
        -13,
        11
      ],
      [
        -24,
        65
      ],
      [
        -50,
        -43
      ],
      [
        -62,
        0
      ],
      [
        -25,
        -44
      ],
      [
        13,
        -32
      ],
      [
        25,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        54
      ],
      [
        -13,
        44
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -33
      ],
      [
        25,
        -32
      ],
      [
        -37,
        -87
      ],
      [
        -25,
        -22
      ],
      [
        -50,
        55
      ],
      [
        38,
        75
      ],
      [
        0,
        33
      ],
      [
        -13,
        22
      ],
      [
        -74,
        -87
      ],
      [
        -37,
        -109
      ],
      [
        -25,
        11
      ],
      [
        -25,
        33
      ],
      [
        -49,
        -65
      ],
      [
        -13,
        -54
      ],
      [
        -25,
        0
      ],
      [
        0,
        65
      ],
      [
        -12,
        43
      ],
      [
        -50,
        65
      ],
      [
        -24,
        43
      ],
      [
        12,
        33
      ],
      [
        37,
        -11
      ],
      [
        37,
        0
      ],
      [
        0,
        22
      ],
      [
        25,
        54
      ],
      [
        -12,
        11
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        11
      ],
      [
        0,
        65
      ],
      [
        -25,
        76
      ],
      [
        -12,
        65
      ],
      [
        25,
        43
      ],
      [
        12,
        55
      ],
      [
        13,
        86
      ],
      [
        12,
        33
      ],
      [
        37,
        22
      ],
      [
        13,
        21
      ],
      [
        -50,
        22
      ],
      [
        0,
        33
      ],
      [
        25,
        10
      ],
      [
        12,
        22
      ],
      [
        50,
        44
      ],
      [
        12,
        54
      ],
      [
        -12,
        21
      ],
      [
        -25,
        11
      ],
      [
        0,
        33
      ],
      [
        12,
        43
      ],
      [
        -37,
        44
      ],
      [
        -12,
        32
      ],
      [
        0,
        195
      ],
      [
        -25,
        141
      ],
      [
        -37,
        -32
      ],
      [
        -50,
        32
      ],
      [
        -12,
        0
      ],
      [
        -12,
        44
      ],
      [
        24,
        65
      ],
      [
        37,
        54
      ],
      [
        38,
        11
      ],
      [
        12,
        22
      ],
      [
        37,
        10
      ],
      [
        37,
        -43
      ],
      [
        25,
        -11
      ],
      [
        25,
        -54
      ],
      [
        12,
        0
      ],
      [
        37,
        54
      ],
      [
        -37,
        22
      ],
      [
        -37,
        119
      ],
      [
        -12,
        22
      ],
      [
        25,
        54
      ],
      [
        -50,
        98
      ],
      [
        0,
        65
      ],
      [
        -37,
        108
      ],
      [
        25,
        33
      ]
    ],
    [
      [
        68824,
        82792
      ],
      [
        12,
        54
      ],
      [
        -24,
        65
      ],
      [
        12,
        11
      ],
      [
        50,
        0
      ],
      [
        0,
        22
      ],
      [
        49,
        22
      ]
    ],
    [
      [
        68923,
        82966
      ],
      [
        50,
        21
      ],
      [
        -13,
        44
      ],
      [
        62,
        65
      ],
      [
        13,
        43
      ],
      [
        -25,
        44
      ],
      [
        62,
        54
      ],
      [
        12,
        0
      ],
      [
        0,
        -33
      ],
      [
        13,
        -21
      ],
      [
        37,
        -33
      ],
      [
        62,
        -43
      ],
      [
        37,
        -87
      ],
      [
        49,
        -54
      ],
      [
        0,
        -44
      ],
      [
        124,
        -54
      ],
      [
        0,
        -43
      ],
      [
        -49,
        -109
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -44
      ],
      [
        12,
        -21
      ]
    ],
    [
      [
        69344,
        82608
      ],
      [
        -62,
        -22
      ],
      [
        -24,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        54
      ],
      [
        -124,
        -65
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -87
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        11
      ]
    ],
    [
      [
        78536,
        74723
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        43
      ],
      [
        -25,
        87
      ],
      [
        25,
        54
      ],
      [
        13,
        54
      ],
      [
        24,
        -21
      ],
      [
        38,
        -98
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -44
      ]
    ],
    [
      [
        78585,
        74040
      ],
      [
        -260,
        0
      ],
      [
        -25,
        54
      ],
      [
        -24,
        130
      ],
      [
        -38,
        98
      ],
      [
        -148,
        33
      ],
      [
        -87,
        21
      ],
      [
        -74,
        11
      ]
    ],
    [
      [
        78437,
        74940
      ],
      [
        -13,
        -21
      ],
      [
        13,
        -66
      ],
      [
        49,
        -141
      ],
      [
        0,
        -21
      ],
      [
        -62,
        21
      ],
      [
        -49,
        -75
      ],
      [
        -37,
        -66
      ],
      [
        49,
        -10
      ],
      [
        50,
        10
      ],
      [
        24,
        -21
      ],
      [
        13,
        -44
      ],
      [
        0,
        -43
      ],
      [
        25,
        -152
      ],
      [
        24,
        -43
      ],
      [
        38,
        -87
      ],
      [
        12,
        -43
      ],
      [
        0,
        -44
      ],
      [
        12,
        -54
      ]
    ],
    [
      [
        98108,
        65180
      ],
      [
        24,
        10
      ],
      [
        38,
        33
      ],
      [
        49,
        65
      ],
      [
        0,
        87
      ],
      [
        13,
        108
      ],
      [
        12,
        54
      ],
      [
        -12,
        76
      ],
      [
        -13,
        55
      ],
      [
        0,
        119
      ],
      [
        25,
        54
      ],
      [
        12,
        43
      ],
      [
        13,
        66
      ],
      [
        0,
        75
      ],
      [
        -25,
        22
      ],
      [
        -37,
        22
      ],
      [
        -25,
        32
      ],
      [
        0,
        76
      ],
      [
        12,
        22
      ],
      [
        -24,
        33
      ],
      [
        -62,
        32
      ],
      [
        -37,
        43
      ],
      [
        -13,
        55
      ],
      [
        -25,
        54
      ],
      [
        -49,
        87
      ],
      [
        -25,
        108
      ],
      [
        0,
        152
      ],
      [
        12,
        119
      ],
      [
        13,
        141
      ],
      [
        -25,
        98
      ],
      [
        -25,
        54
      ],
      [
        -86,
        98
      ],
      [
        -25,
        65
      ],
      [
        -50,
        108
      ],
      [
        -49,
        152
      ],
      [
        -37,
        54
      ],
      [
        -13,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -62,
        44
      ],
      [
        -49,
        21
      ],
      [
        -62,
        0
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -22
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -21
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        -76
      ],
      [
        -12,
        -65
      ],
      [
        -13,
        -33
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -21
      ],
      [
        -37,
        -55
      ],
      [
        0,
        -21
      ],
      [
        -25,
        0
      ],
      [
        0,
        65
      ],
      [
        -25,
        21
      ],
      [
        -24,
        11
      ],
      [
        -37,
        44
      ],
      [
        -75,
        97
      ],
      [
        -12,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -21
      ],
      [
        -24,
        10
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        -54
      ],
      [
        -62,
        -76
      ],
      [
        0,
        -11
      ],
      [
        -50,
        -54
      ],
      [
        -37,
        -66
      ],
      [
        -49,
        -75
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        21
      ],
      [
        -38,
        22
      ],
      [
        -12,
        22
      ],
      [
        25,
        130
      ],
      [
        37,
        152
      ],
      [
        12,
        65
      ],
      [
        0,
        97
      ],
      [
        -24,
        76
      ],
      [
        0,
        44
      ],
      [
        37,
        86
      ],
      [
        12,
        109
      ],
      [
        25,
        108
      ],
      [
        0,
        76
      ],
      [
        -25,
        152
      ],
      [
        0,
        130
      ],
      [
        -12,
        22
      ],
      [
        -87,
        22
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        43
      ],
      [
        -37,
        54
      ],
      [
        0,
        65
      ],
      [
        12,
        87
      ],
      [
        25,
        65
      ],
      [
        12,
        54
      ],
      [
        -12,
        33
      ],
      [
        0,
        33
      ],
      [
        -13,
        0
      ],
      [
        -24,
        32
      ],
      [
        -13,
        65
      ],
      [
        -37,
        22
      ],
      [
        -50,
        -87
      ],
      [
        0,
        54
      ]
    ],
    [
      [
        96373,
        68910
      ],
      [
        0,
        33
      ],
      [
        25,
        130
      ],
      [
        13,
        87
      ],
      [
        62,
        65
      ],
      [
        24,
        -11
      ],
      [
        25,
        11
      ],
      [
        0,
        32
      ],
      [
        -12,
        22
      ],
      [
        0,
        43
      ],
      [
        12,
        33
      ],
      [
        25,
        11
      ],
      [
        12,
        43
      ],
      [
        13,
        76
      ],
      [
        24,
        43
      ],
      [
        13,
        0
      ],
      [
        37,
        33
      ],
      [
        62,
        65
      ],
      [
        12,
        65
      ]
    ],
    [
      [
        97067,
        70190
      ],
      [
        13,
        -54
      ],
      [
        37,
        -65
      ],
      [
        49,
        -98
      ],
      [
        50,
        -76
      ],
      [
        25,
        -87
      ],
      [
        0,
        -54
      ],
      [
        12,
        -11
      ],
      [
        25,
        11
      ],
      [
        12,
        76
      ],
      [
        13,
        0
      ],
      [
        12,
        -54
      ],
      [
        25,
        0
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -65
      ],
      [
        0,
        -43
      ],
      [
        87,
        -228
      ],
      [
        37,
        -32
      ],
      [
        87,
        -44
      ],
      [
        49,
        -54
      ],
      [
        37,
        22
      ],
      [
        25,
        54
      ],
      [
        25,
        33
      ],
      [
        74,
        54
      ],
      [
        37,
        -22
      ],
      [
        50,
        -54
      ],
      [
        62,
        -87
      ],
      [
        25,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -38,
        -44
      ],
      [
        -37,
        -54
      ],
      [
        0,
        -11
      ],
      [
        87,
        -32
      ],
      [
        12,
        -33
      ],
      [
        0,
        -65
      ],
      [
        13,
        -11
      ],
      [
        37,
        11
      ],
      [
        25,
        -32
      ],
      [
        12,
        -55
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -55
      ],
      [
        -49,
        -86
      ],
      [
        -13,
        0
      ],
      [
        -99,
        43
      ],
      [
        -87,
        0
      ],
      [
        0,
        -22
      ],
      [
        13,
        -54
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        0,
        -43
      ],
      [
        74,
        -44
      ],
      [
        112,
        -130
      ],
      [
        25,
        -32
      ],
      [
        74,
        -87
      ],
      [
        87,
        -43
      ],
      [
        49,
        -33
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -33
      ],
      [
        25,
        -65
      ],
      [
        37,
        -65
      ],
      [
        25,
        -33
      ],
      [
        37,
        -21
      ],
      [
        25,
        -44
      ],
      [
        24,
        -65
      ],
      [
        0,
        -43
      ],
      [
        13,
        -44
      ],
      [
        25,
        -65
      ],
      [
        86,
        -184
      ],
      [
        13,
        -22
      ],
      [
        99,
        -119
      ],
      [
        12,
        -43
      ],
      [
        37,
        -87
      ],
      [
        25,
        -33
      ],
      [
        12,
        -54
      ],
      [
        0,
        -141
      ],
      [
        25,
        -32
      ],
      [
        13,
        -33
      ],
      [
        0,
        -32
      ],
      [
        12,
        -22
      ],
      [
        25,
        0
      ],
      [
        25,
        43
      ],
      [
        12,
        0
      ],
      [
        12,
        -76
      ],
      [
        13,
        -32
      ],
      [
        49,
        -44
      ],
      [
        50,
        -86
      ],
      [
        25,
        -33
      ],
      [
        24,
        -11
      ],
      [
        13,
        -21
      ],
      [
        0,
        -55
      ],
      [
        -13,
        -21
      ],
      [
        -62,
        -44
      ],
      [
        0,
        -65
      ],
      [
        13,
        -43
      ],
      [
        25,
        -33
      ],
      [
        12,
        -32
      ],
      [
        50,
        -65
      ],
      [
        37,
        -44
      ],
      [
        12,
        -54
      ],
      [
        12,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -24,
        -43
      ],
      [
        -37,
        -87
      ],
      [
        12,
        -43
      ],
      [
        0,
        -131
      ]
    ],
    [
      [
        74299,
        77847
      ],
      [
        99,
        0
      ],
      [
        13,
        32
      ],
      [
        37,
        -11
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        62,
        -44
      ],
      [
        25,
        -141
      ],
      [
        -13,
        -54
      ],
      [
        -24,
        -43
      ],
      [
        -13,
        0
      ],
      [
        -49,
        -65
      ],
      [
        0,
        -33
      ],
      [
        25,
        -43
      ],
      [
        -100,
        0
      ],
      [
        -24,
        -33
      ],
      [
        -25,
        -76
      ],
      [
        37,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        74002,
        76882
      ],
      [
        37,
        108
      ],
      [
        13,
        87
      ],
      [
        24,
        65
      ],
      [
        62,
        238
      ],
      [
        37,
        87
      ],
      [
        13,
        141
      ],
      [
        49,
        119
      ],
      [
        50,
        33
      ],
      [
        12,
        33
      ],
      [
        0,
        54
      ]
    ],
    [
      [
        57960,
        60527
      ],
      [
        25,
        33
      ],
      [
        25,
        86
      ],
      [
        37,
        87
      ],
      [
        37,
        54
      ],
      [
        50,
        87
      ],
      [
        49,
        43
      ],
      [
        62,
        131
      ],
      [
        13,
        10
      ],
      [
        12,
        87
      ],
      [
        12,
        109
      ],
      [
        25,
        32
      ],
      [
        37,
        22
      ],
      [
        13,
        22
      ],
      [
        25,
        75
      ],
      [
        0,
        109
      ]
    ],
    [
      [
        59323,
        58933
      ],
      [
        -37,
        11
      ],
      [
        -112,
        86
      ],
      [
        -86,
        55
      ],
      [
        -310,
        282
      ],
      [
        -74,
        119
      ],
      [
        -100,
        173
      ],
      [
        -210,
        347
      ],
      [
        -50,
        65
      ],
      [
        -62,
        22
      ],
      [
        -74,
        65
      ],
      [
        -12,
        98
      ],
      [
        -161,
        141
      ],
      [
        -75,
        130
      ]
    ],
    [
      [
        70521,
        69951
      ],
      [
        0,
        -303
      ],
      [
        0,
        -315
      ],
      [
        0,
        -314
      ],
      [
        0,
        -315
      ],
      [
        -173,
        0
      ],
      [
        -174,
        0
      ],
      [
        0,
        -314
      ]
    ],
    [
      [
        70174,
        68390
      ],
      [
        -161,
        152
      ],
      [
        -173,
        151
      ],
      [
        -161,
        141
      ],
      [
        -161,
        152
      ],
      [
        -161,
        141
      ],
      [
        -174,
        152
      ],
      [
        -161,
        152
      ],
      [
        -161,
        141
      ],
      [
        -173,
        152
      ],
      [
        -161,
        152
      ],
      [
        -161,
        141
      ],
      [
        -174,
        151
      ],
      [
        -161,
        141
      ],
      [
        -161,
        152
      ],
      [
        -173,
        152
      ],
      [
        -161,
        141
      ],
      [
        -112,
        108
      ],
      [
        -124,
        -97
      ],
      [
        -99,
        -87
      ],
      [
        -124,
        -98
      ]
    ],
    [
      [
        67077,
        70580
      ],
      [
        -148,
        -130
      ],
      [
        -112,
        -108
      ],
      [
        -12,
        0
      ],
      [
        -112,
        173
      ],
      [
        -86,
        141
      ],
      [
        -50,
        33
      ],
      [
        -161,
        76
      ],
      [
        -173,
        65
      ],
      [
        -186,
        76
      ]
    ],
    [
      [
        65195,
        75092
      ],
      [
        49,
        43
      ],
      [
        50,
        33
      ],
      [
        37,
        33
      ],
      [
        12,
        21
      ],
      [
        37,
        98
      ],
      [
        25,
        54
      ],
      [
        37,
        65
      ],
      [
        13,
        54
      ],
      [
        0,
        109
      ],
      [
        -50,
        271
      ],
      [
        13,
        43
      ],
      [
        37,
        87
      ],
      [
        12,
        11
      ],
      [
        62,
        22
      ],
      [
        25,
        43
      ],
      [
        12,
        54
      ],
      [
        13,
        22
      ],
      [
        74,
        97
      ],
      [
        62,
        55
      ],
      [
        49,
        54
      ],
      [
        62,
        54
      ],
      [
        62,
        44
      ],
      [
        0,
        75
      ],
      [
        -25,
        66
      ],
      [
        0,
        162
      ],
      [
        13,
        44
      ],
      [
        0,
        119
      ],
      [
        12,
        22
      ]
    ],
    [
      [
        65888,
        76947
      ],
      [
        50,
        -44
      ],
      [
        49,
        -21
      ],
      [
        161,
        -141
      ],
      [
        50,
        -22
      ],
      [
        111,
        -11
      ],
      [
        137,
        54
      ],
      [
        49,
        11
      ],
      [
        124,
        -76
      ],
      [
        62,
        0
      ],
      [
        136,
        -65
      ],
      [
        75,
        -87
      ],
      [
        24,
        -21
      ],
      [
        236,
        -76
      ],
      [
        62,
        -141
      ],
      [
        0,
        -120
      ],
      [
        12,
        -86
      ],
      [
        25,
        -109
      ],
      [
        37,
        -87
      ],
      [
        37,
        -65
      ],
      [
        149,
        -97
      ],
      [
        111,
        -22
      ],
      [
        112,
        -11
      ],
      [
        198,
        -76
      ],
      [
        161,
        -97
      ],
      [
        50,
        -55
      ],
      [
        74,
        -43
      ],
      [
        173,
        -228
      ],
      [
        87,
        -76
      ],
      [
        62,
        -10
      ],
      [
        62,
        10
      ],
      [
        99,
        76
      ],
      [
        50,
        44
      ],
      [
        99,
        195
      ],
      [
        37,
        108
      ],
      [
        12,
        65
      ],
      [
        -25,
        141
      ],
      [
        -24,
        66
      ],
      [
        -25,
        97
      ],
      [
        -12,
        163
      ],
      [
        24,
        108
      ],
      [
        13,
        76
      ],
      [
        37,
        65
      ],
      [
        87,
        130
      ],
      [
        86,
        98
      ],
      [
        149,
        119
      ],
      [
        87,
        0
      ],
      [
        37,
        11
      ],
      [
        74,
        87
      ],
      [
        25,
        11
      ],
      [
        49,
        -22
      ],
      [
        112,
        0
      ],
      [
        62,
        -22
      ],
      [
        62,
        -54
      ],
      [
        74,
        -32
      ],
      [
        62,
        -33
      ],
      [
        50,
        -43
      ],
      [
        12,
        -109
      ],
      [
        0,
        -65
      ],
      [
        62,
        -76
      ],
      [
        173,
        -32
      ],
      [
        37,
        -22
      ],
      [
        75,
        -76
      ],
      [
        124,
        -11
      ],
      [
        74,
        11
      ],
      [
        62,
        -11
      ],
      [
        25,
        -21
      ],
      [
        25,
        -44
      ],
      [
        49,
        -141
      ]
    ],
    [
      [
        40977,
        64843
      ],
      [
        -24,
        -65
      ],
      [
        -38,
        44
      ],
      [
        0,
        86
      ],
      [
        25,
        55
      ],
      [
        13,
        43
      ],
      [
        12,
        11
      ],
      [
        12,
        -54
      ],
      [
        0,
        -120
      ]
    ],
    [
      [
        89412,
        61872
      ],
      [
        0,
        -54
      ],
      [
        -25,
        32
      ],
      [
        -12,
        33
      ],
      [
        37,
        -11
      ]
    ],
    [
      [
        89437,
        62230
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        43
      ],
      [
        0,
        44
      ],
      [
        13,
        -11
      ],
      [
        25,
        -65
      ]
    ],
    [
      [
        89449,
        62338
      ],
      [
        87,
        0
      ],
      [
        37,
        -97
      ],
      [
        124,
        -174
      ],
      [
        62,
        -174
      ],
      [
        0,
        -43
      ],
      [
        12,
        -32
      ],
      [
        25,
        -22
      ],
      [
        74,
        -206
      ],
      [
        0,
        -65
      ],
      [
        37,
        -22
      ],
      [
        13,
        -22
      ],
      [
        24,
        -141
      ],
      [
        0,
        -54
      ],
      [
        87,
        -238
      ],
      [
        0,
        -33
      ],
      [
        37,
        -141
      ],
      [
        13,
        -22
      ],
      [
        12,
        -86
      ],
      [
        0,
        -239
      ],
      [
        -12,
        -98
      ],
      [
        -25,
        -86
      ],
      [
        -12,
        -65
      ],
      [
        -38,
        -55
      ],
      [
        -86,
        -108
      ],
      [
        -25,
        -22
      ],
      [
        -112,
        -76
      ],
      [
        -86,
        -65
      ],
      [
        -75,
        -22
      ],
      [
        -86,
        33
      ],
      [
        -50,
        98
      ],
      [
        -37,
        130
      ],
      [
        -12,
        141
      ],
      [
        -38,
        152
      ],
      [
        -24,
        466
      ],
      [
        -13,
        130
      ],
      [
        -12,
        174
      ],
      [
        25,
        -33
      ],
      [
        12,
        22
      ],
      [
        0,
        162
      ],
      [
        12,
        66
      ],
      [
        25,
        173
      ],
      [
        0,
        130
      ],
      [
        50,
        119
      ],
      [
        12,
        76
      ],
      [
        0,
        152
      ],
      [
        -12,
        76
      ],
      [
        37,
        -22
      ],
      [
        25,
        -32
      ],
      [
        24,
        -22
      ],
      [
        13,
        11
      ],
      [
        25,
        0
      ],
      [
        -13,
        43
      ],
      [
        -49,
        44
      ],
      [
        -75,
        22
      ],
      [
        -24,
        32
      ],
      [
        0,
        54
      ],
      [
        12,
        11
      ]
    ],
    [
      [
        71809,
        37405
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -43
      ],
      [
        -62,
        -195
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -87,
        32
      ],
      [
        -37,
        33
      ],
      [
        -25,
        43
      ],
      [
        -25,
        65
      ],
      [
        -37,
        33
      ],
      [
        -12,
        22
      ],
      [
        0,
        76
      ],
      [
        -62,
        140
      ],
      [
        -13,
        66
      ],
      [
        -24,
        54
      ],
      [
        -13,
        54
      ],
      [
        13,
        22
      ],
      [
        74,
        65
      ],
      [
        49,
        97
      ],
      [
        13,
        44
      ],
      [
        25,
        32
      ],
      [
        12,
        65
      ],
      [
        50,
        120
      ],
      [
        86,
        43
      ],
      [
        37,
        65
      ],
      [
        50,
        44
      ],
      [
        87,
        54
      ],
      [
        49,
        21
      ],
      [
        62,
        -108
      ],
      [
        13,
        -11
      ],
      [
        37,
        -65
      ],
      [
        37,
        -43
      ],
      [
        37,
        -55
      ],
      [
        37,
        -32
      ],
      [
        13,
        0
      ],
      [
        24,
        -87
      ],
      [
        0,
        -54
      ],
      [
        -24,
        -163
      ],
      [
        -38,
        -54
      ],
      [
        -24,
        -22
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -76
      ],
      [
        -37,
        -54
      ],
      [
        -87,
        -65
      ]
    ],
    [
      [
        69134,
        90742
      ],
      [
        -25,
        11
      ]
    ],
    [
      [
        69109,
        90753
      ],
      [
        50,
        65
      ],
      [
        12,
        54
      ],
      [
        12,
        0
      ],
      [
        -24,
        -87
      ],
      [
        -25,
        -43
      ]
    ],
    [
      [
        70001,
        89907
      ],
      [
        0,
        86
      ],
      [
        -13,
        44
      ],
      [
        -24,
        32
      ],
      [
        -62,
        54
      ],
      [
        -50,
        11
      ],
      [
        -12,
        33
      ],
      [
        -37,
        22
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        69753,
        90167
      ],
      [
        -25,
        87
      ],
      [
        0,
        43
      ],
      [
        50,
        174
      ],
      [
        0,
        21
      ],
      [
        -25,
        33
      ],
      [
        -49,
        32
      ],
      [
        -13,
        55
      ],
      [
        -173,
        0
      ],
      [
        -62,
        21
      ],
      [
        -112,
        54
      ],
      [
        -62,
        55
      ],
      [
        -49,
        -11
      ]
    ],
    [
      [
        69233,
        90731
      ],
      [
        -13,
        54
      ],
      [
        13,
        65
      ],
      [
        -25,
        109
      ],
      [
        -37,
        119
      ],
      [
        0,
        163
      ]
    ],
    [
      [
        69171,
        91241
      ],
      [
        87,
        75
      ],
      [
        111,
        76
      ],
      [
        37,
        11
      ],
      [
        99,
        44
      ],
      [
        186,
        -22
      ],
      [
        74,
        11
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        25,
        -44
      ],
      [
        50,
        33
      ],
      [
        148,
        -22
      ],
      [
        62,
        0
      ],
      [
        75,
        -21
      ],
      [
        37,
        -22
      ],
      [
        124,
        11
      ],
      [
        74,
        65
      ],
      [
        25,
        11
      ],
      [
        49,
        0
      ],
      [
        13,
        -44
      ],
      [
        37,
        -87
      ],
      [
        186,
        -43
      ],
      [
        24,
        -11
      ],
      [
        75,
        -76
      ],
      [
        74,
        -54
      ],
      [
        62,
        -98
      ],
      [
        87,
        -43
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        69171,
        91241
      ],
      [
        -12,
        119
      ],
      [
        0,
        228
      ],
      [
        12,
        119
      ],
      [
        99,
        119
      ],
      [
        25,
        76
      ],
      [
        0,
        65
      ],
      [
        12,
        54
      ],
      [
        99,
        152
      ],
      [
        62,
        22
      ],
      [
        99,
        43
      ],
      [
        112,
        33
      ],
      [
        37,
        -76
      ],
      [
        136,
        -130
      ],
      [
        37,
        -44
      ],
      [
        50,
        -141
      ],
      [
        124,
        -76
      ],
      [
        99,
        22
      ],
      [
        111,
        98
      ],
      [
        38,
        54
      ],
      [
        12,
        43
      ],
      [
        -12,
        206
      ],
      [
        -25,
        87
      ],
      [
        12,
        54
      ]
    ],
    [
      [
        71339,
        92152
      ],
      [
        49,
        -11
      ],
      [
        13,
        -55
      ],
      [
        86,
        -65
      ],
      [
        13,
        -21
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -55
      ],
      [
        -25,
        -86
      ],
      [
        49,
        21
      ],
      [
        25,
        -32
      ],
      [
        12,
        -54
      ],
      [
        38,
        -87
      ],
      [
        37,
        -33
      ],
      [
        12,
        -97
      ],
      [
        13,
        -44
      ],
      [
        0,
        -76
      ],
      [
        -13,
        -32
      ]
    ],
    [
      [
        100969,
        70082
      ],
      [
        13,
        32
      ],
      [
        12,
        -22
      ],
      [
        -25,
        -10
      ]
    ],
    [
      [
        40246,
        67500
      ],
      [
        -37,
        0
      ]
    ],
    [
      [
        40209,
        67500
      ],
      [
        13,
        33
      ],
      [
        24,
        -11
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        58939,
        73487
      ],
      [
        -50,
        0
      ],
      [
        13,
        -76
      ],
      [
        0,
        -173
      ],
      [
        12,
        -66
      ],
      [
        -12,
        -21
      ],
      [
        -37,
        -11
      ],
      [
        -174,
        0
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        -86
      ],
      [
        -12,
        -33
      ],
      [
        -62,
        0
      ],
      [
        -25,
        22
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -99,
        87
      ],
      [
        -37,
        0
      ],
      [
        -38,
        22
      ],
      [
        -49,
        -11
      ],
      [
        -50,
        -22
      ],
      [
        -74,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        0,
        -54
      ],
      [
        25,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        -65
      ],
      [
        -25,
        -76
      ],
      [
        -50,
        -119
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        -11
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -119
      ],
      [
        -24,
        -141
      ],
      [
        -13,
        -98
      ],
      [
        -25,
        -173
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -22
      ],
      [
        -49,
        -65
      ],
      [
        -75,
        -65
      ],
      [
        -49,
        -76
      ],
      [
        -13,
        -65
      ],
      [
        -24,
        -54
      ],
      [
        -13,
        -76
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -11
      ],
      [
        -61,
        -54
      ],
      [
        -38,
        -22
      ],
      [
        -49,
        -65
      ],
      [
        -13,
        -43
      ],
      [
        -24,
        -130
      ],
      [
        -13,
        -44
      ],
      [
        -25,
        -151
      ],
      [
        0,
        -87
      ],
      [
        -24,
        -130
      ],
      [
        0,
        -196
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -76
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        -21
      ],
      [
        -62,
        -141
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -54
      ],
      [
        -62,
        -87
      ],
      [
        -50,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -49,
        11
      ],
      [
        -50,
        0
      ],
      [
        -62,
        11
      ],
      [
        -99,
        22
      ],
      [
        -49,
        0
      ],
      [
        -50,
        -11
      ],
      [
        -136,
        0
      ],
      [
        -124,
        -33
      ],
      [
        -13,
        -10
      ]
    ],
    [
      [
        56077,
        69594
      ],
      [
        25,
        303
      ],
      [
        50,
        163
      ],
      [
        37,
        65
      ],
      [
        50,
        43
      ],
      [
        61,
        163
      ],
      [
        13,
        152
      ],
      [
        37,
        65
      ],
      [
        12,
        54
      ],
      [
        -12,
        44
      ],
      [
        25,
        75
      ],
      [
        49,
        131
      ],
      [
        13,
        76
      ],
      [
        49,
        119
      ],
      [
        -12,
        32
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        11
      ],
      [
        12,
        65
      ],
      [
        112,
        141
      ],
      [
        136,
        249
      ],
      [
        49,
        44
      ],
      [
        50,
        108
      ],
      [
        12,
        98
      ],
      [
        13,
        217
      ],
      [
        12,
        119
      ],
      [
        37,
        87
      ],
      [
        25,
        162
      ],
      [
        37,
        76
      ],
      [
        13,
        141
      ],
      [
        24,
        55
      ],
      [
        75,
        108
      ],
      [
        74,
        43
      ],
      [
        99,
        98
      ],
      [
        37,
        54
      ],
      [
        25,
        87
      ],
      [
        37,
        173
      ],
      [
        50,
        174
      ],
      [
        25,
        141
      ],
      [
        49,
        76
      ],
      [
        25,
        87
      ],
      [
        62,
        43
      ],
      [
        111,
        22
      ],
      [
        161,
        65
      ],
      [
        149,
        119
      ],
      [
        50,
        43
      ],
      [
        37,
        87
      ],
      [
        74,
        120
      ],
      [
        149,
        141
      ],
      [
        62,
        75
      ],
      [
        99,
        206
      ],
      [
        62,
        163
      ],
      [
        49,
        98
      ],
      [
        37,
        97
      ],
      [
        25,
        98
      ],
      [
        25,
        152
      ],
      [
        -13,
        54
      ],
      [
        -37,
        98
      ],
      [
        -37,
        21
      ],
      [
        0,
        55
      ],
      [
        13,
        75
      ],
      [
        0,
        141
      ],
      [
        12,
        217
      ],
      [
        37,
        185
      ],
      [
        112,
        227
      ],
      [
        24,
        98
      ],
      [
        13,
        152
      ],
      [
        0,
        54
      ],
      [
        148,
        217
      ],
      [
        75,
        174
      ],
      [
        99,
        119
      ],
      [
        260,
        163
      ],
      [
        149,
        119
      ],
      [
        74,
        87
      ],
      [
        49,
        97
      ],
      [
        149,
        401
      ],
      [
        136,
        564
      ],
      [
        0,
        66
      ],
      [
        62,
        21
      ],
      [
        50,
        11
      ],
      [
        37,
        22
      ],
      [
        37,
        43
      ],
      [
        37,
        -22
      ],
      [
        -12,
        -21
      ],
      [
        0,
        -76
      ],
      [
        25,
        -76
      ],
      [
        49,
        -98
      ],
      [
        99,
        -119
      ],
      [
        62,
        -43
      ],
      [
        112,
        -22
      ],
      [
        111,
        43
      ],
      [
        75,
        0
      ],
      [
        24,
        22
      ],
      [
        38,
        -33
      ],
      [
        74,
        -10
      ],
      [
        62,
        21
      ],
      [
        49,
        55
      ],
      [
        25,
        54
      ],
      [
        13,
        -33
      ],
      [
        0,
        -32
      ],
      [
        12,
        -11
      ],
      [
        12,
        -76
      ],
      [
        13,
        -22
      ],
      [
        37,
        0
      ],
      [
        37,
        -11
      ],
      [
        74,
        0
      ],
      [
        62,
        -10
      ]
    ],
    [
      [
        64488,
        83540
      ],
      [
        -24,
        -10
      ],
      [
        0,
        21
      ],
      [
        24,
        -11
      ]
    ],
    [
      [
        71079,
        86360
      ],
      [
        12,
        22
      ],
      [
        74,
        54
      ],
      [
        13,
        -11
      ],
      [
        111,
        0
      ],
      [
        37,
        44
      ],
      [
        25,
        -11
      ],
      [
        50,
        43
      ],
      [
        12,
        -11
      ],
      [
        50,
        -10
      ],
      [
        37,
        -22
      ],
      [
        49,
        -54
      ],
      [
        25,
        0
      ],
      [
        12,
        -44
      ],
      [
        25,
        -11
      ],
      [
        50,
        0
      ],
      [
        25,
        -54
      ],
      [
        37,
        -43
      ],
      [
        12,
        43
      ],
      [
        25,
        -11
      ],
      [
        62,
        -11
      ],
      [
        49,
        -108
      ],
      [
        25,
        -11
      ],
      [
        25,
        11
      ],
      [
        12,
        22
      ],
      [
        13,
        -11
      ],
      [
        24,
        -54
      ],
      [
        0,
        -141
      ],
      [
        -24,
        -76
      ],
      [
        12,
        -44
      ],
      [
        62,
        -54
      ],
      [
        12,
        -32
      ],
      [
        25,
        -22
      ],
      [
        25,
        0
      ],
      [
        12,
        -22
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -33
      ],
      [
        0,
        -54
      ],
      [
        50,
        -44
      ],
      [
        62,
        -32
      ],
      [
        25,
        -65
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -54
      ],
      [
        75,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        -62,
        -11
      ],
      [
        -13,
        -11
      ],
      [
        -49,
        65
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -37,
        32
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        0
      ],
      [
        0,
        87
      ],
      [
        -12,
        0
      ],
      [
        -74,
        -44
      ],
      [
        -13,
        -21
      ],
      [
        13,
        -33
      ],
      [
        0,
        -54
      ],
      [
        25,
        -65
      ],
      [
        -25,
        -76
      ],
      [
        -37,
        -44
      ],
      [
        -38,
        -32
      ],
      [
        0,
        -54
      ],
      [
        -24,
        -33
      ],
      [
        -38,
        -32
      ],
      [
        -24,
        -44
      ],
      [
        12,
        -32
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        71636,
        84603
      ],
      [
        -50,
        98
      ],
      [
        25,
        22
      ],
      [
        0,
        43
      ],
      [
        -12,
        54
      ],
      [
        0,
        54
      ],
      [
        -13,
        55
      ],
      [
        13,
        108
      ],
      [
        37,
        195
      ],
      [
        0,
        120
      ],
      [
        -25,
        86
      ],
      [
        -25,
        120
      ],
      [
        -99,
        119
      ],
      [
        -12,
        43
      ],
      [
        -50,
        65
      ],
      [
        -49,
        120
      ],
      [
        -50,
        65
      ],
      [
        -62,
        206
      ],
      [
        -24,
        54
      ],
      [
        -25,
        33
      ],
      [
        -13,
        32
      ],
      [
        -24,
        33
      ],
      [
        -38,
        32
      ],
      [
        -61,
        0
      ]
    ],
    [
      [
        79106,
        45658
      ],
      [
        -25,
        -21
      ],
      [
        37,
        141
      ],
      [
        12,
        10
      ],
      [
        -24,
        -130
      ]
    ],
    [
      [
        78561,
        47871
      ],
      [
        0,
        -33
      ],
      [
        -50,
        11
      ],
      [
        0,
        87
      ],
      [
        12,
        0
      ],
      [
        13,
        32
      ],
      [
        12,
        0
      ],
      [
        13,
        -65
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        78969,
        48445
      ],
      [
        13,
        -65
      ],
      [
        24,
        -65
      ],
      [
        50,
        -152
      ],
      [
        25,
        -54
      ],
      [
        25,
        -65
      ],
      [
        12,
        -119
      ],
      [
        37,
        -195
      ],
      [
        37,
        -282
      ],
      [
        0,
        -304
      ],
      [
        13,
        -130
      ],
      [
        24,
        -130
      ],
      [
        50,
        -130
      ],
      [
        12,
        -152
      ],
      [
        -24,
        -152
      ],
      [
        -38,
        -141
      ],
      [
        -24,
        -65
      ],
      [
        -13,
        0
      ],
      [
        -37,
        43
      ],
      [
        -25,
        54
      ],
      [
        -37,
        217
      ],
      [
        -12,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        -43
      ],
      [
        0,
        -22
      ],
      [
        13,
        -86
      ],
      [
        0,
        -66
      ],
      [
        12,
        -75
      ],
      [
        0,
        -98
      ],
      [
        25,
        -43
      ],
      [
        12,
        -66
      ],
      [
        0,
        -216
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -33
      ],
      [
        13,
        -33
      ],
      [
        0,
        -21
      ],
      [
        -38,
        -33
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        -66
      ],
      [
        -37,
        -130
      ],
      [
        0,
        -65
      ],
      [
        25,
        -195
      ],
      [
        -12,
        -152
      ],
      [
        -38,
        -271
      ],
      [
        -24,
        -130
      ],
      [
        -25,
        -152
      ],
      [
        -50,
        -206
      ],
      [
        -49,
        -260
      ],
      [
        -50,
        -261
      ],
      [
        -25,
        -162
      ],
      [
        -37,
        -152
      ],
      [
        -49,
        -282
      ],
      [
        -37,
        -271
      ],
      [
        -62,
        -315
      ],
      [
        -87,
        -347
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -174
      ],
      [
        -12,
        -151
      ],
      [
        -25,
        -152
      ],
      [
        -50,
        -250
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -76
      ],
      [
        -50,
        -151
      ],
      [
        -24,
        -120
      ],
      [
        -25,
        -162
      ],
      [
        -37,
        -130
      ],
      [
        -50,
        -120
      ],
      [
        -25,
        -43
      ],
      [
        -74,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -87,
        -11
      ],
      [
        -74,
        -32
      ],
      [
        -87,
        -66
      ],
      [
        -99,
        -119
      ],
      [
        -37,
        -22
      ],
      [
        -99,
        -10
      ],
      [
        -37,
        21
      ],
      [
        -99,
        130
      ],
      [
        -50,
        22
      ],
      [
        -74,
        22
      ],
      [
        -37,
        22
      ],
      [
        -38,
        75
      ],
      [
        -62,
        55
      ],
      [
        -24,
        54
      ],
      [
        0,
        43
      ],
      [
        -13,
        55
      ],
      [
        -12,
        86
      ],
      [
        -25,
        65
      ],
      [
        -62,
        109
      ],
      [
        0,
        238
      ],
      [
        -12,
        152
      ],
      [
        25,
        130
      ],
      [
        0,
        65
      ],
      [
        -25,
        76
      ],
      [
        -25,
        141
      ],
      [
        -62,
        120
      ],
      [
        -25,
        119
      ],
      [
        -12,
        195
      ],
      [
        -12,
        65
      ],
      [
        12,
        141
      ],
      [
        0,
        76
      ],
      [
        25,
        54
      ],
      [
        0,
        33
      ],
      [
        24,
        65
      ],
      [
        0,
        22
      ],
      [
        25,
        184
      ],
      [
        37,
        43
      ],
      [
        38,
        22
      ],
      [
        37,
        43
      ],
      [
        37,
        196
      ],
      [
        49,
        141
      ],
      [
        13,
        65
      ],
      [
        49,
        97
      ],
      [
        38,
        152
      ],
      [
        12,
        65
      ],
      [
        0,
        76
      ],
      [
        12,
        152
      ],
      [
        13,
        76
      ],
      [
        0,
        76
      ],
      [
        -75,
        228
      ],
      [
        0,
        206
      ],
      [
        -49,
        151
      ],
      [
        -25,
        131
      ],
      [
        -12,
        217
      ],
      [
        0,
        151
      ],
      [
        -13,
        76
      ],
      [
        13,
        120
      ],
      [
        148,
        423
      ],
      [
        0,
        292
      ],
      [
        37,
        22
      ],
      [
        124,
        22
      ],
      [
        25,
        11
      ],
      [
        25,
        32
      ],
      [
        62,
        98
      ],
      [
        12,
        -11
      ],
      [
        13,
        -33
      ],
      [
        12,
        -11
      ],
      [
        50,
        33
      ],
      [
        24,
        0
      ],
      [
        13,
        -11
      ],
      [
        24,
        65
      ],
      [
        0,
        33
      ],
      [
        13,
        11
      ],
      [
        111,
        21
      ],
      [
        50,
        33
      ],
      [
        12,
        -11
      ],
      [
        37,
        -98
      ],
      [
        13,
        -10
      ],
      [
        25,
        0
      ],
      [
        12,
        21
      ],
      [
        -37,
        44
      ],
      [
        0,
        65
      ],
      [
        12,
        76
      ],
      [
        37,
        54
      ],
      [
        62,
        76
      ],
      [
        75,
        97
      ],
      [
        24,
        11
      ],
      [
        13,
        -21
      ],
      [
        12,
        -109
      ],
      [
        0,
        -22
      ],
      [
        25,
        11
      ],
      [
        12,
        44
      ],
      [
        0,
        43
      ],
      [
        -12,
        33
      ],
      [
        0,
        65
      ],
      [
        37,
        65
      ],
      [
        25,
        65
      ],
      [
        12,
        76
      ],
      [
        13,
        32
      ],
      [
        37,
        33
      ],
      [
        12,
        -33
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -76
      ],
      [
        25,
        -11
      ],
      [
        13,
        11
      ],
      [
        49,
        152
      ],
      [
        13,
        43
      ],
      [
        24,
        22
      ],
      [
        37,
        0
      ],
      [
        -24,
        65
      ],
      [
        -13,
        109
      ],
      [
        62,
        184
      ],
      [
        0,
        43
      ],
      [
        13,
        22
      ],
      [
        -38,
        65
      ],
      [
        0,
        76
      ],
      [
        25,
        43
      ],
      [
        13,
        33
      ],
      [
        12,
        11
      ],
      [
        25,
        -11
      ],
      [
        25,
        -54
      ],
      [
        24,
        -11
      ],
      [
        38,
        54
      ],
      [
        12,
        65
      ],
      [
        37,
        44
      ],
      [
        37,
        21
      ],
      [
        62,
        98
      ],
      [
        50,
        271
      ],
      [
        -25,
        141
      ],
      [
        -25,
        87
      ],
      [
        13,
        21
      ],
      [
        24,
        -10
      ],
      [
        13,
        10
      ],
      [
        37,
        76
      ],
      [
        62,
        152
      ],
      [
        37,
        -32
      ],
      [
        0,
        -44
      ],
      [
        50,
        -97
      ],
      [
        24,
        -55
      ]
    ],
    [
      [
        87182,
        58228
      ],
      [
        -12,
        11
      ],
      [
        0,
        21
      ],
      [
        12,
        11
      ],
      [
        12,
        -11
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        87219,
        58813
      ],
      [
        -12,
        0
      ],
      [
        0,
        33
      ],
      [
        12,
        11
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        30374,
        67880
      ],
      [
        -37,
        -11
      ],
      [
        0,
        11
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        23759,
        67923
      ],
      [
        -12,
        -10
      ],
      [
        -38,
        32
      ],
      [
        25,
        54
      ],
      [
        25,
        -43
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        32009,
        68899
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        65
      ],
      [
        12,
        65
      ],
      [
        25,
        43
      ],
      [
        25,
        0
      ],
      [
        25,
        22
      ],
      [
        -13,
        -76
      ],
      [
        -49,
        -98
      ]
    ],
    [
      [
        25283,
        69713
      ],
      [
        -13,
        -54
      ],
      [
        -25,
        21
      ],
      [
        -12,
        33
      ],
      [
        0,
        54
      ],
      [
        12,
        11
      ],
      [
        25,
        -22
      ],
      [
        13,
        -43
      ]
    ],
    [
      [
        23499,
        71448
      ],
      [
        -13,
        -22
      ],
      [
        -99,
        109
      ],
      [
        50,
        11
      ],
      [
        62,
        -98
      ]
    ],
    [
      [
        23883,
        71828
      ],
      [
        12,
        -65
      ],
      [
        -25,
        10
      ],
      [
        -24,
        33
      ],
      [
        -13,
        76
      ],
      [
        37,
        -22
      ],
      [
        13,
        -32
      ]
    ],
    [
      [
        23375,
        71546
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        76
      ],
      [
        -13,
        54
      ],
      [
        -12,
        22
      ],
      [
        -25,
        11
      ],
      [
        25,
        97
      ],
      [
        25,
        217
      ],
      [
        12,
        -43
      ],
      [
        -25,
        -206
      ],
      [
        0,
        -33
      ],
      [
        25,
        -65
      ],
      [
        0,
        -54
      ],
      [
        25,
        -65
      ]
    ],
    [
      [
        23697,
        72468
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        43
      ],
      [
        25,
        22
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        22297,
        73747
      ],
      [
        0,
        -21
      ],
      [
        -62,
        43
      ],
      [
        37,
        76
      ],
      [
        -12,
        76
      ],
      [
        12,
        11
      ],
      [
        13,
        -22
      ],
      [
        25,
        -98
      ],
      [
        -13,
        -65
      ]
    ],
    [
      [
        21244,
        74290
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        130
      ],
      [
        0,
        33
      ],
      [
        38,
        10
      ],
      [
        0,
        -32
      ],
      [
        24,
        -54
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        23325,
        74333
      ],
      [
        -37,
        -152
      ],
      [
        -25,
        11
      ],
      [
        -49,
        43
      ],
      [
        -13,
        33
      ],
      [
        25,
        163
      ],
      [
        13,
        21
      ],
      [
        49,
        22
      ],
      [
        13,
        -11
      ],
      [
        0,
        -54
      ],
      [
        24,
        -76
      ]
    ],
    [
      [
        22991,
        74365
      ],
      [
        -37,
        22
      ],
      [
        -112,
        195
      ],
      [
        0,
        109
      ],
      [
        25,
        -11
      ],
      [
        37,
        -43
      ],
      [
        13,
        -44
      ],
      [
        0,
        -54
      ],
      [
        62,
        -22
      ],
      [
        0,
        -108
      ],
      [
        12,
        -44
      ]
    ],
    [
      [
        22458,
        76014
      ],
      [
        -12,
        0
      ],
      [
        -13,
        32
      ],
      [
        0,
        33
      ],
      [
        38,
        -43
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        30188,
        65299
      ],
      [
        -12,
        11
      ],
      [
        -87,
        173
      ],
      [
        -99,
        185
      ],
      [
        -37,
        65
      ],
      [
        -38,
        43
      ],
      [
        -49,
        87
      ],
      [
        -124,
        184
      ],
      [
        -62,
        87
      ],
      [
        -74,
        108
      ],
      [
        -50,
        55
      ],
      [
        -62,
        43
      ],
      [
        -12,
        22
      ],
      [
        -25,
        21
      ],
      [
        -12,
        0
      ],
      [
        -25,
        -54
      ],
      [
        -62,
        0
      ],
      [
        -12,
        22
      ],
      [
        37,
        54
      ],
      [
        -13,
        22
      ],
      [
        -12,
        0
      ],
      [
        -50,
        -44
      ],
      [
        0,
        55
      ],
      [
        -24,
        32
      ],
      [
        -13,
        0
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -22
      ],
      [
        62,
        -21
      ],
      [
        12,
        -22
      ],
      [
        -49,
        0
      ],
      [
        -62,
        -22
      ],
      [
        -124,
        -130
      ],
      [
        -99,
        -54
      ],
      [
        -149,
        -119
      ],
      [
        -74,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -99,
        43
      ],
      [
        -124,
        120
      ],
      [
        -198,
        32
      ],
      [
        -137,
        152
      ],
      [
        -123,
        54
      ],
      [
        -87,
        152
      ],
      [
        -50,
        0
      ],
      [
        -37,
        22
      ],
      [
        -111,
        54
      ],
      [
        -124,
        33
      ],
      [
        -112,
        130
      ],
      [
        -74,
        43
      ],
      [
        -62,
        43
      ],
      [
        -149,
        87
      ],
      [
        -49,
        44
      ],
      [
        -50,
        75
      ],
      [
        -86,
        76
      ],
      [
        -38,
        65
      ],
      [
        -37,
        22
      ],
      [
        -49,
        119
      ],
      [
        -37,
        55
      ],
      [
        -25,
        21
      ],
      [
        -99,
        0
      ],
      [
        -112,
        44
      ],
      [
        -49,
        21
      ],
      [
        -112,
        76
      ],
      [
        -149,
        87
      ],
      [
        -49,
        98
      ],
      [
        -37,
        97
      ],
      [
        -75,
        120
      ],
      [
        -49,
        54
      ],
      [
        -74,
        54
      ],
      [
        -50,
        54
      ],
      [
        -62,
        33
      ],
      [
        -124,
        97
      ],
      [
        -37,
        87
      ],
      [
        -12,
        76
      ],
      [
        -62,
        87
      ],
      [
        -75,
        173
      ],
      [
        -12,
        65
      ],
      [
        -12,
        87
      ],
      [
        -13,
        54
      ],
      [
        -25,
        44
      ],
      [
        13,
        32
      ],
      [
        37,
        44
      ],
      [
        50,
        11
      ],
      [
        37,
        43
      ],
      [
        12,
        54
      ],
      [
        -25,
        54
      ],
      [
        -62,
        11
      ],
      [
        -12,
        22
      ],
      [
        25,
        22
      ],
      [
        49,
        108
      ],
      [
        25,
        65
      ],
      [
        0,
        163
      ],
      [
        13,
        65
      ],
      [
        -75,
        76
      ],
      [
        -37,
        130
      ],
      [
        -37,
        108
      ],
      [
        0,
        206
      ],
      [
        -50,
        196
      ],
      [
        -86,
        119
      ],
      [
        -75,
        152
      ],
      [
        -49,
        76
      ],
      [
        -62,
        162
      ],
      [
        -50,
        98
      ],
      [
        -74,
        174
      ],
      [
        -50,
        86
      ],
      [
        -235,
        282
      ],
      [
        12,
        0
      ],
      [
        62,
        -76
      ],
      [
        13,
        11
      ],
      [
        0,
        76
      ],
      [
        -13,
        11
      ],
      [
        -24,
        -11
      ],
      [
        -38,
        22
      ],
      [
        -37,
        11
      ],
      [
        -37,
        43
      ],
      [
        -25,
        54
      ],
      [
        0,
        55
      ],
      [
        -62,
        119
      ],
      [
        13,
        22
      ],
      [
        37,
        10
      ],
      [
        -12,
        44
      ],
      [
        -100,
        54
      ],
      [
        -37,
        54
      ],
      [
        -74,
        65
      ],
      [
        -25,
        33
      ],
      [
        -12,
        65
      ],
      [
        -13,
        11
      ],
      [
        -62,
        -44
      ],
      [
        -12,
        44
      ],
      [
        25,
        21
      ],
      [
        37,
        65
      ],
      [
        0,
        33
      ],
      [
        -50,
        -65
      ],
      [
        -61,
        -33
      ],
      [
        -25,
        11
      ],
      [
        -37,
        76
      ],
      [
        -13,
        195
      ],
      [
        50,
        131
      ],
      [
        25,
        32
      ],
      [
        -13,
        65
      ],
      [
        0,
        33
      ],
      [
        -12,
        54
      ],
      [
        -75,
        108
      ],
      [
        -86,
        -11
      ],
      [
        -25,
        44
      ],
      [
        -25,
        76
      ],
      [
        -12,
        54
      ],
      [
        0,
        33
      ],
      [
        -13,
        32
      ],
      [
        -111,
        54
      ],
      [
        -37,
        44
      ],
      [
        -37,
        54
      ],
      [
        -25,
        76
      ],
      [
        -13,
        65
      ],
      [
        0,
        65
      ],
      [
        13,
        87
      ],
      [
        12,
        43
      ],
      [
        -74,
        33
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        43
      ],
      [
        -62,
        98
      ],
      [
        -62,
        162
      ],
      [
        -74,
        55
      ],
      [
        -25,
        65
      ],
      [
        -25,
        43
      ],
      [
        -37,
        98
      ],
      [
        0,
        11
      ],
      [
        -37,
        54
      ],
      [
        -37,
        76
      ],
      [
        -13,
        54
      ],
      [
        -12,
        98
      ],
      [
        -50,
        54
      ],
      [
        -12,
        43
      ],
      [
        0,
        76
      ],
      [
        -62,
        109
      ],
      [
        -25,
        97
      ],
      [
        -24,
        65
      ],
      [
        -13,
        87
      ],
      [
        -25,
        119
      ],
      [
        -37,
        130
      ],
      [
        -37,
        87
      ],
      [
        -25,
        87
      ],
      [
        13,
        87
      ],
      [
        0,
        76
      ],
      [
        12,
        21
      ],
      [
        0,
        55
      ],
      [
        -12,
        21
      ],
      [
        -37,
        11
      ],
      [
        -13,
        22
      ],
      [
        -87,
        21
      ],
      [
        -49,
        33
      ],
      [
        0,
        76
      ],
      [
        -25,
        32
      ],
      [
        -87,
        66
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -44
      ],
      [
        -50,
        -10
      ],
      [
        -49,
        32
      ],
      [
        -99,
        109
      ],
      [
        -13,
        21
      ],
      [
        -37,
        11
      ],
      [
        -74,
        76
      ],
      [
        25,
        -65
      ],
      [
        24,
        -98
      ],
      [
        -24,
        -65
      ],
      [
        -13,
        -238
      ],
      [
        13,
        -55
      ],
      [
        37,
        -75
      ],
      [
        12,
        -120
      ],
      [
        25,
        -162
      ],
      [
        0,
        -217
      ],
      [
        25,
        -76
      ],
      [
        49,
        -87
      ],
      [
        13,
        -43
      ],
      [
        74,
        -55
      ],
      [
        37,
        -76
      ],
      [
        75,
        -108
      ],
      [
        24,
        -43
      ],
      [
        75,
        -163
      ],
      [
        0,
        -54
      ],
      [
        24,
        -65
      ],
      [
        38,
        21
      ],
      [
        12,
        -76
      ],
      [
        50,
        -21
      ],
      [
        37,
        -174
      ],
      [
        12,
        -32
      ],
      [
        37,
        -11
      ],
      [
        25,
        -22
      ],
      [
        0,
        -76
      ],
      [
        25,
        -54
      ],
      [
        0,
        -76
      ],
      [
        12,
        -54
      ],
      [
        0,
        -65
      ],
      [
        13,
        -44
      ],
      [
        61,
        -108
      ],
      [
        75,
        -76
      ],
      [
        12,
        -119
      ],
      [
        37,
        -98
      ],
      [
        62,
        -65
      ],
      [
        0,
        -65
      ],
      [
        37,
        -87
      ],
      [
        13,
        -97
      ],
      [
        37,
        -65
      ],
      [
        25,
        0
      ],
      [
        -37,
        65
      ],
      [
        -13,
        43
      ],
      [
        0,
        76
      ],
      [
        13,
        11
      ],
      [
        74,
        -109
      ],
      [
        12,
        -86
      ],
      [
        25,
        -44
      ],
      [
        0,
        -65
      ],
      [
        50,
        -173
      ],
      [
        0,
        -120
      ],
      [
        12,
        -86
      ],
      [
        50,
        -141
      ],
      [
        37,
        -22
      ],
      [
        12,
        -76
      ],
      [
        37,
        -163
      ],
      [
        50,
        -97
      ],
      [
        25,
        -76
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -76
      ],
      [
        -12,
        -44
      ],
      [
        25,
        -162
      ],
      [
        49,
        -76
      ],
      [
        50,
        -33
      ],
      [
        -13,
        -22
      ],
      [
        25,
        -21
      ],
      [
        25,
        65
      ],
      [
        -12,
        43
      ],
      [
        0,
        44
      ],
      [
        12,
        10
      ],
      [
        87,
        -108
      ],
      [
        12,
        -43
      ],
      [
        37,
        -44
      ],
      [
        37,
        -108
      ],
      [
        25,
        -44
      ],
      [
        12,
        -86
      ],
      [
        50,
        -44
      ],
      [
        37,
        -65
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -119
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        -43
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        10
      ],
      [
        -37,
        65
      ],
      [
        -25,
        217
      ],
      [
        -25,
        44
      ],
      [
        -12,
        65
      ],
      [
        -25,
        54
      ],
      [
        -99,
        87
      ],
      [
        -37,
        87
      ],
      [
        -50,
        54
      ],
      [
        -49,
        87
      ],
      [
        -137,
        141
      ],
      [
        -49,
        65
      ],
      [
        -37,
        76
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        21
      ],
      [
        0,
        33
      ],
      [
        -86,
        130
      ],
      [
        -13,
        54
      ],
      [
        0,
        76
      ],
      [
        13,
        174
      ],
      [
        12,
        97
      ],
      [
        -25,
        98
      ],
      [
        0,
        76
      ],
      [
        -25,
        97
      ],
      [
        -62,
        185
      ],
      [
        -49,
        43
      ],
      [
        -50,
        22
      ],
      [
        -124,
        163
      ],
      [
        -37,
        86
      ],
      [
        -24,
        87
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        11
      ],
      [
        -62,
        -55
      ],
      [
        -37,
        44
      ],
      [
        -49,
        119
      ],
      [
        -50,
        11
      ],
      [
        -37,
        76
      ],
      [
        -37,
        21
      ],
      [
        -50,
        11
      ],
      [
        -37,
        33
      ],
      [
        -12,
        43
      ],
      [
        0,
        54
      ],
      [
        -13,
        33
      ],
      [
        -111,
        141
      ],
      [
        -50,
        54
      ],
      [
        -12,
        33
      ],
      [
        0,
        32
      ],
      [
        74,
        -11
      ],
      [
        87,
        -21
      ],
      [
        37,
        0
      ],
      [
        50,
        54
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        24,
        -33
      ],
      [
        37,
        -32
      ],
      [
        0,
        32
      ],
      [
        -12,
        65
      ],
      [
        0,
        55
      ],
      [
        -37,
        10
      ],
      [
        37,
        55
      ],
      [
        25,
        130
      ],
      [
        12,
        130
      ],
      [
        -25,
        108
      ],
      [
        -61,
        76
      ],
      [
        -124,
        228
      ],
      [
        -75,
        119
      ],
      [
        -12,
        44
      ],
      [
        -25,
        21
      ],
      [
        -62,
        22
      ],
      [
        -49,
        65
      ],
      [
        -124,
        141
      ],
      [
        -25,
        120
      ],
      [
        -25,
        10
      ],
      [
        13,
        76
      ],
      [
        -13,
        141
      ],
      [
        -12,
        33
      ],
      [
        -50,
        32
      ],
      [
        -12,
        98
      ],
      [
        0,
        87
      ],
      [
        -12,
        65
      ],
      [
        -75,
        97
      ],
      [
        0,
        55
      ],
      [
        -12,
        43
      ],
      [
        0,
        54
      ],
      [
        -50,
        98
      ],
      [
        -49,
        87
      ],
      [
        -13,
        32
      ],
      [
        0,
        109
      ],
      [
        13,
        21
      ],
      [
        0,
        55
      ],
      [
        -75,
        86
      ],
      [
        -24,
        130
      ],
      [
        -50,
        65
      ],
      [
        0,
        22
      ],
      [
        -25,
        119
      ]
    ],
    [
      [
        21628,
        76534
      ],
      [
        99,
        11
      ],
      [
        99,
        22
      ],
      [
        298,
        33
      ],
      [
        86,
        21
      ],
      [
        199,
        22
      ],
      [
        49,
        11
      ],
      [
        -25,
        -98
      ],
      [
        -24,
        -32
      ],
      [
        173,
        -98
      ],
      [
        161,
        -87
      ],
      [
        161,
        -97
      ],
      [
        161,
        -87
      ],
      [
        161,
        -98
      ],
      [
        161,
        -86
      ],
      [
        174,
        -98
      ],
      [
        161,
        -87
      ],
      [
        124,
        0
      ],
      [
        235,
        0
      ],
      [
        248,
        0
      ],
      [
        124,
        0
      ],
      [
        235,
        0
      ],
      [
        0,
        282
      ],
      [
        235,
        0
      ],
      [
        75,
        -11
      ],
      [
        309,
        0
      ],
      [
        62,
        -141
      ],
      [
        37,
        -54
      ],
      [
        38,
        -32
      ],
      [
        74,
        -98
      ],
      [
        99,
        -163
      ],
      [
        87,
        -108
      ],
      [
        62,
        -54
      ],
      [
        62,
        -87
      ],
      [
        24,
        -87
      ],
      [
        50,
        -195
      ],
      [
        0,
        -87
      ],
      [
        25,
        -87
      ],
      [
        37,
        -108
      ],
      [
        37,
        -65
      ],
      [
        37,
        -22
      ],
      [
        62,
        -98
      ],
      [
        50,
        -43
      ],
      [
        111,
        -65
      ],
      [
        74,
        -87
      ],
      [
        62,
        -43
      ],
      [
        38,
        0
      ],
      [
        24,
        22
      ],
      [
        25,
        54
      ],
      [
        13,
        43
      ],
      [
        24,
        11
      ],
      [
        13,
        33
      ],
      [
        0,
        32
      ],
      [
        12,
        76
      ],
      [
        37,
        130
      ],
      [
        37,
        65
      ],
      [
        50,
        11
      ],
      [
        25,
        22
      ],
      [
        12,
        32
      ],
      [
        25,
        11
      ],
      [
        37,
        -32
      ],
      [
        62,
        -22
      ],
      [
        136,
        0
      ],
      [
        25,
        11
      ],
      [
        12,
        -22
      ],
      [
        38,
        -22
      ],
      [
        24,
        -65
      ],
      [
        99,
        -108
      ],
      [
        0,
        -33
      ],
      [
        100,
        -141
      ],
      [
        24,
        -65
      ],
      [
        13,
        -65
      ],
      [
        24,
        -97
      ],
      [
        75,
        -196
      ],
      [
        0,
        -43
      ],
      [
        12,
        -65
      ],
      [
        25,
        -54
      ],
      [
        37,
        -44
      ],
      [
        37,
        -76
      ],
      [
        87,
        -206
      ],
      [
        62,
        -54
      ],
      [
        25,
        -54
      ],
      [
        12,
        -54
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -33
      ],
      [
        24,
        -32
      ],
      [
        0,
        -120
      ],
      [
        50,
        -97
      ],
      [
        25,
        -76
      ],
      [
        12,
        -130
      ],
      [
        25,
        -65
      ],
      [
        37,
        -33
      ],
      [
        50,
        -11
      ],
      [
        37,
        -32
      ],
      [
        49,
        -54
      ],
      [
        50,
        -11
      ],
      [
        37,
        -33
      ],
      [
        25,
        -43
      ],
      [
        74,
        -22
      ],
      [
        99,
        -22
      ],
      [
        75,
        -32
      ],
      [
        74,
        -76
      ],
      [
        0,
        32
      ],
      [
        74,
        33
      ]
    ],
    [
      [
        28503,
        72435
      ],
      [
        -25,
        -239
      ],
      [
        -74,
        -217
      ],
      [
        -25,
        -140
      ],
      [
        -62,
        -391
      ],
      [
        -12,
        -249
      ],
      [
        0,
        -131
      ],
      [
        -12,
        -10
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -260
      ],
      [
        0,
        -271
      ],
      [
        -25,
        -66
      ],
      [
        -12,
        -97
      ],
      [
        0,
        -65
      ],
      [
        24,
        -141
      ],
      [
        13,
        -109
      ],
      [
        62,
        -195
      ],
      [
        24,
        -65
      ],
      [
        50,
        -54
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -76
      ],
      [
        -12,
        -43
      ],
      [
        -13,
        65
      ],
      [
        13,
        33
      ],
      [
        0,
        32
      ],
      [
        -25,
        22
      ],
      [
        -50,
        97
      ],
      [
        -12,
        -97
      ],
      [
        25,
        -65
      ],
      [
        24,
        -22
      ],
      [
        0,
        -43
      ],
      [
        50,
        -185
      ],
      [
        49,
        -195
      ],
      [
        25,
        -108
      ],
      [
        149,
        -271
      ],
      [
        87,
        -196
      ],
      [
        24,
        -195
      ],
      [
        25,
        -54
      ],
      [
        13,
        -87
      ],
      [
        49,
        -87
      ],
      [
        25,
        -54
      ],
      [
        25,
        -32
      ],
      [
        24,
        -98
      ],
      [
        0,
        -54
      ],
      [
        38,
        -33
      ],
      [
        24,
        0
      ],
      [
        13,
        11
      ],
      [
        49,
        -43
      ],
      [
        124,
        -11
      ],
      [
        62,
        -76
      ],
      [
        74,
        -33
      ],
      [
        38,
        -108
      ],
      [
        49,
        -109
      ],
      [
        50,
        0
      ],
      [
        74,
        11
      ],
      [
        112,
        76
      ],
      [
        37,
        33
      ],
      [
        74,
        43
      ],
      [
        111,
        11
      ],
      [
        25,
        -22
      ],
      [
        87,
        33
      ],
      [
        37,
        32
      ],
      [
        25,
        55
      ],
      [
        74,
        32
      ],
      [
        13,
        11
      ],
      [
        86,
        11
      ],
      [
        37,
        11
      ],
      [
        38,
        0
      ],
      [
        37,
        -44
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -22
      ],
      [
        12,
        -22
      ],
      [
        38,
        -43
      ],
      [
        74,
        -11
      ],
      [
        25,
        0
      ],
      [
        24,
        54
      ],
      [
        62,
        54
      ],
      [
        0,
        66
      ],
      [
        -12,
        32
      ],
      [
        -25,
        11
      ],
      [
        13,
        65
      ],
      [
        -38,
        -43
      ],
      [
        0,
        32
      ],
      [
        112,
        98
      ],
      [
        25,
        32
      ],
      [
        37,
        33
      ],
      [
        74,
        130
      ],
      [
        13,
        239
      ],
      [
        12,
        43
      ],
      [
        50,
        65
      ],
      [
        12,
        22
      ],
      [
        0,
        379
      ],
      [
        12,
        98
      ],
      [
        0,
        32
      ],
      [
        25,
        152
      ],
      [
        62,
        76
      ],
      [
        99,
        76
      ],
      [
        25,
        22
      ],
      [
        322,
        87
      ],
      [
        50,
        21
      ],
      [
        61,
        54
      ],
      [
        38,
        22
      ],
      [
        99,
        0
      ],
      [
        0,
        22
      ],
      [
        62,
        0
      ],
      [
        99,
        -44
      ],
      [
        74,
        -43
      ],
      [
        99,
        -11
      ],
      [
        13,
        33
      ],
      [
        -13,
        21
      ],
      [
        -37,
        -10
      ],
      [
        -25,
        32
      ],
      [
        62,
        0
      ],
      [
        25,
        33
      ],
      [
        37,
        -22
      ],
      [
        37,
        -76
      ],
      [
        25,
        -32
      ],
      [
        12,
        -141
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -98
      ],
      [
        -24,
        -76
      ],
      [
        -13,
        -54
      ],
      [
        -49,
        -97
      ],
      [
        -62,
        -87
      ],
      [
        -62,
        -163
      ],
      [
        -13,
        -87
      ],
      [
        0,
        -65
      ],
      [
        13,
        -65
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -21
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        -98
      ],
      [
        0,
        -21
      ],
      [
        25,
        -22
      ],
      [
        12,
        11
      ],
      [
        62,
        0
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        -21
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -54
      ],
      [
        13,
        -11
      ],
      [
        24,
        43
      ],
      [
        13,
        0
      ],
      [
        12,
        -21
      ],
      [
        -37,
        -152
      ],
      [
        -25,
        -152
      ],
      [
        -25,
        -87
      ],
      [
        -12,
        -130
      ],
      [
        -25,
        -108
      ],
      [
        -12,
        0
      ],
      [
        -25,
        97
      ],
      [
        -37,
        54
      ],
      [
        12,
        131
      ],
      [
        0,
        65
      ],
      [
        -12,
        0
      ],
      [
        -50,
        -65
      ],
      [
        0,
        -55
      ],
      [
        -24,
        -76
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        120293,
        59855
      ],
      [
        -12,
        21
      ],
      [
        12,
        54
      ],
      [
        13,
        -10
      ],
      [
        -13,
        -65
      ]
    ],
    [
      [
        120789,
        60668
      ],
      [
        49,
        -33
      ],
      [
        50,
        22
      ],
      [
        0,
        -11
      ],
      [
        -37,
        -21
      ],
      [
        -13,
        0
      ],
      [
        -49,
        32
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        69344,
        82608
      ],
      [
        13,
        -11
      ],
      [
        49,
        22
      ],
      [
        50,
        32
      ],
      [
        49,
        -11
      ],
      [
        87,
        33
      ],
      [
        25,
        -22
      ]
    ],
    [
      [
        58010,
        63965
      ],
      [
        0,
        43
      ],
      [
        -25,
        33
      ],
      [
        0,
        65
      ],
      [
        13,
        87
      ],
      [
        0,
        32
      ],
      [
        12,
        76
      ],
      [
        -25,
        33
      ],
      [
        0,
        21
      ],
      [
        -37,
        87
      ],
      [
        0,
        43
      ],
      [
        -25,
        76
      ],
      [
        -12,
        11
      ],
      [
        -37,
        11
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -32
      ],
      [
        -13,
        32
      ],
      [
        0,
        55
      ],
      [
        -24,
        43
      ],
      [
        -37,
        76
      ],
      [
        0,
        54
      ],
      [
        24,
        33
      ],
      [
        13,
        32
      ],
      [
        0,
        22
      ],
      [
        -13,
        43
      ],
      [
        -12,
        22
      ],
      [
        0,
        152
      ],
      [
        -25,
        65
      ],
      [
        -25,
        32
      ],
      [
        -24,
        55
      ],
      [
        12,
        76
      ],
      [
        12,
        43
      ],
      [
        -37,
        98
      ]
    ],
    [
      [
        57700,
        65462
      ],
      [
        62,
        -33
      ],
      [
        0,
        11
      ],
      [
        25,
        22
      ],
      [
        25,
        54
      ],
      [
        24,
        65
      ],
      [
        13,
        87
      ],
      [
        0,
        65
      ],
      [
        25,
        119
      ],
      [
        62,
        87
      ],
      [
        37,
        43
      ],
      [
        12,
        -11
      ],
      [
        25,
        -54
      ],
      [
        74,
        -108
      ],
      [
        75,
        -131
      ],
      [
        12,
        0
      ],
      [
        37,
        76
      ],
      [
        25,
        76
      ],
      [
        12,
        22
      ],
      [
        37,
        0
      ],
      [
        38,
        11
      ],
      [
        24,
        -11
      ],
      [
        50,
        -11
      ],
      [
        49,
        -22
      ],
      [
        62,
        0
      ],
      [
        62,
        11
      ],
      [
        62,
        22
      ],
      [
        50,
        22
      ],
      [
        0,
        97
      ],
      [
        12,
        33
      ],
      [
        13,
        0
      ],
      [
        12,
        -87
      ],
      [
        12,
        -22
      ],
      [
        248,
        0
      ],
      [
        211,
        0
      ],
      [
        210,
        0
      ],
      [
        211,
        0
      ],
      [
        272,
        0
      ],
      [
        149,
        0
      ],
      [
        12,
        185
      ],
      [
        25,
        162
      ],
      [
        13,
        141
      ],
      [
        -50,
        98
      ],
      [
        -37,
        87
      ],
      [
        -13,
        141
      ],
      [
        -24,
        314
      ],
      [
        0,
        152
      ],
      [
        -13,
        163
      ],
      [
        -24,
        303
      ],
      [
        -13,
        163
      ],
      [
        0,
        152
      ],
      [
        -25,
        314
      ],
      [
        -24,
        304
      ],
      [
        0,
        163
      ],
      [
        -25,
        303
      ],
      [
        -25,
        315
      ],
      [
        0,
        152
      ],
      [
        -12,
        162
      ],
      [
        -25,
        304
      ],
      [
        -12,
        163
      ],
      [
        0,
        152
      ],
      [
        -38,
        466
      ],
      [
        0,
        152
      ],
      [
        -12,
        162
      ],
      [
        -25,
        304
      ],
      [
        -12,
        163
      ],
      [
        0,
        152
      ],
      [
        -13,
        141
      ],
      [
        211,
        0
      ],
      [
        273,
        0
      ],
      [
        123,
        0
      ]
    ],
    [
      [
        63374,
        68173
      ],
      [
        0,
        -456
      ],
      [
        12,
        -173
      ],
      [
        0,
        -195
      ],
      [
        0,
        -521
      ],
      [
        -12,
        -22
      ],
      [
        -13,
        -97
      ],
      [
        0,
        -141
      ],
      [
        -25,
        -141
      ],
      [
        -49,
        -195
      ],
      [
        0,
        -55
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        -98
      ],
      [
        -12,
        -75
      ],
      [
        -149,
        43
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        -43
      ],
      [
        -99,
        -11
      ],
      [
        -99,
        0
      ],
      [
        -111,
        -11
      ],
      [
        -75,
        0
      ],
      [
        -198,
        -22
      ],
      [
        -62,
        -86
      ],
      [
        -49,
        -87
      ],
      [
        -13,
        -11
      ],
      [
        -74,
        -11
      ],
      [
        -99,
        11
      ],
      [
        -50,
        0
      ],
      [
        -24,
        -11
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        66941,
        78606
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -25,
        22
      ],
      [
        0,
        76
      ],
      [
        62,
        -65
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        95705,
        62414
      ],
      [
        -13,
        -32
      ],
      [
        -12,
        0
      ],
      [
        12,
        65
      ],
      [
        25,
        43
      ],
      [
        25,
        0
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -54
      ]
    ],
    [
      [
        95717,
        63054
      ],
      [
        25,
        -109
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        65
      ],
      [
        -25,
        32
      ],
      [
        0,
        44
      ],
      [
        13,
        11
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        95828,
        63065
      ],
      [
        -24,
        11
      ],
      [
        24,
        65
      ],
      [
        0,
        -76
      ]
    ],
    [
      [
        95717,
        63379
      ],
      [
        -12,
        0
      ],
      [
        12,
        65
      ],
      [
        12,
        44
      ],
      [
        13,
        -33
      ],
      [
        -25,
        -76
      ]
    ],
    [
      [
        95828,
        63553
      ],
      [
        0,
        -130
      ],
      [
        -24,
        21
      ],
      [
        -13,
        0
      ],
      [
        -12,
        65
      ],
      [
        0,
        22
      ],
      [
        -12,
        43
      ],
      [
        49,
        11
      ],
      [
        12,
        -32
      ]
    ],
    [
      [
        95816,
        63650
      ],
      [
        -12,
        0
      ],
      [
        0,
        109
      ],
      [
        24,
        -44
      ],
      [
        25,
        -32
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        95692,
        63802
      ],
      [
        -25,
        11
      ],
      [
        -12,
        43
      ],
      [
        12,
        33
      ],
      [
        25,
        -11
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -22
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        95667,
        63954
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -43
      ],
      [
        -25,
        33
      ],
      [
        25,
        32
      ],
      [
        24,
        0
      ]
    ],
    [
      [
        95779,
        64084
      ],
      [
        12,
        -21
      ],
      [
        13,
        0
      ],
      [
        0,
        -55
      ],
      [
        -25,
        -76
      ],
      [
        -25,
        -10
      ],
      [
        0,
        108
      ],
      [
        -12,
        65
      ],
      [
        12,
        43
      ],
      [
        25,
        -21
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        95754,
        64399
      ],
      [
        0,
        -109
      ],
      [
        -25,
        54
      ],
      [
        0,
        109
      ],
      [
        25,
        -54
      ]
    ],
    [
      [
        94429,
        66177
      ],
      [
        -25,
        -65
      ],
      [
        0,
        98
      ],
      [
        37,
        43
      ],
      [
        12,
        54
      ],
      [
        25,
        33
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -76
      ],
      [
        -37,
        -44
      ]
    ],
    [
      [
        95494,
        66362
      ],
      [
        -12,
        0
      ],
      [
        -13,
        32
      ],
      [
        -12,
        98
      ],
      [
        25,
        22
      ],
      [
        12,
        0
      ],
      [
        12,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -97
      ]
    ],
    [
      [
        94156,
        67880
      ],
      [
        -37,
        54
      ],
      [
        -25,
        65
      ],
      [
        37,
        11
      ],
      [
        50,
        -11
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -65
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        94169,
        68433
      ],
      [
        37,
        -54
      ],
      [
        12,
        0
      ],
      [
        25,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -22
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        65
      ],
      [
        -25,
        22
      ],
      [
        0,
        22
      ],
      [
        12,
        32
      ],
      [
        13,
        11
      ]
    ],
    [
      [
        94094,
        68639
      ],
      [
        0,
        -87
      ],
      [
        -25,
        33
      ],
      [
        0,
        87
      ],
      [
        25,
        -33
      ]
    ],
    [
      [
        93921,
        68661
      ],
      [
        -13,
        -33
      ],
      [
        -12,
        76
      ],
      [
        12,
        33
      ],
      [
        13,
        -76
      ]
    ],
    [
      [
        96373,
        68910
      ],
      [
        -61,
        55
      ],
      [
        -25,
        10
      ],
      [
        -13,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        0
      ],
      [
        -62,
        22
      ],
      [
        13,
        -65
      ],
      [
        12,
        -43
      ],
      [
        -25,
        -44
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        22
      ],
      [
        -24,
        0
      ],
      [
        -38,
        -43
      ],
      [
        -12,
        -120
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        11
      ],
      [
        -112,
        -54
      ],
      [
        -49,
        -11
      ],
      [
        -38,
        0
      ],
      [
        -49,
        54
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -87
      ],
      [
        -13,
        -119
      ],
      [
        13,
        -87
      ],
      [
        -37,
        -87
      ],
      [
        0,
        -32
      ],
      [
        12,
        -196
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        10
      ],
      [
        0,
        -10
      ],
      [
        25,
        -87
      ],
      [
        25,
        -44
      ],
      [
        24,
        11
      ],
      [
        13,
        -11
      ],
      [
        -13,
        -21
      ],
      [
        13,
        -55
      ],
      [
        25,
        -86
      ],
      [
        12,
        -65
      ],
      [
        -12,
        -65
      ],
      [
        0,
        -33
      ],
      [
        24,
        -54
      ],
      [
        99,
        -195
      ],
      [
        62,
        -141
      ],
      [
        62,
        -109
      ],
      [
        13,
        -54
      ],
      [
        0,
        -98
      ],
      [
        12,
        -54
      ],
      [
        25,
        -43
      ],
      [
        0,
        -33
      ],
      [
        25,
        -119
      ],
      [
        12,
        -22
      ],
      [
        50,
        76
      ],
      [
        12,
        -11
      ],
      [
        12,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -24,
        -76
      ],
      [
        -87,
        -76
      ],
      [
        0,
        -76
      ],
      [
        -13,
        -97
      ],
      [
        0,
        -130
      ],
      [
        13,
        -98
      ],
      [
        -13,
        -43
      ],
      [
        -24,
        11
      ],
      [
        -50,
        -55
      ],
      [
        -12,
        0
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -33
      ],
      [
        24,
        -206
      ],
      [
        25,
        -76
      ],
      [
        25,
        -65
      ],
      [
        37,
        -76
      ],
      [
        25,
        -75
      ],
      [
        49,
        -76
      ],
      [
        75,
        -109
      ],
      [
        24,
        -65
      ],
      [
        25,
        -87
      ],
      [
        25,
        -65
      ],
      [
        0,
        -130
      ],
      [
        12,
        -173
      ],
      [
        -24,
        -76
      ],
      [
        0,
        -44
      ],
      [
        24,
        -43
      ],
      [
        0,
        -54
      ],
      [
        13,
        -87
      ],
      [
        25,
        -54
      ],
      [
        24,
        -33
      ],
      [
        13,
        -32
      ],
      [
        0,
        -98
      ],
      [
        12,
        -54
      ],
      [
        13,
        -76
      ],
      [
        12,
        -54
      ],
      [
        37,
        -196
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -44
      ],
      [
        -37,
        -43
      ],
      [
        -13,
        -33
      ],
      [
        -25,
        -108
      ],
      [
        -62,
        -173
      ],
      [
        -62,
        -120
      ],
      [
        -37,
        -76
      ],
      [
        -37,
        -54
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -196
      ],
      [
        -25,
        -97
      ]
    ],
    [
      [
        95878,
        62577
      ],
      [
        -12,
        0
      ],
      [
        -25,
        -98
      ],
      [
        -25,
        43
      ],
      [
        0,
        163
      ],
      [
        -12,
        195
      ],
      [
        12,
        33
      ],
      [
        12,
        11
      ],
      [
        50,
        152
      ],
      [
        0,
        97
      ],
      [
        25,
        65
      ],
      [
        -13,
        54
      ],
      [
        0,
        66
      ],
      [
        13,
        54
      ],
      [
        0,
        43
      ],
      [
        12,
        44
      ],
      [
        25,
        32
      ],
      [
        -12,
        11
      ],
      [
        -13,
        32
      ],
      [
        -37,
        -43
      ],
      [
        -12,
        11
      ],
      [
        -13,
        43
      ],
      [
        13,
        44
      ],
      [
        0,
        21
      ],
      [
        12,
        33
      ],
      [
        0,
        54
      ],
      [
        -12,
        54
      ],
      [
        12,
        55
      ],
      [
        -25,
        0
      ],
      [
        0,
        54
      ],
      [
        25,
        32
      ],
      [
        -25,
        55
      ],
      [
        13,
        65
      ],
      [
        0,
        184
      ],
      [
        -25,
        87
      ],
      [
        0,
        108
      ],
      [
        -37,
        87
      ],
      [
        -13,
        119
      ],
      [
        -62,
        152
      ],
      [
        0,
        130
      ],
      [
        -12,
        33
      ],
      [
        -25,
        -217
      ],
      [
        -12,
        43
      ],
      [
        0,
        120
      ],
      [
        -13,
        54
      ],
      [
        13,
        108
      ],
      [
        -37,
        109
      ],
      [
        -13,
        76
      ],
      [
        -25,
        119
      ],
      [
        13,
        32
      ],
      [
        0,
        44
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        76
      ],
      [
        -13,
        206
      ],
      [
        -12,
        76
      ],
      [
        12,
        76
      ],
      [
        -24,
        282
      ],
      [
        -50,
        87
      ],
      [
        25,
        141
      ],
      [
        0,
        130
      ],
      [
        12,
        43
      ],
      [
        0,
        22
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -25,
        98
      ],
      [
        -37,
        130
      ],
      [
        -12,
        108
      ],
      [
        12,
        22
      ],
      [
        -37,
        43
      ],
      [
        -50,
        98
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        -65
      ],
      [
        25,
        -108
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -87
      ],
      [
        -13,
        -43
      ],
      [
        -49,
        -98
      ],
      [
        -50,
        -33
      ],
      [
        -24,
        0
      ],
      [
        -50,
        55
      ],
      [
        0,
        43
      ],
      [
        -12,
        65
      ],
      [
        -13,
        0
      ],
      [
        13,
        -87
      ],
      [
        0,
        -32
      ],
      [
        24,
        -87
      ],
      [
        0,
        -22
      ],
      [
        -86,
        -43
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -21
      ],
      [
        -86,
        -44
      ],
      [
        -25,
        -65
      ],
      [
        -13,
        -54
      ],
      [
        -37,
        -87
      ],
      [
        -62,
        -76
      ],
      [
        -12,
        0
      ],
      [
        -12,
        22
      ],
      [
        0,
        76
      ],
      [
        24,
        65
      ],
      [
        -12,
        33
      ],
      [
        -50,
        -131
      ],
      [
        -37,
        11
      ],
      [
        -49,
        -21
      ],
      [
        -13,
        108
      ],
      [
        0,
        33
      ],
      [
        -12,
        32
      ],
      [
        -25,
        -76
      ],
      [
        -49,
        -43
      ],
      [
        0,
        108
      ],
      [
        12,
        44
      ],
      [
        0,
        65
      ],
      [
        12,
        97
      ],
      [
        -12,
        11
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        -130
      ],
      [
        -49,
        -54
      ],
      [
        -25,
        11
      ],
      [
        0,
        65
      ],
      [
        12,
        249
      ],
      [
        25,
        33
      ],
      [
        13,
        43
      ],
      [
        12,
        141
      ],
      [
        12,
        54
      ],
      [
        13,
        109
      ],
      [
        12,
        21
      ],
      [
        25,
        87
      ],
      [
        0,
        163
      ],
      [
        -25,
        163
      ],
      [
        -25,
        238
      ],
      [
        -62,
        185
      ],
      [
        0,
        65
      ],
      [
        -24,
        76
      ],
      [
        24,
        10
      ],
      [
        -62,
        65
      ],
      [
        0,
        33
      ],
      [
        -12,
        152
      ],
      [
        0,
        87
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        12,
        -98
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -33
      ],
      [
        -50,
        33
      ],
      [
        -24,
        43
      ],
      [
        -75,
        217
      ],
      [
        13,
        22
      ],
      [
        12,
        0
      ],
      [
        50,
        -87
      ],
      [
        37,
        -22
      ],
      [
        24,
        22
      ],
      [
        25,
        43
      ],
      [
        13,
        65
      ],
      [
        -13,
        22
      ],
      [
        -25,
        22
      ],
      [
        -24,
        10
      ],
      [
        -25,
        55
      ],
      [
        0,
        54
      ],
      [
        -50,
        43
      ],
      [
        13,
        54
      ],
      [
        25,
        33
      ],
      [
        -50,
        0
      ],
      [
        -74,
        98
      ],
      [
        -37,
        0
      ],
      [
        -38,
        -11
      ],
      [
        25,
        -98
      ],
      [
        -12,
        -22
      ],
      [
        -13,
        0
      ],
      [
        -49,
        141
      ],
      [
        12,
        33
      ],
      [
        -12,
        33
      ],
      [
        12,
        97
      ],
      [
        -49,
        -119
      ],
      [
        -25,
        11
      ],
      [
        -13,
        21
      ],
      [
        25,
        55
      ],
      [
        13,
        10
      ],
      [
        -13,
        66
      ],
      [
        -25,
        32
      ],
      [
        -12,
        65
      ],
      [
        -12,
        0
      ],
      [
        12,
        -76
      ],
      [
        -12,
        -97
      ],
      [
        -37,
        108
      ],
      [
        -75,
        163
      ],
      [
        -25,
        43
      ]
    ],
    [
      [
        68576,
        82369
      ],
      [
        -49,
        44
      ],
      [
        -25,
        75
      ],
      [
        -74,
        120
      ],
      [
        -99,
        87
      ],
      [
        12,
        32
      ],
      [
        -50,
        -11
      ]
    ],
    [
      [
        68527,
        83410
      ],
      [
        0,
        -32
      ],
      [
        12,
        -22
      ],
      [
        62,
        -65
      ],
      [
        50,
        -87
      ],
      [
        74,
        -65
      ],
      [
        37,
        0
      ],
      [
        25,
        -11
      ],
      [
        74,
        -76
      ],
      [
        62,
        -43
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        92137,
        86924
      ],
      [
        37,
        0
      ],
      [
        25,
        11
      ],
      [
        37,
        43
      ],
      [
        13,
        33
      ],
      [
        0,
        54
      ],
      [
        24,
        44
      ],
      [
        50,
        10
      ],
      [
        62,
        0
      ],
      [
        37,
        11
      ],
      [
        12,
        -21
      ],
      [
        50,
        -11
      ],
      [
        12,
        21
      ],
      [
        0,
        33
      ],
      [
        13,
        11
      ],
      [
        24,
        -44
      ],
      [
        50,
        11
      ],
      [
        25,
        22
      ],
      [
        25,
        65
      ],
      [
        12,
        -11
      ],
      [
        37,
        0
      ],
      [
        25,
        33
      ],
      [
        62,
        32
      ],
      [
        12,
        22
      ],
      [
        -12,
        43
      ],
      [
        0,
        54
      ],
      [
        37,
        22
      ],
      [
        74,
        22
      ],
      [
        13,
        54
      ],
      [
        12,
        22
      ],
      [
        62,
        11
      ],
      [
        99,
        65
      ],
      [
        50,
        0
      ],
      [
        24,
        21
      ],
      [
        13,
        33
      ],
      [
        25,
        11
      ],
      [
        74,
        65
      ],
      [
        62,
        11
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        12,
        32
      ],
      [
        25,
        33
      ],
      [
        25,
        0
      ],
      [
        12,
        32
      ],
      [
        25,
        33
      ],
      [
        37,
        11
      ],
      [
        99,
        0
      ],
      [
        37,
        10
      ],
      [
        25,
        44
      ],
      [
        0,
        21
      ],
      [
        25,
        33
      ],
      [
        25,
        -43
      ],
      [
        74,
        -65
      ],
      [
        37,
        10
      ],
      [
        12,
        44
      ],
      [
        25,
        11
      ],
      [
        25,
        -11
      ],
      [
        25,
        -76
      ],
      [
        37,
        -33
      ],
      [
        37,
        0
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        37,
        0
      ],
      [
        99,
        -21
      ],
      [
        99,
        0
      ],
      [
        62,
        -11
      ],
      [
        13,
        -22
      ],
      [
        12,
        -65
      ],
      [
        0,
        -65
      ],
      [
        13,
        -54
      ],
      [
        12,
        -22
      ],
      [
        25,
        -11
      ],
      [
        37,
        -54
      ],
      [
        12,
        -33
      ],
      [
        37,
        11
      ],
      [
        75,
        0
      ],
      [
        24,
        -21
      ],
      [
        13,
        -33
      ],
      [
        25,
        -22
      ],
      [
        12,
        11
      ],
      [
        74,
        0
      ],
      [
        25,
        -22
      ],
      [
        25,
        0
      ],
      [
        12,
        22
      ],
      [
        50,
        11
      ],
      [
        37,
        33
      ],
      [
        37,
        -11
      ],
      [
        13,
        -22
      ],
      [
        24,
        22
      ],
      [
        75,
        -22
      ],
      [
        24,
        -33
      ],
      [
        25,
        -10
      ],
      [
        37,
        21
      ],
      [
        13,
        -21
      ],
      [
        25,
        -11
      ],
      [
        37,
        21
      ],
      [
        99,
        -21
      ],
      [
        37,
        -44
      ],
      [
        12,
        -32
      ],
      [
        25,
        -11
      ],
      [
        50,
        0
      ],
      [
        62,
        65
      ],
      [
        24,
        43
      ],
      [
        38,
        22
      ],
      [
        49,
        0
      ],
      [
        25,
        33
      ],
      [
        25,
        11
      ],
      [
        37,
        43
      ],
      [
        0,
        11
      ],
      [
        37,
        76
      ],
      [
        25,
        130
      ],
      [
        0,
        65
      ],
      [
        -50,
        22
      ],
      [
        -37,
        43
      ],
      [
        -25,
        87
      ],
      [
        0,
        43
      ],
      [
        -49,
        87
      ],
      [
        0,
        43
      ],
      [
        37,
        98
      ],
      [
        0,
        87
      ],
      [
        25,
        21
      ],
      [
        12,
        44
      ],
      [
        25,
        21
      ],
      [
        37,
        11
      ],
      [
        25,
        76
      ],
      [
        0,
        33
      ],
      [
        25,
        21
      ],
      [
        99,
        55
      ],
      [
        37,
        65
      ],
      [
        49,
        130
      ],
      [
        25,
        -11
      ],
      [
        25,
        -43
      ],
      [
        12,
        0
      ],
      [
        112,
        -65
      ],
      [
        111,
        -33
      ],
      [
        62,
        -76
      ],
      [
        37,
        -11
      ],
      [
        161,
        0
      ],
      [
        75,
        -43
      ],
      [
        136,
        -65
      ],
      [
        37,
        -33
      ],
      [
        62,
        -32
      ],
      [
        62,
        11
      ],
      [
        87,
        -33
      ],
      [
        99,
        -43
      ],
      [
        12,
        -22
      ],
      [
        0,
        -130
      ],
      [
        25,
        -87
      ],
      [
        0,
        -87
      ],
      [
        37,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -55
      ],
      [
        12,
        -21
      ],
      [
        50,
        -22
      ],
      [
        24,
        -32
      ],
      [
        75,
        -66
      ],
      [
        37,
        -21
      ],
      [
        99,
        -22
      ],
      [
        50,
        -54
      ],
      [
        49,
        -11
      ],
      [
        62,
        -33
      ],
      [
        62,
        22
      ],
      [
        50,
        -11
      ],
      [
        49,
        0
      ],
      [
        37,
        11
      ],
      [
        50,
        65
      ],
      [
        49,
        22
      ],
      [
        38,
        0
      ],
      [
        37,
        22
      ],
      [
        136,
        32
      ],
      [
        62,
        44
      ],
      [
        37,
        10
      ],
      [
        112,
        -43
      ],
      [
        61,
        0
      ],
      [
        62,
        -54
      ],
      [
        50,
        -11
      ],
      [
        50,
        11
      ],
      [
        74,
        0
      ],
      [
        49,
        -11
      ],
      [
        50,
        -33
      ],
      [
        25,
        -32
      ],
      [
        37,
        -76
      ],
      [
        62,
        -54
      ],
      [
        49,
        -11
      ],
      [
        87,
        0
      ],
      [
        99,
        -22
      ],
      [
        13,
        -11
      ],
      [
        0,
        -151
      ],
      [
        24,
        -22
      ],
      [
        25,
        -54
      ],
      [
        50,
        -22
      ],
      [
        62,
        -87
      ],
      [
        37,
        -32
      ],
      [
        37,
        -11
      ],
      [
        37,
        11
      ],
      [
        173,
        0
      ],
      [
        75,
        -22
      ],
      [
        25,
        -22
      ],
      [
        235,
        -65
      ],
      [
        37,
        33
      ],
      [
        37,
        0
      ],
      [
        75,
        -44
      ],
      [
        62,
        11
      ],
      [
        136,
        87
      ],
      [
        37,
        32
      ],
      [
        37,
        -10
      ],
      [
        99,
        43
      ],
      [
        37,
        0
      ],
      [
        38,
        11
      ],
      [
        49,
        0
      ],
      [
        99,
        54
      ],
      [
        50,
        11
      ],
      [
        62,
        -11
      ],
      [
        37,
        11
      ],
      [
        87,
        54
      ],
      [
        12,
        54
      ],
      [
        25,
        65
      ],
      [
        148,
        131
      ],
      [
        50,
        32
      ],
      [
        49,
        22
      ],
      [
        62,
        65
      ],
      [
        87,
        43
      ],
      [
        25,
        -11
      ],
      [
        62,
        -10
      ],
      [
        62,
        0
      ],
      [
        49,
        -33
      ],
      [
        37,
        -33
      ],
      [
        100,
        -119
      ],
      [
        49,
        -32
      ],
      [
        50,
        0
      ],
      [
        49,
        -11
      ],
      [
        25,
        21
      ],
      [
        50,
        22
      ],
      [
        74,
        44
      ],
      [
        25,
        0
      ],
      [
        111,
        -55
      ],
      [
        50,
        -65
      ]
    ],
    [
      [
        111907,
        65060
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        11
      ],
      [
        0,
        21
      ],
      [
        25,
        22
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        112043,
        65570
      ],
      [
        -12,
        -33
      ],
      [
        -12,
        44
      ],
      [
        0,
        22
      ],
      [
        12,
        21
      ],
      [
        12,
        -54
      ]
    ],
    [
      [
        112068,
        65668
      ],
      [
        0,
        -22
      ],
      [
        -25,
        11
      ],
      [
        13,
        65
      ],
      [
        25,
        0
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -21
      ]
    ],
    [
      [
        112056,
        66416
      ],
      [
        -25,
        11
      ],
      [
        0,
        21
      ],
      [
        25,
        0
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        112081,
        67511
      ],
      [
        0,
        44
      ],
      [
        12,
        10
      ],
      [
        12,
        -21
      ],
      [
        -24,
        -33
      ]
    ],
    [
      [
        112056,
        67934
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        10
      ],
      [
        0,
        44
      ],
      [
        25,
        -11
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        72974,
        39444
      ],
      [
        0,
        206
      ],
      [
        -25,
        108
      ],
      [
        0,
        76
      ],
      [
        12,
        65
      ],
      [
        -12,
        66
      ],
      [
        -37,
        32
      ]
    ],
    [
      [
        72912,
        39997
      ],
      [
        0,
        119
      ],
      [
        12,
        87
      ],
      [
        0,
        347
      ],
      [
        0,
        434
      ],
      [
        -25,
        87
      ],
      [
        -12,
        130
      ],
      [
        -25,
        87
      ],
      [
        -37,
        97
      ],
      [
        0,
        44
      ],
      [
        -25,
        76
      ],
      [
        -24,
        43
      ],
      [
        0,
        119
      ],
      [
        -25,
        174
      ],
      [
        -13,
        119
      ],
      [
        -24,
        130
      ],
      [
        -25,
        87
      ],
      [
        0,
        43
      ]
    ],
    [
      [
        72689,
        42220
      ],
      [
        49,
        65
      ],
      [
        112,
        196
      ],
      [
        49,
        97
      ],
      [
        38,
        87
      ],
      [
        136,
        239
      ],
      [
        12,
        10
      ],
      [
        -24,
        98
      ],
      [
        37,
        119
      ],
      [
        0,
        174
      ],
      [
        24,
        32
      ],
      [
        38,
        65
      ],
      [
        37,
        98
      ],
      [
        37,
        87
      ],
      [
        37,
        141
      ],
      [
        12,
        32
      ],
      [
        0,
        44
      ],
      [
        -12,
        43
      ],
      [
        -49,
        152
      ],
      [
        -25,
        108
      ],
      [
        25,
        87
      ],
      [
        0,
        119
      ],
      [
        -38,
        33
      ],
      [
        -12,
        32
      ],
      [
        0,
        55
      ],
      [
        12,
        21
      ],
      [
        50,
        44
      ],
      [
        0,
        21
      ],
      [
        12,
        22
      ],
      [
        0,
        33
      ],
      [
        25,
        173
      ],
      [
        0,
        98
      ],
      [
        -12,
        76
      ],
      [
        0,
        195
      ],
      [
        12,
        206
      ],
      [
        0,
        119
      ],
      [
        -37,
        130
      ],
      [
        0,
        98
      ],
      [
        25,
        65
      ],
      [
        0,
        44
      ],
      [
        -13,
        0
      ],
      [
        -62,
        21
      ],
      [
        -37,
        54
      ],
      [
        -124,
        87
      ],
      [
        -111,
        11
      ],
      [
        -87,
        130
      ],
      [
        -62,
        22
      ],
      [
        -25,
        22
      ],
      [
        -61,
        75
      ],
      [
        -211,
        22
      ],
      [
        -74,
        0
      ],
      [
        -13,
        119
      ],
      [
        0,
        98
      ]
    ],
    [
      [
        72379,
        46439
      ],
      [
        0,
        87
      ],
      [
        -12,
        97
      ],
      [
        -13,
        44
      ],
      [
        -24,
        65
      ],
      [
        -13,
        65
      ],
      [
        0,
        43
      ],
      [
        87,
        65
      ],
      [
        25,
        22
      ],
      [
        49,
        33
      ],
      [
        87,
        43
      ],
      [
        74,
        33
      ],
      [
        62,
        32
      ],
      [
        75,
        43
      ],
      [
        24,
        22
      ],
      [
        124,
        76
      ],
      [
        25,
        22
      ],
      [
        74,
        32
      ],
      [
        99,
        65
      ],
      [
        223,
        131
      ]
    ],
    [
      [
        73345,
        47459
      ],
      [
        13,
        -22
      ],
      [
        49,
        -152
      ],
      [
        50,
        -87
      ],
      [
        37,
        -87
      ],
      [
        25,
        22
      ],
      [
        25,
        11
      ],
      [
        74,
        22
      ],
      [
        25,
        0
      ],
      [
        12,
        21
      ],
      [
        37,
        22
      ],
      [
        50,
        0
      ],
      [
        12,
        -11
      ],
      [
        37,
        -108
      ],
      [
        13,
        -76
      ],
      [
        12,
        -119
      ],
      [
        0,
        -141
      ],
      [
        -12,
        -98
      ],
      [
        -37,
        -108
      ],
      [
        0,
        -55
      ],
      [
        -25,
        -86
      ],
      [
        -25,
        -44
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -44
      ],
      [
        12,
        -32
      ],
      [
        37,
        -55
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -43
      ],
      [
        25,
        -43
      ],
      [
        25,
        -33
      ],
      [
        25,
        -65
      ],
      [
        49,
        -87
      ],
      [
        62,
        -119
      ],
      [
        50,
        -43
      ],
      [
        12,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        25,
        -54
      ],
      [
        12,
        -11
      ],
      [
        50,
        0
      ],
      [
        0,
        195
      ],
      [
        -12,
        109
      ],
      [
        -25,
        43
      ],
      [
        0,
        44
      ],
      [
        25,
        76
      ],
      [
        12,
        75
      ],
      [
        12,
        44
      ],
      [
        13,
        11
      ],
      [
        86,
        21
      ],
      [
        38,
        22
      ],
      [
        12,
        22
      ],
      [
        12,
        65
      ],
      [
        13,
        173
      ],
      [
        0,
        163
      ],
      [
        -13,
        98
      ],
      [
        13,
        141
      ],
      [
        24,
        97
      ],
      [
        -12,
        11
      ],
      [
        0,
        119
      ],
      [
        -62,
        131
      ],
      [
        -99,
        260
      ],
      [
        -49,
        97
      ],
      [
        -75,
        152
      ],
      [
        -37,
        65
      ],
      [
        -25,
        22
      ],
      [
        -62,
        11
      ],
      [
        -24,
        32
      ],
      [
        -13,
        55
      ],
      [
        0,
        86
      ],
      [
        -12,
        65
      ],
      [
        0,
        120
      ],
      [
        -13,
        162
      ],
      [
        -12,
        44
      ],
      [
        -12,
        119
      ],
      [
        -25,
        119
      ],
      [
        0,
        33
      ],
      [
        12,
        22
      ],
      [
        25,
        86
      ],
      [
        37,
        98
      ],
      [
        13,
        87
      ],
      [
        12,
        43
      ],
      [
        12,
        22
      ],
      [
        50,
        11
      ],
      [
        49,
        -11
      ]
    ],
    [
      [
        73952,
        48977
      ],
      [
        75,
        11
      ],
      [
        99,
        -11
      ],
      [
        12,
        -11
      ],
      [
        25,
        0
      ],
      [
        25,
        11
      ],
      [
        25,
        32
      ],
      [
        24,
        55
      ],
      [
        37,
        0
      ],
      [
        62,
        -55
      ],
      [
        38,
        -43
      ],
      [
        0,
        -43
      ],
      [
        37,
        -22
      ],
      [
        74,
        -11
      ],
      [
        62,
        22
      ],
      [
        25,
        54
      ],
      [
        37,
        22
      ],
      [
        37,
        0
      ],
      [
        25,
        -11
      ],
      [
        25,
        -44
      ],
      [
        37,
        -21
      ],
      [
        49,
        -11
      ],
      [
        62,
        22
      ],
      [
        62,
        54
      ],
      [
        37,
        65
      ],
      [
        0,
        65
      ],
      [
        25,
        54
      ],
      [
        37,
        0
      ],
      [
        50,
        11
      ],
      [
        49,
        -22
      ],
      [
        62,
        -65
      ],
      [
        38,
        44
      ],
      [
        74,
        76
      ],
      [
        62,
        32
      ],
      [
        62,
        0
      ],
      [
        49,
        33
      ],
      [
        37,
        54
      ],
      [
        50,
        32
      ],
      [
        50,
        11
      ],
      [
        99,
        87
      ],
      [
        124,
        174
      ],
      [
        37,
        54
      ]
    ],
    [
      [
        75848,
        49682
      ],
      [
        12,
        -65
      ],
      [
        37,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        37,
        -44
      ],
      [
        -37,
        -54
      ],
      [
        0,
        -43
      ],
      [
        12,
        -22
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -76
      ],
      [
        -37,
        -86
      ],
      [
        25,
        -76
      ],
      [
        -13,
        -131
      ],
      [
        25,
        -119
      ],
      [
        0,
        -54
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -120
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -22
      ],
      [
        13,
        -65
      ],
      [
        0,
        -87
      ],
      [
        -13,
        -32
      ],
      [
        -37,
        -54
      ],
      [
        0,
        -55
      ],
      [
        50,
        0
      ],
      [
        0,
        -141
      ],
      [
        -13,
        -43
      ],
      [
        13,
        -54
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -44
      ],
      [
        0,
        -195
      ],
      [
        12,
        -174
      ],
      [
        0,
        -32
      ],
      [
        13,
        -22
      ],
      [
        24,
        0
      ],
      [
        0,
        -54
      ],
      [
        -24,
        -65
      ],
      [
        0,
        -87
      ],
      [
        24,
        76
      ],
      [
        25,
        0
      ],
      [
        13,
        -32
      ],
      [
        0,
        -207
      ],
      [
        -13,
        -32
      ],
      [
        -37,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -33
      ],
      [
        13,
        -54
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -130
      ],
      [
        -87,
        -185
      ],
      [
        -74,
        -130
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -98
      ],
      [
        -50,
        -22
      ],
      [
        -25,
        -21
      ],
      [
        25,
        -87
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -76
      ],
      [
        -136,
        -130
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        -76
      ],
      [
        -50,
        -22
      ],
      [
        -24,
        -22
      ],
      [
        -50,
        -10
      ],
      [
        -25,
        0
      ],
      [
        -99,
        -76
      ],
      [
        -87,
        -44
      ],
      [
        -24,
        -43
      ],
      [
        -75,
        -54
      ],
      [
        -210,
        -206
      ],
      [
        -75,
        -130
      ],
      [
        -24,
        -33
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -33
      ],
      [
        -49,
        -108
      ],
      [
        -75,
        -130
      ],
      [
        -12,
        -44
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        43
      ],
      [
        -12,
        -86
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -50,
        -44
      ],
      [
        -111,
        -162
      ],
      [
        -99,
        -207
      ],
      [
        -137,
        -195
      ],
      [
        -37,
        0
      ],
      [
        -49,
        65
      ],
      [
        0,
        -32
      ],
      [
        12,
        -33
      ],
      [
        0,
        -173
      ],
      [
        -12,
        -196
      ],
      [
        0,
        -43
      ],
      [
        24,
        -54
      ],
      [
        38,
        -65
      ],
      [
        37,
        -87
      ],
      [
        37,
        -249
      ],
      [
        12,
        -120
      ],
      [
        50,
        -162
      ],
      [
        0,
        -65
      ],
      [
        12,
        -174
      ],
      [
        0,
        -228
      ],
      [
        25,
        -32
      ],
      [
        0,
        87
      ],
      [
        12,
        86
      ],
      [
        13,
        33
      ],
      [
        12,
        0
      ],
      [
        0,
        -44
      ],
      [
        13,
        -32
      ],
      [
        0,
        -87
      ],
      [
        -13,
        -173
      ],
      [
        0,
        -65
      ],
      [
        25,
        -120
      ],
      [
        -25,
        -141
      ],
      [
        -37,
        -325
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -33
      ],
      [
        25,
        0
      ],
      [
        12,
        33
      ],
      [
        13,
        0
      ],
      [
        -13,
        -174
      ],
      [
        -86,
        -228
      ],
      [
        -38,
        -65
      ],
      [
        -49,
        -76
      ],
      [
        -136,
        -97
      ],
      [
        -261,
        -163
      ],
      [
        -173,
        -119
      ],
      [
        -136,
        -141
      ],
      [
        -50,
        -98
      ],
      [
        -25,
        -108
      ],
      [
        -49,
        -109
      ],
      [
        37,
        -97
      ],
      [
        50,
        -76
      ],
      [
        24,
        87
      ],
      [
        0,
        32
      ],
      [
        13,
        0
      ],
      [
        0,
        -108
      ],
      [
        -25,
        -369
      ]
    ],
    [
      [
        73234,
        39444
      ],
      [
        -37,
        0
      ],
      [
        -62,
        -11
      ],
      [
        -74,
        0
      ],
      [
        -62,
        22
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        73841,
        48706
      ],
      [
        0,
        21
      ],
      [
        -12,
        11
      ],
      [
        -25,
        -32
      ],
      [
        12,
        -33
      ],
      [
        25,
        0
      ],
      [
        0,
        33
      ]
    ],
    [
      [
        73866,
        48651
      ],
      [
        12,
        11
      ],
      [
        0,
        44
      ],
      [
        -25,
        11
      ],
      [
        0,
        -76
      ],
      [
        13,
        10
      ]
    ],
    [
      [
        56288,
        68520
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        44
      ],
      [
        37,
        86
      ],
      [
        12,
        11
      ],
      [
        -12,
        -108
      ]
    ],
    [
      [
        57700,
        65462
      ],
      [
        -49,
        54
      ],
      [
        -13,
        54
      ],
      [
        -24,
        43
      ],
      [
        -50,
        22
      ],
      [
        -25,
        33
      ],
      [
        -25,
        54
      ],
      [
        -12,
        11
      ],
      [
        0,
        65
      ],
      [
        -25,
        65
      ],
      [
        -25,
        32
      ],
      [
        -12,
        0
      ],
      [
        -25,
        22
      ],
      [
        0,
        22
      ],
      [
        -12,
        21
      ],
      [
        -25,
        11
      ],
      [
        -12,
        54
      ],
      [
        -13,
        87
      ],
      [
        -24,
        76
      ],
      [
        -13,
        54
      ],
      [
        -25,
        22
      ],
      [
        -12,
        0
      ],
      [
        0,
        33
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -12,
        32
      ],
      [
        -13,
        0
      ],
      [
        -24,
        -21
      ],
      [
        -13,
        0
      ],
      [
        -25,
        43
      ],
      [
        -12,
        33
      ],
      [
        0,
        32
      ],
      [
        -37,
        65
      ],
      [
        -74,
        98
      ],
      [
        -87,
        54
      ],
      [
        -87,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -13,
        11
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -21
      ],
      [
        -62,
        0
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        -33
      ],
      [
        -49,
        -10
      ],
      [
        -62,
        0
      ],
      [
        -37,
        10
      ],
      [
        -25,
        22
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -43
      ],
      [
        -13,
        -87
      ],
      [
        -24,
        -54
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -108
      ],
      [
        -12,
        -44
      ]
    ],
    [
      [
        56239,
        66112
      ],
      [
        0,
        271
      ],
      [
        24,
        206
      ],
      [
        37,
        196
      ],
      [
        50,
        173
      ],
      [
        37,
        217
      ],
      [
        25,
        217
      ],
      [
        -12,
        206
      ],
      [
        -13,
        184
      ],
      [
        -25,
        120
      ],
      [
        -12,
        184
      ],
      [
        -37,
        98
      ],
      [
        -62,
        76
      ],
      [
        -12,
        54
      ],
      [
        12,
        11
      ],
      [
        37,
        11
      ],
      [
        25,
        65
      ],
      [
        -50,
        -22
      ],
      [
        62,
        195
      ],
      [
        13,
        130
      ],
      [
        0,
        87
      ],
      [
        12,
        54
      ],
      [
        -50,
        120
      ],
      [
        -24,
        151
      ],
      [
        -37,
        33
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -32
      ],
      [
        -25,
        22
      ],
      [
        -37,
        108
      ],
      [
        -49,
        173
      ],
      [
        -13,
        11
      ],
      [
        -25,
        -43
      ],
      [
        -24,
        -141
      ]
    ],
    [
      [
        56053,
        69214
      ],
      [
        0,
        54
      ],
      [
        24,
        152
      ],
      [
        13,
        119
      ],
      [
        272,
        0
      ],
      [
        248,
        0
      ],
      [
        235,
        0
      ],
      [
        149,
        0
      ],
      [
        161,
        0
      ],
      [
        285,
        0
      ],
      [
        0,
        326
      ],
      [
        -12,
        86
      ],
      [
        0,
        250
      ],
      [
        -13,
        65
      ],
      [
        0,
        43
      ],
      [
        -12,
        76
      ],
      [
        -12,
        44
      ],
      [
        49,
        151
      ],
      [
        50,
        55
      ],
      [
        49,
        65
      ],
      [
        37,
        54
      ],
      [
        25,
        11
      ],
      [
        62,
        11
      ],
      [
        50,
        43
      ],
      [
        74,
        54
      ],
      [
        0,
        402
      ],
      [
        0,
        336
      ],
      [
        0,
        260
      ],
      [
        0,
        249
      ],
      [
        0,
        337
      ],
      [
        124,
        0
      ],
      [
        186,
        0
      ],
      [
        198,
        0
      ],
      [
        124,
        0
      ],
      [
        198,
        0
      ],
      [
        124,
        0
      ],
      [
        198,
        0
      ],
      [
        0,
        314
      ],
      [
        0,
        488
      ]
    ],
    [
      [
        40544,
        66676
      ],
      [
        0,
        -43
      ],
      [
        -25,
        11
      ],
      [
        0,
        32
      ],
      [
        12,
        33
      ],
      [
        13,
        -33
      ]
    ],
    [
      [
        81756,
        43413
      ],
      [
        -37,
        -11
      ],
      [
        -49,
        0
      ],
      [
        -25,
        33
      ],
      [
        12,
        32
      ],
      [
        0,
        44
      ],
      [
        13,
        65
      ],
      [
        12,
        32
      ],
      [
        25,
        22
      ],
      [
        0,
        54
      ],
      [
        25,
        33
      ],
      [
        24,
        11
      ],
      [
        38,
        -65
      ],
      [
        12,
        -76
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        73345,
        47459
      ],
      [
        -12,
        43
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        0
      ],
      [
        0,
        21
      ],
      [
        -37,
        98
      ],
      [
        -25,
        22
      ],
      [
        -12,
        21
      ],
      [
        12,
        11
      ],
      [
        0,
        33
      ],
      [
        -12,
        21
      ],
      [
        -37,
        22
      ],
      [
        0,
        22
      ],
      [
        37,
        21
      ],
      [
        25,
        55
      ],
      [
        24,
        65
      ],
      [
        13,
        65
      ],
      [
        12,
        21
      ],
      [
        0,
        141
      ],
      [
        12,
        55
      ],
      [
        -12,
        21
      ],
      [
        -12,
        44
      ],
      [
        12,
        65
      ],
      [
        12,
        43
      ],
      [
        75,
        44
      ],
      [
        62,
        43
      ],
      [
        12,
        22
      ],
      [
        25,
        65
      ],
      [
        -12,
        11
      ],
      [
        -38,
        0
      ],
      [
        -12,
        10
      ],
      [
        -25,
        130
      ],
      [
        13,
        141
      ],
      [
        0,
        174
      ],
      [
        -13,
        11
      ],
      [
        -12,
        32
      ],
      [
        0,
        76
      ],
      [
        12,
        0
      ],
      [
        25,
        98
      ],
      [
        12,
        65
      ],
      [
        -12,
        43
      ],
      [
        -25,
        120
      ],
      [
        25,
        54
      ],
      [
        25,
        0
      ],
      [
        12,
        11
      ],
      [
        74,
        119
      ],
      [
        0,
        22
      ],
      [
        -12,
        43
      ],
      [
        -25,
        65
      ],
      [
        0,
        22
      ],
      [
        -12,
        76
      ],
      [
        -37,
        65
      ],
      [
        -37,
        54
      ],
      [
        12,
        54
      ],
      [
        0,
        55
      ],
      [
        -25,
        65
      ],
      [
        -25,
        54
      ],
      [
        0,
        32
      ],
      [
        -12,
        11
      ],
      [
        -25,
        0
      ],
      [
        0,
        -21
      ],
      [
        -37,
        10
      ],
      [
        0,
        65
      ],
      [
        -25,
        55
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        73246,
        50333
      ],
      [
        25,
        10
      ],
      [
        50,
        -65
      ],
      [
        37,
        0
      ],
      [
        37,
        -11
      ],
      [
        25,
        -54
      ],
      [
        25,
        -11
      ],
      [
        12,
        11
      ],
      [
        87,
        0
      ],
      [
        37,
        -43
      ],
      [
        25,
        0
      ],
      [
        0,
        87
      ],
      [
        12,
        21
      ],
      [
        37,
        -21
      ],
      [
        74,
        -120
      ],
      [
        0,
        -21
      ],
      [
        62,
        -120
      ],
      [
        13,
        -43
      ],
      [
        0,
        -33
      ],
      [
        12,
        -108
      ],
      [
        0,
        -109
      ],
      [
        13,
        -43
      ],
      [
        0,
        -22
      ],
      [
        24,
        -119
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -54
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -55
      ],
      [
        24,
        -65
      ],
      [
        25,
        -32
      ],
      [
        0,
        -44
      ],
      [
        12,
        -21
      ],
      [
        25,
        -11
      ],
      [
        13,
        -22
      ],
      [
        24,
        -97
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        100251,
        57718
      ],
      [
        -13,
        0
      ],
      [
        -12,
        22
      ],
      [
        -12,
        184
      ],
      [
        12,
        22
      ],
      [
        12,
        0
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -75
      ],
      [
        13,
        -76
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        97786,
        57924
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        33
      ],
      [
        13,
        54
      ],
      [
        12,
        11
      ],
      [
        13,
        -65
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        102406,
        58813
      ],
      [
        0,
        55
      ],
      [
        13,
        11
      ],
      [
        24,
        -11
      ],
      [
        37,
        -44
      ]
    ],
    [
      [
        96435,
        59518
      ],
      [
        -12,
        -10
      ],
      [
        -25,
        10
      ],
      [
        0,
        98
      ],
      [
        13,
        11
      ],
      [
        24,
        -11
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -76
      ]
    ],
    [
      [
        96274,
        60256
      ],
      [
        25,
        -65
      ],
      [
        -12,
        -33
      ],
      [
        -13,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -12,
        43
      ],
      [
        -13,
        22
      ],
      [
        0,
        32
      ],
      [
        13,
        11
      ],
      [
        25,
        -22
      ],
      [
        24,
        33
      ],
      [
        0,
        11
      ]
    ],
    [
      [
        96373,
        60234
      ],
      [
        0,
        33
      ],
      [
        13,
        97
      ],
      [
        0,
        22
      ],
      [
        37,
        0
      ],
      [
        25,
        -76
      ],
      [
        74,
        -54
      ],
      [
        25,
        -11
      ],
      [
        25,
        22
      ],
      [
        12,
        -22
      ],
      [
        25,
        -22
      ],
      [
        0,
        -54
      ],
      [
        25,
        -54
      ],
      [
        37,
        11
      ],
      [
        25,
        -11
      ],
      [
        0,
        -54
      ],
      [
        12,
        -76
      ],
      [
        -12,
        -55
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -43
      ],
      [
        12,
        -32
      ],
      [
        25,
        -33
      ],
      [
        0,
        -22
      ],
      [
        12,
        0
      ],
      [
        25,
        22
      ],
      [
        13,
        43
      ],
      [
        0,
        33
      ],
      [
        61,
        32
      ],
      [
        50,
        44
      ],
      [
        12,
        -22
      ],
      [
        13,
        -54
      ],
      [
        12,
        -11
      ],
      [
        37,
        0
      ],
      [
        37,
        33
      ],
      [
        13,
        54
      ],
      [
        0,
        43
      ],
      [
        49,
        65
      ],
      [
        0,
        65
      ],
      [
        13,
        33
      ]
    ],
    [
      [
        97055,
        60115
      ],
      [
        62,
        -22
      ],
      [
        12,
        -22
      ],
      [
        74,
        -195
      ],
      [
        87,
        -141
      ],
      [
        37,
        -43
      ],
      [
        25,
        -22
      ],
      [
        50,
        -76
      ],
      [
        24,
        -97
      ],
      [
        75,
        -250
      ],
      [
        12,
        -119
      ],
      [
        13,
        -174
      ],
      [
        -13,
        -260
      ],
      [
        -25,
        -130
      ],
      [
        0,
        -54
      ],
      [
        25,
        -98
      ],
      [
        0,
        -369
      ],
      [
        13,
        -54
      ],
      [
        24,
        -43
      ],
      [
        87,
        -119
      ],
      [
        12,
        -44
      ],
      [
        50,
        -152
      ],
      [
        87,
        -336
      ],
      [
        24,
        -152
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        55
      ],
      [
        0,
        43
      ],
      [
        -25,
        33
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -25,
        10
      ],
      [
        -49,
        -10
      ],
      [
        -50,
        -76
      ],
      [
        -24,
        0
      ],
      [
        -13,
        65
      ],
      [
        -12,
        43
      ],
      [
        -13,
        22
      ],
      [
        -161,
        162
      ],
      [
        -62,
        33
      ],
      [
        -62,
        119
      ],
      [
        -136,
        130
      ],
      [
        -87,
        120
      ],
      [
        -37,
        87
      ],
      [
        -86,
        65
      ],
      [
        -38,
        76
      ],
      [
        -49,
        43
      ],
      [
        25,
        87
      ],
      [
        -13,
        76
      ],
      [
        0,
        75
      ],
      [
        -74,
        131
      ],
      [
        -25,
        97
      ],
      [
        -62,
        98
      ],
      [
        -25,
        54
      ],
      [
        -24,
        65
      ],
      [
        37,
        33
      ],
      [
        -13,
        43
      ],
      [
        -37,
        87
      ],
      [
        -12,
        87
      ],
      [
        0,
        173
      ],
      [
        -50,
        250
      ],
      [
        -49,
        336
      ],
      [
        12,
        119
      ],
      [
        -12,
        130
      ],
      [
        -25,
        119
      ],
      [
        -37,
        98
      ],
      [
        -13,
        65
      ]
    ],
    [
      [
        99644,
        57479
      ],
      [
        25,
        -86
      ],
      [
        0,
        -22
      ],
      [
        49,
        -54
      ],
      [
        50,
        -33
      ],
      [
        37,
        -11
      ],
      [
        74,
        0
      ],
      [
        12,
        11
      ],
      [
        112,
        -108
      ],
      [
        37,
        -11
      ],
      [
        37,
        11
      ],
      [
        13,
        -11
      ],
      [
        62,
        -76
      ],
      [
        12,
        -11
      ],
      [
        25,
        11
      ],
      [
        -37,
        33
      ],
      [
        -13,
        21
      ],
      [
        -12,
        44
      ],
      [
        0,
        43
      ],
      [
        25,
        33
      ],
      [
        12,
        32
      ],
      [
        12,
        109
      ],
      [
        25,
        97
      ],
      [
        0,
        54
      ],
      [
        -12,
        33
      ],
      [
        -13,
        65
      ],
      [
        25,
        87
      ],
      [
        13,
        -33
      ],
      [
        24,
        -21
      ],
      [
        25,
        10
      ],
      [
        13,
        33
      ],
      [
        -13,
        43
      ],
      [
        0,
        87
      ],
      [
        25,
        65
      ],
      [
        37,
        54
      ],
      [
        37,
        22
      ],
      [
        136,
        33
      ],
      [
        211,
        97
      ],
      [
        62,
        44
      ],
      [
        25,
        10
      ],
      [
        25,
        33
      ],
      [
        24,
        87
      ],
      [
        62,
        130
      ],
      [
        50,
        119
      ],
      [
        87,
        163
      ],
      [
        74,
        152
      ],
      [
        12,
        21
      ],
      [
        13,
        87
      ],
      [
        0,
        76
      ],
      [
        24,
        33
      ]
    ],
    [
      [
        101502,
        59280
      ],
      [
        0,
        -130
      ],
      [
        12,
        -76
      ],
      [
        13,
        -120
      ],
      [
        49,
        -21
      ],
      [
        25,
        11
      ],
      [
        -12,
        54
      ],
      [
        0,
        108
      ],
      [
        -25,
        76
      ],
      [
        -13,
        76
      ],
      [
        -12,
        22
      ]
    ],
    [
      [
        101539,
        59280
      ],
      [
        87,
        11
      ],
      [
        12,
        32
      ],
      [
        37,
        44
      ],
      [
        13,
        32
      ],
      [
        0,
        54
      ],
      [
        -37,
        44
      ],
      [
        -13,
        43
      ],
      [
        0,
        54
      ],
      [
        50,
        98
      ],
      [
        37,
        -22
      ],
      [
        37,
        0
      ],
      [
        25,
        54
      ],
      [
        25,
        66
      ],
      [
        49,
        97
      ],
      [
        25,
        152
      ],
      [
        124,
        249
      ],
      [
        12,
        33
      ],
      [
        74,
        249
      ],
      [
        25,
        -10
      ],
      [
        13,
        -76
      ],
      [
        -25,
        -87
      ],
      [
        0,
        -54
      ],
      [
        37,
        32
      ],
      [
        37,
        87
      ],
      [
        37,
        108
      ],
      [
        50,
        -32
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -33
      ],
      [
        12,
        -65
      ],
      [
        25,
        -43
      ],
      [
        50,
        -22
      ],
      [
        37,
        -43
      ],
      [
        12,
        -22
      ],
      [
        0,
        -33
      ],
      [
        13,
        -43
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -55
      ],
      [
        12,
        -76
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -43
      ],
      [
        62,
        0
      ],
      [
        37,
        21
      ],
      [
        37,
        55
      ],
      [
        37,
        -120
      ],
      [
        -25,
        -21
      ],
      [
        -49,
        -33
      ],
      [
        25,
        -43
      ],
      [
        12,
        0
      ],
      [
        37,
        32
      ],
      [
        37,
        44
      ],
      [
        25,
        0
      ],
      [
        74,
        -65
      ],
      [
        13,
        -22
      ],
      [
        12,
        -65
      ],
      [
        37,
        -22
      ],
      [
        99,
        -87
      ],
      [
        25,
        0
      ],
      [
        37,
        11
      ],
      [
        13,
        -11
      ],
      [
        25,
        -65
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -74,
        -43
      ],
      [
        -87,
        -44
      ],
      [
        -37,
        0
      ],
      [
        -62,
        33
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        -108
      ],
      [
        37,
        -98
      ],
      [
        87,
        -98
      ],
      [
        12,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -11
      ],
      [
        -62,
        -32
      ],
      [
        -50,
        -11
      ],
      [
        -74,
        -43
      ],
      [
        -37,
        11
      ],
      [
        -62,
        43
      ],
      [
        -12,
        0
      ],
      [
        -13,
        -22
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        102233,
        60690
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        43
      ],
      [
        0,
        44
      ],
      [
        37,
        54
      ],
      [
        37,
        11
      ],
      [
        0,
        -87
      ],
      [
        -13,
        -22
      ],
      [
        -24,
        -10
      ]
    ],
    [
      [
        68799,
        40735
      ],
      [
        0,
        -261
      ],
      [
        0,
        -282
      ],
      [
        0,
        -271
      ],
      [
        0,
        -282
      ],
      [
        0,
        -271
      ],
      [
        0,
        -282
      ],
      [
        0,
        -282
      ],
      [
        0,
        -358
      ],
      [
        -37,
        0
      ],
      [
        -74,
        -32
      ],
      [
        -37,
        -55
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        -38,
        -32
      ],
      [
        -49,
        11
      ],
      [
        -62,
        32
      ],
      [
        -74,
        11
      ],
      [
        -100,
        -22
      ],
      [
        -74,
        11
      ],
      [
        -49,
        43
      ],
      [
        -38,
        22
      ],
      [
        -49,
        0
      ],
      [
        -87,
        44
      ],
      [
        -12,
        54
      ],
      [
        -25,
        76
      ],
      [
        0,
        32
      ],
      [
        12,
        22
      ],
      [
        0,
        32
      ],
      [
        -12,
        55
      ],
      [
        -12,
        21
      ],
      [
        -25,
        0
      ],
      [
        -13,
        22
      ],
      [
        -24,
        76
      ],
      [
        -25,
        32
      ],
      [
        -50,
        -21
      ],
      [
        -24,
        -98
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -44
      ],
      [
        -12,
        0
      ],
      [
        -74,
        -65
      ],
      [
        -13,
        -32
      ]
    ],
    [
      [
        67585,
        38338
      ],
      [
        -37,
        54
      ],
      [
        -111,
        184
      ],
      [
        -50,
        55
      ],
      [
        -49,
        119
      ],
      [
        -137,
        358
      ],
      [
        -12,
        65
      ],
      [
        -25,
        173
      ],
      [
        -37,
        130
      ],
      [
        0,
        76
      ],
      [
        12,
        44
      ],
      [
        -24,
        108
      ],
      [
        -38,
        65
      ],
      [
        -12,
        228
      ],
      [
        -37,
        152
      ],
      [
        12,
        119
      ],
      [
        -12,
        109
      ],
      [
        0,
        195
      ],
      [
        -25,
        163
      ],
      [
        -49,
        141
      ],
      [
        -38,
        216
      ],
      [
        -12,
        98
      ],
      [
        12,
        260
      ],
      [
        -12,
        98
      ],
      [
        0,
        119
      ],
      [
        -12,
        130
      ],
      [
        -13,
        65
      ],
      [
        13,
        55
      ],
      [
        24,
        -22
      ],
      [
        0,
        141
      ],
      [
        -12,
        152
      ],
      [
        -50,
        162
      ],
      [
        -123,
        272
      ],
      [
        -25,
        97
      ],
      [
        -25,
        76
      ],
      [
        -124,
        358
      ],
      [
        -62,
        239
      ],
      [
        -37,
        216
      ],
      [
        -49,
        98
      ],
      [
        -199,
        683
      ],
      [
        -49,
        109
      ],
      [
        -99,
        173
      ],
      [
        -25,
        130
      ],
      [
        -62,
        163
      ],
      [
        -12,
        163
      ],
      [
        0,
        314
      ]
    ],
    [
      [
        69964,
        45192
      ],
      [
        74,
        32
      ],
      [
        74,
        22
      ],
      [
        87,
        22
      ],
      [
        62,
        21
      ],
      [
        12,
        0
      ],
      [
        161,
        -21
      ],
      [
        62,
        -11
      ],
      [
        62,
        -54
      ],
      [
        62,
        -109
      ]
    ],
    [
      [
        119575,
        42079
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        32
      ],
      [
        13,
        44
      ],
      [
        25,
        -22
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        119736,
        42828
      ],
      [
        37,
        -11
      ],
      [
        0,
        -109
      ],
      [
        -62,
        -11
      ],
      [
        0,
        22
      ],
      [
        -25,
        11
      ],
      [
        0,
        43
      ],
      [
        -24,
        76
      ],
      [
        37,
        11
      ],
      [
        25,
        22
      ],
      [
        0,
        -44
      ],
      [
        12,
        -10
      ]
    ],
    [
      [
        119525,
        42990
      ],
      [
        -24,
        0
      ],
      [
        -25,
        44
      ],
      [
        -50,
        21
      ],
      [
        -24,
        44
      ],
      [
        -13,
        43
      ],
      [
        37,
        11
      ],
      [
        25,
        65
      ],
      [
        -49,
        33
      ],
      [
        0,
        21
      ],
      [
        49,
        33
      ],
      [
        37,
        -44
      ],
      [
        0,
        -97
      ],
      [
        37,
        -98
      ],
      [
        0,
        -76
      ]
    ],
    [
      [
        119228,
        43283
      ],
      [
        -25,
        0
      ],
      [
        25,
        54
      ],
      [
        0,
        33
      ],
      [
        13,
        65
      ],
      [
        0,
        32
      ],
      [
        24,
        -32
      ],
      [
        -24,
        -43
      ],
      [
        0,
        -33
      ],
      [
        12,
        -11
      ],
      [
        -25,
        -65
      ]
    ],
    [
      [
        118423,
        43565
      ],
      [
        37,
        -32
      ],
      [
        37,
        10
      ],
      [
        50,
        -65
      ],
      [
        136,
        -184
      ],
      [
        50,
        -43
      ],
      [
        24,
        -11
      ],
      [
        25,
        -33
      ],
      [
        13,
        -43
      ],
      [
        37,
        -54
      ],
      [
        12,
        -65
      ],
      [
        50,
        -66
      ],
      [
        24,
        -54
      ],
      [
        38,
        -21
      ],
      [
        62,
        -87
      ],
      [
        37,
        -22
      ],
      [
        86,
        -98
      ],
      [
        62,
        -86
      ],
      [
        38,
        -65
      ],
      [
        74,
        -87
      ],
      [
        49,
        -43
      ],
      [
        25,
        -109
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -86,
        87
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        43
      ],
      [
        -38,
        22
      ],
      [
        -37,
        44
      ],
      [
        -37,
        86
      ],
      [
        -49,
        22
      ],
      [
        -38,
        43
      ],
      [
        -24,
        44
      ],
      [
        -50,
        32
      ],
      [
        -62,
        65
      ],
      [
        -37,
        22
      ],
      [
        -25,
        33
      ],
      [
        -87,
        130
      ],
      [
        -24,
        21
      ],
      [
        -25,
        55
      ],
      [
        -74,
        130
      ],
      [
        -25,
        54
      ],
      [
        -37,
        54
      ],
      [
        -50,
        120
      ],
      [
        -49,
        97
      ],
      [
        -13,
        33
      ],
      [
        0,
        76
      ],
      [
        -25,
        10
      ],
      [
        -12,
        33
      ],
      [
        0,
        32
      ],
      [
        12,
        22
      ],
      [
        50,
        -65
      ]
    ],
    [
      [
        66607,
        64778
      ],
      [
        -62,
        -11
      ],
      [
        -37,
        -10
      ],
      [
        -50,
        -65
      ],
      [
        -49,
        -22
      ],
      [
        -50,
        -54
      ],
      [
        -87,
        -76
      ],
      [
        -49,
        -87
      ],
      [
        -13,
        -65
      ],
      [
        -49,
        -11
      ],
      [
        -62,
        11
      ],
      [
        -50,
        65
      ],
      [
        -99,
        65
      ],
      [
        -74,
        33
      ],
      [
        -25,
        0
      ],
      [
        -161,
        10
      ],
      [
        -161,
        -21
      ],
      [
        -87,
        -33
      ],
      [
        -12,
        0
      ],
      [
        -50,
        -43
      ],
      [
        -37,
        -44
      ],
      [
        -111,
        -206
      ],
      [
        -137,
        11
      ],
      [
        -86,
        22
      ],
      [
        -75,
        32
      ],
      [
        -99,
        98
      ],
      [
        -124,
        141
      ],
      [
        -49,
        22
      ],
      [
        -62,
        11
      ],
      [
        -149,
        -152
      ],
      [
        -24,
        11
      ],
      [
        -38,
        -22
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        10
      ],
      [
        -25,
        22
      ],
      [
        -24,
        33
      ],
      [
        -75,
        195
      ],
      [
        -25,
        43
      ],
      [
        -49,
        76
      ],
      [
        -37,
        44
      ],
      [
        -25,
        -11
      ],
      [
        -124,
        65
      ],
      [
        -111,
        65
      ],
      [
        -38,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        -43
      ],
      [
        -50,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -37,
        11
      ],
      [
        -49,
        -22
      ],
      [
        -87,
        -54
      ],
      [
        -62,
        -87
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        -21
      ],
      [
        -13,
        -250
      ],
      [
        -24,
        -76
      ],
      [
        -25,
        -97
      ],
      [
        -62,
        -98
      ],
      [
        -50,
        -54
      ],
      [
        0,
        -380
      ],
      [
        -12,
        -21
      ],
      [
        12,
        -33
      ],
      [
        0,
        -22
      ],
      [
        13,
        -21
      ],
      [
        -25,
        -44
      ]
    ],
    [
      [
        67077,
        70580
      ],
      [
        38,
        -357
      ],
      [
        24,
        -315
      ],
      [
        13,
        -195
      ],
      [
        0,
        -54
      ],
      [
        12,
        -33
      ],
      [
        25,
        -32
      ],
      [
        99,
        -293
      ],
      [
        -12,
        -44
      ],
      [
        12,
        -86
      ],
      [
        25,
        -44
      ],
      [
        87,
        -173
      ],
      [
        12,
        -55
      ],
      [
        -74,
        -249
      ],
      [
        -13,
        -260
      ],
      [
        -12,
        -174
      ],
      [
        -13,
        -249
      ],
      [
        -12,
        -304
      ],
      [
        -12,
        -249
      ],
      [
        -13,
        -326
      ],
      [
        -12,
        -314
      ],
      [
        -87,
        -174
      ],
      [
        -161,
        -303
      ],
      [
        -136,
        -250
      ],
      [
        -62,
        -163
      ],
      [
        -136,
        -325
      ],
      [
        -50,
        -206
      ],
      [
        -49,
        -108
      ],
      [
        -13,
        -44
      ],
      [
        13,
        -162
      ],
      [
        37,
        -261
      ]
    ],
    [
      [
        119711,
        38088
      ],
      [
        13,
        -32
      ],
      [
        -25,
        0
      ],
      [
        0,
        32
      ],
      [
        12,
        0
      ]
    ],
    [
      [
        64439,
        58976
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        0
      ],
      [
        37,
        87
      ],
      [
        13,
        -22
      ],
      [
        24,
        0
      ],
      [
        -12,
        -43
      ]
    ],
    [
      [
        66607,
        64778
      ],
      [
        49,
        -141
      ],
      [
        62,
        -141
      ],
      [
        50,
        -108
      ]
    ],
    [
      [
        64872,
        59182
      ],
      [
        -12,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        22
      ],
      [
        -12,
        44
      ],
      [
        -13,
        0
      ],
      [
        -37,
        54
      ],
      [
        25,
        -163
      ],
      [
        -13,
        -54
      ],
      [
        -86,
        0
      ],
      [
        -75,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -24,
        22
      ],
      [
        -13,
        22
      ],
      [
        -25,
        -22
      ],
      [
        -61,
        -11
      ],
      [
        -62,
        108
      ],
      [
        0,
        -21
      ],
      [
        24,
        -44
      ],
      [
        0,
        -65
      ],
      [
        -49,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        33
      ],
      [
        -12,
        54
      ],
      [
        0,
        76
      ],
      [
        -12,
        43
      ],
      [
        -13,
        0
      ],
      [
        0,
        -43
      ],
      [
        13,
        -32
      ],
      [
        0,
        -76
      ],
      [
        24,
        -65
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        0
      ],
      [
        0,
        22
      ],
      [
        -13,
        54
      ],
      [
        -12,
        -76
      ],
      [
        -37,
        0
      ],
      [
        -50,
        -22
      ],
      [
        -12,
        11
      ],
      [
        -13,
        43
      ],
      [
        -12,
        -54
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -37,
        33
      ],
      [
        -62,
        76
      ],
      [
        -75,
        119
      ],
      [
        -24,
        119
      ],
      [
        -25,
        65
      ],
      [
        -13,
        120
      ],
      [
        0,
        21
      ],
      [
        -12,
        22
      ],
      [
        0,
        87
      ],
      [
        50,
        22
      ],
      [
        12,
        32
      ],
      [
        0,
        33
      ],
      [
        -50,
        -55
      ],
      [
        -62,
        55
      ],
      [
        -12,
        32
      ],
      [
        12,
        22
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        -12,
        32
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -21
      ],
      [
        -25,
        21
      ],
      [
        0,
        55
      ],
      [
        -24,
        43
      ],
      [
        -62,
        141
      ],
      [
        -75,
        119
      ],
      [
        -74,
        87
      ],
      [
        -99,
        43
      ],
      [
        -223,
        -11
      ],
      [
        -13,
        11
      ],
      [
        25,
        33
      ],
      [
        -12,
        32
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -76
      ],
      [
        -198,
        -10
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        32418,
        63119
      ],
      [
        0,
        22
      ],
      [
        -25,
        65
      ],
      [
        -50,
        86
      ],
      [
        -173,
        250
      ],
      [
        -62,
        152
      ],
      [
        -37,
        108
      ],
      [
        -25,
        65
      ],
      [
        -99,
        109
      ],
      [
        -25,
        54
      ],
      [
        -87,
        152
      ],
      [
        -74,
        97
      ],
      [
        0,
        33
      ],
      [
        25,
        54
      ],
      [
        12,
        -11
      ],
      [
        50,
        -65
      ],
      [
        25,
        11
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        33310,
        65581
      ],
      [
        0,
        -22
      ],
      [
        -13,
        -22
      ],
      [
        -25,
        -75
      ],
      [
        -12,
        0
      ],
      [
        0,
        54
      ],
      [
        -12,
        11
      ],
      [
        -25,
        -55
      ],
      [
        12,
        -32
      ],
      [
        25,
        -11
      ],
      [
        37,
        -260
      ],
      [
        0,
        -44
      ],
      [
        -49,
        -130
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        -152
      ],
      [
        -25,
        -260
      ],
      [
        13,
        -239
      ],
      [
        0,
        -336
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        43
      ],
      [
        0,
        33
      ],
      [
        24,
        98
      ],
      [
        -12,
        32
      ],
      [
        -12,
        -65
      ],
      [
        -13,
        -32
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        -33
      ],
      [
        13,
        -54
      ],
      [
        25,
        -76
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -130
      ],
      [
        -12,
        0
      ],
      [
        0,
        22
      ],
      [
        -25,
        0
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -32
      ],
      [
        24,
        -22
      ],
      [
        13,
        0
      ],
      [
        25,
        -108
      ],
      [
        -38,
        -44
      ],
      [
        -24,
        -86
      ],
      [
        -13,
        -55
      ],
      [
        0,
        -32
      ],
      [
        13,
        -109
      ],
      [
        12,
        -76
      ],
      [
        25,
        -43
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        3506,
        44292
      ],
      [
        -38,
        -33
      ],
      [
        -12,
        44
      ],
      [
        12,
        43
      ],
      [
        13,
        22
      ],
      [
        12,
        0
      ],
      [
        13,
        -55
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        38463,
        63802
      ],
      [
        -25,
        -76
      ],
      [
        -12,
        33
      ],
      [
        0,
        76
      ],
      [
        -25,
        32
      ],
      [
        0,
        33
      ],
      [
        49,
        -44
      ],
      [
        13,
        -54
      ]
    ],
    [
      [
        40271,
        67143
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        11
      ],
      [
        0,
        21
      ],
      [
        25,
        -21
      ]
    ],
    [
      [
        40172,
        67218
      ],
      [
        -12,
        0
      ],
      [
        0,
        22
      ],
      [
        12,
        0
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        63076,
        88312
      ],
      [
        87,
        11
      ],
      [
        37,
        -22
      ],
      [
        62,
        -10
      ],
      [
        37,
        32
      ],
      [
        37,
        -22
      ],
      [
        38,
        11
      ]
    ],
    [
      [
        63287,
        88529
      ],
      [
        37,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        44
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        32
      ],
      [
        25,
        11
      ],
      [
        62,
        -11
      ]
    ],
    [
      [
        63609,
        89364
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        11
      ],
      [
        12,
        43
      ],
      [
        50,
        65
      ],
      [
        0,
        -76
      ]
    ],
    [
      [
        63981,
        87911
      ],
      [
        -75,
        11
      ],
      [
        -24,
        11
      ]
    ],
    [
      [
        63374,
        88312
      ],
      [
        -75,
        33
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        33
      ],
      [
        -37,
        0
      ],
      [
        -50,
        54
      ],
      [
        38,
        32
      ],
      [
        62,
        0
      ],
      [
        49,
        -10
      ],
      [
        87,
        -76
      ],
      [
        49,
        11
      ],
      [
        -12,
        21
      ],
      [
        -62,
        33
      ],
      [
        -25,
        21
      ],
      [
        50,
        22
      ],
      [
        0,
        33
      ],
      [
        -62,
        86
      ],
      [
        12,
        22
      ],
      [
        25,
        87
      ],
      [
        25,
        11
      ],
      [
        87,
        119
      ],
      [
        37,
        65
      ],
      [
        24,
        87
      ],
      [
        38,
        228
      ],
      [
        24,
        86
      ],
      [
        50,
        -21
      ],
      [
        62,
        32
      ],
      [
        99,
        87
      ],
      [
        25,
        65
      ],
      [
        37,
        33
      ],
      [
        111,
        76
      ],
      [
        62,
        10
      ],
      [
        174,
        22
      ],
      [
        87,
        0
      ],
      [
        86,
        -87
      ],
      [
        50,
        -11
      ]
    ],
    [
      [
        63758,
        89560
      ],
      [
        74,
        43
      ],
      [
        12,
        -11
      ],
      [
        -86,
        -32
      ]
    ],
    [
      [
        63968,
        89603
      ],
      [
        -99,
        0
      ],
      [
        0,
        11
      ],
      [
        99,
        0
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        63671,
        93887
      ],
      [
        0,
        -76
      ],
      [
        -25,
        11
      ],
      [
        -25,
        43
      ],
      [
        13,
        43
      ],
      [
        -13,
        44
      ],
      [
        25,
        22
      ],
      [
        25,
        -87
      ]
    ],
    [
      [
        63634,
        94375
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        11
      ],
      [
        12,
        54
      ],
      [
        37,
        11
      ],
      [
        13,
        -65
      ]
    ],
    [
      [
        64711,
        95774
      ],
      [
        -74,
        11
      ],
      [
        -25,
        43
      ],
      [
        38,
        22
      ],
      [
        49,
        11
      ],
      [
        25,
        -22
      ],
      [
        -13,
        -65
      ]
    ],
    [
      [
        64835,
        95980
      ],
      [
        -37,
        0
      ],
      [
        -25,
        22
      ],
      [
        149,
        54
      ],
      [
        37,
        -11
      ],
      [
        -12,
        -33
      ],
      [
        -112,
        -32
      ]
    ],
    [
      [
        65789,
        96728
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -74,
        -11
      ],
      [
        -37,
        22
      ],
      [
        25,
        33
      ],
      [
        74,
        32
      ],
      [
        37,
        0
      ],
      [
        37,
        -43
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        66037,
        97205
      ],
      [
        -62,
        -10
      ],
      [
        12,
        54
      ],
      [
        62,
        11
      ],
      [
        -12,
        -55
      ]
    ],
    [
      [
        66223,
        97379
      ],
      [
        -25,
        22
      ],
      [
        49,
        43
      ],
      [
        62,
        0
      ],
      [
        13,
        -11
      ],
      [
        -99,
        -54
      ]
    ],
    [
      [
        66198,
        97466
      ],
      [
        -37,
        0
      ],
      [
        74,
        108
      ],
      [
        37,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -49,
        -21
      ]
    ],
    [
      [
        66384,
        98615
      ],
      [
        -25,
        22
      ],
      [
        25,
        65
      ],
      [
        49,
        22
      ],
      [
        0,
        -65
      ],
      [
        -49,
        -44
      ]
    ],
    [
      [
        66693,
        98854
      ],
      [
        25,
        -11
      ],
      [
        50,
        11
      ],
      [
        12,
        -22
      ],
      [
        -25,
        -22
      ],
      [
        -49,
        -10
      ],
      [
        -37,
        -44
      ],
      [
        -50,
        0
      ],
      [
        -87,
        -54
      ],
      [
        -62,
        -11
      ],
      [
        0,
        54
      ],
      [
        25,
        44
      ],
      [
        50,
        0
      ],
      [
        37,
        54
      ],
      [
        49,
        22
      ],
      [
        62,
        -11
      ]
    ],
    [
      [
        67152,
        99277
      ],
      [
        49,
        -54
      ],
      [
        25,
        -44
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -111,
        0
      ],
      [
        -62,
        43
      ],
      [
        -75,
        -32
      ],
      [
        -37,
        21
      ],
      [
        -12,
        33
      ],
      [
        49,
        32
      ],
      [
        13,
        33
      ],
      [
        87,
        -11
      ],
      [
        24,
        76
      ],
      [
        62,
        -22
      ],
      [
        0,
        76
      ],
      [
        50,
        -11
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        67350,
        99038
      ],
      [
        50,
        54
      ],
      [
        49,
        22
      ],
      [
        25,
        44
      ],
      [
        12,
        65
      ],
      [
        62,
        10
      ],
      [
        50,
        -43
      ],
      [
        24,
        -54
      ],
      [
        -12,
        -54
      ],
      [
        -111,
        -55
      ],
      [
        -50,
        -43
      ],
      [
        -25,
        -43
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        21
      ],
      [
        -25,
        -43
      ],
      [
        -87,
        -22
      ],
      [
        -37,
        11
      ],
      [
        0,
        33
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -44
      ],
      [
        -50,
        -21
      ],
      [
        -37,
        21
      ],
      [
        -111,
        -76
      ],
      [
        -87,
        -10
      ],
      [
        -37,
        10
      ],
      [
        0,
        44
      ],
      [
        111,
        87
      ],
      [
        174,
        21
      ],
      [
        111,
        109
      ],
      [
        25,
        119
      ],
      [
        25,
        43
      ],
      [
        -13,
        33
      ],
      [
        -25,
        0
      ],
      [
        13,
        76
      ],
      [
        87,
        76
      ],
      [
        49,
        76
      ],
      [
        62,
        11
      ],
      [
        25,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -50,
        -65
      ],
      [
        -62,
        -54
      ],
      [
        38,
        -76
      ],
      [
        0,
        -108
      ],
      [
        -38,
        -65
      ],
      [
        -12,
        -44
      ]
    ],
    [
      [
        67945,
        99689
      ],
      [
        37,
        -33
      ],
      [
        62,
        11
      ],
      [
        49,
        -32
      ],
      [
        25,
        0
      ],
      [
        25,
        -76
      ],
      [
        -50,
        -33
      ],
      [
        13,
        -87
      ],
      [
        -62,
        -21
      ],
      [
        -75,
        0
      ],
      [
        -24,
        21
      ],
      [
        -62,
        -43
      ],
      [
        -50,
        -65
      ],
      [
        -74,
        33
      ],
      [
        -50,
        0
      ],
      [
        50,
        43
      ],
      [
        12,
        32
      ],
      [
        -12,
        55
      ],
      [
        37,
        76
      ],
      [
        99,
        -11
      ],
      [
        12,
        32
      ],
      [
        -49,
        22
      ],
      [
        0,
        22
      ],
      [
        74,
        11
      ],
      [
        13,
        43
      ]
    ],
    [
      [
        72231,
        99808
      ],
      [
        -62,
        -11
      ],
      [
        -13,
        11
      ],
      [
        37,
        76
      ],
      [
        25,
        0
      ],
      [
        50,
        -43
      ],
      [
        -37,
        -33
      ]
    ],
    [
      [
        69072,
        99993
      ],
      [
        -50,
        -22
      ],
      [
        -62,
        22
      ],
      [
        -12,
        43
      ],
      [
        25,
        33
      ],
      [
        99,
        10
      ],
      [
        12,
        -10
      ],
      [
        -12,
        -76
      ]
    ],
    [
      [
        68552,
        99982
      ],
      [
        24,
        -33
      ],
      [
        62,
        22
      ],
      [
        37,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        -50,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        -74,
        -11
      ],
      [
        -74,
        -65
      ],
      [
        -38,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -173,
        -32
      ],
      [
        -49,
        21
      ],
      [
        -25,
        44
      ],
      [
        49,
        0
      ],
      [
        0,
        32
      ],
      [
        37,
        22
      ],
      [
        25,
        43
      ],
      [
        37,
        -11
      ],
      [
        25,
        22
      ],
      [
        37,
        -11
      ],
      [
        0,
        65
      ],
      [
        50,
        44
      ],
      [
        12,
        32
      ],
      [
        75,
        44
      ],
      [
        -13,
        54
      ],
      [
        25,
        43
      ],
      [
        37,
        0
      ],
      [
        13,
        -43
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        68725,
        100079
      ],
      [
        50,
        -10
      ],
      [
        24,
        -33
      ],
      [
        37,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -61,
        -21
      ],
      [
        -50,
        11
      ],
      [
        -62,
        119
      ],
      [
        37,
        0
      ],
      [
        25,
        -33
      ]
    ],
    [
      [
        70050,
        100285
      ],
      [
        13,
        -54
      ],
      [
        -112,
        -87
      ],
      [
        -62,
        -32
      ],
      [
        -12,
        54
      ],
      [
        -62,
        11
      ],
      [
        0,
        43
      ],
      [
        74,
        44
      ],
      [
        38,
        -11
      ],
      [
        99,
        76
      ],
      [
        24,
        -44
      ]
    ],
    [
      [
        70187,
        100296
      ],
      [
        -62,
        -21
      ],
      [
        -62,
        43
      ],
      [
        12,
        76
      ],
      [
        25,
        11
      ],
      [
        25,
        -22
      ],
      [
        86,
        -33
      ],
      [
        -24,
        -54
      ]
    ],
    [
      [
        69988,
        100448
      ],
      [
        0,
        -22
      ],
      [
        -49,
        -32
      ],
      [
        -74,
        -87
      ],
      [
        -87,
        -32
      ],
      [
        -62,
        10
      ],
      [
        -25,
        -21
      ],
      [
        -74,
        0
      ],
      [
        -62,
        32
      ],
      [
        -62,
        54
      ],
      [
        124,
        0
      ],
      [
        25,
        33
      ],
      [
        49,
        -11
      ],
      [
        99,
        22
      ],
      [
        37,
        -11
      ],
      [
        87,
        65
      ],
      [
        62,
        22
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        72540,
        99808
      ],
      [
        25,
        -87
      ],
      [
        0,
        -32
      ],
      [
        -50,
        -43
      ],
      [
        -61,
        0
      ],
      [
        -75,
        32
      ],
      [
        -49,
        33
      ],
      [
        -37,
        -109
      ],
      [
        -50,
        -43
      ],
      [
        -50,
        -22
      ],
      [
        -161,
        -32
      ],
      [
        -62,
        -131
      ],
      [
        -24,
        -32
      ],
      [
        -50,
        -11
      ]
    ],
    [
      [
        69022,
        99342
      ],
      [
        -173,
        -11
      ],
      [
        74,
        -76
      ],
      [
        -12,
        -97
      ],
      [
        -50,
        -87
      ],
      [
        -62,
        -44
      ],
      [
        87,
        -43
      ],
      [
        -62,
        -54
      ],
      [
        -62,
        -11
      ],
      [
        -210,
        65
      ],
      [
        -137,
        22
      ],
      [
        -37,
        0
      ],
      [
        -136,
        32
      ],
      [
        -74,
        -21
      ],
      [
        0,
        -131
      ],
      [
        12,
        -65
      ],
      [
        -37,
        -76
      ],
      [
        -50,
        -76
      ],
      [
        -210,
        87
      ],
      [
        -50,
        -43
      ],
      [
        -136,
        -87
      ],
      [
        -62,
        -163
      ],
      [
        -50,
        -54
      ],
      [
        -86,
        -32
      ],
      [
        -25,
        -44
      ],
      [
        74,
        -108
      ],
      [
        25,
        -65
      ],
      [
        0,
        -54
      ],
      [
        -62,
        -55
      ],
      [
        -124,
        -130
      ],
      [
        -111,
        -130
      ],
      [
        -50,
        -43
      ],
      [
        25,
        -120
      ],
      [
        -37,
        -32
      ],
      [
        -112,
        -54
      ],
      [
        -49,
        0
      ],
      [
        -124,
        -22
      ],
      [
        25,
        -119
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -98
      ],
      [
        -25,
        -206
      ],
      [
        -37,
        -87
      ],
      [
        -149,
        -238
      ],
      [
        -99,
        -130
      ],
      [
        74,
        -44
      ],
      [
        75,
        -32
      ],
      [
        25,
        -120
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -54
      ],
      [
        -100,
        21
      ],
      [
        -136,
        22
      ],
      [
        -99,
        -11
      ],
      [
        -74,
        -32
      ],
      [
        -87,
        -98
      ],
      [
        -74,
        -108
      ],
      [
        -50,
        -54
      ],
      [
        13,
        -66
      ],
      [
        -75,
        -119
      ],
      [
        50,
        -130
      ],
      [
        25,
        -54
      ],
      [
        -38,
        -54
      ],
      [
        13,
        -55
      ],
      [
        0,
        -108
      ],
      [
        -13,
        -44
      ],
      [
        75,
        -184
      ],
      [
        -25,
        -195
      ],
      [
        -25,
        -163
      ],
      [
        37,
        -43
      ],
      [
        112,
        -65
      ],
      [
        49,
        -65
      ],
      [
        50,
        -55
      ],
      [
        -50,
        -151
      ],
      [
        -24,
        -44
      ],
      [
        -75,
        0
      ],
      [
        -62,
        -21
      ],
      [
        13,
        -66
      ],
      [
        49,
        -130
      ],
      [
        37,
        -86
      ],
      [
        13,
        -65
      ],
      [
        -25,
        -87
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -86
      ],
      [
        -37,
        -33
      ],
      [
        -38,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        -11
      ],
      [
        -24,
        -21
      ],
      [
        -25,
        -98
      ],
      [
        -62,
        -65
      ],
      [
        12,
        -22
      ],
      [
        13,
        -86
      ],
      [
        24,
        -87
      ],
      [
        -24,
        -76
      ],
      [
        -13,
        -87
      ],
      [
        -25,
        -65
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -37,
        87
      ]
    ],
    [
      [
        65839,
        93095
      ],
      [
        0,
        43
      ],
      [
        -186,
        44
      ],
      [
        -74,
        152
      ],
      [
        0,
        162
      ],
      [
        -25,
        11
      ],
      [
        12,
        -76
      ],
      [
        -62,
        -32
      ],
      [
        0,
        -44
      ],
      [
        13,
        -10
      ],
      [
        0,
        -98
      ],
      [
        -62,
        -141
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -32
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        43
      ],
      [
        -50,
        54
      ],
      [
        -12,
        -21
      ],
      [
        25,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -74,
        -54
      ],
      [
        24,
        -33
      ],
      [
        -24,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -22
      ],
      [
        -87,
        -65
      ],
      [
        -136,
        -173
      ],
      [
        -74,
        -44
      ],
      [
        -50,
        -54
      ],
      [
        -49,
        0
      ],
      [
        -50,
        -32
      ],
      [
        -149,
        -44
      ],
      [
        -86,
        22
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        33
      ],
      [
        -13,
        54
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -43
      ],
      [
        -62,
        32
      ],
      [
        37,
        65
      ],
      [
        0,
        22
      ],
      [
        -99,
        0
      ],
      [
        -112,
        76
      ],
      [
        -24,
        32
      ],
      [
        -87,
        55
      ],
      [
        -50,
        65
      ],
      [
        -24,
        65
      ],
      [
        0,
        54
      ],
      [
        12,
        98
      ],
      [
        25,
        21
      ],
      [
        86,
        -32
      ],
      [
        75,
        -54
      ],
      [
        12,
        0
      ],
      [
        37,
        43
      ],
      [
        50,
        43
      ],
      [
        -13,
        11
      ],
      [
        -86,
        -43
      ],
      [
        -62,
        65
      ],
      [
        0,
        22
      ],
      [
        25,
        54
      ],
      [
        -13,
        32
      ],
      [
        0,
        44
      ],
      [
        37,
        43
      ],
      [
        50,
        44
      ],
      [
        -12,
        32
      ],
      [
        -50,
        -54
      ],
      [
        -62,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -12,
        43
      ],
      [
        12,
        141
      ],
      [
        25,
        65
      ],
      [
        12,
        55
      ],
      [
        37,
        0
      ],
      [
        25,
        43
      ],
      [
        25,
        0
      ],
      [
        12,
        -22
      ],
      [
        62,
        -11
      ],
      [
        37,
        44
      ],
      [
        38,
        0
      ],
      [
        86,
        54
      ],
      [
        0,
        11
      ],
      [
        -62,
        -11
      ],
      [
        -74,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        33
      ],
      [
        25,
        32
      ],
      [
        74,
        76
      ],
      [
        25,
        33
      ],
      [
        25,
        97
      ],
      [
        61,
        76
      ],
      [
        62,
        33
      ],
      [
        25,
        -33
      ],
      [
        25,
        0
      ],
      [
        50,
        55
      ],
      [
        0,
        32
      ],
      [
        -162,
        -54
      ],
      [
        -61,
        -44
      ],
      [
        -87,
        -119
      ],
      [
        -13,
        -54
      ],
      [
        -24,
        -22
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        -65
      ],
      [
        -12,
        -54
      ],
      [
        -100,
        -87
      ],
      [
        -24,
        -32
      ],
      [
        -13,
        21
      ],
      [
        0,
        109
      ],
      [
        25,
        43
      ],
      [
        12,
        44
      ],
      [
        -12,
        43
      ],
      [
        12,
        22
      ],
      [
        50,
        -11
      ],
      [
        50,
        0
      ],
      [
        62,
        32
      ],
      [
        -13,
        22
      ],
      [
        -87,
        0
      ],
      [
        -37,
        33
      ],
      [
        -37,
        65
      ],
      [
        -12,
        87
      ],
      [
        12,
        21
      ],
      [
        124,
        87
      ],
      [
        -37,
        0
      ],
      [
        -62,
        -33
      ],
      [
        -50,
        44
      ],
      [
        -24,
        43
      ],
      [
        -13,
        98
      ],
      [
        13,
        43
      ],
      [
        -13,
        65
      ],
      [
        37,
        22
      ],
      [
        25,
        -11
      ],
      [
        112,
        0
      ],
      [
        161,
        43
      ],
      [
        111,
        -32
      ],
      [
        112,
        43
      ],
      [
        49,
        0
      ],
      [
        50,
        -21
      ],
      [
        24,
        -33
      ],
      [
        0,
        -43
      ],
      [
        13,
        -22
      ],
      [
        25,
        11
      ],
      [
        -13,
        32
      ],
      [
        0,
        44
      ],
      [
        174,
        54
      ],
      [
        12,
        22
      ],
      [
        -62,
        11
      ],
      [
        -25,
        43
      ],
      [
        -24,
        -11
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        -38,
        -11
      ],
      [
        -74,
        0
      ],
      [
        -49,
        22
      ],
      [
        -50,
        11
      ],
      [
        -25,
        43
      ],
      [
        -37,
        -76
      ],
      [
        -37,
        -11
      ],
      [
        -99,
        11
      ],
      [
        -149,
        -11
      ],
      [
        -74,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -112,
        86
      ],
      [
        0,
        120
      ],
      [
        87,
        11
      ],
      [
        25,
        21
      ],
      [
        -50,
        33
      ],
      [
        -25,
        54
      ],
      [
        -37,
        11
      ],
      [
        -25,
        43
      ],
      [
        -12,
        54
      ],
      [
        25,
        66
      ],
      [
        49,
        -11
      ],
      [
        124,
        0
      ],
      [
        112,
        -44
      ],
      [
        74,
        -21
      ],
      [
        161,
        10
      ],
      [
        87,
        44
      ],
      [
        -13,
        11
      ],
      [
        -99,
        -22
      ],
      [
        -99,
        0
      ],
      [
        -161,
        43
      ],
      [
        -62,
        11
      ],
      [
        -74,
        0
      ],
      [
        -37,
        11
      ],
      [
        -13,
        43
      ],
      [
        13,
        87
      ],
      [
        37,
        11
      ],
      [
        37,
        -22
      ],
      [
        62,
        98
      ],
      [
        62,
        43
      ],
      [
        87,
        22
      ],
      [
        37,
        -33
      ],
      [
        37,
        0
      ],
      [
        136,
        33
      ],
      [
        -49,
        22
      ],
      [
        -62,
        -22
      ],
      [
        -50,
        0
      ],
      [
        0,
        22
      ],
      [
        37,
        43
      ],
      [
        13,
        43
      ],
      [
        24,
        22
      ],
      [
        100,
        0
      ],
      [
        37,
        11
      ],
      [
        186,
        -22
      ],
      [
        74,
        -32
      ],
      [
        74,
        21
      ],
      [
        -62,
        22
      ],
      [
        0,
        33
      ],
      [
        99,
        32
      ],
      [
        99,
        11
      ],
      [
        -24,
        22
      ],
      [
        -211,
        -44
      ],
      [
        -62,
        33
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -87,
        -11
      ],
      [
        -12,
        11
      ],
      [
        12,
        44
      ],
      [
        87,
        108
      ],
      [
        124,
        33
      ],
      [
        62,
        54
      ],
      [
        99,
        0
      ],
      [
        86,
        -11
      ],
      [
        38,
        -54
      ],
      [
        49,
        21
      ],
      [
        -37,
        33
      ],
      [
        -25,
        43
      ],
      [
        0,
        55
      ],
      [
        37,
        32
      ],
      [
        99,
        11
      ],
      [
        25,
        22
      ],
      [
        -12,
        54
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -13,
        32
      ],
      [
        13,
        22
      ],
      [
        61,
        43
      ],
      [
        100,
        22
      ],
      [
        99,
        -32
      ],
      [
        -25,
        -76
      ],
      [
        25,
        -11
      ],
      [
        62,
        76
      ],
      [
        62,
        11
      ],
      [
        62,
        21
      ],
      [
        49,
        -65
      ],
      [
        37,
        -22
      ],
      [
        13,
        -54
      ],
      [
        37,
        22
      ],
      [
        86,
        22
      ],
      [
        87,
        -11
      ],
      [
        62,
        11
      ],
      [
        -37,
        54
      ],
      [
        37,
        65
      ],
      [
        62,
        22
      ],
      [
        62,
        10
      ],
      [
        37,
        33
      ],
      [
        50,
        22
      ],
      [
        -25,
        43
      ],
      [
        -50,
        22
      ],
      [
        99,
        65
      ],
      [
        -49,
        21
      ],
      [
        -37,
        -10
      ],
      [
        -99,
        -65
      ],
      [
        49,
        -44
      ],
      [
        -37,
        -54
      ],
      [
        -211,
        -119
      ],
      [
        -99,
        -33
      ],
      [
        -37,
        0
      ],
      [
        -12,
        33
      ],
      [
        -50,
        76
      ],
      [
        -62,
        -11
      ],
      [
        13,
        76
      ],
      [
        37,
        43
      ],
      [
        49,
        33
      ],
      [
        50,
        97
      ],
      [
        74,
        65
      ],
      [
        112,
        152
      ],
      [
        99,
        43
      ],
      [
        37,
        55
      ],
      [
        50,
        21
      ],
      [
        49,
        44
      ],
      [
        37,
        0
      ],
      [
        62,
        32
      ],
      [
        37,
        44
      ],
      [
        -24,
        11
      ],
      [
        -87,
        -44
      ],
      [
        12,
        98
      ],
      [
        50,
        43
      ],
      [
        235,
        119
      ],
      [
        25,
        -10
      ],
      [
        25,
        -44
      ],
      [
        62,
        11
      ],
      [
        86,
        76
      ],
      [
        -12,
        32
      ],
      [
        -62,
        -54
      ],
      [
        -62,
        0
      ],
      [
        0,
        33
      ],
      [
        -49,
        0
      ],
      [
        -25,
        21
      ],
      [
        0,
        55
      ],
      [
        49,
        130
      ],
      [
        124,
        152
      ],
      [
        13,
        54
      ],
      [
        49,
        32
      ],
      [
        62,
        -10
      ],
      [
        13,
        10
      ],
      [
        -25,
        44
      ],
      [
        -62,
        32
      ],
      [
        0,
        22
      ],
      [
        210,
        43
      ],
      [
        99,
        0
      ],
      [
        25,
        33
      ],
      [
        62,
        11
      ],
      [
        37,
        32
      ],
      [
        -24,
        11
      ],
      [
        -100,
        -21
      ],
      [
        -111,
        -33
      ],
      [
        -87,
        0
      ],
      [
        -12,
        130
      ],
      [
        12,
        65
      ],
      [
        25,
        0
      ],
      [
        12,
        65
      ],
      [
        38,
        33
      ],
      [
        49,
        11
      ],
      [
        50,
        54
      ],
      [
        62,
        -11
      ],
      [
        49,
        22
      ],
      [
        -74,
        21
      ],
      [
        -25,
        33
      ],
      [
        25,
        22
      ],
      [
        62,
        10
      ],
      [
        37,
        76
      ],
      [
        37,
        22
      ],
      [
        37,
        0
      ],
      [
        37,
        33
      ],
      [
        50,
        -11
      ],
      [
        99,
        32
      ],
      [
        223,
        0
      ],
      [
        12,
        33
      ],
      [
        -210,
        11
      ],
      [
        -87,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        32
      ],
      [
        37,
        22
      ],
      [
        12,
        33
      ],
      [
        62,
        65
      ],
      [
        74,
        43
      ],
      [
        50,
        -11
      ],
      [
        62,
        -43
      ],
      [
        37,
        0
      ],
      [
        25,
        -22
      ],
      [
        37,
        0
      ],
      [
        37,
        44
      ],
      [
        -12,
        21
      ],
      [
        -62,
        -21
      ],
      [
        -50,
        21
      ],
      [
        -37,
        65
      ],
      [
        37,
        55
      ],
      [
        -12,
        10
      ],
      [
        -87,
        -43
      ],
      [
        -86,
        -11
      ],
      [
        12,
        54
      ],
      [
        -12,
        33
      ],
      [
        86,
        87
      ],
      [
        75,
        10
      ],
      [
        49,
        -32
      ],
      [
        74,
        22
      ],
      [
        -12,
        21
      ],
      [
        -74,
        11
      ],
      [
        -25,
        44
      ],
      [
        62,
        21
      ],
      [
        62,
        33
      ],
      [
        62,
        11
      ],
      [
        62,
        32
      ],
      [
        12,
        -11
      ],
      [
        25,
        -108
      ],
      [
        49,
        -98
      ],
      [
        13,
        0
      ],
      [
        -13,
        76
      ],
      [
        38,
        44
      ],
      [
        -38,
        43
      ],
      [
        -37,
        87
      ],
      [
        13,
        21
      ],
      [
        62,
        44
      ],
      [
        86,
        11
      ],
      [
        75,
        -33
      ],
      [
        86,
        11
      ],
      [
        161,
        54
      ],
      [
        -49,
        22
      ],
      [
        -75,
        -22
      ],
      [
        -210,
        11
      ],
      [
        -25,
        11
      ],
      [
        0,
        32
      ],
      [
        50,
        55
      ],
      [
        74,
        32
      ],
      [
        87,
        11
      ],
      [
        86,
        65
      ],
      [
        38,
        54
      ],
      [
        12,
        76
      ],
      [
        62,
        54
      ],
      [
        136,
        44
      ],
      [
        -12,
        97
      ],
      [
        37,
        76
      ],
      [
        37,
        22
      ],
      [
        62,
        -65
      ],
      [
        62,
        -33
      ],
      [
        74,
        0
      ],
      [
        13,
        11
      ],
      [
        -50,
        22
      ],
      [
        -49,
        43
      ],
      [
        0,
        33
      ],
      [
        24,
        22
      ],
      [
        62,
        0
      ],
      [
        50,
        32
      ],
      [
        0,
        33
      ],
      [
        62,
        76
      ],
      [
        173,
        32
      ],
      [
        13,
        -11
      ],
      [
        -13,
        -108
      ],
      [
        -25,
        -65
      ],
      [
        38,
        0
      ],
      [
        74,
        195
      ],
      [
        37,
        32
      ],
      [
        99,
        44
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -162
      ],
      [
        -25,
        -54
      ],
      [
        -74,
        -109
      ],
      [
        50,
        11
      ],
      [
        99,
        108
      ],
      [
        86,
        -10
      ],
      [
        -62,
        65
      ],
      [
        -12,
        32
      ],
      [
        12,
        109
      ],
      [
        25,
        32
      ],
      [
        112,
        0
      ],
      [
        74,
        -11
      ],
      [
        25,
        65
      ],
      [
        62,
        11
      ],
      [
        186,
        -108
      ],
      [
        -25,
        97
      ],
      [
        -25,
        44
      ],
      [
        -74,
        21
      ],
      [
        -75,
        44
      ],
      [
        -12,
        43
      ],
      [
        62,
        11
      ],
      [
        87,
        -22
      ],
      [
        74,
        44
      ],
      [
        25,
        -11
      ],
      [
        49,
        22
      ],
      [
        37,
        -33
      ],
      [
        25,
        11
      ],
      [
        13,
        43
      ],
      [
        86,
        22
      ],
      [
        62,
        -22
      ],
      [
        25,
        -21
      ],
      [
        37,
        -131
      ],
      [
        75,
        -65
      ],
      [
        37,
        -10
      ],
      [
        12,
        21
      ],
      [
        -37,
        33
      ],
      [
        12,
        87
      ],
      [
        13,
        21
      ],
      [
        99,
        98
      ],
      [
        86,
        54
      ],
      [
        50,
        0
      ],
      [
        87,
        108
      ],
      [
        37,
        33
      ],
      [
        0,
        22
      ],
      [
        -50,
        21
      ],
      [
        0,
        33
      ],
      [
        62,
        43
      ],
      [
        75,
        65
      ],
      [
        37,
        0
      ],
      [
        99,
        -43
      ],
      [
        37,
        -43
      ],
      [
        50,
        -11
      ],
      [
        37,
        43
      ],
      [
        49,
        -11
      ],
      [
        25,
        -21
      ],
      [
        50,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -38,
        -22
      ],
      [
        -74,
        -65
      ],
      [
        -62,
        -76
      ],
      [
        -25,
        -43
      ],
      [
        -24,
        -98
      ],
      [
        -50,
        -65
      ],
      [
        0,
        -54
      ],
      [
        25,
        -22
      ],
      [
        49,
        22
      ],
      [
        75,
        65
      ],
      [
        12,
        65
      ],
      [
        186,
        174
      ],
      [
        87,
        97
      ],
      [
        86,
        87
      ],
      [
        62,
        11
      ],
      [
        25,
        -54
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -44
      ],
      [
        25,
        -21
      ],
      [
        0,
        -55
      ],
      [
        -25,
        -86
      ],
      [
        37,
        0
      ],
      [
        112,
        65
      ],
      [
        49,
        97
      ],
      [
        13,
        44
      ],
      [
        49,
        32
      ],
      [
        75,
        0
      ],
      [
        0,
        22
      ],
      [
        -99,
        54
      ],
      [
        -13,
        22
      ],
      [
        37,
        32
      ],
      [
        99,
        55
      ],
      [
        75,
        -22
      ],
      [
        111,
        -11
      ],
      [
        87,
        -43
      ],
      [
        -12,
        -65
      ],
      [
        -38,
        -44
      ],
      [
        -111,
        -43
      ],
      [
        -13,
        -33
      ],
      [
        38,
        -11
      ],
      [
        74,
        33
      ],
      [
        12,
        -22
      ],
      [
        -24,
        -65
      ],
      [
        0,
        -76
      ],
      [
        37,
        0
      ],
      [
        49,
        33
      ],
      [
        13,
        76
      ],
      [
        49,
        87
      ],
      [
        50,
        54
      ],
      [
        25,
        11
      ],
      [
        86,
        0
      ],
      [
        50,
        -22
      ],
      [
        25,
        -43
      ],
      [
        37,
        -22
      ],
      [
        74,
        -11
      ],
      [
        62,
        -43
      ],
      [
        87,
        43
      ],
      [
        62,
        -54
      ],
      [
        -13,
        -54
      ],
      [
        75,
        10
      ],
      [
        62,
        -21
      ],
      [
        111,
        -76
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        -161,
        -43
      ],
      [
        -62,
        -55
      ],
      [
        -124,
        -11
      ],
      [
        -396,
        33
      ],
      [
        12,
        -33
      ],
      [
        273,
        -75
      ],
      [
        12,
        -22
      ],
      [
        0,
        -98
      ],
      [
        25,
        -32
      ],
      [
        99,
        0
      ],
      [
        37,
        -11
      ],
      [
        25,
        22
      ],
      [
        0,
        54
      ],
      [
        62,
        0
      ],
      [
        12,
        -65
      ],
      [
        37,
        32
      ],
      [
        124,
        0
      ]
    ],
    [
      [
        70732,
        100654
      ],
      [
        86,
        -22
      ],
      [
        38,
        0
      ],
      [
        62,
        -65
      ],
      [
        -50,
        -21
      ],
      [
        -136,
        0
      ],
      [
        -37,
        32
      ],
      [
        -62,
        22
      ],
      [
        99,
        54
      ]
    ],
    [
      [
        58840,
        100470
      ],
      [
        -50,
        0
      ],
      [
        50,
        43
      ],
      [
        149,
        76
      ],
      [
        61,
        65
      ],
      [
        124,
        22
      ],
      [
        0,
        -87
      ],
      [
        -223,
        -65
      ],
      [
        -111,
        -54
      ]
    ],
    [
      [
        68539,
        102682
      ],
      [
        -49,
        -21
      ],
      [
        -62,
        32
      ],
      [
        -38,
        54
      ],
      [
        25,
        11
      ],
      [
        112,
        0
      ],
      [
        25,
        -22
      ],
      [
        -13,
        -54
      ]
    ],
    [
      [
        69357,
        105307
      ],
      [
        148,
        -11
      ],
      [
        62,
        -109
      ],
      [
        25,
        -108
      ],
      [
        62,
        -11
      ],
      [
        87,
        22
      ],
      [
        136,
        0
      ],
      [
        111,
        -54
      ],
      [
        -99,
        -44
      ],
      [
        -12,
        -65
      ],
      [
        74,
        -11
      ],
      [
        124,
        -54
      ],
      [
        62,
        -11
      ],
      [
        124,
        22
      ],
      [
        235,
        -87
      ],
      [
        -272,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -74,
        -87
      ],
      [
        -112,
        -65
      ],
      [
        -49,
        -10
      ],
      [
        -87,
        10
      ],
      [
        -112,
        -75
      ],
      [
        -86,
        0
      ],
      [
        -37,
        97
      ],
      [
        86,
        43
      ],
      [
        13,
        22
      ],
      [
        -112,
        22
      ],
      [
        -111,
        -44
      ],
      [
        -75,
        0
      ],
      [
        -272,
        -32
      ],
      [
        -50,
        11
      ],
      [
        -12,
        65
      ],
      [
        111,
        32
      ],
      [
        13,
        55
      ],
      [
        136,
        141
      ],
      [
        -149,
        43
      ],
      [
        -61,
        33
      ],
      [
        -87,
        119
      ],
      [
        -87,
        54
      ],
      [
        12,
        54
      ],
      [
        -61,
        0
      ],
      [
        -50,
        33
      ],
      [
        50,
        32
      ],
      [
        421,
        44
      ]
    ],
    [
      [
        71165,
        105339
      ],
      [
        -49,
        0
      ],
      [
        -87,
        44
      ],
      [
        -25,
        43
      ],
      [
        62,
        22
      ],
      [
        74,
        -54
      ],
      [
        75,
        -22
      ],
      [
        -50,
        -33
      ]
    ],
    [
      [
        65789,
        105318
      ],
      [
        13,
        -44
      ],
      [
        49,
        11
      ],
      [
        74,
        -54
      ],
      [
        87,
        -33
      ],
      [
        62,
        -65
      ],
      [
        25,
        -54
      ],
      [
        -62,
        0
      ],
      [
        -62,
        65
      ],
      [
        -136,
        65
      ],
      [
        -62,
        0
      ],
      [
        -124,
        130
      ],
      [
        -12,
        33
      ],
      [
        -62,
        32
      ],
      [
        -25,
        98
      ],
      [
        136,
        -33
      ],
      [
        74,
        -75
      ],
      [
        -24,
        -33
      ],
      [
        49,
        -43
      ]
    ],
    [
      [
        71921,
        105513
      ],
      [
        99,
        -11
      ],
      [
        99,
        11
      ],
      [
        25,
        -11
      ],
      [
        -136,
        -33
      ],
      [
        -149,
        22
      ],
      [
        -136,
        0
      ],
      [
        -149,
        -32
      ],
      [
        -50,
        10
      ],
      [
        75,
        33
      ],
      [
        87,
        11
      ],
      [
        49,
        32
      ],
      [
        112,
        0
      ],
      [
        74,
        -32
      ]
    ],
    [
      [
        67697,
        106131
      ],
      [
        62,
        33
      ],
      [
        86,
        -11
      ],
      [
        124,
        -33
      ],
      [
        87,
        -54
      ],
      [
        50,
        -65
      ],
      [
        -100,
        -109
      ],
      [
        62,
        -54
      ],
      [
        161,
        109
      ],
      [
        87,
        -33
      ],
      [
        62,
        -43
      ],
      [
        25,
        -98
      ],
      [
        -25,
        -43
      ],
      [
        112,
        -65
      ],
      [
        136,
        10
      ],
      [
        99,
        -21
      ],
      [
        50,
        -54
      ],
      [
        74,
        10
      ],
      [
        12,
        44
      ],
      [
        149,
        -22
      ],
      [
        62,
        -32
      ],
      [
        -99,
        -55
      ],
      [
        86,
        -43
      ],
      [
        124,
        -33
      ],
      [
        75,
        -32
      ],
      [
        24,
        -33
      ],
      [
        -99,
        -43
      ],
      [
        -124,
        0
      ],
      [
        -123,
        -22
      ],
      [
        -211,
        -11
      ],
      [
        -50,
        -43
      ],
      [
        -86,
        -43
      ],
      [
        -112,
        -109
      ],
      [
        -25,
        -54
      ],
      [
        13,
        -87
      ],
      [
        -62,
        -32
      ],
      [
        -87,
        11
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -206
      ],
      [
        -50,
        -109
      ],
      [
        -124,
        -11
      ],
      [
        -86,
        -65
      ],
      [
        -87,
        -151
      ],
      [
        -74,
        -65
      ],
      [
        37,
        -44
      ],
      [
        -87,
        -97
      ],
      [
        25,
        -98
      ],
      [
        -50,
        -33
      ],
      [
        -74,
        -21
      ],
      [
        -87,
        21
      ],
      [
        -148,
        98
      ],
      [
        -161,
        76
      ],
      [
        -149,
        119
      ],
      [
        -136,
        54
      ],
      [
        -87,
        22
      ],
      [
        -111,
        87
      ],
      [
        -50,
        65
      ],
      [
        25,
        76
      ],
      [
        99,
        11
      ],
      [
        74,
        -33
      ],
      [
        37,
        0
      ],
      [
        75,
        98
      ],
      [
        446,
        54
      ],
      [
        148,
        11
      ],
      [
        137,
        0
      ],
      [
        -62,
        76
      ],
      [
        -273,
        -44
      ],
      [
        -248,
        11
      ],
      [
        -173,
        -54
      ],
      [
        -260,
        0
      ],
      [
        -99,
        54
      ],
      [
        -25,
        33
      ],
      [
        -13,
        76
      ],
      [
        50,
        32
      ],
      [
        149,
        -11
      ],
      [
        247,
        55
      ],
      [
        124,
        43
      ],
      [
        124,
        0
      ],
      [
        -12,
        43
      ],
      [
        74,
        33
      ],
      [
        310,
        0
      ],
      [
        74,
        11
      ],
      [
        0,
        21
      ],
      [
        -87,
        0
      ],
      [
        -74,
        33
      ],
      [
        -25,
        33
      ],
      [
        112,
        97
      ],
      [
        -87,
        0
      ],
      [
        -124,
        -76
      ],
      [
        -74,
        -32
      ],
      [
        -186,
        -11
      ],
      [
        -49,
        54
      ],
      [
        0,
        33
      ],
      [
        -149,
        32
      ],
      [
        -12,
        33
      ],
      [
        -75,
        0
      ],
      [
        -37,
        -22
      ],
      [
        12,
        -65
      ],
      [
        -24,
        -54
      ],
      [
        74,
        -44
      ],
      [
        -99,
        -32
      ],
      [
        -87,
        -54
      ],
      [
        -161,
        -22
      ],
      [
        -173,
        0
      ],
      [
        -75,
        32
      ],
      [
        -173,
        120
      ],
      [
        -62,
        65
      ],
      [
        -99,
        32
      ],
      [
        -62,
        44
      ],
      [
        -12,
        32
      ],
      [
        37,
        44
      ],
      [
        -87,
        32
      ],
      [
        -74,
        43
      ],
      [
        62,
        22
      ],
      [
        247,
        -54
      ],
      [
        38,
        43
      ],
      [
        -100,
        0
      ],
      [
        -61,
        65
      ],
      [
        -13,
        44
      ],
      [
        74,
        76
      ],
      [
        -37,
        11
      ],
      [
        -136,
        0
      ],
      [
        12,
        -55
      ],
      [
        -99,
        -54
      ],
      [
        -49,
        11
      ],
      [
        -25,
        65
      ],
      [
        -74,
        76
      ],
      [
        -62,
        108
      ],
      [
        25,
        65
      ],
      [
        -38,
        66
      ],
      [
        38,
        43
      ],
      [
        136,
        -54
      ],
      [
        12,
        43
      ],
      [
        161,
        22
      ],
      [
        136,
        -54
      ],
      [
        62,
        54
      ],
      [
        112,
        -33
      ],
      [
        49,
        0
      ],
      [
        124,
        33
      ],
      [
        198,
        21
      ],
      [
        75,
        -21
      ],
      [
        12,
        -44
      ],
      [
        -49,
        -21
      ],
      [
        -260,
        -22
      ],
      [
        -162,
        -76
      ],
      [
        261,
        11
      ],
      [
        24,
        -65
      ],
      [
        75,
        -11
      ],
      [
        74,
        -54
      ],
      [
        74,
        -22
      ],
      [
        -12,
        87
      ],
      [
        12,
        65
      ],
      [
        50,
        22
      ],
      [
        136,
        119
      ],
      [
        87,
        -22
      ],
      [
        149,
        -141
      ],
      [
        136,
        -195
      ],
      [
        198,
        -76
      ],
      [
        -74,
        141
      ],
      [
        -50,
        109
      ],
      [
        -25,
        108
      ],
      [
        50,
        98
      ],
      [
        49,
        32
      ],
      [
        0,
        76
      ],
      [
        50,
        22
      ],
      [
        99,
        -22
      ],
      [
        87,
        -65
      ]
    ],
    [
      [
        73110,
        106261
      ],
      [
        -322,
        -22
      ],
      [
        -37,
        11
      ],
      [
        532,
        76
      ],
      [
        124,
        11
      ],
      [
        62,
        -22
      ],
      [
        -359,
        -54
      ]
    ],
    [
      [
        68378,
        106380
      ],
      [
        -74,
        -43
      ],
      [
        -136,
        33
      ],
      [
        49,
        43
      ],
      [
        161,
        -33
      ]
    ],
    [
      [
        69109,
        106348
      ],
      [
        37,
        -11
      ],
      [
        198,
        0
      ],
      [
        50,
        -54
      ],
      [
        62,
        -11
      ],
      [
        136,
        -54
      ],
      [
        37,
        21
      ],
      [
        13,
        174
      ],
      [
        37,
        32
      ],
      [
        49,
        0
      ],
      [
        75,
        33
      ],
      [
        148,
        -22
      ],
      [
        -74,
        -152
      ],
      [
        87,
        -10
      ],
      [
        111,
        21
      ],
      [
        87,
        65
      ],
      [
        74,
        -10
      ],
      [
        50,
        43
      ],
      [
        37,
        0
      ],
      [
        49,
        -43
      ],
      [
        62,
        10
      ],
      [
        62,
        -21
      ],
      [
        186,
        -22
      ],
      [
        136,
        -43
      ],
      [
        199,
        0
      ],
      [
        148,
        -11
      ],
      [
        99,
        -54
      ],
      [
        13,
        -98
      ],
      [
        -37,
        -33
      ],
      [
        -298,
        -108
      ],
      [
        -111,
        -76
      ],
      [
        -50,
        -76
      ],
      [
        -37,
        -22
      ],
      [
        -136,
        -43
      ],
      [
        -174,
        22
      ],
      [
        -123,
        -44
      ],
      [
        -87,
        -54
      ],
      [
        -124,
        -11
      ],
      [
        -297,
        22
      ],
      [
        -75,
        65
      ],
      [
        62,
        43
      ],
      [
        -322,
        -10
      ],
      [
        -371,
        0
      ],
      [
        -25,
        32
      ],
      [
        -124,
        11
      ],
      [
        -173,
        43
      ],
      [
        -87,
        44
      ],
      [
        62,
        21
      ],
      [
        223,
        0
      ],
      [
        99,
        76
      ],
      [
        -223,
        11
      ],
      [
        -74,
        -21
      ],
      [
        -174,
        -11
      ],
      [
        -235,
        21
      ],
      [
        -137,
        65
      ],
      [
        -24,
        44
      ],
      [
        111,
        22
      ],
      [
        99,
        43
      ],
      [
        -173,
        22
      ],
      [
        -149,
        43
      ],
      [
        50,
        22
      ],
      [
        247,
        10
      ],
      [
        186,
        -43
      ],
      [
        75,
        33
      ],
      [
        -62,
        10
      ],
      [
        -62,
        44
      ],
      [
        25,
        54
      ],
      [
        173,
        -76
      ],
      [
        12,
        65
      ],
      [
        -62,
        87
      ],
      [
        38,
        11
      ],
      [
        260,
        -65
      ],
      [
        74,
        -54
      ],
      [
        62,
        -22
      ]
    ],
    [
      [
        120132,
        23426
      ],
      [
        13,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        33
      ],
      [
        49,
        22
      ]
    ],
    [
      [
        119117,
        24510
      ],
      [
        0,
        -54
      ],
      [
        -50,
        11
      ],
      [
        -25,
        32
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        0
      ],
      [
        0,
        32
      ],
      [
        62,
        54
      ],
      [
        12,
        66
      ],
      [
        -12,
        21
      ],
      [
        50,
        11
      ],
      [
        12,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        13,
        -54
      ],
      [
        -13,
        -11
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        119773,
        26939
      ],
      [
        0,
        -21
      ],
      [
        -37,
        11
      ],
      [
        0,
        -33
      ],
      [
        37,
        -11
      ],
      [
        13,
        -21
      ],
      [
        24,
        0
      ],
      [
        0,
        -55
      ],
      [
        -24,
        -21
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        -33
      ],
      [
        -50,
        0
      ],
      [
        -37,
        -43
      ],
      [
        -49,
        -11
      ],
      [
        0,
        43
      ],
      [
        37,
        33
      ],
      [
        0,
        32
      ],
      [
        12,
        33
      ],
      [
        25,
        11
      ],
      [
        0,
        43
      ],
      [
        25,
        33
      ],
      [
        -13,
        65
      ],
      [
        0,
        54
      ],
      [
        62,
        11
      ],
      [
        62,
        -109
      ]
    ],
    [
      [
        119290,
        27699
      ],
      [
        0,
        -55
      ],
      [
        -49,
        22
      ],
      [
        -25,
        0
      ],
      [
        12,
        33
      ],
      [
        50,
        21
      ],
      [
        12,
        -21
      ]
    ],
    [
      [
        119377,
        27991
      ],
      [
        12,
        -75
      ],
      [
        -25,
        10
      ],
      [
        -24,
        33
      ],
      [
        24,
        32
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        1313,
        28523
      ],
      [
        -25,
        0
      ],
      [
        13,
        32
      ],
      [
        -13,
        22
      ],
      [
        25,
        11
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -43
      ]
    ],
    [
      [
        1313,
        28892
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        22
      ],
      [
        -24,
        -65
      ],
      [
        12,
        -55
      ],
      [
        25,
        0
      ],
      [
        12,
        -65
      ],
      [
        -37,
        -10
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        11
      ],
      [
        -12,
        65
      ],
      [
        25,
        32
      ],
      [
        12,
        33
      ],
      [
        -37,
        43
      ],
      [
        -62,
        -10
      ],
      [
        -12,
        10
      ],
      [
        24,
        44
      ],
      [
        38,
        -11
      ],
      [
        37,
        32
      ],
      [
        136,
        -10
      ]
    ],
    [
      [
        121755,
        30692
      ],
      [
        -37,
        -44
      ],
      [
        0,
        33
      ],
      [
        12,
        54
      ],
      [
        13,
        22
      ],
      [
        37,
        22
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -43
      ]
    ],
    [
      [
        121483,
        30432
      ],
      [
        37,
        -11
      ],
      [
        37,
        54
      ],
      [
        37,
        33
      ],
      [
        50,
        32
      ],
      [
        62,
        65
      ],
      [
        62,
        43
      ],
      [
        24,
        0
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -43
      ],
      [
        12,
        -33
      ],
      [
        13,
        33
      ],
      [
        -13,
        22
      ],
      [
        50,
        54
      ],
      [
        -13,
        43
      ],
      [
        37,
        -11
      ],
      [
        38,
        22
      ],
      [
        0,
        -33
      ],
      [
        24,
        11
      ],
      [
        -24,
        -65
      ],
      [
        -38,
        -65
      ],
      [
        13,
        -22
      ],
      [
        49,
        55
      ],
      [
        25,
        -11
      ],
      [
        -49,
        -76
      ],
      [
        -38,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -43
      ],
      [
        25,
        -44
      ],
      [
        -25,
        -65
      ],
      [
        37,
        11
      ],
      [
        37,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        -124,
        -195
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -86,
        -130
      ],
      [
        -13,
        -32
      ],
      [
        -62,
        -195
      ],
      [
        -49,
        -87
      ],
      [
        -25,
        -33
      ],
      [
        -87,
        -65
      ],
      [
        -24,
        -43
      ],
      [
        -38,
        -33
      ],
      [
        -24,
        -11
      ],
      [
        0,
        -21
      ],
      [
        37,
        -33
      ],
      [
        -37,
        -43
      ],
      [
        37,
        -22
      ],
      [
        0,
        -32
      ],
      [
        25,
        -66
      ],
      [
        86,
        -32
      ],
      [
        13,
        -22
      ],
      [
        0,
        -86
      ],
      [
        -13,
        -22
      ],
      [
        -49,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -25,
        43
      ],
      [
        -62,
        -11
      ],
      [
        12,
        33
      ],
      [
        -37,
        32
      ],
      [
        -25,
        -10
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -21
      ],
      [
        -49,
        21
      ],
      [
        -25,
        0
      ],
      [
        13,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        -21
      ],
      [
        -38,
        -11
      ],
      [
        -74,
        -76
      ],
      [
        -49,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        -76
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        -141
      ],
      [
        -12,
        -55
      ],
      [
        0,
        -97
      ],
      [
        -12,
        -98
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -49,
        -65
      ],
      [
        -62,
        -238
      ],
      [
        -37,
        -98
      ],
      [
        0,
        -22
      ],
      [
        37,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -21
      ],
      [
        -111,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        -50,
        -98
      ],
      [
        -99,
        -108
      ],
      [
        -74,
        -141
      ],
      [
        -124,
        -44
      ],
      [
        -74,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -74,
        33
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        33
      ],
      [
        13,
        43
      ],
      [
        -38,
        65
      ],
      [
        -24,
        11
      ],
      [
        -112,
        0
      ],
      [
        -62,
        108
      ],
      [
        -62,
        22
      ],
      [
        -37,
        -54
      ],
      [
        -99,
        -11
      ],
      [
        -124,
        33
      ],
      [
        -12,
        43
      ],
      [
        12,
        54
      ],
      [
        -25,
        0
      ],
      [
        25,
        54
      ],
      [
        0,
        44
      ],
      [
        -37,
        -44
      ],
      [
        -50,
        0
      ],
      [
        0,
        76
      ],
      [
        13,
        22
      ],
      [
        111,
        22
      ],
      [
        37,
        11
      ],
      [
        25,
        21
      ],
      [
        -74,
        11
      ],
      [
        0,
        33
      ],
      [
        25,
        65
      ],
      [
        -50,
        0
      ],
      [
        0,
        43
      ],
      [
        12,
        43
      ],
      [
        50,
        0
      ],
      [
        -12,
        22
      ],
      [
        0,
        33
      ],
      [
        12,
        11
      ],
      [
        50,
        -55
      ],
      [
        37,
        -11
      ],
      [
        -13,
        33
      ],
      [
        0,
        54
      ],
      [
        -37,
        33
      ],
      [
        0,
        54
      ],
      [
        37,
        43
      ],
      [
        25,
        11
      ],
      [
        -12,
        33
      ],
      [
        86,
        97
      ],
      [
        13,
        -76
      ],
      [
        12,
        22
      ],
      [
        0,
        33
      ],
      [
        -12,
        43
      ],
      [
        12,
        22
      ],
      [
        25,
        11
      ],
      [
        74,
        97
      ],
      [
        25,
        0
      ],
      [
        0,
        54
      ],
      [
        124,
        174
      ],
      [
        50,
        87
      ],
      [
        37,
        32
      ],
      [
        62,
        44
      ],
      [
        62,
        -22
      ],
      [
        86,
        87
      ],
      [
        37,
        -33
      ],
      [
        -12,
        54
      ],
      [
        12,
        33
      ],
      [
        112,
        97
      ],
      [
        49,
        22
      ],
      [
        38,
        33
      ],
      [
        24,
        0
      ],
      [
        0,
        43
      ],
      [
        13,
        22
      ],
      [
        49,
        43
      ],
      [
        50,
        65
      ],
      [
        25,
        54
      ],
      [
        49,
        66
      ],
      [
        25,
        10
      ],
      [
        37,
        -10
      ],
      [
        -12,
        32
      ],
      [
        74,
        54
      ],
      [
        37,
        44
      ],
      [
        50,
        86
      ],
      [
        12,
        11
      ],
      [
        74,
        141
      ],
      [
        25,
        11
      ],
      [
        -12,
        33
      ],
      [
        12,
        65
      ],
      [
        0,
        65
      ],
      [
        25,
        76
      ],
      [
        37,
        173
      ],
      [
        13,
        22
      ],
      [
        74,
        22
      ],
      [
        37,
        43
      ],
      [
        62,
        130
      ],
      [
        25,
        152
      ],
      [
        12,
        163
      ],
      [
        50,
        119
      ],
      [
        62,
        87
      ],
      [
        62,
        65
      ],
      [
        24,
        11
      ],
      [
        38,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -33
      ],
      [
        25,
        -65
      ],
      [
        25,
        -32
      ],
      [
        49,
        -11
      ],
      [
        25,
        -152
      ],
      [
        0,
        -65
      ],
      [
        13,
        -54
      ]
    ],
    [
      [
        122325,
        33555
      ],
      [
        0,
        -33
      ],
      [
        -25,
        11
      ],
      [
        -12,
        22
      ],
      [
        -37,
        33
      ],
      [
        0,
        54
      ],
      [
        24,
        43
      ],
      [
        13,
        -32
      ],
      [
        25,
        -33
      ],
      [
        12,
        -65
      ]
    ],
    [
      [
        121545,
        34390
      ],
      [
        0,
        -32
      ],
      [
        24,
        21
      ],
      [
        13,
        33
      ],
      [
        25,
        -33
      ],
      [
        74,
        -32
      ],
      [
        37,
        -44
      ],
      [
        25,
        33
      ],
      [
        86,
        -76
      ],
      [
        0,
        -76
      ],
      [
        25,
        -22
      ],
      [
        37,
        33
      ],
      [
        13,
        0
      ],
      [
        25,
        -76
      ],
      [
        0,
        -22
      ],
      [
        24,
        -32
      ],
      [
        25,
        -76
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -21
      ],
      [
        25,
        -76
      ],
      [
        -62,
        11
      ],
      [
        0,
        -22
      ],
      [
        24,
        -54
      ],
      [
        25,
        -76
      ],
      [
        25,
        -44
      ],
      [
        62,
        -141
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -65
      ],
      [
        25,
        -76
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -10
      ],
      [
        0,
        -33
      ],
      [
        25,
        0
      ],
      [
        37,
        -43
      ],
      [
        0,
        32
      ],
      [
        12,
        11
      ],
      [
        38,
        -43
      ],
      [
        86,
        -44
      ],
      [
        13,
        -32
      ],
      [
        0,
        -76
      ],
      [
        12,
        -33
      ],
      [
        62,
        11
      ],
      [
        0,
        87
      ],
      [
        -25,
        119
      ],
      [
        0,
        33
      ],
      [
        13,
        43
      ],
      [
        -38,
        98
      ],
      [
        -12,
        21
      ],
      [
        25,
        44
      ],
      [
        25,
        -65
      ],
      [
        62,
        -98
      ],
      [
        24,
        0
      ],
      [
        0,
        -43
      ],
      [
        25,
        -44
      ],
      [
        12,
        -43
      ],
      [
        13,
        -163
      ],
      [
        25,
        -141
      ],
      [
        49,
        -65
      ],
      [
        0,
        -32
      ],
      [
        -25,
        21
      ],
      [
        -12,
        -21
      ],
      [
        25,
        -33
      ],
      [
        74,
        -21
      ],
      [
        99,
        -98
      ],
      [
        62,
        -33
      ],
      [
        136,
        -65
      ],
      [
        62,
        0
      ],
      [
        37,
        22
      ],
      [
        38,
        33
      ],
      [
        49,
        130
      ],
      [
        37,
        21
      ],
      [
        25,
        33
      ],
      [
        37,
        32
      ],
      [
        99,
        0
      ],
      [
        25,
        -32
      ],
      [
        62,
        -54
      ],
      [
        -37,
        -98
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -304
      ],
      [
        -50,
        -119
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        -185
      ],
      [
        25,
        -43
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -66
      ],
      [
        -12,
        11
      ],
      [
        -13,
        55
      ],
      [
        -12,
        21
      ],
      [
        -87,
        22
      ],
      [
        -49,
        -11
      ],
      [
        -37,
        -22
      ],
      [
        -75,
        -65
      ],
      [
        -37,
        -86
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -44
      ],
      [
        12,
        -32
      ],
      [
        50,
        -44
      ],
      [
        -50,
        -151
      ],
      [
        -37,
        -152
      ],
      [
        -50,
        -87
      ],
      [
        -37,
        -87
      ],
      [
        -37,
        -76
      ],
      [
        -37,
        -65
      ],
      [
        -112,
        -293
      ],
      [
        -24,
        -54
      ],
      [
        -50,
        -65
      ],
      [
        -49,
        -54
      ],
      [
        -87,
        -76
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        43
      ],
      [
        0,
        54
      ],
      [
        -12,
        22
      ],
      [
        -37,
        11
      ],
      [
        -62,
        -22
      ],
      [
        0,
        98
      ],
      [
        -38,
        -33
      ],
      [
        -37,
        0
      ],
      [
        -12,
        22
      ],
      [
        74,
        141
      ],
      [
        62,
        141
      ],
      [
        50,
        141
      ],
      [
        37,
        206
      ],
      [
        -25,
        54
      ],
      [
        -12,
        54
      ],
      [
        -50,
        98
      ],
      [
        -74,
        54
      ],
      [
        -37,
        11
      ],
      [
        -37,
        22
      ],
      [
        -50,
        54
      ],
      [
        -25,
        54
      ],
      [
        -148,
        87
      ],
      [
        -38,
        43
      ],
      [
        -24,
        76
      ],
      [
        0,
        33
      ],
      [
        12,
        54
      ],
      [
        99,
        87
      ],
      [
        87,
        43
      ],
      [
        25,
        0
      ],
      [
        24,
        22
      ],
      [
        38,
        54
      ],
      [
        0,
        32
      ],
      [
        24,
        228
      ],
      [
        25,
        130
      ],
      [
        37,
        120
      ],
      [
        -12,
        86
      ],
      [
        25,
        44
      ],
      [
        24,
        11
      ],
      [
        -37,
        76
      ],
      [
        -25,
        108
      ],
      [
        -12,
        33
      ],
      [
        12,
        32
      ],
      [
        0,
        43
      ],
      [
        -24,
        0
      ],
      [
        0,
        33
      ],
      [
        -37,
        119
      ],
      [
        24,
        0
      ],
      [
        25,
        -76
      ],
      [
        25,
        65
      ],
      [
        49,
        11
      ],
      [
        -49,
        87
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -50,
        33
      ],
      [
        -12,
        32
      ],
      [
        -12,
        76
      ],
      [
        -13,
        22
      ],
      [
        -62,
        141
      ],
      [
        25,
        11
      ],
      [
        50,
        -76
      ],
      [
        12,
        22
      ],
      [
        0,
        76
      ],
      [
        -25,
        43
      ],
      [
        0,
        32
      ],
      [
        13,
        55
      ],
      [
        -38,
        43
      ],
      [
        -12,
        0
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -11
      ],
      [
        -74,
        87
      ],
      [
        -13,
        -22
      ],
      [
        50,
        -87
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        22
      ],
      [
        -13,
        76
      ],
      [
        -24,
        43
      ],
      [
        -174,
        390
      ],
      [
        13,
        55
      ],
      [
        49,
        65
      ],
      [
        0,
        21
      ],
      [
        -25,
        -10
      ],
      [
        -49,
        -87
      ],
      [
        -37,
        43
      ],
      [
        0,
        44
      ],
      [
        -25,
        0
      ],
      [
        -13,
        54
      ],
      [
        -24,
        32
      ],
      [
        24,
        44
      ],
      [
        0,
        65
      ],
      [
        -49,
        141
      ],
      [
        -62,
        108
      ],
      [
        -50,
        109
      ],
      [
        62,
        11
      ],
      [
        50,
        0
      ],
      [
        -25,
        -65
      ],
      [
        12,
        -33
      ],
      [
        25,
        -33
      ],
      [
        37,
        -108
      ],
      [
        0,
        -22
      ],
      [
        38,
        -54
      ]
    ],
    [
      [
        82128,
        68845
      ],
      [
        -25,
        -11
      ],
      [
        0,
        87
      ],
      [
        50,
        98
      ],
      [
        37,
        108
      ],
      [
        12,
        -97
      ],
      [
        -37,
        -55
      ],
      [
        -25,
        -97
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        80183,
        66611
      ],
      [
        -12,
        87
      ],
      [
        -25,
        76
      ],
      [
        -25,
        87
      ],
      [
        -12,
        86
      ],
      [
        -12,
        55
      ],
      [
        -25,
        21
      ],
      [
        -25,
        54
      ],
      [
        -37,
        196
      ],
      [
        -25,
        54
      ],
      [
        -37,
        195
      ],
      [
        -13,
        54
      ],
      [
        -24,
        65
      ],
      [
        -25,
        131
      ],
      [
        -12,
        54
      ],
      [
        -25,
        65
      ],
      [
        -37,
        184
      ]
    ],
    [
      [
        79812,
        68075
      ],
      [
        99,
        65
      ],
      [
        62,
        44
      ],
      [
        124,
        65
      ],
      [
        49,
        43
      ],
      [
        124,
        65
      ],
      [
        62,
        44
      ],
      [
        62,
        32
      ],
      [
        49,
        33
      ],
      [
        62,
        32
      ],
      [
        62,
        44
      ],
      [
        62,
        32
      ],
      [
        112,
        76
      ],
      [
        99,
        54
      ],
      [
        12,
        87
      ],
      [
        25,
        130
      ],
      [
        37,
        217
      ],
      [
        25,
        130
      ],
      [
        37,
        206
      ],
      [
        37,
        217
      ],
      [
        25,
        130
      ],
      [
        25,
        141
      ],
      [
        -13,
        55
      ],
      [
        -37,
        86
      ],
      [
        -49,
        163
      ],
      [
        -25,
        54
      ],
      [
        -25,
        76
      ]
    ],
    [
      [
        81323,
        71817
      ],
      [
        37,
        -163
      ],
      [
        50,
        -152
      ],
      [
        49,
        -86
      ],
      [
        50,
        -120
      ],
      [
        74,
        -97
      ],
      [
        25,
        -44
      ],
      [
        136,
        -76
      ],
      [
        173,
        -54
      ],
      [
        75,
        -54
      ],
      [
        87,
        11
      ],
      [
        61,
        -76
      ],
      [
        25,
        -76
      ],
      [
        25,
        -43
      ],
      [
        50,
        -120
      ],
      [
        49,
        -108
      ],
      [
        37,
        -109
      ],
      [
        87,
        -130
      ],
      [
        99,
        -43
      ],
      [
        0,
        -130
      ],
      [
        -12,
        -55
      ],
      [
        -37,
        -97
      ],
      [
        -13,
        -65
      ],
      [
        -49,
        -109
      ],
      [
        -50,
        -173
      ],
      [
        -25,
        -44
      ],
      [
        -74,
        -86
      ],
      [
        -62,
        -120
      ],
      [
        -74,
        -184
      ],
      [
        -50,
        -195
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -12,
        21
      ],
      [
        0,
        44
      ],
      [
        12,
        65
      ],
      [
        -50,
        -22
      ],
      [
        -61,
        -141
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -97
      ],
      [
        -12,
        -98
      ],
      [
        -13,
        -76
      ],
      [
        0,
        -43
      ],
      [
        13,
        -109
      ],
      [
        0,
        -119
      ],
      [
        24,
        -141
      ],
      [
        -24,
        -33
      ],
      [
        -25,
        -10
      ],
      [
        -87,
        -11
      ],
      [
        -87,
        -22
      ],
      [
        -74,
        -43
      ],
      [
        -49,
        -55
      ],
      [
        -50,
        -97
      ],
      [
        -37,
        -261
      ],
      [
        -62,
        -119
      ],
      [
        -37,
        -21
      ],
      [
        -99,
        -11
      ],
      [
        -124,
        -22
      ],
      [
        -50,
        -33
      ],
      [
        -74,
        -162
      ],
      [
        -13,
        -44
      ],
      [
        25,
        -86
      ],
      [
        -49,
        -131
      ],
      [
        -37,
        -75
      ],
      [
        -100,
        -55
      ],
      [
        -37,
        33
      ],
      [
        -24,
        11
      ],
      [
        -75,
        0
      ],
      [
        -99,
        -11
      ],
      [
        -37,
        -54
      ],
      [
        -62,
        -44
      ],
      [
        -62,
        -54
      ],
      [
        -111,
        -22
      ],
      [
        -75,
        -54
      ]
    ],
    [
      [
        81286,
        71979
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        11
      ],
      [
        0,
        32
      ],
      [
        25,
        22
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        81224,
        72489
      ],
      [
        25,
        98
      ],
      [
        12,
        11
      ],
      [
        37,
        0
      ],
      [
        12,
        54
      ],
      [
        25,
        22
      ],
      [
        0,
        -152
      ],
      [
        -12,
        -185
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        85374,
        71112
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -32
      ],
      [
        -25,
        65
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        43
      ],
      [
        -12,
        -43
      ],
      [
        -62,
        -11
      ],
      [
        0,
        65
      ],
      [
        -25,
        -21
      ],
      [
        -24,
        32
      ],
      [
        -13,
        65
      ],
      [
        -37,
        33
      ],
      [
        -25,
        108
      ],
      [
        0,
        65
      ],
      [
        -37,
        239
      ],
      [
        -25,
        22
      ],
      [
        -136,
        43
      ],
      [
        -12,
        43
      ],
      [
        12,
        120
      ],
      [
        0,
        65
      ],
      [
        -50,
        97
      ],
      [
        -12,
        65
      ],
      [
        -37,
        55
      ],
      [
        -37,
        21
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -54
      ],
      [
        74,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -124,
        -32
      ],
      [
        -74,
        -33
      ],
      [
        -87,
        11
      ],
      [
        -124,
        -43
      ],
      [
        -99,
        0
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        11
      ],
      [
        -12,
        21
      ],
      [
        -136,
        55
      ],
      [
        -13,
        32
      ],
      [
        -25,
        11
      ],
      [
        -24,
        -32
      ],
      [
        -87,
        21
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        -97
      ],
      [
        -62,
        11
      ],
      [
        -37,
        21
      ],
      [
        -62,
        -21
      ],
      [
        -111,
        32
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        55
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        -33
      ],
      [
        -74,
        -11
      ],
      [
        -49,
        0
      ],
      [
        -62,
        33
      ],
      [
        12,
        11
      ]
    ],
    [
      [
        33842,
        60798
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        33
      ],
      [
        -25,
        54
      ],
      [
        -13,
        11
      ],
      [
        0,
        22
      ],
      [
        25,
        54
      ],
      [
        25,
        11
      ],
      [
        25,
        -55
      ],
      [
        -25,
        -32
      ],
      [
        12,
        -33
      ],
      [
        25,
        -32
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        34722,
        61373
      ],
      [
        -13,
        -33
      ],
      [
        -12,
        33
      ],
      [
        12,
        22
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        34784,
        61384
      ],
      [
        -13,
        -33
      ],
      [
        -12,
        65
      ],
      [
        0,
        65
      ],
      [
        25,
        22
      ],
      [
        12,
        -11
      ],
      [
        0,
        -87
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        35118,
        60733
      ],
      [
        0,
        11
      ],
      [
        -87,
        184
      ],
      [
        -74,
        217
      ],
      [
        -12,
        109
      ],
      [
        37,
        0
      ],
      [
        12,
        10
      ],
      [
        0,
        98
      ],
      [
        37,
        54
      ],
      [
        13,
        33
      ],
      [
        25,
        -65
      ],
      [
        37,
        -33
      ],
      [
        37,
        -43
      ],
      [
        0,
        43
      ],
      [
        -62,
        65
      ],
      [
        -12,
        44
      ],
      [
        -13,
        65
      ],
      [
        -37,
        -54
      ],
      [
        -12,
        0
      ],
      [
        -13,
        21
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -12,
        0
      ],
      [
        -13,
        22
      ],
      [
        0,
        32
      ],
      [
        -24,
        109
      ],
      [
        -50,
        76
      ],
      [
        -12,
        0
      ],
      [
        -25,
        43
      ],
      [
        -25,
        22
      ],
      [
        -37,
        54
      ],
      [
        -50,
        43
      ],
      [
        -49,
        11
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -11
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -44
      ],
      [
        24,
        -32
      ],
      [
        -124,
        -152
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        -10
      ],
      [
        -37,
        -55
      ],
      [
        0,
        -76
      ],
      [
        37,
        -54
      ],
      [
        37,
        -87
      ],
      [
        62,
        -119
      ],
      [
        12,
        -43
      ],
      [
        13,
        -65
      ],
      [
        -25,
        -22
      ],
      [
        -13,
        -22
      ],
      [
        -61,
        0
      ],
      [
        -25,
        -21
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        -87,
        -33
      ],
      [
        -49,
        0
      ],
      [
        -25,
        33
      ],
      [
        0,
        108
      ],
      [
        -50,
        163
      ],
      [
        -12,
        108
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -87
      ],
      [
        -13,
        -32
      ],
      [
        -99,
        65
      ],
      [
        -62,
        184
      ],
      [
        0,
        33
      ],
      [
        -12,
        43
      ],
      [
        -50,
        22
      ],
      [
        -37,
        21
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -21
      ],
      [
        -24,
        21
      ],
      [
        0,
        54
      ],
      [
        -50,
        -21
      ],
      [
        -49,
        11
      ],
      [
        -50,
        21
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -43
      ],
      [
        12,
        -87
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        33520,
        62197
      ],
      [
        25,
        -32
      ],
      [
        37,
        -65
      ],
      [
        0,
        -55
      ],
      [
        12,
        -76
      ],
      [
        25,
        -10
      ],
      [
        25,
        10
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -76
      ],
      [
        37,
        -22
      ],
      [
        12,
        -32
      ],
      [
        62,
        11
      ],
      [
        25,
        -11
      ],
      [
        25,
        11
      ],
      [
        -25,
        54
      ],
      [
        -25,
        43
      ],
      [
        0,
        22
      ],
      [
        25,
        -11
      ],
      [
        12,
        -32
      ],
      [
        25,
        -33
      ],
      [
        62,
        -119
      ],
      [
        62,
        -33
      ],
      [
        62,
        0
      ],
      [
        37,
        22
      ],
      [
        87,
        43
      ],
      [
        49,
        87
      ],
      [
        186,
        119
      ],
      [
        62,
        76
      ],
      [
        37,
        22
      ],
      [
        50,
        65
      ],
      [
        25,
        54
      ],
      [
        24,
        22
      ],
      [
        75,
        -22
      ],
      [
        49,
        -21
      ],
      [
        37,
        10
      ],
      [
        25,
        -21
      ],
      [
        12,
        -33
      ],
      [
        25,
        -21
      ],
      [
        75,
        10
      ],
      [
        74,
        -21
      ],
      [
        136,
        -109
      ],
      [
        87,
        -97
      ],
      [
        49,
        -120
      ],
      [
        112,
        -141
      ]
    ],
    [
      [
        17788,
        40973
      ],
      [
        -12,
        0
      ],
      [
        -13,
        33
      ],
      [
        13,
        10
      ],
      [
        12,
        -43
      ]
    ],
    [
      [
        37695,
        44758
      ],
      [
        -25,
        43
      ],
      [
        -112,
        131
      ],
      [
        -37,
        76
      ],
      [
        -49,
        43
      ],
      [
        -87,
        119
      ],
      [
        -12,
        33
      ],
      [
        -13,
        130
      ],
      [
        -12,
        32
      ],
      [
        -37,
        44
      ],
      [
        -87,
        65
      ],
      [
        -25,
        22
      ],
      [
        -37,
        54
      ],
      [
        -50,
        43
      ],
      [
        -49,
        76
      ],
      [
        -37,
        65
      ],
      [
        -37,
        44
      ],
      [
        -112,
        54
      ],
      [
        -49,
        65
      ],
      [
        -112,
        76
      ],
      [
        -49,
        54
      ],
      [
        -112,
        65
      ],
      [
        -136,
        184
      ],
      [
        -87,
        44
      ],
      [
        -62,
        87
      ],
      [
        -186,
        184
      ],
      [
        -62,
        141
      ],
      [
        -37,
        54
      ],
      [
        -49,
        119
      ],
      [
        -75,
        76
      ],
      [
        -62,
        87
      ],
      [
        -24,
        87
      ],
      [
        -50,
        108
      ],
      [
        -12,
        65
      ],
      [
        -37,
        55
      ],
      [
        0,
        119
      ],
      [
        -25,
        54
      ],
      [
        12,
        22
      ],
      [
        25,
        11
      ],
      [
        25,
        184
      ],
      [
        -13,
        87
      ],
      [
        -74,
        162
      ],
      [
        -25,
        76
      ],
      [
        -12,
        109
      ],
      [
        -37,
        54
      ],
      [
        -37,
        130
      ],
      [
        -25,
        109
      ],
      [
        -62,
        76
      ],
      [
        -13,
        32
      ],
      [
        0,
        43
      ],
      [
        -37,
        33
      ],
      [
        0,
        87
      ],
      [
        -25,
        162
      ],
      [
        -24,
        76
      ],
      [
        -112,
        152
      ],
      [
        0,
        65
      ],
      [
        -12,
        98
      ],
      [
        -25,
        119
      ],
      [
        -161,
        467
      ],
      [
        -25,
        173
      ],
      [
        -25,
        98
      ],
      [
        -37,
        184
      ],
      [
        -49,
        130
      ],
      [
        -25,
        119
      ],
      [
        -37,
        217
      ],
      [
        -50,
        131
      ],
      [
        -37,
        119
      ],
      [
        -49,
        108
      ],
      [
        -50,
        76
      ],
      [
        -25,
        54
      ],
      [
        -74,
        261
      ],
      [
        0,
        76
      ],
      [
        -50,
        141
      ],
      [
        -49,
        108
      ],
      [
        -75,
        152
      ],
      [
        -247,
        228
      ],
      [
        -75,
        97
      ],
      [
        -37,
        44
      ],
      [
        -12,
        76
      ],
      [
        12,
        43
      ],
      [
        25,
        43
      ],
      [
        25,
        -32
      ],
      [
        25,
        11
      ],
      [
        12,
        54
      ],
      [
        12,
        76
      ],
      [
        -24,
        97
      ],
      [
        -75,
        196
      ],
      [
        0,
        32
      ],
      [
        13,
        54
      ],
      [
        -25,
        87
      ],
      [
        -37,
        76
      ],
      [
        -13,
        54
      ],
      [
        13,
        217
      ],
      [
        24,
        54
      ],
      [
        112,
        228
      ],
      [
        37,
        87
      ],
      [
        50,
        65
      ],
      [
        49,
        87
      ],
      [
        62,
        65
      ]
    ],
    [
      [
        103298,
        59497
      ],
      [
        -25,
        -55
      ],
      [
        -12,
        11
      ],
      [
        -13,
        -11
      ],
      [
        -37,
        -10
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        0
      ],
      [
        0,
        44
      ],
      [
        87,
        76
      ],
      [
        50,
        54
      ],
      [
        0,
        -33
      ],
      [
        12,
        -21
      ]
    ],
    [
      [
        103608,
        60006
      ],
      [
        24,
        -43
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        54
      ],
      [
        -49,
        -32
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        32
      ],
      [
        12,
        33
      ],
      [
        50,
        54
      ],
      [
        37,
        -11
      ]
    ],
    [
      [
        103930,
        60234
      ],
      [
        -50,
        -11
      ],
      [
        -25,
        65
      ],
      [
        0,
        22
      ],
      [
        -24,
        33
      ],
      [
        12,
        32
      ],
      [
        25,
        11
      ],
      [
        49,
        43
      ],
      [
        87,
        -65
      ],
      [
        12,
        -21
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -33
      ]
    ],
    [
      [
        105206,
        60560
      ],
      [
        -13,
        -33
      ],
      [
        -12,
        87
      ],
      [
        -12,
        21
      ],
      [
        12,
        65
      ],
      [
        25,
        -32
      ],
      [
        0,
        -108
      ]
    ],
    [
      [
        104227,
        60841
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        0
      ],
      [
        0,
        65
      ],
      [
        24,
        -21
      ],
      [
        13,
        21
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        102208,
        61134
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        54
      ],
      [
        0,
        98
      ],
      [
        37,
        11
      ],
      [
        0,
        -120
      ]
    ],
    [
      [
        102307,
        61340
      ],
      [
        -25,
        -10
      ],
      [
        -12,
        43
      ],
      [
        0,
        32
      ],
      [
        25,
        0
      ],
      [
        12,
        -65
      ]
    ],
    [
      [
        104871,
        61926
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        32
      ],
      [
        -13,
        33
      ],
      [
        0,
        32
      ],
      [
        37,
        11
      ],
      [
        25,
        -65
      ]
    ],
    [
      [
        104487,
        61980
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -12,
        44
      ],
      [
        62,
        54
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        105268,
        62208
      ],
      [
        -13,
        -22
      ],
      [
        -12,
        33
      ],
      [
        12,
        76
      ],
      [
        13,
        11
      ],
      [
        0,
        -98
      ]
    ],
    [
      [
        105280,
        62034
      ],
      [
        25,
        -32
      ],
      [
        37,
        11
      ],
      [
        0,
        -130
      ],
      [
        37,
        -76
      ],
      [
        12,
        -65
      ],
      [
        -37,
        -98
      ],
      [
        -24,
        -43
      ],
      [
        0,
        -44
      ],
      [
        37,
        -11
      ],
      [
        37,
        -32
      ],
      [
        0,
        -98
      ],
      [
        25,
        -76
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -141
      ],
      [
        13,
        -65
      ],
      [
        12,
        -44
      ],
      [
        25,
        -21
      ],
      [
        0,
        -33
      ],
      [
        12,
        -76
      ],
      [
        0,
        -184
      ],
      [
        -12,
        -44
      ],
      [
        -37,
        -108
      ],
      [
        -50,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -75
      ],
      [
        0,
        -152
      ],
      [
        -12,
        -109
      ],
      [
        -25,
        109
      ],
      [
        -12,
        152
      ],
      [
        -13,
        65
      ],
      [
        -24,
        65
      ],
      [
        0,
        54
      ],
      [
        -25,
        54
      ],
      [
        -25,
        141
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        -50,
        -130
      ],
      [
        -12,
        -65
      ],
      [
        37,
        -76
      ],
      [
        37,
        -43
      ],
      [
        0,
        -22
      ],
      [
        38,
        -152
      ],
      [
        -13,
        -152
      ],
      [
        -12,
        -76
      ],
      [
        -50,
        -119
      ],
      [
        -49,
        -43
      ],
      [
        -13,
        21
      ],
      [
        -12,
        76
      ],
      [
        -13,
        33
      ],
      [
        13,
        76
      ],
      [
        0,
        65
      ],
      [
        -13,
        21
      ],
      [
        -12,
        -10
      ],
      [
        -37,
        -98
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -112,
        87
      ],
      [
        -86,
        76
      ],
      [
        -62,
        65
      ],
      [
        -50,
        108
      ],
      [
        -12,
        87
      ],
      [
        0,
        76
      ],
      [
        -13,
        130
      ],
      [
        0,
        76
      ],
      [
        13,
        76
      ],
      [
        37,
        65
      ],
      [
        25,
        76
      ],
      [
        0,
        33
      ],
      [
        -50,
        119
      ],
      [
        -37,
        54
      ],
      [
        -62,
        44
      ],
      [
        -37,
        54
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -87
      ],
      [
        -37,
        -163
      ],
      [
        -37,
        33
      ],
      [
        -38,
        43
      ],
      [
        0,
        33
      ],
      [
        -12,
        32
      ],
      [
        0,
        22
      ],
      [
        -12,
        22
      ],
      [
        -13,
        -54
      ],
      [
        -25,
        -44
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -12,
        22
      ],
      [
        0,
        98
      ],
      [
        -38,
        32
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        -50,
        -141
      ],
      [
        -12,
        -108
      ],
      [
        -37,
        -98
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -37,
        97
      ],
      [
        0,
        76
      ],
      [
        25,
        55
      ],
      [
        24,
        43
      ],
      [
        25,
        184
      ],
      [
        0,
        98
      ],
      [
        37,
        87
      ],
      [
        37,
        54
      ],
      [
        13,
        11
      ],
      [
        74,
        21
      ],
      [
        25,
        33
      ],
      [
        50,
        0
      ],
      [
        37,
        11
      ],
      [
        24,
        43
      ],
      [
        0,
        87
      ],
      [
        25,
        43
      ],
      [
        25,
        55
      ],
      [
        50,
        10
      ],
      [
        24,
        22
      ],
      [
        13,
        33
      ],
      [
        12,
        54
      ],
      [
        50,
        -44
      ],
      [
        37,
        -10
      ],
      [
        37,
        -44
      ],
      [
        25,
        -76
      ],
      [
        0,
        -32
      ],
      [
        12,
        -119
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        24,
        0
      ],
      [
        38,
        43
      ],
      [
        24,
        22
      ],
      [
        62,
        32
      ],
      [
        13,
        11
      ],
      [
        0,
        33
      ],
      [
        24,
        65
      ],
      [
        13,
        76
      ],
      [
        25,
        65
      ],
      [
        24,
        0
      ],
      [
        50,
        -54
      ],
      [
        37,
        32
      ],
      [
        12,
        76
      ],
      [
        13,
        108
      ],
      [
        0,
        33
      ],
      [
        25,
        33
      ],
      [
        24,
        -11
      ],
      [
        38,
        -44
      ],
      [
        37,
        -11
      ],
      [
        12,
        33
      ],
      [
        12,
        65
      ],
      [
        13,
        0
      ],
      [
        37,
        -22
      ],
      [
        50,
        22
      ],
      [
        12,
        76
      ],
      [
        -12,
        87
      ],
      [
        -38,
        238
      ],
      [
        25,
        55
      ],
      [
        13,
        0
      ],
      [
        49,
        -65
      ],
      [
        74,
        -87
      ],
      [
        25,
        -54
      ],
      [
        25,
        -66
      ]
    ],
    [
      [
        105292,
        62316
      ],
      [
        -24,
        44
      ],
      [
        12,
        54
      ],
      [
        25,
        87
      ],
      [
        12,
        -76
      ],
      [
        0,
        -43
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -22
      ],
      [
        -25,
        0
      ]
    ],
    [
      [
        105032,
        62447
      ],
      [
        0,
        -33
      ],
      [
        -49,
        87
      ],
      [
        0,
        54
      ],
      [
        12,
        0
      ],
      [
        12,
        -22
      ],
      [
        25,
        -86
      ]
    ],
    [
      [
        104797,
        62327
      ],
      [
        -13,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -24,
        -65
      ],
      [
        -13,
        -11
      ],
      [
        -74,
        -22
      ],
      [
        -74,
        22
      ],
      [
        -38,
        86
      ],
      [
        0,
        33
      ],
      [
        13,
        33
      ],
      [
        25,
        32
      ],
      [
        49,
        43
      ],
      [
        12,
        44
      ],
      [
        25,
        43
      ],
      [
        50,
        11
      ],
      [
        25,
        -11
      ],
      [
        37,
        -43
      ],
      [
        24,
        -22
      ],
      [
        0,
        -130
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        105169,
        62403
      ],
      [
        -38,
        54
      ],
      [
        -12,
        55
      ],
      [
        -12,
        21
      ],
      [
        0,
        120
      ],
      [
        37,
        43
      ],
      [
        12,
        33
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -98
      ],
      [
        13,
        -108
      ],
      [
        0,
        -98
      ]
    ],
    [
      [
        103187,
        62761
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        54
      ],
      [
        37,
        55
      ],
      [
        37,
        -22
      ],
      [
        12,
        -22
      ],
      [
        -24,
        -54
      ]
    ],
    [
      [
        104698,
        62837
      ],
      [
        -13,
        0
      ],
      [
        13,
        65
      ],
      [
        25,
        -22
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        104128,
        62761
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        -21
      ],
      [
        -13,
        43
      ],
      [
        0,
        65
      ],
      [
        62,
        87
      ],
      [
        13,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -98
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        104289,
        61872
      ],
      [
        -50,
        0
      ],
      [
        -12,
        32
      ],
      [
        -25,
        130
      ],
      [
        -37,
        33
      ],
      [
        -37,
        22
      ],
      [
        -12,
        21
      ],
      [
        -25,
        22
      ],
      [
        -50,
        141
      ],
      [
        0,
        119
      ],
      [
        25,
        44
      ],
      [
        12,
        11
      ],
      [
        50,
        0
      ],
      [
        62,
        65
      ],
      [
        12,
        21
      ],
      [
        0,
        109
      ],
      [
        -24,
        130
      ],
      [
        12,
        32
      ],
      [
        25,
        33
      ],
      [
        12,
        65
      ],
      [
        0,
        76
      ],
      [
        25,
        54
      ],
      [
        74,
        54
      ],
      [
        99,
        -54
      ],
      [
        13,
        -65
      ],
      [
        0,
        -22
      ],
      [
        -13,
        -75
      ],
      [
        -37,
        -120
      ],
      [
        -25,
        -87
      ],
      [
        -12,
        -130
      ],
      [
        -12,
        -32
      ],
      [
        -38,
        -130
      ],
      [
        0,
        -87
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -32
      ],
      [
        62,
        -163
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -33
      ],
      [
        -13,
        -54
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        -21
      ]
    ],
    [
      [
        104376,
        62121
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        43
      ],
      [
        0,
        54
      ],
      [
        37,
        195
      ],
      [
        -12,
        44
      ],
      [
        49,
        108
      ],
      [
        25,
        109
      ],
      [
        37,
        108
      ],
      [
        75,
        304
      ],
      [
        0,
        43
      ],
      [
        12,
        22
      ],
      [
        0,
        76
      ],
      [
        25,
        54
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -65
      ],
      [
        0,
        -33
      ],
      [
        12,
        -11
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -98
      ],
      [
        12,
        -119
      ],
      [
        -25,
        -119
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -54
      ],
      [
        -49,
        -206
      ],
      [
        -37,
        -87
      ]
    ],
    [
      [
        104500,
        63260
      ],
      [
        24,
        -76
      ],
      [
        -24,
        0
      ],
      [
        -13,
        54
      ],
      [
        13,
        22
      ]
    ],
    [
      [
        102282,
        61481
      ],
      [
        -25,
        -43
      ],
      [
        0,
        54
      ],
      [
        38,
        163
      ],
      [
        24,
        32
      ],
      [
        38,
        87
      ],
      [
        24,
        44
      ],
      [
        50,
        75
      ],
      [
        49,
        98
      ],
      [
        38,
        0
      ],
      [
        12,
        11
      ],
      [
        37,
        54
      ],
      [
        74,
        152
      ],
      [
        62,
        119
      ],
      [
        75,
        152
      ],
      [
        37,
        65
      ],
      [
        62,
        141
      ],
      [
        12,
        22
      ],
      [
        25,
        11
      ],
      [
        25,
        43
      ],
      [
        25,
        54
      ],
      [
        12,
        76
      ],
      [
        -25,
        98
      ],
      [
        37,
        119
      ],
      [
        37,
        163
      ],
      [
        13,
        32
      ],
      [
        25,
        -21
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -32
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -54
      ],
      [
        25,
        -152
      ],
      [
        25,
        -98
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        -43
      ],
      [
        -13,
        -65
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -21
      ],
      [
        -87,
        -44
      ],
      [
        -62,
        -54
      ],
      [
        -12,
        -32
      ],
      [
        12,
        -55
      ],
      [
        -74,
        -216
      ],
      [
        -25,
        -55
      ],
      [
        -12,
        -54
      ],
      [
        -38,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -76
      ],
      [
        -24,
        -65
      ],
      [
        -38,
        -54
      ],
      [
        -61,
        -76
      ],
      [
        -38,
        -22
      ],
      [
        -24,
        -65
      ],
      [
        -38,
        -21
      ],
      [
        -37,
        -44
      ]
    ],
    [
      [
        103162,
        63412
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        11
      ],
      [
        -12,
        43
      ],
      [
        24,
        33
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        104784,
        63303
      ],
      [
        25,
        -21
      ],
      [
        25,
        0
      ],
      [
        37,
        54
      ],
      [
        37,
        -22
      ],
      [
        38,
        -97
      ],
      [
        0,
        -163
      ],
      [
        -13,
        -98
      ],
      [
        37,
        -65
      ],
      [
        25,
        -65
      ],
      [
        0,
        -76
      ],
      [
        25,
        -76
      ],
      [
        0,
        -54
      ],
      [
        -37,
        11
      ],
      [
        -13,
        -33
      ],
      [
        -24,
        65
      ],
      [
        -13,
        22
      ],
      [
        0,
        -97
      ],
      [
        13,
        -55
      ],
      [
        0,
        -54
      ],
      [
        -38,
        43
      ],
      [
        -37,
        22
      ],
      [
        -12,
        22
      ],
      [
        0,
        97
      ],
      [
        -13,
        76
      ],
      [
        13,
        152
      ],
      [
        0,
        54
      ],
      [
        -13,
        66
      ],
      [
        -24,
        54
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        11
      ],
      [
        0,
        152
      ],
      [
        -25,
        130
      ],
      [
        -12,
        33
      ],
      [
        0,
        76
      ],
      [
        12,
        -11
      ],
      [
        25,
        -44
      ],
      [
        37,
        -32
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        104797,
        63390
      ],
      [
        -37,
        0
      ],
      [
        -25,
        33
      ],
      [
        -25,
        76
      ],
      [
        25,
        21
      ],
      [
        25,
        -11
      ],
      [
        24,
        -21
      ],
      [
        13,
        -55
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        104884,
        63455
      ],
      [
        -13,
        -22
      ],
      [
        -12,
        11
      ],
      [
        -13,
        55
      ],
      [
        13,
        10
      ],
      [
        25,
        -54
      ]
    ],
    [
      [
        104066,
        63466
      ],
      [
        50,
        -33
      ],
      [
        37,
        33
      ],
      [
        37,
        -11
      ],
      [
        25,
        -43
      ],
      [
        0,
        -22
      ],
      [
        62,
        33
      ],
      [
        24,
        0
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        -37,
        -22
      ],
      [
        -50,
        -65
      ],
      [
        -111,
        -43
      ],
      [
        -74,
        -98
      ],
      [
        -13,
        22
      ],
      [
        13,
        87
      ],
      [
        0,
        43
      ],
      [
        -13,
        33
      ],
      [
        37,
        206
      ],
      [
        0,
        151
      ],
      [
        13,
        196
      ],
      [
        0,
        21
      ],
      [
        -13,
        33
      ],
      [
        -49,
        32
      ],
      [
        0,
        44
      ],
      [
        25,
        32
      ],
      [
        37,
        -32
      ],
      [
        74,
        -54
      ],
      [
        37,
        -44
      ],
      [
        25,
        -54
      ]
    ],
    [
      [
        103224,
        63520
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        21
      ],
      [
        0,
        44
      ],
      [
        -25,
        119
      ],
      [
        25,
        11
      ],
      [
        37,
        -33
      ],
      [
        12,
        -43
      ],
      [
        0,
        -44
      ],
      [
        -12,
        -54
      ]
    ],
    [
      [
        103248,
        63813
      ],
      [
        13,
        -11
      ],
      [
        12,
        11
      ],
      [
        13,
        33
      ],
      [
        12,
        -44
      ],
      [
        25,
        -43
      ],
      [
        0,
        -44
      ],
      [
        -25,
        0
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        10
      ],
      [
        -37,
        109
      ],
      [
        -12,
        11
      ],
      [
        0,
        32
      ],
      [
        12,
        11
      ],
      [
        0,
        33
      ],
      [
        13,
        0
      ],
      [
        12,
        -33
      ],
      [
        37,
        -43
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        104128,
        63900
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        108
      ],
      [
        25,
        22
      ],
      [
        37,
        0
      ],
      [
        25,
        -43
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -43
      ]
    ],
    [
      [
        105020,
        64041
      ],
      [
        12,
        -54
      ],
      [
        13,
        -33
      ],
      [
        0,
        -43
      ],
      [
        12,
        -22
      ],
      [
        12,
        0
      ],
      [
        25,
        -22
      ],
      [
        25,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -119
      ],
      [
        13,
        -33
      ],
      [
        0,
        -108
      ],
      [
        37,
        -141
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -22
      ],
      [
        13,
        -11
      ],
      [
        25,
        -43
      ],
      [
        24,
        -54
      ],
      [
        -12,
        -11
      ],
      [
        -12,
        43
      ],
      [
        -25,
        0
      ],
      [
        -62,
        -10
      ],
      [
        -37,
        21
      ],
      [
        -38,
        0
      ],
      [
        -24,
        76
      ],
      [
        -25,
        11
      ],
      [
        -12,
        43
      ],
      [
        -38,
        76
      ],
      [
        0,
        54
      ],
      [
        13,
        55
      ],
      [
        12,
        32
      ],
      [
        0,
        44
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        65
      ],
      [
        -49,
        108
      ],
      [
        -50,
        33
      ],
      [
        -37,
        43
      ],
      [
        -12,
        65
      ],
      [
        -25,
        98
      ],
      [
        -13,
        98
      ],
      [
        99,
        -22
      ],
      [
        87,
        0
      ],
      [
        112,
        22
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        104487,
        63889
      ],
      [
        75,
        -76
      ],
      [
        37,
        -119
      ],
      [
        12,
        -98
      ],
      [
        -12,
        -43
      ],
      [
        -13,
        43
      ],
      [
        -49,
        54
      ],
      [
        -50,
        33
      ],
      [
        13,
        32
      ],
      [
        -25,
        22
      ],
      [
        0,
        11
      ],
      [
        -25,
        22
      ],
      [
        -25,
        65
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -11
      ],
      [
        -87,
        -174
      ],
      [
        0,
        33
      ],
      [
        13,
        87
      ],
      [
        12,
        130
      ],
      [
        13,
        43
      ],
      [
        -13,
        65
      ],
      [
        0,
        54
      ],
      [
        37,
        -21
      ],
      [
        75,
        -65
      ],
      [
        0,
        -22
      ],
      [
        49,
        -76
      ]
    ],
    [
      [
        104004,
        64041
      ],
      [
        -12,
        -22
      ],
      [
        -13,
        44
      ],
      [
        13,
        21
      ],
      [
        12,
        -11
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        103930,
        63932
      ],
      [
        -25,
        -151
      ],
      [
        -25,
        54
      ],
      [
        13,
        32
      ],
      [
        -25,
        55
      ],
      [
        25,
        65
      ],
      [
        12,
        97
      ],
      [
        25,
        33
      ],
      [
        12,
        -22
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -109
      ]
    ],
    [
      [
        104512,
        63997
      ],
      [
        0,
        -54
      ],
      [
        -12,
        11
      ],
      [
        -38,
        109
      ],
      [
        -12,
        43
      ],
      [
        12,
        22
      ],
      [
        25,
        -33
      ],
      [
        25,
        -98
      ]
    ],
    [
      [
        104339,
        64247
      ],
      [
        0,
        -33
      ],
      [
        -38,
        44
      ],
      [
        -37,
        76
      ],
      [
        -37,
        32
      ],
      [
        0,
        33
      ],
      [
        37,
        11
      ],
      [
        50,
        -131
      ],
      [
        25,
        -32
      ]
    ],
    [
      [
        103459,
        64637
      ],
      [
        12,
        -11
      ],
      [
        50,
        22
      ],
      [
        25,
        -11
      ],
      [
        12,
        -32
      ],
      [
        25,
        -11
      ],
      [
        12,
        -22
      ],
      [
        25,
        33
      ],
      [
        37,
        -33
      ],
      [
        25,
        -76
      ],
      [
        25,
        -43
      ],
      [
        25,
        -33
      ],
      [
        12,
        -32
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -108
      ],
      [
        25,
        -130
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -12,
        11
      ],
      [
        -50,
        -65
      ],
      [
        -37,
        21
      ],
      [
        0,
        33
      ],
      [
        -24,
        32
      ],
      [
        -25,
        55
      ],
      [
        -13,
        43
      ],
      [
        0,
        43
      ],
      [
        -24,
        76
      ],
      [
        -25,
        33
      ],
      [
        0,
        21
      ],
      [
        -13,
        33
      ],
      [
        0,
        76
      ],
      [
        -24,
        108
      ],
      [
        -13,
        22
      ],
      [
        -24,
        22
      ],
      [
        -25,
        32
      ],
      [
        -13,
        33
      ],
      [
        0,
        54
      ],
      [
        -24,
        0
      ],
      [
        -25,
        11
      ],
      [
        25,
        65
      ],
      [
        24,
        0
      ],
      [
        62,
        -11
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        103868,
        64670
      ],
      [
        25,
        0
      ],
      [
        49,
        -44
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -21
      ],
      [
        -50,
        43
      ],
      [
        -12,
        33
      ],
      [
        -12,
        65
      ],
      [
        24,
        87
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        103310,
        64800
      ],
      [
        0,
        -43
      ],
      [
        -62,
        65
      ],
      [
        0,
        43
      ],
      [
        38,
        -22
      ],
      [
        24,
        -43
      ]
    ],
    [
      [
        104710,
        64724
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        10
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        43
      ],
      [
        -12,
        33
      ],
      [
        37,
        87
      ],
      [
        0,
        141
      ],
      [
        25,
        32
      ],
      [
        37,
        -76
      ],
      [
        0,
        -11
      ],
      [
        37,
        -43
      ],
      [
        -12,
        -76
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        103955,
        64984
      ],
      [
        0,
        -21
      ],
      [
        -75,
        97
      ],
      [
        0,
        44
      ],
      [
        75,
        -120
      ]
    ],
    [
      [
        103905,
        65592
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -87
      ],
      [
        -12,
        -54
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        11
      ],
      [
        0,
        32
      ],
      [
        12,
        11
      ],
      [
        -12,
        44
      ],
      [
        -13,
        21
      ],
      [
        0,
        54
      ],
      [
        -12,
        22
      ],
      [
        0,
        44
      ],
      [
        50,
        10
      ],
      [
        12,
        -21
      ]
    ],
    [
      [
        103595,
        67847
      ],
      [
        50,
        -32
      ],
      [
        111,
        -119
      ],
      [
        87,
        -55
      ],
      [
        37,
        -10
      ],
      [
        37,
        32
      ],
      [
        13,
        22
      ],
      [
        25,
        76
      ],
      [
        24,
        11
      ],
      [
        25,
        -66
      ],
      [
        0,
        -97
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        -55
      ],
      [
        -12,
        -195
      ],
      [
        0,
        -108
      ],
      [
        24,
        -87
      ],
      [
        13,
        -33
      ],
      [
        37,
        -32
      ],
      [
        0,
        -65
      ],
      [
        12,
        -33
      ],
      [
        37,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -108
      ],
      [
        -62,
        -239
      ],
      [
        -37,
        -152
      ],
      [
        -49,
        -22
      ],
      [
        -99,
        -86
      ],
      [
        -38,
        -55
      ],
      [
        -12,
        -65
      ],
      [
        25,
        -65
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        -37,
        -65
      ],
      [
        -12,
        -65
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -65
      ],
      [
        13,
        -32
      ],
      [
        37,
        -141
      ],
      [
        37,
        -130
      ],
      [
        13,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -32
      ],
      [
        0,
        -65
      ],
      [
        12,
        -66
      ],
      [
        37,
        -151
      ],
      [
        0,
        -44
      ],
      [
        25,
        -65
      ],
      [
        25,
        -21
      ],
      [
        62,
        -44
      ],
      [
        37,
        -11
      ],
      [
        12,
        22
      ],
      [
        25,
        11
      ],
      [
        -12,
        32
      ],
      [
        -25,
        44
      ],
      [
        0,
        21
      ],
      [
        62,
        76
      ],
      [
        37,
        33
      ],
      [
        50,
        0
      ],
      [
        49,
        -22
      ],
      [
        25,
        -22
      ],
      [
        25,
        -32
      ],
      [
        37,
        -76
      ],
      [
        12,
        -76
      ],
      [
        0,
        -97
      ],
      [
        13,
        -33
      ],
      [
        49,
        0
      ],
      [
        25,
        54
      ],
      [
        0,
        65
      ],
      [
        -12,
        22
      ],
      [
        0,
        33
      ],
      [
        12,
        21
      ],
      [
        25,
        -21
      ],
      [
        12,
        -33
      ],
      [
        74,
        -43
      ],
      [
        13,
        0
      ],
      [
        49,
        -44
      ],
      [
        13,
        -21
      ],
      [
        -13,
        -44
      ],
      [
        -74,
        -11
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -76
      ],
      [
        37,
        -54
      ],
      [
        25,
        -54
      ],
      [
        12,
        -44
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -54
      ],
      [
        37,
        11
      ],
      [
        25,
        -11
      ],
      [
        37,
        -44
      ],
      [
        25,
        0
      ],
      [
        0,
        -152
      ],
      [
        -25,
        -140
      ],
      [
        -37,
        21
      ],
      [
        -25,
        54
      ],
      [
        0,
        76
      ],
      [
        25,
        65
      ],
      [
        -12,
        22
      ],
      [
        -62,
        -32
      ],
      [
        -38,
        10
      ],
      [
        -74,
        76
      ],
      [
        -37,
        11
      ],
      [
        -12,
        33
      ],
      [
        12,
        65
      ],
      [
        -37,
        87
      ],
      [
        0,
        32
      ],
      [
        -13,
        33
      ],
      [
        -99,
        86
      ],
      [
        0,
        22
      ],
      [
        -37,
        76
      ],
      [
        -62,
        98
      ],
      [
        -37,
        21
      ],
      [
        0,
        -76
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        37,
        -97
      ],
      [
        0,
        -22
      ],
      [
        25,
        -76
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        43
      ],
      [
        0,
        33
      ],
      [
        -37,
        108
      ],
      [
        -12,
        22
      ],
      [
        -62,
        76
      ],
      [
        -37,
        87
      ],
      [
        -124,
        108
      ],
      [
        -74,
        -65
      ],
      [
        -25,
        -32
      ],
      [
        0,
        -55
      ],
      [
        -37,
        -43
      ],
      [
        -50,
        0
      ],
      [
        -37,
        22
      ],
      [
        -25,
        54
      ],
      [
        -25,
        0
      ],
      [
        -37,
        76
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        119
      ],
      [
        0,
        130
      ],
      [
        25,
        54
      ],
      [
        86,
        130
      ],
      [
        0,
        98
      ],
      [
        -12,
        43
      ],
      [
        -62,
        33
      ],
      [
        -49,
        65
      ],
      [
        -13,
        -65
      ],
      [
        13,
        -109
      ],
      [
        0,
        -76
      ],
      [
        -13,
        -21
      ],
      [
        -37,
        11
      ],
      [
        -12,
        21
      ],
      [
        -13,
        76
      ],
      [
        -25,
        44
      ],
      [
        -12,
        65
      ],
      [
        -12,
        11
      ],
      [
        -25,
        0
      ],
      [
        -25,
        32
      ],
      [
        -12,
        76
      ],
      [
        0,
        87
      ],
      [
        -25,
        141
      ],
      [
        -12,
        54
      ],
      [
        -13,
        260
      ],
      [
        0,
        22
      ],
      [
        -12,
        11
      ],
      [
        -37,
        97
      ],
      [
        12,
        131
      ],
      [
        0,
        21
      ],
      [
        12,
        22
      ],
      [
        38,
        -54
      ],
      [
        37,
        -33
      ],
      [
        24,
        -76
      ],
      [
        13,
        -11
      ],
      [
        49,
        0
      ],
      [
        25,
        33
      ],
      [
        13,
        32
      ],
      [
        0,
        44
      ],
      [
        -25,
        108
      ],
      [
        -13,
        76
      ],
      [
        0,
        76
      ],
      [
        13,
        76
      ],
      [
        25,
        119
      ],
      [
        12,
        87
      ],
      [
        -12,
        109
      ],
      [
        12,
        65
      ],
      [
        0,
        43
      ],
      [
        -25,
        54
      ],
      [
        0,
        65
      ],
      [
        50,
        326
      ],
      [
        25,
        130
      ],
      [
        12,
        87
      ],
      [
        74,
        65
      ],
      [
        37,
        -11
      ],
      [
        62,
        21
      ]
    ],
    [
      [
        103868,
        68021
      ],
      [
        -13,
        -54
      ],
      [
        -12,
        21
      ],
      [
        12,
        44
      ],
      [
        0,
        43
      ],
      [
        25,
        11
      ],
      [
        13,
        -32
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        103645,
        68129
      ],
      [
        0,
        -32
      ],
      [
        -25,
        22
      ],
      [
        0,
        54
      ],
      [
        12,
        22
      ],
      [
        13,
        -22
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        103732,
        68314
      ],
      [
        12,
        -65
      ],
      [
        -25,
        0
      ],
      [
        -37,
        43
      ],
      [
        0,
        33
      ],
      [
        12,
        11
      ],
      [
        38,
        -22
      ]
    ],
    [
      [
        103880,
        68932
      ],
      [
        -12,
        0
      ],
      [
        12,
        54
      ],
      [
        13,
        22
      ],
      [
        12,
        -11
      ],
      [
        -25,
        -65
      ]
    ],
    [
      [
        103855,
        69192
      ],
      [
        -12,
        -43
      ],
      [
        -12,
        0
      ],
      [
        12,
        87
      ],
      [
        12,
        0
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        108228,
        60820
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        54
      ],
      [
        0,
        54
      ],
      [
        13,
        44
      ],
      [
        25,
        11
      ],
      [
        0,
        -76
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        114744,
        49042
      ],
      [
        62,
        -33
      ],
      [
        25,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        -50,
        -11
      ],
      [
        -12,
        22
      ],
      [
        -50,
        22
      ],
      [
        -12,
        43
      ],
      [
        0,
        22
      ],
      [
        -37,
        32
      ],
      [
        -13,
        33
      ],
      [
        0,
        22
      ],
      [
        38,
        -22
      ],
      [
        74,
        -76
      ]
    ],
    [
      [
        115004,
        49118
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -13,
        22
      ],
      [
        0,
        22
      ],
      [
        38,
        -11
      ],
      [
        -13,
        32
      ],
      [
        50,
        -21
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        113840,
        49617
      ],
      [
        0,
        -55
      ],
      [
        -38,
        33
      ],
      [
        0,
        22
      ],
      [
        25,
        11
      ],
      [
        13,
        -11
      ]
    ],
    [
      [
        113902,
        49953
      ],
      [
        12,
        0
      ],
      [
        25,
        43
      ],
      [
        25,
        22
      ],
      [
        12,
        -22
      ],
      [
        -25,
        -152
      ],
      [
        -12,
        22
      ],
      [
        -75,
        44
      ],
      [
        0,
        54
      ],
      [
        -24,
        21
      ],
      [
        -13,
        55
      ],
      [
        -25,
        65
      ],
      [
        0,
        43
      ],
      [
        13,
        -11
      ],
      [
        12,
        -43
      ],
      [
        62,
        -87
      ],
      [
        0,
        -32
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        113716,
        50376
      ],
      [
        49,
        -54
      ],
      [
        25,
        21
      ],
      [
        12,
        -10
      ],
      [
        38,
        -66
      ],
      [
        0,
        -97
      ],
      [
        -13,
        11
      ],
      [
        -62,
        0
      ],
      [
        -37,
        21
      ],
      [
        -49,
        0
      ],
      [
        24,
        44
      ],
      [
        0,
        11
      ],
      [
        -24,
        65
      ],
      [
        0,
        43
      ],
      [
        37,
        11
      ]
    ],
    [
      [
        113654,
        50278
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        11
      ],
      [
        -62,
        87
      ],
      [
        13,
        65
      ],
      [
        24,
        33
      ],
      [
        37,
        -33
      ],
      [
        13,
        -54
      ],
      [
        0,
        -98
      ]
    ],
    [
      [
        114434,
        50614
      ],
      [
        25,
        -10
      ],
      [
        37,
        10
      ],
      [
        13,
        -43
      ],
      [
        24,
        -11
      ],
      [
        25,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        32
      ],
      [
        -13,
        0
      ],
      [
        -24,
        76
      ],
      [
        -50,
        22
      ],
      [
        25,
        32
      ],
      [
        12,
        0
      ]
    ],
    [
      [
        111325,
        50821
      ],
      [
        -37,
        10
      ],
      [
        -50,
        65
      ],
      [
        37,
        0
      ],
      [
        50,
        -75
      ]
    ],
    [
      [
        113914,
        50755
      ],
      [
        -25,
        11
      ],
      [
        13,
        55
      ],
      [
        0,
        43
      ],
      [
        -25,
        22
      ],
      [
        12,
        54
      ],
      [
        25,
        11
      ],
      [
        0,
        -65
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -109
      ]
    ],
    [
      [
        111325,
        50918
      ],
      [
        -12,
        0
      ],
      [
        -62,
        33
      ],
      [
        -13,
        32
      ],
      [
        62,
        0
      ],
      [
        25,
        -11
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        112849,
        52577
      ],
      [
        -13,
        22
      ],
      [
        -37,
        22
      ],
      [
        -25,
        76
      ],
      [
        0,
        87
      ],
      [
        13,
        0
      ],
      [
        74,
        -76
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -76
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        115586,
        52035
      ],
      [
        -12,
        -54
      ],
      [
        -13,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -24,
        -43
      ],
      [
        -38,
        0
      ],
      [
        -62,
        54
      ],
      [
        -24,
        33
      ],
      [
        -37,
        65
      ],
      [
        -13,
        54
      ],
      [
        13,
        76
      ],
      [
        -13,
        65
      ],
      [
        -62,
        43
      ],
      [
        -12,
        22
      ],
      [
        -25,
        65
      ],
      [
        -50,
        76
      ],
      [
        -12,
        32
      ],
      [
        -12,
        65
      ],
      [
        0,
        44
      ],
      [
        12,
        130
      ],
      [
        0,
        65
      ],
      [
        25,
        -32
      ],
      [
        25,
        -22
      ],
      [
        37,
        -11
      ],
      [
        37,
        -43
      ],
      [
        25,
        -98
      ],
      [
        12,
        -33
      ],
      [
        0,
        -32
      ],
      [
        37,
        -33
      ],
      [
        50,
        -141
      ],
      [
        37,
        -32
      ],
      [
        25,
        -11
      ],
      [
        37,
        -43
      ],
      [
        49,
        -109
      ],
      [
        25,
        -141
      ]
    ],
    [
      [
        112564,
        52816
      ],
      [
        -25,
        0
      ],
      [
        -25,
        65
      ],
      [
        -12,
        22
      ],
      [
        0,
        22
      ],
      [
        49,
        43
      ],
      [
        25,
        -33
      ],
      [
        0,
        -86
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        115128,
        52816
      ],
      [
        -25,
        141
      ],
      [
        0,
        43
      ],
      [
        -12,
        22
      ],
      [
        37,
        65
      ],
      [
        12,
        -32
      ],
      [
        0,
        -55
      ],
      [
        25,
        -43
      ],
      [
        -12,
        -108
      ],
      [
        -25,
        -33
      ]
    ],
    [
      [
        112167,
        53261
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        22
      ],
      [
        0,
        76
      ],
      [
        37,
        43
      ],
      [
        12,
        -22
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -54
      ]
    ],
    [
      [
        114186,
        53532
      ],
      [
        25,
        -11
      ],
      [
        50,
        65
      ],
      [
        25,
        -54
      ],
      [
        37,
        -22
      ],
      [
        37,
        -11
      ],
      [
        -12,
        -86
      ],
      [
        0,
        -44
      ],
      [
        12,
        -43
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -55
      ],
      [
        -38,
        -86
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        -11
      ],
      [
        -13,
        -43
      ],
      [
        13,
        -44
      ],
      [
        49,
        -130
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        11
      ],
      [
        -62,
        -11
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -32
      ],
      [
        -74,
        -109
      ],
      [
        -37,
        -43
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        -21
      ],
      [
        -37,
        -55
      ],
      [
        -37,
        -21
      ],
      [
        -62,
        -55
      ],
      [
        -75,
        -10
      ],
      [
        -124,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -24,
        21
      ],
      [
        -37,
        87
      ],
      [
        -38,
        22
      ],
      [
        -37,
        0
      ],
      [
        -49,
        -33
      ],
      [
        -13,
        11
      ],
      [
        -99,
        130
      ],
      [
        -25,
        22
      ],
      [
        -111,
        65
      ],
      [
        -25,
        65
      ],
      [
        0,
        76
      ],
      [
        37,
        43
      ],
      [
        37,
        -21
      ],
      [
        25,
        0
      ],
      [
        13,
        11
      ],
      [
        24,
        0
      ],
      [
        13,
        -11
      ],
      [
        74,
        11
      ],
      [
        50,
        -22
      ],
      [
        37,
        -33
      ],
      [
        87,
        0
      ],
      [
        49,
        44
      ],
      [
        12,
        -11
      ],
      [
        62,
        0
      ],
      [
        38,
        54
      ],
      [
        24,
        184
      ],
      [
        13,
        65
      ],
      [
        12,
        22
      ],
      [
        13,
        -11
      ],
      [
        12,
        -32
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -87
      ],
      [
        12,
        -65
      ],
      [
        25,
        -65
      ],
      [
        49,
        -11
      ],
      [
        25,
        43
      ],
      [
        50,
        11
      ],
      [
        37,
        -43
      ],
      [
        37,
        11
      ],
      [
        12,
        21
      ],
      [
        62,
        33
      ],
      [
        25,
        65
      ],
      [
        13,
        76
      ],
      [
        24,
        54
      ],
      [
        62,
        98
      ],
      [
        25,
        11
      ],
      [
        62,
        0
      ],
      [
        37,
        32
      ],
      [
        0,
        76
      ],
      [
        -12,
        76
      ],
      [
        -37,
        184
      ],
      [
        0,
        33
      ],
      [
        12,
        32
      ],
      [
        0,
        22
      ],
      [
        50,
        0
      ],
      [
        37,
        -11
      ],
      [
        24,
        -43
      ]
    ],
    [
      [
        114793,
        53651
      ],
      [
        -24,
        0
      ],
      [
        12,
        33
      ],
      [
        12,
        11
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        114447,
        54258
      ],
      [
        0,
        -54
      ],
      [
        -25,
        33
      ],
      [
        -13,
        43
      ],
      [
        13,
        22
      ],
      [
        25,
        11
      ],
      [
        0,
        -55
      ]
    ],
    [
      [
        114261,
        54378
      ],
      [
        -13,
        -33
      ],
      [
        -12,
        0
      ],
      [
        -25,
        54
      ],
      [
        0,
        33
      ],
      [
        50,
        -54
      ]
    ],
    [
      [
        114211,
        54443
      ],
      [
        -12,
        0
      ],
      [
        0,
        76
      ],
      [
        25,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -11
      ]
    ],
    [
      [
        110433,
        50517
      ],
      [
        0,
        390
      ],
      [
        0,
        250
      ],
      [
        0,
        260
      ],
      [
        0,
        488
      ],
      [
        -25,
        33
      ],
      [
        -24,
        65
      ],
      [
        12,
        76
      ],
      [
        25,
        108
      ],
      [
        12,
        65
      ],
      [
        0,
        434
      ],
      [
        0,
        379
      ],
      [
        0,
        250
      ],
      [
        0,
        260
      ],
      [
        0,
        250
      ],
      [
        0,
        260
      ],
      [
        0,
        380
      ]
    ],
    [
      [
        110433,
        54465
      ],
      [
        0,
        119
      ]
    ],
    [
      [
        110433,
        54584
      ],
      [
        37,
        0
      ],
      [
        25,
        -11
      ],
      [
        173,
        -141
      ],
      [
        75,
        -65
      ],
      [
        37,
        0
      ],
      [
        74,
        -76
      ],
      [
        112,
        -76
      ],
      [
        124,
        -76
      ],
      [
        74,
        -22
      ],
      [
        87,
        -21
      ],
      [
        49,
        -22
      ],
      [
        62,
        -98
      ],
      [
        37,
        -21
      ],
      [
        25,
        -54
      ],
      [
        62,
        -66
      ],
      [
        25,
        0
      ],
      [
        37,
        -10
      ],
      [
        50,
        10
      ],
      [
        37,
        -10
      ],
      [
        12,
        -22
      ],
      [
        37,
        -87
      ],
      [
        37,
        -21
      ],
      [
        38,
        -44
      ],
      [
        37,
        -54
      ],
      [
        25,
        -54
      ],
      [
        24,
        -44
      ],
      [
        37,
        -21
      ],
      [
        50,
        0
      ],
      [
        149,
        -282
      ],
      [
        0,
        -217
      ],
      [
        -13,
        -141
      ],
      [
        37,
        -44
      ],
      [
        50,
        -10
      ],
      [
        74,
        -33
      ],
      [
        62,
        -43
      ],
      [
        223,
        -196
      ],
      [
        25,
        -10
      ],
      [
        50,
        -11
      ],
      [
        37,
        11
      ],
      [
        24,
        -11
      ],
      [
        25,
        -44
      ],
      [
        25,
        -21
      ],
      [
        25,
        -55
      ],
      [
        25,
        -65
      ],
      [
        24,
        -32
      ],
      [
        13,
        -44
      ],
      [
        12,
        -108
      ],
      [
        -12,
        -65
      ],
      [
        -13,
        -33
      ],
      [
        -24,
        -10
      ],
      [
        -124,
        -11
      ],
      [
        -87,
        11
      ],
      [
        -50,
        -66
      ],
      [
        0,
        -65
      ],
      [
        50,
        -151
      ],
      [
        25,
        -131
      ],
      [
        25,
        -54
      ],
      [
        74,
        -87
      ],
      [
        25,
        -65
      ],
      [
        62,
        -97
      ],
      [
        37,
        -44
      ],
      [
        37,
        -21
      ],
      [
        62,
        -76
      ],
      [
        12,
        -44
      ],
      [
        13,
        -108
      ],
      [
        12,
        -76
      ],
      [
        0,
        -33
      ],
      [
        62,
        -97
      ],
      [
        12,
        -11
      ],
      [
        25,
        -163
      ],
      [
        25,
        -65
      ],
      [
        37,
        -21
      ],
      [
        37,
        0
      ],
      [
        99,
        43
      ],
      [
        37,
        -11
      ],
      [
        13,
        -22
      ],
      [
        12,
        -76
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -75
      ],
      [
        25,
        -55
      ],
      [
        50,
        -43
      ],
      [
        25,
        -11
      ],
      [
        86,
        -11
      ],
      [
        50,
        -11
      ],
      [
        37,
        -21
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -10
      ],
      [
        -25,
        0
      ],
      [
        -24,
        -33
      ],
      [
        0,
        -32
      ],
      [
        12,
        -44
      ],
      [
        37,
        -65
      ],
      [
        13,
        -11
      ],
      [
        49,
        -21
      ],
      [
        37,
        -22
      ],
      [
        50,
        -44
      ],
      [
        62,
        -10
      ],
      [
        49,
        -22
      ],
      [
        -12,
        -54
      ],
      [
        -62,
        21
      ],
      [
        -12,
        -21
      ],
      [
        24,
        -55
      ],
      [
        38,
        -43
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -21
      ],
      [
        -38,
        -44
      ],
      [
        -24,
        -11
      ],
      [
        -38,
        0
      ],
      [
        -61,
        22
      ],
      [
        -38,
        22
      ],
      [
        -24,
        65
      ],
      [
        -38,
        43
      ],
      [
        -37,
        33
      ],
      [
        -25,
        11
      ],
      [
        -37,
        0
      ],
      [
        -74,
        32
      ],
      [
        -136,
        22
      ],
      [
        -37,
        11
      ],
      [
        -38,
        43
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        -11
      ],
      [
        -24,
        11
      ],
      [
        -38,
        33
      ],
      [
        -37,
        11
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -50,
        22
      ],
      [
        -49,
        10
      ],
      [
        -25,
        44
      ],
      [
        -25,
        32
      ],
      [
        -24,
        22
      ],
      [
        -13,
        76
      ],
      [
        -37,
        76
      ],
      [
        -37,
        65
      ],
      [
        -74,
        87
      ],
      [
        -25,
        32
      ],
      [
        -25,
        87
      ],
      [
        0,
        98
      ],
      [
        -25,
        0
      ],
      [
        -62,
        32
      ],
      [
        -12,
        54
      ],
      [
        -37,
        120
      ],
      [
        -25,
        65
      ],
      [
        -62,
        119
      ],
      [
        -12,
        76
      ],
      [
        -37,
        76
      ],
      [
        -25,
        65
      ],
      [
        -13,
        22
      ],
      [
        -74,
        54
      ],
      [
        -25,
        21
      ],
      [
        -62,
        11
      ],
      [
        -37,
        11
      ],
      [
        -62,
        33
      ],
      [
        -25,
        21
      ],
      [
        -37,
        0
      ],
      [
        -62,
        33
      ],
      [
        -12,
        32
      ],
      [
        0,
        66
      ],
      [
        -37,
        -11
      ],
      [
        -87,
        43
      ],
      [
        -25,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -37,
        11
      ],
      [
        0,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -62,
        32
      ],
      [
        -25,
        22
      ],
      [
        -24,
        43
      ],
      [
        -25,
        33
      ],
      [
        -12,
        0
      ],
      [
        74,
        -239
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        11
      ],
      [
        12,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -37,
        22
      ],
      [
        -37,
        0
      ],
      [
        0,
        -22
      ],
      [
        24,
        -108
      ],
      [
        -62,
        -22
      ],
      [
        -49,
        -22
      ],
      [
        -74,
        -21
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        21
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -13,
        43
      ],
      [
        0,
        33
      ],
      [
        -12,
        21
      ],
      [
        -13,
        -21
      ],
      [
        25,
        -76
      ],
      [
        25,
        -33
      ],
      [
        37,
        22
      ],
      [
        74,
        0
      ],
      [
        75,
        -65
      ],
      [
        37,
        -22
      ],
      [
        37,
        -54
      ],
      [
        25,
        -65
      ],
      [
        37,
        -87
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -33
      ],
      [
        -50,
        -43
      ],
      [
        -49,
        -32
      ],
      [
        -149,
        -152
      ],
      [
        -37,
        11
      ],
      [
        -37,
        43
      ],
      [
        -50,
        32
      ],
      [
        -25,
        11
      ],
      [
        -86,
        -21
      ],
      [
        -112,
        0
      ],
      [
        -37,
        10
      ],
      [
        -37,
        22
      ],
      [
        -50,
        -11
      ],
      [
        -25,
        -21
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        65
      ]
    ],
    [
      [
        114558,
        53239
      ],
      [
        -25,
        -43
      ],
      [
        -24,
        43
      ],
      [
        -13,
        43
      ],
      [
        -25,
        33
      ],
      [
        -12,
        87
      ],
      [
        0,
        141
      ],
      [
        -12,
        86
      ],
      [
        -25,
        87
      ],
      [
        -74,
        206
      ],
      [
        -25,
        54
      ],
      [
        -50,
        55
      ],
      [
        -49,
        21
      ],
      [
        -13,
        0
      ],
      [
        -37,
        33
      ],
      [
        -25,
        43
      ],
      [
        -74,
        120
      ],
      [
        -37,
        32
      ],
      [
        -25,
        33
      ],
      [
        -111,
        130
      ],
      [
        -38,
        32
      ],
      [
        -37,
        0
      ],
      [
        -37,
        33
      ],
      [
        25,
        11
      ],
      [
        12,
        43
      ],
      [
        50,
        -32
      ],
      [
        62,
        -55
      ],
      [
        12,
        -54
      ],
      [
        37,
        0
      ],
      [
        50,
        -43
      ],
      [
        74,
        -87
      ],
      [
        37,
        -54
      ],
      [
        87,
        -54
      ],
      [
        50,
        -98
      ],
      [
        49,
        -76
      ],
      [
        13,
        -33
      ],
      [
        222,
        -325
      ],
      [
        38,
        -97
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -55
      ],
      [
        -25,
        -119
      ]
    ],
    [
      [
        113679,
        54551
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -25,
        33
      ],
      [
        -25,
        65
      ],
      [
        -24,
        22
      ],
      [
        49,
        43
      ],
      [
        50,
        11
      ],
      [
        62,
        -54
      ],
      [
        12,
        -22
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        112799,
        54790
      ],
      [
        -12,
        -33
      ],
      [
        -13,
        11
      ],
      [
        0,
        33
      ],
      [
        13,
        11
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        112527,
        54985
      ],
      [
        111,
        -32
      ],
      [
        12,
        0
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        11
      ],
      [
        -24,
        -22
      ],
      [
        -50,
        0
      ],
      [
        -62,
        33
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        0
      ],
      [
        0,
        54
      ],
      [
        25,
        11
      ],
      [
        0,
        55
      ],
      [
        12,
        32
      ],
      [
        37,
        -11
      ],
      [
        37,
        22
      ],
      [
        75,
        -11
      ]
    ],
    [
      [
        113456,
        55245
      ],
      [
        0,
        -21
      ],
      [
        -38,
        11
      ],
      [
        -37,
        65
      ],
      [
        0,
        32
      ],
      [
        13,
        33
      ],
      [
        12,
        0
      ],
      [
        37,
        -44
      ],
      [
        13,
        -76
      ]
    ],
    [
      [
        70050,
        88399
      ],
      [
        25,
        -76
      ],
      [
        -12,
        -54
      ],
      [
        25,
        -33
      ],
      [
        49,
        -86
      ],
      [
        37,
        -120
      ],
      [
        50,
        -54
      ],
      [
        -50,
        -43
      ],
      [
        25,
        -33
      ],
      [
        12,
        -65
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        -65
      ],
      [
        -86,
        -22
      ],
      [
        -75,
        -97
      ],
      [
        -37,
        -33
      ],
      [
        -49,
        -65
      ],
      [
        -75,
        -108
      ],
      [
        -37,
        -44
      ],
      [
        -12,
        -32
      ],
      [
        -87,
        -141
      ],
      [
        0,
        -44
      ],
      [
        25,
        -76
      ],
      [
        0,
        -119
      ],
      [
        12,
        -22
      ],
      [
        37,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        -99,
        33
      ]
    ],
    [
      [
        69679,
        86870
      ],
      [
        -25,
        0
      ],
      [
        -87,
        43
      ],
      [
        -62,
        44
      ],
      [
        -24,
        54
      ],
      [
        -25,
        22
      ],
      [
        -87,
        43
      ],
      [
        -99,
        11
      ],
      [
        -99,
        0
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        32
      ],
      [
        -37,
        11
      ],
      [
        -86,
        0
      ],
      [
        -75,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -54
      ],
      [
        -49,
        22
      ],
      [
        -13,
        -11
      ],
      [
        -37,
        0
      ],
      [
        12,
        43
      ],
      [
        0,
        33
      ],
      [
        -24,
        43
      ],
      [
        -25,
        0
      ],
      [
        -25,
        33
      ],
      [
        -12,
        43
      ],
      [
        -38,
        54
      ],
      [
        -61,
        -54
      ],
      [
        -38,
        -65
      ],
      [
        -62,
        -11
      ],
      [
        0,
        33
      ],
      [
        -12,
        32
      ],
      [
        -37,
        11
      ]
    ],
    [
      [
        66830,
        89776
      ],
      [
        74,
        -32
      ],
      [
        37,
        43
      ],
      [
        -12,
        44
      ],
      [
        -112,
        32
      ]
    ],
    [
      [
        66817,
        89917
      ],
      [
        62,
        -21
      ],
      [
        112,
        65
      ],
      [
        198,
        76
      ],
      [
        211,
        65
      ],
      [
        99,
        21
      ],
      [
        12,
        33
      ],
      [
        25,
        11
      ],
      [
        25,
        54
      ],
      [
        61,
        76
      ],
      [
        112,
        22
      ],
      [
        37,
        32
      ],
      [
        87,
        54
      ],
      [
        210,
        55
      ],
      [
        75,
        11
      ],
      [
        86,
        0
      ],
      [
        75,
        -44
      ],
      [
        74,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -86,
        54
      ],
      [
        49,
        -152
      ],
      [
        37,
        -54
      ],
      [
        50,
        -32
      ],
      [
        49,
        -11
      ],
      [
        149,
        22
      ],
      [
        74,
        43
      ]
    ],
    [
      [
        68675,
        90232
      ],
      [
        13,
        -11
      ],
      [
        87,
        0
      ],
      [
        99,
        -11
      ],
      [
        322,
        -21
      ],
      [
        359,
        -22
      ],
      [
        198,
        0
      ]
    ],
    [
      [
        38574,
        67500
      ],
      [
        -25,
        11
      ],
      [
        0,
        22
      ],
      [
        25,
        0
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        39417,
        67522
      ],
      [
        -50,
        0
      ],
      [
        0,
        22
      ],
      [
        25,
        21
      ],
      [
        62,
        -21
      ],
      [
        -37,
        -22
      ]
    ],
    [
      [
        39169,
        67739
      ],
      [
        25,
        -11
      ],
      [
        0,
        22
      ],
      [
        61,
        -11
      ],
      [
        50,
        -33
      ],
      [
        37,
        -10
      ],
      [
        0,
        -87
      ],
      [
        -25,
        -33
      ],
      [
        -49,
        -86
      ],
      [
        -37,
        -44
      ],
      [
        -62,
        -21
      ],
      [
        -50,
        0
      ],
      [
        -12,
        10
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        21
      ],
      [
        -99,
        0
      ],
      [
        -13,
        -21
      ],
      [
        -49,
        0
      ],
      [
        -13,
        10
      ],
      [
        -49,
        0
      ],
      [
        -12,
        22
      ],
      [
        0,
        141
      ],
      [
        -25,
        65
      ],
      [
        0,
        22
      ],
      [
        25,
        43
      ],
      [
        12,
        44
      ],
      [
        25,
        10
      ],
      [
        86,
        -21
      ],
      [
        223,
        -11
      ],
      [
        13,
        -11
      ]
    ],
    [
      [
        106828,
        82781
      ],
      [
        13,
        -32
      ],
      [
        37,
        -65
      ],
      [
        0,
        -33
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        106890,
        82640
      ],
      [
        -24,
        -21
      ],
      [
        -13,
        10
      ],
      [
        -49,
        11
      ],
      [
        -75,
        -76
      ],
      [
        -12,
        -54
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -50,
        -119
      ],
      [
        -37,
        -54
      ],
      [
        -24,
        -76
      ],
      [
        0,
        -65
      ],
      [
        24,
        -65
      ],
      [
        0,
        -55
      ],
      [
        -12,
        -108
      ],
      [
        12,
        -119
      ],
      [
        -12,
        -44
      ],
      [
        -136,
        -87
      ],
      [
        -75,
        -141
      ],
      [
        -62,
        -43
      ],
      [
        -24,
        -43
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        -76
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -75,
        0
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -65
      ],
      [
        -111,
        -65
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -87
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -55
      ],
      [
        -25,
        22
      ],
      [
        -24,
        -65
      ],
      [
        0,
        -54
      ],
      [
        74,
        -44
      ],
      [
        37,
        -10
      ],
      [
        25,
        -33
      ],
      [
        62,
        -108
      ],
      [
        62,
        -55
      ],
      [
        37,
        -43
      ],
      [
        50,
        -76
      ]
    ],
    [
      [
        105491,
        79810
      ],
      [
        -87,
        65
      ],
      [
        -62,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        -13,
        -11
      ],
      [
        -25,
        87
      ],
      [
        -37,
        0
      ],
      [
        -62,
        65
      ],
      [
        -24,
        -11
      ],
      [
        0,
        -33
      ],
      [
        -38,
        -65
      ],
      [
        -49,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -12,
        76
      ],
      [
        -75,
        22
      ],
      [
        -24,
        32
      ],
      [
        49,
        65
      ],
      [
        25,
        11
      ],
      [
        -13,
        22
      ],
      [
        -74,
        0
      ],
      [
        -37,
        22
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        11
      ],
      [
        62,
        65
      ],
      [
        12,
        43
      ],
      [
        0,
        33
      ],
      [
        25,
        86
      ],
      [
        37,
        44
      ],
      [
        74,
        65
      ],
      [
        37,
        11
      ],
      [
        38,
        0
      ],
      [
        12,
        11
      ],
      [
        -37,
        32
      ],
      [
        -50,
        0
      ],
      [
        -37,
        33
      ],
      [
        -12,
        43
      ],
      [
        86,
        260
      ],
      [
        -12,
        87
      ],
      [
        0,
        65
      ],
      [
        -87,
        43
      ],
      [
        -86,
        66
      ],
      [
        -25,
        32
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        109
      ],
      [
        -61,
        43
      ],
      [
        -13,
        33
      ],
      [
        13,
        54
      ],
      [
        -13,
        0
      ]
    ],
    [
      [
        56016,
        76741
      ],
      [
        37,
        -33
      ],
      [
        49,
        22
      ],
      [
        50,
        -44
      ],
      [
        25,
        -11
      ],
      [
        -50,
        -65
      ],
      [
        -62,
        11
      ],
      [
        -49,
        33
      ],
      [
        -25,
        54
      ],
      [
        25,
        33
      ]
    ],
    [
      [
        53315,
        79300
      ],
      [
        0,
        -11
      ],
      [
        -49,
        0
      ],
      [
        -13,
        33
      ],
      [
        13,
        21
      ],
      [
        24,
        0
      ],
      [
        25,
        -43
      ]
    ],
    [
      [
        53105,
        79853
      ],
      [
        12,
        -11
      ],
      [
        111,
        11
      ],
      [
        38,
        0
      ],
      [
        -13,
        -54
      ],
      [
        -12,
        -11
      ],
      [
        -75,
        -11
      ],
      [
        -99,
        22
      ],
      [
        -37,
        43
      ],
      [
        0,
        44
      ],
      [
        25,
        10
      ],
      [
        50,
        -43
      ]
    ],
    [
      [
        52237,
        80233
      ],
      [
        -24,
        -44
      ],
      [
        -38,
        22
      ],
      [
        -37,
        0
      ],
      [
        -24,
        33
      ],
      [
        -13,
        32
      ],
      [
        13,
        22
      ],
      [
        37,
        0
      ],
      [
        86,
        -65
      ]
    ],
    [
      [
        52064,
        80276
      ],
      [
        -25,
        0
      ],
      [
        -37,
        54
      ],
      [
        50,
        22
      ],
      [
        24,
        -33
      ],
      [
        -12,
        -43
      ]
    ],
    [
      [
        52609,
        80352
      ],
      [
        -74,
        11
      ],
      [
        -25,
        22
      ],
      [
        -12,
        43
      ],
      [
        49,
        22
      ],
      [
        50,
        0
      ],
      [
        24,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        51209,
        80829
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        21
      ],
      [
        12,
        65
      ],
      [
        12,
        22
      ],
      [
        25,
        -32
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        59373,
        79441
      ],
      [
        -25,
        -11
      ],
      [
        -124,
        -97
      ],
      [
        -37,
        0
      ],
      [
        -62,
        43
      ],
      [
        -124,
        11
      ],
      [
        -37,
        11
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        10
      ],
      [
        25,
        87
      ],
      [
        37,
        163
      ],
      [
        0,
        108
      ],
      [
        13,
        87
      ],
      [
        -13,
        87
      ],
      [
        -24,
        54
      ],
      [
        37,
        141
      ],
      [
        -13,
        65
      ],
      [
        -24,
        98
      ],
      [
        74,
        -22
      ],
      [
        -37,
        65
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -62,
        -43
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        11
      ],
      [
        0,
        54
      ],
      [
        -12,
        76
      ],
      [
        25,
        22
      ],
      [
        24,
        0
      ],
      [
        50,
        65
      ],
      [
        -13,
        65
      ],
      [
        25,
        65
      ],
      [
        -12,
        11
      ],
      [
        -50,
        -120
      ],
      [
        -12,
        -54
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -10
      ],
      [
        -38,
        21
      ],
      [
        0,
        76
      ],
      [
        13,
        65
      ],
      [
        25,
        185
      ],
      [
        0,
        54
      ],
      [
        12,
        32
      ],
      [
        25,
        22
      ],
      [
        37,
        76
      ],
      [
        49,
        173
      ],
      [
        62,
        185
      ],
      [
        -24,
        43
      ],
      [
        12,
        44
      ],
      [
        25,
        216
      ],
      [
        37,
        98
      ],
      [
        0,
        98
      ],
      [
        12,
        76
      ],
      [
        -12,
        32
      ],
      [
        0,
        44
      ],
      [
        -25,
        75
      ],
      [
        -25,
        174
      ],
      [
        0,
        54
      ],
      [
        25,
        33
      ],
      [
        -37,
        0
      ],
      [
        -12,
        43
      ],
      [
        0,
        43
      ],
      [
        37,
        66
      ]
    ],
    [
      [
        73692,
        75775
      ],
      [
        99,
        174
      ]
    ],
    [
      [
        15026,
        44628
      ],
      [
        -25,
        22
      ],
      [
        -25,
        10
      ],
      [
        0,
        22
      ],
      [
        37,
        -32
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        10554,
        45159
      ],
      [
        50,
        -21
      ],
      [
        0,
        -55
      ],
      [
        -13,
        -32
      ],
      [
        -25,
        11
      ],
      [
        -12,
        21
      ],
      [
        -12,
        55
      ],
      [
        -50,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -12,
        76
      ],
      [
        0,
        32
      ],
      [
        12,
        22
      ],
      [
        25,
        21
      ],
      [
        49,
        -21
      ],
      [
        13,
        -44
      ],
      [
        12,
        -65
      ]
    ],
    [
      [
        10381,
        45257
      ],
      [
        -13,
        -22
      ],
      [
        -25,
        33
      ],
      [
        0,
        32
      ],
      [
        38,
        0
      ],
      [
        12,
        -11
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        9836,
        45669
      ],
      [
        -25,
        0
      ],
      [
        -13,
        11
      ],
      [
        13,
        76
      ],
      [
        25,
        -22
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        9811,
        45810
      ],
      [
        -13,
        0
      ],
      [
        0,
        54
      ],
      [
        25,
        -32
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        14221,
        49649
      ],
      [
        -13,
        -11
      ],
      [
        0,
        65
      ],
      [
        25,
        -21
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        14084,
        50007
      ],
      [
        -24,
        -43
      ],
      [
        0,
        54
      ],
      [
        24,
        -11
      ]
    ],
    [
      [
        14097,
        50159
      ],
      [
        49,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -49,
        -11
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        11
      ],
      [
        -13,
        44
      ],
      [
        50,
        43
      ]
    ],
    [
      [
        13725,
        50322
      ],
      [
        -12,
        32
      ],
      [
        25,
        33
      ],
      [
        12,
        -11
      ],
      [
        -25,
        -54
      ]
    ],
    [
      [
        13911,
        50625
      ],
      [
        -25,
        0
      ],
      [
        0,
        44
      ],
      [
        13,
        11
      ],
      [
        24,
        -22
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        13725,
        50647
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        0
      ],
      [
        -13,
        54
      ],
      [
        13,
        33
      ],
      [
        62,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        79564,
        71589
      ],
      [
        -62,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -25,
        21
      ],
      [
        -49,
        120
      ]
    ],
    [
      [
        79403,
        71698
      ],
      [
        12,
        65
      ],
      [
        -25,
        173
      ],
      [
        0,
        174
      ],
      [
        38,
        108
      ],
      [
        12,
        65
      ],
      [
        37,
        163
      ],
      [
        37,
        54
      ],
      [
        50,
        54
      ],
      [
        37,
        -97
      ],
      [
        62,
        -65
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -55
      ],
      [
        -13,
        -108
      ],
      [
        13,
        -43
      ],
      [
        0,
        -33
      ],
      [
        24,
        -152
      ],
      [
        0,
        -119
      ],
      [
        -24,
        -43
      ],
      [
        -38,
        -141
      ],
      [
        0,
        -11
      ],
      [
        -49,
        -22
      ]
    ],
    [
      [
        69741,
        83844
      ],
      [
        -13,
        11
      ],
      [
        -12,
        43
      ],
      [
        -25,
        11
      ],
      [
        -25,
        65
      ],
      [
        0,
        33
      ],
      [
        13,
        32
      ],
      [
        25,
        11
      ],
      [
        37,
        0
      ],
      [
        0,
        33
      ],
      [
        -75,
        54
      ],
      [
        -49,
        -11
      ],
      [
        -50,
        -76
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        44
      ],
      [
        -37,
        32
      ],
      [
        -62,
        11
      ],
      [
        -37,
        22
      ],
      [
        -37,
        43
      ],
      [
        -62,
        22
      ],
      [
        12,
        32
      ],
      [
        50,
        0
      ],
      [
        0,
        33
      ],
      [
        -25,
        11
      ],
      [
        -37,
        32
      ],
      [
        25,
        22
      ],
      [
        0,
        33
      ],
      [
        25,
        21
      ],
      [
        0,
        22
      ],
      [
        -38,
        32
      ],
      [
        -49,
        22
      ],
      [
        -37,
        33
      ],
      [
        -13,
        0
      ],
      [
        -49,
        43
      ],
      [
        -25,
        43
      ],
      [
        -37,
        33
      ],
      [
        0,
        173
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        76
      ],
      [
        -50,
        43
      ],
      [
        -37,
        22
      ],
      [
        -12,
        54
      ],
      [
        -25,
        32
      ]
    ],
    [
      [
        69790,
        86165
      ],
      [
        62,
        33
      ],
      [
        13,
        32
      ],
      [
        37,
        22
      ],
      [
        74,
        -65
      ],
      [
        87,
        11
      ],
      [
        124,
        -44
      ],
      [
        12,
        11
      ],
      [
        50,
        -22
      ],
      [
        24,
        0
      ],
      [
        75,
        22
      ],
      [
        37,
        -11
      ],
      [
        87,
        -108
      ],
      [
        12,
        -22
      ],
      [
        37,
        0
      ],
      [
        25,
        11
      ],
      [
        37,
        54
      ],
      [
        99,
        54
      ],
      [
        87,
        11
      ],
      [
        161,
        44
      ],
      [
        25,
        43
      ],
      [
        24,
        87
      ],
      [
        87,
        21
      ],
      [
        13,
        11
      ]
    ],
    [
      [
        71636,
        84603
      ],
      [
        37,
        -65
      ],
      [
        37,
        -32
      ],
      [
        112,
        -33
      ],
      [
        0,
        44
      ],
      [
        49,
        -11
      ],
      [
        112,
        65
      ],
      [
        62,
        11
      ],
      [
        49,
        -22
      ],
      [
        37,
        -43
      ],
      [
        13,
        -33
      ]
    ],
    [
      [
        72144,
        84484
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        -12,
        -109
      ],
      [
        -25,
        -86
      ],
      [
        -173,
        -55
      ],
      [
        12,
        33
      ],
      [
        -12,
        43
      ],
      [
        0,
        33
      ],
      [
        12,
        32
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -43
      ],
      [
        12,
        -76
      ],
      [
        -24,
        -54
      ],
      [
        0,
        -54
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        -50,
        -87
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -196
      ],
      [
        -25,
        -119
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        112403,
        83540
      ],
      [
        -13,
        -21
      ],
      [
        -24,
        21
      ],
      [
        0,
        44
      ],
      [
        74,
        32
      ],
      [
        25,
        -21
      ],
      [
        0,
        -22
      ],
      [
        -62,
        -33
      ]
    ],
    [
      [
        112229,
        84007
      ],
      [
        50,
        -44
      ],
      [
        74,
        11
      ],
      [
        -25,
        -43
      ],
      [
        -24,
        0
      ],
      [
        -50,
        -54
      ],
      [
        -62,
        -22
      ],
      [
        -62,
        -87
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        -65
      ],
      [
        -62,
        -54
      ],
      [
        -13,
        -120
      ],
      [
        -37,
        44
      ],
      [
        -12,
        54
      ],
      [
        12,
        32
      ],
      [
        74,
        87
      ],
      [
        87,
        163
      ],
      [
        62,
        141
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        113047,
        84527
      ],
      [
        -62,
        -54
      ],
      [
        -50,
        -11
      ],
      [
        -124,
        -141
      ],
      [
        -37,
        -21
      ],
      [
        -49,
        10
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        -87,
        -98
      ],
      [
        -37,
        -76
      ],
      [
        -37,
        -22
      ],
      [
        -74,
        -75
      ],
      [
        12,
        65
      ],
      [
        12,
        32
      ],
      [
        62,
        65
      ],
      [
        0,
        65
      ],
      [
        38,
        55
      ],
      [
        61,
        54
      ],
      [
        38,
        76
      ],
      [
        37,
        21
      ],
      [
        37,
        55
      ],
      [
        49,
        21
      ],
      [
        -12,
        55
      ],
      [
        25,
        43
      ],
      [
        12,
        0
      ],
      [
        25,
        -76
      ],
      [
        99,
        11
      ],
      [
        99,
        130
      ],
      [
        50,
        33
      ],
      [
        25,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        13,
        -33
      ],
      [
        -13,
        -22
      ],
      [
        -74,
        0
      ]
    ],
    [
      [
        78437,
        84625
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        65
      ],
      [
        0,
        33
      ],
      [
        12,
        11
      ],
      [
        13,
        -55
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        113431,
        84723
      ],
      [
        -62,
        -33
      ],
      [
        -25,
        0
      ],
      [
        74,
        163
      ],
      [
        50,
        21
      ],
      [
        50,
        87
      ],
      [
        136,
        119
      ],
      [
        74,
        0
      ],
      [
        -111,
        -119
      ],
      [
        -13,
        -54
      ],
      [
        -49,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -87,
        -119
      ]
    ],
    [
      [
        114224,
        85503
      ],
      [
        -62,
        -65
      ],
      [
        -25,
        0
      ],
      [
        -12,
        44
      ],
      [
        49,
        11
      ],
      [
        62,
        86
      ],
      [
        37,
        65
      ],
      [
        25,
        22
      ],
      [
        25,
        0
      ],
      [
        -99,
        -163
      ]
    ],
    [
      [
        114595,
        86046
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        11
      ],
      [
        25,
        43
      ],
      [
        12,
        -21
      ]
    ],
    [
      [
        114942,
        86696
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        22
      ],
      [
        37,
        32
      ],
      [
        13,
        43
      ],
      [
        37,
        -10
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -33
      ]
    ],
    [
      [
        115190,
        87022
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        22
      ],
      [
        0,
        54
      ],
      [
        74,
        163
      ],
      [
        25,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -55
      ],
      [
        0,
        -97
      ]
    ],
    [
      [
        115574,
        87640
      ],
      [
        -50,
        -65
      ],
      [
        -99,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -12,
        22
      ],
      [
        0,
        65
      ],
      [
        -13,
        54
      ],
      [
        37,
        0
      ],
      [
        37,
        43
      ],
      [
        87,
        22
      ],
      [
        37,
        54
      ],
      [
        37,
        131
      ],
      [
        38,
        43
      ],
      [
        37,
        11
      ],
      [
        0,
        -141
      ],
      [
        -62,
        -152
      ]
    ],
    [
      [
        115735,
        87857
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        43
      ],
      [
        12,
        44
      ],
      [
        50,
        54
      ],
      [
        37,
        0
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -54
      ]
    ],
    [
      [
        115475,
        87965
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        11
      ],
      [
        -12,
        55
      ],
      [
        37,
        10
      ],
      [
        25,
        -10
      ],
      [
        0,
        -55
      ]
    ],
    [
      [
        111040,
        90189
      ],
      [
        74,
        -152
      ],
      [
        0,
        -76
      ],
      [
        -24,
        -87
      ],
      [
        62,
        -249
      ],
      [
        49,
        -120
      ],
      [
        25,
        -97
      ],
      [
        12,
        -109
      ],
      [
        0,
        -217
      ],
      [
        -24,
        -86
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -174
      ],
      [
        13,
        -87
      ],
      [
        25,
        -54
      ],
      [
        12,
        -65
      ],
      [
        0,
        -76
      ],
      [
        37,
        -65
      ],
      [
        25,
        -76
      ],
      [
        0,
        -76
      ],
      [
        25,
        -21
      ],
      [
        62,
        -467
      ],
      [
        24,
        -141
      ],
      [
        87,
        -238
      ],
      [
        37,
        -141
      ],
      [
        37,
        -217
      ],
      [
        25,
        -87
      ],
      [
        37,
        -76
      ],
      [
        50,
        -76
      ],
      [
        37,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        44
      ],
      [
        -37,
        65
      ],
      [
        -50,
        54
      ],
      [
        -49,
        87
      ],
      [
        -50,
        43
      ],
      [
        -86,
        22
      ],
      [
        -174,
        -33
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -120
      ],
      [
        -111,
        -423
      ],
      [
        -25,
        -108
      ],
      [
        -12,
        -119
      ],
      [
        12,
        -87
      ],
      [
        0,
        -33
      ],
      [
        37,
        -97
      ],
      [
        37,
        -76
      ],
      [
        25,
        -11
      ],
      [
        25,
        -43
      ],
      [
        25,
        -66
      ],
      [
        25,
        -140
      ],
      [
        37,
        -98
      ],
      [
        12,
        -22
      ],
      [
        62,
        0
      ],
      [
        25,
        -32
      ],
      [
        25,
        -109
      ],
      [
        12,
        -130
      ],
      [
        -37,
        -119
      ],
      [
        -25,
        32
      ],
      [
        -12,
        76
      ],
      [
        0,
        76
      ],
      [
        -25,
        54
      ],
      [
        -87,
        22
      ],
      [
        -74,
        11
      ],
      [
        -50,
        65
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -55
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -65
      ],
      [
        -25,
        -162
      ],
      [
        -49,
        -109
      ],
      [
        -25,
        33
      ],
      [
        -25,
        76
      ],
      [
        0,
        54
      ],
      [
        -37,
        173
      ],
      [
        12,
        152
      ],
      [
        50,
        206
      ],
      [
        12,
        76
      ],
      [
        0,
        65
      ],
      [
        -12,
        54
      ],
      [
        -12,
        131
      ],
      [
        12,
        97
      ],
      [
        50,
        119
      ],
      [
        12,
        76
      ],
      [
        -12,
        174
      ],
      [
        -38,
        108
      ],
      [
        -49,
        120
      ],
      [
        -13,
        54
      ],
      [
        38,
        141
      ],
      [
        24,
        65
      ],
      [
        13,
        152
      ],
      [
        25,
        152
      ],
      [
        0,
        466
      ],
      [
        -25,
        130
      ],
      [
        0,
        76
      ],
      [
        25,
        152
      ],
      [
        24,
        76
      ],
      [
        0,
        141
      ],
      [
        -37,
        130
      ],
      [
        -37,
        54
      ],
      [
        -37,
        65
      ],
      [
        -62,
        65
      ],
      [
        37,
        33
      ],
      [
        -37,
        43
      ],
      [
        -13,
        54
      ],
      [
        0,
        261
      ],
      [
        50,
        119
      ],
      [
        25,
        304
      ],
      [
        -13,
        65
      ],
      [
        -12,
        130
      ],
      [
        50,
        65
      ],
      [
        62,
        32
      ],
      [
        61,
        -65
      ],
      [
        75,
        33
      ],
      [
        12,
        54
      ],
      [
        -25,
        33
      ],
      [
        13,
        43
      ],
      [
        49,
        11
      ],
      [
        -12,
        32
      ],
      [
        25,
        109
      ],
      [
        -13,
        43
      ],
      [
        -74,
        109
      ],
      [
        -50,
        86
      ],
      [
        75,
        0
      ],
      [
        25,
        11
      ],
      [
        49,
        55
      ]
    ],
    [
      [
        119736,
        90297
      ],
      [
        12,
        -33
      ],
      [
        -198,
        174
      ],
      [
        -12,
        43
      ],
      [
        25,
        0
      ],
      [
        24,
        -32
      ],
      [
        38,
        -22
      ],
      [
        61,
        -54
      ],
      [
        50,
        -76
      ]
    ],
    [
      [
        109120,
        90633
      ],
      [
        -37,
        -108
      ],
      [
        -37,
        0
      ],
      [
        -25,
        21
      ],
      [
        -37,
        -10
      ],
      [
        -25,
        10
      ],
      [
        25,
        33
      ],
      [
        74,
        54
      ],
      [
        25,
        -11
      ],
      [
        37,
        11
      ]
    ],
    [
      [
        109380,
        90633
      ],
      [
        37,
        -32
      ],
      [
        50,
        11
      ],
      [
        12,
        -22
      ],
      [
        -37,
        -22
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        -38,
        -22
      ],
      [
        -62,
        -65
      ],
      [
        -49,
        109
      ],
      [
        -25,
        32
      ],
      [
        -62,
        -54
      ],
      [
        -12,
        0
      ],
      [
        12,
        65
      ],
      [
        50,
        76
      ],
      [
        49,
        119
      ],
      [
        112,
        -54
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        68675,
        90232
      ],
      [
        50,
        54
      ],
      [
        37,
        54
      ],
      [
        25,
        76
      ],
      [
        0,
        44
      ],
      [
        12,
        65
      ],
      [
        37,
        21
      ],
      [
        112,
        -10
      ],
      [
        37,
        32
      ],
      [
        112,
        152
      ],
      [
        12,
        33
      ]
    ],
    [
      [
        69134,
        90742
      ],
      [
        -124,
        -185
      ],
      [
        62,
        -21
      ],
      [
        37,
        -22
      ],
      [
        111,
        11
      ],
      [
        0,
        108
      ],
      [
        13,
        98
      ]
    ],
    [
      [
        119265,
        90471
      ],
      [
        0,
        -87
      ],
      [
        -49,
        43
      ],
      [
        -13,
        33
      ],
      [
        -49,
        21
      ],
      [
        -75,
        109
      ],
      [
        -24,
        65
      ],
      [
        -25,
        32
      ],
      [
        -74,
        66
      ],
      [
        62,
        32
      ],
      [
        99,
        -11
      ],
      [
        12,
        -11
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -43
      ],
      [
        74,
        -141
      ],
      [
        38,
        -22
      ],
      [
        24,
        -43
      ]
    ],
    [
      [
        113741,
        93084
      ],
      [
        -38,
        -11
      ],
      [
        -12,
        33
      ],
      [
        50,
        22
      ],
      [
        37,
        0
      ],
      [
        -37,
        -44
      ]
    ],
    [
      [
        118225,
        92824
      ],
      [
        -62,
        -65
      ],
      [
        -13,
        43
      ],
      [
        50,
        44
      ],
      [
        62,
        97
      ],
      [
        12,
        87
      ],
      [
        -12,
        43
      ],
      [
        161,
        55
      ],
      [
        99,
        86
      ],
      [
        25,
        -10
      ],
      [
        25,
        -66
      ],
      [
        0,
        -86
      ],
      [
        -13,
        -55
      ],
      [
        -111,
        -32
      ],
      [
        -112,
        -54
      ],
      [
        -111,
        -87
      ]
    ],
    [
      [
        74250,
        96934
      ],
      [
        12,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        12,
        -22
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        54
      ],
      [
        -25,
        0
      ],
      [
        -24,
        55
      ],
      [
        24,
        0
      ],
      [
        38,
        32
      ],
      [
        37,
        -11
      ]
    ],
    [
      [
        86018,
        97758
      ],
      [
        -62,
        -10
      ],
      [
        -62,
        43
      ],
      [
        -62,
        98
      ],
      [
        0,
        21
      ],
      [
        49,
        -11
      ],
      [
        62,
        0
      ],
      [
        87,
        -21
      ],
      [
        0,
        -65
      ],
      [
        12,
        -11
      ],
      [
        -24,
        -44
      ]
    ],
    [
      [
        76616,
        97878
      ],
      [
        -13,
        -11
      ],
      [
        -62,
        32
      ],
      [
        -12,
        22
      ],
      [
        37,
        22
      ],
      [
        50,
        -44
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        62,
        99277
      ],
      [
        74,
        -22
      ],
      [
        37,
        11
      ],
      [
        38,
        -43
      ],
      [
        173,
        -65
      ],
      [
        62,
        -44
      ],
      [
        -25,
        -11
      ],
      [
        25,
        -76
      ],
      [
        149,
        -43
      ],
      [
        74,
        -54
      ],
      [
        12,
        -33
      ],
      [
        -24,
        -43
      ],
      [
        49,
        11
      ],
      [
        50,
        32
      ],
      [
        -25,
        33
      ],
      [
        -149,
        87
      ],
      [
        13,
        10
      ],
      [
        198,
        -108
      ],
      [
        49,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        87,
        0
      ],
      [
        37,
        -11
      ],
      [
        37,
        -32
      ],
      [
        87,
        -33
      ],
      [
        545,
        -282
      ],
      [
        37,
        -97
      ],
      [
        0,
        -44
      ],
      [
        -49,
        -54
      ],
      [
        74,
        0
      ],
      [
        49,
        54
      ],
      [
        38,
        -22
      ],
      [
        24,
        -43
      ],
      [
        -37,
        -87
      ],
      [
        0,
        -65
      ],
      [
        50,
        -108
      ],
      [
        12,
        -87
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        25,
        -10
      ],
      [
        62,
        0
      ],
      [
        62,
        -44
      ],
      [
        37,
        -119
      ],
      [
        12,
        0
      ],
      [
        50,
        65
      ],
      [
        50,
        11
      ],
      [
        24,
        -54
      ],
      [
        -24,
        -98
      ],
      [
        24,
        11
      ],
      [
        62,
        76
      ],
      [
        13,
        43
      ],
      [
        -13,
        33
      ],
      [
        -37,
        21
      ],
      [
        -62,
        11
      ],
      [
        -37,
        54
      ],
      [
        50,
        44
      ],
      [
        24,
        54
      ],
      [
        -24,
        98
      ],
      [
        -25,
        21
      ],
      [
        -50,
        11
      ],
      [
        -12,
        33
      ],
      [
        -62,
        0
      ],
      [
        -13,
        32
      ],
      [
        223,
        11
      ],
      [
        75,
        22
      ],
      [
        62,
        -33
      ],
      [
        124,
        -21
      ],
      [
        -62,
        -66
      ],
      [
        -13,
        -65
      ],
      [
        37,
        -10
      ],
      [
        25,
        21
      ],
      [
        -12,
        65
      ],
      [
        25,
        11
      ],
      [
        62,
        -32
      ],
      [
        136,
        -11
      ],
      [
        0,
        32
      ],
      [
        -149,
        33
      ],
      [
        0,
        22
      ],
      [
        124,
        -22
      ],
      [
        124,
        -44
      ],
      [
        87,
        11
      ],
      [
        74,
        -32
      ],
      [
        87,
        -65
      ],
      [
        62,
        -87
      ],
      [
        74,
        -54
      ],
      [
        87,
        -44
      ],
      [
        148,
        -130
      ],
      [
        0,
        -21
      ],
      [
        62,
        10
      ],
      [
        37,
        -65
      ],
      [
        137,
        -32
      ],
      [
        24,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        22
      ],
      [
        -136,
        -65
      ],
      [
        -50,
        -44
      ],
      [
        0,
        -130
      ],
      [
        -37,
        -22
      ],
      [
        -86,
        11
      ],
      [
        -75,
        33
      ],
      [
        -99,
        76
      ],
      [
        0,
        -44
      ],
      [
        99,
        -76
      ],
      [
        25,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        -11
      ],
      [
        -49,
        22
      ],
      [
        -137,
        -11
      ],
      [
        -62,
        -11
      ],
      [
        0,
        22
      ],
      [
        -62,
        22
      ],
      [
        -37,
        0
      ],
      [
        -62,
        65
      ],
      [
        -99,
        11
      ],
      [
        -25,
        -11
      ],
      [
        75,
        -43
      ],
      [
        74,
        -66
      ],
      [
        -25,
        -32
      ],
      [
        62,
        0
      ],
      [
        13,
        -11
      ],
      [
        -37,
        -98
      ],
      [
        -124,
        -10
      ],
      [
        37,
        -22
      ],
      [
        62,
        0
      ],
      [
        37,
        -11
      ],
      [
        25,
        -98
      ],
      [
        -62,
        -54
      ],
      [
        -137,
        -54
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -11
      ],
      [
        0,
        -22
      ],
      [
        62,
        -32
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -32
      ],
      [
        25,
        -55
      ],
      [
        86,
        -21
      ],
      [
        62,
        -44
      ],
      [
        13,
        -65
      ],
      [
        -124,
        0
      ],
      [
        -13,
        54
      ],
      [
        -37,
        22
      ],
      [
        -24,
        -11
      ],
      [
        12,
        -86
      ],
      [
        -25,
        -44
      ],
      [
        -99,
        -11
      ],
      [
        -37,
        44
      ],
      [
        0,
        32
      ],
      [
        25,
        22
      ],
      [
        -25,
        22
      ],
      [
        -25,
        -33
      ],
      [
        -74,
        -43
      ],
      [
        -112,
        54
      ],
      [
        -74,
        87
      ],
      [
        -37,
        32
      ],
      [
        -87,
        54
      ],
      [
        -161,
        55
      ],
      [
        -74,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -37,
        43
      ],
      [
        -74,
        43
      ],
      [
        -37,
        44
      ],
      [
        0,
        141
      ],
      [
        -25,
        65
      ],
      [
        -62,
        76
      ],
      [
        -161,
        54
      ],
      [
        -174,
        43
      ],
      [
        -37,
        -10
      ],
      [
        -111,
        -66
      ],
      [
        -75,
        -10
      ],
      [
        -210,
        0
      ],
      [
        -62,
        32
      ],
      [
        -13,
        33
      ],
      [
        13,
        97
      ],
      [
        -62,
        33
      ],
      [
        -37,
        43
      ],
      [
        -50,
        109
      ],
      [
        62,
        -11
      ],
      [
        25,
        65
      ],
      [
        37,
        43
      ],
      [
        12,
        76
      ],
      [
        -24,
        22
      ],
      [
        -50,
        -76
      ],
      [
        -49,
        -33
      ],
      [
        -75,
        33
      ],
      [
        -24,
        54
      ],
      [
        -50,
        -21
      ],
      [
        0,
        -76
      ],
      [
        -99,
        -22
      ],
      [
        -25,
        32
      ],
      [
        -25,
        -97
      ],
      [
        -12,
        -76
      ],
      [
        25,
        -65
      ],
      [
        99,
        -65
      ],
      [
        25,
        -33
      ],
      [
        12,
        -43
      ],
      [
        -62,
        -119
      ],
      [
        -37,
        -87
      ],
      [
        -25,
        -33
      ],
      [
        -99,
        -76
      ],
      [
        0,
        152
      ],
      [
        0,
        152
      ],
      [
        0,
        152
      ],
      [
        0,
        152
      ],
      [
        0,
        162
      ],
      [
        0,
        152
      ],
      [
        0,
        152
      ],
      [
        0,
        152
      ],
      [
        0,
        152
      ],
      [
        0,
        152
      ],
      [
        0,
        151
      ],
      [
        0,
        152
      ],
      [
        0,
        152
      ],
      [
        0,
        152
      ],
      [
        0,
        163
      ],
      [
        0,
        151
      ],
      [
        62,
        -32
      ]
    ],
    [
      [
        79217,
        99429
      ],
      [
        12,
        -55
      ],
      [
        -24,
        -32
      ],
      [
        -25,
        0
      ],
      [
        0,
        32
      ],
      [
        -25,
        22
      ],
      [
        -49,
        -43
      ],
      [
        -38,
        -54
      ],
      [
        -74,
        -66
      ],
      [
        -149,
        -54
      ],
      [
        -173,
        -32
      ],
      [
        -87,
        43
      ],
      [
        -49,
        119
      ],
      [
        0,
        120
      ],
      [
        12,
        54
      ],
      [
        37,
        43
      ],
      [
        75,
        65
      ],
      [
        111,
        44
      ],
      [
        87,
        0
      ],
      [
        272,
        -130
      ],
      [
        50,
        -33
      ],
      [
        37,
        -43
      ]
    ],
    [
      [
        85101,
        99646
      ],
      [
        -37,
        -55
      ],
      [
        -50,
        0
      ],
      [
        -24,
        22
      ],
      [
        61,
        65
      ],
      [
        38,
        0
      ],
      [
        12,
        -32
      ]
    ],
    [
      [
        117482,
        99255
      ],
      [
        0,
        54
      ],
      [
        -38,
        33
      ],
      [
        -62,
        22
      ],
      [
        -24,
        75
      ],
      [
        12,
        87
      ],
      [
        -25,
        44
      ],
      [
        13,
        43
      ],
      [
        74,
        43
      ],
      [
        62,
        55
      ],
      [
        37,
        -22
      ],
      [
        0,
        -65
      ],
      [
        -25,
        -33
      ],
      [
        -62,
        -21
      ],
      [
        0,
        -131
      ],
      [
        13,
        -54
      ],
      [
        37,
        -54
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        120145,
        99678
      ],
      [
        -99,
        -11
      ],
      [
        -198,
        65
      ],
      [
        -75,
        33
      ],
      [
        -124,
        76
      ],
      [
        13,
        21
      ],
      [
        86,
        66
      ],
      [
        50,
        21
      ],
      [
        50,
        0
      ],
      [
        346,
        -87
      ],
      [
        25,
        -10
      ],
      [
        0,
        -55
      ],
      [
        -37,
        0
      ],
      [
        -12,
        -21
      ],
      [
        -13,
        -87
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        82723,
        99895
      ],
      [
        12,
        -22
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -43
      ],
      [
        -38,
        0
      ],
      [
        -49,
        -22
      ],
      [
        -62,
        22
      ],
      [
        -99,
        -11
      ],
      [
        -50,
        22
      ],
      [
        0,
        32
      ],
      [
        -24,
        44
      ],
      [
        -50,
        21
      ],
      [
        -37,
        0
      ],
      [
        -37,
        22
      ],
      [
        -50,
        -33
      ],
      [
        -25,
        11
      ],
      [
        -86,
        98
      ],
      [
        -75,
        141
      ],
      [
        13,
        32
      ],
      [
        62,
        22
      ],
      [
        37,
        44
      ],
      [
        87,
        21
      ],
      [
        12,
        -21
      ],
      [
        124,
        -76
      ],
      [
        62,
        -65
      ],
      [
        260,
        -152
      ],
      [
        25,
        -22
      ]
    ],
    [
      [
        117221,
        100459
      ],
      [
        -74,
        -11
      ],
      [
        -25,
        22
      ],
      [
        0,
        54
      ],
      [
        50,
        -11
      ],
      [
        49,
        -54
      ]
    ],
    [
      [
        80121,
        100795
      ],
      [
        62,
        -87
      ],
      [
        25,
        11
      ],
      [
        25,
        -54
      ],
      [
        -62,
        -76
      ],
      [
        25,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        54
      ],
      [
        -62,
        32
      ],
      [
        -12,
        44
      ],
      [
        -75,
        43
      ],
      [
        -86,
        11
      ],
      [
        -13,
        43
      ],
      [
        99,
        33
      ],
      [
        87,
        11
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        123465,
        100459
      ],
      [
        -25,
        0
      ],
      [
        -62,
        141
      ],
      [
        99,
        108
      ],
      [
        111,
        55
      ],
      [
        112,
        86
      ],
      [
        62,
        11
      ],
      [
        49,
        33
      ],
      [
        50,
        11
      ],
      [
        0,
        -347
      ],
      [
        -50,
        -11
      ],
      [
        -74,
        -44
      ],
      [
        -173,
        -11
      ],
      [
        -99,
        -32
      ]
    ],
    [
      [
        109393,
        100882
      ],
      [
        -87,
        -54
      ],
      [
        -87,
        43
      ],
      [
        -62,
        -22
      ],
      [
        -74,
        33
      ],
      [
        0,
        22
      ],
      [
        74,
        21
      ],
      [
        186,
        11
      ],
      [
        50,
        -54
      ]
    ],
    [
      [
        384,
        100925
      ],
      [
        149,
        -21
      ],
      [
        99,
        -44
      ],
      [
        111,
        -87
      ],
      [
        87,
        -32
      ],
      [
        25,
        -43
      ],
      [
        -13,
        -33
      ],
      [
        -99,
        -54
      ],
      [
        -86,
        -22
      ],
      [
        -162,
        -11
      ],
      [
        -210,
        -54
      ],
      [
        -124,
        -11
      ],
      [
        -74,
        33
      ],
      [
        -87,
        11
      ],
      [
        0,
        119
      ],
      [
        0,
        141
      ],
      [
        0,
        87
      ],
      [
        99,
        21
      ],
      [
        99,
        -11
      ],
      [
        99,
        22
      ],
      [
        87,
        -11
      ]
    ],
    [
      [
        88631,
        101370
      ],
      [
        -161,
        0
      ],
      [
        -86,
        11
      ],
      [
        0,
        32
      ],
      [
        124,
        76
      ],
      [
        37,
        54
      ],
      [
        74,
        44
      ],
      [
        50,
        0
      ],
      [
        185,
        -54
      ],
      [
        38,
        -44
      ],
      [
        -75,
        -43
      ],
      [
        -49,
        -11
      ],
      [
        -87,
        -54
      ],
      [
        -50,
        -11
      ]
    ],
    [
      [
        89276,
        101641
      ],
      [
        -25,
        -11
      ],
      [
        -186,
        33
      ],
      [
        -87,
        54
      ],
      [
        13,
        33
      ],
      [
        173,
        119
      ],
      [
        62,
        -33
      ],
      [
        62,
        -76
      ],
      [
        0,
        -86
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        87616,
        101739
      ],
      [
        -87,
        21
      ],
      [
        -112,
        65
      ],
      [
        38,
        55
      ],
      [
        136,
        11
      ],
      [
        124,
        -33
      ],
      [
        -75,
        -22
      ],
      [
        -37,
        -43
      ],
      [
        25,
        -33
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        103298,
        101869
      ],
      [
        -87,
        -22
      ],
      [
        -74,
        0
      ],
      [
        -50,
        44
      ],
      [
        38,
        21
      ],
      [
        74,
        11
      ],
      [
        99,
        -43
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        80964,
        102010
      ],
      [
        148,
        -33
      ],
      [
        124,
        0
      ],
      [
        99,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        -62,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        12,
        -44
      ],
      [
        -37,
        -76
      ],
      [
        -99,
        0
      ],
      [
        -62,
        -119
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        -76
      ],
      [
        12,
        -97
      ],
      [
        38,
        -54
      ],
      [
        -38,
        -66
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -43
      ],
      [
        62,
        -43
      ],
      [
        50,
        -109
      ],
      [
        62,
        -119
      ],
      [
        223,
        -250
      ],
      [
        148,
        -108
      ],
      [
        62,
        -33
      ],
      [
        149,
        -54
      ],
      [
        49,
        -43
      ],
      [
        -62,
        -44
      ],
      [
        -74,
        -10
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -11
      ],
      [
        -173,
        33
      ],
      [
        -38,
        54
      ],
      [
        -86,
        -11
      ],
      [
        99,
        -76
      ],
      [
        -50,
        -11
      ],
      [
        -99,
        54
      ],
      [
        -12,
        -21
      ],
      [
        -50,
        21
      ],
      [
        -12,
        -21
      ],
      [
        -74,
        11
      ],
      [
        0,
        32
      ],
      [
        -162,
        -11
      ],
      [
        -123,
        0
      ],
      [
        -75,
        44
      ],
      [
        -12,
        -44
      ],
      [
        -99,
        44
      ],
      [
        -211,
        43
      ],
      [
        -111,
        33
      ],
      [
        25,
        21
      ],
      [
        49,
        11
      ],
      [
        -12,
        87
      ],
      [
        37,
        22
      ],
      [
        62,
        -11
      ],
      [
        -13,
        32
      ],
      [
        38,
        11
      ],
      [
        49,
        -22
      ],
      [
        25,
        11
      ],
      [
        -87,
        44
      ],
      [
        -111,
        65
      ],
      [
        12,
        21
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        44
      ],
      [
        0,
        43
      ],
      [
        37,
        33
      ],
      [
        -25,
        11
      ],
      [
        -148,
        -33
      ],
      [
        -87,
        11
      ],
      [
        -87,
        22
      ],
      [
        -86,
        -33
      ],
      [
        -75,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -75,
        54
      ],
      [
        -24,
        44
      ],
      [
        -38,
        108
      ],
      [
        13,
        76
      ],
      [
        49,
        76
      ],
      [
        75,
        54
      ],
      [
        86,
        -11
      ],
      [
        99,
        11
      ],
      [
        38,
        65
      ],
      [
        49,
        22
      ],
      [
        25,
        32
      ],
      [
        12,
        66
      ],
      [
        50,
        65
      ],
      [
        -12,
        21
      ],
      [
        37,
        55
      ],
      [
        -87,
        10
      ],
      [
        -50,
        33
      ],
      [
        13,
        32
      ],
      [
        87,
        55
      ],
      [
        74,
        21
      ],
      [
        74,
        -10
      ],
      [
        37,
        10
      ],
      [
        -37,
        33
      ],
      [
        -25,
        87
      ],
      [
        25,
        54
      ],
      [
        37,
        22
      ],
      [
        99,
        21
      ],
      [
        38,
        22
      ],
      [
        111,
        -11
      ],
      [
        87,
        11
      ],
      [
        161,
        54
      ],
      [
        111,
        -11
      ],
      [
        75,
        -32
      ]
    ],
    [
      [
        86241,
        101869
      ],
      [
        -99,
        -22
      ],
      [
        -87,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        33
      ],
      [
        37,
        87
      ],
      [
        -13,
        86
      ],
      [
        50,
        55
      ],
      [
        272,
        43
      ],
      [
        75,
        -22
      ],
      [
        74,
        -76
      ],
      [
        25,
        -11
      ],
      [
        74,
        -75
      ],
      [
        -12,
        -33
      ],
      [
        -248,
        -32
      ],
      [
        -74,
        -22
      ]
    ],
    [
      [
        88334,
        102097
      ],
      [
        -37,
        -11
      ],
      [
        -149,
        21
      ],
      [
        -49,
        33
      ],
      [
        62,
        22
      ],
      [
        173,
        -65
      ]
    ],
    [
      [
        87901,
        102097
      ],
      [
        -38,
        10
      ],
      [
        62,
        44
      ],
      [
        124,
        21
      ],
      [
        37,
        -10
      ],
      [
        -74,
        -65
      ],
      [
        -111,
        0
      ]
    ],
    [
      [
        110842,
        102379
      ],
      [
        161,
        -66
      ],
      [
        235,
        -141
      ],
      [
        50,
        -75
      ],
      [
        0,
        -131
      ],
      [
        -13,
        -10
      ],
      [
        -86,
        0
      ],
      [
        -211,
        21
      ],
      [
        -74,
        0
      ],
      [
        -260,
        33
      ],
      [
        -298,
        87
      ],
      [
        -123,
        -11
      ],
      [
        -161,
        -55
      ],
      [
        -38,
        0
      ],
      [
        -37,
        55
      ],
      [
        75,
        11
      ],
      [
        86,
        0
      ],
      [
        75,
        21
      ],
      [
        74,
        44
      ],
      [
        37,
        43
      ],
      [
        62,
        98
      ],
      [
        74,
        54
      ],
      [
        75,
        0
      ],
      [
        210,
        32
      ],
      [
        87,
        -10
      ]
    ],
    [
      [
        104772,
        102346
      ],
      [
        -62,
        11
      ],
      [
        -12,
        32
      ],
      [
        74,
        11
      ],
      [
        37,
        -32
      ],
      [
        -37,
        -22
      ]
    ],
    [
      [
        90675,
        102487
      ],
      [
        -49,
        -22
      ],
      [
        -87,
        22
      ],
      [
        -124,
        11
      ],
      [
        37,
        22
      ],
      [
        75,
        10
      ],
      [
        136,
        -10
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        90378,
        102498
      ],
      [
        -25,
        -22
      ],
      [
        -86,
        22
      ],
      [
        -13,
        22
      ],
      [
        62,
        21
      ],
      [
        37,
        -11
      ],
      [
        25,
        -32
      ]
    ],
    [
      [
        108786,
        102389
      ],
      [
        -25,
        -21
      ],
      [
        -149,
        108
      ],
      [
        -25,
        44
      ],
      [
        -62,
        32
      ],
      [
        -24,
        43
      ],
      [
        86,
        -21
      ],
      [
        137,
        -76
      ],
      [
        86,
        -65
      ],
      [
        -24,
        -44
      ]
    ],
    [
      [
        110446,
        102444
      ],
      [
        -174,
        -55
      ],
      [
        -37,
        0
      ],
      [
        -74,
        55
      ],
      [
        -38,
        108
      ],
      [
        38,
        33
      ],
      [
        74,
        21
      ],
      [
        186,
        0
      ],
      [
        25,
        -11
      ],
      [
        24,
        -54
      ],
      [
        -24,
        -97
      ]
    ],
    [
      [
        91084,
        102726
      ],
      [
        -12,
        -33
      ],
      [
        -99,
        11
      ],
      [
        -13,
        22
      ],
      [
        99,
        32
      ],
      [
        62,
        0
      ],
      [
        -37,
        -32
      ]
    ],
    [
      [
        100932,
        102693
      ],
      [
        -37,
        -87
      ],
      [
        -25,
        -21
      ],
      [
        -74,
        -22
      ],
      [
        -62,
        -65
      ],
      [
        -211,
        32
      ],
      [
        -186,
        76
      ],
      [
        -49,
        55
      ],
      [
        25,
        10
      ],
      [
        99,
        0
      ],
      [
        25,
        11
      ],
      [
        49,
        98
      ],
      [
        421,
        -65
      ],
      [
        25,
        -22
      ]
    ],
    [
      [
        91741,
        103051
      ],
      [
        24,
        -11
      ],
      [
        87,
        22
      ],
      [
        50,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        -38,
        -22
      ],
      [
        -185,
        22
      ],
      [
        -38,
        22
      ],
      [
        25,
        32
      ],
      [
        112,
        22
      ]
    ],
    [
      [
        90192,
        103322
      ],
      [
        25,
        -43
      ],
      [
        -62,
        0
      ],
      [
        -124,
        -44
      ],
      [
        -62,
        55
      ],
      [
        75,
        54
      ],
      [
        74,
        -22
      ],
      [
        -12,
        54
      ],
      [
        86,
        11
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        112427,
        103300
      ],
      [
        100,
        -10
      ],
      [
        148,
        54
      ],
      [
        322,
        -22
      ],
      [
        25,
        -22
      ],
      [
        -12,
        -65
      ],
      [
        37,
        -21
      ],
      [
        99,
        -11
      ],
      [
        74,
        21
      ],
      [
        347,
        -21
      ],
      [
        149,
        -76
      ],
      [
        74,
        43
      ],
      [
        25,
        -11
      ],
      [
        -62,
        -130
      ],
      [
        -112,
        -43
      ],
      [
        -161,
        -54
      ],
      [
        -86,
        -11
      ],
      [
        -186,
        0
      ],
      [
        -260,
        21
      ],
      [
        -75,
        11
      ],
      [
        -161,
        87
      ],
      [
        -161,
        22
      ],
      [
        -148,
        76
      ],
      [
        -198,
        54
      ],
      [
        37,
        119
      ],
      [
        62,
        98
      ],
      [
        37,
        22
      ],
      [
        74,
        -44
      ],
      [
        12,
        -87
      ]
    ],
    [
      [
        108699,
        103322
      ],
      [
        -74,
        -22
      ],
      [
        -100,
        11
      ],
      [
        50,
        109
      ],
      [
        -12,
        43
      ],
      [
        49,
        130
      ],
      [
        37,
        -32
      ],
      [
        13,
        -44
      ],
      [
        111,
        -76
      ],
      [
        -74,
        -76
      ],
      [
        25,
        -32
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        114521,
        103767
      ],
      [
        -25,
        -22
      ],
      [
        -87,
        33
      ],
      [
        87,
        32
      ],
      [
        25,
        -43
      ]
    ],
    [
      [
        110111,
        103582
      ],
      [
        74,
        0
      ],
      [
        38,
        -21
      ],
      [
        37,
        -65
      ],
      [
        37,
        -33
      ],
      [
        74,
        0
      ],
      [
        50,
        43
      ],
      [
        -13,
        55
      ],
      [
        13,
        86
      ],
      [
        25,
        33
      ],
      [
        99,
        43
      ],
      [
        62,
        55
      ],
      [
        86,
        -22
      ],
      [
        248,
        -130
      ],
      [
        161,
        -44
      ],
      [
        87,
        -10
      ],
      [
        124,
        32
      ],
      [
        49,
        0
      ],
      [
        533,
        -173
      ],
      [
        37,
        -33
      ],
      [
        -111,
        -33
      ],
      [
        -75,
        -43
      ],
      [
        -25,
        -32
      ],
      [
        50,
        -55
      ],
      [
        -161,
        -108
      ],
      [
        -136,
        -33
      ],
      [
        -137,
        22
      ],
      [
        -74,
        0
      ],
      [
        -74,
        22
      ],
      [
        -87,
        65
      ],
      [
        -74,
        76
      ],
      [
        -13,
        65
      ],
      [
        13,
        65
      ],
      [
        49,
        11
      ],
      [
        50,
        54
      ],
      [
        -25,
        32
      ],
      [
        -136,
        11
      ],
      [
        -161,
        -43
      ],
      [
        25,
        -119
      ],
      [
        37,
        -76
      ],
      [
        148,
        -152
      ],
      [
        87,
        -22
      ],
      [
        62,
        -65
      ],
      [
        -112,
        -54
      ],
      [
        -136,
        -33
      ],
      [
        -74,
        44
      ],
      [
        -62,
        65
      ],
      [
        -87,
        -11
      ],
      [
        -74,
        -22
      ],
      [
        -434,
        -65
      ],
      [
        -86,
        33
      ],
      [
        -87,
        43
      ],
      [
        -74,
        -32
      ],
      [
        -38,
        -98
      ],
      [
        -37,
        -43
      ],
      [
        -86,
        -22
      ],
      [
        -75,
        32
      ],
      [
        -297,
        76
      ],
      [
        -112,
        120
      ],
      [
        -74,
        21
      ],
      [
        -87,
        44
      ],
      [
        -86,
        97
      ],
      [
        12,
        55
      ],
      [
        99,
        -11
      ],
      [
        -25,
        130
      ],
      [
        25,
        119
      ],
      [
        25,
        22
      ],
      [
        124,
        -11
      ],
      [
        -74,
        98
      ],
      [
        49,
        43
      ],
      [
        50,
        22
      ],
      [
        62,
        0
      ],
      [
        86,
        54
      ],
      [
        75,
        11
      ],
      [
        136,
        43
      ],
      [
        25,
        0
      ],
      [
        111,
        -76
      ],
      [
        99,
        -32
      ],
      [
        186,
        -120
      ]
    ],
    [
      [
        95135,
        103864
      ],
      [
        25,
        -32
      ],
      [
        -87,
        -11
      ],
      [
        -13,
        -54
      ],
      [
        -74,
        21
      ],
      [
        -87,
        0
      ],
      [
        -62,
        22
      ],
      [
        -123,
        11
      ],
      [
        24,
        43
      ],
      [
        75,
        -21
      ],
      [
        62,
        32
      ],
      [
        136,
        -22
      ],
      [
        37,
        22
      ],
      [
        87,
        -11
      ]
    ],
    [
      [
        95246,
        103810
      ],
      [
        -37,
        0
      ],
      [
        0,
        43
      ],
      [
        37,
        55
      ],
      [
        50,
        0
      ],
      [
        25,
        -33
      ],
      [
        -75,
        -65
      ]
    ],
    [
      [
        100622,
        104081
      ],
      [
        62,
        -76
      ],
      [
        -37,
        -32
      ],
      [
        -87,
        54
      ],
      [
        -49,
        0
      ],
      [
        -62,
        54
      ],
      [
        111,
        -11
      ],
      [
        62,
        11
      ]
    ],
    [
      [
        95506,
        104060
      ],
      [
        -62,
        0
      ],
      [
        -37,
        54
      ],
      [
        25,
        11
      ],
      [
        74,
        -65
      ]
    ],
    [
      [
        113245,
        104103
      ],
      [
        -260,
        -11
      ],
      [
        12,
        22
      ],
      [
        99,
        43
      ],
      [
        186,
        0
      ],
      [
        -37,
        -54
      ]
    ],
    [
      [
        85237,
        103832
      ],
      [
        -297,
        -98
      ],
      [
        -434,
        -108
      ],
      [
        -309,
        -65
      ],
      [
        -161,
        -44
      ],
      [
        -174,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -111,
        -44
      ],
      [
        -99,
        -21
      ],
      [
        -335,
        -87
      ],
      [
        -161,
        -65
      ],
      [
        -87,
        -11
      ],
      [
        -74,
        -54
      ],
      [
        -74,
        -33
      ],
      [
        -87,
        -76
      ],
      [
        -50,
        11
      ],
      [
        -86,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        75,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -50,
        -22
      ],
      [
        -25,
        -32
      ],
      [
        -86,
        -33
      ],
      [
        -87,
        11
      ],
      [
        12,
        -76
      ],
      [
        -62,
        -11
      ],
      [
        -124,
        44
      ],
      [
        -24,
        -44
      ],
      [
        -13,
        -65
      ],
      [
        -62,
        -32
      ],
      [
        -136,
        21
      ],
      [
        37,
        -108
      ],
      [
        -12,
        -54
      ],
      [
        -62,
        -65
      ],
      [
        -235,
        -76
      ],
      [
        37,
        -65
      ],
      [
        0,
        -66
      ],
      [
        -75,
        -21
      ],
      [
        -62,
        43
      ],
      [
        -61,
        -11
      ],
      [
        61,
        -43
      ],
      [
        25,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -111,
        -65
      ],
      [
        -62,
        -87
      ],
      [
        -111,
        -32
      ],
      [
        -75,
        -11
      ],
      [
        -136,
        32
      ],
      [
        -161,
        11
      ],
      [
        -99,
        22
      ],
      [
        -87,
        33
      ],
      [
        -87,
        0
      ],
      [
        -161,
        -66
      ],
      [
        -49,
        87
      ],
      [
        25,
        33
      ],
      [
        -137,
        97
      ],
      [
        -24,
        44
      ],
      [
        223,
        108
      ],
      [
        86,
        11
      ],
      [
        25,
        54
      ],
      [
        99,
        87
      ],
      [
        112,
        152
      ],
      [
        24,
        11
      ],
      [
        236,
        21
      ],
      [
        12,
        11
      ],
      [
        -62,
        33
      ],
      [
        -99,
        11
      ],
      [
        -25,
        43
      ],
      [
        25,
        11
      ],
      [
        87,
        87
      ],
      [
        99,
        65
      ],
      [
        99,
        43
      ],
      [
        -50,
        33
      ],
      [
        -123,
        -11
      ],
      [
        -62,
        76
      ],
      [
        74,
        43
      ],
      [
        87,
        -11
      ],
      [
        74,
        -43
      ],
      [
        25,
        0
      ],
      [
        111,
        87
      ],
      [
        -24,
        54
      ],
      [
        61,
        32
      ],
      [
        112,
        0
      ],
      [
        99,
        -21
      ],
      [
        62,
        97
      ],
      [
        111,
        55
      ],
      [
        -12,
        43
      ],
      [
        124,
        43
      ],
      [
        149,
        76
      ],
      [
        408,
        87
      ],
      [
        25,
        54
      ],
      [
        50,
        11
      ],
      [
        161,
        11
      ],
      [
        25,
        -22
      ],
      [
        49,
        0
      ],
      [
        37,
        33
      ],
      [
        -12,
        65
      ],
      [
        49,
        32
      ],
      [
        211,
        11
      ],
      [
        235,
        -43
      ],
      [
        112,
        11
      ],
      [
        62,
        -11
      ],
      [
        186,
        54
      ],
      [
        322,
        43
      ],
      [
        86,
        22
      ],
      [
        87,
        43
      ],
      [
        87,
        11
      ],
      [
        223,
        65
      ],
      [
        74,
        87
      ],
      [
        260,
        109
      ],
      [
        149,
        21
      ],
      [
        99,
        33
      ],
      [
        161,
        -11
      ],
      [
        161,
        -33
      ],
      [
        74,
        -43
      ],
      [
        75,
        -65
      ],
      [
        12,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        13,
        -54
      ],
      [
        -124,
        -76
      ],
      [
        -136,
        -109
      ],
      [
        -137,
        -32
      ]
    ],
    [
      [
        95048,
        104331
      ],
      [
        -149,
        -33
      ],
      [
        -49,
        33
      ],
      [
        -149,
        -11
      ],
      [
        50,
        32
      ],
      [
        148,
        22
      ],
      [
        236,
        65
      ],
      [
        12,
        -43
      ],
      [
        -99,
        -65
      ]
    ],
    [
      [
        92719,
        104428
      ],
      [
        -74,
        0
      ],
      [
        -50,
        22
      ],
      [
        50,
        54
      ],
      [
        111,
        0
      ],
      [
        25,
        -11
      ],
      [
        -62,
        -65
      ]
    ],
    [
      [
        98876,
        104461
      ],
      [
        -37,
        0
      ],
      [
        -13,
        32
      ],
      [
        37,
        33
      ],
      [
        87,
        -11
      ],
      [
        25,
        -32
      ],
      [
        -99,
        -22
      ]
    ],
    [
      [
        78858,
        85156
      ],
      [
        12,
        -21
      ],
      [
        -49,
        -11
      ],
      [
        0,
        -33
      ],
      [
        -13,
        -21
      ],
      [
        -86,
        -55
      ],
      [
        -50,
        -10
      ],
      [
        0,
        -44
      ],
      [
        25,
        -65
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        33
      ],
      [
        -37,
        0
      ],
      [
        -87,
        -98
      ],
      [
        -24,
        -21
      ],
      [
        -38,
        -11
      ],
      [
        -86,
        -44
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -22
      ],
      [
        0,
        -43
      ],
      [
        -50,
        65
      ],
      [
        -12,
        -11
      ],
      [
        25,
        -43
      ],
      [
        0,
        -76
      ],
      [
        -38,
        -43
      ],
      [
        -12,
        -76
      ],
      [
        -50,
        -163
      ],
      [
        -37,
        -76
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        32
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        -44
      ],
      [
        -24,
        -86
      ],
      [
        24,
        -55
      ],
      [
        50,
        -21
      ],
      [
        37,
        -33
      ],
      [
        74,
        -87
      ],
      [
        25,
        -54
      ],
      [
        37,
        -206
      ],
      [
        13,
        -141
      ],
      [
        37,
        174
      ],
      [
        25,
        32
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        -12,
        -108
      ],
      [
        -13,
        -76
      ],
      [
        13,
        -65
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -119
      ],
      [
        25,
        -44
      ],
      [
        37,
        -43
      ],
      [
        25,
        -54
      ],
      [
        12,
        -76
      ],
      [
        111,
        -206
      ],
      [
        62,
        -109
      ],
      [
        50,
        -141
      ],
      [
        12,
        -21
      ],
      [
        50,
        -55
      ]
    ],
    [
      [
        75674,
        83334
      ],
      [
        -37,
        33
      ],
      [
        -186,
        271
      ],
      [
        -210,
        239
      ],
      [
        -25,
        21
      ],
      [
        -112,
        33
      ],
      [
        -49,
        32
      ],
      [
        -112,
        174
      ],
      [
        -49,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -37,
        22
      ],
      [
        -50,
        54
      ],
      [
        -12,
        76
      ],
      [
        -38,
        43
      ],
      [
        -86,
        55
      ],
      [
        -99,
        43
      ],
      [
        -13,
        33
      ],
      [
        87,
        43
      ],
      [
        25,
        22
      ],
      [
        -75,
        54
      ],
      [
        50,
        32
      ],
      [
        87,
        -75
      ],
      [
        37,
        -22
      ],
      [
        12,
        22
      ],
      [
        136,
        43
      ],
      [
        0,
        65
      ],
      [
        -12,
        0
      ],
      [
        0,
        54
      ],
      [
        12,
        54
      ],
      [
        62,
        87
      ],
      [
        38,
        130
      ],
      [
        24,
        33
      ],
      [
        37,
        -33
      ],
      [
        25,
        55
      ],
      [
        37,
        0
      ],
      [
        38,
        -11
      ],
      [
        24,
        11
      ],
      [
        -62,
        97
      ],
      [
        -74,
        98
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -37,
        76
      ],
      [
        -12,
        65
      ],
      [
        37,
        0
      ],
      [
        37,
        -11
      ],
      [
        62,
        54
      ],
      [
        25,
        0
      ],
      [
        86,
        -22
      ],
      [
        0,
        44
      ],
      [
        -12,
        54
      ],
      [
        62,
        33
      ],
      [
        62,
        21
      ],
      [
        111,
        76
      ],
      [
        50,
        11
      ],
      [
        0,
        43
      ],
      [
        -25,
        98
      ],
      [
        -62,
        0
      ],
      [
        -37,
        -54
      ],
      [
        -87,
        -22
      ],
      [
        -37,
        0
      ],
      [
        25,
        43
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -32
      ],
      [
        -99,
        -54
      ]
    ],
    [
      [
        75067,
        85634
      ],
      [
        0,
        54
      ],
      [
        25,
        32
      ],
      [
        0,
        22
      ],
      [
        -25,
        22
      ],
      [
        0,
        21
      ],
      [
        25,
        44
      ],
      [
        0,
        97
      ],
      [
        37,
        33
      ],
      [
        50,
        0
      ],
      [
        37,
        32
      ],
      [
        25,
        33
      ],
      [
        37,
        76
      ],
      [
        25,
        11
      ],
      [
        62,
        -11
      ],
      [
        37,
        0
      ],
      [
        74,
        -11
      ],
      [
        124,
        11
      ],
      [
        12,
        32
      ],
      [
        0,
        44
      ],
      [
        37,
        130
      ],
      [
        25,
        43
      ],
      [
        0,
        22
      ],
      [
        -37,
        11
      ],
      [
        12,
        43
      ],
      [
        0,
        33
      ],
      [
        -24,
        76
      ],
      [
        -25,
        21
      ],
      [
        -37,
        11
      ],
      [
        25,
        98
      ],
      [
        24,
        43
      ],
      [
        37,
        -11
      ],
      [
        38,
        11
      ],
      [
        0,
        22
      ],
      [
        -87,
        43
      ],
      [
        -25,
        55
      ],
      [
        25,
        21
      ],
      [
        49,
        11
      ],
      [
        25,
        43
      ],
      [
        37,
        44
      ],
      [
        25,
        65
      ],
      [
        0,
        43
      ],
      [
        -25,
        33
      ],
      [
        0,
        43
      ],
      [
        13,
        33
      ],
      [
        -25,
        32
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        10
      ],
      [
        -111,
        98
      ],
      [
        -50,
        0
      ],
      [
        -49,
        76
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -99,
        87
      ],
      [
        -62,
        0
      ],
      [
        -62,
        54
      ],
      [
        -37,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -87,
        87
      ],
      [
        -37,
        76
      ],
      [
        0,
        43
      ],
      [
        -62,
        76
      ],
      [
        -25,
        0
      ],
      [
        -74,
        -43
      ],
      [
        -50,
        0
      ],
      [
        -74,
        -33
      ],
      [
        -50,
        -54
      ],
      [
        -37,
        43
      ],
      [
        -49,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        87
      ],
      [
        -37,
        0
      ],
      [
        -38,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        10
      ],
      [
        -24,
        55
      ],
      [
        -38,
        54
      ],
      [
        -12,
        43
      ],
      [
        12,
        22
      ],
      [
        0,
        76
      ],
      [
        -12,
        22
      ],
      [
        -12,
        65
      ],
      [
        -13,
        32
      ],
      [
        0,
        54
      ],
      [
        -12,
        11
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        55
      ],
      [
        0,
        32
      ],
      [
        -12,
        22
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -49,
        -11
      ],
      [
        -75,
        33
      ],
      [
        -86,
        11
      ],
      [
        -13,
        10
      ],
      [
        25,
        33
      ],
      [
        -25,
        65
      ],
      [
        0,
        87
      ],
      [
        -24,
        32
      ],
      [
        0,
        44
      ],
      [
        86,
        21
      ],
      [
        13,
        22
      ],
      [
        -13,
        22
      ],
      [
        -99,
        119
      ],
      [
        -25,
        109
      ],
      [
        -37,
        65
      ],
      [
        -37,
        43
      ],
      [
        -25,
        11
      ],
      [
        -99,
        0
      ],
      [
        -49,
        11
      ],
      [
        -50,
        -11
      ],
      [
        -87,
        -54
      ],
      [
        -86,
        10
      ],
      [
        -50,
        22
      ],
      [
        -25,
        0
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        -97
      ],
      [
        -62,
        -44
      ],
      [
        -50,
        0
      ],
      [
        -74,
        33
      ]
    ],
    [
      [
        71562,
        93366
      ],
      [
        12,
        54
      ],
      [
        0,
        55
      ],
      [
        -12,
        43
      ],
      [
        12,
        43
      ],
      [
        25,
        0
      ],
      [
        37,
        -43
      ],
      [
        37,
        -22
      ],
      [
        25,
        33
      ],
      [
        12,
        54
      ],
      [
        25,
        22
      ],
      [
        25,
        -22
      ],
      [
        49,
        -11
      ],
      [
        50,
        0
      ],
      [
        25,
        11
      ],
      [
        25,
        54
      ],
      [
        49,
        55
      ],
      [
        173,
        -22
      ],
      [
        162,
        -54
      ],
      [
        12,
        54
      ],
      [
        -62,
        43
      ],
      [
        -37,
        54
      ],
      [
        -50,
        44
      ],
      [
        -62,
        11
      ],
      [
        -62,
        -22
      ],
      [
        -111,
        11
      ],
      [
        -87,
        87
      ],
      [
        -49,
        32
      ],
      [
        -50,
        65
      ],
      [
        37,
        11
      ],
      [
        13,
        65
      ],
      [
        -25,
        33
      ],
      [
        -25,
        11
      ],
      [
        -111,
        -66
      ],
      [
        -137,
        -21
      ]
    ],
    [
      [
        72540,
        99808
      ],
      [
        62,
        -11
      ],
      [
        149,
        -54
      ],
      [
        74,
        22
      ],
      [
        37,
        65
      ],
      [
        25,
        11
      ],
      [
        50,
        -22
      ],
      [
        12,
        22
      ],
      [
        -25,
        43
      ],
      [
        0,
        33
      ],
      [
        149,
        -55
      ],
      [
        62,
        -43
      ],
      [
        124,
        -32
      ],
      [
        24,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -43
      ],
      [
        -49,
        0
      ],
      [
        -198,
        43
      ],
      [
        -38,
        -21
      ],
      [
        25,
        -22
      ],
      [
        62,
        -22
      ],
      [
        13,
        -54
      ],
      [
        86,
        11
      ],
      [
        87,
        -22
      ],
      [
        49,
        11
      ],
      [
        -24,
        -54
      ],
      [
        12,
        -11
      ],
      [
        136,
        43
      ],
      [
        25,
        -11
      ],
      [
        -12,
        -97
      ],
      [
        -25,
        -76
      ],
      [
        37,
        -11
      ],
      [
        62,
        98
      ],
      [
        25,
        11
      ],
      [
        186,
        10
      ],
      [
        260,
        -65
      ],
      [
        62,
        11
      ],
      [
        37,
        22
      ],
      [
        198,
        -44
      ],
      [
        260,
        -119
      ],
      [
        384,
        -195
      ],
      [
        211,
        -174
      ],
      [
        25,
        -43
      ],
      [
        86,
        -11
      ],
      [
        62,
        0
      ],
      [
        248,
        -162
      ],
      [
        87,
        -11
      ],
      [
        -25,
        65
      ],
      [
        25,
        0
      ],
      [
        74,
        -87
      ],
      [
        62,
        -43
      ],
      [
        62,
        -76
      ],
      [
        124,
        -54
      ],
      [
        74,
        -22
      ],
      [
        25,
        -163
      ],
      [
        25,
        -32
      ],
      [
        0,
        -76
      ],
      [
        49,
        -33
      ],
      [
        37,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -130
      ],
      [
        -25,
        -54
      ],
      [
        -235,
        -228
      ],
      [
        -136,
        -98
      ],
      [
        -285,
        -108
      ],
      [
        -211,
        -33
      ],
      [
        -99,
        0
      ],
      [
        -161,
        11
      ],
      [
        -99,
        22
      ],
      [
        -111,
        65
      ],
      [
        -112,
        22
      ],
      [
        -74,
        21
      ],
      [
        -136,
        0
      ],
      [
        -347,
        76
      ],
      [
        -186,
        120
      ],
      [
        -112,
        -44
      ],
      [
        -37,
        44
      ],
      [
        25,
        21
      ],
      [
        -111,
        33
      ],
      [
        -87,
        0
      ],
      [
        -37,
        32
      ],
      [
        -62,
        22
      ],
      [
        -37,
        -11
      ],
      [
        -112,
        44
      ],
      [
        -50,
        43
      ],
      [
        -61,
        76
      ],
      [
        37,
        32
      ],
      [
        -186,
        44
      ],
      [
        -174,
        11
      ],
      [
        25,
        -22
      ],
      [
        75,
        -11
      ],
      [
        111,
        -65
      ],
      [
        -12,
        -54
      ],
      [
        136,
        -109
      ],
      [
        25,
        -32
      ],
      [
        86,
        -11
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        13,
        -33
      ],
      [
        148,
        -54
      ],
      [
        -24,
        -32
      ],
      [
        -13,
        -44
      ],
      [
        186,
        -54
      ],
      [
        99,
        -65
      ],
      [
        112,
        -109
      ],
      [
        24,
        -54
      ],
      [
        0,
        -65
      ],
      [
        -61,
        -152
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        37,
        -76
      ],
      [
        49,
        -65
      ],
      [
        50,
        -119
      ],
      [
        0,
        -108
      ],
      [
        49,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        13,
        -87
      ],
      [
        49,
        -76
      ],
      [
        87,
        -54
      ],
      [
        124,
        11
      ],
      [
        49,
        -22
      ],
      [
        124,
        -98
      ],
      [
        50,
        -87
      ],
      [
        25,
        -21
      ],
      [
        123,
        -44
      ],
      [
        87,
        -21
      ],
      [
        136,
        -55
      ],
      [
        25,
        0
      ],
      [
        62,
        44
      ],
      [
        124,
        43
      ],
      [
        25,
        44
      ],
      [
        0,
        43
      ],
      [
        -25,
        76
      ],
      [
        -12,
        65
      ],
      [
        -38,
        33
      ],
      [
        -37,
        10
      ],
      [
        -148,
        -10
      ],
      [
        -38,
        21
      ],
      [
        -49,
        54
      ],
      [
        -99,
        120
      ],
      [
        -50,
        43
      ],
      [
        -25,
        54
      ],
      [
        0,
        65
      ],
      [
        38,
        -10
      ],
      [
        49,
        32
      ],
      [
        25,
        119
      ],
      [
        99,
        11
      ],
      [
        124,
        -54
      ],
      [
        173,
        -141
      ],
      [
        37,
        -11
      ],
      [
        100,
        0
      ],
      [
        37,
        -43
      ],
      [
        25,
        0
      ],
      [
        161,
        -44
      ],
      [
        173,
        -97
      ],
      [
        62,
        11
      ],
      [
        37,
        65
      ],
      [
        74,
        54
      ],
      [
        50,
        11
      ],
      [
        62,
        -22
      ],
      [
        12,
        11
      ],
      [
        -49,
        141
      ],
      [
        -50,
        43
      ],
      [
        -124,
        174
      ],
      [
        -12,
        65
      ],
      [
        25,
        98
      ],
      [
        173,
        86
      ],
      [
        62,
        65
      ],
      [
        62,
        76
      ],
      [
        136,
        33
      ],
      [
        137,
        65
      ],
      [
        99,
        87
      ],
      [
        111,
        130
      ],
      [
        37,
        32
      ],
      [
        87,
        -21
      ],
      [
        50,
        -44
      ],
      [
        74,
        -11
      ],
      [
        62,
        11
      ],
      [
        87,
        0
      ],
      [
        111,
        -65
      ],
      [
        25,
        -43
      ],
      [
        -37,
        -76
      ],
      [
        74,
        22
      ],
      [
        37,
        -11
      ],
      [
        62,
        -54
      ],
      [
        37,
        10
      ],
      [
        -12,
        98
      ],
      [
        37,
        108
      ],
      [
        37,
        55
      ],
      [
        62,
        108
      ],
      [
        -25,
        87
      ],
      [
        0,
        87
      ],
      [
        -12,
        43
      ],
      [
        -37,
        54
      ],
      [
        -75,
        44
      ],
      [
        -74,
        10
      ],
      [
        -25,
        44
      ],
      [
        0,
        43
      ],
      [
        25,
        76
      ],
      [
        62,
        141
      ],
      [
        74,
        250
      ],
      [
        -12,
        21
      ],
      [
        0,
        98
      ],
      [
        -12,
        43
      ],
      [
        -261,
        174
      ],
      [
        -24,
        43
      ],
      [
        37,
        0
      ],
      [
        198,
        -76
      ],
      [
        50,
        -11
      ],
      [
        309,
        22
      ],
      [
        149,
        -22
      ],
      [
        136,
        -32
      ],
      [
        87,
        -119
      ],
      [
        186,
        -207
      ],
      [
        0,
        -75
      ],
      [
        -87,
        -11
      ],
      [
        -99,
        0
      ],
      [
        -211,
        -44
      ],
      [
        -62,
        -43
      ],
      [
        -148,
        -130
      ],
      [
        -13,
        -44
      ],
      [
        13,
        -32
      ],
      [
        74,
        -43
      ],
      [
        136,
        -66
      ],
      [
        112,
        -184
      ],
      [
        74,
        -32
      ],
      [
        74,
        0
      ],
      [
        62,
        -22
      ],
      [
        75,
        11
      ],
      [
        272,
        65
      ],
      [
        62,
        32
      ],
      [
        13,
        44
      ],
      [
        24,
        141
      ],
      [
        50,
        119
      ],
      [
        -13,
        76
      ],
      [
        137,
        43
      ],
      [
        124,
        22
      ],
      [
        62,
        0
      ],
      [
        24,
        33
      ],
      [
        -49,
        54
      ],
      [
        37,
        21
      ],
      [
        99,
        11
      ],
      [
        273,
        120
      ],
      [
        99,
        65
      ],
      [
        161,
        86
      ],
      [
        49,
        22
      ],
      [
        87,
        11
      ],
      [
        87,
        22
      ],
      [
        99,
        43
      ],
      [
        124,
        43
      ],
      [
        49,
        0
      ],
      [
        50,
        -54
      ],
      [
        -37,
        -43
      ],
      [
        24,
        -22
      ],
      [
        50,
        0
      ],
      [
        25,
        22
      ],
      [
        74,
        32
      ],
      [
        12,
        33
      ],
      [
        -24,
        11
      ],
      [
        -25,
        54
      ],
      [
        -75,
        11
      ],
      [
        112,
        76
      ],
      [
        260,
        119
      ],
      [
        124,
        43
      ],
      [
        136,
        11
      ],
      [
        62,
        -21
      ],
      [
        -173,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        62,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        -49,
        -98
      ],
      [
        62,
        -65
      ],
      [
        0,
        -65
      ],
      [
        -38,
        -32
      ],
      [
        -49,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -75,
        -11
      ],
      [
        -37,
        -54
      ],
      [
        87,
        0
      ],
      [
        136,
        -22
      ],
      [
        74,
        22
      ],
      [
        38,
        0
      ],
      [
        86,
        22
      ],
      [
        87,
        -66
      ],
      [
        50,
        11
      ],
      [
        12,
        109
      ],
      [
        87,
        65
      ],
      [
        86,
        54
      ],
      [
        87,
        0
      ],
      [
        87,
        43
      ],
      [
        124,
        -10
      ],
      [
        124,
        0
      ],
      [
        99,
        -33
      ],
      [
        74,
        -11
      ],
      [
        111,
        54
      ],
      [
        248,
        152
      ],
      [
        25,
        -32
      ],
      [
        37,
        54
      ],
      [
        186,
        54
      ],
      [
        50,
        0
      ],
      [
        24,
        -65
      ],
      [
        37,
        -32
      ],
      [
        50,
        -65
      ],
      [
        -50,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        -12,
        -98
      ],
      [
        74,
        -32
      ],
      [
        112,
        -33
      ],
      [
        37,
        0
      ],
      [
        62,
        43
      ],
      [
        12,
        55
      ],
      [
        -25,
        65
      ],
      [
        13,
        65
      ],
      [
        87,
        -11
      ],
      [
        111,
        22
      ],
      [
        50,
        32
      ],
      [
        99,
        130
      ],
      [
        -25,
        98
      ],
      [
        -62,
        -22
      ],
      [
        -112,
        217
      ],
      [
        -61,
        87
      ],
      [
        37,
        32
      ],
      [
        99,
        22
      ],
      [
        87,
        87
      ],
      [
        74,
        22
      ],
      [
        260,
        -55
      ],
      [
        297,
        -21
      ],
      [
        248,
        -44
      ],
      [
        285,
        -86
      ],
      [
        136,
        -55
      ],
      [
        112,
        -76
      ],
      [
        -13,
        -43
      ],
      [
        50,
        11
      ],
      [
        99,
        -44
      ],
      [
        74,
        -10
      ],
      [
        75,
        -33
      ],
      [
        24,
        -32
      ],
      [
        99,
        -22
      ],
      [
        87,
        -54
      ],
      [
        25,
        0
      ],
      [
        111,
        -44
      ],
      [
        87,
        -11
      ],
      [
        50,
        -75
      ],
      [
        173,
        -109
      ],
      [
        25,
        -32
      ],
      [
        149,
        -76
      ],
      [
        74,
        -55
      ],
      [
        49,
        22
      ],
      [
        112,
        141
      ],
      [
        99,
        239
      ],
      [
        -74,
        0
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -99,
        87
      ],
      [
        -87,
        108
      ],
      [
        -12,
        119
      ],
      [
        -25,
        33
      ],
      [
        -87,
        33
      ],
      [
        -49,
        32
      ],
      [
        -186,
        76
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        11
      ],
      [
        12,
        109
      ],
      [
        37,
        108
      ],
      [
        75,
        11
      ],
      [
        37,
        43
      ],
      [
        -37,
        76
      ],
      [
        0,
        44
      ],
      [
        37,
        130
      ],
      [
        12,
        152
      ],
      [
        -49,
        54
      ],
      [
        -112,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -12,
        54
      ],
      [
        62,
        98
      ],
      [
        -62,
        -11
      ],
      [
        -13,
        22
      ],
      [
        99,
        130
      ],
      [
        124,
        43
      ],
      [
        236,
        120
      ],
      [
        99,
        86
      ],
      [
        74,
        109
      ],
      [
        50,
        97
      ],
      [
        74,
        239
      ],
      [
        74,
        174
      ],
      [
        112,
        173
      ],
      [
        111,
        22
      ],
      [
        -25,
        -54
      ],
      [
        87,
        -11
      ],
      [
        99,
        11
      ],
      [
        161,
        0
      ],
      [
        298,
        10
      ],
      [
        148,
        -54
      ],
      [
        62,
        0
      ],
      [
        112,
        -22
      ],
      [
        124,
        -65
      ],
      [
        0,
        -130
      ],
      [
        -13,
        -87
      ],
      [
        -62,
        -206
      ],
      [
        -74,
        -119
      ],
      [
        -25,
        -76
      ],
      [
        -62,
        -54
      ],
      [
        -74,
        -43
      ],
      [
        -13,
        -55
      ],
      [
        75,
        -97
      ],
      [
        173,
        -98
      ],
      [
        37,
        -108
      ],
      [
        13,
        -87
      ],
      [
        -13,
        -228
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        25,
        -65
      ],
      [
        12,
        -239
      ],
      [
        13,
        -195
      ],
      [
        -25,
        -65
      ],
      [
        -13,
        -184
      ],
      [
        25,
        -65
      ],
      [
        37,
        -66
      ],
      [
        38,
        -32
      ],
      [
        136,
        -65
      ],
      [
        124,
        -87
      ],
      [
        12,
        -54
      ],
      [
        -50,
        -33
      ],
      [
        -111,
        -162
      ],
      [
        12,
        -131
      ],
      [
        0,
        -65
      ],
      [
        -74,
        -108
      ],
      [
        -124,
        -65
      ],
      [
        -248,
        -358
      ],
      [
        -62,
        -43
      ],
      [
        -111,
        10
      ],
      [
        62,
        -119
      ],
      [
        0,
        -54
      ],
      [
        -62,
        0
      ],
      [
        -99,
        -43
      ],
      [
        -50,
        -44
      ],
      [
        -74,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -61,
        33
      ],
      [
        12,
        32
      ],
      [
        87,
        65
      ],
      [
        -38,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -62,
        -11
      ],
      [
        -62,
        43
      ],
      [
        -49,
        55
      ],
      [
        -74,
        -11
      ],
      [
        -174,
        11
      ],
      [
        -49,
        -11
      ],
      [
        -13,
        -33
      ],
      [
        25,
        -76
      ],
      [
        25,
        -43
      ],
      [
        74,
        -44
      ],
      [
        99,
        -10
      ],
      [
        99,
        -55
      ],
      [
        124,
        -32
      ],
      [
        273,
        11
      ],
      [
        148,
        -22
      ],
      [
        112,
        -54
      ],
      [
        62,
        0
      ],
      [
        86,
        54
      ],
      [
        13,
        108
      ],
      [
        12,
        33
      ],
      [
        322,
        152
      ],
      [
        62,
        32
      ],
      [
        99,
        87
      ],
      [
        25,
        54
      ],
      [
        37,
        152
      ],
      [
        25,
        54
      ],
      [
        211,
        174
      ],
      [
        37,
        54
      ],
      [
        0,
        130
      ],
      [
        -13,
        55
      ],
      [
        -37,
        97
      ],
      [
        -37,
        44
      ],
      [
        -49,
        75
      ],
      [
        37,
        152
      ],
      [
        24,
        55
      ],
      [
        199,
        75
      ],
      [
        148,
        22
      ],
      [
        186,
        44
      ],
      [
        74,
        10
      ],
      [
        50,
        -10
      ],
      [
        50,
        -44
      ],
      [
        37,
        -76
      ],
      [
        136,
        -119
      ],
      [
        37,
        -76
      ],
      [
        13,
        -98
      ],
      [
        0,
        -227
      ],
      [
        -25,
        -109
      ],
      [
        49,
        -21
      ],
      [
        87,
        -66
      ],
      [
        25,
        -32
      ],
      [
        37,
        -11
      ],
      [
        74,
        0
      ],
      [
        211,
        11
      ],
      [
        111,
        0
      ],
      [
        -24,
        32
      ],
      [
        -100,
        0
      ],
      [
        -136,
        22
      ],
      [
        -198,
        54
      ],
      [
        -25,
        98
      ],
      [
        50,
        173
      ],
      [
        37,
        22
      ],
      [
        74,
        22
      ],
      [
        -24,
        141
      ],
      [
        -50,
        87
      ],
      [
        -37,
        173
      ],
      [
        -62,
        0
      ],
      [
        -50,
        33
      ],
      [
        -235,
        97
      ],
      [
        -223,
        76
      ],
      [
        -149,
        11
      ],
      [
        -49,
        -11
      ],
      [
        -124,
        -76
      ],
      [
        -87,
        -11
      ],
      [
        -161,
        33
      ],
      [
        -124,
        -22
      ],
      [
        -49,
        22
      ],
      [
        -25,
        32
      ],
      [
        37,
        141
      ],
      [
        -12,
        55
      ],
      [
        -62,
        65
      ],
      [
        -37,
        54
      ],
      [
        12,
        65
      ],
      [
        87,
        228
      ],
      [
        37,
        65
      ],
      [
        87,
        108
      ],
      [
        49,
        87
      ],
      [
        -12,
        43
      ],
      [
        -198,
        261
      ],
      [
        -75,
        119
      ],
      [
        -124,
        76
      ],
      [
        -24,
        33
      ],
      [
        198,
        249
      ],
      [
        99,
        43
      ],
      [
        186,
        55
      ],
      [
        111,
        54
      ],
      [
        62,
        43
      ],
      [
        37,
        76
      ],
      [
        0,
        98
      ],
      [
        -12,
        76
      ],
      [
        -99,
        162
      ],
      [
        62,
        33
      ],
      [
        62,
        -11
      ],
      [
        74,
        -33
      ],
      [
        87,
        -130
      ],
      [
        0,
        -76
      ],
      [
        12,
        -54
      ],
      [
        37,
        -54
      ],
      [
        -74,
        -76
      ],
      [
        -50,
        -119
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        -87
      ],
      [
        87,
        -108
      ],
      [
        -25,
        -98
      ],
      [
        -50,
        -32
      ],
      [
        13,
        -66
      ],
      [
        272,
        -75
      ],
      [
        223,
        -11
      ],
      [
        62,
        -44
      ],
      [
        25,
        33
      ],
      [
        198,
        -11
      ],
      [
        161,
        -108
      ],
      [
        87,
        -33
      ],
      [
        74,
        -11
      ],
      [
        149,
        11
      ],
      [
        49,
        43
      ],
      [
        -74,
        0
      ],
      [
        -25,
        -21
      ],
      [
        -74,
        11
      ],
      [
        -37,
        21
      ],
      [
        -37,
        44
      ],
      [
        -62,
        108
      ],
      [
        -99,
        33
      ],
      [
        -75,
        -11
      ],
      [
        -74,
        11
      ],
      [
        -211,
        86
      ],
      [
        -148,
        65
      ],
      [
        -38,
        22
      ],
      [
        -37,
        54
      ],
      [
        -62,
        141
      ],
      [
        137,
        65
      ],
      [
        148,
        11
      ],
      [
        62,
        -11
      ],
      [
        174,
        -108
      ],
      [
        74,
        0
      ],
      [
        149,
        43
      ],
      [
        12,
        33
      ],
      [
        -74,
        87
      ],
      [
        -87,
        10
      ],
      [
        -99,
        -21
      ],
      [
        -25,
        21
      ],
      [
        25,
        44
      ],
      [
        49,
        11
      ],
      [
        124,
        76
      ],
      [
        87,
        32
      ],
      [
        87,
        11
      ],
      [
        322,
        -11
      ],
      [
        186,
        -97
      ],
      [
        173,
        -44
      ],
      [
        124,
        -54
      ],
      [
        12,
        -54
      ],
      [
        223,
        -141
      ],
      [
        50,
        -22
      ],
      [
        148,
        -11
      ],
      [
        236,
        44
      ],
      [
        74,
        -11
      ],
      [
        87,
        -54
      ],
      [
        -87,
        -131
      ],
      [
        -25,
        -21
      ],
      [
        -198,
        -98
      ],
      [
        -37,
        -163
      ],
      [
        37,
        -119
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        13,
        -54
      ],
      [
        24,
        11
      ],
      [
        62,
        97
      ],
      [
        50,
        119
      ],
      [
        49,
        33
      ],
      [
        50,
        11
      ],
      [
        50,
        -33
      ],
      [
        12,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -65
      ],
      [
        -38,
        -108
      ],
      [
        -62,
        -76
      ],
      [
        -12,
        -44
      ],
      [
        50,
        -76
      ],
      [
        37,
        -10
      ],
      [
        49,
        10
      ],
      [
        13,
        33
      ],
      [
        -25,
        76
      ],
      [
        74,
        32
      ],
      [
        75,
        11
      ],
      [
        61,
        44
      ],
      [
        25,
        86
      ],
      [
        -136,
        272
      ],
      [
        -62,
        75
      ],
      [
        37,
        109
      ],
      [
        62,
        119
      ],
      [
        37,
        44
      ],
      [
        0,
        65
      ],
      [
        -74,
        108
      ],
      [
        -50,
        33
      ],
      [
        -198,
        32
      ],
      [
        -124,
        109
      ],
      [
        -24,
        86
      ],
      [
        -38,
        22
      ],
      [
        -173,
        54
      ],
      [
        -99,
        0
      ],
      [
        -62,
        22
      ],
      [
        -112,
        76
      ],
      [
        -24,
        87
      ],
      [
        -25,
        32
      ],
      [
        62,
        152
      ],
      [
        -25,
        43
      ],
      [
        -87,
        44
      ],
      [
        -24,
        87
      ],
      [
        -13,
        86
      ],
      [
        75,
        65
      ],
      [
        -13,
        65
      ],
      [
        310,
        44
      ],
      [
        111,
        11
      ],
      [
        595,
        0
      ],
      [
        49,
        21
      ],
      [
        261,
        22
      ],
      [
        111,
        22
      ],
      [
        112,
        -33
      ],
      [
        37,
        11
      ],
      [
        86,
        0
      ],
      [
        62,
        54
      ],
      [
        124,
        22
      ],
      [
        211,
        22
      ],
      [
        99,
        0
      ],
      [
        50,
        -44
      ],
      [
        -112,
        -65
      ],
      [
        -111,
        -54
      ],
      [
        -100,
        -33
      ],
      [
        -86,
        -54
      ],
      [
        -13,
        -76
      ],
      [
        13,
        -21
      ],
      [
        86,
        -33
      ],
      [
        75,
        -54
      ],
      [
        124,
        -54
      ],
      [
        24,
        11
      ],
      [
        -285,
        162
      ],
      [
        13,
        44
      ],
      [
        49,
        43
      ],
      [
        100,
        32
      ],
      [
        260,
        22
      ],
      [
        86,
        98
      ],
      [
        62,
        32
      ],
      [
        -124,
        44
      ],
      [
        -173,
        195
      ],
      [
        -37,
        32
      ],
      [
        -136,
        22
      ],
      [
        -62,
        22
      ],
      [
        62,
        65
      ],
      [
        74,
        22
      ],
      [
        49,
        -11
      ],
      [
        124,
        -76
      ],
      [
        112,
        32
      ],
      [
        -124,
        44
      ],
      [
        -62,
        54
      ],
      [
        -198,
        65
      ],
      [
        -112,
        11
      ],
      [
        25,
        54
      ],
      [
        87,
        11
      ],
      [
        25,
        43
      ],
      [
        161,
        -86
      ],
      [
        74,
        21
      ],
      [
        62,
        33
      ],
      [
        124,
        108
      ],
      [
        12,
        44
      ],
      [
        -111,
        32
      ],
      [
        -62,
        0
      ],
      [
        -13,
        33
      ],
      [
        38,
        32
      ],
      [
        49,
        11
      ],
      [
        173,
        -32
      ],
      [
        285,
        97
      ],
      [
        87,
        44
      ],
      [
        198,
        65
      ],
      [
        99,
        0
      ],
      [
        199,
        76
      ],
      [
        284,
        43
      ],
      [
        162,
        0
      ],
      [
        123,
        43
      ],
      [
        199,
        11
      ],
      [
        62,
        22
      ],
      [
        322,
        43
      ],
      [
        49,
        44
      ],
      [
        -37,
        21
      ],
      [
        -62,
        -32
      ],
      [
        -99,
        32
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        11
      ],
      [
        -13,
        43
      ],
      [
        37,
        54
      ],
      [
        50,
        -32
      ],
      [
        50,
        43
      ],
      [
        37,
        11
      ],
      [
        99,
        -33
      ],
      [
        62,
        33
      ],
      [
        99,
        11
      ],
      [
        136,
        -11
      ],
      [
        25,
        32
      ],
      [
        161,
        -32
      ],
      [
        111,
        22
      ],
      [
        75,
        0
      ],
      [
        111,
        -22
      ],
      [
        50,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -112,
        -65
      ],
      [
        25,
        -22
      ],
      [
        75,
        43
      ],
      [
        198,
        44
      ],
      [
        25,
        -11
      ],
      [
        -38,
        -54
      ],
      [
        137,
        21
      ],
      [
        111,
        55
      ],
      [
        50,
        10
      ],
      [
        49,
        -32
      ],
      [
        50,
        22
      ],
      [
        12,
        32
      ],
      [
        87,
        11
      ],
      [
        87,
        43
      ],
      [
        161,
        55
      ],
      [
        111,
        -22
      ],
      [
        223,
        -76
      ],
      [
        74,
        33
      ],
      [
        -74,
        65
      ],
      [
        -186,
        86
      ],
      [
        -37,
        33
      ],
      [
        -62,
        22
      ],
      [
        25,
        21
      ],
      [
        248,
        -21
      ],
      [
        124,
        10
      ],
      [
        123,
        -10
      ],
      [
        186,
        32
      ],
      [
        75,
        -32
      ],
      [
        86,
        0
      ],
      [
        99,
        -22
      ],
      [
        25,
        32
      ],
      [
        -161,
        33
      ],
      [
        -74,
        -11
      ],
      [
        -25,
        22
      ],
      [
        62,
        87
      ],
      [
        -25,
        54
      ],
      [
        -37,
        22
      ],
      [
        0,
        54
      ],
      [
        25,
        54
      ],
      [
        62,
        22
      ],
      [
        37,
        43
      ],
      [
        87,
        65
      ],
      [
        371,
        195
      ],
      [
        174,
        65
      ],
      [
        148,
        11
      ],
      [
        161,
        54
      ],
      [
        62,
        0
      ],
      [
        211,
        -43
      ],
      [
        49,
        -32
      ],
      [
        124,
        -33
      ],
      [
        137,
        -11
      ],
      [
        61,
        -22
      ],
      [
        62,
        -65
      ],
      [
        -111,
        -21
      ],
      [
        -124,
        -76
      ],
      [
        -161,
        -44
      ],
      [
        -198,
        -21
      ],
      [
        -50,
        -22
      ],
      [
        496,
        0
      ],
      [
        25,
        -65
      ],
      [
        37,
        0
      ],
      [
        111,
        33
      ],
      [
        75,
        0
      ],
      [
        123,
        -22
      ],
      [
        75,
        11
      ],
      [
        124,
        -22
      ],
      [
        49,
        -43
      ],
      [
        -173,
        -120
      ],
      [
        -99,
        -97
      ],
      [
        -87,
        11
      ],
      [
        12,
        -55
      ],
      [
        87,
        0
      ],
      [
        50,
        -21
      ],
      [
        111,
        32
      ],
      [
        161,
        -11
      ],
      [
        99,
        44
      ],
      [
        37,
        86
      ],
      [
        62,
        11
      ],
      [
        149,
        -11
      ],
      [
        260,
        22
      ],
      [
        211,
        -22
      ],
      [
        161,
        22
      ],
      [
        223,
        -22
      ],
      [
        99,
        -21
      ],
      [
        74,
        -33
      ],
      [
        62,
        -11
      ],
      [
        99,
        -86
      ],
      [
        -25,
        -33
      ],
      [
        99,
        11
      ],
      [
        38,
        -22
      ],
      [
        74,
        -11
      ],
      [
        25,
        -108
      ],
      [
        37,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        37,
        -11
      ],
      [
        75,
        33
      ],
      [
        37,
        43
      ],
      [
        -62,
        44
      ],
      [
        37,
        10
      ],
      [
        62,
        -10
      ],
      [
        37,
        -44
      ],
      [
        62,
        -173
      ],
      [
        99,
        11
      ],
      [
        12,
        -44
      ],
      [
        -86,
        -162
      ],
      [
        -50,
        43
      ],
      [
        -124,
        22
      ],
      [
        -173,
        86
      ],
      [
        -62,
        0
      ],
      [
        99,
        -54
      ],
      [
        74,
        -108
      ],
      [
        75,
        32
      ],
      [
        62,
        -54
      ],
      [
        74,
        -22
      ],
      [
        62,
        -32
      ],
      [
        -37,
        -98
      ],
      [
        -248,
        -173
      ],
      [
        -248,
        -98
      ],
      [
        -111,
        -76
      ],
      [
        -198,
        -43
      ],
      [
        -137,
        -76
      ],
      [
        -173,
        -54
      ],
      [
        -50,
        -55
      ],
      [
        -136,
        -32
      ],
      [
        25,
        -33
      ],
      [
        -37,
        -65
      ],
      [
        -99,
        -43
      ],
      [
        -149,
        -44
      ],
      [
        -310,
        -206
      ],
      [
        -148,
        -43
      ],
      [
        -174,
        0
      ],
      [
        -198,
        -184
      ],
      [
        -173,
        -11
      ],
      [
        -174,
        -217
      ],
      [
        -99,
        -76
      ],
      [
        12,
        -33
      ],
      [
        100,
        33
      ],
      [
        123,
        65
      ],
      [
        50,
        65
      ],
      [
        87,
        54
      ],
      [
        223,
        22
      ],
      [
        86,
        -11
      ],
      [
        137,
        11
      ],
      [
        86,
        43
      ],
      [
        99,
        11
      ],
      [
        13,
        33
      ],
      [
        87,
        0
      ],
      [
        173,
        43
      ],
      [
        87,
        65
      ],
      [
        99,
        -21
      ],
      [
        74,
        10
      ],
      [
        198,
        98
      ],
      [
        124,
        43
      ],
      [
        25,
        22
      ],
      [
        -50,
        33
      ],
      [
        -111,
        -33
      ],
      [
        -99,
        -11
      ],
      [
        -124,
        11
      ],
      [
        -25,
        43
      ],
      [
        74,
        87
      ],
      [
        137,
        54
      ],
      [
        272,
        -54
      ],
      [
        25,
        76
      ],
      [
        136,
        -22
      ],
      [
        -111,
        -32
      ],
      [
        25,
        -54
      ],
      [
        37,
        -33
      ],
      [
        136,
        -54
      ],
      [
        124,
        -22
      ],
      [
        87,
        0
      ],
      [
        136,
        22
      ],
      [
        49,
        54
      ],
      [
        -37,
        76
      ],
      [
        62,
        -22
      ],
      [
        62,
        -54
      ],
      [
        74,
        -119
      ],
      [
        -12,
        -33
      ],
      [
        -74,
        -86
      ],
      [
        37,
        -33
      ],
      [
        74,
        -33
      ],
      [
        0,
        -184
      ],
      [
        -37,
        -65
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        -44
      ],
      [
        25,
        -65
      ],
      [
        37,
        -43
      ],
      [
        124,
        -11
      ],
      [
        13,
        11
      ],
      [
        -112,
        32
      ],
      [
        -50,
        65
      ],
      [
        62,
        76
      ],
      [
        50,
        76
      ],
      [
        12,
        54
      ],
      [
        -12,
        55
      ],
      [
        25,
        32
      ],
      [
        86,
        43
      ],
      [
        -61,
        22
      ],
      [
        -50,
        33
      ],
      [
        -12,
        43
      ],
      [
        111,
        22
      ],
      [
        74,
        32
      ],
      [
        261,
        11
      ],
      [
        185,
        54
      ],
      [
        397,
        -10
      ],
      [
        272,
        -55
      ],
      [
        397,
        0
      ],
      [
        148,
        -32
      ],
      [
        13,
        -33
      ],
      [
        -62,
        -11
      ],
      [
        -99,
        0
      ],
      [
        -25,
        -65
      ],
      [
        12,
        -76
      ],
      [
        186,
        -75
      ],
      [
        161,
        -33
      ],
      [
        112,
        -54
      ],
      [
        62,
        -11
      ],
      [
        235,
        11
      ],
      [
        136,
        -33
      ],
      [
        124,
        22
      ],
      [
        173,
        0
      ],
      [
        50,
        -43
      ],
      [
        87,
        -11
      ],
      [
        86,
        0
      ],
      [
        62,
        11
      ],
      [
        13,
        21
      ],
      [
        -87,
        22
      ],
      [
        12,
        32
      ],
      [
        38,
        11
      ],
      [
        123,
        -43
      ],
      [
        62,
        -11
      ],
      [
        50,
        33
      ],
      [
        49,
        86
      ],
      [
        62,
        33
      ],
      [
        -49,
        43
      ],
      [
        -62,
        109
      ],
      [
        0,
        65
      ],
      [
        37,
        65
      ],
      [
        25,
        11
      ],
      [
        99,
        -22
      ],
      [
        50,
        43
      ],
      [
        161,
        33
      ],
      [
        49,
        0
      ],
      [
        87,
        -22
      ],
      [
        285,
        -119
      ],
      [
        -13,
        -43
      ],
      [
        75,
        10
      ],
      [
        37,
        22
      ],
      [
        74,
        11
      ],
      [
        50,
        22
      ],
      [
        24,
        -33
      ],
      [
        -24,
        -54
      ],
      [
        99,
        -54
      ],
      [
        99,
        65
      ],
      [
        62,
        76
      ],
      [
        248,
        -44
      ],
      [
        74,
        -21
      ],
      [
        25,
        -44
      ],
      [
        86,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        124,
        0
      ],
      [
        99,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        24,
        -21
      ],
      [
        62,
        0
      ],
      [
        -86,
        -87
      ],
      [
        -87,
        -43
      ],
      [
        25,
        -11
      ],
      [
        111,
        0
      ],
      [
        74,
        -65
      ],
      [
        13,
        -44
      ],
      [
        -149,
        -76
      ],
      [
        -62,
        -21
      ],
      [
        -74,
        -11
      ],
      [
        37,
        -22
      ],
      [
        198,
        -11
      ],
      [
        62,
        -21
      ],
      [
        37,
        -76
      ],
      [
        0,
        -98
      ],
      [
        -37,
        -43
      ],
      [
        -124,
        -11
      ],
      [
        -161,
        108
      ],
      [
        -86,
        33
      ],
      [
        -137,
        76
      ],
      [
        -24,
        -11
      ],
      [
        37,
        -65
      ],
      [
        62,
        -33
      ],
      [
        111,
        -108
      ],
      [
        198,
        -206
      ],
      [
        62,
        43
      ],
      [
        62,
        22
      ],
      [
        62,
        -76
      ],
      [
        -87,
        11
      ],
      [
        -86,
        -22
      ],
      [
        -37,
        -32
      ],
      [
        24,
        -44
      ],
      [
        75,
        0
      ],
      [
        24,
        -54
      ],
      [
        62,
        -65
      ],
      [
        124,
        -174
      ],
      [
        87,
        -32
      ],
      [
        99,
        -76
      ],
      [
        124,
        -44
      ],
      [
        37,
        55
      ],
      [
        25,
        -22
      ],
      [
        25,
        -87
      ],
      [
        37,
        -32
      ],
      [
        87,
        11
      ],
      [
        61,
        43
      ],
      [
        38,
        43
      ],
      [
        74,
        130
      ],
      [
        87,
        87
      ],
      [
        -13,
        65
      ],
      [
        112,
        239
      ],
      [
        111,
        119
      ],
      [
        62,
        -97
      ],
      [
        112,
        -98
      ],
      [
        99,
        -76
      ],
      [
        86,
        -32
      ],
      [
        149,
        -33
      ],
      [
        198,
        0
      ],
      [
        38,
        43
      ],
      [
        74,
        33
      ],
      [
        124,
        22
      ],
      [
        62,
        43
      ],
      [
        111,
        11
      ],
      [
        186,
        -33
      ],
      [
        235,
        -97
      ],
      [
        236,
        -163
      ],
      [
        49,
        -22
      ],
      [
        25,
        11
      ],
      [
        -50,
        54
      ],
      [
        50,
        22
      ],
      [
        37,
        54
      ],
      [
        -62,
        22
      ],
      [
        0,
        33
      ],
      [
        25,
        10
      ],
      [
        12,
        44
      ],
      [
        62,
        43
      ],
      [
        37,
        11
      ],
      [
        75,
        -33
      ],
      [
        49,
        44
      ],
      [
        37,
        0
      ],
      [
        75,
        -44
      ],
      [
        74,
        -75
      ],
      [
        37,
        0
      ],
      [
        99,
        32
      ],
      [
        124,
        0
      ],
      [
        -12,
        43
      ],
      [
        -87,
        87
      ],
      [
        13,
        120
      ],
      [
        -124,
        43
      ],
      [
        99,
        22
      ],
      [
        62,
        97
      ],
      [
        99,
        33
      ],
      [
        -174,
        11
      ],
      [
        -62,
        -33
      ],
      [
        -86,
        0
      ],
      [
        -13,
        98
      ],
      [
        149,
        108
      ],
      [
        297,
        0
      ],
      [
        87,
        11
      ],
      [
        124,
        43
      ],
      [
        -25,
        33
      ],
      [
        0,
        54
      ],
      [
        -111,
        76
      ],
      [
        12,
        33
      ],
      [
        211,
        -22
      ],
      [
        74,
        -44
      ],
      [
        186,
        -43
      ],
      [
        495,
        -11
      ],
      [
        62,
        -21
      ],
      [
        211,
        -22
      ],
      [
        309,
        -44
      ],
      [
        100,
        -10
      ],
      [
        74,
        -33
      ],
      [
        124,
        -11
      ],
      [
        62,
        -21
      ],
      [
        0,
        -55
      ],
      [
        -273,
        0
      ],
      [
        -87,
        22
      ],
      [
        -99,
        0
      ],
      [
        -49,
        -11
      ],
      [
        -62,
        -43
      ],
      [
        -149,
        -33
      ],
      [
        50,
        -43
      ],
      [
        62,
        -11
      ],
      [
        186,
        54
      ],
      [
        545,
        33
      ],
      [
        74,
        -11
      ],
      [
        0,
        -33
      ],
      [
        -74,
        -76
      ],
      [
        -75,
        -54
      ],
      [
        -99,
        -54
      ],
      [
        -37,
        0
      ],
      [
        87,
        119
      ],
      [
        -62,
        11
      ],
      [
        -87,
        44
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        -76
      ],
      [
        25,
        -22
      ],
      [
        0,
        -54
      ],
      [
        -111,
        -32
      ],
      [
        -50,
        0
      ],
      [
        -74,
        21
      ],
      [
        12,
        -43
      ],
      [
        -37,
        -65
      ],
      [
        25,
        -22
      ],
      [
        49,
        -11
      ],
      [
        211,
        33
      ],
      [
        87,
        32
      ],
      [
        99,
        76
      ],
      [
        186,
        174
      ],
      [
        74,
        54
      ],
      [
        111,
        32
      ],
      [
        335,
        -21
      ],
      [
        186,
        -33
      ],
      [
        186,
        -54
      ],
      [
        99,
        -43
      ],
      [
        62,
        -65
      ],
      [
        24,
        -65
      ],
      [
        -49,
        -33
      ],
      [
        -211,
        -11
      ],
      [
        -74,
        -11
      ],
      [
        -50,
        -54
      ],
      [
        25,
        -11
      ],
      [
        174,
        -21
      ],
      [
        148,
        -55
      ],
      [
        50,
        -43
      ],
      [
        186,
        11
      ],
      [
        24,
        -44
      ],
      [
        -148,
        -119
      ],
      [
        198,
        65
      ],
      [
        49,
        11
      ],
      [
        62,
        -11
      ],
      [
        149,
        -54
      ],
      [
        62,
        -43
      ],
      [
        111,
        -120
      ],
      [
        -111,
        -21
      ],
      [
        260,
        -98
      ],
      [
        99,
        0
      ],
      [
        223,
        32
      ],
      [
        124,
        0
      ],
      [
        211,
        55
      ],
      [
        210,
        43
      ],
      [
        198,
        0
      ],
      [
        99,
        33
      ],
      [
        273,
        0
      ],
      [
        260,
        -11
      ],
      [
        198,
        -22
      ],
      [
        236,
        -65
      ],
      [
        223,
        -87
      ],
      [
        161,
        -119
      ],
      [
        37,
        -65
      ],
      [
        25,
        -119
      ],
      [
        0,
        -55
      ],
      [
        -62,
        -86
      ],
      [
        12,
        -55
      ],
      [
        -49,
        -76
      ],
      [
        37,
        -54
      ],
      [
        99,
        -32
      ],
      [
        223,
        -55
      ],
      [
        49,
        -21
      ],
      [
        13,
        -98
      ],
      [
        37,
        -228
      ],
      [
        87,
        -65
      ],
      [
        12,
        -54
      ],
      [
        -74,
        -152
      ],
      [
        -87,
        -76
      ],
      [
        87,
        11
      ],
      [
        86,
        163
      ],
      [
        50,
        22
      ],
      [
        12,
        32
      ],
      [
        0,
        98
      ],
      [
        -24,
        86
      ],
      [
        0,
        66
      ],
      [
        24,
        43
      ],
      [
        137,
        108
      ],
      [
        74,
        44
      ],
      [
        74,
        21
      ],
      [
        198,
        22
      ],
      [
        87,
        22
      ],
      [
        99,
        -11
      ],
      [
        75,
        0
      ],
      [
        86,
        22
      ],
      [
        75,
        -11
      ],
      [
        111,
        -65
      ],
      [
        434,
        -22
      ],
      [
        74,
        -22
      ],
      [
        285,
        -32
      ],
      [
        25,
        0
      ],
      [
        62,
        43
      ],
      [
        198,
        109
      ],
      [
        74,
        0
      ],
      [
        37,
        -22
      ],
      [
        62,
        -76
      ],
      [
        37,
        -87
      ],
      [
        25,
        -108
      ],
      [
        37,
        -22
      ],
      [
        62,
        0
      ],
      [
        248,
        -97
      ],
      [
        25,
        -98
      ],
      [
        74,
        -87
      ],
      [
        161,
        11
      ],
      [
        161,
        22
      ],
      [
        149,
        130
      ],
      [
        0,
        54
      ],
      [
        -37,
        87
      ],
      [
        -50,
        76
      ],
      [
        -49,
        119
      ],
      [
        -149,
        33
      ],
      [
        12,
        32
      ],
      [
        62,
        44
      ],
      [
        50,
        65
      ],
      [
        -13,
        151
      ],
      [
        137,
        0
      ],
      [
        123,
        -10
      ],
      [
        248,
        -55
      ],
      [
        211,
        -21
      ],
      [
        99,
        -22
      ],
      [
        74,
        -43
      ],
      [
        75,
        -22
      ],
      [
        24,
        65
      ],
      [
        25,
        11
      ],
      [
        99,
        -33
      ],
      [
        75,
        -11
      ],
      [
        136,
        0
      ],
      [
        161,
        -10
      ],
      [
        173,
        0
      ],
      [
        149,
        32
      ],
      [
        124,
        -32
      ],
      [
        111,
        -55
      ],
      [
        174,
        -76
      ],
      [
        161,
        -21
      ],
      [
        186,
        -76
      ],
      [
        173,
        -22
      ],
      [
        149,
        -43
      ],
      [
        24,
        -54
      ],
      [
        112,
        -22
      ],
      [
        210,
        -163
      ],
      [
        50,
        -11
      ],
      [
        0,
        -2451
      ],
      [
        -62,
        -21
      ],
      [
        -62,
        -65
      ],
      [
        -74,
        -65
      ],
      [
        -99,
        -22
      ],
      [
        -161,
        -98
      ],
      [
        -62,
        -21
      ],
      [
        -75,
        43
      ],
      [
        -185,
        32
      ],
      [
        -62,
        33
      ],
      [
        -75,
        98
      ],
      [
        -37,
        21
      ],
      [
        -25,
        33
      ],
      [
        -99,
        43
      ],
      [
        -86,
        -32
      ],
      [
        0,
        -11
      ],
      [
        111,
        0
      ],
      [
        62,
        -44
      ],
      [
        25,
        -54
      ],
      [
        -50,
        -43
      ],
      [
        -86,
        43
      ],
      [
        -87,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -124,
        65
      ],
      [
        -99,
        -76
      ],
      [
        -124,
        -32
      ],
      [
        -111,
        -11
      ],
      [
        0,
        -11
      ],
      [
        87,
        0
      ],
      [
        111,
        22
      ],
      [
        62,
        22
      ],
      [
        74,
        54
      ],
      [
        38,
        -11
      ],
      [
        49,
        -65
      ],
      [
        12,
        -54
      ],
      [
        50,
        -11
      ],
      [
        87,
        -33
      ],
      [
        37,
        0
      ],
      [
        74,
        54
      ],
      [
        112,
        33
      ],
      [
        24,
        -22
      ],
      [
        -12,
        -97
      ],
      [
        0,
        -87
      ],
      [
        87,
        -87
      ],
      [
        99,
        -54
      ],
      [
        62,
        11
      ],
      [
        25,
        87
      ],
      [
        62,
        -66
      ],
      [
        24,
        -86
      ],
      [
        -12,
        -76
      ],
      [
        37,
        -22
      ],
      [
        37,
        0
      ],
      [
        25,
        -195
      ],
      [
        -99,
        -33
      ],
      [
        12,
        -21
      ],
      [
        62,
        -11
      ],
      [
        25,
        -22
      ],
      [
        -12,
        -76
      ],
      [
        37,
        22
      ],
      [
        -13,
        43
      ],
      [
        13,
        22
      ],
      [
        49,
        -119
      ],
      [
        38,
        -44
      ],
      [
        99,
        -54
      ],
      [
        24,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -49,
        -43
      ],
      [
        37,
        -76
      ],
      [
        50,
        -11
      ],
      [
        24,
        -54
      ],
      [
        0,
        -54
      ],
      [
        -99,
        -109
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -49,
        21
      ],
      [
        -335,
        120
      ],
      [
        -111,
        21
      ],
      [
        -112,
        0
      ],
      [
        -24,
        11
      ],
      [
        0,
        33
      ],
      [
        24,
        54
      ],
      [
        -62,
        11
      ],
      [
        -24,
        22
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        -54
      ],
      [
        12,
        -44
      ],
      [
        62,
        -22
      ],
      [
        0,
        -10
      ],
      [
        -86,
        -22
      ],
      [
        -75,
        -11
      ],
      [
        -86,
        -65
      ],
      [
        -38,
        -43
      ],
      [
        -247,
        -98
      ],
      [
        -62,
        -32
      ],
      [
        -62,
        -22
      ],
      [
        -25,
        -44
      ],
      [
        -136,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -74,
        -76
      ],
      [
        -75,
        0
      ],
      [
        -49,
        -11
      ],
      [
        -112,
        -75
      ],
      [
        -74,
        21
      ],
      [
        -74,
        -97
      ],
      [
        -87,
        -98
      ],
      [
        -25,
        0
      ],
      [
        -74,
        43
      ],
      [
        -12,
        -21
      ],
      [
        12,
        -44
      ],
      [
        25,
        -32
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -11
      ],
      [
        12,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        -22
      ],
      [
        13,
        -43
      ],
      [
        -62,
        -32
      ],
      [
        -50,
        -55
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        -43
      ],
      [
        -37,
        11
      ],
      [
        -87,
        -76
      ],
      [
        -186,
        -130
      ],
      [
        -49,
        -11
      ],
      [
        -62,
        -43
      ],
      [
        -12,
        -55
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -130
      ],
      [
        -37,
        -54
      ],
      [
        -62,
        11
      ],
      [
        -62,
        54
      ],
      [
        -25,
        54
      ],
      [
        0,
        44
      ],
      [
        -25,
        21
      ],
      [
        -74,
        109
      ],
      [
        -111,
        76
      ],
      [
        -25,
        32
      ],
      [
        -149,
        -22
      ],
      [
        -111,
        11
      ],
      [
        -112,
        -11
      ],
      [
        -136,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        -137,
        -32
      ],
      [
        -99,
        -65
      ],
      [
        -173,
        -228
      ],
      [
        -37,
        -43
      ],
      [
        -50,
        -11
      ],
      [
        -25,
        76
      ],
      [
        13,
        65
      ],
      [
        25,
        54
      ],
      [
        24,
        108
      ],
      [
        0,
        44
      ],
      [
        13,
        43
      ],
      [
        -50,
        0
      ],
      [
        -86,
        -76
      ],
      [
        -124,
        -76
      ],
      [
        -62,
        -21
      ],
      [
        -37,
        -44
      ],
      [
        -75,
        -21
      ],
      [
        0,
        -98
      ],
      [
        -25,
        -54
      ],
      [
        -49,
        -11
      ],
      [
        -25,
        22
      ],
      [
        -37,
        76
      ],
      [
        -50,
        43
      ],
      [
        -49,
        0
      ],
      [
        -87,
        -54
      ],
      [
        -37,
        21
      ],
      [
        -87,
        22
      ],
      [
        -74,
        -87
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        -65
      ],
      [
        -13,
        -54
      ],
      [
        -12,
        -108
      ],
      [
        0,
        -141
      ],
      [
        -62,
        -109
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -22
      ],
      [
        13,
        -54
      ],
      [
        -13,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        -74,
        -87
      ],
      [
        -62,
        -54
      ],
      [
        -112,
        -163
      ],
      [
        -24,
        -108
      ],
      [
        -37,
        -130
      ],
      [
        49,
        -120
      ],
      [
        37,
        -32
      ],
      [
        75,
        -33
      ],
      [
        24,
        0
      ],
      [
        13,
        76
      ],
      [
        49,
        33
      ],
      [
        25,
        0
      ],
      [
        136,
        -65
      ],
      [
        38,
        -33
      ],
      [
        -13,
        -97
      ],
      [
        -87,
        -98
      ],
      [
        -62,
        -76
      ],
      [
        0,
        -76
      ],
      [
        13,
        -87
      ],
      [
        0,
        -173
      ],
      [
        12,
        -44
      ],
      [
        25,
        -21
      ],
      [
        50,
        21
      ],
      [
        37,
        -10
      ],
      [
        25,
        -33
      ],
      [
        0,
        -76
      ],
      [
        37,
        -206
      ],
      [
        -50,
        -54
      ],
      [
        -49,
        -65
      ],
      [
        -25,
        0
      ],
      [
        -50,
        22
      ],
      [
        -74,
        97
      ],
      [
        25,
        65
      ],
      [
        99,
        76
      ],
      [
        -112,
        22
      ],
      [
        -62,
        -54
      ],
      [
        13,
        -87
      ],
      [
        -25,
        -22
      ],
      [
        -99,
        -65
      ],
      [
        -25,
        -22
      ],
      [
        -111,
        -271
      ],
      [
        -13,
        -97
      ],
      [
        0,
        -87
      ],
      [
        37,
        -141
      ],
      [
        87,
        -152
      ],
      [
        0,
        -87
      ],
      [
        -124,
        -141
      ],
      [
        -37,
        -11
      ],
      [
        -111,
        11
      ],
      [
        -62,
        44
      ],
      [
        -62,
        -11
      ],
      [
        -62,
        -22
      ],
      [
        -87,
        -76
      ],
      [
        -74,
        -87
      ],
      [
        -75,
        -54
      ],
      [
        -24,
        -43
      ],
      [
        -25,
        -76
      ],
      [
        -25,
        -141
      ],
      [
        0,
        -65
      ],
      [
        25,
        -33
      ],
      [
        12,
        -43
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -43
      ],
      [
        38,
        -66
      ],
      [
        12,
        -97
      ],
      [
        -25,
        0
      ],
      [
        -62,
        65
      ],
      [
        -74,
        11
      ],
      [
        -149,
        -76
      ],
      [
        -62,
        -44
      ],
      [
        -74,
        -86
      ],
      [
        -25,
        11
      ],
      [
        -12,
        54
      ],
      [
        -25,
        21
      ],
      [
        -25,
        -10
      ],
      [
        -24,
        -44
      ],
      [
        49,
        -21
      ],
      [
        13,
        -33
      ],
      [
        -25,
        -119
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -162
      ],
      [
        -49,
        -174
      ],
      [
        -87,
        -184
      ],
      [
        -87,
        -120
      ],
      [
        -74,
        -43
      ],
      [
        -37,
        -43
      ],
      [
        -12,
        -44
      ],
      [
        -100,
        -119
      ],
      [
        -123,
        -130
      ],
      [
        -25,
        -22
      ],
      [
        -13,
        54
      ],
      [
        0,
        44
      ],
      [
        -12,
        65
      ],
      [
        -50,
        54
      ],
      [
        -12,
        43
      ],
      [
        0,
        326
      ],
      [
        -49,
        293
      ],
      [
        0,
        86
      ],
      [
        -50,
        65
      ],
      [
        -25,
        76
      ],
      [
        -12,
        76
      ],
      [
        0,
        87
      ],
      [
        -50,
        466
      ],
      [
        -25,
        109
      ],
      [
        -61,
        379
      ],
      [
        -38,
        206
      ],
      [
        -12,
        217
      ],
      [
        0,
        87
      ],
      [
        25,
        282
      ],
      [
        25,
        174
      ],
      [
        86,
        390
      ],
      [
        37,
        54
      ],
      [
        161,
        152
      ],
      [
        62,
        76
      ],
      [
        87,
        195
      ],
      [
        0,
        65
      ],
      [
        -25,
        65
      ],
      [
        -37,
        44
      ],
      [
        25,
        43
      ],
      [
        37,
        11
      ],
      [
        87,
        -33
      ],
      [
        74,
        11
      ],
      [
        74,
        141
      ],
      [
        112,
        -21
      ],
      [
        74,
        21
      ],
      [
        25,
        0
      ],
      [
        12,
        44
      ],
      [
        137,
        119
      ],
      [
        111,
        87
      ],
      [
        62,
        65
      ],
      [
        37,
        54
      ],
      [
        50,
        54
      ],
      [
        49,
        65
      ],
      [
        87,
        206
      ],
      [
        174,
        163
      ],
      [
        61,
        98
      ],
      [
        112,
        54
      ],
      [
        124,
        130
      ],
      [
        74,
        119
      ],
      [
        112,
        76
      ],
      [
        24,
        54
      ],
      [
        62,
        109
      ],
      [
        13,
        32
      ],
      [
        74,
        44
      ],
      [
        149,
        76
      ],
      [
        99,
        76
      ],
      [
        124,
        10
      ],
      [
        37,
        33
      ],
      [
        87,
        43
      ],
      [
        -50,
        65
      ],
      [
        12,
        44
      ],
      [
        99,
        97
      ],
      [
        38,
        65
      ],
      [
        -13,
        44
      ],
      [
        -49,
        22
      ],
      [
        24,
        119
      ],
      [
        50,
        43
      ],
      [
        12,
        98
      ],
      [
        0,
        108
      ],
      [
        50,
        152
      ],
      [
        25,
        33
      ],
      [
        111,
        86
      ],
      [
        25,
        0
      ],
      [
        74,
        -32
      ],
      [
        75,
        -11
      ],
      [
        37,
        -22
      ],
      [
        0,
        44
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        0,
        32
      ],
      [
        -124,
        11
      ],
      [
        -87,
        33
      ],
      [
        -74,
        65
      ],
      [
        -50,
        21
      ],
      [
        -62,
        0
      ],
      [
        -309,
        -97
      ],
      [
        -37,
        -54
      ],
      [
        24,
        -55
      ],
      [
        -24,
        -21
      ],
      [
        -25,
        -55
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -97
      ],
      [
        0,
        -65
      ],
      [
        62,
        -33
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -32
      ],
      [
        -49,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        32
      ],
      [
        -25,
        65
      ],
      [
        -37,
        11
      ],
      [
        -12,
        -43
      ],
      [
        -112,
        11
      ],
      [
        -62,
        -76
      ],
      [
        -396,
        -358
      ],
      [
        -50,
        -44
      ],
      [
        -49,
        -86
      ],
      [
        -99,
        -11
      ],
      [
        -99,
        -65
      ],
      [
        12,
        54
      ],
      [
        0,
        65
      ],
      [
        62,
        119
      ],
      [
        -74,
        22
      ],
      [
        -62,
        -32
      ],
      [
        -38,
        -33
      ],
      [
        -37,
        0
      ],
      [
        13,
        43
      ],
      [
        49,
        65
      ],
      [
        -25,
        109
      ],
      [
        13,
        11
      ],
      [
        87,
        141
      ],
      [
        24,
        65
      ],
      [
        25,
        87
      ],
      [
        0,
        65
      ],
      [
        -49,
        11
      ],
      [
        -161,
        -98
      ],
      [
        -50,
        -22
      ],
      [
        -25,
        44
      ],
      [
        -25,
        10
      ],
      [
        -49,
        66
      ],
      [
        -74,
        10
      ],
      [
        -87,
        -43
      ],
      [
        -87,
        -22
      ],
      [
        -74,
        0
      ],
      [
        -62,
        -32
      ],
      [
        -37,
        -11
      ],
      [
        -87,
        32
      ],
      [
        -111,
        0
      ],
      [
        -38,
        -32
      ],
      [
        -99,
        -43
      ],
      [
        -62,
        -76
      ],
      [
        -74,
        -55
      ],
      [
        -25,
        -130
      ],
      [
        -99,
        -65
      ],
      [
        -99,
        -97
      ],
      [
        -62,
        -141
      ],
      [
        -49,
        -55
      ],
      [
        -100,
        -86
      ],
      [
        -161,
        -109
      ],
      [
        -136,
        -173
      ],
      [
        -37,
        -131
      ],
      [
        -62,
        -32
      ],
      [
        0,
        -109
      ],
      [
        -25,
        -43
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -33
      ],
      [
        50,
        0
      ],
      [
        87,
        44
      ],
      [
        123,
        -65
      ],
      [
        75,
        -55
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -43
      ],
      [
        -50,
        0
      ],
      [
        -74,
        -11
      ],
      [
        -37,
        -22
      ],
      [
        -87,
        44
      ],
      [
        -74,
        -66
      ],
      [
        -75,
        -21
      ],
      [
        -49,
        21
      ],
      [
        -62,
        76
      ],
      [
        -112,
        -10
      ],
      [
        -37,
        -76
      ],
      [
        -62,
        -11
      ],
      [
        -86,
        -98
      ],
      [
        -87,
        22
      ],
      [
        -62,
        43
      ],
      [
        -25,
        0
      ],
      [
        -62,
        -21
      ],
      [
        -25,
        -55
      ],
      [
        -123,
        -21
      ],
      [
        -137,
        0
      ],
      [
        -74,
        130
      ],
      [
        136,
        54
      ],
      [
        75,
        -11
      ],
      [
        99,
        11
      ],
      [
        86,
        33
      ],
      [
        -24,
        43
      ],
      [
        -87,
        0
      ],
      [
        -50,
        22
      ],
      [
        -99,
        130
      ],
      [
        -49,
        21
      ],
      [
        -62,
        11
      ],
      [
        -62,
        0
      ],
      [
        -62,
        -76
      ],
      [
        -99,
        44
      ],
      [
        49,
        21
      ],
      [
        -74,
        22
      ],
      [
        -285,
        109
      ],
      [
        -111,
        -22
      ],
      [
        -87,
        -65
      ],
      [
        49,
        -87
      ],
      [
        -24,
        -11
      ],
      [
        -75,
        0
      ],
      [
        -37,
        33
      ],
      [
        -37,
        -54
      ],
      [
        12,
        -44
      ],
      [
        50,
        22
      ],
      [
        25,
        -22
      ],
      [
        -13,
        -54
      ],
      [
        -62,
        -22
      ],
      [
        -86,
        11
      ],
      [
        -75,
        87
      ],
      [
        -136,
        -11
      ],
      [
        -62,
        -65
      ],
      [
        -62,
        -11
      ],
      [
        -161,
        65
      ],
      [
        -87,
        0
      ],
      [
        -86,
        54
      ],
      [
        -37,
        -21
      ],
      [
        -50,
        -130
      ],
      [
        -74,
        -33
      ],
      [
        -50,
        22
      ],
      [
        -37,
        86
      ],
      [
        -25,
        22
      ],
      [
        -62,
        22
      ],
      [
        -371,
        -22
      ],
      [
        -124,
        22
      ],
      [
        -87,
        0
      ],
      [
        -124,
        -44
      ],
      [
        -111,
        22
      ],
      [
        -211,
        -87
      ],
      [
        -87,
        -54
      ],
      [
        -99,
        -87
      ],
      [
        -99,
        -162
      ],
      [
        -49,
        -65
      ],
      [
        -87,
        -76
      ],
      [
        -124,
        -65
      ],
      [
        -74,
        -76
      ],
      [
        -25,
        -55
      ],
      [
        -87,
        -249
      ],
      [
        -148,
        -76
      ],
      [
        -50,
        -87
      ],
      [
        -25,
        -21
      ],
      [
        -62,
        -33
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -22
      ],
      [
        -86,
        -43
      ],
      [
        -75,
        -108
      ],
      [
        -111,
        -76
      ],
      [
        -149,
        -206
      ],
      [
        -24,
        -76
      ],
      [
        -25,
        -44
      ],
      [
        -137,
        -184
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        -87
      ],
      [
        -74,
        -43
      ],
      [
        -49,
        -65
      ],
      [
        -87,
        -65
      ],
      [
        -112,
        -76
      ],
      [
        -37,
        -33
      ],
      [
        -62,
        -108
      ],
      [
        -148,
        -119
      ],
      [
        -62,
        -22
      ],
      [
        -99,
        -108
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -43
      ],
      [
        13,
        -66
      ],
      [
        24,
        -21
      ],
      [
        37,
        -11
      ],
      [
        137,
        -65
      ],
      [
        136,
        22
      ],
      [
        124,
        0
      ],
      [
        37,
        10
      ],
      [
        37,
        -10
      ],
      [
        0,
        -98
      ],
      [
        -12,
        -65
      ],
      [
        -13,
        -185
      ],
      [
        -24,
        -75
      ],
      [
        12,
        -87
      ],
      [
        37,
        -11
      ],
      [
        25,
        33
      ],
      [
        50,
        10
      ],
      [
        37,
        -21
      ],
      [
        37,
        130
      ],
      [
        -25,
        21
      ],
      [
        -25,
        44
      ],
      [
        13,
        32
      ],
      [
        86,
        65
      ],
      [
        99,
        0
      ],
      [
        -74,
        -97
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -22
      ],
      [
        37,
        -43
      ],
      [
        50,
        -33
      ],
      [
        74,
        -11
      ],
      [
        -12,
        -32
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        -97
      ],
      [
        -112,
        -87
      ],
      [
        13,
        -22
      ],
      [
        173,
        11
      ],
      [
        75,
        33
      ],
      [
        99,
        75
      ],
      [
        37,
        109
      ],
      [
        49,
        32
      ],
      [
        25,
        0
      ],
      [
        0,
        -86
      ],
      [
        -99,
        -141
      ],
      [
        -12,
        -44
      ],
      [
        62,
        11
      ],
      [
        24,
        22
      ],
      [
        50,
        108
      ],
      [
        25,
        185
      ],
      [
        0,
        108
      ],
      [
        -25,
        54
      ],
      [
        12,
        11
      ],
      [
        149,
        -65
      ],
      [
        74,
        -11
      ],
      [
        124,
        54
      ],
      [
        37,
        -21
      ],
      [
        25,
        -33
      ],
      [
        99,
        -87
      ],
      [
        25,
        -32
      ],
      [
        37,
        -119
      ],
      [
        124,
        -141
      ],
      [
        99,
        -65
      ],
      [
        74,
        -98
      ],
      [
        62,
        -22
      ],
      [
        0,
        -65
      ],
      [
        -24,
        -54
      ],
      [
        -50,
        -54
      ],
      [
        -99,
        43
      ],
      [
        0,
        -32
      ],
      [
        74,
        -87
      ],
      [
        50,
        -33
      ],
      [
        12,
        -119
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        12,
        -43
      ],
      [
        50,
        -66
      ],
      [
        37,
        -21
      ],
      [
        25,
        -33
      ],
      [
        -38,
        -76
      ],
      [
        -12,
        -86
      ],
      [
        -37,
        -44
      ],
      [
        -37,
        -76
      ],
      [
        -75,
        -65
      ],
      [
        -24,
        -130
      ],
      [
        -50,
        -119
      ],
      [
        -12,
        -109
      ],
      [
        -50,
        -162
      ],
      [
        -12,
        -152
      ],
      [
        12,
        -261
      ],
      [
        12,
        -21
      ],
      [
        25,
        -11
      ],
      [
        -12,
        -33
      ],
      [
        -50,
        -76
      ],
      [
        0,
        -54
      ],
      [
        25,
        -43
      ],
      [
        0,
        -98
      ],
      [
        -37,
        -162
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -76
      ],
      [
        -12,
        -65
      ],
      [
        12,
        -43
      ],
      [
        13,
        -11
      ],
      [
        -50,
        -119
      ],
      [
        -25,
        -163
      ],
      [
        -12,
        -65
      ],
      [
        -50,
        -54
      ],
      [
        -74,
        -98
      ],
      [
        -25,
        -54
      ],
      [
        -111,
        -120
      ],
      [
        -75,
        -162
      ],
      [
        -49,
        -163
      ],
      [
        -149,
        -195
      ],
      [
        -25,
        -109
      ],
      [
        -37,
        -86
      ],
      [
        -25,
        -130
      ],
      [
        -37,
        -55
      ],
      [
        -37,
        -130
      ],
      [
        -111,
        -195
      ],
      [
        -38,
        -76
      ],
      [
        -86,
        -108
      ],
      [
        -99,
        -152
      ],
      [
        -112,
        -141
      ],
      [
        -25,
        -54
      ],
      [
        -49,
        -66
      ],
      [
        -50,
        -97
      ],
      [
        -74,
        -98
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -33
      ],
      [
        -37,
        -43
      ],
      [
        -124,
        -250
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -43
      ],
      [
        -74,
        -98
      ],
      [
        -50,
        -98
      ],
      [
        -74,
        -54
      ],
      [
        -75,
        -87
      ],
      [
        -185,
        -162
      ],
      [
        -50,
        -54
      ],
      [
        -99,
        -76
      ],
      [
        -50,
        0
      ],
      [
        -86,
        -44
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        11
      ],
      [
        -25,
        54
      ],
      [
        -49,
        -11
      ],
      [
        -50,
        54
      ],
      [
        -50,
        0
      ],
      [
        -24,
        22
      ],
      [
        -62,
        -22
      ],
      [
        12,
        228
      ],
      [
        -12,
        43
      ],
      [
        -25,
        -43
      ],
      [
        -74,
        -76
      ],
      [
        -50,
        -11
      ],
      [
        0,
        44
      ],
      [
        50,
        65
      ],
      [
        -25,
        10
      ],
      [
        -50,
        -21
      ],
      [
        -24,
        -33
      ],
      [
        -75,
        -130
      ],
      [
        -49,
        -108
      ],
      [
        -25,
        -33
      ],
      [
        -50,
        -97
      ],
      [
        -49,
        21
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -25,
        -11
      ],
      [
        50,
        -76
      ],
      [
        -37,
        -130
      ],
      [
        -13,
        -11
      ]
    ],
    [
      [
        98975,
        105025
      ],
      [
        -74,
        -54
      ],
      [
        -50,
        32
      ],
      [
        -112,
        -11
      ],
      [
        -198,
        33
      ],
      [
        50,
        21
      ],
      [
        347,
        11
      ],
      [
        37,
        -32
      ]
    ],
    [
      [
        98492,
        105068
      ],
      [
        -50,
        -11
      ],
      [
        -25,
        44
      ],
      [
        100,
        11
      ],
      [
        37,
        43
      ],
      [
        62,
        -11
      ],
      [
        24,
        -43
      ],
      [
        -74,
        0
      ],
      [
        -74,
        -33
      ]
    ],
    [
      [
        97327,
        105719
      ],
      [
        -49,
        -87
      ],
      [
        -112,
        -152
      ],
      [
        50,
        0
      ],
      [
        124,
        120
      ],
      [
        49,
        0
      ],
      [
        124,
        43
      ],
      [
        124,
        11
      ],
      [
        50,
        -11
      ],
      [
        49,
        -76
      ],
      [
        112,
        -22
      ],
      [
        12,
        -54
      ],
      [
        62,
        -32
      ],
      [
        136,
        10
      ],
      [
        62,
        -43
      ],
      [
        50,
        -119
      ],
      [
        -13,
        -54
      ],
      [
        -161,
        -98
      ],
      [
        -111,
        0
      ],
      [
        -273,
        -54
      ],
      [
        -248,
        0
      ],
      [
        -74,
        -44
      ],
      [
        -62,
        22
      ],
      [
        -309,
        -22
      ],
      [
        -174,
        0
      ],
      [
        -62,
        -32
      ],
      [
        -161,
        -54
      ],
      [
        -248,
        -66
      ],
      [
        -111,
        22
      ],
      [
        -74,
        33
      ],
      [
        49,
        32
      ],
      [
        37,
        54
      ],
      [
        161,
        98
      ],
      [
        62,
        130
      ],
      [
        25,
        22
      ],
      [
        0,
        65
      ],
      [
        50,
        43
      ],
      [
        74,
        33
      ],
      [
        87,
        11
      ],
      [
        -13,
        54
      ],
      [
        62,
        76
      ],
      [
        13,
        65
      ],
      [
        86,
        65
      ],
      [
        75,
        11
      ],
      [
        24,
        65
      ],
      [
        75,
        11
      ],
      [
        62,
        -65
      ],
      [
        86,
        -11
      ],
      [
        -24,
        43
      ],
      [
        12,
        54
      ],
      [
        62,
        22
      ],
      [
        136,
        -32
      ],
      [
        112,
        -55
      ],
      [
        -75,
        -32
      ]
    ],
    [
      [
        88161,
        105968
      ],
      [
        74,
        0
      ],
      [
        310,
        -54
      ],
      [
        74,
        -43
      ],
      [
        -322,
        0
      ],
      [
        0,
        32
      ],
      [
        -173,
        22
      ],
      [
        -38,
        43
      ],
      [
        75,
        0
      ]
    ],
    [
      [
        96373,
        105947
      ],
      [
        -74,
        -11
      ],
      [
        13,
        54
      ],
      [
        37,
        11
      ],
      [
        86,
        -22
      ],
      [
        -62,
        -32
      ]
    ],
    [
      [
        93809,
        105990
      ],
      [
        -74,
        -11
      ],
      [
        -99,
        11
      ],
      [
        -161,
        65
      ],
      [
        -112,
        33
      ],
      [
        -86,
        43
      ],
      [
        -25,
        43
      ],
      [
        124,
        44
      ],
      [
        260,
        0
      ],
      [
        149,
        -33
      ],
      [
        297,
        -32
      ],
      [
        111,
        -22
      ],
      [
        -62,
        -54
      ],
      [
        -235,
        -76
      ],
      [
        -87,
        -11
      ]
    ],
    [
      [
        79613,
        106153
      ],
      [
        13,
        -11
      ],
      [
        -347,
        0
      ],
      [
        -124,
        32
      ],
      [
        211,
        44
      ],
      [
        86,
        32
      ],
      [
        112,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        62,
        -32
      ]
    ],
    [
      [
        82463,
        106164
      ],
      [
        -124,
        -22
      ],
      [
        -149,
        32
      ],
      [
        37,
        44
      ],
      [
        186,
        43
      ],
      [
        87,
        -22
      ],
      [
        37,
        -54
      ],
      [
        -74,
        -21
      ]
    ],
    [
      [
        95531,
        106283
      ],
      [
        74,
        -33
      ],
      [
        38,
        -54
      ],
      [
        -38,
        -11
      ],
      [
        -49,
        -65
      ],
      [
        37,
        -22
      ],
      [
        74,
        22
      ],
      [
        75,
        -11
      ],
      [
        74,
        44
      ],
      [
        12,
        65
      ],
      [
        112,
        0
      ],
      [
        149,
        -22
      ],
      [
        24,
        -22
      ],
      [
        124,
        -32
      ],
      [
        112,
        -98
      ],
      [
        -50,
        -21
      ],
      [
        -49,
        -66
      ],
      [
        0,
        -75
      ],
      [
        -25,
        -33
      ],
      [
        0,
        -87
      ],
      [
        -50,
        -32
      ],
      [
        -136,
        21
      ],
      [
        -37,
        -10
      ],
      [
        99,
        -33
      ],
      [
        62,
        -65
      ],
      [
        87,
        -11
      ],
      [
        62,
        -98
      ],
      [
        -174,
        -75
      ],
      [
        -210,
        -11
      ],
      [
        -149,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -248,
        22
      ],
      [
        -111,
        21
      ],
      [
        -112,
        44
      ],
      [
        -37,
        32
      ],
      [
        -136,
        11
      ],
      [
        -248,
        0
      ],
      [
        -62,
        54
      ],
      [
        -136,
        -32
      ],
      [
        -112,
        32
      ],
      [
        -62,
        33
      ],
      [
        0,
        32
      ],
      [
        -49,
        11
      ],
      [
        -87,
        119
      ],
      [
        -161,
        33
      ],
      [
        -161,
        0
      ],
      [
        -74,
        22
      ],
      [
        111,
        86
      ],
      [
        161,
        44
      ],
      [
        136,
        76
      ],
      [
        25,
        76
      ],
      [
        136,
        43
      ],
      [
        87,
        54
      ],
      [
        99,
        -43
      ],
      [
        75,
        43
      ],
      [
        123,
        11
      ],
      [
        199,
        -11
      ],
      [
        247,
        33
      ],
      [
        149,
        11
      ],
      [
        37,
        -11
      ]
    ],
    [
      [
        79143,
        106229
      ],
      [
        -174,
        54
      ],
      [
        124,
        43
      ],
      [
        124,
        0
      ],
      [
        25,
        -32
      ],
      [
        -99,
        -65
      ]
    ],
    [
      [
        81013,
        106359
      ],
      [
        -99,
        -33
      ],
      [
        -74,
        22
      ],
      [
        86,
        43
      ],
      [
        87,
        -32
      ]
    ],
    [
      [
        81558,
        106402
      ],
      [
        25,
        -22
      ],
      [
        -25,
        -130
      ],
      [
        -25,
        -21
      ],
      [
        -408,
        10
      ],
      [
        -25,
        11
      ],
      [
        99,
        65
      ],
      [
        0,
        87
      ],
      [
        223,
        -11
      ],
      [
        12,
        22
      ],
      [
        124,
        -11
      ]
    ],
    [
      [
        80344,
        106304
      ],
      [
        -309,
        -10
      ],
      [
        -25,
        21
      ],
      [
        -75,
        0
      ],
      [
        -49,
        33
      ],
      [
        124,
        22
      ],
      [
        99,
        65
      ],
      [
        111,
        10
      ],
      [
        112,
        -54
      ],
      [
        124,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -87,
        -22
      ]
    ],
    [
      [
        81868,
        106261
      ],
      [
        -62,
        -11
      ],
      [
        -136,
        22
      ],
      [
        -37,
        32
      ],
      [
        -38,
        131
      ],
      [
        -62,
        43
      ],
      [
        25,
        22
      ],
      [
        161,
        -11
      ],
      [
        322,
        -11
      ],
      [
        223,
        -43
      ],
      [
        50,
        -33
      ],
      [
        -297,
        -11
      ],
      [
        -38,
        -21
      ],
      [
        -12,
        -55
      ],
      [
        -99,
        -54
      ]
    ],
    [
      [
        80642,
        106478
      ],
      [
        -38,
        -33
      ],
      [
        -161,
        44
      ],
      [
        25,
        22
      ],
      [
        -12,
        54
      ],
      [
        186,
        -44
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        78251,
        106717
      ],
      [
        148,
        -22
      ],
      [
        124,
        11
      ],
      [
        75,
        -11
      ],
      [
        74,
        -54
      ],
      [
        -12,
        -65
      ],
      [
        -211,
        32
      ],
      [
        -87,
        54
      ],
      [
        -62,
        -10
      ],
      [
        -62,
        -44
      ],
      [
        -136,
        -65
      ],
      [
        -124,
        -11
      ],
      [
        -99,
        -65
      ],
      [
        -74,
        0
      ],
      [
        -62,
        76
      ],
      [
        -112,
        -22
      ],
      [
        -86,
        11
      ],
      [
        -87,
        33
      ],
      [
        -12,
        32
      ],
      [
        421,
        55
      ],
      [
        161,
        10
      ],
      [
        74,
        33
      ],
      [
        149,
        22
      ]
    ],
    [
      [
        83317,
        106706
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        -136,
        -22
      ],
      [
        -25,
        -33
      ],
      [
        -111,
        -21
      ],
      [
        -75,
        -55
      ],
      [
        -111,
        11
      ],
      [
        -161,
        44
      ],
      [
        -211,
        -44
      ],
      [
        -124,
        55
      ],
      [
        0,
        65
      ],
      [
        25,
        54
      ],
      [
        74,
        65
      ],
      [
        174,
        22
      ],
      [
        62,
        -33
      ],
      [
        74,
        0
      ],
      [
        285,
        43
      ],
      [
        99,
        22
      ],
      [
        173,
        -22
      ],
      [
        25,
        -21
      ]
    ],
    [
      [
        79217,
        106771
      ],
      [
        186,
        -11
      ],
      [
        223,
        -108
      ],
      [
        49,
        0
      ],
      [
        38,
        -33
      ],
      [
        -186,
        -54
      ],
      [
        -75,
        -44
      ],
      [
        -223,
        0
      ],
      [
        -161,
        -21
      ],
      [
        -12,
        -44
      ],
      [
        -74,
        -32
      ],
      [
        -260,
        -11
      ],
      [
        -50,
        -43
      ],
      [
        87,
        -11
      ],
      [
        12,
        -65
      ],
      [
        -62,
        -11
      ],
      [
        -74,
        21
      ],
      [
        -62,
        -54
      ],
      [
        -74,
        22
      ],
      [
        -75,
        -33
      ],
      [
        -74,
        0
      ],
      [
        -37,
        22
      ],
      [
        124,
        54
      ],
      [
        -38,
        22
      ],
      [
        -148,
        -11
      ],
      [
        -37,
        -22
      ],
      [
        -124,
        0
      ],
      [
        -112,
        66
      ],
      [
        347,
        130
      ],
      [
        74,
        21
      ],
      [
        112,
        0
      ],
      [
        62,
        22
      ],
      [
        87,
        -43
      ],
      [
        148,
        11
      ],
      [
        37,
        21
      ],
      [
        -12,
        98
      ],
      [
        37,
        65
      ],
      [
        87,
        32
      ],
      [
        260,
        44
      ]
    ],
    [
      [
        89461,
        106717
      ],
      [
        -322,
        -22
      ],
      [
        -37,
        11
      ],
      [
        74,
        76
      ],
      [
        211,
        11
      ],
      [
        211,
        -22
      ],
      [
        -25,
        -44
      ],
      [
        -112,
        -10
      ]
    ],
    [
      [
        82958,
        106782
      ],
      [
        -111,
        -11
      ],
      [
        -174,
        11
      ],
      [
        -87,
        21
      ],
      [
        186,
        65
      ],
      [
        297,
        11
      ],
      [
        38,
        -32
      ],
      [
        -38,
        -33
      ],
      [
        -111,
        -32
      ]
    ],
    [
      [
        80753,
        106879
      ],
      [
        260,
        -54
      ],
      [
        236,
        0
      ],
      [
        111,
        -11
      ],
      [
        149,
        -54
      ],
      [
        260,
        -76
      ],
      [
        -37,
        -22
      ],
      [
        -260,
        -65
      ],
      [
        -323,
        -21
      ],
      [
        -61,
        10
      ],
      [
        -50,
        44
      ],
      [
        -149,
        22
      ],
      [
        -161,
        0
      ],
      [
        -198,
        43
      ],
      [
        -12,
        32
      ],
      [
        111,
        22
      ],
      [
        13,
        54
      ],
      [
        74,
        76
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        82091,
        106836
      ],
      [
        99,
        -87
      ],
      [
        -12,
        -76
      ],
      [
        -199,
        -11
      ],
      [
        -123,
        22
      ],
      [
        -62,
        54
      ],
      [
        -124,
        22
      ],
      [
        -62,
        65
      ],
      [
        148,
        11
      ],
      [
        137,
        54
      ],
      [
        49,
        -22
      ],
      [
        149,
        -32
      ]
    ],
    [
      [
        79390,
        106836
      ],
      [
        -86,
        0
      ],
      [
        -50,
        43
      ],
      [
        75,
        44
      ],
      [
        49,
        0
      ],
      [
        74,
        -44
      ],
      [
        -62,
        -43
      ]
    ],
    [
      [
        83726,
        106619
      ],
      [
        -124,
        11
      ],
      [
        -161,
        76
      ],
      [
        198,
        87
      ],
      [
        260,
        10
      ],
      [
        75,
        11
      ],
      [
        74,
        109
      ],
      [
        174,
        11
      ],
      [
        74,
        -11
      ],
      [
        124,
        -76
      ],
      [
        -13,
        -33
      ],
      [
        37,
        -43
      ],
      [
        -161,
        -76
      ],
      [
        -148,
        -33
      ],
      [
        -409,
        -43
      ]
    ],
    [
      [
        93425,
        106901
      ],
      [
        -111,
        -54
      ],
      [
        -434,
        32
      ],
      [
        -25,
        44
      ],
      [
        62,
        21
      ],
      [
        360,
        -10
      ],
      [
        124,
        -11
      ],
      [
        24,
        -22
      ]
    ],
    [
      [
        95135,
        106858
      ],
      [
        74,
        -76
      ],
      [
        235,
        -65
      ],
      [
        100,
        -11
      ],
      [
        49,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -223,
        -22
      ],
      [
        -62,
        -76
      ],
      [
        75,
        -108
      ],
      [
        61,
        -22
      ],
      [
        -86,
        -54
      ],
      [
        -459,
        -43
      ],
      [
        -297,
        -11
      ],
      [
        -136,
        -22
      ],
      [
        -248,
        -65
      ],
      [
        -74,
        0
      ],
      [
        -223,
        54
      ],
      [
        -273,
        44
      ],
      [
        -37,
        32
      ],
      [
        -161,
        33
      ],
      [
        -37,
        54
      ],
      [
        124,
        76
      ],
      [
        235,
        32
      ],
      [
        87,
        55
      ],
      [
        149,
        108
      ],
      [
        -162,
        -22
      ],
      [
        -61,
        11
      ],
      [
        61,
        76
      ],
      [
        50,
        11
      ],
      [
        50,
        43
      ],
      [
        99,
        33
      ],
      [
        185,
        11
      ],
      [
        162,
        32
      ],
      [
        86,
        0
      ],
      [
        149,
        55
      ],
      [
        37,
        43
      ],
      [
        223,
        11
      ],
      [
        62,
        -44
      ],
      [
        74,
        -21
      ],
      [
        112,
        -65
      ]
    ],
    [
      [
        82326,
        106999
      ],
      [
        -198,
        10
      ],
      [
        -25,
        33
      ],
      [
        149,
        22
      ],
      [
        74,
        -22
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        81818,
        107150
      ],
      [
        62,
        -32
      ],
      [
        149,
        -11
      ],
      [
        50,
        -32
      ],
      [
        -75,
        -22
      ],
      [
        -173,
        -11
      ],
      [
        49,
        -76
      ],
      [
        -24,
        -32
      ],
      [
        -162,
        -33
      ],
      [
        -222,
        54
      ],
      [
        -149,
        -32
      ],
      [
        -62,
        32
      ],
      [
        -161,
        -21
      ],
      [
        -50,
        21
      ],
      [
        -37,
        54
      ],
      [
        99,
        11
      ],
      [
        137,
        -21
      ],
      [
        86,
        54
      ],
      [
        99,
        22
      ],
      [
        137,
        75
      ],
      [
        247,
        0
      ]
    ],
    [
      [
        83825,
        107194
      ],
      [
        -37,
        -11
      ],
      [
        -334,
        22
      ],
      [
        -100,
        43
      ],
      [
        174,
        11
      ],
      [
        322,
        -22
      ],
      [
        -25,
        -43
      ]
    ],
    [
      [
        81979,
        107259
      ],
      [
        -136,
        0
      ],
      [
        37,
        54
      ],
      [
        50,
        11
      ],
      [
        384,
        22
      ],
      [
        49,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        -372,
        -22
      ]
    ],
    [
      [
        72094,
        55343
      ],
      [
        13,
        0
      ],
      [
        74,
        33
      ],
      [
        12,
        -11
      ],
      [
        13,
        -65
      ],
      [
        37,
        10
      ],
      [
        37,
        44
      ],
      [
        13,
        32
      ],
      [
        49,
        87
      ],
      [
        12,
        43
      ],
      [
        13,
        22
      ],
      [
        25,
        11
      ],
      [
        24,
        0
      ]
    ],
    [
      [
        72416,
        55549
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -44
      ],
      [
        50,
        -97
      ],
      [
        25,
        -22
      ],
      [
        12,
        -43
      ],
      [
        25,
        -65
      ],
      [
        0,
        -250
      ],
      [
        12,
        -43
      ],
      [
        13,
        -65
      ],
      [
        -13,
        -76
      ],
      [
        -12,
        -44
      ],
      [
        -13,
        -21
      ],
      [
        -49,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -13,
        0
      ]
    ],
    [
      [
        56053,
        69214
      ],
      [
        -13,
        33
      ],
      [
        37,
        325
      ],
      [
        0,
        22
      ]
    ],
    [
      [
        76368,
        66655
      ],
      [
        25,
        54
      ],
      [
        37,
        -54
      ],
      [
        0,
        -87
      ],
      [
        -13,
        11
      ],
      [
        -12,
        32
      ],
      [
        0,
        22
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -37,
        65
      ],
      [
        -12,
        43
      ],
      [
        12,
        0
      ],
      [
        25,
        22
      ],
      [
        0,
        76
      ],
      [
        12,
        -11
      ],
      [
        13,
        -33
      ],
      [
        0,
        -86
      ],
      [
        12,
        -11
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -21
      ]
    ],
    [
      [
        74621,
        72066
      ],
      [
        -12,
        0
      ],
      [
        -50,
        98
      ],
      [
        -62,
        43
      ],
      [
        0,
        22
      ],
      [
        75,
        -54
      ],
      [
        62,
        -76
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        78585,
        74040
      ],
      [
        25,
        -54
      ],
      [
        12,
        -65
      ],
      [
        38,
        -130
      ],
      [
        49,
        -109
      ],
      [
        13,
        -43
      ],
      [
        0,
        -76
      ],
      [
        -13,
        -33
      ],
      [
        37,
        -54
      ],
      [
        62,
        -54
      ],
      [
        62,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        38,
        -87
      ],
      [
        37,
        -76
      ],
      [
        49,
        -22
      ],
      [
        62,
        -119
      ],
      [
        87,
        -76
      ],
      [
        62,
        -108
      ],
      [
        -50,
        21
      ],
      [
        0,
        -54
      ],
      [
        13,
        -54
      ],
      [
        49,
        -76
      ],
      [
        13,
        -54
      ],
      [
        -25,
        -130
      ],
      [
        -37,
        11
      ],
      [
        24,
        -174
      ],
      [
        25,
        -54
      ],
      [
        13,
        -87
      ],
      [
        24,
        -32
      ],
      [
        50,
        -87
      ],
      [
        25,
        -76
      ],
      [
        12,
        -141
      ],
      [
        87,
        -184
      ]
    ],
    [
      [
        79564,
        71589
      ],
      [
        25,
        -32
      ],
      [
        24,
        10
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -119
      ],
      [
        87,
        -33
      ]
    ],
    [
      [
        79812,
        68075
      ],
      [
        -87,
        -11
      ],
      [
        -74,
        -21
      ],
      [
        -87,
        -22
      ],
      [
        -112,
        -33
      ],
      [
        -86,
        -10
      ],
      [
        -223,
        -65
      ],
      [
        -99,
        -22
      ],
      [
        -112,
        -22
      ],
      [
        -87,
        -22
      ],
      [
        -49,
        -21
      ],
      [
        -62,
        -54
      ],
      [
        -87,
        -87
      ],
      [
        -148,
        -130
      ],
      [
        -50,
        -109
      ],
      [
        -25,
        -65
      ],
      [
        -86,
        -173
      ],
      [
        -38,
        -98
      ],
      [
        -24,
        -76
      ],
      [
        -25,
        -130
      ],
      [
        -25,
        -33
      ],
      [
        -87,
        -76
      ],
      [
        -49,
        11
      ],
      [
        -37,
        76
      ],
      [
        -50,
        120
      ],
      [
        -149,
        -22
      ],
      [
        -74,
        11
      ],
      [
        -99,
        21
      ],
      [
        -87,
        11
      ],
      [
        -49,
        11
      ],
      [
        -75,
        65
      ],
      [
        -148,
        0
      ],
      [
        -75,
        -11
      ],
      [
        -61,
        0
      ],
      [
        -75,
        -11
      ],
      [
        -25,
        -10
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        22
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -25,
        32
      ],
      [
        -13,
        33
      ],
      [
        -49,
        21
      ],
      [
        -13,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -22
      ],
      [
        13,
        -32
      ],
      [
        -25,
        -44
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -163
      ],
      [
        25,
        -54
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -55
      ],
      [
        -62,
        -86
      ]
    ],
    [
      [
        76653,
        66438
      ],
      [
        -13,
        54
      ],
      [
        -12,
        76
      ],
      [
        0,
        54
      ],
      [
        -25,
        87
      ],
      [
        -37,
        43
      ],
      [
        0,
        54
      ],
      [
        -25,
        55
      ],
      [
        -37,
        54
      ],
      [
        -12,
        76
      ],
      [
        -13,
        119
      ],
      [
        -86,
        141
      ],
      [
        -99,
        130
      ],
      [
        -38,
        87
      ],
      [
        -49,
        152
      ],
      [
        -25,
        119
      ],
      [
        -74,
        141
      ],
      [
        0,
        54
      ],
      [
        -25,
        141
      ],
      [
        -12,
        54
      ],
      [
        -87,
        304
      ],
      [
        -25,
        54
      ],
      [
        0,
        44
      ],
      [
        -12,
        21
      ],
      [
        -50,
        44
      ],
      [
        -49,
        108
      ],
      [
        -137,
        174
      ],
      [
        -62,
        11
      ],
      [
        -61,
        65
      ],
      [
        -38,
        76
      ],
      [
        -37,
        141
      ],
      [
        -74,
        141
      ],
      [
        -62,
        216
      ],
      [
        12,
        76
      ],
      [
        0,
        55
      ],
      [
        -12,
        86
      ],
      [
        -25,
        76
      ],
      [
        -12,
        65
      ],
      [
        12,
        87
      ],
      [
        0,
        109
      ],
      [
        25,
        119
      ],
      [
        -12,
        130
      ],
      [
        -25,
        65
      ],
      [
        0,
        43
      ],
      [
        -37,
        66
      ],
      [
        24,
        0
      ],
      [
        -37,
        65
      ],
      [
        -37,
        130
      ],
      [
        -12,
        76
      ],
      [
        -50,
        152
      ],
      [
        -37,
        97
      ],
      [
        -62,
        130
      ],
      [
        -62,
        87
      ],
      [
        -62,
        76
      ],
      [
        -37,
        0
      ],
      [
        -37,
        54
      ],
      [
        -50,
        11
      ],
      [
        -37,
        108
      ],
      [
        -87,
        228
      ],
      [
        25,
        87
      ],
      [
        -12,
        65
      ],
      [
        0,
        54
      ],
      [
        -25,
        87
      ],
      [
        -99,
        249
      ],
      [
        -37,
        44
      ],
      [
        -25,
        87
      ],
      [
        0,
        86
      ],
      [
        -62,
        44
      ],
      [
        -87,
        303
      ],
      [
        -49,
        109
      ],
      [
        -25,
        76
      ],
      [
        -62,
        119
      ],
      [
        -37,
        109
      ],
      [
        -62,
        108
      ],
      [
        -50,
        195
      ],
      [
        -86,
        185
      ],
      [
        -37,
        32
      ],
      [
        -87,
        11
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -44
      ],
      [
        -12,
        54
      ],
      [
        24,
        66
      ],
      [
        37,
        151
      ],
      [
        13,
        141
      ],
      [
        49,
        391
      ]
    ],
    [
      [
        73655,
        62121
      ],
      [
        -74,
        0
      ],
      [
        0,
        163
      ],
      [
        25,
        76
      ],
      [
        0,
        141
      ],
      [
        -13,
        76
      ],
      [
        -12,
        11
      ],
      [
        -149,
        216
      ],
      [
        -25,
        55
      ],
      [
        0,
        11
      ],
      [
        -86,
        54
      ],
      [
        0,
        21
      ],
      [
        12,
        22
      ],
      [
        0,
        22
      ],
      [
        -25,
        466
      ],
      [
        0,
        33
      ],
      [
        13,
        11
      ],
      [
        0,
        173
      ],
      [
        24,
        119
      ],
      [
        0,
        55
      ],
      [
        -161,
        0
      ],
      [
        0,
        -131
      ],
      [
        -223,
        0
      ],
      [
        87,
        -184
      ],
      [
        0,
        -22
      ],
      [
        13,
        -65
      ],
      [
        -13,
        -97
      ],
      [
        0,
        -65
      ],
      [
        37,
        -130
      ],
      [
        -12,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -161,
        -249
      ],
      [
        0,
        -11
      ],
      [
        -25,
        -98
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        -87
      ],
      [
        -149,
        -260
      ],
      [
        -25,
        -22
      ],
      [
        -74,
        -10
      ],
      [
        -50,
        0
      ],
      [
        -12,
        -11
      ],
      [
        -99,
        152
      ],
      [
        -161,
        184
      ],
      [
        -99,
        -98
      ],
      [
        -37,
        -32
      ],
      [
        0,
        -87
      ],
      [
        -13,
        -43
      ],
      [
        -24,
        -55
      ],
      [
        -87,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        -50,
        -43
      ],
      [
        -12,
        -44
      ],
      [
        -37,
        -54
      ],
      [
        0,
        -87
      ],
      [
        -273,
        11
      ],
      [
        -12,
        22
      ],
      [
        -38,
        141
      ],
      [
        -37,
        0
      ],
      [
        -247,
        11
      ],
      [
        -38,
        -11
      ],
      [
        -74,
        -65
      ],
      [
        -37,
        0
      ],
      [
        -37,
        22
      ],
      [
        -124,
        271
      ],
      [
        -25,
        32
      ],
      [
        -37,
        65
      ],
      [
        -37,
        55
      ],
      [
        0,
        86
      ],
      [
        -13,
        44
      ],
      [
        -12,
        0
      ],
      [
        -186,
        -55
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -10
      ],
      [
        -12,
        -11
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -76
      ],
      [
        -25,
        -76
      ],
      [
        -50,
        -97
      ],
      [
        -12,
        -44
      ],
      [
        12,
        -97
      ],
      [
        -12,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -130
      ],
      [
        -38,
        -76
      ],
      [
        0,
        -87
      ],
      [
        -12,
        -22
      ],
      [
        -74,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        69790,
        63032
      ],
      [
        13,
        76
      ],
      [
        12,
        98
      ],
      [
        0,
        97
      ],
      [
        -25,
        33
      ],
      [
        -25,
        0
      ],
      [
        -74,
        108
      ],
      [
        0,
        282
      ],
      [
        -37,
        22
      ],
      [
        0,
        43
      ],
      [
        -25,
        206
      ],
      [
        13,
        55
      ],
      [
        -25,
        76
      ],
      [
        -37,
        21
      ],
      [
        -87,
        -21
      ],
      [
        -25,
        10
      ],
      [
        -25,
        33
      ],
      [
        -12,
        32
      ],
      [
        12,
        44
      ],
      [
        13,
        87
      ],
      [
        37,
        76
      ],
      [
        50,
        54
      ],
      [
        24,
        43
      ],
      [
        0,
        33
      ],
      [
        13,
        43
      ],
      [
        -13,
        43
      ],
      [
        0,
        44
      ],
      [
        -24,
        54
      ],
      [
        -13,
        65
      ],
      [
        0,
        44
      ],
      [
        25,
        75
      ],
      [
        37,
        44
      ],
      [
        12,
        22
      ],
      [
        25,
        21
      ],
      [
        37,
        44
      ],
      [
        13,
        21
      ],
      [
        0,
        22
      ],
      [
        -13,
        22
      ],
      [
        -24,
        65
      ],
      [
        0,
        65
      ],
      [
        -13,
        43
      ],
      [
        0,
        22
      ],
      [
        25,
        54
      ],
      [
        25,
        22
      ],
      [
        37,
        11
      ],
      [
        12,
        21
      ],
      [
        0,
        87
      ],
      [
        13,
        22
      ],
      [
        12,
        65
      ],
      [
        12,
        32
      ],
      [
        25,
        33
      ],
      [
        25,
        43
      ],
      [
        12,
        44
      ],
      [
        0,
        43
      ],
      [
        -12,
        141
      ],
      [
        25,
        54
      ],
      [
        37,
        54
      ],
      [
        50,
        -10
      ],
      [
        74,
        10
      ],
      [
        49,
        22
      ],
      [
        25,
        0
      ],
      [
        87,
        -22
      ],
      [
        12,
        0
      ],
      [
        0,
        413
      ],
      [
        0,
        282
      ],
      [
        0,
        282
      ],
      [
        0,
        282
      ],
      [
        0,
        271
      ],
      [
        0,
        282
      ],
      [
        0,
        282
      ],
      [
        0,
        271
      ]
    ],
    [
      [
        74609,
        69951
      ],
      [
        0,
        -141
      ],
      [
        25,
        -108
      ],
      [
        49,
        -163
      ],
      [
        50,
        -86
      ],
      [
        12,
        -55
      ],
      [
        -12,
        -21
      ],
      [
        -25,
        21
      ],
      [
        0,
        -238
      ],
      [
        25,
        -109
      ],
      [
        -13,
        -97
      ],
      [
        0,
        -174
      ],
      [
        25,
        -206
      ],
      [
        0,
        -130
      ],
      [
        37,
        -304
      ],
      [
        38,
        -173
      ],
      [
        12,
        -44
      ],
      [
        25,
        -21
      ],
      [
        49,
        -11
      ],
      [
        124,
        -174
      ],
      [
        12,
        -54
      ],
      [
        25,
        -54
      ],
      [
        25,
        32
      ],
      [
        25,
        -43
      ],
      [
        74,
        -98
      ],
      [
        13,
        -43
      ]
    ],
    [
      [
        73618,
        58846
      ],
      [
        -87,
        -141
      ],
      [
        -62,
        -108
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -62,
        11
      ],
      [
        -62,
        65
      ],
      [
        -49,
        -54
      ],
      [
        -38,
        -11
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        -11
      ],
      [
        -74,
        -22
      ],
      [
        -49,
        -65
      ],
      [
        -13,
        -43
      ],
      [
        -37,
        11
      ],
      [
        -37,
        32
      ],
      [
        -13,
        65
      ],
      [
        -37,
        55
      ],
      [
        -62,
        -65
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -37,
        43
      ],
      [
        -50,
        22
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        56177,
        63932
      ],
      [
        -13,
        22
      ],
      [
        -12,
        54
      ],
      [
        0,
        33
      ],
      [
        74,
        43
      ],
      [
        37,
        -11
      ],
      [
        0,
        22
      ],
      [
        -37,
        33
      ],
      [
        -12,
        32
      ],
      [
        -13,
        -22
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        33
      ],
      [
        0,
        22
      ],
      [
        12,
        21
      ],
      [
        -12,
        109
      ],
      [
        12,
        65
      ],
      [
        -12,
        54
      ]
    ],
    [
      [
        56226,
        64702
      ],
      [
        -12,
        65
      ],
      [
        -13,
        44
      ],
      [
        -37,
        43
      ],
      [
        -12,
        44
      ],
      [
        12,
        32
      ],
      [
        37,
        33
      ],
      [
        0,
        21
      ],
      [
        -12,
        0
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        0
      ],
      [
        -13,
        54
      ],
      [
        -24,
        76
      ],
      [
        -25,
        119
      ],
      [
        -37,
        43
      ],
      [
        -37,
        109
      ],
      [
        -25,
        32
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        -43
      ],
      [
        -24,
        65
      ],
      [
        37,
        22
      ],
      [
        99,
        86
      ],
      [
        99,
        228
      ],
      [
        99,
        282
      ],
      [
        13,
        65
      ]
    ],
    [
      [
        97699,
        57046
      ],
      [
        -50,
        -44
      ],
      [
        -62,
        44
      ],
      [
        13,
        54
      ],
      [
        49,
        22
      ],
      [
        50,
        -44
      ],
      [
        0,
        -32
      ]
    ],
    [
      [
        52894,
        19717
      ],
      [
        0,
        -44
      ],
      [
        -62,
        33
      ],
      [
        -12,
        21
      ],
      [
        24,
        22
      ],
      [
        25,
        0
      ],
      [
        25,
        -32
      ]
    ],
    [
      [
        49153,
        22439
      ],
      [
        37,
        -33
      ],
      [
        25,
        22
      ],
      [
        87,
        -11
      ],
      [
        24,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        37,
        11
      ],
      [
        37,
        -43
      ],
      [
        37,
        43
      ],
      [
        38,
        -76
      ],
      [
        37,
        -54
      ],
      [
        12,
        -65
      ],
      [
        13,
        -11
      ],
      [
        49,
        11
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -44
      ],
      [
        37,
        -32
      ],
      [
        -49,
        -44
      ],
      [
        -50,
        -21
      ],
      [
        -62,
        54
      ],
      [
        -62,
        130
      ],
      [
        -24,
        44
      ],
      [
        -38,
        0
      ],
      [
        -37,
        21
      ],
      [
        -62,
        76
      ],
      [
        -37,
        0
      ],
      [
        -49,
        44
      ],
      [
        -112,
        75
      ],
      [
        -49,
        -10
      ],
      [
        -25,
        21
      ],
      [
        0,
        44
      ],
      [
        49,
        43
      ],
      [
        62,
        11
      ],
      [
        0,
        -22
      ],
      [
        50,
        -32
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        59967,
        46222
      ],
      [
        -37,
        -11
      ],
      [
        25,
        65
      ],
      [
        24,
        0
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        56982,
        51233
      ],
      [
        -13,
        0
      ],
      [
        0,
        54
      ],
      [
        25,
        -11
      ],
      [
        13,
        -22
      ],
      [
        -25,
        -21
      ]
    ],
    [
      [
        119352,
        48923
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        11
      ],
      [
        -25,
        54
      ],
      [
        25,
        11
      ],
      [
        12,
        -11
      ],
      [
        25,
        -54
      ]
    ],
    [
      [
        117172,
        48847
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        22
      ],
      [
        -12,
        54
      ],
      [
        -25,
        22
      ],
      [
        -50,
        21
      ],
      [
        -12,
        22
      ],
      [
        -37,
        11
      ],
      [
        -13,
        32
      ],
      [
        13,
        22
      ],
      [
        0,
        22
      ],
      [
        24,
        -22
      ],
      [
        124,
        -119
      ],
      [
        37,
        -44
      ],
      [
        13,
        -21
      ]
    ],
    [
      [
        119079,
        49497
      ],
      [
        -37,
        -10
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        11
      ],
      [
        -12,
        33
      ],
      [
        12,
        11
      ],
      [
        13,
        43
      ],
      [
        12,
        11
      ],
      [
        37,
        11
      ],
      [
        37,
        -11
      ],
      [
        13,
        -11
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        117568,
        49725
      ],
      [
        37,
        -32
      ],
      [
        25,
        0
      ],
      [
        37,
        -22
      ],
      [
        25,
        11
      ],
      [
        25,
        -33
      ],
      [
        49,
        -130
      ],
      [
        0,
        -32
      ],
      [
        25,
        -33
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        22
      ],
      [
        -50,
        11
      ],
      [
        -37,
        32
      ],
      [
        -87,
        98
      ],
      [
        0,
        43
      ],
      [
        -12,
        22
      ],
      [
        -12,
        54
      ],
      [
        -25,
        22
      ],
      [
        -37,
        11
      ],
      [
        0,
        75
      ],
      [
        62,
        -21
      ],
      [
        61,
        -76
      ],
      [
        25,
        -22
      ]
    ],
    [
      [
        117506,
        50202
      ],
      [
        0,
        -86
      ],
      [
        -24,
        43
      ],
      [
        -13,
        -22
      ],
      [
        -12,
        33
      ],
      [
        0,
        195
      ],
      [
        49,
        -163
      ]
    ],
    [
      [
        116887,
        50419
      ],
      [
        74,
        -97
      ],
      [
        37,
        11
      ],
      [
        100,
        0
      ],
      [
        86,
        -109
      ],
      [
        25,
        -65
      ],
      [
        25,
        -11
      ],
      [
        12,
        -32
      ],
      [
        13,
        -65
      ],
      [
        -38,
        -33
      ],
      [
        -24,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -50,
        54
      ],
      [
        -111,
        0
      ],
      [
        -50,
        11
      ],
      [
        -12,
        22
      ],
      [
        -25,
        21
      ],
      [
        -25,
        55
      ],
      [
        -25,
        65
      ],
      [
        0,
        119
      ],
      [
        25,
        43
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        117036,
        50593
      ],
      [
        24,
        -11
      ],
      [
        25,
        -33
      ],
      [
        25,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        22
      ],
      [
        -13,
        0
      ],
      [
        0,
        22
      ],
      [
        -24,
        22
      ],
      [
        -25,
        0
      ],
      [
        0,
        32
      ],
      [
        25,
        22
      ]
    ],
    [
      [
        116689,
        50517
      ],
      [
        -37,
        11
      ],
      [
        -13,
        21
      ],
      [
        13,
        22
      ],
      [
        24,
        22
      ],
      [
        38,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        116168,
        50745
      ],
      [
        0,
        -22
      ],
      [
        -24,
        0
      ],
      [
        -50,
        32
      ],
      [
        0,
        22
      ],
      [
        50,
        0
      ],
      [
        24,
        -32
      ]
    ],
    [
      [
        116354,
        50701
      ],
      [
        -12,
        0
      ],
      [
        0,
        22
      ],
      [
        12,
        65
      ],
      [
        13,
        -54
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        116317,
        50788
      ],
      [
        -25,
        -43
      ],
      [
        -24,
        10
      ],
      [
        -25,
        44
      ],
      [
        12,
        65
      ],
      [
        25,
        11
      ],
      [
        0,
        21
      ],
      [
        37,
        -10
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        116069,
        50766
      ],
      [
        -12,
        11
      ],
      [
        -37,
        87
      ],
      [
        0,
        32
      ],
      [
        37,
        55
      ],
      [
        12,
        0
      ],
      [
        13,
        -33
      ],
      [
        -13,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -43
      ],
      [
        12,
        -44
      ]
    ],
    [
      [
        116862,
        50896
      ],
      [
        -12,
        -10
      ],
      [
        -37,
        54
      ],
      [
        12,
        32
      ],
      [
        12,
        11
      ],
      [
        13,
        -21
      ],
      [
        0,
        -22
      ],
      [
        12,
        -44
      ]
    ],
    [
      [
        117234,
        51016
      ],
      [
        86,
        -185
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -65
      ],
      [
        12,
        -22
      ],
      [
        25,
        -10
      ],
      [
        37,
        -66
      ],
      [
        12,
        -75
      ],
      [
        25,
        -66
      ],
      [
        0,
        -75
      ],
      [
        37,
        -109
      ],
      [
        0,
        -76
      ],
      [
        -12,
        11
      ],
      [
        -50,
        119
      ],
      [
        -49,
        55
      ],
      [
        -62,
        97
      ],
      [
        -37,
        119
      ],
      [
        -37,
        217
      ],
      [
        24,
        44
      ],
      [
        -49,
        108
      ],
      [
        12,
        33
      ],
      [
        25,
        -11
      ],
      [
        25,
        11
      ]
    ],
    [
      [
        116206,
        51070
      ],
      [
        24,
        -54
      ],
      [
        25,
        -120
      ],
      [
        -12,
        -32
      ],
      [
        -13,
        0
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        55
      ],
      [
        -25,
        21
      ],
      [
        -24,
        33
      ],
      [
        -13,
        65
      ],
      [
        0,
        43
      ],
      [
        -12,
        11
      ],
      [
        -62,
        -11
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        11
      ],
      [
        0,
        65
      ],
      [
        37,
        32
      ],
      [
        0,
        44
      ],
      [
        37,
        65
      ],
      [
        13,
        11
      ],
      [
        37,
        -22
      ],
      [
        12,
        -98
      ],
      [
        12,
        -32
      ],
      [
        38,
        -11
      ]
    ],
    [
      [
        115809,
        51113
      ],
      [
        -12,
        -21
      ],
      [
        -13,
        76
      ],
      [
        0,
        65
      ],
      [
        13,
        10
      ],
      [
        12,
        -86
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        115995,
        51146
      ],
      [
        0,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -25,
        65
      ],
      [
        0,
        43
      ],
      [
        12,
        44
      ],
      [
        38,
        11
      ],
      [
        24,
        -55
      ],
      [
        0,
        -86
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        115834,
        51265
      ],
      [
        -25,
        33
      ],
      [
        0,
        43
      ],
      [
        -37,
        54
      ],
      [
        0,
        44
      ],
      [
        12,
        43
      ],
      [
        38,
        -22
      ],
      [
        24,
        -54
      ],
      [
        25,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -87
      ]
    ],
    [
      [
        116936,
        50886
      ],
      [
        0,
        -22
      ],
      [
        -49,
        54
      ],
      [
        -37,
        65
      ],
      [
        -99,
        76
      ],
      [
        -25,
        33
      ],
      [
        -12,
        0
      ],
      [
        -50,
        65
      ],
      [
        -50,
        32
      ],
      [
        -37,
        54
      ],
      [
        0,
        22
      ],
      [
        -25,
        11
      ],
      [
        -24,
        54
      ],
      [
        -37,
        33
      ],
      [
        -13,
        76
      ],
      [
        -37,
        65
      ],
      [
        99,
        -44
      ],
      [
        37,
        -76
      ],
      [
        37,
        -32
      ],
      [
        25,
        -33
      ],
      [
        25,
        -43
      ],
      [
        37,
        0
      ],
      [
        25,
        -43
      ],
      [
        25,
        -11
      ],
      [
        24,
        -22
      ],
      [
        149,
        -184
      ],
      [
        -25,
        -54
      ],
      [
        25,
        -33
      ],
      [
        12,
        -43
      ]
    ],
    [
      [
        115537,
        51786
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        22
      ],
      [
        25,
        76
      ],
      [
        37,
        -44
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        116107,
        51634
      ],
      [
        12,
        -22
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        11
      ],
      [
        -12,
        32
      ],
      [
        -25,
        0
      ],
      [
        -50,
        11
      ],
      [
        -62,
        98
      ],
      [
        -74,
        162
      ],
      [
        -62,
        98
      ],
      [
        -25,
        76
      ],
      [
        13,
        21
      ],
      [
        49,
        -21
      ],
      [
        50,
        -76
      ],
      [
        99,
        -87
      ],
      [
        25,
        -32
      ],
      [
        12,
        -98
      ],
      [
        12,
        -33
      ],
      [
        50,
        -76
      ],
      [
        25,
        -21
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        57614,
        60863
      ],
      [
        -25,
        22
      ],
      [
        -124,
        54
      ],
      [
        37,
        33
      ],
      [
        87,
        10
      ],
      [
        25,
        -21
      ],
      [
        12,
        -44
      ],
      [
        -12,
        -54
      ]
    ],
    [
      [
        57960,
        60527
      ],
      [
        -74,
        119
      ],
      [
        -62,
        54
      ],
      [
        -198,
        131
      ],
      [
        0,
        32
      ],
      [
        25,
        65
      ],
      [
        -25,
        76
      ],
      [
        0,
        54
      ],
      [
        -25,
        -32
      ],
      [
        -49,
        11
      ],
      [
        -25,
        43
      ],
      [
        -25,
        22
      ],
      [
        -12,
        21
      ],
      [
        -13,
        120
      ],
      [
        -12,
        54
      ],
      [
        -25,
        43
      ],
      [
        -37,
        0
      ],
      [
        -25,
        76
      ],
      [
        -25,
        65
      ],
      [
        13,
        33
      ],
      [
        12,
        0
      ],
      [
        25,
        -22
      ],
      [
        25,
        -11
      ],
      [
        24,
        55
      ],
      [
        38,
        65
      ],
      [
        0,
        21
      ],
      [
        -25,
        -21
      ],
      [
        -50,
        0
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        76
      ],
      [
        0,
        98
      ],
      [
        50,
        0
      ],
      [
        0,
        21
      ],
      [
        -25,
        11
      ],
      [
        -50,
        54
      ],
      [
        0,
        44
      ]
    ],
    [
      [
        31712,
        64583
      ],
      [
        -13,
        -11
      ],
      [
        13,
        -65
      ],
      [
        -25,
        -32
      ],
      [
        -13,
        -33
      ],
      [
        -86,
        0
      ],
      [
        -87,
        22
      ],
      [
        -25,
        -11
      ],
      [
        -124,
        54
      ],
      [
        -148,
        130
      ],
      [
        -87,
        11
      ],
      [
        -87,
        33
      ],
      [
        -62,
        76
      ],
      [
        -37,
        32
      ]
    ],
    [
      [
        66223,
        83638
      ],
      [
        -25,
        0
      ],
      [
        -12,
        22
      ],
      [
        24,
        32
      ],
      [
        25,
        -21
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        76802,
        63401
      ],
      [
        74,
        -98
      ],
      [
        62,
        -195
      ],
      [
        74,
        -163
      ],
      [
        99,
        -141
      ],
      [
        50,
        -54
      ],
      [
        37,
        -21
      ],
      [
        186,
        0
      ],
      [
        136,
        141
      ],
      [
        124,
        97
      ],
      [
        49,
        11
      ],
      [
        62,
        -22
      ],
      [
        87,
        -11
      ],
      [
        62,
        -21
      ],
      [
        37,
        0
      ],
      [
        149,
        119
      ],
      [
        86,
        109
      ],
      [
        62,
        43
      ],
      [
        25,
        0
      ],
      [
        75,
        -43
      ],
      [
        111,
        21
      ],
      [
        136,
        98
      ],
      [
        50,
        11
      ],
      [
        37,
        0
      ],
      [
        74,
        -33
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        78759,
        63249
      ],
      [
        0,
        -347
      ],
      [
        0,
        -455
      ],
      [
        0,
        -326
      ],
      [
        -50,
        -141
      ],
      [
        -62,
        -162
      ],
      [
        -62,
        -185
      ],
      [
        -148,
        -423
      ]
    ],
    [
      [
        78759,
        63249
      ],
      [
        49,
        0
      ],
      [
        112,
        54
      ],
      [
        86,
        65
      ],
      [
        161,
        44
      ],
      [
        124,
        130
      ],
      [
        13,
        54
      ],
      [
        37,
        76
      ],
      [
        62,
        33
      ],
      [
        136,
        -98
      ],
      [
        25,
        0
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -98
      ],
      [
        -12,
        -109
      ],
      [
        12,
        -162
      ],
      [
        0,
        -293
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -33
      ],
      [
        37,
        0
      ],
      [
        0,
        43
      ],
      [
        37,
        -32
      ],
      [
        25,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -25,
        22
      ],
      [
        -87,
        -55
      ],
      [
        -12,
        -54
      ],
      [
        -12,
        -206
      ],
      [
        -13,
        -130
      ],
      [
        0,
        -184
      ],
      [
        -49,
        -109
      ],
      [
        -25,
        -87
      ],
      [
        -62,
        -162
      ],
      [
        -37,
        -141
      ],
      [
        -13,
        -76
      ],
      [
        -62,
        -185
      ],
      [
        -86,
        -151
      ],
      [
        -37,
        -196
      ],
      [
        -25,
        -108
      ],
      [
        -37,
        -109
      ],
      [
        -75,
        -195
      ],
      [
        -37,
        -130
      ],
      [
        -49,
        -239
      ],
      [
        -25,
        -141
      ],
      [
        -136,
        -422
      ],
      [
        -137,
        -337
      ],
      [
        -86,
        -293
      ],
      [
        -161,
        -325
      ],
      [
        -223,
        -423
      ],
      [
        -285,
        -510
      ],
      [
        -75,
        -108
      ],
      [
        -309,
        -304
      ],
      [
        -211,
        -271
      ],
      [
        -99,
        -173
      ],
      [
        -111,
        -152
      ],
      [
        -87,
        -152
      ],
      [
        -260,
        -499
      ],
      [
        -50,
        -87
      ],
      [
        -49,
        -119
      ],
      [
        -62,
        -141
      ],
      [
        -38,
        -76
      ],
      [
        -49,
        -76
      ],
      [
        -12,
        -54
      ],
      [
        -38,
        -87
      ],
      [
        -37,
        -141
      ],
      [
        -62,
        -162
      ]
    ],
    [
      [
        42563,
        85471
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        11
      ],
      [
        12,
        65
      ],
      [
        -12,
        109
      ],
      [
        37,
        -11
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        24,
        -65
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        64216,
        56287
      ],
      [
        -37,
        -44
      ],
      [
        -13,
        11
      ],
      [
        -12,
        33
      ],
      [
        0,
        97
      ],
      [
        12,
        43
      ],
      [
        38,
        33
      ],
      [
        24,
        11
      ],
      [
        13,
        -54
      ],
      [
        0,
        -55
      ],
      [
        -25,
        -75
      ]
    ],
    [
      [
        64476,
        57198
      ],
      [
        -12,
        -22
      ],
      [
        -13,
        11
      ],
      [
        0,
        32
      ],
      [
        13,
        44
      ],
      [
        12,
        10
      ],
      [
        12,
        -10
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        42241,
        59681
      ],
      [
        12,
        -11
      ],
      [
        13,
        65
      ],
      [
        0,
        65
      ],
      [
        24,
        120
      ],
      [
        38,
        32
      ],
      [
        173,
        -32
      ],
      [
        74,
        -33
      ],
      [
        99,
        -54
      ],
      [
        13,
        -54
      ],
      [
        12,
        54
      ],
      [
        -12,
        65
      ],
      [
        25,
        43
      ],
      [
        61,
        11
      ],
      [
        100,
        -22
      ],
      [
        74,
        33
      ],
      [
        111,
        -11
      ],
      [
        161,
        -43
      ],
      [
        75,
        -33
      ],
      [
        37,
        -32
      ],
      [
        0,
        -130
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -87
      ]
    ],
    [
      [
        69679,
        86870
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -21
      ],
      [
        -62,
        -185
      ],
      [
        -49,
        -76
      ],
      [
        0,
        -108
      ]
    ],
    [
      [
        66594,
        84647
      ],
      [
        25,
        11
      ],
      [
        25,
        32
      ]
    ],
    [
      [
        67610,
        91382
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        0
      ],
      [
        0,
        43
      ],
      [
        -12,
        109
      ],
      [
        12,
        54
      ],
      [
        74,
        184
      ],
      [
        37,
        22
      ],
      [
        50,
        163
      ],
      [
        37,
        97
      ],
      [
        25,
        -21
      ],
      [
        0,
        -55
      ],
      [
        -62,
        -130
      ],
      [
        -12,
        -97
      ],
      [
        -25,
        -22
      ],
      [
        -87,
        -314
      ]
    ],
    [
      [
        68490,
        92347
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -22
      ],
      [
        -13,
        -141
      ],
      [
        38,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -50,
        -98
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -21
      ],
      [
        -50,
        -120
      ],
      [
        -24,
        -32
      ],
      [
        -37,
        0
      ],
      [
        49,
        98
      ],
      [
        -25,
        32
      ],
      [
        -12,
        54
      ],
      [
        -25,
        33
      ],
      [
        13,
        43
      ],
      [
        0,
        130
      ],
      [
        24,
        44
      ],
      [
        25,
        21
      ],
      [
        37,
        66
      ],
      [
        50,
        43
      ],
      [
        62,
        22
      ],
      [
        24,
        -22
      ],
      [
        13,
        43
      ],
      [
        25,
        11
      ],
      [
        62,
        -43
      ]
    ],
    [
      [
        68514,
        92401
      ],
      [
        0,
        -43
      ],
      [
        -24,
        0
      ],
      [
        -13,
        32
      ],
      [
        25,
        44
      ],
      [
        62,
        0
      ],
      [
        12,
        -11
      ],
      [
        -62,
        -22
      ]
    ],
    [
      [
        68267,
        93084
      ],
      [
        -25,
        0
      ],
      [
        0,
        33
      ],
      [
        37,
        21
      ],
      [
        -12,
        -54
      ]
    ],
    [
      [
        68316,
        93366
      ],
      [
        -12,
        11
      ],
      [
        25,
        33
      ],
      [
        24,
        -11
      ],
      [
        -37,
        -33
      ]
    ],
    [
      [
        70236,
        97325
      ],
      [
        -87,
        -22
      ],
      [
        -74,
        33
      ],
      [
        -37,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -99,
        -44
      ],
      [
        -62,
        22
      ],
      [
        -62,
        54
      ],
      [
        -74,
        -43
      ],
      [
        -25,
        32
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -65
      ],
      [
        -12,
        -86
      ],
      [
        -62,
        0
      ],
      [
        25,
        -33
      ],
      [
        -75,
        -11
      ],
      [
        -12,
        -22
      ],
      [
        25,
        -21
      ],
      [
        -13,
        -22
      ],
      [
        -87,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -33
      ],
      [
        25,
        -21
      ],
      [
        24,
        -76
      ],
      [
        -49,
        -65
      ],
      [
        -50,
        -44
      ],
      [
        -49,
        -86
      ],
      [
        49,
        -55
      ],
      [
        13,
        -54
      ],
      [
        24,
        -54
      ],
      [
        50,
        -54
      ],
      [
        -25,
        -54
      ],
      [
        -74,
        -44
      ],
      [
        -74,
        -76
      ],
      [
        -87,
        -195
      ],
      [
        -112,
        -54
      ],
      [
        -24,
        -33
      ],
      [
        -62,
        -43
      ],
      [
        -99,
        -33
      ],
      [
        -50,
        -43
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        32
      ],
      [
        -12,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -62,
        -65
      ],
      [
        -74,
        10
      ],
      [
        0,
        -43
      ],
      [
        -74,
        -11
      ],
      [
        -25,
        -65
      ],
      [
        -75,
        -43
      ],
      [
        50,
        -22
      ],
      [
        0,
        -43
      ],
      [
        -74,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -37,
        0
      ],
      [
        12,
        32
      ],
      [
        -74,
        -11
      ],
      [
        25,
        -65
      ],
      [
        -25,
        -43
      ],
      [
        49,
        -33
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -49,
        43
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -54
      ],
      [
        37,
        -44
      ],
      [
        12,
        -32
      ],
      [
        -24,
        -33
      ],
      [
        -13,
        -87
      ],
      [
        -25,
        -97
      ],
      [
        0,
        -54
      ],
      [
        25,
        -65
      ],
      [
        -49,
        10
      ],
      [
        -38,
        22
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -55
      ],
      [
        0,
        -43
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        24,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -87
      ],
      [
        12,
        -119
      ],
      [
        25,
        -87
      ],
      [
        -12,
        -65
      ],
      [
        37,
        -43
      ],
      [
        74,
        0
      ],
      [
        37,
        -65
      ],
      [
        25,
        0
      ],
      [
        37,
        32
      ],
      [
        38,
        0
      ],
      [
        12,
        -43
      ],
      [
        50,
        -65
      ],
      [
        37,
        -33
      ],
      [
        49,
        -11
      ],
      [
        50,
        -54
      ],
      [
        0,
        -65
      ],
      [
        25,
        -22
      ],
      [
        61,
        -21
      ],
      [
        25,
        -33
      ],
      [
        25,
        -54
      ],
      [
        12,
        -76
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -11
      ],
      [
        -62,
        -54
      ],
      [
        -50,
        -55
      ],
      [
        -99,
        -75
      ],
      [
        -49,
        -11
      ],
      [
        -62,
        -44
      ],
      [
        0,
        -11
      ],
      [
        62,
        -10
      ],
      [
        37,
        32
      ],
      [
        49,
        0
      ],
      [
        37,
        22
      ],
      [
        25,
        -11
      ],
      [
        13,
        -43
      ],
      [
        -38,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -44
      ],
      [
        -62,
        -32
      ],
      [
        -99,
        -65
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -33
      ],
      [
        -74,
        -43
      ],
      [
        -37,
        -44
      ],
      [
        -87,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        -235,
        0
      ],
      [
        25,
        -32
      ],
      [
        99,
        0
      ],
      [
        37,
        -11
      ],
      [
        49,
        -65
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        -11
      ],
      [
        12,
        -86
      ],
      [
        25,
        -55
      ],
      [
        -25,
        -32
      ],
      [
        0,
        -152
      ],
      [
        -37,
        0
      ],
      [
        -13,
        -65
      ],
      [
        13,
        -32
      ],
      [
        0,
        -120
      ],
      [
        25,
        -43
      ],
      [
        -13,
        -44
      ],
      [
        -49,
        -97
      ],
      [
        0,
        -76
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -87
      ],
      [
        -12,
        -76
      ],
      [
        -25,
        -54
      ],
      [
        -49,
        -76
      ],
      [
        -13,
        -54
      ],
      [
        -62,
        -174
      ],
      [
        -24,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -75,
        33
      ],
      [
        -37,
        0
      ],
      [
        -62,
        -22
      ],
      [
        -99,
        22
      ],
      [
        -86,
        -11
      ],
      [
        -25,
        -11
      ],
      [
        12,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -99,
        -109
      ],
      [
        -25,
        -97
      ],
      [
        37,
        -55
      ],
      [
        12,
        -65
      ],
      [
        -49,
        -86
      ],
      [
        -37,
        0
      ],
      [
        -99,
        21
      ],
      [
        -161,
        -54
      ],
      [
        -149,
        43
      ],
      [
        25,
        120
      ],
      [
        0,
        86
      ],
      [
        -13,
        44
      ],
      [
        -37,
        43
      ],
      [
        -74,
        163
      ],
      [
        -37,
        98
      ],
      [
        74,
        -44
      ],
      [
        37,
        22
      ],
      [
        -25,
        54
      ],
      [
        -24,
        22
      ],
      [
        0,
        32
      ],
      [
        62,
        11
      ],
      [
        24,
        44
      ],
      [
        -12,
        54
      ],
      [
        -62,
        32
      ],
      [
        -50,
        98
      ],
      [
        -49,
        54
      ],
      [
        -87,
        195
      ],
      [
        -37,
        141
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        120
      ],
      [
        0,
        43
      ],
      [
        -49,
        22
      ],
      [
        -13,
        152
      ],
      [
        -49,
        21
      ],
      [
        -38,
        76
      ],
      [
        0,
        141
      ],
      [
        -37,
        22
      ],
      [
        -37,
        -11
      ],
      [
        13,
        65
      ],
      [
        -25,
        250
      ],
      [
        -13,
        32
      ],
      [
        0,
        76
      ],
      [
        13,
        22
      ],
      [
        37,
        11
      ],
      [
        25,
        -33
      ]
    ],
    [
      [
        72974,
        39444
      ],
      [
        -37,
        22
      ],
      [
        -13,
        -98
      ],
      [
        -12,
        -130
      ],
      [
        12,
        -76
      ],
      [
        -74,
        -11
      ],
      [
        -99,
        11
      ],
      [
        -62,
        32
      ],
      [
        -74,
        87
      ],
      [
        -50,
        120
      ],
      [
        -12,
        75
      ],
      [
        -38,
        22
      ],
      [
        0,
        195
      ],
      [
        13,
        22
      ],
      [
        49,
        119
      ],
      [
        25,
        76
      ],
      [
        13,
        76
      ],
      [
        49,
        87
      ],
      [
        37,
        54
      ],
      [
        25,
        11
      ],
      [
        87,
        -87
      ],
      [
        74,
        -65
      ],
      [
        25,
        11
      ]
    ],
    [
      [
        40246,
        67500
      ],
      [
        0,
        -32
      ],
      [
        -24,
        11
      ],
      [
        -13,
        21
      ]
    ],
    [
      [
        81038,
        53282
      ],
      [
        0,
        -54
      ],
      [
        -25,
        11
      ],
      [
        0,
        43
      ],
      [
        -25,
        22
      ],
      [
        -12,
        33
      ],
      [
        25,
        32
      ],
      [
        37,
        -87
      ]
    ],
    [
      [
        74299,
        77847
      ],
      [
        -25,
        141
      ],
      [
        0,
        130
      ],
      [
        13,
        97
      ],
      [
        0,
        76
      ],
      [
        -13,
        44
      ],
      [
        -49,
        97
      ],
      [
        25,
        174
      ],
      [
        24,
        43
      ]
    ],
    [
      [
        74274,
        78649
      ],
      [
        25,
        0
      ],
      [
        50,
        -54
      ],
      [
        12,
        0
      ],
      [
        37,
        87
      ],
      [
        38,
        22
      ],
      [
        0,
        108
      ],
      [
        37,
        32
      ],
      [
        62,
        0
      ],
      [
        0,
        22
      ],
      [
        -38,
        119
      ],
      [
        0,
        33
      ],
      [
        13,
        119
      ],
      [
        12,
        55
      ],
      [
        13,
        10
      ],
      [
        99,
        -21
      ],
      [
        12,
        -44
      ],
      [
        37,
        -32
      ],
      [
        37,
        11
      ],
      [
        50,
        -11
      ],
      [
        37,
        0
      ],
      [
        25,
        21
      ],
      [
        136,
        76
      ],
      [
        99,
        65
      ],
      [
        62,
        -21
      ],
      [
        25,
        0
      ],
      [
        87,
        -98
      ],
      [
        24,
        -11
      ],
      [
        50,
        0
      ],
      [
        62,
        -11
      ],
      [
        87,
        0
      ],
      [
        49,
        11
      ],
      [
        62,
        22
      ],
      [
        112,
        54
      ],
      [
        161,
        120
      ],
      [
        86,
        54
      ],
      [
        38,
        11
      ],
      [
        49,
        0
      ],
      [
        50,
        -22
      ],
      [
        49,
        -11
      ],
      [
        25,
        11
      ],
      [
        62,
        11
      ],
      [
        124,
        32
      ],
      [
        62,
        33
      ],
      [
        49,
        65
      ],
      [
        37,
        -43
      ],
      [
        25,
        -76
      ]
    ],
    [
      [
        37038,
        69865
      ],
      [
        50,
        -44
      ],
      [
        0,
        -11
      ],
      [
        -37,
        -10
      ],
      [
        -13,
        10
      ],
      [
        0,
        55
      ]
    ],
    [
      [
        37199,
        69854
      ],
      [
        25,
        11
      ],
      [
        37,
        -11
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -10
      ],
      [
        -12,
        21
      ],
      [
        -37,
        0
      ],
      [
        -13,
        33
      ]
    ],
    [
      [
        37199,
        69854
      ],
      [
        -37,
        22
      ],
      [
        -12,
        54
      ],
      [
        24,
        0
      ],
      [
        13,
        -54
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        62482,
        60093
      ],
      [
        -112,
        -43
      ],
      [
        -37,
        -33
      ]
    ],
    [
      [
        96212,
        60288
      ],
      [
        -12,
        44
      ],
      [
        12,
        76
      ],
      [
        13,
        -87
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        96014,
        60961
      ],
      [
        13,
        -76
      ],
      [
        -13,
        11
      ],
      [
        -12,
        32
      ],
      [
        12,
        33
      ]
    ],
    [
      [
        95841,
        61167
      ],
      [
        -13,
        108
      ],
      [
        25,
        -32
      ],
      [
        -12,
        -76
      ]
    ],
    [
      [
        95779,
        61145
      ],
      [
        0,
        -43
      ],
      [
        -12,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -13,
        98
      ],
      [
        13,
        130
      ],
      [
        12,
        22
      ],
      [
        13,
        -44
      ],
      [
        24,
        -11
      ],
      [
        -12,
        -75
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        95742,
        61872
      ],
      [
        -13,
        21
      ],
      [
        13,
        22
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        96349,
        62197
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        0,
        97
      ],
      [
        37,
        0
      ]
    ],
    [
      [
        96361,
        62273
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        44
      ],
      [
        0,
        21
      ],
      [
        25,
        0
      ],
      [
        12,
        -21
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        97228,
        63509
      ],
      [
        -12,
        -65
      ],
      [
        -13,
        22
      ],
      [
        0,
        33
      ],
      [
        13,
        21
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        97166,
        63705
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        0
      ],
      [
        0,
        108
      ],
      [
        12,
        0
      ],
      [
        25,
        -43
      ],
      [
        0,
        -33
      ],
      [
        12,
        -21
      ]
    ],
    [
      [
        97340,
        63531
      ],
      [
        -13,
        -11
      ],
      [
        0,
        44
      ],
      [
        -37,
        76
      ],
      [
        -12,
        75
      ],
      [
        -50,
        120
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        43
      ],
      [
        -62,
        108
      ],
      [
        -12,
        -10
      ],
      [
        -25,
        65
      ],
      [
        -37,
        54
      ],
      [
        -111,
        97
      ],
      [
        -87,
        -43
      ],
      [
        -124,
        33
      ],
      [
        -50,
        -33
      ],
      [
        -24,
        22
      ],
      [
        -13,
        43
      ],
      [
        13,
        65
      ],
      [
        12,
        130
      ],
      [
        12,
        98
      ],
      [
        -12,
        76
      ],
      [
        12,
        32
      ],
      [
        0,
        44
      ],
      [
        -12,
        21
      ],
      [
        -87,
        33
      ],
      [
        -24,
        33
      ],
      [
        -25,
        -33
      ],
      [
        -99,
        -22
      ],
      [
        -38,
        -32
      ],
      [
        -37,
        -54
      ],
      [
        -12,
        -66
      ],
      [
        25,
        -43
      ],
      [
        12,
        -76
      ],
      [
        -49,
        -228
      ],
      [
        24,
        -206
      ],
      [
        -12,
        -119
      ],
      [
        -12,
        -76
      ],
      [
        -38,
        -65
      ],
      [
        -12,
        -119
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -120
      ],
      [
        -25,
        -162
      ],
      [
        -12,
        -65
      ],
      [
        -12,
        -131
      ],
      [
        -62,
        -206
      ],
      [
        -25,
        -108
      ],
      [
        -25,
        -44
      ],
      [
        12,
        -32
      ],
      [
        0,
        -65
      ],
      [
        -12,
        -152
      ],
      [
        0,
        -119
      ],
      [
        12,
        -65
      ],
      [
        38,
        -130
      ],
      [
        -13,
        -44
      ],
      [
        0,
        -54
      ],
      [
        25,
        -22
      ],
      [
        25,
        -11
      ],
      [
        111,
        65
      ],
      [
        37,
        -21
      ],
      [
        25,
        -109
      ],
      [
        13,
        -271
      ],
      [
        12,
        -54
      ],
      [
        25,
        -43
      ],
      [
        24,
        -55
      ],
      [
        13,
        11
      ],
      [
        25,
        -11
      ],
      [
        12,
        -97
      ],
      [
        62,
        -521
      ],
      [
        12,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        -12,
        108
      ],
      [
        -13,
        54
      ],
      [
        -37,
        0
      ],
      [
        0,
        22
      ],
      [
        25,
        43
      ],
      [
        -25,
        76
      ],
      [
        -37,
        -32
      ],
      [
        0,
        -76
      ],
      [
        12,
        -65
      ],
      [
        62,
        -130
      ],
      [
        13,
        -66
      ],
      [
        24,
        -10
      ],
      [
        38,
        10
      ],
      [
        37,
        -65
      ],
      [
        37,
        -54
      ],
      [
        74,
        -87
      ],
      [
        50,
        11
      ],
      [
        49,
        22
      ],
      [
        25,
        0
      ],
      [
        37,
        -22
      ],
      [
        37,
        -76
      ],
      [
        62,
        -173
      ],
      [
        112,
        -141
      ]
    ],
    [
      [
        96373,
        60234
      ],
      [
        -86,
        195
      ],
      [
        -62,
        76
      ],
      [
        12,
        152
      ],
      [
        -25,
        22
      ],
      [
        -24,
        0
      ],
      [
        -13,
        43
      ],
      [
        13,
        87
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -25,
        22
      ],
      [
        -24,
        119
      ],
      [
        -38,
        98
      ],
      [
        -37,
        0
      ],
      [
        -12,
        32
      ],
      [
        0,
        76
      ],
      [
        -25,
        44
      ],
      [
        -37,
        32
      ],
      [
        -25,
        33
      ],
      [
        -37,
        119
      ],
      [
        -12,
        32
      ],
      [
        -25,
        22
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -86
      ],
      [
        -24,
        11
      ],
      [
        -25,
        21
      ],
      [
        -13,
        120
      ],
      [
        -12,
        75
      ],
      [
        12,
        141
      ],
      [
        25,
        131
      ],
      [
        13,
        195
      ],
      [
        24,
        130
      ],
      [
        25,
        43
      ],
      [
        25,
        174
      ],
      [
        37,
        217
      ]
    ],
    [
      [
        86228,
        81784
      ],
      [
        -25,
        32
      ],
      [
        13,
        11
      ],
      [
        12,
        -43
      ]
    ],
    [
      [
        85237,
        79430
      ],
      [
        13,
        54
      ],
      [
        12,
        141
      ],
      [
        12,
        55
      ],
      [
        50,
        97
      ],
      [
        25,
        76
      ],
      [
        37,
        54
      ],
      [
        37,
        65
      ],
      [
        25,
        87
      ],
      [
        -13,
        44
      ],
      [
        -61,
        86
      ],
      [
        -25,
        55
      ],
      [
        -13,
        75
      ],
      [
        0,
        55
      ],
      [
        38,
        130
      ],
      [
        -13,
        43
      ],
      [
        -25,
        22
      ],
      [
        -123,
        0
      ],
      [
        -13,
        76
      ],
      [
        -12,
        21
      ],
      [
        -75,
        33
      ],
      [
        -12,
        33
      ],
      [
        25,
        130
      ],
      [
        12,
        11
      ],
      [
        25,
        54
      ],
      [
        62,
        32
      ],
      [
        62,
        -11
      ],
      [
        62,
        -21
      ],
      [
        111,
        -22
      ],
      [
        37,
        22
      ],
      [
        25,
        43
      ],
      [
        13,
        65
      ],
      [
        0,
        65
      ],
      [
        37,
        0
      ],
      [
        12,
        11
      ],
      [
        0,
        33
      ],
      [
        25,
        -11
      ],
      [
        12,
        11
      ],
      [
        -24,
        65
      ],
      [
        0,
        21
      ],
      [
        49,
        11
      ],
      [
        12,
        33
      ],
      [
        -24,
        11
      ],
      [
        -99,
        0
      ],
      [
        12,
        32
      ],
      [
        99,
        22
      ],
      [
        99,
        -22
      ],
      [
        13,
        11
      ],
      [
        -13,
        54
      ],
      [
        25,
        0
      ],
      [
        0,
        22
      ],
      [
        -37,
        152
      ],
      [
        25,
        11
      ],
      [
        12,
        32
      ],
      [
        0,
        54
      ],
      [
        37,
        44
      ],
      [
        74,
        -76
      ],
      [
        25,
        -11
      ],
      [
        99,
        76
      ],
      [
        50,
        22
      ],
      [
        62,
        65
      ],
      [
        25,
        65
      ],
      [
        24,
        0
      ],
      [
        37,
        -65
      ],
      [
        38,
        -44
      ],
      [
        -13,
        -43
      ],
      [
        37,
        -22
      ],
      [
        -12,
        -54
      ],
      [
        -62,
        -54
      ],
      [
        -49,
        -76
      ],
      [
        0,
        -54
      ],
      [
        49,
        -22
      ],
      [
        25,
        -65
      ],
      [
        12,
        -11
      ],
      [
        87,
        22
      ],
      [
        25,
        0
      ]
    ],
    [
      [
        80196,
        80450
      ],
      [
        -25,
        65
      ],
      [
        0,
        97
      ],
      [
        12,
        -11
      ],
      [
        13,
        -151
      ]
    ],
    [
      [
        80468,
        79539
      ],
      [
        0,
        43
      ],
      [
        -25,
        325
      ],
      [
        0,
        76
      ],
      [
        13,
        141
      ],
      [
        0,
        76
      ],
      [
        -13,
        76
      ],
      [
        13,
        65
      ],
      [
        0,
        76
      ],
      [
        12,
        76
      ],
      [
        -25,
        98
      ],
      [
        -37,
        54
      ],
      [
        0,
        65
      ],
      [
        -37,
        0
      ],
      [
        -49,
        54
      ],
      [
        -50,
        22
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -44
      ],
      [
        0,
        109
      ],
      [
        37,
        108
      ],
      [
        25,
        -32
      ],
      [
        62,
        -22
      ],
      [
        37,
        11
      ],
      [
        -25,
        65
      ],
      [
        -24,
        11
      ],
      [
        0,
        108
      ],
      [
        12,
        44
      ],
      [
        -12,
        21
      ],
      [
        -25,
        11
      ],
      [
        -37,
        0
      ],
      [
        -100,
        22
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        11
      ],
      [
        -24,
        86
      ],
      [
        -25,
        109
      ],
      [
        0,
        108
      ],
      [
        12,
        98
      ],
      [
        25,
        87
      ],
      [
        12,
        108
      ],
      [
        25,
        109
      ],
      [
        12,
        -44
      ],
      [
        25,
        -54
      ],
      [
        37,
        -43
      ],
      [
        50,
        -22
      ],
      [
        37,
        11
      ],
      [
        37,
        21
      ],
      [
        25,
        -10
      ],
      [
        50,
        -87
      ],
      [
        37,
        -11
      ],
      [
        74,
        33
      ],
      [
        37,
        10
      ],
      [
        37,
        -21
      ],
      [
        25,
        0
      ],
      [
        -12,
        43
      ],
      [
        0,
        43
      ],
      [
        12,
        22
      ],
      [
        62,
        -22
      ],
      [
        62,
        44
      ],
      [
        0,
        76
      ],
      [
        -12,
        32
      ],
      [
        0,
        33
      ],
      [
        -174,
        195
      ],
      [
        -37,
        54
      ],
      [
        -37,
        217
      ],
      [
        -37,
        141
      ],
      [
        -37,
        22
      ],
      [
        -50,
        0
      ],
      [
        -111,
        -33
      ],
      [
        -38,
        11
      ],
      [
        -74,
        -76
      ],
      [
        -25,
        -54
      ],
      [
        -24,
        -108
      ],
      [
        24,
        -44
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -162
      ],
      [
        -25,
        11
      ],
      [
        -50,
        97
      ],
      [
        -37,
        163
      ]
    ],
    [
      [
        81187,
        82022
      ],
      [
        86,
        0
      ],
      [
        273,
        -32
      ],
      [
        25,
        43
      ],
      [
        -25,
        76
      ],
      [
        -25,
        249
      ],
      [
        25,
        44
      ],
      [
        25,
        21
      ],
      [
        49,
        76
      ],
      [
        13,
        33
      ],
      [
        37,
        11
      ],
      [
        99,
        11
      ],
      [
        49,
        10
      ],
      [
        38,
        98
      ],
      [
        0,
        54
      ],
      [
        37,
        44
      ],
      [
        86,
        -44
      ],
      [
        38,
        -87
      ],
      [
        24,
        0
      ],
      [
        0,
        33
      ],
      [
        -12,
        43
      ],
      [
        -74,
        109
      ],
      [
        -25,
        11
      ],
      [
        0,
        21
      ],
      [
        37,
        33
      ],
      [
        37,
        -11
      ],
      [
        37,
        0
      ],
      [
        25,
        11
      ],
      [
        13,
        54
      ],
      [
        99,
        -130
      ],
      [
        62,
        -22
      ],
      [
        24,
        0
      ],
      [
        25,
        -32
      ],
      [
        25,
        -76
      ],
      [
        62,
        -33
      ],
      [
        111,
        0
      ],
      [
        37,
        -11
      ],
      [
        50,
        -65
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -65
      ],
      [
        -13,
        -44
      ],
      [
        50,
        -32
      ],
      [
        37,
        -44
      ],
      [
        0,
        -21
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -43
      ],
      [
        12,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -33
      ],
      [
        137,
        -119
      ],
      [
        24,
        -11
      ],
      [
        75,
        22
      ],
      [
        49,
        0
      ],
      [
        13,
        -11
      ],
      [
        74,
        -11
      ],
      [
        12,
        -11
      ],
      [
        50,
        0
      ],
      [
        49,
        54
      ],
      [
        62,
        -21
      ],
      [
        87,
        -98
      ],
      [
        25,
        -32
      ],
      [
        25,
        -87
      ],
      [
        24,
        -130
      ],
      [
        25,
        -98
      ],
      [
        37,
        -43
      ],
      [
        25,
        -87
      ],
      [
        25,
        -184
      ],
      [
        12,
        -33
      ],
      [
        25,
        -22
      ],
      [
        37,
        -54
      ],
      [
        87,
        -87
      ],
      [
        50,
        -54
      ],
      [
        161,
        -163
      ],
      [
        74,
        -119
      ],
      [
        74,
        -76
      ],
      [
        75,
        -65
      ],
      [
        49,
        11
      ],
      [
        74,
        -98
      ],
      [
        38,
        -32
      ],
      [
        12,
        -22
      ],
      [
        50,
        -32
      ],
      [
        99,
        -87
      ],
      [
        99,
        -119
      ],
      [
        74,
        -65
      ],
      [
        50,
        -11
      ],
      [
        37,
        32
      ],
      [
        86,
        -43
      ],
      [
        25,
        -22
      ],
      [
        50,
        -65
      ],
      [
        86,
        -32
      ],
      [
        25,
        -33
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -86
      ],
      [
        -12,
        -120
      ],
      [
        0,
        -87
      ],
      [
        12,
        -65
      ]
    ],
    [
      [
        104599,
        50376
      ],
      [
        62,
        54
      ],
      [
        74,
        43
      ]
    ],
    [
      [
        104908,
        50625
      ],
      [
        38,
        55
      ],
      [
        24,
        97
      ],
      [
        25,
        33
      ],
      [
        62,
        43
      ],
      [
        149,
        54
      ],
      [
        124,
        0
      ],
      [
        123,
        11
      ],
      [
        38,
        11
      ],
      [
        37,
        22
      ],
      [
        74,
        65
      ],
      [
        37,
        -22
      ],
      [
        50,
        -11
      ],
      [
        25,
        -11
      ],
      [
        12,
        -21
      ],
      [
        -62,
        -98
      ],
      [
        -74,
        -87
      ],
      [
        -37,
        -21
      ],
      [
        -50,
        -22
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        -74,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        -62,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -112,
        -76
      ],
      [
        -62,
        -76
      ],
      [
        -49,
        -76
      ]
    ],
    [
      [
        105156,
        51124
      ],
      [
        -25,
        -97
      ],
      [
        -24,
        21
      ],
      [
        37,
        76
      ],
      [
        12,
        0
      ]
    ],
    [
      [
        1747,
        42904
      ],
      [
        0,
        -87
      ],
      [
        -25,
        43
      ],
      [
        0,
        22
      ],
      [
        25,
        22
      ]
    ],
    [
      [
        1660,
        42990
      ],
      [
        12,
        22
      ],
      [
        13,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        22
      ],
      [
        -50,
        43
      ],
      [
        12,
        22
      ],
      [
        25,
        0
      ],
      [
        25,
        -33
      ]
    ],
    [
      [
        2069,
        44574
      ],
      [
        -13,
        -44
      ],
      [
        -24,
        44
      ],
      [
        24,
        43
      ],
      [
        25,
        -11
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        40928,
        62544
      ],
      [
        -50,
        -32
      ],
      [
        -148,
        -11
      ],
      [
        -62,
        11
      ],
      [
        37,
        65
      ],
      [
        12,
        32
      ],
      [
        37,
        11
      ],
      [
        13,
        11
      ],
      [
        12,
        163
      ],
      [
        -12,
        43
      ],
      [
        0,
        22
      ],
      [
        -13,
        21
      ],
      [
        -37,
        22
      ],
      [
        13,
        22
      ],
      [
        49,
        11
      ],
      [
        25,
        21
      ],
      [
        74,
        11
      ],
      [
        87,
        22
      ],
      [
        -37,
        -109
      ],
      [
        0,
        -173
      ],
      [
        25,
        -44
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        41014,
        63195
      ],
      [
        -12,
        0
      ],
      [
        0,
        22
      ],
      [
        37,
        43
      ],
      [
        50,
        32
      ],
      [
        12,
        0
      ],
      [
        -12,
        -43
      ],
      [
        -75,
        -54
      ]
    ],
    [
      [
        65690,
        77283
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -12,
        22
      ],
      [
        0,
        86
      ],
      [
        62,
        0
      ],
      [
        49,
        -65
      ],
      [
        -37,
        -32
      ]
    ],
    [
      [
        65802,
        77923
      ],
      [
        -50,
        -44
      ],
      [
        12,
        44
      ],
      [
        38,
        43
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        64872,
        79289
      ],
      [
        87,
        33
      ],
      [
        87,
        97
      ],
      [
        25,
        33
      ],
      [
        186,
        87
      ],
      [
        49,
        -22
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -21
      ],
      [
        12,
        -55
      ],
      [
        25,
        33
      ],
      [
        -13,
        43
      ],
      [
        75,
        0
      ],
      [
        37,
        -32
      ],
      [
        0,
        -109
      ],
      [
        49,
        -97
      ],
      [
        -12,
        -54
      ],
      [
        37,
        -33
      ],
      [
        37,
        33
      ],
      [
        25,
        54
      ],
      [
        62,
        32
      ],
      [
        62,
        87
      ],
      [
        37,
        11
      ],
      [
        25,
        -130
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -61,
        -163
      ],
      [
        -50,
        -43
      ],
      [
        -50,
        -65
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -54
      ],
      [
        12,
        -87
      ],
      [
        25,
        -97
      ],
      [
        37,
        -55
      ],
      [
        38,
        -10
      ],
      [
        74,
        -87
      ],
      [
        0,
        -120
      ],
      [
        12,
        -65
      ],
      [
        25,
        -65
      ],
      [
        -62,
        -130
      ],
      [
        -25,
        -87
      ],
      [
        -62,
        -130
      ],
      [
        -49,
        -86
      ],
      [
        -124,
        -120
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        -87
      ],
      [
        0,
        -54
      ],
      [
        38,
        -130
      ],
      [
        49,
        -76
      ],
      [
        50,
        -44
      ],
      [
        99,
        22
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -54
      ],
      [
        37,
        0
      ],
      [
        25,
        10
      ],
      [
        12,
        55
      ],
      [
        50,
        -44
      ],
      [
        24,
        -119
      ],
      [
        38,
        -32
      ],
      [
        -25,
        -44
      ],
      [
        49,
        -22
      ],
      [
        25,
        11
      ],
      [
        37,
        -21
      ]
    ],
    [
      [
        70856,
        81285
      ],
      [
        -75,
        -22
      ],
      [
        -25,
        22
      ],
      [
        25,
        43
      ],
      [
        62,
        22
      ],
      [
        25,
        -44
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        74274,
        78649
      ],
      [
        25,
        55
      ],
      [
        -49,
        195
      ],
      [
        24,
        54
      ],
      [
        50,
        76
      ],
      [
        50,
        87
      ],
      [
        0,
        86
      ],
      [
        -13,
        33
      ],
      [
        -37,
        32
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        -43
      ],
      [
        -49,
        -33
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        -50,
        -11
      ],
      [
        -74,
        33
      ],
      [
        -124,
        108
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -21
      ],
      [
        -100,
        -109
      ],
      [
        -99,
        -173
      ],
      [
        -111,
        -98
      ],
      [
        -62,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -173,
        -43
      ],
      [
        -50,
        -33
      ],
      [
        -87,
        44
      ],
      [
        -61,
        43
      ],
      [
        -25,
        54
      ],
      [
        -62,
        119
      ],
      [
        -37,
        55
      ],
      [
        -75,
        43
      ],
      [
        -148,
        119
      ],
      [
        -137,
        33
      ],
      [
        -111,
        11
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -173
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -86
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        22
      ],
      [
        -12,
        22
      ],
      [
        -50,
        -44
      ],
      [
        -136,
        -54
      ],
      [
        -124,
        65
      ],
      [
        -74,
        87
      ],
      [
        0,
        76
      ],
      [
        -25,
        43
      ],
      [
        0,
        65
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -25,
        11
      ],
      [
        -86,
        65
      ],
      [
        -62,
        11
      ],
      [
        -37,
        -87
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        -11
      ],
      [
        0,
        22
      ],
      [
        24,
        54
      ],
      [
        -99,
        -11
      ],
      [
        -49,
        -33
      ],
      [
        -37,
        0
      ],
      [
        -25,
        22
      ],
      [
        0,
        22
      ],
      [
        49,
        22
      ],
      [
        112,
        10
      ],
      [
        25,
        22
      ],
      [
        24,
        54
      ],
      [
        50,
        44
      ],
      [
        0,
        21
      ],
      [
        -37,
        0
      ],
      [
        -161,
        -10
      ],
      [
        -99,
        10
      ],
      [
        -13,
        -32
      ],
      [
        -24,
        0
      ],
      [
        0,
        65
      ],
      [
        12,
        32
      ],
      [
        25,
        -10
      ],
      [
        62,
        32
      ],
      [
        -13,
        54
      ],
      [
        -37,
        33
      ],
      [
        -12,
        22
      ],
      [
        -50,
        32
      ],
      [
        0,
        65
      ],
      [
        -25,
        65
      ],
      [
        -24,
        33
      ],
      [
        0,
        21
      ],
      [
        49,
        22
      ],
      [
        13,
        98
      ],
      [
        -13,
        65
      ],
      [
        -25,
        0
      ],
      [
        -74,
        54
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        54
      ],
      [
        -50,
        33
      ],
      [
        -49,
        -22
      ],
      [
        -37,
        33
      ],
      [
        -38,
        22
      ],
      [
        -12,
        21
      ],
      [
        25,
        54
      ],
      [
        25,
        0
      ],
      [
        0,
        44
      ],
      [
        -25,
        76
      ],
      [
        12,
        43
      ],
      [
        13,
        11
      ],
      [
        24,
        -11
      ],
      [
        25,
        -43
      ],
      [
        13,
        -44
      ],
      [
        0,
        -43
      ],
      [
        12,
        -43
      ],
      [
        25,
        43
      ],
      [
        24,
        -22
      ],
      [
        25,
        0
      ],
      [
        87,
        22
      ],
      [
        12,
        22
      ],
      [
        -62,
        0
      ],
      [
        -24,
        21
      ],
      [
        -25,
        44
      ],
      [
        -25,
        97
      ],
      [
        50,
        44
      ],
      [
        37,
        65
      ],
      [
        -25,
        32
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        22
      ],
      [
        0,
        33
      ],
      [
        12,
        32
      ],
      [
        0,
        33
      ],
      [
        -49,
        97
      ],
      [
        -13,
        11
      ],
      [
        13,
        33
      ],
      [
        37,
        54
      ],
      [
        25,
        54
      ],
      [
        0,
        22
      ],
      [
        -25,
        11
      ],
      [
        -112,
        -22
      ],
      [
        -49,
        -22
      ],
      [
        -87,
        -10
      ],
      [
        0,
        54
      ],
      [
        13,
        54
      ],
      [
        0,
        141
      ],
      [
        12,
        76
      ],
      [
        49,
        22
      ],
      [
        50,
        108
      ],
      [
        99,
        119
      ],
      [
        87,
        0
      ],
      [
        37,
        33
      ],
      [
        62,
        0
      ],
      [
        12,
        -44
      ],
      [
        50,
        -32
      ],
      [
        87,
        0
      ],
      [
        24,
        11
      ],
      [
        13,
        21
      ],
      [
        -37,
        66
      ],
      [
        12,
        21
      ],
      [
        37,
        0
      ],
      [
        50,
        -32
      ],
      [
        -25,
        -55
      ],
      [
        124,
        11
      ],
      [
        111,
        -11
      ],
      [
        37,
        11
      ],
      [
        100,
        0
      ],
      [
        12,
        22
      ],
      [
        -25,
        22
      ],
      [
        -49,
        21
      ],
      [
        -13,
        22
      ],
      [
        50,
        65
      ],
      [
        37,
        11
      ],
      [
        272,
        54
      ],
      [
        -12,
        11
      ],
      [
        -149,
        33
      ],
      [
        -37,
        21
      ],
      [
        -49,
        55
      ],
      [
        -25,
        43
      ],
      [
        0,
        65
      ],
      [
        12,
        43
      ],
      [
        25,
        33
      ],
      [
        50,
        0
      ],
      [
        210,
        -43
      ],
      [
        149,
        21
      ],
      [
        161,
        -65
      ],
      [
        149,
        11
      ],
      [
        37,
        33
      ],
      [
        37,
        97
      ],
      [
        210,
        174
      ],
      [
        75,
        86
      ],
      [
        86,
        44
      ],
      [
        137,
        54
      ],
      [
        111,
        76
      ],
      [
        37,
        0
      ],
      [
        285,
        -33
      ],
      [
        186,
        0
      ],
      [
        87,
        65
      ],
      [
        49,
        -21
      ],
      [
        -12,
        -44
      ],
      [
        12,
        -43
      ],
      [
        50,
        -98
      ],
      [
        99,
        -65
      ],
      [
        124,
        55
      ],
      [
        37,
        -22
      ],
      [
        50,
        -163
      ],
      [
        37,
        -54
      ],
      [
        37,
        -33
      ],
      [
        37,
        -10
      ],
      [
        25,
        43
      ],
      [
        74,
        22
      ],
      [
        62,
        -55
      ],
      [
        37,
        -65
      ],
      [
        124,
        -43
      ],
      [
        112,
        -22
      ],
      [
        49,
        -43
      ],
      [
        161,
        -54
      ],
      [
        62,
        11
      ],
      [
        99,
        54
      ],
      [
        198,
        54
      ],
      [
        137,
        -76
      ],
      [
        37,
        -11
      ],
      [
        25,
        11
      ],
      [
        49,
        -22
      ],
      [
        37,
        11
      ],
      [
        149,
        87
      ],
      [
        50,
        54
      ],
      [
        49,
        11
      ],
      [
        149,
        130
      ],
      [
        37,
        65
      ]
    ],
    [
      [
        71562,
        82434
      ],
      [
        -13,
        -76
      ],
      [
        25,
        -76
      ],
      [
        50,
        -108
      ],
      [
        49,
        -54
      ],
      [
        211,
        -141
      ],
      [
        37,
        -11
      ],
      [
        -25,
        -109
      ],
      [
        -12,
        -32
      ],
      [
        -62,
        -22
      ],
      [
        -161,
        65
      ],
      [
        -50,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        -43
      ],
      [
        -62,
        22
      ],
      [
        -87,
        -33
      ],
      [
        -25,
        -76
      ],
      [
        -61,
        -97
      ],
      [
        -100,
        -76
      ],
      [
        -62,
        -44
      ],
      [
        -111,
        -151
      ],
      [
        -50,
        -87
      ],
      [
        -37,
        -22
      ],
      [
        0,
        33
      ],
      [
        13,
        43
      ],
      [
        0,
        65
      ],
      [
        37,
        54
      ],
      [
        37,
        33
      ],
      [
        87,
        65
      ],
      [
        24,
        43
      ],
      [
        -74,
        0
      ],
      [
        -74,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -12,
        55
      ],
      [
        -13,
        21
      ]
    ],
    [
      [
        102666,
        71535
      ],
      [
        13,
        -44
      ],
      [
        -13,
        -21
      ],
      [
        -37,
        11
      ],
      [
        37,
        54
      ]
    ],
    [
      [
        103558,
        70342
      ],
      [
        -25,
        -76
      ],
      [
        -24,
        -141
      ],
      [
        0,
        -152
      ],
      [
        -13,
        -65
      ],
      [
        -25,
        22
      ],
      [
        -24,
        43
      ],
      [
        0,
        87
      ],
      [
        -37,
        119
      ],
      [
        -38,
        54
      ],
      [
        -24,
        22
      ],
      [
        -25,
        43
      ],
      [
        -13,
        55
      ],
      [
        -24,
        54
      ],
      [
        -25,
        163
      ],
      [
        -25,
        65
      ],
      [
        0,
        76
      ],
      [
        25,
        119
      ],
      [
        -13,
        76
      ],
      [
        13,
        87
      ],
      [
        0,
        32
      ],
      [
        161,
        477
      ],
      [
        49,
        109
      ],
      [
        25,
        43
      ],
      [
        75,
        195
      ],
      [
        12,
        22
      ],
      [
        99,
        54
      ],
      [
        25,
        65
      ],
      [
        49,
        11
      ],
      [
        25,
        -22
      ],
      [
        25,
        -54
      ],
      [
        62,
        -54
      ],
      [
        12,
        -54
      ],
      [
        -25,
        -54
      ],
      [
        -24,
        -87
      ],
      [
        12,
        -65
      ],
      [
        0,
        -76
      ],
      [
        -37,
        -152
      ],
      [
        -37,
        -141
      ],
      [
        -13,
        -119
      ],
      [
        -24,
        -120
      ],
      [
        -13,
        -162
      ],
      [
        -37,
        -217
      ],
      [
        -25,
        -65
      ],
      [
        -49,
        -120
      ],
      [
        -50,
        -97
      ]
    ],
    [
      [
        75588,
        51233
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        32
      ],
      [
        25,
        22
      ],
      [
        13,
        43
      ],
      [
        49,
        65
      ],
      [
        12,
        0
      ],
      [
        -24,
        -108
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -43
      ]
    ],
    [
      [
        75513,
        52361
      ],
      [
        25,
        -141
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        22
      ],
      [
        -13,
        43
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        54
      ],
      [
        -24,
        0
      ],
      [
        -25,
        66
      ],
      [
        12,
        54
      ],
      [
        0,
        97
      ],
      [
        25,
        44
      ],
      [
        12,
        87
      ],
      [
        13,
        -55
      ],
      [
        0,
        -86
      ],
      [
        24,
        -109
      ],
      [
        25,
        -32
      ]
    ],
    [
      [
        75637,
        53152
      ],
      [
        0,
        -217
      ],
      [
        -25,
        -86
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        22
      ],
      [
        -12,
        21
      ],
      [
        25,
        163
      ],
      [
        -13,
        119
      ],
      [
        37,
        -21
      ],
      [
        25,
        32
      ]
    ],
    [
      [
        75414,
        53282
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -130
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -65
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -184
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -152
      ],
      [
        0,
        -119
      ],
      [
        25,
        -163
      ],
      [
        37,
        -87
      ],
      [
        25,
        -22
      ],
      [
        24,
        -32
      ],
      [
        38,
        -87
      ],
      [
        12,
        -76
      ],
      [
        62,
        -43
      ],
      [
        25,
        -87
      ],
      [
        0,
        -65
      ],
      [
        -38,
        -54
      ],
      [
        -24,
        -87
      ],
      [
        -25,
        -108
      ],
      [
        0,
        -163
      ],
      [
        12,
        22
      ],
      [
        37,
        -44
      ],
      [
        0,
        -119
      ],
      [
        -37,
        -217
      ],
      [
        0,
        -54
      ],
      [
        25,
        -174
      ],
      [
        37,
        -86
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -22
      ],
      [
        62,
        -152
      ],
      [
        0,
        -140
      ],
      [
        25,
        -98
      ],
      [
        0,
        -98
      ],
      [
        24,
        -65
      ],
      [
        0,
        -54
      ],
      [
        -24,
        -54
      ],
      [
        49,
        -11
      ],
      [
        50,
        -87
      ],
      [
        24,
        0
      ],
      [
        25,
        -22
      ],
      [
        25,
        -32
      ],
      [
        62,
        -65
      ],
      [
        25,
        -54
      ],
      [
        0,
        -11
      ]
    ],
    [
      [
        73246,
        50333
      ],
      [
        -12,
        21
      ],
      [
        -37,
        33
      ],
      [
        -50,
        32
      ],
      [
        -49,
        44
      ],
      [
        -13,
        32
      ],
      [
        -74,
        22
      ],
      [
        -37,
        32
      ],
      [
        -25,
        0
      ],
      [
        -37,
        11
      ],
      [
        0,
        65
      ],
      [
        -37,
        33
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        0
      ],
      [
        -49,
        65
      ],
      [
        0,
        54
      ],
      [
        -25,
        44
      ],
      [
        -37,
        32
      ],
      [
        -99,
        -11
      ],
      [
        -38,
        44
      ],
      [
        -24,
        43
      ],
      [
        -25,
        54
      ],
      [
        -13,
        76
      ],
      [
        -12,
        44
      ]
    ],
    [
      [
        72416,
        55549
      ],
      [
        38,
        0
      ],
      [
        24,
        11
      ],
      [
        25,
        22
      ],
      [
        25,
        10
      ],
      [
        223,
        0
      ],
      [
        124,
        0
      ],
      [
        186,
        0
      ],
      [
        123,
        0
      ],
      [
        186,
        0
      ],
      [
        223,
        0
      ]
    ],
    [
      [
        72937,
        85080
      ],
      [
        0,
        -32
      ],
      [
        -112,
        32
      ],
      [
        -37,
        33
      ],
      [
        0,
        22
      ],
      [
        149,
        -55
      ]
    ],
    [
      [
        75067,
        85634
      ],
      [
        -12,
        -11
      ],
      [
        -112,
        11
      ],
      [
        -99,
        -11
      ],
      [
        -74,
        -98
      ],
      [
        -37,
        0
      ],
      [
        -62,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        -50,
        -65
      ],
      [
        -37,
        33
      ],
      [
        -50,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -49,
        -44
      ],
      [
        -37,
        -10
      ],
      [
        -50,
        10
      ],
      [
        -74,
        -21
      ],
      [
        -149,
        -152
      ],
      [
        -49,
        -109
      ],
      [
        -38,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        87,
        109
      ],
      [
        0,
        54
      ],
      [
        -12,
        43
      ],
      [
        -62,
        -108
      ],
      [
        -38,
        -11
      ],
      [
        -37,
        -32
      ],
      [
        0,
        -131
      ],
      [
        62,
        -173
      ],
      [
        75,
        -163
      ],
      [
        74,
        -86
      ],
      [
        37,
        0
      ],
      [
        62,
        54
      ],
      [
        87,
        -11
      ],
      [
        24,
        32
      ],
      [
        75,
        22
      ],
      [
        99,
        -43
      ],
      [
        -50,
        -98
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -54
      ],
      [
        -62,
        -22
      ],
      [
        -62,
        0
      ],
      [
        -62,
        -11
      ],
      [
        -62,
        54
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -76
      ],
      [
        -75,
        -54
      ],
      [
        -12,
        -54
      ],
      [
        -74,
        11
      ],
      [
        -62,
        -11
      ],
      [
        -87,
        -54
      ],
      [
        -62,
        -109
      ],
      [
        -74,
        -76
      ],
      [
        -50,
        -21
      ],
      [
        -49,
        11
      ],
      [
        -38,
        21
      ],
      [
        -74,
        76
      ],
      [
        13,
        33
      ],
      [
        49,
        184
      ],
      [
        -12,
        43
      ],
      [
        -13,
        76
      ],
      [
        -62,
        55
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -99,
        97
      ],
      [
        -49,
        11
      ],
      [
        -50,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        33
      ],
      [
        112,
        119
      ],
      [
        111,
        98
      ],
      [
        37,
        10
      ],
      [
        75,
        44
      ],
      [
        61,
        76
      ],
      [
        -24,
        87
      ],
      [
        -50,
        -22
      ],
      [
        -62,
        43
      ],
      [
        -25,
        33
      ],
      [
        -86,
        -33
      ],
      [
        -50,
        0
      ],
      [
        -111,
        -21
      ],
      [
        -50,
        21
      ],
      [
        -99,
        87
      ],
      [
        -37,
        11
      ],
      [
        -37,
        0
      ],
      [
        -13,
        32
      ],
      [
        75,
        22
      ],
      [
        0,
        43
      ],
      [
        -99,
        22
      ],
      [
        -38,
        22
      ],
      [
        -24,
        32
      ],
      [
        62,
        0
      ],
      [
        49,
        -21
      ],
      [
        87,
        -11
      ],
      [
        87,
        -22
      ],
      [
        12,
        33
      ],
      [
        -12,
        21
      ],
      [
        -87,
        22
      ],
      [
        -50,
        76
      ],
      [
        -12,
        43
      ],
      [
        12,
        44
      ],
      [
        -25,
        43
      ],
      [
        0,
        -130
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        -86,
        21
      ],
      [
        -13,
        44
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -62,
        11
      ],
      [
        -124,
        -44
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -108
      ],
      [
        -62,
        -120
      ],
      [
        0,
        -10
      ],
      [
        -99,
        -141
      ],
      [
        -74,
        -44
      ],
      [
        -62,
        -43
      ],
      [
        -37,
        21
      ],
      [
        -37,
        -43
      ],
      [
        0,
        -54
      ],
      [
        24,
        -43
      ],
      [
        25,
        -120
      ],
      [
        -12,
        -54
      ]
    ],
    [
      [
        43566,
        35138
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        -152
      ],
      [
        -74,
        -141
      ],
      [
        -12,
        -87
      ],
      [
        -75,
        -87
      ],
      [
        -62,
        -97
      ],
      [
        -24,
        11
      ],
      [
        -38,
        -44
      ],
      [
        -185,
        -130
      ],
      [
        -62,
        22
      ],
      [
        -50,
        0
      ],
      [
        -49,
        54
      ],
      [
        -100,
        22
      ],
      [
        -74,
        -22
      ],
      [
        -87,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -49,
        21
      ],
      [
        -25,
        55
      ],
      [
        -136,
        65
      ],
      [
        -112,
        141
      ],
      [
        -124,
        0
      ],
      [
        -99,
        -22
      ],
      [
        -49,
        109
      ],
      [
        -87,
        130
      ],
      [
        -62,
        119
      ],
      [
        -12,
        119
      ],
      [
        12,
        130
      ],
      [
        12,
        163
      ],
      [
        0,
        43
      ],
      [
        25,
        33
      ],
      [
        25,
        0
      ],
      [
        25,
        43
      ],
      [
        25,
        109
      ],
      [
        -25,
        87
      ],
      [
        0,
        119
      ],
      [
        -25,
        54
      ]
    ],
    [
      [
        8399,
        68086
      ],
      [
        -25,
        -22
      ],
      [
        -13,
        0
      ],
      [
        -74,
        65
      ],
      [
        0,
        196
      ],
      [
        -25,
        130
      ],
      [
        -24,
        97
      ],
      [
        12,
        55
      ],
      [
        37,
        32
      ],
      [
        25,
        76
      ],
      [
        -25,
        98
      ],
      [
        13,
        54
      ],
      [
        12,
        11
      ],
      [
        74,
        -65
      ],
      [
        136,
        -109
      ],
      [
        38,
        -76
      ],
      [
        12,
        -76
      ],
      [
        25,
        -10
      ],
      [
        12,
        -55
      ],
      [
        50,
        -76
      ],
      [
        -13,
        -43
      ],
      [
        -74,
        -87
      ],
      [
        -87,
        -32
      ],
      [
        -74,
        -98
      ],
      [
        -12,
        -65
      ]
    ],
    [
      [
        7965,
        69192
      ],
      [
        -25,
        -21
      ],
      [
        -24,
        10
      ],
      [
        0,
        44
      ],
      [
        -25,
        54
      ],
      [
        37,
        11
      ],
      [
        37,
        -33
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -33
      ]
    ],
    [
      [
        8089,
        69290
      ],
      [
        0,
        -11
      ],
      [
        62,
        22
      ],
      [
        49,
        -44
      ],
      [
        13,
        -21
      ],
      [
        37,
        -33
      ],
      [
        0,
        -54
      ],
      [
        -37,
        -43
      ],
      [
        -75,
        -22
      ],
      [
        -37,
        11
      ],
      [
        0,
        54
      ],
      [
        -12,
        54
      ],
      [
        -25,
        0
      ],
      [
        -25,
        22
      ],
      [
        -24,
        43
      ],
      [
        0,
        33
      ],
      [
        12,
        43
      ],
      [
        25,
        11
      ],
      [
        12,
        -33
      ],
      [
        25,
        -32
      ]
    ],
    [
      [
        7829,
        69463
      ],
      [
        74,
        -10
      ],
      [
        37,
        -11
      ],
      [
        62,
        -11
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -50,
        21
      ],
      [
        -99,
        11
      ],
      [
        12,
        33
      ],
      [
        0,
        43
      ],
      [
        13,
        -11
      ]
    ],
    [
      [
        7631,
        69615
      ],
      [
        24,
        0
      ],
      [
        25,
        -76
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        -11
      ],
      [
        -38,
        43
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        0
      ],
      [
        0,
        44
      ],
      [
        -37,
        65
      ],
      [
        0,
        32
      ],
      [
        -12,
        33
      ],
      [
        49,
        0
      ],
      [
        37,
        65
      ],
      [
        25,
        0
      ],
      [
        37,
        -87
      ],
      [
        0,
        -54
      ],
      [
        13,
        -11
      ]
    ],
    [
      [
        6813,
        69854
      ],
      [
        -25,
        -22
      ],
      [
        13,
        65
      ],
      [
        37,
        65
      ],
      [
        25,
        0
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -43
      ]
    ],
    [
      [
        7086,
        69919
      ],
      [
        -25,
        -43
      ],
      [
        -13,
        21
      ],
      [
        -37,
        0
      ],
      [
        -12,
        33
      ],
      [
        -37,
        21
      ],
      [
        -13,
        33
      ],
      [
        25,
        65
      ],
      [
        50,
        43
      ],
      [
        74,
        0
      ],
      [
        12,
        -43
      ],
      [
        0,
        -65
      ],
      [
        -24,
        -65
      ]
    ],
    [
      [
        34263,
        71914
      ],
      [
        -62,
        -108
      ],
      [
        0,
        22
      ],
      [
        38,
        65
      ],
      [
        0,
        32
      ],
      [
        24,
        22
      ],
      [
        13,
        32
      ],
      [
        0,
        33
      ],
      [
        25,
        33
      ],
      [
        12,
        0
      ],
      [
        -50,
        -131
      ]
    ],
    [
      [
        28491,
        72554
      ],
      [
        -37,
        109
      ],
      [
        -37,
        303
      ],
      [
        12,
        -10
      ],
      [
        49,
        -315
      ],
      [
        13,
        -87
      ]
    ],
    [
      [
        28429,
        73270
      ],
      [
        -12,
        11
      ],
      [
        37,
        130
      ],
      [
        12,
        11
      ],
      [
        -37,
        -152
      ]
    ],
    [
      [
        28540,
        73639
      ],
      [
        13,
        76
      ],
      [
        37,
        65
      ],
      [
        12,
        -22
      ],
      [
        -62,
        -119
      ]
    ],
    [
      [
        29222,
        74420
      ],
      [
        62,
        86
      ],
      [
        12,
        33
      ],
      [
        25,
        0
      ],
      [
        -37,
        -54
      ],
      [
        -62,
        -65
      ]
    ],
    [
      [
        30337,
        74637
      ],
      [
        -13,
        0
      ],
      [
        -49,
        54
      ],
      [
        0,
        21
      ],
      [
        37,
        22
      ],
      [
        25,
        -32
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        31228,
        75005
      ],
      [
        -37,
        -11
      ],
      [
        13,
        33
      ],
      [
        24,
        11
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        21207,
        76719
      ],
      [
        -49,
        11
      ],
      [
        -13,
        54
      ],
      [
        -25,
        54
      ],
      [
        13,
        11
      ],
      [
        12,
        -43
      ],
      [
        50,
        -76
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        20836,
        76968
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        44
      ],
      [
        25,
        0
      ],
      [
        12,
        -33
      ],
      [
        13,
        0
      ]
    ],
    [
      [
        21207,
        77066
      ],
      [
        13,
        -43
      ],
      [
        -25,
        10
      ],
      [
        -25,
        -10
      ],
      [
        0,
        32
      ],
      [
        -12,
        33
      ],
      [
        -25,
        10
      ],
      [
        0,
        33
      ],
      [
        62,
        -43
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        20625,
        77402
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -24,
        54
      ],
      [
        62,
        11
      ],
      [
        24,
        -22
      ],
      [
        -12,
        -43
      ]
    ],
    [
      [
        20674,
        77500
      ],
      [
        75,
        -33
      ],
      [
        37,
        22
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -11
      ],
      [
        -87,
        -21
      ],
      [
        -25,
        10
      ],
      [
        0,
        55
      ]
    ],
    [
      [
        35936,
        78226
      ],
      [
        -50,
        -21
      ],
      [
        0,
        10
      ],
      [
        50,
        33
      ],
      [
        12,
        130
      ],
      [
        12,
        54
      ],
      [
        -12,
        109
      ],
      [
        12,
        -11
      ],
      [
        0,
        -174
      ],
      [
        -12,
        -108
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        36394,
        81523
      ],
      [
        -12,
        0
      ],
      [
        12,
        65
      ],
      [
        50,
        22
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        36976,
        81816
      ],
      [
        -25,
        -43
      ],
      [
        25,
        0
      ],
      [
        75,
        65
      ],
      [
        49,
        21
      ],
      [
        12,
        -21
      ],
      [
        -74,
        -76
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -33
      ],
      [
        -75,
        -32
      ],
      [
        -148,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -124,
        -33
      ],
      [
        -62,
        11
      ],
      [
        0,
        22
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        -10
      ],
      [
        0,
        32
      ],
      [
        12,
        33
      ],
      [
        37,
        65
      ],
      [
        62,
        43
      ],
      [
        13,
        -11
      ],
      [
        25,
        44
      ],
      [
        37,
        0
      ],
      [
        37,
        21
      ],
      [
        37,
        -21
      ],
      [
        74,
        32
      ],
      [
        75,
        0
      ],
      [
        74,
        11
      ],
      [
        25,
        22
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        37843,
        81990
      ],
      [
        -24,
        -11
      ],
      [
        -62,
        21
      ],
      [
        49,
        22
      ],
      [
        25,
        33
      ],
      [
        12,
        -65
      ]
    ],
    [
      [
        37670,
        82066
      ],
      [
        -99,
        -33
      ],
      [
        37,
        76
      ],
      [
        25,
        0
      ],
      [
        37,
        -43
      ]
    ],
    [
      [
        37373,
        82131
      ],
      [
        -13,
        -11
      ],
      [
        0,
        65
      ],
      [
        13,
        0
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        37410,
        82131
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        21
      ],
      [
        0,
        33
      ],
      [
        12,
        43
      ],
      [
        25,
        22
      ],
      [
        -12,
        -108
      ]
    ],
    [
      [
        38314,
        83822
      ],
      [
        -25,
        -10
      ],
      [
        0,
        43
      ],
      [
        13,
        0
      ],
      [
        12,
        -33
      ]
    ],
    [
      [
        38463,
        83909
      ],
      [
        -37,
        -11
      ],
      [
        0,
        -43
      ],
      [
        -38,
        33
      ],
      [
        0,
        43
      ],
      [
        38,
        54
      ],
      [
        24,
        -11
      ],
      [
        13,
        -65
      ]
    ],
    [
      [
        19820,
        85818
      ],
      [
        -37,
        0
      ],
      [
        -13,
        22
      ],
      [
        25,
        10
      ],
      [
        25,
        -32
      ]
    ],
    [
      [
        19783,
        85948
      ],
      [
        -13,
        -11
      ],
      [
        -25,
        22
      ],
      [
        25,
        43
      ],
      [
        13,
        -54
      ]
    ],
    [
      [
        19758,
        86295
      ],
      [
        12,
        -43
      ],
      [
        50,
        -65
      ],
      [
        0,
        -33
      ],
      [
        -25,
        0
      ],
      [
        0,
        22
      ],
      [
        -37,
        22
      ],
      [
        -13,
        21
      ],
      [
        0,
        54
      ],
      [
        -12,
        22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        33
      ],
      [
        0,
        32
      ],
      [
        37,
        65
      ],
      [
        12,
        0
      ],
      [
        25,
        -32
      ],
      [
        -12,
        -22
      ],
      [
        -50,
        -33
      ],
      [
        0,
        -10
      ],
      [
        37,
        -11
      ],
      [
        13,
        -33
      ]
    ],
    [
      [
        19671,
        86469
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        22
      ],
      [
        0,
        54
      ],
      [
        12,
        11
      ],
      [
        25,
        -76
      ]
    ],
    [
      [
        19597,
        86512
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        22
      ],
      [
        0,
        54
      ],
      [
        25,
        0
      ],
      [
        25,
        -43
      ],
      [
        0,
        -22
      ]
    ],
    [
      [
        19683,
        86620
      ],
      [
        -12,
        -32
      ],
      [
        -25,
        -22
      ],
      [
        -37,
        22
      ],
      [
        0,
        32
      ],
      [
        25,
        22
      ],
      [
        49,
        -22
      ]
    ],
    [
      [
        38834,
        84430
      ],
      [
        -12,
        -22
      ],
      [
        25,
        -87
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -33
      ],
      [
        37,
        -11
      ],
      [
        0,
        -32
      ],
      [
        -61,
        -87
      ],
      [
        -62,
        11
      ],
      [
        -38,
        -33
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -25,
        -76
      ],
      [
        -25,
        0
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        65
      ],
      [
        -12,
        11
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        44
      ],
      [
        -25,
        -76
      ],
      [
        0,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -12,
        32
      ],
      [
        -62,
        11
      ],
      [
        0,
        33
      ],
      [
        12,
        32
      ],
      [
        -12,
        11
      ],
      [
        12,
        33
      ],
      [
        -12,
        21
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -54
      ],
      [
        -38,
        -108
      ],
      [
        0,
        -55
      ],
      [
        -24,
        -32
      ],
      [
        -38,
        -33
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -32
      ],
      [
        -12,
        -33
      ],
      [
        -50,
        -11
      ],
      [
        0,
        44
      ],
      [
        -12,
        21
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        22
      ],
      [
        -37,
        -22
      ],
      [
        0,
        22
      ],
      [
        -24,
        11
      ],
      [
        -38,
        -44
      ],
      [
        -37,
        -54
      ],
      [
        25,
        -32
      ],
      [
        -50,
        -87
      ],
      [
        -61,
        -87
      ],
      [
        -38,
        -130
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        -151
      ],
      [
        13,
        -33
      ],
      [
        0,
        -32
      ],
      [
        12,
        -33
      ],
      [
        37,
        0
      ],
      [
        13,
        -32
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        -32
      ],
      [
        -62,
        -109
      ],
      [
        12,
        -11
      ],
      [
        62,
        -21
      ],
      [
        25,
        -22
      ],
      [
        50,
        -119
      ],
      [
        -13,
        -33
      ],
      [
        38,
        -32
      ],
      [
        0,
        -87
      ],
      [
        37,
        -33
      ],
      [
        49,
        -11
      ],
      [
        50,
        22
      ],
      [
        49,
        33
      ],
      [
        0,
        32
      ],
      [
        -37,
        65
      ],
      [
        0,
        33
      ],
      [
        -25,
        21
      ],
      [
        -12,
        -21
      ],
      [
        -12,
        43
      ],
      [
        49,
        -11
      ],
      [
        37,
        -76
      ],
      [
        13,
        -97
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -112,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -62,
        -22
      ],
      [
        12,
        43
      ],
      [
        -12,
        66
      ],
      [
        -12,
        0
      ],
      [
        -87,
        -109
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -13,
        97
      ],
      [
        25,
        65
      ],
      [
        -12,
        0
      ],
      [
        -38,
        -43
      ],
      [
        -12,
        22
      ],
      [
        0,
        32
      ],
      [
        -25,
        22
      ],
      [
        13,
        -65
      ],
      [
        -25,
        -44
      ],
      [
        0,
        -108
      ],
      [
        -37,
        -43
      ],
      [
        -75,
        -33
      ],
      [
        -111,
        0
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -124,
        -10
      ],
      [
        -25,
        10
      ],
      [
        -37,
        -43
      ],
      [
        -62,
        -22
      ],
      [
        -136,
        -97
      ],
      [
        -87,
        -120
      ],
      [
        -25,
        -10
      ],
      [
        -12,
        21
      ],
      [
        -37,
        -76
      ],
      [
        -50,
        -43
      ],
      [
        -25,
        -76
      ],
      [
        13,
        -43
      ],
      [
        62,
        -22
      ],
      [
        24,
        11
      ],
      [
        0,
        -33
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -43
      ],
      [
        0,
        -55
      ],
      [
        -24,
        -108
      ],
      [
        -25,
        -33
      ],
      [
        -13,
        -141
      ],
      [
        -24,
        -65
      ],
      [
        -62,
        -97
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        11
      ],
      [
        -25,
        -44
      ],
      [
        -13,
        -43
      ],
      [
        -49,
        -130
      ],
      [
        -50,
        -44
      ],
      [
        -12,
        11
      ],
      [
        25,
        119
      ],
      [
        -62,
        44
      ],
      [
        -25,
        0
      ],
      [
        -37,
        43
      ],
      [
        -37,
        33
      ],
      [
        -62,
        97
      ],
      [
        0,
        65
      ],
      [
        37,
        120
      ],
      [
        25,
        21
      ],
      [
        74,
        33
      ],
      [
        -12,
        11
      ],
      [
        -75,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -12,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -108
      ],
      [
        13,
        -44
      ],
      [
        37,
        -76
      ],
      [
        12,
        -119
      ],
      [
        25,
        -76
      ],
      [
        50,
        -98
      ],
      [
        24,
        -21
      ],
      [
        13,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        25,
        -32
      ],
      [
        12,
        -44
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        -76
      ],
      [
        -24,
        -33
      ],
      [
        -87,
        -271
      ],
      [
        12,
        -43
      ],
      [
        -49,
        -33
      ],
      [
        -37,
        -54
      ],
      [
        -13,
        -76
      ],
      [
        -25,
        -98
      ],
      [
        -24,
        76
      ],
      [
        37,
        217
      ],
      [
        37,
        87
      ],
      [
        25,
        43
      ],
      [
        25,
        76
      ],
      [
        -38,
        22
      ],
      [
        -37,
        -11
      ],
      [
        25,
        76
      ],
      [
        -50,
        54
      ],
      [
        25,
        54
      ],
      [
        0,
        65
      ],
      [
        -12,
        0
      ],
      [
        -13,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        54
      ],
      [
        -24,
        87
      ],
      [
        12,
        65
      ],
      [
        25,
        11
      ],
      [
        24,
        -11
      ],
      [
        25,
        11
      ],
      [
        -49,
        54
      ],
      [
        -13,
        33
      ],
      [
        -24,
        11
      ],
      [
        37,
        43
      ],
      [
        0,
        43
      ],
      [
        -25,
        11
      ],
      [
        -25,
        -21
      ],
      [
        0,
        65
      ],
      [
        50,
        -11
      ],
      [
        12,
        54
      ],
      [
        -25,
        -11
      ],
      [
        0,
        87
      ],
      [
        25,
        76
      ],
      [
        50,
        54
      ],
      [
        12,
        33
      ],
      [
        0,
        32
      ],
      [
        -12,
        33
      ],
      [
        -25,
        0
      ],
      [
        0,
        -54
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        -43
      ],
      [
        -13,
        32
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        21
      ],
      [
        0,
        -10
      ],
      [
        50,
        -76
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -141
      ],
      [
        -12,
        -22
      ],
      [
        12,
        -130
      ],
      [
        13,
        -43
      ],
      [
        24,
        -33
      ],
      [
        0,
        -33
      ],
      [
        -12,
        0
      ],
      [
        12,
        -65
      ],
      [
        25,
        -76
      ],
      [
        0,
        -32
      ],
      [
        -49,
        54
      ],
      [
        -38,
        33
      ],
      [
        -61,
        21
      ],
      [
        -38,
        44
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        98
      ],
      [
        -50,
        -33
      ],
      [
        -25,
        11
      ],
      [
        0,
        76
      ],
      [
        62,
        108
      ],
      [
        13,
        44
      ],
      [
        -13,
        0
      ],
      [
        -12,
        -44
      ],
      [
        -62,
        -65
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -87
      ],
      [
        12,
        -32
      ],
      [
        74,
        10
      ],
      [
        50,
        -108
      ],
      [
        87,
        -33
      ],
      [
        37,
        -32
      ],
      [
        25,
        -43
      ],
      [
        37,
        -33
      ],
      [
        37,
        -43
      ],
      [
        0,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        0,
        -44
      ],
      [
        -13,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -25,
        10
      ],
      [
        -99,
        152
      ],
      [
        -49,
        109
      ],
      [
        -50,
        43
      ],
      [
        -12,
        0
      ],
      [
        99,
        -141
      ],
      [
        37,
        -87
      ],
      [
        37,
        -32
      ],
      [
        25,
        -54
      ],
      [
        87,
        -65
      ],
      [
        -25,
        -22
      ],
      [
        37,
        -22
      ],
      [
        0,
        -87
      ],
      [
        -50,
        22
      ],
      [
        0,
        -54
      ],
      [
        -24,
        -22
      ],
      [
        -25,
        22
      ],
      [
        -74,
        130
      ],
      [
        0,
        -22
      ],
      [
        49,
        -97
      ],
      [
        37,
        -44
      ],
      [
        37,
        -21
      ],
      [
        38,
        -65
      ],
      [
        0,
        -44
      ],
      [
        -13,
        -21
      ],
      [
        -25,
        -11
      ],
      [
        -24,
        21
      ],
      [
        -13,
        33
      ],
      [
        -37,
        43
      ],
      [
        0,
        44
      ],
      [
        -25,
        0
      ],
      [
        -111,
        65
      ],
      [
        0,
        -33
      ],
      [
        25,
        -32
      ],
      [
        86,
        -33
      ],
      [
        13,
        -76
      ],
      [
        49,
        -54
      ],
      [
        13,
        -33
      ],
      [
        24,
        -10
      ],
      [
        50,
        43
      ],
      [
        37,
        -22
      ],
      [
        50,
        -11
      ],
      [
        24,
        -86
      ],
      [
        62,
        -337
      ],
      [
        -24,
        22
      ],
      [
        -25,
        185
      ],
      [
        -13,
        43
      ],
      [
        -12,
        -33
      ],
      [
        -12,
        -65
      ],
      [
        12,
        -21
      ],
      [
        37,
        -109
      ],
      [
        -12,
        -54
      ],
      [
        -50,
        32
      ],
      [
        -37,
        33
      ],
      [
        0,
        -87
      ],
      [
        -25,
        11
      ],
      [
        0,
        -22
      ],
      [
        -62,
        11
      ],
      [
        -24,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -50,
        33
      ],
      [
        -12,
        -76
      ],
      [
        124,
        0
      ],
      [
        49,
        22
      ],
      [
        50,
        -11
      ],
      [
        0,
        -174
      ],
      [
        25,
        22
      ],
      [
        12,
        108
      ],
      [
        37,
        44
      ],
      [
        13,
        -11
      ],
      [
        24,
        -65
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -65
      ],
      [
        -62,
        -87
      ],
      [
        -50,
        -87
      ],
      [
        -24,
        -11
      ],
      [
        -37,
        0
      ],
      [
        -50,
        33
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        22
      ],
      [
        -12,
        54
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -55
      ],
      [
        -25,
        -10
      ],
      [
        74,
        -98
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -54
      ],
      [
        -62,
        -44
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -21
      ],
      [
        50,
        -22
      ],
      [
        99,
        32
      ],
      [
        37,
        -32
      ],
      [
        -25,
        -65
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -10
      ],
      [
        0,
        -33
      ],
      [
        -136,
        0
      ],
      [
        -62,
        -65
      ],
      [
        -25,
        11
      ],
      [
        0,
        54
      ],
      [
        -12,
        22
      ],
      [
        0,
        -109
      ],
      [
        12,
        -21
      ],
      [
        -50,
        -44
      ],
      [
        -86,
        -108
      ],
      [
        -38,
        -87
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -76
      ],
      [
        -12,
        32
      ],
      [
        -13,
        0
      ],
      [
        -12,
        -43
      ],
      [
        -136,
        0
      ],
      [
        -50,
        -32
      ],
      [
        -99,
        -87
      ],
      [
        -25,
        -44
      ],
      [
        -74,
        -162
      ],
      [
        -25,
        -98
      ],
      [
        -12,
        44
      ],
      [
        -13,
        0
      ],
      [
        13,
        -76
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        -65
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -54
      ],
      [
        -74,
        -76
      ],
      [
        -38,
        11
      ],
      [
        13,
        -54
      ],
      [
        -13,
        -33
      ],
      [
        -62,
        -54
      ],
      [
        -24,
        11
      ],
      [
        -25,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        -75,
        21
      ],
      [
        13,
        -32
      ],
      [
        25,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        -21
      ],
      [
        -12,
        65
      ],
      [
        -37,
        -55
      ],
      [
        24,
        -32
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -43
      ],
      [
        -38,
        -22
      ],
      [
        0,
        -54
      ],
      [
        -24,
        -54
      ],
      [
        -38,
        -33
      ],
      [
        -24,
        -11
      ],
      [
        12,
        -21
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -32
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -22
      ],
      [
        25,
        -11
      ],
      [
        -25,
        -54
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        -11
      ],
      [
        25,
        -54
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        10
      ],
      [
        -12,
        -43
      ],
      [
        12,
        -22
      ],
      [
        -25,
        -108
      ],
      [
        0,
        -119
      ],
      [
        25,
        -55
      ],
      [
        25,
        -227
      ],
      [
        12,
        -87
      ],
      [
        25,
        -217
      ],
      [
        50,
        -206
      ],
      [
        74,
        -250
      ],
      [
        111,
        -314
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -33
      ],
      [
        0,
        -163
      ],
      [
        -12,
        0
      ],
      [
        0,
        217
      ],
      [
        -12,
        0
      ],
      [
        0,
        -87
      ],
      [
        -13,
        -21
      ],
      [
        -12,
        76
      ],
      [
        0,
        32
      ],
      [
        12,
        54
      ],
      [
        -24,
        11
      ],
      [
        -13,
        33
      ],
      [
        13,
        32
      ],
      [
        -25,
        22
      ],
      [
        0,
        -76
      ],
      [
        12,
        -54
      ],
      [
        13,
        -109
      ],
      [
        24,
        -65
      ],
      [
        13,
        -65
      ],
      [
        148,
        -607
      ],
      [
        37,
        -76
      ],
      [
        13,
        -54
      ],
      [
        12,
        -119
      ],
      [
        0,
        -141
      ],
      [
        -25,
        -282
      ],
      [
        -12,
        -152
      ],
      [
        -49,
        -163
      ],
      [
        -13,
        -119
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        10
      ],
      [
        -62,
        -54
      ],
      [
        -50,
        11
      ],
      [
        -49,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -13,
        55
      ],
      [
        0,
        54
      ],
      [
        25,
        11
      ],
      [
        37,
        -65
      ],
      [
        13,
        21
      ],
      [
        -13,
        33
      ],
      [
        -49,
        32
      ],
      [
        -38,
        141
      ],
      [
        -37,
        87
      ],
      [
        -12,
        65
      ],
      [
        -74,
        44
      ],
      [
        -50,
        54
      ],
      [
        -25,
        97
      ],
      [
        -25,
        185
      ],
      [
        -24,
        21
      ],
      [
        12,
        76
      ],
      [
        -37,
        -32
      ],
      [
        -12,
        11
      ],
      [
        -13,
        86
      ],
      [
        13,
        120
      ],
      [
        12,
        43
      ],
      [
        -62,
        -11
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        22
      ],
      [
        -13,
        43
      ],
      [
        -37,
        76
      ],
      [
        -62,
        217
      ],
      [
        -24,
        65
      ],
      [
        24,
        11
      ],
      [
        38,
        98
      ],
      [
        24,
        54
      ],
      [
        13,
        43
      ],
      [
        -13,
        33
      ],
      [
        -12,
        -22
      ],
      [
        -12,
        11
      ],
      [
        -25,
        54
      ],
      [
        -25,
        0
      ],
      [
        12,
        -43
      ],
      [
        13,
        -11
      ],
      [
        -13,
        -87
      ],
      [
        -24,
        0
      ],
      [
        -13,
        -21
      ],
      [
        -25,
        43
      ],
      [
        -12,
        43
      ],
      [
        37,
        250
      ],
      [
        25,
        152
      ],
      [
        0,
        173
      ],
      [
        12,
        33
      ],
      [
        -49,
        151
      ],
      [
        -174,
        250
      ],
      [
        -148,
        293
      ],
      [
        -112,
        108
      ],
      [
        -99,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -11
      ],
      [
        -49,
        -11
      ],
      [
        -87,
        -76
      ],
      [
        -37,
        0
      ],
      [
        -50,
        -32
      ],
      [
        -99,
        -22
      ],
      [
        -12,
        11
      ],
      [
        25,
        65
      ],
      [
        -25,
        43
      ],
      [
        -112,
        152
      ],
      [
        25,
        0
      ],
      [
        -12,
        43
      ],
      [
        0,
        33
      ],
      [
        -13,
        22
      ],
      [
        -37,
        -65
      ],
      [
        -24,
        32
      ],
      [
        -112,
        65
      ],
      [
        -87,
        44
      ],
      [
        75,
        21
      ],
      [
        37,
        -11
      ],
      [
        0,
        22
      ],
      [
        -50,
        33
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -49,
        -44
      ],
      [
        -37,
        -21
      ],
      [
        -100,
        -11
      ],
      [
        0,
        32
      ],
      [
        13,
        44
      ],
      [
        -13,
        43
      ],
      [
        -24,
        -43
      ],
      [
        -37,
        21
      ],
      [
        -13,
        -54
      ],
      [
        -25,
        -65
      ],
      [
        -74,
        -33
      ],
      [
        12,
        66
      ],
      [
        -24,
        -22
      ],
      [
        -37,
        -65
      ],
      [
        -50,
        21
      ],
      [
        -25,
        76
      ],
      [
        -25,
        22
      ],
      [
        0,
        76
      ],
      [
        -12,
        32
      ],
      [
        -25,
        33
      ],
      [
        -12,
        -65
      ],
      [
        -13,
        -98
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -37,
        11
      ],
      [
        -112,
        -11
      ],
      [
        -49,
        32
      ],
      [
        -25,
        0
      ],
      [
        -50,
        -32
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -76
      ],
      [
        -49,
        -32
      ],
      [
        -124,
        65
      ],
      [
        -62,
        65
      ],
      [
        -37,
        0
      ],
      [
        -38,
        -65
      ],
      [
        -24,
        -87
      ],
      [
        37,
        -44
      ],
      [
        37,
        -21
      ],
      [
        62,
        21
      ],
      [
        37,
        33
      ],
      [
        50,
        11
      ],
      [
        12,
        22
      ],
      [
        25,
        -33
      ],
      [
        -50,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        25,
        -54
      ],
      [
        62,
        -11
      ],
      [
        0,
        54
      ],
      [
        24,
        43
      ],
      [
        38,
        -10
      ],
      [
        0,
        -44
      ],
      [
        12,
        -32
      ],
      [
        0,
        -65
      ],
      [
        -62,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -44
      ],
      [
        12,
        -43
      ],
      [
        38,
        -32
      ],
      [
        24,
        -44
      ],
      [
        87,
        -54
      ],
      [
        25,
        0
      ],
      [
        37,
        -76
      ],
      [
        25,
        -11
      ],
      [
        -13,
        -32
      ],
      [
        -24,
        -33
      ],
      [
        -13,
        -32
      ],
      [
        -37,
        21
      ],
      [
        -37,
        -54
      ],
      [
        0,
        54
      ],
      [
        -12,
        22
      ],
      [
        -13,
        54
      ],
      [
        -25,
        33
      ],
      [
        -24,
        11
      ],
      [
        -13,
        21
      ],
      [
        -62,
        22
      ],
      [
        0,
        32
      ],
      [
        -24,
        44
      ],
      [
        -100,
        54
      ],
      [
        0,
        -43
      ],
      [
        38,
        -33
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -22
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -65
      ],
      [
        -24,
        -11
      ],
      [
        -13,
        11
      ],
      [
        -12,
        76
      ],
      [
        -25,
        32
      ],
      [
        -49,
        0
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        -76
      ],
      [
        -25,
        -11
      ],
      [
        -87,
        43
      ],
      [
        -99,
        54
      ],
      [
        25,
        33
      ],
      [
        25,
        -11
      ],
      [
        0,
        22
      ],
      [
        -38,
        97
      ],
      [
        0,
        33
      ],
      [
        -24,
        -33
      ],
      [
        -62,
        33
      ],
      [
        -50,
        119
      ],
      [
        -49,
        0
      ],
      [
        -25,
        54
      ],
      [
        -50,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -32
      ],
      [
        25,
        -55
      ],
      [
        -13,
        -10
      ],
      [
        -61,
        -22
      ],
      [
        -137,
        22
      ],
      [
        -37,
        21
      ],
      [
        -62,
        55
      ],
      [
        -74,
        43
      ],
      [
        -37,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -100,
        0
      ],
      [
        -49,
        -32
      ],
      [
        -25,
        54
      ],
      [
        25,
        32
      ],
      [
        25,
        55
      ],
      [
        -25,
        21
      ],
      [
        -37,
        -97
      ],
      [
        12,
        -87
      ],
      [
        -74,
        -11
      ],
      [
        -161,
        -108
      ],
      [
        -62,
        -66
      ],
      [
        0,
        22
      ],
      [
        87,
        76
      ],
      [
        -38,
        11
      ],
      [
        -37,
        -22
      ],
      [
        -12,
        11
      ],
      [
        12,
        65
      ],
      [
        0,
        65
      ],
      [
        -37,
        0
      ],
      [
        -25,
        -43
      ],
      [
        -24,
        22
      ],
      [
        -13,
        -11
      ],
      [
        13,
        -109
      ],
      [
        24,
        -97
      ],
      [
        -74,
        -130
      ],
      [
        -12,
        -55
      ],
      [
        -38,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -99,
        -98
      ],
      [
        -62,
        -65
      ],
      [
        -62,
        -32
      ],
      [
        0,
        21
      ],
      [
        -37,
        0
      ],
      [
        -49,
        22
      ],
      [
        -38,
        0
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -21
      ],
      [
        -38,
        54
      ],
      [
        0,
        22
      ],
      [
        -24,
        0
      ],
      [
        37,
        -141
      ],
      [
        37,
        -22
      ],
      [
        -50,
        -54
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        43
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -44
      ],
      [
        -12,
        22
      ],
      [
        -38,
        -22
      ],
      [
        -49,
        -10
      ],
      [
        12,
        -44
      ],
      [
        37,
        11
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -13,
        -22
      ],
      [
        50,
        -108
      ],
      [
        -37,
        -152
      ],
      [
        -13,
        -65
      ],
      [
        -37,
        0
      ],
      [
        -50,
        43
      ],
      [
        0,
        -65
      ],
      [
        62,
        -32
      ],
      [
        13,
        -44
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -43
      ],
      [
        12,
        -87
      ],
      [
        13,
        -44
      ],
      [
        12,
        -130
      ],
      [
        13,
        -54
      ],
      [
        61,
        -206
      ],
      [
        25,
        0
      ],
      [
        0,
        -65
      ]
    ],
    [
      [
        21628,
        76534
      ],
      [
        0,
        76
      ],
      [
        -24,
        22
      ],
      [
        -13,
        -11
      ],
      [
        -12,
        87
      ],
      [
        0,
        87
      ],
      [
        -25,
        97
      ],
      [
        -50,
        120
      ],
      [
        -111,
        151
      ],
      [
        -50,
        55
      ],
      [
        -49,
        65
      ],
      [
        -62,
        21
      ],
      [
        -12,
        -32
      ],
      [
        -38,
        22
      ],
      [
        13,
        65
      ],
      [
        -50,
        108
      ],
      [
        -25,
        11
      ],
      [
        -86,
        -11
      ],
      [
        -99,
        54
      ],
      [
        -38,
        33
      ],
      [
        -12,
        54
      ],
      [
        -49,
        54
      ],
      [
        -62,
        55
      ],
      [
        -38,
        -11
      ],
      [
        -49,
        0
      ],
      [
        -62,
        43
      ],
      [
        -50,
        0
      ],
      [
        -74,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -62,
        65
      ],
      [
        13,
        54
      ],
      [
        -13,
        55
      ],
      [
        13,
        32
      ],
      [
        -13,
        87
      ],
      [
        0,
        108
      ],
      [
        -74,
        55
      ],
      [
        -12,
        43
      ],
      [
        12,
        54
      ],
      [
        -12,
        44
      ],
      [
        -38,
        32
      ],
      [
        -49,
        76
      ],
      [
        -50,
        43
      ],
      [
        -12,
        76
      ],
      [
        -37,
        44
      ],
      [
        -13,
        43
      ],
      [
        -62,
        141
      ],
      [
        -74,
        109
      ],
      [
        -12,
        65
      ],
      [
        0,
        86
      ],
      [
        25,
        55
      ],
      [
        12,
        43
      ],
      [
        0,
        76
      ],
      [
        -25,
        54
      ],
      [
        -99,
        33
      ],
      [
        -87,
        130
      ],
      [
        0,
        108
      ],
      [
        -24,
        109
      ],
      [
        0,
        65
      ],
      [
        -13,
        76
      ],
      [
        50,
        11
      ],
      [
        0,
        -87
      ],
      [
        49,
        -54
      ],
      [
        25,
        -44
      ],
      [
        25,
        -11
      ],
      [
        -25,
        98
      ],
      [
        -25,
        65
      ],
      [
        -24,
        33
      ],
      [
        -13,
        65
      ],
      [
        -12,
        10
      ],
      [
        0,
        33
      ],
      [
        49,
        43
      ],
      [
        50,
        11
      ],
      [
        124,
        -11
      ],
      [
        12,
        22
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -49,
        33
      ],
      [
        -50,
        -33
      ],
      [
        -12,
        0
      ],
      [
        -50,
        43
      ],
      [
        -49,
        -21
      ],
      [
        0,
        -163
      ],
      [
        -13,
        -11
      ],
      [
        -25,
        33
      ],
      [
        -24,
        11
      ],
      [
        -38,
        32
      ],
      [
        -49,
        65
      ],
      [
        -12,
        33
      ],
      [
        -13,
        76
      ],
      [
        0,
        32
      ],
      [
        -25,
        22
      ],
      [
        -24,
        87
      ],
      [
        -50,
        54
      ],
      [
        -49,
        87
      ],
      [
        -100,
        141
      ],
      [
        0,
        130
      ],
      [
        -37,
        162
      ],
      [
        13,
        87
      ],
      [
        0,
        65
      ],
      [
        -13,
        98
      ],
      [
        -99,
        206
      ],
      [
        -74,
        98
      ],
      [
        -13,
        75
      ],
      [
        0,
        76
      ],
      [
        25,
        131
      ],
      [
        25,
        -11
      ],
      [
        0,
        86
      ],
      [
        25,
        87
      ],
      [
        0,
        120
      ],
      [
        25,
        141
      ],
      [
        0,
        43
      ],
      [
        -13,
        108
      ],
      [
        -49,
        98
      ],
      [
        12,
        65
      ],
      [
        0,
        65
      ],
      [
        -50,
        87
      ],
      [
        -12,
        108
      ],
      [
        -12,
        44
      ],
      [
        12,
        130
      ],
      [
        -12,
        54
      ],
      [
        -37,
        87
      ],
      [
        61,
        336
      ],
      [
        25,
        11
      ],
      [
        25,
        32
      ],
      [
        -12,
        11
      ],
      [
        0,
        65
      ],
      [
        24,
        76
      ],
      [
        13,
        22
      ],
      [
        0,
        228
      ],
      [
        12,
        173
      ],
      [
        25,
        54
      ],
      [
        -12,
        65
      ],
      [
        12,
        76
      ],
      [
        -12,
        76
      ],
      [
        37,
        391
      ],
      [
        0,
        54
      ],
      [
        12,
        54
      ],
      [
        -12,
        174
      ],
      [
        0,
        206
      ],
      [
        -13,
        21
      ],
      [
        13,
        11
      ],
      [
        12,
        -32
      ],
      [
        87,
        0
      ],
      [
        49,
        32
      ],
      [
        25,
        -11
      ],
      [
        25,
        -32
      ],
      [
        25,
        11
      ],
      [
        -37,
        32
      ],
      [
        -13,
        22
      ],
      [
        -62,
        0
      ],
      [
        -12,
        22
      ],
      [
        -75,
        -22
      ],
      [
        -24,
        22
      ],
      [
        -37,
        -11
      ],
      [
        12,
        54
      ],
      [
        25,
        43
      ],
      [
        24,
        141
      ],
      [
        -24,
        33
      ],
      [
        -37,
        22
      ],
      [
        -13,
        76
      ],
      [
        87,
        54
      ],
      [
        -50,
        22
      ],
      [
        -12,
        21
      ],
      [
        -50,
        -11
      ],
      [
        0,
        44
      ],
      [
        -12,
        76
      ],
      [
        -37,
        130
      ],
      [
        -25,
        152
      ],
      [
        -25,
        86
      ],
      [
        -49,
        65
      ],
      [
        -25,
        55
      ],
      [
        -12,
        108
      ],
      [
        12,
        76
      ],
      [
        -12,
        65
      ],
      [
        24,
        0
      ],
      [
        75,
        -54
      ],
      [
        86,
        -33
      ],
      [
        25,
        -21
      ],
      [
        50,
        -22
      ],
      [
        223,
        -33
      ],
      [
        24,
        0
      ],
      [
        38,
        22
      ],
      [
        49,
        -54
      ],
      [
        50,
        11
      ],
      [
        24,
        -11
      ],
      [
        38,
        -87
      ],
      [
        0,
        -32
      ],
      [
        -38,
        -87
      ],
      [
        -12,
        0
      ],
      [
        0,
        32
      ],
      [
        -87,
        -151
      ],
      [
        -24,
        -66
      ],
      [
        0,
        -54
      ],
      [
        12,
        -11
      ],
      [
        25,
        11
      ],
      [
        -13,
        22
      ],
      [
        0,
        54
      ],
      [
        25,
        54
      ],
      [
        62,
        55
      ],
      [
        12,
        32
      ],
      [
        62,
        87
      ],
      [
        0,
        54
      ],
      [
        25,
        -11
      ],
      [
        0,
        -86
      ],
      [
        -37,
        -44
      ],
      [
        0,
        -65
      ],
      [
        25,
        -87
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -87
      ],
      [
        -24,
        11
      ],
      [
        -13,
        22
      ],
      [
        -12,
        -11
      ],
      [
        -37,
        21
      ],
      [
        -37,
        -54
      ],
      [
        -13,
        -54
      ],
      [
        25,
        -22
      ],
      [
        37,
        11
      ],
      [
        37,
        -22
      ],
      [
        37,
        33
      ],
      [
        13,
        65
      ],
      [
        49,
        22
      ],
      [
        25,
        43
      ],
      [
        -12,
        98
      ],
      [
        0,
        65
      ],
      [
        -13,
        11
      ],
      [
        13,
        43
      ],
      [
        -13,
        43
      ],
      [
        25,
        65
      ],
      [
        37,
        76
      ],
      [
        -12,
        11
      ],
      [
        -37,
        87
      ],
      [
        -13,
        0
      ],
      [
        13,
        -54
      ],
      [
        -13,
        0
      ],
      [
        -37,
        43
      ],
      [
        0,
        44
      ],
      [
        13,
        21
      ],
      [
        24,
        11
      ],
      [
        -24,
        65
      ],
      [
        -38,
        33
      ],
      [
        -24,
        11
      ],
      [
        12,
        32
      ],
      [
        25,
        -11
      ],
      [
        25,
        11
      ],
      [
        -13,
        33
      ],
      [
        0,
        75
      ],
      [
        -12,
        55
      ],
      [
        -37,
        0
      ],
      [
        -25,
        54
      ],
      [
        -13,
        87
      ]
    ],
    [
      [
        123663,
        88301
      ],
      [
        -62,
        0
      ],
      [
        -112,
        109
      ],
      [
        -62,
        32
      ],
      [
        -37,
        33
      ],
      [
        13,
        11
      ],
      [
        74,
        -33
      ],
      [
        136,
        -119
      ],
      [
        37,
        -11
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        1276,
        88562
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        65
      ],
      [
        13,
        11
      ],
      [
        37,
        -43
      ]
    ],
    [
      [
        1363,
        88583
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        32
      ],
      [
        0,
        33
      ],
      [
        62,
        -44
      ]
    ],
    [
      [
        718,
        88475
      ],
      [
        -12,
        -22
      ],
      [
        -49,
        44
      ],
      [
        37,
        32
      ],
      [
        -25,
        44
      ],
      [
        -37,
        32
      ],
      [
        -13,
        33
      ],
      [
        25,
        11
      ],
      [
        50,
        0
      ],
      [
        37,
        -44
      ],
      [
        25,
        -11
      ],
      [
        -13,
        -97
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        979,
        88518
      ],
      [
        -13,
        -10
      ],
      [
        -136,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        21
      ],
      [
        148,
        55
      ],
      [
        25,
        65
      ],
      [
        37,
        0
      ],
      [
        0,
        -22
      ],
      [
        -24,
        -22
      ],
      [
        0,
        -76
      ]
    ],
    [
      [
        1164,
        88616
      ],
      [
        0,
        -22
      ],
      [
        50,
        -11
      ],
      [
        0,
        -54
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -22
      ],
      [
        -75,
        -54
      ],
      [
        -24,
        33
      ],
      [
        -13,
        65
      ],
      [
        50,
        32
      ],
      [
        12,
        98
      ],
      [
        37,
        -11
      ],
      [
        13,
        -32
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        123366,
        88649
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        21
      ],
      [
        13,
        33
      ],
      [
        37,
        -22
      ],
      [
        -12,
        -21
      ]
    ],
    [
      [
        123762,
        88638
      ],
      [
        -62,
        -11
      ],
      [
        -12,
        54
      ],
      [
        37,
        33
      ],
      [
        49,
        -33
      ],
      [
        -12,
        -43
      ]
    ],
    [
      [
        1363,
        88703
      ],
      [
        -13,
        -22
      ],
      [
        -49,
        54
      ],
      [
        12,
        22
      ],
      [
        50,
        -11
      ],
      [
        12,
        -32
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        122969,
        88627
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        44
      ],
      [
        50,
        43
      ],
      [
        49,
        22
      ],
      [
        13,
        65
      ],
      [
        37,
        -11
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -33
      ],
      [
        -62,
        -32
      ]
    ],
    [
      [
        2217,
        88779
      ],
      [
        62,
        -22
      ],
      [
        112,
        0
      ],
      [
        0,
        -11
      ],
      [
        -112,
        -22
      ],
      [
        -111,
        11
      ],
      [
        -50,
        -11
      ],
      [
        -62,
        33
      ],
      [
        0,
        22
      ],
      [
        75,
        -11
      ],
      [
        49,
        22
      ],
      [
        37,
        -11
      ]
    ],
    [
      [
        2589,
        88865
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        10
      ],
      [
        37,
        55
      ],
      [
        25,
        21
      ],
      [
        25,
        -10
      ],
      [
        25,
        -33
      ],
      [
        -50,
        -33
      ]
    ],
    [
      [
        1821,
        88714
      ],
      [
        -186,
        -22
      ],
      [
        0,
        32
      ],
      [
        37,
        0
      ],
      [
        75,
        33
      ],
      [
        86,
        22
      ],
      [
        62,
        32
      ],
      [
        62,
        22
      ],
      [
        13,
        32
      ],
      [
        -50,
        11
      ],
      [
        -12,
        22
      ],
      [
        24,
        11
      ],
      [
        62,
        54
      ],
      [
        50,
        -32
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -54
      ],
      [
        -50,
        -33
      ],
      [
        25,
        -43
      ],
      [
        -74,
        -33
      ],
      [
        -124,
        -32
      ]
    ],
    [
      [
        121693,
        88920
      ],
      [
        -25,
        0
      ],
      [
        -12,
        21
      ],
      [
        -74,
        11
      ],
      [
        12,
        22
      ],
      [
        25,
        0
      ],
      [
        49,
        32
      ],
      [
        50,
        0
      ],
      [
        -25,
        -86
      ]
    ],
    [
      [
        3184,
        89061
      ],
      [
        -25,
        -11
      ],
      [
        -13,
        22
      ],
      [
        50,
        65
      ],
      [
        37,
        -22
      ],
      [
        0,
        -22
      ],
      [
        -49,
        -32
      ]
    ],
    [
      [
        3543,
        89223
      ],
      [
        -13,
        -32
      ],
      [
        -86,
        11
      ],
      [
        0,
        21
      ],
      [
        49,
        22
      ],
      [
        25,
        0
      ],
      [
        25,
        -22
      ]
    ],
    [
      [
        121384,
        89332
      ],
      [
        61,
        -22
      ],
      [
        38,
        11
      ],
      [
        49,
        -33
      ],
      [
        62,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -112,
        -10
      ],
      [
        -49,
        -33
      ],
      [
        -50,
        22
      ],
      [
        -25,
        54
      ],
      [
        -74,
        33
      ],
      [
        62,
        43
      ],
      [
        50,
        11
      ]
    ],
    [
      [
        4137,
        89538
      ],
      [
        -111,
        -65
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        -44
      ],
      [
        -12,
        -32
      ],
      [
        -38,
        -11
      ],
      [
        -49,
        -33
      ],
      [
        -112,
        -87
      ],
      [
        0,
        22
      ],
      [
        62,
        54
      ],
      [
        37,
        65
      ],
      [
        0,
        66
      ],
      [
        50,
        65
      ],
      [
        74,
        0
      ],
      [
        25,
        21
      ],
      [
        -12,
        22
      ],
      [
        0,
        54
      ],
      [
        37,
        54
      ],
      [
        25,
        22
      ],
      [
        74,
        11
      ],
      [
        62,
        -33
      ],
      [
        -12,
        -75
      ],
      [
        -38,
        -22
      ]
    ],
    [
      [
        4744,
        89776
      ],
      [
        -24,
        11
      ],
      [
        24,
        44
      ],
      [
        13,
        -22
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        4596,
        89885
      ],
      [
        12,
        -33
      ],
      [
        37,
        22
      ],
      [
        37,
        76
      ],
      [
        13,
        -22
      ],
      [
        37,
        -21
      ],
      [
        -112,
        -131
      ],
      [
        0,
        -21
      ],
      [
        62,
        21
      ],
      [
        25,
        -21
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -32
      ],
      [
        -62,
        -44
      ],
      [
        -25,
        -43
      ],
      [
        -62,
        -11
      ],
      [
        -74,
        -22
      ],
      [
        -50,
        -43
      ],
      [
        -24,
        0
      ],
      [
        -50,
        -44
      ],
      [
        -50,
        -10
      ],
      [
        -37,
        21
      ],
      [
        -12,
        22
      ],
      [
        62,
        33
      ],
      [
        37,
        10
      ],
      [
        136,
        76
      ],
      [
        13,
        76
      ],
      [
        24,
        33
      ],
      [
        50,
        0
      ],
      [
        12,
        -33
      ],
      [
        38,
        44
      ],
      [
        -50,
        32
      ],
      [
        -50,
        0
      ],
      [
        -37,
        54
      ],
      [
        13,
        33
      ],
      [
        37,
        32
      ],
      [
        49,
        11
      ],
      [
        38,
        22
      ],
      [
        37,
        -11
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        4868,
        89993
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        10
      ],
      [
        -37,
        -10
      ],
      [
        -25,
        43
      ],
      [
        0,
        22
      ],
      [
        25,
        32
      ],
      [
        49,
        11
      ],
      [
        50,
        -43
      ],
      [
        25,
        -11
      ],
      [
        -13,
        -33
      ],
      [
        -37,
        0
      ]
    ],
    [
      [
        4967,
        90026
      ],
      [
        -24,
        0
      ],
      [
        -13,
        76
      ],
      [
        25,
        21
      ],
      [
        37,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -32
      ]
    ],
    [
      [
        5995,
        90199
      ],
      [
        -24,
        -21
      ],
      [
        -62,
        43
      ],
      [
        0,
        33
      ],
      [
        62,
        -22
      ],
      [
        24,
        -33
      ]
    ],
    [
      [
        6082,
        90471
      ],
      [
        -49,
        54
      ],
      [
        49,
        32
      ],
      [
        25,
        -11
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -54
      ]
    ],
    [
      [
        5673,
        90557
      ],
      [
        50,
        -119
      ],
      [
        49,
        -22
      ],
      [
        25,
        -21
      ],
      [
        13,
        -33
      ],
      [
        -87,
        43
      ],
      [
        -62,
        -65
      ],
      [
        -186,
        -10
      ],
      [
        -62,
        -22
      ],
      [
        -49,
        -87
      ],
      [
        -75,
        -22
      ],
      [
        -49,
        0
      ],
      [
        -37,
        33
      ],
      [
        -13,
        54
      ],
      [
        0,
        44
      ],
      [
        62,
        43
      ],
      [
        62,
        119
      ],
      [
        25,
        22
      ],
      [
        62,
        -11
      ],
      [
        49,
        43
      ],
      [
        100,
        44
      ],
      [
        12,
        11
      ],
      [
        74,
        0
      ],
      [
        37,
        -44
      ]
    ],
    [
      [
        7098,
        90557
      ],
      [
        -25,
        0
      ],
      [
        -12,
        55
      ],
      [
        25,
        -11
      ],
      [
        12,
        -44
      ]
    ],
    [
      [
        16735,
        90622
      ],
      [
        37,
        -86
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        11
      ],
      [
        0,
        54
      ],
      [
        -49,
        54
      ],
      [
        12,
        33
      ],
      [
        -12,
        76
      ],
      [
        24,
        0
      ],
      [
        38,
        -33
      ],
      [
        24,
        -76
      ]
    ],
    [
      [
        6925,
        90655
      ],
      [
        -62,
        -54
      ],
      [
        -50,
        -65
      ],
      [
        0,
        43
      ],
      [
        12,
        11
      ],
      [
        -12,
        54
      ],
      [
        25,
        11
      ],
      [
        25,
        32
      ],
      [
        24,
        11
      ],
      [
        13,
        44
      ],
      [
        25,
        -11
      ],
      [
        -13,
        -22
      ],
      [
        13,
        -54
      ]
    ],
    [
      [
        16215,
        90503
      ],
      [
        25,
        22
      ],
      [
        25,
        0
      ],
      [
        37,
        -22
      ],
      [
        -13,
        -32
      ],
      [
        0,
        -55
      ],
      [
        -24,
        -43
      ],
      [
        -38,
        11
      ],
      [
        -62,
        97
      ],
      [
        -74,
        141
      ],
      [
        -12,
        55
      ],
      [
        -62,
        21
      ],
      [
        -13,
        33
      ],
      [
        13,
        32
      ],
      [
        49,
        11
      ],
      [
        62,
        -65
      ],
      [
        37,
        -65
      ],
      [
        0,
        -54
      ],
      [
        50,
        -87
      ]
    ],
    [
      [
        6763,
        90785
      ],
      [
        -12,
        -54
      ],
      [
        -49,
        43
      ],
      [
        0,
        22
      ],
      [
        49,
        0
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        6640,
        90763
      ],
      [
        37,
        44
      ],
      [
        12,
        -11
      ],
      [
        -12,
        -33
      ],
      [
        12,
        -43
      ],
      [
        25,
        -22
      ],
      [
        -50,
        -32
      ],
      [
        -74,
        11
      ],
      [
        -12,
        86
      ],
      [
        24,
        44
      ],
      [
        25,
        21
      ],
      [
        13,
        -10
      ],
      [
        0,
        -55
      ]
    ],
    [
      [
        16054,
        90915
      ],
      [
        12,
        -32
      ],
      [
        -49,
        -44
      ],
      [
        -37,
        -76
      ],
      [
        -37,
        -21
      ],
      [
        0,
        86
      ],
      [
        -38,
        55
      ],
      [
        38,
        21
      ],
      [
        61,
        -11
      ],
      [
        50,
        22
      ]
    ],
    [
      [
        8399,
        91089
      ],
      [
        -13,
        -22
      ],
      [
        -37,
        0
      ],
      [
        -12,
        22
      ],
      [
        49,
        54
      ],
      [
        13,
        0
      ],
      [
        0,
        -54
      ]
    ],
    [
      [
        16859,
        90872
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        11
      ],
      [
        -12,
        33
      ],
      [
        -37,
        0
      ],
      [
        -13,
        21
      ],
      [
        13,
        33
      ],
      [
        -13,
        32
      ],
      [
        -25,
        -43
      ],
      [
        -74,
        -76
      ],
      [
        -25,
        0
      ],
      [
        -12,
        119
      ],
      [
        25,
        55
      ],
      [
        37,
        54
      ],
      [
        12,
        152
      ],
      [
        124,
        76
      ],
      [
        12,
        0
      ],
      [
        38,
        -55
      ],
      [
        49,
        -86
      ],
      [
        0,
        -152
      ]
    ],
    [
      [
        15967,
        91403
      ],
      [
        62,
        -11
      ],
      [
        62,
        0
      ],
      [
        25,
        -21
      ],
      [
        25,
        -55
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        124,
        -54
      ],
      [
        75,
        -97
      ],
      [
        37,
        -98
      ],
      [
        49,
        -87
      ],
      [
        25,
        -22
      ],
      [
        0,
        -21
      ],
      [
        -37,
        11
      ],
      [
        -74,
        54
      ],
      [
        -25,
        -76
      ],
      [
        62,
        11
      ],
      [
        49,
        -54
      ],
      [
        25,
        -11
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        74,
        0
      ],
      [
        0,
        -260
      ],
      [
        -12,
        -54
      ],
      [
        -62,
        10
      ],
      [
        -25,
        44
      ],
      [
        -25,
        65
      ],
      [
        -37,
        22
      ],
      [
        -37,
        0
      ],
      [
        -12,
        65
      ],
      [
        -25,
        65
      ],
      [
        -12,
        -11
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -50,
        86
      ],
      [
        -49,
        76
      ],
      [
        -13,
        33
      ],
      [
        50,
        11
      ],
      [
        -37,
        76
      ],
      [
        12,
        54
      ],
      [
        -25,
        11
      ],
      [
        -62,
        0
      ],
      [
        -24,
        32
      ],
      [
        0,
        22
      ],
      [
        -62,
        0
      ],
      [
        -37,
        32
      ],
      [
        -13,
        44
      ],
      [
        50,
        11
      ],
      [
        37,
        -22
      ],
      [
        37,
        33
      ],
      [
        0,
        21
      ],
      [
        25,
        22
      ],
      [
        -13,
        65
      ],
      [
        -24,
        11
      ],
      [
        -62,
        -22
      ],
      [
        -50,
        -32
      ],
      [
        -25,
        10
      ],
      [
        0,
        22
      ],
      [
        75,
        87
      ],
      [
        0,
        22
      ],
      [
        -25,
        21
      ],
      [
        0,
        65
      ],
      [
        12,
        11
      ]
    ],
    [
      [
        16240,
        91349
      ],
      [
        -37,
        11
      ],
      [
        -50,
        43
      ],
      [
        0,
        33
      ],
      [
        50,
        43
      ],
      [
        62,
        0
      ],
      [
        24,
        -11
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -21
      ],
      [
        -37,
        -22
      ]
    ],
    [
      [
        16475,
        91262
      ],
      [
        -12,
        -97
      ],
      [
        -50,
        -11
      ],
      [
        -49,
        11
      ],
      [
        0,
        43
      ],
      [
        -13,
        22
      ],
      [
        -74,
        11
      ],
      [
        -12,
        32
      ],
      [
        0,
        43
      ],
      [
        37,
        33
      ],
      [
        37,
        54
      ],
      [
        37,
        109
      ],
      [
        25,
        -11
      ],
      [
        87,
        -152
      ],
      [
        -13,
        -87
      ]
    ],
    [
      [
        8708,
        91468
      ],
      [
        -37,
        -11
      ],
      [
        13,
        55
      ],
      [
        74,
        54
      ],
      [
        25,
        -11
      ],
      [
        -75,
        -87
      ]
    ],
    [
      [
        8869,
        91512
      ],
      [
        -24,
        0
      ],
      [
        -25,
        21
      ],
      [
        12,
        22
      ],
      [
        37,
        22
      ],
      [
        37,
        0
      ],
      [
        0,
        -33
      ],
      [
        -37,
        -32
      ]
    ],
    [
      [
        3518,
        91588
      ],
      [
        50,
        -11
      ],
      [
        24,
        11
      ],
      [
        25,
        -22
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -37,
        55
      ]
    ],
    [
      [
        16252,
        91523
      ],
      [
        0,
        -11
      ],
      [
        -49,
        0
      ],
      [
        -25,
        32
      ],
      [
        37,
        87
      ],
      [
        0,
        65
      ],
      [
        87,
        -108
      ],
      [
        12,
        -33
      ],
      [
        -62,
        -32
      ]
    ],
    [
      [
        15819,
        91718
      ],
      [
        24,
        -44
      ],
      [
        38,
        11
      ],
      [
        24,
        -87
      ],
      [
        0,
        -32
      ],
      [
        -24,
        11
      ],
      [
        -25,
        -76
      ],
      [
        12,
        -65
      ],
      [
        -25,
        -120
      ],
      [
        0,
        -43
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -13,
        -32
      ],
      [
        -24,
        0
      ],
      [
        -25,
        86
      ],
      [
        25,
        130
      ],
      [
        37,
        22
      ],
      [
        -25,
        33
      ],
      [
        -49,
        43
      ],
      [
        0,
        22
      ],
      [
        -38,
        76
      ],
      [
        13,
        65
      ],
      [
        37,
        54
      ],
      [
        37,
        11
      ],
      [
        37,
        -22
      ],
      [
        13,
        -43
      ]
    ],
    [
      [
        16042,
        91826
      ],
      [
        24,
        -22
      ],
      [
        13,
        22
      ],
      [
        62,
        -22
      ],
      [
        37,
        -54
      ],
      [
        0,
        -152
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        32
      ],
      [
        -37,
        76
      ],
      [
        -25,
        -11
      ],
      [
        37,
        -54
      ],
      [
        25,
        -54
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -11
      ],
      [
        -75,
        0
      ],
      [
        -37,
        -11
      ],
      [
        -49,
        22
      ],
      [
        0,
        65
      ],
      [
        -13,
        76
      ],
      [
        0,
        54
      ],
      [
        -49,
        76
      ],
      [
        -38,
        32
      ],
      [
        -12,
        44
      ],
      [
        37,
        11
      ],
      [
        50,
        0
      ],
      [
        124,
        -33
      ]
    ],
    [
      [
        9278,
        91902
      ],
      [
        -49,
        -22
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        33
      ],
      [
        13,
        54
      ],
      [
        24,
        33
      ],
      [
        112,
        -11
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        3382,
        91935
      ],
      [
        -37,
        -33
      ],
      [
        -38,
        11
      ],
      [
        0,
        32
      ],
      [
        87,
        22
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        15484,
        92043
      ],
      [
        37,
        -76
      ],
      [
        13,
        -54
      ],
      [
        24,
        -54
      ],
      [
        25,
        -141
      ],
      [
        25,
        -44
      ],
      [
        0,
        -119
      ],
      [
        -12,
        -32
      ],
      [
        12,
        -55
      ],
      [
        0,
        -86
      ],
      [
        -25,
        -55
      ],
      [
        -25,
        22
      ],
      [
        -24,
        43
      ],
      [
        -37,
        87
      ],
      [
        -13,
        44
      ],
      [
        0,
        43
      ],
      [
        37,
        43
      ],
      [
        -49,
        0
      ],
      [
        -50,
        44
      ],
      [
        0,
        54
      ],
      [
        -49,
        -11
      ],
      [
        -13,
        11
      ],
      [
        0,
        43
      ],
      [
        50,
        87
      ],
      [
        -50,
        33
      ],
      [
        -12,
        65
      ],
      [
        -25,
        43
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        -130
      ],
      [
        -50,
        -11
      ],
      [
        13,
        33
      ],
      [
        -13,
        108
      ],
      [
        13,
        54
      ],
      [
        49,
        22
      ],
      [
        50,
        98
      ],
      [
        49,
        11
      ],
      [
        75,
        -66
      ],
      [
        24,
        -10
      ],
      [
        25,
        -33
      ]
    ],
    [
      [
        9204,
        92347
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        22
      ],
      [
        -62,
        54
      ],
      [
        12,
        11
      ],
      [
        50,
        -22
      ],
      [
        37,
        -54
      ]
    ],
    [
      [
        9315,
        92336
      ],
      [
        0,
        -33
      ],
      [
        25,
        0
      ],
      [
        74,
        44
      ],
      [
        38,
        0
      ],
      [
        37,
        -22
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -21
      ],
      [
        0,
        -22
      ],
      [
        25,
        -33
      ],
      [
        62,
        -21
      ],
      [
        0,
        -22
      ],
      [
        -38,
        -65
      ],
      [
        -24,
        -11
      ],
      [
        -149,
        22
      ],
      [
        -25,
        11
      ],
      [
        -37,
        -33
      ],
      [
        74,
        0
      ],
      [
        38,
        -54
      ],
      [
        -13,
        -33
      ],
      [
        -49,
        0
      ],
      [
        -37,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        -75,
        -11
      ],
      [
        -62,
        -32
      ],
      [
        -24,
        -22
      ],
      [
        0,
        -22
      ],
      [
        -75,
        -32
      ],
      [
        38,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -50,
        -65
      ],
      [
        -74,
        -55
      ],
      [
        -25,
        11
      ],
      [
        0,
        22
      ],
      [
        87,
        108
      ],
      [
        -62,
        33
      ],
      [
        -38,
        -11
      ],
      [
        0,
        22
      ],
      [
        25,
        32
      ],
      [
        -37,
        22
      ],
      [
        -37,
        0
      ],
      [
        -12,
        -33
      ],
      [
        24,
        -21
      ],
      [
        13,
        -33
      ],
      [
        -37,
        -65
      ],
      [
        -25,
        11
      ],
      [
        -50,
        76
      ],
      [
        -25,
        97
      ],
      [
        -49,
        87
      ],
      [
        12,
        65
      ],
      [
        50,
        76
      ],
      [
        49,
        11
      ],
      [
        38,
        33
      ],
      [
        49,
        10
      ],
      [
        37,
        -10
      ],
      [
        13,
        -33
      ],
      [
        -13,
        -22
      ],
      [
        25,
        -10
      ],
      [
        50,
        -109
      ],
      [
        12,
        11
      ],
      [
        -12,
        43
      ],
      [
        0,
        130
      ],
      [
        37,
        -10
      ],
      [
        0,
        21
      ],
      [
        -62,
        55
      ],
      [
        -13,
        43
      ],
      [
        38,
        32
      ],
      [
        37,
        0
      ],
      [
        49,
        -75
      ],
      [
        37,
        -11
      ],
      [
        38,
        43
      ],
      [
        37,
        -11
      ],
      [
        25,
        54
      ],
      [
        0,
        55
      ],
      [
        74,
        -22
      ],
      [
        37,
        -22
      ],
      [
        -25,
        -43
      ]
    ],
    [
      [
        15224,
        92596
      ],
      [
        50,
        -65
      ],
      [
        -13,
        -54
      ],
      [
        13,
        -33
      ],
      [
        74,
        76
      ],
      [
        74,
        -11
      ],
      [
        75,
        -54
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -87
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        11
      ],
      [
        -37,
        -22
      ],
      [
        25,
        -21
      ],
      [
        99,
        -11
      ],
      [
        25,
        -44
      ],
      [
        12,
        -43
      ],
      [
        -24,
        -65
      ],
      [
        -50,
        22
      ],
      [
        -136,
        97
      ],
      [
        -50,
        -11
      ],
      [
        0,
        -108
      ],
      [
        -25,
        -33
      ],
      [
        -74,
        11
      ],
      [
        -62,
        141
      ],
      [
        -99,
        109
      ],
      [
        -25,
        21
      ],
      [
        -37,
        55
      ],
      [
        13,
        86
      ],
      [
        24,
        0
      ],
      [
        25,
        22
      ],
      [
        25,
        54
      ],
      [
        25,
        -43
      ],
      [
        37,
        0
      ],
      [
        12,
        22
      ],
      [
        37,
        0
      ],
      [
        37,
        32
      ],
      [
        38,
        11
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        15707,
        92585
      ],
      [
        0,
        -11
      ],
      [
        -49,
        0
      ],
      [
        -38,
        22
      ],
      [
        -24,
        44
      ],
      [
        49,
        10
      ],
      [
        37,
        -21
      ],
      [
        25,
        -44
      ]
    ],
    [
      [
        15583,
        92542
      ],
      [
        87,
        -11
      ],
      [
        62,
        0
      ],
      [
        62,
        -87
      ],
      [
        62,
        -130
      ],
      [
        25,
        -97
      ],
      [
        -38,
        21
      ],
      [
        -37,
        98
      ],
      [
        -25,
        32
      ],
      [
        -24,
        66
      ],
      [
        0,
        21
      ],
      [
        -37,
        22
      ],
      [
        0,
        -54
      ],
      [
        12,
        -55
      ],
      [
        62,
        -108
      ],
      [
        49,
        -76
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -33
      ],
      [
        25,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        -62,
        -21
      ],
      [
        -49,
        -98
      ],
      [
        -62,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        54
      ],
      [
        0,
        43
      ],
      [
        12,
        22
      ],
      [
        38,
        119
      ],
      [
        0,
        33
      ],
      [
        -62,
        98
      ],
      [
        -38,
        227
      ],
      [
        -61,
        206
      ],
      [
        12,
        11
      ],
      [
        25,
        -21
      ],
      [
        37,
        -55
      ],
      [
        12,
        -43
      ]
    ],
    [
      [
        9489,
        92672
      ],
      [
        24,
        33
      ],
      [
        50,
        -33
      ],
      [
        25,
        11
      ],
      [
        12,
        -43
      ],
      [
        37,
        0
      ],
      [
        0,
        -44
      ],
      [
        -49,
        -54
      ],
      [
        -50,
        54
      ],
      [
        -25,
        -22
      ],
      [
        13,
        -43
      ],
      [
        -87,
        -22
      ],
      [
        -12,
        33
      ],
      [
        -37,
        -54
      ],
      [
        -38,
        -33
      ],
      [
        -61,
        -11
      ],
      [
        -137,
        55
      ],
      [
        87,
        97
      ],
      [
        50,
        33
      ],
      [
        74,
        -11
      ],
      [
        0,
        43
      ],
      [
        -25,
        44
      ],
      [
        50,
        21
      ],
      [
        49,
        -11
      ],
      [
        50,
        -43
      ]
    ],
    [
      [
        9464,
        92748
      ],
      [
        -37,
        11
      ],
      [
        -13,
        43
      ],
      [
        50,
        33
      ],
      [
        37,
        -11
      ],
      [
        0,
        -22
      ],
      [
        -37,
        -54
      ]
    ],
    [
      [
        6553,
        92802
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -12,
        54
      ],
      [
        50,
        44
      ],
      [
        74,
        32
      ],
      [
        -62,
        -130
      ]
    ],
    [
      [
        12189,
        93583
      ],
      [
        0,
        33
      ],
      [
        74,
        76
      ],
      [
        25,
        -11
      ],
      [
        -49,
        -33
      ],
      [
        -50,
        -65
      ]
    ],
    [
      [
        11000,
        93735
      ],
      [
        -25,
        -22
      ],
      [
        -62,
        11
      ],
      [
        13,
        43
      ],
      [
        49,
        22
      ],
      [
        62,
        -32
      ],
      [
        -37,
        -22
      ]
    ],
    [
      [
        11099,
        93572
      ],
      [
        -49,
        11
      ],
      [
        12,
        54
      ],
      [
        74,
        76
      ],
      [
        50,
        44
      ],
      [
        49,
        54
      ],
      [
        50,
        108
      ],
      [
        25,
        0
      ],
      [
        37,
        -21
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        -112,
        -108
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        -25,
        -44
      ],
      [
        -49,
        -21
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -11
      ]
    ],
    [
      [
        4769,
        93930
      ],
      [
        25,
        -32
      ],
      [
        87,
        10
      ],
      [
        37,
        -43
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -65
      ],
      [
        38,
        -22
      ],
      [
        12,
        -76
      ],
      [
        -62,
        -11
      ],
      [
        -62,
        0
      ],
      [
        -49,
        -21
      ],
      [
        -13,
        -54
      ],
      [
        -25,
        0
      ],
      [
        -24,
        32
      ],
      [
        -25,
        11
      ],
      [
        -99,
        11
      ],
      [
        -124,
        76
      ],
      [
        -50,
        21
      ],
      [
        -62,
        55
      ],
      [
        -49,
        65
      ],
      [
        74,
        21
      ],
      [
        136,
        -10
      ],
      [
        25,
        43
      ],
      [
        99,
        54
      ],
      [
        37,
        -11
      ],
      [
        38,
        22
      ],
      [
        49,
        -11
      ]
    ],
    [
      [
        11991,
        93908
      ],
      [
        -12,
        -21
      ],
      [
        -38,
        21
      ],
      [
        50,
        33
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        11557,
        93974
      ],
      [
        13,
        -11
      ],
      [
        74,
        0
      ],
      [
        12,
        -11
      ],
      [
        -37,
        -33
      ],
      [
        -74,
        -21
      ],
      [
        -62,
        -33
      ],
      [
        -12,
        43
      ],
      [
        -25,
        44
      ],
      [
        49,
        43
      ],
      [
        62,
        -21
      ]
    ],
    [
      [
        11124,
        93974
      ],
      [
        -13,
        -33
      ],
      [
        13,
        -22
      ],
      [
        -25,
        -54
      ],
      [
        0,
        -32
      ],
      [
        -25,
        -33
      ],
      [
        -24,
        33
      ],
      [
        -13,
        43
      ],
      [
        25,
        32
      ],
      [
        12,
        76
      ],
      [
        50,
        -10
      ]
    ],
    [
      [
        9625,
        93919
      ],
      [
        12,
        87
      ],
      [
        25,
        -22
      ],
      [
        -37,
        -65
      ]
    ],
    [
      [
        2490,
        93984
      ],
      [
        74,
        -43
      ],
      [
        50,
        0
      ],
      [
        37,
        -33
      ],
      [
        -37,
        -10
      ],
      [
        -87,
        0
      ],
      [
        -111,
        86
      ],
      [
        -38,
        22
      ],
      [
        13,
        43
      ],
      [
        37,
        22
      ],
      [
        25,
        -65
      ],
      [
        37,
        -22
      ]
    ],
    [
      [
        11025,
        94212
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        11
      ],
      [
        25,
        54
      ],
      [
        37,
        -21
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        2936,
        95969
      ],
      [
        148,
        -32
      ],
      [
        50,
        0
      ],
      [
        74,
        54
      ],
      [
        37,
        11
      ],
      [
        87,
        -11
      ],
      [
        62,
        -33
      ],
      [
        37,
        -87
      ],
      [
        137,
        -32
      ],
      [
        24,
        -33
      ],
      [
        37,
        -21
      ],
      [
        50,
        11
      ],
      [
        25,
        -11
      ],
      [
        74,
        0
      ],
      [
        99,
        -22
      ],
      [
        -12,
        -65
      ],
      [
        -37,
        -22
      ],
      [
        -87,
        11
      ],
      [
        -87,
        -11
      ],
      [
        -74,
        -76
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        109
      ],
      [
        -49,
        32
      ],
      [
        -75,
        11
      ],
      [
        -24,
        22
      ],
      [
        0,
        32
      ],
      [
        -87,
        65
      ],
      [
        -112,
        44
      ],
      [
        -74,
        0
      ],
      [
        -87,
        -54
      ],
      [
        -74,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -50,
        43
      ],
      [
        -12,
        33
      ],
      [
        0,
        65
      ],
      [
        25,
        76
      ],
      [
        37,
        21
      ],
      [
        62,
        -54
      ]
    ],
    [
      [
        17194,
        91121
      ],
      [
        -25,
        -32
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -87
      ],
      [
        37,
        -109
      ],
      [
        0,
        -75
      ],
      [
        -49,
        -98
      ],
      [
        -13,
        -65
      ]
    ],
    [
      [
        16995,
        90427
      ],
      [
        -12,
        11
      ],
      [
        -74,
        11
      ],
      [
        -37,
        87
      ],
      [
        -13,
        76
      ],
      [
        -25,
        54
      ],
      [
        0,
        21
      ],
      [
        25,
        33
      ],
      [
        74,
        33
      ],
      [
        0,
        21
      ],
      [
        -24,
        0
      ],
      [
        -13,
        22
      ],
      [
        0,
        152
      ],
      [
        -12,
        86
      ],
      [
        -74,
        141
      ],
      [
        0,
        22
      ],
      [
        37,
        54
      ],
      [
        -99,
        -43
      ],
      [
        -112,
        -54
      ],
      [
        -49,
        -33
      ],
      [
        -13,
        -21
      ],
      [
        0,
        -55
      ],
      [
        -12,
        -11
      ],
      [
        -13,
        -65
      ],
      [
        -37,
        -65
      ],
      [
        -49,
        22
      ],
      [
        -37,
        98
      ],
      [
        86,
        130
      ],
      [
        50,
        141
      ],
      [
        37,
        0
      ],
      [
        62,
        32
      ],
      [
        -99,
        11
      ],
      [
        -13,
        11
      ],
      [
        -49,
        87
      ],
      [
        -50,
        21
      ],
      [
        -24,
        44
      ],
      [
        -38,
        43
      ],
      [
        0,
        44
      ],
      [
        -49,
        10
      ],
      [
        0,
        76
      ],
      [
        -74,
        33
      ],
      [
        -38,
        43
      ],
      [
        -12,
        44
      ],
      [
        12,
        65
      ],
      [
        -37,
        -11
      ],
      [
        -186,
        76
      ],
      [
        13,
        108
      ],
      [
        -37,
        130
      ],
      [
        -37,
        55
      ],
      [
        12,
        32
      ],
      [
        25,
        0
      ],
      [
        62,
        -32
      ],
      [
        74,
        -55
      ],
      [
        12,
        11
      ],
      [
        -111,
        98
      ],
      [
        -37,
        65
      ],
      [
        12,
        32
      ],
      [
        99,
        -10
      ],
      [
        13,
        10
      ],
      [
        -112,
        33
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -13,
        11
      ],
      [
        -49,
        86
      ],
      [
        -50,
        44
      ],
      [
        -12,
        86
      ],
      [
        12,
        55
      ],
      [
        -62,
        -44
      ],
      [
        -37,
        44
      ],
      [
        -49,
        43
      ],
      [
        -62,
        11
      ],
      [
        -38,
        43
      ],
      [
        -61,
        120
      ],
      [
        -13,
        76
      ],
      [
        -37,
        21
      ],
      [
        -12,
        33
      ],
      [
        -38,
        141
      ],
      [
        -37,
        97
      ],
      [
        -12,
        55
      ],
      [
        -37,
        -11
      ],
      [
        25,
        -33
      ],
      [
        0,
        -21
      ],
      [
        -38,
        -11
      ],
      [
        50,
        -65
      ],
      [
        12,
        -120
      ],
      [
        50,
        -141
      ],
      [
        0,
        -54
      ],
      [
        49,
        -152
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -33
      ],
      [
        -49,
        22
      ],
      [
        -25,
        22
      ],
      [
        -25,
        54
      ],
      [
        -49,
        22
      ],
      [
        -112,
        -11
      ],
      [
        0,
        43
      ],
      [
        12,
        98
      ],
      [
        -61,
        97
      ],
      [
        12,
        55
      ],
      [
        -12,
        10
      ],
      [
        -13,
        76
      ],
      [
        -25,
        -32
      ],
      [
        13,
        -44
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -10
      ],
      [
        -25,
        10
      ],
      [
        -25,
        33
      ],
      [
        -37,
        22
      ],
      [
        -25,
        43
      ],
      [
        -87,
        33
      ],
      [
        -62,
        32
      ],
      [
        13,
        -43
      ],
      [
        0,
        -55
      ],
      [
        25,
        0
      ],
      [
        99,
        -43
      ],
      [
        12,
        -43
      ],
      [
        50,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        62,
        0
      ],
      [
        25,
        -11
      ],
      [
        49,
        -65
      ],
      [
        13,
        -33
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -112,
        -11
      ],
      [
        -49,
        -54
      ],
      [
        -37,
        11
      ],
      [
        -50,
        43
      ],
      [
        -74,
        44
      ],
      [
        -161,
        108
      ],
      [
        -13,
        33
      ],
      [
        -37,
        21
      ],
      [
        -62,
        76
      ],
      [
        -62,
        98
      ],
      [
        -111,
        98
      ],
      [
        -62,
        10
      ],
      [
        12,
        33
      ],
      [
        -74,
        11
      ],
      [
        -62,
        32
      ],
      [
        -149,
        87
      ],
      [
        -136,
        87
      ],
      [
        -25,
        22
      ],
      [
        50,
        21
      ],
      [
        49,
        76
      ],
      [
        -24,
        87
      ],
      [
        0,
        43
      ],
      [
        24,
        33
      ],
      [
        25,
        0
      ],
      [
        50,
        -76
      ],
      [
        -13,
        -65
      ],
      [
        13,
        -76
      ],
      [
        12,
        0
      ],
      [
        0,
        108
      ],
      [
        25,
        33
      ],
      [
        49,
        -11
      ],
      [
        25,
        11
      ],
      [
        -87,
        32
      ],
      [
        -74,
        76
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -21
      ],
      [
        -74,
        -98
      ],
      [
        -136,
        -65
      ],
      [
        -149,
        0
      ],
      [
        -62,
        22
      ],
      [
        -161,
        76
      ],
      [
        -37,
        21
      ],
      [
        49,
        44
      ],
      [
        -12,
        65
      ],
      [
        -37,
        21
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -22
      ],
      [
        -74,
        -32
      ],
      [
        -149,
        43
      ],
      [
        -148,
        33
      ],
      [
        -136,
        11
      ],
      [
        -199,
        -33
      ],
      [
        -99,
        -22
      ],
      [
        -124,
        0
      ],
      [
        0,
        22
      ],
      [
        25,
        22
      ],
      [
        -37,
        43
      ],
      [
        -50,
        22
      ],
      [
        -99,
        22
      ],
      [
        -12,
        21
      ],
      [
        -62,
        22
      ],
      [
        -25,
        32
      ],
      [
        13,
        76
      ],
      [
        24,
        44
      ],
      [
        25,
        76
      ],
      [
        -49,
        -33
      ],
      [
        -75,
        -97
      ],
      [
        -49,
        -44
      ],
      [
        -50,
        11
      ],
      [
        -62,
        33
      ],
      [
        -49,
        10
      ],
      [
        -50,
        0
      ],
      [
        -12,
        11
      ],
      [
        49,
        54
      ],
      [
        25,
        55
      ],
      [
        -161,
        0
      ],
      [
        -12,
        54
      ],
      [
        -62,
        0
      ],
      [
        -50,
        -22
      ],
      [
        -25,
        11
      ],
      [
        62,
        54
      ],
      [
        -74,
        33
      ],
      [
        -12,
        21
      ],
      [
        0,
        55
      ],
      [
        12,
        43
      ],
      [
        112,
        33
      ],
      [
        -38,
        21
      ],
      [
        -62,
        -11
      ],
      [
        -49,
        -32
      ],
      [
        -50,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -49,
        0
      ],
      [
        -25,
        -11
      ],
      [
        -37,
        -44
      ],
      [
        -25,
        22
      ],
      [
        -49,
        22
      ],
      [
        -25,
        -44
      ],
      [
        -50,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -37,
        54
      ],
      [
        12,
        87
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -33
      ],
      [
        62,
        0
      ],
      [
        -37,
        -65
      ],
      [
        -13,
        -54
      ],
      [
        -24,
        -11
      ],
      [
        -50,
        0
      ],
      [
        0,
        -22
      ],
      [
        50,
        -43
      ],
      [
        49,
        -11
      ],
      [
        -12,
        -108
      ],
      [
        62,
        21
      ],
      [
        25,
        0
      ],
      [
        24,
        -32
      ],
      [
        0,
        -43
      ],
      [
        -74,
        -33
      ],
      [
        -12,
        -76
      ],
      [
        12,
        -65
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        -97
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -87,
        -11
      ],
      [
        -62,
        22
      ],
      [
        -37,
        32
      ],
      [
        -50,
        -21
      ],
      [
        -37,
        65
      ],
      [
        -12,
        0
      ],
      [
        0,
        -65
      ],
      [
        -50,
        -66
      ],
      [
        -37,
        0
      ],
      [
        -12,
        22
      ],
      [
        -37,
        -43
      ],
      [
        12,
        -65
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        32
      ],
      [
        -25,
        -10
      ],
      [
        25,
        -33
      ],
      [
        0,
        -22
      ],
      [
        -87,
        -76
      ],
      [
        -49,
        11
      ],
      [
        -50,
        -32
      ],
      [
        -37,
        21
      ],
      [
        -25,
        -86
      ],
      [
        -62,
        -55
      ],
      [
        -24,
        -54
      ],
      [
        -87,
        33
      ],
      [
        -13,
        -11
      ],
      [
        13,
        -33
      ],
      [
        -62,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        -32
      ],
      [
        -49,
        0
      ],
      [
        -50,
        54
      ],
      [
        -25,
        11
      ],
      [
        25,
        65
      ],
      [
        74,
        43
      ],
      [
        62,
        11
      ],
      [
        38,
        22
      ],
      [
        49,
        43
      ],
      [
        25,
        33
      ],
      [
        49,
        87
      ],
      [
        -24,
        10
      ],
      [
        -99,
        -76
      ],
      [
        -38,
        -10
      ],
      [
        -111,
        43
      ],
      [
        -12,
        43
      ],
      [
        24,
        87
      ],
      [
        62,
        109
      ],
      [
        50,
        65
      ],
      [
        25,
        43
      ],
      [
        24,
        119
      ],
      [
        0,
        55
      ],
      [
        -12,
        65
      ],
      [
        0,
        43
      ],
      [
        12,
        11
      ],
      [
        124,
        65
      ],
      [
        62,
        43
      ],
      [
        112,
        65
      ],
      [
        37,
        0
      ],
      [
        49,
        -43
      ],
      [
        75,
        -11
      ],
      [
        49,
        22
      ],
      [
        75,
        -11
      ],
      [
        161,
        -43
      ],
      [
        37,
        0
      ],
      [
        -25,
        32
      ],
      [
        -161,
        33
      ],
      [
        -124,
        86
      ],
      [
        -37,
        33
      ],
      [
        62,
        33
      ],
      [
        12,
        54
      ],
      [
        87,
        65
      ],
      [
        87,
        43
      ],
      [
        -38,
        11
      ],
      [
        -86,
        -22
      ],
      [
        -37,
        -32
      ],
      [
        -50,
        -76
      ],
      [
        -50,
        -22
      ],
      [
        -123,
        0
      ],
      [
        -25,
        22
      ],
      [
        -25,
        0
      ],
      [
        -124,
        -65
      ],
      [
        -62,
        -65
      ],
      [
        -49,
        -33
      ],
      [
        -62,
        -11
      ],
      [
        -50,
        -21
      ],
      [
        -62,
        -76
      ],
      [
        13,
        -65
      ],
      [
        -87,
        -54
      ],
      [
        -87,
        -87
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -22
      ],
      [
        -87,
        -76
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -37,
        33
      ],
      [
        -37,
        0
      ],
      [
        124,
        -109
      ],
      [
        12,
        -43
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        -44
      ],
      [
        -37,
        -22
      ],
      [
        -87,
        -10
      ],
      [
        -25,
        -22
      ],
      [
        62,
        -33
      ],
      [
        -25,
        -54
      ],
      [
        -49,
        -22
      ],
      [
        -50,
        0
      ],
      [
        0,
        44
      ],
      [
        -37,
        -11
      ],
      [
        -62,
        -43
      ],
      [
        13,
        -33
      ],
      [
        -38,
        -54
      ],
      [
        -24,
        -22
      ],
      [
        -100,
        -65
      ],
      [
        13,
        -22
      ],
      [
        -37,
        -108
      ],
      [
        12,
        -22
      ],
      [
        74,
        -32
      ],
      [
        50,
        0
      ],
      [
        124,
        -76
      ],
      [
        25,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -38,
        -65
      ],
      [
        -86,
        -76
      ],
      [
        -62,
        -22
      ],
      [
        -50,
        -65
      ],
      [
        -25,
        -76
      ],
      [
        -61,
        -32
      ],
      [
        24,
        -11
      ],
      [
        -12,
        -33
      ],
      [
        0,
        -54
      ],
      [
        -12,
        -11
      ],
      [
        -50,
        0
      ],
      [
        -62,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -136,
        -22
      ],
      [
        -50,
        -87
      ],
      [
        -99,
        -65
      ],
      [
        -62,
        -21
      ],
      [
        -12,
        -44
      ],
      [
        -50,
        -65
      ],
      [
        -74,
        -11
      ],
      [
        -12,
        -10
      ],
      [
        0,
        -55
      ],
      [
        -38,
        11
      ],
      [
        -37,
        -11
      ],
      [
        -62,
        -54
      ],
      [
        -12,
        -32
      ],
      [
        25,
        -44
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -65
      ],
      [
        -37,
        -21
      ],
      [
        -13,
        -33
      ],
      [
        -62,
        0
      ],
      [
        -24,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -12,
        -22
      ],
      [
        -62,
        -54
      ],
      [
        -38,
        -11
      ],
      [
        -24,
        11
      ],
      [
        -50,
        -33
      ],
      [
        -12,
        -54
      ],
      [
        -25,
        -32
      ],
      [
        -99,
        10
      ],
      [
        -74,
        -54
      ],
      [
        37,
        -11
      ],
      [
        0,
        -21
      ],
      [
        -50,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -74,
        -22
      ],
      [
        -37,
        -65
      ],
      [
        49,
        -21
      ],
      [
        38,
        -66
      ],
      [
        -50,
        -54
      ],
      [
        -37,
        -21
      ],
      [
        -13,
        65
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        -76
      ],
      [
        -25,
        -33
      ],
      [
        -223,
        -86
      ],
      [
        -37,
        -22
      ],
      [
        0,
        -44
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -21
      ],
      [
        0,
        130
      ],
      [
        -37,
        11
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        0
      ],
      [
        -99,
        -87
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        -54
      ],
      [
        -25,
        -11
      ],
      [
        -25,
        11
      ],
      [
        -24,
        -11
      ],
      [
        -25,
        -32
      ],
      [
        -50,
        21
      ],
      [
        -37,
        -43
      ],
      [
        -62,
        -32
      ],
      [
        -99,
        -11
      ],
      [
        0,
        54
      ],
      [
        12,
        32
      ],
      [
        25,
        22
      ],
      [
        50,
        0
      ],
      [
        -13,
        22
      ],
      [
        -86,
        22
      ],
      [
        -50,
        -33
      ],
      [
        -12,
        -22
      ],
      [
        -13,
        -86
      ],
      [
        -86,
        -120
      ],
      [
        -37,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -37,
        -43
      ],
      [
        -38,
        -11
      ],
      [
        -24,
        21
      ],
      [
        12,
        44
      ],
      [
        -50,
        54
      ],
      [
        -24,
        0
      ],
      [
        0,
        -130
      ],
      [
        -13,
        -22
      ],
      [
        -49,
        -32
      ],
      [
        -25,
        10
      ],
      [
        -37,
        55
      ],
      [
        -50,
        11
      ],
      [
        13,
        -55
      ],
      [
        -13,
        -43
      ],
      [
        -25,
        -33
      ],
      [
        -49,
        -10
      ],
      [
        0,
        21
      ],
      [
        25,
        87
      ],
      [
        -13,
        54
      ],
      [
        62,
        54
      ],
      [
        75,
        0
      ],
      [
        24,
        44
      ],
      [
        62,
        54
      ],
      [
        50,
        65
      ],
      [
        124,
        174
      ],
      [
        74,
        65
      ],
      [
        248,
        119
      ],
      [
        12,
        -43
      ],
      [
        112,
        10
      ],
      [
        -13,
        -21
      ],
      [
        -37,
        -11
      ],
      [
        0,
        -22
      ],
      [
        50,
        -65
      ],
      [
        37,
        -11
      ],
      [
        0,
        55
      ],
      [
        49,
        21
      ],
      [
        38,
        -32
      ],
      [
        49,
        -22
      ],
      [
        25,
        11
      ],
      [
        -13,
        32
      ],
      [
        -74,
        65
      ],
      [
        25,
        109
      ],
      [
        62,
        108
      ],
      [
        49,
        55
      ],
      [
        38,
        21
      ],
      [
        86,
        76
      ],
      [
        174,
        76
      ],
      [
        37,
        54
      ],
      [
        87,
        76
      ],
      [
        12,
        -43
      ],
      [
        62,
        -22
      ],
      [
        12,
        11
      ],
      [
        0,
        152
      ],
      [
        62,
        97
      ],
      [
        87,
        87
      ],
      [
        62,
        44
      ],
      [
        49,
        65
      ],
      [
        62,
        21
      ],
      [
        25,
        -32
      ],
      [
        37,
        -11
      ],
      [
        25,
        22
      ],
      [
        -37,
        21
      ],
      [
        -12,
        33
      ],
      [
        -25,
        22
      ],
      [
        0,
        65
      ],
      [
        25,
        97
      ],
      [
        0,
        98
      ],
      [
        24,
        54
      ],
      [
        37,
        22
      ],
      [
        87,
        11
      ],
      [
        -49,
        32
      ],
      [
        -50,
        11
      ],
      [
        -12,
        54
      ],
      [
        0,
        44
      ],
      [
        24,
        54
      ],
      [
        75,
        87
      ],
      [
        87,
        54
      ],
      [
        -25,
        32
      ],
      [
        37,
        120
      ],
      [
        -12,
        11
      ],
      [
        -62,
        -66
      ],
      [
        -298,
        -151
      ],
      [
        -62,
        -22
      ],
      [
        -37,
        22
      ],
      [
        -25,
        65
      ],
      [
        -24,
        21
      ],
      [
        -13,
        44
      ],
      [
        0,
        54
      ],
      [
        25,
        43
      ],
      [
        37,
        0
      ],
      [
        25,
        22
      ],
      [
        -62,
        33
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -33
      ],
      [
        -37,
        11
      ],
      [
        0,
        -33
      ],
      [
        -25,
        -65
      ],
      [
        0,
        -54
      ],
      [
        25,
        -119
      ],
      [
        0,
        -55
      ],
      [
        -62,
        -21
      ],
      [
        -49,
        43
      ],
      [
        -87,
        163
      ],
      [
        -37,
        43
      ],
      [
        -75,
        65
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -75,
        54
      ],
      [
        -74,
        98
      ],
      [
        -99,
        -65
      ],
      [
        -62,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -99,
        -44
      ],
      [
        -37,
        -32
      ],
      [
        -13,
        -44
      ],
      [
        -136,
        -43
      ],
      [
        -136,
        22
      ],
      [
        99,
        43
      ],
      [
        49,
        54
      ],
      [
        -24,
        98
      ],
      [
        0,
        43
      ],
      [
        49,
        54
      ],
      [
        -49,
        0
      ],
      [
        -38,
        -21
      ],
      [
        -24,
        43
      ],
      [
        -13,
        87
      ],
      [
        37,
        54
      ],
      [
        25,
        87
      ],
      [
        0,
        54
      ],
      [
        -25,
        76
      ],
      [
        -74,
        163
      ],
      [
        -37,
        119
      ],
      [
        -62,
        76
      ],
      [
        37,
        108
      ],
      [
        62,
        98
      ],
      [
        62,
        43
      ],
      [
        -62,
        0
      ],
      [
        -49,
        -65
      ],
      [
        -112,
        -184
      ],
      [
        25,
        -54
      ],
      [
        12,
        -55
      ],
      [
        -25,
        -75
      ],
      [
        -61,
        0
      ],
      [
        -50,
        -44
      ],
      [
        -112,
        -54
      ],
      [
        -161,
        -22
      ],
      [
        -86,
        0
      ],
      [
        -75,
        54
      ],
      [
        0,
        66
      ],
      [
        -111,
        97
      ],
      [
        -62,
        98
      ],
      [
        -50,
        0
      ],
      [
        -49,
        21
      ],
      [
        -50,
        44
      ],
      [
        13,
        54
      ],
      [
        -25,
        22
      ],
      [
        -37,
        -11
      ],
      [
        -50,
        11
      ],
      [
        124,
        130
      ],
      [
        37,
        76
      ],
      [
        37,
        21
      ],
      [
        100,
        -54
      ],
      [
        49,
        -11
      ],
      [
        37,
        -43
      ],
      [
        -37,
        -87
      ],
      [
        124,
        109
      ],
      [
        37,
        -11
      ],
      [
        50,
        -98
      ],
      [
        74,
        44
      ],
      [
        37,
        65
      ],
      [
        -74,
        43
      ],
      [
        -99,
        11
      ],
      [
        25,
        22
      ],
      [
        61,
        0
      ],
      [
        25,
        10
      ],
      [
        -49,
        44
      ],
      [
        -87,
        -65
      ],
      [
        -149,
        0
      ],
      [
        -111,
        43
      ],
      [
        -112,
        -11
      ],
      [
        -37,
        33
      ],
      [
        112,
        76
      ],
      [
        0,
        11
      ],
      [
        -75,
        -11
      ],
      [
        -49,
        43
      ],
      [
        -50,
        11
      ],
      [
        0,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -37,
        11
      ],
      [
        -37,
        119
      ],
      [
        -62,
        22
      ],
      [
        -13,
        43
      ],
      [
        38,
        54
      ],
      [
        -13,
        33
      ],
      [
        -49,
        11
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        22
      ],
      [
        0,
        65
      ],
      [
        25,
        0
      ],
      [
        86,
        22
      ],
      [
        13,
        10
      ],
      [
        -75,
        33
      ],
      [
        -24,
        32
      ],
      [
        37,
        22
      ],
      [
        49,
        0
      ],
      [
        75,
        22
      ],
      [
        -25,
        32
      ],
      [
        -25,
        55
      ],
      [
        12,
        54
      ],
      [
        186,
        238
      ],
      [
        62,
        33
      ],
      [
        74,
        -11
      ],
      [
        -24,
        43
      ],
      [
        24,
        22
      ],
      [
        -12,
        33
      ],
      [
        -12,
        86
      ],
      [
        37,
        98
      ],
      [
        25,
        33
      ],
      [
        99,
        10
      ],
      [
        -50,
        55
      ],
      [
        25,
        43
      ],
      [
        124,
        43
      ],
      [
        49,
        -10
      ],
      [
        75,
        -33
      ],
      [
        49,
        -43
      ],
      [
        37,
        -11
      ],
      [
        50,
        -33
      ],
      [
        99,
        22
      ],
      [
        37,
        22
      ],
      [
        50,
        54
      ],
      [
        62,
        32
      ],
      [
        86,
        120
      ],
      [
        38,
        43
      ],
      [
        49,
        11
      ],
      [
        25,
        -43
      ],
      [
        25,
        -11
      ],
      [
        161,
        11
      ],
      [
        86,
        21
      ],
      [
        50,
        33
      ],
      [
        99,
        108
      ],
      [
        12,
        54
      ],
      [
        -12,
        76
      ],
      [
        -25,
        55
      ],
      [
        -24,
        141
      ],
      [
        -87,
        86
      ],
      [
        -50,
        33
      ],
      [
        -37,
        0
      ],
      [
        25,
        54
      ],
      [
        74,
        -11
      ],
      [
        50,
        11
      ],
      [
        37,
        33
      ],
      [
        37,
        65
      ],
      [
        -25,
        65
      ],
      [
        -74,
        87
      ],
      [
        -25,
        0
      ],
      [
        -99,
        -87
      ],
      [
        -49,
        0
      ],
      [
        -50,
        22
      ],
      [
        -37,
        -55
      ],
      [
        -99,
        -32
      ],
      [
        -62,
        -44
      ],
      [
        -99,
        -97
      ],
      [
        -25,
        -54
      ],
      [
        -37,
        0
      ],
      [
        -25,
        86
      ],
      [
        -112,
        87
      ],
      [
        -37,
        -32
      ],
      [
        50,
        -44
      ],
      [
        37,
        0
      ],
      [
        -25,
        -65
      ],
      [
        -124,
        76
      ],
      [
        -74,
        22
      ],
      [
        -211,
        0
      ],
      [
        -123,
        -44
      ],
      [
        -50,
        0
      ],
      [
        -25,
        -32
      ],
      [
        -86,
        0
      ],
      [
        -100,
        32
      ],
      [
        -247,
        44
      ],
      [
        -62,
        32
      ],
      [
        -50,
        65
      ],
      [
        0,
        44
      ],
      [
        25,
        11
      ],
      [
        0,
        65
      ],
      [
        -50,
        10
      ],
      [
        -99,
        98
      ],
      [
        25,
        22
      ],
      [
        87,
        11
      ],
      [
        25,
        54
      ],
      [
        62,
        21
      ],
      [
        24,
        22
      ],
      [
        -148,
        33
      ],
      [
        -13,
        -11
      ],
      [
        -260,
        54
      ],
      [
        -198,
        87
      ],
      [
        -37,
        54
      ],
      [
        37,
        43
      ],
      [
        25,
        -32
      ],
      [
        111,
        54
      ],
      [
        62,
        65
      ],
      [
        124,
        11
      ],
      [
        62,
        43
      ],
      [
        50,
        66
      ],
      [
        111,
        54
      ],
      [
        62,
        21
      ],
      [
        62,
        -32
      ],
      [
        111,
        -11
      ],
      [
        62,
        33
      ],
      [
        -99,
        54
      ],
      [
        25,
        43
      ],
      [
        111,
        54
      ],
      [
        87,
        22
      ],
      [
        37,
        0
      ],
      [
        137,
        76
      ],
      [
        74,
        22
      ],
      [
        136,
        11
      ],
      [
        62,
        -22
      ],
      [
        37,
        -33
      ],
      [
        0,
        -21
      ],
      [
        -37,
        -65
      ],
      [
        0,
        -65
      ],
      [
        -49,
        -44
      ],
      [
        111,
        -76
      ],
      [
        186,
        -11
      ],
      [
        99,
        22
      ],
      [
        50,
        -32
      ],
      [
        173,
        10
      ],
      [
        99,
        -21
      ],
      [
        50,
        11
      ],
      [
        86,
        119
      ],
      [
        37,
        22
      ],
      [
        87,
        -44
      ],
      [
        37,
        54
      ],
      [
        -12,
        22
      ],
      [
        -149,
        43
      ],
      [
        -99,
        -21
      ],
      [
        -25,
        32
      ],
      [
        13,
        44
      ],
      [
        -112,
        130
      ],
      [
        -37,
        21
      ],
      [
        -62,
        0
      ],
      [
        -25,
        44
      ],
      [
        -12,
        54
      ],
      [
        74,
        33
      ],
      [
        38,
        -11
      ],
      [
        49,
        -76
      ],
      [
        37,
        -11
      ],
      [
        -12,
        -76
      ],
      [
        49,
        -65
      ],
      [
        112,
        -65
      ],
      [
        87,
        22
      ],
      [
        62,
        0
      ],
      [
        37,
        -11
      ],
      [
        86,
        -54
      ],
      [
        50,
        -11
      ],
      [
        149,
        32
      ],
      [
        0,
        54
      ],
      [
        -13,
        44
      ],
      [
        -37,
        22
      ],
      [
        -99,
        0
      ],
      [
        -74,
        32
      ],
      [
        -62,
        -11
      ],
      [
        -124,
        -54
      ],
      [
        -62,
        22
      ],
      [
        -37,
        32
      ],
      [
        -62,
        33
      ],
      [
        0,
        65
      ],
      [
        49,
        76
      ],
      [
        38,
        32
      ],
      [
        -38,
        33
      ],
      [
        -86,
        11
      ],
      [
        -137,
        -11
      ],
      [
        -12,
        43
      ],
      [
        -62,
        -54
      ],
      [
        -62,
        11
      ],
      [
        -74,
        0
      ],
      [
        -186,
        43
      ],
      [
        -99,
        109
      ],
      [
        -50,
        130
      ],
      [
        -62,
        76
      ],
      [
        -433,
        282
      ],
      [
        -198,
        65
      ],
      [
        -87,
        76
      ],
      [
        -62,
        21
      ],
      [
        -62,
        0
      ],
      [
        -62,
        33
      ],
      [
        37,
        11
      ],
      [
        37,
        -11
      ],
      [
        62,
        32
      ],
      [
        62,
        239
      ],
      [
        0,
        54
      ],
      [
        236,
        -11
      ],
      [
        161,
        11
      ],
      [
        49,
        11
      ],
      [
        211,
        22
      ],
      [
        49,
        11
      ],
      [
        100,
        54
      ],
      [
        111,
        76
      ],
      [
        124,
        141
      ],
      [
        25,
        141
      ],
      [
        49,
        87
      ],
      [
        211,
        216
      ],
      [
        87,
        76
      ],
      [
        37,
        44
      ],
      [
        37,
        21
      ],
      [
        74,
        -54
      ],
      [
        223,
        44
      ],
      [
        124,
        65
      ],
      [
        0,
        21
      ],
      [
        186,
        87
      ],
      [
        49,
        -11
      ],
      [
        -49,
        -65
      ],
      [
        37,
        -11
      ],
      [
        -37,
        -76
      ],
      [
        74,
        0
      ],
      [
        25,
        109
      ],
      [
        25,
        22
      ],
      [
        -75,
        65
      ],
      [
        -37,
        0
      ],
      [
        136,
        97
      ],
      [
        124,
        54
      ],
      [
        25,
        0
      ],
      [
        25,
        -32
      ],
      [
        -62,
        -33
      ],
      [
        37,
        -21
      ],
      [
        87,
        32
      ],
      [
        124,
        0
      ],
      [
        49,
        33
      ],
      [
        174,
        0
      ],
      [
        136,
        54
      ],
      [
        136,
        98
      ],
      [
        75,
        86
      ],
      [
        61,
        55
      ],
      [
        75,
        10
      ],
      [
        37,
        -21
      ],
      [
        223,
        -65
      ],
      [
        62,
        -11
      ],
      [
        25,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -50,
        -33
      ],
      [
        -124,
        -43
      ],
      [
        62,
        -54
      ],
      [
        38,
        -11
      ],
      [
        99,
        43
      ],
      [
        86,
        76
      ],
      [
        25,
        44
      ],
      [
        99,
        0
      ],
      [
        50,
        -22
      ],
      [
        49,
        -43
      ],
      [
        -37,
        -55
      ],
      [
        62,
        -32
      ],
      [
        74,
        -11
      ],
      [
        62,
        -22
      ],
      [
        99,
        54
      ],
      [
        75,
        11
      ],
      [
        74,
        0
      ],
      [
        87,
        22
      ],
      [
        148,
        -33
      ],
      [
        112,
        0
      ],
      [
        62,
        -21
      ],
      [
        25,
        -22
      ],
      [
        -75,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        25,
        -21
      ],
      [
        49,
        0
      ],
      [
        0,
        -33
      ],
      [
        25,
        -11
      ],
      [
        149,
        0
      ],
      [
        -62,
        -65
      ],
      [
        247,
        -21
      ],
      [
        25,
        21
      ],
      [
        62,
        11
      ],
      [
        99,
        33
      ],
      [
        137,
        -54
      ],
      [
        49,
        10
      ],
      [
        87,
        44
      ],
      [
        111,
        0
      ],
      [
        50,
        -22
      ],
      [
        49,
        11
      ],
      [
        199,
        -54
      ],
      [
        74,
        -65
      ],
      [
        37,
        0
      ],
      [
        37,
        32
      ],
      [
        37,
        0
      ],
      [
        38,
        -32
      ],
      [
        62,
        0
      ],
      [
        24,
        -44
      ],
      [
        25,
        -11
      ],
      [
        223,
        -32
      ],
      [
        112,
        11
      ],
      [
        161,
        0
      ],
      [
        74,
        -22
      ],
      [
        87,
        0
      ],
      [
        123,
        -65
      ],
      [
        87,
        -22
      ],
      [
        198,
        -21
      ],
      [
        75,
        32
      ],
      [
        124,
        11
      ],
      [
        99,
        32
      ],
      [
        136,
        -10
      ],
      [
        49,
        21
      ],
      [
        174,
        -54
      ],
      [
        99,
        -54
      ],
      [
        50,
        -44
      ],
      [
        198,
        -65
      ],
      [
        62,
        -32
      ],
      [
        37,
        -44
      ],
      [
        111,
        11
      ],
      [
        37,
        -11
      ]
    ],
    [
      [
        40878,
        64431
      ],
      [
        -12,
        -11
      ],
      [
        -25,
        44
      ],
      [
        0,
        54
      ],
      [
        25,
        22
      ],
      [
        12,
        21
      ],
      [
        13,
        0
      ],
      [
        0,
        -97
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        40940,
        61752
      ],
      [
        -25,
        -10
      ],
      [
        0,
        76
      ],
      [
        38,
        54
      ],
      [
        12,
        11
      ],
      [
        25,
        -55
      ],
      [
        0,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        -25,
        -22
      ]
    ],
    [
      [
        41002,
        61926
      ],
      [
        -49,
        -22
      ],
      [
        12,
        44
      ],
      [
        49,
        21
      ],
      [
        0,
        -21
      ],
      [
        -12,
        -22
      ]
    ],
    [
      [
        39491,
        63021
      ],
      [
        -25,
        -10
      ],
      [
        -37,
        10
      ],
      [
        -12,
        22
      ],
      [
        12,
        22
      ],
      [
        25,
        0
      ],
      [
        24,
        -22
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        39962,
        63162
      ],
      [
        0,
        -97
      ],
      [
        -25,
        -54
      ],
      [
        -50,
        0
      ],
      [
        -12,
        10
      ],
      [
        -25,
        44
      ],
      [
        -25,
        -11
      ],
      [
        -49,
        11
      ],
      [
        -13,
        11
      ],
      [
        25,
        43
      ],
      [
        25,
        22
      ],
      [
        12,
        0
      ],
      [
        13,
        -33
      ],
      [
        24,
        -22
      ],
      [
        38,
        0
      ],
      [
        0,
        44
      ],
      [
        37,
        65
      ],
      [
        25,
        -33
      ]
    ],
    [
      [
        37385,
        63629
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -25,
        -22
      ],
      [
        -124,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        0,
        -54
      ],
      [
        50,
        -184
      ],
      [
        12,
        -33
      ],
      [
        50,
        -76
      ],
      [
        -25,
        -11
      ],
      [
        12,
        -108
      ],
      [
        25,
        -65
      ],
      [
        0,
        -43
      ],
      [
        -12,
        -131
      ],
      [
        -50,
        -86
      ],
      [
        -37,
        -87
      ],
      [
        -25,
        -33
      ],
      [
        -50,
        -184
      ],
      [
        38,
        -108
      ],
      [
        12,
        -55
      ],
      [
        37,
        -86
      ],
      [
        25,
        -22
      ],
      [
        12,
        -33
      ],
      [
        -12,
        -54
      ],
      [
        12,
        -76
      ],
      [
        25,
        -32
      ],
      [
        25,
        -22
      ],
      [
        25,
        0
      ],
      [
        86,
        54
      ],
      [
        25,
        54
      ],
      [
        50,
        87
      ],
      [
        0,
        98
      ],
      [
        12,
        119
      ],
      [
        -12,
        87
      ],
      [
        -50,
        108
      ],
      [
        -12,
        87
      ],
      [
        -50,
        65
      ],
      [
        -25,
        130
      ],
      [
        -12,
        44
      ],
      [
        0,
        54
      ],
      [
        -12,
        97
      ],
      [
        24,
        33
      ],
      [
        0,
        87
      ],
      [
        75,
        21
      ],
      [
        148,
        131
      ],
      [
        100,
        32
      ],
      [
        99,
        65
      ],
      [
        24,
        44
      ],
      [
        25,
        54
      ],
      [
        13,
        0
      ],
      [
        61,
        -54
      ],
      [
        25,
        21
      ],
      [
        13,
        44
      ],
      [
        -13,
        86
      ],
      [
        -37,
        0
      ],
      [
        -99,
        -32
      ],
      [
        0,
        65
      ],
      [
        -25,
        98
      ],
      [
        13,
        75
      ],
      [
        12,
        55
      ],
      [
        25,
        21
      ],
      [
        49,
        33
      ],
      [
        25,
        -43
      ],
      [
        25,
        -33
      ],
      [
        0,
        -43
      ],
      [
        25,
        -196
      ],
      [
        24,
        -76
      ],
      [
        25,
        -43
      ],
      [
        25,
        0
      ],
      [
        12,
        11
      ],
      [
        99,
        11
      ],
      [
        62,
        -44
      ],
      [
        75,
        -10
      ],
      [
        74,
        -76
      ],
      [
        74,
        -98
      ],
      [
        25,
        -65
      ],
      [
        0,
        -65
      ],
      [
        25,
        -43
      ],
      [
        -25,
        -44
      ],
      [
        13,
        -76
      ],
      [
        24,
        -76
      ],
      [
        25,
        -43
      ],
      [
        99,
        -22
      ],
      [
        99,
        33
      ],
      [
        149,
        32
      ],
      [
        49,
        22
      ],
      [
        261,
        22
      ],
      [
        49,
        -44
      ],
      [
        0,
        -54
      ],
      [
        87,
        -141
      ],
      [
        62,
        -22
      ],
      [
        62,
        -43
      ],
      [
        62,
        -22
      ],
      [
        62,
        -32
      ],
      [
        62,
        21
      ],
      [
        37,
        0
      ],
      [
        223,
        228
      ],
      [
        124,
        -11
      ],
      [
        24,
        11
      ],
      [
        13,
        22
      ],
      [
        -50,
        32
      ],
      [
        -99,
        22
      ],
      [
        -25,
        -22
      ],
      [
        -24,
        55
      ],
      [
        37,
        0
      ],
      [
        111,
        21
      ],
      [
        124,
        -21
      ],
      [
        112,
        43
      ],
      [
        49,
        11
      ],
      [
        37,
        -11
      ],
      [
        75,
        22
      ],
      [
        161,
        -22
      ],
      [
        123,
        22
      ],
      [
        -12,
        -33
      ],
      [
        -37,
        -32
      ],
      [
        -74,
        0
      ],
      [
        -50,
        -55
      ],
      [
        -99,
        11
      ],
      [
        -74,
        -21
      ],
      [
        24,
        -22
      ],
      [
        0,
        -65
      ],
      [
        13,
        0
      ],
      [
        37,
        -65
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -66
      ],
      [
        12,
        -21
      ],
      [
        13,
        32
      ],
      [
        0,
        65
      ],
      [
        24,
        -10
      ],
      [
        13,
        -22
      ],
      [
        37,
        -152
      ],
      [
        25,
        -87
      ],
      [
        12,
        0
      ],
      [
        13,
        22
      ],
      [
        12,
        43
      ],
      [
        12,
        -10
      ],
      [
        13,
        65
      ],
      [
        25,
        0
      ],
      [
        12,
        -11
      ],
      [
        37,
        -54
      ],
      [
        37,
        -87
      ],
      [
        0,
        -22
      ],
      [
        25,
        -11
      ],
      [
        0,
        44
      ],
      [
        -12,
        43
      ],
      [
        49,
        0
      ],
      [
        13,
        43
      ],
      [
        24,
        -32
      ],
      [
        75,
        -130
      ],
      [
        24,
        -22
      ],
      [
        75,
        -22
      ],
      [
        49,
        -65
      ],
      [
        25,
        -65
      ],
      [
        -12,
        -54
      ],
      [
        -37,
        -33
      ],
      [
        -25,
        -32
      ],
      [
        -13,
        -44
      ],
      [
        0,
        -32
      ],
      [
        -12,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -54
      ],
      [
        -13,
        -76
      ],
      [
        -25,
        -76
      ],
      [
        -123,
        -11
      ],
      [
        24,
        -22
      ],
      [
        25,
        -32
      ],
      [
        50,
        -54
      ],
      [
        37,
        43
      ],
      [
        62,
        0
      ],
      [
        49,
        54
      ],
      [
        25,
        11
      ],
      [
        112,
        -22
      ],
      [
        24,
        33
      ],
      [
        25,
        11
      ],
      [
        62,
        0
      ],
      [
        50,
        -44
      ]
    ],
    [
      [
        39701,
        67706
      ],
      [
        -24,
        0
      ],
      [
        -13,
        11
      ],
      [
        13,
        22
      ],
      [
        37,
        0
      ],
      [
        -13,
        -33
      ]
    ],
    [
      [
        39639,
        67327
      ],
      [
        25,
        -22
      ],
      [
        0,
        -32
      ],
      [
        -62,
        0
      ],
      [
        0,
        43
      ],
      [
        37,
        11
      ]
    ],
    [
      [
        39677,
        67674
      ],
      [
        -25,
        -11
      ],
      [
        0,
        22
      ],
      [
        25,
        -11
      ]
    ],
    [
      [
        39615,
        67663
      ],
      [
        -25,
        0
      ],
      [
        -12,
        33
      ],
      [
        24,
        0
      ],
      [
        13,
        -33
      ]
    ],
    [
      [
        98603,
        61633
      ],
      [
        -12,
        11
      ],
      [
        25,
        43
      ],
      [
        0,
        -43
      ],
      [
        -13,
        -11
      ]
    ],
    [
      [
        97724,
        62707
      ],
      [
        12,
        -33
      ],
      [
        0,
        -76
      ],
      [
        -12,
        -65
      ],
      [
        0,
        -32
      ],
      [
        -13,
        -22
      ],
      [
        -24,
        130
      ],
      [
        -25,
        65
      ],
      [
        37,
        55
      ],
      [
        12,
        0
      ],
      [
        13,
        -22
      ]
    ],
    [
      [
        98801,
        62707
      ],
      [
        -37,
        -33
      ],
      [
        0,
        33
      ],
      [
        25,
        11
      ],
      [
        12,
        -11
      ]
    ],
    [
      [
        98752,
        69171
      ],
      [
        -13,
        0
      ],
      [
        -37,
        54
      ],
      [
        25,
        22
      ],
      [
        37,
        -33
      ],
      [
        -12,
        -43
      ]
    ],
    [
      [
        98690,
        69214
      ],
      [
        -25,
        22
      ],
      [
        0,
        54
      ],
      [
        25,
        -43
      ],
      [
        0,
        -33
      ]
    ],
    [
      [
        98913,
        69290
      ],
      [
        -12,
        11
      ],
      [
        12,
        43
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -32
      ]
    ],
    [
      [
        98950,
        69463
      ],
      [
        -49,
        -76
      ],
      [
        -25,
        0
      ],
      [
        12,
        87
      ],
      [
        13,
        22
      ],
      [
        49,
        -33
      ]
    ],
    [
      [
        99074,
        69648
      ],
      [
        -62,
        -11
      ],
      [
        -25,
        -54
      ],
      [
        -25,
        -22
      ],
      [
        -86,
        -54
      ],
      [
        -13,
        -54
      ],
      [
        0,
        -87
      ],
      [
        -62,
        -65
      ],
      [
        -24,
        11
      ],
      [
        -13,
        21
      ],
      [
        -62,
        -32
      ],
      [
        -24,
        0
      ],
      [
        -38,
        32
      ],
      [
        -12,
        -21
      ],
      [
        25,
        -98
      ],
      [
        0,
        -43
      ],
      [
        -75,
        -131
      ],
      [
        13,
        -86
      ],
      [
        -13,
        -65
      ],
      [
        -49,
        -55
      ],
      [
        -74,
        -130
      ],
      [
        -38,
        0
      ],
      [
        -24,
        -32
      ],
      [
        -62,
        -217
      ],
      [
        0,
        -76
      ],
      [
        -13,
        -65
      ],
      [
        0,
        -44
      ],
      [
        -24,
        -108
      ],
      [
        -25,
        -43
      ],
      [
        0,
        -55
      ],
      [
        37,
        -119
      ],
      [
        0,
        -22
      ],
      [
        25,
        -65
      ],
      [
        24,
        -86
      ],
      [
        62,
        -120
      ],
      [
        25,
        -32
      ],
      [
        37,
        -22
      ],
      [
        62,
        -108
      ],
      [
        25,
        -65
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -97
      ],
      [
        -37,
        32
      ],
      [
        0,
        -22
      ],
      [
        61,
        -43
      ],
      [
        75,
        -184
      ],
      [
        124,
        -196
      ],
      [
        24,
        -97
      ],
      [
        62,
        -65
      ],
      [
        62,
        -98
      ],
      [
        0,
        -22
      ],
      [
        13,
        -21
      ],
      [
        49,
        -54
      ],
      [
        25,
        -55
      ],
      [
        12,
        -54
      ],
      [
        38,
        11
      ],
      [
        37,
        0
      ],
      [
        12,
        -54
      ],
      [
        25,
        -55
      ],
      [
        25,
        -43
      ],
      [
        12,
        0
      ],
      [
        0,
        -32
      ],
      [
        12,
        -33
      ],
      [
        38,
        -65
      ],
      [
        12,
        -76
      ],
      [
        50,
        -108
      ],
      [
        24,
        -66
      ],
      [
        25,
        -32
      ],
      [
        37,
        -33
      ],
      [
        25,
        -119
      ],
      [
        12,
        -119
      ],
      [
        25,
        -119
      ],
      [
        25,
        -55
      ],
      [
        0,
        -97
      ],
      [
        12,
        -109
      ],
      [
        25,
        -76
      ],
      [
        0,
        -65
      ],
      [
        12,
        -43
      ],
      [
        0,
        -22
      ],
      [
        25,
        -130
      ],
      [
        -12,
        -54
      ],
      [
        -13,
        -109
      ],
      [
        13,
        -86
      ],
      [
        0,
        -109
      ],
      [
        12,
        -32
      ],
      [
        25,
        -120
      ],
      [
        12,
        -43
      ],
      [
        0,
        -152
      ],
      [
        -12,
        -32
      ],
      [
        -12,
        54
      ],
      [
        -25,
        -33
      ],
      [
        -13,
        -32
      ],
      [
        25,
        -163
      ],
      [
        -37,
        11
      ],
      [
        0,
        -206
      ],
      [
        25,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -43
      ],
      [
        12,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -87
      ],
      [
        -24,
        0
      ],
      [
        -25,
        -163
      ],
      [
        -62,
        -10
      ],
      [
        -37,
        -76
      ],
      [
        -50,
        -22
      ],
      [
        -49,
        -76
      ],
      [
        -50,
        -65
      ],
      [
        -62,
        -22
      ],
      [
        -25,
        -108
      ],
      [
        -62,
        -11
      ],
      [
        -123,
        -141
      ],
      [
        -25,
        -11
      ],
      [
        -50,
        -43
      ],
      [
        -12,
        11
      ],
      [
        -13,
        32
      ],
      [
        -37,
        22
      ],
      [
        -12,
        32
      ],
      [
        0,
        55
      ],
      [
        -13,
        11
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -109
      ],
      [
        -12,
        -32
      ],
      [
        -13,
        -11
      ],
      [
        -24,
        33
      ],
      [
        -38,
        65
      ],
      [
        -37,
        -44
      ],
      [
        37,
        0
      ],
      [
        13,
        -11
      ],
      [
        12,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -32
      ],
      [
        -37,
        0
      ],
      [
        -50,
        11
      ],
      [
        -12,
        -11
      ],
      [
        49,
        -33
      ],
      [
        62,
        -54
      ],
      [
        0,
        -22
      ],
      [
        -25,
        -32
      ],
      [
        -24,
        -44
      ],
      [
        0,
        -54
      ],
      [
        -13,
        -32
      ],
      [
        -49,
        54
      ],
      [
        -112,
        173
      ],
      [
        13,
        -54
      ],
      [
        111,
        -195
      ],
      [
        25,
        -65
      ],
      [
        0,
        -43
      ],
      [
        -25,
        -55
      ],
      [
        -37,
        0
      ],
      [
        -62,
        76
      ],
      [
        -99,
        174
      ],
      [
        -37,
        21
      ],
      [
        99,
        -206
      ],
      [
        25,
        -43
      ],
      [
        12,
        -54
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -21
      ],
      [
        -236,
        -196
      ],
      [
        -62,
        -184
      ],
      [
        -37,
        -54
      ],
      [
        -25,
        -54
      ],
      [
        -86,
        -22
      ],
      [
        -38,
        11
      ],
      [
        38,
        87
      ],
      [
        -25,
        32
      ],
      [
        0,
        239
      ],
      [
        12,
        271
      ],
      [
        25,
        130
      ],
      [
        25,
        33
      ],
      [
        37,
        21
      ],
      [
        0,
        54
      ],
      [
        -25,
        44
      ],
      [
        -25,
        21
      ],
      [
        -24,
        11
      ],
      [
        -25,
        55
      ],
      [
        -25,
        0
      ],
      [
        -25,
        -22
      ],
      [
        -12,
        22
      ],
      [
        -12,
        43
      ],
      [
        -25,
        43
      ],
      [
        -37,
        44
      ]
    ],
    [
      [
        120380,
        43608
      ],
      [
        -12,
        -43
      ],
      [
        -25,
        0
      ],
      [
        -25,
        33
      ],
      [
        13,
        21
      ],
      [
        37,
        11
      ],
      [
        12,
        -22
      ]
    ],
    [
      [
        120244,
        44010
      ],
      [
        -25,
        -65
      ],
      [
        -25,
        11
      ],
      [
        -37,
        54
      ],
      [
        -12,
        32
      ],
      [
        12,
        87
      ],
      [
        25,
        11
      ],
      [
        12,
        -76
      ],
      [
        50,
        -54
      ]
    ],
    [
      [
        120182,
        44378
      ],
      [
        -12,
        -21
      ],
      [
        -13,
        0
      ],
      [
        -87,
        65
      ],
      [
        0,
        141
      ],
      [
        25,
        22
      ],
      [
        25,
        -11
      ],
      [
        12,
        -55
      ],
      [
        25,
        -21
      ],
      [
        -12,
        -22
      ],
      [
        25,
        -43
      ],
      [
        12,
        -55
      ]
    ],
    [
      [
        119885,
        45257
      ],
      [
        24,
        -87
      ],
      [
        13,
        -11
      ],
      [
        -13,
        -65
      ],
      [
        -49,
        0
      ],
      [
        -50,
        65
      ],
      [
        -24,
        -10
      ],
      [
        12,
        43
      ],
      [
        25,
        54
      ],
      [
        12,
        11
      ],
      [
        13,
        -11
      ],
      [
        37,
        11
      ]
    ],
    [
      [
        119885,
        45734
      ],
      [
        0,
        -32
      ],
      [
        -50,
        21
      ],
      [
        -49,
        -11
      ],
      [
        -13,
        33
      ],
      [
        0,
        76
      ],
      [
        25,
        32
      ],
      [
        25,
        -54
      ],
      [
        0,
        -11
      ],
      [
        25,
        -43
      ],
      [
        37,
        -11
      ]
    ],
    [
      [
        119823,
        46005
      ],
      [
        -37,
        0
      ],
      [
        -50,
        22
      ],
      [
        -25,
        22
      ],
      [
        -12,
        32
      ],
      [
        49,
        22
      ],
      [
        38,
        65
      ],
      [
        12,
        -22
      ],
      [
        12,
        -76
      ],
      [
        13,
        -21
      ],
      [
        0,
        -44
      ]
    ],
    [
      [
        119525,
        46157
      ],
      [
        25,
        -11
      ],
      [
        0,
        -32
      ],
      [
        50,
        -55
      ],
      [
        12,
        0
      ],
      [
        13,
        -32
      ],
      [
        24,
        -22
      ],
      [
        0,
        -32
      ],
      [
        25,
        -33
      ],
      [
        -25,
        -43
      ],
      [
        -62,
        11
      ],
      [
        -24,
        -44
      ],
      [
        -25,
        11
      ],
      [
        0,
        33
      ],
      [
        -13,
        65
      ],
      [
        -12,
        97
      ],
      [
        -12,
        55
      ],
      [
        -13,
        21
      ],
      [
        -25,
        -21
      ],
      [
        -12,
        0
      ],
      [
        -12,
        43
      ],
      [
        12,
        98
      ],
      [
        0,
        21
      ],
      [
        12,
        11
      ],
      [
        38,
        -22
      ],
      [
        24,
        -119
      ]
    ],
    [
      [
        119463,
        46396
      ],
      [
        -12,
        -22
      ],
      [
        -37,
        43
      ],
      [
        12,
        33
      ],
      [
        37,
        -11
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        119798,
        46233
      ],
      [
        -12,
        33
      ],
      [
        -13,
        151
      ],
      [
        13,
        109
      ],
      [
        37,
        -239
      ],
      [
        -13,
        -43
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        119699,
        46569
      ],
      [
        -25,
        -21
      ],
      [
        -49,
        0
      ],
      [
        -13,
        10
      ],
      [
        50,
        87
      ],
      [
        62,
        22
      ],
      [
        -25,
        -98
      ]
    ],
    [
      [
        119786,
        46634
      ],
      [
        -13,
        11
      ],
      [
        -12,
        185
      ],
      [
        0,
        21
      ],
      [
        12,
        0
      ],
      [
        13,
        -130
      ],
      [
        0,
        -87
      ]
    ],
    [
      [
        119290,
        46949
      ],
      [
        25,
        -206
      ],
      [
        25,
        0
      ],
      [
        12,
        11
      ],
      [
        25,
        54
      ],
      [
        0,
        76
      ],
      [
        12,
        11
      ],
      [
        25,
        -11
      ],
      [
        -12,
        -22
      ],
      [
        0,
        -65
      ],
      [
        12,
        -33
      ],
      [
        12,
        0
      ],
      [
        13,
        -162
      ],
      [
        12,
        -33
      ],
      [
        0,
        -32
      ],
      [
        -37,
        -55
      ],
      [
        -50,
        0
      ],
      [
        -37,
        -32
      ],
      [
        -25,
        0
      ],
      [
        0,
        43
      ],
      [
        -24,
        33
      ],
      [
        -25,
        65
      ],
      [
        12,
        119
      ],
      [
        -49,
        228
      ],
      [
        0,
        54
      ],
      [
        12,
        76
      ],
      [
        25,
        0
      ],
      [
        12,
        -54
      ],
      [
        25,
        -65
      ]
    ],
    [
      [
        119587,
        47307
      ],
      [
        -12,
        -33
      ],
      [
        -50,
        11
      ],
      [
        0,
        65
      ],
      [
        25,
        33
      ],
      [
        37,
        -33
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        119550,
        47524
      ],
      [
        -12,
        0
      ],
      [
        -25,
        76
      ],
      [
        37,
        54
      ],
      [
        25,
        -44
      ],
      [
        0,
        -65
      ],
      [
        -25,
        0
      ],
      [
        0,
        -21
      ]
    ],
    [
      [
        669,
        47274
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        11
      ],
      [
        12,
        22
      ],
      [
        25,
        -22
      ]
    ],
    [
      [
        1313,
        47881
      ],
      [
        -12,
        22
      ],
      [
        12,
        44
      ],
      [
        12,
        -22
      ],
      [
        -12,
        -44
      ]
    ],
    [
      [
        2936,
        47437
      ],
      [
        -99,
        0
      ],
      [
        -50,
        32
      ],
      [
        -12,
        0
      ],
      [
        -37,
        55
      ],
      [
        -13,
        32
      ],
      [
        25,
        22
      ],
      [
        50,
        11
      ],
      [
        86,
        -44
      ],
      [
        13,
        -43
      ],
      [
        12,
        0
      ],
      [
        25,
        -22
      ],
      [
        0,
        -43
      ]
    ],
    [
      [
        2626,
        47806
      ],
      [
        50,
        -65
      ],
      [
        12,
        -76
      ],
      [
        -25,
        -76
      ],
      [
        -24,
        21
      ],
      [
        -62,
        -21
      ],
      [
        -13,
        11
      ],
      [
        -74,
        130
      ],
      [
        -13,
        43
      ],
      [
        38,
        -11
      ],
      [
        62,
        33
      ],
      [
        49,
        11
      ]
    ],
    [
      [
        80419,
        64106
      ],
      [
        24,
        -11
      ],
      [
        38,
        22
      ],
      [
        86,
        11
      ],
      [
        112,
        -76
      ],
      [
        -25,
        -11
      ],
      [
        -12,
        -33
      ],
      [
        -50,
        -21
      ],
      [
        -50,
        -55
      ],
      [
        -136,
        -21
      ],
      [
        -37,
        11
      ],
      [
        -37,
        54
      ],
      [
        -62,
        65
      ],
      [
        25,
        43
      ],
      [
        0,
        22
      ],
      [
        12,
        22
      ],
      [
        37,
        32
      ],
      [
        37,
        -11
      ],
      [
        38,
        -43
      ]
    ],
    [
      [
        76640,
        64941
      ],
      [
        -24,
        22
      ],
      [
        24,
        43
      ],
      [
        13,
        -43
      ],
      [
        -13,
        -22
      ]
    ],
    [
      [
        76579,
        65776
      ],
      [
        -13,
        -22
      ],
      [
        0,
        87
      ],
      [
        13,
        11
      ],
      [
        12,
        -43
      ],
      [
        0,
        -22
      ],
      [
        -12,
        -11
      ]
    ],
    [
      [
        80183,
        66611
      ],
      [
        -173,
        -108
      ],
      [
        -37,
        -55
      ],
      [
        -50,
        -54
      ],
      [
        -25,
        -76
      ],
      [
        -24,
        -141
      ],
      [
        12,
        -119
      ],
      [
        0,
        -65
      ],
      [
        -37,
        -43
      ],
      [
        -50,
        -33
      ],
      [
        -37,
        -43
      ],
      [
        -37,
        -11
      ],
      [
        -25,
        -44
      ],
      [
        -25,
        -21
      ],
      [
        -99,
        -76
      ],
      [
        -99,
        -54
      ],
      [
        -173,
        -65
      ],
      [
        -62,
        -66
      ],
      [
        -62,
        -43
      ],
      [
        -87,
        -22
      ],
      [
        -124,
        -65
      ],
      [
        -62,
        -54
      ],
      [
        -86,
        -87
      ],
      [
        -25,
        -21
      ],
      [
        -13,
        -65
      ],
      [
        -24,
        -55
      ],
      [
        -50,
        -86
      ],
      [
        -37,
        -44
      ],
      [
        -74,
        -32
      ],
      [
        -62,
        0
      ],
      [
        -99,
        21
      ],
      [
        -25,
        -21
      ],
      [
        -25,
        -33
      ],
      [
        -74,
        -54
      ],
      [
        -75,
        -130
      ],
      [
        -62,
        -33
      ],
      [
        -86,
        -32
      ],
      [
        -62,
        -55
      ],
      [
        -50,
        -21
      ],
      [
        -49,
        -11
      ],
      [
        -112,
        0
      ],
      [
        -99,
        -11
      ],
      [
        -87,
        -32
      ],
      [
        -37,
        -66
      ],
      [
        -49,
        -108
      ],
      [
        -87,
        -43
      ],
      [
        -12,
        -33
      ],
      [
        -25,
        -87
      ],
      [
        -50,
        -11
      ],
      [
        -49,
        -21
      ],
      [
        -50,
        43
      ],
      [
        -86,
        -97
      ],
      [
        -87,
        -22
      ],
      [
        -37,
        -22
      ],
      [
        -25,
        11
      ],
      [
        -25,
        33
      ],
      [
        -74,
        43
      ],
      [
        -50,
        -22
      ],
      [
        0,
        87
      ],
      [
        -86,
        260
      ],
      [
        12,
        239
      ],
      [
        0,
        32
      ],
      [
        -12,
        109
      ],
      [
        -50,
        87
      ],
      [
        0,
        119
      ],
      [
        -12,
        87
      ],
      [
        -25,
        86
      ],
      [
        12,
        33
      ],
      [
        0,
        22
      ],
      [
        -25,
        130
      ],
      [
        -12,
        32
      ],
      [
        0,
        22
      ],
      [
        12,
        22
      ],
      [
        0,
        32
      ],
      [
        -24,
        44
      ],
      [
        -13,
        76
      ],
      [
        -62,
        65
      ],
      [
        13,
        54
      ],
      [
        24,
        -33
      ],
      [
        13,
        33
      ],
      [
        0,
        32
      ],
      [
        -37,
        174
      ],
      [
        49,
        239
      ],
      [
        -12,
        206
      ]
    ],
    [
      [
        74943,
        26885
      ],
      [
        -12,
        -11
      ],
      [
        -62,
        11
      ],
      [
        -12,
        22
      ],
      [
        37,
        54
      ],
      [
        37,
        0
      ],
      [
        25,
        -32
      ],
      [
        -13,
        -44
      ]
    ],
    [
      [
        73234,
        39444
      ],
      [
        -12,
        -141
      ],
      [
        -50,
        -228
      ],
      [
        -12,
        -108
      ],
      [
        -38,
        -369
      ],
      [
        -86,
        -260
      ],
      [
        -87,
        -141
      ],
      [
        -50,
        -44
      ],
      [
        -37,
        -10
      ],
      [
        -161,
        -282
      ],
      [
        -49,
        -131
      ],
      [
        -50,
        -195
      ],
      [
        -49,
        -108
      ],
      [
        -75,
        -228
      ],
      [
        -74,
        -174
      ],
      [
        -62,
        -162
      ],
      [
        -111,
        -217
      ],
      [
        -38,
        -65
      ],
      [
        -37,
        -22
      ],
      [
        -86,
        -130
      ],
      [
        -124,
        -206
      ],
      [
        -99,
        -184
      ],
      [
        -137,
        -207
      ],
      [
        -74,
        -86
      ],
      [
        -124,
        -185
      ],
      [
        -37,
        -21
      ],
      [
        -136,
        -163
      ],
      [
        -99,
        -98
      ],
      [
        -161,
        -119
      ],
      [
        -62,
        -32
      ],
      [
        -149,
        32
      ],
      [
        -62,
        -22
      ],
      [
        -62,
        -65
      ],
      [
        0,
        -108
      ],
      [
        -49,
        -11
      ],
      [
        -112,
        43
      ],
      [
        -62,
        -10
      ],
      [
        -25,
        -44
      ],
      [
        -24,
        -76
      ],
      [
        -87,
        0
      ],
      [
        -136,
        65
      ],
      [
        -211,
        55
      ],
      [
        -74,
        -55
      ],
      [
        -37,
        -11
      ],
      [
        -112,
        11
      ],
      [
        -74,
        33
      ],
      [
        -62,
        0
      ],
      [
        -37,
        -22
      ],
      [
        -62,
        -11
      ],
      [
        -161,
        -195
      ],
      [
        -75,
        0
      ],
      [
        -74,
        -22
      ],
      [
        -99,
        33
      ],
      [
        -62,
        -11
      ],
      [
        -37,
        -32
      ],
      [
        -87,
        -22
      ],
      [
        -25,
        -22
      ],
      [
        -148,
        -173
      ],
      [
        -37,
        0
      ],
      [
        -25,
        11
      ],
      [
        -75,
        10
      ],
      [
        -74,
        87
      ],
      [
        -25,
        22
      ],
      [
        0,
        54
      ],
      [
        -24,
        43
      ],
      [
        -38,
        0
      ],
      [
        -24,
        44
      ],
      [
        -50,
        0
      ],
      [
        -37,
        -11
      ],
      [
        0,
        108
      ],
      [
        -13,
        55
      ],
      [
        -24,
        21
      ],
      [
        -62,
        -11
      ],
      [
        -13,
        -10
      ],
      [
        -12,
        -44
      ],
      [
        0,
        -108
      ],
      [
        -25,
        32
      ],
      [
        -25,
        141
      ],
      [
        13,
        76
      ],
      [
        37,
        33
      ],
      [
        0,
        65
      ],
      [
        -50,
        173
      ],
      [
        -24,
        55
      ],
      [
        -37,
        43
      ],
      [
        -25,
        98
      ],
      [
        -25,
        32
      ],
      [
        -12,
        65
      ],
      [
        -25,
        54
      ],
      [
        -13,
        76
      ],
      [
        13,
        55
      ],
      [
        25,
        21
      ],
      [
        24,
        -32
      ],
      [
        25,
        11
      ],
      [
        50,
        65
      ],
      [
        24,
        86
      ],
      [
        0,
        239
      ],
      [
        -37,
        239
      ],
      [
        -99,
        227
      ],
      [
        -87,
        228
      ],
      [
        -111,
        358
      ],
      [
        -62,
        217
      ],
      [
        -74,
        434
      ],
      [
        -75,
        238
      ],
      [
        -86,
        239
      ],
      [
        -13,
        11
      ]
    ],
    [
      [
        72032,
        42350
      ],
      [
        99,
        33
      ],
      [
        87,
        -22
      ],
      [
        99,
        -76
      ],
      [
        87,
        -21
      ],
      [
        87,
        21
      ],
      [
        74,
        0
      ],
      [
        50,
        -10
      ],
      [
        49,
        -22
      ],
      [
        25,
        -33
      ]
    ],
    [
      [
        71500,
        38153
      ],
      [
        -37,
        -21
      ],
      [
        -50,
        -120
      ],
      [
        -12,
        -65
      ],
      [
        -25,
        -32
      ],
      [
        -13,
        -44
      ],
      [
        -49,
        -97
      ],
      [
        -74,
        -65
      ],
      [
        -13,
        -22
      ],
      [
        13,
        -54
      ],
      [
        24,
        -54
      ],
      [
        13,
        -66
      ],
      [
        62,
        -140
      ],
      [
        0,
        -76
      ],
      [
        12,
        -22
      ],
      [
        37,
        -33
      ],
      [
        25,
        -65
      ],
      [
        25,
        -43
      ],
      [
        37,
        -33
      ],
      [
        87,
        -32
      ],
      [
        12,
        11
      ],
      [
        25,
        65
      ],
      [
        62,
        195
      ],
      [
        37,
        43
      ],
      [
        37,
        11
      ],
      [
        50,
        0
      ],
      [
        24,
        11
      ],
      [
        87,
        65
      ],
      [
        37,
        54
      ],
      [
        13,
        76
      ],
      [
        0,
        65
      ],
      [
        24,
        22
      ],
      [
        38,
        54
      ],
      [
        24,
        163
      ],
      [
        0,
        54
      ],
      [
        -24,
        87
      ],
      [
        -13,
        0
      ],
      [
        -37,
        32
      ],
      [
        -37,
        55
      ],
      [
        -37,
        43
      ],
      [
        -37,
        65
      ],
      [
        -13,
        11
      ],
      [
        -62,
        108
      ],
      [
        -49,
        -21
      ],
      [
        -87,
        -54
      ],
      [
        -50,
        -44
      ],
      [
        -37,
        -65
      ],
      [
        -49,
        -22
      ]
    ],
    [
      [
        72379,
        46439
      ],
      [
        -223,
        0
      ],
      [
        -86,
        -32
      ],
      [
        -75,
        -44
      ],
      [
        -74,
        -87
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        -55
      ],
      [
        -12,
        -65
      ],
      [
        0,
        -184
      ],
      [
        -25,
        -65
      ],
      [
        -124,
        -76
      ],
      [
        -87,
        -76
      ],
      [
        -74,
        -76
      ],
      [
        -62,
        -97
      ],
      [
        -37,
        -131
      ],
      [
        -75,
        -151
      ],
      [
        -74,
        -141
      ],
      [
        -62,
        -141
      ],
      [
        -87,
        -55
      ],
      [
        -74,
        11
      ],
      [
        -87,
        65
      ],
      [
        -61,
        11
      ],
      [
        -50,
        -43
      ],
      [
        -50,
        11
      ],
      [
        -37,
        65
      ],
      [
        -37,
        21
      ],
      [
        -25,
        -21
      ],
      [
        -37,
        0
      ],
      [
        -62,
        32
      ]
    ]
  ],
  "bbox": [
    -180,
    -89.99892578124998,
    180,
    83.59960937500004
  ]
}
